(function () {
    "use strict";

    angular.module("app.gerenciamento.leitura.visualizacao", []).config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao;

        $stateProvider.state("app.gerenciamento_leitura_visualizacao", {
            url: "/gerenciamento/leitura/visualizacao",
            module: "privado",
            views: {
                "content@app": {
                    templateUrl: rotasHtml.templateUrl,
                    controller: "VisualizacaoController as vm",
                    abstract: true
                },
                "leitura-visualizacao-form@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.form,
                    controller: "VisualizacaoController as vm"
                },
                "leitura-visualizacao-form-caema@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.caema.form,
                    controller: "VisualizacaoController as vm"
                },
                "tab-dados-cadastrais@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.dadosCadastrais
                    // controller: 'VisualizacaoController as vm'
                },
                "tab-dados-leitura@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.dadosLeitura.templateUrl,
                    controller: "DadosLeituraController as vm"
                },
                "tab-dados-faturamento@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.dadosFaturamento.templateUrl,
                    controller: "DadosFaturamentoController as vm"
                },
                "tab-fotos@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.fotos.templateUrl
                },
                "tab-fotos-hidrometro@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.fotos.hidrometro
                },
                "tab-fotos-prova-adulteracao@app.gerenciamento_leitura_visualizacao": {
                    templateUrl: rotasHtml.tabs.fotos.provaAdulteracao
                }
            },
            resolve: {
                ListarTodosLeituristas: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(
                        Api.leiturista.listarTodosAtivos
                    );
                },
                Leitura: function () {
                    return undefined;
                },
                listaRegionais: function (RegionalService) {
                    return RegionalService.listarTodos();
                },
                EditarAtivo: function () {
                    return undefined;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DialogDetalharFotoController', DialogDetalharFotoController)

    /** @ngInject */
    function DialogDetalharFotoController(
        Foto, 
        $mdDialog
    ) {
        
        var vm = this;
        vm.foto = Foto;
        vm.fotoBase64 = vm.foto.includes('.png') || vm.foto.includes('.jpg');

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DialogLogLeituraController', DialogLogLeituraController)

    function DialogLogLeituraController(
        $mdDialog,
        Dados,
        DatatableFactory
    ) {

        var vm = this;
        vm.dados = Dados;
        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao([

            {
                targets: [0, 2, 3, 4, 5, 6, 7],
                orderable: false
            }

        ]);
        vm.dtOptions.order = [];
        vm.dtOptions.scrollY = '45vh';
        vm.dtOptions.scrollCollapse = true;

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DialogFotosDadosLeituraController', DialogFotosDadosLeituraController)

    /** @ngInject */
    function DialogFotosDadosLeituraController(
        $mdDialog,
        RotasHtml,
        Fotos,
        urlApi,
        SessionStorageService,
        KeysSessionStorage
    ) {
        var vm = this;
        vm.tabSelecionada = '';
        vm.rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura.dialogs.fotos.tabs;
        vm.fotos = Fotos;

        init();

        function init() {
            vm.tipoDetalheCalculo = SessionStorageService.recuperar(
                KeysSessionStorage.tipoDetalheCalculo);

            vm.fotos.fotosHidrometro = vm.fotos.fotosHidrometro.map(function (item) {
                return {
                    caminhoFoto: urlApi.url_base_api + item.caminhoFoto,
                    codigoCliente: item.codigoCliente,
                    indiceFoto: item.indiceFoto,
                    tipoFoto: item.tipoFoto,
                    dataFoto: item.dataFoto
                };
            });

            vm.fotos.fotosFachada = vm.fotos.fotosFachada.map(function (item) {
                return {
                    caminhoFoto: urlApi.url_base_api + item.caminhoFoto,
                    codigoCliente: item.codigoCliente,
                    indiceFoto: item.indiceFoto,
                    tipoFoto: item.tipoFoto,
                    dataFoto: item.dataFoto
                };
            });

            vm.fotos.fotosProvaAdulteracao = vm.fotos.fotosProvaAdulteracao.map(function (item) {
                return {
                    caminhoFoto: urlApi.url_base_api + item.caminhoFoto,
                    codigoCliente: item.codigoCliente,
                    indiceFoto: item.indiceFoto,
                    tipoFoto: item.tipoFoto,
                    dataFoto: item.dataFoto
                };
            });

            vm.fotos.fotosOutros = vm.fotos.fotosOutros.map(function (item) {
                return {
                    caminhoFoto: urlApi.url_base_api + item.caminhoFoto,
                    codigoCliente: item.codigoCliente,
                    indiceFoto: item.indiceFoto,
                    tipoFoto: item.tipoFoto,
                    dataFoto: item.dataFoto
                };
            });

            vm.fotos.fotosRepasse = vm.fotos.fotosRepasse.map(function (item) {
                return {
                    caminhoFoto: urlApi.url_base_api + item.caminhoFoto,
                    codigoCliente: item.codigoCliente,
                    indiceFoto: item.indiceFoto,
                    tipoFoto: item.tipoFoto,
                    dataFoto: item.dataFoto
                };
            });
        }

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            tabSelecionada: tabSelecionada,
            abrirDialogFotoDetalhada: abrirDialogFotoDetalhada
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function tabSelecionada(tabSelecionada) {
            vm.tabSelecionada = tabSelecionada;
        }

        function abrirDialogFotoDetalhada(foto) {
            var rota = RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura.dialogs.fotos;
            $mdDialog.show({
                controller: 'DialogDetalharFotoController',
                controllerAs: 'vm',
                templateUrl: rota.dialogs.detalharFotos,
                transclude: true,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    Foto: foto
                }
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller("DialogDadosServicoController", DialogDadosServicoController);

    function DialogDadosServicoController($mdDialog, $scope, DatatableFactory, Api, RequisicaoGenericaService,
        CodigoCliente, NomeArquivoExportacao, NomeCliente) {
        var vm = this;
        vm.nomeCliente = NomeCliente;
        vm.rota = Api.leitura.visualizacao.listarDadosServico;
        vm.pesquisarServicos = "";
        vm.possuiDados = false;

        vm.metodosDialog = {
            fecharDialog: fecharDialog,
            atualizarItensPorPagina: atualizarItensPorPagina
        }

        init();

        function init() {
            vm.dtOptions = DatatableFactory.construirDtOptionPadrao([
                {
                    width: '15%',
                    targets: [0]
                },
                {
                    width: 'auto',
                    targets: [1]
                },
                {
                    width: '20%',
                    targets: [2]
                }
            ]);

            vm.dtOptions.dom = 'rt<"bottom"<"left"l i><"right"p>>';
            vm.dtOptions.pageLength = 10;
            vm.dtOptions.lengthChange = true;
            vm.dtOptions.lengthMenu = [10, 25, 50, 100];
            vm.dtOptions.responsive = false;

            vm.dtOptions.language = {
                info: "Exibindo _START_ a _END_ de _TOTAL_ serviços",
                infoEmpty: "Nenhum serviço encontrado",
                infoFiltered: "",
                paginate: {
                    first: "Primeira",
                    last: "Última",
                    next: "Próxima",
                    previous: "Anterior"
                },
                zeroRecords: "Nenhum serviço encontrado com base na pesquisa informada"
            };

            vm.dtOptions.initComplete = function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisarServicos');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                        $scope.$digest();
                    });
                }
            };

            vm.servico = [];
            carregaDadosServico();
        }

        function atualizarItensPorPagina() {
            if (vm.dtOptions && vm.dtOptions.pageLength) {
                var table = angular.element('.tabela-servico-custom').DataTable();
                table.page.len(vm.dtOptions.pageLength).draw();
            }
        }

        function carregaDadosServico() {
            vm.emProgresso = true;
            RequisicaoGenericaService.listarSemParams(vm.rota + "?codigoCliente=" +
                CodigoCliente + "&nomeArquivoExportacao=" + NomeArquivoExportacao)
                .then(function (sucess) {
                    vm.servico = angular.copy(sucess.data);
                    vm.possuiDados = vm.servico && vm.servico.length > 0;
                    vm.emProgresso = false;
                })
                .catch(function (erro) {
                    vm.emProgresso = true;
                    MdDialogService.alertPadrao("Atenção", null, erro.data)
                })
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller("DialogHistoricoAbastecimentoController", DialogHistoricoAbastecimentoController);

    function DialogHistoricoAbastecimentoController(
        $mdDialog,
        DatatableFactory,
        RequisicaoGenericaService,
        Api,
        Dados,
        MdDialogService
    ) {
        var vm = this;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            carregarDadosHistorico: carregarDadosHistorico
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function init() {
            vm.rota = Api.leitura.visualizacao.listarDadosHistoricoAbastecimento;
            vm.historicos = [];
            vm.consumoTotal = 0;
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao();
            vm.dtOptions.scrollY = '60vh';
            vm.dtOptions.order = [];
            vm.dtOptions.scrollCollapse = true;

            carregarDadosHistorico();
        }

        function carregarDadosHistorico() {
            vm.emProgresso = true;

            RequisicaoGenericaService
                .listarSemParams(vm.rota + "?codigoCliente=" + Dados.CodigoCliente +
                    "&nomeArquivoExportacao=" + Dados.NomeArquivoExportacao + "&exibirConsumosCancelados=true")
                .then(function (success) {
                    if (success.data && success.data.length == 0) {
                        MdDialogService.alertPadraoComEvento(
                            "Atenção",
                            function () { fecharDialog(); },
                            null,
                            "Não foram encontrados dados de histórico de abastecimento para este cliente."
                        );
                    } else {
                        vm.historicos = success.data;
                        vm.historicos.forEach(function (historico) {
                            historico.leiturista =
                                Dados.Leituristas.find(function (leiturista) { return leiturista.codigo == historico.leiCodigo });
                            vm.consumoTotal += historico.consumoAbastecido;
                        });
                    }
                }, function (error) {
                    MdDialogService.alertPadraoComEvento(
                        "Atenção",
                        function () { fecharDialog(); },
                        null,
                        "Não foi possível carregar os dados de histórico de abastecimento para este cliente."
                    );
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller("DialogHistoricoController", DialogHistoricoController);

    function DialogHistoricoController(
        $mdDialog,
        DatatableFactory,
        RequisicaoGenericaService,
        Api,
        CodigoCliente,
        NomeCliente,
        NomeArquivoExportacao,
        MdDialogService
    ) {
        var vm = this;
        vm.rota = Api.leitura.visualizacao.listarDadosHistorico;
        vm.codigoCliente = CodigoCliente;
        vm.nomeArquivoExportacao = NomeArquivoExportacao;
        vm.nomeCliente = NomeCliente;
        init();

        vm.metodosDialog = {
            fecharDialog: fecharDialog
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function init() {
            vm.historicos = [];
            vm.emProgresso = true;
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([

                {
                    targets: [0],
                    orderable: false
                }
            ]);
            vm.dtOptions.scrollY = '60vh';
            vm.dtOptions.order = [];
            vm.dtOptions.scrollCollapse = true;

            carregarDadosHistorico();
        }

        function carregarDadosHistorico() {
            vm.emProgresso = true;
            RequisicaoGenericaService
                .listarSemParams(vm.rota + "?codigoCliente=" + vm.codigoCliente +
                    "&nomeArquivoExportacao=" + vm.nomeArquivoExportacao)
                .then(function (success) {
                    if (success.data && success.data.length == 0) {
                        MdDialogService.alertPadrao(
                            "Atenção",
                            null,
                            "Não foram encontrados dados de histórico de leituras para este cliente."
                        );
                        return;
                    }

                    vm.historicos = success.data;
                    vm.historicos.forEach(function (item) {
                        if (!item.mediaConsumo) {
                            if (item.consumo && item.numeroDias) {
                                item.mediaConsumo = item.consumo / item.numeroDias;
                            }
                        }
                    });

                }).catch(function (erro) {
                    MdDialogService.alertPadrao("Atenção", null, erro.data);
                }).finally(function () { vm.emProgresso = false; });
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DialogMotivoCriticaController', DialogMotivoCriticaController)

    /** @ngInject */
    function DialogMotivoCriticaController($mdDialog, Motivo, Erros){
        var vm = this;
        
        init();

        vm.metodos = {
            fecharDialog: fecharDialog
        }

        function init(){
            vm.motivo = Motivo;
            vm.erros = Erros
        }

        function fecharDialog(){
            $mdDialog.hide();
        }

    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.gerenciamento.critica.consulta;
            var rotasHtmlVisualizacao = RotasHtml.gerenciamento.leitura.visualizacao;
            $stateProvider
                    .state('app.gerenciamento_consultacritica', {
                        url: '/gerenciamento/critica/consulta',
                        module: 'privado',
                        views:{
                            'content@app': {
                                templateUrl: rotasHtml.templateUrl,
                                controller: 'ConsultaCriticaController as vm'
                            },
                            'consultacritica-form@app.gerenciamento_consultacritica': {
                                templateUrl: rotasHtml.form
                            },
                            'filtro-sidenav-consulta-critica@app.gerenciamento_consultacritica': {
                                templateUrl: rotasHtml.sidenav.filtro,
                                controller: 'FiltroConsultaCriticaController as vm'   
                            },
                            'leitura-visualizacao-form@app.gerenciamento_leitura_visualizacao': {
                                templateUrl: rotasHtmlVisualizacao.form                              
                            }                            
                        },
                        resolve: {
                            ListarLeituristas: function(Api, RequisicaoGenericaService){
                                return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                            }
                        }
                    });
        }
}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta')
        .controller('DialogFotosHistoricoCriticaController', DialogFotosHistoricoCriticaController)

    /** @ngInject */
    function DialogFotosHistoricoCriticaController(Fotos, $mdDialog, urlApi, FotosService){
        var vm = this;
        
        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirDialogDetalheFoto: abrirDialogDetalheFoto
        }
        init();

        function init(){
            vm.fotos = Fotos.map(function(item){
                return urlApi.url_base_api + item.url
            });   
        }

        function fecharDialog(){
            $mdDialog.hide();
        }

        function abrirDialogDetalheFoto(urlFoto){
            FotosService.abrirDialogDetalheFoto(urlFoto);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.parametros', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.parametros;

        $stateProvider
            .state('app.cadastro_parametros', {
                url: '/cadastros/parametros',
                module: 'privado',
                params: {
                    dadosEmpresaFaltando: null,
                },
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        abstract: true
                    },
                    'parametros-form@app.cadastro_parametros': {
                        templateUrl: rotasHtml.form,
                        controller: 'ParametrosController as vm'
                    },
                    'tab-empresa@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabEmpresa
                    },
                    'tab-personalizacao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabPersonalizacao
                    },
                    'tab-coletor@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabColetor
                    },
                    'tab-coletor-tab-configuracao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabColetorTabConfiguracao
                    },
                    'tab-coletor-tab-leitura@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabColetorTabLeitura
                    },
                    'tab-ocorrencia@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabOcorrencia
                    },
                    'tab-calculo@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabCalculo
                    },
                    'tab-calculo-tab-configuracao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabCalculoTabConfiguracao
                    },
                    'tab-calculo-tab-faixa@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabCalculoTabFaixa
                    },
                    'tab-calculo-tab-arredondamento@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabCalculoTabArredondamento
                    },
                    'tab-impressao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressao
                    },
                    'tab-impressao-tab-mensagens@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabMensagens
                    },
                    'tab-impressao-tab-comunicados@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicados
                    },
                    'tab-impressao-tab-comunicados-tab-consumoalterado@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabConsumoAlterado
                    },
                    'tab-impressao-tab-comunicados-tab-debitosanteriores@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabDebitosAnteriores
                    },
                    'tab-impressao-tab-comunicados-tab-ocorrencia@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabOcorrencia
                    },
                    'tab-impressao-tab-comunicados-tab-quitacaoanualdebitos@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabQuitacaoAnualDebitos
                    },
                    'tab-impressao-tab-comunicados-tab-alternativo@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabAlternativo
                    },
                    'tab-impressao-tab-comunicados-tab-servicos@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabComunicadosTabServicos
                    },
                    'tab-impressao-tab-outros@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabImpressaoTabOutros
                    },
                    'tab-controller@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabController
                    },
                    'tab-modoimplantacao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacao
                    },
                    'tab-modoimplantacao-tab-configuracao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabConfiguracao
                    },
                    'tab-modoimplantacao-tab-processamento@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabProcessamento
                    },
                    'tab-modoimplantacao-tab-auditoria@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabAuditoria
                    },
                    'tab-modoimplantacao-tab-auditoria-tab-outros@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabAuditoriaTabOutros
                    },
                    'tab-modoimplantacao-tab-critica@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabCritica
                    },
                    'tab-modoimplantacao-tab-outros@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabOutros
                    },
                    'tab-modoimplantacao-tab-especifico@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabEspecifico
                    },
                    'tab-modoimplantacao-tab-especifico-tab-jardinopolis@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabEspecificoTabJardinopolis
                    },
                    'tab-modoimplantacao-tab-dados-config@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabDadosConfig
                    },
                    'tab-modoimplantacao-tab-controle-importacao@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabControleImportacao
                    },
                    'tab-modoimplantacao-tab-ilhaSolteira@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabIlhaSolteira
                    },
                    'tab-modoimplantacao-tab-ilhaSolteira-tab-poupaAgua@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabIlhaSolteiraTabPoupaAgua
                    },
                    'tab-modoimplantacao-tab-ilhaSolteira-tab-ligacaoCota@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabIlhaSolteiraTabLigacaoCota
                    },
                    'tab-modoimplantacao-tab-ilhaSolteira-tab-lancamentoOcorrencia@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabIlhaSolteiraTabLancamentoOcorrencia
                    },
                    'tab-modoimplantacao-tab-marca-especial@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabMarcaEspecial
                    },
                    'tab-modoimplantacao-tab-danfag@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabDANFAg
                    },
                    'tab-modoimplantacao-tab-retencao-dados@app.cadastro_parametros': {
                        templateUrl: rotasHtml.tabs.tabModoImplantacaoTabRetencaoDados
                    }
                },
                resolve: {
                    obterDadosParametro: function ($q, Api, LocalStorageService, RequisicaoGenericaService) {
                        var deferred = $q.defer();

                        if (navigator.onLine) {
                            RequisicaoGenericaService.listarSemParams(Api.parametros.dadosParametro).then(
                                function (success) {
                                    deferred.resolve(success);
                                    LocalStorageService.armazenar("cadastro-parametro-obterDadosParametro", success.data);
                                },
                                function (error) {
                                    deferred.reject(error);
                                });
                        }
                        else {
                            deferred.resolve(LocalStorageService.recuperar("cadastro-parametro-obterDadosParametro"));
                        }

                        return deferred.promise;
                    },
                    obterListasParametro: function ($q, Api, LocalStorageService, RequisicaoGenericaService) {
                        var deferred = $q.defer();

                        if (navigator.onLine) {
                            RequisicaoGenericaService.listarSemParams(Api.parametros.listasParametro).then(
                                function (success) {
                                    deferred.resolve(success);
                                    LocalStorageService.armazenar("cadastro-parametro-obterListasParametro", success.data);
                                },
                                function (error) {
                                    deferred.reject(error);
                                });
                        }
                        else {
                            deferred.resolve(LocalStorageService.recuperar("cadastro-parametro-obterListasParametro"));
                        }

                        return deferred.promise;
                    },
                    ListarBoletos: function (BoletoBancarioService) {
                        return BoletoBancarioService.listar();
                    },
                    LogomarcaStream: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParamsComCache(Api.parametros.logomarcaStream);
                    },
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.parametros')
        .controller('DialogImagensPreDefinidasBackgroundController', DialogImagensPreDefinidasBackgroundController)

    /** @ngInject */
    function DialogImagensPreDefinidasBackgroundController(
        $mdDialog,
        MdDialogService,
        ZoomImagem,
        ImagemSelecionada
    ) {
        var vm = this;
        vm.houveAlteracao = false;

        vm.imagens = [
            {
                codigo: 1,
                src: 'assets/images/backgrounds/planoFundoDesk-1.png',
                selecionado: false
            },
            {
                codigo: 2,
                src: 'assets/images/backgrounds/planoFundoDesk-2.png',
                selecionado: false
            },
            {
                codigo: 3,
                src: 'assets/images/backgrounds/planoFundoDesk-3.png',
                selecionado: false
            }
        ];

        vm.metodos = {
            zoomImagem: ZoomImagem,
            selecionarImagem: selecionarImagem,
            fecharDialog: fecharDialog
        }
        init();

        function init() {
            _retornarImagemSelecionada();
        }

        function selecionarImagem(imagem) {
            vm.imagens.forEach(function (img) {
                if (img.codigo == imagem.codigo) {
                    img.selecionado = true;
                } else {
                    img.selecionado = false;
                }
            });

            vm.imagemSelecionada = vm.imagens.find(function (img) {
                return img.codigo == imagem.codigo && img.selecionado;
            });

            if (vm.imagemSelecionada) {
                vm.houveAlteracao = true;
                return vm.imagemSelecionada.src;
            }
        }

        function fecharDialog() {
            if (vm.houveAlteracao) {
                $mdDialog.hide(vm.imagemSelecionada.src);
            } else {
                $mdDialog.hide(ImagemSelecionada);
            }
        }

        function _retornarImagemSelecionada() {
            if (ImagemSelecionada) {
                vm.imagens.forEach(function (img) {
                    if (img.src == ImagemSelecionada) {
                        img.selecionado = true;
                    } else {
                        img.selecionado = false;
                    }
                });

                vm.imagemSelecionada = vm.imagens.find(function (img) {
                    return img.src == ImagemSelecionada && img.selecionado;
                });

                if (vm.imagemSelecionada) {
                    return vm.imagemSelecionada.src;
                }
            }
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo', [])
        .config(Config);

        function Config($stateProvider, RotasHtml) {
            var rotasHtml = RotasHtml.gerenciamentoGrupo;
    
            $stateProvider
                .state('app.gerenciamento_grupo', {
                    url: '/processamento/gerenciamentogrupo',
                    module: 'privado',
                    views: {
                        'content@app': {
                            templateUrl: rotasHtml.templateUrl,
                            controller: 'GerenciamentoGrupoController as vm',
                            abstract: true
                        },
    
                        'gerenciamentogrupo-form@app.gerenciamento_grupo': {
                            templateUrl: rotasHtml.form,
                        },
                        'gerenciamentogrupo-form-caema@app.gerenciamento_grupo': {
                            templateUrl: rotasHtml.caema.form,
                        },
                        'gerenciamentogrupo-filtro@app.gerenciamento_grupo':{
                            templateUrl: rotasHtml.sidenav.filtro,
                            controller: 'FiltroGerenciamentoGrupoController as vm'
                        },
                        'gerenciamentogrupo-filtro-caema@app.gerenciamento_grupo':{
                            templateUrl: rotasHtml.caema.sidenav.filtro,
                            controller: 'FiltroGerenciamentoGrupoController as vm'
                        },
                        'gerenciamentogrupo-legenda@app.gerenciamento_grupo':{
                            templateUrl: rotasHtml.sidenav.legenda,
                            controller: 'LegendaCoresGerenciamentoGrupoController as vm'
                        },
                        'distribuicao-form@app.distribuicao': {
                            templateUrl: RotasHtml.distribuicao.form,
                        },
                        'distribuicao-form-caema@app.distribuicao': {
                            templateUrl: RotasHtml.distribuicao.caema.form,
                        },

                        'disponibilizartarefas-form@app.disponibilizar_tarefas': {
                            templateUrl: RotasHtml.disponibilizarTarefas.form,
                        },
                        'disponibilizartarefas-form-caema@app.disponibilizar_tarefas': {
                            templateUrl: RotasHtml.disponibilizarTarefas.caema.form,
                        },
                        'importacao-grupo-leitura-form@app.importacao_grupo_leitura': {
                            templateUrl: RotasHtml.importacaoGrupoLeitura.form,
                        },
                        'importacao-grupo-leitura-form-caema@app.importacao_grupo_leitura': {
                            templateUrl: RotasHtml.importacaoGrupoLeitura.caema.form,
                        },
                        'exportacaogrupoleitura-form@app.exportacao_grupo_leitura': {
                            templateUrl: RotasHtml.exportacaoGrupoLeitura.form,
                        }, 
                        'exportacaogrupoleitura-caema-form@app.exportacao_grupo_leitura': {
                            templateUrl: RotasHtml.exportacaoGrupoLeitura.caema.form,
                        },                          
                        'trocarleiturista-form@app.controlecarga_trocarleiturista': {
                            templateUrl: RotasHtml.controleCarga.trocarLeiturista.form
                        },
                        
                    },
                    resolve: {
                        listarRegionais: function(RequisicaoGenericaService, Api){
                          return RequisicaoGenericaService.listarSemParams(Api.regional.listarTodos)
                        }
                    }                
            });
        }
}());
(function(){
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('DialogRotasController', DialogRotasController)

    /** @ngInject */
    function DialogRotasController(Rotas,$mdDialog, Titulo){
        var vm = this;
        
        vm.metodos = {
            fecharDialog: fecharDialog
        }
        init();

        function init(){
            vm.rotas = Rotas;
            if(Titulo) {
                vm.titulo = Titulo
            } else {
                vm.titulo = 'Rota(s)'
            }
        }

        function fecharDialog(){
            $mdDialog.hide();
        }

    }

}());
(function () {
  'use strict';

  angular
    .module('app.processamento.gerenciamentogrupo')
    .controller('DialogDetalhesUnificaoController', DialogDetalhesUnificaoController)

  /** @ngInject */
  function DialogDetalhesUnificaoController($mdDialog, Tarefa) {
    var vm = this;

    vm.metodos = {
      fecharDialog: fecharDialog
    }

    init();

    function init() {
      vm.tarefa = Tarefa;
    }

    function fecharDialog() {
      $mdDialog.hide();
    }
  }
}());

(function () {
  "use strict";

  angular
    .module("app.gerenciamento.leitura.visualizacao")
    .service("VisualizacaoLeituraService", VisualizacaoLeituraService);

  /** @ngInject */
  function VisualizacaoLeituraService(
    Api,
    RequisicaoGenericaService,
    $rootScope,
    MdDialogService
  ) {
    var vm = this;

    vm.carregaDadosDemaisAbas = function (filtro, controleForm) {
      var requisicaoDadosLeitura =
        RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
          Api.leitura.visualizacao.listarDadosLeitura,
          filtro
        );
      var requisicaoDadosFaturamento =
        RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
          Api.leitura.visualizacao.listarDadosFaturamento,
          filtro
        );
      controleForm.emProgresso = true;
      Promise.all([requisicaoDadosLeitura, requisicaoDadosFaturamento])
        .then(function (values) {
          vm.emitirDados("DadosLeituraRecebido", values[0].data);
          vm.emitirDados("DadosFaturamentoRecebido", values[1].data);
          vm.emitirDados("ControleFormVisualizacaoLeitura", controleForm);
          controleForm.emProgresso = false;
        })
        .catch(function (erros) {
          console.log(erros);
          MdDialogService.alertPadrao(
            "Atenção",
            null,
            "Não foi possível listar os dados de leitura, tente novamente!"
          );
          controleForm.emProgresso = false;
        });
    };

    vm.emitirDados = function (mensagem, dados) {
      $rootScope.$emit(mensagem, dados);
    };

    return vm;
  }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .factory('VisualizacaoLeituraFactory', VisualizacaoLeituraFactory)

    /** @ngInject */
    function VisualizacaoLeituraFactory(LoginUsuarioService, $rootScope) {

        var _dadosCritica = {};
        var _editandoLeituraComRetencao;
        var _leituristas = [];
        var _dadosCadastrais = {};
        var _dadosLeitura = {};

        function construirDadosCritica() {
            return {
                leitura: {},
                consumoReal: undefined,
                consumoFaturado: undefined,
                motivoCriticaNegada: undefined,
                resultadoCritica: '',
                statusCritica: undefined,
                usuarioCritica: LoginUsuarioService.usuarioArmazenado().login,
                leituraPosCritica: undefined,
                codigoOcorrenciaPosCritica: '',
                dataLeituraPosCritica: '',
                erroPorLeitura: false,
                erroPorOcorrencia: false,
                consumoFaturadoPosCritica: undefined
            };
        }

        function setDadosCritica(dadosCritica) {
            _dadosCritica = dadosCritica
        }

        function getDadosCritica() {
            return _dadosCritica;
        }

        function resetDadosCritica() {
            _dadosCritica = {}
        }


        function setEditandoComRetencao(editando) {
            _editandoLeituraComRetencao = editando;
        }
        function getEditancoComRetencao() {
            return _editandoLeituraComRetencao;
        }

        function setLeituristas(leituristas) {
            _leituristas = leituristas;
        }

        function getLeituristas() {
            return _leituristas;
        }

        function setDadosCadastrais(dadosCadastrais) {
            _dadosCadastrais = dadosCadastrais;
        }

        function getDadosCadastrais() {
            return _dadosCadastrais;
        }

        function setDadosLeitura(dadosLeitura) {
            _dadosLeitura = dadosLeitura;
        }

        function getDadosLeitura() {
            return _dadosLeitura;
        }

        return {
            construirDadosCritica: construirDadosCritica,
            setDadosCritica: setDadosCritica,
            getDadosCritica: getDadosCritica,
            resetDadosCritica: resetDadosCritica,
            setEditandoComRetencao: setEditandoComRetencao,
            getEditancoComRetencao: getEditancoComRetencao,
            setLeituristas: setLeituristas,
            getLeituristas: getLeituristas,
            setDadosCadastrais: setDadosCadastrais,
            getDadosCadastrais: getDadosCadastrais,
            setDadosLeitura: setDadosLeitura,
            getDadosLeitura: getDadosLeitura
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DadosLeituraController', DadosLeituraController);

    function DadosLeituraController(
        $rootScope,
        RotasHtml,
        MdDialogService,
        RequisicaoGenericaService,
        Api,
        $mdDialog,
        $window,
        SessionStorageService,
        KeysSessionStorage,
        VisualizacaoLeituraFactory
    ) {

        var vm = this;
        var rota = RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura;
        vm.dadosLeitura = {};
        vm.rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao;
        vm.tipoDetalheCalculo = SessionStorageService.recuperar(KeysSessionStorage.tipoDetalheCalculo);

        vm.metodos = {
            abrirDialogFotos: abrirDialogFotos,
            abrirDialogLogLeitura: abrirDialogLogLeitura,
            mostrarLocalizacaoLeitura: mostrarLocalizacaoLeitura,
            mostrarLocalizacaoEntregaFatura: mostrarLocalizacaoEntregaFatura
        }

        $rootScope.$on('DadosLeituraRecebido', function (event, dados) {
            vm.dadosLeitura = angular.copy(dados);
            VisualizacaoLeituraFactory.setDadosLeitura(vm.dadosLeitura);
            vm.entidadeDeEnvio = {
                mesAnoReferencia: null,
                codigoCliente: vm.dadosLeitura.codigoCliente,
                nomeArquivoExportacao: vm.dadosLeitura.nomeArquivoExportacao
            };
            _definirMenusAbaLeitura();
        });

        function abrirDialogFotos() {
            vm.filtroFotosViewModel = {
                codigoCliente: vm.dadosLeitura.codigoCliente,
                nomeArquivoExportacao: vm.dadosLeitura.nomeArquivoExportacao,
                dataImportacaoArquivo: vm.dadosLeitura.dataImportacaoArquivo,
                dataLeitura: vm.dadosLeitura.dataLeitura
            };

            RequisicaoGenericaService.salvar(Api.leitura.visualizacao.listarCaminhoFotosLeitura, vm.filtroFotosViewModel)
                .then(function (success) {
                    var data = success.data;
                    $mdDialog.show({
                        controller: 'DialogFotosDadosLeituraController',
                        controllerAs: 'vm',
                        templateUrl: rota.dialogs.fotos.templateUrl,
                        //parent: ---------------,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Fotos: {
                                fotosHidrometro: data.fotosHidrometro,
                                fotosFachada: data.fotosFachada,
                                fotosProvaAdulteracao: data.fotosProvaAdulteracao,
                                fotosOutros: data.fotosOutros,
                                fotosRepasse: data.fotosRepasse,
                            }
                        }
                    });

                }, function (error) {
                    if (error.data)
                        MdDialogService.alertPadrao("Atenção!", null, error.data);
                    else
                        MdDialogService.alertPadrao("Atenção!", null, error);
                });
        }

        function abrirDialogLogLeitura() {

            RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
                Api.leitura.visualizacao.listarLogLeitura, vm.entidadeDeEnvio)
                .then(function (success) {
                    $mdDialog.show({
                        controller: 'DialogLogLeituraController',
                        controllerAs: 'vm',
                        templateUrl: rota.dialogs.logLeitura,
                        //parent: ---------------,
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Dados: success.data
                        }
                    });
                });
        }

        function mostrarLocalizacaoLeitura(dadosLeitura) {
            if (!dadosLeitura) return;
            if (!dadosLeitura.latitudeGPS && !dadosLeitura.longitudeGPS) return;

            var coordenadas = dadosLeitura.latitudeGPS + ',' + dadosLeitura.longitudeGPS;
            var url = 'http://maps.google.com/maps?q=' + coordenadas;
            $window.open(url, "_blank");
        }

        function mostrarLocalizacaoEntregaFatura(dadosLeitura) {
            if (!dadosLeitura) return;
            if (!dadosLeitura.latitudeGPSEntregaFatura && !dadosLeitura.longitudeGPSEntregaFatura) return;

            var coordenadas = dadosLeitura.latitudeGPSEntregaFatura + ',' + dadosLeitura.longitudeGPSEntregaFatura;
            var url = 'http://maps.google.com/maps?q=' + coordenadas;
            $window.open(url, "_blank");
        }

        function _definirMenusAbaLeitura() {
            vm.menus = [
                {
                    icon: 'icon-map-marker s20',
                    name: 'Ver localização da leitura',
                    direction: 'top',
                    disabled: (!vm.dadosLeitura.latitudeGPS && !vm.dadosLeitura.longitudeGPS),
                    executarAcaoClick: function () {
                        return mostrarLocalizacaoLeitura(vm.dadosLeitura);
                    }
                },
                {
                    icon: 'icon-map-marker s20',
                    name: 'Ver localização da entrega da fatura',
                    direction: 'top',
                    hide: (vm.tipoDetalheCalculo !== 89),
                    disabled: (!vm.dadosLeitura.latitudeGPSEntregaFatura && !vm.dadosLeitura.longitudeGPSEntregaFatura),
                    executarAcaoClick: function () {
                        return mostrarLocalizacaoEntregaFatura(vm.dadosLeitura);
                    }
                },
                {
                    icon: 'icon-camera s20',
                    name: 'Visualizar fotos da leitura',
                    direction: 'top',
                    disabled: (!vm.dadosLeitura.fotoEnviadaImportacaoOnline),
                    executarAcaoClick: function () {
                        return abrirDialogFotos();
                    }
                },
                {
                    icon: 'icon-format-list-bulleted s20',
                    name: 'Visualizar log da leitura',
                    direction: 'top',
                    disabled: (!vm.dadosLeitura),
                    executarAcaoClick: function () {
                        return abrirDialogLogLeitura();
                    }
                }
            ];
        }
    }
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
  "use strict";

  angular
    .module("app.gerenciamento.leitura.visualizacao")
    .controller("DadosFaturamentoController", DadosFaturamentoController);

  function DadosFaturamentoController(
    $mdDialog,
    RotasHtml,
    $rootScope,
    VisualizacaoLeituraFactory,
    RequisicaoGenericaService,
    Api,
    MdDialogService,
    RelatorioService,
    LoginUsuarioService,
    SessionStorageService,
    KeysSessionStorage
  ) {
    var vm = this;
    var rota =
      RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosFaturamento;
    vm.rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao;
    vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
    var possuiLancamentosConsumo = false;

    vm.metodos = {
      abrirDialogServico: abrirDialogServico,
      abrirDialogHistorico: abrirDialogHistorico,
    };

    $rootScope.$on("DadosFaturamentoRecebido", function (event, dados) {
      vm.dadosFaturamento = angular.copy(dados);
      possuiLancamentosConsumo = vm.dadosFaturamento.possuiLancamentosConsumo;
      _atualizarBotoesFlutuantes();
    });

    $rootScope.$on(
      "ControleFormVisualizacaoLeitura",
      function (event, controleForm) {
        vm.controleForm = controleForm;
      }
    );

    init();

    function init() {
      _atualizarBotoesFlutuantes();
    }

    function _atualizarBotoesFlutuantes() {
      vm.itens = [
        {
          icon: "icon-cash-multiple s20",
          name: "Serviço",
          direction: "top",
          executarAcaoClick: function () {
            return abrirDialogServico();
          },
        },
        {
          icon: "icon-clipboard-outline s20",
          name: "Histórico de consumo",
          direction: "top",
          executarAcaoClick: function () {
            return abrirDialogHistorico();
          },
        },
        {
          icon: "icon-water s20",
          name: "Histórico de abastecimento",
          hide: !possuiLancamentosConsumo,
          direction: "top",
          executarAcaoClick: function () {
            return abrirDialogHistoricoAbastecimento();
          },
        },
        {
          icon: "icon-file-document s20",
          name: "Emitir segunda via",
          direction: "top",
          disabled: !vm.dadosFaturamento || vm.dadosFaturamento.lido != "S",
          executarAcaoClick: function () {
            return emitirSegundaVia();
          },
        },
        {
          icon: "icon-library-books s20",
          name: "Emitir segunda via comunicado ocorrência",
          direction: "top",
          disabled: !vm.dadosFaturamento || !VisualizacaoLeituraFactory.getDadosCadastrais().permiteSegundaViaOcorrencia,
          executarAcaoClick: function () {
            return emitirSegundaViaOcorrencia();
          },
        }
      ];
    }

    function abrirDialogHistorico() {
      $mdDialog.show({
        controller: "DialogHistoricoController",
        controllerAs: "vm",
        templateUrl: rota.dialogs.historico,
        //parent: ---------------,
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          NomeCliente: vm.dadosFaturamento.nomeCliente,
          CodigoCliente: vm.dadosFaturamento.codigoCliente,
          NomeArquivoExportacao: vm.dadosFaturamento.nomeArquivoExportacao,
        },
      });
    }

    function abrirDialogHistoricoAbastecimento() {
      $mdDialog.show({
        controller: "DialogHistoricoAbastecimentoController",
        controllerAs: "vm",
        templateUrl: rota.dialogs.historicoAbastecimento,
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          Dados: {
            CodigoCliente: vm.dadosFaturamento.codigoCliente,
            NomeArquivoExportacao: vm.dadosFaturamento.nomeArquivoExportacao,
            Leituristas: VisualizacaoLeituraFactory.getLeituristas(),
          },
        },
      });
    }

    function abrirDialogServico() {
      $mdDialog.show({
        controller: "DialogDadosServicoController",
        controllerAs: "vm",
        templateUrl: rota.dialogs.servico,
        multiple: true,
        //parent: ---------------,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          CodigoCliente: vm.dadosFaturamento.codigoCliente,
          NomeArquivoExportacao: vm.dadosFaturamento.nomeArquivoExportacao,
          NomeCliente: vm.dadosFaturamento.nomeCliente,
        },
      });
    }

    function emitirSegundaVia() {
      vm.controleForm.habilitarAbaFaturamento = true;
      vm.controleForm.emProgresso = true;

      RequisicaoGenericaService.downloadPDF(
        Api.leitura.visualizacao.emitirSegundaVia,
        {
          CodigoCliente: vm.dadosFaturamento.codigoCliente,
          NomeArquivoExportacao: vm.dadosFaturamento.nomeArquivoExportacao,
        }
      )
        .then(
          function (success) {
            MdDialogService.alertPadrao("Relatório gerado com sucesso!");
            var file = new Blob([success.data], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
          function (error) {
            MdDialogService.alertPadrao(
              RelatorioService.arrayBufferToString(error.data)
            );
          }
        )
        .finally(function () {
          vm.controleForm.habilitarAbaFaturamento = false;
          vm.controleForm.emProgresso = false;
        });
    }

    function emitirSegundaViaOcorrencia() {
      vm.controleForm.habilitarAbaFaturamento = true;
      vm.controleForm.emProgresso = true;

      var partesEndereco = [];
      if (vm.parametros.empresa.endereco) {
        partesEndereco.push(vm.parametros.empresa.endereco);
      }
      if (vm.parametros.empresa.bairro) {
        partesEndereco.push(vm.parametros.empresa.bairro);
      }

      var cidadeUf = [];
      if (vm.parametros.empresa.cidade) {
        cidadeUf.push(vm.parametros.empresa.cidade);
      }
      if (vm.parametros.empresa.uf) {
        cidadeUf.push(vm.parametros.empresa.uf);
      }

      if (cidadeUf.length > 0) {
        partesEndereco.push(cidadeUf.join(' - '));
      }

      var enderecoCompleto = partesEndereco.join(', ');

      var dadosRelatorio = {
        CodigoCliente: vm.dadosFaturamento.codigoCliente,
        NomeArquivoExportacao: vm.dadosFaturamento.nomeArquivoExportacao,
        EnderecoImovel: VisualizacaoLeituraFactory.getDadosCadastrais().enderecoImovel,
        NumeroImovel: VisualizacaoLeituraFactory.getDadosCadastrais().numeroImovel,
        BairroImovel: VisualizacaoLeituraFactory.getDadosCadastrais().bairroImovel,
        Complemento: VisualizacaoLeituraFactory.getDadosCadastrais().complemento,
        Nome: VisualizacaoLeituraFactory.getDadosCadastrais().nome,
        UsuarioLogado: LoginUsuarioService.usuarioArmazenado().login,
        NomeEmpresa: vm.parametros.empresa.nomeEmpresa,
        EnderecoEmpresa: enderecoCompleto,
      };

      console.table(dadosRelatorio);

      RequisicaoGenericaService.downloadPDF(
        Api.leitura.visualizacao.emitirSegundaViaOcorrencia,
        dadosRelatorio
      )
        .then(
          function (success) {
            if (success.status === 204) {
              MdDialogService.alertPadrao(
                "Atenção!", null, "Para realizar a impressão deste comunicado, entre em contato com o suporte."
              );
            } else {
              MdDialogService.alertPadrao("Relatório gerado com sucesso!");
              var file = new Blob([success.data], {
                type: "application/pdf;base64",
              });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            }
          },
          function (error) {
            MdDialogService.alertPadrao(
              "Atenção!", null, error.data
            );
          }
        )
        .finally(function () {
          vm.controleForm.habilitarAbaFaturamento = false;
          vm.controleForm.emProgresso = false;
        });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.visualizacao')
        .controller('DadosCriticaController', DadosCriticaController)

    /** @ngInject */
    function DadosCriticaController(RotasHtml, $rootScope, RequisicaoGenericaService, Api, MdDialogService, DTDefaultOptions, DatatableFactory, CriticaLeituraService, $mdDialog) {
        var vm = this;

        vm.rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao;


        vm.metodos = {
            configuraMdSelectOcorrencia: configuraMdSelectOcorrencia,
            abrirDialogFotos: abrirDialogFotos,
            abrirDialogMotivoCritica: abrirDialogMotivoCritica
        }

        $rootScope.$on('DadosFaturamentoRecebido', function (event, dados) {
            _buscarHistoricoCriticas(dados.codigoCliente, dados.nomeArquivoExportacao);
        });

        $rootScope.$on('ResetDadosCritica', function (event, data) {
            vm.dadosCritica = {};
        });

        init();

        function init() {
            vm.dtOptions = _construirDtOptions();
            vm.dtOptions.order = [0, 'desc'];
            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
        }

        function _construirDtOptions() {
            return DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                    orderable: false
                },
                {
                    targets: [2],
                    orderData: 1
                },
                {
                    targets: [0, 2, 14],
                    responsivePriority: 1
                }
            ]);
        }

        function configuraMdSelectOcorrencia() {
            vm.filtrarOcorrencia = "";
            angular.element('#select-ocorrencia').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _buscarHistoricoCriticas(codigoCliente, nomeArquivoExportacao) {
            var viewModel = {
                nomeArquivoExportacao: nomeArquivoExportacao,
                codigoCliente: codigoCliente,
                retornaHistoricoProporcional: false
            }
            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarHistoricoCritica, viewModel);
            promisse.then(function (success) {
                vm.historicosCriticas = success.data;
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            });
        }

        function abrirDialogFotos(critica) {
            if (vm.dialogFotosAberto) return;
            critica.emProgresso = true;
            var pFotos = CriticaLeituraService
                .buscarFotosPorVisita(critica.codigoCliente, critica.gleiCodigo, critica.numeroCritica);
            pFotos.then(function (success) {
                if (!success.data.length) {
                    MdDialogService.alertPadrao("Atenção", null, 'Não foram encontradas fotos para essa visita.');
                    return;
                }
                vm.dialogFotosAberto = true;
                $mdDialog.show({
                    controller: 'DialogFotosHistoricoCriticaController as vm',
                    templateUrl: RotasHtml.gerenciamento.critica.consulta.dialogs.fotosVisita,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        Fotos: success.data
                    }
                }).then(function () { vm.dialogFotosAberto = false; })
                    .finally(function () { vm.dialogFotosAberto = false; });
            }, function (error) {
                MdDialogService.alertPadrao("Atenção", null, error.data);
                vm.dialogFotosAberto = false;
            }).finally(function () { critica.emProgresso = false; });
        }

        function abrirDialogMotivoCritica(critica) {
            $mdDialog.show({
                controller: 'DialogMotivoCriticaController as vm',
                templateUrl: RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosCritica.dialogs.motivoCritica.templateUrl,
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: event,
                locals: {
                    Motivo: critica.motivo,
                    Erros: {
                        ocorrencia: critica.erroOcorrencia,
                        leitura: critica.erroLeitura
                    }
                }
            });
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.usuario', [])
        .config(config);

    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.cadastro_usuario_usuario', {
                url: '/cadastro-usuario',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cadastros/usuario/usuario/views/usuario.html',
                        controller: 'UsuarioController as vm'
                    },
                    'usuario-form@app.cadastro_usuario_usuario': {
                        templateUrl: 'app/main/cadastros/usuario/usuario/views/usuario-form.html',
                    },
                    'usuarios-tabela@app.cadastro_usuario_usuario': {
                        templateUrl: 'app/main/cadastros/usuario/usuario/views/usuarios-tabela.html',
                    }
                },
                resolve: {
                    perfis: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.perfil.listartodos);
                    },
                    listarAgrupamentos: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.agrupamento.listarTodos);
                    },
                    ListarTodosUsuarios: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.usuario.listartodos);
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.usuario')
        .controller("DialogInclusaoSenhaController", DialogInclusaoSenhaController);

    function DialogInclusaoSenhaController($mdDialog, Usuario, MdToastService, MdDialogService, form) {
        var vm = this;

        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            confirmar: confirmar
        };

        function confirmar() {
            if (vm.senhaNova && vm.confirmacaoSenhaNova) {
                if (vm.senhaNova == vm.confirmacaoSenhaNova) {
                    Usuario.senha = vm.senhaNova;
                    form.$setDirty();
                    MdToastService.toastPadrao("Senha incluída com sucesso!");
                    $mdDialog.hide();
                }
                else {
                    MdToastService.toastErro("As senhas digitadas não conferem.");
                }
            }
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.usuario')
        .controller("DialogAlteracaoSenhaController", DialogAlteracaoSenhaController);

    function DialogAlteracaoSenhaController($mdDialog, Usuario, Api, RequisicaoGenericaService, MdToastService, form) {
        var vm = this;

        vm.emProgresso = false;
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            confirmar: confirmar
        };

        function confirmar() {
            if (vm.senhaNova && vm.confirmacaoSenhaNova) {
                if (vm.senhaNova == vm.confirmacaoSenhaNova) {
                    vm.emProgresso = true;
                    var lstrSenhaAtual = btoa(vm.senhaAtual);

                    var promessa = RequisicaoGenericaService
                        .listarSemParams(Api.usuario.confirmarSenhaPorCodigo + Usuario.codigo + "/" + lstrSenhaAtual);

                    promessa.then(
                        function (success) {
                            vm.emProgresso = false;
                            if (success.data) {
                                Usuario.senha = vm.senhaNova;
                                Usuario.possuiSenha = true;
                                Usuario.login = Usuario.login;
                                form.$setDirty();
                                $mdDialog.hide();
                                return;
                            }
                            else {
                                MdToastService.toastErro("Senha atual inválida.");
                            }
                        }, function (error) {
                            vm.emProgresso = false;
                            MdToastService.toastErro(error.data);
                        }
                    );
                }
                else {
                    MdToastService.toastErro("As senhas digitadas não conferem.");
                }
            }
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.processamento.gerenciamentogrupo')
        .controller('DialogLegendaController', DialogLegendaController);

    /** @ngInject */
    function DialogLegendaController(
        $mdDialog
    ) {

        var vm = this;
        init();
        vm.metodos = {
            fecharDialog: fecharDialog
        }

        function init() {
            vm.legendaCores = [
                {
                    descricao: 'Quando a projeção final é menor que a data fim estimada',
                    cor: '#4CAF50'
                },
                {
                    descricao: 'Quando a projeção final é igual a data fim estimada',
                    cor: '#FFC100'
                },
                {
                    descricao: 'Quando a projeção final é maior que a data fim estimada',
                    cor: '#E51001'
                }
            ]
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.distribuicao;

        $stateProvider
            .state('app.distribuicao', {
                url: '/processamento/distribuicao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'DistribuicaoController as vm',
                        abstract: true
                    },
                    'distribuicao-form@app.distribuicao': {
                        templateUrl: rotasHtml.form,
                    },
                    'distribuicao-form-caema@app.distribuicao': {
                        templateUrl: rotasHtml.caema.form,
                    },
                    'distribuicao-filtro@app.distribuicao': {
                        templateUrl: rotasHtml.sidenav.filtroDistribuicao,
                        controller: 'DistribuicaoFiltroController as vm'
                    },
                    'distribuicao-filtro-caema@app.distribuicao': {
                        templateUrl: rotasHtml.caema.sidenav.filtroDistribuicao,
                        controller: 'DistribuicaoFiltroCaemaController as vm'
                    },
                    'disponibilizartarefas-form@app.disponibilizar_tarefas': {
                        templateUrl: RotasHtml.disponibilizarTarefas.form,
                    },
                    'disponibilizartarefas-form-caema@app.disponibilizar_tarefas': {
                        templateUrl: RotasHtml.disponibilizarTarefas.caema.form,
                    },
                    'trocarleiturista-form@app.controlecarga_trocarleiturista': {
                        templateUrl: RotasHtml.controleCarga.trocarLeiturista.form
                    },
                },
                resolve: {
                    Grupo: function () { return null }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DistribuicaoFiltroCaemaController', DistribuicaoFiltroCaemaController)

    /** @ngInject */
    function DistribuicaoFiltroCaemaController(DistribuicaoFiltroService, $rootScope, MdDialogService, $mdSidenav, DistribuicaoService) {
        var vm = this;

        init();

        vm.metodos = {
            pesquisarGrupos: pesquisarGrupos,
            pesquisarMunicipiosPorRegional: pesquisarMunicipiosPorRegional,
            filtrarDadosDistribuicao: filtrarDadosDistribuicao
        }

        function init() {
            vm.filtro = DistribuicaoFiltroService.construirFiltro();
            _pesquisarParametros();
            _pesquisarAgrupamentos();
            _pesquisarTiposDistribuicao();
        }

        function _pesquisarParametros() {
            vm.parametros = DistribuicaoFiltroService.retornarParametros();
        }

        function _pesquisarAgrupamentos() {
            vm.regionais = DistribuicaoFiltroService.pesquisarAgrupamentos();
        }

        function _pesquisarTiposDistribuicao() {
            var pTiposDistribuicao = DistribuicaoFiltroService.pesquisarTiposDistribuicao();
            pTiposDistribuicao.then(function (success) {
                vm.tipodistribuicoes = success;
                vm.filtro.tipodistribuicao = vm.tipodistribuicoes[2].codigo;
            });
        }

        function pesquisarGrupos(regional, mes, ano) {
            _setProgressoGrupo(true);
            var pGrupos = DistribuicaoFiltroService.pesquisarGrupos(regional, mes, ano);
            pGrupos.then(function (success) { vm.grupos = success }).finally(function () { _setProgressoGrupo(false) });
        }

        function pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            _setProgressoMunicipio(true);
            var pMunicipios = DistribuicaoFiltroService.pesquisarMunicipiosPorAgrupamento(regional, mes, ano, grupo);
            pMunicipios.then(function (success) { vm.municipios = success }).finally(function () { _setProgressoMunicipio(false) });
        }


        function filtrarDadosDistribuicao(filtro) {
            _setProgresso(true);
            $rootScope.$broadcast("limparDadosDistribuicao", true);
            var pVerificarExistenciaGrupo = DistribuicaoFiltroService.filtrarDadosDistribuicao(filtro);
            pVerificarExistenciaGrupo
                .then(
                    function () {
                        _consistirDadosDistribuicao(filtro);
                        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
                    },
                    function (error) {
                        _setProgresso(false);
                        MdDialogService.alertPadrao("Atenção", event, error)
                    }
                ).finally(function () { });
        }

        function _consistirDadosDistribuicao(filtro) {
            var pConsistirDados = DistribuicaoFiltroService.consistirLeiturasDistribuidas(filtro);
            pConsistirDados.then(function (success) {
                if ($mdSidenav("filtro-distribuicao").isOpen()) {
                    $mdSidenav("filtro-distribuicao").toggle();
                }
                _setProgresso(false);
                MdDialogService.confirmPadraoComEvento("Atenção", success.data.mensagem, null, function () {
                    _carregarDadosDistribuicao(filtro)
                }, function () {
                    MdDialogService.alertPadrao("Atenção", null, "Processo de distribuição não foi iniciado.");
                });
            });
        }

        function _carregarDadosDistribuicao(filtro) {
            $rootScope.$broadcast("carregamentoDados", true);
            var pDadosDistribuicao = DistribuicaoFiltroService.carregarDadosDistribuicao(filtro);
            pDadosDistribuicao.then(function (success) {
                if (filtro.tipodistribuicao == 3) {
                    var bkp = success.data;
                    DistribuicaoService
                        .abrirDialogSelecionarQuadra(success.data.detalhesDistribuicao, success.data.resumoDistribuicao, filtro.tipodistribuicao)
                        .then(function (success) {
                            success.bkp = bkp;
                            $rootScope.$broadcast("dadosDistribuicao", success);
                        }, function (err) {
                            err.bkp = bkp;
                            $rootScope.$broadcast("dadosDistribuicao", err);
                        });
                }
                else {
                    $rootScope.$broadcast("dadosDistribuicao", success.data);
                }
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            });
        }


        function _setProgresso(progresso) {
            vm.emProgresso = progresso;
        }

        function _setProgressoGrupo(progresso) {
            vm.emProgressoBuscaGrupo = progresso;
        }

        function _setProgressoMunicipio(progresso) {
            vm.emProgressoBuscaMunicipio = progresso;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.alertacliente', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.alertaCliente;

        $stateProvider
            .state('app.alerta_cliente', {
                url: '/processamento/alertacliente',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'AlertaClienteController as vm',
                        abstract: true
                    },
                    'alertacliente-form@app.alerta_cliente': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    ListarTodos: function (AlertaClienteHttpService) {
                        return AlertaClienteHttpService.listarTodos();
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.alertacliente')
        .controller('DialogCadastrarAlertaController', DialogCadastrarAlertaController)

    function DialogCadastrarAlertaController(Alerta, $mdDialog, MdDialogService, AlertaClienteHttpService) {
        var vm = this;
        vm.alerta = {};
        vm.editando = false;
        vm.emProgresso = false;

        init();

        function init() {
            if (Alerta) {
                vm.alerta = Alerta;
                vm.editando = true;
            }
        }

        vm.metodos = {
            salvar: salvar,
            fecharDialog: fecharDialog,
        }

        function salvar() {
            vm.emProgresso = true;

            if (vm.editando) {
                AlertaClienteHttpService.editar(vm.alerta).then(function (success) {
                    MdDialogService.alertPadraoComEvento(success.data, function () { $mdDialog.hide(true); });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
            } else {
                AlertaClienteHttpService.salvar(vm.alerta).then(function (success) {
                    MdDialogService.alertPadraoComEvento(success.data, function () { vm.alerta = null; });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
            }
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }
    }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.resumoretencoes', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.resumoretencoes;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_resumoretencoes', {
        url: '/gerenciamento/dashboards/resumoretencoes',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'ResumoRetencoesController as vm'
          },
          'dashboards-resumoretencoes-faturassimplificado-form@app.gerenciamento.dashboards_resumoretencoes': {
            templateUrl: rotasHtml.faturasSimplificado.form
          },
          'dashboards-resumoretencoes-faturasdetalhado-form@app.gerenciamento.dashboards_resumoretencoes': {
            templateUrl: rotasHtml.faturasDetalhado.form
          },
          'dashboards-resumoretencoes-comunicadosdetalhado-form@app.gerenciamento.dashboards_resumoretencoes': {
            templateUrl: rotasHtml.comunicadosDetalhado.form
          },
          'dashboards-resumoretencoes-comunicadossimplificado-form@app.gerenciamento.dashboards_resumoretencoes': {
            templateUrl: rotasHtml.comunicadosSimplificado.form
          },
          'resumoretencoes-filtro@app.gerenciamento.dashboards_resumoretencoes': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroResumoRetencoesController as vm"
          }
        },
        resolve: {}
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.resumoretencoes')
    .controller('FiltroResumoRetencoesController', FiltroResumoRetencoesController)

  /** @ngInject */
  function FiltroResumoRetencoesController(ResumoRetencoesService, MdDialogService) {
    var vm = this;

    _carregaDadosFiltrosSalvos();

    vm.metodos = {
      marcarFiltroReferenciaOuPeriodo: marcarFiltroReferenciaOuPeriodo,
      marcarFiltroSimplificadoOuDetalhado: marcarFiltroSimplificadoOuDetalhado,
      marcarFiltroFaturaOuComunicado: marcarFiltroFaturaOuComunicado,
      filtrarDados: filtrarDados,
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();

      var viewModel = {};

      if (vm.referenciaOuPeriodo) {
        viewModel.tipoFiltro = 1;
        viewModel.mesInicial = filtro.mesInicial;
        viewModel.anoInicial = filtro.anoInicial;
        viewModel.mesFinal = filtro.mesFinal;
        viewModel.anoFinal = filtro.anoFinal;
      } else {
        viewModel.tipoFiltro = 2;
        viewModel.dataInicial = filtro.dataInicio;
        viewModel.dataFinal = filtro.dataFim;
      }


      if (vm.faturaOuComunicado) { // FATURA

        if (!vm.simplificadoOuDetalhado) { // DETALHADO

          var pBuscarDadosDetalhado = ResumoRetencoesService.buscarDadosFaturasDetalhado(viewModel);

          viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
          viewModel.tipoRetencao = vm.faturaOuComunicado;

          ResumoRetencoesService.setFiltro(viewModel);

          pBuscarDadosDetalhado
            .then(function (success) {
              var dados = success.data;

              var object = {
                dados: dados,
                filtros: viewModel
              }

              ResumoRetencoesService.listener(function () { return object; });

              ResumoRetencoesService.toggleFiltro();

            }, function (error) {
              console.log(error);
              MdDialogService.alertPadrao("Atenção!", event, error.data);
            })
            .finally(function () { _finalizarProgresso() });

        } else { // SIMPLIFICADO

          var pBuscarDadosSimplificado = ResumoRetencoesService.buscarDadosFaturasSimplificado(viewModel);

          viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
          viewModel.tipoRetencao = vm.faturaOuComunicado;

          ResumoRetencoesService.setFiltro(viewModel);

          pBuscarDadosSimplificado
            .then(function (success) {
              var dados = success.data;

              var dadosGraficoGeral = [];

              if (dados.detalhesReferencias.length > 1) {
                dados.detalhesReferencias.forEach(function (dado) {
                  dadosGraficoGeral.push({
                    label: dado.referencia,
                    value: dado.totalReferencia
                  });
                });
              }

              dados.detalhesReferencias.forEach(function (dado) {
                dado.dadosGraficoIndividual = [];
                dado.grupos.forEach(function (grupo) {
                  dado.dadosGraficoIndividual.push({
                    key: grupo.grupo,
                    y: grupo.totalGrupo
                  });
                });
              });

              var object = {
                dados: dados,
                filtros: viewModel,
                dadosGraficoGeral: dadosGraficoGeral
              }

              ResumoRetencoesService.listener(function () { return object; });

              ResumoRetencoesService.toggleFiltro();

            }, function (error) {
              console.log(error);
              MdDialogService.alertPadrao("Atenção!", event, error.data);
            })
            .finally(function () { _finalizarProgresso() });

        }
      } else { // COMUNICADO

        if (!vm.simplificadoOuDetalhado) { // DETALHADO

          var pBuscarDadosComunicadoDetalhado = ResumoRetencoesService.buscarDadosComunicadosDetalhado(viewModel);

          viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
          viewModel.tipoRetencao = vm.faturaOuComunicado;

          ResumoRetencoesService.setFiltro(viewModel);

          pBuscarDadosComunicadoDetalhado
            .then(function (success) {
              var dados = success.data;

              var object = {
                dados: dados,
                filtros: viewModel
              }

              ResumoRetencoesService.listener(function () { return object; });

              ResumoRetencoesService.toggleFiltro();

            }, function (error) {
              console.log(error);
              MdDialogService.alertPadrao("Atenção!", event, error.data);
            })
            .finally(function () { _finalizarProgresso() });
        } else { // SIMPLIFICADO

          var pBuscarDadosComunicadoDetalhado = ResumoRetencoesService.buscarDadosComunicadosSimplificado(viewModel);

          viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
          viewModel.tipoRetencao = vm.faturaOuComunicado;

          ResumoRetencoesService.setFiltro(viewModel);

          pBuscarDadosComunicadoDetalhado
            .then(function (success) {
              var dados = success.data;

              var dadosGraficoGeral = [];

              if (dados.detalhesReferencias.length > 1) {
                dados.detalhesReferencias.forEach(function (dado) {
                  dadosGraficoGeral.push({
                    label: dado.referencia,
                    value: dado.totalReferencia
                  });
                });
              }

              dados.detalhesReferencias.forEach(function (dado) {
                dado.dadosGraficoIndividual = [];
                dado.grupos.forEach(function (grupo) {
                  dado.dadosGraficoIndividual.push({
                    key: grupo.grupo,
                    y: grupo.totalGrupo
                  });
                });
              });

              var object = {
                dados: dados,
                filtros: viewModel,
                dadosGraficoGeral: dadosGraficoGeral
              }

              ResumoRetencoesService.listener(function () { return object; });

              ResumoRetencoesService.toggleFiltro();

            }, function (error) {
              console.log(error);
              MdDialogService.alertPadrao("Atenção!", event, error.data);
            })
            .finally(function () { _finalizarProgresso() });
        }
      }
    }

    function _carregaDadosFiltrosSalvos() {
      var filtro = ResumoRetencoesService.getFiltro();

      if (filtro) {

        vm.filtro = filtro;
        vm.filtro.dataInicio = filtro.dataInicial;
        vm.filtro.dataFim = filtro.dataFinal;
        vm.faturaOuComunicado = filtro.tipoRetencao;
        vm.simplificadoOuDetalhado = filtro.tipoDashboard;
        vm.referenciaOuPeriodo = filtro.tipoFiltro == 1 ? true : false;
      } else {

        vm.referenciaOuPeriodo = true;
        vm.faturaOuComunicado = true;
        vm.simplificadoOuDetalhado = true;
      }
    }

    function marcarFiltroReferenciaOuPeriodo() {
      //True = Referencia --- False = Periodo
      vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
    }

    function marcarFiltroSimplificadoOuDetalhado() {
      //True = Simplificado --- False = Detalhado
      vm.simplificadoOuDetalhado = vm.simplificadoOuDetalhado ? false : true;
    }

    function marcarFiltroFaturaOuComunicado() {
      //True = Fatura --- False = Comunicado
      vm.faturaOuComunicado = vm.faturaOuComunicado ? false : true;
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quitacaoanual', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.quitacaoanual;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_quitacaoanual', {
        url: '/gerenciamento/dashboards/quitacaoanual',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'QuitacaoAnualController as vm'
          },
          'dashboards-quitacaoanual-simplificado-form@app.gerenciamento.dashboards_quitacaoanual': {
            templateUrl: rotasHtml.quitacaoAnualSimplificado.form
          },
          'dashboards-quitacaoanual-detalhado-form@app.gerenciamento.dashboards_quitacaoanual': {
            templateUrl: rotasHtml.quitacaoAnualDetalhado.form
          },
          'quitacaoanual-filtro@app.gerenciamento.dashboards_quitacaoanual': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroQuitacaoAnualController as vm"
          }
        },
        resolve: {
          ListarGrupos: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.clienteOcorrencia.retornarTodosGrupos);
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quitacaoanual')
    .controller('FiltroQuitacaoAnualController', FiltroQuitacaoAnualController)

  /** @ngInject */
  function FiltroQuitacaoAnualController(QuitacaoAnualService, MdDialogService, ListarGrupos) {
    var vm = this;


    _carregarDadosGrupos();

    _carregarDadosFiltrosSalvos();

    vm.metodos = {
      marcarFiltroReferenciaOuPeriodo: marcarFiltroReferenciaOuPeriodo,
      marcarFiltroSimplificadoOuDetalhado: marcarFiltroSimplificadoOuDetalhado,
      filtrarDados: filtrarDados,
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();

      var viewModel = {};

      if (vm.referenciaOuPeriodo) {
        viewModel.tipoFiltro = 1;
        viewModel.mesReferencia = filtro.mesReferencia;
        viewModel.anoReferencia = filtro.anoReferencia;
      } else {
        viewModel.tipoFiltro = 2;
        viewModel.dataInicial = filtro.dataInicial;
        viewModel.dataFinal = filtro.dataFinal;
      }

      viewModel.gruposLeitura = [];


      if (vm.filtro.gruposLeitura) {
        vm.filtro.gruposLeitura.forEach(function (dado) {
          viewModel.gruposLeitura.push(dado.descricao)
        })
      }

      viewModel.tipoSimplificadoOuDetalhado = vm.tipoSimplificadoOuDetalhado;

      if (!vm.tipoSimplificadoOuDetalhado) { // DETALHADO

        var pBuscarDadosDetalhado = QuitacaoAnualService.buscarDadosQuitacaoAnualDetalhado(viewModel);


        pBuscarDadosDetalhado
          .then(function (success) {
            var dados = success.data;

            var object = {
              dados: dados,
              filtros: viewModel
            }

            viewModel.gruposLeitura = vm.filtro.gruposLeitura;

            QuitacaoAnualService.setFiltro(viewModel);

            QuitacaoAnualService.listener(function () { return object; });

            QuitacaoAnualService.toggleFiltro();

          }, function (error) {
            console.log(error);
            MdDialogService.alertPadrao("Atenção!", event, error.data);
          })
          .finally(function () { _finalizarProgresso() });

      } else { // SIMPLIFICADO

        var pBuscarDadosSimplificado = QuitacaoAnualService.buscarDadosQuitacaoAnualSimplificado(viewModel);

        pBuscarDadosSimplificado
          .then(function (success) {
            var dados = success.data;

            var dadosGraficoGeral = [];

            if (dados.detalhesReferencias.length > 1) {
              dados.detalhesReferencias.forEach(function (dado) {
                dadosGraficoGeral.push({
                  label: dado.referencia,
                  value: dado.total
                });
              });
            }

            dados.detalhesReferencias.forEach(function (dado) {
              dado.dadosGraficoIndividual = [];
              dado.grupos.forEach(function (grupo) {
                dado.dadosGraficoIndividual.push({
                  key: grupo.grupo,
                  y: grupo.total
                });
              });
            });


            var object = {
              dados: dados,
              filtros: viewModel,
              dadosGraficoGeral: dadosGraficoGeral
            }

            viewModel.gruposLeitura = vm.filtro.gruposLeitura;

            QuitacaoAnualService.setFiltro(viewModel);

            QuitacaoAnualService.listener(function () { return object; });

            QuitacaoAnualService.toggleFiltro();

          }, function (error) {
            console.log(error);
            MdDialogService.alertPadrao("Atenção!", event, error.data);
          })
          .finally(function () { _finalizarProgresso() });

      }
    }

    function _carregarDadosFiltrosSalvos() {
      var filtro = QuitacaoAnualService.getFiltro();

      if (filtro) {
        vm.filtro = filtro;
        vm.referenciaOuPeriodo = filtro.tipoFiltro == 1 ? true : false;
        vm.tipoSimplificadoOuDetalhado = filtro.tipoSimplificadoOuDetalhado;
      }
    }

    function _carregarDadosGrupos() {
      vm.emProgressoBuscaGrupos = true;
      vm.grupos = ListarGrupos.data;
      vm.emProgressoBuscaGrupos = false;
    }

    function marcarFiltroReferenciaOuPeriodo() {
      //True = Referencia --- False = Periodo
      vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
    }

    function marcarFiltroSimplificadoOuDetalhado() {
      //True = Simplificado --- False = Detalhado
      vm.tipoSimplificadoOuDetalhado = vm.tipoSimplificadoOuDetalhado ? false : true;
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quantitativoleituras', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.quantitativoleituras;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_quantitativoleituras', {
        url: '/gerenciamento/dashboards/quantitativoleituras',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'QuantitativoLeiturasController as vm'
          },
          'dashboards-quantitativoleituras-form@app.gerenciamento.dashboards_quantitativoleituras': {
            templateUrl: rotasHtml.form
          },
          'quantitativo-leituras-filtro@app.gerenciamento.dashboards_quantitativoleituras': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroQuantitativoLeiturasController as vm"
          }
        },
        resolve: {
          ListarLeituristas: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
          },
          ListarGrupos: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.clienteOcorrencia.retornarTodosGrupos);
          },
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quantitativoleituras')
    .controller('FiltroQuantitativoLeiturasController', FiltroQuantitativoLeiturasController)

  /** @ngInject */
  function FiltroQuantitativoLeiturasController(ListarLeituristas, ListarGrupos, QuantitativoLeiturasService, MdDialogService) {
    var vm = this;

    vm.referenciaOuPeriodo = true;

    vm.metodos = {
      marcarFiltroReferenciaOuPeriodo: marcarFiltroReferenciaOuPeriodo,
      configuraMdSelectGrupo: configuraMdSelectGrupo,
      filtrarDados: filtrarDados,
    }

    init();

    function init() {
      vm.leituristas = ListarLeituristas.data;
      vm.grupos = ListarGrupos.data;
    }

    function marcarFiltroReferenciaOuPeriodo() {
      //True = Referencia --- False = Periodo
      vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
    }

    function configuraMdSelectGrupo() {
      vm.filtrarGrupos = "";
      angular.element('#select-grupo').on('keydown', function (ev) {
        ev.stopPropagation();
      });
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();
      var viewModel = {};

      if (vm.referenciaOuPeriodo) {
        viewModel = {
          tipoFiltro: 1,
          mes: filtro.mes,
          ano: filtro.ano,
        }
      } else {
        viewModel = {
          tipoFiltro: 2,
          dataInicial: filtro.dataInicial,
          dataFinal: filtro.dataFinal,
        }
      }

      if (filtro.grupos != undefined) {
        if (filtro.grupos.length > 0) {
          viewModel.grupos = filtro.grupos.map(function (grupo) {
            return grupo.codigoGrupo;
          });
        }
      }

      if (filtro.leituristas != undefined) {
        if (filtro.leituristas.length > 0) {
          viewModel.leituristas = filtro.leituristas.map(function (leiturista) {
            return leiturista.codigo;
          });
        }
      }

      var pBuscarDados = QuantitativoLeiturasService.buscarDadosQuantitativoLeituras(viewModel);

      QuantitativoLeiturasService.setFiltro(viewModel);

      pBuscarDados
        .then(function (success) {
          var dados = success.data;

          var dadosGraficoGeral = [];

          if (dados.leituristas.length > 1) {
            dados.leituristas.forEach(function (dado) {
              dadosGraficoGeral.push({
                label: dado.nome,
                value: dado.total
              });
            });
          }

          dados.leituristas.forEach(function (dado) {
            dado.dadosGraficoIndividual = [];
            dado.gruposQuantitativo.forEach(function (grupo) {
              dado.dadosGraficoIndividual.push({
                key: grupo.grupo,
                y: grupo.quantidadeLeituras
              });
            });
          });

          var object = {
            dados: dados,
            filtros: viewModel,
            dadosGraficoGeral: dadosGraficoGeral
          }

          QuantitativoLeiturasService.listener(function () { return object; });

          QuantitativoLeiturasService.toggleFiltro();

        }, function (error) {
          console.log(error);
          MdDialogService.alertPadrao("Atenção!", event, error.data);
        })
        .finally(function () { _finalizarProgresso() });
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }
}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.ocorrenciasleiturista', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.ocorrenciasleiturista;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_ocorrenciasleiturista', {
        url: '/gerenciamento/dashboards/ocorrenciasleiturista',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'OcorrenciasLeituristaController as vm'
          },
          'dashboards-ocorrenciasleiturista-form@app.gerenciamento.dashboards_ocorrenciasleiturista': {
            templateUrl: rotasHtml.form
          },
          'ocorrencias-leiturista-filtro@app.gerenciamento.dashboards_ocorrenciasleiturista': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroOcorrenciasLeituristaController as vm"
          }
        },
        resolve: {
          ListarLeituristas: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
          },
          ListarOcorrencias: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.ocorrencia.listarTodos);
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.ocorrenciasleiturista')
    .controller('FiltroOcorrenciasLeituristaController', FiltroOcorrenciasLeituristaController)

  /** @ngInject */
  function FiltroOcorrenciasLeituristaController(ListarLeituristas, ListarOcorrencias, OcorrenciasLeituristaService, MdDialogService) {
    var vm = this;

    vm.referenciaOuPeriodo = true;

    vm.metodos = {
      marcarFiltroReferenciaOuPeriodo: marcarFiltroReferenciaOuPeriodo,
      filtrarDados: filtrarDados,
    }

    init();

    function init() {
      vm.leituristas = ListarLeituristas.data;
      vm.ocorrencias = ListarOcorrencias.data;
    }

    function marcarFiltroReferenciaOuPeriodo() {
      //True = Referencia --- False = Periodo
      vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();

      var viewModel = {};

      if (vm.referenciaOuPeriodo) {
        viewModel = {
          tipoFiltro: 1,
          mes: filtro.mes,
          ano: filtro.ano,
        }
      } else {
        viewModel = {
          tipoFiltro: 2,
          dataInicial: filtro.dataInicial,
          dataFinal: filtro.dataFinal,
        }
      }

      if (filtro.ocorrencias != undefined) {
        if (filtro.ocorrencias.length > 0) {
          viewModel.ocorrencias = filtro.ocorrencias.map(function (ocorrencia) {
            return ocorrencia.codigo;
          });
        }
      }

      if (filtro.leituristas != undefined) {
        if (filtro.leituristas.length > 0) {
          viewModel.leituristas = filtro.leituristas.map(function (leiturista) {
            return leiturista.codigo;
          });
        }
      }

      var pBuscarDados = OcorrenciasLeituristaService.buscarDadosOcorrenciasLeiturista(viewModel);

      OcorrenciasLeituristaService.setFiltro(viewModel);

      pBuscarDados
        .then(function (success) {
          var dados = success.data;

          var dadosGraficoGeral = [];

          if (dados.ocorrencias.length > 1) {
            dados.ocorrencias.forEach(function (dado) {
              dadosGraficoGeral.push({
                label: dado.codigoOcorrencia + " - " + dado.descricaoOcorrencia,
                value: dado.total
              });
            });
          }

          dados.leituristas.forEach(function (dado) {
            dado.dadosGraficoIndividual = [];
            dado.ocorrencias.forEach(function (ocorrencia) {
              dado.dadosGraficoIndividual.push({
                key: ocorrencia.codigoOcorrencia + " - " + ocorrencia.descricaoOcorrencia,
                y: ocorrencia.total
              });
            });
          });

          var object = {
            dados: dados,
            filtros: viewModel,
            dadosGraficoGeral: dadosGraficoGeral
          }

          OcorrenciasLeituristaService.listener(function () { return object; });

          OcorrenciasLeituristaService.toggleFiltro();

        }, function (error) {
          console.log(error);
          MdDialogService.alertPadrao("Atenção!", event, error.data);
        })
        .finally(function () { _finalizarProgresso() });
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }
}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.clientesocorrencia', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.gerenciamento.dashboards.clientesocorrencia;

        //State
        $stateProvider
            .state('app.gerenciamento_dashboards_clientesocorrencia', {
                url: '/gerenciamento/dashboards/clienteocorrencia',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ClienteOcorrenciaController as vm'
                    },
                    'dashboards-clientesocorrencia-form@app.gerenciamento.dashboards_clientesocorrencia': {
                        templateUrl: rotasHtml.form
                    },
                    'cliente-ocorrencia-filtro@app.gerenciamento.dashboards_clienteocorrencia': {
                        templateUrl: rotasHtml.sidenavs.filtro,
                        controller: "FiltroClienteOcorrenciaController as vm"
                    },
                    'cliente-ocorrencia-filtro-casan@app.gerenciamento.dashboards_clienteocorrencia': {
                        templateUrl: rotasHtml.sidenavs.filtroCasan,
                        controller: "FiltroClienteOcorrenciaController as vm"
                    }
                },
                resolve: {
                    ListarGrupos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.clienteOcorrencia.retornarTodosGrupos);
                    },
                    ListarOcorrencias: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.ocorrencia.listarTodos);
                    }
                }
            });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.clientesocorrencia')
    .controller('DialogFotosClienteOcorrenciaController', DialogFotosClienteOcorrenciaController)

  /** @ngInject */
  function DialogFotosClienteOcorrenciaController(
    $mdDialog,
    Cliente,
    urlApi
  ) {
    var vm = this;

    vm.urlApi = urlApi.url_base_api;

    vm.metodos = {
      fecharDialog: fecharDialog
    }
    init();


    function init() {
      vm.cliente = Cliente;
      console.log(vm.cliente);
    }

    function fecharDialog() {
      $mdDialog.hide();
    }

  }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.ocorrenciasleiturista')
    .controller('DialogDetalhamentoOcorrenciasLeituristaController', DialogDetalhamentoOcorrenciasLeituristaController)

  /** @ngInject */
  function DialogDetalhamentoOcorrenciasLeituristaController(Leiturista, Dados, $mdDialog) {
    var vm = this;

    vm.metodos = {
      fecharDialog: fecharDialog
    }

    init();

    function init() {
      vm.leiturista = Leiturista;
      vm.dados = Dados;
    }

    function fecharDialog() {
      $mdDialog.hide();
    }
  }
}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.controlecargafluxo', [])
        .config(config);

    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.gerenciamento.dashboards.controlecargafluxo;

        $stateProvider
            .state('app.gerenciamento_dashboards_controlecargafluxo', {
                url: '/gerenciamento/dashboards/controlecargafluxo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ControleFluxoController as vm'
                    },
                    'dashboards-controlecargafluxo-form@app.gerenciamento.dashboards_controlecargafluxo': {
                        templateUrl: rotasHtml.form
                    },
                    'dashboards-controlecargafluxo-filtro@app.gerenciamento.dashboards_controlecargafluxo': {
                        templateUrl: rotasHtml.sidenav.filtro,
                        controller: "FiltroControleFluxoController as vm"
                    }
                },
                resolve: {
                    ListarLeituristasAtivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                    },
                    Parametros: function (SessionStorageService, KeysSessionStorage) {
                        return SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.controlecargafluxo')
        .controller('FiltroControleFluxoController', FiltroControleFluxoController)

    function FiltroControleFluxoController(
        ListarLeituristasAtivos,
        ControleFluxoService,
        $filter,
        MdDialogService
    ) {
        var vm = this;
        vm.leituristas = ListarLeituristasAtivos.data;
        vm.leituristas.sort(function (a, b) {
            return a.codigo - b.codigo;
        });
        vm.leituristas.map(function (leiturista) { leiturista.apelidoExibicao = leiturista.codigo + ' - ' + leiturista.nome; });

        vm.metodos = {
            filtrar: filtrar
        }

        function filtrar(filtroSelecionado) {
            vm.emProgresso = true;
            var dadosFiltroSelecionado = {};
            dadosFiltroSelecionado.dataInicial = $filter('date')(filtroSelecionado.dataInicial, 'yyyy-MM-ddTHH:mm:ss.sssZ');
            dadosFiltroSelecionado.dataFinal = $filter('date')(filtroSelecionado.dataFinal, 'yyyy-MM-ddTHH:mm:ss.sssZ');

            if (filtroSelecionado.leituristas != undefined) {
                if (filtroSelecionado.leituristas.length > 0) {
                    dadosFiltroSelecionado.leituristas = filtroSelecionado.leituristas.map(function (leiturista) {
                        return leiturista.codigo;
                    });
                }
            } else {
                dadosFiltroSelecionado.leituristas = [];
            }

            ControleFluxoService.setFiltro(dadosFiltroSelecionado);
            ControleFluxoService.buscarDadosLeitura(dadosFiltroSelecionado).then(
                function (success) {
                    ControleFluxoService.listener(function () { return success.data; });
                    ControleFluxoService.abrirFecharFiltro();
                }, function (error) {
                    var controleFluxo = undefined;
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                    ControleFluxoService.listener(function () { return controleFluxo; });
                }
            ).finally(function () {
                vm.emProgresso = false
            });
        }
    }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.distribuicaogrupos', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.resumodistribuicaogrupos;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_distribuicaogrupos', {
        url: '/gerenciamento/dashboards/distribuicaogrupos',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'ResumoDistribuicaoGruposController as vm'
          },
          'dashboards-resumo-distribuicao-grupos-form@app.gerenciamento.dashboards_distribuicaogrupos': {
            templateUrl: rotasHtml.resumoDistribuicaoGrupos.form
          },
          'distribuicaogrupos-filtro@app.gerenciamento_dashboards_distribuicaogrupos': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroResumoDistribuicaoGruposLeituras as vm"
          }
        },
        resolve: {
          ListarGrupos: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.clienteOcorrencia.retornarTodosGrupos);
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.distribuicaogrupos')
    .controller('FiltroResumoDistribuicaoGruposLeituras', FiltroResumoDistribuicaoGruposLeituras)

  /** @ngInject */
  function FiltroResumoDistribuicaoGruposLeituras(ResumoDistribuicaoGruposLeiturasService, RequisicaoGenericaService, Api, MdDialogService) {
    var vm = this;


    _carregarDadosFiltrosSalvos();

    vm.metodos = {
      configuraMdSelectGrupo: configuraMdSelectGrupo,
      filtrarDados: filtrarDados,
      filtrarGrupos: filtrarGrupos,
      pesquisarGrupos: _pesquisarGrupos
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();

      var viewModel = {};

      viewModel.mes = vm.filtro.mes;
      viewModel.ano = vm.filtro.ano;
      viewModel.grupo = vm.filtro.grupo;


      var pBuscarDadosDetalhado = ResumoDistribuicaoGruposLeiturasService.buscarDadosResumoDistribuicao(viewModel);


      pBuscarDadosDetalhado
        .then(function (success) {
          var dados = success.data;

          var object = {
            dados: dados,
            filtros: viewModel
          }

          ResumoDistribuicaoGruposLeiturasService.setFiltro(viewModel);

          ResumoDistribuicaoGruposLeiturasService.listener(function () { return object; });

          ResumoDistribuicaoGruposLeiturasService.toggleFiltro();

        }, function (error) {
          console.log(error);
          MdDialogService.alertPadrao("Atenção!", event, error.data);
        })
        .finally(function () { _finalizarProgresso() });


    }

    function filtrarGrupos(filtro) {

      RequisicaoGenericaService.salvar(rotasApi.realizarFiltroGrupos, filtro).then(function (success) {
        var dados = {
          grupos: success.data,
          filtro: filtro
        }
        if (!dados.grupos.length) {
          MdDialogService.alertPadrao("Atenção", event, "Nenhum grupo encontrado com base no filtro realizado.");
        }
      }, function (error) {
        MdDialogService.alertPadrao("Atenção", null, error.data);
      });
    }

    function _pesquisarGrupos(mes, ano) {
      mes = mes.padStart(2, '0')
      vm.filtro.grupo = undefined;
      vm.municipios = [];
      vm.emProgressoBuscaGrupo = true;
      RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
        '?mes=' + mes + '&ano=' + ano).then(
          function (success) {
            vm.emProgressoBuscaGrupo = false;
            vm.grupos = success.data.map(function (item) {
              return item
            });
          },
          function (error) {
            vm.emProgressoBuscaGrupo = false;
            console.log(error.data);
          }
        )
    }

    function _carregarDadosFiltrosSalvos() {
      var filtro = ResumoDistribuicaoGruposLeiturasService.getFiltro();

      if (filtro) {
        vm.filtro.mes = filtro.mes;
        vm.filtro.ano = filtro.ano;
        vm.filtro.grupo = filtro.grupo;
      }
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }

    function configuraMdSelectGrupo() {
      vm.filtrarGrupos = "";
      angular.element('#select-grupo').on('keydown', function (ev) {
        ev.stopPropagation();
      });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.comunicadosdebitoimpressos', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.dashboards.comunicadosdebitoimpressos;

    //State
    $stateProvider
      .state('app.gerenciamento_dashboards_comunicadosdebitoimpressos', {
        url: '/gerenciamento/dashboards/comunicadosdebitoimpressos',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'ComunicadosDebitoImpressosController as vm'
          },
          'dashboards-comunicadosdebitoimpressos-form@app.gerenciamento.dashboards_comunicadosdebitoimpressos': {
            templateUrl: rotasHtml.form
          },
          'comunicados-debito-impressos-filtro@app.gerenciamento.dashboards_comunicadosdebitoimpressos': {
            templateUrl: rotasHtml.sidenavs.filtro,
            controller: "FiltroComunicadosDebitoImpressosController as vm"
          }
        },
        resolve: {
          ListarLeituristas: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
          },
          ListarGrupos: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.clienteOcorrencia.retornarTodosGrupos);
          },
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.comunicadosdebitoimpressos')
    .controller('FiltroComunicadosDebitoImpressosController', FiltroComunicadosDebitoImpressosController)

  /** @ngInject */
  function FiltroComunicadosDebitoImpressosController(ListarLeituristas, ListarGrupos, ComunicadosDebitoImpressosService, MdDialogService) {
    var vm = this;

    vm.referenciaOuPeriodo = true;

    vm.metodos = {
      marcarFiltroReferenciaOuPeriodo: marcarFiltroReferenciaOuPeriodo,
      filtrarDados: filtrarDados,
      configuraMdSelectGrupo: configuraMdSelectGrupo,
    }

    init();

    function init() {
      vm.leituristas = ListarLeituristas.data;
      vm.grupos = ListarGrupos.data;

      console.log(vm.grupos)
    }

    function filtrarDados(filtro) {
      _iniciarProgresso();

      var viewModel = {};

      if (vm.referenciaOuPeriodo) {
        if (filtro.mes.length < 2 && filtro.mes.length > 0) {
          viewModel.MesReferencia = "0" + filtro.mes;
        } else {
          viewModel.MesReferencia = filtro.mes
        }
        viewModel.AnoReferencia = filtro.ano;
      } else {
        viewModel.dataInicial = filtro.dataInicio;
        viewModel.dataFinal = filtro.dataFim;
      }

      if (filtro.leituristas != undefined) {
        if (filtro.leituristas.length > 0) {
          viewModel.leituristas = filtro.leituristas.map(function (leiturista) {
            return leiturista.codigo;
          });
        }
      }

      viewModel.grupoLeitura = filtro.grupo;

      ComunicadosDebitoImpressosService.setFiltro(viewModel);

      var pBuscarDados = ComunicadosDebitoImpressosService.buscarDadosComunicadosImpressos(viewModel);

      pBuscarDados
        .then(function (success) {
          var total = 0;

          var dados = success.data;

          dados.forEach(function (dado) {
            total += dado.dadosComunicados.length
          });

          var dadosGrafico = [];
          dados.forEach(function (dado) {
            dadosGrafico.push({
              key: dado.leiturista,
              y: dado.dadosComunicados.length
            })
          });

          var object = {
            dados: dados,
            filtros: viewModel,
            totalizador: total,
            dadosGrafico: dadosGrafico
          }

          ComunicadosDebitoImpressosService.listener(function () { return object; });

          ComunicadosDebitoImpressosService.toggleFiltro();
        }, function (error) {
          var object = {
            dados: [],
            filtros: "",
          }
          ComunicadosDebitoImpressosService.listener(function () { return object; });
          console.log(error);
          MdDialogService.alertPadrao("Atenção!", event, error.data);
        })
        .finally(function () { _finalizarProgresso() });
    }

    function marcarFiltroReferenciaOuPeriodo() {
      //True = Referencia --- False = Periodo
      vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
    }

    function configuraMdSelectGrupo() {
      vm.filtrarGrupos = "";
      angular.element('#select-grupo').on('keydown', function (ev) {
        ev.stopPropagation();
      });
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.clientesocorrencia')
        .controller('FiltroClienteOcorrenciaController', FiltroClienteOcorrenciaController)

    /** @ngInject */
    function FiltroClienteOcorrenciaController(
        ListarGrupos,
        ListarOcorrencias,
        ClienteOcorrenciaService,
        MdDialogService,
        SessionStorageService,
        KeysSessionStorage,
        RequisicaoGenericaService,
        Api,
        $mdSidenav
    ) {
        var vm = this;

        vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        vm.metodos = {
            filtrarDados: filtrarDados,
            pesquisarGrupos: pesquisarGrupos,
            pesquisarMunicipiosPorRegional: pesquisarMunicipiosPorRegional,
            configuraMdSelectRegional: configuraMdSelectRegional,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio
        }

        init();

        function init() {
            vm.filtros = ["Referência", "Período"];
            vm.opcaoFiltro = vm.filtros[0];
            var dataAtual = new Date();

            vm.ocorrencias = ListarOcorrencias.data;

            if (vm.parametro.utilizaCadastroRegional) {
                vm.grupos = [];
                vm.municipios = [];

                vm.filtro = {
                    mes: dataAtual.getMonth() + 1,
                    ano: dataAtual.getFullYear(),
                };

                _pesquisarRegionais();
            } else {
                vm.grupos = ListarGrupos.data;
            }
        }

        function filtrarDados(filtro) {
            _iniciarProgresso();

            var viewModel = {};

            if (vm.parametro.utilizaCadastroRegional) {
                viewModel.MesReferencia = filtro.mes.toString().padStart(2, '0');
                viewModel.AnoReferencia = filtro.ano;
                viewModel.regional = filtro.regional;
                viewModel.municipio = filtro.municipio;
                viewModel.grupo = filtro.grupo;

                vm.regionais.map(function (regional) {
                    if (regional.codigo == filtro.regional) viewModel.dadosRegional = regional;
                });

                vm.municipios.map(function (municipio) {
                    if (municipio.codigo == filtro.municipio) viewModel.dadosMunicipio = municipio;
                });
            }
            else {
                if (vm.opcaoFiltro == "Referência") {
                    viewModel.MesReferencia = filtro.mes.toString().padStart(2, '0');
                    viewModel.AnoReferencia = filtro.ano;
                } else {
                    viewModel.dataInicial = filtro.dataInicio;
                    viewModel.dataFinal = filtro.dataFim;
                }

                if (filtro.grupos != undefined) {
                    if (filtro.grupos.length > 0) {
                        viewModel.gruposLeitura = filtro.grupos.map(function (grupo) {
                            return grupo.codigoGrupo;
                        });
                    }
                }
            }

            if (filtro.ocorrencias != undefined) {
                if (filtro.ocorrencias.length > 0) {
                    viewModel.ocorrencias = filtro.ocorrencias.map(function (ocorrencia) {
                        return ocorrencia.codigo;
                    });
                }
            }

            ClienteOcorrenciaService.setFiltro(viewModel);

            var pBuscarDados = ClienteOcorrenciaService.buscarDadosClienteOcorrencia(viewModel);

            pBuscarDados
                .then(function (success) {
                    var total = 0;

                    var dados = success.data;

                    dados.forEach(function (dado) {
                        total += dado.dadosClientes.length
                    });

                    var object = {
                        dados: dados,
                        filtros: viewModel,
                        totalizador: total
                    }

                    ClienteOcorrenciaService.listener(function () { return object; });

                    $mdSidenav('filtro-clienteocorrencia').toggle();
                }, function (error) {
                    var object = undefined
                    ClienteOcorrenciaService.listener(function () { return object; });
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgresso() });
        }

        // function marcarFiltroReferenciaOuPeriodo() {
        //     //True = Referencia --- False = Periodo
        //     vm.referenciaOuPeriodo = vm.referenciaOuPeriodo ? false : true;
        // }

        function pesquisarGrupos(regional, mes, ano) {
            mes = mes.toString().padStart(2, '0');
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;

            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function _pesquisarRegionais() {
            vm.filtro.regional = undefined;
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }

}());
(function (){
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml){
        var rotasHtml = RotasHtml.gerenciamento.leitura.rastreamento;

        $stateProvider.state('app.gerenciamento_leitura_rastreamento', {
            url  : '/gerenciamento/leitura/rastreamento',
            module: 'privado',
            params:{
                nomeArquivo: null,
                leiturista: null,
                data: null,
                tarefa:null,
            },
            onEnter: function (RastreamentoLeituristasFactory) {
                RastreamentoLeituristasFactory.setValoresInciaisFiltro();
            },
            views: {
                'content@app': {
                    templateUrl: rotasHtml.templateUrl,
                    controller : 'RastreamentoController as vm'
                },'gerenciamento-leiura-rastreamento--mapa@app.gerenciamento_leitura_rastreamento':{
                    templateUrl: rotasHtml.mapa.templateUrl,
                    controller: "RastreamentoLeituristasMapaController as vm"
                },'gerenciamento-leiura-rastreamento--filtro@app.gerenciamento_leitura_rastreamento':{
                    templateUrl: rotasHtml.filtro.templateUrl,
                    controller: "RastreamentoLeituristaFiltroController as vm"
                },'gerenciamento-leiura-rastreamento--legenda@app.gerenciamento_leitura_rastreamento':{
                    templateUrl: rotasHtml.legenda.templateUrl,
                    controller: "RastreamentoLeituristaLegendaController as vm"
                }
            }, resolve: {
                ListarLeituristas: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosCodigoNome);
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoLeituristasListagemController', RastreamentoLeituristasListagemController);

    /** @ngInject */
    function RastreamentoLeituristasListagemController(ListarLeituristas, 
                                                       RastreamentoLeituristasFactory,
                                                       $timeout, $q) {
        var vm = this;

        // Data
        init();

        function init() {
            vm.simulateQuery = false;
            vm.isDisabled    = false;

            vm.form = RastreamentoLeituristasFactory.form;
            vm.filtro = RastreamentoLeituristasFactory.filtros;
            vm.leituristas =ListarLeituristas.data;
            vm.querySearch = querySearch;
            vm.preLoader = RastreamentoLeituristasFactory.preLoader;
            vm.dataAtual = new Date();
        }


        // Methods
        vm.metodos = {
            querySearch: querySearch,
            createFilterFor: createFilterFor
        }

        //////////

        function querySearch(query) {
            var results = query ? vm.leituristas.filter(createFilterFor(query)) : vm.leituristas,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(leiturista) {
                return (leiturista.apelido.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }
    }

})();
(function (){
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoLeituristasPeriodoController', RastreamentoLeituristasPeriodoController);

    /** @ngInject */
    function RastreamentoLeituristasPeriodoController(RastreamentoLeituristasFactory)
    {
        var vm = this;
        
        // Data
        init();

        function init() {
            vm.form = RastreamentoLeituristasFactory.form;
            vm.filtro = RastreamentoLeituristasFactory.filtros;
            vm.dataAtual = new Date();
        }
        
        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoLeituristaLegendaController', RastreamentoLeituristaLegendaController);

    /** @ngInject */
    function RastreamentoLeituristaLegendaController(RastreamentoLeituristaService) {
        var vm = this;

        // Data

        // Methods
        vm.metodos = {
            fecharLegendas: fecharLegendas
        };

        ////////
        function fecharLegendas() {
            RastreamentoLeituristaService.toggleLegenda();
        }
    }
})();
(function (){
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml){
        var rotasHtml = RotasHtml.gerenciamento.leitura.monitoramento;

        $stateProvider.state('app.gerenciamento_leitura_monitoramento', {
            url  : '/gerenciamento/leitura/monitoramento',
            module: 'privado',
            params:{
                nomeArquivo: null,
                leiturista: null,
                data: null
            },
            views: {
                'content@app': {
                    templateUrl: rotasHtml.templateUrl,
                    controller : 'MonitoramentoController as vm'
                },'gerenciamento-leitura-monitoramento--mapa@app.gerenciamento_leitura_monitoramento':{
                    templateUrl: rotasHtml.mapa.templateUrl,
                    controller: "MonitoramentoMapaController as vm"
                },'gerenciamento-leitura-monitoramento--filtro@app.gerenciamento_leitura_monitoramento':{
                    templateUrl: rotasHtml.filtro.templateUrl,
                    controller: "MonitoramentoFiltroController as vm"
                },'gerenciamento-leitura-monitoramento--dashboard@app.gerenciamento_leitura_monitoramento':{
                    templateUrl: rotasHtml.dashboard.templateUrl,
                    controller: "MonitoramentoDashboardController as vm"
                },'gerenciamento-leitura-monitoramento--legenda@app.gerenciamento_leitura_monitoramento':{
                    templateUrl: rotasHtml.legenda.templateUrl,
                    controller: "MonitoramentoLegendaController as vm"
                }
            }, resolve: {
                ListarLeituristas: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosCodigoNome);
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .controller('MonitoramentoFiltroController', MonitoramentoFiltroController);

    /** @ngInject */
    function MonitoramentoFiltroController(MonitoramentoService,
        MonitoramentoMapaService,
        ListarLeituristas,
        $interval,
        $scope,
        SessionStorageService,
        KeysSessionStorage) {
        var vm = this;

        // Data
        var funcaoTimer = undefined;
        init();

        // Methods
        function init() {
            vm.intervalos = [{
                valor: 60,
                descricao: '60'
            },
            {
                valor: 90,
                descricao: '90'
            },
            {
                valor: 120,
                descricao: '120'
            }]
            vm.leituristas = angular.copy(ListarLeituristas.data);
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if(vm.parametros.utilizaCadastroRegional){
                vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
                var resultado = vm.leituristas.filter(function(item){
                    if(_pertentceAgrupamento(item.agrupamento)){
                        return item;
                    }
                })
                vm.leituristas = resultado;
            }
            
            vm.filtro = {
                leituristas: [],
                intervalo: vm.intervalos[2],
                somenteRotaComLeituras: false
            }

            _inicializarIntervalo();
            _monitorar();

            MonitoramentoService.listenerEstadoLeiturista = function (callback) {
                var dados = callback();
                for (var i = 0; i < dados.length; i++) {
                    _atualizarEstadoLeiturista(dados[i]);
                }
            }

            MonitoramentoService.listenerParametrosGerenciamentoCarga = function (callback) {
                var parametrosGerenciamentoCarga = callback();
                if(parametrosGerenciamentoCarga != null){
                    vm.tempoRestante = 0;
                    vm.filtro.data = parametrosGerenciamentoCarga.data;
                    atualizarMapa(parametrosGerenciamentoCarga.leiturista.codigo);
                }
            }

            vm.avatar = 'assets/images/avatars/user.jpg';
            vm.preLoader = false;
        }

        vm.metodos = {
            atualizarMapa: atualizarMapa,
            verificarSeLeituristaJaSelecionado: verificarSeLeituristaJaSelecionado,
            abrirFiltros: abrirFiltros,
            atualizarDashboard: atualizarDashboard
        };

        $scope.$on('$destroy', function () {
            $interval.cancel(funcaoTimer);
            clearInterval(funcaoTimer);
            funcaoTimer = undefined;
            vm.filtro.leituristas = [];
        });

        //////////

        function _atualizarEstadoLeiturista(dados) {
            return vm.leituristas.some(function (item) {
                if (item.codigo == dados.leituristaCodigo) {
                    item.estado = dados.estado;
                    vm.preLoader = false;
                    return true;
                }
            });
        }

        function _monitorar() {
            if (angular.isUndefined(funcaoTimer)) {
                funcaoTimer = $interval(function () {
                    if (vm.tempoRestante == 0 && vm.filtro.leituristas.length > 0) {
                        MonitoramentoService.filtrar(_criarObjetoFiltro(vm.filtro));
                        _inicializarIntervalo();
                    }
                    else {
                        vm.tempoRestante = vm.tempoRestante - 1;
                    }
                }, 1000);
            }
        }

        function _inicializarIntervalo() {
            vm.tempoRestante = vm.filtro.intervalo.valor;
        }

        function _adicionarLeituristaNoFiltro(leituristaCodigo) {
            vm.filtro.leituristas.push(leituristaCodigo);
        }

        function _removerLeituristaNoFiltro(leituristaCodigo) {
            var posicao = vm.filtro.leituristas.indexOf(leituristaCodigo);
            vm.filtro.leituristas.splice(posicao, 1);
            _limparEstadoLeiturista(leituristaCodigo);
        }

        function _limparEstadoLeiturista(leituristaCodigo) {
            vm.leituristas.map(function (item) {
                if (item.codigo == leituristaCodigo) {
                    item.estado = 0;
                }
            })
        }

        function _criarObjetoFiltro(dados) {
            var objeto = {
                somenteRotaComLeituras: dados.somenteRotaComLeituras,
                leituristas: dados.leituristas,
                data: dados.data
            };

            return JSON.stringify(objeto);
        }

        function _pertentceAgrupamento(agrupamento){
            var resultado = vm.regionais.filter(function(item){
                if(item.codigo === agrupamento){
                    return item;
                }
            })

            return resultado.length > 0;
        }

        function atualizarMapa(leituristaCodigo) {
            if (!vm.preLoader) {
                if (vm.filtro.leituristas.length > 0) {
                    if (!verificarSeLeituristaJaSelecionado(leituristaCodigo)) {
                        _adicionarLeituristaNoFiltro(leituristaCodigo);
                    }
                    else {
                        _removerLeituristaNoFiltro(leituristaCodigo);
                    }
                }
                else {
                    _adicionarLeituristaNoFiltro(leituristaCodigo);
                }

                if (vm.filtro.leituristas && vm.filtro.leituristas.length > 0) {
                    vm.preLoader = true;
                }

                MonitoramentoService.filtrar(_criarObjetoFiltro(vm.filtro));
                if (vm.filtro.leituristas == undefined || vm.filtro.leituristas.length == 0) {
                    MonitoramentoMapaService.limparMapa();
                    MonitoramentoService.setHabilitarMapa(false);
                }
                else {
                    _inicializarIntervalo();
                }
            }
        }

        function verificarSeLeituristaJaSelecionado(leituristaCodigo) {
            if (vm.filtro.leituristas.length == 0) {
                return false;
            }
            else {
                return vm.filtro.leituristas.indexOf(leituristaCodigo) != -1;
            }
        }

        function abrirFiltros() {
            MonitoramentoService.toggleFiltro();
        }

        function atualizarDashboard(leituristaCodigo) {
            MonitoramentoMapaService.atualizarDashboard(leituristaCodigo);
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .controller('MonitoramentoLegendaController', MonitoramentoLegendaController)

    /** @ngInject */
    function MonitoramentoLegendaController(MonitoramentoService){
        var vm = this;

        vm.metodos = {
            fecharLegenda: fecharLegenda
        }
        
        vm.legendas = [
            {descricao: 'Ponto inicial do leiturista', cor: '#0090CA'},
            {descricao: 'Ponto atual do leiturista', cor: 'grey'},
            {descricao: 'Primeira leitura', cor: 'darkblue'},
            {descricao: 'Última leitura', cor: 'yellow'}
        ];
        
        function fecharLegenda(){
            MonitoramentoService.toggleLegenda();
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .controller('MonitoramentoDashboardController', MonitoramentoDashboardController);

    /** @ngInject */
    function MonitoramentoDashboardController(MonitoramentoMapaService, $mdSidenav) {
        var vm = this;

        // Data
        vm.dados = {};

        MonitoramentoMapaService.listenerAtualizacao = function (callback) {
            vm.dados = callback();
            vm.dashboardData = {
                widget6: {
                    footerLeft: {
                        title: 'Clientes',
                        count: vm.dados.informacoes.carga
                    },
                    footerRight: {
                        title: 'Cancelamentos',
                        count: vm.dados.informacoes.cancelamentos
                    },
                    mainChart: [
                        {
                            label: 'Leitura normal',
                            values: vm.dados.informacoes.leituras,
                            cor: '#339933'
                        },
                        {
                            label: 'Leitura com ocorrência',
                            values: vm.dados.informacoes.leiturasComOcorrencia,
                            cor: '#ff9900'
                        },
                        {
                            label: 'Somente ocorrência',
                            values: vm.dados.informacoes.somenteOcorrencia,
                            cor: '#ff3300'
                        },
                        {
                            label: 'Pendente(s)',
                            values: vm.dados.informacoes.pendentes,
                            cor: '#999999'
                        }
                    ]
                }
            }

            vm.habilitarCampoPrimeiraLeitura = vm.dados.informacoes.detalheLeituras.length > 0;
            vm.habilitarCampoUltimaLeitura = vm.dados.informacoes.detalheLeituras.length > 1;

            var dataPrimeiraLeitura = false;
            var dataUltimaLeitura = false;

            if(vm.habilitarCampoPrimeiraLeitura){
                dataPrimeiraLeitura = vm.dados.informacoes.detalheLeituras[0].data;
            }

            if(vm.habilitarCampoUltimaLeitura){
                dataUltimaLeitura = vm.dados.informacoes.detalheLeituras[1].data;
            }

            vm.dashboard = {
                title: vm.dados.leituristaNome,
                primeiraLeitura: dataPrimeiraLeitura,
                ultimaLeitura: dataUltimaLeitura,
                retencoes: 'Contas retidas: ' + vm.dados.informacoes.retencoes,
                mainChart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            showLegend: false,
                            type: 'pieChart',
                            color: [],
                            height: 350,
                            width: 300,
                            margin: {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            donut: true,
                            clipEdge: true,
                            cornerRadius: 0,
                            labelType: 'percent',
                            padAngle: 0.02,
                            x: function (d) {
                                return d.label;
                            },
                            y: function (d) {
                                return d.value;
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            },
                            noData: "Sem informações à serem exibidas."
                        }
                    },
                    data: []
                },
                footerLeft: vm.dashboardData.widget6.footerLeft,
                footerRight: vm.dashboardData.widget6.footerRight,
                ranges: vm.dashboardData.widget6.ranges,
                currentRange: '',

                atualizar: function () {

                    angular.forEach(vm.dashboardData.widget6.mainChart, function (data) {
                        if (data.values > 0) {
                            vm.dashboard.mainChart.data.push({
                                label: data.label,
                                value: data.values
                            });
                            vm.dashboard.mainChart.options.chart.color.push(data.cor);
                        }
                    });
                },

                init: function () {
                    vm.dashboard.atualizar();
                }
            };

            vm.dashboard.init();
        }

        vm.metodos = {
            fecharDashboard: fecharDashboard
        }
        // Methods
        function fecharDashboard() {
            $mdSidenav("dashboard").toggle();
        }
        //////////
    }
})();
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica', [
            'app.gerenciamento.critica.execucao',
            'app.gerenciamento.critica.consulta',
            'app.gerenciamento.critica.acompanhamento'
        ]);

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica')
        .controller('LegendaCriticaSidenavController', LegendaCriticaSidenavController)

    /** @ngInject */
    function LegendaCriticaSidenavController($mdSidenav){
        var vm = this;
        
        init();

        vm.metodos = {
            fecharSidenav: fecharSidenav
        }

        function init(){
            vm.itens = [
                {cor: '#EF8B15', situacao: 'Leituras com consumo maior que a média entre 100% e 200%.', icone: 'icon-label' },
                {cor: '#FF0000', situacao: 'Leituras com consumo maior que a média em 200% ou mais.', icone: 'icon-label' },
            ]
        }

        function fecharSidenav(){  
            $mdSidenav('legenda-critica-sidenav').toggle();
        }

        

    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.execucao', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.gerenciamento.critica.execucao;
            var rotasHtmlVisualizacao = RotasHtml.gerenciamento.leitura.visualizacao;
            $stateProvider
                    .state('app.gerenciamento_critica', {
                        url: '/gerenciamento/critica/execucao',
                        module: 'privado',
                        views:{
                            'content@app': {
                                templateUrl: rotasHtml.templateUrl,
                                controller: 'CriticaLeiturasController as vm'
                            },
                            'criticaleituras-form@app.gerenciamento_critica': {
                                templateUrl: rotasHtml.form
                            },
                            'filtro-sidenav-critica-leituras@app.gerenciamento_critica': {
                                templateUrl: rotasHtml.sidenav.filtro,
                                controller: 'FiltroCriticaLeiturasController as vm'   
                            },
                            'leitura-visualizacao-form@app.gerenciamento_leitura_visualizacao': {
                                templateUrl: rotasHtmlVisualizacao.form                              
                            },
                            'execucao-critica-sidenav@app.gerenciamento_critica': {
                                templateUrl: rotasHtml.sidenav.execucao,
                                controller: 'ExecucaoCriticaSidenavController as vm'
                            },
                            'fotos-critica-sidenav@app.gerenciamento_critica': {
                                templateUrl: rotasHtml.sidenav.fotos,
                                controller: 'FotosCriticaSidenavController as vm'
                            },
                            'legenda-critica-sidenav@app.gerenciamento_critica': {
                                templateUrl: rotasHtml.sidenav.legenda,
                                controller: 'LegendaCriticaSidenavController as vm'
                            }
                        },
                        resolve: {
                            ListarLeituristas: function(Api, RequisicaoGenericaService){
                                return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                            },
                            ListarOcorrencias: function(Api, RequisicaoGenericaService){
                                return RequisicaoGenericaService.listarSemParams(Api.ocorrencia.listarTodos);
                            }
                        }
                    });
        }
}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.execucao')
        .controller('FotosCriticaSidenavController', FotosCriticaSidenavController)

    /** @ngInject */
    function FotosCriticaSidenavController(){
        var vm = this;
        
        init();

        vm.fotos = [
            {data: '08/02/2019', src: 'assets/images/backgrounds/april.jpg'}
        ]

        function init(){
        }

    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.execucao')
        .controller('FiltroCriticaLeiturasController', FiltroCriticaLeiturasController)

    /** @ngInject */
    function FiltroCriticaLeiturasController(ListarLeituristas, $rootScope, Api, RequisicaoGenericaService, CriticaLeiturasFactory, MdDialogService,
        SessionStorageService, KeysSessionStorage){
        var vm = this;
        
        vm.metodos = {
            filtrarLeiturasComRetencao: filtrarLeiturasComRetencao,            
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            pesquisarMunicipiosPorRegional : _pesquisarMunicipiosPorRegional,
            pesquisarGrupos: _pesquisarGrupos,
            configuraMdSelectMunicipio : configuraMdSelectMunicipio,
            configuraMdSelectRegional: configuraMdSelectRegional
        }
       
        init();

        function init(){
            vm.leituristas = ListarLeituristas.data;
            vm.filtro = CriticaLeiturasFactory.construirFiltro();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if(vm.parametros.utilizaCadastroRegional){
                _pesquisarRegionais();
            } else {
                _pesquisarGrupos("", vm.filtro.mes, vm.filtro.ano);
            }
        }

        function filtrarLeiturasComRetencao(filtro){
            CriticaLeiturasFactory.setFiltro(filtro);
            var viewModel = angular.copy(filtro);  
            
            if(!_validarFiltro(viewModel)){
                MdDialogService.alertPadrao("Para filtrar as críticas é necessário marcar uma opção de status");
                return;
            }

            vm.emProgresso = true;
            var promessa = RequisicaoGenericaService.salvar(Api.criticaLeituras.filtrarLeituras, viewModel);
            promessa.then(function(success){
                vm.emProgresso = false;
                CriticaLeiturasFactory.atualizarLeiturasComRetencao(success.data);
                CriticaLeiturasFactory.toggleSidenavFiltro();
            }, function(error){
                vm.emProgresso = false;
                MdDialogService.alertPadrao(error.data)
            });
        }

        function configuraMdSelectGrupo(){
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _pesquisarRegionais(){
           
            vm.filtro.regional = undefined;
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }

        
        function _pesquisarGrupos(regional, mes, ano){
            mes = mes.toString().padStart(2,'0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;            
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional+
                 '?regional=' + regional + '&mes=' + mes + '&ano=' + ano ).then(
                function(success){
                    vm.emProgressoBuscaGrupo = false;                    
                    vm.grupos = success.data;
                },
                function(error){
                    vm.emProgressoBuscaGrupo = false;
                    console.log(error.data);                    
                }
            )
        }


        function _pesquisarMunicipiosPorRegional(regional, mes, ano, grupo){
            mes = mes.toString().padStart(2,'0')
            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;            
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional+
                 '?regional=' + regional + '&mes=' + mes + '&ano=' + ano +"&grupo=" + grupo).then(
                function(success){
                    vm.emProgressoBuscaMunicipio = false;                    
                    vm.municipios = success.data;
                },
                function(error){
                    vm.emProgressoBuscaMunicipio = false;
                    console.log(error.data);                    
                }
            )
        }       
        
        function configuraMdSelectMunicipio(){
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _validarFiltro(filtro){
            return filtro.pendentes || filtro.criticados || filtro.retorno
        }

    }

}());
(function() {
  "use strict";

  angular
    .module("app.gerenciamento.critica.execucao")
    .controller(
      "ExecucaoCriticaSidenavController",
      ExecucaoCriticaSidenavController
    );

  /** @ngInject */
  function ExecucaoCriticaSidenavController() {
    var vm = this;

    init();

    vm.clienteSelecionado = {
      codigoCliente: "0000006604",
      nome: "VALDIR KLAUBERG",
      dataHoraColeta: "2020-03-06T15:46:18",
      quantidadeCriticas: 0,
      porcentagemConsumoFaturadoAcimaConsumoMedio: "0%",
      leitura: 150,
      ocorrencia: "21",
      consumo: 0,
      endereco: "R.  NATIVIDADE, 4253  - SUL DO RIO",
      localizacao: "02.513.291.001.0420.0001",
      hidrometro: "Y11C073638",
      media: 10,
      historico: [
        { ocorrencia: 28, leitura: 5600, consumo: 0 },
        { ocorrencia: 28, leitura: 5600, consumo: 0 },
        { ocorrencia: 28, leitura: 5600, consumo: 0 },
        { ocorrencia: 28, leitura: 5600, consumo: 0 },
        { ocorrencia: 28, leitura: 5600, consumo: 0 },
        { ocorrencia: 28, leitura: 5600, consumo: 0 }
      ]
    };

    function init() {}
  }
})();

(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta')
        .controller('DialogHistoricoCriticaController', DialogHistoricoCriticaController)

    /** @ngInject */
    function DialogHistoricoCriticaController(historicos, DatatableFactory, $mdDialog, DTDefaultOptions, CriticaLeituraService, MdDialogService, RotasHtml){
        var vm = this;
        

        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirDialogFotos: abrirDialogFotos
        }

        vm.criticas = historicos;
        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
            {
                targets: [2,3,4,5,6,7,8,9,10,11,12,13],
                orderable: false 
            },

        ]);        
        init();
        
        function init(){
            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
        }

        function fecharDialog(){
            $mdDialog.hide();
        }

        function abrirDialogFotos(critica){
            critica.emProgresso = true;
            var pFotos = CriticaLeituraService
                                .buscarFotosPorVisita(critica.codigoCliente, critica.gleiCodigo, critica.numeroCritica);
            pFotos.then(function(success){                    
                if(!success.data.length){
                    MdDialogService.alertPadrao("Atenção", null, 'Não foram encontradas fotos para essa visita.');
                    return;
                }                
                $mdDialog.show({
                    controller: 'DialogFotosHistoricoCriticaController as vm',
                    templateUrl: RotasHtml.gerenciamento.critica.consulta.dialogs.fotosVisita,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,                    
                    locals: {
                        Fotos: success.data
                    }                
                });
            }, function(error){
                MdDialogService.alertPadrao("Atenção", null, error.data);
            }).finally(function(){critica.emProgresso = false;});
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta')
        .controller('FiltroConsultaCriticaController', FiltroConsultaCriticaController)

    /** @ngInject */
    function FiltroConsultaCriticaController(ListarLeituristas, $rootScope, Api, RequisicaoGenericaService,
        ConsultaCriticaFactory, MdDialogService, SessionStorageService, KeysSessionStorage, $scope) {
        var vm = this;

        vm.metodos = {
            filtrarCriticas: filtrarCriticas,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            pesquisarMunicipiosPorRegional: _pesquisarMunicipiosPorRegional,
            pesquisarGrupos: _pesquisarGrupos,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            configuraMdSelectRegional: configuraMdSelectRegional
        }

        $rootScope.$on("AtualizarFiltroCriticasLeitura", function (ev, data) {
            var filtro = ConsultaCriticaFactory.getFiltro();

        });

        $scope.$on("$destroy", function () {
            ConsultaCriticaFactory.setFiltro({});
        });

        init();

        function init() {
            vm.leituristas = ListarLeituristas.data;
            vm.filtro = ConsultaCriticaFactory.getFiltro();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

            if (Object.keys(vm.filtro).length) {
                _pesquisarRegionais(false);
                _pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, false);
                _pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo, false);
            } else {
                vm.filtro = ConsultaCriticaFactory.construirFiltro();

                if (vm.parametros.utilizaCadastroRegional) {
                    _pesquisarRegionais(true);
                } else {
                    _pesquisarGrupos("", vm.filtro.mes, vm.filtro.ano, true);
                }
            }
        }

        function filtrarCriticas(filtro) {
            ConsultaCriticaFactory.setFiltro(filtro);
            var viewModel = angular.copy(filtro);
            if (viewModel.leituristas.length) {
                viewModel.leituristas = viewModel.leituristas.map(function (item) {
                    return item.codigo;
                });
            }
            vm.emProgresso = true;
            var promessa = RequisicaoGenericaService.salvar(Api.criticaLeituras.filtrarCriticas, viewModel);
            promessa.then(function (success) {
                vm.emProgresso = false;
                ConsultaCriticaFactory.atualizarConsultaCritica(success.data);
                ConsultaCriticaFactory.toggleSidenavFiltro();
            }, function (error) {
                vm.emProgresso = false;
                MdDialogService.alertPadrao(error.data)
            });
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _pesquisarRegionais(resetarFiltro) {
            if (resetarFiltro) vm.filtro.regional = undefined;

            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }


        function _pesquisarGrupos(regional, mes, ano, resetarFiltro) {
            mes = mes.toString().padStart(2, '0');

            if (resetarFiltro) vm.filtro.grupo = undefined;

            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }


        function _pesquisarMunicipiosPorRegional(regional, mes, ano, grupo, resetarFiltro) {
            mes = mes.toString().padStart(2, '0');

            if (resetarFiltro) vm.filtro.municipio = undefined;

            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.acompanhamento', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.gerenciamento.critica.acompanhamento;
            $stateProvider
                .state('app.gerenciamento_critica_acompanhamento', {
                    url: '/gerenciamento/critica/acompanhamento',
                    module: 'privado',
                    views : {
                        'content@app': {
                            templateUrl: rotasHtml.templateUrl,
                            controller: 'AcompanhamentoCriticasController as vm'
                        },
                        'acompanhamento-critica-form@app.gerenciamento_critica_acompanhamento' : {
                            templateUrl: rotasHtml.form
                        },
                        'filtro-acompanhamento-sidenav@app.gerenciamento_critica_acompanhamento': {
                            templateUrl: rotasHtml.sidenav.filtro,
                            controller: 'FiltroAcompanhamentoSidenavController as vm'
                        }
                    }
            });
        }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.critica.acompanhamento')
        .controller('FiltroAcompanhamentoSidenavController', FiltroAcompanhamentoSidenavController)

    /** @ngInject */
    function FiltroAcompanhamentoSidenavController(SessionStorageService, KeysSessionStorage,
        AcompanhamentoCriticaService, RequisicaoGenericaService, Api, MdDialogService) {
        var vm = this;

        init();

        vm.metodos = {
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            pesquisarMunicipiosPorRegional: _pesquisarMunicipiosPorRegional,
            pesquisarGrupos: _pesquisarGrupos,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            configuraMdSelectRegional: configuraMdSelectRegional,
            filtrarCriticas: filtrarCriticas
        }

        function init() {
            vm.filtro = AcompanhamentoCriticaService.construirFiltroAcompanhamento();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if (vm.parametros.utilizaCadastroRegional) {
                _pesquisarRegionais();
            } else {
                _pesquisarGrupos("", vm.filtro.mes, vm.filtro.ano);
            }
        }

        function _pesquisarRegionais() {

            vm.filtro.regional = undefined;
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }


        function _pesquisarGrupos(regional, mes, ano) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data;
                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }


        function _pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data;
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            AcompanhamentoCriticaService.configurarMdSelect('#select-municipio');
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            AcompanhamentoCriticaService.configurarMdSelect('#select-regional');
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            AcompanhamentoCriticaService.configurarMdSelect('#select-grupo');
        }

        function filtrarCriticas(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');
            AcompanhamentoCriticaService.setFiltroAcompanhamento(filtro);

            var filtroAgrupamento = vm.regionais.filter(function (regional) {
                return regional.codigo == filtro.regional
            });
            AcompanhamentoCriticaService.setAgrupamentoFiltrado(filtroAgrupamento[0]);

            if (filtro.municipio != undefined && vm.municipios != undefined) {
                var filtroMunicipio = vm.municipios.filter(function (municipio) {
                    return municipio.codigo == filtro.municipio
                });
                AcompanhamentoCriticaService.setMunicipioFiltrado(filtroMunicipio[0]);
            }

            var promisse = AcompanhamentoCriticaService.buscarDadosAcompanhamentoCriticas(filtro);
            _iniciarProgresso();
            promisse.then(function (success) {
                AcompanhamentoCriticaService.listarDadosAcompanhamentoCritica(function () { return success.data });

            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            }).finally(function () { _finalizarProgresso() });

        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }
        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.datamobil', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.datamobil', {
                url: '/datamobil',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/datamobil-ia/datamobil-ia.html',
                        controller: 'DatamobilController as vm'
                    }
                },
                resolve: {
                    ConfiguracaoCliente: function (DatamobilIaService, $q) {
                        return DatamobilIaService.obterConfiguracaoCliente().catch(function () {
                            return $q.resolve(null);
                        });
                    }
                }
            });
    }
})();

(function () {
    "use strict";
    angular
        .module('app.datamobil')
        .controller("FavoritosDialogController", FavoritosDialogController);

    function FavoritosDialogController($mdDialog, $timeout, MdToastService, DatamobilIaService, MdDialogService, favorito) {
        var vm = this;

        vm.favorito = favorito || {};
        vm.modoEdicao = !!(favorito && favorito.id);
        vm.titulo = vm.modoEdicao ? "Editar favorito" : "Favoritar";
        vm.favoritando = false;
        vm.acaoCopiar = false;
        vm.metodos = {
            fecharDialog: fecharDialog,
            cancelar: cancelar,
            salvar: salvar,
            copiarComando: copiarComando
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function fecharDialog() {
            if (vm.favoritando) return;
            $mdDialog.hide();
        }

        function cancelar() {
            if (vm.favoritando) return;
            $mdDialog.cancel();
        }

        function salvar() {
            vm.favoritando = true;
            var promise;
            if (vm.modoEdicao) {
                promise = DatamobilIaService.editarFavorito(vm.favorito);
            } else {
                promise = DatamobilIaService.criarFavorito(vm.favorito);
            }

            promise.then(function () {
                var msg = vm.modoEdicao ? 'Favorito atualizado com sucesso!' : 'Favorito criado com sucesso!';
                MdToastService.toastPadrao(msg, false);
                vm.favoritando = false;
                fecharDialog();
            }).catch(function () {
                mostrarDialogErroServidor();
                vm.favoritando = false;
            });
        }

        function copiarComando() {
            vm.acaoCopiar = true;

            var texto = vm.favorito.comando;
            var textarea = document.createElement('textarea');
            textarea.value = texto;
            textarea.style.position = 'fixed';
            textarea.style.left = '-999999px';
            textarea.style.top = '-999999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            $timeout(function () {
                vm.acaoCopiar = false;
            }, 3000);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('TabelaRespostaController', TabelaRespostaController)
        .directive('tabelaResposta', tabelaResposta);

    /** @ngInject */
    function TabelaRespostaController($scope, $filter) {
        var vm = this;

        var dadosOriginais = [];
        var dadosProcessados = [];

        vm.pesquisar = '';
        vm.cabecalhos = [];
        vm.dadosPaginados = [];
        vm.paginacao = {
            paginaAtual: 1,
            itensPorPagina: 5,
            opcoesItensPorPagina: [5, 10, 20, 50, 100, 500],
            totalItens: 0,
            totalPaginas: 0,
            itemInicial: 0,
            itemFinal: 0
        };
        vm.ordenacao = {
            coluna: null,
            direcao: 'asc'
        };

        vm.metodos = {
            primeiraPagina: primeiraPagina,
            paginaAnterior: paginaAnterior,
            proximaPagina: proximaPagina,
            ultimaPagina: ultimaPagina,
            mudarItensPorPagina: mudarItensPorPagina,
            ordenarPor: ordenarPor,
            processarDados: processarDados
        };

        $scope.$watch('vm.data', function (novosDados) {
            if (novosDados && angular.isArray(novosDados)) {
                ativar(angular.copy(novosDados));
            }
        });

        $scope.$watch('vm.pesquisar', function (novoValor, valorAntigo) {
            if (novoValor !== valorAntigo) {
                vm.paginacao.paginaAtual = 1;
                processarDados();
            }
        });

        function ativar(dados) {
            dadosOriginais = dados;
            if (dados.length > 0) {
                vm.cabecalhos = Object.keys(dados[0]).filter(function (key) {
                    return key !== '$$hashKey';
                });
                vm.pesquisar = '';
                vm.ordenacao.coluna = null;
                vm.paginacao.paginaAtual = 1;
                processarDados();
            } else {
                dadosOriginais = [];
                dadosProcessados = [];
                vm.cabecalhos = [];
                atualizarPaginacao();
            }
        }

        function processarDados() {
            var dadosFiltrados = $filter('filter')(dadosOriginais, vm.pesquisar);

            if (vm.ordenacao.coluna) {
                dadosFiltrados.sort(function (a, b) {
                    var valorA = a[vm.ordenacao.coluna];
                    var valorB = b[vm.ordenacao.coluna];
                    var resultado = 0;

                    if (typeof valorA === 'number' && typeof valorB === 'number') {
                        resultado = valorA - valorB;
                    } else {
                        resultado = String(valorA).localeCompare(String(valorB));
                    }
                    return vm.ordenacao.direcao === 'asc' ? resultado : -resultado;
                });
            }

            dadosProcessados = dadosFiltrados;
            atualizarPaginacao();
        }

        function ordenarPor(coluna) {
            if (vm.ordenacao.coluna === coluna) {
                vm.ordenacao.direcao = vm.ordenacao.direcao === 'asc' ? 'desc' : 'asc';
            } else {
                vm.ordenacao.coluna = coluna;
                vm.ordenacao.direcao = 'asc';
            }
            vm.paginacao.paginaAtual = 1;
            processarDados();
        }

        function mudarItensPorPagina() {
            vm.paginacao.paginaAtual = 1;
            atualizarPaginacao();
        }

        function primeiraPagina() {
            if (vm.paginacao.paginaAtual > 1) {
                vm.paginacao.paginaAtual = 1;
                atualizarPaginacao();
            }
        }

        function paginaAnterior() {
            if (vm.paginacao.paginaAtual > 1) {
                vm.paginacao.paginaAtual--;
                atualizarPaginacao();
            }
        }

        function proximaPagina() {
            if (vm.paginacao.paginaAtual < vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual++;
                atualizarPaginacao();
            }
        }

        function ultimaPagina() {
            if (vm.paginacao.paginaAtual < vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual = vm.paginacao.totalPaginas;
                atualizarPaginacao();
            }
        }

        function atualizarPaginacao() {
            if (!dadosProcessados) return;

            vm.paginacao.totalItens = dadosProcessados.length;
            vm.paginacao.totalPaginas = Math.ceil(vm.paginacao.totalItens / vm.paginacao.itensPorPagina) || 1;

            if (vm.paginacao.paginaAtual > vm.paginacao.totalPaginas) {
                vm.paginacao.paginaAtual = vm.paginacao.totalPaginas;
            }

            var inicio = (vm.paginacao.paginaAtual - 1) * vm.paginacao.itensPorPagina;
            var fim = inicio + vm.paginacao.itensPorPagina;

            vm.dadosPaginados = dadosProcessados.slice(inicio, fim);

            vm.paginacao.itemInicial = vm.paginacao.totalItens > 0 ? inicio + 1 : 0;
            vm.paginacao.itemFinal = Math.min(fim, vm.paginacao.totalItens);
        }
    }

    function tabelaResposta() {
        return {
            restrict: 'E',
            scope: {
                data: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagens-recebidas/components/tabela-resposta/tabela-resposta.html',
            controller: 'TabelaRespostaController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function(){
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('DialogSelecionarSetoresDistribuicaoPorGerenciamentoGrupoController', DialogSelecionarSetoresDistribuicaoPorGerenciamentoGrupoController)

    /** @ngInject */
    function DialogSelecionarSetoresDistribuicaoPorGerenciamentoGrupoController(listarSetores, $mdDialog, MdDialogService){
        var vm = this;
        
        init();

        vm.metodos = {
            confirmar: confirmar,
            fecharDialog: fecharDialog,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio
        }

        function init(){
            vm.setores = listarSetores.data;            
        }

        function fecharDialog(){
            $mdDialog.cancel();
        }

        function confirmar(){
            if(vm.setorSelecionado){
                $mdDialog.hide(vm.setorSelecionado);
                return;
            }            
        }

        function configuraMdSelectMunicipio(){
            vm.filtrarSetores = "";
            angular.element('#select-setor').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.importacao', ['lfNgMdFileInput'])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.importacaoGrupoLeitura;
        $stateProvider
            .state('app.importacao_grupo_leitura', {
                url: '/processamento/importacaogrupoleitura',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ImportacaoGrupoLeituraController as vm',
                        abstract: true
                    },

                    'importacao-grupo-leitura-form@app.importacao_grupo_leitura': {
                        templateUrl: rotasHtml.form,
                    },

                    'importacao-grupo-leitura-caema-form@app.importacao_grupo_leitura': {
                        templateUrl: rotasHtml.caema.form,
                    }
                },
                resolve: {
                    retornarArquivoPadrao: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.retornarArquivoPadrao);
                    },
                    listarAgrupamentos: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.agrupamento.listarTodos);
                    }
                }
            });
    }
}());

(function(){
    'use strict';

    angular
        .module('app.processamento.importacao')
        .controller('DialogEstatisticaController', DialogEstatisticaController)

    /** @ngInject */
    function DialogEstatisticaController(Lista,  $mdDialog, DatatableFactory){
        var vm = this;

        vm.metodosDialog =  {
            fecharDialog: fecharDialog
        }
        
        vm.codigo = 0;

        init();

        
        function init(){     
                               
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao();
            vm.dadosEstatisticas = Lista;

        }

        function fecharDialog(){
            $mdDialog.hide();
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('DialogTarefasGerenciamentoGrupoController', DialogTarefasGerenciamentoGrupoController)

    /** @ngInject */
    function DialogTarefasGerenciamentoGrupoController(MdDialogService, $mdSidenav, $mdDialog, DatatableFactory, Tarefas,
        Grupo, RotasHtml, GerenciamentoGrupoFactory, RequisicaoGenericaService, Api, DTDefaultOptions, Filtro,
        SessionStorageService, KeysSessionStorage) {
        var vm = this;


        vm.tarefas = [];
        vm.coresSituacao = [];
        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        vm.codigoCliente = vm.parametros.empresa.codigoImanager;

        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirDialogDisponibilizarTarefa: abrirDialogDisponibilizarTarefa,
            abrirDialogDistribuicao: abrirDialogDistribuicao,
            abrirLegenda: abrirLegenda,
            pesquisarTarefas: pesquisarTarefas,
            quebrarRotas: quebrarRotas,
            abrirDialogRotas: abrirDialogRotas,
            quebrarQuadras: quebrarQuadras,
            abrirDialogTrocaLeiturista: abrirDialogTrocaLeiturista,
            cancelamentoTarefa: cancelamentoTarefa,
            abrirDialogDetalhesUnificacao: abrirDialogDetalhesUnificacao
        }

        init();

        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.tipoDetalheCalculoCaema = vm.parametros.calculo.tipoDetalheCalculo == 88;
            vm.filtro = Filtro;
            vm.coresSituacao = GerenciamentoGrupoFactory.coresLegendaSituacao();
            vm.tarefas = Tarefas.tarefas;
            vm.resumoTarefas = Tarefas.resumoTarefas;
            vm.resumoLeituras = Tarefas.resumoVisitas;
            vm.grupo = Grupo;

            vm.dtOptions = ConstruirDtOptions();
            vm.dtOptions.dom = '<"top"<"right"f>>rt'
            vm.dtOptions.scrollY = '60vh';
            vm.dtOptions.scrollCollapse = true;

            vm.totalizador = _montarArrayTotalizador(vm.resumoLeituras, vm.resumoTarefas);

            pesquisarTarefas();
        }

        function ConstruirDtOptions() {

            if (vm.parametros.utilizaCadastroRegional) {
                if (vm.parametros.impressao.utilizaRotinaCriticaLeituras) {
                    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                        {
                            targets: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
                            orderable: false
                        },
                        {
                            targets: [11, 14, 16],
                            responsivePriority: 1
                        }
                    ]);
                }
                else {
                    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                        {
                            targets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                            orderable: false
                        },
                        {
                            targets: [13],
                            responsivePriority: 1
                        }
                    ]);
                }
            } else {
                if (vm.parametros.impressao.utilizaRotinaCriticaLeituras) {
                    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                        {
                            targets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                            orderable: false
                        },
                        {
                            targets: [10, 13],
                            responsivePriority: 1
                        }
                    ]);
                }
                else {
                    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                        {
                            targets: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                            orderable: false
                        },
                        {
                            targets: [10],
                            responsivePriority: 1
                        }
                    ]);
                }
            }

            if (vm.parametros.calculo.tipoDetalheCalculo == 88) {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [0, 1, 2, 9, 10, 11],
                        width: '3%'
                    },
                    {
                        targets: [3, 4, 5, 6, 7, 8],
                        width: '10%'
                    },
                    {
                        targets: [4],
                        width: '32%'
                    },
                    {
                        targets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                        orderable: false
                    },
                    {
                        targets: [10],
                        responsivePriority: 1
                    }
                ]);
                vm.dtOptions.order = [0, 'desc']
            }

            return vm.dtOptions;
        }

        function _abrirCarregamento(mensagem) {
            vm.emProgresso = true;
            vm.mensagemCarregamento = mensagem;
        }

        function _fecharCarregamento() {
            vm.emProgresso = false;
        }

        function abrirDialogDisponibilizarTarefa(tarefa) {
            var municipio = _validarFiltroMunicipio(tarefa);

            var viewModel = {
                tarefa: tarefa.numeroDistribuicao.toString(),
                grupoReferencia: vm.grupo.referencia,
                grupo: vm.grupo.grupo,
                regional: vm.filtro.regional,
                municipio: municipio,
            }
            $mdDialog.show({
                controller: 'DisponibilizarTarefasController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.disponibilizarTarefas,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    LeituristaCodigo: 0,
                    GrupoTarefa: viewModel
                }
            }).then().finally(function () {
                pesquisarTarefas(false);
            });
        }

        function fecharDialog() {
            $mdDialog.hide()
        }

        function abrirLegenda() {
            $mdSidenav('legenda-gerenciamentogrupo').toggle();
        }

        function pesquisarTarefas(naoExibirMensagemTarefas) {
            var grupoLeitura = {
                mes: vm.grupo.referencia.substring(0, 2),
                ano: vm.grupo.referencia.substring(3, 8),
                grupoLeitura: vm.grupo.grupo,
                regional: vm.grupo.regional,
                municipio: vm.grupo.municipio
            };
            _abrirCarregamento("Buscando dados de tarefas...");

            if (!_validarFiltroTarefas(grupoLeitura)) {
                return;
            }

            RequisicaoGenericaService.salvar(Api.gerenciamentoGrupo.realizarFiltroTarefas, grupoLeitura).then(
                function (success) {
                    _fecharCarregamento();
                    vm.tarefas = success.data.tarefas;
                    vm.resumoTarefas = success.data.resumoTarefas;
                    vm.resumoLeituras = success.data.resumoVisitas;
                    vm.totalizador = _montarArrayTotalizador(vm.resumoLeituras, vm.resumoTarefas);
                },
                function (error) {
                    _fecharCarregamento();
                    if (!naoExibirMensagemTarefas) {
                        MdDialogService.alertPadrao(error.data);
                    }
                    console.log(error.data);
                }
            )
        }

        function _validarFiltroTarefas(grupoLeitura) {
            if (grupoLeitura == undefined) {
                return false;
            }
            return true;
        }

        function abrirDialogDistribuicao(tarefa) {

            var viewModel = {
                referencia: vm.grupo.referencia,
                grupo: vm.grupo.grupo,
                tipodistribuicao: 2,
                regional: vm.grupo.regional,
                municipio: tarefa.municipioCodigo
            };


            $mdDialog.show({
                controller: 'DistribuicaoController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.distribuicao,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Grupo: viewModel
                }
            }).then().finally(function () {
                pesquisarTarefas(false);
            });
        }

        function _montarArrayTotalizador(resumoLeituras, resumoTarefas) {

            var cards = [
                { title: 'Total leit.', data: resumoLeituras.totalVisitas },
                { title: 'Leit. efetuadas', data: resumoLeituras.totalVisitasEfetuadas },
                { title: 'Leit. não efetuadas', data: resumoLeituras.totalVisitasNaoEfetuadas },
                { title: 'Tarefas', data: resumoTarefas.totalTarefas },
                { title: 'Tar. disponibilizadas', data: resumoTarefas.totalTarefasExportadas },
                { title: 'Tar. importadas', data: resumoTarefas.totalTarefasImportadas },
                { title: 'Tar. não importadas', data: resumoTarefas.totalTarefasExportadosNaoImportados }
            ]

            if (vm.parametros.coletor.utilizaRotinaRepasse == 'S')
                cards.push({ title: 'Rep. a realizar', data: resumoLeituras.totalRepassesARealizar });

            return cards;
        }

        function quebrarRotas(rotas, tarefa) {
            if (rotas && rotas.length > 24) {
                tarefa.rotaBKP = rotas;
                tarefa.quebrouRota = true;
                return rotas.substring(0, 23);
            }
            return rotas;
        }

        function quebrarQuadras(quadras, tarefa) {
            if (quadras && quadras.length > 24) {
                tarefa.quadraBKP = quadras;
                tarefa.quebrouQuadra = true;
                return quadras.substring(0, 23)
            }
            return quadras;
        }

        function abrirDialogRotas(rotas, titulo) {
            $mdDialog.show({
                controller: "DialogRotasController",
                controllerAs: "vm",
                templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.rotas,
                locals: {
                    Rotas: rotas,
                    Titulo: titulo
                },
                escapeToClose: true,
                clickOutsideToClose: true,
                multiple: true
            })
        }

        function _validarFiltroMunicipio(tarefa) {
            if (vm.parametros.utilizaCadastroRegional) {
                return vm.filtro.municipio == undefined ? tarefa.detalhamentoMunicipios[0] : vm.filtro.municipio;
            } else {
                return vm.filtro.municipio;
            }
        }

        function abrirDialogTrocaLeiturista(tarefa) {
            _abrirCarregamento("Validando tarefa...");

            var validacao = {
                leituristaOrigem: tarefa.codigoLeiturista,
                leituristaDestino: tarefa.codigoLeiturista,
                tarefa: tarefa.numeroDistribuicao,
                gleiCodigo: tarefa.grupoLeituraCodigo
            }

            RequisicaoGenericaService.salvar(Api.trocarLeiturista.validarTrocaLeiturista, validacao)
                .then(
                    function (success) {
                        if (vm.dialogTrocaLeituristaAberto) return;

                        var viewModel = {
                            tarefa: tarefa.numeroDistribuicao.toString(),
                            grupo: vm.grupo.grupo,
                            agrupamento: vm.grupo.regional,
                            mes: vm.grupo.referencia.substring(0, 2),
                            ano: vm.grupo.referencia.substring(3, 8),
                        }

                        vm.dialogTrocaLeituristaAberto = true;

                        $mdDialog.show({
                            controller: 'TrocarLeituristaController',
                            controllerAs: 'vm',
                            templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.trocarLeiturista,
                            multiple: true,
                            targetEvent: event,
                            clickOutsideToClose: false,
                            escapeToClose: false,
                            locals: {
                                Parametro: viewModel
                            },
                            resolve: {
                                ListarLeituristas: function (RequisicaoGenericaService, Api) {
                                    return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                                }
                            }
                        }).then().finally(function () {
                            pesquisarTarefas(false);
                            vm.dialogTrocaLeituristaAberto = false;
                        });
                    },
                    function (error) {
                        _fecharCarregamento();
                        MdDialogService.alertPadraoComEvento("Não será possível realizar a troca:", event, event, error.data);
                    }
                )
                .finally(function () { _fecharCarregamento(); });
        }

        function cancelamentoTarefa(tarefa) {
            _abrirCarregamento("Validando tarefa...");

            var viewModel = {
                tarefa: tarefa.numeroDistribuicao,
                gleiCodigo: tarefa.grupoLeituraCodigo,
                quantidadeLeituras: tarefa.visitasNaoEfetuadas,
                codigoLeiturista: tarefa.codigoLeiturista
            };

            RequisicaoGenericaService.salvar(Api.cancelarTarefa.validar, viewModel)
                .then(
                    function (success) {
                        _fecharCarregamento();
                        MdDialogService.confirmPadraoComEvento(
                            "Deseja realmente cancelar essa tarefa?",
                            "Ao cancelar uma tarefa, a mesma será retornada para distribuição.",
                            null,
                            function () {
                                _abrirCarregamento("Realizando cancelamento de tarefa...");

                                var promisse = RequisicaoGenericaService.editar(Api.cancelarTarefa.cancelar, viewModel);

                                promisse.then(
                                    function (success) {
                                        MdDialogService.alertPadrao(success.data);
                                        _fecharCarregamento();
                                    },
                                    function (error) {
                                        MdDialogService.alertPadrao(error.data);
                                        _fecharCarregamento();
                                    }
                                )
                                    .finally(function () { _fecharCarregamento(); pesquisarTarefas(false); });
                            }
                        );
                    },
                    function (error) {
                        _fecharCarregamento();
                        MdDialogService.alertPadraoComEvento("Não foi possível cancelar a tarefa:", event, event, error.data);
                    }
                )
                .finally(function () { _fecharCarregamento(); });
        }

        function abrirDialogDetalhesUnificacao(tarefa) {
            $mdDialog.show({
                controller: "DialogDetalhesUnificaoController",
                controllerAs: "vm",
                templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.detalhesUnificao,
                locals: {
                    Tarefa: tarefa
                },
                escapeToClose: false,
                clickOutsideToClose: false,
                multiple: true
            })
        }

    }
}());

(function () {
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('DialogDatasGrupoController', DialogDatasGrupoController)

    /** @ngInject */
    function DialogDatasGrupoController(
        $mdDialog,
        Grupo,
        SessionStorageService,
        KeysSessionStorage,
        RotasHtml
    ) {
        var vm = this;
        vm.rotasHtml = RotasHtml.gerenciamentoGrupo;

        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirDialogLegenda: abrirDialogLegenda,
            definirCorCards: definirCorCards
        }

        init();

        function init() {
            vm.grupo = Grupo;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.exibeProjecao =
                (vm.parametros.calculo.tipoDetalheCalculo == 89 &&
                    vm.grupo.dataInicioEstimada && vm.grupo.dataInicioEstimada.length) ||
                (vm.parametros.calculo.tipoDetalheCalculo != 89 &&
                    vm.grupo.dataInicioReal && vm.grupo.dataInicioReal.length);

            if (vm.exibeProjecao) {
                if (vm.parametros.calculo.tipoDetalheCalculo == 89) {
                    _calcularDataProjecaoFinal(vm.grupo.dataInicioEstimada);
                } else {
                    _calcularDataProjecaoFinal(vm.grupo.dataInicioReal)
                }
            }
        }

        function fecharDialog() {
            $mdDialog.hide()
        }

        function abrirDialogLegenda() {
            $mdDialog.show({
                controller: 'DialogLegendaController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogLegenda,
                multiple: true,
                targetEvent: event,
                clickOutsideToClose: false
            });
        }

        function definirCorCards(dataPrevisao) {
            if (vm.parametros.calculo.tipoDetalheCalculo == 89) {
                if (_converterStringParaData(dataPrevisao) > _converterStringParaData(vm.grupo.dataFinalEstimada)) {
                    return "vermelho";
                }
                else if (_converterStringParaData(dataPrevisao) < _converterStringParaData(vm.grupo.dataFinalEstimada)) {
                    return "verde";
                }
                else {
                    return "amarelo";
                }
            }
        }

        function _calcularDataProjecaoFinal(dataInicio) {
            var mediaRealLeituras = _calcularMediaReal(dataInicio);

            vm.diasParaConclusao = Math.ceil(vm.grupo.leiturasNaoEfetuadas / mediaRealLeituras);

            var dataPrevisao = new Date(vm.dataAtual.getTime() + (vm.diasParaConclusao - 1) * 1000 * 60 * 60 * 24);
            vm.dataPrevistaFormatadaComFds = dataPrevisao.toLocaleDateString();

            vm.dataPrevistaFormatadaSemFds = _calcularDataPrevistaSemFds();
        }

        function _calcularMediaReal(dataInicio) {
            var dataInicioEstimada = _converterStringParaData(dataInicio);

            vm.dataAtual = new Date();

            var diferencaMilissegundos = Math.abs(vm.dataAtual - dataInicioEstimada);
            var diferencaDias = Math.ceil(diferencaMilissegundos / (1000 * 60 * 60 * 24));

            var mediaReal = Math.ceil(vm.grupo.leiturasEfetuadas / diferencaDias);

            return mediaReal;
        }

        function _calcularDataPrevistaSemFds() {
            var dataSemFds = new Date(vm.dataAtual.getTime());
            var diasConsiderados = 1;

            while (diasConsiderados < vm.diasParaConclusao) {
                dataSemFds.setDate(dataSemFds.getDate() + 1);
                var diaSemana = dataSemFds.getDay();
                if (!(diaSemana === 0 || diaSemana === 6)) {
                    diasConsiderados++;
                }
            };

            return dataSemFds.toLocaleDateString();
        }

        function _converterStringParaData(dataString) {
            var partesData = dataString.split('/');

            return new Date(partesData[2], partesData[1] - 1, partesData[0]);
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('LegendaCoresGerenciamentoGrupoController', LegendaCoresGerenciamentoGrupoController)

    /** @ngInject */
    function LegendaCoresGerenciamentoGrupoController(GerenciamentoGrupoFactory, $mdSidenav){
        var vm = this;
        
        vm.metodos = {
            fecharLegenda: fecharLegenda
        }
        init();
        
        
        function init(){
            vm.itensLegenda = GerenciamentoGrupoFactory.coresLegendaSituacao();
        }
        function fecharLegenda(){
            if($mdSidenav('legenda-gerenciamentogrupo').isOpen())
                $mdSidenav('legenda-gerenciamentogrupo').toggle();
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('FiltroGerenciamentoGrupoController', FiltroGerenciamentoGrupoController)

    /** @ngInject */
    function FiltroGerenciamentoGrupoController(RequisicaoGenericaService, Api, $rootScope, MdDialogService,
        $mdSidenav, GerenciamentoGrupoFactory,
        SessionStorageService, KeysSessionStorage) {
        var vm = this;

        var rotasApi = Api.gerenciamentoGrupo;

        vm.metodos = {
            filtrarGrupos: filtrarGrupos,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            configuraMdSelectTipoDistribuicao: configuraMdSelectTipoDistribuicao,
            configuraMdSelectRegional: configuraMdSelectRegional,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            pesquisarMunicipiosPorRegional: _pesquisarMunicipiosPorRegional,
            pesquisarGrupos: _pesquisarGrupos

        }

        init();

        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.filtro = GerenciamentoGrupoFactory.construirEntidadeFiltro();

            if (vm.parametros.utilizaCadastroRegional) {
                _pesquisarRegionais();
            }
            else {
                _pesquisarGrupos("", vm.filtro.mes, vm.filtro.ano);
            }
        }

        function filtrarGrupos(filtro) {
            GerenciamentoGrupoFactory.setFiltro(filtro);
            if ($mdSidenav("filtro-gerenciamentogrupo").isOpen()) {
                $mdSidenav("filtro-gerenciamentogrupo").toggle();
            }
            $rootScope.$broadcast('carregamentoDadosGerenciamento', true);
            RequisicaoGenericaService.salvar(rotasApi.realizarFiltroGrupos, filtro).then(function (success) {
                var dados = {
                    grupos: success.data,
                    filtro: filtro
                }
                if(!dados.grupos.length){
                    $rootScope.$broadcast('dadosGerenciamentoGrupo', null);
                    MdDialogService.alertPadrao("Atenção", event, "Nenhum grupo encontrado com base no filtro realizado.");
                    $mdSidenav("filtro-gerenciamentogrupo").toggle();
                } else {
                    $rootScope.$broadcast('dadosGerenciamentoGrupo', dados);                    
                }
            }, function (error) {
                $rootScope.$broadcast('dadosGerenciamentoGrupo', null);
                MdDialogService.alertPadrao("Atenção", null, error.data);
            });
        }

        function _pesquisarRegionais() {

            vm.filtro.regional = undefined;
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }


        function _pesquisarGrupos(regional, mes, ano) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }


        function _pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data;
                        GerenciamentoGrupoFactory.setSetores(success.data);
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectTipoDistribuicao() {
            vm.filtrarTipoDistribuicoes = "";
            angular.element('#select-tipodistribuicao').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile', ['lfNgMdFileInput'])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.exportacaomobile;
        var rotasHtmlRetidas = RotasHtml.disponibilizarCargaRetidas;
        var rotasHtmlFiorilli = RotasHtml.disponibilizarCargaFiorilli;
        var rotasHtmlThema = RotasHtml.disponibilizarCargaThema;

        $stateProvider
            .state('app.exportacao_mobile', {
                url: '/processamento/disponibilizarcarga',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ExportacaomobileController as vm',
                        abstract: true
                    },

                    'exportacaomobile-form@app.exportacao_mobile': {
                        templateUrl: rotasHtml.form,
                    },

                    'disponibilizarcargaretidas-form@app.exportacao_mobile': {
                        templateUrl: rotasHtmlRetidas.form,
                    },

                    'disponibilizarcargafiorilli@app.exportacao_mobile': {
                        templateUrl: rotasHtmlFiorilli.templateUrl,
                        controller: 'DisponibilizarCargaFiorilliController as vm',
                    },

                    'disponibilizarcargathema@app.exportacao_mobile': {
                        templateUrl: rotasHtmlThema.templateUrl,
                    }
                },
                resolve: {
                    LeituristaCodigo: function () {
                        return 0;
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile')
        .controller('RelatorioImportacaoController', RelatorioImportacaoController);

    function RelatorioImportacaoController(Relatorio, $mdDialog, RelatorioService, Api, ServicosGenericoService) {
        var vm = this;

        var _rotaGerarRelatorio = Api.relatorios.consumoCreditoDebito.enviaFormulario;
        var _rotaVisualizarRelatorio = Api.relatorios.consumoCreditoDebito.visualizarRelatorio;

        init();

        function init() {
            vm.dados = angular.copy(Relatorio);

            vm.preLoader = true;
            RequisicaoGenericaService.listarSemParams(Api.parametros.logomarcaStream)
                .then(function (success) {
                    vm.dados.logomarca = success.data;
                }).finally(function () { vm.preLoader = false; });
        }

        vm.metodos = {
            fecharDialog: fecharDialog,
            confirmar: confirmar,
            gerarRelatorio: gerarRelatorio
        }

        function _visualizarRelatorio(nomeArquivo) {
            RelatorioService.visualizarRelatorio(_rotaVisualizarRelatorio, nomeArquivo);
        }

        function _gerarParametrRequisicao() {
            var parametro = {
                dadosRelatorio: vm.dados.dadosRelatorio,
                nomeEmpresa: vm.dados.nomeEmpresa,
                marcaEspecial: vm.dados.marcaEspecial,
                logomarca: vm.dados.logomarca
            };

            return JSON.stringify(parametro);
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }

        function confirmar() {
            $mdDialog.hide();
        }

        function gerarRelatorio() {
            vm.preLoader = true;
            RelatorioService.gerarRelatorio(_rotaGerarRelatorio, _gerarParametrRequisicao())
                .then(function (success) {
                    _visualizarRelatorio(success.data);
                    vm.preLoader = false;
                },
                    function (error) {
                        ServicosGenericoService.tratarErroAPI(error);
                        vm.emProgresso = false;
                    }).catch(function (err) {
                        console.log(err);
                    });
        }
    }
})();
(function () {
    "use strict";

    angular
        .module('app.processamento.exportacaomobile')
        .controller("DisponibilizarRetidasDialogController", DisponibilizarRetidasDialogController);

    /* @ngInject */
    function DisponibilizarRetidasDialogController(
        $mdDialog,
        $scope,
        $timeout,
        DisponibilizarCargaRetidasService,
        FaturasRetidas,
        RotasHtml,
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService
    ) {
        var vm = this;

        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        vm.dtOptions = configDataTable([
            {
                targets: [0, 8, 3, 4],
                orderable: false
            },
            {
                targets: [0, 8],
                width: "5%"
            },
            {
                targets: [1, 2, 5, 7],
                width: "15%"
            },
            {
                targets: [3, 4, 6],
                width: "10%"
            },
            {
                targets: [0, 7, 8],
                responsivePriority: 1,
            },
        ]);
        vm.marcarTodas = false;
        vm.emProgresso = false;
        vm.ehDialog = true;
        vm.dtOptions.order = [];
        vm.dtOptions.dom = '<"top"f>rt<"bottom"<"left"<"info"i>>>';
        vm.dtOptions.responsive = true;
        
        vm.faturasRetidas = FaturasRetidas.data;        
        vm.setoresUnicos = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.setor)));  
        vm.rotasUnicas = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.rota))); 

        vm.rotasHtml = RotasHtml.disponibilizarCargaRetidas;

        init();

        vm.metodos = {
            marcarTodas: marcarTodas,
            fecharDialog: fecharDialog,
            disponibilizarRetidas: disponibilizarRetidas,
            existeFaturaSelecionada: existeFaturaSelecionada,
            quantidadeFaturasSelecionadas: quantidadeFaturasSelecionadas,
            faturaVencida: faturaVencida,
            abrirDialogDetalhesDependentes: abrirDialogDetalhesDependentes,
            atualizarDados: atualizarDados,
            cancelar: cancelar
        };

        function init() {
            if (vm.faturasRetidas.length == 0) {
                MdDialogService.alertPadraoComEvento("Não existem faturas retidas para disponibilização.", function () { fecharDialog(); });
            }
        }

        function marcarTodas() {
            if(vm.todosMarcados){
                vm.faturasRetidas.forEach(function (fatura) {
                    if (vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = false;
                    }
                });
            }else{
                var codigosItensNaoMarcados = vm.faturasRetidas
                    .filter(fatura => !fatura.selecionada)
                    .map(fatura => fatura.codigo);
                vm.faturasRetidas.forEach(function (fatura) {
                    if (codigosItensNaoMarcados.includes(fatura.codigo) && vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = true;
                    }
                });  
            }
        }

        $scope.$watch('vm.faturasRetidas', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                var codigosItensMarcados = newValue
                .filter(function(fatura) {
                    return fatura.selecionada === true;
                })
                .map(function(fatura) {
                    return fatura.codigo;
                });
                var codigosFiltrados = vm.codigosFiltrados;
                var saoIguais = codigosFiltrados.every(function(codigo) {
                    return codigosItensMarcados.includes(codigo);
                });
                $timeout(function() {
                    vm.todosMarcados = saoIguais;
                });
            }
        }, true);

        function disponibilizarRetidas() {
            var faturasSelecionadas = vm.faturasRetidas.filter(function (fatura) {
                return fatura.selecionada;
            });

            $mdDialog.hide(faturasSelecionadas)
        }

        function fecharDialog() {
            $mdDialog.hide([]);
        }

        function abrirDialogDetalhesDependentes(dependentes) {
            $mdDialog.show({
                controller: 'DialogDetalhesDependentesController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogDetalhesDependentes,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    FaturasRetidasDependentes: dependentes,
                    ExibeInformativo: true
                }
            });
        }

        function existeFaturaSelecionada() {
            return vm.faturasRetidas.some(function (fatura) {
                return fatura.selecionada;
            });
        }

        function quantidadeFaturasSelecionadas() {
            return vm.faturasRetidas.filter(function (fatura) {
                return fatura.selecionada;
            }).length;
        }

        function faturaVencida(fatura) {
            return _converterStringParaData(fatura.vencimento) < new Date();
        }

        function atualizarDados() {
            vm.emProgresso = true;

            DisponibilizarCargaRetidasService.listarFaturasRetidas("")
                .then(function (success) {
                    vm.faturasRetidas = success.data;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
        }

        function cancelar() {
            MdDialogService.confirmPadraoComEvento("A carga será disponibilizada sem as faturas retidas vinculadas. Deseja cancelar?",
                null,
                null,
                function () { fecharDialog(); },
                null);
        }

        function _converterStringParaData(dataString) {
            var partes = dataString.split("/");

            return new Date(partes[2], partes[1] - 1, partes[0]);
        }

        function configDataTable(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');
        
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                     
                    function filtrarDados() {
                        var setoresSelecionados = vm.setorSelecionado || [];
                        var rotasSelecionadas = vm.rotaSelecionada || [];
                    
                        api.column(3).search(setoresSelecionados.map(function(setor) {
                            return '^' + setor + '$';
                        }).join('|'), true, false).draw();
                    
                        api.column(4).search(rotasSelecionadas.map(function(rota) {
                            return '^' + rota + '$';
                        }).join('|'), true, false).draw();
                    }
        
                    $scope.$watchGroup(['vm.setorSelecionado', 'vm.rotaSelecionada'], function (newValue, oldValue) {
                        filtrarDados();
                    });                             
                },
                drawCallback: function () {
                    var itensFiltrados = this.api().rows({ filter: 'applied' }).data().toArray();
                    vm.codigosFiltrados = itensFiltrados.map(item => {
                        const codigo = item[1];
                        return codigo.match(/\d+/)[0];
                    });
                    var faturasFiltradas = vm.faturasRetidas.filter(fatura => vm.codigosFiltrados.includes(fatura.codigo));
                    vm.todosMarcados = faturasFiltradas.every(fatura => fatura.selecionada);
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }
    }
})();
/**
 * Created by nova on 02/08/2016.
 */
/**
 * Created by nova on 28/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.compartilhado',
            [
                'app.diretivas',
                'app.filtros'               
            ]);

})();

(function () {
    'use strict';

    angular
        .module('app.compartilhado')
        .controller('DialogConfirmacaoExclusaoController', DialogConfirmacaoExclusaoController);

    function DialogConfirmacaoExclusaoController(Arquivos, $mdDialog) {
        var vm = this;

        vm.arquivos = Arquivos;

        vm.metodos = {
            confirmarExclusao: confirmarExclusao,
        }

        function confirmarExclusao(boolean) {
            $mdDialog.hide(boolean);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DistribuicaoFiltroController', DistribuicaoFiltroController)

    /** @ngInject */
    function DistribuicaoFiltroController($mdSidenav, RequisicaoGenericaService,
        Api, MdDialogService, $rootScope, SessionStorageService, KeysSessionStorage, DistribuicaoService) {
        var vm = this;

        var dataAtual = new Date();

        vm.metodos = {
            filtrarDadosDistribuicao: _filtrarDadosDistribuicao,
            pesquisarGrupos: _pesquisarGrupos,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            configuraMdSelectRegional: configuraMdSelectRegional,
            configuraMdSelectTipoDistribuicao: configuraMdSelectTipoDistribuicao,
            pesquisarMunicipiosPorRegional: _pesquisarMunicipiosPorRegional,
        }

        init();

        function init() {
            vm.emProgresso = false;
            vm.emProgressoBuscaGrupo = false;

            vm.filtro = {
                mes: dataAtual.getMonth() + 1,
                ano: dataAtual.getFullYear(),
                tipodistribuicao: 1,
            };

            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.ehEnorsulSertaozinho = vm.parametros.empresa.tipoEmpresa == 565;
            vm.ehBauru = vm.parametros.empresa.codigoImanager == "0070";
            //CASAN ou CAEMA
            vm.ehCalculoEspecifico = (vm.parametros.calculo.tipoDetalheCalculo == 89 || vm.parametros.calculo.tipoDetalheCalculo == 88);

            _pesquisarTipoDistribuicao();
            if (vm.parametros.utilizaCadastroRegional) {
                _pesquisarRegionais();
            }
            else {
                _pesquisarGrupos("", vm.filtro.mes, vm.filtro.ano);
            }
            //_pesquisarGrupos(vm.filtro.mes, vm.filtro.ano);   

            //_pesquisarMunicipios();

        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _filtrarDadosDistribuicao(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');
            $rootScope.$broadcast("limparDadosDistribuicao", true);
            vm.emProgresso = true;
            DistribuicaoService.setFiltroDistribuicao(filtro);
            RequisicaoGenericaService.salvar(Api.distribuicao.verificarLeituraExisteGrupo, filtro).then(
                function (success) {
                    _consistirLeiturasDistribuidas(filtro);
                    $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
                },
                function (error) {
                    vm.emProgresso = false;
                    MdDialogService.alertPadrao("Atenção", null, error.data);
                }
            );

        }

        function _consistirLeiturasDistribuidas(filtro) {
            var promessa = RequisicaoGenericaService.salvar(Api.distribuicao.consistirLeiturasDistribuidas, filtro);
            promessa.then(function (success) {
                vm.emProgresso = false;
                if ($mdSidenav("filtro-distribuicao").isOpen()) {
                    $mdSidenav("filtro-distribuicao").toggle();
                }
                MdDialogService.confirmPadraoComEvento("Atenção", success.data.mensagem, null, function () {
                    if (filtro.tipodistribuicao == 5) {
                        DistribuicaoService.abrirDialogCalculoDistribuicaoAutomatica(success.data.leiturasAhDistribuir)
                            .then(function (success) {
                                filtro.quantidadeTarefas = success;
                                _carregarDadosDistribuicaoPorRota(filtro);
                            }, function (err) {
                                MdDialogService.alertPadrao("Atenção", null, "Processo de distribuição não foi iniciado.");
                            });
                    }
                    else {
                        _carregarDadosDistribuicaoPorRota(filtro);
                    }
                }, function () {
                    MdDialogService.alertPadrao("Atenção", null, "Processo de distribuição não foi iniciado.");
                });
            }, function (error) {
                vm.emProgresso = false;
                MdDialogService.alertPadrao("Atenção", null, error.data)
            });
        }

        function _carregarDadosDistribuicaoPorRota(filtro) {
            $rootScope.$broadcast("carregamentoDados", true);
            var promessa = RequisicaoGenericaService.salvar(Api.distribuicao.carregarDadosDistribuicaoPorRota, filtro);
            promessa.then(function (success) {
                if (filtro.tipodistribuicao == 1 && vm.parametros.calculo.tipoDetalheCalculo == 88) {

                }
                else if (filtro.tipodistribuicao == 2 || filtro.tipodistribuicao == 3) {
                    var bkp = success.data;
                    DistribuicaoService
                        .abrirDialogSelecionarSetor(success.data.detalhesDistribuicao, success.data.resumoDistribuicao, filtro.tipodistribuicao)
                        .then(function (success) {
                            success.bkp = bkp;
                            $rootScope.$broadcast("dadosDistribuicao", success);
                        }, function (err) {
                            $rootScope.$broadcast("dadosDistribuicao", err);
                        });
                }
                else {
                    $rootScope.$broadcast("dadosDistribuicao", success.data);
                }
            }, function (error) {
                console.log(error);
            });

        }

        // function _pesquisarGrupos(mes, ano){
        //     mes = mes.toString().padStart(2,'0');
        //     vm.filtro.grupo = undefined;
        //     vm.emProgressoBuscaGrupo = true;
        //     RequisicaoGenericaService.listarSemParams(Api.distribuicao.retornarGruposLeitura + mes + '/' + ano).then(
        //         function(success){
        //             vm.emProgressoBuscaGrupo = false;
        //             vm.grupos = success.data.map(function(item){
        //                 return item.grupo
        //             });
        //         },
        //         function(error){
        //             vm.emProgressoBuscaGrupo = false;
        //             console.log(error.data);                    
        //         }
        //     )
        // }

        function _pesquisarMunicipios(regional) {

            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.municipio.retornarMunicipios + '?regional=' + regional).then(
                function (success) {
                    vm.emProgressoBuscaMunicipio = false;
                    vm.municipios = success.data.map(function (item) {
                        return item
                    });
                },
                function (error) {
                    vm.emProgressoBuscaMunicipio = false;
                    console.log(error.data);
                }
            )
        }

        function _pesquisarGrupos(regional, mes, ano) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }

        function _pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.municipio = undefined;
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function _pesquisarRegionais() {

            vm.filtro.regional = undefined;
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
        }

        function _pesquisarTipoDistribuicao() {
            vm.filtro.tipodistribuicao = undefined;
            vm.emProgressoBuscaTipoDistribuicao = true;
            RequisicaoGenericaService.listarSemParams(Api.distribuicao.retornarTipoDistribuicao).then(
                function (success) {
                    vm.emProgressoBuscaTipoDistribuicao = false;
                    vm.tipodistribuicoes = success.data;
                    if (vm.ehCalculoEspecifico) {
                        vm.filtro.tipodistribuicao = vm.tipodistribuicoes[1].codigo;
                    } else if (vm.ehEnorsulSertaozinho) {
                        vm.filtro.tipodistribuicao = vm.tipodistribuicoes[0].codigo;
                        vm.tipodistribuicoes.splice(2, 2);
                    }
                    else if (vm.ehBauru) {
                        vm.filtro.tipodistribuicao = vm.tipodistribuicoes[6].codigo
                    }
                    else {
                        vm.filtro.tipodistribuicao = vm.tipodistribuicoes[0].codigo;
                    }

                },
                function (error) {
                    vm.emProgressoBuscaTipoDistribuicao = false;
                    console.log(error.data);
                }
            )
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectTipoDistribuicao() {
            vm.filtrarTipoDistribuicoes = "";
            angular.element('#select-tipodistribuicao').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }


    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DialogUnificarTarefasController', DialogUnificarTarefasController)

        function DialogUnificarTarefasController($mdDialog, MdDialogService){
            var vm = this;

            init();

            vm.metodos = {
                fecharDialog: fecharDialog,
                retornarNumeroTarefa: retornarNumeroTarefa
            }

            function init(){
                vm.tarefa = "";
            }

            function fecharDialog(){            
                $mdDialog.cancel();
            }

            function retornarNumeroTarefa(){
                if(vm.tarefa == null || vm.tarefa == 0){
                    MdDialogService.alertPadrao("O campo é obrigatório.");
                    return;
                }
                $mdDialog.hide(vm.tarefa);
            }
        }

    }());
(function(){
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DialogSelecionarQuadrasController', DialogSelecionarQuadrasController)

    /** @ngInject */
    function DialogSelecionarQuadrasController(Quadras, QuadrasMarcadas, DatatableFactory, $mdDialog, MdDialogService){
        var vm = this;
        
        init();

        
        vm.metodos = {
            fecharDialog: fecharDialog,
            selecionarQuadras: selecionarQuadras,
            marcarTodasQuadras: marcarTodasQuadras
        }

        vm.dtColumns = [
            {
                targets: [0,1,2],
                orderable: false
            }
        ]
        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(vm.dtColumns);

        function init(){
            vm.quadras = _dividirArrayQuadras(Quadras);
            if(QuadrasMarcadas && QuadrasMarcadas.length) _marcarQuadras(QuadrasMarcadas);
        }

        function fecharDialog(){ 
            $mdDialog.cancel();
        }

        function marcarTodasQuadras(selecionarTodos){            
            vm.quadras.forEach(function(arrayQuadras){
                arrayQuadras.forEach(function(item){
                    item.marcado = selecionarTodos;
                });
            }); 
        }

        function _marcarQuadras(quadras){
            vm.quadras.forEach(function(arrayQuadras){
                arrayQuadras.forEach(function(item){
                    if(quadras.includes(item.quadra)) item.marcado = true;                    
                });
            }); 
        }

        function selecionarQuadras(){
            var quadras = _retornaQuadrasSelecionados();
            if(!_validarSelecaoQuadras(quadras)){                
                return;
            }
            $mdDialog.hide(quadras.map(function(item){return item.quadra}));
        }

        function _validarSelecaoQuadras(quadras){
            if(!quadras || !quadras.length){
                MdDialogService.alertPadrao("É necessário selecionar pelo menos uma quadra para distribuição.");
                return false;
            }

            return true;
        }

        function _retornaQuadrasSelecionados(){
            var array = [];

            vm.quadras.forEach(function(arrayQuadras){
                array = array.concat(arrayQuadras.filter(function(quadra){
                    return quadra.marcado;
                }));
            });    
            
            return array;        
        }

        function _dividirArrayQuadras(quadras){
            var qntArrays = Math.ceil(quadras.length/10);
            var novoArray = [];
            var count = 1
            var aux = 0;
            while(count <= qntArrays){                
                novoArray.push(quadras.slice(aux, aux + 10))           
                aux = aux + 10;
                count++;
            }
            return novoArray;
        }   

    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DialogSelecionarSetoresController', DialogSelecionarSetoresController)

    /** @ngInject */
    function DialogSelecionarSetoresController(DatatableFactory, Setores, $mdDialog, MdDialogService, SetoresMarcados, SessionStorageService, KeysSessionStorage){
        var vm = this;
        
        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            selecionarSetores: selecionarSetores,
            marcarTodosSetores: marcarTodosSetores
        }

        vm.dtColumns = [
            {
                targets: [0,1,2],
                orderable: false
            }
        ]
        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(vm.dtColumns);
        

        function init(){
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.setores = _dividirArraySetores(Setores);
            if(SetoresMarcados && SetoresMarcados.length) _marcarSetores(SetoresMarcados);
        }

        function fecharDialog(){  
            if(vm.parametros.calculo.tipoDetalheCalculo == 88 && !_retornaSetoresSelecionados().length){
              MdDialogService.alertPadrao("Não é possível fechar o dialog sem selecionar um setor.");
              return;
            }

            $mdDialog.cancel();
        }

        function marcarTodosSetores(selecionarTodos){            
            vm.setores.forEach(function(arraySetores){
                arraySetores.forEach(function(item){
                    item.marcado = selecionarTodos;
                });
            }); 
        }

        function _marcarSetores(setores){
            vm.setores.forEach(function(arraySetores){
                arraySetores.forEach(function(item){
                    if(setores.includes(item.setor)) item.marcado = true;                    
                });
            }); 
        }

        function selecionarSetores(){
            var setores = _retornaSetoresSelecionados();
            if(!_validarSelecaoSetores(setores)){                
                return;
            }
            $mdDialog.hide(setores.map(function(item){return item.setor}));
        }

        function _validarSelecaoSetores(setores){
            if(!setores || !setores.length){
                MdDialogService.alertPadrao("É necessário selecionar pelo menos um setor para distribuição.");
                return false;
            }

            else if(vm.parametros.calculo.tipoDetalheCalculo == 88 && _retornaSetoresSelecionados().length > 1){
                MdDialogService.alertPadrao("Para continuar a operação, é possível selecionar somente um setor.");
                return false;
            }

            return true;
        }

        function _retornaSetoresSelecionados(){
            var array = [];

            vm.setores.forEach(function(arraySetores){
                array = array.concat(arraySetores.filter(function(setor){
                    return setor.marcado;
                }));
            });    
            
            return array;        
        }

        function _dividirArraySetores(setores){
            var qntArrays = Math.ceil(setores.length/10);
            var novoArray = [];
            var count = 1
            var aux = 0;
            while(count <= qntArrays){                
                novoArray.push(setores.slice(aux, aux + 10))           
                aux = aux + 10;
                count++;
            }
            return novoArray;
        }   
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DialogDivisaoTarefasSequencialController', DialogDivisaoTarefasSequencialController)

    /** @ngInject */
    function DialogDivisaoTarefasSequencialController($mdDialog, Tarefa) {
        var vm = this;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            adicionarSequencial: adicionarSequencial,
            excluirSequencial: excluirSequencial,
            changeSequencial: changeSequencial,
            salvar: salvar
        }

        function init() {
            vm.tarefa = Tarefa;
            vm.mensagemErro = null;
            vm.sequencial = {
                sequencialInicial: vm.tarefa.sequencialInicial,
                sequencialFinal: null
            };
            vm.sequenciais = [];
            vm.sequencialInicial = vm.tarefa.sequencialInicial;
        }

        function salvar() {
            $mdDialog.hide(vm.sequenciais);
        }

        function fecharDialog() {
            $mdDialog.hide(null);
        }

        function adicionarSequencial() {
            vm.mensagemErro = _validarSequencial(vm.sequencial.sequencialInicial, vm.sequencial.sequencialFinal);

            if (vm.mensagemErro == null) {
                if (vm.sequencial.sequencialInicial && vm.sequencial.sequencialFinal) {
                    vm.sequenciais.push({
                        sequencialInicial: vm.sequencial.sequencialInicial,
                        sequencialFinal: vm.sequencial.sequencialFinal
                    });
                    vm.sequencial = {
                        sequencialInicial: null,
                        sequencialFinal: null
                    };

                    _atualizarSequenciaInicialMinima();
                }
            }
        }

        function excluirSequencial(index) {
            vm.sequenciais.splice(index, 1);
            _atualizarSequenciaInicialMinima();
        }

        function changeSequencial() {
            vm.mensagemErro = null;

            console.log(vm.sequencialInicial);
            if (vm.sequencial.sequencialInicial != null) {
                if (vm.sequencial.sequencialInicial < vm.sequencialInicial) {
                    vm.form.sequencialInicial.$setValidity("seqmin", false);
                }
                else {
                    vm.form.sequencialInicial.$setValidity("seqmin", true);
                }

                if (vm.sequencial.sequencialInicial > (vm.tarefa.sequencialFinal - 1)) {
                    vm.form.sequencialInicial.$setValidity("seqmax", false);
                }
                else {
                    vm.form.sequencialInicial.$setValidity("seqmax", true);
                }
            }

            if (vm.sequencial.sequencialFinal != null) {
                if (vm.sequencial.sequencialFinal < (vm.sequencialInicial + 1)) {
                    vm.form.sequencialFinal.$setValidity("seqmin", false);
                }
                else {
                    vm.form.sequencialFinal.$setValidity("seqmin", true);
                }

                if (vm.sequencial.sequencialFinal > vm.tarefa.sequencialFinal) {
                    vm.form.sequencialFinal.$setValidity("seqmax", false);
                }
                else {
                    vm.form.sequencialFinal.$setValidity("seqmax", true);
                }
            }

            if (vm.sequencial.sequencialInicial != null && vm.sequencial.sequencialFinal != null) {
                if (vm.sequencial.sequencialInicial >= vm.sequencial.sequencialFinal) {
                    vm.form.sequencialInicial.$setValidity("sequencialInicialError", false);
                }
                else {
                    vm.form.sequencialInicial.$setValidity("sequencialInicialError", true);
                }

                if (vm.sequencial.sequencialFinal <= vm.sequencial.sequencialInicial) {
                    vm.form.sequencialFinal.$setValidity("sequencialFinalError", false);
                }
                else {
                    vm.form.sequencialFinal.$setValidity("sequencialFinalError", true);
                }
            }
        }

        function _validarSequencial(sequencialInicial, sequencialFinal) {
            if (sequencialInicial === null || sequencialFinal === null) {
                return "Sequenciais inválidos";
            }

            if (sequencialInicial < vm.tarefa.sequencialInicial || sequencialFinal > vm.tarefa.sequencialFinal || sequencialInicial > sequencialFinal) {
                return "Sequenciais devem estar entre " + vm.tarefa.sequencialInicial + " e " + vm.tarefa.sequencialFinal;
            }

            for (var i = 0; i < vm.sequenciais.length; i++) {
                var seq = vm.sequenciais[i];
                if ((sequencialInicial >= seq.sequencialInicial && sequencialInicial <= seq.sequencialFinal) || (sequencialFinal >= seq.sequencialInicial && sequencialFinal <= seq.sequencialFinal) || (sequencialInicial <= seq.sequencialInicial && sequencialFinal >= seq.sequencialFinal)) {
                    return "Intervalo de sequenciais não podem sobrepor sequenciais já inseridos";
                }
            }

            return null;
        }

        function _atualizarSequenciaInicialMinima() {
            if (vm.sequenciais.length == 0) {
                console.log("entrou", vm.tarefa.sequencialInicial);
                vm.sequencialInicial = vm.tarefa.sequencialInicial;
                vm.sequencial.sequencialInicial = vm.tarefa.sequencialInicial;
                return;
            }

            var maxSequencialFinal = vm.sequenciais.reduce(function (max, seq) {
                return seq.sequencialFinal > max ? seq.sequencialFinal : max;
            }, vm.sequencialInicial);

            vm.sequencialInicial = maxSequencialFinal + 1;
            vm.sequencial.sequencialInicial = vm.sequencialInicial;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DialogMensagemTipoDistribuicaoController', DialogMensagemTipoDistribuicaoController)

    /** @ngInject */
    function DialogMensagemTipoDistribuicaoController(Mensagem, $mdDialog, listarTiposDistribuicao, SessionStorageService, KeysSessionStorage){
        var vm = this;  

        vm.mensagem = Mensagem;
        vm.tiposDistribuicao = [];
        
        vm.metodos = {
            continuarDistribuicao: continuarDistribuicao,
            cancelarDistribuicao: cancelarDistribuicao,
            configuraMdSelectTipoDistribuicao: configuraMdSelectTipoDistribuicao
        }

        init();

        function init(){
            vm.tiposDistribuicao = listarTiposDistribuicao.data;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

            vm.tipoDistribuicao = _definirTipoDistribuicaoInicial(vm.parametros.calculo.tipoDetalheCalculo);
            
        }

        function continuarDistribuicao(){
            $mdDialog.hide(vm.tipoDistribuicao)
        }

        function cancelarDistribuicao(){
            $mdDialog.cancel();
        }

        function configuraMdSelectTipoDistribuicao() {
            vm.filtrarTipoDistribuicoes = "";
            angular.element('#select-tipodistribuicao').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _definirTipoDistribuicaoInicial(tipoDetalheCalculo){
            if(tipoDetalheCalculo == 88)
                return vm.tiposDistribuicao[2].codigo;
            return vm.tiposDistribuicao[1].codigo;
        }


    }

}());
(function () {
  'use strict';

  angular
    .module('app.processamento.distribuicao')
    .controller('CalculoDistribuicaoAutomaticaController', CalculoDistribuicaoAutomaticaController)

  /** @ngInject */
  function CalculoDistribuicaoAutomaticaController(DatatableFactory, $mdDialog, MdDialogService, LeiturasAhDistribuir, SessionStorageService, KeysSessionStorage) {
    var vm = this;

    vm.quantidadeTarefas = 0;
    vm.mediaLeituras = "0.000";

    init();

    vm.metodos = {
      fecharDialog: fecharDialog,
      calcular: calcular,
      continuarDistribuicao: continuarDistribuicao
    }

    vm.dtColumns = [
      {
        targets: [0, 1, 2],
        orderable: false
      }
    ]
    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(vm.dtColumns);

    function init() {
      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
      vm.leiturasAhDistribuir = LeiturasAhDistribuir;
    }

    function fecharDialog() {
      $mdDialog.cancel();
    }

    function calcular() {
      var result = "";
      if (vm.quantidadeTarefas > 0) {
        result = parseFloat((vm.leiturasAhDistribuir / vm.quantidadeTarefas).toString()).toFixed(3);
        vm.mediaLeituras = result.replace(".", ",");
      } else {
        result = parseFloat((vm.leiturasAhDistribuir / 1).toString()).toFixed(3);
        vm.mediaLeituras = result.replace(".", ",");
      }
    }

    function continuarDistribuicao() {
      if (vm.quantidadeTarefas <= 0) {
        MdDialogService.alertPadrao("Atenção", null, "Deve ser informado um valor maior que zero.");
      } else {
        $mdDialog.hide(vm.quantidadeTarefas);
      }
    }

  }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizarcargaretidas', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.disponibilizarCargaRetidas;

        $stateProvider
            .state('app.disponibilizacao_cargas_retidas', {
                url: '/processamento/disponibilizarcargaretidas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'DisponibilizarCargaRetidasController as vm',
                        abstract: true
                    },
                    'disponibilizarcargaretidas-form@app.disponibilizacao_cargas_retidas': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    Leituristas: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                    },
                    FaturasRetidas: function (DisponibilizarCargaRetidasService) {
                        return DisponibilizarCargaRetidasService.listarFaturasRetidas("");
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizarcargaretidas')
        .controller('DialogSelecionarLeituristaController', DialogSelecionarLeituristaController)

    function DialogSelecionarLeituristaController($mdDialog, Leituristas) {
        var vm = this;

        vm.leituristas = Leituristas;

        vm.metodos = {
            disponibilizarFaturas: disponibilizarFaturas,
            fecharDialog: fecharDialog,
            configurarSelect: configurarSelect
        }

        function disponibilizarFaturas() {
            $mdDialog.hide(vm.codigoLeiturista)
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizarcargaretidas')
        .controller('DialogDetalhesDependentesController', DialogDetalhesDependentesController)

    function DialogDetalhesDependentesController($mdDialog, FaturasRetidasDependentes, ExibeInformativo, DatatableFactory) {
        var vm = this;

        vm.faturasRetidasDependentes = FaturasRetidasDependentes;
        vm.exibeInformativo = ExibeInformativo;

        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([]);

        vm.dtOptions.order = [];

        vm.metodos = {
            fecharDialog: fecharDialog,
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade', [])
        .config(Config);

        function Config(RotasHtml, $stateProvider){
            var rotasHtml = RotasHtml.gerenciamento.produtividade;
            $stateProvider.state('app.gerenciamento_produtividade', {
                url: '/gerenciamento/produtividade',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: "ProdutividadeDashboardController as vm"
                    },
                    'produtividade-form@app.gerenciamento_produtividade': {
                        templateUrl: rotasHtml.form
                    },
                    'produtividade-filtro@app.gerenciamento_produtividade': {
                        templateUrl: rotasHtml.sidenav.filtro.templateUrl,
                        controller: "FiltroProdutividadeDashboardController as vm"
                    }
                },
                resolve: {
                    ListarLeituristas: function(Api, RequisicaoGenericaService){
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                    }
                }
            });
        }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .controller('DialogDetalhesCriticaController', DialogDetalhesCriticaController)

    /** @ngInject */
    function DialogDetalhesCriticaController($mdDialog, Filtro, Ocorrencias, $state, CodigoLeiturista, DatatableFactory){
        var vm = this;
        
        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirTelaVisualizacaoLeituras: abrirTelaVisualizacaoLeituras
        }
        init();

        function init(){
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(_retornaColumnDefs());            
            vm.filtrosUtilizados = Filtro;
            vm.ocorrencias = Ocorrencias;
            vm.codigoLeiturista = CodigoLeiturista;
            vm.totalCriticas = Ocorrencias.reduce(function(acc, curr){
                return acc + curr.quantidade
            }, 0)
        }

        function fecharDialog(){
            $mdDialog.hide();
        }

        function _retornaColumnDefs(){
            return [
                {
                    targets: [0],
                    width: '50%'
                },
                {
                    targets: [1],
                    orderable: false,
                    width: '30%'
                },
                {
                    targets: [2],
                    orderable: false,
                    width: '20%'
                }
            ]
        }

        function abrirTelaVisualizacaoLeituras(ocorrencia){
            $state.goNewTab('app.gerenciamento_leitura_visualizacao', {
                parametrosProdutividade: {
                    clientes: ocorrencia.clientes,
                    leiturista: vm.codigoLeiturista,
                    arquivos: ocorrencia.arquivos
                }
            });
        }

    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .controller('FiltroProdutividadeDashboardController', FiltroProdutividadeDashboardController)

    /** @ngInject */
    function FiltroProdutividadeDashboardController(SessionStorageService,
         KeysSessionStorage, ProdutividadeService, $scope, MdDialogService, ListarLeituristas, $timeout){
        var vm = this;

        vm.metodos = {
            onChangeAgrupamento: onChangeAgrupamento,
            onChangeDataFim: onChangeDataFim,
            onChangeDataInicio: onChangeDataInicio,
            onChangeGrupo: onChangeGrupo,
            filtrarDadosProdutividade: filtrarDadosProdutividade,
        }
               
        
        init();        

        function init(){                 
            
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if(vm.parametros.utilizaCadastroRegional){
                _buscarAgrupamentos();
            } 
            vm.filtro = ProdutividadeService.montarFiltro();            
        }

        function _buscarAgrupamentos(){
            vm.agrupamentos = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
        }

        function onChangeAgrupamento(agrupamento){
            vm.leituristas = ListarLeituristas.data.filter(function(leiturista){
                return leiturista.agrupamentoId === agrupamento;
            });
            
            vm.filtro.descricaoAgrupamento = vm.agrupamentos.filter(function(item){
                return item.codigo === agrupamento
            })[0].descricao;           
        }      


        function onChangeDataFim(input, form){ 
            if(input.$name == 'dataFim'){
                if(input.$modelValue >= form.dataInicio.$modelValue){
                    form.dataInicio.$setValidity("dataMaxima", true);
                    input.$setValidity("dataMinima", true);
                    return;
                }

                if(input.$modelValue < form.dataInicio.$modelValue){
                    input.$setValidity("dataMinima", false);
                    return;
                }                
            }
        }    

        function onChangeDataInicio(input, form){

            if(input.$modelValue > form.dataFim.$modelValue){
                input.$setValidity("dataMaxima", false);

                return;
            }

            if(input.$modelValue <= form.dataFim.$modelValue){
                input.$setValidity("dataMaxima", true);
                form.dataFim.$setValidity("dataMinima", true);
                return;
            }

        }
        
        function onChangeGrupo(grupos){            
            var gleiCodigos = [];
            if(grupos && grupos.length){
                gleiCodigos = _retornaGleiCodigo(grupos)
            }
            else if(vm.grupos && vm.grupos.length) {                
                gleiCodigos = _retornaGleiCodigo(angular.copy(vm.grupos));
            }
            
            if(!gleiCodigos || !gleiCodigos.length) return;
            
            var viewModel = {
                dataInicio: vm.filtro.dataInicio,
                grupos: gleiCodigos,
                dataFim: vm.filtro.dataFim,
                agrupamento: vm.filtro.agrupamento
            }

            vm.emProgressoBuscaLeituristas = true;
            var pBuscaLeituristas = ProdutividadeService.buscarLeituristasPorGleiCodigo(viewModel);
            pBuscaLeituristas.then(function(success){
                vm.leituristas = success.data;
            }).finally(function(){vm.emProgressoBuscaLeituristas = false;});

        }

        function _retornaGleiCodigo(grupos){
            if(!grupos) return;
            return grupos.map(function(item){ return item.gleiCodigo});
        }


        function _retornarGrupos(filtro){
            if(!filtro.dataInicio || !filtro.dataFim) return;
            if(filtro.grupos) filtro.grupos = [];

            vm.emProgressoBuscaGrupo = true;
            var viewModel = {
                agrupamento: filtro.agrupamento,
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim
            }
            var pBuscaGrupos = ProdutividadeService.retornaGruposPorDataInicioDataFim(viewModel);

            pBuscaGrupos.then(
                function(success){
                    vm.grupos = success.data;
                }
            )
            .finally(function (){vm.emProgressoBuscaGrupo = false;})
        }

        function filtrarDadosProdutividade(filtro){    
            var viewModel = angular.copy(filtro);        
            viewModel.grupos = _validarFiltroGrupos(filtro.grupos);
            viewModel.leituristas = _validarFiltroLeituristas(filtro.leituristas);          
            ProdutividadeService.setFiltro(viewModel);
            vm.emProgresso = true;
            var pFiltrarDados = ProdutividadeService.filtrarDadosProdutividade(viewModel);
            pFiltrarDados.then(function(success){
                ProdutividadeService.listenerProdutividade(function(){ return success.data});
                ProdutividadeService.toggleFiltroProdutividade();

            }, function(error){
                MdDialogService.alertPadrao("Atenção", event, error.data);
            }).finally(function(){vm.emProgresso = false;})

        }

        function _validarFiltroGrupos(grupos){
            if(!grupos.length){
                return _retornaGleiCodigo(angular.copy(vm.grupos));  
            } 
            return grupos.map(function(item) {return item.gleiCodigo});
        }

        function _validarFiltroLeituristas(leituristas){
            if(!leituristas.length) {
                return vm.leituristas.map(function(item) {return item.codigo});
            }

            return leituristas.map(function(item) {return item.codigo});
        }
        
    }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.resumoretencoes')
    .service('ResumoRetencoesService', ResumoRetencoesService)

  /** @ngInject */
  function ResumoRetencoesService(RequisicaoGenericaService, Api, $mdSidenav) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      limparFiltro: limparFiltro,
      buscarDadosFaturasSimplificado: buscarDadosFaturasSimplificado,
      buscarDadosFaturasDetalhado: buscarDadosFaturasDetalhado,
      buscarDadosComunicadosDetalhado: buscarDadosComunicadosDetalhado,
      buscarDadosComunicadosSimplificado: buscarDadosComunicadosSimplificado
    }

    function toggleFiltro() {
      $mdSidenav('filtro-resumoretencoes').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function limparFiltro() {
      setFiltro(null);
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosFaturasSimplificado(filtro) {
      return RequisicaoGenericaService.salvar(Api.resumoretencoes.filtrarFaturasSimplificado, filtro);
    }

    function buscarDadosFaturasDetalhado(filtro) {
      return RequisicaoGenericaService.salvar(Api.resumoretencoes.filtrarFaturasDetalhado, filtro);
    }

    function buscarDadosComunicadosDetalhado(filtro) {
      return RequisicaoGenericaService.salvar(Api.resumoretencoes.filtrarComunicadosDetalhado, filtro);
    }

    function buscarDadosComunicadosSimplificado(filtro) {
      return RequisicaoGenericaService.salvar(Api.resumoretencoes.filtrarComunicadosSimplificado, filtro);
    }


    return service;
  }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .controller('DialogDetalhesOciosidadeController', DialogDetalhesOciosidadeController)

    /** @ngInject */
    function DialogDetalhesOciosidadeController(DetalhesOciosidade,Totalizador,Filtro, $mdDialog, DatatableFactory){
        var vm = this;
        
        vm.metodos = {
            fecharDialog: fecharDialog
        }

        init();

        function init(){
            vm.totalizador = Totalizador;
            vm.detalhesOciosidade = DetalhesOciosidade;
            vm.filtrosUtilizados = Filtro;
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(_construirColumnDefs());
        }
        function _construirColumnDefs(){
            return [
                {
                    targets: [0,1,2],
                    orderable: false,
                    sortable: false
                }
            ]
        }

        function fecharDialog(){
            $mdDialog.hide();
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .controller('DialogDetalhesProdutividadeController', DialogDetalhesProdutividadeController)

    /** @ngInject */
    function DialogDetalhesProdutividadeController(DadosDetalheProdutividade, DatatableFactory, $mdDialog, DTDefaultOptions, Filtros) {
        var vm = this;

        vm.metodos = {
            fecharDialog: fecharDialog
        }
        init();


        function init() {
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(_construirColumnDefs());
            vm.dadosDetalhes = DadosDetalheProdutividade;
            vm.filtrosUtilizados = Filtros;
            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function _construirColumnDefs() {
            return [
                {
                    targets: [1, 2, 3, 4, 5, 6, 7],
                    sortable: false,
                    ordable: false
                }
            ]
        }

    }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quitacaoanual')
    .service('QuitacaoAnualService', QuiatacaoAnualService)

  /** @ngInject */
  function QuiatacaoAnualService(RequisicaoGenericaService, Api, $mdSidenav) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      limparFiltro: limparFiltro,
      buscarDadosQuitacaoAnualSimplificado: buscarDadosQuitacaoAnualSimplificado,
      buscarDadosQuitacaoAnualDetalhado: buscarDadosQuitacaoAnualDetalhado

    }

    function toggleFiltro() {
      $mdSidenav('filtro-quitacaoanual').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function limparFiltro() {
      setFiltro(null);
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosQuitacaoAnualSimplificado(filtro) {
      return RequisicaoGenericaService.salvar(Api.quitacaoanual.filtrarQuitacaoAnualSimplificado, filtro);
    }

    function buscarDadosQuitacaoAnualDetalhado(filtro) {
      return RequisicaoGenericaService.salvar(Api.quitacaoanual.filtrarQuitacaoAnualDetalhado, filtro);
    }

    return service;
  }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quantitativoleituras')
    .service('QuantitativoLeiturasService', QuantitativoLeiturasService)

  /** @ngInject */
  function QuantitativoLeiturasService($mdSidenav, Api, RequisicaoGenericaService) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      buscarDadosQuantitativoLeituras: buscarDadosQuantitativoLeituras
    }

    function toggleFiltro() {
      $mdSidenav('filtro-quantitativoleituras').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosQuantitativoLeituras(filtro) {
      return RequisicaoGenericaService.salvar(Api.quantitativoleituras.filtrarQuantitativoLeituras, filtro);
    }

    return service;
  }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.quantitativoleituras')
    .service('OcorrenciasLeituristaService', OcorrenciasLeituristaService)

  /** @ngInject */
  function OcorrenciasLeituristaService(RequisicaoGenericaService, Api, $mdSidenav) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      buscarDadosOcorrenciasLeiturista: buscarDadosOcorrenciasLeiturista,
      buscarDadosAgrupadoPorDia: buscarDadosAgrupadoPorDia
    }

    function toggleFiltro() {
      $mdSidenav('filtro-ocorrenciasleiturista').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosOcorrenciasLeiturista(filtro) {
      return RequisicaoGenericaService.salvar(Api.ocorrenciasleiturista.filtrarOcorrenciasLeiturista, filtro);
    }

    function buscarDadosAgrupadoPorDia(filtro) {
      return RequisicaoGenericaService.salvar(Api.ocorrenciasleiturista.filtrarOcorrenciaPorLeituristaAgrupadoPorDia, filtro);
    }

    return service;
  }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.distribuicaogrupos')
    .service('ResumoDistribuicaoGruposLeiturasService', ResumoDistribuicaoGruposLeiturasService)

  /** @ngInject */
  function ResumoDistribuicaoGruposLeiturasService(RequisicaoGenericaService, Api, $mdSidenav) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      limparFiltro: limparFiltro,
      buscarDadosResumoDistribuicao: buscarDadosResumoDistribuicao

    }

    function toggleFiltro() {
      $mdSidenav('filtro-gruposleituras').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function limparFiltro() {
      setFiltro(null);
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosResumoDistribuicao(filtro) {
      return RequisicaoGenericaService.salvar(Api.resumodistribuicaogrupos.filtrarDadosDistribuicao, filtro);
    }

    return service;
  }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.controlecargafluxo')
        .service('ControleFluxoService', ControleFluxoService)

    function ControleFluxoService($mdSidenav, Api, RequisicaoGenericaService, MdDialogService) {
        var dadosFiltrados;


        var service = {
            buscarDadosLeitura: buscarDadosLeitura,
            abrirFecharFiltro: abrirFecharFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro,
        }

        function abrirFecharFiltro() {
            $mdSidenav('filtro-controleFluxo').toggle();
        }

        function setFiltro(dadosFiltro) {
            dadosFiltrados = dadosFiltro;
        }

        function getFiltro() {
            return angular.copy(dadosFiltrados);
        }

        function buscarDadosLeitura(dadosFiltro) {
            return RequisicaoGenericaService.salvar(Api.controleFluxo.filtrarDadosControleCargaFluxo, dadosFiltro);
        }
        return service;
    }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.comunicadosdebitoimpressos')
    .service('ComunicadosDebitoImpressosService', ComunicadosDebitoImpressosService)

  /** @ngInject */
  function ComunicadosDebitoImpressosService($mdSidenav, Api, RequisicaoGenericaService) {

    var _filtro;

    var service = {
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      buscarDadosComunicadosImpressos: buscarDadosComunicadosImpressos,
      gerarRelatorio: gerarRelatorio
    }

    function toggleFiltro() {
      $mdSidenav('filtro-comunicadosimpressos').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosComunicadosImpressos(filtro) {
      return RequisicaoGenericaService.salvar(Api.comunicadosDebitosImpressos.filtrarComunicadosDebitoImpressos, filtro)
    }

    function gerarRelatorio(dados) {
      return RequisicaoGenericaService.downloadPDF(Api.relatorios.comunicadosDebitosImpressos.gerarRelatorioComunicadosDebitoImpressos, dados);
    }

    return service;
  }

}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.clientesocorrencia')
    .service('ClienteOcorrenciaService', ClienteOcorrenciaService)

  /** @ngInject */
  function ClienteOcorrenciaService($mdSidenav, Api, RequisicaoGenericaService) {

    var _filtro;

    var service = {
      buscarDadosClienteOcorrencia: buscarDadosClienteOcorrencia,
      buscarFotosClienteOcorrencia: buscarFotosClienteOcorrencia,
      toggleFiltro: toggleFiltro,
      setFiltro: setFiltro,
      getFiltro: getFiltro,
      gerarRelatorio: gerarRelatorio
    }

    function toggleFiltro() {
      $mdSidenav('filtro-clienteocorrencia').toggle();
    }

    function setFiltro(filtro) {
      _filtro = filtro;
    }

    function getFiltro() {
      return angular.copy(_filtro);
    }

    function buscarDadosClienteOcorrencia(filtro) {
      return RequisicaoGenericaService.salvar(Api.clienteOcorrencia.filtrarClientesOcorrencia, filtro);
    }

    function buscarFotosClienteOcorrencia(filtro) {
      return RequisicaoGenericaService.salvar(Api.clienteOcorrencia.retornarFotosClientesOcorrencia, filtro);
    }

    function gerarRelatorio(dados) {
      return RequisicaoGenericaService.downloadPDF(Api.relatorios.clientesPorOcorrencia.gerarRelatorioClientesPorOcorrencia, dados);
    }

    return service;
  }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoLeituristaFiltroController', RastreamentoLeituristaFiltroController);

    /** @ngInject */
    function RastreamentoLeituristaFiltroController($timeout,
        ListarLeituristas,
        $q,
        RastreamentoLeituristasFactory,
        MdDialogService,
        RequisicaoGenericaService,
        Api,
        $mdSidenav,
        MdToastService,
        SessionStorageService,
        KeysSessionStorage) {
        var vm = this;

        // Data
        init();

        // Methods
        function init() {
            vm.desabilitarCamposFiltro = false;
            vm.form = RastreamentoLeituristasFactory.form.form;
            vm.filtro = RastreamentoLeituristasFactory.filtros;
            vm.leituristas = ListarLeituristas.data;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if (vm.parametros.utilizaCadastroRegional) {
                vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
                var resultado = vm.leituristas.filter(function (item) {
                    if (_pertentceAgrupamento(item.agrupamento)) {
                        return item;
                    }
                })
                vm.leituristas = resultado;
            }
            vm.querySearch = querySearch;

            if (vm.filtro.leiturista) {
                vm.desabilitarCamposFiltro = true;
                atualizarMapa(vm.filtro);
            }
        }

        vm.metodos = {
            atualizarMapa: atualizarMapa,
            querySearch: querySearch
        }

        vm.metodosInternos = {
            montarFiltro: _montarFiltro
        };

        ////////
        function querySearch(query) {
            var results = query ? vm.leituristas.filter(createFilterFor(query)) : vm.leituristas;
            results.sort(function (a, b) {
                return a.codigo - b.codigo;
            });

            var deferred = $q.defer();

            $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
            return deferred.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(leiturista) {
                return (leiturista.apelido.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }

        function atualizarMapa(filtro) {
            vm.emProgresso = true;
            MdToastService.toastInfo("Buscando informações...");
            var promessa = RequisicaoGenericaService.salvar(Api.leitura.rastreamento.filtrar, _montarFiltro(filtro));

            promessa.then(function (sucesso) {
                if (sucesso.data.length > 0) {
                    RastreamentoLeituristasFactory.atualizarMapa(sucesso.data);
                    $mdSidenav("filtro-rastreamento-leiturista").toggle();
                }
                else {
                    RastreamentoLeituristasFactory.setHabilitarMapa(false);
                    MdToastService.toastWarning("Nenhum registro encontrado.");
                }
            }, function (erro) {
                MdToastService.toastErro(erro.data);
            }).finally(function () { vm.emProgresso = false; });

        }

        function _montarFiltro(dados) {
            var filtro = {
                dataInicial: dados.dataInicial,
                dataFinal: dados.dataFinal,
                leiturista: dados.leiturista.codigo,
                nomeArquivo: dados.nomeArquivo,
                tarefa: dados.tarefa
            }

            return filtro;
        }

        function _pertentceAgrupamento(agrupamento) {
            var resultado = vm.regionais.filter(function (item) {
                if (item.codigo === agrupamento) {
                    return item;
                }
            })

            return resultado.length > 0;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoLeituristasMapaController', RastreamentoLeituristasMapaController);

    /** @ngInject */
    function RastreamentoLeituristasMapaController(RastreamentoLeituristasFactory, urlApi, $rootScope) {
        var vm = this;

        vm.form = RastreamentoLeituristasFactory.form.form;

        // Criar e definir chave do mapa padrão
        tomtom.key(urlApi.chave_api_maps_tomtom);
        tomtom.routingKey(urlApi.chave_api_maps_tomtom);
        var mapa = tomtom.map('mapa', {
            center: [-23.5489, -46.6388],
            source: 'vector',
            zoom: 5,
            basePath: urlApi.url_api_maps_tomtom
        });
        mapa.zoomControl.setPosition('topleft');

        var rotas = [];
        var marcadores = [];
        var eventoMarcadorTemporario = null;

        //#region 

        var metodosInternos = {
            desenharRota: _desenharRota,
            desenharMarcadores: _desenharMarcadores,
            limparMapa: _limparMapa,
            definirIcone: _definirIcone,
            centralizarMapa: _centralizarMapa,
            desmarcarQuandoFocoAusente: _desmarcarQuandoFocoAusente
        }

        //#endregion                       

        //#region Métodos Internos

        $rootScope.$on('atualizarMapaFactory', function (event, dados) {
            vm.dados = dados;
            _desenharRota(dados);
            _desenharMarcadores(dados);
        });

        $rootScope.$on('centralizarMapaRastreamento', function (event, dados) {
            _centralizarMapa(vm.dados);
        });

        function _desenharRota(dados) {
            _limparMapa();


            var localizacoes = dados
                .map(function (item) {
                    return {
                        lat: item.coordenadas.latitude,
                        lon: item.coordenadas.longitude
                    }
                });

            tomtom.routing({
                traffic: false
            })
                .locations([localizacoes[0], localizacoes[localizacoes.length - 1]])
                .travelMode("pedestrian")
                .routeRepresentation("polyline")
                .supportingPoints(localizacoes)
                .go()
                .then(function (routeJson) {
                    rotas.push(tomtom.L.geoJson(routeJson, {
                        style: {
                            color: '#00d7ff',
                            opacity: 0.8
                        }
                    }).addTo(mapa));
                }).catch(function (error) {
                    tomtom.messageBox({
                        closeAfter: 3000
                    }).setContent('Um erro ocorreu: ' + error).openOn(mapa);
                });
        }

        function _desenharMarcadores(dados) {

            _centralizarMapa(dados);

            dados.map(function (item) {
                return {
                    marcadorOpcoes: {
                        icon: tomtom.L.icon({
                            iconUrl: _definirIcone(item.tipoLeitura),
                            iconSize: [45, 45],
                            iconAnchor: [15, 34],
                            popupAnchor: [8, -30]
                        }),
                        descricaoEquipe: item.leiturista
                    },
                    textoMarcador: item.textoMarcador,
                    coordenadas: [item.coordenadas.latitude, item.coordenadas.longitude]
                };
            }).forEach(function (item) {
                var marcador = tomtom.L.marker(item.coordenadas, item.marcadorOpcoes)
                    .bindPopup(item.textoMarcador)
                    .addTo(mapa)
                    .on('contextmenu', function (e) {
                        eventoMarcadorTemporario = e;
                        $("#cntnr").css("left", e.containerPoint.x + 10);
                        $("#cntnr").css("top", e.containerPoint.y + 40);
                        $("#cntnr").fadeIn(200, _desmarcarQuandoFocoAusente());
                    });
                marcadores.push(marcador);
            });

        }

        function _limparMapa() {
            if (rotas.length > 0) {
                rotas.forEach(function (rota) {
                    mapa.removeLayer(rota);
                });
            }

            if (marcadores) {
                marcadores.forEach(function (marcador) {
                    mapa.removeLayer(marcador);
                });
                marcadores = [];
            }
        }

        function _definirIcone(tipoLeitura) {
            if (tipoLeitura == 1) {
                return 'assets/icons/mapas/verde.png';
            } else if (tipoLeitura == 2) {
                return 'assets/icons/mapas/laranja.png';
            } else if (tipoLeitura == 3) {
                return 'assets/icons/mapas/vermelho.png';
            } else if (tipoLeitura == 4) {
                return 'assets/icons/mapas/azul-escuro.png';
            } else if (tipoLeitura == 5) {
                return 'assets/icons/mapas/amarelo.png';
            }

            return "";
        }

        function _centralizarMapa(dados) {
            mapa.setView([dados[dados.length - 1].coordenadas.latitude, dados[dados.length - 1].coordenadas.longitude], 16);
        }

        function _desmarcarQuandoFocoAusente() {
            $(document).on("click", function () {
                _limparMarcadorTemporario();
                $("#cntnr").hide();
                $(document).off("click");
            });
        }

        function _limparMarcadorTemporario() {
            eventoMarcadorTemporario = null;
        }

        //#endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .service('RastreamentoLeituristaService', RastreamentoLeituristaService)

    /** @ngInject */
    function RastreamentoLeituristaService($mdSidenav) {

        var service = {
            toggleFiltro: toggleFiltro,
            toggleLegenda: toggleLegenda,
            verificarLegendaAberta: verificarLegendaAberta,
            verificarFiltroAberto: verificarFiltroAberto
        }

        function toggleFiltro() {
            $mdSidenav('filtro-rastreamento-leiturista').toggle();
        }

        function toggleLegenda() {
            $mdSidenav('legenda').toggle();
        }

        function verificarFiltroAberto() {
            return $mdSidenav('filtro-rastreamento-leiturista').isOpen();
        }

        function verificarLegendaAberta() {
            return $mdSidenav('legenda').isOpen();
        }

        return service;

    }

}());
/**
 * Created by nova on 18/07/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service',
      []
    );

})();

(function () {
  'use strict';

  angular
    .module('app.service')
    .service('CancelamentoDinamicoService', CancelamentoDinamicoService)

  /** @ngInject */
  function CancelamentoDinamicoService(RequisicaoGenericaService, Api) {

    var service = {
      gerarSenha: gerarSenha,
    };

    function gerarSenha(dados) {
      return RequisicaoGenericaService.salvar(Api.leitura.cancelamentoDinamico.gerarSenhaCancelamento, dados);
    }

    return service;
  }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .factory('MonitoramentoService', MonitoramentoService);

    /** @ngInject */
    function MonitoramentoService(urlApi, HubService, MonitoramentoMapaService, $mdSidenav, $rootScope, MdToastService, $q) {

        var _parametrosGerenciamentoCarga = null;

        var service = {
            data: {},
            dashboard: {},
            conectarHub: conectarHub,            
            toggleFiltro: toggleFiltro,
            verificarFiltroAberto:verificarFiltroAberto,
            toggleLegenda: toggleLegenda,
            verificarLegendaAberta: verificarLegendaAberta,
            verificarDashboardAberto: verificarDashboardAberto,
            toggleDashboard: toggleDashboard,
            abrirDashboard: abrirDashboard,
            filtrar: filtrar,
            setHabilitarMapa: setHabilitarMapa,
            setParametrosGerenciamentoCarga: setParametrosGerenciamentoCarga,
        };

        function filtrar(filtro) {
            if (filtro && filtro.length > 0) {
                MdToastService.toastInfo("Atualizando informações...");
                HubService.realizarRequisicao("Atualizar", filtro, conectarHub);
            }
        }

        function conectarHub() {
            var deferred = $q.defer();
            var listeners = [];
            listeners.push({ nome: "AtualizarMapa", metodo: _atualizarMapa });
            HubService.conectar(urlApi.url_base_api, "monitoramentoHub", listeners).then(function (success) {
                deferred.resolve(success);
            }).catch(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function _atualizarMapa(dados) {
            service.data = angular.copy(dados);
            if (dados && dados.length > 0) {
                MonitoramentoMapaService.listenerHabilitarMapa = function (callback) {
                    var nenhumaRotaDesenhada = callback();
                    if (nenhumaRotaDesenhada) {
                        MdToastService.toastWarning("Nenhum registro encontrado!");
                    }
                    else {
                        setHabilitarMapa(true);
                    }
                }
                MonitoramentoMapaService.desenharRota(dados);                
                service.listenerEstadoLeiturista(function () { return dados; });
            }
        }

        function toggleFiltro() {
            $mdSidenav("filtro").toggle();
        }

        function verificarFiltroAberto(){
            return $mdSidenav("filtro").isOpen();
        }
        
        function verificarLegendaAberta(){
            return $mdSidenav("legenda").isOpen();
        }

        function verificarDashboardAberto(){
            return $mdSidenav("dashboard").isOpen();
        }
        function toggleDashboard(){
            $mdSidenav("dashboard").toggle();            

        }

        function toggleLegenda(){
            $mdSidenav("legenda").toggle();            
        }

        function abrirDashboard() {
            $mdSidenav("dashboard").toggle();
        }

        function setHabilitarMapa(valor) {
            $rootScope.$broadcast('habilitarMapaMonitoramento', valor);
        }

        function setParametrosGerenciamentoCarga(parametrosGerenciamentoCarga) {
            _parametrosGerenciamentoCarga = parametrosGerenciamentoCarga;
            service.listenerParametrosGerenciamentoCarga(function () { return _parametrosGerenciamentoCarga; });
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .factory('MonitoramentoMapaService', MonitoramentoMapaService);

    /** @ngInject */
    function MonitoramentoMapaService(urlApi, $mdSidenav) {

        var _rotas = [];
        var _mapa = null;
        var _marcadores = [];
        var _dados = [];
        var _eventosMarcadores = [];
        var _centralizado = false;
        var _numeroLeituristas = 0;

        var service = {
            inicializar: inicializar,
            desenharRota: desenharRota,
            limparMapa: limparMapa,
            atualizarDashboard: atualizarDashboard,
            centralizarMapa: centralizarMapa
        };

        function _limparMarcadores() {
            if (_marcadores.length > 0) {
                _marcadores.forEach(function (marcador) {
                    _mapa.removeLayer(marcador.inicio);
                    _mapa.removeLayer(marcador.fim);
                    if(marcador.primeiraLeitura && marcador.primeiraLeitura != null){
                        _mapa.removeLayer(marcador.primeiraLeitura);
                    }
                    if(marcador.ultimaLeitura && marcador.ultimaLeitura != null){
                        _mapa.removeLayer(marcador.ultimaLeitura);
                    }
                });
                _marcadores = [];
            }
        }

        function _recuperarInformacoesDashboard(leituristaCodigo) {
            var resultado = _dados.filter(function (item) {
                return item.leituristaCodigo == leituristaCodigo;
            });

            if (resultado.length > 0) {
                service.listenerAtualizacao(function () {
                    return resultado[0];
                });
            }
        }

        function _definirLeituristaNoMarcador(leituristaCodigo, cor, foto, leituras) {
            var marcadorInicial = {
                icon: tomtom.L.icon({
                    iconUrl: 'assets/icons/mapas/azul.png',
                    iconSize: [45, 45],
                }),
                leiturista: {
                    codigo: leituristaCodigo,
                    foto: foto
                }
            };

            var marcadorFinal = {
                icon: tomtom.L.icon({
                    iconUrl: 'assets/icons/mapas/cinza.png',
                    iconSize: [45, 45]
                }),
                leiturista: {
                    codigo: leituristaCodigo,
                    foto: foto
                }
            };

            var primeiraLeitura = null;
            var ultimaLeitura = null;

            if (leituras.length > 0) {
                primeiraLeitura = _criarObjetoLeitura(leituristaCodigo, foto, leituras[0], 'assets/icons/mapas/azul-escuro.png');
                
                if (leituras.length > 1) {
                    ultimaLeitura = _criarObjetoLeitura(leituristaCodigo, foto, leituras[1], 'assets/icons/mapas/amarelo.png');
                }
            }

            _eventosMarcadores.push({
                marcadorInicial: marcadorInicial,
                marcadorFinal: marcadorFinal,
                primeiraLeitura: primeiraLeitura,
                ultimaLeitura: ultimaLeitura,
                cor: cor
            })
        }

        function _criarObjetoLeitura(leituristaCodigo, foto, leitura, icone){
            var marcadorLeitura = {
                icon: tomtom.L.icon({
                    iconUrl: icone,
                    iconSize: [45, 45],
                }),
                leiturista: {
                    codigo: leituristaCodigo,
                    foto: foto
                },
                data: leitura.data,
                coordenadas: [leitura.coordenadas.latitude, leitura.coordenadas.longitude] 
            };

            return marcadorLeitura;
        }

        function _adicionarMarcadores(feature) {
            var startPoint, endPoint;
            if (feature.geometry.type === 'MultiLineString') {
                startPoint = feature.geometry.coordinates[0][0].reverse();
                endPoint = feature.geometry.coordinates.slice(-1)[0].slice(-1)[0].reverse();
            } else {
                startPoint = feature.geometry.coordinates[0].reverse();
                endPoint = feature.geometry.coordinates.slice(-1)[0].reverse();
            }

            var marcador = {};

            var eventoMarcador = angular.copy(_eventosMarcadores[0]);
            _eventosMarcadores.splice(0, 1);
            marcador.leiturista = angular.copy(eventoMarcador.marcadorInicial.leiturista.codigo);

            marcador.inicio = tomtom.L.marker(startPoint, eventoMarcador.marcadorInicial)
                .on('click', function (e) {
                    //_atualizarDashboard(e);
                    _abrirPopupMapa(e.latlng, e.target.options.leiturista.foto);
                })
                .addTo(_mapa);

            marcador.fim = tomtom.L.marker(endPoint, eventoMarcador.marcadorFinal)
                .on('click', function (e) {
                    //_atualizarDashboard(e);
                    _abrirPopupMapa(e.latlng, e.target.options.leiturista.foto);
                })
                .on('mouseover', function (e) {
                    _abrirPopupMapa(e.latlng, e.target.options.leiturista.foto);
                })
                .addTo(_mapa);

            _abrirPopupMapa(endPoint, eventoMarcador.marcadorFinal.leiturista.foto);

            if(eventoMarcador.primeiraLeitura && eventoMarcador.primeiraLeitura != null){
                marcador.primeiraLeitura = tomtom.L.marker(eventoMarcador.primeiraLeitura.coordenadas, eventoMarcador.primeiraLeitura)
                .on('click', function (e) {
                    _abrirPopupMapa(e.latlng, e.target.options.leiturista.foto);
                })
                .on('mouseover', function (e) {
                    _abrirPopupMapa(e.latlng, e.target.options.data);
                })
                .addTo(_mapa);
            }

            if(eventoMarcador.ultimaLeitura && eventoMarcador.ultimaLeitura != null){
                marcador.ultimaLeitura = tomtom.L.marker(eventoMarcador.ultimaLeitura.coordenadas, eventoMarcador.ultimaLeitura)
                .on('click', function (e) {
                    _abrirPopupMapa(e.latlng, e.target.options.leiturista.foto);
                })
                .on('mouseover', function (e) {
                    _abrirPopupMapa(e.latlng, e.target.options.data);
                })
                .addTo(_mapa);
            }
            
            _centralizarMapa(endPoint);

            _marcadores.push(marcador);
        }

        function _atualizarDashboard(e) {
            if (e.target.options.leiturista) {
                _recuperarInformacoesDashboard(e.target.options.leiturista.codigo);
                _verificaSidenavsAbertos();
                $mdSidenav("dashboard").toggle();
            }
        }

        function _abrirPopupMapa(coordenada, conteudo) {
            tomtom.L.popup()
                .setLatLng(coordenada)
                .setContent(conteudo)
                .openOn(_mapa);
        }

        function _centralizarMapa(ultimaCoordenada){
            if(_centralizado == false){
                if(_dados.length == 1){
                    _mapa.setView([ultimaCoordenada[0],ultimaCoordenada[1]], 20);
                }
                else{
                    _mapa.setView([ultimaCoordenada[0],ultimaCoordenada[1]], 15);
                }
                _centralizado = true;
            }
            else{
                var currentCenterOfMap = _mapa.getCenter();
                _mapa.setView([currentCenterOfMap.lat,currentCenterOfMap.lng], _mapa._zoom);
            }
        }

        function _atualizarNumeroLeituristas(){
            if(_numeroLeituristas != _dados.length){
                _numeroLeituristas = _dados.length;
                _centralizado = false;
            }
        }

        function limparMapa() {
            if (_rotas.length > 0) {
                _rotas.forEach(function (rota) {
                    _mapa.removeLayer(rota);
                });
                _rotas = []
            }

            if (_marcadores) {
                _limparMarcadores();
            }

            _eventosMarcadores = [];
        }

        function desenharRota(dados) {
            var nenhumaRotaDesenhada = true;
            limparMapa();

            _dados = angular.copy(dados);
            _atualizarNumeroLeituristas();

            if($mdSidenav("dashboard").isOpen()){
                $mdSidenav("dashboard").toggle();
            }

            for (var i = 0; i < dados.length; i++) {
                if (dados[i].coordenadas.length > 0) {
                    nenhumaRotaDesenhada = false;
                    var coordenadas = "";
                    var localizacoes = dados[i].coordenadas
                        .map(function (item) {
                            if (coordenadas == "") {
                                coordenadas = '' + item.latitude + ',' + item.longitude;
                            }
                            else {
                                coordenadas = '' + coordenadas + ':' + item.latitude + ',' + item.longitude;
                            }
                            return { lat: item.latitude, lon: item.longitude }
                        });

                    var codigoLeiturista = angular.copy(dados[i].leituristaCodigo);
                    _definirLeituristaNoMarcador(codigoLeiturista, dados[i].cor, dados[i].marcadorFotoMapa, dados[i].informacoes.detalheLeituras);

                    tomtom.routing({ traffic: false })
                        .locations([localizacoes[0], localizacoes[localizacoes.length - 1]])
                        .travelMode("pedestrian")
                        .supportingPoints(localizacoes)
                        .routeRepresentation('polyline')
                        .computeBestOrder(false)
                        .go()
                        .then(function (routeJson) {
                            var route = tomtom.L.geoJson(routeJson, {
                                onEachFeature: _adicionarMarcadores,
                                style: { color: _eventosMarcadores[0].cor, opacity: 0.8 }
                            }).addTo(_mapa);
                            _rotas.push(route);
                        });
                }
            }

            service.listenerHabilitarMapa(function(){ return nenhumaRotaDesenhada;});
        }

        function atualizarDashboard(leituristaCodigo) {
            _recuperarInformacoesDashboard(leituristaCodigo);
            $mdSidenav("dashboard").toggle();
        }

        function inicializar() {
            // Criar e definir chave do mapa padrão
            tomtom.key(urlApi.chave_api_maps_tomtom);
            tomtom.routingKey(urlApi.chave_api_maps_tomtom);
            _mapa = tomtom.map('mapa', {
                source: 'vector',
                center: [-23.5489, -46.6388],
                zoom: 5,
                basePath: urlApi.url_api_maps_tomtom
            });
            _mapa.zoomControl.setPosition('topright');

            _centralizado = false;
            _numeroLeituristas = false;
        }

        function centralizarMapa(){
            if(!_marcadores.length) return;
            
            if(_marcadores.length == 1){
                var latLngAtual = _marcadores[0].fim._latlng;
                _mapa.setView([latLngAtual.lat, latLngAtual.lng], 20);
            } else {
                var coordenadas = _marcadores.map(function (item) {
                    return item.fim._latlng;
                });
                var obj = _definirDadosDeCoordenadas(coordenadas);
                var zoom = _definirZoom(obj.distancia);
                _mapa.fitBounds(obj.coordenadas, {maxZoom: zoom});                
            }
        }
        
        function _definirDadosDeCoordenadas(coordenadas){     
            if(!coordenadas.length) return;
            

            coordenadas.sort(function(a,b){
                if(a.lat < b.lat)
                    return 1;
                if(a.lat > b.lat)
                    return -1;
                return 0;
            });

            var distancia = _mapa.distance(coordenadas[0], coordenadas[coordenadas.length - 1 ]);

            return {
                distancia: distancia,
                coordenadas: [coordenadas[0], coordenadas[coordenadas.length - 1 ]]
            };
        }
        
        function _definirZoom(distancia){
            if(distancia < 1000)
                return 17;
            if( distancia > 1000 && distancia < 3000 )
                return 16;
            if(distancia > 3000 && distancia < 5000)
                return 15;
            if(distancia > 5000 && distancia < 8000)
                return 13;
            if(distancia > 8000)
                return 12;            
        }

        function _verificaSidenavsAbertos(){
            if($mdSidenav("filtro").isOpen())
                $mdSidenav("filtro").toggle();
            if($mdSidenav("legenda").isOpen())
                $mdSidenav("legenda").toggle();
        }
        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.monitoramento')
        .controller('MonitoramentoMapaController', MonitoramentoMapaController);

    /** @ngInject */
    function MonitoramentoMapaController(MonitoramentoMapaService) {
        var vm = this;

        init();

        function init(){
            MonitoramentoMapaService.inicializar();
        }

        //#region 

        //#endregion                       

        //#region Métodos Internos

        //#endregion
    }

})();
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica')
        .service('CriticaLeituraService', CriticaLeituraService)

    /** @ngInject */
    function CriticaLeituraService(Api, RequisicaoGenericaService){

        var service = {
            ordenarArrayUsandoOrdenacaoDatatable: ordenarArrayUsandoOrdenacaoDatatable,
            buscarDadosOcorrenciaCritica: buscarDadosOcorrenciaCritica,
            buscarUltimoHistoricoCritica: buscarUltimoHistoricoCritica,
            buscarFotosPorVisita: buscarFotosPorVisita,
        };

        function ordenarArrayUsandoOrdenacaoDatatable(array, campoOrdenacao, tipoOrdenacao){

            switch (campoOrdenacao) {
                case 1:
                  array = _ordenarArrayInteiro(array, tipoOrdenacao, 'codigoCliente');
                  break;
                case 2:
                  array = _ordenarArray(array, tipoOrdenacao, 'localizacao');
                  break;
                case 3:
                  array = _ordenarArrayComDuasPropriedades('dataHoraColeta', 'localizacao', array, tipoOrdenacao);
                  break;
                case 6:
                  array = _ordenarArrayComDuasPropriedades('ocorrencia', 'localizacao', array, tipoOrdenacao);
                  break;
                default:
                  break;        
              }

              return array;
        }

        function _ordenarArray(array, tipoOrdenacao, campo){
            if(tipoOrdenacao === 'asc'){
                return array.sort(function(a,b){
                    if(a[campo] > b[campo] ){
                        return 1;
                    }
                    if(a[campo] < b[campo]){
                        return -1
                    }
                    return 0;                        
                });
            }
            else {
                return array.sort(function(a,b){
                    if(a[campo] < b[campo] ){
                        return 1;
                    }
                    if(a[campo] > b[campo]){
                        return -1
                    }
                    return 0;                        
                });
            }
        }

        function _ordenarArrayInteiro(array, tipoOrdenacao, campo){
            if(tipoOrdenacao === 'asc'){
                return array.sort(function(a,b){
                    if(parseInt(a[campo], 10) > parseInt(b[campo], 10) ){
                        return 1;
                    }
                    if(parseInt(a[campo], 10) < parseInt(b[campo], 10)){
                        return -1
                    }
                    return 0;                        
                });
            }
            else {
                return array.sort(function(a,b){
                    if(parseInt(a[campo], 10) < parseInt(b[campo], 10) ){
                        return 1;
                    }
                    if(parseInt(a[campo], 10) > parseInt(b[campo], 10)){
                        return -1
                    }
                    return 0;                        
                });
            }
        }

        function _ordenarArrayComDuasPropriedades(campoA, campoB, array, tipoOrdenacao){
            if(tipoOrdenacao === 'asc'){
                return array.sort(function(a,b){
                    if(a[campoA] === b[campoA]){
                        return a[campoB] > b[campoB] ? 1 : -1;
                    }
                    else{
                        return a[campoA] > b[campoA] ? 1 : -1;
                    }
                });
            }
            else {
                return array.sort(function(a,b){                    
                    if(a[campoA] === b[campoA]){
                        return a[campoB] < b[campoB] ? 1 : -1;
                    }
                    else{
                        return a[campoA] < b[campoA] ? 1 : -1;
                    }
                });
            }
        }

        function buscarDadosOcorrenciaCritica(viewModel){
            return RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarDadosOcorrenciaCritica, viewModel);
        }

        function buscarUltimoHistoricoCritica(codigoCliente, nomeArquivoExportacao){
            return RequisicaoGenericaService.listarSemParams(Api.criticaLeituras.retornaUltimoHistoricoCritica + '/' + codigoCliente + '/' + nomeArquivoExportacao);
        }

        function buscarFotosPorVisita(codigoCliente, gleiCodigo, numeroVisita){
            return RequisicaoGenericaService
                    .listarSemParams(Api.criticaLeituras.buscarListaFotosVisita + '/' + codigoCliente + '/' + gleiCodigo + '/' + numeroVisita);
        }
        
        return service;
    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.execucao')
        .factory('CriticaLeiturasFactory', CriticaLeiturasFactory)

    /** @ngInject */
    function CriticaLeiturasFactory($rootScope, $mdSidenav){

        var data = new Date();    
        
        var _filtro = {};

        function atualizarLeiturasComRetencao(leituras){
            $rootScope.$broadcast("dadosLeiturasRetidas", leituras);
        }

        function construirFiltro(){
            return {
                mes: data.getMonth() + 1,
                ano: data.getFullYear(),
                grupo: undefined,
                pendentes: true,
                leituristas: []                
            }
        }

        function setFiltro(filtro){
            _filtro = angular.copy(filtro);
        }

        function getFiltro(){
            var filtroCopy = angular.copy(_filtro);
            return filtroCopy;
        }

        function toggleSidenavFiltro(){            
            $mdSidenav('filtro-critica-leituras').toggle();            
        }

        function toggleSidenavExecucao(){
            $mdSidenav('execucao-critica-leituras').toggle();
        }

        function atualizarGruposNoFiltro(){
            $rootScope.$broadcast("AtualizarFiltroCriticasLeitura", true);
        }
        
        return {            
            atualizarLeiturasComRetencao: atualizarLeiturasComRetencao,
            construirFiltro: construirFiltro,
            toggleSidenavFiltro: toggleSidenavFiltro,
            toggleSidenavExecucao: toggleSidenavExecucao,
            setFiltro:setFiltro,
            getFiltro:getFiltro,
            atualizarGruposNoFiltro: atualizarGruposNoFiltro
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta')
        .factory('ConsultaCriticaFactory', ConsultaCriticaFactory)

    /** @ngInject */
    function ConsultaCriticaFactory($rootScope, $mdSidenav, RequisicaoGenericaService, Api){

        var data = new Date();    
        
        var _filtro = {};

        function atualizarConsultaCritica(criticas){
            $rootScope.$broadcast("dadosConsultaCritica", criticas);
        }

        function construirFiltro(){
            return {
                mes: data.getMonth() + 1,
                ano: data.getFullYear(),
                grupo: undefined,
                leituristas: []
            }
        }

        function setFiltro(filtro){
            _filtro = angular.copy(filtro);
        }

        function getFiltro(){
            var filtroCopy = angular.copy(_filtro);
            return filtroCopy;
        }

        function toggleSidenavFiltro(){            
            $mdSidenav('filtro-consulta-critica').toggle();            
        }

        
        return {            
            atualizarConsultaCritica: atualizarConsultaCritica,
            construirFiltro: construirFiltro,
            toggleSidenavFiltro: toggleSidenavFiltro,
            setFiltro:setFiltro,
            getFiltro:getFiltro,            
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.critica.acompanhamento')
        .service('AcompanhamentoCriticaService', AcompanhamentoCriticaService)

    /** @ngInject */
    function AcompanhamentoCriticaService($mdSidenav, RequisicaoGenericaService, Api) {

        var _filtro = {};
        var _filtroAgrupamento = {};
        var _filtroMunicipio = {};

        var service = {
            toggleFiltroSidenav: toggleFiltroSidenav,
            construirFiltroAcompanhamento: construirFiltroAcompanhamento,
            configurarMdSelect: configurarMdSelect,
            buscarDadosAcompanhamentoCriticas: buscarDadosAcompanhamentoCriticas,
            getFiltroAcompanhamento: getFiltroAcompanhamento,
            setFiltroAcompanhamento: setFiltroAcompanhamento,
            getAgrupamentoFiltrado: getAgrupamentoFiltrado,
            setAgrupamentoFiltrado: setAgrupamentoFiltrado,
            getMunicipioFiltrado: getMunicipioFiltrado,
            setMunicipioFiltrado: setMunicipioFiltrado
        };

        function toggleFiltroSidenav() {
            $mdSidenav('filtro-acompanhamento-criticas').toggle();
        }

        function construirFiltroAcompanhamento() {
            var data = new Date();
            return {
                mes: data.getMonth() + 1,
                ano: data.getFullYear(),
                grupo: undefined,
                usuarios: []
            }
        }

        function getFiltroAcompanhamento() {
            return angular.copy(_filtro);
        }

        function setFiltroAcompanhamento(filtro) {
            _filtro = angular.copy(filtro);
        }

        function getAgrupamentoFiltrado() {
            return angular.copy(_filtroAgrupamento);
        }

        function setAgrupamentoFiltrado(filtroAgrupamento) {
            _filtroAgrupamento = angular.copy(filtroAgrupamento);
        }

        function getMunicipioFiltrado() {
            return angular.copy(_filtroMunicipio);
        }

        function setMunicipioFiltrado(filtroMunicipio) {
            _filtroMunicipio = angular.copy(filtroMunicipio);
        }

        function configurarMdSelect(elemento) {
            angular.element(elemento).on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function buscarDadosAcompanhamentoCriticas(filtro) {
            return RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarDadosAcompanhamentoCriticas, filtro);
        }

        return service;
    }

}());
(function () {
    'use strict';
    angular
        .module('app.controlecarga.faturasretidas', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.controleCarga.faturasretidas;
        $stateProvider.state('app.controlecarga_faturasretidas', {
            url: '/controlecarga/faturasretidas',
            module: 'privado',
            views: {
                'content@app': {
                    templateUrl: rotasHtml.templateUrl,
                    controller: 'ControleCargaFaturasRetidasController as vm'
                },
                'controle-carga-faturas-retidas-form@app.controlecarga_faturasretidas': {
                    templateUrl: rotasHtml.form
                },
                'sidenav-faturas-retidas@app.controlecarga_faturasretidas': {
                    templateUrl: rotasHtml.sidenav.filtro,
                    controller: 'SidenavFaturasRetidasController as vm'
                }
            },
            resolve: {
                ListarClientesRetidos: function (RequisicaoGenericaService, Api) {
                    return RequisicaoGenericaService.listarSemParams(Api.faturasRetidas.listarLigacoesRetidas);
                },

            }
        });
    }
}());
(function () {
    'use strict';
    angular
        .module('app.controlecarga.faturasretidas')
        .directive('tabelaDependentes', tabelaDependentes);

    function tabelaDependentes() {
        return {
            restrict: 'E',
            scope: {
                dependentes: '='
            },
            controller: 'TabelaDependentesController',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'app/main/controlecarga/faturas-retidas/components/tabela-dependentes/views/tabela-dependentes.html'
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.controlecarga.faturasretidas')
        .controller('TabelaDependentesController', TabelaDependentesController);

    /** @ngInject */
    function TabelaDependentesController($scope) {
        var vm = this;
        vm.dependentes = vm.dependentes || [];
    }
})();
(function () {
    'use strict';
    angular
        .module('app.controlecarga.faturasretidas')
        .controller('SidenavFaturasRetidasController', SidenavFaturasRetidasController)

    /** @ngInject */
    function SidenavFaturasRetidasController(
        ControleCargaFaturasRetidasService,
        ListarClientesRetidos
    ) {
        var vm = this;
        vm.listaClientesRetidos = ListarClientesRetidos.data;

        vm.filtro = {
            tipoFiltro: 1,
            mesReferencia: null,
            anoReferencia: null,
            mesReferenciaInicial: null,
            anoReferenciaInicial: null,
            mesReferenciaFinal: null,
            anoReferenciaFinal: null,
            tipoParametro: 1,
            codigoCliente: null,
            clienteSelecionado: null
        };
        vm.emProgresso = false;
        init();

        vm.metodos = {
            onChangeTipoFiltro: onChangeTipoFiltro,
            onChangeReferenciaPeriodo: onChangeReferenciaPeriodo,
            onChangeTipoParametro: onChangeTipoParametro,
            filtrar: filtrar,
            pesquisarAutoCompleteClienteVinculado: pesquisarAutoCompleteClienteVinculado,
            alterarItemSelecionadoAutoCompleteCliente: alterarItemSelecionadoAutoCompleteCliente,
            configuraAutoCompleteClienteOnBlur: configuraAutoCompleteClienteOnBlur
        };

        function init() {
            vm.emProgresso = ControleCargaFaturasRetidasService.getEmProgresso();
            ControleCargaFaturasRetidasService.onProgressoChanged(function (emProgresso) {
                vm.emProgresso = emProgresso;
            });
        }

        function onChangeTipoFiltro(filtro) {
            switch (filtro.tipoFiltro) {
                case 1:
                    filtro.mesReferenciaInicial = null;
                    filtro.anoReferenciaInicial = null;
                    filtro.mesReferenciaFinal = null;
                    filtro.anoReferenciaFinal = null;

                    break;
                case 2:
                    filtro.mesReferencia = null;
                    filtro.anoReferencia = null;
                    break;
            }
            vm.erroReferenciaInicial = false;
            vm.erroReferenciaFinal = false;
        }

        function onChangeReferenciaPeriodo() {
            vm.erroReferenciaInicial = false;
            vm.erroReferenciaFinal = false;

            if (!vm.filtro.mesReferenciaInicial || !vm.filtro.anoReferenciaInicial ||
                !vm.filtro.mesReferenciaFinal || !vm.filtro.anoReferenciaFinal) {
                return;
            }

            var mesInicial = parseInt(vm.filtro.mesReferenciaInicial);
            var anoInicial = parseInt(vm.filtro.anoReferenciaInicial);
            var mesFinal = parseInt(vm.filtro.mesReferenciaFinal);
            var anoFinal = parseInt(vm.filtro.anoReferenciaFinal);

            var dataInicial = new Date(anoInicial, mesInicial - 1, 1);
            var dataFinal = new Date(anoFinal, mesFinal - 1, 1);

            if (dataInicial > dataFinal) {
                vm.erroReferenciaInicial = true;
            }

            if (dataFinal < dataInicial) {
                vm.erroReferenciaFinal = true;
            }
        }

        function onChangeTipoParametro(filtro) {
            switch (filtro.tipoParametro) {
                case 1:
                    filtro.clienteCodigo = null;
                    vm.filtro.clienteSelecionado = null;
                    break;
            }
        }

        function filtrar(filtro) {
            vm.emProgresso = true;
            ControleCargaFaturasRetidasService.filtrar(filtro);
        }

        function pesquisarAutoCompleteClienteVinculado(query) {
            if (!query) return vm.listaClientesRetidos;
            query = query.toString().toLowerCase();
            return vm.listaClientesRetidos.filter(function (item) {
                return (
                    item.codigo.toString().toLowerCase().includes(query) ||
                    (item.nome && item.nome.toLowerCase().includes(query))
                );
            });
        }

        function alterarItemSelecionadoAutoCompleteCliente(item) {
            if (item) {
                vm.filtro.codigoCliente = item.codigo;
                vm.filtro.clienteSelecionado = item;
            } else {
                vm.textoDePesquisaAutoCompleteCliente = "";
                vm.filtro.codigoCliente = null;
                vm.filtro.clienteSelecionado = null;
            }
        }

        function configuraAutoCompleteClienteOnBlur() {
            if (!vm.filtro.codigoCliente) {
                vm.textoDePesquisaAutoCompleteCliente = "";
            }
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.controlecarga.trocarsequencial', [])
        .config(Config);


        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.controleCarga.trocarSequencial;
            $stateProvider.state('app.controlecarga_trocarsequencial', {
                url: '/controlecarga/trocarsequencial',
                module: 'privado',
                views: {
                    'content@app':{
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TrocarSequencialController as vm' 
                    },
                    'trocarsequencial-form@app.controlecarga_trocarsequencial': {
                        templateUrl: rotasHtml.form
                    },
                    'filtro-trocarsequencial-sidenav@app.controlecaraga_trocarsequencial': {
                        templateUrl: rotasHtml.sidenav.filtro,
                        controller: 'FiltroTrocarSequencialController as vm'
                    }
                },
                resolve: {
                    ListarLeituristas: function(Api, RequisicaoGenericaService){
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                    },
                }
            });
        }

}());
(function () {
    'use strict';

    angular
        .module('app.controlecarga.trocarsequencial')
        .controller('FiltroTrocarSequencialController', FiltroTrocarSequencialController)

    /** @ngInject */
    function FiltroTrocarSequencialController(SessionStorageService, KeysSessionStorage, TrocarSequencialService, ListarLeituristas, MdDialogService) {
        var vm = this;

        init();

        vm.metodos = {
            changeAgrupamento: changeAgrupamento,
            changeReferencia: changeReferencia,
            configuraMdSelectLeiturista: configuraMdSelectLeiturista,
            configuraMdSelectAgrupamento: configuraMdSelectAgrupamento,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            buscarDadosTarefa: buscarDadosTarefa
        }

        function init() {
            vm.filtro = TrocarSequencialService.construirFiltroTrocaSequencial();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if (vm.parametros.utilizaCadastroRegional) {
                _pesquisarAgrupamentos();
            } else {
                _pesquisarLeituristas();
            }
        }

        function changeAgrupamento() {
            _pesquisarLeituristas();
        }

        function changeReferencia() {
            _pesquisarGrupos(vm.filtro.agrupamento, vm.filtro.mes, vm.filtro.ano);
        }

        function configuraMdSelectLeiturista() {
            vm.filtrarLeiturista = "";
            angular.element('#select-leiturista').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function configuraMdSelectAgrupamento() {
            vm.filtrarAgrupamento = "";
            angular.element('#select-agrupamento').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function configuraMdSelectGrupo() {
            vm.filtrarAgrupamento = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _pesquisarAgrupamentos() {
            vm.filtro.agrupamento = undefined;
            vm.agrupamentos = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
        }

        function _pesquisarLeituristas() {
            if (vm.filtro.agrupamento) {
                vm.leituristas = _filtrarLeituristasPorAgrupamento(vm.filtro.agrupamento, ListarLeituristas.data);
                return;
            }
            vm.leituristas = ListarLeituristas.data;
        }

        function _pesquisarGrupos(agrupamento, mes, ano) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            var pGrupos = TrocarSequencialService.buscarGrupos(agrupamento, mes, ano);
            pGrupos.then(
                function (success) {
                    vm.emProgressoBuscaGrupo = false;
                    vm.grupos = success.data;
                },
                function (error) {
                    vm.emProgressoBuscaGrupo = false;
                }
            )
        }

        function _filtrarLeituristasPorAgrupamento(agrupamento, leituristas) {
            return leituristas.filter(function (leiturista) {
                return leiturista.agrupamentoId === agrupamento;
            });
        }

        function buscarDadosTarefa(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');
            TrocarSequencialService.setFiltroTrocaSequencial(filtro);
            _setarProgresso(true);

            if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                var pBuscarDadosMultiploGrupos = TrocarSequencialService.buscarDadosTarefasMultiplosGrupos(filtro);

                pBuscarDadosMultiploGrupos.then(function (success) {
                    TrocarSequencialService.listenerDadosTarefas(function () { return success.data });
                    TrocarSequencialService.toggleFiltro();
                }, function (error) {
                    var objeto = undefined;
                    MdDialogService.alertPadrao(error.data);
                    TrocarSequencialService.listenerDadosTarefas(function () { return objeto });
                }).finally(function () { _setarProgresso(false) });
            } else {
                var pBuscarDados = TrocarSequencialService.buscarTarefasLeiturista(filtro);

                pBuscarDados.then(function (success) {
                    TrocarSequencialService.listenerDadosTarefas(function () { return success.data });
                    TrocarSequencialService.toggleFiltro();
                }, function (error) {
                    var objeto = undefined;
                    MdDialogService.alertPadrao(error.data);
                    TrocarSequencialService.listenerDadosTarefas(function () { return objeto });
                }).finally(function () { _setarProgresso(false) });
            }
        }

        function _setarProgresso(progresso) {
            vm.emProgresso = progresso;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.controlecarga.trocarsequencial')
        .controller('DialogAlterarSequencialController', DialogAlterarSequencialController)

    /** @ngInject */
    function DialogAlterarSequencialController($mdDialog, Sequencial){
        var vm = this;
        
        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            retornarSequencialTarefa: retornarSequencialTarefa
        }

        function init(){
            vm.sequencial = Sequencial;
        }

        function fecharDialog(){
            $mdDialog.cancel();
        }


        function retornarSequencialTarefa(){
            if(_verificarSequencial())
                $mdDialog.hide(vm.sequencial);
        }

        function _verificarSequencial(){
            return vm.sequencial && vm.sequencial > 0;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.controlecarga.trocarleiturista', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.controleCarga.trocarLeiturista;
            $stateProvider.state('app.controlecarga_trocarleiturista', {
                 url: '/controlecarga/trocarleiturista',
                 module: 'privado',
                 views: {
                     'content@app': {
                         templateUrl: rotasHtml.templateUrl,
                         controller: 'TrocarLeituristaController as vm'
                     },
                     'trocarleiturista-form@app.controlecarga_trocarleiturista': {
                         templateUrl: rotasHtml.form
                     },
                     'filtro-trocarleiturista-sidenav@app.controlecarga_trocarleiturista': {
                         templateUrl: rotasHtml.sidenav.filtro,
                         controller: 'FiltroTrocarLeituristaController as vm'
                     }
                 },
                 resolve: {
                     ListarLeituristas: function(RequisicaoGenericaService, Api){
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
                     },
                     Parametro: function(){ return null}
                 }
            });
        }

}());
(function () {
    'use strict';

    angular
        .module('app.controlecarga.trocarleiturista')
        .controller('FiltroTrocarLeituristaController', FiltroTrocarLeituristaController)

    /** @ngInject */
    function FiltroTrocarLeituristaController(ListarLeituristas, TrocarLeituristaService, SessionStorageService, KeysSessionStorage, MdDialogService) {
        var vm = this;

        init();

        vm.metodos = {
            changeAgrupamento: changeAgrupamento,
            changeReferencia: changeReferencia,
            changeGrupo: changeGrupo,
            configuraMdSelectAgrupamento: configuraMdSelectAgrupamento,
            configuraMdSelectTarefa: configuraMdSelectTarefa,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            filtrarDadosTarefaTroca: filtrarDadosTarefaTroca
        }

        function init() {
            vm.filtro = TrocarLeituristaService.construirFiltroTrocaLeiturista();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if (vm.parametros.utilizaCadastroRegional) {
                _pesquisarAgrupamentos();
            }
        }

        function changeAgrupamento(agrupamento, mes, ano) {
            _pesquisarGrupos(agrupamento, mes, ano);
            _pesquisarLeituristas();
        }

        function changeReferencia(agrupamento, mes, ano) {
            _pesquisarGrupos(agrupamento, mes, ano);
        }

        function changeGrupo(agrupamento, mes, ano, grupo) {
            _pesquisarTarefas(agrupamento, mes, ano, grupo);
        }

        function configuraMdSelectTarefa() {
            vm.filtrartarefa = "";
            angular.element('#select-tarefa').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function configuraMdSelectAgrupamento() {
            vm.filtrarAgrupamento = "";
            angular.element('#select-agrupamento').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }
        function configuraMdSelectGrupo() {
            vm.filtrarGrupo = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _pesquisarAgrupamentos() {
            vm.filtro.agrupamento = undefined;
            vm.agrupamentos = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
        }

        function _pesquisarLeituristas() {
            if (vm.filtro.agrupamento) {
                vm.leituristas = _filtrarLeituristasPorAgrupamento(vm.filtro.agrupamento, ListarLeituristas.data);
                return;
            }
            vm.leituristas = ListarLeituristas.data;
        }

        function _filtrarLeituristasPorAgrupamento(agrupamento, leituristas) {
            return leituristas.filter(function (leiturista) {
                return leiturista.agrupamentoId === agrupamento;
            });
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _pesquisarGrupos(agrupamento, mes, ano) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.grupo = undefined;
            vm.municipios = [];
            vm.emProgressoBuscaGrupo = true;
            var pGrupos = TrocarLeituristaService.buscarGrupos(agrupamento, mes, ano);
            pGrupos
                .then(function (success) { vm.grupos = success.data; })
                .finally(function () { vm.emProgressoBuscaGrupo = false; })
        }

        function _pesquisarTarefas(agrupamento, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            vm.filtro.tarefa = undefined;
            vm.tarefas = [];
            vm.emProgressoTarefa = true;
            var pTarefas = TrocarLeituristaService.buscarTarefas(agrupamento, mes, ano, grupo);
            pTarefas
                .then(function (success) { vm.tarefas = success.data })
                .finally(function () { vm.emProgressoTarefa = false })
        }

        function filtrarDadosTarefaTroca(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');

            var viewModel = {
                agrupamento: filtro.agrupamento,
                mes: filtro.mes,
                ano: filtro.ano,
                grupo: filtro.grupo,
                tarefa: filtro.tarefa
            }
            TrocarLeituristaService.setFiltro(filtro);
            _iniciarProgresso();

            if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                var pTarefas = TrocarLeituristaService.filtrarDadosTrocaMultiplosGrupos(viewModel);

                pTarefas.then(function (success) {
                    var object = {
                        tarefa: success.data,
                        leituristas: vm.leituristas
                    }

                    TrocarLeituristaService.listenerTarefa(function () { return object });

                    filtro.tarefa = undefined;
                    TrocarLeituristaService.toggleFiltroTrocarLeiturista();

                }, function (err) {
                    var mensagem = err.data.split(". ");
                    MdDialogService.alertPadrao(mensagem[0], event, mensagem[1]);
                })
                    .finally(function () { _finalizarProgresso() });

            } else {
                var pTarefa = TrocarLeituristaService.filtrarDadosTarefaTroca(viewModel);
                pTarefa.then(function (success) {
                    var object = {
                        tarefa: [success.data],
                        leituristas: vm.leituristas
                    }
                    TrocarLeituristaService.listenerTarefa(function () { return object });
                    filtro.tarefa = undefined;
                    TrocarLeituristaService.toggleFiltroTrocarLeiturista();

                }, function (err) {
                    var mensagem = err.data.split(". ");
                    MdDialogService.alertPadrao(mensagem[0], event, mensagem[1]);
                }).finally(function () { _finalizarProgresso() })
            }
        }
    }

}());
(function () {
  'use strict';

  angular
    .module('app.controlecarga.cancelarcarga', [])
    .config(Config);

  function Config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.controleCarga.cancelarcarga;
    $stateProvider.state('app.controlecarga_cancelamentocarga', {
      url: '/controlecarga/cancelarcarga',
      module: 'privado',
      views: {
        'content@app': {
          templateUrl: rotasHtml.templateUrl,
          controller: 'CancelarCargaController as vm'
        },
        'cancelar-carga-form@app.controlecarga_cancelamentocarga': {
          templateUrl: rotasHtml.form
        },
        'filtro-cancelarcarga-sidenav@app.controlecarga_cancelamentocarga': {
          templateUrl: rotasHtml.sidenav.filtro,
          controller: 'FiltroCancelarCargaController as vm'
        }
      },
      resolve: {
        ListarParametros: function (RequisicaoGenericaService, Api) {
          return RequisicaoGenericaService.listarSemParams(Api.parametros.dadosParametro);
        },
        ListarLeituristas: function (RequisicaoGenericaService, Api, ListarParametros) {
          var tipoProcesso = ListarParametros.data.tipoProcesso;
          if (tipoProcesso === '01') {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
          } else {
            return;
          }
        },
      }
    });
  }

}());
(function () {
    'use strict';

    angular
        .module('app.controlecarga.cancelarcarga')
        .controller('FiltroCancelarCargaController', FiltroCancelarCargaController)

    /** @ngInject */
    function FiltroCancelarCargaController(
        CancelarCargaService,
        ListarLeituristas,
        MdDialogService,
        ListarParametros,
        Api,
        RequisicaoGenericaService
    ) {
        var vm = this;
        vm.tipoProcesso = ListarParametros.data.tipoProcesso;

        vm.status = [
            { codigo: 0, descricao: "Todos" },
            { codigo: 1, descricao: "Disponível" },
            { codigo: 2, descricao: "Em execução" },
            { codigo: 3, descricao: "Finalizado" }
        ];

        init();

        vm.metodos = {
            configuraMdSelectLeiturista: configuraMdSelectLeiturista,
            configuraMdSelectStatus: configuraMdSelectStatus,
            filtrarDadosCancelamento: filtrarDadosCancelamento,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            changeReferencia: changeReferencia
        }

        function init() {
            vm.filtro = CancelarCargaService.construirFiltroCancelarCarga();
            if (vm.tipoProcesso == '01') {
                vm.leituristas = ListarLeituristas.data;
            } else if (vm.tipoProcesso == '02') {
                _listarGrupoComReferencia(vm.filtro.mes, vm.filtro.ano);
            }
        }

        function changeReferencia(mes, ano) {
            if (vm.tipoProcesso === '02') {
                vm.filtro.grupo = null;
                _listarGrupoComReferencia(mes, ano);
                return
            }
        }

        function _listarGrupoComReferencia(mes, ano) {
            vm.grupos = [];
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposRegionalCancelamento +
                '?regional=' + '' + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.grupos = success.data;
                    }
                )
        }

        function _iniciarProgresso(mensagem) {
            vm.emProgresso = true;
            vm.mensagem = mensagem;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function configuraMdSelectLeiturista() {
            vm.filtrarLeiturista = "";
            angular.element('#select-leiturista').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectStatus() {
            vm.filtrarStatus = "";
            angular.element('#select-status').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function filtrarDadosCancelamento(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');

            var viewModel = {
                mes: filtro.mes,
                ano: filtro.ano,
            }

            if (vm.tipoProcesso == '01') {
                viewModel.codigoLeiturista = filtro.leiturista;
                viewModel.tipoCancelamento = filtro.status;
            } else if (vm.tipoProcesso == '02') {
                viewModel.grupo = filtro.grupo;
            }

            CancelarCargaService.setFiltroCancelarCarga(filtro);
            _iniciarProgresso();

            var pBuscarDados = CancelarCargaService.buscarDadosArquivos(viewModel);

            pBuscarDados
                .then(function (success) {

                    var filtros = {
                        mes: viewModel.mes,
                        ano: viewModel.ano,
                    }
                    if (vm.tipoProcesso == '01') {
                        filtros.leiturista = viewModel.codigoLeiturista;
                    } else if (vm.tipoProcesso == '02') {
                        filtros.grupo = filtro.grupo;
                    }
                    var object = {
                        arquivos: success.data,
                        filtros
                    }
                    CancelarCargaService.listenerArquivos(function () { return object; });

                    CancelarCargaService.toggleFiltro();
                }, function (error) {
                    var object = undefined
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                    CancelarCargaService.listenerArquivos(function () { return object; });
                })
                .finally(function () { _finalizarProgresso() });
        }
    }

}());
/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.perfil', [])
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('app.cadastro_usuario_perfil', {
                url: '/cadastro-usuario-perfil',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cadastros/usuario/perfil/views/perfil.html',
                        controller: 'PerfilController as vm'
                    },
                    'perfil-form@app.cadastro_usuario_perfil': {
                        templateUrl: 'app/main/cadastros/usuario/perfil/views/perfil-form.html',
                    },
                    'perfis-tabela@app.cadastro_usuario_perfil': {
                        templateUrl: 'app/main/cadastros/usuario/perfil/views/perfis-tabela.html',
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.perfil')
        .factory('PerfilFactory', PerfilFactory);

    function PerfilFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        //#endregion

        //#region Definição dos Métodos
        return {
            construirDtOptions: _construirDtOptions
        };
        //#endregion

        // #region Implementação dos métodos

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.perfil.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.usuario')
        .factory('UsuarioFactory', UsuarioFactory);

    function UsuarioFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        //#endregion

        //#region Definição dos Métodos
        return {
            construirDtOptions: _construirDtOptions
        };
        //#endregion

        // #region Implementação dos métodos

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.usuario.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Nome",
                        data: "nome",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "CodigoPerfil",
                        data: "clsPerfil.descricao",
                        defaultContent: ""                
                    },
                    {
                        targets: 4,
                        name: "Login",
                        data: "login",
                        defaultContent: ""
                    }
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.formularioImpressao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.formularioImpressao;

        $stateProvider
            .state('app.cadastro_relacionados_formulario_impressao', {
                url: '/cadastros/relacionados/formulario-impressao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'FormularioImpressaoController as vm',
                        abstract: true
                    },
                    'formulario-impressao-form@app.cadastro_relacionados_formulario_impressao': {
                        templateUrl: rotasHtml.form,                        
                    },
                    'formularios-impressoes-tabela@app.cadastro_relacionados_formulario_impressao': {
                        templateUrl: rotasHtml.tabela,
                    },
                    'tab-geral@app.cadastro_relacionados_formulario_impressao': {
                        templateUrl: rotasHtml.tabs.tabGeral
                    },
                    'tab-especifico@app.cadastro_relacionados_formulario_impressao': {
                        templateUrl: rotasHtml.tabs.tabEspecifico
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.formularioImpressao')
        .service('FormularioImpressaoService', FormularioImpressaoService);

    /** @ngInject */
    function FormularioImpressaoService(FormularioImpressaoFactory, ValidacaoService, MensagemConstant, MdDialogService) {

        //#region Data

        var formularioImpressao = FormularioImpressaoFactory.formularioImpressao;


        //#region Definição dos métodos

        var validarParametrosSelecaoArquivo = _validarParametrosSelecaoArquivo;
        var validarExtensaoArquivoValido = _validarExtensaoArquivoValido;

        this.validarParametrosAberturaArquivo = _validarParametrosAberturaArquivo;
        this.selecionarArquivo = _selecionarArquivo;
        this.validarParametrosExclusaoArquivo = _validarParametrosExclusaoArquivo;

        //#endregion


        //#endregionregion 

        //#region Implementação dos Métodos


        function _validarParametrosAberturaArquivo(idComponente) {
            ValidacaoService.validarParametroString(idComponente);           
        }

        function _selecionarArquivo(event, arquivo, functionOnLoad) {
            validarParametrosSelecaoArquivo(event, arquivo, functionOnLoad);            

            if (arquivo) {
                if (!validarExtensaoArquivoValido(arquivo.name)) return;

                var leituraArquivo = new FileReader();

                leituraArquivo.readAsText(arquivo, "UTF-8");
                leituraArquivo.onload = functionOnLoad;
                leituraArquivo.onerror = function (event) {
                    MdDialogService.alertPadrao("Erro ao carregar o arquivo: " + event, event);
                }
            }
        }

        function _validarParametrosExclusaoArquivo(event, idComponente, campoSelecionado) {
            ValidacaoService.validarParametroString(campoSelecionado);
            ValidacaoService.validarParametroString(idComponente);
            ValidacaoService.validarParametroObjeto(event)
        }

        //#endregion

        //#region Métodos Internos       

        function _validarParametrosSelecaoArquivo(event, arquivo, functionOnLoad) {
            ValidacaoService.validarParametroObjeto(event)
            ValidacaoService.validarParametroObjeto(arquivo);            
            ValidacaoService.validarParametroFuncao(functionOnLoad);

        }

        function _validarExtensaoArquivoValido(nomeArquivo) {
            if (nomeArquivo.substr(nomeArquivo.length - 7) != ".layout") {
                MdDialogService.alertPadrao("Nome do arquivo inválido, o nome do arquivo deve ter a extensão [.layout].", event);
                return false;
            }
            return true
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.formularioImpressao')
        .factory('FormularioImpressaoFactory', FormularioImpressaoFactory);

    function FormularioImpressaoFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        var _formularioImpressao = {
            codigo: "",
            fatura: "",
            comunicadoAlternativo: "",
            comunicadoConsumoAlterado: "",
            comunicadoDebitoAnterior: "",
            comunicadoOcorrencia: "",
            comunicadoQuitacaoAnual: "",
            comunicadoServicosCobrancaAvulsa: "",
            descricao: "",
            comunicadoVariosDebitos: "",
            comunicadoUnicoDebito: "",
            extratoDebito: "",
            relatorioClientesVisitados: ""
        }

        //#endregion

        //#region Definição dos Métodos
        return {
            formularioImpressao: _formularioImpressao,
            construirDtOptions: _construirDtOptions
        }
        //#endregion

        // #region Implementação dos métodos

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.formularioImpressao.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descricao",
                            data: "descricao",
                            defaultContent: ""
                        },
                    ]);
        }

        //#endregion




    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.pagamentoPix', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.pagamentoPix;

        $stateProvider
            .state('app.cadastro_relacionados_pagamento_pix', {
                url: '/cadastros/relacionados/pagamento-pix',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'PagamentoPixController as vm',
                        abstract: true
                    },
                    'pagamento-pix-form@app.cadastro_relacionados_pagamento_pix': {
                        templateUrl: rotasHtml.form,
                    },
                    'tab-configuracoes@app.cadastro_relacionados_pagamento_pix': {
                        templateUrl: rotasHtml.tabs.configuracoes,
                    },
                    'tab-integracao@app.cadastro_relacionados_pagamento_pix': {
                        templateUrl: rotasHtml.tabs.integracao,
                    },
                },
                resolve: {
                    PagamentoPix: function (RequisicaoGenericaService, Api, PagamentoPixFactory) {
                        return RequisicaoGenericaService.listarSemParams(Api.pagamentoPix.listartodos)
                            .then(function (success) {
                                if (success.data.length) {
                                    return success.data[0];
                                } else {
                                    return PagamentoPixFactory.pagamentoPix();
                                }

                            }, function (error) {
                                return PagamentoPixFactory.pagamentoPix();
                            });
                    },
                    DadosCadastradosEmpresa: function (RequisicaoGenericaService, Api, ParametrosFactory) {
                      return RequisicaoGenericaService.listarSemParams(
                        Api.parametros.dadosParametro
                      ).then(
                        function (success) {
                          return success.data.empresa;
                        },
                        function (error) {                            
                          return ParametrosFactory.parametro
                        }
                      );
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.pagamentoPix')
        .service('PagamentoPixService', PagamentoPixService);

    /** @ngInject */
    function PagamentoPixService(ValidacaoService, MdDialogService) {

        //#region Definição dos métodos

        var validarParametrosSelecaoArquivo = _validarParametrosSelecaoArquivo;
        var validarExtensaoArquivoValido = _validarExtensaoArquivoValido;

        this.validarParametrosAberturaArquivo = _validarParametrosAberturaArquivo;
        this.selecionarArquivo = _selecionarArquivo;
        this.validarParametrosExclusaoArquivo = _validarParametrosExclusaoArquivo;

        //#endregion

        //#region Implementação dos Métodos


        function _validarParametrosAberturaArquivo(idComponente) {
            ValidacaoService.validarParametroString(idComponente);
        }

        function _selecionarArquivo(event, arquivo, functionOnLoad) {
            validarParametrosSelecaoArquivo(event, arquivo, functionOnLoad);

            if (arquivo) {
                if (!validarExtensaoArquivoValido(arquivo.name)) return;

                var leituraArquivo = new FileReader();

                leituraArquivo.readAsArrayBuffer(arquivo);
                leituraArquivo.onload = functionOnLoad;
                leituraArquivo.onerror = function (event) {
                    MdDialogService.alertPadrao("Erro ao carregar o arquivo: " + event, event);
                }
            }
        }

        function _validarParametrosExclusaoArquivo(event, idComponente, campoSelecionado) {
            ValidacaoService.validarParametroString(campoSelecionado);
            ValidacaoService.validarParametroString(idComponente);
            ValidacaoService.validarParametroObjeto(event)
        }

        //#endregion

        //#region Métodos Internos       

        function _validarParametrosSelecaoArquivo(event, arquivo, functionOnLoad) {
            ValidacaoService.validarParametroObjeto(event)
            ValidacaoService.validarParametroObjeto(arquivo);
            ValidacaoService.validarParametroFuncao(functionOnLoad);

        }

        function _validarExtensaoArquivoValido(nomeArquivo) {
            if (nomeArquivo.substr(nomeArquivo.length - 4) != ".p12") {
                MdDialogService.alertPadrao("Nome do arquivo inválido, o nome do arquivo deve ter a extensão [.p12].", event);
                return false;
            }
            return true
        }

        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.pagamentoPix')
        .factory('PagamentoPixFactory', PagamentoPixFactory);

    function PagamentoPixFactory(ValidacaoService, Api, DatatableFactory, RequisicaoGenericaService) {




        return {
            pagamentoPix: pagamentoPix,
            construirDtOptions: _construirDtOptions
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(
                Api.pagamentoPix.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [
                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Chave",
                        data: "chave",
                        defaultContent: ""
                    }
                ]
            );
        }

        function pagamentoPix() {
            var _pagamentoPix = {
                codigo: 0,
                tipoConfiguracao: 1,
                chave: '',
                nomeEmpresa: '',
                cidade: '',
                enderecoApi: '',
                certificado: '',
                usuarioCertificado: '',
                senhaCertificado: '',
            };

            RequisicaoGenericaService.listarSemParams(Api.pagamentoPix.proximocodigo)
                .then(function (result) {
                    _pagamentoPix.codigo = result.data;
                });

            return _pagamentoPix;
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.relacionados.cadastroArquivo', [])
    .config(Config);

  function Config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.arquivo;

    $stateProvider
      .state('app.cadastro_relacionados_arquivo', {
        url: '/cadastros/relacionados/arquivo',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'CadastroArquivoController as vm',
            abstract: true
          },
          'cadastro-arquivo-form@app.cadastro_relacionados_arquivo': {
            templateUrl: rotasHtml.form,
          },
          'cadastro-arquivos-tabela@app.cadastro_relacionados_arquivo': {
            templateUrl: rotasHtml.tabela,
          }
        }
      });

  }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.cadastroArquivo')
        .factory('ImpressoraFactory', ImpressoraFactory);

    function ImpressoraFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        var _entidade = {
            descricao: "",
            exibeMensagemPreparaImpressao: "",
            conexao: "",
            layoutFaturaZebra: "",
            metodoImpressaoZebra: "",
            observacao: "",
        };

        //#endregion

        //#region Definição dos Métodos
        return {
            impressora: _entidade,
            construirEntidadeParaInsercao: _construirEntidadeParaInsercao,
            construirDtOptions: _construirDtOptions
        }
        //#endregion

        // #region Implementação dos métodos

        function _construirEntidadeParaInsercao() {
            return {
                descricao: "",
                exibeMensagemPreparaImpressao: "N",
                conexao: "01",
                layoutFaturaZebra: "01",
                metodoImpressaoZebra: "01",
                observacao: "",
            };
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio, dicionariosimpressora) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);
            ValidacaoService.validarParametroObjeto(dicionariosimpressora);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.impressora.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "Conexao",
                        data: "conexao",
                        defaultContent: "",
                        render: function (data) {
                            var retorno = "";
                            angular.forEach(dicionariosimpressora[0], function (chave, valor) {
                                if (data == chave) {
                                    retorno = valor;
                                }                                             
                            });
                            return retorno;
                        },
                    },
                    {
                        targets: 4,
                        name: "LayoutFaturaZebra",
                        data: "layoutFaturaZebra",
                        defaultContent: "",
                        render: function (data) {
                            var retorno = "";
                            angular.forEach(dicionariosimpressora[1], function (chave, valor) {
                                if (data == chave) {
                                    retorno = valor;
                                }
                            });
                            return retorno;
                        },
                    },
                    {
                        targets: 5,
                        name: "MetodoImpressaoZebra",
                        data: "metodoImpressaoZebra",
                        defaultContent: "",
                        render: function (data) {
                            var retorno = "";
                            angular.forEach(dicionariosimpressora[2], function (chave, valor) {
                                if (data == chave) {
                                    retorno = valor;
                                }
                            });
                            return retorno;
                        },
                    },
                    {
                        targets: 6,
                        name: "Observacao",
                        data: "observacao",
                        defaultContent: ""
                    }
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();


(function () {
  'use strict';

  angular
    .module('app.service')
    .service("EspecieDocumentoService", EspecieDocumentoService);

  function EspecieDocumentoService(Api, RequisicaoGenericaService, DatatableFactory) {

    var rota = Api.especieDocumento;

    var servico = {
      criar: criar,
      atualizar: atualizar,
      remover: remover,
      listarTodos: listarTodos,
      pesquisar: pesquisar,
      construirDatatable: construirDatatable,
      listar: listar,
      rota: rota
    }


    function criar(especie) {
      return RequisicaoGenericaService.salvar(rota.criar, especie);
    }

    function listarTodos() {
      return RequisicaoGenericaService.listarSemParams(rota.listar);
    }

    function atualizar(especie) {
      return RequisicaoGenericaService.editar(rota.atualizar, especie);
    }

    function remover(codigo) {
      return RequisicaoGenericaService.excluir(rota.remover, codigo);
    }

    function pesquisar(entidadeEnvio) {
      return RequisicaoGenericaService.salvar(rota.listarPorPaginacao, entidadeEnvio);
    }

    function construirDatatable(entidadeDeEnvio, funcaoSelecionar) {
      var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
        (rota.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, '#especie-datatable',
          [

            DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
            {
              targets: 1,
              name: "Codigo",
              data: "codigo",
              defaultContent: ""
            },
            {
              targets: 2,
              name: "Descrição",
              data: "descricao",
              defaultContent: ""
            },
            {
              targets: 3,
              name: "Sigla",
              data: "sigla",
              defaultContent: ""
            }
          ]);

      return dtOptions;
    }

    function listar(){
      return RequisicaoGenericaService.listarSemParams(rota.listar);
    }

    return servico;

  }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.equipamento', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.equipamento;

        $stateProvider
            .state('app.cadastro_relacionados_equipamento', {
                url: '/cadastros/relacionados/equipamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'EquipamentoController as vm',
                        abstract: true
                    },
                    'equipamento-form@app.cadastro_relacionados_equipamento': {
                        templateUrl: rotasHtml.form
                    },
                    'equipamentos-tabela@app.cadastro_relacionados_equipamento': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    RetornarEnumsEquipamento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.enum.listarEnumsEquipamento);
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.equipamento')
        .service('EquipamentoService', EquipamentoService);

    /** @ngInject */
    function EquipamentoService(EquipamentoFactory, ValidacaoService, MensagemConstant, MdDialogService) {

        //#region Data

        var formularioImpressao = EquipamentoFactory.equipamento;


        //#region Definição dos métodos

        var validarParametrosSelecaoArquivo = _validarParametrosSelecaoArquivo;
        var validarExtensaoArquivoValido = _validarExtensaoArquivoValido;

        this.validarParametrosAberturaArquivo = _validarParametrosAberturaArquivo;
        this.validarParametrosExclusaoArquivo = _validarParametrosExclusaoArquivo;

        //#endregion

        //#endregionregion 

        //#region Implementação dos Métodos

        function _validarParametrosAberturaArquivo(idComponente) {
            ValidacaoService.validarParametroString(idComponente);
        }

        //#endregion

        //#region Métodos Internos       

        function _validarParametrosExclusaoArquivo(event, idComponente, campoSelecionado) {
            ValidacaoService.validarParametroString(campoSelecionado);
            ValidacaoService.validarParametroString(idComponente);
            ValidacaoService.validarParametroObjeto(event);
        }

        function _validarParametrosSelecaoArquivo(event, arquivo, functionOnLoad) {
            ValidacaoService.validarParametroObjeto(event);
            ValidacaoService.validarParametroObjeto(arquivo);
            ValidacaoService.validarParametroFuncao(functionOnLoad);

        }

        function _validarExtensaoArquivoValido(nomeArquivo) {
            if (nomeArquivo.substr(nomeArquivo.length - 7) != ".layout") {
                MdDialogService.alertPadrao("Nome do arquivo inválido, o nome do arquivo deve ter a extensão [.layout].", event);
                return false;
            }
            return true;
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.equipamento')
        .factory('EquipamentoFactory', EquipamentoFactory);

    function EquipamentoFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        //#endregion

        //#region Definição dos Métodos
        return {
            equipamento: _equipamento,
            construirDtOptions: _construirDtOptions
        };
        //#endregion

        // #region Implementação dos métodos

        function _equipamento(){
            return {
                codigo: null,
                descricao: "",
                possuiTecladoFisico: "N",
                possuiLeitorBarras: "N",
                possuiGps: "N",
                observacao: "",
                tipoCamera: 1,
                tipoUsoTecladoFisico: 1,
                timer: 4000,
                utilizaPosicionamentoEspecial: "N",
                utilizaPareamentoInterno: "N",
                utilizaTimerImpressaoFoto: "N",
                timerImpressaoFoto: 4000,
                sistemaOperacional: 1,
                diretorioArmazenamentoInterno: "",
                utilizaModoTelefoneAutomatico: "N"
            };
        }
        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.equipamento.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();

(function () {
  'use strict';

  angular
    .module('app.service')
    .service("BoletoBancarioService", BoletoBancarioService);

  function BoletoBancarioService(Api, RequisicaoGenericaService, DatatableFactory) {

    var rota = Api.boletoBancario;

    var servico = {
      criar: criar,
      atualizar: atualizar,
      remover: remover,
      listarTodos: listarTodos,
      pesquisar: pesquisar,
      construirDatatable: construirDatatable,
      listar: listar,
      rota: rota
    }


    function criar(boleto) {
      return RequisicaoGenericaService.salvar(rota.criar, boleto);
    }

    function listarTodos() {
      return RequisicaoGenericaService.listarSemParams(rota.listarTodos);
    }

    function atualizar(boleto) {
      return RequisicaoGenericaService.editar(rota.atualizar, boleto);
    }

    function remover(codigo) {
      return RequisicaoGenericaService.excluir(rota.remover, codigo);
    }

    function pesquisar(entidadeEnvio) {
      return RequisicaoGenericaService.salvar(rota.listarPorPaginacao, entidadeEnvio);
    }

    function construirDatatable(entidadeDeEnvio, funcaoSelecionar) {
      var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
        (rota.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, '#boleto-datatable',
          [

            DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
            {
              targets: 1,
              name: "Codigo",
              data: "codigo",
              defaultContent: ""
            },
            {
              targets: 2,
              name: "Cedente",
              data: "cedente",
              defaultContent: ""
            },
            {
              targets: 3,
              name: "CNPJ",
              data: "cnpjCedente",
              defaultContent: ""
            }
          ]);

      return dtOptions;
    }

    function listar(){
      return RequisicaoGenericaService.listarSemParams(rota.listar);
    }

    return servico;

  }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.cadastroArquivo')
        .factory('CadastroArquivoFactory', CadastroArquivoFactory);

    function CadastroArquivoFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        var _entidade = {
            codigo: "",
            descricao: "",
            observacao: ""
        };

        //#endregion

        //#region Definição dos Métodos
        return {
            arquivo: _entidade,
            construirDtOptions: _construirDtOptions
        }
        //#endregion

        // #region Implementação dos métodos

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);           
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.arquivo.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "Observacao",
                        data: "observacao",
                        defaultContent: ""
                    },
                ]);
        }

        //#endregion




    } // FIM FACTORY

})();


/**
 * Created by nova on 20/07/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service')
    .service("RegionalService", RegionalService);

  function RegionalService(Api, RequisicaoGenericaService, DatatableFactory) {

    var rota = Api.regional;

    var servico = {
      criar: criar,
      atualizar: atualizar,
      remover: remover,
      listarTodos: listarTodos,
      pesquisar: pesquisar,
      construirDatatable: construirDatatable,
      listar: listar,
      rota: rota
    }


    function criar(regional) {
      return RequisicaoGenericaService.salvar(rota.criar, regional);
    }

    function listarTodos() {
      return RequisicaoGenericaService.listarSemParams(rota.listarTodos);
    }

    function atualizar(regional) {
      return RequisicaoGenericaService.editar(rota.atualizar, regional);
    }

    function remover(codigo) {
      return RequisicaoGenericaService.excluir(rota.remover, codigo);
    }

    function pesquisar(entidadeEnvio) {
      return RequisicaoGenericaService.salvar(rota.listarPorPaginacao, entidadeEnvio);
    }

    function construirDatatable(entidadeDeEnvio, funcaoSelecionar) {
      var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
        (rota.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, '#regional-datatable',
          [

            DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
            {
              targets: 1,
              name: "Codigo",
              data: "codigo",
              defaultContent: ""
            },
            {
              targets: 2,
              name: "Descrição",
              data: "descricao",
              defaultContent: ""
            }
          ]);

      return dtOptions;
    }

    function listar(){
      return RequisicaoGenericaService.listarSemParams(rota.listar);
    }

    return servico;

  }

})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service')
    .service("MunicipioService", MunicipioService);

  function MunicipioService(Api, RequisicaoGenericaService, DatatableFactory) {

    var rota = Api.municipio;

    var servico = {
      criar: criar,
      atualizar: atualizar,
      remover: remover,
      pesquisar: pesquisar,
      construirDatatable: construirDatatable,
      rota: rota,
      listarMunicipios: listarMunicipios
    }


    function criar(municipio) {
      return RequisicaoGenericaService.salvar(rota.criar, municipio);
    }

    function atualizar(municipio) {
      return RequisicaoGenericaService.editar(rota.atualizar, municipio);
    }

    function remover(codigoMunicipio) {
      return RequisicaoGenericaService.excluir(rota.remover, codigoMunicipio);
    }

    function pesquisar(entidadeEnvio) {
      return RequisicaoGenericaService.salvar(rota.listarPorPaginacao, entidadeEnvio);
    }

    function construirDatatable(entidadeDeEnvio, funcaoSelecionar, listaRegional) {
      var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
        (rota.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, '#municipio-datatable',
          [

            DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
            {
              targets: 1,
              name: "Codigo",
              data: "codigo",
              defaultContent: ""
            },
            {
              targets: 2,
              name: "Descrição",
              data: "descricao",
              defaultContent: ""
            },
            {
              targets: 3,
              name: "Localização",
              data: "localizacao",
              defaultContent: ""
            },
            {
              targets: 4,
              name: "Regional",
              data: "regional",
              defaultContent: "",
              render: function (data, type, row) {
                var regiao = listaRegional.filter(function (item) {
                  return item.codigo == data;
                })[0];
                return regiao.descricao;
              }
            }
          ]);

      return dtOptions;
    }

    function listarMunicipios(codigoRegional) {
      return RequisicaoGenericaService.listarSemParams(rota.listarMunicipios + "?regional=" + codigoRegional);
    }

    return servico;

  }

})();

(function(){
    'use strict';

    angular
        .module('app.service')
        .service('AgrupamentoService', AgrupamentoService)

    /** @ngInject */
    function AgrupamentoService(Api, RequisicaoGenericaService, DatatableFactory){
       
        var rota = Api.agrupamento;

        var service = {
          criar: criar,
          atualizar: atualizar,
          remover: remover,
          listarTodos: listarTodos,
          pesquisar: pesquisar,
          construirDatatable: construirDatatable,
          listar: listar,
          rota: rota
        }
    
    
        function criar(agrupamento) {
          return RequisicaoGenericaService.salvar(rota.criar, agrupamento);
        }
    
        function listarTodos() {
          return RequisicaoGenericaService.listarSemParams(rota.listarTodos);
        }
    
        function atualizar(agrupamento) {
          return RequisicaoGenericaService.editar(rota.atualizar, agrupamento);
        }
    
        function remover(codigo) {
          return RequisicaoGenericaService.excluir(rota.remover, codigo);
        }
    
        function pesquisar(entidadeEnvio) {
          return RequisicaoGenericaService.salvar(rota.listarPorPaginacao, entidadeEnvio);
        }
    
        function construirDatatable(entidadeDeEnvio, funcaoSelecionar) {
          var dtOptions = DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
            (rota.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, '#agrupamento-datatable',
              [
    
                DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                {
                  targets: 1,
                  name: "Codigo",
                  data: "codigo",
                  defaultContent: ""
                },
                {
                  targets: 2,
                  name: "Descrição",
                  data: "descricao",
                  defaultContent: ""
                }
              ]);
    
          return dtOptions;
        }
    
        function listar(){
          return RequisicaoGenericaService.listarSemParams(rota.listar);
        }
        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.tipoEntrega', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.tipoEntrega;

        $stateProvider
            .state('app.cadastro_entrega_tipoentrega', {
                url: '/cadastros/entrega/tipo-entrega',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TipoEntregaController as vm',
                        abstract: true
                    },
                    'tipo-entrega-form@app.cadastro_entrega_tipoentrega': {
                        templateUrl: rotasHtml.form
                    },
                    'tipo-entregas-tabela@app.cadastro_entrega_tipoentrega': {
                        templateUrl: rotasHtml.tabela
                    }
                }               
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.tipoEntrega')
        .factory('TipoEntregaFactory', TipoEntregaFactory);

    function TipoEntregaFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        //#endregion

        //#region Definição dos Métodos
        return {
            tipoEntrega: _tipoEntrega,
            construirDtOptions: _construirDtOptions
        };
        //#endregion

        // #region Implementação dos métodos

        function _tipoEntrega() {
            return {
                codigo: null,
                descricao: "",
                permiteRecadastramento: "N"
            };
        }
        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.tipoEntrega.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                    {
                        targets: 3,
                        name: "Permite Recadastramento",
                        data: "permiteRecadastramento",
                        defaultContent: ""
                    },
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.motivoNaoEntrega', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.motivoNaoEntrega;

        $stateProvider
            .state('app.cadastro_entrega_motivonaoentrega', {
                url: '/cadastros/entrega/motivo-nao-entrega',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'MotivoNaoEntregaController as vm',
                        abstract: true
                    },
                    'motivo-nao-entrega-form@app.cadastro_entrega_motivonaoentrega': {
                        templateUrl: rotasHtml.form
                    },
                    'motivo-nao-entrega-tabela@app.cadastro_entrega_motivonaoentrega': {
                        templateUrl: rotasHtml.tabela
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.motivoNaoEntrega')
        .factory('MotivoNaoEntregaFactory', MotivoNaoEntregaFactory);

    function MotivoNaoEntregaFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        //#endregion

        //#region Definição dos Métodos
        return {
            motivoNaoEntrega: _motivoNaoEntrega,
            construirDtOptions: _construirDtOptions
        };
        //#endregion

        // #region Implementação dos métodos

        function _motivoNaoEntrega() {
            return {
                codigo: null,
                descricao: "",
                permiteRecadastramento: "N"
            };
        }
        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.tipoEntrega.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo",
                        defaultContent: ""
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao",
                        defaultContent: ""
                    },
                ]);
        }

        //#endregion

    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.toolbar', ['ja.qr'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('DialogLicencasTemporariasCadastradasController', DialogLicencasTemporariasCadastradasController);

    function DialogLicencasTemporariasCadastradasController(
        $mdDialog,
        LicencasTemporarias,
        DatatableFactory
    ) {
        var vm = this;
        vm.licencasTemporarias = LicencasTemporarias;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog
        };

        function init() {
            vm.emProgresso = true;
            vm.dtInstanceLicencasTemporariasCadastradas = {};
            vm.dtOptionsLicencasTemporariasCadastradas = _construirDtOptions([]);
            vm.dtOptionsLicencasTemporariasCadastradas.order = [2, 'desc'];
            vm.dtOptionsLicencasTemporariasCadastradas.scrollY = '50vh';
            vm.dtOptionsLicencasTemporariasCadastradas.scrollCollapse = true;
            vm.pesquisar = '';
            vm.licencasTemporarias.forEach(function (licenca) {
                licenca.estaVencido = _verificaDataAtual(licenca.dataHoraVencimentoLicencaTemporaria);
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function _construirDtOptions() {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisa');

                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                columnDefs: [{
                    targets: [2],
                    type: 'date-pt-br',
                    orderable: true,
                }],
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }

        function _verificaDataAtual(dataVencimentoLicencaTemporaria) {
            var dataAtual = new Date();
            var dataVencimentoLicenca = new Date(dataVencimentoLicencaTemporaria);

            return dataVencimentoLicenca < dataAtual;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('DialogLicencasTemporariasController', DialogLicencasTemporariasController);

    function DialogLicencasTemporariasController(
        $mdDialog,
        Dados,
        CodigoHdn,
        ImanagerRequisicaoGenericaService,
        MdDialogService,
        MdToastService
    ) {
        var vm = this;
        vm.licencaTemporaria = Dados.licencaTemporaria;

        init();

        vm.metodos = {
            salvar: salvar,
            fecharDialog: fecharDialog,
            changeValidaCampoLicencaTemporaria: changeValidaCampoLicencaTemporaria,
            changeValidaCampoImei: changeValidaCampoImei
        };

        function init() {
            vm.emProgresso = true;
            vm.houveAlteracoes = false;
        }

        function salvar() {
            ImanagerRequisicaoGenericaService.post('api/protecao/licenca/CriarLicencaTemporaria',
                {
                    licenca: vm.licencaTemporaria.licencaEquipamento,
                    imei: vm.licencaTemporaria.imeiEquipamento,
                    produto: 2,
                    cliente: CodigoHdn,
                })
                .then(function (success) {
                    vm.houveAlteracoes = true;
                    MdToastService.toastPadrao("Licença temporária cadastrada com sucesso!");
                    $mdDialog.hide(vm.houveAlteracoes);
                }, function (error) {
                    MdDialogService.alertPadrao("Atenção!", null, error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function changeValidaCampoLicencaTemporaria(licencaTemporaria, form) {
            if (licencaTemporaria.startsWith("1")) {
                form.licenca.$setValidity("validaCaractereInicial", true);
            } else {
                form.licenca.$setValidity("validaCaractereInicial", false);
            }

            if (licencaTemporaria.toString().length < 8) {
                form.licenca.$setValidity("validaQuantidadeCaracteresLicenca", false);
            } else {
                form.licenca.$setValidity("validaQuantidadeCaracteresLicenca", true);
            }
        }

        function changeValidaCampoImei(imei, form) {
            if (imei.toString().length < 5) {
                form.imei.$setValidity("validaQuantidadeCaracteresImei", false);
            } else {
                form.imei.$setValidity("validaQuantidadeCaracteresImei", true);
            }
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.processamento.importacao')
        .service('ImportacaoGrupoLeituraCaemaService', ImportacaoGrupoLeituraCaemaService)

    /** @ngInject */
    function ImportacaoGrupoLeituraCaemaService(RequisicaoGenericaService, Api, $q){

        var service = {
            listarArquivosFtp: listarArquivosFtp,
            importacaoViaFtp: importacaoViaFtp
        };

        function listarArquivosFtp(localidade, setor){
            var promise = $q.defer();

            RequisicaoGenericaService.listarSemParams('api/agrupamento/' + localidade + '/' + setor + '/' + 'listarArquivosFTPCaema').then(
                function (success) {
                  promise.resolve(success);
                },
                function (error) {
                  promise.reject(error);
                });

            return promise.promise;
        }

        function importacaoViaFtp(localidade, nomeArquivo, setor){
            var promise = $q.defer();

            RequisicaoGenericaService.listarSemParams('api/agrupamento/' + localidade + '/' + setor + '/' + 'baixarArquivoFTPCaema?' + 'nomeArquivo=' + nomeArquivo)
            .then(function (success) {
                promise.resolve(success);
            }, function (error){
                $q.reject(error);
            });

            return promise.promise;
        }


        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.geracaoarquivo', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.geracaoarquivo;

        $stateProvider
            .state('app.geracao_arquivo', {
                url: '/processamento/geracaoarquivo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'GeracaoarquivoController as vm',
                        abstract: true
                    },
                    'geracaoarquivo-form@app.geracao_arquivo': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    ListarLeituristas:
                        function (Api, RequisicaoGenericaService) {
                            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos)
                        },
                    LeituristaCodigo: function () { return null },
                    DataExportacao: function () { return null },
                    obterDadosParametro: function ($q, Api, LocalStorageService, RequisicaoGenericaService) {
                        var deferred = $q.defer();

                        if (navigator.onLine) {
                            RequisicaoGenericaService.listarSemParams(Api.parametros.dadosParametro).then(
                                function (success) {
                                    deferred.resolve(success);
                                    LocalStorageService.armazenar("cadastro-parametro-obterDadosParametro", success.data);
                                },
                                function (error) {
                                    deferred.reject(error);
                                });
                        }
                        else {
                            deferred.resolve(LocalStorageService.recuperar("cadastro-parametro-obterDadosParametro"));
                        }

                        return deferred.promise;
                    },
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.processamento.geracaoarquivo')
        .factory('GeracaoArquivoService', GeracaoArquivoService);

    /** @ngInject */
    function GeracaoArquivoService(Api, ArquivosService, RequisicaoGenericaService, MdDialogService) {

        this.gerarArquivo = function (codigoLeiturista, dataExportacao, nomeArquivoExportacao, callbackSuccess, callbackError) {

            var filtro = {
                codigoLeiturista: codigoLeiturista,
                dataExportacao: dataExportacao,
                nomeArquivoExportacao: nomeArquivoExportacao
            };

            RequisicaoGenericaService
                .salvar(Api.geracaoArquivoRetorno.gerarArquivoRetorno, filtro)
                .then(
                    function (success) {
                        return ArquivosService
                            .baixarArquivo(Api.geracaoArquivoRetorno.abrirArquivo, success.data);
                    })
                .then(
                    function () {
                       callbackSuccess();
                    })
                .catch(function (error) {
                    MdDialogService.alertPadrao(error.data);
                    callbackSuccess();
                });
        }

        return this;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.geracaoarquivo')
        .factory('GeracaoArquivoFactory', GeracaoArquivoFactory);

    function GeracaoArquivoFactory(DatatableFactory) {
        return {
            dtOptionsArquivoRetorno: DatatableFactory.construirDtOptionPadrao([
                {
                    width: '20%',
                    targets: [0, 1, 2]
                },
                {
                    targets: [0, 2],
                    orderable: false
                },
            ], true)
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .factory('GerenciamentoGrupoFactory', GerenciamentoGrupoFactory)

    /** @ngInject */
    function GerenciamentoGrupoFactory(){

        var entidadeFiltro = {
            regional: undefined,            
            mes: new Date().getMonth() + 1,
            ano: new Date().getFullYear(),
            grupo: undefined,
            municipio: undefined,
            situacao: 1
        }

        var _filtro = undefined;

        var _setores = undefined;

        return {
            coresLegendaSituacao: getCoresLegendaSituacaoGerenciamentoGrupo,
            construirEntidadeFiltro: construirEntidadeFiltro,
            getFiltro: getFiltro,
            setFiltro: setFiltro,
            setSetores: setSetores,
            getSetores: getSetores  
        }

       function getSetores(){
           return angular.copy(_setores)
       }

       function setSetores(setores){
           _setores = angular.copy(setores);
       }


        function construirEntidadeFiltro(){
            return angular.copy(entidadeFiltro);
        }

        function getFiltro(){
            return angular.copy(_filtro);            
        }
        function setFiltro(filtro){
            _filtro = angular.copy(filtro);
        }

        function getCoresLegendaSituacaoGerenciamentoGrupo(){
            var coresSituacao = [
                {cor: '', situacao: 'Não distribuído', icone: 'icon-label-outline' },
                {cor: '#f0e68c', situacao: 'Distribuído', icone: 'icon-label' },
                {cor: '#a9a9a9', situacao: 'Parcialmente distribuído', icone: 'icon-label' },
                {cor: '#f4a460', situacao: 'Tarefa disponibilizada', icone: 'icon-label' },
                {cor: '#add8e6', situacao: 'Importado', icone: 'icon-label' },
                {cor: '#9acd32', situacao: 'Exportado grupo leitura', icone: 'icon-label' }
            ]
            return coresSituacao;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaogestor', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.exportacaogestor;

        $stateProvider
            .state('app.exportacao_gestor', {
                url: '/processamento/exportacaogestor',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ExportacaoGestorController as vm',
                        abstract: true
                    },
                    'exportacaogestor-form@app.exportacao_gestor': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    ListarArquivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.exportacaoGestor.retornaListaNomesArquivoExportacaoGestor);
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaogestor')
        .factory('ExportacaoGestorService', ExportacaoGestorService);

    /** @ngInject */
    function ExportacaoGestorService(Api, RequisicaoGenericaService, MdDialogService) {

        this.enviarLeituras = function (codigoLeiturista, nomeArquivoExportacao, callbackSuccess, callbackError) {

            var filtro = {
                nomeArquivoExportacao: nomeArquivoExportacao,
                codigoLeiturista: codigoLeiturista
            };

            RequisicaoGenericaService
                .salvar(Api.exportacaoGestor.realizarEnvio, filtro)
                .then(
                    function (success) {
                        MdDialogService.alertPadrao("Leituras enviadas com sucesso!");
                    })
                .then(
                    function () {
                        callbackSuccess();
                    })
                .catch(function (error) {
                    MdDialogService.alertPadrao(error.data);
                    callbackSuccess();
                });
        }

        return this;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaogestor')
        .factory('ExportacaoGestorFactory', ExportacaoGestorFactory);

    function ExportacaoGestorFactory(DatatableFactory) {
        return {
            dtOptionsArquivoRetorno: DatatableFactory.construirDtOptionPadrao([
                {
                    width: '20%',
                    targets: [0, 1, 2]
                }
            ], false)
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile')
        .service('ValidacaoNomeArquivoExportacaoService', ValidacaoNomeArquivoExportacaoService);

    /** @ngInject */
    function ValidacaoNomeArquivoExportacaoService
        (
            ValidacaoService,
            MdDialogService
        ) {

        //#region Definição dos métodos

        this.validarNomeArquivo1 = _validarNomeArquivo1;
        this.validarNomeArquivo3 = _validarNomeArquivo3;
        this.validarNomeArquivo11 = _validarNomeArquivo11;
        this.validarNomeArquivo12 = _validarNomeArquivo12;
        this.validarNomeArquivo14 = _validarNomeArquivo14;
        this.validarNomeArquivo17 = _validarNomeArquivo17;
        this.validarNomeArquivo20 = _validarNomeArquivo20;
        this.validarNomeArquivo21 = _validarNomeArquivo21;
        this.validarNomeArquivo22 = _validarNomeArquivo22;
        this.validarNomeArquivoPadrao = _validarNomeArquivoPadrao;
        //#endregion

        //#region Implementação dos Métodos

        function _validarNomeArquivo1(nomeArquivo, parametrosExportacao, apiLf, parametros) {
            var padraoRegex = '';
            var padraoConsiderar = '';
            var tamanhograde = 0;
            if (parametros.utilizaGradeQuatroDigitos) {
                padraoConsiderar = 'GGGGMMAA.E';
                padraoRegex = '(^[0-9]{8}\.[E]{1}$)';
                tamanhograde = 4;
            }
            else {
                padraoConsiderar = 'GGGMMAA.E';
                padraoRegex = '(^[0-9]{7}\.[E]{1}$)';
                tamanhograde = 3;
            }

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, padraoConsiderar)) {
                parametrosExportacao.grade = nomeArquivo.substr(0, tamanhograde);
                parametrosExportacao.mesGrade = nomeArquivo.substr(tamanhograde, 2);
                parametrosExportacao.anoGrade = "20" + nomeArquivo.substr(tamanhograde + 2, 2);

                if (parametrosExportacao.mesGrade < 1 || parametrosExportacao.mesGrade > 12) {
                    MdDialogService.alertPadrao("O mês é inválido (" + parametrosExportacao.mesGrade + "), o nome do arquivo deve ter a seguinte estrutura: 'GGGMMAA.E'.");
                    apiLf.removeAll();
                    return false;
                }

                return true;
            }

            return false;
        }

        function _validarNomeArquivo3(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^CONSUMID\.[0-9]{3}$)";

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "Consumid.RRR")) {
                parametrosExportacao.rota = nomeArquivo.substr(-3);
                return true;
            }

            return false;
        }

        function _validarNomeArquivo11(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^[0-9]{9}\.REM$)";

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "AAMMAAOOO.REM")) {
                //AAMMRROO.REM
                var ano = parseInt(nomeArquivo.substr(0, 2)) + 2000;
                var mes = parseInt(nomeArquivo.substr(2, 2));

                if (mes < 1 || mes > 12) {
                    MdDialogService.alertPadrao("O mês é inválido (" + mes + "), o nome do arquivo deve ter a seguinte estrutura: 'AAMMAAOOO.REM'.");
                    apiLf.removeAll();
                    return false;
                }

                parametrosExportacao.dataArea = new Date(ano, (mes - 1), 1);
                parametrosExportacao.area = nomeArquivo.substr(4, 2);
                parametrosExportacao.origemArea = nomeArquivo.substr(6, 3);

                return true;
            }

            return false;
        }

        function _validarNomeArquivo12(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^[0-9]{8}\.REM$)";

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "LLIIIFFF.REM")) {
                parametrosExportacao.localidade = nomeArquivo.substr(0, 2);
                parametrosExportacao.rotaInicial = nomeArquivo.substr(2, 3);
                parametrosExportacao.rotaFinal = nomeArquivo.substr(5, 3);
                return true;
            }

            return false;
        }

        function _validarNomeArquivo14(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^[0-9]{8}\.[A-Z]{3}$)";

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "SSRRR000.MMM")) {
                parametrosExportacao.setor = nomeArquivo.substr(0, 2);
                parametrosExportacao.rotaPdc = nomeArquivo.substr(2, 3);
                return true;
            }

            return false;
        }

        function _validarNomeArquivo17(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^[0-9]{9}\.REM$)";

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "SSRRRMMAA.REM")) {
                var ano = parseInt(nomeArquivo.substr(7, 2)) + 2000;
                var mes = parseInt(nomeArquivo.substr(5, 2));

                if (mes < 1 || mes > 12) {
                    MdDialogService.alertPadrao(
                        "O mês é inválido (" + mes + "), o nome do arquivo deve ter a seguinte estrutura: 'SSRRRMMAA.REM'.");
                    apiLf.removeAll();
                    return false;
                }

                parametrosExportacao.setor = nomeArquivo.substr(0, 2);
                parametrosExportacao.rota = nomeArquivo.substr(2, 3);
                parametrosExportacao.mes = mes;
                parametrosExportacao.ano = ano;

                return true;
            }
        }

        function _validarNomeArquivo20(nomeArquivo, parametrosExportacao, apiLf) {
            return true;
        }

        function _validarNomeArquivo21(nomeArquivo, parametrosExportacao, apiLf) {
            return true;
        }

        function _validarNomeArquivo22(nomeArquivo, parametrosExportacao, apiLf) {
            var padraoRegex = "(^[0-9]{12}\.REM$)"; //AAMMLLRRRSSS.REM

            if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "AAMMLLRRRSSS.REM")) {
                parametrosExportacao.ano = nomeArquivo.substr(0, 2);
                parametrosExportacao.mes = nomeArquivo.substr(2, 2);
                parametrosExportacao.localidade = nomeArquivo.substr(4, 2);
                parametrosExportacao.rota = nomeArquivo.substr(6, 3);
                parametrosExportacao.sequencia = nomeArquivo.substr(9, 3);

                return true;
            }

            return false;
        }

        function _validarNomeArquivoPadrao(nomeArquivo, parametrosExportacao, apiLf, tipoProcesso) {
            var padraoRegex = "(^[0-9]{8}\.REM$)";

            if (tipoProcesso == 2) {
                if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "AAMMGGGG.REM")) {
                    var ano = parseInt(nomeArquivo.substr(0, 2)) + 2000;
                    var mes = parseInt(nomeArquivo.substr(2, 2));
                    var grupo = nomeArquivo.substr(4, 4);

                    if (mes < 1 || mes > 12) {
                        MdDialogService.alertPadrao("O mês é inválido (" + mes + "), o nome do arquivo deve ter a seguinte estrutura: 'AAMMGGGG.REM'.");
                        apiLf.removeAll();
                        return false;
                    }
                    parametrosExportacao.mesDistribuicao = mes;
                    parametrosExportacao.anoDistribuicao = ano;
                    parametrosExportacao.grupoDistribuicao = grupo;
                    return true;
                }
            } else {
                if (_validarNomeArquivoPorRegex(nomeArquivo, padraoRegex, apiLf, "AAMMDDOO.REM")) {
                    var ano = parseInt(nomeArquivo.substr(0, 2)) + 2000;
                    var mes = parseInt(nomeArquivo.substr(2, 2)) - 1;
                    var dia = parseInt(nomeArquivo.substr(4, 2));

                    parametrosExportacao.dataOrigem = new Date(ano, mes, dia);
                    parametrosExportacao.origem = "0" + nomeArquivo.substr(6, 2);

                    parametrosExportacao.mesDistribuicao = mes + 1;
                    parametrosExportacao.anoDistribuicao = ano;
                    parametrosExportacao.grupoDistribuicao = "0" + nomeArquivo.substr(6, 2);
                    return true;
                }
            }

            return false;
        }

        function _validarNomeArquivoPorRegex(nomeArquivo, regex, apiLf, padraoArquivo) {
            var padraoRegex = new RegExp(regex, "g");
            if (!padraoRegex.test(nomeArquivo)) {
                MdDialogService.alertPadrao("Nome do arquivo inválido, o mesmo deve ter a seguinte estrutura: '" + padraoArquivo + "'.");
                apiLf.removeAll();
                return false;
            }

            return true;
        }
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile')
        .service('ExportacaoMobileService', ExportacaoMobileService);

    /** @ngInject */
    function ExportacaoMobileService(ValidacaoService, MdDialogService, ValidacaoNomeArquivoExportacaoService) {

        //#region Definição dos métodos

        this.fabricarValidacaoNomeArquivo = _fabricarValidacaoNomeArquivo;
        this.fabricarValidacaoNomeArquivoGrupo = _fabricarValidacaoNomeArquivoGrupo;

        //#endregion

        //#region Implementação dos Métodos

        function _fabricarValidacaoNomeArquivo(leiturista, parametros) {
            switch (leiturista.inT_LeituristaConfiguracao.arqCodigo) {
                case 1: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo1;
                }
                case 3: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo3;
                }
                case 11: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo11;
                }
                case 12: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo12;
                }
                case 14: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo14;
                }
                case 17: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo17;
                }
                case 20: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo20;
                }
                case 22: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo22;
                }
                default: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivoPadrao;
                }
            }
        }

        function _fabricarValidacaoNomeArquivoGrupo(arqCodigo, parametros) {
            switch (arqCodigo) {
                case 1: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo1;
                }
                case 3: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo3;
                }
                case 11: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo11;
                }
                case 12: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo12;
                }
                case 14: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo14;
                }
                case 17: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo17;
                }
                case 20: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo20;
                }
                case 21: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivo21;
                }
                default: {
                    return ValidacaoNomeArquivoExportacaoService.validarNomeArquivoPadrao;
                }
            }
        }
        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile')
        .controller('DisponibilizarCargaFiorilliController', DisponibilizarCargaFiorilliController);

    function DisponibilizarCargaFiorilliController
        (
            SessionStorageService,
            KeysSessionStorage,
            Api,
            RequisicaoGenericaService,
            MdDialogService,
            ValidacaoService,
            ParametrosFactory,
            $scope,
            ExportacaoMobileService,
            ServicosGenericoService,
            LeituristaUtilsService,
            $mdDialog,
            LeituristaCodigo,
            DisponibilizarCargaRetidasService,
            $q,
            $timeout
        ) {

        var vm = this;
        vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        vm.tipoProcesso = SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso);
        vm.parametrosExportacao = {};

        vm.metodos = {
            disponibilizarCarga: disponibilizarCarga,
            configurarSelect: configurarSelect,
            controlaTelaPorTipoArquivo: controlaTelaPorTipoArquivo
        };

        init();

        function init() {
            vm.form = {};
            vm.entidade = {};
            vm.filtro = {};
            vm.filtro.leituristas = [];

            vm.emProgresso = true;
            _buscarLeituristasAtivos();
        }

        function disponibilizarCarga() {
            if (vm.disponibilizarCargaForm.$invalid) {
                MdDialogService.alertPadrao("Por favor, preencha todos os campos obrigatórios.");
                return;
            }

            var leituristasSelecionados = vm.filtro.leituristas.length > 0 ? vm.filtro.leituristas : vm.leituristas;

            if (leituristasSelecionados.length === 0) {
                MdDialogService.alertPadrao("Nenhum leiturista selecionado.");
                return;
            }

            vm.emProgresso = true;

            var dialogConfig = {
                title: 'Aguarde... Realizando disponibilização de carga.',
                body: 'Iniciando...',
                progress: ''
            };
            MdDialogService.abrirDialogProcessamento(dialogConfig);

            var sucessos = [];
            var erros = [];
            var total = leituristasSelecionados.length;

            leituristasSelecionados.reduce(function (promise, leiturista, index) {
                return promise.then(function () {
                    var dadosFormulario = {
                        leiturista: leiturista.codigo,
                        mes: vm.entidade.mes,
                        ano: vm.entidade.ano
                    };

                    dialogConfig.body = 'Enviando carga do leiturista: ' + leiturista.nome;
                    dialogConfig.progress = (index + 1) + ' / ' + total;

                    return _realizarDisponibilizacaoCarga(dadosFormulario).then(
                        function (response) {
                            sucessos.push({
                                codigo: leiturista.codigo,
                                nome: leiturista.nome
                            });
                        },
                        function (error) {
                            var mensagemErro = 'Ocorreu uma falha no processamento.';
                            if (error && error.data) {
                                mensagemErro = error.data.message || error.data;
                            }
                            erros.push({
                                codigo: leiturista.codigo,
                                nome: leiturista.nome,
                                erro: mensagemErro
                            });
                        }
                    );
                });
            }, $q.when()).then(function () {
                vm.emProgresso = false;
                MdDialogService.fecharDialogProcessamento();

                var resultados = [];

                erros.forEach(function (leiturista) {
                    resultados.push({
                        titulo: leiturista.codigo + ' - ' + leiturista.nome,
                        mensagem: leiturista.erro,
                        iconSrc: 'assets/icons/erro.svg',
                        iconColor: '#d70022'
                    });
                });

                sucessos.forEach(function (leiturista) {
                    resultados.push({
                        titulo: leiturista.codigo + ' - ' + leiturista.nome,
                        mensagem: 'Disponibilizado com sucesso.',
                        iconSrc: 'assets/icons/confirma.svg',
                        iconColor: '#12bc00'
                    });
                });

                MdDialogService.abrirDialogResultados({
                    title: 'Atenção!',
                    mensagem: 'O processo de distribuição foi concluído. Veja o status de cada leiturista abaixo:',
                    resultados: resultados
                });
            });
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element(document.querySelector('#select-header-input-search'))
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function controlaTelaPorTipoArquivo() {
            if (!vm.codigoLeiturista)
                return;

            if (typeof vm.codigoLeiturista != 'number')
                vm.codigoLeiturista = parseInt(vm.codigoLeiturista);

            ValidacaoService.validarParametroNumber(vm.codigoLeiturista);

            var leiturista = LeituristaUtilsService.retornarLeituristaPorCodigo(vm.leituristas, vm.codigoLeiturista);

            if (!leiturista)
                return;

        }

        function _buscarLeituristasAtivos() {
            vm.emProgresso = true;
            RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos).then(
                function (success) {
                    vm.leituristas = success.data;
                    if (vm.leituristas.length == 0)
                        MdDialogService.alertPadrao("Não existem leituristas cadastrados ou ativos, por favor verifique.");
                    else if (LeituristaCodigo != 0) {
                        vm.codigoLeiturista = LeituristaCodigo;
                    }
                    vm.emProgresso = false;
                },
                function (error) {
                    vm.emProgresso = false;
                    MdDialogService.alertPadrao("Falha ao carregar os leituristas.\n\nDetalhes: " + error.data);
                }
            );
        }

        function _realizarDisponibilizacaoCarga(dadosFormulario) {
            return RequisicaoGenericaService.salvar(Api.exportacao.fiorilli, dadosFormulario);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exclusaoarquivo', ['lfNgMdFileInput'])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.exclusaoArquivo;

        $stateProvider
            .state('app.exclusao_arquivo', {
                url: '/processamento/exclusaoarquivo',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ExclusaoArquivoController as vm',
                        abstract: true
                    },
                    'exclusao_arquivo-form@app.exclusao_arquivo': {
                        templateUrl: rotasHtml.form,
                    },
                },
                resolve: {
                    retornarArquivoPadrao: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.retornarArquivoPadrao);
                    },
                    listarAgrupamentos: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.agrupamento.listarTodos);
                    }
                }
            });
    }
}());

(function () {
    'use strict';

    angular
        .module('app.processamento.exclusaoarquivo')
        .service('ExclusaoArquivoService', ExclusaoArquivoService)

    /** @ngInject */
    function ExclusaoArquivoService(RequisicaoGenericaService, Api) {

        var service = {
            filtrarArquivos: filtrarArquivos,
            validarArquivo: validarArquivo,
            excluirArquivo: excluirArquivo,
            filtrarMunicipios: filtrarMunicipios
        }

        function filtrarArquivos(model) {
            return RequisicaoGenericaService.salvar(Api.exclusaoArquivo.filtrarArquivos, model);
        }

        function validarArquivo(arquivos) {
            return RequisicaoGenericaService.salvar(Api.exclusaoArquivo.validarArquivo, { listaArquivos: arquivos });
        }

        function excluirArquivo(arquivos, senhaImplantacao) {
            return RequisicaoGenericaService.excluirSemUrl(Api.exclusaoArquivo.deletarArquivo, { listaArquivos: arquivos, senhaImplantacao: senhaImplantacao });
        }

        function filtrarMunicipios(regional) {
            return RequisicaoGenericaService.listarSemParams(Api.municipio.retornarMunicipios + '?regional=' + regional);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.downloadfotos', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.downloadfotos;

        $stateProvider
            .state('app.download_fotos', {
                url: '/processamento/downloadfotos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'DownloadFotosController as vm',
                        abstract: true
                    },

                    'downloadfotos-form@app.download_fotos': {
                        templateUrl: rotasHtml.form,
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.processamento.downloadfotos')
        .service('DownloadFotosService', DownloadFotosService)

    /** @ngInject */
    function DownloadFotosService(Api, RequisicaoGenericaService) {

        var service = {
            retornarArquivosMesAnoReferencia: retornarArquivosMesAnoReferencia,
            retornarListagemFotosCliente: retornarListagemFotosCliente,
            gerarZipDownload: gerarZipDownload
        }

        function retornarArquivosMesAnoReferencia(filtro) {
            return RequisicaoGenericaService.salvar(Api.downloadFotos.retornarArquivosMesAnoReferencia, filtro);
        }

        function retornarListagemFotosCliente(filtro) {
            return RequisicaoGenericaService.salvar(Api.downloadFotos.retornarListagemFotosCliente, filtro);
        }

        function gerarZipDownload(filtro) {
            return RequisicaoGenericaService.salvar(Api.downloadFotos.gerarZipDownload, filtro);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .service('DistribuicaoService', DistribuicaoService)

    /** @ngInject */
    function DistribuicaoService($q, $mdDialog, RotasHtml, SessionStorageService, KeysSessionStorage) {

        var _filtro;

        var service = {
            abrirDialogSelecionarSetor: abrirDialogSelecionarSetor,
            reodernarTarefas: reodernarTarefas,
            setFiltroDistribuicao: setFiltroDistribuicao,
            getFiltroDistribuicao: getFiltroDistribuicao,
            abrirDialogSelecionarQuadra: abrirDialogSelecionarQuadra,
            abrirDialogCalculoDistribuicaoAutomatica: abrirDialogCalculoDistribuicaoAutomatica
        }

        function setFiltroDistribuicao(filtro) {
            _filtro = angular.copy(filtro);
        }

        function getFiltroDistribuicao() {
            return angular.copy(_filtro);
        }

        function abrirDialogSelecionarSetor(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao, tarefas) {
            var parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            var deferred = $q.defer()
            var numeroPrimeiraTarefa = dadosDistribuicao[0].tarefa;
            var retorno = {
                resumoDistribuicao: resumoDistribuicao
            }

            var setores = dadosDistribuicao.map(function (item) {
                return {
                    setor: item.setor,
                    quantidade: item.quantidade
                }
            });


            if (tipoDistribuicao === 3) {
                var setoresPorQuadra = [];
                setores.forEach(function (setor) {
                    if (setoresPorQuadra.some(function (item) { return item.setor == setor.setor })) {
                        var item = setoresPorQuadra.filter(function (setorNoArray) {
                            return setor.setor == setorNoArray.setor
                        })[0];
                        setoresPorQuadra[setoresPorQuadra.indexOf(item)].quantidade += setor.quantidade;
                    }
                    else {
                        setoresPorQuadra.push(setor);
                    }
                });
                setores = setoresPorQuadra;
            }
            if (tipoDistribuicao === 1) {
                var setoresPorRota = [];
                setores.forEach(function (setor) {
                    if (setoresPorRota.some(function (item) { return item.setor == setor.setor })) {
                        var item = setoresPorRota.filter(function (setorNoArray) {
                            return setor.setor == setorNoArray.setor
                        })[0];
                        setoresPorRota[setoresPorRota.indexOf(item)].quantidade += setor.quantidade;
                    }
                    else {
                        setoresPorRota.push(setor);
                    }
                });
                setores = setoresPorRota;
            }


            if (tarefas && tarefas.length) {
                var setoresMarcados = tarefas.map(function (item) {
                    return item.setor;
                });
                tarefas = [];
            }
            $mdDialog.show({
                controller: 'DialogSelecionarSetoresController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.distribuicao.dialogs.selecionarSetores,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Setores: setores,
                    SetoresMarcados: setoresMarcados
                }
            }).then(function (setores) {
                var success = dadosDistribuicao.filter(function (item) {
                    return setores.includes(item.setor);
                });
                reodernarTarefas(success, numeroPrimeiraTarefa);
                retorno.detalhesDistribuicao = success;
                retorno.numeroPrimeiraTarefa = numeroPrimeiraTarefa;
                deferred.resolve(retorno);
            }, function () {
                retorno.detalhesDistribuicao = dadosDistribuicao;
                retorno.numeroPrimeiraTarefa = numeroPrimeiraTarefa;
                deferred.reject(retorno);
            });

            return deferred.promise;
        }

        function reodernarTarefas(tarefas, numeroPrimeiraTarefa) {
            tarefas.forEach(function (item, index) {
                item.tarefa = numeroPrimeiraTarefa + index;
            });
        }


        function abrirDialogSelecionarQuadra(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao, tarefas) {

            var deferred = $q.defer()
            var numeroPrimeiraTarefa = dadosDistribuicao[0].tarefa;
            var retorno = {
                resumoDistribuicao: resumoDistribuicao
            }

            var quadras = dadosDistribuicao.map(function (item) {
                return {
                    quadra: item.quadra,
                    quantidade: item.quantidade
                }
            });

            if (tarefas && tarefas.length) {
                var quadrasMarcadas = tarefas.map(function (item) {
                    return item.quadra;
                });
                tarefas = [];
            }

            $mdDialog.show({
                controller: 'DialogSelecionarQuadrasController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.distribuicao.dialogs.selecionarQuadras,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Quadras: quadras,
                    QuadrasMarcadas: quadrasMarcadas
                }
            }).then(function (quadras) {
                var success = dadosDistribuicao.filter(function (item) {
                    return quadras.includes(item.quadra);
                });
                reodernarTarefas(success, numeroPrimeiraTarefa);
                retorno.detalhesDistribuicao = success;
                retorno.numeroPrimeiraTarefa = numeroPrimeiraTarefa;
                deferred.resolve(retorno);
            }, function () {
                retorno.detalhesDistribuicao = dadosDistribuicao;
                retorno.numeroPrimeiraTarefa = numeroPrimeiraTarefa;
                deferred.reject(retorno);
            });

            return deferred.promise;


        }

        function abrirDialogCalculoDistribuicaoAutomatica(leiturasAhDistribuir) {

            var deferred = $q.defer()

            $mdDialog.show({
                controller: 'CalculoDistribuicaoAutomaticaController',
                controllerAs: 'vm',
                templateUrl: RotasHtml.distribuicao.dialogs.calculoDistribuicaoAutomatica,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    LeiturasAhDistribuir: leiturasAhDistribuir,
                }
            }).then(function (quantidadeTarefas) {
                deferred.resolve(quantidadeTarefas);
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        return service;

    }

}());
(function(){
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .service('DistribuicaoFiltroService', DistribuicaoFiltroService)

    /** @ngInject */
    function DistribuicaoFiltroService($q, Api, RequisicaoGenericaService, SessionStorageService, KeysSessionStorage, DistribuicaoService, $rootScope, MdDialogService){

        var service = {
            filtrarDadosDistribuicao: filtrarDadosDistribuicao,
            consistirLeiturasDistribuidas: consistirLeiturasDistribuidas,
            carregarDadosDistribuicao: carregarDadosDistribuicao,
            pesquisarGrupos: pesquisarGrupos,
            pesquisarAgrupamentos: pesquisarAgrupamentos,
            pesquisarMunicipiosPorAgrupamento: pesquisarMunicipiosPorAgrupamento,
            pesquisarTiposDistribuicao: pesquisarTiposDistribuicao,
            configurarMdSelect: configurarMdSelect,
            retornarParametros: retornarParametros,
            construirFiltro: construirFiltro            
        }


        function filtrarDadosDistribuicao(filtro){
            var deferred = $q.defer();
            filtro.mes = filtro.mes.toString().padStart(2, '0');            
            DistribuicaoService.setFiltroDistribuicao(filtro);
            RequisicaoGenericaService.salvar(Api.distribuicao.verificarLeituraExisteGrupo, filtro).then(
                function (success) {deferred.resolve(success.data);},
                function (error) {deferred.reject(error.data);}
            );
            return deferred.promise;
        }

        function consistirLeiturasDistribuidas(filtro){
            return RequisicaoGenericaService.salvar(Api.distribuicao.consistirLeiturasDistribuidas, filtro);
        }

        function carregarDadosDistribuicao(filtro){
            return RequisicaoGenericaService.salvar(Api.distribuicao.carregarDadosDistribuicaoPorRota, filtro);
        }

        function construirFiltro(){
            var data = new Date();
            return {
                mes: data.getMonth() + 1,
                ano: data.getFullYear()
            }
        }

        function pesquisarGrupos(regional, mes, ano){
            var deferred = $q.defer();
            mes = mes.toString().padStart(2, '0');
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {                        
                       deferred.reject(error.data);
                    }
                );
            return deferred.promise;
        }

        function pesquisarAgrupamentos(){
            return SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
        }

        function pesquisarMunicipiosPorAgrupamento(regional, mes, ano, grupo){
            var deferred = $q.defer();
            mes = mes.toString().padStart(2, '0');
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        deferred.resolve(success.data);                      
                    },
                    function (error) {                       
                        deferred.reject(error.data);
                    }
                )
            return deferred.promise;
        }

        function pesquisarTiposDistribuicao(){
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(Api.distribuicao.retornarTipoDistribuicao).then(
                function (success) {                    
                    deferred.resolve(success.data);
                },
                function (error) {                   
                    deferred.reject(error.data);
                }
            )
            return deferred.promise;
        }

        function configurarMdSelect(selectId){
            angular.element(selectId).on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }


        function retornarParametros(){
            return SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        }

        return service;        
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizarcargaretidas')
        .service('DisponibilizarCargaRetidasService', DisponibilizarCargaRetidasService);

    /** @ngInject */
    function DisponibilizarCargaRetidasService(Api, RequisicaoGenericaService) {
        var service = {
            listarFaturasRetidas: listarFaturasRetidas,
            disponibilizarCargaRetidas: disponibilizarCargaRetidas,
            disponibilizarUnificadoArquivo: disponibilizarUnificadoArquivo
        };

        var api = Api.disponibilizarCargaRetidas;

        function listarFaturasRetidas(nomeArquivoExportacao) {
            return RequisicaoGenericaService.listarSemParams(api.listarFaturasRetidas + "?nomeArquivoExportacao=" + nomeArquivoExportacao);
        }

        function disponibilizarCargaRetidas(faturasSelecionadas, codigoLeiturista) {
            return RequisicaoGenericaService.salvar(api.disponibilizarCarga, {
                ligacaoFaturasRetidas: faturasSelecionadas,
                leiturista: codigoLeiturista
            });
        }

        function disponibilizarUnificadoArquivo(faturasSelecionadas, codigoLeiturista, nomeArquivo) {
            return RequisicaoGenericaService.salvar(api.disponibilizarUnificadoArquivo, {
                ligacaoFaturasRetidas: faturasSelecionadas,
                leiturista: codigoLeiturista,
                nomeArquivoExportacao: nomeArquivo
            });
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.cancelamentofaturasretidas', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.cancelamentoFaturasRetidas;

        $stateProvider
            .state('app.cancelamento_faturas_retidas', {
                url: '/processamento/cancelarretidasdisponibilizadas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'CancelamentoFaturasRetidasController as vm',
                        abstract: true
                    },
                    'cancelamentofaturasretidas-form@app.cancelamento_faturas_retidas': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    FaturasRetidasCancelamento: function (CancelamentoFaturasRetidasService) {
                        return CancelamentoFaturasRetidasService.listarLigacoesRetidasCancelamento();
                    }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.cancelamentofaturasretidas')
        .service('CancelamentoFaturasRetidasService', CancelamentoFaturasRetidasService);

    /** @ngInject */
    function CancelamentoFaturasRetidasService(Api, RequisicaoGenericaService) {
        var service = {
            listarLigacoesRetidasCancelamento: listarLigacoesRetidasCancelamento,
            cancelarLigacoesRetidas: cancelarLigacoesRetidas
        };

        var api = Api.cancelamentoFaturasRetidas;

        function listarLigacoesRetidasCancelamento() {
            return RequisicaoGenericaService.listarSemParams(api.listarLigacoesRetidasCancelamento);
        }

        function cancelarLigacoesRetidas(faturas) {
            return RequisicaoGenericaService.salvar(api.cancelarLigacoesRetidas, faturas);
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.alertacliente')
        .service('AlertaClienteHttpService', AlertaClienteHttpService);

    /** @ngInject */
    function AlertaClienteHttpService(Api, RequisicaoGenericaService) {
        var service = {
            listarTodos: listarTodos,
            salvar: salvar,
            editar: editar,
            excluir: excluir
        };

        var api = Api.alertaCliente;


        function listarTodos() {
            return RequisicaoGenericaService.listarSemParams(api.listarTodos);
        }

        function salvar(alerta) {
            return RequisicaoGenericaService.salvar(api.salvar, alerta);
        }

        function editar(alerta) {
            return RequisicaoGenericaService.editar(api.salvar, alerta);
        }

        function excluir(alertas) {
            return RequisicaoGenericaService.excluirSemUrl(api.excluir, alertas);
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('VivaAguaService', VivaAguaService)

    /** @ngInject */
    function VivaAguaService(RequisicaoGenericaService, Api, MdDialogService) {

        var service = {
            gerarRelatorio: gerarRelatorio,
            filtrarRelatorioPlanilha: filtrarRelatorioPlanilha,
            gerarRelatorioPlanilha: gerarRelatorioPlanilha,
            consultarClientes: consultarClientes,
            buscarSetores: buscarSetores,
            buscarGrupos: buscarGrupos,
            selecionarArquivo: selecionarArquivo
        };

        function gerarRelatorio(filtro) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.vivaAgua.gerarRelatorio, filtro);
        }

        function filtrarRelatorioPlanilha(arquivo) {
            return RequisicaoGenericaService.salvar(Api.relatorios.vivaAgua.retornarClientesLocalidadesPorPlanilha, arquivo);
        }

        function gerarRelatorioPlanilha(localidade) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.vivaAgua.gerarRelatorioPlanilha, localidade);
        }

        function consultarClientes(filtro) {
            return RequisicaoGenericaService.salvar(Api.relatorios.vivaAgua.consultarClientes, filtro);
        }

        function buscarSetores(regional, mes, ano, grupo) {
            return RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo);
        }

        function buscarGrupos(regional, mes, ano) {
            return RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano);
        }

        function selecionarArquivo(event, arquivo, functionOnLoad) {
            if (arquivo) {
                if (!_validarExtensaoArquivoValido(arquivo.name)) {
                    return undefined;
                }

                var leituraArquivo = new FileReader();

                leituraArquivo.readAsArrayBuffer(arquivo);
                leituraArquivo.onload = functionOnLoad;
                leituraArquivo.onerror = function (event) {
                    MdDialogService.alertPadrao("Erro ao carregar o arquivo: " + event, event);
                }

                arquivo.leituraArquivo = leituraArquivo;
                return arquivo;
            }
        }

        function _validarExtensaoArquivoValido(arquivo) {
            var partes = arquivo.split(".");
            var extensao = partes[partes.length - 1];

            if (extensao != "xlsx") {
                MdDialogService.alertPadrao("Arquivo inválido! O arquivo deve ter a extensão xlsx.");
                return false;
            }

            return true;
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.relatorios.vivaagua', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.vivaAgua;
        //State
        $stateProvider
            .state('app.relatorios_vivaagua', {
                url: '/relatorios/espelhovivaagua',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'VivaAguaController as vm'
                    },
                    'relatorios-form@app.relatorios_vivaagua': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                }
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.vivaagua')
        .controller('VivaAguaLocalidadesDialogController', VivaAguaLocalidadesDialogController)

    /** @ngInject */
    function VivaAguaLocalidadesDialogController($mdDialog, Localidades, DatatableFactory, MdDialogService, VivaAguaService) {
        var vm = this;

        vm.metodos = {
            fecharDialog: fecharDialog,
            gerarRelatorio: gerarRelatorio,
            gerarRelatorioTodasLocalidades: gerarRelatorioTodasLocalidades
        }

        init();

        function init() {
            vm.emProgresso = false;
            vm.infoLocalidadeSelecionada = "";
            vm.localidades = Localidades;

            vm.options = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [1, 2, 3, 4],
                    orderable: false
                },
                {
                    targets: [3],
                    width: '40%'
                },
                {
                    targets: [0],
                    width: '25%'
                },
                {
                    targets: [1, 2],
                    width: '15%'
                },
                {
                    targets: [4],
                    width: '5%'
                }
            ]);
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function gerarRelatorio(localidade) {
            vm.emProgresso = true;
            vm.infoLocalidadeSelecionada = "Localidade: " + localidade.codigoLocalidade + " - " + localidade.descricaoLocalidade;

            VivaAguaService.gerarRelatorioPlanilha([localidade])
                .then(
                    function (success) {
                        MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                        var file = new Blob([success.data], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    },
                    function (error) {
                        MdDialogService.alertPadrao(_arrayBufferToString(error.data));
                    }).finally(function () {
                        vm.emProgresso = false;
                        vm.infoLocalidadeSelecionada = "";
                    });
        }

        function gerarRelatorioTodasLocalidades() {
            vm.emProgresso = true;
            vm.infoLocalidadeSelecionada = "Todas localidades";

            VivaAguaService.gerarRelatorioPlanilha(vm.localidades)
                .then(
                    function (success) {
                        MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                        var file = new Blob([success.data], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    },
                    function (error) {
                        MdDialogService.alertPadrao(_arrayBufferToString(error.data));
                    }).finally(function () {
                        vm.emProgresso = false;
                        vm.infoLocalidadeSelecionada = "";
                    });
        }

        function _arrayBufferToString(buffer) {
            var arr = new Uint8Array(buffer);
            var enc = new TextDecoder("utf-8");
            var str = enc.decode(arr);

            return str;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('PersonalizadoRelatorioService', PersonalizadoRelatorioService)

    /** @ngInject */
    function PersonalizadoRelatorioService(RequisicaoGenericaService, Api) {

        var service = {
            consultar: consultar,
        };

      function consultar(query, apenasPlanilha ) {
          var filtro = {
            querySQL: query,
            apenasPlanilha: apenasPlanilha
          };
          return RequisicaoGenericaService.salvar(Api.relatorios.personalizado.consultar, filtro);
        }

        return service;
    }
}());

(function () {
    'use strict';

    angular
        .module('app.relatorios.personalizado', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.personalizado;
        //State
        $stateProvider
            .state('app.relatorios_personalizado', {
                url: '/relatorios/personalizado',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'PersonalizadoRelatorioController as vm'
                    },
                    'relatorios-form@app.relatorios_personalizado': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                }
            });
    }
})();

(function () {
  "use strict";

  angular
    .module("app.relatorios.personalizado")
    .controller(
      "PersonalizadoPlanilhaDialogController",
      PersonalizadoPlanilhaDialogController
    );

  /** @ngInject */
  function PersonalizadoPlanilhaDialogController($mdDialog) {
    var vm = this;

    vm.nomePlanilha = "";

    vm.metodos = {
      fecharDialog: fecharDialog,
    };

    function fecharDialog() {
      $mdDialog.hide(vm.nomePlanilha);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.faturamento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.faturamento;
        //State
        $stateProvider
            .state('app.relatorios_faturamento', {
                url: '/relatorios/faturamento',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'FaturamentoController as vm'
                    },
                    'relatorios-form@app.relatorios_faturamento': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    listarOcorrencias: function (Api, RequisicaoGenericaService) {                                                
                        return RequisicaoGenericaService.listarSemParams(Api.ocorrencia.listarTodosMenosNormal);
                    },
                    ListarLocalidades: function (SessionStorageService, KeysSessionStorage, Api, RequisicaoGenericaService) {
                        var parametrosEmpresa = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
                        var codigoImanager = parametrosEmpresa.empresa.codigoImanager;                                         
                        if (codigoImanager === '3821') {
                            return RequisicaoGenericaService.listarSemParams(Api.relatorios.faturamento.listarLocalidades);
                        } else {
                            return;
                        }
                    }
                }
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.faturamento')
        .controller('FaturamentoServicosPrestadosDialogController', FaturamentoServicosPrestadosDialogController);

    function FaturamentoServicosPrestadosDialogController($mdDialog, Servicos, DatatableFactory, MdDialogService) {
        var vm = this;

        init();

        function init() {
            vm.preLoader = false;
            vm.servicos = Servicos;
            vm.entidade = {
                valorUnitario: 0,
                quantidade: 0,
                descricao: ''
            };
            vm.codigo = 0;
            vm.valorTotal = vm.servicos.reduce(function (prevValue, currentValue) {
                return currentValue.total + prevValue;
            }, 0);
            vm.servicos.map(function (item) {
                return vm.codigo++;
            });

        }

        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao([
            {
                targets: 5,
                responsivePriority: 1
            }
        ]);

    vm.metodos = {
        fecharDialog: fecharDialog,
        confirmar: confirmar,
        adicionarServico: adicionarServico,
        removerServico: removerServico
    }

    function fecharDialog() {
        $mdDialog.cancel();
    }

    function confirmar() {
        $mdDialog.hide();
    }

    function adicionarServico() {
        var _mensagem = _validarServico(vm.entidade);
        if (_mensagem == '') {
            var servico = {
                codigo: ++vm.codigo,
                quantidade: vm.entidade.quantidade,
                valorUnitario: vm.entidade.valorUnitario,
                descricao: vm.entidade.descricao,
                total: vm.entidade.quantidade * vm.entidade.valorUnitario
            };
            vm.valorTotal += servico.total;
            vm.servicos.push(servico);
            vm.entidade = {
                valorUnitario: 0,
                quantidade: 0,
                descricao: ''
            };         
        }
        else {
            MdDialogService.alertPadrao(_mensagem);
        }

    }

    function _validarServico(entidade) {

        if (entidade.descricao == '')
            return 'A descrição deve ser informada.';
        else if (entidade.quantidade == 0)
            return 'A quantidade não pode ser 0.';
        else if (entidade.valorUnitario == 0)
            return 'O valor não pode ser 0.';
        else
            return '';
    }

    function removerServico(index) {
        vm.valorTotal -= vm.servicos[index].total;
        console.log(vm.valorTotal);
        vm.servicos.splice(index, 1);
    }

}
}) ();

(function () {
    'use strict';

    angular
        .module('app.relatorios.logs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.logs;
        //State
        $stateProvider
            .state('app.relatorios_logs', {
                url: '/relatorios/logs',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,                                      
                        controller: 'LogsController as vm'
                    },
                    'relatorios-form@app.relatorios_logs': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                        listarLeituristas: function (Api, RequisicaoGenericaService) {
                            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
                        }
                }
            });
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.logs')
        .controller('SelecionarArquivoLogDialogController', SelecionarArquivoLogDialogController)

    /** @ngInject */
    function SelecionarArquivoLogDialogController($mdDialog, Logs, ViewModel, LogsServico, $window, urlApi, MdDialogService) {
        var vm = this;

        vm.metodos = {
            fecharDialog: fecharDialog,
            gerarRelatorio: gerarRelatorio
        }

        init();

        function init() {
            vm.entidade = ViewModel;
            vm.logs = Logs;
            vm.exibirDataColeta = vm.entidade.gerarRelatorioPorCarga === 'N';
            vm.options = {
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                responsive: true,
                columnDefs: [
                    {
                        targets: 0,
                        responsivePriority: 1,
                    },
                    {
                        targets: 1,
                        responsivePriority: 3,

                    },
                    {
                        targets: 3,
                        responsivePriority: 3,

                    },
                    {
                        targets: 2,
                        responsivePriority: 3,

                    },
                    {
                        targets: 4,
                        responsivePriority: 1
                    }
                ],
                oLanguage: {
                    "sInfo": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    "sSearch": "Pesquisar: ",
                    "sLengthMenu": 'Exibir <select>' +
                        '<option value="10">10</option>' +
                        '<option value="20">20</option>' +
                        '<option value="50">50</option>' +
                        '<option value="100">100</option>' +
                        '</select> registros',
                    oPaginate: {
                        "sPrevious": "Anterior",
                        "sNext": "Próximo",
                        "sLast": "Anterior",
                        "sShow": "Exibir"
                    }
                }
            }
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function gerarRelatorio(log) {
            inicioProgressoRelatorio();
            vm.infoArquivoSelecionado = 'Arquivo: ' +
                log.arquivoExportacao + '\n' +
                'Leiturista: ' +
                log.leiturista + '\n';

            if (vm.entidade.gerarRelatorioPorCarga === 'N') {
                vm.infoArquivoSelecionado += 'Data de execução: ' + new Date(log.dataExecucao).toLocaleDateString();
            }

            var viewModel = {
                dadosLog: {
                    leiturista: log.leiturista,
                    dataExecucao: log.dataExecucao,
                    codigoLeiturista: log.codigoLeiturista,
                    arquivoExportacao: log.arquivoExportacao,
                },
                ordenacao: vm.entidade.ordenacao,
                filtrosUtilizados: LogsServico.constroiFiltrosUtilizados(vm.entidade),
                exibirGrafico: vm.entidade.exibirGrafico,
                gerarRelatorioPorCarga: vm.entidade.gerarRelatorioPorCarga
            };
            LogsServico.enviarFormulario(viewModel)
                .then(function (success) {
                    fimProgressoRelatorio();
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                },
                    function (error) {
                        fimProgressoRelatorio();
                        MdDialogService.alertPadrao(_arrayBufferToString(error.data));
                    }
                );
        }

        function inicioProgressoRelatorio() {
            vm.relatorioEmProgresso = true;
        }
        function fimProgressoRelatorio() {
            vm.relatorioEmProgresso = false;
        }

        function _arrayBufferToString(buffer) {
            var arr = new Uint8Array(buffer);
            var enc = new TextDecoder("utf-8");
            var str = enc.decode(arr);

            return str;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('FaturasRetidasService', FaturasRetidasService);

    /** @ngInject */
    function FaturasRetidasService(RequisicaoGenericaService, Api) {

        var service = {
            gerarRelatorio: gerarRelatorio,
        };

        function gerarRelatorio(filtro) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.faturasRetidas.gerarRelatorio, filtro);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('AlertaClienteRelatorioService', AlertaClienteRelatorioService)

    /** @ngInject */
    function AlertaClienteRelatorioService(RequisicaoGenericaService, Api) {

        var service = {
            gerarRelatorio: gerarRelatorio,
        };

        function gerarRelatorio(filtro) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.alertaCliente.gerarRelatorio, filtro);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ClientesNaoVisitadosService', ClientesNaoVisitadosService)

    /** @ngInject */
    function ClientesNaoVisitadosService(RequisicaoGenericaService, Api) {

        var service = {
            gerarRelatorio: gerarRelatorio,
            filtrarGrupos: filtrarGrupos
        };

        function gerarRelatorio(filtro) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.clientesNaoVisitados.gerarRelatorio, filtro);
        }

        function filtrarGrupos(mes, ano) {
            return RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional + '?regional=&mes=' + mes.toString().padStart(2, '0') + '&ano=' + ano);
        }

        return service;
    }

}());
(function () {
  'use strict';

  angular
    .module('app.service')
    .service('HistoricoConsumoService', HistoricoConsumoService)

  /** @ngInject */
  function HistoricoConsumoService(RequisicaoGenericaService, Api) {

    var service = {
      gerarRelatorio: gerarRelatorio,
    };

    function gerarRelatorio(filtro) {
      return RequisicaoGenericaService.downloadPDF(Api.relatorios.historicoConsumo.gerarRelatorio, filtro);
    }

    return service;
  }

}());
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.inicio', [])
        .config(Config);

    function Config($stateProvider) {
        $stateProvider
            .state('app.inicio', {
                url: '/inicio',
                module: 'privado',
                params: {
                    vemDoLogin: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/inicio/views/inicio.html',
                        controller: 'InicioController as vm'
                    }
                },
                resolve: {
                    VerificacaoDatamobil: function ($stateParams, $injector, $q) {
                        if (!$stateParams.vemDoLogin) {
                            return $q.resolve(null);
                        }

                        try {
                            var RequisicaoDatamobilService = $injector.get('RequisicaoDatamobilService');
                            var DatamobilIaService = $injector.get('DatamobilIaService');

                            return RequisicaoDatamobilService.autenticar().then(function () {
                                return DatamobilIaService.obterConfiguracaoCliente();
                            }).catch(function () {
                                return $q.resolve(null);
                            });
                        } catch (e) {
                            return $q.resolve(null);
                        }
                    }
                }
            });

    }

})();


(function () {
    'use strict';

    angular
        .module('app.inicio')
        .controller('DialogDatamobilController', DialogDatamobilController);

    function DialogDatamobilController($mdDialog, $state) {
        var vm = this;

        vm.fechar = function () {
            $mdDialog.hide();
        };

        vm.irParaDatamobil = function () {
            $state.go('app.datamobil');
            $mdDialog.hide();
        };
    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.carga', [])
    .config(Config);

  function Config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamentoCarga;

        $stateProvider
            .state('app.gerenciamento_carga', {
                url: '/dashboard',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/gerenciamentocarga/views/gerenciamento-carga.html',
                        controller: 'GerenciamentoCargaController as vm'
                    },
                    'gerenciamento-carga-totalizador@app.gerenciamento_carga': {
                        templateUrl: rotasHtml.totalizador.templateUrl,
                        controller: 'GerenciamentoCargaTotalizadorController as vm'
                    },
                    'gerenciamento-carga-leiturista@app.gerenciamento_carga': {
                        templateUrl: rotasHtml.leiturista.templateUrl,
                        controller: 'GerenciamentoCargaLeituristaController as vm'
                    },
                    'disponibilizar-carga@app.gerenciamento_carga': {
                        templateUrl: RotasHtml.exportacaomobile.form
                    },
                    'gerenciamento-carga-filtro@app.gerenciamento_carga': {
                        templateUrl: rotasHtml.filtro.templateUrl,
                        controller: 'GerenciamentoCargaFiltroController as vm'
                    },
                    'gerenciamento-carga-filtro-caema@app.gerenciamento_carga': {
                        templateUrl: rotasHtml.caema.sidenav.filtro.templateUrl,
                        controller: 'GerenciamentoCargaFiltroController as vm'
                    },
                    'geracaoarquivo-form@app.gerenciamento_carga': {
                        templateUrl: RotasHtml.geracaoarquivo.form
                    },
                    'disponibilizar-tarefas@app.gerenciamento_carga': {
                        templateUrl: RotasHtml.disponibilizarTarefas.form
                    },
                    'disponibilizar-tarefas-caema@app.gerenciamento_carga': {
                        templateUrl: RotasHtml.disponibilizarTarefas.caema.form
                    },

                },
                resolve: {
                    Regional: function (RegionalService){
                      return RegionalService.listarTodos();
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.carga')
        .controller('GerenciamentoCargaFiltroController', GerenciamentoCargaFiltroController);

    /** @ngInject */
    function GerenciamentoCargaFiltroController(GerenciamentoCargaService, $mdSidenav, MdToastService, $scope,
        MunicipioService, SessionStorageService, KeysSessionStorage, $state) {
        var vm = this;

        // Data
        init();

        // Methods
        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.municipios = [];
            vm.dataAtual = new Date();
            vm.intervalos = GerenciamentoCargaService.getIntervalosAtualizacao();
            vm.filtros = {
                data: GerenciamentoCargaService.getDataReferencia(),
                intervalo: GerenciamentoCargaService.getIntervaloAtualizacao(),
            };
            if (vm.regionais.length > 0) {
                vm.filtros.regionalId = vm.regionais[0].codigo
            }

            GerenciamentoCargaService.listenerProgresso = function (callback) {
                vm.emProgresso = callback();
            }
        }

        vm.metodos = {
            atualizarDataReferencia: atualizarDataReferencia,
            disponibilizarCarga: disponibilizarCarga
        }

        $scope.$watch('vm.filtros.regionalId', function (newValue, oldValue) {
            if (newValue) {
                MunicipioService.listarMunicipios(newValue).then(function (success) {
                    vm.municipios = success.data;
                },
                    function (erro) {
                        vm.municipios = [];
                    });
            } else {
                vm.municipios = [];
            }
        })

        function disponibilizarCarga() {
            if (vm.parametros.tipoProcesso === "01")
                $state.go('app.exportacao_mobile', {});
            else if (vm.parametros.tipoProcesso === "02")
                $state.go('app.disponibilizar_tarefas', {});
        }

        function atualizarDataReferencia(filtro) {
            GerenciamentoCargaService.setProgresso(true);
            MdToastService.toastInfo("Atualizando informações...");
            GerenciamentoCargaService.setDataReferencia(filtro.data);
            GerenciamentoCargaService.setIntervaloAtualizacao(filtro.intervalo);
            GerenciamentoCargaService.setRegionalId(filtro.regionalId);
            GerenciamentoCargaService.setMunicipioId(filtro.municipioId);
            GerenciamentoCargaService.atualizar(GerenciamentoCargaService.getDataReferencia());
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.resumoretencoes')
        .controller('ResumoRetencoesController', ResumoRetencoesController)

    /** @ngInject */
    function ResumoRetencoesController(ResumoRetencoesService, DatatableFactory, MdDialogService) {
        var vm = this;

        vm.menus = _construirMenus();
        vm.pieChart = {};
        vm.multiBarHorizontalChart = {};
        vm.tipoSimplificadoOuDetalhado = true;
        vm.tipoFaturaOuComunicado = true;

        ResumoRetencoesService.limparFiltro();

        vm.metodos = {
            abrirFiltro: abrirFiltro,
        }

        init();

        function init() {
            ResumoRetencoesService.listener = function (callback) {
                vm.retencoes = callback();

                vm.tipoSimplificadoOuDetalhado = vm.retencoes.filtros.tipoDashboard;
                vm.tipoFaturaOuComunicado = vm.retencoes.filtros.tipoRetencao;

                if (vm.retencoes.filtros.tipoDashboard) {
                    _montarDadosGraficoGeral(vm.retencoes.dadosGraficoGeral);

                    vm.retencoes.dados.detalhesReferencias.forEach(function (dado) {
                        dado.pieChart = _montarGraficoIndividual(dado.dadosGraficoIndividual);
                    });
                }
            };

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1],
                    width: '50%'
                }
            ]);

            vm.dtOptions.ordering = false;
        }

        function abrirFiltro() {
            ResumoRetencoesService.toggleFiltro();
        }

        function atualizarDados() {
            _iniciarProgresso();

            var viewModel = {};

            viewModel.tipoFiltro = vm.retencoes.filtros.tipoFiltro;
            viewModel.mesInicial = vm.retencoes.filtros.mesInicial;
            viewModel.anoInicial = vm.retencoes.filtros.anoInicial;
            viewModel.mesFinal = vm.retencoes.filtros.mesFinal;
            viewModel.anoFinal = vm.retencoes.filtros.anoFinal;
            viewModel.dataInicial = vm.retencoes.filtros.dataInicial;
            viewModel.dataFinal = vm.retencoes.filtros.dataFinal;
            viewModel.tipoDashboard = vm.retencoes.filtros.tipoDashboard;
            viewModel.tipoRetencao = vm.retencoes.filtros.tipoRetencao;
            vm.simplificadoOuDetalhado = viewModel.tipoDashboard;
            vm.faturaOuComunicado = viewModel.tipoRetencao;


            vm.retencoes = {};

            if (vm.faturaOuComunicado) {
                if (!vm.simplificadoOuDetalhado) {
                    var pBuscarDadosDetalhado = ResumoRetencoesService.buscarDadosFaturasDetalhado(viewModel);

                    viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
                    viewModel.tipoRetencao = vm.faturaOuComunicado;

                    ResumoRetencoesService.setFiltro(viewModel);

                    pBuscarDadosDetalhado
                        .then(function (success) {
                            var dados = success.data;

                            var object = {
                                dados: dados,
                                filtros: viewModel
                            }

                            ResumoRetencoesService.listener(function () { return object; });


                        }, function (error) {
                            console.log(error);
                            MdDialogService.alertPadrao("Atenção!", event, error.data);
                        })
                        .finally(function () { _finalizarProgresso() });

                } else {
                    var pBuscarDadosSimplificado = ResumoRetencoesService.buscarDadosFaturasSimplificado(viewModel);

                    viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
                    viewModel.tipoRetencao = vm.faturaOuComunicado;

                    ResumoRetencoesService.setFiltro(viewModel);

                    pBuscarDadosSimplificado
                        .then(function (success) {
                            var dados = success.data;

                            var dadosGraficoGeral = [];

                            if (dados.detalhesReferencias.length > 1) {
                                dados.detalhesReferencias.forEach(function (dado) {
                                    dadosGraficoGeral.push({
                                        label: dado.referencia,
                                        value: dado.totalReferencia
                                    });
                                });
                            }

                            dados.detalhesReferencias.forEach(function (dado) {
                                dado.dadosGraficoIndividual = [];
                                dado.grupos.forEach(function (grupo) {
                                    dado.dadosGraficoIndividual.push({
                                        key: grupo.grupo,
                                        y: grupo.totalGrupo
                                    });
                                });
                            });

                            var object = {
                                dados: dados,
                                filtros: viewModel,
                                dadosGraficoGeral: dadosGraficoGeral
                            }

                            ResumoRetencoesService.listener(function () { return object; });

                        }, function (error) {
                            console.log(error);
                            MdDialogService.alertPadrao("Atenção!", event, error.data);
                        })
                        .finally(function () { _finalizarProgresso() });

                }
            } else {

                if (!vm.simplificadoOuDetalhado) {

                    var pBuscarDadosComunicadoDetalhado = ResumoRetencoesService.buscarDadosComunicadosDetalhado(viewModel);

                    viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
                    viewModel.tipoRetencao = vm.faturaOuComunicado;

                    ResumoRetencoesService.setFiltro(viewModel);

                    pBuscarDadosComunicadoDetalhado
                        .then(function (success) {
                            var dados = success.data;

                            var object = {
                                dados: dados,
                                filtros: viewModel
                            }

                            ResumoRetencoesService.listener(function () { return object; });

                        }, function (error) {
                            console.log(error);
                            MdDialogService.alertPadrao("Atenção!", event, error.data);
                        })
                        .finally(function () { _finalizarProgresso() });
                } else {
                    var pBuscarDadosComunicadoDetalhado = ResumoRetencoesService.buscarDadosComunicadosSimplificado(viewModel);

                    viewModel.tipoDashboard = vm.simplificadoOuDetalhado;
                    viewModel.tipoRetencao = vm.faturaOuComunicado;

                    ResumoRetencoesService.setFiltro(viewModel);

                    pBuscarDadosComunicadoDetalhado
                        .then(function (success) {
                            var dados = success.data;

                            var dadosGraficoGeral = [];

                            if (dados.detalhesReferencias.length > 1) {
                                dados.detalhesReferencias.forEach(function (dado) {
                                    dadosGraficoGeral.push({
                                        label: dado.referencia,
                                        value: dado.totalReferencia
                                    });
                                });
                            }

                            dados.detalhesReferencias.forEach(function (dado) {
                                dado.dadosGraficoIndividual = [];
                                dado.grupos.forEach(function (grupo) {
                                    dado.dadosGraficoIndividual.push({
                                        key: grupo.grupo,
                                        y: grupo.totalGrupo
                                    });
                                });
                            });

                            var object = {
                                dados: dados,
                                filtros: viewModel,
                                dadosGraficoGeral: dadosGraficoGeral
                            }

                            ResumoRetencoesService.listener(function () { return object; });

                        }, function (error) {
                            console.log(error);
                            MdDialogService.alertPadrao("Atenção!", event, error.data);
                        })
                        .finally(function () { _finalizarProgresso() });
                }
            }
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return atualizarDados() }
                },
            ]
        }

        function _montarDadosGraficoGeral(dados) {
            vm.multiBarHorizontalChart = {
                options: {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        height: 450,
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        showControls: false,
                        showValues: true,
                        transitionDuration: 500,
                        valueFormat: d3.format('d'),
                        yAxis: {
                            tickFormat: function (d) {
                                return d3.format(',f')(d);
                            }
                        },
                        xAxis: {
                            showMaxMin: false,
                        }
                    }
                },
                data: [
                    {
                        'key': 'Faturas retidas',
                        'color': '#1f77b4',
                        'values': dados
                    },
                ]
            };
        }

        function _montarGraficoIndividual(dados) {

            return {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 350,
                        x: function (d) {
                            return d.key;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        showLabels: true,
                        transitionDuration: 500,
                        labelThreshold: 0.01,
                        valueFormat: d3.format('d'),
                        legend: {
                            margin: {
                                top: 5,
                                right: 35,
                                bottom: 5,
                                left: 0
                            }
                        }
                    }
                },
                data: dados
            };
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .service('ProdutividadeService', ProdutividadeService)

    /** @ngInject */
    function ProdutividadeService($mdSidenav, Api, RequisicaoGenericaService){

        var _filtro;

        var service = { 
            toggleFiltroProdutividade: toggleFiltroProdutividade,
            retornaGruposPorDataInicioDataFim: retornaGruposPorDataInicioDataFim,
            buscarLeituristasPorGleiCodigo: buscarLeituristasPorGleiCodigo,
            montarFiltro: montarFiltro,
            filtrarDadosProdutividade: filtrarDadosProdutividade,
            buscarDadosDetalheProdutividade: buscarDadosDetalheProdutividade,
            buscarDadosDetalheCritica: buscarDadosDetalheCritica,
            getFiltro:getFiltro,
            setFiltro: setFiltro
        }
       
        function getFiltro(){
            return angular.copy(_filtro);
        }
        function setFiltro(filtro){
            _filtro = angular.copy(filtro);
        }

        function toggleFiltroProdutividade(){
            $mdSidenav('filtro-produtividade').toggle();
        }

        function retornaGruposPorDataInicioDataFim(viewModel){
            return RequisicaoGenericaService.salvar(Api.produtividade.retornaGruposPorDataInicioDataFim, viewModel);
        }

        function buscarLeituristasPorGleiCodigo(grupos){
            return RequisicaoGenericaService.salvar(Api.produtividade.retornaLeituristaPorGleiCodigo, grupos);
        }

        function montarFiltro(){
            return {
                grupos: [],
                leituristas: [],
                agrupamento: undefined,
                dataInicio: new Date(),
                dataFim: new Date(),
                descricaoAgrupamento: ''
            }
        }

        function filtrarDadosProdutividade(filtro){
            return RequisicaoGenericaService.salvar(Api.produtividade.filtrarDadosProdutividade, filtro);
        }

        function buscarDadosDetalheProdutividade(filtro){
            return RequisicaoGenericaService.salvar(Api.produtividade.buscarDadosDetalheProdutividade, filtro);
        }

        function buscarDadosDetalheCritica(filtro){
            return RequisicaoGenericaService.salvar(Api.produtividade.buscarDadosDetalheCritica, filtro);
        }

        return service;
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.quitacaoanual')
        .controller('QuitacaoAnualController', QuitacaoAnualController)

    /** @ngInject */
    function QuitacaoAnualController(QuitacaoAnualService, DatatableFactory, MdDialogService) {
        var vm = this;

        vm.menus = _construirMenus();
        vm.pieChart = {};
        vm.multiBarHorizontalChart = {};
        vm.tipoSimplificadoOuDetalhado = true;

        QuitacaoAnualService.limparFiltro();

        vm.metodos = {
            abrirFiltro: abrirFiltro,
        }

        init();

        function init() {
            QuitacaoAnualService.listener = function (callback) {
                vm.quitacoes = callback();

                vm.tipoSimplificadoOuDetalhado = vm.quitacoes.filtros.tipoSimplificadoOuDetalhado;

                if (vm.quitacoes.filtros.tipoSimplificadoOuDetalhado) {
                    _montarDadosGraficoGeral(vm.quitacoes.dadosGraficoGeral);

                    vm.quitacoes.dados.detalhesReferencias.forEach(function (dado) {
                        dado.pieChart = _montarGraficoIndividual(dado.dadosGraficoIndividual);
                    });
                }
            };

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1],
                    width: '50%'
                }
            ]);

            vm.dtOptions.ordering = false;
        }

        function abrirFiltro() {
            QuitacaoAnualService.toggleFiltro();
        }

        function atualizarDados() {
            _iniciarProgresso();

            var viewModel = {};


            viewModel.tipoFiltro = vm.quitacoes.filtros.tipoFiltro;
            viewModel.mesReferencia = vm.quitacoes.filtros.mesReferencia;
            viewModel.anoReferencia = vm.quitacoes.filtros.anoReferencia;
            viewModel.dataInicial = vm.quitacoes.filtros.dataInicial;
            viewModel.dataFinal = vm.quitacoes.filtros.dataFinal;
            viewModel.tipoSimplificadoOuDetalhado = vm.quitacoes.filtros.tipoSimplificadoOuDetalhado;


            vm.quitacoes = {};


            if (!vm.tipoSimplificadoOuDetalhado) { // DETALHADO

                var pBuscarDadosDetalhado = QuitacaoAnualService.buscarDadosQuitacaoAnualDetalhado(viewModel);



                pBuscarDadosDetalhado
                    .then(function (success) {
                        var dados = success.data;

                        var object = {
                            dados: dados,
                            filtros: viewModel
                        }

                        QuitacaoAnualService.listener(function () { return object; });

                        viewModel.gruposLeitura = vm.filtro.gruposLeitura;

                        QuitacaoAnualService.setFiltro(viewModel);


                    }, function (error) {
                        console.log(error);
                        MdDialogService.alertPadrao("Atenção!", event, error.data);
                    })
                    .finally(function () { _finalizarProgresso() });

            } else { // SIMPLIFICADO

                var pBuscarDadosSimplificado = QuitacaoAnualService.buscarDadosQuitacaoAnualSimplificado(viewModel);


                pBuscarDadosSimplificado
                    .then(function (success) {
                        var dados = success.data;

                        var dadosGraficoGeral = [];

                        if (dados.detalhesReferencias.length > 1) {
                            dados.detalhesReferencias.forEach(function (dado) {
                                dadosGraficoGeral.push({
                                    label: dado.referencia,
                                    value: dado.total
                                });
                            });
                        }

                        dados.detalhesReferencias.forEach(function (dado) {
                            console.log(dado);
                            dado.dadosGraficoIndividual = [];
                            dado.grupos.forEach(function (grupo) {
                                dado.dadosGraficoIndividual.push({
                                    key: grupo.grupo,
                                    y: grupo.total
                                });
                            });
                        });


                        var object = {
                            dados: dados,
                            filtros: viewModel,
                            dadosGraficoGeral: dadosGraficoGeral
                        }

                        QuitacaoAnualService.listener(function () { return object; });

                        viewModel.gruposLeitura = vm.filtro.gruposLeitura;

                        QuitacaoAnualService.setFiltro(viewModel);


                    }, function (error) {
                        console.log(error);
                        MdDialogService.alertPadrao("Atenção!", event, error.data);
                    })
                    .finally(function () { _finalizarProgresso() });

            }

        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return atualizarDados() }
                },
            ]
        }

        function _montarDadosGraficoGeral(dados) {
            vm.multiBarHorizontalChart = {
                options: {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        height: 450,
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        showControls: false,
                        showValues: true,
                        transitionDuration: 500,
                        valueFormat: d3.format('d'),
                        yAxis: {
                            tickFormat: function (d) {
                                return d3.format(',f')(d);
                            }
                        },
                        xAxis: {
                            showMaxMin: false,
                        }
                    }
                },
                data: [
                    {
                        'key': 'Quitação anual de débitos:',
                        'color': '#1f77b4',
                        'values': dados
                    },
                ]
            };
        }

        function _montarGraficoIndividual(dados) {

            return {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 350,
                        x: function (d) {
                            return d.key;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        showLabels: true,
                        transitionDuration: 500,
                        labelThreshold: 0.01,
                        valueFormat: d3.format('d'),
                        legend: {
                            margin: {
                                top: 5,
                                right: 35,
                                bottom: 5,
                                left: 0
                            }
                        }
                    }
                },
                data: dados
            };
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.quantitativoleituras')
        .controller('QuantitativoLeiturasController', QuantitativoLeiturasController)

    /** @ngInject */
    function QuantitativoLeiturasController(QuantitativoLeiturasService, DatatableFactory, MdDialogService) {
        var vm = this;

        vm.menus = _construirMenus();
        vm.multiBarChart = {};

        vm.metodos = {
            abrirFiltro: abrirFiltro,
        }

        init();

        function init() {
            QuantitativoLeiturasService.listener = function (callback) {
                vm.quantitativo = callback();
                _montarDadosGraficoGeral(vm.quantitativo.dadosGraficoGeral);

                vm.quantitativo.dados.leituristas.forEach(function (dado) {
                    dado.pieChart = _montarGraficoIndividual(dado.dadosGraficoIndividual);
                });
            };

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 1],
                    width: '50%'
                }
            ]);

            vm.dtOptions.ordering = false;
        }

        function abrirFiltro() {
            QuantitativoLeiturasService.toggleFiltro();
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return _atualizarDados(vm.quantitativo.filtros) }
                },
            ]
        }

        function _atualizarDados(filtro) {
            _iniciarProgresso();
            var viewModel = {};

            if (filtro.tipoFiltro === 1) {
                viewModel = {
                    tipoFiltro: filtro.tipoFiltro,
                    mes: filtro.mes,
                    ano: filtro.ano,
                    grupos: filtro.grupos,
                    leituristas: filtro.leituristas
                }
            } else {
                viewModel = {
                    tipoFiltro: filtro.tipoFiltro,
                    dataInicial: filtro.dataInicial,
                    dataFinal: filtro.dataFinal,
                    grupos: filtro.grupos,
                    leituristas: filtro.leituristas
                }
            }

            vm.quantitativo = {};

            var pBuscarDados = QuantitativoLeiturasService.buscarDadosQuantitativoLeituras(viewModel);

            pBuscarDados
                .then(function (success) {
                    var dados = success.data;

                    var dadosGraficoGeral = [];

                    if (dados.leituristas.length > 1) {
                        dados.leituristas.forEach(function (dado) {
                            dadosGraficoGeral.push({
                                label: dado.nome,
                                value: dado.total
                            });
                        });
                    }

                    dados.leituristas.forEach(function (dado) {
                        dado.dadosGraficoIndividual = [];
                        dado.gruposQuantitativo.forEach(function (grupo) {
                            dado.dadosGraficoIndividual.push({
                                key: grupo.grupo,
                                y: grupo.quantidadeLeituras
                            });
                        });
                    });

                    var object = {
                        dados: dados,
                        filtros: viewModel,
                        dadosGraficoGeral: dadosGraficoGeral
                    }

                    QuantitativoLeiturasService.listener(function () { return object; });

                }, function (error) {
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgresso() });
        }

        function _montarDadosGraficoGeral(dados) {
            vm.multiBarChart = {
                options: {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        useInteractiveGuideline: true,
                        wrapLabels: false,
                        showLegend: true,
                        height: 650,
                        margin: {
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 200
                        },
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        showControls: false,
                        valueFormat: d3.format('d'),
                        yAxis: {
                            tickFormat: function (d) {
                                return d3.format(',f')(d);
                            }
                        },
                        transitionDuration: 500,
                    }
                },
                data: [
                    {
                        'key': 'Leituras realizadas',
                        'color': '#1f77b4',
                        'values': dados
                    },
                ]
            };
        }

        function _montarGraficoIndividual(dados) {
            return {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 350,
                        x: function (d) {
                            return d.key;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        showLabels: true,
                        transitionDuration: 500,
                        labelThreshold: 0.01,
                        valueFormat: d3.format('d'),
                        legend: {
                            margin: {
                                top: 5,
                                right: 35,
                                bottom: 5,
                                left: 0
                            }
                        }
                    }
                },
                data: dados
            };
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.ocorrenciasleiturista')
        .controller('OcorrenciasLeituristaController', OcorrenciasLeituristaController)

    /** @ngInject */
    function OcorrenciasLeituristaController(OcorrenciasLeituristaService, RotasHtml, MdDialogService, $mdDialog) {
        var vm = this;

        vm.rotasHtml = RotasHtml.gerenciamento.dashboards.ocorrenciasleiturista;
        vm.menus = _construirMenus();
        vm.multiBarChart = {};
        vm.emProgressoDialog = false;

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            abrirDialogDetalhamento: abrirDialogDetalhamento,
        }

        init();

        function init() {
            OcorrenciasLeituristaService.listener = function (callback) {
                vm.ocorrenciasleiturista = callback();
                _montarDadosGraficoGeral(vm.ocorrenciasleiturista.dadosGraficoGeral);

                vm.ocorrenciasleiturista.dados.leituristas.forEach(function (dado) {
                    dado.pieChart = _montarGraficoIndividual(dado.dadosGraficoIndividual);
                });
            };
        }

        function abrirFiltro() {
            OcorrenciasLeituristaService.toggleFiltro();
        }

        function abrirDialogDetalhamento(leiturista) {
            _iniciarProgressoDialog();

            var viewModel = {};

            if (vm.ocorrenciasleiturista.filtros.tipoFiltro === 1) {
                viewModel = {
                    tipoFiltro: 1,
                    mes: vm.ocorrenciasleiturista.filtros.mes,
                    ano: vm.ocorrenciasleiturista.filtros.ano,
                }
            } else {
                viewModel = {
                    tipoFiltro: 2,
                    dataInicial: vm.ocorrenciasleiturista.filtros.dataInicial,
                    dataFinal: vm.ocorrenciasleiturista.filtros.dataFinal,
                }
            }

            if (vm.ocorrenciasleiturista.filtros.ocorrencias != undefined) {
                if (vm.ocorrenciasleiturista.filtros.ocorrencias.length > 0) {
                    viewModel.ocorrencias = vm.ocorrenciasleiturista.filtros.ocorrencias.map(function (ocorrencia) {
                        return ocorrencia.codigo;
                    });
                }
            }

            viewModel.leituristas = [leiturista.codigoLeiturista];

            var pBuscarDados = OcorrenciasLeituristaService.buscarDadosAgrupadoPorDia(viewModel);

            pBuscarDados
                .then(function (success) {
                    var dados = success.data;

                    $mdDialog.show({
                        controller: 'DialogDetalhamentoOcorrenciasLeituristaController',
                        controllerAs: 'vm',
                        templateUrl: vm.rotasHtml.dialogs.detalhamento,
                        targetEvent: null,
                        multiple: true,
                        locals: {
                            Leiturista: leiturista.codigoLeiturista + " - " + leiturista.nome,
                            Dados: dados
                        }
                    });

                }, function (error) {
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgressoDialog() });
        }

        function atualizarDados() {
            _iniciarProgresso();

            var viewModel = {};

            if (vm.ocorrenciasleiturista.filtros.tipoFiltro === 1) {
                viewModel = {
                    tipoFiltro: 1,
                    mes: vm.ocorrenciasleiturista.filtros.mes,
                    ano: vm.ocorrenciasleiturista.filtros.ano,
                }
            } else {
                viewModel = {
                    tipoFiltro: 2,
                    dataInicial: vm.ocorrenciasleiturista.filtros.dataInicial,
                    dataFinal: vm.ocorrenciasleiturista.filtros.dataFinal,
                }
            }

            if (vm.ocorrenciasleiturista.filtros.ocorrencias != undefined) {
                if (vm.ocorrenciasleiturista.filtros.ocorrencias.length > 0) {
                    viewModel.ocorrencias = vm.ocorrenciasleiturista.filtros.ocorrencias.map(function (ocorrencia) {
                        return ocorrencia.codigo;
                    });
                }
            }

            if (vm.ocorrenciasleiturista.leituristas != undefined) {
                if (vm.ocorrenciasleiturista.leituristas.length > 0) {
                    viewModel.leituristas = vm.ocorrenciasleiturista.leituristas.map(function (leiturista) {
                        return leiturista.codigo;
                    });
                }
            }

            var pBuscarDados = OcorrenciasLeituristaService.buscarDadosOcorrenciasLeiturista(viewModel);

            vm.ocorrenciasleiturista = {};

            pBuscarDados
                .then(function (success) {
                    var dados = success.data;

                    var dadosGraficoGeral = [];

                    if (dados.ocorrencias.length > 1) {
                        dados.ocorrencias.forEach(function (dado) {
                            dadosGraficoGeral.push({
                                label: dado.codigoOcorrencia + " - " + dado.descricaoOcorrencia,
                                value: dado.total
                            });
                        });
                    }

                    dados.leituristas.forEach(function (dado) {
                        dado.dadosGraficoIndividual = [];
                        dado.ocorrencias.forEach(function (ocorrencia) {
                            dado.dadosGraficoIndividual.push({
                                key: ocorrencia.codigoOcorrencia + " - " + ocorrencia.descricaoOcorrencia,
                                y: ocorrencia.total
                            });
                        });
                    });

                    var object = {
                        dados: dados,
                        filtros: viewModel,
                        dadosGraficoGeral: dadosGraficoGeral
                    }

                    OcorrenciasLeituristaService.listener(function () { return object; });
                }, function (error) {
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgresso() });
        }

        function _montarDadosGraficoGeral(dados) {
            vm.multiBarChart = {
                options: {
                    chart: {
                        type: 'multiBarHorizontalChart',
                        useInteractiveGuideline: true,
                        wrapLabels: false,
                        showLegend: true,
                        height: 650,
                        margin: {
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 300
                        },
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        showControls: false,
                        valueFormat: d3.format('d'),
                        yAxis: {
                            tickFormat: function (d) {
                                return d3.format(',f')(d);
                            }
                        },
                        transitionDuration: 500,
                    }
                },
                data: [
                    {
                        'key': 'Ocorrências',
                        'color': '#1f77b4',
                        'values': dados
                    },
                ]
            };
        }

        function _montarGraficoIndividual(dados) {
            return {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 450,
                        x: function (d) {
                            return d.key;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        showLabels: false,
                        transitionDuration: 500,
                        labelThreshold: 0.01,
                        valueFormat: d3.format('d'),
                        legend: {
                            margin: {
                                top: 5,
                                right: 35,
                                bottom: 5,
                                left: 0
                            }
                        }
                    }
                },
                data: dados
            };
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return atualizarDados() }
                },
            ]
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _iniciarProgressoDialog() {
            vm.emProgressoDialog = true;
        }

        function _finalizarProgressoDialog() {
            vm.emProgressoDialog = false;
        }
    }
}());
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.dashboards.distribuicaogrupos')
    .controller('ResumoDistribuicaoGruposController', ResumoDistribuicaoGruposController)

  /** @ngInject */
  function ResumoDistribuicaoGruposController(ResumoDistribuicaoGruposLeiturasService, DatatableFactory, MdDialogService) {
    var vm = this;

    vm.menus = _construirMenus();

    ResumoDistribuicaoGruposLeiturasService.limparFiltro();

    vm.metodos = {
      abrirFiltro: abrirFiltro,
    }

    init();

    function init() {
      ResumoDistribuicaoGruposLeiturasService.listener = function (callback) {
        vm.distribuicao = callback();

      };

      vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
        {
          targets: [2, 4, 5, 6],
          orderable: false
        }
      ]);

      vm.dtOptions.order = [[1, "asc"]]
    }

    function abrirFiltro() {
      ResumoDistribuicaoGruposLeiturasService.toggleFiltro();
    }

    function atualizarDados() {
      _iniciarProgresso();

      var viewModel = {};


      viewModel.mes = vm.distribuicao.filtros.mes;
      viewModel.ano = vm.distribuicao.filtros.ano;
      viewModel.grupo = vm.distribuicao.filtros.grupo;


      vm.distribuicao = {};

      var pBuscarDadosDetalhado = ResumoDistribuicaoGruposLeiturasService.buscarDadosResumoDistribuicao(viewModel);

      pBuscarDadosDetalhado
        .then(function (success) {
          var dados = success.data;

          var object = {
            dados: dados,
            filtros: viewModel
          }

          ResumoDistribuicaoGruposLeiturasService.listener(function () { return object; });

          ResumoDistribuicaoGruposLeiturasService.setFiltro(viewModel);


        }, function (error) {
          console.log(error);
          MdDialogService.alertPadrao("Atenção!", event, error.data);
        })
        .finally(function () { _finalizarProgresso() });
    }

    function _construirMenus() {
      return [
        {
          icon: 'icon-filter s20',
          name: 'Filtrar',
          direction: 'top',
          hide: false,
          executarAcaoClick: function () { return abrirFiltro() }
        },
        {
          icon: 'icon-refresh s20',
          name: "Atualizar dados",
          direction: top,
          executarAcaoClick: function () { return atualizarDados() }
        },
      ]
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }
  }

}());
(function () {
    "use strict";

    angular
        .module("app.gerenciamento.dashboards.controlecargafluxo")
        .controller("ControleFluxoController", ControleFluxoController);

    function ControleFluxoController(
        ControleFluxoService,
        DatatableFactory,
        Parametros,
        $mdSidenav
    ) {
        var vm = this;
        vm.parametro = Parametros;

        $(document).ready(function () {
            $('#controleFluxo').on('click', function (event) {
                if (vm.controleCargaFluxo == undefined) {
                    $mdSidenav('filtro-controleFluxo').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        init();
        vm.metodos = {
            abrirFecharFiltro: abrirFecharFiltro,
            atualizarDados: atualizarDados
        }

        function init() {
            vm.pesquisar = '';
            ControleFluxoService.listener = function (callback) {
                vm.controleCargaFluxo = callback();
                vm.dadosFiltrados = ControleFluxoService.getFiltro();
            };

            if (vm.parametro.tipoProcesso == '02') {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [3, 4, 5, 6],
                        type: 'date-pt-br',
                        orderable: true,
                    },
                ]);
                vm.dtOptions.order = [3, 'asc']
            }
            if (vm.parametro.tipoProcesso == '01') {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [2, 3, 4],
                        type: 'date-pt-br',
                        orderable: true,
                    },
                ]);
                vm.dtOptions.order = [2, 'asc']
            }
        }

        function abrirFecharFiltro() {
            ControleFluxoService.abrirFecharFiltro();
        }

        function atualizarDados() {
            vm.emProgresso = true;
            var dadosFiltrados = ControleFluxoService.getFiltro();
            ControleFluxoService.buscarDadosLeitura(dadosFiltrados).then(
                function (success) {
                    vm.controleCargaFluxo = success.data;
                }
            ).finally(function () { vm.emProgresso = false });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards.comunicadosdebitoimpressos')
        .controller('ComunicadosDebitoImpressosController', ComunicadosDebitoImpressosController)

    /** @ngInject */
    function ComunicadosDebitoImpressosController(ComunicadosDebitoImpressosService, DatatableFactory, MdDialogService, RelatorioService) {
        var vm = this;

        vm.menus = _construirMenus();

        vm.pieChart = {};

        vm.metodos = {
            abrirFiltro: abrirFiltro,
        }

        init();

        function init() {
            ComunicadosDebitoImpressosService.listener = function (callback) {
                vm.comunicadosImpressos = callback();
                _montarDadosGráfico(vm.comunicadosImpressos.dadosGrafico);
            };

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [1, 2],
                    orderable: false
                },
                {
                    targets: [0, 1, 3],
                    width: '20%'
                },
                {
                    targets: [2],
                    width: '40%'
                }
            ]);

            vm.dtOptions.order = [[0, "desc"]]
        }

        function abrirFiltro() {
            ComunicadosDebitoImpressosService.toggleFiltro();
        }

        function _atualizarDadosFiltrados() {
            _iniciarProgresso();

            var viewModel = ComunicadosDebitoImpressosService.getFiltro();

            var pBuscarDados = ComunicadosDebitoImpressosService.buscarDadosComunicadosImpressos(viewModel);

            pBuscarDados
                .then(function (success) {
                    var total = 0;

                    var dados = success.data;

                    dados.forEach(function (dado) {
                        total += dado.dadosComunicados.length
                    });

                    var dadosGrafico = [];
                    dados.forEach(function (dado) {
                        dadosGrafico.push({
                            key: dado.leiturista,
                            y: dado.dadosComunicados.length
                        });
                    });

                    _montarDadosGráfico(dadosGrafico);

                    var object = {
                        dados: dados,
                        filtros: viewModel,
                        totalizador: total
                    }

                    vm.comunicadosImpressos = object;

                }, function (error) {
                    vm.comunicadosImpressos = {};
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgresso() });

        }

        function gerarRelatorio() {
            _iniciarProcessoRelatorio();

            var viewModel = {
                filtro: vm.comunicadosImpressos.filtros,
                dados: vm.comunicadosImpressos.dados
            }

            var gerarRelatorio = ComunicadosDebitoImpressosService.gerarRelatorio(viewModel);

            gerarRelatorio
                .then(function (success) {

                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                }, function (error) {
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                })
                .finally(function () { _finalizarProcessoRelatorio() });
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _iniciarProcessoRelatorio() {
            vm.emProgressoRelatorio = true;
        }

        function _finalizarProcessoRelatorio() {
            vm.emProgressoRelatorio = false;
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return _atualizarDadosFiltrados() }
                },
                {
                    icon: 'icon-download s20',
                    name: "Baixar Relatório",
                    direction: top,
                    executarAcaoClick: function () { return gerarRelatorio() }
                }
            ]
        }

        function _montarDadosGráfico(data) {

            vm.pieChart = {
                options: {
                    chart: {
                        type: 'pieChart',
                        height: 400,
                        x: function (d) {
                            return d.key;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        showLabels: true,
                        transitionDuration: 500,
                        labelThreshold: 0.01,
                        valueFormat: d3.format('d'),
                        legend: {
                            margin: {
                                top: 5,
                                right: 35,
                                bottom: 5,
                                left: 0
                            }
                        }
                    }
                },
                data: data
            };
        }
    }

}());
/* eslint-disable no-undef */
/* eslint-disable no-console */
(function () {
    "use strict";

    angular
        .module("app.gerenciamento.dashboards.clientesocorrencia")
        .controller("ClienteOcorrenciaController", ClienteOcorrenciaController);

    /* @ngInject */
    function ClienteOcorrenciaController(
        MdDialogService,
        $mdDialog,
        DatatableFactory,
        RotasHtml,
        ClienteOcorrenciaService,
        SessionStorageService,
        KeysSessionStorage,
        RelatorioService,
        $mdSidenav
    ) {
        var vm = this;

        vm.rotasHtml = RotasHtml.gerenciamento.dashboards.clientesocorrencia;
        vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        init();

        $(document).ready(function () {
            $('#clienteocorrencia').on('click', function (event) {
                if (!vm.clientesOcorrencia || vm.clientesOcorrencia.length <= 0) {
                    $mdSidenav('filtro-clienteocorrencia').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        vm.metodos = {
            abrirDialogFotos: abrirDialogFotos,
            abrirFiltro: abrirFiltro
        };

        function init() {
            ClienteOcorrenciaService.listener = function (callback) {
                vm.clientesOcorrencia = callback();
            };

            vm.menus = _construirMenus();

            if (vm.parametro.utilizaCadastroRegional) {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [8],
                        width: '4%',
                        orderable: false,
                        responsivePriority: 1
                    },
                    {
                        targets: [7],
                        width: '30%'
                    },
                    {
                        targets: [0],
                        width: '20%'
                    },
                    {
                        targets: [6],
                        width: '11%'
                    },
                    {
                        targets: [1, 2],
                        width: '10%'
                    },
                    {
                        targets: [3, 4, 5],
                        width: '5%'
                    },
                    {
                        targets: [1, 2],
                        type: "html"
                    }
                ]);
            }

            if (vm.parametro.tipoProcesso == '01') {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [7],
                        width: '5%',
                        orderable: false,
                        responsivePriority: 1
                    },
                    {
                        targets: [3],
                        width: '25%'
                    },
                    {
                        targets: [0],
                        width: '20%'
                    },
                    {
                        targets: [1, 2, 4, 5, 6],
                        width: '10%'
                    },
                    {
                        targets: [1, 2],
                        type: "html"
                    },
                ]);
            }

            if (vm.parametro.tipoProcesso == '02' && !vm.parametro.utilizaCadastroRegional) {
                vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [8],
                        width: '4%',
                        orderable: false,
                        responsivePriority: 1
                    },
                    {
                        targets: [4],
                        width: '20%'
                    },
                    {
                        targets: [0],
                        width: '16%'
                    },
                    {
                        targets: [1, 2, 3, 5, 6, 7],
                        width: '10%'
                    },
                    {
                        targets: [1, 2],
                        type: "html"
                    }
                ]);
            }



        }

        function abrirDialogFotos(cliente) {
            _iniciarProgressoAlternativo("Carregando fotos...");

            var viewModel = {
                codigoCliente: cliente.clienteCodigo,
                nomeArquivoExportacao: cliente.nomeArquivoExportacao,
                codigoGrupoLeitura: cliente.grupoLeituraCodigo
            }

            var pBuscarDados = ClienteOcorrenciaService.buscarFotosClienteOcorrencia(viewModel);

            pBuscarDados
                .then(function (success) {

                    if (success.data.fotos.length > 0) {
                        cliente.urlFotos = success.data.fotos;

                        $mdDialog.show({
                            controller: 'DialogFotosClienteOcorrenciaController',
                            controllerAs: 'vm',
                            templateUrl: vm.rotasHtml.dialogs.fotos,
                            targetEvent: null,
                            multiple: true,
                            locals: {
                                Cliente: cliente
                            }
                        });
                    } else {
                        MdDialogService.alertPadrao("Atenção!", event, "Não foi possível carregar as fotos.");
                    }
                }, function (error) {
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgressoAlternativo(); });
        }

        function abrirFiltro() {
            ClienteOcorrenciaService.toggleFiltro();
        }

        function gerarRelatorio() {
            _iniciarProgressoAlternativo("Gerando o relatório...");

            var viewModel = {
                filtro: vm.clientesOcorrencia.filtros,
                dados: vm.clientesOcorrencia.dados,
                tipoProcesso: vm.parametro.tipoProcesso
            }

            var gerarRelatorio = ClienteOcorrenciaService.gerarRelatorio(viewModel);

            gerarRelatorio
                .then(function (success) {

                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                }, function (error) {
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                })
                .finally(function () { _finalizarProgressoAlternativo() });
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltro() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return _atualizarDadosFiltrados() }
                },
                {
                    icon: 'icon-download s20',
                    name: "Baixar Relatório",
                    direction: top,
                    executarAcaoClick: function () { return gerarRelatorio() }
                }
            ]
        }

        function _atualizarDadosFiltrados() {
            _iniciarProgresso();

            var viewModel = ClienteOcorrenciaService.getFiltro();

            var pBuscarDados = ClienteOcorrenciaService.buscarDadosClienteOcorrencia(viewModel);

            pBuscarDados
                .then(function (success) {
                    var total = 0;

                    var dados = success.data;

                    dados.forEach(function (dado) {
                        total += dado.dadosClientes.length
                    });

                    var object = {
                        dados: dados,
                        filtros: viewModel,
                        totalizador: total
                    }

                    vm.clientesOcorrencia = object;
                }, function (error) {
                    vm.clientesOcorrencia = {};
                    console.log(error);
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                })
                .finally(function () { _finalizarProgresso() });
        }

        function _iniciarProgressoAlternativo(mensagem) {
            vm.emProgressoAlternativo = true;
            vm.mensagem = mensagem;
        }

        function _finalizarProgressoAlternativo() {
            vm.emProgressoAlternativo = false;
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura.rastreamento')
        .controller('RastreamentoController', RastreamentoController);

    /** @ngInject */
    function RastreamentoController(RotasHtml, $mdSidenav, RastreamentoLeituristasFactory, $rootScope, $stateParams, $state,
        RastreamentoLeituristaService) {
        var vm = this;

        $(document).ready(function () {
            $('#rastreamento-leiturista-html').on('click', function (event) {
                console.log('vm.habilitarMapa: ', vm.habilitarMapa);
                if (vm.habilitarMapa == undefined || !vm.habilitarMapa) {
                    $mdSidenav('filtro-rastreamento-leiturista').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });
        init();

        // Data


        // Methods
        function init() {
            vm.habilitarIconeVoltarATelaDeCliente = false;
            vm.preLoader = false;
            vm.ngUtilizaPesquisa = false;

            vm.rotasHtml = RotasHtml.gerenciamento.leitura.rastreamento;
            RastreamentoLeituristasFactory.form = vm;
            vm.filtro = RastreamentoLeituristasFactory.filtros;
            vm.habilitarMapa = RastreamentoLeituristasFactory.habilitarMapa;

            if ($stateParams.leiturista) {
                vm.preLoader = true;
                vm.filtro.dataInicial = $stateParams.data;
                vm.filtro.dataFinal = $stateParams.data;
                vm.filtro.nomeArquivo = $stateParams.nomeArquivo;
                vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao = "Voltar para tela de Gerenciamento de cargas";
                vm.filtro.leiturista = $stateParams.leiturista;
                vm.filtro.tarefa = $stateParams.tarefa;
                vm.habilitarIconeVoltarATelaDeCliente = true;
            }
        }

        vm.metodos = {
            abrirFiltros: abrirFiltros,
            abrirLegendas: abrirLegendas,
            implementarVoltarParaOEstado: implementarVoltarParaOEstado,
            centralizarMapa: centralizarMapa
        };

        $rootScope.$on('habilitarMapa', function (event, dados) {
            vm.habilitarMapa = dados;
            vm.preLoader = false;
        })

        //////////
        function abrirFiltros() {
            if (RastreamentoLeituristaService.verificarLegendaAberta())
                RastreamentoLeituristaService.toggleLegenda();

            RastreamentoLeituristaService.toggleFiltro();
        }

        function abrirLegendas() {
            if (RastreamentoLeituristaService.verificarFiltroAberto())
                RastreamentoLeituristaService.toggleFiltro();

            RastreamentoLeituristaService.toggleLegenda();
        }

        function implementarVoltarParaOEstado() {
            if (vm.filtro) {
                $state.go('app.gerenciamento_carga', {
                    dataFiltro: vm.filtro.dataInicial
                });
            } else {
                $state.go('app.gerenciamento_carga', {})
            }
        }

        function centralizarMapa() {
            RastreamentoLeituristasFactory.centralizarMapa();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.gerenciamento.leitura.cancelamentodinamico', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.gerenciamento.leitura.cancelamentoDinamico;

    //State
    $stateProvider
      .state('app.gerenciamento_leitura_cancelamentodinamico', {
        url: '/gerenciamento/leitura/cancelamentodinamico',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'CancelamentoDinamicoController as vm'
          },
          'leitura-cancelamentodinamico-form@app.gerenciamento.leitura_cancelamentodinamico': {
            templateUrl: rotasHtml.form
          }
        },
        resolve: {
          ListarLeituristas: function (RequisicaoGenericaService, Api) {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos);
          }
        }
      });

  }
})();

/* eslint-disable no-undef */
/* eslint-disable no-console */
(function () {
  "use strict";

  angular
    .module("app.gerenciamento.leitura.cancelamentodinamico")
    .controller("CancelamentoDinamicoController", CancelamentoDinamicoController);

  /* @ngInject */
  function CancelamentoDinamicoController(
    ListarLeituristas,
    CancelamentoDinamicoService,
    MdDialogService
  ) {
    var vm = this;

    vm.senha;

    vm.validade = new Date().toLocaleDateString();

    init();

    vm.metodos = {
      configuraMdSelectLeiturista: configuraMdSelectLeiturista,
      gerarSenha: gerarSenha
    };

    function init() {
      _pesquisarLeituristas();
    }


    function gerarSenha(dados) {
      _iniciarProgresso();

      vm.senha = undefined;

      var viewModel = {
        codigoLigacao: dados.cliente,
        codigoLeiturista: dados.leiturista
      };
      console.log("gerarSenha -> viewModel", viewModel);

      var pSenha = CancelamentoDinamicoService.gerarSenha(viewModel);

      pSenha.then(
        function (success) {
          MdDialogService.alertPadrao("Senha gerada com sucesso!");
          vm.senha = success.data;
          console.log(vm.senha);
          _finalizarProgresso();
        }, function (error) {
          MdDialogService.alertPadrao(error.data);
        }).finally(function () {
          _finalizarProgresso();
        });
    }

    function configuraMdSelectLeiturista() {
      vm.filtrarLeiturista = "";
      angular.element('#select-leiturista').on('keydown', function (ev) {
        ev.stopPropagation();
      });
    }

    function _pesquisarLeituristas() {
      vm.leituristas = ListarLeituristas.data;
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }

  }
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    "use strict";

    angular
        .module("app.gerenciamento.leitura.visualizacao")
        .controller("VisualizacaoController", VisualizacaoController);

    function VisualizacaoController(
        ListarTodosLeituristas,
        RequisicaoGenericaService,
        Api,
        VisualizacaoLeituraService,
        $scope,
        $mdDialog,
        Leitura,
        RotasHtml,
        VisualizacaoLeituraFactory,
        MdDialogService,
        MdToastService,
        SessionStorageService,
        KeysSessionStorage,
        EditarAtivo,
        MunicipioService,
        $state,
        $rootScope,
        $mdSidenav
    ) {
        var vm = this;
        var rotaApi = Api.leitura.visualizacao;
        vm.controleForm = {};
        vm.dados = false;
        vm.emProgresso = false;


        vm.metodos = {
            setDefaultAno: setDefaultAno,
            setDefaultMes: setDefaultMes,
            pesquisar: _pesquisar,
            pesquisarBotao: _pesquisarBotao,
            limparFiltrosRadio: _limparFiltrosRadio,
            editar: _editar,
            configurarSelect: configurarSelect,
            fecharDialog: fecharDialog,
            tabSelecionada: tabSelecionada,
            onChangeRegional: onChangeRegional,
            abrirFiltro: abrirFiltro
        };

        init();

        $scope.$watch("vm.dadosCadastrais", function () {
            vm.emProgresso = false;
            vm.dados = false;
            if (
                !angular.isUndefinedOrNull(vm.dadosCadastrais) &&
                vm.dadosCadastrais.statusLeitura
            ) {
                vm.dados = true;
                vm.emProgresso = false;
                if ($mdSidenav("filtro").isOpen()) {
                    $mdSidenav('filtro').toggle();
                }
                VisualizacaoLeituraFactory.setDadosCadastrais(vm.dadosCadastrais);
                VisualizacaoLeituraService.carregaDadosDemaisAbas(
                    {
                        mesAnoReferencia: vm.dadosCadastrais.referencia,
                        codigoCliente: vm.dadosCadastrais.codigoCliente,
                        nomeArquivoExportacao: vm.dadosCadastrais.nomeArquivoExportacao
                    },
                    vm.controleForm
                );
            }
        });

        $(document).ready(function () {
            $('#leitura-visualizacao').on('click', function (event) {
                if (!angular.isUndefinedOrNull(vm.dadosCadastrais) &&
                    !vm.dadosCadastrais.statusLeitura) {
                    $mdSidenav('filtro').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        $rootScope.$on('DadosFaturamentoRecebido', function (event, dados) {
            vm.leituraComCritica = dados.leituraComCritica;
            vm.leituraComCriticaPendenteExecucao = dados.leituraComCriticaPendenteExecucao;
        });

        function init() {
            vm.rotasHtml = RotasHtml.gerenciamento.leitura.visualizacao;
            vm.parametros = SessionStorageService.recuperar(
                KeysSessionStorage.parametrosEmpresa
            );

            if (Leitura) {
                vm.leitura = Leitura;
                vm.dadosCritica = VisualizacaoLeituraFactory.construirDadosCritica();
                vm.dadosCritica.leitura = Leitura;
                VisualizacaoLeituraFactory.setDadosCritica(vm.dadosCritica);
                if (!EditarAtivo) {
                    vm.editandoLeituraComRetencao = false;
                    VisualizacaoLeituraFactory.setEditandoComRetencao(false);
                    vm.visualizandoLeituraComCritica = true;
                } else {
                    vm.visualizandoLeituraComCritica = false;
                    vm.editandoLeituraComRetencao = true;
                    VisualizacaoLeituraFactory.setEditandoComRetencao(true);
                }
                vm.entidadeDeEnvio = {
                    intPosicao: 0,
                    intTamanhoPagina: 1,
                    clsEntidade: {
                        ano: Leitura.anoReferencia,
                        mes: Leitura.mesReferencia,
                        hidrometro: null,
                        cliente: Leitura.codigoCliente,
                        nomeArquivoExportacao: Leitura.nomeArquivoExportacao
                    }
                };
                vm.iniciarChamandoPesquisa = true;
            } else {
                vm.visualizandoLeituraComCritica = false;
                vm.editandoLeituraComRetencao = false;
                VisualizacaoLeituraFactory.setEditandoComRetencao(false);
                if ($state.params.parametrosProdutividade) {
                    var parametros = $state.params.parametrosProdutividade;
                    vm.entidadeDeEnvio = {
                        intPosicao: 0,
                        intTamanhoPagina: 1,
                        clsEntidade: {
                            clientes: parametros.clientes,
                            leiturista: parametros.leiturista,
                            nomesArquivosExportacao: parametros.arquivos
                        }
                    };
                    vm.clsEntidade = vm.entidadeDeEnvio.clsEntidade;
                    vm.iniciarChamandoPesquisa = true;
                }
                else {
                    vm.entidadeDeEnvio = {
                        intPosicao: 0,
                        clsEntidade: {}
                    };
                }
            }

            vm.leituristas = ListarTodosLeituristas.data;
            VisualizacaoLeituraFactory.setLeituristas(ListarTodosLeituristas.data);

            vm.filtros = ["Todos", "Leiturista", "Cliente", "Hidrômetro"];

            vm.opcaoFiltro = vm.filtros[0];

            vm.filtroSelecionado = {
                ano: new Date().getFullYear(),
                mes: new Date().getMonth() + 1,
                hidrometro: "",
                cliente: ""
            };

            vm.listaRegionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);

            if (vm.listaRegionais && vm.listaRegionais.length > 0) {
                vm.filtroSelecionado.regional = vm.listaRegionais[0].codigo;
                onChangeRegional();
            }
        }

        angular.isUndefinedOrNull = function (val) {
            return angular.isUndefined(val) || val === null;
        };

        function _limparFiltrosRadio() {
            vm.filtroSelecionado.hidrometro = null;
            vm.filtroSelecionado.cliente = null;
            vm.filtroSelecionado.codigoLeiturista = null;
        }

        function _pesquisarBotao() {
            vm.leituraComCritica = false;
            vm.leituraComCriticaPendenteExecucao = false;
            vm.clsEntidade = undefined;
            vm.entidadeDeEnvio.intPosicao = 1;
            vm.metodosExternosPgToolbar.metodoControladorExternoPesquisar();
            vm.emProgresso = true;
        }

        vm.habilitaBotaoSidenav = function () {
            return $mdSidenav("filtro").isOpen();
        };

        function abrirFiltro() {
            $mdSidenav('filtro').toggle();
        }

        function _pesquisar() {
            if (!vm.iniciarChamandoPesquisa) {
                vm.entidadeDeEnvio.clsEntidade = angular.copy(vm.filtroSelecionado);
            }
            else if (vm.clsEntidade) {
                vm.entidadeDeEnvio.clsEntidade = vm.clsEntidade;
            }

            vm.leituraComCritica = false;
            vm.leituraComCriticaPendenteExecucao = false;
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
                rotaApi.listarPorPaginacao,
                vm.entidadeDeEnvio
            );
        }

        function setDefaultAno() {
            if (
                vm.filtroSelecionado.ano == undefined
            )
                vm.filtroSelecionado.ano = new Date().getFullYear();
        }

        function setDefaultMes() {
            if (
                vm.filtroSelecionado.mes == undefined ||
                vm.filtroSelecionado.mes <= 0 ||
                vm.filtroSelecionado.mes > 12
            )
                vm.filtroSelecionado.mes = new Date().getMonth() + 1;
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element("#select").on("keydown", function (ev) {
                ev.stopPropagation();
            });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function tabSelecionada(tab) {

        }

        function _editar() {
            vm.controleForm.emProgresso = true;
            var viewModel = VisualizacaoLeituraFactory.getDadosCritica();
            if (_verificarStatusCriticaPendenteComAlteracoes(viewModel)) {
                vm.controleForm.emProgresso = false;
                MdDialogService.alertPadrao(
                    "Atenção",
                    null,
                    "Para efetivar uma crítica a mesma deverá estar com o status 'Impressão' ou 'Revisão'"
                );
                return;
            }
            var promessa = RequisicaoGenericaService.salvar(
                Api.criticaLeituras.atualizarDadosLeitura,
                viewModel
            );
            promessa.then(
                function (success) {
                    VisualizacaoLeituraFactory.resetDadosCritica();
                    vm.controleForm.emProgresso = false;
                    MdToastService.toastPadrao("Crítica realizada com sucesso!");
                    $mdDialog.hide();
                },
                function (error) {
                    vm.controleForm.emProgresso = false;
                    MdDialogService.alertPadrao(error.data);
                }
            );
        }

        function _verificarStatusCriticaPendenteComAlteracoes(dadosCritica) {
            if (dadosCritica) return dadosCritica.statusCritica == 1
        }

        function onChangeRegional() {
            vm.listandoMunicipios = true;
            MunicipioService.listarMunicipios(vm.filtroSelecionado.regional).then(
                function (success) {
                    vm.listaMunicipios = success.data;
                    vm.listandoMunicipios = false;
                },
                function (error) {
                    console.error(error);
                    vm.listandoMunicipios = false;
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.leitura.monitoramento')
    .controller('MonitoramentoController', MonitoramentoController);

  /** @ngInject */
  function MonitoramentoController(MonitoramentoService, $mdSidenav, $rootScope, $stateParams, $state,
    MonitoramentoMapaService, SessionStorageService, KeysSessionStorage, MdDialogService) {
    var vm = this;

    // Data
    init();

    // Methods
    function init() {

      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
      if (!vm.parametros.coletor.utilizaRotinaGeoprocessamento) {
        MdDialogService.alertPadrao('Atenção', null, 'Para utilizar o monitoramento é necessário ativar o geoprocessamento nos parâmetros.');
        $state.go('app.inicio', {}, {reload: true});
        return;
      }

      vm.habilitarMapa = false;
      vm.habilitarIconeVoltarATelaCarga = false;
      MonitoramentoService.conectarHub().then(function (success) {
        if ($stateParams.leiturista) {
          var parametrosGerenciamentoCarga = {
            leiturista: $stateParams.leiturista,
            data: $stateParams.data
          };

          _inicializarMonitoramentoComFiltros(parametrosGerenciamentoCarga);
        }
      });

      MonitoramentoService.habilitarMapa = function (callback) {
        var habilitar = callback();
        vm.habilitarMapa = habilitar;
      }
    }

    vm.metodos = {
      abrirFiltros: abrirFiltros,
      abrirLegenda: abrirLegenda,
      filtrar: filtar,
      implementarVoltarParaOEstado: implementarVoltarParaOEstado,
      centralizarMapa: centralizarMapa
    };

    //////////
    $rootScope.$on('habilitarMapaMonitoramento', function (event, dados) {
      vm.habilitarMapa = dados;
    })

    function _inicializarMonitoramentoComFiltros(parametrosGerenciamentoCarga) {
      MonitoramentoService.setParametrosGerenciamentoCarga(parametrosGerenciamentoCarga);
      vm.preLoader = true;
      vm.habilitarIconeVoltarATelaCarga = true;
    }

    function abrirFiltros() {
      if (MonitoramentoService.verificarLegendaAberta())
        MonitoramentoService.toggleLegenda();
      if (MonitoramentoService.verificarDashboardAberto())
        MonitoramentoService.toggleDashboard();

      MonitoramentoService.toggleFiltro();
    }

    function filtar(filtro) {
      MonitoramentoService.fitrar(filtro);
    }

    function abrirLegenda() {
      if (MonitoramentoService.verificarFiltroAberto())
        MonitoramentoService.toggleFiltro();
      if (MonitoramentoService.verificarDashboardAberto())
        MonitoramentoService.toggleDashboard();

      MonitoramentoService.toggleLegenda();
    }

    function implementarVoltarParaOEstado() {
      if ($stateParams.data) {
        $state.go('app.gerenciamento_carga', {
          dataFiltro: $stateParams.data
        });
      } else
        $state.go('app.gerenciamento_carga', {})
    }

    function centralizarMapa() {
      MonitoramentoMapaService.centralizarMapa();
    }
  }
})();

(function () {
    "use strict";

    angular
        .module("app.gerenciamento.critica.execucao")
        .controller("CriticaLeiturasController", CriticaLeiturasController);

    /** @ngInject */
    function CriticaLeiturasController(
        DatatableFactory,
        $scope,
        CriticaLeiturasFactory,
        DTDefaultOptions,
        $mdDialog,
        RotasHtml,
        Api,
        RequisicaoGenericaService,
        ListarLeituristas,
        MdDialogService,
        RegionalService,
        VisualizacaoLeituraFactory,
        $mdBottomSheet,
        ListarOcorrencias,
        $mdSidenav,
        LoginUsuarioService,
        MdToastService,
        urlApi,
        CriticaLeituraService,
        $state,
        $window
    ) {
        var vm = this;

        var rotasHtml = RotasHtml.gerenciamento.critica.execucao;

        vm.urlApi = urlApi.url_base_api;
        vm.abriuDialogVisualizacaoLeitura = false;
        vm.ordenacaoDatatable = undefined;

        vm.metodos = {
            abrirFiltroCritica: abrirFiltroCritica,
            abrirLegendaCritica: abrirLegendaCritica,
            abrirDialogVisualizacaoLeitura: abrirDialogVisualizacaoLeitura,
            atualizarLeiturasComRetencao: _atualizarListaLeiturasComRetencao,
            verificarPorcentagem: verificarPorcentagem,
            abrirExecucaoCritica: abrirExecucaoCritica,
            abrirDialogDetalheFoto: abrirDialogDetalheFoto,
            salvarExecucaoCritica: salvarExecucaoCritica,
            abrirDialogMotivo: abrirDialogMotivo,
            validarExecucaoCritica: validarExecucaoCritica,
            calcularConsumoPosCritica: calcularConsumoPosCritica,
            abrirHistoricoCritica: abrirHistoricoCritica,
            configuraMdSelectOcorrencia: configuraMdSelectOcorrencia,
            onChangeOcorrenciaCritica: onChangeOcorrenciaCritica,
            abrirNovaAbaConsultaCriticas: abrirNovaAbaConsultaCriticas
        };

        init();

        function init() {
            vm.apiDatatable = undefined;
            vm.critica = {};
            vm.ocorrencias = ListarOcorrencias.data;
            vm.exibirInformacoesAdicionais = false;
            vm.dtOptions = _construirDtOptions();
            DTDefaultOptions.setLoadingTemplate("Carregando dados ...");
        }

        $scope.$on("dadosLeiturasRetidas", function (ev, data) {
            vm.ordenar = false;
            vm.textoPesquisa = undefined;
            vm.leiturasRetidas = data;
            abrirExecucaoCritica(angular.copy(data[0]));
            vm.filtro = CriticaLeiturasFactory.getFiltro();
        });


        function abrirFiltroCritica() {
            if ($mdSidenav('legenda-critica-leituras').isOpen())
                $mdSidenav('legenda-critica-leituras').toggle();
            CriticaLeiturasFactory.toggleSidenavFiltro();
        }

        function abrirLegendaCritica() {
            if ($mdSidenav('filtro-critica-leituras').isOpen())
                CriticaLeiturasFactory.toggleSidenavFiltro();

            $mdSidenav('legenda-critica-leituras').toggle();

        }

        function abrirHistoricoCritica(critica) {
            if (vm.dialogHistoricoAberto) return;
            if (!critica)
                MdDialogService.alertPadrao("Para abrir o histórico de críticas é necessário selecionar uma matrícula.");

            var viewModel = {
                nomeArquivoExportacao: critica.leitura.nomeArquivoExportacao,
                codigoCliente: critica.leitura.codigoCliente,
                retornaHistoricoProporcional: true
            }

            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarHistoricoCritica, viewModel);

            vm.dialogHistoricoAberto = true;

            promisse.then(function (success) {
                $mdDialog.show({
                    controller: 'DialogHistoricoCriticaController as vm',
                    templateUrl: RotasHtml.gerenciamento.critica.consulta.dialogs.historico,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        historicos: success.data
                    }
                }).then(function () { vm.dialogHistoricoAberto = false })
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            });
        }

        function abrirExecucaoCritica(cliente) {
            vm.historicoCritica = {};

            _verificarExisteClienteSelecionado();
            cliente.selecionado = true;

            var criticaNoColetor = cliente.statusLeitura != '00' && cliente.statusLeitura != '05' && cliente.statusLeitura != '06';

            if (criticaNoColetor) {
                MdDialogService.alertPadrao('Não é possível editar a crítica, a mesma já foi disponibilizada no coletor.');
                cliente.criticaNoColetor = true;
            }

            vm.critica.leitura = angular.copy(cliente);
            _preencherDadosSugestaoCritica(vm.critica, cliente);

            if (!cliente.historicoCritica || cliente.historicoCritica.length == 0) {
                _buscaHistoricoCriticaLeituras(cliente);
            } else {
                vm.historicoCritica = cliente.historicoCritica;
            }

            if (!cliente.fotos) {
                _buscarHistoricoFotosCliente(cliente);
            }
        }

        function abrirDialogVisualizacaoLeitura(leitura) {
            if (vm.abriuDialogVisualizacaoLeitura) return;
            vm.abriuDialogVisualizacaoLeitura = true;
            $mdDialog
                .show({
                    controller: "VisualizacaoController",
                    controllerAs: "vm",
                    templateUrl: rotasHtml.dialogs.visualizacaoLeitura,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    mdIsFullscreen: "xs,sm,md",
                    multiple: true,
                    escapeToClose: false,
                    locals: {
                        ListarTodosLeituristas: ListarLeituristas,
                        Leitura: leitura,
                        EditarAtivo: true,
                        listaRegionais: RegionalService.listarTodos()
                    }
                })
                .then()
                .finally(function () {
                    vm.abriuDialogVisualizacaoLeitura = false;
                    _atualizarListaLeiturasComRetencao();
                    VisualizacaoLeituraFactory.resetDadosCritica();
                });
        }

        function _atualizarListaLeiturasComRetencao() {
            var viewModel = CriticaLeiturasFactory.getFiltro();

            if (viewModel.leituristas.length) {
                viewModel.leituristas = viewModel.leituristas.map(function (item) {
                    return item.codigo;
                });
            }
            vm.emProgresso = true;
            var promessa = RequisicaoGenericaService.salvar(
                Api.criticaLeituras.filtrarLeituras,
                viewModel
            );
            promessa.then(
                function (success) {
                    vm.emProgresso = false;
                    vm.leiturasRetidas = success.data;
                },
                function (error) {
                    vm.emProgresso = false;
                    MdDialogService.alertPadrao(error.data);
                    vm.leiturasRetidas = [];
                    CriticaLeiturasFactory.atualizarGruposNoFiltro();
                }
            );
        }

        function verificarPorcentagem(leitura) {
            if (leitura) {
                var porcentagem = parseInt(leitura.porcentagemConsumoFaturadoAcimaConsumoMedio);

                if (porcentagem >= 100 && porcentagem < 200)
                    return "orange";
                if (porcentagem >= 200) return "red";
            }
        }

        function _buscarHistoricoFotosCliente(cliente) {
            _inicializarProgressoHistorico();
            var viewModel = {
                codigoCliente: cliente.codigoCliente,
                gleiCodigo: cliente.gleiCodigo
            }

            var promisse = RequisicaoGenericaService.salvar(
                Api.criticaLeituras.buscarHistoricoLeiturasFotos, viewModel);

            promisse.then(function (success) {
                cliente.fotos = success.data.fotos;
                vm.critica.leitura.fotos = success.data.fotos;
            }, function (error) {
                MdDialogService.alertPadrao("Não foi possível buscar as fotos do cliente.");
                return;
            }).finally(function () { _finalizarProgressoHistorico() });

        }

        function _inicializarProgressoHistorico() {
            vm.emProgressoHist = true;
        }

        function _finalizarProgressoHistorico() {
            vm.emProgressoHist = false;
        }

        function _iniciarProgressoCritica() {
            vm.emProgressoCritica = true;
        }

        function _finalizarProgressoCritica() {
            vm.emProgressoCritica = false;
        }


        function abrirDialogDetalheFoto(foto) {
            foto = vm.urlApi + foto;

            var rota = RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura.dialogs.fotos;
            $mdDialog.show({
                controller: 'DialogDetalharFotoController',
                controllerAs: 'vm',
                templateUrl: rota.dialogs.detalharFotos,
                transclude: true,
                multiple: true,
                locals: {
                    Foto: foto
                }
            });

        }

        function salvarExecucaoCritica(critica) {
            if (critica.leitura.selecionado) critica.leitura.selecionado = false;

            critica.usuarioCritica = LoginUsuarioService.usuarioArmazenado().login;


            var verificarHistAberto = _verificarHistoricoCriticaEmAberto(critica);
            _iniciarProgressoCritica();
            verificarHistAberto.then(function (success) {
                if (success.data) {
                    _atualizarDadosCritica(critica);
                }
                else {
                    _inserirNovoHistoricoCritica(critica);
                }
            }, function (err) {
                MdDialogService.alertPadrao("Atenção", null, err.data);
            });
        }

        function _atualizarDadosCritica(critica) {
            var promisse = RequisicaoGenericaService.editar(Api.criticaLeituras.atualizarDadosCritica, critica);
            promisse.then(function (success) {
                MdToastService.toastPadrao("Crítica atualizada com sucesso!");
                _acaoDadosLeituraPosCritica(critica);
            }, function (error) {
                MdDialogService.alertPadrao("Não foi possível atualizar crítica. Detalhes:" + error.data);
            }).finally(function () { _finalizarProgressoCritica(); });
        }

        function _removerLeituraListaLeiturasRetidas(cliente) {
            var _proximoIndex = undefined;

            _setarOrdenacaoDatatableENaoReordenar();
            vm.leiturasRetidas = _ordenarArrayCriticaComBaseOrdenacaoDatatable(vm.leiturasRetidas, vm.ordenacaoDatatable[0]);
            var leitura = vm.leiturasRetidas.filter(function (item) {
                return item.codigoCliente === cliente
            })[0];

            if (vm.textoPesquisa) {
                vm.leiturasCopy = angular.copy(vm.leiturasRetidas);
            }

            var _index = vm.leiturasRetidas.indexOf(leitura);
            vm.leiturasRetidas.splice(_index, 1);
            _limparEntidadeCritica();

            if (vm.textoPesquisa) {
                _proximoIndex =
                    _definirIndiceProximaLeituraQuandoPesquisaPreenchida(vm.leiturasCopy, vm.leiturasRetidas, leitura);
            }

            if (_proximoIndex) {
                _abrirExecucaoCriticaIndiceDefinido(_proximoIndex);
            }
            else {
                _abrirExecucaoCriticaIndiceDefinido(_index);
            }
        }

        function _abrirExecucaoCriticaIndiceDefinido(indice) {
            if (vm.leiturasRetidas[indice]) {
                abrirExecucaoCritica(vm.leiturasRetidas[indice]);
            } else {
                if (vm.leiturasRetidas.length)
                    abrirExecucaoCritica(vm.leiturasRetidas[0]);
            }
        }

        function _limparEntidadeCritica() {
            vm.critica = {};
        }

        function _atualizarDadosLeituraEspecifica(critica) {
            var leitura = vm.leiturasRetidas.filter(function (item) {
                return item.codigoCliente === critica.leitura.codigoCliente
            })[0];
            leitura.statusCritica = angular.copy(critica.statusCritica);
            leitura.leituraCorrigida = angular.copy(critica.leituraPosCritica);
            leitura.consumoCorrigido = angular.copy(critica.consumoFaturadoPosCritica);
            leitura.ocorrenciaCorrigida = angular.copy(critica.codigoOcorrenciaPosCritica);
            leitura.motivo = angular.copy(critica.motivoCriticaNegada);
            leitura.descricaoStatusCritica = _retornarDescricaoStatusCritica(leitura.statusCritica);
            leitura.porcentagemLeituraCorrigida = _retornarPorcentagemLeituraCorrigida(critica);
            leitura.quantidadeCriticas = angular.copy(critica.leitura.quantidadeCriticas);
            leitura.erroPorLeitura = angular.copy(critica.erroPorLeitura);
            leitura.erroPorOcorrencia = angular.copy(critica.erroPorOcorrencia);
            abrirExecucaoCritica(leitura);
        }

        function _preencherDadosSugestaoCritica(critica, dados) {
            var ehRetornoRevisao = critica.leitura.statusCritica == 2 && critica.leitura.statusRetencao == 12;
            var criticaPendente = critica.leitura.statusCritica == 1;
            if (dados.quantidadeCriticas && !ehRetornoRevisao && !criticaPendente) {
                critica.leituraPosCritica = dados.leituraCorrigida;
                critica.consumoFaturadoPosCritica = dados.consumoCorrigido;
                critica.codigoOcorrenciaPosCritica = dados.ocorrenciaCorrigida;
                critica.statusCritica = dados.statusCritica;
                critica.motivoCriticaNegada = dados.motivo;
                critica.erroPorLeitura = dados.erroPorLeitura;
                critica.erroPorOcorrencia = dados.erroPorOcorrencia;
            }
            else {
                critica.leituraPosCritica = dados.leitura;
                critica.consumoFaturadoPosCritica = dados.consumoFaturado;
                critica.codigoOcorrenciaPosCritica = dados.ocorrencia;
                critica.statusCritica = dados.statusCritica;
                critica.motivoCriticaNegada = dados.motivoCriticaNegada;
                critica.erroPorLeitura = dados.erroPorLeitura;
                critica.erroPorOcorrencia = dados.erroPorOcorrencia;
            }
        }

        function abrirDialogMotivo(motivo) {
            MdDialogService.alertPadrao("Motivo de crítica", null, motivo);
        }

        function _verificarConsumoFaturadoAcimaMedio(critica) {

            if (critica.leitura.consumoMedio == 0)
                return false;

            if (critica.leitura.geraAltoConsumo === "S")
                return critica.consumoFaturadoPosCritica > (critica.leitura.consumoMedioElevado * 20)

            return critica.consumoFaturadoPosCritica > (critica.leitura.consumoMedio * 20)
        }

        function validarExecucaoCritica(critica) {
            if (_verificarConsumoFaturadoAcimaMedio(critica)) {
                var mensagem = "O consumo " + critica.consumoFaturadoPosCritica + " da unidade " + critica.leitura.codigoCliente +
                    " superou em vinte vezes a média de consumo.<br>Deseja continuar a operação?";
                MdDialogService.confirmPadraoComEvento("Atenção", mensagem, event, function () { salvarExecucaoCritica(critica) }, function () { });
            }
            else if (critica.consumoFaturadoPosCritica == 0) {
                var mensagem = "O consumo da crítica está zerado, não haverá cobrança de consumo para essa matrícula.<br>Deseja continuar a operação?";
                MdDialogService.confirmPadraoComEvento("Atenção", mensagem, event, function () { salvarExecucaoCritica(critica) }, function () { });
            }
            else {
                salvarExecucaoCritica(critica);
            }
        }

        function _acaoDadosLeituraPosCritica(critica) {
            var statusCritica = critica.statusCritica;
            if (statusCritica == 2 || statusCritica == 3 || statusCritica == 4) {
                _verificarAcaoParaStatusCriticado(critica);
            }
        }

        function _verificarAcaoParaStatusCriticado(critica) {
            if (vm.filtro.criticados) {
                _atualizarDadosLeituraEspecifica(critica);
                return;
            }
            _removerLeituraListaLeiturasRetidas(critica.leitura.codigoCliente);
            return;
        }

        function _retornarDescricaoStatusCritica(statusCritica) {
            switch (statusCritica) {
                case 1:
                    return "Pendente";
                case 2:
                    return "Revisão";
                case 3:
                    return "Impressão";
                case 4:
                    return "Rev. impr."
                default:
                    break;
            }
        }

        function calcularConsumoPosCritica(critica) {
            var consumo = critica.leituraPosCritica - critica.leitura.historico[0].leitura;
            critica.consumoFaturadoPosCritica = consumo >= 0 ? consumo : "";
        }

        function _retornarPorcentagemLeituraCorrigida(critica) {
            if ((!critica.leituraPosCritica || critica.leituraPosCritica == 0) || (!critica.leitura.leitura || critica.leitura.leitura == 0)) {
                return '-'
            }
            var porcentagem = critica.leituraPosCritica / critica.leitura.leitura;
            return porcentagem > 1 ? Math.trunc((porcentagem - 1) * 100).toString() + "%" : Math.trunc((1 - porcentagem) * 100).toString() + "%"
        }

        function _verificarHistoricoCriticaEmAberto(critica) {
            return RequisicaoGenericaService.salvar(Api.criticaLeituras.verificarHistoricoEmAberto, critica);
        }

        function _inserirNovoHistoricoCritica(critica) {
            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.atualizarDadosLeitura, critica);
            promisse.then(function (success) {
                if (!critica.leitura.quantidadeCriticas) critica.leitura.quantidadeCriticas = 1;
                MdToastService.toastPadrao("Crítica executada com sucesso!");
                _acaoDadosLeituraPosCritica(critica);
            }, function (error) {
                MdDialogService.alertPadrao("Não foi possível executar crítica. Detalhes:" + error.data); _
            }).finally(function () { _finalizarProgressoCritica(); });
        }

        function _verificarExisteClienteSelecionado() {
            var cliente = vm.leiturasRetidas.filter(function (item) {
                return item.selecionado
            })[0];
            if (cliente) cliente.selecionado = false;
        }


        function configuraMdSelectOcorrencia() {
            vm.filtrarOcorrencia = "";
            angular.element('#select-ocorrencia').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function _construirDtOptions() {
            var options = DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao(
                [
                    {
                        targets: [4, 5, 7, 8],
                        orderable: false
                    },
                    {
                        targets: [2],
                        responsivePriority: 1,

                    },
                    {
                        targets: [1],
                        orderData: 0,
                        searchable: false
                    },
                    {
                        targets: [2],
                        orderData: [2, 0]
                    },
                    {
                        targets: [3],
                        orderData: [3, 2]
                    },
                    {
                        targets: [6],
                        orderData: [6, 2]
                    }
                ]
            );
            options.order = [2, 'asc'];
            options.lengthMenu = [20];
            options.pageLength = 20;
            options.dom = '<"top"f>rt<"bottom"<"left"><"right"<"info"i><"pagination"p>>>';
            options.initComplete = function () {
                var api = this.api();
                vm.apiDatatable = api;
                if (vm.ordenacaoDatatable && vm.ordenar) {
                    vm.ordenar = false;

                    if (vm.textoPesquisa)
                        api.search(vm.textoPesquisa);

                    api.order(vm.ordenacaoDatatable).draw();
                    vm.ordenacaoDatatable = undefined;
                }
                return;
            }
            return options;
        }

        function _setarOrdenacaoDatatableENaoReordenar() {
            vm.textoPesquisa = angular.element('.dataTables_filter input').val();
            vm.ordenacaoDatatable = vm.apiDatatable.order();
            vm.ordenar = true;
        }

        function _ordenarArrayCriticaComBaseOrdenacaoDatatable(array, ordenacao) {
            var campoOrdenacao = ordenacao[0];
            var tipoOrdenacao = ordenacao[1];
            array = CriticaLeituraService.ordenarArrayUsandoOrdenacaoDatatable(array, campoOrdenacao, tipoOrdenacao);
            return array;
        }

        function _definirIndiceProximaLeituraQuandoPesquisaPreenchida(criticasCopy, criticasNovo, leitura) {

            var props = ['codigoCliente', 'localizacao', 'leitura', 'consumoFaturado', 'ocorrencia', 'porcentagemConsumoFaturadoAcimaConsumoMedio'];

            var _array = [];

            criticasCopy.forEach(function (item) {
                Object.keys(item).forEach(function (prop) {
                    if (prop === 'dataHoraColeta') {
                        var data = new Date(item[prop]).getDate() + '/' + (new Date(item[prop]).getMonth() + 1).toString().padStart(2, '0');

                        if (data.includes(vm.textoPesquisa)) {
                            _array.push(item);
                        }
                    }
                    else {
                        if (props.includes(prop) && item[prop].toString().includes(vm.textoPesquisa)) {
                            _array.push(item);
                        }
                    }
                });
            });

            var critica = _array.filter(function (item) {
                return item.codigoCliente === leitura.codigoCliente
            })[0];

            var proximoCliente = _array[_array.indexOf(critica) + 1].codigoCliente;

            var leituraCriticaNovo = criticasNovo.filter(function (item) {
                return item.codigoCliente === proximoCliente
            })[0]

            return criticasNovo.indexOf(leituraCriticaNovo);
        }

        function onChangeOcorrenciaCritica(ocorrenciaCodigo, nomeArquivoExportacao) {

            var viewModel = {
                ocorrenciaCodigo: ocorrenciaCodigo,
                nomeArquivoExportacao: nomeArquivoExportacao
            }

            var promisse = CriticaLeituraService.buscarDadosOcorrenciaCritica(viewModel);
            vm.emProgressoOcorrencia = true;
            promisse.then(function (success) {
                vm.critica.leitura.somenteOcorrencia = !success.data.existeLeitura;
                if (!success.data.existeLeitura) {
                    vm.critica.leituraPosCritica = undefined;
                } else {
                    if (vm.critica.leitura.leitura) {
                        vm.critica.leituraPosCritica = vm.critica.leitura.leitura;
                        calcularConsumoPosCritica(vm.critica)
                    }
                }
            }, function (err) {
                MdDialogService.alertPadrao("Atenção", event, err.data);
            }).finally(function () { vm.emProgressoOcorrencia = false; });
        }

        function _buscaHistoricoCriticaLeituras(cliente) {

            var viewModel = {
                nomeArquivoExportacao: cliente.nomeArquivoExportacao,
                codigoCliente: cliente.codigoCliente,
                retornaHistoricoProporcional: true
            }

            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarHistoricoCritica, viewModel);

            promisse.then(function (success) {
                vm.historicoCritica = success.data;
                cliente.historicoCritica = success.data;
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            });
        }

        function abrirNovaAbaConsultaCriticas() {
            var filtro = CriticaLeiturasFactory.getFiltro();
            $state.goNewTab('app.gerenciamento_consultacritica', {
                dadosFiltro: {
                    ano: filtro.ano,
                    grupo: filtro.grupo,
                    mes: filtro.mes,
                    municipio: filtro.municipio,
                    regional: filtro.regional,
                    leituristas: filtro.leituristas
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.critica.consulta')
        .controller('ConsultaCriticaController', ConsultaCriticaController)

    /** @ngInject */
    function ConsultaCriticaController($mdDialog, RotasHtml, MdDialogService, DatatableFactory,
        DTDefaultOptions, $scope, ConsultaCriticaFactory, RegionalService, ListarLeituristas, RequisicaoGenericaService, Api, $state) {
        var vm = this;

        var rotasHtml = RotasHtml.gerenciamento.critica.consulta;

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            abrirDialogVisualizacaoLeitura: abrirDialogVisualizacaoLeitura,
            atualizarCriticas: _atualizarCriticas,
            abrirDialogHistorico: abrirDialogHistorico,
            marcarTodos: marcarTodos,
            liberarCriticas: liberarCriticas,
            liberarTodasCriticas: liberarTodasCriticas
        }
        vm.abriuDialogLeitura = false;

        init();

        function init() {
            if ($state.params.dadosFiltro) {
                ConsultaCriticaFactory.setFiltro($state.params.dadosFiltro);
                _atualizarCriticas();
            }


            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [0, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                    orderable: false
                },
                {
                    targets: [2],
                    orderData: 1
                },
                {
                    targets: [0, 2],
                    responsivePriority: 1
                }
            ]);
            //vm.dtOptions.dom = '<"top"f>rt<"bottom"<"left"<"info"i>>>';  
            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
        }

        $scope.$on("dadosConsultaCritica", function (ev, data) {
            vm.criticas = data;
        });

        function abrirFiltro() {
            ConsultaCriticaFactory.toggleSidenavFiltro();
        }

        function abrirDialogVisualizacaoLeitura(leitura) {
            if (vm.abriuDialogLeitura) return;
            vm.abriuDialogLeitura = true;
            $mdDialog.show({
                controller: 'VisualizacaoController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.visualizacaoLeitura,
                targetEvent: event,
                clickOutsideToClose: false,
                mdIsFullscreen: 'xs,sm,md',
                multiple: true,
                escapeToClose: false,
                locals: {
                    ListarTodosLeituristas: ListarLeituristas,
                    Leitura: leitura,
                    EditarAtivo: false,
                    listaRegionais: RegionalService.listarTodos()
                }
            }).then().finally(function () {
                vm.abriuDialogLeitura = false;
                _atualizarCriticas();
            });
        }

        function abrirDialogHistorico(critica) {

            var viewModel = {
                nomeArquivoExportacao: critica.nomeArquivoExportacao,
                codigoCliente: critica.codigoCliente,
                retornaHistoricoProporcional: true
            }

            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.buscarHistoricoCritica, viewModel);

            promisse.then(function (success) {
                $mdDialog.show({
                    controller: 'DialogHistoricoCriticaController as vm',
                    templateUrl: rotasHtml.dialogs.historico,
                    multiple: true,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        historicos: success.data,
                        dtOptions: vm.dtOptions
                    }
                });
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            });


        }

        function _atualizarCriticas() {
            var viewModel = ConsultaCriticaFactory.getFiltro();

            if (viewModel.leituristas.length) {
                viewModel.leituristas = viewModel.leituristas.map(function (item) {
                    return item.codigo;
                });
            }
            vm.emProgresso = true;
            var promessa = RequisicaoGenericaService.salvar(Api.criticaLeituras.filtrarCriticas, viewModel);
            promessa.then(function (success) {
                vm.emProgresso = false;
                vm.criticas = success.data;
            }, function (error) {
                vm.emProgresso = false;
                MdDialogService.alertPadrao(error.data);
                vm.criticas = [];
                ConsultaCriticaFactory.atualizarGruposNoFiltro();
            });
        }

        function marcarTodos() {
            vm.criticas.forEach(function (item) {
                item.marcado = vm.selecionarTodos;
            });
        }

        function liberarTodasCriticas() {
            MdDialogService.confirmPadraoComEvento("Atenção", "Deseja liberar todas as críticas filtradas?", event, liberarCriticas);
        }

        function liberarCriticas(liberarSelecionadas) {
            var criticas = _montarListaCriticasParaDistribuicao(liberarSelecionadas);

            if (!criticas.length && liberarSelecionadas) {
                MdDialogService.alertPadrao("Para continuar a operação é necessário marcar pelo menos uma leitura com crítica.");
                return;
            }
            var viewModel = {
                criticas: criticas
            }
            var promisse = RequisicaoGenericaService.salvar(Api.criticaLeituras.liberarCriticasDistribuicao, viewModel);
            _inicarProgressoCritcas();
            promisse.then(function () {
                MdDialogService.alertPadrao("Críticas liberadas com sucesso!");
                if (!liberarSelecionadas) {
                    vm.criticas = [];
                    return;
                }
                _removerCriticasMarcadas();
            }, function (err) {
                MdDialogService.alertPadrao(err.data);

            }).finally(function () { _finalizarProgressoCriticas() });
        }

        function _montarListaCriticasParaDistribuicao(liberarApenasSelecionados) {
            if (!liberarApenasSelecionados) {
                return vm.criticas.map(function (item) {
                    return {
                        codigoCliente: item.codigoCliente,
                        gleiCodigo: item.gleiCodigo
                    }
                });
            }
            else {
                return _retornaCriticasMarcadas().map(function (criticaMarcada) {
                    return {
                        codigoCliente: criticaMarcada.codigoCliente,
                        gleiCodigo: criticaMarcada.gleiCodigo
                    }
                });
            }
        }

        function _inicarProgressoCritcas() {
            vm.emprogressoCriticas = true;
        }
        function _finalizarProgressoCriticas() {
            vm.emprogressoCriticas = false;
        }

        function _removerCriticasMarcadas() {
            _retornaCriticasMarcadas().forEach(function (item) {
                vm.criticas.splice(vm.criticas.indexOf(item), 1);
            });
        }

        function _retornaCriticasMarcadas() {
            return vm.criticas.filter(function (critica) {
                return critica.marcado;
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.critica.acompanhamento')
        .controller('AcompanhamentoCriticasController', AcompanhamentoCriticasController)

    /** @ngInject */
    function AcompanhamentoCriticasController(AcompanhamentoCriticaService, DatatableFactory, MdDialogService, $mdMedia) {
        var vm = this;
        vm.metodos = {
            abrirFiltroAcompanhamentoCritica: abrirFiltroAcompanhamentoCritica,
            atualizarDadosAcompanhamento: atualizarDadosAcompanhamento
        }



        init();

        function init() {
            vm.menus = _montarMenus();
            AcompanhamentoCriticaService.listarDadosAcompanhamentoCritica = function (callback) {
                var dados = callback();
                AcompanhamentoCriticaService.toggleFiltroSidenav();
                vm.informacoesCritica = dados;
                vm.filtros = AcompanhamentoCriticaService.getFiltroAcompanhamento();
                vm.filtros.municipioDetalhes = AcompanhamentoCriticaService.getMunicipioFiltrado();
                vm.filtros.agrupamento = AcompanhamentoCriticaService.getAgrupamentoFiltrado();
            }

            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                {
                    targets: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                    orderable: false
                },
                {
                    targets: [2, 4, 6, 8],
                    width: '5%'
                },
                {
                    targets: [1, 3, 5, 7],
                    width: '10%'
                },
                {
                    targets: [9],
                    width: '15%'
                },
                {
                    targets: [0],
                    width: '25%'
                }
            ]);
            vm.dtOptions.dom = 'rt<"bottom"<"left"<"info"i>>>';
            vm.dtOptions.scrollY = '60vh';
            vm.dtOptions.scrollCollapse = true;

            vm.emProgresso = false;
        }

        function abrirFiltroAcompanhamentoCritica() {
            AcompanhamentoCriticaService.toggleFiltroSidenav();
        }

        function atualizarDadosAcompanhamento() {
            var _filtro = AcompanhamentoCriticaService.getFiltroAcompanhamento();
            var patualizar = AcompanhamentoCriticaService.buscarDadosAcompanhamentoCriticas(_filtro);
            _iniciarProgresso();
            patualizar.then(function (success) {
                vm.informacoesCritica = success.data;
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            }).finally(function () { _finalizarProgresso() });
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _montarMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltroAcompanhamentoCritica() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: 'Atualizar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return atualizarDadosAcompanhamento() }
                },
            ]
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.mododeimplantacao', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.mododeimplantacao;

        $stateProvider
            .state('app.modo_de_implantacao', {
                url: '/ferramentasadministrativas/mododeimplantacao',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'MododeimplantacaoController as vm',
                        abstract: true
                    },

                    'mododeimplantacao-form@app.modo_de_implantacao': {
                        templateUrl: rotasHtml.form,
                    },

                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.mododeimplantacao')
        .factory('ModoImplantacaoFactory', ModoImplantacaoFactory);

    function ModoImplantacaoFactory() {

        // #region Implementação dos métodos


        var _senha = ""
        var _emProgresso = false;
        var _progresso = 0;

        //#endregion

        //#region Definição dos Métodos
        return {
            senha: _senha,
            emProgresso: _emProgresso,
            progresso: _progresso
        }
        //#endregion



    } // FIM FACTORY

})();

(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.mododeimplantacao')
        .service('ModoImplantacaoService', ModoImplantacaoService);

    function ModoImplantacaoService($rootScope, $q, $interval, RequisicaoGenericaService, Api, ModoImplantacaoFactory, MdDialogService, 
        SessionStorageService, ControleAcessoConfig, ValidacaoService) {

        var rotaApi = Api.modoimplantacao;

        this.ativarModoImplantacao = _ativarModoImplantacao

        /**
        * Método que retorna o icone e o css com base na extensão
        * @param {keyativa} keyativa extensao do arquivo
        */
        function _ativarModoImplantacao(keyativa, senhaParam) {
            ValidacaoService.validarParametroBoolean(keyativa);
            ValidacaoService.validarParametroString(senhaParam);
            var deferred = $q.defer();
            
            if (keyativa) {                
                RequisicaoGenericaService.listarSemParams(rotaApi.validarSenhaImplantacao + senhaParam).then(
                    function (success) {
                        SessionStorageService.armazenar(ControleAcessoConfig.key_modo_implantacao, true);
                        MdDialogService.alertPadrao(success.data);
                        $rootScope.modoImplantacao = true;
                        deferred.resolve();                        
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                        deferred.reject();                        
                    })
            }
            else {
                SessionStorageService.armazenar(ControleAcessoConfig.key_modo_implantacao, keyativa);   
                $rootScope.modoImplantacao = false;             
                MdDialogService.alertPadrao("Modo de implantação desativado com sucesso!");                
                deferred.resolve();
            }

            return deferred.promise;
        }       

    }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('BackupBancoDadosService', BackupBancoDadosService)

    /** @ngInject */
    function BackupBancoDadosService(RequisicaoGenericaService, Api) {

        var service = {
            realizarBackupBancoDados: realizarBackupBancoDados,
            listarTodos: listarTodos
        };

        function realizarBackupBancoDados(codigoUsuario) {
            return RequisicaoGenericaService.listarSemParams(Api.backupbancodados.realizarBackupBancoDados + '/' + codigoUsuario);
        }

        function listarTodos() {
            return RequisicaoGenericaService.listarSemParams(Api.backupbancodados.listarTodos);
        }

        return service;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('ListaFavoritosController', ListaFavoritosController)
        .directive('listaFavoritos', listaFavoritosDirective);

    function ListaFavoritosController($mdDialog, MdToastService, DatamobilIaService, MdDialogService) {
        var vm = this;
        vm.datamobilIaService = DatamobilIaService;

        vm.metodos = {
            adicionarEditarFavoritos: adicionarEditarFavoritos,
            removerFavorito: removerFavorito
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        vm.datamobilIaService.listarFavoritos().catch(function () {
            mostrarDialogErroServidor();
        });

        function adicionarEditarFavoritos(favorito, event) {
            $mdDialog
                .show({
                    controller: "FavoritosDialogController",
                    controllerAs: "vm",
                    templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html',
                    targetEvent: event,
                    clickOutsideToClose: false,
                    multiple: true,
                    escapeToClose: false,
                    locals: {
                        favorito: angular.copy(favorito)
                    }
                });
        }

        function removerFavorito(favorito, event) {
            var titulo = 'Remover favorito';
            var htmlContent = 'Tem certeza que deseja remover este comando dos seus favoritos?';

            function eventoSim() {
                vm.datamobilIaService.removerFavorito(favorito.id).then(function () {
                    MdToastService.toastPadrao('Favorito removido com sucesso!', false);
                }).catch(function () {
                    mostrarDialogErroServidor();
                });
            }

            MdDialogService.confirmPadraoComEvento(titulo, htmlContent, event, eventoSim);
        }
    }

    function listaFavoritosDirective() {
        return {
            restrict: 'E',
            templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/lista-favoritos.html',
            scope: {
                onComandoSelecionado: '&',
                carregando: '='
            },
            controller: 'ListaFavoritosController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('MensagensRecebidasController', MensagensRecebidasController)
        .directive('mensagemRecebida', mensagemRecebida);

    function MensagensRecebidasController(DatamobilIaService, MdDialogService) {
        var vm = this;

        vm.respostaAvaliada = null;
        vm.baixandoRelatorio = false;
        vm.avaliando = { acao: null, carregando: false };

        vm.metodos = {
            avaliar: avaliar,
            download: download
        };

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function avaliar(avaliacao) {
            if (vm.avaliando.carregando) {
                return;
            }
            var novaAvaliacao = vm.respostaAvaliada === avaliacao ? null : avaliacao;

            vm.avaliando.acao = avaliacao;
            vm.avaliando.carregando = true;

            DatamobilIaService.avaliarResposta(vm.mensagem, novaAvaliacao)
                .then(function () {
                    vm.respostaAvaliada = novaAvaliacao;
                }).catch(function () {
                    mostrarDialogErroServidor();
                }).finally(function () {
                    vm.avaliando.carregando = false;
                    vm.avaliando.acao = null;
                });
        }

        function download() {
            vm.baixandoRelatorio = true;
            DatamobilIaService.gerarRelatorio(vm.mensagem.data)
                .then(function (response) {
                    DatamobilIaService.baixarArquivoXLSX(response, 'Datamobil_ia_relatorio.xlsx');
                }).catch(function () {
                    mostrarDialogErroServidor();
                }).finally(function () {
                    vm.baixandoRelatorio = false;
                });
        }
    }

    function mensagemRecebida() {
        return {
            restrict: 'E',
            scope: {
                mensagem: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagens-recebidas/mensagens-recebidas.html',
            controller: 'MensagensRecebidasController',
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('MensagensEnviadasController', MensagensEnviadasController)
        .directive('mensagemEnvio', mensagemEnvio);

    function MensagensEnviadasController($mdDialog, $timeout, DatamobilIaService) {
        var vm = this;
        vm.acaoCopiar = false;
        vm.atualizandoFavorito = false;

        vm.metodos = {
            copiarMensagem: copiarMensagem,
            atualizarFavorito: atualizarFavorito,
            isFavorito: isFavorito
        };

        function copiarMensagem(mensagem, event) {
            vm.acaoCopiar = true;

            var elementoPai = angular.element(event.currentTarget).closest('#container-mensagem-envio');
            var elemento = elementoPai.find('.mensagem-digitada')[0];
            if (elemento) {
                var texto = elemento.textContent || elemento.innerText;
                var textarea = document.createElement('textarea');
                textarea.value = texto;
                textarea.style.position = 'fixed';
                textarea.style.left = '-999999px';
                textarea.style.top = '-999999px';
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }

            $timeout(function () {
                vm.acaoCopiar = false;
            }, 3000);
        }

        function atualizarFavorito(mensagem) {
            if (!isFavorito(mensagem)) {
                $mdDialog
                    .show({
                        controller: "FavoritosDialogController",
                        controllerAs: "vm",
                        templateUrl: 'app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html',
                        targetEvent: event,
                        clickOutsideToClose: false,
                        multiple: true,
                        escapeToClose: false,
                        locals: {
                            favorito: angular.copy(mensagem)
                        }
                    });
            } else {
                vm.atualizandoFavorito = true;
                DatamobilIaService.atualizarFavorito(mensagem.comando)
                    .finally(function () {
                        vm.atualizandoFavorito = false;
                    });
            }

        }

        function isFavorito(mensagem) {
            return DatamobilIaService.isFavorito(mensagem.comando);
        }
    }

    function mensagemEnvio() {
        return {
            restrict: 'E',
            scope: {
                mensagem: '='
            },
            templateUrl: 'app/main/datamobil-ia/components/mensagem-envio/mensagem-envio.html',
            controller: 'MensagensEnviadasController',
            controllerAs: 'vm',
            bindToController: true
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('TrocarSequencialService', TrocarSequencialService)

    /** @ngInject */
    function TrocarSequencialService($mdSidenav, RequisicaoGenericaService, Api, $mdDialog, $q, RotasHtml) {

        var _filtro;

        var rotasHtml = RotasHtml.controleCarga.trocarSequencial;

        var service = {
            construirFiltroTrocaSequencial: construirFiltroTrocaSequencial,
            setFiltroTrocaSequencial: _setFiltro,
            getFiltroTrocaSequencial: _getFiltro,
            toggleFiltro: toggleFiltro,
            buscarTarefasLeiturista: buscarDadosTarefas,
            buscarGrupos: buscarGrupos,
            abrirDialogAlterarSequencial: abrirDialogAlterarSequencial,
            alterarSequencialTarefas: alterarSequencialTarefas,
            buscarDadosTarefasMultiplosGrupos: buscarDadosTarefasMultiplosGrupos,
            alterarSequencialTarefasMultiplosGrupos: alterarSequencialTarefasMultiplosGrupos,
        };

        function construirFiltroTrocaSequencial() {
            var data = new Date();
            return {
                leiturista: undefined,
                agrupamento: undefined,
                mes: data.getMonth() + 1,
                ano: data.getFullYear(),
                grupo: undefined,
                municipio: undefined
            }
        }

        function _setFiltro(filtro) {
            _filtro = filtro;
        }

        function _getFiltro() {
            return angular.copy(_filtro);
        }

        function toggleFiltro() {
            $mdSidenav('filtro-trocarsequencial').toggle();
        }

        function buscarDadosTarefas(leiturista) {
            return RequisicaoGenericaService.salvar(Api.trocaSequencial.listarTarefas, leiturista);
        }

        function buscarGrupos(agrupamento, mes, ano) {
            return RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + agrupamento + '&mes=' + mes + '&ano=' + ano);
        }

        function alterarSequencialTarefas(tarefas) {
            return RequisicaoGenericaService.salvar(Api.trocaSequencial.alterarSequencialTarefas, tarefas);
        }

        function buscarDadosTarefasMultiplosGrupos(leiturista) {
            return RequisicaoGenericaService.salvar(Api.trocaSequencial.listarTarefasMultiplosGrupos, leiturista);
        }

        function alterarSequencialTarefasMultiplosGrupos(tarefas) {
            return RequisicaoGenericaService.salvar(Api.trocaSequencial.alterarSequencialTarefasMultiplosGrupos, tarefas);
        }

        function abrirDialogAlterarSequencial(tarefa) {
            var deferred = $q.defer();

            $mdDialog.show({
                controller: 'DialogAlterarSequencialController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.alterarNumeroSequencial,
                targetEvent: event,
                escapeToClose: false,
                multiple: true,
                clickOutsideToClose: false,
                locals: {
                    Tarefa: tarefa
                }
            }).then(function (success) {
                deferred.resolve(success);
            }, function (error) {
                deferred.reject(error);
            });


            return deferred.promise;
        }


        return service;
    }

}());
(function () {
    'use strict';
    angular
        .module('app.controlecarga.faturasretidas')
        .service('ControleCargaFaturasRetidasService', ControleCargaFaturasRetidasService)
    /** @ngInject */
    function ControleCargaFaturasRetidasService(RequisicaoGenericaService, Api, $mdSidenav) {
        var _filtro;
        var _emProgresso = false;
        var _onFiltroCallback = null;
        var _onProgressoCallback = null;

        var service = {
            toggleFiltro: toggleFiltro,
            setFiltro: setFiltro,
            getFiltro: getFiltro,
            filtrar: filtrar,
            getEmProgresso: getEmProgresso,
            onFiltroRealizado: onFiltroRealizado,
            onProgressoChanged: onProgressoChanged
        }

        function toggleFiltro() {
            $mdSidenav('sidenav-faturas-retidas').toggle();
        }

        function setFiltro(filtro) {
            _filtro = filtro;
        }

        function getFiltro() {
            return angular.copy(_filtro);
        }

        function filtrar(filtro) {
            setFiltro(filtro);
            _setEmProgresso(true);
            return RequisicaoGenericaService.salvar(Api.faturasRetidas.listarFaturasRetidas, filtro)
                .then(function (response) {
                    _setEmProgresso(false);
                    if (_onFiltroCallback) {
                        _onFiltroCallback(response);
                    }
                    $mdSidenav('sidenav-faturas-retidas').close();
                    return response;
                })
                .catch(function (error) {
                    _setEmProgresso(false);
                    console.error('Erro ao filtrar faturas retidas:', error);
                    throw error;
                });
        }

        function getEmProgresso() {
            return _emProgresso;
        }

        function onFiltroRealizado(callback) {
            _onFiltroCallback = callback;
        }

        function onProgressoChanged(callback) {
            _onProgressoCallback = callback;
        }

        function _setEmProgresso(valor) {
            _emProgresso = valor;
            if (_onProgressoCallback) {
                _onProgressoCallback(valor);
            }
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.controlecarga.trocarleiturista')
        .service('TrocarLeituristaService', TrocarLeituristaService)

    /** @ngInject */
    function TrocarLeituristaService($mdSidenav, RequisicaoGenericaService, Api) {

        var _filtro;
        var service = {
            toggleFiltroTrocarLeiturista: toggleFiltroTrocarLeiturista,
            getFiltro: getFiltro,
            setFiltro: setFiltro,
            buscarGrupos: buscarGrupos,
            buscarTarefas: buscarTarefas,
            construirFiltroTrocaLeiturista: construirFiltro,
            filtrarDadosTarefaTroca: filtrarDadosTarefaTroca,
            salvarTrocaLeiturista: salvarTrocaLeiturista,
            filtrarDadosTrocaMultiplosGrupos: filtrarDadosTrocaMultiplosGrupos,
            salvarTrocaMultiplosGrupos: salvarTrocaMultiplosGrupos
        };

        function setFiltro(filtro) {
            _filtro = angular.copy(filtro);
        }
        function getFiltro() {
            return angular.copy(_filtro);
        }

        function toggleFiltroTrocarLeiturista() {
            $mdSidenav('filtro-troca-leiturista').toggle();
        }

        function construirFiltro() {
            var data = new Date();
            return {
                agrupamento: undefined,
                leiturista: undefined,
                mes: data.getMonth() + 1,
                ano: data.getFullYear(),
                tarefa: undefined
            }
        }

        function buscarGrupos(agrupamento, mes, ano) {
            return RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + agrupamento + '&mes=' + mes + '&ano=' + ano);
        }

        function buscarTarefas(agrupamento, mes, ano, grupo) {
            var viewModel = {
                agrupamento: agrupamento,
                mes: mes,
                ano: ano,
                grupo: grupo,
                tarefa: undefined
            }

            return RequisicaoGenericaService.salvar(Api.trocarLeiturista.buscarTarefas, viewModel);
        }

        function filtrarDadosTarefaTroca(viewModel) {
            return RequisicaoGenericaService.salvar(Api.trocarLeiturista.filtrarDadosTarefaTroca, viewModel)
        }

        function filtrarDadosTrocaMultiplosGrupos(viewModel) {
            return RequisicaoGenericaService.salvar(Api.trocarLeiturista.filtrarDadosTrocaMultiplosGrupos, viewModel)
        }

        function salvarTrocaLeiturista(viewModel) {
            return RequisicaoGenericaService.salvar(Api.trocarLeiturista.salvarTrocaLeiturista, viewModel)
        }

        function salvarTrocaMultiplosGrupos(viewModel) {
            return RequisicaoGenericaService.salvar(Api.trocarLeiturista.salvarTrocaLeituristaMultiplosGrupos, viewModel)
        }

        return service;
    }

}());
(function () {
  'use strict';

  angular
    .module('app.service')
    .service('CancelarCargaService', CancelarCargaService)

  /** @ngInject */
  function CancelarCargaService($mdSidenav, RequisicaoGenericaService, Api) {

    var _filtro;

    var service = {
      construirFiltroCancelarCarga: construirFiltroCancelarCarga,
      buscarDadosArquivos: buscarDadosArquivos,
      cancelarCarga: cancelarCarga,
      setFiltroCancelarCarga: _setFiltro,
      getFiltroCancelarCarga: _getFiltro,
      toggleFiltro: toggleFiltro,
    };

    function construirFiltroCancelarCarga() {
      var data = new Date();
      return {
        mes: (data.getMonth() + 1).toString().padStart(2, '0'),
        ano: data.getFullYear(),
        leiturista: 0,
      }
    }

    function _setFiltro(filtro) {
      _filtro = filtro;
    }

    function _getFiltro() {
      return angular.copy(_filtro);
    }

    function toggleFiltro() {
      $mdSidenav('filtro-cancelarcarga').toggle();
    }

    function buscarDadosArquivos(filtro) {
      return RequisicaoGenericaService.salvar(Api.cancelarCarga.filtrarDadosCancelamento, filtro);
    }

    function cancelarCarga(carga) {
      return RequisicaoGenericaService.salvar(Api.cancelarCarga.cancelar, carga);
    }

    return service;
  }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.parametros')
        .service('ParametrosService', ParametrosService);

    /** @ngInject */
    function ParametrosService($http, Api, urlApi, TokenService) {
        this.uploadLogomarca = function (arquivos) {
            var formData = new FormData();
            var _token = TokenService.getToken();
            angular.forEach(arquivos, function (obj) {
                formData.append('files[]', obj.lfFile);
            });

            return $http.post(urlApi.url_base_api + Api.parametros.uploadLogomarca, formData, {
                timeout: 60000,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined, "Authorization": "Bearer " + _token }
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cadastros.parametros')
        .factory('ParametrosFactory', ParametrosFactory);

    function ParametrosFactory() {

        // #region Implementação dos métodos


        var _parametro = {
            codigo: 0,
            codigoOcorrenciaLeituraMenorAnterior: 0,
            fixaProximaLeitura: "",
            bolCodigo: 0,
            grupoExportacao: "",
            anoMesExportacao: "",
            tipoProcesso: "",
            processaIdentificadorFimArquivo: "",
            utilizaExportacaoMultiplosArquivos: "",
            bloquearImportacaoNaoVisitadosRepasseRepassar: "",
            bloquearImportacaoContasRetidas: "",
            exportarRepasseRealizar: "",
            exibeMensagensBancoDados: "",
            tipoPadraoExibicaoMapa: 0,
            utilizaRedistribuicaoLeiturasExportadaColetor: "",
            utilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa: "",
            utilizaAtualizacaoOcorrencia: "",
            codigoSistemaProtecao: 0,
            utilizaGrupoCalculo: "",
            utilizaAuditoriaValoresImportacao: "",
            bloqueiaNovaExportacaoImportacaoGrupoMesmoNomeArquivo: "",
            numeroDiasInicioAtualizacaoAutomatica: 0,
            utilizaEliminacaoAutomaticaLeiturasJaImportadas: "",
            utilizaAuditoriaValorServico: "",
            utilizaAuditoriaRegistrosLayout: "",
            tipoAcaoAuditoriaValorMaximoFatura: "",
            empresa: {
                nomeEmpresa: "",
                endereco: "",
                cidade: "",
                bairro: "",
                cep: "",
                cnpj: "",
                ie: "",
                telefone: "",
                fax: "",
                email: "",
                site: "",
                tipoEmpresa: 0,
                tipoSegmento: "",
                tipoCidade: "",
                codigoImanager: 0,
                logomarca: "",
            },
            calculo: {
                codigoOcorrenciaLeituraNormal: 0,
                codigoOcorrenciaForaFaixa: 0,
                codigoOcorrenciaVirada: 0,
                codigoOcorrenciaLigacaoSemMedidor: 0,
                codigoOcorrenciaHidrometroInvertido: 0,
                codigoOcorrenciaLeituraConfirmada: 0,
                utilizaCalculoProporcionalNumeroDias: "",
                numeroDiasLimiteCalculoNormal: 0,
                numeroDiasConsumoCalculoProporcional: 0,
                tipoDetalheCalculo: 0,
                tipoCategoriaPrioritaria01: 0,
                tipoCategoriaPrioritaria02: 0,
                tipoCategoriaPrioritaria03: 0,
                tipoCategoriaPrioritaria04: 0,
                tipoCategoriaPrioritaria05: 0,
                tipoAcaoOcorrencia: 0,
                limiteInferiorFaixa: 0,
                limiteSuperiorFaixa: 0,
                percentual: 0,
                criaServicoArredondamento: "",
                codigoServicoArredondamentoAcrescimo: 0,
                descricaoServicoArredondamentoAcrescimo: "",
                codigoServicoArredondamentoDesconto: 0,
                descricaoServicoArredondamentoDesconto: "",
                referenciaArredondamentoValorTotalConta: 0,
                digitoDesconsideradoArredondamento: 0,
                codigoOcorrenciaHidrometroNovo: 0,
                igualarConsumoALeituraAtualQuandoHidrometroNovo: "",
                utilizaPadronizacaoConsumoForaFaixa: "",
                percentualConsumoForaFaixaAbaixoMedia: 0,
                percentualConsumoForaFaixaAcimaMedia: 0,
                utilizaConsistenciaLeituraNegativa: "",
                tipoDataLeituraCalculoProporcional: "",
                realizaCobrancaAguaEsgotoConsumoZerado: "",
                utilizaEntidadeCalculoValorCategoria: "",
                consumoAdicionalAConsistirLeituraForaFaixa: "",
                consisteForaFaixaMesmoSemParametrosConsumo: "",
                utilizaCreditoConsumo: "",
                retornaConsumoRealQuandoNaoCalculaFatura: "",
                codigoOcorrenciaSituacaoExcecaoComConsumo: 0,
                utilizaCasasDecimaisValorTotalConta: "",
                numeroCasasDecimaisValorTotalConta: 0,
                codigoOcorrenciaCalculoProporcional: 0,

            },
            coletor: {
                exibeInformacaoLeitura: "",
                senhaSaida: "",
                senhaControleRotina: "",
                tipoTela: "",
                tipoConfiguracao: 0,
                utilizaVariasOcorrencias: "",
                mostraConsumoMedio: "",
                timeoutGPS: 0,
                utilizaRecursoConsumoMedio: "",
                tipoAcaoFaixaConsumo: "",
                utilizaRotinaEliminaLeitura: "",
                permiteReimpressaoConta: "",
                mensagemPrincipal: "",
                tipoServicoArredondamento: "",
                permiteCancelamentoLeitura: "",
                utilizaTipoEntrega: "",
                utilizaMotivoNaoEntrega: "",
                stringParametrizacao: "",
                utilizaRotinaRepasse: "",
                utilizaTrocaLeiturista: "",
                utilizaAlertaDiasConsumoLimite: "",
                numeroDiasConsumoLimiteAlerta: 1,
                utilizaInformacaoFonteAlternativaTelaLeitura: "",
                utilizaSenhaCancelamentoLeitura: "",
                utilizaConsistenciaCategoria: "",
                utilizaRotinaFotosObservacaoLeitura: "",
                utilizaImpressaoFotoComunicadoOcorrencia: "",
                utilizaCapturaFotoOcorrenciaAutomatica: "",
                utilizaPesquisaRapidaTelaLeitura: "",
                utilizaIdentificadorImportacaoServicos: "",
                utilizaLancamentoOcorrenciaRota: "",
                intervaloMaximoEstatisticaLeitura: "",
                destacaSituacaoExcecaoClienteTelaLeitura: "",
                configuracaoVisualizacaoTelaLeitura: "",
                limiteMaximoTentativasLeitura: 0,
                limiteMaximoNumeroDigitosHidrometro: 0,
                obrigaGPSAtivo: "",
                utilizaExibicaoSituacaoLeitura: "",
                leituraConsumoFracionadoSegmento: '00',
                leituraConsumoFracionadoCasasDecimaisAgua: 4,
                leituraConsumoFracionadoCasasDecimaisGas: 4,
                imprimeConsumoMedidoCampoFaturadoQuandoMenorMinimo: 1,
                enviaFotosEmTempoReal: "",
                gerarLogFluxoRotinas: false
            },
            comunicado: {
                utilizaComunicadoConsumoAlterado: "",
                utilizaComunicadoDebitoAnterior: "",
                layoutComunicadoDebitoAnterior: "",
                confirmaImpressaoConsumoAlterado: "",
                confirmaImpressaoDebitoAnterior: "",
                mensagemConsumoAlterado: "",
                mensagemDebitoAnterior: "",
                utilizaMensagemDebitoPagamentoAtraso: "",
                mensagemDebitoPagamentoAtraso: "",
                mensagemEnviarDebitoSeparado: "",
                utilizaValidadeComunicadoDebito: "",
                numeroDiasValidadeComunicadoDebito: 0,
                mensagemComunicadoOcorrencia: "",
                mensagemComunicadoQuitacaoAnualDebitos: "",
                imprimirSempreComunicadoCA: "",
                imprimirSempreComunicadoDA: "",
                imprimirSempreComunicadoQA: "",
                imprimirSempreComunicadoOC: "",
                mensagemComunicadoAlternativo: "",
                utilizaComunicadoAlternativo: "",
                imprimirSempreComunicadoAlternativo: "",
                tituloComunicadoAlternativo: "",
                tipoInformacaoImpressaComunicadoDebitosNaFatura: "",
                utilizaImpressaoCanhotoComunicadoDebito: "",
                imprimeComunicadoConsumoAlteradoEmCampoComContaRetida: "",
                imprimeComunicadoDebitoAnteriorEmCampoComContaRetida: "",
                imprimeComunicadoOcorrenciaEmCampoComContaRetida: "",
                imprimeComunicadoQuitacaoAnualEmCampoComContaRetida: "",
                imprimeComunicadoAlternativoEmCampoComContaRetida: "",
                tituloComunicadoQuitacaoAnualDebitos: "",
                utilizaConfiguracaoTituloComunicadoDebitos: "",
                tituloComunicadoDebitos: "",
                mensagemServicoCobrancaAvulsa: "",
                utilizaServicoCobrancaAvulsa: false,
                imprimirSempreServicoCobrancaAvulsa: false,
                tituloServicoCobrancaAvulsa: "",
                imprimeServicoCobrancaAvulsaEmCampoComContaRetida: false
            },
            impressao: {
                imprimeCodigoBarrasDebitoAutomatico: "",
                utilizaFonteParametrizada: "",
                fonteCampoMensagem01: "",
                fonteCampoMensagem02: "",
                imprimeConsumoResidual: "",
                imprimirContaDescontoTotal: "",
                descricaoAgua: "",
                descricaoEsgoto: "",
                descricaoTBOAgua: "",
                descricaoTBOEsgoto: "",
                imprimeTBOUnificada: "",
                omitirConsumoFaturaTarifaMinima: "",
                imprimeAguaEsgotoIsento: "",
                imprimeCodigoBarras: "",
                tipoCodigoBarras: 0,
                imprimeMensagemAdicionalConta: "",
                tipoLayout: 0,
                imprimeServicoAguaEsgotoUnificado: "",
                descricaoAguaEsgotoUnificado: "",
                utilizaMensagemSaldoLNR: "",
                mensagemSaldoLNR: "",
                utilizaMensagemSaldoM3: "",
                mensagemSaldoM3: "",
                mensagemAlternativaFatura: "",
                mensagemFixa: "",
                utilizaMensagemFixa: "",
                geraMensagemFaturamentoReavisoAutomatica: "",
                utilizaRotinaCriticaLeituras: false
            },
            valor: {
                valorMinimoCobrancaConta: 0,
                valorLeituraImpressaoSimultanea: 0,
                valorSomenteLeitura: 0,
                valorComunicadoDebito: 0,
                valorComunicadoConsumoAlterado: 0,
                valorComunicadoPorOcorrencia: 0,
                valorComunicadoQuitacaoAnual: 0,
                valorComunicadoAlternativo: 0,
                valorMaximoImpressaoFatura: 0,
                valorExtratoDebito: 0,
            },
            quantidadeLeiturasPendentesEnvioOnlinePermitida: 0,
            parametroJobRetencao: {
                utilizaRentencaoDados: false,
            }
        }

        //#endregion

        //#region Definição dos Métodos
        return {
            parametro: _parametro
        }
        //#endregion



    } // FIM FACTORY

})();

/**
 * Created by nova on 18/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.perfil')
        .controller('PerfilController', PerfilController);

    function PerfilController(PerfilFactory, Api, RequisicaoGenericaService, DataTableConfigPadrao) {
        var vm = this;

        vm.perfil = {};
        vm.perfis = [];

        vm.rota = Api.perfil.retornaProximoCodigo;

        vm.dtOptions = DataTableConfigPadrao.dtOptionsPadraoComPaginacaoEReponsivo;
        vm.dtOptions.columnDefs = [DataTableConfigPadrao.columnDefsPadrao];

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar
        };

        // Implementação dos Métodos region

        /**
         * Método para pesquisar um perfil
         */
        function pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(Api.perfil.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        /**
         * Método para salvar um perfil
         * @param {perfil} perfil 
         */
        function salvar(perfil) {
            return RequisicaoGenericaService.salvar(Api.perfil.criar, perfil);
        }

        /**
         * Método para editar um perfil
         * @param {perfil} perfil 
         */
        function editar(perfil) {
            return RequisicaoGenericaService.editar(Api.perfil.atualizar, perfil);
        }

        /**
         * Método para excluir um perfil
         * @param {perfil} perfil 
         */
        function excluir(perfil) {
            return RequisicaoGenericaService.excluir(Api.perfil.excluir, perfil.codigo);
        }

        function _construirDtOptions() {
            PerfilFactory.construirDtOptions('#cadastros-usuario-perfil-datatable-perfil', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        //endregion
        //</editor-fold>
    }
})();

/**
 * Created by nova on 12/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario.usuario')
        .controller('UsuarioController', UsuarioController);

    function UsuarioController(UsuarioFactory,
        DataTableConfigPadrao,
        RequisicaoGenericaService,
        Api,
        perfis,
        $mdDialog,
        listarAgrupamentos,
        SessionStorageService,
        KeysSessionStorage,
        $q,
        MdDialogService,
        ListarTodosUsuarios,
        $scope) {
        var vm = this;

        var senhaAntiga = "";


        // Data
        vm.usuarios = null;
        vm.usuario = null;
        vm.rota = Api.usuario.retornaProximoCodigo;
        vm.perfis = perfis.data;
        vm.agrupamentos = listarAgrupamentos.data;
        vm.dtOptions = DataTableConfigPadrao.dtOptions;
        vm.agrupamentosSelecionados = [];
        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            rotinaSenha: rotinaSenha,
            detectaAlteracaoSenha: detectaAlteracaoSenha,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            configuraMdSelectAgrupamento: configuraMdSelectAgrupamento,
            novaPesquisa: novaPesquisa,
            onChangeLogin: onChangeLogin
        };

        function rotinaSenha(event) {
            var lstrController = vm.usuario.possuiSenha
                ? 'DialogAlteracaoSenhaController'
                : 'DialogInclusaoSenhaController';

            var lstrTemplateUrl = vm.usuario.possuiSenha
                ? 'compartilhado/dialog-alteracao-senha/dialog-alteracao-senha.html'
                : 'main/cadastros/usuario/usuario/views/dialogs/inclusaosenha/dialog-inclusao-senha.html';


            $mdDialog.show({
                controller: lstrController,
                controllerAs: 'vm',
                templateUrl: 'app/' + lstrTemplateUrl,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                onShowing: function () {
                    senhaAntiga = btoa(vm.usuario.senha);
                },
                onRemoving: function () {
                    if (vm.usuario.possuiSenha) {
                        detectaAlteracaoSenha(vm.usuario.senha)
                    }
                },
                locals: {
                    Usuario: vm.usuario,
                    form: vm.form
                }
            });
        }

        function detectaAlteracaoSenha(senhaAtual) {

            if (senhaAntiga != btoa(senhaAtual)) {
                vm.metodosInternosToolbar.metodoAcaoExternaEditarEntidade(null);
            }
        }

        function pesquisar() {
            var deferred = $q.defer();

            RequisicaoGenericaService.listarPorPaginacaoJsonFormato(Api.usuario.listarPorPaginacao, vm.entidadeDeEnvio).then(
                function (success) {
                    if (success.data && success.data.lstResultado.length > 0) {
                        _listarAgrupamentos(success.data.lstResultado[0].codigo);
                    }
                    else {
                        vm.agrupamento = [];
                    }
                    deferred.resolve(success);
                },
                function (erro) {

                });

            return deferred.promise;
        }

        function salvar(usuario) {
            var deferred = $q.defer();

            var userCopy = _usuarioCopy(usuario);
            vm.usuarios.push(userCopy);
            vm.entidadeDeEnvio = angular.copy(userCopy);

            RequisicaoGenericaService.salvar(Api.usuario.criar, userCopy).then(
                function (success) {
                    _vincularAgrupamentos(success.data.codigo);
                    deferred.resolve(success);
                },
                function (error) {
                    _tratarErro(error);
                }
            );

            return deferred.promise;
        }

        function editar(usuario) {
            var deferred = $q.defer();

            var userCopy = _usuarioCopy(usuario);

            RequisicaoGenericaService.editar(Api.usuario.atualizar, userCopy).then(
                function (success) {
                    _vincularAgrupamentos(success.data.codigo);
                    deferred.resolve(success);
                },
                function (error) {
                    _tratarErro(error);
                }
            );

            return deferred.promise;
        }

        function excluir(usuario) {
            return RequisicaoGenericaService.excluir(Api.usuario.excluir, usuario.codigo);
        }

        function configuraMdSelectAgrupamento() {
            vm.filtrarAgrupamentos = "";
            angular.element('#usuario-agrupamento-md-select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function novaPesquisa() {
            vm.agrupamento = [];
        }

        function _construirDtOptions() {
            if (vm.entidadeDeEnvio.clsEntidade)
                delete vm.entidadeDeEnvio.clsEntidade.possuiSenha;
            UsuarioFactory.construirDtOptions('#cadastros-usuario-usuario-datatable-usuario', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        $scope.$watch('vm.form.login.$pristine', function (novoValor) {
            if (novoValor) {
                if (vm.form.login.$error) {
                    vm.form.login.$error = {};
                }
            }
        });

        function onChangeLogin(loginUsuario, form, controleForm) {
            if (controleForm.inserirAtivo || controleForm.editarAtivo) {
                var usuarioExiste = ListarTodosUsuarios.data.some(function (usuario) {
                    return usuario.login == loginUsuario.toUpperCase() &&
                        vm.usuario.codigo != usuario.codigo;
                });
                if (usuarioExiste) {
                    form.login.$setValidity("usuarioExistente", false);
                } else {
                    form.login.$setValidity("usuarioExistente", true);
                }
            }
        }

        function _vincularAgrupamentos(usuarioCodigo) {
            if (vm.parametros.utilizaCadastroRegional) {
                var agrupamentosId = vm.agrupamento.map(function (item) {
                    return item.codigo;
                });
                SessionStorageService.remover(KeysSessionStorage.usuarioAgrupamentos);
                SessionStorageService.armazenar(KeysSessionStorage.usuarioAgrupamentos, vm.agrupamento);
                RequisicaoGenericaService.salvar(Api.usuario.vincularAgrupamentos + '/' + usuarioCodigo, agrupamentosId);
            }
        }

        function _listarAgrupamentos(usuarioCodigo) {
            if (vm.parametros.utilizaCadastroRegional) {
                RequisicaoGenericaService.listarSemParams(Api.usuario.listarAgrupamentos + '/' + usuarioCodigo + '/Agrupamentos').then(
                    function (success) {
                        vm.agrupamento = success.data;
                    },
                    function (error) {
                        _tratarErro(error);
                    }
                );
            }
        }

        function _tratarErro(error) {
            var mensagemErro = "";
            if (error.data['']) {
                error.data[''].map(function (err) {
                    mensagemErro += err + "<br>";
                });
                MdDialogService.alertPadrao("Atenção", null, mensagemErro);
            }
            else {
                MdDialogService.alertPadrao("Atenção", null, error.data);
            }
            vm.controleForm.emProgresso = false;
        }

        function _usuarioCopy(usuario) {
            var userCopy = angular.copy(usuario);

            if (userCopy.login) {
                userCopy.login = btoa(userCopy.login);
            }

            if (userCopy.senha) {
                userCopy.senha = btoa(userCopy.senha);
            }

            return userCopy;
        }
    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.formularioImpressao')
        .controller('FormularioImpressaoController', FormularioImpressaoController);

    function FormularioImpressaoController(FormularioImpressaoFactory, FormularioImpressaoService, Api, RequisicaoGenericaService, DatatableFactory,
        SessionStorageService, KeysSessionStorage) {
        var vm = this;

        //#region Data              

        init();

        vm.metodos = {
            abrirSelecaoArquivo: _abrirSelecaoArquivo,
            selecionarArquivo: _selecionarArquivo,
            removerArquivoSelecionado: _removerArquivoSelecionado,
            redefinirValorCamposArquivos: _redefinirValorCamposArquivos,
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            definirCamposClonados: definirCamposClonados
        };
        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = Api.formularioImpressao.proximocodigo

            vm.formularioImpressao = FormularioImpressaoFactory.formularioImpressao;
            vm.formulariosImpressao = [];
            vm.tipoDetalheCalculo = SessionStorageService.recuperar(KeysSessionStorage.tipoDetalheCalculo);
            vm.tipoProcesso = SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso);
            vm.parametrosEmpresa = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        }

        function _abrirSelecaoArquivo(idComponente) {
            FormularioImpressaoService.validarParametrosAberturaArquivo(idComponente);
            document.querySelector('#' + idComponente).click();
        }

        function _selecionarArquivo(event, idComponente, campoSelecionado) {
            var arquivo = document.querySelector('#' + idComponente).files[0];
            if (arquivo) {
                FormularioImpressaoService.selecionarArquivo(event, arquivo, function (event) {
                    vm.formularioImpressao[campoSelecionado] = event.target.result;
                    vm.form.$setDirty();
                });
            }
        }

        function _removerArquivoSelecionado(event, idComponente, campoSelecionado) {
            FormularioImpressaoService.validarParametrosExclusaoArquivo(event, idComponente, campoSelecionado);

            angular.element(document.querySelector('#' + idComponente)).val(null);
            vm.formularioImpressao[campoSelecionado] = "";
            vm.form.$setDirty();
        }

        function _redefinirValorCamposArquivos() {
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flFatura')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoAlternativo')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flConsumoAlterado')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoDebitosAnteriores')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoOcorrencia')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoQuitacaoAnual')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabgeral-flExtratoDebitos')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito')).val(null);
            angular.element(document.querySelector('#cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoVariosDebitos')).val(null);
        }

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(Api.formularioImpressao.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(Api.formularioImpressao.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(Api.formularioImpressao.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(Api.formularioImpressao.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            FormularioImpressaoFactory.construirDtOptions('#cadastros-relacionados-formularioimpressao-datatable-formularioimpressao', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function definirCamposClonados() {
            var entidade = angular.copy(vm.controleForm.entidadeClonada);

            RequisicaoGenericaService.listarSemParams(Api.formularioImpressao.proximocodigo).then(function (response) {
                entidade.codigo = response.data;
                entidade.nome = undefined;
                entidade.descricao = undefined;
                vm.formularioImpressao = entidade;
            });
        }
        //#endregion
    }
})();

(function(){
    'use strict';

    angular
        .module('app.cadastros.tiposervico', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.tipoServico;

            $stateProvider
            .state('app.cadastro_tiposervico', {
                url: '/cadastros/tiposervico',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'TipoServicoController as vm',
                        abstract: true
                    },
                    'tiposervico-form@app.cadastro_tiposervico': {
                        templateUrl: rotasHtml.form,
                    },
                    'tiposervico-tabela@app.cadastro_tiposervico': {
                        templateUrl: rotasHtml.tabela
                    }
                }               
            });
        }

}());
(function(){
    'use strict';

    angular
        .module('app.cadastros.tiposervico')
        .factory('TipoServicoFactory', TipoServicoFactory)

    /** @ngInject */
    function TipoServicoFactory(Api, ValidacaoService, DatatableFactory){
        
        
        return {            
            tipoServico: entidade,
            construirDtOptions: _construirDtOptions
        }
        
        function entidade(){
            return {
                descricao: undefined,
                ativo: true,
                exigeFoto: false
            };
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio){
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.tipoServico.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo"                        
                    },
                    {
                        targets: 2,
                        name: "Descricao",
                        data: "descricao"                    
                    },
                    {
                        targets: 3,
                        name: "Ativo",
                        data: "ativo",
                        render: function (data){
                            if(data == true)
                                return "Sim";
                            else if (data == false)
                                return "Não";
                        }
                    },
                    {
                        targets: 4,
                        name: "Exige foto",
                        data: "exigeFoto",
                        render: function (data){
                            if(data == true)
                                return "Sim";
                            else if (data == false)
                                return "Não";
                        }
                    }                    
                ]);
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.pagamentoPix')
        .controller('PagamentoPixController', PagamentoPixController);

    function PagamentoPixController(
        $rootScope,
        $state,
        PagamentoPix,
        PagamentoPixFactory,
        PagamentoPixService,
        Base64Service,
        Api,
        RequisicaoGenericaService,
        SessionStorageService,
        ControleAcessoConfig,
        MdDialogService,
        PgToolbarService,
        DadosCadastradosEmpresa
    ) {
        var vm = this;

        vm.tiposQrCode = [
            {
                codigo: 1,
                descricao: "Estático"
            },
            {
                codigo: 2,
                descricao: "Misto"
            }
        ];

        vm.bancos = [
            {
                codigo: 0,
                descricao: "Nenhum"
            },
            {
                codigo: 1,
                descricao: "Banco do Brasil"
            },
            {
                codigo: 2,
                descricao: "Banco do Brasil - Cobrança"
            },
            {
                codigo: 3,
                descricao: "Inovapay"
            }
        ];

        init();

        vm.metodos = {
            editar: _editar,
            excluir: excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            abrirSelecaoArquivo: _abrirSelecaoArquivo,
            selecionarArquivo: _selecionarArquivo,
            removerArquivoSelecionado: _removerArquivoSelecionado,
            validarCamposPixEstatico: _validarCamposPixEstatico,
            onChangeBanco: onChangeBanco,
            redefinir: redefinir
        }

        function init() {
            vm.exibeMensagem = false;
            vm.pagamentoPix = PagamentoPix;
            vm.diasAdicionaisExpiracaoPixBkp = angular.copy(vm.pagamentoPix.diasAdicionaisExpiracaoPix);

            if (vm.pagamentoPix.tipoConfiguracao != 1 && vm.pagamentoPix.tipoConfiguracao != 2) {
                vm.pagamentoPix = PagamentoPixFactory.pagamentoPix();
            }
            $rootScope.modoImplantacao = SessionStorageService.recuperar(ControleAcessoConfig.key_modo_implantacao);
        }


        if (!$rootScope.modoImplantacao) {
            MdDialogService.alertPadrao("Atenção!", null,
                'Para acessar a rotina de pagamento pix é necessário ativar o modo de implantação.');
            $state.go('app.inicio');
        }

        function excluir(entidade) {
            PgToolbarService.iniciarPreLoaderToolbar(vm.controleForm, vm.controladorPreLoader);

            RequisicaoGenericaService.excluir(Api.pagamentoPix.excluir, entidade.codigo)
                .then(function (success) {
                    vm.pagamentoPix = PagamentoPixFactory.pagamentoPix();
                    MdDialogService.alertPadrao("Cadastro excluído com sucesso.");
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { PgToolbarService.finalizarPreLoaderToolbar(vm.controleForm, vm.controladorPreLoader); });
        }

        function onChangeBanco(codigoBanco) {
            vm.pagamentoPix.diasAdicionaisExpiracaoPix = 0;
            if (codigoBanco == 0) {
                vm.pagamentoPix.chaveAcessoIntegracao = ""
            }
            if (codigoBanco == 1) {
                vm.pagamentoPix.diasAdicionaisExpiracaoPix = vm.diasAdicionaisExpiracaoPixBkp;
                vm.exibeMensagem = false;
            }
        }

        function _editar(entidade) {
            if (entidade.tipoConfiguracao != 1) {
                if (entidade.banco != 0) {
                    var prefixo = "?gw-dev-app-key="
                    var possuiPrefixo = entidade.chaveAcessoIntegracao.startsWith(prefixo);
                    entidade.chaveAcessoIntegracao = prefixo + vm.pagamentoPix.chaveAcessoIntegracao;
                    if (possuiPrefixo) {
                        entidade.chaveAcessoIntegracao = vm.pagamentoPix.chaveAcessoIntegracao.replace(prefixo, "");
                    }
                }

                if (entidade.banco == 2) {
                    var dadosCadastradosEmpresa = {
                        cnpj: DadosCadastradosEmpresa.cnpj,
                        endereco: DadosCadastradosEmpresa.endereco,
                        cidade: DadosCadastradosEmpresa.cidade,
                        uf: DadosCadastradosEmpresa.uf,
                        bairro: DadosCadastradosEmpresa.bairro,
                        cep: DadosCadastradosEmpresa.cep,
                    };

                    var mensagem =
                        "<span style='font-size: 16px;'>É necessário informar todos os dados referentes ao endereço da empresa nos parâmetros, pois estas informações podem ser utilizadas para o cadastro do boleto e geração do QrCode para pagamentos via PIX. <br><br> <b>Deseja realizar o cadastro?</b></span>";

                    var algumaPropriedadeVazia = Object.values(
                        dadosCadastradosEmpresa
                    ).some(function (valor) {
                        return valor == "";
                    });

                    if (algumaPropriedadeVazia) {
                        MdDialogService.confirmPadraoComEvento(
                            "Atenção!",
                            mensagem,
                            function () { },
                            function () {
                                $state.go("app.cadastro_parametros", {
                                    dadosEmpresaFaltando: true,
                                });
                            }
                        );
                    }
                }
            }

            return RequisicaoGenericaService.editar(Api.pagamentoPix.editar, entidade);
        }

        function _construirDtOptions() {
            PagamentoPixFactory.construirDtOptions(
                '#cadastros-relacionados-pagamento-pix-datatable-pagamento-pix',
                _selecionar,
                vm.entidadeDeEnvio
            );
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }



        function _abrirSelecaoArquivo(idComponente) {
            vm.exibeMensagem = true;
            PagamentoPixService.validarParametrosAberturaArquivo(idComponente);
            document.querySelector('#' + idComponente).click();
        }

        function _selecionarArquivo(event, idComponente, campoSelecionado) {
            var arquivo = document.querySelector('#' + idComponente).files[0];

            if (arquivo) {
                PagamentoPixService.selecionarArquivo(event, arquivo, function (event) {
                    vm.pagamentoPix[campoSelecionado] = Base64Service.convertToBase64String(event.target.result);
                    vm.form.$setDirty();
                    vm.exibeMensagem = false;
                });
            }
        }

        function _removerArquivoSelecionado(event, idComponente, campoSelecionado) {

            PagamentoPixService.validarParametrosExclusaoArquivo(event, idComponente, campoSelecionado);

            angular.element(document.querySelector('#' + idComponente)).val(null);
            vm.pagamentoPix[campoSelecionado] = "";
            vm.form.$setDirty();
            if (vm.pagamentoPix.banco != 1) {
                vm.exibeMensagem = true;
            }

        }

        function _validarCamposPixEstatico(pagamentoPix) {
            if (pagamentoPix.tipoConfiguracao == 1) {
                pagamentoPix.enderecoApi = '';
                pagamentoPix.usuarioCertificado = '';
                pagamentoPix.senhaCertificado = '';
                pagamentoPix.banco = 0;
                vm.pagamentoPix.certificado = '';
                pagamentoPix.enderecoApiToken = '';
                pagamentoPix.chaveAcessoIntegracao = '';
                _removerArquivoSelecionado(null, 'cadastros-relacionados-pagamentopix-flcertificado', 'certificado');
            }
        }

        function redefinir(pagamentoPix) {
            if (pagamentoPix.tipoConfiguracao == 1) {
                _removerArquivoSelecionado(null, 'cadastros-relacionados-pagamentopix-flcertificado', 'certificado');
            }
            vm.exibeMensagem = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.impressora', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.impressora;

        $stateProvider
            .state('app.cadastro_relacionados_impressora', {
                url: '/cadastros/relacionados/impressora',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ImpressoraController as vm',
                        abstract: true
                    },
                    'impressora-form@app.cadastro_relacionados_impressora': {
                        templateUrl: rotasHtml.form,
                    },
                    'impressoras-tabela@app.cadastro_relacionados_impressora': {
                        templateUrl: rotasHtml.tabela,
                    }
                },
                resolve: {
                    Retonardicionariosimpressora: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.enum.listardicionariosimpressora);
                    }
                }
            });

    }

})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.impressora')
        .controller('ImpressoraController', ImpressoraController);

    function ImpressoraController(Api, RequisicaoGenericaService, DatatableFactory, ImpressoraFactory,
        ValidacaoService, Retonardicionariosimpressora) {
        var vm = this;

        //#region Data              

        var rotaApi = Api.impressora;

        init();

        vm.metodos = {
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            predefinirCamposParaInsercao: _predefinirCamposParaInsercao,
            alterarConexao: _alterarConexao
        };
        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = rotaApi.proximocodigo;
            vm.regex = /^((zebra)(\s+\w*)*?)$/;
            vm.conexoes = Retonardicionariosimpressora.data[0];
            vm.layoutsFaturaZebra = Retonardicionariosimpressora.data[1];
            vm.metodosImpressao = Retonardicionariosimpressora.data[2];

            vm.impressora = ImpressoraFactory.impressora;
        }

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotaApi.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(rotaApi.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(rotaApi.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(rotaApi.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            ImpressoraFactory.construirDtOptions('#cadastros-relacionados-impressora-datatable-impressoras', _selecionar, vm.entidadeDeEnvio,
                Retonardicionariosimpressora.data);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function _predefinirCamposParaInsercao() {
            vm.impressora = ImpressoraFactory.construirEntidadeParaInsercao();
        }

        function _alterarConexao(conexao) {
            ValidacaoService.validarParametroString(conexao);

            if (conexao == "02") {
                vm.impressora.exibeMensagemPreparaImpressao = "S";
                vm.impressora.layoutFaturaZebra = "01";
                vm.impressora.metodoImpressaoZebra = "01";
            }
        }

        //#endregion
    }
})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.relacionados.especiaDocumento', [])
    .config(Config);

  function Config($stateProvider, RotasHtml, $translatePartialLoaderProvider) {
    var rotasHtml = RotasHtml.especieDocumento;

    $stateProvider
      .state('app.cadastro_relacionados_especie_documento', {
        url: '/cadastros/relacionados/especie-documento',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'EspecieDocumentoController as vm',
            abstract: true
          },
          'especie-documento-form@app.cadastro_relacionados_especie_documento': {
            templateUrl: rotasHtml.form
          },
          'especie-documento-tabela@app.cadastro_relacionados_especie_documento': {
            templateUrl: rotasHtml.tabela
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/cadastros/relacionados/especie-documento');

  }

})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.relacionados.especiaDocumento')
    .controller('EspecieDocumentoController', EspecieDocumentoController);

  function EspecieDocumentoController(EspecieDocumentoService, Regex) {
    var vm = this;

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      construirDtOptions: construirDtOptions,
      inicializarCampos: inicializarCampos
    }

    init();

    function init() {
      vm.rota = EspecieDocumentoService.rota;
      vm.regexBloquearEspaco = Regex.bloquearEspaco;
    }

    //#region metodos

    function pesquisar() {
      return EspecieDocumentoService.pesquisar(vm.entidadeDeEnvio);
    }

    function salvar() {
      return EspecieDocumentoService.criar(vm.especie);
    }

    function editar() {
      return EspecieDocumentoService.atualizar(vm.especie);
    }

    function excluir() {
      return EspecieDocumentoService.remover(vm.especie.codigo);
    }

    function construirDtOptions() {
      return EspecieDocumentoService.construirDatatable(vm.entidadeDeEnvio, _selecionar);
    }

    function _selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    //#endregion

    function inicializarCampos() {
      vm.especie = {
      };
      return;
    }

    //#region  metodos privados
    //#endregion

  }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.equipamento')
        .controller('EquipamentoController', EquipamentoController);

    function EquipamentoController(EquipamentoFactory, EquipamentoService, Api, RequisicaoGenericaService, DatatableFactory,
        SessionStorageService, KeysSessionStorage, RetornarEnumsEquipamento) {
        var vm = this;

        //#region Data              

        init();

        vm.metodos = {
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            predefinirCamposParaInsercao: _predefinirCamposParaInsercao
        };
        
        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = Api.equipamento.proximocodigo;
            vm.equipamentos = [];
            vm.tipoDetalheCalculo = SessionStorageService.recuperar(KeysSessionStorage.tipoDetalheCalculo);
            vm.parametrosEmpresa = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.tiposTeclado = RetornarEnumsEquipamento.data.tiposTeclado;
            vm.sistemasOperacionais = RetornarEnumsEquipamento.data.sistemaOperacional;
            vm.tiposCamera = RetornarEnumsEquipamento.data.tiposCamera;
        }

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(Api.equipamento.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(Api.equipamento.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(Api.equipamento.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(Api.equipamento.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            EquipamentoFactory.construirDtOptions('#cadastros-relacionados-equipamento-datatable-equipamento', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function _predefinirCamposParaInsercao() {
            vm.equipamento = EquipamentoFactory.equipamento();
        }

        //#endregion
    }
})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.relacionados.boletoBancario', [])
    .config(Config);

  function Config($stateProvider, RotasHtml, $translatePartialLoaderProvider) {
    var rotasHtml = RotasHtml.boletoBancario;

    $stateProvider
      .state('app.cadastro_relacionados_boleto_bancario', {
        url: '/cadastros/relacionados/boleto-bancario',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'BoletoBancarioController as vm',
            abstract: true
          },
          'boleto-bancario-form@app.cadastro_relacionados_boleto_bancario': {
            templateUrl: rotasHtml.form
          },
          'boleto-bancario-tabela@app.cadastro_relacionados_boleto_bancario': {
            templateUrl: rotasHtml.tabela
          }
        },
        resolve: {
            ListaEspecies: function (EspecieDocumentoService) {
                    return EspecieDocumentoService.listarTodos();
            }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/cadastros/relacionados/boleto-bancario');

  }

})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.relacionados.boletoBancario')
    .controller('BoletoBancarioController', BoletoBancarioController);

  function BoletoBancarioController(BoletoBancarioService, ListaEspecies) {
    var vm = this;

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      construirDtOptions: construirDtOptions,
      inicializarCampos: inicializarCampos
    }

    init();

    function init() {
      vm.rota = BoletoBancarioService.rota;
      vm.especies = ListaEspecies.data;
    }

    //#region metodos

    function pesquisar() {
      return BoletoBancarioService.pesquisar(vm.entidadeDeEnvio);
    }

    function salvar() {
      return BoletoBancarioService.criar(vm.boleto);
    }

    function editar() {
      return BoletoBancarioService.atualizar(vm.boleto);
    }

    function excluir() {
      return BoletoBancarioService.remover(vm.boleto.codigo);
    }

    function construirDtOptions() {
      return BoletoBancarioService.construirDatatable(vm.entidadeDeEnvio, _selecionar);
    }

    function _selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    //#endregion

    function inicializarCampos() {
      vm.boleto = {
      };
      return;
    }

    //#region  metodos privados
    //#endregion

  }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados.formularioImpressao')
        .controller('CadastroArquivoController', CadastroArquivoController);

    function CadastroArquivoController(Api, RequisicaoGenericaService, DatatableFactory, CadastroArquivoFactory) {
        var vm = this;

        //#region Data              

        var rotaApi = Api.arquivo;

        init();

        vm.metodos = {            
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar
        };
        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = Api.arquivo.proximocodigo;

            vm.arquivo = CadastroArquivoFactory.arquivo;
            vm.arquivos = [];
        }      

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotaApi.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(rotaApi.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(rotaApi.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(rotaApi.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            CadastroArquivoFactory.construirDtOptions('#cadastros-relacionados-arquivo-datatable-arquivos', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.ocorrencia', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.ocorrencia;

        $stateProvider
            .state('app.cadastro_ocorrencia', {
                url: '/cadastros/ocorrencia',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'OcorrenciaController as vm',
                        abstract: true
                    },
                    'ocorrencia-form@app.cadastro_ocorrencia': {
                        templateUrl: rotasHtml.form
                    },
                    'ocorrencias-tabela@app.cadastro_ocorrencia': {
                        templateUrl: rotasHtml.tabela
                    },
                    'tab-ocorrencia@app.cadastro_ocorrencia': {
                        templateUrl: rotasHtml.tabs.ocorrencia
                    },
                    'tab-comunicado@app.cadastro_ocorrencia': {
                        templateUrl: rotasHtml.tabs.comunicado
                    },
                    'tab-configuracoes-adicionais@app.cadastro_ocorrencia': {
                        templateUrl: rotasHtml.tabs.configuracoesAdicionais
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.ocorrencia')
        .service('OcorrenciaService', OcorrenciaService);

    /** @ngInject */
    function OcorrenciaService(OcorrenciaFactory, ValidacaoService) {

        //#region Data 

        var ocorrencia = OcorrenciaFactory.ocorrencia;
        var controladorTelaOcorrencia = OcorrenciaFactory.controladorTelaOcorrencia


        //#region Definição dos métodos        
        this.tabSelecionada = _tabSelecionada;
        //#endregion

        //#endregionregion 

        //#region Implementação dos Métodos        
        function _tabSelecionada(tab) {
            ValidacaoService.validarParametroString(tab);

            controladorTelaOcorrencia.tabSelecionada = tab;
        }
        //#endregion        
    }
})();

(function () {
    'use strict',

        angular
            .module('app.cadastros.ocorrencia')
            .factory('OcorrenciaFactory', OcorrenciaFactory);

    function OcorrenciaFactory(DatatableFactory, Api, ValidacaoService, $filter) {

        //#region Data

        var _controladorTelaOcorrencia = {
            tabSelecionada: "ocorrencia"
        };

        //#endregion

        //#region Definição dos Métodos
        return {
            ocorrencia: _entidade,
            controladorTelaOcorrencia: _controladorTelaOcorrencia,
            predefinirCamposInsercao: _predefinirCamposInsercao,
            construirDtOptions: _construirDtOptions
        }
        //#endregion

        // #region Implementação dos métodos 

        function _predefinirCamposInsercao() {
            return {
                permiteImpressaoConta: "S",
                imprimeDescricaoConta: "S",
                permiteCreditoConsumo: "S",
                desconsideraLeitura: "N",
                permiteDescontoConsumo: "S",
                geraLeituraCalculada: "N",
                consideraOcorrenciaSomenteCalculoImpressaoConta: "N",
                volumeFixoDeterminado: 0,
                codigoValorFixoDeterminado: 0,
                acaoSemLeitura: 1,
                descricao: "",
                valor: 0,
                acaoOcorrenciaAnterior: 1,
                permiteDigitarLeitura: "S",
                exigeCapturarFoto: "N",
                geraRepasse: "N",
                imprimeComunicadoSeparado: "N",
                codigoObservacaoLeitura: "",
                acaoCalculo: "",
                mensagemEspecificaOcorrenciaComunicado: "",
                utilizaDescricaoOcorrenciaTituloComunicado: "S",
                geraLeituraCalculadaConsumoMinimoQuandoConsumoMenorMinimo: "N",
                mensagemEspecificaColetorQuandoFaturaNaoImpressaPelaOcorrencia: "",
                exibeNaRotinaImpressaoFaturasNaoImpressasPorOcorrencia: "S",
                codigoServico: 0,
                descricaoServico: "",
                valorServico: 0,
                tipoServico: 1,
                quantidadeMinimaFotos: 1,
                quantidadeMaximaFotos: 48,
                situacaoLigacao: 0
            };
        }

        function _entidade() {
            return {
                codigo: undefined,
                descricao: undefined,
                valor: undefined,
                permiteImpressaoConta: undefined,
                imprimeDescricaoConta: undefined,
                permiteCreditoConsumo: undefined,
                volumeFixoDeterminado: undefined,
                desconsideraLeitura: undefined,
                codigoValorFixoDeterminado: undefined,
                permiteDescontoConsumo: undefined,
                acaoOcorrenciaAnterior: undefined,
                consideraOcorrenciaSomenteCalculoImpressaoConta: undefined,
                permiteDigitarLeitura: undefined,
                exigeCapturarFoto: undefined,
                acaoSemLeitura: undefined,
                geraLeituraCalculada: undefined,
                geraRepasse: undefined,
                imprimeComunicadoSeparado: undefined,
                codigoObservacaoLeitura: undefined,
                acaoCalculo: undefined,
                mensagemEspecificaOcorrenciaComunicado: undefined,
                utilizaDescricaoOcorrenciaTituloComunicado: undefined,
                geraLeituraCalculadaConsumoMinimoQuandoConsumoMenorMinimo: undefined,
                mensagemEspecificaColetorQuandoFaturaNaoImpressaPelaOcorrencia: undefined,
                exibeNaRotinaImpressaoFaturasNaoImpressasPorOcorrencia: undefined
            };
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.ocorrencia.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Descrição",
                            data: "descricao",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Valor",
                            data: function (a, b) {
                                return $filter("currency")(a.valor, "R$ ", 4);
                            },
                            defaultContent: ""
                        }
                    ]);
        }

        //#endregion

    } // FIM FACTORY

})();


(function () {
  'use strict';

  angular
    .module('app.cadastros.localizacao.regional', [])
    .config(Config);

  function Config($stateProvider, RotasHtml, $translatePartialLoaderProvider) {
    var rotasHtml = RotasHtml.regional;

    $stateProvider
      .state('app.cadastro_localizacao_regional', {
        url: '/cadastros/regional',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'RegionalController as vm',
            abstract: true
          },
          'regional-form@app.cadastro_localizacao_regional': {
            templateUrl: rotasHtml.form
          },
          'regional-tabela@app.cadastro_localizacao_regional': {
            templateUrl: rotasHtml.tabela
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/cadastros/localizacao/regionais');

  }

})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.localizacao.regional')
    .controller('RegionalController', RegionalController);

  function RegionalController(RegionalService, SessionStorageService,KeysSessionStorage) {
    var vm = this;

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      construirDtOptions: construirDtOptions,
      inicializarCampos: inicializarCampos
    }

    init();

    function init() {

      vm.rota = RegionalService.rota;
      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
    }

    //#region metodos

    function pesquisar() {
      return RegionalService.pesquisar(vm.entidadeDeEnvio);
    }

    function salvar() {
      return RegionalService.criar(vm.regional);
    }

    function editar() {
      return RegionalService.atualizar(vm.regional);
    }

    function excluir() {
      return RegionalService.remover(vm.regional.codigo);
    }

    function construirDtOptions() {
      return RegionalService.construirDatatable(vm.entidadeDeEnvio, _selecionar);
    }

    function _selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    //#endregion

    function inicializarCampos() {
      vm.regional = {
        ftpModoAtivo:true,
        ftpPorta:undefined,
        ativo : true
      };
      return;
    }

    //#region  metodos privados
    //#endregion

  }
})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.localizacao.municipio', [])
    .config(Config);

  function Config($stateProvider, RotasHtml, $translatePartialLoaderProvider) {
    var rotasHtml = RotasHtml.municipio;

    $stateProvider
      .state('app.cadastro_localizacao_municipio', {
        url: '/cadastros/municipio',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'MunicipioController as vm',
            abstract: true
          },
          'municipio-form@app.cadastro_localizacao_municipio': {
            templateUrl: rotasHtml.form
          },
          'municipio-tabela@app.cadastro_localizacao_municipio': {
            templateUrl: rotasHtml.tabela
          }
        },
        resolve:{
          Regional: function (RegionalService){
            return RegionalService.listarTodos();
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/cadastros/localizacao/municipios');

  }

})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.localizacao.municipio')
    .controller('MunicipioController', MunicipioController);

  function MunicipioController(MunicipioService, Regional, SessionStorageService, KeysSessionStorage) {
    var vm = this;

    vm.metodos = {
      pesquisar: pesquisar,
      salvar: salvar,
      editar: editar,
      excluir: excluir,
      construirDtOptions: construirDtOptions,
      inicializarCampos: inicializarCampos
    }

    init();

    function init() {
      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

      vm.rota = MunicipioService.rota;
      vm.regioes = Regional.data;
    }

    //#region metodos

    function pesquisar() {
      return MunicipioService.pesquisar(vm.entidadeDeEnvio);
    }

    function salvar() {
      return MunicipioService.criar(vm.municipio);
    }

    function editar() {
      return MunicipioService.atualizar(vm.municipio);
    }

    function excluir() {
      return MunicipioService.remover(vm.municipio.codigo);
    }

    function construirDtOptions() {
      return MunicipioService.construirDatatable(vm.entidadeDeEnvio, _selecionar, vm.regioes);
    }

    function _selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    function inicializarCampos() {
      vm.municipio = {
        ativo : true
      };
      return;
    }

    //#endregion

    //#region  metodos privados
    //#endregion

  }
})();


(function(){
    'use strict';

    angular
        .module('app.cadastros.localizacao.agrupamento', [])
        .config(Config);

        function Config($stateProvider, RotasHtml, $translatePartialLoaderProvider){
            var rotasAgrupamento = RotasHtml.agrupamento;
            $stateProvider
            .state('app.cadastro_localizacao_agrupamento', {
                url: '/cadastros/agrupamentos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasAgrupamento.templateUrl,
                        controller: 'AgrupamentoController as vm',
                        abstract: true
                    },
                    'agrupamento-form@app.cadastro_localizacao_agrupamento': {
                        templateUrl: rotasAgrupamento.form                        
                    },
                    'agrupamento-table@app.cadastro_localizacao_agrupamento':{
                        templateUrl: rotasAgrupamento.tabela
                    }
                },
                resolve: {
                    RetornarEnumsProtocolo: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.enum.listarEnumsProtocolo);
                    }
                }
            });
            $translatePartialLoaderProvider.addPart('app/main/cadastros/localizacao/agrupamentos');

        }

}());
(function(){
    'use strict';

    angular
        .module('app.cadastros.localizacao.agrupamento')
        .controller('AgrupamentoController', AgrupamentoController)

    /** @ngInject */
    function AgrupamentoController(SessionStorageService, KeysSessionStorage, AgrupamentoService, RetornarEnumsProtocolo){
        var vm = this;
        
        init();

        vm.metodos = {
            salvar: salvar,
            editar: editar,
            pesquisar: pesquisar,
            construirDtOptions: construirDtOptions,
            inicializarCampos: inicializarCampos
        }


        function init(){
            _buscarParametros();
            vm.protocolos = RetornarEnumsProtocolo.data;   
            vm.rotaProximoCodigo = AgrupamentoService.rota.proximoCodigo;         
        }

        function salvar(agrupamento){
            return AgrupamentoService.criar(agrupamento);
        }
        function editar(agrupamento){
            return AgrupamentoService.atualizar(agrupamento);
        }

        function pesquisar(){
            return AgrupamentoService.pesquisar(vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions(){
            return AgrupamentoService.construirDatatable(vm.entidadeDeEnvio, _selecionar);
        }

        function inicializarCampos() {
            vm.agrupamento = {
              ftpModoAtivo:true,
              ftpPorta: undefined,
              ativo : true,
              protocolo: undefined,
              ftpServidorWindows: true,
            };
          }

        function _buscarParametros(){
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);            
        }
    }

}());
(function(){
    'use strict';

    angular
        .module('app.cadastros.cronogramagrupo', [])
        .config(Config);

        function Config($stateProvider, RotasHtml){
            var rotasHtml = RotasHtml.cronogramaGrupos;

            $stateProvider
            .state('app.cadastros_cronogramagrupo', {
                url: '/cadastros/cronogramagrupos',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'CronogramaGruposController as vm',
                        abstract: true
                    },
                    'cronogramagrupos-form@app.cadastros_cronogramagrupo': {
                        templateUrl: rotasHtml.form,
                    },
                    'cronogramagrupos-form-caema@app.cadastros_cronogramagrupo': {
                        templateUrl: rotasHtml.caema.form,
                    },
                    'cronogramagrupos-tabela@app.cadastros_cronogramagrupo': {
                        templateUrl: rotasHtml.tabela
                    }
                },
                resolve: {
                    listarAgrupamentos: function(Api, RequisicaoGenericaService){
                        return RequisicaoGenericaService.listarSemParams(Api.agrupamento.listar);
                    }
                }               
            });

        }

}());
(function(){
    'use strict';

    angular
        .module('app.cadastros.cronogramagrupo')
        .factory('CronogramaGrupoFactory', CronogramaGrupoFactory)

    /** @ngInject */
    function CronogramaGrupoFactory(ValidacaoService, DatatableFactory, Api){

        var _agrupamentos = [];

        return {
            fn: fn,
            construirEntidade: construirEntidade,
            construirDtOptions: _construirDtOptions,
            setAgrupamentos: setAgrupamentos
        }
        
        function setAgrupamentos(agrupamentos){
            _agrupamentos = agrupamentos;
        }

        function construirEntidade(){
            var entidade =  {
                mes: '',
                ano: '',
                dataCadastro:'',
                descricao: '',
                dataInicio: '',
                dataFim: ''
            }
            return entidade;
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio){
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.cronogramaGrupos.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                [

                    DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                    {
                        targets: 1,
                        name: "Codigo",
                        data: "codigo"                        
                    },
                    {
                        targets: 2,
                        name: "Mes",
                        data: "mes"                    
                    },
                    {
                        targets: 3,
                        name: "Ano",
                        data: "ano"                    
                    },
                    {
                        targets: 4,
                        name: "Grupo",
                        data: "grupo"                    
                    },
                    {
                        targets: 5,
                        name: "Agrupamento",
                        data: "regional",
                        render: function(data){
                            if(data){
                                var item = _agrupamentos.filter(function(agrupamento){
                                    return agrupamento.codigo == data
                                })[0]

                                data = item.codigo.toString().padStart(3,'0') + ' - ' + item.descricao;
                                return data;
                            }
                        }
                    },
                    {
                        targets: 6,
                        name: "DataInicio",
                        data: "dataInicio",
                        render: function(data){
                            if(data){
                                data = new Date(data).toLocaleDateString();
                                return data;
                            }
                        }                    
                    },
                    {
                        targets: 7,
                        name: "DataFinal",
                        data: "dataFim", 
                        render: function(data){
                            if(data){
                                data = new Date(data).toLocaleDateString();
                                return data;
                            }
                        }                         
                    }   
                ]);
        }


        function fn(){
            
        }
    }

}());
/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.tipoEntrega')
        .controller('TipoEntregaController', TipoEntregaController);

    function TipoEntregaController(TipoEntregaFactory, Api, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;

        //#region Data              

        init();

        vm.metodos = {
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar
        };

        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = Api.tipoEntrega;

            vm.tipoEntrega = {};
        }

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(vm.rota.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(vm.rota.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(vm.rota.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(vm.rota.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            TipoEntregaFactory.construirDtOptions('#cadastros-entrega-tipo-entrega-datatable-tipo-entrega',
                _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        //#endregion
    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega.tipoEntrega')
        .controller('MotivoNaoEntregaController', MotivoNaoEntregaController);

    function MotivoNaoEntregaController(MotivoNaoEntregaFactory, Api, RequisicaoGenericaService, DatatableFactory) {
        var vm = this;

        //#region Data              

        init();

        vm.metodos = {
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar
        };

        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.rota = Api.motivoNaoEntrega;

            vm.motivoNaoEntrega = {};
        }

        function _pesquisar() {
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(vm.rota.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _salvar(entidade) {
            return RequisicaoGenericaService.salvar(vm.rota.criar, entidade);
        }

        function _editar(entidade) {
            return RequisicaoGenericaService.editar(vm.rota.editar, entidade);
        }

        function _excluir(entidade) {
            return RequisicaoGenericaService.excluir(vm.rota.excluir, entidade.codigo)
        }

        function _construirDtOptions() {
            MotivoNaoEntregaFactory.construirDtOptions('#cadastros-entrega-motivo-nao-entrega-datatable-motivo-nao-entrega',
                _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.leiturista', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.leiturista;

        $stateProvider
            .state('app.cadastro_leiturista', {
                url: '/cadastros/leiturista',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'LeituristaController as vm',
                        abstract: true
                    },
                    'leiturista-form@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.form,
                    },
                    'leituristas-tabela@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabela
                    },
                    'leiturista-tabela@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabela,
                    },
                    'tab-pessoal@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabs.pessoal,
                    },
                    'tab-configuracoes@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabs.configuracoes
                    },
                    'tab-impressao@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabs.impressao
                    },
                    'tab-telemetria@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabs.telemetria
                    },
                    'tab-recadastramento@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabs.recadastramento
                    },                    
                    'tab-recadastramento.tabela-informacoes@app.cadastro_leiturista': {
                        templateUrl: rotasHtml.tabelaInformacoes
                    },
                },
                resolve: {
                    ListarTodosArquivos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.arquivo.listartodos);
                    },
                    Listardicionariosleiturista: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.enum.listardicionariosleiturista);
                    },
                    ListarTodosEquipamentos: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.equipamento.listartodos);
                    },
                    ListarTodasImpressoras: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.impressora.listartodos);
                    },
                    ListarTodosFormulariosImpressao: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.formularioImpressao.listartodos);
                    },
                    Regional: function (RegionalService) {
                        return RegionalService.listarTodos();
                    },
                    ListarCamposRecadastramento: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarCamposRecadastramento);
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.leiturista')
        .service('LeituristaService', LeituristaService);

    /** @ngInject */
    function LeituristaService(LeituristaFactory, ValidacaoService) {

        //#region Data 

        var leiturista = LeituristaFactory.leiturista;
        var controladorTelaLeiturista = LeituristaFactory.controladorTelaLeiturista


        //#region Definição dos métodos        
        this.tabSelecionada = _tabSelecionada;
        //#endregion

        //#endregionregion 

        //#region Implementação dos Métodos        
        function _tabSelecionada(tab) {
            ValidacaoService.validarParametroString(tab);

            controladorTelaLeiturista.tabSelecionada = tab;
        }
        //#endregion        
    }
})();

(function () {
    'use strict',

        angular
            .module('app.cadastros.leiturista')
            .factory('LeituristaFactory', LeituristaFactory);

    function LeituristaFactory(DatatableFactory, Api, ValidacaoService) {

        //#region Data

        var _controladorTelaLeiturista = {
            tabSelecionada: "pessoal"
        };

        //#endregion

        //#region Definição dos Métodos
        return {
            leiturista: _entidade,
            controladorTelaLeiturista: _controladorTelaLeiturista,
            predefinirCamposInsercao: _predefinirCamposInsercao,
            construirDtOptions: _construirDtOptions
        }
        //#endregion

        // #region Implementação dos métodos 

        function _predefinirCamposInsercao() {
            return {
                // DELPHI
                utilizaAtualizacaoOnline: "N",
                // Definições Atuais
                nome: "",
                apelido: "",
                endereco: "",
                cidade: "",
                bairro: "",
                arqCodigo: 0,
                eqpCodigo: 0,
                impCodigo: 0,
                cep: "",
                telefoneCelular: "",
                telefoneResidencial: "",
                inativo: "N",
                modeloImpressao: 0,
                detalheModeloImpressao: 0,
                utilizaGPS: "N",
                utilizaCartaoBackup: "N",
                utilizaCapturaFotos: "N",
                utilizaImpressaoFoto: "01",
                utilizaRecadastramento: "N",
                exibeObservacaoCliente: "N",
                alteraDataLeitura: "N",
                destacaMensagemAlerta: "N",
                mostraDadosLeitura: "N",
                layoutArquivo: "01",
                avisaOcorrenciaAnterior: "N",
                tipoRotina: "01",
                portaBluetoothSaida: "",
                senha: "",
                utilizaExportacaoOnline: "N",
                localidade: "",
                avisaContaRetidaMesmoEndereco: "N",
                imprimeContaRetidaMesmoEndereco: "N",
                coordenadaXCodigoBarras: 0,
                utilizaTelemetriaLeitura: "N",
                utilizaConfirmacaoLeituraForaFaixaSemVisualizacaoLeitura: "N",
                portaBluetoothTelemetria: 0,
                senhaTelemetria: "",
                numeroSerieBluetoothReceiverTelemetria: "",
                permiteRecadastrarRuaBairroNovo: "S",
                codigoFabricanteEquipamentosTelemetria: 2,
                utilizaPermissaoAlterarCampoRecadastramento: "N",
                ocultaOutrosDadosClienteTelaLeitura: "N",
                segmento: "01",
                foto: {
                    nome: "",
                    extensao: "",
                    conteudo: "",
                }
            };
        }

        function _entidade() {
            return {
                // DELPHI
                utilizaAtualizacaoOnline: undefined,
                // Definições Atuais
                nome: undefined,
                apelido: undefined,
                endereco: undefined,
                cidade: undefined,
                bairro: undefined,
                arqCodigo: undefined,
                eqpCodigo: undefined,
                impCodigo: undefined,
                cep: undefined,
                telefoneCelular: undefined,
                telefoneResidencial: undefined,
                inativo: undefined,
                modeloImpressao: undefined,
                detalheModeloImpressao: undefined,
                utilizaGPS: undefined,
                utilizaCartaoBackup: undefined,
                utilizaCapturaFotos: undefined,
                utilizaImpressaoFoto: undefined,
                utilizaRecadastramento: undefined,
                exibeObservacaoCliente: undefined,
                alteraDataLeitura: undefined,
                destacaMensagemAlerta: undefined,
                mostraDadosLeitura: undefined,
                layoutArquivo: undefined,
                avisaOcorrenciaAnterior: undefined,
                tipoRotina: undefined,
                portaBluetoothSaida: undefined,
                senha: undefined,
                utilizaExportacaoOnline: undefined,
                localidade: undefined,
                avisaContaRetidaMesmoEndereco: undefined,
                imprimeContaRetidaMesmoEndereco: undefined,
                coordenadaXCodigoBarras: undefined,
                utilizaTelemetriaLeitura: undefined,
                utilizaConfirmacaoLeituraForaFaixaSemVisualizacaoLeitura: undefined,
                portaBluetoothTelemetria: undefined,
                senhaTelemetria: undefined,
                numeroSerieBluetoothReceiverTelemetria: undefined,
                permiteRecadastrarRuaBairroNovo: undefined,
                codigoFabricanteEquipamentosTelemetria: undefined,
                utilizaPermissaoAlterarCampoRecadastramento: undefined,
                ocultaOutrosDadosClienteTelaLeitura: undefined,
                tipoConfirmacaoLeitura: undefined,
                segmento: undefined,
                configuracao: {
                    codigoFabricanteEquipamentoTelemetriaAPI: undefined,
                    enderecoRotaTelemetriaAPI: undefined,
                    rotaTokenTelemetriaAPI: undefined,
                    usernameTelemetriaAPI: undefined,
                    passwordTelemetriaAPI: undefined,
                    clientIdTelemetriaAPI: undefined,
                    clientSecretTelemetriaAPI: undefined,
                },
                foto: {
                    nome: undefined,
                    extensao: undefined,
                    conteudo: undefined,
                }
            };
        }

        function _construirDtOptions(id, funcaoSelecionar, entidadeDeEnvio) {
            ValidacaoService.validarParametroString(id);
            ValidacaoService.validarParametroFuncao(funcaoSelecionar);
            ValidacaoService.validarParametroObjeto(entidadeDeEnvio);

            DatatableFactory.construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar
                (Api.leiturista.listarPorPaginacaoDatatable, entidadeDeEnvio.clsEntidade, id,
                    [

                        DatatableFactory.construirColunaDeSelecionarPadrao(function (indexLinha) { funcaoSelecionar(indexLinha) }),
                        {
                            targets: 1,
                            name: "Codigo",
                            data: "codigo",
                            defaultContent: ""
                        },
                        {
                            targets: 2,
                            name: "Nome",
                            data: "nome",
                            defaultContent: ""
                        },
                        {
                            targets: 3,
                            name: "Apelido",
                            data: "apelido",
                            defaultContent: ""
                        },
                        {
                            targets: 4,
                            name: "Inativo",
                            data: "inativo",
                            defaultContent: "",
                            render: function (data) {
                                if (data == "N")
                                    return "Não";
                                else
                                    return "Sim";
                            }
                        },
                    ]);
        }

        //#endregion

    } // FIM FACTORY

})();


(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller("DialogDetalhamentoLicencasController", DialogDetalhamentoLicencasController);

    function DialogDetalhamentoLicencasController(
        $mdDialog,
        ImanagerRequisicaoGenericaService,
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService,
        DatatableFactory,
        RotasHtml) {
        var vm = this;

        init();

        vm.metodos = {
            fecharDialog: fecharDialog,
            abrirDialogLicencasTemporarias: abrirDialogLicencasTemporarias,
            abrirDialogVisualizarLicencasTemporariasCadastradas: abrirDialogVisualizarLicencasTemporariasCadastradas,
            _pesquisarLicencas: _pesquisarLicencas
        };

        function init() {
            vm.emProgresso = true;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.codigoHdn = parseInt(vm.parametros.empresa.codigoImanager);
            vm.dtInstance = {};
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([]);
            vm.dtOptions.order = [3, 'desc'];
            vm.dtOptions.scrollY = '45vh';
            vm.dtOptions.scrollCollapse = true;
            vm.pesquisar = '';
            _pesquisarLicencas();
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function abrirDialogLicencasTemporarias() {
            var rota = RotasHtml.toolbar.dialogLicencasTemporarias;
            $mdDialog.show({
                controller: 'DialogLicencasTemporariasController',
                controllerAs: 'vm',
                templateUrl: rota,
                transclude: true,
                multiple: true,
                locals: {
                    Dados: vm.dados,
                    CodigoHdn: vm.codigoHdn
                }
            }).then(function (houveAlteracoes) {
                if (houveAlteracoes) {
                    _pesquisarLicencas();
                    vm.emProgresso = false;
                }
            });
        }

        function abrirDialogVisualizarLicencasTemporariasCadastradas() {
            var rota = RotasHtml.toolbar.dialogVisualizarLicencasTemporariasCadastradas;
            $mdDialog.show({
                controller: 'DialogLicencasTemporariasCadastradasController',
                controllerAs: 'vm',
                templateUrl: rota,
                transclude: true,
                multiple: true,
                locals: {
                    LicencasTemporarias: vm.dados.licencaTemporaria,
                }
            })
        }

        function _pesquisarLicencas() {
            vm.dados = undefined;
            ImanagerRequisicaoGenericaService.getComParametros('api/protecao/gerenciamento',
                { codigoCliente: vm.codigoHdn, codigoproduto: 2 })
                .then(function (success) {
                    vm.dados = success.data;
                    vm.dadosTotaisLicencas = vm.dados.quantitativoLicencas.find(function (licenca) {
                        return licenca.tipoLicenca.codigo == 5;
                    });
                    var resultadoFuncao = _verificaLicencaTemporaria(vm.dados);
                    vm.dados.licencaTemporaria = resultadoFuncao.licencasTemporarias;
                    vm.dados.licencasPermanentes = resultadoFuncao.licencasPermanentes;
                    setTimeout(function () { vm.habilitaBotao = true; }, 300)
                }, function (error) {
                    MdDialogService.alertPadraoComEvento(error.data, fecharDialog);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function _verificaLicencaTemporaria() {
            var licencasTemporarias = vm.dados.licencas.filter(function (item) {
                return item.licencaTemporaria;
            });
            var licencasPermanentes = vm.dados.licencas.filter(function (item) {
                return !item.licencaTemporaria;
            });
            return {
                licencasTemporarias: licencasTemporarias,
                licencasPermanentes: licencasPermanentes
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller("DialogConfiguracaoSmartphone", DialogConfiguracaoSmartphone);

    function DialogConfiguracaoSmartphone(
        $mdDialog,
        ControleAcessoConfig,
        SessionStorageService,
        KeysSessionStorage,
        urlApi,
        Leituristas
    ) {

        var vm = this;

        init();

        vm.metodos = {
            _criarObjetoQrCode: _criarObjetoQrCode,
            fecharDialog: fecharDialog
        };

        function init() {
            vm.emProgresso = true;
            vm.leituristas = Leituristas[0];
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.codigoHdn = vm.parametros.empresa.codigoImanager;

            vm.string = _criarObjetoQrCode();
            vm.stringDownload = _criarObjetoQrCodeDownload();
        }

        function _criarObjetoQrCode() {
            var dadosQrCode = {
                ChaveLeiturista: vm.parametros.coletor.chaveLeiturista,
                CodigoHDN: vm.codigoHdn,
                EnderecoAPI: urlApi.url_base_api,
                EnderecoConcentrador: vm.parametros.coletor.macConcentrador,
                LeituristaPadrao: vm.leituristas.codigo,
                MatriculaLeiturista: vm.parametros.coletor.matriculaLeiturista,
                ModoSuporte: vm.parametros.coletor.modoSuporte ? "S" : "N",
                RotinaChat: vm.parametros.coletor.rotinaChat ? "S" : "N",
                TipoImportacao: vm.parametros.coletor.tipoImportacao,
                UtilizarMarcaEspecial: vm.parametros.utilizarMarcaEspecial ? "S" : "N",
                WEB: "S",
                GerarLogFluxoRotinas: vm.parametros.coletor.gerarLogFluxoRotinas ? "S" : "N",
            };

            return JSON.stringify(dadosQrCode);
        }

        function _criarObjetoQrCodeDownload() {
            vm.versao = ControleAcessoConfig.configuracao.versao.replace('.', '');
            vm.release = ControleAcessoConfig.configuracao.release.replace(/(\d+)\/(\w)/, '$1$2');
            if (vm.parametros.coletor.releaseMinimaMobile) {
                var releaseMinimaMobileFormatada = vm.parametros.coletor.releaseMinimaMobile.replace(/(\d+)\/(\w)/, '$1$2');
                var releaseMinimaMobile = releaseMinimaMobileFormatada;
            } else {
                releaseMinimaMobile = vm.release;
            }

            var qrCode = "Download Reader: " + "http://ws.inovamobil.com.br/downloads/Reader/" + vm.versao + releaseMinimaMobile + "/Reader.apk";
            return qrCode;

        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller("DialogAlteracaoSenhaToolbarController", DialogAlteracaoSenhaToolbarController);

    function DialogAlteracaoSenhaToolbarController($mdDialog, Api, RequisicaoGenericaService, MdToastService, Usuario) {
        var vm = this;

        vm.emProgresso = false;
        vm.metodosDialog = {
            fecharDialog: metodoDialogFecharDialog,
            confirmar: confirmar
        };

        function confirmar() {
            if (vm.senhaNova && vm.confirmacaoSenhaNova) {
                if (vm.senhaNova == vm.confirmacaoSenhaNova) {
                    vm.emProgresso = true;

                    var lstrLogin = btoa(Usuario.login);
                    var lstrSenhaAtual = btoa(vm.senhaAtual);

                    var promessa = RequisicaoGenericaService
                        .listarSemParams(Api.usuario.confirmarSenha + lstrLogin + "/" + lstrSenhaAtual);

                    promessa.then(
                        function (success) {
                            vm.emProgresso = false;
                            if (success.data) {
                                var modelo = {
                                    login: lstrLogin,
                                    senhaAtual: lstrSenhaAtual,
                                    senhaNova: btoa(vm.senhaNova)
                                }

                                var promessaAlteracao = RequisicaoGenericaService
                                    .editar(Api.usuario.alterarsenha, modelo);

                                promessaAlteracao.then(
                                    function (success) {
                                        vm.emProgresso = false;
                                        if (success.data) {
                                            Usuario.senha = vm.senhaNova;
                                            MdToastService.toastPadrao("Senha editada com sucesso!");
                                            $mdDialog.hide();
                                            return;
                                        }
                                        else {
                                            MdToastService.toastErro("Senha atual inválida.");
                                        }
                                    }, function (error) {
                                        vm.emProgresso = false;
                                        MdToastService.toastErro(error.data);
                                    }
                                );
                                return;
                            }
                            else {
                                MdToastService.toastErro("Senha atual inválida.");
                            }
                        }, function (error) {
                            vm.emProgresso = false;
                            MdToastService.toastErro(error.data);
                        }
                    );
                }
                else {
                    MdToastService.toastErro("As senhas digitadas não conferem.");
                }
            }
        }

        function metodoDialogFecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.processamento.importacao")
    .controller(
      "ImportacaoGrupoLeituraController",
      ImportacaoGrupoLeituraController
    );

  /** @ngInject */
  function ImportacaoGrupoLeituraController(
    SessionStorageService,
    KeysSessionStorage,
    Api,
    RequisicaoGenericaService,
    MdDialogService,
    ValidacaoService,
    $scope,
    $q,
    ExportacaoMobileService,
    ServicosGenericoService,
    $mdDialog,
    retornarArquivoPadrao,
    $timeout,
    urlApi,
    MunicipioService,
    ImportacaoGrupoLeituraCaemaService
  ) {
    var vm = this;

    //#region Data
    var parametro = SessionStorageService.recuperar(
      KeysSessionStorage.parametrosEmpresa
    );

    var funcaoTimer = undefined;

    vm.tituloSplash = "Importando grupo de leituras...";

    init();
    //#endregion

    //#region Métodos

    /// Método inicializador
    function init() {
      vm.arquivoCodigo = retornarArquivoPadrao.data;
      vm.status = [
        { valor: "Todos" },
        { valor: "Importados" },
        { valor: "Não importados" },
      ];

      vm.preLoader = false;
      vm.existeClienteSelecionado = false;
      vm.parametros = SessionStorageService.recuperar(
        KeysSessionStorage.parametrosEmpresa
      );
      vm.sistemaGestorEhFiorilli = vm.parametros.coletor.sistemaGestor == 2;
      vm.ehBauru = vm.parametros.empresa.codigoImanager == "0070";

      if (
        vm.parametros.calculo.tipoDetalheCalculo == 89 ||
        vm.parametros.calculo.tipoDetalheCalculo == 88 ||
        vm.ehBauru
      ) {
        vm.base64Arquivo = "";
        vm.reader = new FileReader();

        vm.reader.addEventListener(
          "load",
          function () {
            vm.base64Arquivo = vm.reader.result;
          },
          false
        );
      }

      vm.regionais = SessionStorageService.recuperar(
        KeysSessionStorage.usuarioAgrupamentos
      );
      vm.desabilitarCampos = false;
      vm.form = {};

      vm.filtro = {};

      vm.arquivos = [];
      vm.lfApi = {};
      vm.emProgresso = false;

      vm.arquivoSelecionado = false;

      vm.arquivosFTPBkp = [];

      vm.arquivosFTP = {
        titulo: "Arquivos",
        arquivos: [],
      };

      $scope.$watch("vm.arquivos[0]", function (newValue, oldValue) {
        if (newValue) {
          if (
            vm.parametros.calculo.tipoDetalheCalculo == 89 &&
            newValue.lfFile
          ) {
            vm.reader.readAsDataURL(newValue.lfFile);
          }

          if (vm.ehBauru && newValue.lfFile) {
            if (!newValue.lfFile.name.endsWith(".zip")) {
              MdDialogService.alertPadrao("O tipo do arquivo deve ser zip.");
              vm.lfApi.removeAll();
            } else {
              vm.reader.readAsDataURL(newValue.lfFile);

              var reader = new FileReader();
              reader.onload = function (e) {
                JSZip.loadAsync(e.target.result).then(function (zip) {
                  var arquivos = Object.keys(zip.files);
                  if (arquivos.length > 0) {
                    var nomeArquivo = arquivos[0];
                    var ano = parseInt(nomeArquivo.substr(1, 2)) + 2000;
                    var mes = parseInt(nomeArquivo.substr(3, 2));

                    vm.parametrosExportacao.mesDistribuicao = mes;
                    vm.parametrosExportacao.anoDistribuicao = ano;
                    vm.parametrosExportacao.grupoDistribuicao =
                      nomeArquivo.substr(5, 3);
                  }
                });
              };

              reader.readAsArrayBuffer(newValue.lfFile);
            }
          }

          if (vm.parametros.calculo.tipoDetalheCalculo != 89 && !vm.ehBauru) {
            vm.metodos.validacaoArquivo();
          }
        }
      });

      $scope.$watch(
        "vm.parametrosExportacao.regionalCodigo",
        function (newValue, oldValue) {
          if (newValue && vm.parametros.calculo.tipoDetalheCalculo != 88) {
            vm.regional = _retornarRegionalSelecionada(newValue);
            vm.preLoader = true;
            if (vm.parametros.utilizaImportacaoLeituraViaFtp) {
              _listarArquivosFTP(vm.regional.codigo);
              vm.arquivoSelecionado = false;
            }
          } else {
            vm.arquivoSelecionado = false;
          }
        }
      );

      vm.parametrosExportacao = {
        imprimeAvisoCorte: "N",
      };

      vm.metodos = {
        validacaoArquivo: _validacaoArquivo,
        realizarImportacao: _realizarImportacao,
        validarArquivoJaImportado: _validarArquivoJaImportado,
        configurarSelect: configurarSelect,
        fecharDialog: fecharDialog,
        importacaoViaFTP: importacaoViaFTP,
        filtrar: filtrar,
        changeLocalidade: changeLocalidade,
        changeSetor: changeSetor,
        selecionarTodosArquivos: selecionarTodosArquivos,
        existemArquivosMarcados: existemArquivosMarcados,
        importarArquivosSelecionados: importarArquivosSelecionados,
      };
    }

    //#region Implementação Métodos

    /// Método interno para a validação do arquivo.
    function _retornarRegionalSelecionada(codigo) {
      return vm.regionais.find(function (item) {
        if (item.codigo == codigo) {
          return item;
        }
      });
    }

    function _validacaoArquivo() {
      var metodoValidacao =
        ExportacaoMobileService.fabricarValidacaoNomeArquivoGrupo(
          vm.arquivoCodigo,
          vm.parametros
        );

      var nomeArquivo = vm.arquivos[0].lfFileName.toUpperCase();

      ValidacaoService.validarParametroString(nomeArquivo);
      ValidacaoService.validarParametroObjeto(vm.parametrosExportacao);
      ValidacaoService.validarParametroObjeto(vm.lfApi);
      ValidacaoService.validarParametroFuncao(metodoValidacao);

      metodoValidacao(nomeArquivo, vm.parametrosExportacao, vm.lfApi, 2);
    }

    function importacaoViaFTP(nomeArquivo) {
      vm.tituloSplash = "Realizando download do arquivo no FTP...";
      vm.emProgresso = true;
      RequisicaoGenericaService.listarSemParams(
        "api/agrupamento/" +
        vm.regional.codigo +
        "/" +
        "baixarArquivoFTP?" +
        "nomeArquivo=" +
        nomeArquivo
      ).then(
        function (success) {
          vm.arquivos = [];
          vm.emProgresso = false;
          var parts = [];
          var arquivo = success.data;

          if (vm.arquivoCodigo == 20 || vm.arquivoCodigo == 21) {
            vm.urlArquivo = success.data;
          }

          for (var i = 0; i < arquivo.length; i++) {
            var conteudo = arquivo[i] + "\n";
            parts.push(new Blob([conteudo]));
          }

          var arquivoFTP = {
            lfFileName: nomeArquivo,
            lfFile: new File(parts, nomeArquivo, {}),
          };

          vm.arquivos.push(arquivoFTP);

          _realizarImportacao();
        },
        function (error) {
          vm.emProgresso = false;
          MdDialogService.alertPadrao(
            "Atenção",
            vm.event,
            "Não foi possível fazer download do arquivo do FTP."
          );
        }
      );
    }

    function _realizarImportacao() {
      if (vm.sistemaGestorEhFiorilli) {
        vm.tituloSplash = "Importando grupo de leituras...";

        if (vm.parametros.utilizarImportacaoGrupoLeituraFilaFiorilli) {
          vm.tituloSplash = "Importação do grupo de leitura em andamento";
          vm.subTituloSplash =
            "Aguardando o sistema gestor processar e disponibilizar os dados...";
        }

        vm.emProgresso = true;

        var viewModel = {
          mes: vm.parametrosExportacao.mesDistribuicao,
          ano: vm.parametrosExportacao.anoDistribuicao,
        };
        var url = Api.importacao.importacaoFiorilli;
        var dadosImportacaoFiorilli = {
          mes: viewModel.mes,
          ano: viewModel.ano,
        };
        RequisicaoGenericaService.salvar(url, dadosImportacaoFiorilli)
          .then(
            function (success) {
              MdDialogService.alertPadrao('', null, success.data);
              vm.lfApi.removeAll();
              vm.parametrosExportacao = {};
            },
            function (error) {
              ServicosGenericoService.tratarErroAPI(error);
            }
          )
          .finally(function () {
            vm.emProgresso = false;
          });
        return;
      }
      if (vm.ehBauru) {
        vm.tituloSplash = "Importando grupo de leituras...";
        vm.emProgresso = true;

        var viewModel = {
          mes: vm.parametrosExportacao.mesDistribuicao,
          ano: vm.parametrosExportacao.anoDistribuicao,
          grupo: vm.parametrosExportacao.grupoDistribuicao,
          NomeArquivo: vm.arquivos[0].lfFileName.toUpperCase(),
          arquivoBase64: vm.base64Arquivo.split(",")[1],
        };

        RequisicaoGenericaService.salvar(
          Api.importacao.importarBauru,
          viewModel
        )
          .then(
            function (success) {
              MdDialogService.alertPadrao("Arquivo importado com sucesso !");
              vm.lfApi.removeAll();
              vm.parametrosExportacao = {};
            },
            function (error) {
              ServicosGenericoService.tratarErroAPI(error);
            }
          )
          .finally(function () {
            vm.emProgresso = false;
          });
      } else {
        vm.tituloSplash = "Validando informações da remessa...";
        vm.emProgresso = true;
        for (var index = 0; index < vm.arquivos.length; index++) {
          const arquivo = vm.arquivos[index];
          if (!arquivo.isRemote && arquivo.lfFile.size == 0) {
            vm.emProgresso = false;
            MdDialogService.alertPadrao(
              "Arquivo [" + arquivo.lfFile.name + "] inexistente ou vazio !"
            );
            return;
          }
        }
        _validarArquivoJaImportado(vm.arquivos[0].lfFileName);
      }
    }

    function _chamarImportacao(arquivo) {
      vm.tituloSplash = "Importando grupo de leituras...";
      const nomeArquivo = vm.arquivos[0].lfFileName.toUpperCase();
      var dadosExportacao = {
        mes: vm.parametrosExportacao.mesDistribuicao,
        ano: vm.parametrosExportacao.anoDistribuicao,
        grupo: vm.parametrosExportacao.grupoDistribuicao,
        nomeArquivo: nomeArquivo,
        arquivoViewModel: arquivo,
      };
      var promessaExportacao = RequisicaoGenericaService.salvar(
        Api.importacao.criar,
        dadosExportacao
      );
      promessaExportacao.then(
        function (success) {
          vm.emProgresso = false;
          if (vm.parametros.calculo.tipoDetalheCalculo === 88) {
            vm.arquivos.splice(0, 1);

            if (vm.arquivos.length) {
              vm.urlArquivo = vm.arquivos[0].urlArquivo;
              vm.arquivoAtual += 1;
              vm.mensagemSplash =
                "Arquivo: " +
                vm.arquivos[0].lfFileName +
                "\n" +
                "Progresso: " +
                vm.arquivoAtual +
                " de " +
                vm.totalArquivos;
              _realizarImportacao();
              return;
            }
            MdDialogService.alertPadrao("Importação realizada com sucesso !");
            vm.parametrosExportacao.localidadeCodigo = vm.regional.codigo;
            vm.parametrosExportacao.setorCodigo = vm.setor;
            vm.preLoader = true;
            _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
            return;
          } else if (vm.parametros.calculo.tipoDetalheCalculo === 89) {
            MdDialogService.alertPadrao("Arquivo importado com sucesso !");
          } else {
            if (success.data.length) {
              MdDialogService.alertPadrao(success.data[0]);
            } else {
              MdDialogService.confirmPadraoComEvento(
                "Grupo de leituras importado com sucesso",
                "Deseja visualizar as estatísticas do processo de importação?",
                null,
                function () {
                  _abrirDialogEstatisticaImportacao(
                    arquivo.resumoDadosImportados
                  );
                },
                null
              );
            }
          }
          if (vm.parametros.utilizaImportacaoLeituraViaFtp) {
            _listarArquivosFTP(vm.regional.codigo);
          }
        },
        function (error) {
          vm.emProgresso = false;
          ServicosGenericoService.tratarErroAPI(error);
          if (vm.parametros.calculo.tipoDetalheCalculo == 88)
            _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
        }
      );
    }

    function _validarArquivoJaImportado(nomeArquivo) {
      vm.emProgresso = true;
      var promessaValidarArquivoGrupoImportado =
        RequisicaoGenericaService.listarSemParams(
          Api.importacao.verificarArquivoGrupoImportado + nomeArquivo
        );
      promessaValidarArquivoGrupoImportado.then(
        function (success) {
          _importarDadosArquivo(vm.arquivoCodigo);
        },
        function (error) {
          vm.emProgresso = false;

          if (vm.parametros.calculo.tipoDetalheCalculo == 88)
            error.data +=
              "<br><br>Arquivo: <strong>" +
              vm.arquivos[0].lfFileName +
              "</strong>";

          if (error.status == 400) {
            // MdDialogService.confirmPadraoComEventoEParametro("Atenção", error.data, vm.event,_importarDadosArquivo,vm.arquivoCodigo, null, null);

            var confirm = $mdDialog
              .confirm()
              .title("Atenção")
              .ariaLabel("Atenção")
              .htmlContent(error.data)
              .clickOutsideToClose(false)
              .targetEvent(event)
              .multiple(true)
              .ok("Sim")
              .cancel("Não");

            $mdDialog.show(confirm).then(
              function () {
                _importarDadosArquivo(vm.arquivoCodigo, true);
              },
              function () {
                if (vm.parametros.calculo.tipoDetalheCalculo == 88)
                  _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
              }
            );

            //Pergunta sim e não para continuar o processo
          } else if (error.status == 409) {
            MdDialogService.alertPadraoComEvento(
              "Atenção",
              _abrirDialogSenhaControleRotina,
              vm.event,
              error.data
            );

            //Após o ok chama o formulário de controle de rotinas
          } else {
            MdDialogService.alertPadrao("Atenção", vm.event, error.data);
            if (vm.parametros.calculo.tipoDetalheCalculo == 88)
              _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
          }

          vm.emProgresso = false;
        }
      );
    }

    function _importarDadosArquivo(arquivoCodigo, removerExistente) {
      vm.emProgresso = true;

      if (removerExistente == true) {
        var promiseExcluir = RequisicaoGenericaService.excluir(
          Api.importacao.removerGrupoLeitura,
          vm.arquivos[0].lfFileName
        );
        promiseExcluir.then(
          function (success) {
            _validarDadosArquivo(arquivoCodigo);
          },
          function (error) {
            vm.emProgresso = false;
            vm.error = error;
            MdDialogService.alertPadrao(
              "Atenção",
              vm.event,
              "Não foi possível remover o grupo de leituras!"
            );
            return;
          }
        );
      } else {
        _validarDadosArquivo(arquivoCodigo);
      }
    }

    function _validarDadosArquivo(arquivoCodigo) {
      var arquivo = arquivoCodigo;
      var dados = {};

      if (arquivoCodigo == 20 || arquivoCodigo == 21) {
        dados = {
          arquivoCodigo: arquivoCodigo,
          empresaCodigo: parametro.empresa.codigoImanager * 1,
          codificacaoArquivo: urlApi.codificao_arquivo,
          urlArquivo: vm.urlArquivo,
          base64Arquivo: vm.base64Arquivo,
        };

        var promessaUpload = RequisicaoGenericaService.importar(
          "api/layout/importacao",
          dados
        );
      } else {
        dados = {
          parametros: {
            tipoCalculo: arquivo,
            empresaCodigo: parametro.empresa.codigoImanager,
            utilizaAuditoriaExportacaoCreditoDebito: "N",
          },
          arquivo: vm.arquivos[0],
        };

        var promessaUpload = RequisicaoGenericaService.validarArquivos(
          dados,
          Api.arquivo.validar
        );
      }

      promessaUpload.then(
        function (success) {
          var arquivo = success.data;
          if (
            arquivo.informacoesConsumoCreditoDebito &&
            arquivo.informacoesConsumoCreditoDebito.length > 0
          ) {
            parametro = SessionStorageService.recuperar(
              KeysSessionStorage.parametrosEmpresa
            );
            vm.dados = arquivo.informacoesConsumoCreditoDebito;
            $mdDialog
              .show({
                controller: "RelatorioImportacaoController",
                controllerAs: "vm",
                templateUrl:
                  "app/main/processamento/exportacao-mobile/dialogs/relatorio-dialog/views/relatorio-dialog.html",
                targetEvent: null,
                clickOutsideToClose: false,
                fullscreen: false,
                locals: {
                  Relatorio: {
                    dadosRelatorio: arquivo.informacoesConsumoCreditoDebito,
                    nomeEmpresa: parametro.empresa.nomeEmpresa,
                    marcaEspecial: null,
                    logomarca: null,
                  },
                },
              })
              .then(
                function () {
                  _chamarImportacao(arquivo);
                },
                function () {
                  vm.emProgresso = false;
                }
              );
          } else {
            _chamarImportacao(arquivo);
          }
        },
        function (error) {
          vm.emProgresso = false;
          ServicosGenericoService.tratarErroAPI(error);

          if (vm.parametros.calculo.tipoDetalheCalculo == 88)
            _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
        }
      );
    }

    function configurarSelect() {
      vm.termoProcurado = "";
      angular.element("#select").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }

    function fecharDialog() {
      $mdDialog.hide();
    }

    function _abrirDialogSenhaControleRotina() {
      $mdDialog
        .show({
          controller: "DialogSenhaImplantacaoController",
          controllerAs: "vm",
          templateUrl:
            "app/compartilhado/dialog-senha-implantacao/views/dialog-senha-implantacao.html",
          targetEvent: null,
          clickOutsideToClose: false,
          multiple: true,
        })
        .then(
          function (success) {
            _importarDadosArquivo(vm.arquivoCodigo, true);
          },
          function (error) {
            if (error)
              MdDialogService.alertPadrao(
                "Senha de implantação não confere.",
                vm.event,
                "Não foi possível realizar importação pois não foi informada senha de implantação."
              );
            else
              MdDialogService.alertPadrao(
                "Atenção",
                vm.event,
                "Grupo de leituras não importado."
              );

            if (vm.parametros.calculo.tipoDetalheCalculo == 88)
              _listarArquivosFTPCaema(vm.regional.codigo, vm.setor);
          }
        );
    }
    function _abrirDialogEstatisticaImportacao(lista) {
      $mdDialog.show({
        controller: "DialogEstatisticaController",
        controllerAs: "vm",
        templateUrl:
          "app/main/processamento/importacao-grupo-leitura/dialogs/estatistica-dialog/views/estatistica-dialog.html",
        targetEvent: null,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          Lista: lista,
        },
      });
    }

    function filtrar(status) {
      if (vm.arquivosFTPBkp.length > 0) {
        if (status == "Todos") {
          vm.arquivosFTP.arquivos = angular.copy(vm.arquivosFTPBkp);
        } else if (status == "Importados") {
          vm.arquivosFTP.arquivos = vm.arquivosFTPBkp.filter(function (item) {
            if (item.situacao == "Importado") {
              return item;
            }
          });
        } else if (status == "Não importados") {
          vm.arquivosFTP.arquivos = vm.arquivosFTPBkp.filter(function (item) {
            if (item.situacao == "Não importado") {
              return item;
            }
          });
        }
      }
    }

    function _listarArquivosFTP(regional) {
      RequisicaoGenericaService.listarSemParams(
        "api/agrupamento/" + regional + "/" + "listarArquivosFTP"
      ).then(
        function (success) {
          vm.filtro.status = "Não importados";
          vm.arquivosFTP.arquivos = angular.copy(success.data);
          vm.arquivosFTPBkp = angular.copy(success.data);
          vm.preLoader = false;

          filtrar(vm.filtro.status);
        },
        function (error) {
          vm.arquivosFTP.arquivos = [];
          vm.preLoader = false;
          MdDialogService.alertPadrao(
            "Atenção",
            vm.event,
            "Não foi possível listar arquivos do FTP."
          );
        }
      );
    }

    ////#region METODOS CAEMA
    function changeLocalidade(localidade) {
      vm.emProgressoSetores = true;
      var pSetores = MunicipioService.listarMunicipios(localidade);

      pSetores
        .then(function (success) {
          vm.municipios = success.data;
        })
        .finally(function () {
          vm.emProgressoSetores = false;
        });
    }

    function changeSetor() {
      vm.preLoader = true;
      vm.regional = _retornarRegionalSelecionada(
        vm.parametrosExportacao.localidadeCodigo
      );
      vm.setor = vm.parametrosExportacao.setorCodigo;
      if (vm.parametros.utilizaImportacaoLeituraViaFtp) {
        _listarArquivosFTPCaema(
          vm.parametrosExportacao.localidadeCodigo,
          vm.parametrosExportacao.setorCodigo
        );
        vm.arquivoSelecionado = false;
      }
    }

    function _listarArquivosFTPCaema(localidade, setor) {
      vm.preLoader = true;
      if (vm.parametros.calculo.tipoDetalheCalculo != 88) return;
      setor = parseInt(setor);

      var pArquivos = ImportacaoGrupoLeituraCaemaService.listarArquivosFtp(
        localidade,
        setor
      );
      pArquivos.then(
        function (success) {
          if (!vm.parametrosExportacao.localidadeCodigo) {
            vm.parametrosExportacao.localidadeCodigo = localidade;
            vm.parametrosExportacao.setorCodigo = setor
              .toString()
              .padStart(3, "0");
          }

          vm.filtro.status = "Não importados";
          vm.arquivosFTP.arquivos = angular.copy(success.data);
          vm.arquivosFTPBkp = angular.copy(success.data);
          vm.preLoader = false;
          filtrar(vm.filtro.status);
        },
        function (error) {
          vm.arquivosFTP.arquivos = [];
          vm.preLoader = false;
          MdDialogService.alertPadrao(
            "Atenção",
            vm.event,
            "Não foi possível listar arquivos do FTP."
          );
        }
      );
    }

    function selecionarTodosArquivos() {
      vm.marcarTodos = !vm.marcarTodos;
      if (vm.filtro.status == "Todos") {
        vm.arquivosFTP.arquivos.forEach(function (item) {
          if (item.situacao == "Não importado")
            item.selecionado = vm.marcarTodos;
        });
      } else {
        vm.arquivosFTP.arquivos.forEach(function (item) {
          item.selecionado = vm.marcarTodos;
        });
      }
    }

    function existemArquivosMarcados() {
      return vm.arquivosFTP.arquivos.some(function (item) {
        return item.selecionado;
      });
    }

    function _retornaArquivosSelecionados() {
      return vm.arquivosFTP.arquivos.filter(function (item) {
        return item.selecionado;
      });
    }

    function importarArquivosSelecionados() {
      var arquivos = _retornaArquivosSelecionados().map(function (item) {
        return item.nome;
      });
      vm.emProgresso = true;
      vm.tituloSplash = "Realizando download do(s) arquivo(s) no FTP...";
      vm.mensagemSplash = "";
      vm.arquivos = [];

      arquivos.forEach(function (nomeArquivo, index) {
        var setor = parseInt(vm.parametrosExportacao.setorCodigo);
        var pImportacao = ImportacaoGrupoLeituraCaemaService.importacaoViaFtp(
          vm.regional.codigo,
          nomeArquivo,
          setor
        );
        pImportacao.then(
          function (success) {
            var parts = [];
            var arquivo = success.data;

            for (var i = 0; i < arquivo.length; i++) {
              var conteudo = arquivo[i] + "\n";
              parts.push(new Blob([conteudo]));
            }

            var arquivoFTP = {
              lfFileName: nomeArquivo,
              lfFile: new File(parts, nomeArquivo, {}),
              urlArquivo: success.data,
            };

            vm.arquivos.push(arquivoFTP);

            if (index === arquivos.length - 1) {
              vm.urlArquivo = vm.arquivos[0].urlArquivo;
              vm.totalArquivos = arquivos.length;
              vm.arquivoAtual = 1;
              vm.mensagemSplash =
                "Arquivo: " +
                vm.arquivos[0].lfFileName +
                "\n " +
                "Progresso: " +
                vm.arquivoAtual +
                " de " +
                vm.totalArquivos;
              _realizarImportacao();
              return;
            }
          },
          function (error) {
            vm.emProgresso = false;
            MdDialogService.alertPadrao(
              "Atenção",
              vm.event,
              "Não foi possível fazer download do arquivo do FTP."
            );
          }
        );
      });
    }

    ////#endregion

    //#endregion

    //#endregion

    //#region Métodos internos

    /// Fabrica o método de validação de arquivo

    //#endregion

    //#endregion
  }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.geracaoarquivo')
        .controller('GeracaoarquivoController', GeracaoarquivoController);

    function GeracaoarquivoController(
        $mdDialog,
        Api,
        RequisicaoGenericaService,
        MdDialogService,
        ServicosGenericoService,
        GeracaoArquivoService,
        ArquivosService,
        GeracaoArquivoFactory,
        RotasHtml,
        LeituristaCodigo,
        DataExportacao,
        obterDadosParametro,
        SessionStorageService,
        KeysSessionStorage
    ) {

        var vm = this;
        vm.parametro = obterDadosParametro.data;

        init();

        vm.metodos = {
            configurarSelect: configurarSelect,
            gerarArquivoRetorno: _gerarArquivoRetorno,
            pesquisarArquivosRetorno: pesquisarArquivosRetorno
        };

        vm.metodosGeral = {
            fecharDialog: fecharDialog
        }

        function init() {
            vm.codigoLeiturista = LeituristaCodigo;
            vm.emProgresso = false;
            vm.form = {};
            vm.exibirFiltro = true;
            vm.cabecalhos = ['Arquivo', 'Status', 'Ação']
            vm.propriedadesExibirTabela = ['nomeArquivoExportacao'];
            vm.options = GeracaoArquivoFactory.dtOptionsArquivoRetorno;
            vm.options.order = [[1, "asc"]]
            vm.exibirListaArquivos = false;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.sistemaGestorEhThema = vm.parametros.coletor.sistemaGestor == 3;
            vm.filtro = {
                dataExportacao: new Date()
            };
            if (DataExportacao)
                vm.filtro.dataExportacao = DataExportacao;

            RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos).then(
                function (success) {
                    vm.leituristas = success.data;
                    if (LeituristaCodigo)
                        vm.filtro.codigoLeiturista = LeituristaCodigo;
                },
                function (error) {
                    MdDialogService.alertPadrao("Falha ao carregar os leituristas.\n\nDetalhes: " + error.data);
                }
            );

            vm.diretorioCompomentListaArquivo = RotasHtml.geracaoarquivo.tabelaArquivo;

        }

        function _gerarArquivoRetorno(arquivo) {
            if (arquivo.emAndamento) {
                MdDialogService
                    .confirmPadraoComEvento(
                        'Ainda existem leituras pendentes de execução, deseja continuar?',
                        null,
                        null,
                        function () {
                            _geracaoArquivoRetorno(arquivo);
                        },
                        event);
            }
            else {
                _geracaoArquivoRetorno(arquivo);
            }
        }

        function _geracaoArquivoRetorno(arquivo) {
            arquivo.emProgresso = true;
            vm.filtro.nomeArquivoExportacao = arquivo.nomeArquivoExportacao;
            vm.desabilitarBotaoFiltro = true;

          if (vm.sistemaGestorEhThema) {
            RequisicaoGenericaService
              .salvar(Api.geracaoArquivoRetorno.gerarArquivoRetorno, vm.filtro).then(
                function (success) {
                  return ArquivosService.baixarArquivoBytes(success.data.bytesArquivo, success.data.arquivos[0], success.data.tipoArquivo);
                },
                function (error) {
                  if (error.data && error.data.retornoErro && error.data.retornoErro.mensagemErro){
                    MdDialogService.alertPadrao(
                            "Atenção",
                            null,
                            error.data.retornoErro.mensagemErro
                        );
                  } else {
                    ServicosGenericoService.tratarErroAPI(error.data);
                  }
                }).finally(function () {
                    arquivo.emProgresso = false;
                    vm.desabilitarBotaoFiltro = false;
                });
          } else {
            GeracaoArquivoService.gerarArquivo(
                vm.filtro.codigoLeiturista,
                vm.filtro.dataExportacao,
                vm.filtro.nomeArquivoExportacao,
                function () {
                    arquivo.emProgresso = false;
                    vm.desabilitarBotaoFiltro = false;
                },
                function (error) {
                    ServicosGenericoService.tratarErroAPI(error.data.title);
                    arquivo.emProgresso = false;
                    vm.desabilitarBotaoFiltro = false;
                });
          }


        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function pesquisarArquivosRetorno() {
            vm.emProgresso = true;
            RequisicaoGenericaService
                .listarSemParams(Api.geracaoArquivoRetorno.retornaListaNomesArquivoExportacao +
                    vm.filtro.codigoLeiturista + '?dataExportacao=' + vm.filtro.dataExportacao.toLocaleDateString())
                .then(function (success) {
                    vm.emProgresso = false;
                    vm.arquivos = angular.copy(success.data);
                }).catch(function (error) {
                    vm.emProgresso = false;
                    ServicosGenericoService.tratarErroAPI(error);
                });
        }


        function fecharDialog() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.gerenciamentogrupo')
        .controller('GerenciamentoGrupoController', GerenciamentoGrupoController)

    /** @ngInject */
    function GerenciamentoGrupoController($mdSidenav, $scope, DatatableFactory, MdDialogService, RotasHtml, $mdDialog,
        RequisicaoGenericaService, Api, GerenciamentoGrupoFactory, DTDefaultOptions, SessionStorageService, KeysSessionStorage) {
        var vm = this;

        var rotasHtml = RotasHtml.gerenciamentoGrupo;
        vm.metodos = {
            abrirFiltroGerenciamentoGrupo: abrirFiltroGerenciamentoGrupo,
            selecionarMetodoAcao: selecionarMetodoAcao,
            recuperarTarefas: recuperarTarefas,
            recuperarTodasTarefas: recuperarTodasTarefas,
            abrirImportacao: abrirImportacao,
            abrirDialogDatas: abrirDialogDatas
        }

        vm.emProgresso = false;
        vm.mensagemCarregamento = "";
        vm.dialogImportacaoAberto = false;

        vm.grupos = [];
        vm.existeGrupoDistribuido = false;

        vm.coresSituacao = [];
        var data = new Date();
        vm.entidadefiltro = {
            mes: data.getMonth() + 1,
            ano: data.getFullYear(),
            situacao: 'Aberto'
        }

        $scope.$on('carregamentoDadosGerenciamento', function (ev, data) {
            _iniciaProgresso('Carregando dados dos grupos...');
        });

        $scope.$on('dadosGerenciamentoGrupo', function (ev, data) {
            _finalizaProgresso();
            if (data == null) {
                vm.grupos = [];
                vm.existeGrupoDistribuido = false;
                _finalizaProgresso();
            }
            else {
                if (data.grupo && data.grupos.length === 0) {
                    vm.grupos = [];
                    vm.existeGrupoDistribuido = false;
                    return;
                }
                else {
                    vm.grupos = data.grupos;
                    vm.existeGrupoDistribuido = vm.grupos.some(function (grupo) { return grupo.situacao !== 'NÃO DISTRIBUÍDO' });
                    vm.filtros = _construirFiltros(vm.grupos[0], vm.parametros.calculo.tipoDetalheCalculo);
                    vm.entidadefiltro = angular.copy(data.filtro);
                    vm.entidadefiltro.mes = vm.entidadefiltro.mes.toString().padStart(2, '0');
                    vm.entidadefiltro.situacao = vm.entidadefiltro.situacao == 1 ? 'Aberto' : 'Todos';
                    _finalizaProgresso();
                }
            }

        });

        init();



        function init() {
            //_pesquisaGruposMesAtual();
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.coresSituacao = GerenciamentoGrupoFactory.coresLegendaSituacao()

            vm.dtOptions = _construirDtOptions(vm.parametros.calculo.tipoDetalheCalculo);
            vm.itensMenu = _construirMenus();
        }

        function _construirDtOptions(tipoDetalheCalculo) {
            var dtOptions;

            if (tipoDetalheCalculo == 88) {
                dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [1, 2, 3, 4, 5, 6, 7, 8],
                        orderable: false
                    },
                    {
                        targets: [10],
                        responsivePriority: 1
                    }
                ]);
            } else if (tipoDetalheCalculo == 89) {
                dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                        orderable: false
                    },
                    {
                        targets: [10],
                        responsivePriority: 1
                    }
                ]);
            } else {
                dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
                    {
                        targets: [1, 2, 3, 4, 5, 6, 7, 8],
                        orderable: false
                    },
                    {
                        targets: [9],
                        responsivePriority: 1
                    }
                ]);
            }

            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
            dtOptions.dom = 'rt<"bottom"<"left"<"info"i>>>';

            return dtOptions;

        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar grupo',
                    direction: top,
                    executarAcaoClick: function () { return abrirFiltroGerenciamentoGrupo() }
                },
                {
                    icon: 'icon-clipboard-arrow-down s20',
                    name: "Importar grupo de leitura",
                    direction: top,
                    executarAcaoClick: function () { return abrirImportacao() }
                },
                {
                    icon: 'icon-refresh s20',
                    name: "Atualizar dados",
                    direction: top,
                    executarAcaoClick: function () { return _pesquisaGruposMesAtual() }
                },
                {
                    icon: 'icon-information-outline s20',
                    name: "Legenda",
                    direction: top,
                    hide: true,
                    executarAcaoClick: function () { return abrirLegendaGerenciamentoGrupo() }
                }
            ]
        }

        function _construirFiltros(grupo, tipoDetalheCalculo) {

            if (tipoDetalheCalculo == 88) {
                return [
                    { titulo: 'Localidade', dado: grupo.filtroRealizado, flexGtXs: 30 },
                    { titulo: 'Setor', dado: grupo.filtroRealizado2, flexGtXs: 25 },
                    { titulo: 'Referência', dado: grupo.filtroRealizado3, flexGtXs: 25 },
                    { titulo: 'Status', dado: grupo.filtroRealizado4, flexGtXs: 20 },
                ]
            }

            return [
                { titulo: 'Agrupamento', dado: grupo.filtroRealizado, flexGtXs: 30 },
                { titulo: 'Município', dado: grupo.filtroRealizado2, flexGtXs: 25 },
                { titulo: 'Referência', dado: grupo.filtroRealizado3, flexGtXs: 25 },
                { titulo: 'Status', dado: grupo.filtroRealizado4, flexGtXs: 20 },
            ]

        }

        function abrirFiltroGerenciamentoGrupo() {
            $mdSidenav('filtro-gerenciamentogrupo').toggle();
        }

        function abrirLegendaGerenciamentoGrupo() {
            $mdSidenav('legenda-gerenciamentogrupo').toggle();
        }

        function _iniciaProgresso(mensagem) {
            vm.emProgresso = true,
                vm.mensagemCarregamento = mensagem;
        }

        function _finalizaProgresso() {
            vm.emProgresso = false
        }

        function recuperarTarefas(grupo) {
            if (grupo.grupo) {
                var mensagem = 'Buscando tarefas...' + '\n' + 'Referência: ' + grupo.referencia + ' Grupo: ' + grupo.grupo;
                _iniciaProgresso(mensagem);
                var grupoViewModel = {
                    mes: grupo.referencia.substring(0, 2),
                    ano: grupo.referencia.substring(3, 8),
                    grupoLeitura: grupo.grupo,
                    regional: grupo.regional,
                    municipio: grupo.municipio
                }
                var promise = RequisicaoGenericaService.salvar(Api.gerenciamentoGrupo.realizarFiltroTarefas, grupoViewModel);
                promise.then(function (success) {
                    _finalizaProgresso();
                    vm.entidadefiltro.informacoesCardFiltros = [];
                    vm.entidadefiltro.informacoesCardFiltros = vm.filtros;
                    _abrirDialogTarefas(grupo, success.data, vm.entidadefiltro);
                }, function (error) {
                    _finalizaProgresso();
                    MdDialogService.alertPadrao("Atenção", null, error.data);
                });
            }
        }

        function recuperarTodasTarefas() {
            if (vm.grupos[0].grupo) {
                var mensagem = 'Buscando tarefas...' + '\n' + 'Referência: ' + vm.grupos[0].referencia + ' Grupo: ' + vm.grupos[0].grupo;
                _iniciaProgresso(mensagem);
                var grupoViewModel = {
                    mes: vm.grupos[0].referencia.substring(0, 2),
                    ano: vm.grupos[0].referencia.substring(3, 8),
                    grupoLeitura: vm.grupos[0].grupo,
                    regional: vm.grupos[0].regional
                }
                var promise = RequisicaoGenericaService.salvar(Api.gerenciamentoGrupo.realizarFiltroTarefas, grupoViewModel);
                promise.then(function (success) {
                    var grupo = angular.copy(vm.grupos[0]);
                    grupo.municipio = null;
                    _finalizaProgresso();
                    vm.entidadefiltro.informacoesCardFiltros = [];
                    vm.entidadefiltro.informacoesCardFiltros = vm.filtros;
                    _abrirDialogTarefas(grupo, success.data, vm.entidadefiltro);
                }, function (error) {
                    _finalizaProgresso();
                    MdDialogService.alertPadrao("Atenção", null, error.data);
                });
            }
        }

        function _pesquisaGruposMesAtual() {
            var filtro = GerenciamentoGrupoFactory.getFiltro();
            _iniciaProgresso("Carregando dados dos grupos...")
            RequisicaoGenericaService.salvar(Api.gerenciamentoGrupo.realizarFiltroGrupos, filtro).then(function (success) {
                vm.grupos = success.data;
                vm.existeGrupoDistribuido = vm.grupos.some(function (grupo) { return grupo.situacao !== 'NÃO DISTRIBUÍDO' });
                _finalizaProgresso();
            }, function (error) {
                _finalizaProgresso();
            });
        }


        function _abrirDialogTarefas(grupo, tarefas, filtro) {
            var tmpt = _definirTemplate(vm.parametros.calculo.tipoDetalheCalculo)
            $mdDialog.show({
                controller: 'DialogTarefasGerenciamentoGrupoController',
                controllerAs: 'vm',
                templateUrl: tmpt,
                targetEvent: null,
                clickOutsideToClose: false,
                mdIsFullscreen: 'xs,sm,md',
                multiple: true,
                escapeToClose: false,
                locals: {
                    Grupo: grupo,
                    Tarefas: tarefas,
                    Filtro: filtro
                }
            }).then().finally(function () {
                _pesquisaGruposMesAtual();
            });
        }

        function _definirTemplate(tipoDetalheCalculo) {
            if (tipoDetalheCalculo == 88) {
                return rotasHtml.dialogs.caema.tarefas;
            }
            return rotasHtml.dialogs.tarefas;
        }


        function selecionarMetodoAcao(event, grupo, tarefa) {
            if (!grupo.situacao) {
                MdDialogService.alertPadrao("Grupo não pode executar nenhuma ação");
                return;
            }
            var acao = function () { };
            switch (grupo.situacao) {
                case "NÃO DISTRIBUÍDO":
                    acao = function () {
                        _abrirDistribuicao(event, grupo);
                    };
                    break;
                case "DISTRIBUÍDO":
                    acao = function () {
                        _abrirDisponibilizacaoTarefa(grupo, tarefa);
                    };
                    break;
                case "PARCIALMENTE DISTRIBUÍDO":
                    acao = function () {
                        _abrirDistribuicao(event, grupo);
                    };
                    break;
                case "IMPORTADO MOBILE":
                case "GRUPO EXPORTADO":
                    acao = function () {
                        _abrirExportacao(grupo);
                    };
                    break;
                default:
                    acao = function () {
                        MdDialogService.alertPadrao("Não há nenhuma ação para esta situação.");
                    }
            }
            acao(event, grupo);
        }

        function _abrirDistribuicao(event, grupo) {
            var filtro = GerenciamentoGrupoFactory.getFiltro();
            var setores = GerenciamentoGrupoFactory.getSetores();
            grupo.regional = filtro.regional;
            if (vm.parametros.calculo.tipoDetalheCalculo == 88 && !filtro.municipio) {
                _abrirDialogSelecionarSetorDistribuicao(grupo, filtro);
            }
            else {
                _abrirDialogDistribuicao(grupo);
            }
        }

        function _abrirDialogDistribuicao(grupo) {
            $mdDialog.show({
                controller: 'DistribuicaoController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.distribuicao,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    Grupo: grupo
                }
            }).then().finally(function () {
                _pesquisaGruposMesAtual();
            });
        }

        function _abrirDialogSelecionarSetorDistribuicao(grupo, filtro) {

            $mdDialog.show({
                controller: 'DialogSelecionarSetoresDistribuicaoPorGerenciamentoGrupoController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.caema.dialogs.selecionarSetores,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                resolve: {
                    listarSetores: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                            '?regional=' + grupo.regional + '&mes=' + filtro.mes.toString().padStart(2, '0') + '&ano=' + filtro.ano + "&grupo=" + grupo.grupo);
                    }
                }
            }).then(function (success) {
                grupo.municipio = success;
                _abrirDialogDistribuicao(grupo);
            }, function () { MdDialogService.alertPadrao("Atenção", null, "Processo de distribuição não foi iniciado."); });
        }


        function _abrirDisponibilizacaoTarefa(Grupo) {

            var viewModel = {
                grupoReferencia: Grupo.referencia,
                grupo: Grupo.grupo,
                regional: vm.entidadefiltro.regional,
                municipio: Grupo.municipio
            }
            $mdDialog.show({
                controller: 'DisponibilizarTarefasController',
                controllerAs: 'vm',
                escapeToClose: false,
                templateUrl: RotasHtml.gerenciamentoGrupo.dialogs.disponibilizarTarefas,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    LeituristaCodigo: 0,
                    GrupoTarefa: angular.copy(viewModel)
                }
            }).then().finally(function () {
                _pesquisaGruposMesAtual();
            });

        }

        function abrirImportacao() {

            if (vm.dialogImportacaoAberto)
                return;

            vm.dialogImportacaoAberto = true;

            $mdDialog.show({
                controller: 'ImportacaoGrupoLeituraController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.importacaoGrupoLeitura,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                escapeToClose: false,
                locals: {
                    listarRegionais: SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos)
                },
                resolve: {
                    retornarArquivoPadrao: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.retornarArquivoPadrao);
                    },
                }
            }).then().finally(function () {
                _pesquisaGruposMesAtual();
                vm.dialogImportacaoAberto = false;

            });

        }

        function _abrirExportacao(grupo) {
            $mdDialog.show({
                controller: 'ExportacaoGrupoLeituraController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.exportacaoGrupoLeitura,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                escapeToClose: false,
                locals: {
                    Grupo: grupo
                }
            }).then().finally(function () {
                _pesquisaGruposMesAtual();
            });
        }

        function abrirDialogDatas(grupo) {
            $mdDialog.show({
                controller: 'DialogDatasGrupoController',
                controllerAs: 'vm',
                templateUrl: rotasHtml.dialogs.datasGrupo,
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                escapeToClose: true,
                locals: {
                    Grupo: grupo
                }
            });
        }

    }

}());

(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaogestor')
        .controller('ExportacaoGestorController', ExportacaoGestorController);

    function ExportacaoGestorController(Api, RequisicaoGenericaService, ListarArquivos,
        $mdDialog, ServicosGenericoService, ExportacaoGestorService, ExportacaoGestorFactory, RotasHtml) {
        var vm = this;

        init();

        vm.metodos = {
            configurarSelect: configurarSelect,
            realizarEnvio: _realizarEnvio
        };

        vm.metodosGeral = {
            fecharDialog: fecharDialog
        };

        vm.filtro = {
            codigoLeiturista: "",
            nomeArquivoExportacao: ""
        };

        function _iniciarProcesso(mensagem) {
            vm.emProgresso = true;
            vm.mensagem = mensagem;
        }

        function init() {

            _iniciarProcesso("Buscando arquivos...");

            if (ListarArquivos.data) {
                vm.arquivos = ListarArquivos.data;
                vm.emProgresso = false;
            }
            else {
                RequisicaoGenericaService.listarSemParams(Api.exportacaoGestor
                    .retornaListaNomesArquivoExportacaoGestor)
                    .then(
                        function (success) {
                            vm.arquivos = success.data;
                        },
                        function (error) {
                            vm.arquivos = [];
                        })
                    .finally(function () {
                        vm.emProgresso = false;
                    }
                    );
            }

            vm.form = {};
            vm.cabecalhos = ['Leiturista', 'Arquivo', 'Quantidade', 'Ação']
            vm.propriedadesExibirTabela = ['nomeLeiturista', 'nomeArquivoExportacao', 'quantidade'];
            vm.options = ExportacaoGestorFactory.dtOptionsArquivoRetorno;
            vm.exibirListaArquivos = false;
            vm.diretorioCompomentListaArquivo = RotasHtml.exportacaogestor.tabelaArquivo;
        }

        function _realizarEnvio(arquivo) {

            vm.filtro.codigoLeiturista = arquivo.codigoLeiturista;
            vm.filtro.nomeArquivoExportacao = arquivo.nomeArquivoExportacao;

            vm.desabilitarBotaoFiltro = true;
            _iniciarProcesso("Enviando leituras...");

            ExportacaoGestorService.enviarLeituras(
                vm.filtro.codigoLeiturista,
                vm.filtro.nomeArquivoExportacao,

                function () {
                    vm.desabilitarBotaoFiltro = false;
                    ListarArquivos.data = null;
                    init();
                },
                function (error) {
                    ServicosGenericoService.tratarErroAPI(error.data.title);
                    vm.desabilitarBotaoFiltro = false;
                    vm.emProgresso = false;
                });
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function fecharDialog() {
            $mdDialog.cancel();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaomobile')
        .controller('ExportacaomobileController', ExportacaomobileController);

    function ExportacaomobileController
        (
            SessionStorageService,
            KeysSessionStorage,
            Api,
            RequisicaoGenericaService,
            MdDialogService,
            ValidacaoService,
            ParametrosFactory,
            $scope,
            ExportacaoMobileService,
            ServicosGenericoService,
            LeituristaUtilsService,
            $mdDialog,
            LeituristaCodigo,
            DisponibilizarCargaRetidasService,
            Base64Service
        ) {

        var vm = this;
        var rotaApi = Api.exportacaomobile;
        vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        vm.sistemaGestorEhFiorilli = vm.parametro.coletor.sistemaGestor == 2;
        vm.sistemaGestorEhThema = vm.parametro.coletor.sistemaGestor == 3;

        init();

        function init() {
            vm.desabilitarCampos = false;
            vm.form = {};

            RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos).then(
                function (success) {
                    vm.leituristas = success.data;
                    if (vm.leituristas.length == 0)
                        MdDialogService.alertPadrao("Não existem leituristas cadastrados ou ativos, por favor verifique.");
                    else if (LeituristaCodigo != 0) {
                        vm.codigoLeiturista = LeituristaCodigo;
                        vm.desabilitarCampos = true;
                        _controlaTelaPorTipoArquivo();
                    }
                },
                function (error) {
                    MdDialogService.alertPadrao("Falha ao carregar os leituristas.\n\nDetalhes: " + error.data);
                }
            );

            vm.arquivos = [];
            vm.lfApi = {};
            vm.emProgresso = false;

            $scope.$watch('vm.arquivos[0]', function (newValue, oldValue) {
                if (newValue) {
                    vm.metodos.validacaoArquivo();
                }
                else {
                    var _imprimeAvisoCorte = vm.controleTela.chkImprimeAvisoCorte ? "S" : "N";

                    vm.parametrosExportacao = {
                        imprimeAvisoCorte: _imprimeAvisoCorte
                    };
                }
            });

            vm.controleTela = {
                pnlPocosCaldas: false,
                pnlDistribuicao: false,
                pnlOrigem: false,
                pnlHoraMinuto: false,
                pnlGrade: false,
                pnlRota: false,
                pnlLocalidade: false,
                chkProcedimentoRepasse: false,
                chkImprimeAvisoCorte: false,
                dtProximaLeitura: false,
                pnlArea: false,
                localidadeRotaSequencia: false,
                setorRotaMesAno: false
            };

            vm.parametrosExportacao = {
                imprimeAvisoCorte: "N"
            };

            vm.metodos = {
                controlaTelaPorTipoArquivo: _controlaTelaPorTipoArquivo,
                validacaoArquivo: _validacaoArquivo,
                realizarExportacao: _realizarExportacao,
                validarArquivoJaImportado: _validarArquivoJaImportado,
                configurarSelect: configurarSelect,
                disponibilizarCarga: _disponibilizarCarga
            };

            vm.metodosGeral = {
                fecharDialog: fecharDialog
            }

            habilitaDesabilitaCampos();
        }

        function _validacaoArquivo() {
            // Para sistema THEMA, validar apenas a extensão .REM
            if (vm.sistemaGestorEhThema) {
                var nomeArquivo = vm.arquivos[0].lfFileName.toUpperCase();
                if (!nomeArquivo.endsWith('.REM')) {
                    MdDialogService.alertPadrao("Arquivo inválido! O arquivo deve ter a extensão .REM");
                    vm.lfApi.removeAll();
                }
                return;
            }

            var leiturista = LeituristaUtilsService.retornarLeituristaPorCodigo(vm.leituristas, vm.codigoLeiturista);

            if (leiturista) {
                var metodoValidacao = ExportacaoMobileService.fabricarValidacaoNomeArquivo(leiturista, vm.parametro);
                var nomeArquivo = vm.arquivos[0].lfFileName.toUpperCase();

                ValidacaoService.validarParametroString(nomeArquivo);
                ValidacaoService.validarParametroObjeto(vm.parametrosExportacao);
                ValidacaoService.validarParametroObjeto(vm.lfApi);
                ValidacaoService.validarParametroFuncao(metodoValidacao);

                metodoValidacao(nomeArquivo, vm.parametrosExportacao, vm.lfApi, vm.parametro);
            }
        }

        function _realizarExportacao() {
            vm.emProgresso = true;
            for (var index = 0; index < vm.arquivos.length; index++) {
                const arquivo = vm.arquivos[index];
                if (arquivo.lfFile.size == 0) {
                    MdDialogService.alertPadrao("Arquivo [" + arquivo.lfFile.name + "] inexistente ou vazio !");
                    vm.emProgresso = false;
                    return;
                }
            }

            _validarArquivoJaImportado(vm.codigoLeiturista, vm.arquivos[0].lfFileName);
        }

        function _chamarExportacao(arquivo) {
            const nomeArquivo = vm.arquivos[0].lfFileName.toUpperCase();

            var dadosExportacao = {
                nomeArquivo: nomeArquivo,
                arquivoViewModel: arquivo,
                leituristaCodigo: vm.codigoLeiturista,
                parametrosExportacao: vm.parametrosExportacao
            };

            var promessaExportacao = RequisicaoGenericaService.salvar(Api.exportacao.criar, dadosExportacao);

            promessaExportacao.then(function (success) {
                var mensagemExportacao = success.data;

                if (vm.parametro.utilizarGerenciamentoFaturasRetidasVinculadas && vm.parametrosExportacao.disponibilizarRetidas) {
                    _exportarRetidas(dadosExportacao, mensagemExportacao);
                } else {
                    vm.emProgresso = false;

                    if (mensagemExportacao.length) {
                        MdDialogService.alertPadrao(mensagemExportacao[0]);
                    } else {
                        MdDialogService.alertPadrao("Disponibilização da carga realizada com sucesso!");
                    }
                }
            }, function (error) {
                ServicosGenericoService.tratarErroAPI(error);
                vm.emProgresso = false;
            });
        }

        function _exportarRetidas(dadosExportacao, mensagemExportacao) {
            DisponibilizarCargaRetidasService.listarFaturasRetidas(dadosExportacao.nomeArquivo).then(function (success) {
                $mdDialog.show({
                    controller: 'DisponibilizarRetidasDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/processamento/exportacao-mobile/dialogs/disponibilizar-retidas-dialog/views/disponibilizar-retidas-dialog.html',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    locals: {
                        FaturasRetidas: success
                    }
                }).then(function (faturasRetidas) {
                    if (faturasRetidas && faturasRetidas.length > 0) {
                        DisponibilizarCargaRetidasService.disponibilizarUnificadoArquivo(faturasRetidas, dadosExportacao.leituristaCodigo, dadosExportacao.nomeArquivo)
                            .then(function () {
                                if (mensagemExportacao.length) {
                                    MdDialogService.alertPadrao(mensagemExportacao[0]);
                                } else {
                                    MdDialogService.alertPadrao("Disponibilização da carga realizada com sucesso!");
                                }
                            }, function (error) {
                                MdDialogService.alertPadrao(error.data);
                            }).finally(function () { vm.emProgresso = false; });
                    }
                    else {
                        if (mensagemExportacao.length) {
                            MdDialogService.alertPadrao(mensagemExportacao[0]);
                        } else {
                            MdDialogService.alertPadrao("Disponibilização da carga realizada com sucesso!");
                        }
                        vm.emProgresso = false;
                    }
                });
            }, function (error) {
                ServicosGenericoService.tratarErroAPI(error);
                vm.emProgresso = false;
            });
        }

        function _controlaTelaPorTipoArquivo() {
            desabilitaTodasOpcoesFormulario();
            vm.lfApi.removeAll();
            if (!vm.codigoLeiturista)
                return;

            if (typeof vm.codigoLeiturista != 'number')
                vm.codigoLeiturista = parseInt(vm.codigoLeiturista);

            ValidacaoService.validarParametroNumber(vm.codigoLeiturista);

            var leiturista = LeituristaUtilsService.retornarLeituristaPorCodigo(vm.leituristas, vm.codigoLeiturista);

            if (!leiturista)
                return;

            switch (leiturista.inT_LeituristaConfiguracao.arqCodigo) {
                case 1: {
                    habilitarGrupoGradeMesAno();
                    break;
                }
                case 3: {
                    habilitarGrupoRota();
                    break;
                }
                case 11: {
                    habilitarGrupoDataAreaOrigem();
                    break;
                }
                case 12: {
                    habilitarGrupoLocalidadeRotas();
                    break;
                }
                case 14: {
                    habilitarSetorRotaMes();
                    break;
                }
                case 17: {
                    habilitarSetorRotaMesAno();
                    break;
                }
                case 22: {
                    habilitarLocalidadeRotaSequencia();
                    break;
                }
                default: {
                    habilitarGrupoDataOrigem();
                    break;
                }
            }
        }

        function habilitarGrupoDataOrigem() {
            vm.controleTela.pnlOrigem = true;
        }

        function habilitarSetorRotaMes() {
            vm.controleTela.pnlPocosCaldas = true;
        }

        function habilitarGrupoLocalidadeRotas() {
            vm.controleTela.pnlLocalidade = true;
        }

        function habilitarGrupoDataAreaOrigem() {
            vm.controleTela.pnlArea = true;
        }

        function habilitarGrupoRota() {
            vm.controleTela.pnlRota = true;
        }

        function habilitarGrupoGradeMesAno() {
            vm.controleTela.pnlGrade = true;
        }

        function habilitaRepasse() {
            vm.controleTela.chkProcedimentoRepasse = true;
        }

        function habilitarGrupoDataProximaLeitura() {
            vm.controleTela.dtProximaLeitura = true;
        }

        function habilitarCondicaoImprimeAvisoCorte() {
            vm.controleTela.chkImprimeAvisoCorte = true;
        }

        function habilitarGrupoExportaçãoDistribuicao() {
            vm.controleTela.pnlDistribuicao = true;
        }

        function habilitarLocalidadeRotaSequencia() {
            vm.controleTela.localidadeRotaSequencia = true;
        }

        function habilitarSetorRotaMesAno() {
            vm.controleTela.setorRotaMesAno = true;
        }

        function habilitaDesabilitaCampos() {
            desabilitaTodasOpcoesFormulario();
            if (vm.parametro.tipoProcesso == "02") {
                habilitarGrupoExportaçãoDistribuicao();
                if (vm.parametro.coletor.utilizaRotinaRepasse == "S") {
                    habilitaRepasse();
                }
            }

            if (vm.parametro.fixaProximaLeitura == "S") {
                habilitarGrupoDataProximaLeitura();
            }

            RequisicaoGenericaService.listarSemParams(
                Api.exportacao.existeStringParametrizacao + "MENSAGEM_COMUNICADO_DEBITO_AVISO_DEBITO").then(
                    function (success) {
                        if (success.data) {
                            vm.parametrosExportacao.imprimeAvisoCorte = "S";
                            habilitarCondicaoImprimeAvisoCorte();
                        }
                    },
                    function (error) {
                    }
                );
        }

        function desabilitaTodasOpcoesFormulario() {
            vm.controleTela.pnlPocosCaldas = false;
            vm.controleTela.pnlDistribuicao = false;
            vm.controleTela.pnlOrigem = false;
            vm.controleTela.pnlHoraMinuto = false;
            vm.controleTela.pnlGrade = false;
            vm.controleTela.pnlRota = false;
            vm.controleTela.pnlLocalidade = false;
            vm.controleTela.pnlArea = false;
            vm.controleTela.localidadeRotaSequencia = false;
            vm.controleTela.setorRotaMesAno = false;

            var _imprimeAvisoCorte = vm.controleTela.chkImprimeAvisoCorte ? "S" : "N";

            vm.parametrosExportacao = {

                imprimeAvisoCorte: _imprimeAvisoCorte
            };
        }

        function _validarArquivoJaImportado(leituristaCodigo, nomeArquivo) {
            var promessaValidarArquivoImportado = RequisicaoGenericaService.listarSemParams(
                Api.leiturista.verificarArquivoImportado + leituristaCodigo + '/' + nomeArquivo);

            promessaValidarArquivoImportado.then(function (success) {
                var validacao = success.data;
                var leiturista = vm.leituristas.filter(function (item) {
                    if (item.codigo == leituristaCodigo) {
                        return item;
                    }

                });
                if (validacao != "") {
                    MdDialogService.confirmPadraoComEvento("Atenção", validacao, vm.event,
                        function () {
                            _importarDadosArquivo(leiturista[0].inT_LeituristaConfiguracao.arqCodigo);
                        },
                        function () {
                            vm.emProgresso = false;
                        });
                }
                else {
                    _importarDadosArquivo(leiturista[0].inT_LeituristaConfiguracao.arqCodigo);
                }
            }, function (error) {
                ServicosGenericoService.tratarErroAPI(error);
                vm.emProgresso = false;
            });
        }

        function _importarDadosArquivo(arquivoCodigo) {
            var arquivo = arquivoCodigo

            var dados =
            {
                parametros: {
                    tipoCalculo: arquivo,
                    empresaCodigo: vm.parametro.empresa.codigoImanager,
                    utilizaAuditoriaExportacaoCreditoDebito: vm.parametro.utilizaAuditoriaExportacaoCreditoDebito
                },
                arquivo: vm.arquivos[0]
            };

            var promessaUpload = RequisicaoGenericaService.validarArquivos(dados, Api.arquivo.validar);

            promessaUpload.then(function (success) {
                var arquivo = success.data;

                if (arquivo.informacoesConsumoCreditoDebito.length > 0) {
                    vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
                    vm.dados = arquivo.informacoesConsumoCreditoDebito;
                    $mdDialog.show({
                        controller: 'RelatorioImportacaoController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/processamento/exportacao-mobile/dialogs/relatorio-dialog/views/relatorio-dialog.html',
                        targetEvent: null,
                        clickOutsideToClose: false,
                        fullscreen: false,
                        locals: {
                            Relatorio: {
                                dadosRelatorio: arquivo.informacoesConsumoCreditoDebito,
                                nomeEmpresa: vm.parametro.empresa.nomeEmpresa,
                                marcaEspecial: null,
                                logomarca: null
                            }
                        }
                    })
                        .then(function () {
                            _chamarExportacao(arquivo);
                        }, function () {
                            vm.emProgresso = false;
                        });
                }
                else {
                    _chamarExportacao(arquivo);
                }
            }, function (error) {
                ServicosGenericoService.tratarErroAPI(error);
                vm.emProgresso = false;
            });
        }

        function _disponibilizarCarga() {
            if (!vm.codigoLeiturista) {
                MdDialogService.alertPadrao("Selecione um leiturista!");
                return;
            }

            if (!vm.arquivos || vm.arquivos.length === 0) {
                MdDialogService.alertPadrao("Selecione um arquivo!");
                return;
            }

            vm.emProgresso = true;

            var dialogConfig = {
                title: 'Aguarde... Realizando disponibilização de carga.',
                body: '',
                progress: ''
            };
            MdDialogService.abrirDialogProcessamento(dialogConfig);

            var arquivo = vm.arquivos[0];
            var reader = new FileReader();

            reader.onload = function (e) {
                var arquivoBase64 = Base64Service.converterArquivosGrandesParaBase64(e.target.result);

                var dados = {
                    nomeArquivo: arquivo.lfFileName,
                    codigoLeiturista: vm.codigoLeiturista,
                    arquivoBase64: arquivoBase64
                };

                RequisicaoGenericaService.salvar(Api.exportacao.exportacaoCargaThema, dados).then(
                    function (success) {
                        vm.emProgresso = false;
                        MdDialogService.fecharDialogProcessamento();
                        MdDialogService.alertPadrao("Carga disponibilizada com sucesso!");
                        vm.lfApi.removeAll();
                    },
                    function (error) {
                        vm.emProgresso = false;
                        MdDialogService.fecharDialogProcessamento();
                        ServicosGenericoService.tratarErroAPI(error);
                    }
                );
            };

            reader.onerror = function () {
                vm.emProgresso = false;
                MdDialogService.fecharDialogProcessamento();
                MdDialogService.alertPadrao("Erro ao ler o arquivo!");
            };

            reader.readAsArrayBuffer(arquivo.lfFile);
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select')
                .on('keydown', function (ev) {
                    ev.stopPropagation();
                });
        }

        function fecharDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.exclusaoarquivo')
        .controller('ExclusaoArquivoController', ExclusaoArquivoController)

    /** @ngInject */
    function ExclusaoArquivoController(SessionStorageService, KeysSessionStorage, MdDialogService, ExclusaoArquivoService, $mdDialog, $rootScope) {
        var vm = this;

        vm.metodos = {
            filtrarArquivos: filtrarArquivos,
            selecionarTodosArquivos: selecionarTodosArquivos,
            existemArquivosMarcados: existemArquivosMarcados,
            excluirArquivosSelecionados: excluirArquivosSelecionados,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            pesquisarMunicipios: pesquisarMunicipios
        }

        init();

        function init() {
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            var data = new Date();
            vm.filtros = {
                mes: data.getMonth() + 1,
                ano: data.getFullYear()
            }

            vm.arquivos = [];

            vm.emProgresso = false;

            vm.progressoSplash = {
                tituloSplash: '',
                mensagemSplash: ''
            }

            $rootScope.scrollButtonContainerLocal = "md-content#content";
            $rootScope.utilizaBotaoScroll = true;
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";

            angular.element('#md-select-municipio md-content').animate({ scrollTop: 0 });

            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function pesquisarMunicipios(regional) {
            if (vm.parametros.calculo.tipoDetalheCalculo == 88) {
                vm.filtros.municipio = undefined;
                ExclusaoArquivoService.filtrarMunicipios(regional).then(
                    function (success) {
                        vm.municipios = success.data;
                    },
                    function (error) {
                        console.log(error.data);
                    }
                );
            }
        }

        function filtrarArquivos() {
            vm.arquivos = [];
            _iniciarProgresso("Aguarde...", "Filtrando dados dos arquivos.");

            var inputModel = {
                mes: vm.filtros.mes.toString().padStart(2, '0'),
                ano: vm.filtros.ano,
                regional: vm.filtros.regionalCodigo,
                municipio: vm.filtros.municipio
            }

            ExclusaoArquivoService.filtrarArquivos(inputModel)
                .then(function (success) {
                    vm.arquivos = success.data.map(function (arquivo) {
                        return {
                            nome: arquivo,
                            selecionado: false
                        };
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }


        function selecionarTodosArquivos() {
            if (_todosArquivosMarcados()) {
                vm.arquivos.forEach(function (item) {
                    item.selecionado = false;
                });
            } else {
                vm.arquivos.forEach(function (item) {
                    item.selecionado = true;
                });
            }
        }

        function existemArquivosMarcados() {
            return vm.arquivos.some(function (item) {
                return item.selecionado;
            });
        }

        function excluirArquivosSelecionados() {
            var arquivosSelecionados = vm.arquivos.filter(function (arquivo) {
                return arquivo.selecionado;
            });

            var inputModel = arquivosSelecionados.map(function (arquivo) {
                return arquivo.nome;
            });

            $mdDialog.show({
                controller: 'DialogSenhaImplantacaoController',
                controllerAs: 'vm',
                templateUrl: 'app/compartilhado/dialog-senha-implantacao/views/dialog-senha-implantacao.html',
                targetEvent: null,
                multiple: true,
            }).then(
                function (senha) {
                    _iniciarProgresso("Aguarde...", "Validando os arquivos.");
                    ExclusaoArquivoService.validarArquivo(inputModel)
                        .then(
                            function (success) {
                                var existeLeituras = success.data.some(function (item) { return item.existeLeitura; });

                                if (!existeLeituras) {
                                    _iniciarProgresso("Aguarde...", "Excluindo os arquivos.");
                                    ExclusaoArquivoService.excluirArquivo(inputModel, senha)
                                        .then(function (res) {
                                            MdDialogService.alertPadraoComEvento("Arquivos excluídos com sucesso.", filtrarArquivos, null, null);
                                        }, function (err) {
                                            MdDialogService.alertPadrao(err.data);
                                        }).finally(function () {
                                            vm.emProgresso = false;
                                        });
                                } else {
                                    vm.emProgresso = false;
                                    var arquivosComLeitura = success.data.map(function (arquivo) {
                                        if (arquivo.existeLeitura) return arquivo;
                                    });

                                    $mdDialog.show({
                                        controller: 'DialogConfirmacaoExclusaoController',
                                        controllerAs: 'vm',
                                        templateUrl: 'app/main/processamento/exclusao-arquivo/dialogs/dialog-confirmacao-exclusao/views/dialog-confirmacao-exclusao.html',
                                        targetEvent: null,
                                        multiple: true,
                                        clickOutsideToClose: false,
                                        locals: {
                                            Arquivos: arquivosComLeitura
                                        }
                                    }).then(
                                        function (resultado) {
                                            if (resultado) {
                                                _iniciarProgresso("Aguarde...", "Excluindo os arquivos.");
                                                ExclusaoArquivoService.excluirArquivo(inputModel, senha)
                                                    .then(function (res) {
                                                        MdDialogService.alertPadraoComEvento("Arquivos excluídos com sucesso.", filtrarArquivos, null, null);
                                                    }, function (err) {
                                                        MdDialogService.alertPadrao(err.data);
                                                    }).finally(function () {
                                                        vm.emProgresso = false;
                                                    });
                                            }
                                        });
                                }
                            }, function (error) {
                                MdDialogService.alertPadrao(error.data);
                            });

                }
            );

        }

        function _todosArquivosMarcados() {
            return vm.arquivos.every(function (item) {
                return item.selecionado;
            });
        }

        function _iniciarProgresso(titulo, mensagem) {
            vm.emProgresso = true;

            vm.progressoSplash = {
                tituloSplash: titulo,
                mensagemSplash: mensagem
            };
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('app.processamento.exportacaogrupoleitura', [])
        .config(Config);

    function Config(RotasHtml, $stateProvider) {
        var rotasHtml = RotasHtml.exportacaoGrupoLeitura;

        $stateProvider
            .state('app.exportacao_grupo_leitura', {
                url: '/processamento/exportacaogrupoleitura',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ExportacaoGrupoLeituraController as vm',
                        abstract: true
                    },
                    'exportacaogrupoleitura-form@app.exportacao_grupo_leitura': {
                        templateUrl: rotasHtml.form,
                    },
                    'exportacaogrupoleitura-caema-form@app.exportacao_grupo_leitura': {
                        templateUrl: rotasHtml.caema.form,
                    },
                    'exportacaogrupoleitura-bauru-form@app.exportacao_grupo_leitura': {
                        templateUrl: rotasHtml.bauru.form,
                    },
                    'exportacaogrupoleitura-fiorilli-form@app.exportacao_grupo_leitura': {
                        templateUrl: rotasHtml.fiorilli.form,
                    },
                },
                resolve: {
                    Grupo: function () { return null }
                }
            });
    }

}());
(function () {
  "use strict";

  angular
    .module("app.processamento.exportacaogrupoleitura")
    .controller(
      "ExportacaoGrupoLeituraController",
      ExportacaoGrupoLeituraController
    );

  /** @ngInject */
  function ExportacaoGrupoLeituraController(
    RequisicaoGenericaService,
    Api,
    MdDialogService,
    ArquivosService,
    $mdDialog,
    Grupo,
    SessionStorageService,
    ControleAcessoConfig,
    KeysSessionStorage,
    urlApi
  ) {
    var vm = this;

    vm.grupos = undefined;
    vm.modoImplantacaoAtivo = SessionStorageService.recuperar(
      ControleAcessoConfig.key_modo_implantacao
    );
    vm.labelBotaoGerar = 'Gerar';
    vm.tiposExportacao = [
      { chave: 1, valor: "API" },
      { chave: 2, valor: "Arquivo" },
    ];
    vm.filtrarLeituristas = "";
    vm.todosLeituristas = false;
    vm.leituristas = [];
    var data = new Date();
    vm.entidade = {
      mes: data.getMonth() + 1,
      ano: data.getFullYear(),
      gerarArquivoSomenteLeiturasEfetuadas: true,
    };

    vm.metodos = {
      pesquisarGrupos: pesquisarGrupos,
      configuraMdSelectGrupo: configuraMdSelectGrupo,
      configuraMdSelectLeiturista: configuraMdSelectLeiturista,
      gerarArquivoExportacaoGrupo: gerarArquivoExportacaoGrupo,
      fecharDialog: fecharDialog,
      configuraMdSelectRegional: configuraMdSelectRegional,
      pesquisarMunicipiosPorRegional: pesquisarMunicipiosPorRegional,
      configuraMdSelectMunicipio: configuraMdSelectMunicipio,
      buscarSequencialControleEnvio: buscarSequencialControleEnvio,
      pesquisarRotasParaExportacao: pesquisarRotasParaExportacao,
      configuraMdSelectRota: configuraMdSelectRota,
      onChangeTipoExportacao: onChangeTipoExportacao,
      onChangeLeituristas: onChangeLeituristas,
      limparTermoPesquisado: limparTermoPesquisado,
      limparSelecao: limparSelecao,
      pesquisarLeituristas: pesquisarLeituristas,
    };

    init();

    function init() {
      if (Grupo) {
        vm.grupo = Grupo;
        vm.entidade.ano = vm.grupo.referencia.substring(3, 8);
        vm.entidade.mes = vm.grupo.referencia.substring(0, 2);
        vm.entidade.grupo = vm.grupo.grupo.padStart(4, "0");
        vm.tituloHeader = 'Exportação do grupo de leitura';


        if (vm.grupo.regional) {
          vm.entidade.regional = vm.grupo.regional;
        }
        if (vm.grupo.municipio) {
          vm.entidade.municipio = vm.grupo.municipio;
        }
      }

      //pesquisarGrupos();
      vm.parametros = SessionStorageService.recuperar(
        KeysSessionStorage.parametrosEmpresa
      );

      vm.sistemaGestorEhFiorilli = vm.parametros.coletor.sistemaGestor == 2;
      vm.tipoProcesso = vm.parametros.tipoProcesso;
      vm.codigoCliente = vm.parametros.empresa.codigoImanager;
      vm.parametroUtilizaExportacaoPorLeiturista = vm.parametros.utilizaExportacaoPorLeiturista;
      vm.entidade.gerarArquivoZip =
        vm.parametros.empresa.codigoImanager == "1102";
      if (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1) {
        vm.tituloHeader = 'Exportação de carga';
      }
      if (vm.parametros.utilizaCadastroRegional) {
        _pesquisarRegionais();
      } else {
        pesquisarGrupos("", vm.entidade.mes, vm.entidade.ano);
      }

      if (!vm.sistemaGestorEhFiorilli || !vm.modoImplantacaoAtivo) {
        vm.entidade.tipoExportacao = 1;
      }


      _configurarLabelBotaoGerar();
    }

    function configuraMdSelectGrupo() {
      vm.filtrarGrupos = "";
      angular.element("#select-grupo").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }
    function configuraMdSelectLeiturista() {
      vm.filtrarLeituristas = "";
      angular.element("#select-leituristas").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }
    function configuraMdSelectRota() {
      vm.filtrarRota = "";
      angular.element("#select-rota").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }

    // function pesquisarGrupos(){

    //     if(!_validarFiltroGrupos()){
    //         return;
    //     }

    //      vm.entidade.mes = vm.entidade.mes.toString().padStart(2,'0');
    //      vm.entidade.grupo = undefined;
    //      RequisicaoGenericaService.listarSemParams(Api.distribuicao.retornarGruposLeitura + vm.entidade.mes + '/' + vm.entidade.ano).then(
    //          function(success){
    //              vm.emProgressoBuscaGrupo = false;
    //              vm.grupos = success.data.map(function(item){
    //                  return item.grupo
    //              });

    //              if(vm.grupo){
    //                  vm.grupos.forEach(function(item){
    //                      if(item == vm.grupo.grupo){
    //                          vm.entidade.grupo = item;
    //                      }
    //                  });
    //              };

    //          },
    //          function(error){
    //              vm.emProgressoBuscaGrupo = false;
    //              console.log(error.data);
    //          }
    //      )
    //  }

    function _validarFiltroGrupos() {
      if (vm.entidade.mes == undefined || vm.entidade.ano == undefined) {
        vm.grupos = [];
        return false;
      }

      if (vm.entidade.mes > 12 || vm.entidade.mes < 1) {
        return false;
      }

      return true;
    }

    function configuraMdSelectMunicipio() {
      vm.filtrarMunicipios = "";
      angular.element("#select-municipio").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }

    function gerarArquivoExportacaoGrupo(filtro) {
      if (vm.codigoCliente === "0070")
        return executarGeracaoArquivoBauru(filtro);
      else {
        _iniciarProgresso(_retornarMensagemAguarde());
        if (vm.parametros.impressao.utilizaRotinaCriticaLeituras) {
          var promessa = RequisicaoGenericaService.salvar(
            Api.exportacaoGrupoLeitura.verificarRetencoesPendentes,
            filtro
          );
          promessa.then(
            function (success) {
              executarGeracaoArquivo(filtro);
            },
            function (error) {
              if (error.status == 409) {
                MdDialogService.confirmPadraoComEvento(
                  "Atenção",
                  error.data,
                  event,
                  function () {
                    executarGeracaoArquivo(filtro);
                  },
                  function () {
                    _finalizarProgresso();
                    return;
                  }
                );
              } else {
                MdDialogService.alertPadrao(error.data);
                return false;
              }
            }
          );
        } else {
          executarGeracaoArquivo(filtro);
        }
      }
    }

    function validarFiltroExportacao(filtro) {
      if (filtro) {
        if (filtro.mes > 12 || filtro.mes < 1) return false;
        if (filtro.mes == undefined || filtro.ano == undefined) return false;
        if (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1) {
          return true;
        }
        if (filtro.grupo == undefined) return false;
        return true;
      }
    }

    function pesquisarLeituristas(mes, ano) {
      if (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1) {
        vm.buscandoLeituristas = true;
        var filtro = {
          mes: mes,
          ano: ano
        };
        RequisicaoGenericaService.listarComParams(Api.exportacao.listarLeituristasFiorilli, filtro).then(function (success) {
          vm.leituristas = success.data;
          if (vm.leituristas.length > 0) {
            vm.leituristas.map(function (leiturista) { leiturista.apelidoExibicao = leiturista.codigo + ' - ' + leiturista.nome; });
            vm.todosLeituristas = true;
          }
          vm.buscandoLeituristas = false;
        });
      }
    }


    function fecharDialog() {
      $mdDialog.hide();
    }

    function _iniciarProgresso(mensagem) {
      vm.emProgresso = true;
      vm.mensagemCarregamento = mensagem;
    }
    function _finalizarProgresso() {
      vm.emProgresso = false;
    }

    function executarGeracaoArquivoBauru(filtro) {
      if (filtro.dataExportacao !== undefined) {
        filtro.enviarFTP = true;
        _iniciarProgresso(_retornarMensagemAguarde());
        RequisicaoGenericaService.salvar(
          Api.exportacaoGrupoLeitura.gerarExportacaoGrupo,
          filtro
        ).then(
          function (success) {
            _finalizarProgresso();

            if (success.data.arquivos) {
              if (filtro.gerarArquivoZip) {
                window.open(
                  urlApi.url_base_api +
                  "cdn/retorno/" +
                  success.data.arquivos[0]
                );
              } else {
                return ArquivosService.baixarArquivo(
                  Api.geracaoArquivoRetorno.abrirArquivo,
                  success.data.arquivos[0]
                );
              }
            } else {
              MdDialogService.alertPadrao(success.data, null, null);
            }
          },
          function (error) {
            _finalizarProgresso();
            if (error.data.mensagemErro) {
              if (error.data.tipoErro == 2) {
                if (error.data.nomeArquivos.length > 0) {
                  MdDialogService.confirmPadraoComEvento(
                    "Atenção",
                    "Ocorreu uma falha na conexão com o FTP. Deseja realizar o download dos arquivos?",
                    null,
                    function () {
                      _downloadArquivoFTPLocal(
                        error.data.nomeArquivos,
                        filtro.gerarArquivoZip
                      );
                    },
                    null
                  );
                } else {
                  MdDialogService.alertPadrao(
                    "Atenção",
                    null,
                    error.data.mensagemErro
                  );
                }
              } else {
                MdDialogService.alertPadrao(
                  "Atenção",
                  null,
                  error.data.mensagemErro
                );
              }
            } else if (error.data.inconsistencias) {
              MdDialogService.alertPadrao(
                "Não foi possível exportar o grupo. Detalhes: ",
                null,
                error.data.inconsistencias
              );
            } else {
              MdDialogService.alertPadrao("Atenção", null, error.data);
            }
          }
        );
      }
    }

    function gerarExportacaoCargaFiorilli(filtro) {
      var leituristasSelecionados = (filtro.leituristas && filtro.leituristas.length > 0)
        ? filtro.leituristas.map(function (l) { return typeof l === 'object' ? l.codigo : l; })
        : vm.leituristas.map(function (l) { return l.codigo; });

      var filtroCopia = {
        mes: filtro.mes,
        ano: filtro.ano,
        gerarArquivoSomenteLeiturasEfetuadas: filtro.gerarArquivoSomenteLeiturasEfetuadas,
        gerarArquivoZip: filtro.gerarArquivoZip,
        tipoExportacao: filtro.tipoExportacao,
        leituristas: leituristasSelecionados
      };
      RequisicaoGenericaService.salvar(
        Api.exportacao.exportacaoCargaFiorilli,
        filtroCopia
      ).then(
        function (success) {
          _finalizarProgresso();
          MdDialogService.alertPadrao(
            "Exportação de carga de leituras realizada com sucesso!"
          );
          if (vm.entidade.tipoExportacao == 2) {
            return ArquivosService.baixarArquivoBytes(success.data.bytesArquivo, success.data.arquivos[0], success.data.tipoArquivo);
          } else {
            return;
          }
        },
        function (error) {
          _finalizarProgresso();
          if (error.data.inconsistencias) {
            MdDialogService.alertPadrao(
              "Não foi possível exportar a carga. Detalhes: ",
              null,
              error.data.inconsistencias
            );
          } else {
            if (error.data.mensagemErro) {
              if (error.data.tipoErro == 2) {
                if (error.data.nomeArquivos.length > 0) {
                  MdDialogService.confirmPadraoComEvento(
                    "Atenção",
                    "Ocorreu uma falha na conexão com o FTP. Deseja realizar o download dos arquivos?",
                    null,
                    function () {
                      _downloadArquivoFTPLocal(
                        error.data.nomeArquivos
                      );
                    },
                    null
                  );
                } else {
                  MdDialogService.alertPadrao(
                    "Atenção",
                    null,
                    error.data.mensagemErro
                  );
                }
              } else {
                MdDialogService.alertPadrao(
                  "Atenção",
                  null,
                  error.data.mensagemErro
                );
              }
            } else {
              MdDialogService.alertPadrao(
                "Atenção",
                null,
                error.data
              );
            }
          }
        }
      );
    }

    function executarGeracaoArquivo(filtro) {
      _verificarSetorRotaNoFiltro(filtro);
      if (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1) {
        gerarExportacaoCargaFiorilli(filtro);
        return;
      }

      if (validarFiltroExportacao(filtro)) {
        RequisicaoGenericaService.salvar(
          Api.exportacaoGrupoLeitura.validarExportacaoGrupo,
          filtro
        ).then(
          function (success) {
            if (success.data) {
              _finalizarProgresso();
              MdDialogService.confirmPadraoComEvento(
                "Atenção",
                success.data,
                event,
                function () {
                  _iniciarProgresso(_retornarMensagemAguarde());
                  if (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1) {
                    var leituristasSelecionados = (filtro.leituristas && filtro.leituristas.length > 0)
                      ? filtro.leituristas
                      : vm.leituristas.map(function (l) { return l.codigo; });

                    filtro.leituristas = leituristasSelecionados;
                    delete filtro.grupo;
                  }
                  RequisicaoGenericaService.salvar(
                    Api.exportacaoGrupoLeitura.gerarExportacaoGrupo,
                    filtro
                  ).then(
                    function (success) {
                      _finalizarProgresso();
                      if (vm.sistemaGestorEhFiorilli) {
                        if (vm.tipoProcesso == 1) {
                          MdDialogService.alertPadrao(
                            "Exportação de carga de leituras realizada com sucesso!"
                          );
                        } else {
                          MdDialogService.alertPadrao(
                            "Exportação do grupo de leituras realizada com sucesso!"
                          );
                        }
                        if (vm.entidade.tipoExportacao == 2) {
                          return ArquivosService.baixarArquivoBytes(success.data.bytesArquivo, success.data.arquivos[0], success.data.tipoArquivo);
                        } else {
                          return;
                        }
                      }

                      if (
                        vm.parametros.calculo.tipoDetalheCalculo === 89 ||
                        vm.parametros.calculo.tipoDetalheCalculo === 88
                      ) {
                        if (vm.parametros.utilizaImportacaoLeituraViaFtp) {
                          if (success.data.inconsistencias) {
                            var titulo =
                              "Exportação realizada com alguma(s) inconsistência(s), os arquivos foram enviados para o FTP configurado!";
                            var detalhes = success.data.inconsistencias;
                            MdDialogService.alertPadrao(
                              titulo,
                              event,
                              detalhes
                            );
                            return;
                          } else {
                            MdDialogService.alertPadrao(
                              "Exportação realizada com sucesso, os arquivos foram enviados para o FTP configurado!"
                            );
                            return;
                          }
                        } else {
                          _downloadArquivosMultiplos(success.data.arquivos);
                        }
                        return;
                      }

                      if (filtro.gerarArquivoZip) {
                        window.open(
                          urlApi.url_base_api +
                          "cdn/retorno/" +
                          success.data.arquivos[0]
                        );
                      } else {
                        return ArquivosService.baixarArquivo(
                          Api.geracaoArquivoRetorno.abrirArquivo,
                          success.data.arquivos[0]
                        );
                      }
                    },
                    function (error) {
                      _finalizarProgresso();
                      if (error.data.inconsistencias) {
                        MdDialogService.alertPadrao(
                          "Não foi possível exportar o grupo. Detalhes: ",
                          null,
                          error.data.inconsistencias
                        );
                      } else {
                        if (error.data.mensagemErro) {
                          if (error.data.tipoErro == 2) {
                            if (error.data.nomeArquivos.length > 0) {
                              MdDialogService.confirmPadraoComEvento(
                                "Atenção",
                                "Ocorreu uma falha na conexão com o FTP. Deseja realizar o download dos arquivos?",
                                null,
                                function () {
                                  _downloadArquivoFTPLocal(
                                    error.data.nomeArquivos
                                  );
                                },
                                null
                              );
                            } else {
                              MdDialogService.alertPadrao(
                                "Atenção",
                                null,
                                error.data.mensagemErro
                              );
                            }
                          } else {
                            MdDialogService.alertPadrao(
                              "Atenção",
                              null,
                              error.data.mensagemErro
                            );
                          }
                        } else {
                          MdDialogService.alertPadrao(
                            "Atenção",
                            null,
                            error.data
                          );
                        }
                      }
                    }
                  );
                },
                function () {
                  _finalizarProgresso();
                  MdDialogService.alertPadrao(
                    "Atenção",
                    null,
                    "Exportação do grupo de leitura informado não foi realizada!"
                  );
                }
              );
            } else {
              RequisicaoGenericaService.salvar(
                Api.exportacaoGrupoLeitura.gerarExportacaoGrupo,
                filtro
              ).then(
                function (success) {
                  _finalizarProgresso();

                  if (vm.sistemaGestorEhFiorilli) {
                    MdDialogService.alertPadrao(
                      "Exportação do grupo de leituras realizada com sucesso!"
                    );
                    if (vm.entidade.tipoExportacao == 2) {
                      return ArquivosService.baixarArquivoBytes(success.data.bytesArquivo, success.data.arquivos[0], success.data.tipoArquivo);
                    } else {
                      return;
                    }
                  }

                  if (
                    vm.parametros.calculo.tipoDetalheCalculo === 89 ||
                    vm.parametros.calculo.tipoDetalheCalculo === 88
                  ) {
                    if (vm.parametros.utilizaImportacaoLeituraViaFtp) {
                      if (success.data.inconsistencias) {
                        var titulo =
                          "Exportação realizada com alguma(s) inconsistencia(s), os arquivos foram enviados para o FTP configurado!";
                        var detalhes =
                          "Detalhes: <br> " + success.data.inconsistencias;
                        MdDialogService.alertPadrao(titulo, event, detalhes);
                        return;
                      } else {
                        MdDialogService.alertPadrao(
                          "Exportação realizada com sucesso!",
                          null,
                          "Os arquivos gerados foram enviados para o FTP configurado!"
                        );
                        return;
                      }
                    } else {
                      _downloadArquivosMultiplos(success.data.arquivos);
                    }
                    return;
                  }

                  if (filtro.gerarArquivoZip) {
                    window.open(
                      urlApi.url_base_api +
                      "cdn/retorno/" +
                      success.data.arquivos[0]
                    );
                  } else {
                    return ArquivosService.baixarArquivo(
                      Api.geracaoArquivoRetorno.abrirArquivo,
                      success.data.arquivos[0]
                    );
                  }
                },
                function (error) {
                  _finalizarProgresso();
                  if (error.data.inconsistencias) {
                    MdDialogService.alertPadrao(
                      "Não foi possível exportar o grupo. Detalhes: ",
                      null,
                      error.data.inconsistencias
                    );
                  } else {
                    if (error.data.mensagemErro) {
                      if (error.data.tipoErro == 2) {
                        if (error.data.nomeArquivos.length > 0) {
                          MdDialogService.confirmPadraoComEvento(
                            "Atenção",
                            "Ocorreu uma falha na conexão com o FTP. Deseja realizar o download dos arquivos?",
                            null,
                            function () {
                              _downloadArquivoFTPLocal(error.data.nomeArquivos);
                            },
                            null
                          );
                        } else {
                          MdDialogService.alertPadrao(
                            "Atenção",
                            null,
                            error.data.mensagemErro
                          );
                        }
                      } else {
                        MdDialogService.alertPadrao(
                          "Atenção",
                          null,
                          error.data.mensagemErro
                        );
                      }
                    } else {
                      MdDialogService.alertPadrao("Atenção", null, error.data);
                    }
                  }
                }
              );
            }
          },
          function (error) {
            _finalizarProgresso();
            MdDialogService.alertPadrao("Atenção", null, error.data);
          }
        );
      }
    }

    function _pesquisarRegionais() {
      vm.regional = undefined;
      vm.emProgressoBuscaRegional = true;
      vm.regionais = SessionStorageService.recuperar(
        KeysSessionStorage.usuarioAgrupamentos
      );
      vm.emProgressoBuscaRegional = false;
      if (vm.grupo && vm.grupo.grupo) {
        vm.parametros.calculo.tipoDetalheCalculo === 89
          ? (vm.entidade.grupo = vm.grupo.grupo)
          : (vm.entidade.grupo = vm.grupo.grupo.padStart(4, "0"));

        pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano);
      }
    }

    function configuraMdSelectRegional() {
      vm.filtrarRegionais = "";
      angular.element("#select-regional").on("keydown", function (ev) {
        ev.stopPropagation();
      });
    }

    function pesquisarGrupos(regional, mes, ano) {
      if (!mes) return;
      mes = mes.toString().padStart(2, "0");
      if (!Grupo) {
        vm.entidade.grupo = undefined;
      }
      vm.municipios = [];
      vm.emProgressoBuscaGrupo = true;
      pesquisarLeituristas(mes, ano);
      RequisicaoGenericaService.listarSemParams(
        Api.agrupamento.listarGruposPorAgrupamento +
        "?agrupamento=" +
        regional +
        "&mes=" +
        mes +
        "&ano=" +
        ano
      ).then(
        function (success) {
          vm.emProgressoBuscaGrupo = false;
          vm.grupos = success.data.map(function (item) {
            return item;
          });
          if (vm.sistemaGestorEhFiorilli && vm.grupos.length) vm.entidade.grupo = vm.grupos[0];
          if (vm.parametroUtilizaExportacaoPorLeiturista) _pesquisarLeituristas(mes, ano);
        },
        function (error) {
          vm.emProgressoBuscaGrupo = false;
        }
      );
    }

    function _pesquisarLeituristas(mes, ano) {
      vm.leituristas = [];
      vm.emProgresso = true;

      RequisicaoGenericaService.listarSemParams(
        Api.exportacaoGrupoLeitura.listarLeituristas +
        "?mes=" +
        mes +
        "&ano=" +
        ano
      ).then(
        function (success) {
          vm.emProgresso = false;
          vm.leituristas = success.data;
          if (vm.leituristas.length > 0) {
            vm.leituristas.map(function (leiturista) { leiturista.apelidoExibicao = leiturista.codigo + ' - ' + leiturista.nome; });
            vm.todosLeituristas = true;
          }
        },
        function (error) {
          vm.emProgresso = false;
        }
      );
    }

    function pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
      mes = mes.toString().padStart(2, "0");
      vm.entidade.municipio = undefined;
      vm.emProgressoBuscaMunicipio = true;
      RequisicaoGenericaService.listarSemParams(
        Api.regional.listarMunicipiosPorRegional +
        "?regional=" +
        regional +
        "&mes=" +
        mes +
        "&ano=" +
        ano +
        "&grupo=" +
        grupo
      ).then(
        function (success) {
          vm.emProgressoBuscaMunicipio = false;
          vm.municipios = success.data.map(function (item) {
            return item;
          });
        },
        function (error) {
          vm.emProgressoBuscaMunicipio = false;
        }
      );
    }

    function buscarSequencialControleEnvio(regional, mes, ano, grupo) {
      vm.entidade.numeroSequencialGeracaoArquivo = null;
      if (vm.entidade.tipoExportacao !== 2) {
        return;
      }
      var viewModel = {
        mes: mes,
        ano: ano,
        grupo: grupo,
        regional: regional,
      };
      var promisse = RequisicaoGenericaService.salvar(
        Api.exportacaoGrupoLeitura.buscarSequencialControleEnvio,
        viewModel
      );

      promisse.then(
        function (success) {
          vm.sequenciais = success.data;
        },
        function (err) {
          console.error(err);
        }
      );
    }

    function _downloadArquivosMultiplos(arquivos) {
      if (arquivos.length) {
        arquivos.forEach(function (arquivo) {
          ArquivosService.baixarArquivo(
            Api.geracaoArquivoRetorno.abrirArquivo,
            arquivo
          );
        });
        return;
      }
    }

    function _verificarSetorRotaNoFiltro(filtro) {
      if (filtro.setor && filtro.rota) {
        filtro.setor = parseInt(filtro.setor);
        filtro.rota = parseInt(filtro.rota);
      }
    }

    function pesquisarRotasParaExportacao(filtro) {
      var promisse = RequisicaoGenericaService.salvar(
        Api.exportacaoGrupoLeitura.retornarRotasDisponiveisExportacao,
        filtro
      );
      promisse.then(function (success) {
        vm.rotas = success.data;
      });
    }

    function onChangeTipoExportacao(tipoExportacaoSelecionado) {
      _configurarLabelBotaoGerar();
    }

    function limparTermoPesquisado() {
      vm.filtrarLeituristas = "";
    }

    function onChangeLeituristas() {
      if (vm.entidade.leituristas.length > 0)
        vm.todosLeituristas = false;

      if ((vm.entidade.leituristas.length === vm.leituristas.length)
        || (vm.entidade.leituristas.length === 0)) {
        vm.todosLeituristas = true;
        vm.entidade.leituristas = [];
      }

      vm.todosLeituristas = vm.todosLeituristas;
    }

    function limparSelecao() {
      if (vm.todosLeituristas === true) {
        vm.entidade.leituristas = [];
      }

      vm.todosLeituristas = vm.todosLeituristas;
    }

    function _downloadArquivoFTPLocal(arquivos, arquivoZip) {
      if (vm.parametros.calculo.tipoDetalheCalculo === 89) {
        var dadosGrupoLeituraControle = _retornaDadosArquivoCasan(arquivos[0]);

        RequisicaoGenericaService.salvar(
          Api.exportacaoGrupoLeitura.gravarGrupoLeituraControleDowloadArquivo,
          dadosGrupoLeituraControle
        ).then(
          function (sucess) {
            arquivos.forEach(function (arquivo) {
              window.open(arquivo);
            });
          },
          function (error) {
            MdDialogService.alertPadrao(
              "Não foi possível realizar o download do(s) arquivo(s). Detalhes: " +
              error.data
            );
          }
        );
      } else if (vm.parametros.calculo.tipoDetalheCalculo === 88) {
        var dadosGrupoLeituraControleCaema = _retornaDadosArquivoCaema(
          arquivos[0]
        );

        RequisicaoGenericaService.salvar(
          Api.exportacaoGrupoLeitura.gravarGrupoLeituraControleDowloadArquivo,
          dadosGrupoLeituraControleCaema
        ).then(
          function (sucess) {
            arquivos.forEach(function (arquivo) {
              window.open(arquivo);
            });
          },
          function (error) {
            MdDialogService.alertPadrao(
              "Não foi possível realizar o download do(s) arquivo(s). Detalhes: " +
              error.data
            );
          }
        );
      } else {
        if (arquivoZip) {
          window.open(urlApi.url_base_api + "cdn/retorno/" + arquivos[0]);
        } else {
          ArquivosService.baixarArquivo(
            Api.geracaoArquivoRetorno.abrirArquivo,
            arquivos
          );
        }
      }
    }

    function _retornaDadosArquivoCasan(arquivo) {
      var arrayDados = arquivo.split("/");

      var nomeArquivo = arrayDados[arrayDados.length - 1];

      var dados = nomeArquivo.split(".")[0].split("_");

      return {
        mes: dados[2].substring(4, 6),
        ano: dados[2].substring(0, 4),
        grupo: dados[0].substring(1, 3),
        regional: parseInt(dados[1]),
        sequencial: parseInt(dados[4]),
      };
    }

    function _retornaDadosArquivoCaema(arquivo) {
      var arrayDados = arquivo.split("/");

      var nomeArquivo = arrayDados[arrayDados.length - 1];

      var dados = nomeArquivo.split(".")[0];

      return {
        mes: dados.substring(17, 19),
        ano: dados.substring(19, 23),
        grupo: dados.substring(1, 4),
        regional: parseInt(dados.substring(5, 8)),
        sequencial: 0,
      };
    }

    function _retornarMensagemAguarde() {
      if (vm.sistemaGestorEhFiorilli) {
        if (vm.tipoProcesso == 1) {
          return "Enviando arquivo de exportação de carga de leituras...";
        }
        return "Enviando arquivo de exportação do grupo de leituras...";
      }

      return "Gerando arquivo de exportação do grupo de leituras...";
    }

    function _configurarLabelBotaoGerar() {
      if (!vm.sistemaGestorEhFiorilli) {
        vm.labelBotaoGerar = 'Gerar';
      }
      else if (vm.sistemaGestorEhFiorilli && vm.modoImplantacaoAtivo && vm.entidade.tipoExportacao == 1) {
        vm.labelBotaoGerar = 'Enviar';
      }
      else if (vm.sistemaGestorEhFiorilli && vm.modoImplantacaoAtivo && vm.entidade.tipoExportacao == 2) {
        vm.labelBotaoGerar = 'Download';
      }
      else {
        vm.labelBotaoGerar = 'Enviar';
      }

    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento.downloadfotos')
        .controller('DownloadFotosController', DownloadFotosController);

    function DownloadFotosController(DownloadFotosService, urlApi, MdDialogService, $rootScope, $filter, $scope) {
        var vm = this;

        init();

        vm.metodos = {
            setDefaultMes: setDefaultMes,
            setDefaultAno: setDefaultAno,
            expandirFotos: expandirFotos,
            configuraMdSelectArquivos: configuraMdSelectArquivos,
            pesquisarArquivos: pesquisarArquivos,
            pesquisarFotosCliente: pesquisarFotosCliente,
            montarURLCDN: montarURLCDN,
            realizarDownload: realizarDownload,
            realizarDownloadUnitario: realizarDownloadUnitario,
            totalPaginas: totalPaginas,
            mudarPagina: mudarPagina,
            mudarItensPorPagina: mudarItensPorPagina,
            selecionarTodosPagina: selecionarTodosPagina,
            selecionarTodosTabela: selecionarTodosTabela,
            todosDaPaginaSelecionados: todosDaPaginaSelecionados,
            todosDaTabelaSelecionados: todosDaTabelaSelecionados,
            existeFotoSelecionada: existeFotoSelecionada,
            todasFotosSelecionadas: todasFotosSelecionadas,
            existeFotoClienteSelecionada: existeFotoClienteSelecionada,
            selecionarFotos: selecionarFotos,
            totalFotosSelecionadas: totalFotosSelecionadas,
            ordenarPor: ordenarPor,
            getClasseOrdenacao: getClasseOrdenacao
        };

        function init() {
            vm.arquivos = undefined;
            vm.arquivSelecionado = '';
            vm.consultaRealizada = false;
            vm.clienteFotosFiltrados = [];
            vm._clienteFotosCompleto = [];

            $scope.$watch('vm.pesquisar', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _aplicarFiltro();
                }
            });

            vm.paginacao = {
                paginaAtual: 1,
                itensPorPagina: 100,
                opcoes: [100, 200, 300]
            };

            vm.ordenacao = {
                campo: 'codigoCliente',
                reversa: false
            };

            $rootScope.scrollButtonContainerLocal = 'md-content#content';
            $rootScope.utilizaBotaoScroll = true;
        }

        function setDefaultAno() {
            if (vm.entidade.ano == undefined || vm.entidade.ano <= 2000 || vm.entidade.ano > new Date().getFullYear()) {
                vm.entidade.ano = new Date().getFullYear();
                pesquisarArquivos();
            }
        }

        function setDefaultMes() {
            if (vm.entidade.mes == undefined || vm.entidade.mes <= 0 || vm.entidade.mes > 12) {
                vm.entidade.mes = new Date().getMonth() + 1;
                pesquisarArquivos();
            }
        }

        function configuraMdSelectArquivos() {
            vm.filtrarArquivos = '';
            angular.element('#select-arquivo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function pesquisarArquivos() {
            vm.emProgresso = true;
            vm.arquivos = undefined;
            vm.entidade.arquivo = null;

            var mesValido = !(vm.entidade.mes == undefined || vm.entidade.mes <= 0 || vm.entidade.mes > 12);
            var anoValido = !(vm.entidade.ano == undefined || vm.entidade.ano <= 2000 || vm.entidade.ano > new Date().getFullYear());

            if (mesValido && anoValido) {
                var inputModel = {
                    mesReferencia: vm.entidade.mes.toString().padStart(2, '0'),
                    anoReferencia: vm.entidade.ano
                };

                DownloadFotosService.retornarArquivosMesAnoReferencia(inputModel)
                    .then(
                        function (success) {
                            vm.arquivos = success.data;
                        },
                        function (error) {
                            vm.arquivos = undefined;
                            console.log(error);
                        })
                    .finally(function () {
                        vm.emProgresso = false;
                    });
            } else {
                vm.emProgresso = false;
            }
        }

        function expandirFotos(dadosFoto) {
            dadosFoto.exibirFotos = !dadosFoto.exibirFotos;
        }

        function existeFotoSelecionada() {
            var retorno = false;
            if (vm.clienteFotos) {
                vm.clienteFotos.forEach(function (cliente) {
                    cliente.fotos.forEach(function (foto) {
                        if (foto.selecionada) {
                            retorno = true;
                        }
                    });
                });
            }
            return retorno;
        }

        function todasFotosSelecionadas(dadosFoto) {
            if (!dadosFoto.fotos || dadosFoto.fotos.length === 0) return false;
            var retorno = true;
            dadosFoto.fotos.forEach(function (foto) {
                if (!foto.selecionada) {
                    retorno = false;
                }
            });
            return retorno;
        }

        function existeFotoClienteSelecionada(dadosFoto) {
            if (todasFotosSelecionadas(dadosFoto)) return false;
            var retorno = false;
            dadosFoto.fotos.forEach(function (foto) {
                if (foto.selecionada) {
                    retorno = true;
                }
            });
            return retorno;
        }

        function selecionarFotos(dadosFotos) {
            var selecionar = !todasFotosSelecionadas(dadosFotos);
            dadosFotos.fotos.forEach(function (foto) {
                foto.selecionada = selecionar;
            });
        }


        function _aplicarFiltro() {
            var texto = (vm.pesquisar || '').toLowerCase().trim();
            if (!texto) {
                vm.clienteFotosFiltrados = vm._clienteFotosCompleto || [];
            } else {
                vm.clienteFotosFiltrados = (vm._clienteFotosCompleto || []).filter(function (c) {
                    return (c.codigoCliente || '').toString().toLowerCase().indexOf(texto) !== -1;
                });
            }
            vm.paginacao.paginaAtual = 1;
        }

        function totalPaginas() {
            if (!vm.clienteFotosFiltrados || vm.clienteFotosFiltrados.length === 0) return 1;
            return Math.ceil(vm.clienteFotosFiltrados.length / vm.paginacao.itensPorPagina);
        }

        function mudarPagina(pagina) {
            if (pagina < 1) pagina = 1;
            if (pagina > totalPaginas()) pagina = totalPaginas();
            vm.paginacao.paginaAtual = pagina;
        }

        function mudarItensPorPagina() {
            vm.paginacao.paginaAtual = 1;
        }

        function _getItensPaginaAtual() {
            if (!vm.clienteFotosFiltrados) return [];
            var ordenados = $filter('orderBy')(vm.clienteFotosFiltrados, vm.ordenacao.campo, vm.ordenacao.reversa);
            var inicio = (vm.paginacao.paginaAtual - 1) * vm.paginacao.itensPorPagina;
            return $filter('limitTo')(ordenados, vm.paginacao.itensPorPagina, inicio);
        }


        function selecionarTodosPagina() {
            var selecionar = !todosDaPaginaSelecionados();
            _getItensPaginaAtual().forEach(function (cliente) {
                cliente.fotos.forEach(function (foto) {
                    foto.selecionada = selecionar;
                });
            });
        }

        function selecionarTodosTabela() {
            if (!vm.clienteFotosFiltrados) return;
            var selecionar = !todosDaTabelaSelecionados();
            vm.clienteFotosFiltrados.forEach(function (cliente) {
                cliente.fotos.forEach(function (foto) {
                    foto.selecionada = selecionar;
                });
            });
        }

        function todosDaPaginaSelecionados() {
            var itens = _getItensPaginaAtual();
            if (!itens || itens.length === 0) return false;
            var retorno = true;
            itens.forEach(function (cliente) {
                if (!todasFotosSelecionadas(cliente)) {
                    retorno = false;
                }
            });
            return retorno;
        }

        function todosDaTabelaSelecionados() {
            if (!vm.clienteFotosFiltrados || vm.clienteFotosFiltrados.length === 0) return false;
            var retorno = true;
            vm.clienteFotosFiltrados.forEach(function (cliente) {
                if (!todasFotosSelecionadas(cliente)) {
                    retorno = false;
                }
            });
            return retorno;
        }

        function totalFotosSelecionadas() {
            var total = 0;
            if (vm.clienteFotos) {
                vm.clienteFotos.forEach(function (cliente) {
                    cliente.fotos.forEach(function (foto) {
                        if (foto.selecionada) total++;
                    });
                });
            }
            return total;
        }


        function ordenarPor(campo) {
            if (vm.ordenacao.campo === campo) {
                vm.ordenacao.reversa = !vm.ordenacao.reversa;
            } else {
                vm.ordenacao.campo = campo;
                vm.ordenacao.reversa = false;
            }
            vm.paginacao.paginaAtual = 1;
        }

        function getClasseOrdenacao(campo) {
            if (vm.ordenacao.campo !== campo) return '';
            return vm.ordenacao.reversa ? 'icon-arrow-down' : 'icon-arrow-up';
        }


        function pesquisarFotosCliente() {
            var dialogConfig = {
                title: 'Aguarde... Buscando fotos',
                progress: ''
            };
            MdDialogService.abrirDialogProcessamento(dialogConfig);
            vm.arquivSelecionado = vm.entidade.arquivo;

            var inputModel = {
                nomeArquivo: vm.entidade.arquivo
            };

            DownloadFotosService.retornarListagemFotosCliente(inputModel)
                .then(function (success) {
                    MdDialogService.fecharDialogProcessamento();
                    vm.clienteFotos = success.data;
                    vm._clienteFotosCompleto = success.data;
                    vm.pesquisar = '';
                    _aplicarFiltro();
                    vm.paginacao.paginaAtual = 1;
                }, function (error) {
                    MdDialogService.fecharDialogProcessamento();
                    MdDialogService.alertPadrao(error.data);
                    vm.clienteFotos = undefined;
                    vm._clienteFotosCompleto = [];
                    vm.clienteFotosFiltrados = [];
                }).finally(function () {
                    vm.emProgresso = false;
                    vm.consultaRealizada = true;
                });
        }

        function montarURLCDN(urlFoto) {
            return urlApi.url_base_api + urlFoto;
        }

        function realizarDownload() {
            var dialogConfig = {
                title: 'Aguarde... Realizando download das fotos',
                progress: ''
            };
            MdDialogService.abrirDialogProcessamento(dialogConfig);

            var clienteFotos = angular.copy(vm.clienteFotos);

            clienteFotos.forEach(function (cliente) {
                cliente.fotos = cliente.fotos.filter(function (foto) {
                    return foto.selecionada;
                });
            });

            clienteFotos = clienteFotos.filter(function (cliente) {
                return cliente.fotos.length > 0;
            });

            var nomeArquivoZip = vm.arquivSelecionado.split('.');

            var inputModel = {
                nomeArquivoZip: nomeArquivoZip[0] + '.zip',
                clienteFotos: clienteFotos
            };

            DownloadFotosService.gerarZipDownload(inputModel)
                .then(function (success) {
                    window.open(montarURLCDN(success.data));
                    vm.clienteFotos.forEach(function (cliente) {
                        cliente.fotos.forEach(function (foto) {
                            foto.selecionada = false;
                        });
                    });
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                    MdDialogService.fecharDialogProcessamento();
                });
        }

        function realizarDownloadUnitario(dadosCliente) {
            vm.emProgresso = true;

            var nomeArquivoZip = vm.arquivSelecionado.split('.');

            var inputModel = {
                nomeArquivoZip: nomeArquivoZip[0] + '.zip',
                clienteFotos: [angular.copy(dadosCliente)]
            };

            DownloadFotosService.gerarZipDownload(inputModel)
                .then(function (success) {
                    window.open(montarURLCDN(success.data));
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.processamento.distribuicao')
        .controller('DistribuicaoController', DistribuicaoController)

    /** @ngInject */
    function DistribuicaoController($mdSidenav, DatatableFactory, MdDialogService, $scope, RequisicaoGenericaService, Api
        , $anchorScroll, $rootScope, Grupo, $mdDialog, RotasHtml, DistribuicaoService, SessionStorageService, KeysSessionStorage) {
        var vm = this;

        vm.quantidade = 1;
        vm.executouAcaoCritica = false;

        vm.rotasHtml = RotasHtml.distribuicao;


        vm.metodos = {
            abrirFiltroDistribuicao: _abrirFiltroDistribuicao,
            removerTarefa: _removerTarefa,
            dividirTarefa: _dividirTarefa,
            reordenarTarefas: _confirmReordenarTarefas,
            distribuirGrupo: _distribuirGrupo,
            fecharDialog: fecharDialog,
            marcarTodasTarefas: _marcarTodasTarefas,
            removerTarefasMarcadas: _removerTarefasMarcada,
            retonaTarefasMarcadas: _retornaTarefasMarcadas,
            abrirDialogSelecionarSetores: _abrirDialogSelecionarSetores,
            recuperarTarefas: recuperarTarefas,
            verificarTarefasSelecionadas: verificarTarefasSelecionadas,
            abrirDialogUnificarTarefas: abrirDialogUnificarTarefas,
            habilitarRemocaoTarefas: _habilitarRemocaoTarefas,
            desfazerRemocaoTarefas: _desfazerRemocaoTarefas,
            cancelarRemocaoTarefas: cancelarRemocaoTarefas,
            efetivarRemocaoTarefas: efetivarRemocaoTarefas,
            desfazerUnificarTarefas: _desfazerUnificarTarefas,
            cancelarUnificarTarefas: cancelarUnificarTarefas,
            efetivarUnificarTarefas: efetivarUnificarTarefas,
            habilitarUnificacaoTarefas: _habilitarUnificacaoTarefas,
            existeTarefaMarcada: existeTarefaMarcada,
            habilitarIncrementoDecremento: habilitarIncrementoDecremento,
            cancelarIncrementoDecremento: cancelarIncrementoDecremento,
            incrementarDecrementarTarefas: incrementarDecrementarTarefas
        }

        init();

        $scope.$on('carregamentoDados', function (ev, data) {
            _limparFormulario();
            _iniciarProgresso('Carregando informações do grupo...');
        })

        $scope.$on('dadosDistribuicao', function (ev, data) {
            if (data.listaPosicaoEnderecos) {
                vm.listaEnderecos = data.listaPosicaoEnderecos;
            }

            vm.tipoDistribuicaoFiltrado = data.resumoDistribuicao.enumTipoDistribuicao;

            _atribuirDadosDistribuicao(data.resumoDistribuicao, data.detalhesDistribuicao, data.bkp);
            _finalizarProgresso();
            _definirDtOptions();
            _atualizarMenus();
        });

        function init() {

            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.codigoCliente = vm.parametros.empresa.codigoImanager;
            vm.ehCalculoEspecifico = (vm.parametros.calculo.tipoDetalheCalculo == 89 || vm.parametros.calculo.tipoDetalheCalculo == 88);
            vm.exibirReferencia = true;
            vm.numeroTarefas = 0;
            vm.quantidadeDistribuir = 0;
            vm.emProgresso = false;
            vm.mensagemCarregamento = "";
            vm.tipoDistribuicaoFiltrado = 0;

            if (Grupo) {
                vm.distribuindoPorDialog = true;
                _iniciarDistribuicao(Grupo);
            }

            vm.filtro = DistribuicaoService.getFiltroDistribuicao();

            vm.menus = [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar grupo de leitura',
                    direction: 'top',
                    hide: vm.distribuindoPorDialog,
                    executarAcaoClick: function () { return _abrirFiltroDistribuicao() }
                },
                {
                    icon: 'icon-format-line-spacing s20',
                    name: '(Re)Ordenar tarefa',
                    direction: 'top',
                    hide: vm.parametros.calculo.tipoDetalheCalculo == 88,
                    executarAcaoClick: function () { return _reordenarTarefas(true) }
                },
                {
                    icon: 'icon-checkbox-marked-outline s20',
                    name: 'Selecionar setores',
                    direction: 'top',
                    hide: !(vm.tipoDistribuicaoFiltrado == 2 || vm.tipoDistribuicaoFiltrado == 3) || vm.parametros.calculo.tipoDetalheCalculo == 88,
                    executarAcaoClick: function () { return _abrirDialogSelecionarSetores(vm.tarefasBKP, vm.distribuicaoBKP, vm.tipoDistribuicaoBKP) }
                },
                {
                    icon: 'icon-checkbox-marked-outline s20',
                    name: 'Selecionar quadras',
                    direction: 'top',
                    hide: vm.tipoDistribuicaoFiltrado != 3 || vm.parametros.calculo.tipoDetalheCalculo != 88,
                    executarAcaoClick: function () { return _abrirDialogSelecionarQuadras(vm.tarefasBKP, vm.distribuicaoBKP, vm.tipoDistribuicaoBKP) }
                },
                {
                    icon: 'icon-open-in-app s20',
                    name: 'Tarefas',
                    direction: 'top',
                    executarAcaoClick: function () { return recuperarTarefas() }
                },
            ]
        }

        function _atualizarMenus() {
            vm.menus = [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar grupo de leitura',
                    direction: 'top',
                    hide: vm.distribuindoPorDialog,
                    executarAcaoClick: function () { return _abrirFiltroDistribuicao() }
                },
                {
                    icon: 'icon-format-line-spacing s20',
                    name: '(Re)Ordenar tarefa',
                    direction: 'top',
                    hide: vm.parametros.calculo.tipoDetalheCalculo == 88,
                    executarAcaoClick: function () { return _reordenarTarefas(true) }
                },
                {
                    icon: 'icon-checkbox-marked-outline s20',
                    name: 'Selecionar setores',
                    direction: 'top',
                    hide: !(vm.tipoDistribuicaoFiltrado == 2 || vm.tipoDistribuicaoFiltrado == 3) || vm.parametros.calculo.tipoDetalheCalculo == 88,
                    executarAcaoClick: function () { return _abrirDialogSelecionarSetores(vm.tarefasBKP, vm.distribuicaoBKP, vm.tipoDistribuicaoBKP) }
                },
                {
                    icon: 'icon-checkbox-marked-outline s20',
                    name: 'Selecionar quadras',
                    direction: 'top',
                    hide: vm.tipoDistribuicaoFiltrado != 3 || vm.parametros.calculo.tipoDetalheCalculo != 88,
                    executarAcaoClick: function () { return _abrirDialogSelecionarQuadras(vm.tarefasBKP, vm.distribuicaoBKP, vm.tipoDistribuicaoBKP) }
                },
                {
                    icon: 'icon-open-in-app s20',
                    name: 'Tarefas',
                    direction: 'top',
                    executarAcaoClick: function () { return recuperarTarefas() }
                },
            ];
        }

        function _abrirFiltroDistribuicao() {
            $mdSidenav('filtro-distribuicao').toggle();
        }

        function _reordenarTarefas() {
            _iniciarProgresso('Reordenando tarefas...');
            vm.tarefas.forEach(function (tarefa, index) {
                tarefa.tarefa = vm.tarefaIndiceInicial + index;
            });
            _finalizarProgresso();
        }

        function _removerTarefa(tarefa, index) {
            var htmlContent = "<span style='font-size: medium'>Deseja remover a tarefa " + tarefa.tarefa + "?</span>";
            MdDialogService.confirmPadraoComEvento("Atenção", htmlContent, null, function () {
                removerTarefaDaLista(tarefa, index);
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            }, null);
        }

        function _dividirTarefa(tarefa, index, reordenarAutomaticamente) {
            if (vm.codigoCliente == '1093' && vm.distribuicao.enumTipoDistribuicao == 1) {
                $mdDialog.show({
                    controller: 'DialogDivisaoTarefasSequencialController',
                    controllerAs: 'vm',
                    templateUrl: "app/main/processamento/distribuicao/dialogs/dialog-divisao-tarefas-sequencial/views/dialog-divisao-tarefas-sequencial.html",
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    locals: {
                        Tarefa: tarefa,
                    },
                }).then(function (sequenciais) {
                    if (sequenciais != null && sequenciais.length > 0) {
                        dividirSequencial(tarefa, index, sequenciais, true);
                    }
                });
            }
            else {
                if (tarefa.quantidade <= 1) {
                    MdDialogService.alertPadrao("Quantidade de leituras não é válida para dividir tarefa.");
                    return;
                }

                var htmlContent = "<span style='font-size: medium'>Deseja dividir a tarefa " + tarefa.tarefa + "?</span>";
                MdDialogService.confirmPadraoComEvento("Atenção", htmlContent, null, function () {
                    dividir(tarefa, index, reordenarAutomaticamente);
                    $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
                }, null)
            }
        }

        function dividir(tarefa, index, reordenarAutomaticamente) {
            _iniciarProgresso('Dividindo tarefa...');

            var tarefas = [tarefa];
            var viewModel = {
                resumoDistribuicao: vm.distribuicao,
                detalhesDistribuicao: tarefas
            };

            var promise = RequisicaoGenericaService.salvar(Api.distribuicao.dividirTarefa, viewModel);

            promise.then(function (success) {
                var dados = success.data;
                if (dados) {
                    var novasTarefas = dados.detalhesDistribuicao;
                    novasTarefas.forEach(function (item) {
                        vm.tarefas.splice(index, 0, item);
                        index++;
                    });
                    vm.tarefas.splice(index, 1);
                    vm.executouAcaoCritica = true;
                    if (reordenarAutomaticamente) {
                        _reordenarTarefas()
                    } else {
                        _confirmReordenarTarefas();
                    }
                    _contarLeiturasADistribuir();
                    _contarNumeroTarefas();
                    _finalizarProgresso();
                }
            }, function (error) {
                MdDialogService.alertPadrao("Não foi possível dividir a tarefa.");
            }
            );
        }

        function dividirSequencial(tarefa, index, sequenciais, reordenarAutomaticamente) {
            _iniciarProgresso('Dividindo tarefa...');

            var tarefas = [tarefa];
            var viewModel = {
                resumoDistribuicao: vm.distribuicao,
                detalhesDistribuicao: tarefas,
                sequenciaisDistribuicao: sequenciais
            };

            var promise = RequisicaoGenericaService.salvar(Api.distribuicao.dividirTarefa, viewModel);

            promise.then(function (success) {
                var dados = success.data;
                if (dados) {
                    var novasTarefas = dados.detalhesDistribuicao;
                    novasTarefas.forEach(function (item) {
                        vm.tarefas.splice(index, 0, item);
                        index++;
                    });
                    vm.tarefas.splice(index, 1);
                    vm.executouAcaoCritica = true;
                    if (reordenarAutomaticamente) {
                        _reordenarTarefas()
                    } else {
                        _confirmReordenarTarefas();
                    }
                    _contarLeiturasADistribuir();
                    _contarNumeroTarefas();
                    _finalizarProgresso();
                }
            }, function (error) {
                MdDialogService.alertPadrao("Não foi possível dividir a tarefa.");
            }
            );
        }

        function _contarLeiturasADistribuir() {
            vm.quantidadeDistribuir = vm.tarefas.reduce(function (acc, curr, index) {
                return acc + curr.quantidade
            }, 0)
                .toString()
                .padStart(4, "0");
        }

        function _contarNumeroTarefas() {
            vm.numeroTarefas = vm.tarefas.length.toString().padStart(3, "0");
        }

        function removerTarefaDaLista(tarefa, index) {
            vm.emProgresso = true;
            _iniciarProgresso('Removendo tarefa...');
            vm.tarefas.splice(index, 1);
            vm.executouAcaoCritica = true;
            _confirmReordenarTarefas();
            _contarLeiturasADistribuir();
            _contarNumeroTarefas();
            _finalizarProgresso();
        }

        function _distribuirGrupo() {
            var strValidacaoTarefas = _validarTarefas();

            if (strValidacaoTarefas) {
                MdDialogService.alertPadrao("Atenção", event, strValidacaoTarefas);
                return;
            }

            $anchorScroll();
            vm.emProgressoDistribuicao = true;
            vm.mensagemCarregamento = 'Distribuindo grupo de leituras...';
            // _iniciarProgresso('Distribuindo grupo de leituras...')
            var dadosDistribuicaoViewModel = {
                resumoDistribuicao: vm.distribuicao,
                detalhesDistribuicao: vm.tarefas
            }

            var verificarLeituraExisteGrupoViewModel = {
                ano: vm.distribuicao.ano,
                mes: vm.distribuicao.mes,
                grupo: vm.distribuicao.grupoLeitura,
                regional: vm.distribuicao.regional,
                municipio: vm.distribuicao.municipio,
                critica: vm.distribuicao.critica,
                ligacaoCritica: vm.distribuicao.critica,
                repasse: vm.distribuicao.repasse
            }

            RequisicaoGenericaService.salvar(Api.distribuicao.verificarLeituraExisteGrupo, verificarLeituraExisteGrupoViewModel).then(
                function (success) {
                    var promise = RequisicaoGenericaService.salvar(Api.distribuicao.validarExecucaoDistribuicao, dadosDistribuicaoViewModel);
                    promise.then(function (success) {
                        _finalizarProgressoDistribuicao();
                        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                        MdDialogService.alertPadrao(success.data, null);
                        vm.executouAcaoCritica = false;
                    }, function (error) {
                        _finalizarProgressoDistribuicao();
                        MdDialogService.alertPadrao("Atenção", null, error.data);
                    });
                },
                function (error) {
                    _finalizarProgresso();
                    MdDialogService.alertPadrao("Atenção", null, 'Não foi possível realizar a distribuição pois todas as leituras deste grupo já foram distribuidas.');
                }
            );


        }

        function _limparFormulario() {
            vm.tarefas = undefined;
            vm.distribuicao = undefined;
        }

        function _confirmReordenarTarefas(exibirMensagem) {
            if (vm.tarefas.length > 0)
                MdDialogService.confirmPadraoComEvento("Atenção", "Deseja reordenar as tarefas ? ", null, _reordenarTarefas, null);
            else {
                if (exibirMensagem)
                    MdDialogService.alertPadrao("Atenção", null, "Não é possível realizar reordenação sem tarefas.");
            }
        }

        function _iniciarProgresso(titulo) {
            vm.emProgresso = true;
            vm.mensagemCarregamento = titulo;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _finalizarProgressoDistribuicao() {
            vm.emProgressoDistribuicao = false;
        }

        function _validarTarefas() {
            if (!vm.tarefas.length) return "Não existe(m) tarefa(s) a ser(em) distribuída(s)."
            if (_existemTarefasVazias(vm.tarefas)) return "Não é possível distribuir grupo sem informação de número de tarefa.";
            return "";
        }

        function _existemTarefasComMesmoNumero(tarefas) {
            var nTarefas = tarefas.map(function (item) { return parseInt(item.tarefa) }).sort();
            var existemTarefasIguais = nTarefas.some(function (item, index) {
                return nTarefas[index + 1] == item;
            });

            return existemTarefasIguais;
        }

        function _existemTarefasVazias(tarefas) {
            return tarefas.some(function (item, index) { return item.tarefa == ""; });
        }

        function fecharDialog() {
            if (vm.executouAcaoCritica) {
                MdDialogService.confirmPadraoComEvento("Você realmente deseja sair da tela ?", "Pois todos os dados informados serão perdidos", null, function () {
                    $mdDialog.hide();
                }, null);
            }
            else {
                $mdDialog.hide();
            }
        }

        function _iniciarDistribuicao(Grupo) {
            var viewModel = {
                ano: Grupo.referencia.substring(3, 7),
                mes: Grupo.referencia.substring(0, 2),
                grupo: Grupo.grupo,
                tipodistribuicao: 2,
                regional: Grupo.regional,
                municipio: Grupo.municipio
            }
            _filtrarDadosDistribuicao(viewModel);
        }

        function _filtrarDadosDistribuicao(filtro) {
            filtro.mes = filtro.mes.toString().padStart(2, '0');
            vm.emProgresso = true;
            RequisicaoGenericaService.salvar(Api.distribuicao.verificarLeituraExisteGrupo, filtro).then(
                function (success) {
                    _consistirLeiturasDistribuidas(filtro);
                },
                function (error) {
                    vm.emProgresso = false;
                    if (vm.distribuindoPorDialog) {
                        MdDialogService.alertPadraoComEvento("Atenção", function () { $mdDialog.hide() }, null, error.data);
                    } else {
                        MdDialogService.alertPadrao("Atenção", null, error.data);
                    }
                }
            );

        }

        function _consistirLeiturasDistribuidas(filtro) {
            var promessa = RequisicaoGenericaService.salvar(Api.distribuicao.consistirLeiturasDistribuidas, filtro);
            promessa.then(function (success) {
                vm.emProgresso = false;

                if ($mdSidenav("filtro-distribuicao").isOpen()) {
                    $mdSidenav("filtro-distribuicao").toggle();
                }

                if (vm.distribuindoPorDialog) {
                    _abrirDialogMensagemSelecaoTipoDistribuicao(success.data, filtro);
                }
                else {
                    MdDialogService.confirmPadraoComEvento("Atenção", success.data.mensagem, null,
                        function () {
                            _carregarDadosDistribuicaoPorRota(filtro)
                        }, function () {
                            _cancelarProcessoDistribuicao()
                        });
                }

            }, function (error) {
                vm.emProgresso = false;
                MdDialogService.alertPadrao("Atenção", null, error.data);
                $mdDialog.hide();
            });
        }

        function _carregarDadosDistribuicaoPorRota(filtro) {
            vm.tipoDetalheCalculoCaemaDistribuindoViaDialog = (vm.parametros.calculo.tipoDetalheCalculo == 88 && vm.distribuindoPorDialog);
            vm.emProgresso = true;
            var promessa = RequisicaoGenericaService.salvar(Api.distribuicao.carregarDadosDistribuicaoPorRota, filtro);
            promessa.then(function (success) {
                if (success.data.listaPosicaoEnderecos) {
                    vm.listaEnderecos = success.data.listaPosicaoEnderecos;
                }

                var acao = _definirAcaoDadosDistribuicao(filtro, vm.parametros, success);
                acao();
            }, function (error) {
                console.error(error);
            }).finally(function () { vm.emProgresso = false });

        }

        function _definirAcaoDadosDistribuicao(filtro, parametros, success) {
            if (filtro.tipodistribuicao === 3 && vm.parametros.calculo.tipoDetalheCalculo == 88) {
                return function () {
                    _guardarDadosDistribuicao(success.data, filtro);
                    _abrirDialogSelecionarQuadras(success.data.detalhesDistribuicao, success.data.resumoDistribuicao, filtro.tipodistribuicao);
                }
            }
            if ((filtro.tipodistribuicao === 2 || filtro.tipodistribuicao === 3)) {
                return function () {
                    _guardarDadosDistribuicao(success.data, filtro);
                    _abrirDialogSelecionarSetores(success.data.detalhesDistribuicao, success.data.resumoDistribuicao, filtro.tipodistribuicao);
                }
            }

            return function () { _atribuirDadosDistribuicao(success.data.resumoDistribuicao, success.data.detalhesDistribuicao) };
        }

        function _definirDtOptions() {
            vm.defColumns = _definirColunasDtOptions(vm.distribuicao.enumTipoDistribuicao);
            vm.options = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(vm.defColumns);
            if (vm.distribuicao.enumTipoDistribuicao == 6) vm.options.autoWidth = false;
        }

        function _definirColunasDtOptions(tipoDistribuicao) {
            if (tipoDistribuicao) {
                switch (tipoDistribuicao) {
                    case 1:
                        if (vm.codigoCliente == '1093') {
                            return [
                                {
                                    targets: [0, 1, 2],
                                    width: '10%',
                                },
                                {
                                    targets: [3, 4],
                                    width: '10%',
                                },
                                {
                                    targets: [5, 6],
                                    width: '20%',
                                },
                                {
                                    targets: [7],
                                    width: '10%',
                                },
                                {
                                    targets: [7],
                                    responsivePriority: 1
                                }
                            ];
                        } else {
                            return [
                                {
                                    targets: [0, 1, 2],
                                    width: '10%',
                                },
                                {
                                    targets: [3],
                                    width: '15%',
                                },
                                {
                                    targets: [4, 5],
                                    width: '25%',
                                },
                                {
                                    targets: [6],
                                    width: '5%',
                                },
                                {
                                    targets: [6],
                                    responsivePriority: 1
                                }
                            ];
                        }

                    case 2:
                        return [
                            {
                                targets: [0, 1, 2, 3],
                                width: '10%',
                            },
                            {
                                targets: [4, 5],
                                width: '30%',
                            },
                            {
                                targets: [6],
                                responsivePriority: 1
                            }
                        ];
                    case 3:
                        return [
                            {
                                targets: [0, 1, 2, 3, 5, 6, 7],
                                searchable: false
                            },
                            {
                                targets: [0, 1, 2, 3, 4],
                                width: '5%',
                            },
                            {
                                targets: [5, 6],
                                width: '30%',
                            },
                            {
                                targets: [7],
                                responsivePriority: 1
                            }
                        ];
                    case 4:
                        return [
                            {
                                targets: [0, 1, 2, 3, 4, 5, 6],
                                width: '5%',
                            },
                            {
                                targets: [7, 8],
                                width: '30%',
                            },
                            {
                                targets: [9],
                                responsivePriority: 1
                            }
                        ];
                    case 5:
                        return [
                            {
                                targets: [0, 1],
                                width: '10%',
                            },
                            {
                                targets: [2, 3, 4],
                                width: '25%',
                            },
                            {
                                targets: [5],
                                width: '5%',
                            },
                            {
                                targets: [5],
                                responsivePriority: 1
                            }
                        ];
                    case 6:
                        return [
                            {
                                targets: [0, 1, 2],
                                width: '8%',
                            },
                            {
                                targets: [3, 4],
                                width: '30%',
                            },
                            {
                                targets: [5],
                                width: '10%',
                            },
                            {
                                targets: [6],
                                width: '6%',
                            },
                            {
                                targets: [5],
                                responsivePriority: 1
                            }
                        ];
                }
            }
        }

        function _marcarTodasTarefas() {
            if (!vm.marcarTodasTarefas) {
                vm.marcarTodasTarefas = true;
            }
            else {
                vm.marcarTodasTarefas = false;
            }
            vm.tarefas.forEach(function (item) {
                item.marcado = vm.marcarTodasTarefas;
            });
        }

        function _removerTarefasMarcada() {
            var tarefasMarcadas = _retornaTarefasMarcadas();

            if (!tarefasMarcadas.length) {
                MdDialogService.alertPadrao("É necessário marcar pelo menos uma tarefa a ser removida.");
                return;
            }

            tarefasMarcadas.forEach(function (item) {
                vm.tarefas.splice(vm.tarefas.indexOf(item), 1);
            });

            if (vm.removendoTarefas && !vm.removendoTarefas.removeuTarefa) {
                vm.removendoTarefas.removeuTarefa = true;
            }

            vm.executouAcaoCritica = true;
            _confirmReordenarTarefas();
            _contarLeiturasADistribuir();
            _contarNumeroTarefas();
            _finalizarProgresso();
            vm.marcarTodasTarefas = false;
        }

        function _retornaTarefasMarcadas() {
            return vm.tarefas.filter(function (item) {
                return item.marcado;
            });
        }

        function _abrirDialogMensagemSelecaoTipoDistribuicao(dados, filtro) {
            $mdDialog.show({
                controller: 'DialogMensagemTipoDistribuicaoController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.mensagemTipoDistribuicao,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Mensagem: dados.mensagem
                },
                resolve: {
                    listarTiposDistribuicao: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.distribuicao.retornarTipoDistribuicao)
                    }
                }
            }).then(function (success) {
                filtro.tipodistribuicao = success;
                if (filtro.tipodistribuicao == 5) {
                    DistribuicaoService.abrirDialogCalculoDistribuicaoAutomatica(dados.leiturasAhDistribuir)
                        .then(function (success) {
                            filtro.quantidadeTarefas = success;
                            _carregarDadosDistribuicaoPorRota(filtro);
                        }, function (err) {
                            _cancelarProcessoDistribuicao();
                        });
                } else {
                    _carregarDadosDistribuicaoPorRota(filtro);
                }
            }, function () {
                _cancelarProcessoDistribuicao();
            });
        }

        function _cancelarProcessoDistribuicao() {
            MdDialogService.alertPadrao("Atenção", null, "Processo de distribuição não foi iniciado.");
            $mdDialog.hide();
        }

        function _abrirDialogSelecionarSetores(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao) {

            var numeroPrimeiraTarefa;
            var pDialogSelecionarSetores = DistribuicaoService.abrirDialogSelecionarSetor(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao, vm.tarefas);
            pDialogSelecionarSetores.then(function (dadosDialog) {
                dadosDistribuicao = dadosDialog.detalhesDistribuicao;
                resumoDistribuicao = dadosDialog.resumoDistribuicao;
                numeroPrimeiraTarefa = dadosDialog.numeroPrimeiraTarefa;
                vm.executouAcaoCritica = true;
            }, function (dadosDialog) {
                dadosDistribuicao = dadosDialog.detalhesDistribuicao;
                resumoDistribuicao = dadosDialog.resumoDistribuicao;
                numeroPrimeiraTarefa = dadosDialog.numeroPrimeiraTarefa;
            }).finally(function () {
                _atribuirDadosDistribuicao(resumoDistribuicao, dadosDistribuicao, undefined, numeroPrimeiraTarefa);
            });

        }

        function _abrirDialogSelecionarQuadras(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao) {
            var numeroPrimeiraTarefa;
            var pDialogSelecionarSetores = DistribuicaoService.abrirDialogSelecionarQuadra(dadosDistribuicao, resumoDistribuicao, tipoDistribuicao, vm.tarefas);
            pDialogSelecionarSetores.then(function (dadosDialog) {
                dadosDistribuicao = dadosDialog.detalhesDistribuicao;
                resumoDistribuicao = dadosDialog.resumoDistribuicao;
                numeroPrimeiraTarefa = dadosDialog.numeroPrimeiraTarefa;
                vm.executouAcaoCritica = true;
            }, function (dadosDialog) {
                dadosDistribuicao = dadosDialog.detalhesDistribuicao;
                resumoDistribuicao = dadosDialog.resumoDistribuicao;
                numeroPrimeiraTarefa = dadosDialog.numeroPrimeiraTarefa;
            }).finally(function () {
                _atribuirDadosDistribuicao(resumoDistribuicao, dadosDistribuicao, undefined, numeroPrimeiraTarefa);
            });
        }

        function _atribuirDadosDistribuicao(resumoDistribuicao, dadosTarefas, dadosDistribuicaoBKP, numeroPrimeiraTarefa) {
            vm.distribuicao = resumoDistribuicao;
            vm.tarefas = dadosTarefas;

            if (dadosDistribuicaoBKP) {
                _guardarDadosDistribuicao(dadosDistribuicaoBKP, DistribuicaoService.getFiltroDistribuicao());
            }

            if (numeroPrimeiraTarefa) {
                vm.tarefaIndiceInicial = numeroPrimeiraTarefa
                _reordenarTarefas();
            } else {
                vm.tarefaIndiceInicial = vm.tarefas[0].tarefa;
            }

            _contarNumeroTarefas();
            _contarLeiturasADistribuir();
            _definirDtOptions();
        }

        function _guardarDadosDistribuicao(dadosDistribuicao, filtro) {
            vm.tarefasBKP = angular.copy(dadosDistribuicao.detalhesDistribuicao);
            vm.distribuicaoBKP = angular.copy(dadosDistribuicao.resumoDistribuicao);
            vm.tipoDistribuicaoBKP = angular.copy(filtro.tipodistribuicao);
        }

        function recuperarTarefas() {
            _iniciarProgresso('Buscando dados de tarefas...');
            var grupoViewModel = {
                mes: vm.distribuicao.mes,
                ano: vm.distribuicao.ano,
                grupoLeitura: vm.distribuicao.grupoLeitura,
                regional: vm.distribuicao.regional,
                municipio: vm.distribuicao.municipio,
                referencia: vm.distribuicao.mes + "/" + vm.distribuicao.ano
            }
            var promise = RequisicaoGenericaService.salvar(Api.gerenciamentoGrupo.realizarFiltroTarefas, grupoViewModel);
            promise.then(function (success) {
                grupoViewModel.grupo = vm.distribuicao.grupoLeitura;
                _abrirDialogTarefas(grupoViewModel, success.data, DistribuicaoService.getFiltroDistribuicao());
            }, function (error) {
                MdDialogService.alertPadrao("Atenção", null, error.data);
            }).finally(function () { _finalizarProgresso(); });

        }

        function _abrirDialogTarefas(grupo, tarefas, filtro) {
            var tmpt = _definirTemplateDialogTarefas(vm.parametros.calculo.tipoDetalheCalculo);
            $mdDialog.show({
                controller: 'DialogTarefasGerenciamentoGrupoController',
                controllerAs: 'vm',
                templateUrl: tmpt,
                targetEvent: null,
                clickOutsideToClose: false,
                mdIsFullscreen: 'xs,sm,md',
                multiple: true,
                escapeToClose: false,
                locals: {
                    Grupo: grupo,
                    Tarefas: tarefas,
                    Filtro: filtro
                }
            });
        }

        function _definirTemplateDialogTarefas(tipoDetalheCalculo) {
            if (tipoDetalheCalculo == 88) {
                return RotasHtml.gerenciamentoGrupo.dialogs.caema.tarefas;
            }
            return RotasHtml.gerenciamentoGrupo.dialogs.tarefas
        }

        function verificarTarefasSelecionadas() {
            var resultado = vm.tarefas.filter(function (item) {
                if (item.marcado) {
                    return item;
                }
            })

            return resultado.length == 0;
        }

        function abrirDialogUnificarTarefas() {
            $mdDialog.show({
                controller: 'DialogUnificarTarefasController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.unificarTarefas,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {}
            }).then(function (numeroTarefa) {
                _iniciarProgresso('Unificando tarefas...');
                vm.tarefas.some(function (item) {
                    if (item.marcado) {
                        item.tarefa = numeroTarefa;
                        item.marcado = false;
                    }
                });
                if (vm.unificandoTarefas && vm.unificandoTarefas.habilitar) {
                    vm.unificandoTarefas.unificouTarefa = true;
                }
            }, function () {

            }).finally(function () {
                _finalizarProgresso();
            });

        }

        function _habilitarRemocaoTarefas(habilitar) {

            if ((vm.unificandoTarefas && vm.unificandoTarefas.habilitar) || (vm.incrementandoDecrementandoTarefas && vm.incrementandoDecrementandoTarefas.habilitar)) {
                if (vm.distribuicao.enumTipoDistribuicao == 5) {

                    MdDialogService.alertPadrao("Atenção", event, "Para remover tarefas é necessário finalizar o processo de unificação ou incremento/decremento.");
                    return;
                } else {

                    MdDialogService.alertPadrao("Atenção", event, "Para remover tarefas é necessário finalizar o processo de unificação.");
                    return;
                }
            }

            vm.removendoTarefas = {
                habilitar: habilitar,
                removeuTarefa: false
            };

            if (!habilitar) {
                vm.tarefas.forEach(function (item) {
                    item.marcado = false;
                });
            } else {
                vm.tarefasBKPRemocao = angular.copy(vm.tarefas);
            }
            _contarLeiturasADistribuir();
            _contarNumeroTarefas();
        }

        function cancelarRemocaoTarefas() {
            MdDialogService.confirmPadraoComEvento("Atenção", "Deseja cancelar a remoção de tarefas ?", event, function () {
                _desfazerRemocaoTarefas();
                _habilitarRemocaoTarefas(false);
            })
        }

        function efetivarRemocaoTarefas() {
            _habilitarRemocaoTarefas(false);
        }

        function _desfazerRemocaoTarefas() {
            vm.removendoTarefas.removeuTarefa = false;
            vm.tarefas = angular.copy(vm.tarefasBKPRemocao);
        }

        function _habilitarUnificacaoTarefas(habilitar) {

            if ((vm.removendoTarefas && vm.removendoTarefas.habilitar) || (vm.incrementandoDecrementandoTarefas && vm.incrementandoDecrementandoTarefas.habilitar)) {
                if (vm.distribuicao.enumTipoDistribuicao == 5) {
                    MdDialogService.alertPadrao("Atenção", event, "Para unificar tarefas é necessário finalizar o processo de remoção ou incremento/decremento.");
                    return;
                } else {
                    MdDialogService.alertPadrao("Atenção", event, "Para unificar tarefas é necessário finalizar o processo de remoção.");
                    return;
                }
            }

            vm.unificandoTarefas = {
                habilitar: habilitar,
                unificouTarefa: false
            };
            vm.tarefasBKPUnificar = angular.copy(vm.tarefas);

            _contarLeiturasADistribuir();
            _contarNumeroTarefas();
        }

        function cancelarUnificarTarefas() {
            MdDialogService.confirmPadraoComEvento("Atenção", "Deseja cancelar a unificação de tarefas ?", event, function () {
                _desfazerUnificarTarefas();
                _habilitarUnificacaoTarefas(false);
            })
        }

        function efetivarUnificarTarefas() {
            _habilitarUnificacaoTarefas(false);
        }

        function _desfazerUnificarTarefas() {
            vm.unificandoTarefas.unificouTarefa = false;
            vm.tarefas = angular.copy(vm.tarefasBKPUnificar);
        }

        function habilitarIncrementoDecremento(habilitar) {

            if ((vm.removendoTarefas && vm.removendoTarefas.habilitar) || (vm.unificandoTarefas && vm.unificandoTarefas.habilitar)) {
                MdDialogService.alertPadrao("Atenção", event, "Para incrementar/decrementar tarefas é necessário finalizar o processo de remoção ou unificação.");
                return;
            }

            vm.incrementandoDecrementandoTarefas = {
                habilitar: habilitar
            };
        }

        function cancelarIncrementoDecremento() {
            vm.tarefas.map(function (tarefa) {
                if (tarefa.marcado === true) {
                    tarefa.marcado = false;
                }
            });

            habilitarIncrementoDecremento(false);
        }

        function incrementarDecrementarTarefas(tipo) {
            var tarefaMarcada;
            vm.tarefas.map(function (tarefa) {
                if (tarefa.marcado === true) {
                    tarefaMarcada = tarefa;
                }
            });

            var indexTarefaMarcada = vm.tarefas.indexOf(tarefaMarcada);

            if (indexTarefaMarcada === (vm.tarefas.length - 1) && tipo.toString().toLowerCase() === 'incrementar') {
                MdDialogService.alertPadrao("Atenção", event, "Não é possível realizar incremento para a última tarefa.");
                return;
            }

            if (indexTarefaMarcada === (0) && tipo.toString().toLowerCase() === 'decrementar') {
                MdDialogService.alertPadrao("Atenção", event, "Não é possível realizar decremento para a primeira tarefa.");
                return;
            }

            var quantidade = parseInt(vm.quantidade);

            if (quantidade > tarefaMarcada.quantidade) {
                MdDialogService.alertPadrao("A quantidade de leituras informada é maior que o número de leituras da tarefa selecionada.");
                return;
            }

            if (quantidade <= 0) {
                MdDialogService.alertPadrao("A quantidade de leituras informada deve ser maior que zero.");
                return;
            }

            var tarefaAhSerIncrementada;

            if (tipo.toString().toLowerCase() === 'incrementar') {

                tarefaAhSerIncrementada = vm.tarefas[indexTarefaMarcada + 1];

                tarefaAhSerIncrementada.quantidade += quantidade;
                tarefaAhSerIncrementada.posicaoInicial -= quantidade;
                tarefaAhSerIncrementada.enderecoInicial = vm.listaEnderecos[tarefaAhSerIncrementada.posicaoInicial].endereco;
                tarefaAhSerIncrementada.roteirizacaoInicial = vm.listaEnderecos[tarefaAhSerIncrementada.posicaoInicial].roteirizacao;

                tarefaMarcada.quantidade -= quantidade;
                if (tarefaMarcada.quantidade > 0) {
                    tarefaMarcada.posicaoFinal -= quantidade;
                    tarefaMarcada.enderecoFinal = vm.listaEnderecos[tarefaMarcada.posicaoFinal].endereco;
                } else {
                    vm.tarefas.splice(indexTarefaMarcada, 1);
                }
            }

            if (tipo.toString().toLowerCase() === 'decrementar') {
                tarefaAhSerIncrementada = vm.tarefas[indexTarefaMarcada - 1];

                tarefaAhSerIncrementada.quantidade += quantidade;
                tarefaAhSerIncrementada.posicaoFinal += quantidade;
                tarefaAhSerIncrementada.enderecoFinal = vm.listaEnderecos[tarefaAhSerIncrementada.posicaoFinal].endereco;

                tarefaMarcada.quantidade -= quantidade;
                if (tarefaMarcada.quantidade > 0) {
                    tarefaMarcada.posicaoInicial += quantidade;
                    tarefaMarcada.enderecoInicial = vm.listaEnderecos[tarefaMarcada.posicaoInicial].endereco;
                    tarefaMarcada.roteirizacaoInicial = vm.listaEnderecos[tarefaMarcada.posicaoInicial].roteirizacao;
                } else {
                    vm.tarefas.splice(indexTarefaMarcada, 1);
                }
            }

        }

        function existeTarefaMarcada() {
            return vm.tarefas.some(function (tarefa) {
                return tarefa.marcado === true;
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizartarefas', [])
        .config(Config);


    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.disponibilizarTarefas;

        $stateProvider
            .state('app.disponibilizar_tarefas', {
                url: '/processamento/disponibilizartarefas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'DisponibilizarTarefasController as vm',
                        abstract: true
                    },

                    'disponibilizartarefas-form@app.disponibilizar_tarefas': {
                        templateUrl: rotasHtml.form,
                    },

                    'disponibilizartarefas-form-caema@app.disponibilizar_tarefas': {
                        templateUrl: rotasHtml.caema.form,
                    },

                    'disponibilizartarefas-form-multiplos-grupos@app.disponibilizar_tarefas': {
                        templateUrl: rotasHtml.multiplosGrupos.form,
                    }
                },
                resolve: {
                    LeituristaCodigo:
                        function () {
                            return 0;
                        },
                    GrupoTarefa: function () { return null; }
                }
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.processamento.disponibilizartarefas')
        .controller('DisponibilizarTarefasController', DisponibilizarTarefasController)

    /** @ngInject */
    function DisponibilizarTarefasController(RequisicaoGenericaService, Api, LeituristaCodigo, MdDialogService,
        GrupoTarefa, $mdDialog, SessionStorageService, KeysSessionStorage, $state, $scope) {
        var vm = this;

        var data = new Date();



        vm.tarefas = [];

        vm.metodos = {
            configurarSelect: configurarSelect,
            configuraMdSelectGrupo: configuraMdSelectGrupo,
            configuraMdSelectTarefa: configuraMdSelectTarefa,
            disponibilizarTarefa: disponibilizarTarefa,
            disponibilizarMultiplasTarefas: disponibilizarMultiplasTarefas,
            configuraMdSelectRegional: configuraMdSelectRegional,
            configuraMdSelectMunicipio: configuraMdSelectMunicipio,
            pesquisarGrupos: pesquisarGrupos,
            pesquisarMunicipiosPorRegional: pesquisarMunicipiosPorRegional,
            pesquisarTarefasPorRegionalMunicipio: pesquisarTarefasPorRegionalMunicipio,
            pesquisarTarefasMultiplosGrupos: pesquisarTarefasMultiplosGrupos,
            pesquisarTarefas: pesquisarTarefas,
            fecharDialog: fecharDialog,
            realizarEventoChangeGrupo: realizarEventoChangeGrupo,
            onChangeItem: onChangeItem,
        }

        init();


        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.ehEnorsulSertaozinho = vm.parametros.empresa.tipoEmpresa == 565;

            vm.grupos = [];
            vm.grupoTarefa = GrupoTarefa;
            vm.entidade = {};


            if (vm.parametros.utilizaCadastroRegional) {

                if (!vm.grupoTarefa) {
                    vm.entidade = {
                        mes: data.getMonth() + 1,
                        ano: data.getFullYear()
                    }
                    if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                        vm.entidade.critica = false;
                    }
                    _pesquisarRegionais();
                } else {
                    vm.entidade.ano = vm.grupoTarefa.grupoReferencia.substring(3, 8);
                    vm.entidade.mes = vm.grupoTarefa.grupoReferencia.substring(0, 2);
                    vm.entidade.regional = vm.grupoTarefa.regional;
                    if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                        vm.entidade.critica = false;
                    }
                    _pesquisarRegionais();
                    vm.entidade.municipio = vm.grupoTarefa.municipio;
                    if (GrupoTarefa.tarefa) {
                        vm.entidade.tarefa = vm.grupoTarefa.tarefa;
                        pesquisarTarefas();
                    }
                }
            } else {

                if (vm.grupoTarefa) {
                    vm.entidade.ano = vm.grupoTarefa.grupoReferencia.substring(3, 8);
                    vm.entidade.mes = vm.grupoTarefa.grupoReferencia.substring(0, 2);

                    vm.entidade.grupo = vm.grupoTarefa.grupo;
                    pesquisarGrupos("", vm.entidade.mes, vm.entidade.ano);

                    if (vm.grupoTarefa.tarefa) {
                        vm.entidade.tarefa = vm.grupoTarefa.tarefa;
                        pesquisarTarefas();
                    }

                    _pesquisarLeituristas();

                } else {

                    _pesquisarLeituristas();
                    vm.entidade = {
                        mes: data.getMonth() + 1,
                        ano: data.getFullYear()
                    }

                    pesquisarGrupos("", vm.entidade.mes, vm.entidade.ano);
                }

            }
        }

        function onChangeItem() {
            if ($scope.model.length > 0)
                vm.todos = false;

            if (($scope.model.length === $scope.data.length)
                || ($scope.model.length === 0)) {
                vm.todos = true;
                $scope.model = [];
            }
        }

        function configurarSelect() {
            vm.termoProcurado = "";
            angular.element('#select').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectGrupo() {
            vm.filtrarGrupos = "";
            angular.element('#select-grupo').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectTarefa() {
            vm.filtrarTarefas = "";
            angular.element('#select-tarefa').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRegional() {
            vm.filtrarRegionais = "";
            angular.element('#select-regional').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectMunicipio() {
            vm.filtrarMunicipios = "";
            angular.element('#select-municipio').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function pesquisarTarefas(naoExibirMensagemTarefas) {
            vm.entidade.mes = vm.entidade.mes.toString().padStart(2, '0');
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) vm.entidade.tarefa = undefined;
            vm.tarefas = [];
            var viewModel = {
                mes: vm.entidade.mes,
                ano: vm.entidade.ano,
                grupo: vm.entidade.grupo,
                agrupamento: vm.entidade.regional,
                municipio: vm.entidade.municipio
            }
            vm.emProgressoBuscaTarefa = true;

            if (!_validarFiltroTarefas(viewModel)) {
                return
            }

            RequisicaoGenericaService.salvar(Api.disponibilizacaoTarefa.pesquisarTarefas, viewModel).then(
                function (success) {
                    vm.emProgressoBuscaTarefa = false;
                    vm.tarefas = success.data;
                },
                function (error) {
                    vm.emProgressoBuscaTarefa = false;
                    if (!naoExibirMensagemTarefas) {
                        MdDialogService.alertPadrao(error.data);
                    }
                    vm.tarefas = [];
                    console.log(error.data);
                }
            )
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function disponibilizarTarefa(entidade) {
            vm.emProgresso = true;
            vm.entidade.mes = vm.entidade.mes.toString().padStart(2, '0');
            entidade.agrupamento = vm.entidade.regional;

            RequisicaoGenericaService.salvar(Api.disponibilizacaoTarefa.disponibilizarTarefa, entidade).then(function (success) {
                MdDialogService.alertPadrao(success.data);
                if (vm.parametros.utilizaCadastroRegional) {
                    pesquisarTarefasPorRegionalMunicipio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.municipio);
                } else {
                    pesquisarTarefas(true);
                }
                vm.entidade.tarefa = null;
                vm.disponibilizarTarefasForm.tarefa.$setUntouched()
                vm.entidade.leiturista = null;
                vm.disponibilizarTarefasForm.leiturista.$setUntouched()

            }, function (err) {
                MdDialogService.alertPadrao(err.data);
            }).finally(function () {
                vm.emProgresso = false;
            });
        }

        function disponibilizarMultiplasTarefas(entidade) {
            vm.emProgresso = true;
            vm.entidade.mes = vm.entidade.mes.toString().padStart(2, '0');
            entidade.agrupamento = vm.entidade.regional;

            if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {

                var tarefas = [];
                entidade.tarefa.forEach(function (dado) {
                    tarefas.push({
                        grupo: dado.grupo,
                        tarefa: dado.numeroTarefa,
                    })
                });

                var viewModel = {
                    mes: entidade.mes,
                    ano: entidade.ano,
                    leiturista: entidade.leiturista,
                    agrupamento: entidade.agrupamento,
                    municipio: entidade.municipio,
                    critica: entidade.critica,
                    tarefas: tarefas
                }

                RequisicaoGenericaService.salvar(Api.disponibilizacaoTarefa.disponibilizarMultiplasTarefas, viewModel)
                    .then(function (success) {
                        MdDialogService.alertPadrao(success.data);
                        if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                            pesquisarTarefasMultiplosGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.municipio);
                        } else {
                            pesquisarTarefas(true);
                        }
                        vm.entidade.tarefa = null;
                        vm.disponibilizarTarefasForm.tarefa.$setUntouched()
                        vm.entidade.leiturista = null;
                        vm.disponibilizarTarefasForm.leiturista.$setUntouched()

                    }, function (err) {
                        MdDialogService.alertPadrao(err.data);
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
            } else {
                disponibilizarTarefa(entidade);
            }
        }

        function _validarFiltroGrupos() {
            if (vm.entidade.mes == undefined || vm.entidade.ano == undefined) {
                vm.grupos = [];
                return false;
            }

            if (vm.entidade.mes > 12 || vm.entidade.mes < 1) {
                return false;
            }

            return true;
        }

        function _validarFiltroTarefas(viewModel) {
            if (viewModel.grupo == undefined) {
                return false;
            }

            if (viewModel.mes == undefined || viewModel.ano == undefined) {
                vm.grupos = [];
                return false;
            }

            if (viewModel.mes > 12 || viewModel.mes < 1) {
                return false;
            }

            return true;
        }

        function _pesquisarRegionais() {

            if (angular.isUndefined(vm.grupoTarefa)) {
                vm.entidade.regional = undefined;
            }
            vm.emProgressoBuscaRegional = true;
            vm.regionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.emProgressoBuscaRegional = false;
            if (vm.grupoTarefa) {
                vm.entidade.grupo = vm.grupoTarefa.grupo;
                pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano);
            }
        }

        function pesquisarMunicipiosPorRegional(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0')
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) {
                vm.entidade.municipio = undefined;
            }
            vm.emProgressoBuscaMunicipio = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarMunicipiosPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo).then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data.map(function (item) {
                            return item
                        });

                        if (vm.grupoTarefa) {
                            if (vm.grupoTarefa.tarefa) vm.entidade.tarefa = vm.grupoTarefa.tarefa;
                            pesquisarTarefasPorRegionalMunicipio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.municipio);
                        }

                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        console.log(error.data);
                    }
                )
        }

        function pesquisarMunicipiosPorMultiplosGrupos(regional, mes, ano, grupos) {
            vm.emProgressoBuscaMunicipio = true;
            mes = mes.toString().padStart(2, '0')
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) {
                vm.entidade.municipio = undefined;
            }

            var viewModel = {
                regional: regional,
                mes: mes,
                ano: ano,
                grupos: grupos
            }

            RequisicaoGenericaService.salvar(Api.regional.listarMunicipiosPorMultiplosGrupos, viewModel)
                .then(
                    function (success) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = success.data.map(function (item) {
                            return item
                        });

                        if (vm.grupoTarefa) {
                            if (vm.grupoTarefa.tarefa) vm.entidade.tarefa = vm.grupoTarefa.tarefa;
                            pesquisarTarefasPorRegionalMunicipio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.municipio);
                        }
                    },
                    function (error) {
                        vm.emProgressoBuscaMunicipio = false;
                        vm.municipios = "";
                        console.log(error.data);
                    }
                )
                .finally(function () {
                    vm.emProgressoBuscaMunicipio = false;
                });
        }

        function realizarEventoChangeGrupo(regional, mes, ano, grupo, municipio) {

            if (vm.parametros.utilizaCadastroRegional) {
                if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                    pesquisarMunicipiosPorMultiplosGrupos(regional, mes, ano, grupo);
                } else {
                    pesquisarMunicipiosPorRegional(regional, mes, ano, grupo);
                }
            } else {
                if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                    pesquisarTarefasMultiplosGrupos("", mes, ano, grupo, "");
                } else {
                    pesquisarTarefasPorRegionalMunicipio("", mes, ano, grupo, "");
                }
            }

        }

        function pesquisarTarefasPorRegionalMunicipio(regional, mes, ano, grupo, municipio) {
            if (!municipio && vm.parametros.utilizaCadastroRegional) return;

            mes = mes.toString().padStart(2, '0')
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) {
                vm.entidade.tarefa = undefined;
            }
            vm.emProgressoBuscaTarefa = true;

            RequisicaoGenericaService.listarSemParams(Api.regional.listarTarefasPorRegionalMunicipio +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano + "&grupo=" + grupo + "&municipio=" + municipio).then(
                    function (success) {
                        vm.emProgressoBuscaTarefa = false;
                        vm.tarefas = success.data.map(function (item) {
                            return item
                        });
                    },
                    function (error) {
                        vm.emProgressoBuscaTarefa = false;
                        console.log(error.data);
                    }
                );
        }

        function pesquisarTarefasMultiplosGrupos(regional, mes, ano, grupos, municipio) {
            if (!municipio && vm.parametros.utilizaCadastroRegional) return;
            mes = mes.toString().padStart(2, '0')
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) {
                vm.entidade.tarefa = undefined;
            }
            vm.emProgressoBuscaTarefas = true;

            var viewModel = {
                regional: regional,
                mes: mes,
                ano: ano,
                grupos: grupos,
                municipio: municipio,
                critica: vm.entidade.critica
            }

            RequisicaoGenericaService.salvar(Api.regional.listarTarefasMultiplosGrupos, viewModel)
                .then(
                    function (success) {
                        vm.emProgressoBuscaTarefas = false;
                        vm.tarefas = success.data;
                    },
                    function (error) {
                        vm.tarefa = [];
                        vm.emProgressoBuscaTarefas = false;
                        console.log(error.data);
                    }
                ).finally(function () {
                    vm.emProgressoBuscaTarefas = false;
                });
        }

        function pesquisarGrupos(regional, mes, ano) {
            if (!mes) return;
            mes = mes.toString().padStart(2, '0');
            if (angular.isUndefined(vm.grupoTarefa) || vm.grupoTarefa == null) {
                vm.entidade.grupo = undefined;
                vm.entidade.tarefa = undefined;
                vm.municipios = undefined;
                vm.tarefas = undefined;
            }
            vm.emProgressoBuscaGrupo = true;
            RequisicaoGenericaService.listarSemParams(Api.regional.listarGruposPorRegional +
                '?regional=' + regional + '&mes=' + mes + '&ano=' + ano).then(
                    function (success) {
                        vm.emProgressoBuscaGrupo = false;
                        vm.grupos = success.data;
                        vm.entidade.leiturista = undefined;

                        if (vm.parametros.utilizaCadastroRegional) {
                            RequisicaoGenericaService.listarSemParams(Api.leiturista.listarLeituristasPorRegional +
                                '?regional=' + regional).then(
                                    function (success) {
                                        vm.emProgressoBuscaLeiturista = false;
                                        vm.leituristas = _adicionarCampoBuscaLeituristas(success.data);
                                        if (vm.leituristas.length == 0) {
                                            MdDialogService.confirmPadraoComEvento("Atenção",
                                                "Não existem leituristas cadastrados ou ativos na regional selecionada, deseja verificar no cadastro de leituristas?", null,
                                                function () {
                                                    $state.go('app.cadastro_leiturista');
                                                });

                                        }

                                        pesquisarMunicipiosPorRegional(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo);

                                        if (vm.grupoTarefa.municipio) {
                                            vm.entidade.municipio = vm.grupoTarefa.municipio;
                                        }
                                    },
                                    function (error) {
                                        vm.emProgressoBuscaLeiturista = false;
                                        console.log(error.data);
                                    }
                                )
                        }

                    },
                    function (error) {
                        vm.emProgressoBuscaGrupo = false;
                        console.log(error.data);
                    }
                )
        }

        function _pesquisarLeituristas() {

            RequisicaoGenericaService.listarSemParams(Api.leiturista.listarTodosAtivos).then(
                function (success) {
                    vm.leituristas = _adicionarCampoBuscaLeituristas(success.data);
                    if (vm.leituristas.length == 0)
                        MdDialogService.alertPadrao("Não existem leituristas cadastrados ou ativos, por favor verifique.");
                    else if (LeituristaCodigo != 0) {
                        vm.codigoLeiturista = LeituristaCodigo;
                        vm.desabilitarCampos = true;
                    }
                },
                function (error) {
                    MdDialogService.alertPadrao("Falha ao carregar os leituristas.\n\nDetalhes: " + error.data);
                }
            );

        }

        function _adicionarCampoBuscaLeituristas(leituristas) {
            if (!Array.isArray(leituristas)) return [];
            return leituristas.map(function (leiturista) {
                leiturista.busca = (leiturista.codigo ? leiturista.codigo.toString() : '') + ' - ' + (leiturista.apelido || '');
                return leiturista;
            });
        }

    }

}());

(function () {
    "use strict";

    angular
        .module("app.processamento.disponibilizarcargaretidas")
        .controller("DisponibilizarCargaRetidasController", DisponibilizarCargaRetidasController);

    /* @ngInject */
    function DisponibilizarCargaRetidasController(
        $rootScope,
        $mdDialog,
        $state,
        $scope,
        $timeout,
        DisponibilizarCargaRetidasService,
        Leituristas,
        FaturasRetidas,
        RotasHtml,
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService
    ) {
        var vm = this;
        vm.setorSelecionado = [];
        vm.rotaSelecionada = [];
        $rootScope.scrollButtonContainerLocal = "md-content#content";
        $rootScope.utilizaBotaoScroll = true;

        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        init();

        vm.dtOptions = configDataTable([
            {
                targets: [0, 8, 3, 4],
                orderable: false
            },
            {
                targets: [0, 8],
                width: "5%"
            },
            {
                targets: [1, 2, 5, 7],
                width: "15%"
            },
            {
                targets: [3, 4, 6],
                width: "10%"
            },
            {
                targets: [0, 8],
                responsivePriority: 1,
            },
        ]);
        vm.marcarTodas = false;
        vm.emProgresso = false;
        vm.ehDialog = false;
        vm.dtOptions.dom = '<"top"f>rt<"bottom"<"left"<"info"i>>>';
        vm.dtOptions.responsive = false;
        vm.faturasRetidas = FaturasRetidas.data;
        vm.setoresUnicos = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.setor)));  
        vm.rotasUnicas = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.rota))); 
        vm.rotasHtml = RotasHtml.disponibilizarCargaRetidas;

        vm.metodos = {
            marcarTodas: marcarTodas,
            disponibilizarRetidas: disponibilizarRetidas,
            quantidadeFaturasSelecionadas: quantidadeFaturasSelecionadas,
            faturaVencida: faturaVencida,
            abrirDialogDetalhesDependentes: abrirDialogDetalhesDependentes,
            atualizarDados: atualizarDados,
            configuraMdSelectSetor: configuraMdSelectSetor,
            configuraMdSelectRota: configuraMdSelectRota,
        };

        function init() {
            if (!vm.parametros.utilizarGerenciamentoFaturasRetidasVinculadas) {
                MdDialogService.alertPadrao("A funcionalidade de gerenciamento de faturas retidas vinculadas não está habilitada.");
                $state.go('app.inicio')
            }
        }

        function marcarTodas() {
            if(vm.todosMarcados){
                vm.faturasRetidas.forEach(function (fatura) {
                    if (vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = false;
                    }
                });
            }else{
                var codigosItensNaoMarcados = vm.faturasRetidas
                    .filter(fatura => !fatura.selecionada)
                    .map(fatura => fatura.codigo);
                vm.faturasRetidas.forEach(function (fatura) {
                    if (codigosItensNaoMarcados.includes(fatura.codigo) && vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = true;
                    }
                });
            }
        }

        $scope.$watch('vm.faturasRetidas', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                var codigosItensMarcados = newValue
                .filter(function(fatura) {
                    return fatura.selecionada === true;
                })
                .map(function(fatura) {
                    return fatura.codigo;
                });
                var codigosFiltrados = vm.codigosFiltrados;
                var saoIguais = codigosFiltrados.every(function(codigo) {
                    return codigosItensMarcados.includes(codigo);
                });
                $timeout(function() {
                    vm.todosMarcados = saoIguais;
                });
            }
        }, true);

        function disponibilizarRetidas() {
            $mdDialog.show({
                controller: 'DialogSelecionarLeituristaController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogSelecionarLeiturista,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Leituristas: Leituristas.data
                }
            }).then(function (codigoLeiturista) {
                vm.emProgressoDisponibilizacao = true;
                var faturasSelecionadas = vm.faturasRetidas.filter(function (fatura) {
                    return fatura.selecionada;
                });

                DisponibilizarCargaRetidasService.disponibilizarCargaRetidas(faturasSelecionadas, codigoLeiturista)
                    .then(function (success) {
                        if (success.data) {
                            MdDialogService.alertPadrao(success.data);
                            atualizarDados();
                        }
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }).finally(function () { vm.emProgressoDisponibilizacao = false; });
            });
        }

        function abrirDialogDetalhesDependentes(dependentes) {
            $mdDialog.show({
                controller: 'DialogDetalhesDependentesController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogDetalhesDependentes,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    FaturasRetidasDependentes: dependentes,
                    ExibeInformativo: true
                }
            });
        }

        function configuraMdSelectSetor() {
            vm.filtrarSetores = "";
            angular.element('#select-setor').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRota() {
            vm.filtrarRotas = "";
            angular.element('#select-rota').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function quantidadeFaturasSelecionadas() {            
            return vm.faturasRetidas.filter(function (fatura) {
                return fatura.selecionada;
            }).length;
        }

        function faturaVencida(fatura) {
            return _converterStringParaData(fatura.vencimento) < new Date();
        }

        function atualizarDados() {
            vm.emProgresso = true;

            DisponibilizarCargaRetidasService.listarFaturasRetidas("")
                .then(function (success) {
                    vm.faturasRetidas = success.data;
                    atualizarItensUnicos();
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
        }

        function obterItensUnicos(array, propriedade) {
            return Array.from(new Set(array.map(item => item[propriedade])));
        }
        
        function atualizarItensUnicos() {
            vm.setoresUnicos = obterItensUnicos(vm.faturasRetidas, 'setor');
            vm.rotasUnicas = obterItensUnicos(vm.faturasRetidas, 'rota');
        }

        function _converterStringParaData(dataString) {
            var partes = dataString.split("/");

            return new Date(partes[2], partes[1] - 1, partes[0]);
        }
       

        function configDataTable(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                order: [[5, "asc"]],
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                        if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }

                    function filtrarDados() {
                        var setoresSelecionados = vm.setorSelecionado || [];
                        var rotasSelecionadas = vm.rotaSelecionada || [];
                    
                        api.column(3).search(setoresSelecionados.map(function(setor) {
                            return '^' + setor + '$';
                        }).join('|'), true, false).draw();
                    
                        api.column(4).search(rotasSelecionadas.map(function(rota) {
                            return '^' + rota + '$';
                        }).join('|'), true, false).draw();
                    }
        
                    $scope.$watchGroup(['vm.setorSelecionado', 'vm.rotaSelecionada'], function (newValue, oldValue) {
                        filtrarDados();
                    }); 
                                               
                },
                drawCallback: function () {
                    var itensFiltrados = this.api().rows({ filter: 'applied' }).data().toArray();
                    vm.codigosFiltrados = itensFiltrados.map(item => {
                        const codigo = item[1];
                        return codigo.match(/\d+/)[0];
                    });
                    var faturasFiltradas = vm.faturasRetidas.filter(fatura => vm.codigosFiltrados.includes(fatura.codigo));
                    vm.todosMarcados = faturasFiltradas.every(fatura => fatura.selecionada);
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.processamento.cancelamentofaturasretidas")
        .controller("CancelamentoFaturasRetidasController", CancelamentoFaturasRetidasController);

    /* @ngInject */
    function CancelamentoFaturasRetidasController(
        $rootScope,
        $mdDialog,
        $state,
        $scope,
        $timeout,
        CancelamentoFaturasRetidasService,
        DatatableFactory,
        FaturasRetidasCancelamento,
        RotasHtml,
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService
    ) {
        var vm = this;

        $rootScope.scrollButtonContainerLocal = "md-content#content";
        $rootScope.utilizaBotaoScroll = true;

        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        vm.setorSelecionado = [];
        vm.rotaSelecionada = [];

        init();

        vm.dtOptions = configDataTable([
            {
                targets: [0, 5, 6, 9],
                orderable: false
            },
            {
                targets: [0, 9],
                width: "5%"
            },
            {
                targets: [3, 4, 6],
                width: "10%"
            },
            {
                targets: [0, 8],
                responsivePriority: 1,
            },
        ]);
        vm.marcarTodas = false;
        vm.emProgresso = false;
        vm.emProgressoCancelamento = false;
        vm.dtOptions.order = [[7, "asc"]]; 
        vm.dtOptions.dom = '<"top"f>rt<"bottom"<"left"<"info"i>>>';
        vm.dtOptions.responsive = false;

        vm.faturasRetidas = FaturasRetidasCancelamento.data;
        vm.setoresUnicos = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.setor)));  
        vm.rotasUnicas = Array.from(new Set(vm.faturasRetidas.map(fatura => fatura.rota)));
        vm.rotaHtmlDialog = RotasHtml.disponibilizarCargaRetidas.dialogs.dialogDetalhesDependentes;

        vm.metodos = {
            marcarTodas: marcarTodas,
            existeFaturaSelecionada: existeFaturaSelecionada,
            quantidadeFaturasSelecionadas: quantidadeFaturasSelecionadas,
            abrirDialogDetalhesDependentes: abrirDialogDetalhesDependentes,
            atualizarDados: atualizarDados,
            cancelar: cancelar,
            configuraMdSelectSetor: configuraMdSelectSetor,
            configuraMdSelectRota: configuraMdSelectRota
        };

        function init() {
            if (!vm.parametros.utilizarGerenciamentoFaturasRetidasVinculadas) {
                MdDialogService.alertPadrao("A funcionalidade de gerenciamento de faturas retidas vinculadas não está habilitada.");
                $state.go('app.inicio')
            }
        }

        function marcarTodas() {
            if(vm.todosMarcados){
                vm.faturasRetidas.forEach(function (fatura) {
                    if (vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = false;
                    }
                });
            }else{
                var codigosItensNaoMarcados = vm.faturasRetidas
                    .filter(fatura => !fatura.selecionada)
                    .map(fatura => fatura.codigo);
                vm.faturasRetidas.forEach(function (fatura) {
                    if (codigosItensNaoMarcados.includes(fatura.codigo) && vm.codigosFiltrados.includes(fatura.codigo)) {
                        fatura.selecionada = true;
                    }
                });
            }
        }

        $scope.$watch('vm.faturasRetidas', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                var codigosItensMarcados = newValue
                .filter(function(fatura) {
                    return fatura.selecionada === true;
                })
                .map(function(fatura) {
                    return fatura.codigo;
                });
                var codigosFiltrados = vm.codigosFiltrados;
                var saoIguais = codigosFiltrados.every(function(codigo) {
                    return codigosItensMarcados.includes(codigo);
                });
                $timeout(function() {
                    vm.todosMarcados = saoIguais;
                });
            }
        }, true);

        function configuraMdSelectSetor() {
            vm.filtrarSetores = "";
            angular.element('#select-setor').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRota() {
            vm.filtrarRotas = "";
            angular.element('#select-rota').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }


        function abrirDialogDetalhesDependentes(dependentes) {
            $mdDialog.show({
                controller: 'DialogDetalhesDependentesController',
                controllerAs: 'vm',
                templateUrl: vm.rotaHtmlDialog,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    FaturasRetidasDependentes: dependentes,
                    ExibeInformativo: false
                }
            });
        }

        function existeFaturaSelecionada() {
            return vm.faturasRetidas.some(function (fatura) {
                return fatura.selecionada;
            });
        }

        function quantidadeFaturasSelecionadas() {
            return vm.faturasRetidas.filter(function (fatura) {
                return fatura.selecionada;
            }).length;
        }

        function atualizarDados() {
            vm.emProgresso = true;

            CancelamentoFaturasRetidasService.listarLigacoesRetidasCancelamento()
                .then(function (success) {
                    vm.faturasRetidas = success.data;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () { vm.emProgresso = false; });
        }

        function cancelar() {
            MdDialogService.confirmPadraoComEvento(
                "Deseja cancelar a disponibilização das ligações selecionadas?",
                null,
                null,
                function () {
                    vm.emProgressoCancelamento = true;

                    var viewModel = vm.faturasRetidas.filter(function (fatura) {
                        return fatura.selecionada;
                    });

                    CancelamentoFaturasRetidasService.cancelarLigacoesRetidas(viewModel)
                        .then(
                            function (success) {
                                MdDialogService.alertPadrao("Cancelamento realizado com sucesso!");
                                atualizarDados();
                            },
                            function (error) {
                                MdDialogService.alertPadrao(error.data);
                            })
                        .finally(function () { vm.emProgressoCancelamento = false; });
                },
                function () { vm.emProgressoCancelamento = false; });
        }

        function configDataTable(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                        if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }

                    function filtrarDados() {
                        var setoresSelecionados = vm.setorSelecionado || [];
                        var rotasSelecionadas = vm.rotaSelecionada || [];
                    
                        api.column(5).search(setoresSelecionados.map(function(setor) {
                            return '^' + setor + '$';
                        }).join('|'), true, false).draw();
                    
                        api.column(6).search(rotasSelecionadas.map(function(rota) {
                            return '^' + rota + '$';
                        }).join('|'), true, false).draw();
                    }
        
                    $scope.$watchGroup(['vm.setorSelecionado', 'vm.rotaSelecionada'], function (newValue, oldValue) {
                        filtrarDados();
                    }); 
                                               
                },
                drawCallback: function () {
                    var itensFiltrados = this.api().rows({ filter: 'applied' }).data().toArray();
                    vm.codigosFiltrados = itensFiltrados.map(item => {
                        const codigo = item[3];
                        return codigo.match(/\d+/)[0];
                    });
                    var faturasFiltradas = vm.faturasRetidas.filter(fatura => vm.codigosFiltrados.includes(fatura.codigo));
                    vm.todosMarcados = faturasFiltradas.every(fatura => fatura.selecionada);
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.processamento.alertacliente")
        .controller("AlertaClienteController", AlertaClienteController);

    /* @ngInject */
    function AlertaClienteController($mdDialog, $rootScope, DatatableFactory, RotasHtml, MdDialogService, ListarTodos, AlertaClienteHttpService
    ) {
        var vm = this;

        vm.pesquisar = "";
        vm.marcarTodas = false;
        vm.rotasHtml = RotasHtml.alertaCliente;
        vm.alertas = ListarTodos.data;
        vm.emProgresso = false;

        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
            {
                targets: [0, 3],
                width: '2%',
            },
            {
                targets: [3],
                width: '8%',
            },
            {
                targets: [1],
                width: '15%',
            },
            {
                targets: [2],
                width: '75%',
            },
            {
                targets: [3],
                responsivePriority: 1
            }
        ]);

        vm.dtOptions.dom = '<"top"f>rt<"bottom"<"left"<"info"i>>>';
        $rootScope.scrollButtonContainerLocal = "md-content#content";
        $rootScope.utilizaBotaoScroll = true;

        vm.metodos = {
            atualizarAlertas: atualizarAlertas,
            marcarTodas: marcarTodas,
            existeAlertaMarcado: existeAlertaMarcado,
            abrirDialogCadastroAlerta: abrirDialogCadastroAlerta,
            excluirAlertas: excluirAlertas
        }

        function atualizarAlertas() {
            vm.emProgresso = true;
            AlertaClienteHttpService.listarTodos().then(function (response) {
                vm.alertas = response.data;
            }, function (error) {
                MdDialogService.alertPadrao(error.data);
            }).finally(function () { vm.emProgresso = false; });
        }

        function marcarTodas() {
            vm.marcarTodas = !vm.marcarTodas;
            vm.alertas.forEach(function (alerta) {
                alerta.marcado = vm.marcarTodas;
            });
        }

        function existeAlertaMarcado() {
            return vm.alertas.some(function (alerta) {
                return alerta.marcado;
            });
        }

        function abrirDialogCadastroAlerta(alerta) {
            $mdDialog.show({
                controller: 'DialogCadastrarAlertaController',
                controllerAs: 'vm',
                templateUrl: vm.rotasHtml.dialogs.dialogCadastrarAlerta,
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    Alerta: alerta
                }
            }).then(function (success) {
                if (success) {
                    atualizarAlertas();
                }
            });
        }

        function excluirAlertas() {
            var alertasMarcados = vm.alertas.filter(function (alerta) {
                return alerta.marcado;
            });

            var mensagemAlerta = alertasMarcados.length > 1 ?
                ("os " + alertasMarcados.length + " alertas selecionados?")
                : "o alerta selecionado?";

            MdDialogService.confirmPadraoComEvento("Atenção", "Deseja realmente excluir " + mensagemAlerta,
                event, function () {
                    vm.emProgresso = true;

                    var viewModel = {
                        identificadores: alertasMarcados.map(function (alerta) { return alerta.identificador; })
                    }

                    var mensagemRetorno = alertasMarcados.length > 1 ?
                        "Alertas excluídos com sucesso!"
                        : "Alerta excluído com sucesso!";

                    AlertaClienteHttpService.excluir(viewModel).then(function () {
                        MdDialogService.alertPadraoComEvento(mensagemRetorno, function () {
                            atualizarAlertas();
                        });
                    }, function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }).finally(function () { vm.emProgresso = false; });
                }, null);
        }
    }
})();
/* eslint-disable no-undef */
/* eslint-disable no-console */
(function () {
    "use strict";

    angular
        .module("app.relatorios.vivaagua")
        .controller("VivaAguaController", VivaAguaController);

    /* @ngInject */
    function VivaAguaController(SessionStorageService, KeysSessionStorage, MdDialogService, VivaAguaService, ValidacaoService, Base64Service, RotasHtml, $mdDialog, RelatorioService) {
        var vm = this;

        vm.metodos = {
            configurarSelect: configurarSelect,
            pesquisarGrupos: pesquisarGrupos,
            selecionarArquivo: selecionarArquivo,
            realizarEventoChangeGrupo: realizarEventoChangeGrupo,
            realizarEventoChangeSetor: realizarEventoChangeSetor,
            realizarEventoChangeFiltroViaArquivo: realizarEventoChangeFiltroViaArquivo,
            realizarEventoChangeFiltroManualmente: realizarEventoChangeFiltroManualmente,
            gerarRelatorio: gerarRelatorio,
            filtrarRelatorioPlanilha: filtrarRelatorioPlanilha,
            abrirSelecaoArquivo: abrirSelecaoArquivo,
            removerArquivo: removerArquivo
        }

        init();

        function init() {
            vm.localidades = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.rotasHtml = RotasHtml.relatorio.vivaAgua;
            vm.grupos = [];
            vm.setor = [];
            vm.clientes = [];
            vm.entidade = {
                mes: new Date().getMonth() + 1,
                ano: new Date().getFullYear(),
                tipoFiltro: "2",
            }
            vm.entidade.gerarViaArquivo = true;
            vm.entidade.gerarManualmente = false;
            vm.arquivoBase64 = "";
        }

        function configurarSelect(modelPesquisa, seletor) {
            modelPesquisa = "";
            angular.element(seletor).on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function pesquisarGrupos(regional, mes, ano) {
            if (!mes) return;
            mes = mes.toString().padStart(2, '0');
            vm.entidade.grupo = undefined;
            vm.grupos = undefined;

            vm.emProgressoBuscaGrupo = true;

            VivaAguaService.buscarGrupos(regional, mes, ano).then(
                function (success) {
                    vm.emProgressoBuscaGrupo = false;
                    vm.grupos = success.data;
                },
                function (error) {
                    vm.emProgressoBuscaGrupo = false;
                    vm.grupos = [];
                    console.log(error.data);
                }
            );
        }

        function selecionarArquivo() {
            var arquivo = document.querySelector('#vivaagua-arquivo').files[0];
            if (arquivo) {
                vm.arquivo = VivaAguaService.selecionarArquivo(event, arquivo, function (event) {
                    vm.arquivoBase64 = Base64Service.converterArquivosGrandesParaBase64(event.target.result);
                });
            }
        }

        function realizarEventoChangeGrupo(regional, mes, ano, grupo) {
            mes = mes.toString().padStart(2, '0');
            vm.setor = undefined;
            vm.entidade.setor = "";
            vm.clientes = undefined;
            vm.entidade.clientes = undefined;

            vm.emProgressoBuscaSetor = true;

            VivaAguaService.buscarSetores(regional, mes, ano, grupo).then(
                function (success) {

                    vm.setor = success.data.map(function (item) {
                        return item
                    });
                },
                function (error) {
                    console.log(error.data);
                    vm.setor = []
                }
            ).finally(function () {
                vm.emProgressoBuscaSetor = false;
            });
        }

        function realizarEventoChangeSetor(localidade, mes, ano, grupo, setor) {
            vm.emProgressoBuscaClientes = true;

            mes = mes.toString().padStart(2, '0');

            vm.clientes = undefined;
            vm.entidade.clientes = undefined;

            var inputModel = {
                ano: ano,
                mes: mes,
                grupo: grupo,
                localidade: localidade,
                setor: setor,
                tipoFiltro: vm.entidade.tipoFiltro,
            };

            VivaAguaService.consultarClientes(inputModel).then(
                function (success) {
                    vm.clientes = [];
                    if (success.data.length > 0) {
                        success.data.map(function (cliente) {
                            vm.clientes.push({
                                descricao: cliente
                            });
                        });
                    }
                },
                function (error) {
                    vm.clientes = [];
                    console.log(error);
                }
            ).finally(function () {
                vm.emProgressoBuscaClientes = false;
            });
        }

        function realizarEventoChangeFiltroViaArquivo() {
            if (vm.entidade.gerarViaArquivo) {
                vm.entidade.gerarManualmente = false;
            } else {
                vm.entidade.gerarManualmente = true;
            }
        }

        function realizarEventoChangeFiltroManualmente() {
            if (vm.entidade.gerarManualmente) {
                vm.entidade.gerarViaArquivo = false;
            } else {
                vm.entidade.gerarViaArquivo = true;
            }
        }

        function abrirSelecaoArquivo() {
            ValidacaoService.validarParametroString("vivaagua-arquivo");
            document.querySelector("#vivaagua-arquivo").click();
        }

        function removerArquivo(event) {
            ValidacaoService.validarParametroString("vivaagua-arquivo");
            ValidacaoService.validarParametroObjeto(event);

            angular.element(document.querySelector("#vivaagua-arquivo")).val(null);
            vm.arquivo = "";
            vm.arquivoBase64 = "";
            vm.form.$setDirty();
        }

        function gerarRelatorio() {
            _inciarProgresso("Gerando relatórios...");

            var inputModel = {};
            var mes = vm.entidade.mes.toString().padStart(2, '0');

            if (vm.entidade.clientes !== undefined) {
                if (vm.entidade.clientes.length > 0) {
                    var clientes = vm.entidade.clientes.map(function (cliente) {
                        return cliente.descricao
                    });
                }
            }

            inputModel = {
                ano: vm.entidade.ano,
                mes: mes,
                grupo: vm.entidade.grupo,
                localidade: vm.entidade.localidade,
                setor: vm.entidade.setor,
                tipoFiltro: vm.entidade.tipoFiltro,
                clientes: clientes,
            };

            VivaAguaService.gerarRelatorio(inputModel)
                .then(
                    function (success) {
                        MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                        var file = new Blob([success.data], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    },
                    function (error) {
                        MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
        }

        function filtrarRelatorioPlanilha() {
            _inciarProgresso("Filtrando dados...");

            var inputModel = {};

            inputModel = {
                base64: vm.arquivoBase64
            };

            VivaAguaService.filtrarRelatorioPlanilha(inputModel)
                .then(
                    function (success) {
                        $mdDialog.show({
                            controller: 'VivaAguaLocalidadesDialogController',
                            controllerAs: 'vm',
                            templateUrl: vm.rotasHtml.dialogs.localidades,
                            targetEvent: null,
                            clickOutsideToClose: false,
                            fullscreen: false,
                            locals: {
                                Localidades: success.data,
                            }
                        }).then().finally(function () {
                            vm.emProgresso = false;
                        });
                    },
                    function (error) {
                        MdDialogService.alertPadrao(error.data);
                    }).finally(function () {
                        vm.emProgresso = false;
                    });
        }

        function _inciarProgresso(mensagem) {
            vm.mensagemEmProgresso = mensagem;
            vm.emProgresso = true;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.relatorios.visualizar', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.relatorios_visualizar', {
                url: '/relatorios/visualizar/:relatorios',
                module: 'privado',
                params: {
                    parametroRelatorio: null
                },
                views: {
                    'content@app': {                                      
                        templateUrl: 'app/main/relatorios/visualizar/views/visualizar.html',                                       
                        controller: 'VisualizaRelatoriosController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.visualizar')
        .controller('VisualizaRelatoriosController', VisualizaRelatoriosController);

    /** @ngInject */
    function VisualizaRelatoriosController(urlApi, $stateParams, $sce, Base64Service, $window, $http, Api) {
        var vm = this;
        var relatorio = $stateParams.relatorios;
        var parametrosRelatorio = $stateParams.parametroRelatorio;

        //var url = urlApi.url_relatorios_api +
        //'VisualizarRelatorio/index.html?relatorio=' + relatorio;

     
        var url = urlApi.url_base_api + Api.relatorios.abrirRelatorio + "?caminhoArquivo=" + relatorio;

        if (parametrosRelatorio != null) {
            url += "&" + Base64Service.converteDadosParaString64(parametrosRelatorio);
        }

        vm.urlRelatorio = $sce.trustAsResourceUrl(url);
    }
})();

/* eslint-disable no-undef */
(function () {
  "use strict";

  angular
    .module("app.relatorios.personalizado")
    .controller(
      "PersonalizadoRelatorioController",
      PersonalizadoRelatorioController
    );

  /* @ngInject */
  function PersonalizadoRelatorioController(
    $mdDialog,
    PersonalizadoRelatorioService,
    MdDialogService
  ) {
    var vm = this;
    init();

    function init() {
      vm.query = "";
      vm.queryInvalida = false;
      vm.emProgresso = false;
      vm.apenasPlanilha = false;

      vm.metodos = {
        consultar: consultar,
        verificarQuery: verificarQuery,
        gerarPlanilha: gerarPlanilha,
      };
    }

    function consultar() {
      if (vm.apenasPlanilha) {
        _consultar();
        return;
      }

      MdDialogService.confirmPadraoComEvento(
        "Atenção!",
        "A visualização em tela está limitada a 1.000 registros. Caso o resultado da sua pesquisa ultrapasse esse limite, apenas os primeiros 1.000 serão exibidos em tela e exportados no Excel.<br><br>Se você precisa de todos os registros, recomendamos utilizar a opção <strong>Gerar apenas planilha.<strong/> <br><br>Deseja continuar com a visualização em tela?",
        null,
        function () {
          _consultar();
        },
        null
      );
    }

    function verificarQuery() {
      vm.queryInvalida = vm.query.includes(";");
    }

    function gerarPlanilha(base64) {
      $mdDialog
        .show({
          controller: "PersonalizadoPlanilhaDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/relatorios/personalizado/dialogs/views/personalizado-planilha-dialog.html",
          targetEvent: null,
          clickOutsideToClose: false,
        })
        .then(function (nomePlanilha) {
          if (
            nomePlanilha == undefined ||
            nomePlanilha == null ||
            nomePlanilha == ""
          ) {
            return;
          }
          _converterBase64ParaXLSX(base64, nomePlanilha);
        });
    }

    function _consultar() {
      _iniciarProgresso();

      var consultar = PersonalizadoRelatorioService.consultar(
        vm.query,
        vm.apenasPlanilha
      );

      consultar
        .then(
          function (success) {
            if (vm.apenasPlanilha) {
              gerarPlanilha(success.data.relatorioBase64);
            } else {
              vm.dados = success.data;
              vm.dados.registros = JSON.parse(vm.dados.tabela);
            }
          },
          function (error) {
            if (error.data.exibirMensagem) {
              MdDialogService.alertPadrao(error.data.mensagem);
              return;
            } else {
              console.error(error.data.mensagem);
              MdDialogService.alertPadrao(
                "Não foi possível processar o comando. Verifique se os nomes das tabelas e colunas estão corretos e se a sintaxe está válida."
              );
            }
          }
        )
        .finally(function () {
          _finalizarProgresso();
        });
    }

    function _iniciarProgresso() {
      vm.emProgresso = true;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }

    function _converterBase64ParaXLSX(base64, nomePlanilha) {
      var byteCharacters = atob(base64);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = nomePlanilha + ".xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      MdDialogService.alertPadrao("Planilha gerada com sucesso!", null, null);
    }
  }
})();

(function () {
    "use strict";

    angular
        .module("app.relatorios.faturamento")
        .controller("FaturamentoController", FaturamentoController);

    /* @ngInject */
    function FaturamentoController(
        $interval,
        $mdDialog,
        $window,
        FaturamentoServico,
        MdDialogService,
        SessionStorageService,
        KeysSessionStorage,
        listarOcorrencias,
        urlApi,
        RotasHtml,
        RelatorioService,
        ListarLocalidades
    ) {
        var vm = this;
        var rotasHtml = RotasHtml.relatorio.faturamento;
        init();

        var processando = undefined;

        function init() {
            vm.ocorrencias = listarOcorrencias.data;
            if (ListarLocalidades) vm.localidades = ListarLocalidades.data
            else vm.localidades = [];

            vm.parametrosEmpresa = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.codigoImanager = vm.parametrosEmpresa.empresa.codigoImanager;

            vm.habilitarTodasOcorrencias = false;
            vm.numeroServicosIncluidos = 0;

            vm.tipoDetalheCalculo = SessionStorageService.recuperar(
                KeysSessionStorage.tipoDetalheCalculo
            );

            vm.utilizaCadastroRegional =
                SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa)
                    .utilizaCadastroRegional && vm.tipoDetalheCalculo == 88; // CAEMA

            vm.entidade = {
                tipoFiltro: "1",
                ocorrencias: [],
                servicos: [],
                exibirOcorrenciaLeituraNormal: true,
            };

            vm.metodos = {
                gerarRelatorio: gerarRelatorio,
                configurarSelectOcorrencias: configurarSelectOcorrencias,
                abrirDialogServicos: abrirDialogServicos,
                configuraMdSelectLocalidades: configuraMdSelectLocalidades,
            };

            vm.listandoMunicipios = false;
            vm.listaRegionais = SessionStorageService.recuperar(
                KeysSessionStorage.usuarioAgrupamentos
            );
        }

        function configuraMdSelectLocalidades() {
            vm.filtrarLocalidade = "";
            angular.element('#select-localidade').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function abrirDialogServicos() {
            $mdDialog
                .show({
                    controller: "FaturamentoServicosPrestadosDialogController",
                    controllerAs: "vm",
                    templateUrl: rotasHtml.dialogs.servicosPrestados.templateUrl,
                    targetEvent: null,
                    clickOutsideToClose: false,
                    fullscreen: false,
                    locals: {
                        Servicos: vm.entidade.servicos,
                    },
                })
                .then(
                    function () { },
                    function () {
                        vm.emProgresso = false;
                    }
                );
        }

        function gerarRelatorio() {
            var regionais =
                vm.entidade.regionais == null || angular.isUndefined(vm.entidade.regionais)
                    ? []
                    : vm.entidade.regionais.map(function (o) {
                        return o.codigo;
                    });

            inicioProgresso();
            var viewModel = {};

            if (vm.utilizaCadastroRegional) {
                viewModel = {
                    tipoFiltro: vm.entidade.tipoFiltro,
                    mes: vm.entidade.mes,
                    ano: vm.entidade.ano,
                    mesInicial: vm.entidade.mesInicial,
                    mesFinal: vm.entidade.mesFinal,
                    anoInicial: vm.entidade.anoInicial,
                    anoFinal: vm.entidade.anoFinal,
                    localidades: regionais,
                }

                vm.viewModelTeste = viewModel;

                FaturamentoServico.gerarRelatorioCAEMA(viewModel)
                    .then(
                        function (success) {
                            fimProgresso();
                            MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                            var file = new Blob([success.data], { type: 'application/pdf;base64' });
                            var fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        },
                        function (error) {
                            fimProgresso();
                            MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                        }
                    );
            } else {
                var localidadeItapemirim = null;

                if (vm.entidade.localidadeItapemirim) {
                    localidadeItapemirim = vm.entidade.localidadeItapemirim.codigo
                }
                viewModel = {
                    tipoFiltro: vm.entidade.tipoFiltro,
                    dataInicial: vm.entidade.dataInicial,
                    dataFinal: vm.entidade.dataFinal,
                    mes: vm.entidade.mes,
                    ano: vm.entidade.ano,
                    mesInicial: vm.entidade.mesInicial,
                    mesFinal: vm.entidade.mesFinal,
                    anoInicial: vm.entidade.anoInicial,
                    anoFinal: vm.entidade.anoFinal,
                    servicos: vm.entidade.servicos,
                    ocorrencias: vm.entidade.ocorrencias,
                    exibirOcorrenciaLeituraNormal:
                        vm.entidade.exibirOcorrenciaLeituraNormal,
                    somenteOcorrenciaPrincipal: vm.entidade.somenteOcorrenciaPrincipal,
                    ocultarTotalizadorViasImpressas:
                        vm.entidade.ocultarTotalizadorViasImpressas,
                    exibirAgrupamentoLeiturasComSemHidrometro:
                        vm.entidade.exibirAgrupamentoLeiturasComSemHidrometro,
                    filtrosUtilizados: angular.copy(
                        FaturamentoServico.constroiFiltrosUtilizados(vm.entidade)
                    ),
                    localidades: regionais,
                    localidadeItapemirim: localidadeItapemirim
                };

                FaturamentoServico.enviarFormulario(viewModel).then(
                    function (success) {
                        fimProgresso();
                        MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                        var file = new Blob([success.data], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    },
                    function (error) {
                        fimProgresso();
                        MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                    }
                );
            }
        }

        function inicioProgresso() {
            vm.emProgresso = true;
            processando = $interval(function () {
                vm.progresso += 3;

                if (vm.progresso > 100) vm.progresso = 0;
            }, 100);
        }

        function configurarSelectOcorrencias() {
            vm.termoProcuradoOcorrencias = "";
            angular.element("#selectOcorrencias").on("keydown", function (ev) {
                ev.stopPropagation();
            });
        }

        function fimProgresso() {
            vm.emProgresso = false;
            vm.progresso = 0;
            if (angular.isDefined(processando)) {
                $interval.cancel(processando);
                clearInterval(processando);
                processando = undefined;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.relatorios.logs')
        .controller('LogsController', LogsController);

    /* @ngInject */
    function LogsController(listarLeituristas, $interval, LogsServico, MdDialogService, $state, $window, urlApi, $mdDialog, RotasHtml) {
        var vm = this;
        vm.leituristas = listarLeituristas.data;
        var processando = undefined;
        var rotasHtml = RotasHtml.relatorio.logs;
        vm.metodos = {            
            filtrarRelatorio: filtrarRelatorio
        };

        init();

        function init() {
            vm.nomeArquivoSelecionado = "";
            vm.entidade = { 
                ordenacao: 1,
                gerarRelatorioPorCarga: 'N',
             };
            vm.logs = [];
            vm.progresso = 0;
            vm.progressoBuffer = 0;         
        }

        function filtrarRelatorio() {            
            inicioProgresso();
            var viewModel = {
                dataInicio: vm.entidade.dataInicio,
                dataFim: vm.entidade.dataFim,
                leiturista: vm.entidade.leiturista,
                ordenacao: vm.entidade.ordenacao,
                exibirGrafico: vm.entidade.exibirGrafico,
                filtrosUtilizados: LogsServico.constroiFiltrosUtilizados(vm.entidade),
                gerarRelatorioPorCarga: vm.entidade.gerarRelatorioPorCarga
            };
            LogsServico.enviarDados(viewModel)
                .then(function (success) {
                    if (success.status == 204)
                    {
                        vm.logs = undefined;
                        MdDialogService.alertPadrao("Atenção", event, "Não foram encontradas informações de log!");
                        fimProgresso();
                    }
                    else
                    {                        
                        $mdDialog.show({
                            controller: 'SelecionarArquivoLogDialogController',
                            controllerAs: 'vm',
                            templateUrl: rotasHtml.dialogs.selecionarArquivo.templateUrl,
                            targetEvent: null,
                            clickOutsideToClose:false,
                            fullscreen: false,
                            locals: {
                                Logs: success.data,
                                ViewModel: viewModel
                            }
                          }).then(
                            function(success){
                                fimProgresso(); 
                          }, function(err){
                                fimProgresso(); 
                          });
                    }                                
                },
                    function (error) {
                        fimProgresso();
                        MdDialogService.alertPadrao("Erro ao filtrar relatório", event, error.data);
                    }
                )
                
        }
       

        function inicioProgresso() {
            vm.emProgresso = true;
            processando = $interval(function () {
                vm.progresso += 3;

                if (vm.progresso > 100)
                    vm.progresso = 0;

            }, 100);
        }

        function fimProgresso() {
            vm.emProgresso = false;
            vm.progresso = 0;
            if (angular.isDefined(processando)) {
                $interval.cancel(processando);
                clearInterval(processando);
                processando = undefined;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.faturasretidas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.faturasRetidas;
        //State
        $stateProvider
            .state('app.relatorios_faturasretidas', {
                url: '/relatorios/faturasretidas',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'FaturasRetidasController as vm'
                    },
                    'relatorios-form@app.relatorios_faturasretidas': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    listarLeituristas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
                    }
                }
            });

    }
})();

(function () {
    "use strict";

    angular
        .module("app.relatorios.faturasretidas")
        .controller("FaturasRetidasController", FaturasRetidasController);

    /* @ngInject */
    function FaturasRetidasController(listarLeituristas, $interval, FaturasRetidasService, MdDialogService, RelatorioService) {
        var vm = this;
        var processando = undefined;

        vm.leituristas = listarLeituristas.data;
        vm.metodos = {
            gerarRelatorio: _gerarRelatorio
        };
        vm.tiposFiltros = [
            { valor: 1, descricao: 'Mês/Ano referência' },
            { valor: 2, descricao: 'Período de leitura' }
        ];

        init();

        function init() {
            vm.entidade = {
                tipoFiltro: 1,
                ordenacao: 1,
                leituristas: []
            };
        }

        function _gerarRelatorio() {
            _inicioProgresso();

            var viewModel = {
                tipoFiltro: vm.entidade.tipoFiltro,
                mes: vm.entidade.mes,
                ano: vm.entidade.ano,
                dataInicial: vm.entidade.dataInicial,
                dataFinal: vm.entidade.dataFinal,
                leituristas: vm.entidade.leituristas.map(function (leiturista) {
                    return leiturista.codigo;
                }),
                ordenacao: vm.entidade.ordenacao
            }

            FaturasRetidasService.gerarRelatorio(viewModel).then(
                function (success) {
                    _fimProgresso();
                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }, function (error) {
                    _fimProgresso();
                    // MdDialogService.alertPadrao(error.status + ': ' + error.statusText);
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                }
            );

        }

        function _inicioProgresso() {
            vm.emProgresso = true;
            processando = $interval(function () {
                vm.progresso += 3;
                if (vm.progresso > 100) {
                    vm.progresso = 0;
                }
            }, 100);
        }

        function _fimProgresso() {
            vm.emProgresso = false;
            vm.progresso = 0;
            if (angular.isDefined(processando)) {
                $interval.cancel(processando);
                clearInterval(processando);
                processando = undefined;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.relatorios.alertacliente', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.alertaCliente;
        //State
        $stateProvider
            .state('app.relatorios_alertacliente', {
                url: '/relatorios/alertacliente',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'AlertaClienteRelatorioController as vm'
                    },
                    'relatorios-form@app.relatorios_alertacliente': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    listarLocalidades: function (RegionalService) {
                        return RegionalService.listarTodos();
                    }
                }
            });

    }
})();

/* eslint-disable no-undef */
(function () {
    "use strict";

    angular
        .module("app.relatorios.alertacliente")
        .controller("AlertaClienteRelatorioController", AlertaClienteRelatorioController);

    /* @ngInject */
    function AlertaClienteRelatorioController(
        SessionStorageService,
        KeysSessionStorage,
        AlertaClienteRelatorioService,
        MdDialogService,
        RelatorioService
    ) {
        var vm = this;

        init();

        function init() {
            vm.listaRegionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);

            vm.tipoDetalheCalculo = SessionStorageService.recuperar(
                KeysSessionStorage.tipoDetalheCalculo
            );

            vm.metodos = {
                gerarRelatorio: gerarRelatorio,
            };

        }

        function gerarRelatorio() {
            _iniciarProgresso();

            var localidades = [];

            if (vm.entidade.regionais != undefined) {
                vm.entidade.regionais.forEach(function (regional) {
                    localidades.push(regional.codigo);
                });
            }


            var viewModel = {
                dataInicial: vm.entidade.dataInicio,
                dataFinal: vm.entidade.dataFim,
                localidades: localidades.length > 0 ? localidades : null,
                codigoConsumidor: vm.entidade.codigoCliente != undefined ? vm.entidade.codigoCliente : null
            }

            var gerarRelatorio = AlertaClienteRelatorioService.gerarRelatorio(viewModel);

            gerarRelatorio
                .then(function (success) {

                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                }, function (error) {
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                })
                .finally(function () { _finalizarProgresso() });
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.relatorios.clientesNaoVisitados', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.relatorio.clientesNaoVisitados;
        $stateProvider
            .state('app.relatorios_clientesnaovisitados', {
                url: '/relatorios/clientesnaovisitados',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'ClientesNaoVisitadosController as vm'
                    },
                    'relatorios-form@app.relatorios_clientesnaovisitados': {
                        templateUrl: rotasHtml.form
                    }
                },
                resolve: {
                    ListarLeituristas: function (Api, RequisicaoGenericaService) {
                        return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
                    }
                }
            });
    }
})();

/* eslint-disable no-undef */
(function () {
    "use strict";

    angular
        .module("app.relatorios.clientesNaoVisitados")
        .controller("ClientesNaoVisitadosController", ClientesNaoVisitadosController);

    /* @ngInject */
    function ClientesNaoVisitadosController(
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService,
        RelatorioService,
        ClientesNaoVisitadosService,
        ListarLeituristas
    ) {
        var vm = this;

        init();

        function init() {
            vm.tipoProcesso = SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso);
            vm.leituristas = ListarLeituristas.data;

            vm.filtro = {};
            vm.filtro.leituristas = [];
            vm.filtro.grupo = [];

            vm.metodos = {
                gerarRelatorio: gerarRelatorio,
                pesquisarGrupos: pesquisarGrupos
            };

            vm.todosGrupos = true;
            vm.searchTermGrupos = "";

            vm.clearSearchTermGrupos = function () {
                vm.searchTermGrupos = "";
            };

            vm.limparSelecaoGrupos = function () {
                if (vm.todosGrupos === true) {
                    vm.filtro.grupo = [];
                }
            };

            vm.onChangeItemGrupos = function () {
                var selecionados = (vm.filtro.grupo || []);
                if (selecionados.length > 0) {
                    vm.todosGrupos = false;
                }

                if ((vm.grupos && selecionados.length === vm.grupos.length) || selecionados.length === 0) {
                    vm.todosGrupos = true;
                    vm.filtro.grupo = [];
                }
            };
        }

        function gerarRelatorio() {
            _iniciarProgresso();

            var viewModel = {
                tipoProcesso: vm.tipoProcesso,
                mesAnoReferencia: vm.filtro.mes.toString().padStart(2, '0') + "/" + vm.filtro.ano,
                leituristas: vm.filtro.leituristas.map(function (leiturista) { return leiturista.codigo; })
            };

            if (vm.tipoProcesso == "02") {
                viewModel.grupoLeitura = (vm.filtro.grupo || []).map(function (grupo) { return grupo.codigo; });
            }

            var gerarRelatorioPromise = ClientesNaoVisitadosService.gerarRelatorio(viewModel);

            gerarRelatorioPromise
                .then(function (success) {

                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                }, function (error) {
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                })
                .finally(function () { _finalizarProgresso() });
        }

        function pesquisarGrupos(mes, ano) {
            if (vm.tipoProcesso == "02" && (mes && ano)) {
                vm.filtro.grupo = undefined;
                vm.emProgressoBuscaGrupo = true;
                ClientesNaoVisitadosService.filtrarGrupos(mes, ano)
                    .then(
                        function (success) {
                            vm.emProgressoBuscaGrupo = false;
                            vm.grupos = (success.data || []).map(function (cod) {
                                return { codigo: cod, identificadorGrupo: cod };
                            });
                        },
                        function (error) {
                            console.log(error.data);
                        }
                    ).finally(function () {
                        vm.emProgressoBuscaGrupo = false;
                    });
            }
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.relatorios.historicoconsumo', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.relatorio.historicoConsumo;
    //State
    $stateProvider
      .state('app.relatorios_historicoconsumo', {
        url: '/relatorios/historicoconsumo',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'HistoricoConsumoController as vm'
          },
          'relatorios-form@app.relatorios_historicoconsumo': {
            templateUrl: rotasHtml.form
          }
        }
      });

  }
})();

/* eslint-disable no-undef */
/* eslint-disable no-console */
(function () {
    "use strict";

    angular
        .module("app.relatorios.historicoconsumo")
        .controller("HistoricoConsumoController", HistoricoConsumoController);

    /* @ngInject */
    function HistoricoConsumoController(
        SessionStorageService,
        KeysSessionStorage,
        HistoricoConsumoService,
        MdDialogService
    ) {
        var vm = this;

        init();

        function init() {

            vm.tipoDetalheCalculo = SessionStorageService.recuperar(
                KeysSessionStorage.tipoDetalheCalculo
            );

            vm.metodos = {
                gerarRelatorio: gerarRelatorio,
            };

        }

        function gerarRelatorio() {
            _iniciarProgresso();

            var viewModel = {
                referenciaAnoInicial: vm.entidade.anoInicial,
                referenciaMesInicial: vm.entidade.mesInicial,
                referenciaAnoFinal: vm.entidade.anoFinal,
                referenciaMesFinal: vm.entidade.mesFinal,
                codigoCliente: vm.entidade.codigoCliente
            }

            var gerarRelatorio = HistoricoConsumoService.gerarRelatorio(viewModel);

            gerarRelatorio
                .then(function (success) {

                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                }, function (error) {
                    MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                    console.log(error)
                })
                .finally(function () { _finalizarProgresso() });
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.relatorios.estatisticas', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, RotasHtml) {
    var rotasHtml = RotasHtml.relatorio.estatistica;
    //State
    $stateProvider
      .state('app.relatorios_estatisticas', {
        url: '/relatorios/estatisticas',
        module: 'privado',
        views: {
          'content@app': {
            templateUrl: rotasHtml.templateUrl,
            controller: 'EstatisticasController as vm',
            abstract: true
          },
          'relatorios-form@app.relatorios_estatisticas': {
            templateUrl: rotasHtml.form,
          },
          'relatorios-form-caema@app.relatorios_estatisticas': {
            templateUrl: rotasHtml.caema.form,
          }
        },
        resolve: {
          listarLeituristas: function (Api, RequisicaoGenericaService) {
            return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarDadosLookup);
          },
          listaRegionais: function (RegionalService) {
            return RegionalService.listarTodos();
          }
        }
      });

  }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.estatisticas')
        .controller('EstatisticasController', EstatisticasController);

    /* @ngInject */
    function EstatisticasController($window, $interval, urlApi, EstatisticasServico,
        MunicipioService, MdDialogService, listarLeituristas,
        SessionStorageService, KeysSessionStorage, RelatorioService) {
        var vm = this;
        var processando = undefined;

        init();

        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.entidade = {};
            vm.listandoMunicipios = false;
            vm.listaRegionais = SessionStorageService.recuperar(KeysSessionStorage.usuarioAgrupamentos);
            vm.leituristas = listarLeituristas.data;
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            if (vm.listaRegionais && vm.listaRegionais.length > 0) {
                vm.entidade.regional = vm.listaRegionais[0].codigo;
                onChangeRegional();
            }
        }

        vm.metodos = {
            gerarRelatorio: gerarRelatorio,
            onChangeRegional: onChangeRegional
        };

        function gerarRelatorio() {
            inicioProgresso();

            var viewModel = {
                dataInicio: vm.entidade.dataInicio,
                dataFim: vm.entidade.dataFim,
                leiturista: vm.entidade.leiturista,
                filtrosUtilizados: angular.copy(EstatisticasServico.constroiFiltrosUtilizados(vm.entidade)),
                agrupamento: vm.entidade.agrupamento,
                regional: vm.entidade.regional,
                municipio: vm.entidade.municipio,
                utilizaDataRealColeta: vm.entidade.utilizaDataRealColeta
            };

            EstatisticasServico.enviarFormulario(viewModel)
                .then(function (success) {
                    fimProgresso();
                    MdDialogService.alertPadrao("Relatório gerado com sucesso!");
                    var file = new Blob([success.data], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                },
                    function (error) {
                        fimProgresso();
                        MdDialogService.alertPadrao(RelatorioService.arrayBufferToString(error.data));
                        console.log(error)
                    }
                )
        }

        function onChangeRegional() {
            vm.listandoMunicipios = true;
            MunicipioService.listarMunicipios(vm.entidade.regional).then(
                function (success) {
                    vm.listaMunicipios = success.data;
                    vm.listandoMunicipios = false;
                },
                function (error) {
                    console.error(error);
                    vm.listandoMunicipios = false;
                }
            );
        }

        function inicioProgresso() {
            vm.emProgresso = true;
        }

        function fimProgresso() {
            vm.emProgresso = false;
        }
    }
})();

(function () {
  'use strict';

  angular
      .module('app.controleacessomenu.controlemenu', [])
      .config(config);

  /** @ngInject */
  function config($stateProvider) {
      //State
      $stateProvider
          .state('app.controleacessomenu_controlemenu', {
              url: '/controle-acesso',
              module: 'privado',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/controleacessomenu/controleacesso/views/controle-acesso.html',
                      controller: 'ControleAcessoController as vm'
                  },
                  'controleacesso-form@app.controleacessomenu_controlemenu': {
                      templateUrl: 'app/main/controleacessomenu/controleacesso/views/controle-acesso-form.html'
                  }
              },
              resolve: {
                  ListarUsuariosPorPerfil: function (RequisicaoGenericaService, Api) {
                      return RequisicaoGenericaService.listarSemParams(Api.perfil.listarUsuariosPerfil);
                  }
              }
          });
  }
})();

(function () {
  'use strict';

  angular.module('app.controleacessomenu.controlemenu')
    .controller('ControleAcessoController', ControleAcessoController);

  /** @ngInject */
  function ControleAcessoController(ListarUsuariosPorPerfil, RequisicaoGenericaService, Api, MdDialogService) {
    var vm = this;

    init();

    function init() {
      vm.perfil = ListarUsuariosPorPerfil.data;
      if (vm.perfil && vm.perfil.length > 0) {
        filtrarColaboradoresPorPerfil(vm.perfil[0].descricao);
      }
      else{
        vm.menuTitulo = "";
        vm.menuItemTitulo = "";
        vm.perfil = [{descricao: 'Nenhum perfil encontrado!'}]
        vm.menus = [{titulo : 'Nenhum rotina encontrada!'}];
      }
    }

    vm.metodosInternos = {
      limparDadosSubrotinas: _limparDadosSubrotinas,
      verificarSeTodosMenuSubItensEstaoMarcados: _verificarSeTodosMenuSubItensEstaoMarcados
    }

    vm.metodos = {
      filtrarColaboradoresPorPerfil: filtrarColaboradoresPorPerfil,
      filtrarMenusItensPorMenu: filtrarMenusItensPorMenu,
      filtrarMenusSubItensPorMenuItem: filtrarMenusSubItensPorMenuItem
    }

    vm.metodosMenu = {
      controleAcessoMenu: controleAcessoMenu,
      atualizarMenuItens: atualizarMenuItens
    }

    vm.metodosMenuItem = {
      controleAcessoMenuIten: controleAcessoMenuIten,
      selecionarTodos: selecionarTodos
    }

    function _limparDadosSubrotinas() {
      vm.menuItemTitulo = "";
      vm.menusSubItens = [];
    }

    function _verificarSeTodosMenuSubItensEstaoMarcados() {
      var temMenuSubItemSelecionado = vm.menuItemSelecionado.itens.some(function (item) {
        return ((true) == (item.selecionado));
      });

      if (!temMenuSubItemSelecionado) {
        vm.menuItemSelecionado.selecionado = false;
      }
      else {
        vm.menuItemSelecionado.selecionado = true;
      }

    }

    function filtrarColaboradoresPorPerfil(perfilCodigo) {
      if (vm.perfil && vm.perfil.length > 0) {
        var perfil = vm.perfil.filter(function (item) {
          if (item.descricao == perfilCodigo) {
            return item;
          }
        });

        vm.perfilDescricao = perfil[0].descricao;
        vm.colaboradores = perfil[0].usuarios;

        RequisicaoGenericaService.listarSemParams(Api.menu.listarporperfil + perfil[0].codigo + "/" + true).then(
          function (success) {
            vm.controleAcesso = success.data;
            vm.menus = vm.controleAcesso.menus;
            if (vm.menus.length > 0) {
              filtrarMenusItensPorMenu(vm.menus[0].titulo);
            }
            else {
              vm.menuTitulo = "";
              vm.menusItens = [];
            }
          },
          function (error) {
            MdDialogService.alertPadrao(error.data);
          }
        );
      }
    }

    function filtrarMenusItensPorMenu(menuTitulo) {
      var menu = vm.menus.filter(function (menu) {
        if (menu.titulo == menuTitulo) {
          return menu.itens;
        }
      });

      vm.menuTitulo = menu[0].titulo;
      vm.menusItens = menu[0].itens;
      if (vm.menusItens[0].itens.length > 0) {
        vm.menuSelecionado = vm.menusItens[0];
        filtrarMenusSubItensPorMenuItem(vm.menusItens[0].itens[0].titulo);
      }
      else {
        _limparDadosSubrotinas();
      }
    }

    function filtrarMenusSubItensPorMenuItem(menuItem) {
      vm.menuItemSelecionado = menuItem;
      vm.menuItemTitulo = menuItem.titulo;
      vm.menusSubItens = menuItem.itens;
      if (vm.menusSubItens.length == 0) {
        var obj = {
          titulo: 'Não há sub-rotinas vinculadas.'
        }
        vm.menusSubItens.push(obj);
      }
    }

    function controleAcessoMenu(menuItem) {
      vm.menuItemSelecionado = menuItem;
      if (menuItem.selecionado) {
        menuItem.selecionado = false;
      }
      else {
        menuItem.selecionado = true;
      }

      if (menuItem.itens.length > 0) {
        vm.menuItemTitulo = menuItem.titulo;
        atualizarMenuItens(menuItem.selecionado, menuItem.itens);
      }
      else {
        _limparDadosSubrotinas();
        vm.menuItemTitulo = menuItem.titulo;
      }

      RequisicaoGenericaService.editar(Api.menu.atualizar, vm.controleAcesso);
    }

    function atualizarMenuItens(opcao, menuSubItens) {
      vm.menusSubItens = menuSubItens;
      for (var i = menuSubItens.length - 1; i >= 0; i--) {
        menuSubItens[i].selecionado = opcao;
      }
    }

    function controleAcessoMenuIten(opcao, menuItem) {
      menuItem.selecionado = !opcao;
      _verificarSeTodosMenuSubItensEstaoMarcados();
      RequisicaoGenericaService.editar(Api.menu.atualizar, vm.controleAcesso);
    }

    function selecionarTodos(opcao) {
      var selecionado = true;
      if (opcao == 'Adicionar todos') {
        selecionado = true;
      }
      else if (opcao == 'Remover todos') {
        selecionado = false;
      }

      if (vm.menusSubItens && vm.menusSubItens.length > 0) {
        for (var i = vm.menusSubItens.length - 1; i >= 0; i--) {
          vm.menusSubItens[i].selecionado = selecionado;
        }
        _verificarSeTodosMenuSubItensEstaoMarcados();
        RequisicaoGenericaService.editar(Api.menu.atualizar, vm.controleAcesso);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.carga')
    .controller('GerenciamentoCargaTotalizadorController', GerenciamentoCargaTotalizadorController);

  function GerenciamentoCargaTotalizadorController(GerenciamentoCargaService, SessionStorageService, KeysSessionStorage) {
    var vm = this;

    // Data
    init();

    // Methods
    function init() {

      if (SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso) == "01") {
        vm.tituloTotalizadorCancelamentos = "Cancelamento";
      }
      else {
        vm.tituloTotalizadorCancelamentos = "Não impressas/Retidas";
      }
      vm.habilitarTotalizadores = false;
      vm.totalizador = GerenciamentoCargaService.getTotalizadores();
      GerenciamentoCargaService.listenerTotalizadores = function (callback) {
        var dados = callback();
        vm.totalizador = dados;
        if (dados.clientes > 0) {
          vm.habilitarTotalizadores = true;
        }
        else {
          vm.habilitarTotalizadores = false;
        }

        GerenciamentoCargaService.setCargaDisponibilizada(dados.clientes > 0);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.gerenciamento.carga')
    .controller('GerenciamentoCargaLeituristaController', GerenciamentoCargaLeituristaController);

  function GerenciamentoCargaLeituristaController(GerenciamentoCargaService, $timeout,
    MdDialogService, GeracaoArquivoService,
    $mdDialog, $state, RotasHtml,
    MdToastService, SessionStorageService, KeysSessionStorage,
    RequisicaoGenericaService, ArquivosService, Api, ServicosGenericoService) {
    var vm = this;

    vm.metodos = {
      habilitarPesquisa: habilitarPesquisa,
      desabilitarPesquisa: desabilitarPesquisa,
      atualizarLeituristaDashboard: atualizarLeituristaDashboard,
      habilitarDetalhes: habilitarDetalhes,
      habilitarLeituristaDashboard: habilitarLeituristaDashboard,
      abrirDisponibilizarCarga: abrirDisponibilizarCarga,
      abrirRastreamento: abrirRastreamento,
      abrirMonitoramento: abrirMonitoramento,
      abrirGerarArquivoRetorno: abrirGerarArquivoRetorno,
      gerarArquivoRetorno: gerarArquivoRetorno
    }

    // Data
    init();

    // Methods
    function init() {
      _alterarDashboardDetalhamentoPorTipoProcesso(SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso));
      vm.tipoProcesso = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa).tipoProcesso;
      vm.habilitarLeituristas = false;
      vm.preLoader = false;
      vm.habilitarPesquisa = false;
      vm.detalhes = false;
      vm.emProgresso = true;
      vm.leituristasDashboard = 0;
      vm.arquivoProgress = [];
      vm.atualizouLeituristaSelecionado = false;
      vm.tipoProcesso = SessionStorageService.recuperar(KeysSessionStorage.tipoProcesso);
      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
      vm.sistemaGestorEhThema = vm.parametros.coletor.sistemaGestor == 3;
      vm.leituristas = GerenciamentoCargaService.getLeituristas();

      GerenciamentoCargaService.listenerLeituristas = function (callback) {
        var dados = callback();
        if (dados.length > 0) {
          // vm.detalhes = false;
          vm.emProgresso = true;
          vm.habilitarLeituristas = true;
          vm.leituristas = angular.copy(dados);
          vm.leituristasFiltrados = angular.copy(dados);
          vm.preLoader = false;
          if (!vm.leituristaSelecionado) {
            vm.leituristaSelecionado = vm.leituristas[0];
          }
          _verificarLeituristaSelecionadoLista(vm.leituristasFiltrados, vm.leituristaSelecionado);
          atualizarLeituristaDashboard(vm.leituristaSelecionado);

        } else {
          vm.habilitarLeituristas = false;
          vm.leituristas = GerenciamentoCargaService.getLeituristas();
          vm.leituristasFiltrados = [];
          MdToastService.toastWarning("Nenhuma carga disponibilizada para a data informada.");
        }
      }

      vm.metodos = {
        habilitarPesquisa: habilitarPesquisa,
        desabilitarPesquisa: desabilitarPesquisa,
        atualizarLeituristaDashboard: atualizarLeituristaDashboard,
        habilitarDetalhes: habilitarDetalhes,
        habilitarLeituristaDashboard: habilitarLeituristaDashboard,
        abrirDisponibilizarCarga: abrirDisponibilizarCarga,
        abrirRastreamento: abrirRastreamento,
        abrirMonitoramento: abrirMonitoramento,
        abrirGerarArquivoRetorno: abrirGerarArquivoRetorno,
        gerarArquivoRetorno: gerarArquivoRetorno,
        abrirChat: abrirChat,
        abrirDisponibilizacaoTarefa: abrirDisponibilizacaoTarefa
      }
    }

    function atualizarLeituristaDashboard(leiturista) {

      vm.emProgresso = true;
      vm.leituristaSelecionado = leiturista;
      GerenciamentoCargaService.setLeituristaSelecionado(leiturista);
      vm.leituristasDashboard = leiturista;
      vm.dashboardData = {
        widget6: {
          footerLeft: {
            titulo: 'Clientes',
            total: leiturista.dashboard.clientes
          },
          footerRight: {
            titulo: vm.tituloFooterRight, //'Cancelamentos',
            total: leiturista.dashboard.cancelamentos
          },
          mainChart: [{
            label: 'Leitura normal',
            values: leiturista.dashboard.leituras,
            cor: '#339933'
          },
          {
            label: 'Leitura com ocorrência',
            values: leiturista.dashboard.leiturasComOcorrencia,
            cor: '#ff9900'
          },
          {
            label: 'Somente ocorrência',
            values: leiturista.dashboard.somenteOcorrencia,
            cor: '#ff3300'
          },
          {
            label: 'Não visitado(s)',
            values: leiturista.dashboard.pendentes,
            cor: '#999999'
          }
          ]
        }
      }

      vm.dashboard = {
        titulo: leiturista.apelido,
        retencoes: 'Contas retidas: ' + '0',
        detalhe: {
          nomeArquivo: leiturista.detalhe.nomeArquivo,
          disponilizada: leiturista.detalhe.dataExportacao,
          dataPrimeiraLeitura: leiturista.detalhe.dataPrimeiraLeitura,
          dataUltimaLeitura: leiturista.detalhe.dataUltimaLeitura
        },
        mainChart: {
          config: {
            visible: false,
            refreshDataOnly: true,
            deepWatchData: true
          },
          options: {
            chart: {
              type: 'pieChart',
              showLegend: false,
              color: [],
              //donut: true,
              clipEdge: true,
              cornerRadius: 0,
              labelType: 'percent',
              //padAngle: 0.02,
              x: function (d) {
                return d.label;
              },
              y: function (d) {
                return d.value;
              },
              tooltip: {
                gravity: 's',
                classes: 'gravity-s'
              },
              noData: ""
            }
          },
          data: []
        },
        footerLeft: vm.dashboardData.widget6.footerLeft,
        footerRight: vm.dashboardData.widget6.footerRight,
        ranges: vm.dashboardData.widget6.ranges,
        currentRange: '',


        atualizar: function () {

          angular.forEach(vm.dashboardData.widget6.mainChart, function (data) {
            if (data.values > 0) {
              vm.dashboard.mainChart.data.push({
                label: data.label,
                value: data.values
              });
              vm.dashboard.mainChart.options.chart.color.push(data.cor);
            }
          });
        },

        init: function () {
          vm.dashboard.atualizar();
        }
      };

      vm.dashboard.init();

      $timeout(function () {
        vm.dashboard.mainChart.config.visible = true;
        vm.emProgresso = false;
      }, 750);

    }


    function habilitarPesquisa() {
      vm.habilitarPesquisa = true;
    }

    function desabilitarPesquisa() {
      vm.filtroLeiturista = "";
      vm.habilitarPesquisa = false;
    }

    function habilitarDetalhes(opcao) {
      vm.detalhes = opcao;
    }

    function habilitarLeituristaDashboard(leiturista) {
      vm.detalhes = false;
      /*
      var leiturista = vm.leituristasFiltrados.filter(function (item) {
        if (item.codigo == leiturista.codigo && item.detalhe.nomeArquivo == leiturista.detalhe.nomeArquivo) {
          return item;
        }
      });
      atualizarLeituristaDashboard(leiturista[0]);*/
      atualizarLeituristaDashboard(vm.leituristaSelecionado);
    }

    function gerarArquivoRetorno(leiturista, $event) {
      var nomeArquivo = leiturista.detalhe.nomeArquivo;
      vm.arquivoProgress[leiturista.codigo] = true;

      vm.arquivoProgress[leiturista.codigo] = true;

      if (vm.sistemaGestorEhThema) {
        var filtro = {
          codigoLeiturista: leiturista.codigo,
          dataExportacao: _getDataExportacao(),
          nomeArquivoExportacao: nomeArquivo
        };

        RequisicaoGenericaService
          .salvar(Api.geracaoArquivoRetorno.gerarArquivoRetorno, filtro).then(
            function (success) {
              return ArquivosService.baixarArquivoBytes(success.data.bytesArquivo, success.data.arquivos[0], success.data.tipoArquivo);
            },
            function (error) {
              if (error.data && error.data.retornoErro && error.data.retornoErro.mensagemErro) {
                MdDialogService.alertPadrao(
                  "Atenção",
                  null,
                  error.data.retornoErro.mensagemErro
                );
              } else {
                ServicosGenericoService.tratarErroAPI(error.data);
              }
            }).finally(function () {
              vm.arquivoProgress[leiturista.codigo] = false;
            });
      } else {
        GeracaoArquivoService.gerarArquivo(
          leiturista.codigo,
          _getDataExportacao(),
          nomeArquivo,
          function () {
            vm.arquivoProgress[leiturista.codigo] = false;
          },
          function (error) {
            MdDialogService.alertPadrao(error.data, event);
            vm.arquivoProgress[leiturista.codigo] = false;
          });
      }
    }

    function abrirDisponibilizarCarga(event, leituristaCodigo) {
      $mdDialog.show({
        controller: 'ExportacaomobileController',
        controllerAs: 'vm',
        templateUrl: RotasHtml.gerenciamentoCarga.leiturista.dialogs.disponibilizarCarga,
        //parent: ---------------,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          LeituristaCodigo: leituristaCodigo,
        },
      }).then().finally(function () {
        _atualizarDashboard();
      });
    }

    function abrirRastreamento(leiturista) {
      if (leiturista.dashboard.leituras === 0 && leiturista.dashboard.leiturasComOcorrencia === 0 && leiturista.dashboard.somenteOcorrencia === 0) {
        //MdDialogService.alertPadrao("Atenção", null, "Não é possível visualizar o rastreamento dessa carga, pois nenhuma leitura foi realizada até o momento.");
        MdToastService.toastWarning("Não é possível visualizar o rastreamento dessa carga, pois nenhuma leitura foi realizada até o momento.");
      } else {

        $state.go('app.gerenciamento_leitura_rastreamento', {
          leiturista: leiturista,
          data: GerenciamentoCargaService.getDataReferencia(),
          nomeArquivo: vm.dashboard.detalhe.nomeArquivo,
          tarefa: leiturista.tarefa
        });

        /*$state.goNewTab('app.gerenciamento_leitura_rastreamento', {
          leiturista: leiturista,
          data: GerenciamentoCargaService.getDataReferencia(),
          nomeArquivo: vm.dashboard.detalhe.nomeArquivo,
          tarefa: leiturista.tarefa
        }
        );*/
      }
    }

    function abrirMonitoramento(leiturista) {

      if (vm.parametros.coletor.utilizaRotinaGeoprocessamento) {
        $state.go('app.gerenciamento_leitura_monitoramento', {
          leiturista: leiturista,
          data: GerenciamentoCargaService.getDataReferencia(),
          nomeArquivo: vm.dashboard.detalhe.nomeArquivo
        });
      } else {
        //MdDialogService.alertPadrao("Atenção", null, 'Para utilizar o monitoramento é necessário ativar o geoprocessamento nos parâmetros.');
        MdToastService.toastWarning('Para utilizar o monitoramento é necessário ativar o geoprocessamento nos parâmetros.');
      }
    }

    function abrirGerarArquivoRetorno(event, leituristaCodigo) {
      $mdDialog.show({
        controller: 'GeracaoarquivoController',
        controllerAs: 'vm',
        templateUrl: RotasHtml.gerenciamentoCarga.leiturista.dialogs.gerarArquivoRetorno,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          LeituristaCodigo: leituristaCodigo,
          DataExportacao: _getDataExportacao()
        },
        resolve: {
          obterDadosParametro: function () {
            return RequisicaoGenericaService.listarSemParams(Api.parametros.dadosParametro);
          }
        }
      });
    }

    function abrirChat() {
      $state.goNewTab('app.chat', {});
    }

    function _getDataExportacao() {
      return moment(vm.dashboard.detalhe.disponilizada.toString(), 'DD-MM-YYYY').toDate();
    }

    function _alterarDashboardDetalhamentoPorTipoProcesso(tipoProcesso) {
      vm.tituloCarga = "Carga";
      if (tipoProcesso == "02") {
        vm.tipoProcesso02 = true;
        vm.tituloFooterRight = "Não impressas/Retidas";
      } else {
        vm.tipoProcesso02 = false;
        vm.tituloFooterRight = "Cancelamentos";
      }
    }

    function _atualizarDashboard() {
      GerenciamentoCargaService.setProgresso(true);
      MdToastService.toastInfo("Atualizando informações...");
      GerenciamentoCargaService.atualizar(GerenciamentoCargaService.getDataReferencia());
    }

    function _verificarLeituristaSelecionadoLista(leituristas, leiturista) {

      if (leiturista == undefined) {
        atualizarLeituristaDashboard(leituristas[0]);
        return;
      }
      var indexLeituristaSelecionado;
      if (vm.tipoProcesso == '01') {
        leituristas.forEach(function (item, index) {
          if (item.codigo == leiturista.codigo && leiturista.detalhe.nomeArquivo == item.detalhe.nomeArquivo) {
            indexLeituristaSelecionado = index;
          }
        });
        if (angular.isDefined(indexLeituristaSelecionado) && indexLeituristaSelecionado >= 0) {
          vm.leituristaSelecionado = leituristas[indexLeituristaSelecionado];
          //atualizarLeituristaDashboard(leituristas[indexLeituristaSelecionado]);
        }
      } else {
        leituristas.forEach(function (item, index) {
          if (item.apelido === leiturista.apelido && leiturista.detalhe.nomeArquivo === item.detalhe.nomeArquivo) {
            indexLeituristaSelecionado = index;
          }
        });
        if (angular.isDefined(indexLeituristaSelecionado) && indexLeituristaSelecionado >= 0) {
          vm.leituristaSelecionado = leituristas[indexLeituristaSelecionado];
          //atualizarLeituristaDashboard(leituristas[indexLeituristaSelecionado]);
        }
      }
    }

    function abrirDisponibilizacaoTarefa(leituristaCodigo) {
      $mdDialog.show({
        controller: 'DisponibilizarTarefasController',
        controllerAs: 'vm',
        templateUrl: RotasHtml.gerenciamentoCarga.leiturista.dialogs.disponibilizarTarefa,
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          LeituristaCodigo: leituristaCodigo,
          GrupoTarefa: null
        }
      });
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.carga')
        .factory('GerenciamentoCargaService', GerenciamentoCargaService);

    /** @ngInject */
    function GerenciamentoCargaService(urlApi, HubService, $q, RequisicaoGenericaService, Api, $mdSidenav, MdToastService) {

        var _totalizadores = {
            clientes: 0,
            leituras: 0,
            leiturasPercentual: 0,
            leiturasComOcorrencia: 0,
            leiturasComOcorrenciaPercentual: 0,
            somenteOcorrencia: 0,
            somenteOcorrenciaPercentual: 0,
            cancelamentos: 0,
            cancelamentosPercentual: 0,
            pendentes: 0
        };

        var _intervalos = [{
            valor: 60,
            descricao: '60'
        },
        {
            valor: 90,
            descricao: '90'
        },
        {
            valor: 120,
            descricao: '120'
        }
        ];

        var _intervalo = _intervalos[2];

        var _leituristas = {};

        var _dataReferencia = new Date();

        var _progresso;

        var _regionalId = 0;

        var _municipioId = 0;

        var _leituristaSelecionado = undefined;

        var service = {
            data: {},
            form: {},
            getTotalizadores: getTotalizadores,
            getLeituristas: getLeituristas,
            conectarHub: conectarHub,
            atualizar: atualizar,
            setDataReferencia: setDataReferencia,
            getDataReferencia: getDataReferencia,
            getIntervalosAtualizacao: getIntervalosAtualizacao,
            setIntervaloAtualizacao: setIntervaloAtualizacao,
            getIntervaloAtualizacao: getIntervaloAtualizacao,
            setCargaDisponibilizada: setCargaDisponibilizada,
            setProgresso: setProgresso,
            getProgresso: getProgresso,
            setRegionalId: setRegionalId,
            getRegionalId: getRegionalId,
            setMunicipioId: setMunicipioId,
            getMunicipioId: getMunicipioId,
            setLeituristaSelecionado: setLeituristaSelecionado,
            getLeituristaSelecionado: getLeituristaSelecionado,
            atualizarDashboard: _atualizarDashboardCargas,
            buscarDadosDashboard: buscarDadosDashboard
        };

        function conectarHub() {
            var deferred = $q.defer();

            var listeners = [];

            listeners.push({
                nome: "AtualizarDashboardCargas",
                metodo: _atualizarDashboardCargas
            });

            HubService.conectar(urlApi.url_base_api, "gerenciamentoCargaHub", listeners).then(function (success) {
                deferred.resolve(success);
            }).catch(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function atualizar() {

            setProgresso(true);

            var filtro = {
                Data: _dataReferencia,
                RegionalId: _regionalId,
                MunicipioId: _municipioId
            };

            HubService.realizarRequisicao("Atualizar", JSON.stringify(filtro), erroRequisicao);
        }

        function getTotalizadores() {
            return _totalizadores;
        }

        function getLeituristas() {
            return _leituristas;
        }

        function _atualizarDashboardCargas(dados) {
            _setLeituristas(dados.gerenciamento.leituristas);
            _setTotalizadores(dados.totalizador);
        }

        function _setLeituristas(leituristas) {
            _leituristas = angular.copy(leituristas);
            service.listenerLeituristas(function () {
                return getLeituristas();
            });
        }

        function _setTotalizadores(dados) {
            _totalizadores = angular.copy(dados);
            _calcularPercentuais(_totalizadores);
            service.listenerTotalizadores(function () {
                return getTotalizadores();
            });
        }

        function _calcularPercentuais(totalizador) {
            totalizador.leiturasPercentual = (totalizador.leituras * 100) / totalizador.clientes;
            totalizador.leiturasComOcorrenciaPercentual = (totalizador.leiturasComOcorrencia * 100) / totalizador.clientes;
            totalizador.somenteOcorrenciaPercentual = (totalizador.somenteOcorrencia * 100) / totalizador.clientes;
            totalizador.cancelamentosPercentual = (totalizador.cancelamentos * 100) / totalizador.clientes;
        }

        function setDataReferencia(data) {
            _dataReferencia = data;
        }

        function getDataReferencia() {
            return _dataReferencia;
        }

        function getIntervalosAtualizacao() {
            return _intervalos;
        }

        function setIntervaloAtualizacao(tempo) {
            _intervalo = tempo;
            service.listenerIntervalo(function () {
                return tempo;
            });
        }

        function getIntervaloAtualizacao() {
            return _intervalo;
        }

        function setCargaDisponibilizada(dados) {
            if (dados && $mdSidenav("filtro-gerenciamento-carga").isOpen()) {
                $mdSidenav("filtro-gerenciamento-carga").toggle();
            }

            if (!dados && !$mdSidenav("filtro-gerenciamento-carga").isOpen()) {
                $mdSidenav("filtro-gerenciamento-carga").toggle();
            }
            service.listenerResultados(function () {
                return dados;
            });
        }

        function setProgresso(progresso) {
            _progresso = progresso;

            service.listenerProgresso(function () {
                return _progresso;
            });

            service.listenerProgressoControlerPrincipal(function () {
                return _progresso;
            })
        }

        function getProgresso() {
            return _progresso;
        }

        function setRegionalId(id) {
            _regionalId = id;
        }

        function getRegionalId() {
            return _regionalId;
        }

        function setMunicipioId(id) {
            _municipioId = id;
        }

        function getMunicipioId() {
            return _municipioId;
        }

        function setLeituristaSelecionado(leiturista) {
            _leituristaSelecionado = leiturista;
        }

        function getLeituristaSelecionado() {
            return angular.copy(_leituristaSelecionado);
        }

        function buscarDadosDashboard() {
            return RequisicaoGenericaService.listarSemParams(Api.gerenciamentoCarga.buscarDadosIniciais + "?data=" + getDataReferencia().toLocaleDateString());
        }

        function erroRequisicao(erro) {
            setProgresso(false);
            MdToastService.toastErro("Não foram encontrados dados para a pesquisa realizada, devido a falta de conexão com o servidor. Por favor, tente novamente!");
        }

        return service;
    }
})();

(function(){
    'use strict';

    angular
        .module('app.gerenciamento.produtividade')
        .controller('ProdutividadeDashboardController', ProdutividadeDashboardController)

    /** @ngInject */
    function ProdutividadeDashboardController(ProdutividadeService, SessionStorageService, KeysSessionStorage,
         DatatableFactory, $mdDialog, RotasHtml, MdDialogService, DTDefaultOptions){
        var vm = this;
        

        vm.metodos = {
            abrirFiltroProdutividade: abrirFiltroProdutividade,
            abrirDialogDetalhesProdutividade:abrirDialogDetalhesProdutividade,
            abrirDialogDetalhesOciosidade: abrirDialogDetalhesOciosidade,
            abrirDialogDetalhesCritica: abrirDialogDetalhesCritica
        }
        vm.rotasHtml = RotasHtml.gerenciamento.produtividade;
        vm.dialogs = {}
        vm.emProgresso = false;
        init();


        function init(){
            
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);          
            ProdutividadeService.listenerProdutividade = function(callback){
                vm.dadosLeituristas =  callback();
                _montarTotalizadorLeituristas(vm.dadosLeituristas);
                vm.dadosSomatorioGeral = _montarSomatorioGeral(vm.dadosLeituristas);
                vm.filtroUtilizado = ProdutividadeService.getFiltro();
            }
            vm.menus = _construirMenus();
            vm.dtOptionsTabInformacoes = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(_retornaColumnDefs());
            vm.dtOptionsTabInformacoes.deferRender = true;
            vm.dtOptionsTabInformacoes.order = [3, 'desc'];
            DTDefaultOptions.setLoadingTemplate('Carregando dados ...');
            
        }

        function _construirMenus(){
            return [
                {
                    icon: 'icon-filter s20',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltroProdutividade() }                    
                },
                {
                    icon: 'icon-refresh s20',
                    name:"Atualizar dados",
                    direction: top,
                    executarAcaoClick: function() { return _atualizarDadosProdutividade() }
                },
            ]
        }

        function abrirFiltroProdutividade(){
            ProdutividadeService.toggleFiltroProdutividade();
        }     
        
        
        function _montarTotalizadorLeituristas(dados){
            dados.forEach(function(item){
                item.total = _montarTotalizarASerExibido(item.totalizador);
            })
        }

        function _definirFotoLeiturista(dados){
            dados.forEach(function(item){
                if(!item.caminhoFotoLeiturista){
                    item.caminhoFotoLeiturista = '../../../../../assets/images/avatars/user.jpg'
                }
                else {
                    item.caminhoFotoLeiturista = vm.urlApi + item.caminhoFotoLeiturista
                }
            });
        }
        
        function _montarTotalizarASerExibido(totalizador){
            return [
                {title: 'Dias trabalhados', data: totalizador.diasTrabalhados},
                {title: 'Horas trabalhadas', data: totalizador.descricaoHorasTrabalhadas},
                {title: 'Total ociosidade', data: totalizador.descricaoTotalOciosidade},
                {title: 'Leit. recebidas', data: totalizador.leiturasRecebidas, usePipeNumber: true},
                {title: 'Leit. realizadas', data: totalizador.leiturasRealizadas, usePipeNumber: true},
                {title: 'Críticas', data: totalizador.totalCriticas, usePipeNumber: true}
            ]
        }

        function _montarSomatorioGeral(dados){
            var somatorio = {
                leiturasRecebidas: 0,
                leiturasRealizadas: 0,
                criticas: 0
            }

            dados.forEach(function(item){
                somatorio.leiturasRecebidas += item.totalizador.leiturasRecebidas,                
                somatorio.leiturasRealizadas += item.totalizador.leiturasRealizadas,
                somatorio.criticas += item.totalizador.totalCriticas
            });

            return somatorio;
        }

        function _retornaColumnDefs(){
            return [
                {
                    targets: [0,1,4,5,6,7,8,9,10,11,12],
                    sortable: false,
                    orderable: false
                },
                {
                    targets: [12],
                    responsivePriority: 1
                },
                {
                    targets: [3],
                    orderData: 2
                }
            ]
        }

        function _atualizarDadosProdutividade(){
            var viewModel = angular.copy(ProdutividadeService.getFiltro()); 
            vm.mensagemCarregamento = 'Atualizando dados de leituristas...';
            vm.emProgresso = true;
            var pFiltrarDados = ProdutividadeService.filtrarDadosProdutividade(viewModel);
            pFiltrarDados.then(function(success){
                ProdutividadeService.listenerProdutividade(function(){ return success.data});

            }, function(error){
                MdDialogService.alertPadrao("Atenção", event, error.data);
            }).finally(function(){vm.emProgresso = false;})
        }

        function abrirDialogDetalhesProdutividade(dadosDia){
            if(vm.dialogs.detalhesProdutividade) return;
            var viewModel = {
                gleiCodigo: dadosDia.gleiCodigo,
                data: dadosDia.data,
                codigoLeiturista: dadosDia.codigoLeiturista,             
            }

            vm.dialogs.detalhesProdutividade = true;

            var pBuscarDadosDetalhesProdutividade = ProdutividadeService.buscarDadosDetalheProdutividade(viewModel);
            
            dadosDia.emProgressoDetalhesProdutividade = true;
            pBuscarDadosDetalhesProdutividade.then(function(success){                
                $mdDialog.show({
                    controller: 'DialogDetalhesProdutividadeController',
                    controllerAs: 'vm',
                    templateUrl: vm.rotasHtml.dialogs.detalhesProdutividade.templateUrl,
                    targetEvent: null,
                    multiple:true,
                    locals: {
                        DadosDetalheProdutividade: success.data,
                        Filtros: {
                                agrupamento: vm.filtroUtilizado.descricaoAgrupamento,
                                leiturista: dadosDia.leiturista,
                                data: dadosDia.data
                            }
                        }                    
                }).then().finally(function(){
                    vm.dialogs.detalhesProdutividade = false;
                });
            },function (error){
                vm.dialogs.detalhesProdutividade = false;
                MdDialogService.alertPadrao("Atenção", event, error.data);
            }).finally(function(){
                dadosDia.emProgressoDetalhesProdutividade = false;
            });          
         }


         function abrirDialogDetalhesOciosidade(dadosDia){
                if(vm.dialogs.detalhesOciosidade) return;
                vm.dialogs.detalhesOciosidade = true;
                $mdDialog.show({
                    controller: 'DialogDetalhesOciosidadeController',
                    controllerAs: 'vm',
                    templateUrl: vm.rotasHtml.dialogs.detalhesOciosidade.templateUrl,
                    targetEvent: null,
                    multiple:true,
                    locals: {
                        DetalhesOciosidade: dadosDia.detalhesOciosidade,
                        Totalizador: dadosDia.horaOciosidade,
                        Filtro: {
                                agrupamento: vm.filtroUtilizado.descricaoAgrupamento,
                                leiturista: dadosDia.leiturista,
                                data: dadosDia.data
                            }
                        }                    
                }).then().finally(function(){vm.dialogs.detalhesOciosidade = false});
        }  
        
        function abrirDialogDetalhesCritica(dadosDia){
            if(vm.dialogs.detalhesCritica) return;
            var viewModel = {
                gleiCodigo: dadosDia.gleiCodigo,
                data: dadosDia.data,
                codigoLeiturista: dadosDia.codigoLeiturista,             
            }           

            var pBuscarDadosDetalhesCritica = ProdutividadeService.buscarDadosDetalheCritica(viewModel);
            vm.mensagemCarregamento = "Buscando detalhes de críticas..."
            dadosDia.emProgresso = true;

            pBuscarDadosDetalhesCritica.then(function(success){
                vm.dialogs.detalhesCriticas = true;
                $mdDialog.show({
                    controller: 'DialogDetalhesCriticaController as vm',
                    templateUrl: vm.rotasHtml.dialogs.detalhesCritica.templateUrl,
                    targetEvent: event,
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    locals: {
                        Ocorrencias: success.data,
                        Filtro: {
                            agrupamento: vm.filtroUtilizado.descricaoAgrupamento,
                            leiturista: dadosDia.leiturista,
                            data: dadosDia.data
                        },
                        CodigoLeiturista: dadosDia.codigoLeiturista
                    }
                }).then().finally(function(){vm.dialogs.detalhesCriticas = false});
            },function (error){
                vm.dialogs.detalhesCriticas = false;
                MdDialogService.alertPadrao("Atenção", event, error.data);
            }).finally(function(){
                dadosDia.emProgresso = false;
            });   
        }
    }        

}());
/**
 * Created by Victor on 05/12/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.mododeimplantacao')
        .controller('MododeimplantacaoController', MododeimplantacaoController);

    function MododeimplantacaoController($interval, Api, ControleAcessoConfig, ValidacaoService, SessionStorageService,
        RequisicaoGenericaService, MdDialogService, ModoImplantacaoService, ModoImplantacaoFactory) {
        var vm = this;

        var rotaApi = Api.modoimplantacao;
        //#region Data              

        init();

        vm.metodos = {
            ativarModoImplantacao: _ativarModoImplantacao
        };
        //#endregion

        //#region Métodos

        // Método inicializador
        function init() {
            vm.form = {};
            vm.senha = SessionStorageService.recuperar(ControleAcessoConfig.key_modo_implantacao);
            vm.txtSenha = ModoImplantacaoFactory.senha;
            vm.emProgresso = ModoImplantacaoFactory.emProgresso;
            vm.progresso = ModoImplantacaoFactory.progresso;
        }

        function _ativarModoImplantacao(keyativa) {
            if (vm.txtSenha || !keyativa) {
                vm.emProgresso = true;
                ModoImplantacaoService.ativarModoImplantacao(keyativa, vm.txtSenha).then(
                    function (success) {
                        vm.senha = SessionStorageService.recuperar(ControleAcessoConfig.key_modo_implantacao)
                        vm.txtSenha = "";
                        vm.emProgresso = false;
                    },
                    function (error) {
                        vm.senha = SessionStorageService.recuperar(ControleAcessoConfig.key_modo_implantacao)
                        vm.txtSenha = "";
                        vm.emProgresso = false;
                    });
            }
        }

        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.backupbancodados', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtml = RotasHtml.backup_banco_dados;

        $stateProvider
            .state('app.backup_banco_dados', {
                url: '/ferramentasadministrativas/backupbancodados',
                module: 'privado',
                views: {
                    'content@app': {
                        templateUrl: rotasHtml.templateUrl,
                        controller: 'BackupBancoDadosController as vm'
                    },
                    'backupbancodados-form@app.backup_banco_dados': {
                        templateUrl: rotasHtml.form,
                    }
                },
                resolve: {
                    ListarTodos: function (RequisicaoGenericaService, Api) {
                        return RequisicaoGenericaService.listarSemParams(Api.backupbancodados.listarTodos);
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas.backupbancodados')
        .controller('BackupBancoDadosController', BackupBancoDadosController);

    function BackupBancoDadosController(ListarTodos, BackupBancoDadosService, LoginUsuarioService, MdDialogService, DatatableFactory) {
        var vm = this;

        init();

        vm.metodos = {
            gerarBackupBancoDados: gerarBackupBancoDados,
            atualizarDados: atualizarDados
        };

        function init() {
            vm.backups = ListarTodos.data;
            vm.dtOptions = DatatableFactory.construirDtOptionsComPaginacaoResponsivoPadrao([
                {
                    targets: [5],
                    orderable: false
                }
            ]);

            vm.dtOptions.scrollCollapse = true;
            vm.dtOptions.responsive = {
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,
                    type: 'none',
                    target: ''
                }
            };
        }

        function gerarBackupBancoDados() {
            _inciarProgresso("Realizando backup do banco de dados...");

            BackupBancoDadosService.realizarBackupBancoDados(LoginUsuarioService.usuarioArmazenado().login)
                .then(function (succes) {
                    window.open(succes.data);
                    MdDialogService.alertPadraoComEvento("Backup realizado com sucesso.", function () {
                        atualizarDados();
                    });
                }, function (error) {
                    MdDialogService.alertPadraoComEvento(error.data, function () {
                        atualizarDados();
                    });
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }

        function atualizarDados() {
            _inciarProgresso("Buscando dados...");

            BackupBancoDadosService.listarTodos()
                .then(function (succes) {
                    vm.backups = succes.data;
                }, function (error) {
                    MdDialogService.alertPadrao(error.data);
                }).finally(function () {
                    vm.emProgresso = false;
                });
        }


        function _inciarProgresso(mensagem) {
            vm.emProgresso = true;
            vm.mensagem = mensagem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .service('RequisicaoDatamobilService', RequisicaoDatamobilService);

    function RequisicaoDatamobilService(urlApi, $http, $q, LoginUsuarioService) {
        var service = this;
        var urlBase = urlApi.url_datamobil;
        var datamobilToken = null;
        var codigoProduto = 2;

        service.autenticar = autenticar;
        service.get = get;
        service.post = post;
        service.put = put;
        service.delete = _delete;
        service.download = download;
        service.consultarN8N = consultarN8N;
        service.obterConfiguracaoCliente = obterConfiguracaoCliente;
        service.iniciarTrial = iniciarTrial;

        function consultarN8N(data) {
            var url = "https://n8n.srv954202.hstgr.cloud/webhook/DataMobilReader";
            return $http({
                url: url,
                method: "GET",
                params: {
                    Solicitacao: data.solicitacao,
                    CodigoIManager: data.codigoIManager
                }
            });
        }

        function _fazerRequisicaoComRetry(config) {
            var promise = datamobilToken ? $q.resolve() : autenticar();

            return promise.then(function () {
                config.headers = _getHeaders();
                return $http(config);
            }).catch(function (error) {
                if (error.status === 401) {
                    return autenticar().then(function () {
                        config.headers = _getHeaders();
                        return $http(config);
                    });
                }
                return $q.reject(error);
            });
        }

        function _getHeaders() {
            return {
                "Authorization": "Bearer " + datamobilToken,
                "Content-Type": "application/json"
            };
        }

        function _verificarUrlBase() {
            if (!urlBase) {
                var errorMsg = "URL da API Datamobil.IA não configurada em config.json (url_datamobil).";
                console.error(errorMsg);
                return $q.reject(errorMsg);
            }
            return null;
        }

        function autenticar() {
            var error = _verificarUrlBase();
            if (error) return error;

            var usuario = LoginUsuarioService.usuarioArmazenado();
            var credenciais = {
                login: usuario.login,
                codigoUsuario: usuario.codigo
            };

            return $http({
                url: urlBase + '/api/autenticacao/login-externo',
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth": "READER"
                },
                data: credenciais,
                ignoreAuthInterceptor: true
            }).then(function (response) {
                if (response && response.data) {
                    datamobilToken = response.data;
                }
                return response;
            });
        }

        function get(rota, params) {
            var error = _verificarUrlBase();
            if (error) return error;

            var queryParams = angular.extend({}, params, { produto: codigoProduto });

            var config = {
                url: urlBase + rota,
                method: "GET",
                params: queryParams,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function post(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var postData = angular.extend({}, dados, { produto: codigoProduto });

            var config = {
                url: urlBase + rota,
                method: "POST",
                data: postData,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function put(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "PUT",
                data: dados,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function _delete(rota) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "DELETE",
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function download(rota, dados) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + rota,
                method: "POST",
                responseType: 'arraybuffer',
                data: dados,
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function obterConfiguracaoCliente(codigoCliente) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + '/api/cliente/' + codigoCliente + '/configuracao',
                method: "GET",
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }

        function iniciarTrial(codigoCliente) {
            var error = _verificarUrlBase();
            if (error) return error;

            var config = {
                url: urlBase + '/api/cliente/' + codigoCliente + '/iniciar-trial',
                method: "GET",
                ignoreAuthInterceptor: true
            };

            return _fazerRequisicaoComRetry(config);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.datamobil')
        .service("DatamobilIaService", DatamobilIaService);

    function DatamobilIaService(RequisicaoDatamobilService, urlApi) {
        var service = this;
        var codigoImanager = urlApi.codigo_cliente;

        service.favoritos = [];
        service.configuracaoCliente = null;
        service.avaliarResposta = avaliarResposta;
        service.gerarRelatorio = gerarRelatorio;
        service.atualizarFavorito = atualizarFavorito;
        service.listarFavoritos = listarFavoritos;
        service.isFavorito = isFavorito;
        service.criarFavorito = criarFavorito;
        service.removerFavorito = removerFavorito;
        service.editarFavorito = editarFavorito;
        service.baixarArquivoXLSX = baixarArquivoXLSX;
        service.consultarIA = consultarIA;
        service.salvarHistoricoComandos = salvarHistoricoComandos;
        service.obterConfiguracaoCliente = obterConfiguracaoCliente;
        service.iniciarTrial = iniciarTrial;
        service.validarAcessoModulo = validarAcessoModulo;
        service.calcularDiasRestantes = calcularDiasRestantes;

        function listarFavoritos() {
            return RequisicaoDatamobilService.get('/api/comandos-favoritos/obter-todos', { codigoIManager: codigoImanager })
                .then(function (response) {
                    service.favoritos = response.data || [];
                    return service.favoritos;
                });
        }

        function consultarIA(comando) {
            var dados = {
                solicitacao: comando,
                codigoIManager: codigoImanager
            };
            return RequisicaoDatamobilService.consultarN8N(dados);
        }

        function criarFavorito(entidade) {
            var dadosEnvio = {
                codigoIManager: codigoImanager,
                comando: entidade.comando,
                titulo: entidade.titulo || ''
            };
            return RequisicaoDatamobilService.post('/api/comandos-favoritos', dadosEnvio)
                .then(function (response) {
                    var criado = response.data;
                    service.favoritos.push(criado);
                    return criado;
                });
        }

        function removerFavorito(id) {
            return RequisicaoDatamobilService.delete('/api/comandos-favoritos/' + id)
                .then(function () {
                    var index = service.favoritos.findIndex(function (item) { return item.id === id; });
                    if (index > -1) {
                        service.favoritos.splice(index, 1);
                    }
                });
        }

        function editarFavorito(favorito) {
            var dadosEnvio = {
                id: favorito.id,
                comando: favorito.comando,
                titulo: favorito.titulo
            };
            return RequisicaoDatamobilService.put('/api/comandos-favoritos', dadosEnvio)
                .then(function (response) {
                    var atualizado = response.data;
                    var index = service.favoritos.findIndex(function (item) { return item.id === atualizado.id; });
                    if (index > -1) {
                        service.favoritos[index] = atualizado;
                    }
                    return atualizado;
                });
        }

        function atualizarFavorito(comando) {
            var existente = service.favoritos.find(function (item) { return item.comando === comando; });
            if (existente) {
                return removerFavorito(existente.id);
            }
            return criarFavorito(comando);
        }

        function isFavorito(comando) {
            return service.favoritos.some(function (item) { return item.comando === comando; });
        }

        function avaliarResposta(mensagem, avaliacao) {
            var rota = '/api/historico-comandos';
            var dadosPut = {
                id: mensagem.avaliacaoId,
                avaliacaoPositiva: avaliacao === null ? null : avaliacao === 'positiva',
            };
            return RequisicaoDatamobilService.put(rota, dadosPut);
        }

        function salvarHistoricoComandos(mensagem) {
            var usageGpt = mensagem.usageGPT || {};
            var usageGptDiagnostico = mensagem.usageGptDiagnostico || {};

            var dadosEnvio = {
                codigoIManager: codigoImanager,
                comando: mensagem.comando,
                query: mensagem.query || 'Não possui query',
                avaliacaoPositiva: null,
                erro: mensagem.texto || '',
                tokenInputGeradorQuery: usageGpt.input_tokens || 0,
                tokenOutputGeradorQuery: usageGpt.output_tokens || 0,
                tokenTotalGeradorQuery: usageGpt.total_tokens || 0,
                tokenInputDiagnostico: usageGptDiagnostico.input_tokens || 0,
                tokenOutputDiagnostico: usageGptDiagnostico.output_tokens || 0,
                tokenTotalDiagnostico: usageGptDiagnostico.total_tokens || 0
            };

            return RequisicaoDatamobilService.post('/api/historico-comandos', dadosEnvio)
                .then(function (response) {
                    var retorno = response.data;
                    mensagem.avaliacaoId = retorno.id;
                    return retorno;
                });
        }

        function gerarRelatorio(listaDeDados) {
            var rota = '/api/relatorio/gerar-planilha';
            var corpoRequisicao = {
                dados: listaDeDados
            };
            return RequisicaoDatamobilService.download(rota, corpoRequisicao);
        }

        function baixarArquivoXLSX(response, nomeArquivo) {
            var contentType = response.headers('content-type');
            var blob = new Blob([response.data], { type: contentType });
            var nomeFinal = nomeArquivo || 'relatorio.xlsx';

            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = nomeFinal;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }

        function obterConfiguracaoCliente() {
            return RequisicaoDatamobilService.obterConfiguracaoCliente(codigoImanager)
                .then(function (response) {
                    service.configuracaoCliente = response.data;
                    return service.configuracaoCliente;
                });
        }

        function iniciarTrial() {
            return RequisicaoDatamobilService.iniciarTrial(codigoImanager)
                .then(function (response) {
                    service.configuracaoCliente = response.data;
                    return service.configuracaoCliente;
                });
        }

        function validarAcessoModulo() {
            if (!service.configuracaoCliente) {
                return { permitido: false, motivo: 'sem-configuracao' };
            }

            if (service.configuracaoCliente.contratual) {
                return { permitido: true, motivo: 'contratual' };
            }

            if (!service.configuracaoCliente.dataUltimoAcessoGratuito) {
                return { permitido: false, motivo: 'trial-nao-iniciado' };
            }

            var dataLimite = new Date(service.configuracaoCliente.dataUltimoAcessoGratuito);
            var dataAtual = new Date();

            if (dataAtual <= dataLimite) {
                return { permitido: true, motivo: 'trial-ativo' };
            }

            return { permitido: false, motivo: 'trial-expirado' };
        }

        function calcularDiasRestantes() {
            if (!service.configuracaoCliente || !service.configuracaoCliente.dataUltimoAcessoGratuito) {
                return null;
            }

            var dataLimite = new Date(service.configuracaoCliente.dataUltimoAcessoGratuito);
            var dataAtual = new Date();
            var diferencaMs = dataLimite - dataAtual;

            if (diferencaMs <= 0) {
                return { dias: 0, horas: '00', minutos: '00', segundos: '00', expirado: true };
            }

            var dias = Math.floor(diferencaMs / (1000 * 60 * 60 * 24));
            var horas = Math.floor((diferencaMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutos = Math.floor((diferencaMs % (1000 * 60 * 60)) / (1000 * 60));
            var segundos = Math.floor((diferencaMs % (1000 * 60)) / 1000);

            var horasFormatadas = horas < 10 ? '0' + horas : '' + horas;
            var minutosFormatados = minutos < 10 ? '0' + minutos : '' + minutos;
            var segundosFormatados = segundos < 10 ? '0' + segundos : '' + segundos;

            return {
                dias: dias,
                horas: horasFormatadas,
                minutos: minutosFormatados,
                segundos: segundosFormatados,
                expirado: false
            };
        }
    }
})();
/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.erros.manutencao', [])
    .config(Config);

  function Config($stateProvider) {

    // State
    $stateProvider.state('app.em_manutencao', {
      url: '/em-manutencao',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'IndexController as vm'
        },
        'content@app.em_manutencao': {
          templateUrl: 'app/main/erros/manutencao/manutencao.html',
          controller: 'ManutencaoController as vm'
        }
      },
      bodyClass: 'maintenance'
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.erros.manutencao')
    .controller('ManutencaoController', ManutencaoController);

  /** @ngInject */
  function ManutencaoController($state, $rootScope) {
    var vm = this;
    $rootScope.$broadcast('msSplashScreen::remove');
  }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.erros.error-404', [])
        .config(Config);

    function Config($stateProvider, RotasHtml) {
        var rotasHtmlErro404 = RotasHtml.erro_404;
        // State
        $stateProvider.state('app.erros_error-404', {
            url: '/error-404',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'IndexController as vm'
                },
                'content@app.erros_error-404': {
                    templateUrl: rotasHtmlErro404.templateUrl,
                    controller: 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

    }

})();

(function ()
 {
  'use strict';

  angular
    .module('app.erros.error-404')
    .controller('Error404Controller', Error404Controller);

  /** @ngInject */
  function Error404Controller($state, $rootScope)
  {
    var vm = this;
    // Data

    // Methods

    //////////
  }
})();

(function () {
    "use strict";

    angular
        .module("app.controlecarga.faturasretidas")
        .controller("ControleCargaFaturasRetidasController", ControleCargaFaturasRetidasController);

    /** @ngInject */
    function ControleCargaFaturasRetidasController(
        ControleCargaFaturasRetidasService,
        $scope
    ) {
        var vm = this;
        vm.emProgresso = false;
        vm.filtroUtilizado = null;
        vm.listaFaturasRetidas = [];
        vm.setorSelecionado = [];
        vm.rotaSelecionada = [];
        vm.setoresUnicos = [];
        vm.rotasUnicas = [];
        vm.dtOptions = configDataTable([
            {
                targets: [0],
                type: 'num',
                render: function (data, type, row, meta) {
                    if (type === 'sort' || type === 'type') {
                        var fatura = vm.listaFaturasRetidas[meta.row];
                        return fatura ? fatura.codigoLigacaoPrincipal : '';
                    }
                    return data;
                },
                orderable: true
            },
            {
                targets: [3, 4],
                orderable: false
            },
        ]);
        vm.dtOptions.order = [[0, "asc"]];
        vm.dtOptions.dom = 'rt<"bottom"<"left"<"info"i>>>';
        vm.dtOptions.responsive = false;

        vm.metodos = {
            abrirFiltro: abrirFiltro,
            configuraMdSelectSetor: configuraMdSelectSetor,
            configuraMdSelectRota: configuraMdSelectRota,
            toggleDetalhesFatura: toggleDetalhesFatura,
            recolherTodasLinhas: recolherTodasLinhas,
        }

        init();

        function init() {
            ControleCargaFaturasRetidasService.onFiltroRealizado(function (resultado) {
                vm.listaFaturasRetidas = resultado.data;
                vm.filtroUtilizado = ControleCargaFaturasRetidasService.getFiltro();
                vm.setoresUnicos = Array.from(new Set(vm.listaFaturasRetidas.map(function (fatura) { return fatura.setorPrincipal; })));
                vm.rotasUnicas = Array.from(new Set(vm.listaFaturasRetidas.map(function (fatura) { return fatura.rotaPrincipal; })));
            });

            ControleCargaFaturasRetidasService.onProgressoChanged(function (emProgresso) {
                vm.emProgresso = emProgresso;
            });
        }

        function abrirFiltro() {
            ControleCargaFaturasRetidasService.toggleFiltro();
        }

        function configuraMdSelectSetor() {
            vm.filtrarSetores = "";
            angular.element('#select-setor').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configuraMdSelectRota() {
            vm.filtrarRotas = "";
            angular.element('#select-rota').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function configDataTable(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                searching: true,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            vm.metodos.recolherTodasLinhas(api);
                            api.search(event.target.value).draw();
                        });
                    }

                    function filtrarDados() {
                        var setoresSelecionados = vm.setorSelecionado || [];
                        var rotasSelecionadas = vm.rotaSelecionada || [];

                        vm.metodos.recolherTodasLinhas(api);

                        api.column(3).search(setoresSelecionados.map(function (setor) {
                            return '^' + setor + '$';
                        }).join('|'), true, false).draw();

                        api.column(4).search(rotasSelecionadas.map(function (rota) {
                            return '^' + rota + '$';
                        }).join('|'), true, false).draw();
                    }

                    $scope.$watchGroup(['vm.setorSelecionado', 'vm.rotaSelecionada'], function (newValue, oldValue) {
                        filtrarDados();
                    });

                    angular.element('tbody').off('click', 'td.details-control.has-dependentes');
                    angular.element('tbody').on('click', 'td.details-control.has-dependentes', function () {
                        var tr = angular.element(this).closest('tr');
                        var row = api.row(tr);
                        vm.metodos.toggleDetalhesFatura(tr[0], row, api);
                    });

                    api.on('order.dt', function () {
                        vm.metodos.recolherTodasLinhas(api);
                    });

                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }

        function toggleDetalhesFatura(tr, row, dtInstance) {
            if (row.child.isShown()) {
                row.child.hide();
                angular.element(tr).removeClass('shown');
            } else {
                var rowIndex = dtInstance.row(tr).index();
                var fatura = vm.listaFaturasRetidas[rowIndex];
                var $injector = angular.element(document.body).injector();
                var $compile = $injector.get('$compile');
                var $rootScope = $injector.get('$rootScope');
                var childScope = $scope.$new(true);
                childScope.dependentes = fatura && fatura.dependentes ? fatura.dependentes : [];
                var tabelaDependentesElem = $compile('<tabela-dependentes dependentes="dependentes"></tabela-dependentes>')(childScope);
                row.child(tabelaDependentesElem).show();
                angular.element(tr).addClass('shown');
            }
        }

        function recolherTodasLinhas(dtInstance) {
            if (!dtInstance) return;
            dtInstance.rows().every(function () {
                var row = this;
                if (row.child.isShown()) {
                    row.child.hide();
                }
            });
            angular.element('tr.shown').removeClass('shown');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.controlecarga.trocarsequencial')
        .controller('TrocarSequencialController', TrocarSequencialController)

    /** @ngInject */
    function TrocarSequencialController(SessionStorageService, KeysSessionStorage,
        TrocarSequencialService, DatatableFactory, urlApi, MdDialogService, $mdSidenav) {
        var vm = this;

        vm.parametro = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

        init();

        $(document).ready(function () {
            $('#troca-sequencial').on('click', function (event) {
                if (vm.dados == undefined) {
                    $mdSidenav('filtro-trocarsequencial').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        vm.metodos = {
            abrirFiltroTrocarSequencial: abrirFiltroTrocarSequencial,
            abrirDialogTrocarSequencial: abrirDialogTrocarSequencial,
            salvarTrocaSequencial: salvarTrocaSequencial
        };

        function init() {
            vm.urlApi = urlApi.url_base_api;
            vm.dados = undefined;
            TrocarSequencialService.listenerDadosTarefas = function (callback) {
                vm.dados = callback();
                console.log('vm.dados : ', vm.dados);
                _constistirFotoLeiturista(vm.dados);
            }
            vm.columnDefs = _construirColumnDefs();
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(vm.columnDefs);
            if (!vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                vm.dtOptions.order = [5, 'asc'];
            } else {
                vm.dtOptions.order = [6, 'asc'];
            }
            vm.dtOptions.scrollY = '45vh';
            vm.dtOptions.scrollCollapse = true;
        }

        function abrirFiltroTrocarSequencial() {
            TrocarSequencialService.toggleFiltro();
        }

        function _construirColumnDefs() {
            if (!vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                return [
                    {
                        targets: [6],
                        responsivePriority: 1,
                        orderable: false
                    },
                ];
            } else {
                return [
                    {
                        targets: [7],
                        responsivePriority: 1,
                        orderable: false
                    },
                ];
            }
        }

        function abrirDialogTrocarSequencial(tarefa) {
            var pDialog = TrocarSequencialService.abrirDialogAlterarSequencial(tarefa);
            pDialog.then(function (sequencial) { tarefa.sequencial = sequencial; });
        }

        function salvarTrocaSequencial() {
            _iniciarProgresso();

            var validacao = _validarDadosTarefa(vm.dados.tarefas);

            if (validacao) {
                MdDialogService.alertPadrao("Atenção", event, validacao);
                _finalizarProgresso();
                return;
            }
            var tarefas = vm.dados.tarefas.filter(function (item) {
                return !item.emCampo
            });

            if (vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                var pSalvarMultiplosGrupos = TrocarSequencialService.alterarSequencialTarefasMultiplosGrupos(tarefas);

                pSalvarMultiplosGrupos.then(function (success) {
                    MdDialogService.alertPadrao(success.data);
                }, function (error) {
                    MdDialogService.alertPadrao(error.data)
                }).finally(function () { _finalizarProgresso() });
            } else {
                var pSalvar = TrocarSequencialService.alterarSequencialTarefas(tarefas);

                pSalvar.then(function (success) {
                    MdDialogService.alertPadrao(success.data);
                }, function (error) {
                    MdDialogService.alertPadrao(error.data)
                }).finally(function () { _finalizarProgresso() });
            }
        }

        function _constistirFotoLeiturista(dados) {
            if (!dados.leiturista.caminhoFoto) {
                dados.leiturista.caminhoFoto = '../../../../../assets/images/avatars/user.jpg'
            }
            else {
                dados.leiturista.caminhoFoto = vm.urlApi + vm.dados.leiturista.caminhoFoto
            }
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _validarDadosTarefa(tarefas) {

            var textoSingular = vm.parametro.tipoProcesso == '01' ? 'carga' : 'tarefa';
            var textoPlural = vm.parametro.tipoProcesso == '01' ? 'cargas' : 'tarefas';

            if (tarefas.length == 1 && tarefas[0].emCampo) return 'Não é possível alterar o sequencial de uma ' + textoSingular + ' em campo.'
            if (tarefas.some(function (item) { return !item.sequencial && !item.emCampo })) return 'É preciso informar o sequencial de todas as ' + textoPlural + '.';
            if (tarefas.some(function (item) { return item.sequencial == 0 && !item.emCampo })) return 'Não é possível salvar ' + textoSingular + ' com sequencial zero.';
            if (_verificarSequenciaisIguais(tarefas)) return 'Não é possível salvar duas ou mais ' + textoPlural + ' com o mesmo sequencial.';
        }

        function _verificarSequenciaisIguais(tarefas) {
            var sequenciais = tarefas.map(function (item) { return item.sequencial }).sort();

            var numerosIguais = sequenciais.some(function (item, index) {
                return sequenciais[index + 1] == item;
            });

            return numerosIguais;
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.controlecarga.trocarleiturista')
        .controller('TrocarLeituristaController', TrocarLeituristaController)

    /** @ngInject */
    function TrocarLeituristaController(TrocarLeituristaService,
        DatatableFactory,
        MdDialogService,
        $mdDialog,
        Parametro,
        ListarLeituristas,
        SessionStorageService,
        KeysSessionStorage) {
        var vm = this;

        init();

        vm.metodos = {
            abrirFiltroTrocarLeiturista: abrirFiltroTrocarLeiturista,
            salvarTrocaLeiturista: salvarTrocaLeiturista,
            configuraMdSelectLeiturista: configuraMdSelectLeiturista,
            retornaTotalLeituras: retornaTotalLeituras,
            fecharDialog: fecharDialog
        }

        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);

            if (Parametro) {
                vm.trocandoLeituristaViaDialog = true;
                vm.leituristas = ListarLeituristas.data;
                if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                    _filtrarDadosTarefasMultiplosGrupos(Parametro);

                } else {
                    _filtrarDadosTarefas(Parametro);
                }
            }

            vm.menus = _construirMenus();
            vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao(_construirColumnDefs());
            vm.dtOptions.orderable = false;

            TrocarLeituristaService.listenerTarefa = function (callback) {
                vm.dados = callback();
                vm.leituristaDestino = undefined;
            };
        }

        function configuraMdSelectLeiturista() {
            vm.filtrarLeiturista = "";
            angular.element('#select-leiturista').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }

        function abrirFiltroTrocarLeiturista() {
            TrocarLeituristaService.toggleFiltroTrocarLeiturista();
        }

        function retornaTotalLeituras(tarefas) {
            var total = 0;

            tarefas.forEach(function (tarefa) {
                total = total + tarefa.quantidadeLeituras;
            });

            return total;
        }

        function _construirColumnDefs() {
            if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                return [
                    {
                        targets: [0, 1, 2, 3, 4, 5, 6],
                        orderable: false
                    },
                    {
                        targets: [0, 1, 2],
                        width: '15%'
                    },
                    {
                        targets: [3],
                        width: '5%'
                    },
                    {
                        targets: [4],
                        width: '10%'
                    },
                    {
                        targets: [5, 6],
                        width: '20%'
                    },
                    {
                        targets: [6],
                        responsivePriority: 1
                    }
                ];
            } else {
                return [
                    {
                        targets: [0, 1, 2, 3, 4, 5],
                        orderable: false
                    },
                    {
                        targets: [0, 1, 2, 3],
                        width: '15%'
                    },
                    {
                        targets: [4, 5],
                        width: '20%'
                    },
                    {
                        targets: [5],
                        responsivePriority: 1
                    }
                ];
            }
        }

        function _construirMenus() {
            return [
                {
                    icon: 'icon-filter',
                    name: 'Filtrar',
                    direction: 'top',
                    hide: false,
                    executarAcaoClick: function () { return abrirFiltroTrocarLeiturista() }
                }
            ]
        }

        function salvarTrocaLeiturista() {
            var viewModel;

            if (vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos) {
                viewModel = [];

                vm.dados.tarefa.forEach(function (tarefa) {
                    viewModel.push({
                        leituristaOrigem: tarefa.codigoLeiturista,
                        leituristaDestino: vm.leituristaDestino,
                        tarefa: tarefa.tarefa,
                        gleiCodigo: tarefa.gleiCodigo
                    });
                });

                var validacaoMultiplosGrupos = _validarDadosTrocaLeiturista(viewModel[0]);

                if (validacaoMultiplosGrupos) {
                    MdDialogService.alertPadrao("Atenção", event, validacaoMultiplosGrupos);
                    return;
                }

                _iniciarProgresso();
                var pSalvar = TrocarLeituristaService.salvarTrocaMultiplosGrupos(viewModel);

                pSalvar.then(function (success) {
                    if (vm.trocandoLeituristaViaDialog) {
                        MdDialogService.alertPadraoComEvento(success.data, function () { $mdDialog.hide() });
                    }
                    else {
                        MdDialogService.alertPadrao(success.data);
                        vm.dados = undefined;
                    }
                }, function (err) {
                    MdDialogService.alertPadrao(err.data);
                }).finally(function () { _finalizarProgresso() });

            } else {
                viewModel = {
                    leituristaOrigem: vm.dados.tarefa[0].codigoLeiturista,
                    leituristaDestino: vm.leituristaDestino,
                    tarefa: vm.dados.tarefa[0].tarefa,
                    gleiCodigo: vm.dados.tarefa[0].gleiCodigo
                }

                var validacao = _validarDadosTrocaLeiturista(viewModel);

                if (validacao) {
                    MdDialogService.alertPadrao("Atenção", event, validacao);
                    return;
                }

                _iniciarProgresso();
                var pSalvarMultiplosGrupos = TrocarLeituristaService.salvarTrocaLeiturista(viewModel);

                pSalvarMultiplosGrupos.then(function (success) {
                    if (vm.trocandoLeituristaViaDialog) {
                        MdDialogService.alertPadraoComEvento(success.data, function () { $mdDialog.hide() });
                    }
                    else {
                        MdDialogService.alertPadrao(success.data);
                        vm.dados = undefined;
                    }
                }, function (err) {
                    MdDialogService.alertPadrao(err.data);
                }).finally(function () { _finalizarProgresso() });
            }
        }

        function _iniciarProgresso() {
            vm.emProgresso = true;
        }

        function _finalizarProgresso() {
            vm.emProgresso = false;
        }

        function _validarDadosTrocaLeiturista(dados) {
            if (dados.leituristaOrigem == dados.leituristaDestino) return "A tarefa já está disponibilizada para este leiturista."
            if (!dados.leituristaDestino) return "É preciso informar para qual leiturista a tarefa será destinada."
        }

        function fecharDialog() {
            $mdDialog.hide();
        }

        function _filtrarDadosTarefas(viewModel) {
            var leituristas = vm.leituristas.filter(function (item) { return item.agrupamentoId == viewModel.agrupamento; });
            _iniciarProgressoBuscaTarefa()
            var pTarefa = TrocarLeituristaService.filtrarDadosTarefaTroca(viewModel);
            pTarefa.then(function (success) {
                var object = {
                    tarefa: [success.data],
                    leituristas: leituristas
                }
                TrocarLeituristaService.listenerTarefa(function () { return object });
            }, function (err) {
                var mensagem = err.data.split(". ");
                if (vm.trocandoLeituristaViaDialog) {
                    MdDialogService.alertPadraoComEvento(mensagem[0], function () { $mdDialog.hide() }, event, mensagem[1]);
                } else {
                    MdDialogService.alertPadrao(mensagem[0], event, mensagem[1]);
                }
            }).finally(function () { _finalizarProgressoBuscaTarefa() })
        }

        function _filtrarDadosTarefasMultiplosGrupos(viewModel) {
            var leituristas = vm.leituristas.filter(function (item) { return item.agrupamentoId == viewModel.agrupamento; });
            _iniciarProgressoBuscaTarefa()
            var pTarefas = TrocarLeituristaService.filtrarDadosTrocaMultiplosGrupos(viewModel);

            pTarefas.then(function (success) {
                var object = {
                    tarefa: success.data,
                    leituristas: leituristas
                }

                TrocarLeituristaService.listenerTarefa(function () { return object });

            }, function (err) {
                var mensagem = err.data.split(". ");
                if (vm.trocandoLeituristaViaDialog) {
                    MdDialogService.alertPadraoComEvento(mensagem[0], function () { $mdDialog.hide() }, event, mensagem[1]);
                } else {
                    MdDialogService.alertPadrao(mensagem[0], event, mensagem[1]);
                }
            })
                .finally(function () { _finalizarProgressoBuscaTarefa() });
        }

        function _iniciarProgressoBuscaTarefa() {
            vm.emProgressoBuscaTarefa = true;
        }

        function _finalizarProgressoBuscaTarefa() {
            vm.emProgressoBuscaTarefa = false;
        }
    }

}());
(function () {
  "use strict";

  angular
    .module("app.controlecarga.cancelarcarga")
    .controller("CancelarCargaController", CancelarCargaController);

  /** @ngInject */
  function CancelarCargaController(
    $mdDialog,
    CancelarCargaService,
    MdDialogService,
    $mdSidenav,
    ListarParametros,
    DatatableFactory
  ) {
    var vm = this;
    vm.tipoProcesso = ListarParametros.data.tipoProcesso;

    init();

    vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao([
      {
        targets: [4],
        orderable: false
      },
      {
        targets: [0, 1, 2, 3, 4],
        width: '20%'
      },
    ]);

    vm.dtOptions.order = [[1, "desc"]]

    $(document).ready(function () {
      $("#cancelar-carga").on("click", function (event) {
        if (vm.dados == undefined) {
          $mdSidenav("filtro-cancelarcarga").open();
        }
      });
      $(".sidenav").on("click", function (event) {
        event.stopPropagation();
      });
    });

    vm.metodos = {
      abrirFiltroCancelamento: abrirFiltroCancelamento,
      cancelarCarga: cancelarCarga,
      ordernarPor: ordernarPor,
    };

    vm.nomePropriedade = "dataExportacao";
    vm.reverso = true;

    function init() {
      CancelarCargaService.listenerArquivos = function (callback) {
        vm.filtroStatus = "Todos";
        vm.dados = callback();
        if (vm.dados) vm.arquivosBkp = vm.dados.arquivos;
        _retornarStatusDescricao();
      };

      vm.pesquisar = "";
    }

    function abrirFiltroCancelamento() {
      CancelarCargaService.toggleFiltro();
    }

    function _iniciarProgresso(mensagem) {
      vm.emProgresso = true;
      vm.mensagem = mensagem;
    }

    function _finalizarProgresso() {
      vm.emProgresso = false;
    }

    function _buscarDadosCancelamento() {
      _iniciarProgresso("Buscando dados...");
      var filtro = {
        mes: vm.dados.filtros.mes,
        ano: vm.dados.filtros.ano,
      };

      if (vm.tipoProcesso == "01") {
        filtro.codigoLeiturista = vm.dados.filtros.leiturista;
      } else if (vm.tipoProcesso == "02") {
        filtro.grupo = vm.dados.filtros.grupo;
      }

      var pBuscarDados = CancelarCargaService.buscarDadosArquivos(filtro);

      pBuscarDados
        .then(
          function (success) {
            vm.dados.arquivos = success.data;
            vm.arquivosBkp = angular.copy(success.data);
            _retornarStatusDescricao();
          },
          function (error) {
            MdDialogService.alertPadrao(error.data);
            vm.dados.arquivos = [];
          }
        )
        .finally(function () {
          _finalizarProgresso();
        });
    }

    function cancelarCarga(carga) {
      var viewModel = {
        nomeArquivoExportacao: carga.nomeArquivoExportacao,
        senhaImplantacao: "",
      };

      if (vm.tipoProcesso == "01") {
        viewModel.codigoLeiturista = carga.codigoLeiturista;
      } else if (vm.tipoProcesso == "02") {
        viewModel.grupo = carga.grupo;
      }

      if (carga.statusCarga == 2 || carga.statusCarga == 3) {
        MdDialogService.confirmPadraoComEvento(
          "Carga com leituras executadas!",
          "Deverá ser informado a senha de implantação para realizar o processo. Deseja continuar?",
          null,
          function () {
            $mdDialog
              .show({
                controller: "DialogSenhaImplantacaoController",
                controllerAs: "vm",
                templateUrl:
                  "app/compartilhado/dialog-senha-implantacao/views/dialog-senha-implantacao.html",
                targetEvent: null,
                multiple: true,
              })
              .then(function (senha) {
                viewModel.senhaImplantacao = senha;
                _dialogCancelamento(viewModel);
              });
          }
        );
      } else {
        _dialogCancelamento(viewModel);
      }
    }

    function _dialogCancelamento(viewModel) {
      MdDialogService.confirmPadraoComEvento(
        "Deseja realmente cancelar essa carga?",
        "Ao cancelar uma carga, a mesma será excluída do sistema e todos os dados serão perdidos!",
        null,
        function () {
          //resposta sim
          _iniciarProgresso("Realizando o cancelamento...");

          var promisse = CancelarCargaService.cancelarCarga(viewModel);

          promisse
            .then(
              function (success) {
                MdDialogService.alertPadraoComEvento(success.data, function () {
                  _buscarDadosCancelamento();
                });
                _finalizarProgresso();
              },
              function (error) {
                MdDialogService.alertPadraoComEvento(error.data, function () {
                  _buscarDadosCancelamento();
                });
                _finalizarProgresso();
              }
            )
            .finally(function () {
              _finalizarProgresso();
            });
        }
      );
    }

    function ordernarPor(nomePropriedade) {
      vm.reverso = vm.nomePropriedade === nomePropriedade ? !vm.reverso : false;
      vm.nomePropriedade = nomePropriedade;
    }

    function _retornarStatusDescricao() {
      if (vm.dados) {
        vm.dados.arquivos.forEach(function (arquivo) {
          if (arquivo.statusCarga == 1) {
            arquivo.statusDescricao = "Disponível";
          } else if (arquivo.statusCarga == 2) {
            arquivo.statusDescricao = "Em execução";
          } else {
            arquivo.statusDescricao = "Finalizado";
          }
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.chat', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

    // State
    $stateProvider.state('app.chat', {
      url: '/chat',
      views: {
        'content@app': {
          templateUrl: 'app/main/chat/chat.html',
          controller: 'ChatController as vm'
        }
      },
      resolve: {
        Leituristas: function (Api, RequisicaoGenericaService) {
          return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarParaChat);
        },
        User: function (msApi) {
          return msApi.resolve('chat.user@get');
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/chat');

    msApiProvider.register('chat.user', ['app/data/chat/user.json']);

  }

})();

(function () {
  'use strict';

  angular
    .module('app.chat')
    .factory('ChatsService', ChatsService);

  /** @ngInject */
  function ChatsService(Api, RequisicaoGenericaService) {

    var service = {
      listarMensagensCentral: listarMensagensCentral,
      listarLeituristas: listarLeituristas,
      verificarNovasMensagens: verificarNovasMensagens
    };

    function
      listarMensagensCentral(leituristaId, data) {
      return RequisicaoGenericaService.listarSemParams(Api.chat.ListarMensagensCentral + "?leituristaId=" + leituristaId + "&data=" + data);
    }

    function verificarNovasMensagens() {
      return RequisicaoGenericaService.listarSemParams(Api.chat.VerificarNovasMensagens + "?origem=2");
    }

    function listarLeituristas() {
      return RequisicaoGenericaService.listarSemParams(Api.leiturista.listarParaChat);
    }

    return service;
  }
})();



(function () {
  'use strict';

  angular
    .module('app.chat')
    .factory('ChatNotificacaoService', ChatNotificacaoService);

  /** @ngInject */
  function ChatNotificacaoService(NotificationService) {

    var service = {
      notificar: notificar
    };

    function notificar(onClick) {
      var notificacao = NotificationService.criarNotificacao("Você recebeu novas mensagens", "Clique aqui para visualizar",
        null, null, function () {
          onClick();
          notificacao.close();
        }, null, null, 'app.chat');
    }

    return service;
  }
})();

/* eslint-disable no-console */

(function () {
  'use strict';

  angular
    .module('app.chat')
    .factory('ChatHubService', ChatHubService);

  /** @ngInject */
  function ChatHubService($rootScope, $state, ChatNotificacaoService, ChatsService, urlApi, MdToastService) {

    var rota = urlApi.url_base_api + "chatHub";
    var _conexao = undefined;
    var service = {
      conectarHub: conectarHub,
      desconectarHub: desconectarHub,
      enviarMensagem: enviarMensagem,
      notificarNovasMensagens: notificarNovasMensagens
    };

    var listeners = [
      {
        nome: 'EnviarMensagemWeb', metodo: _aoReceberMensagem
      },
      {
        nome: 'MensagemRecebidaWebArmazenada', metodo: _aoReceberConfirmacaoDeArmazenamentoNovaMensagem
      },
      {
        nome: 'FalhaEnvioMensagem', metodo: _falhaAoEnviarMensagem
      }
    ];

    function conectarHub() {
      if (!$state.current.name || $state.current.name === 'app.login' || $state.current.name === 'app.em_manutencao') {
        desconectarHub();
        return;
      }

      MdToastService.toastInfo("Conectando ao servidor de chat...");

      _conexao = new signalR.HubConnectionBuilder()
        .withUrl(rota, {
          transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling
        })
        .build();

      _conexao
        .start()
        .then(function () {
          _verificarNovasMensagens();
          _configurarListeners();
          $rootScope.$broadcast('conectadoAoChat');
          MdToastService.toastPadrao("Conectado ao servidor de chat!");
          _conexao.onclose(function () {
            _reconectarAoSignalR(_conexao);
          });
        })
        .catch(function (error) {
          MdToastService.toastWarning("Desconectado do servidor de chat, não será possível enviar e/ou receber mensagens!", 10000);
          $rootScope.$broadcast('desconectadoDoChat');
          _reconectarAoSignalR(_conexao);
          console.error(error);
        });
    }

    function notificarNovasMensagens() {
      $rootScope.$on('novasMensagens', function (evt, mensagem) {
        _notificarNovasMensagens();
      });
    }

    function desconectarHub() {
      if (_conexao)
        _conexao.stop();
      _conexao = undefined;
    }

    function enviarMensagem(mensagem) {
      return _conexao
        .invoke("ReceberMensagemWeb", mensagem)
        .catch(function (err) {
          return console.error(err.toString());
        });
    }

    //#region metodos internos

    function _notificarNovasMensagens() {
      ChatNotificacaoService.notificar(function () {
        $state.go('app.chat');
      })
    }

    function _verificarNovasMensagens() {
      ChatsService.verificarNovasMensagens().then(function (success) {
        if (success.data > 0)
          _notificarNovasMensagens();
      });
    }

    function _aoReceberMensagem(mensagem) {
      $rootScope.$broadcast('novasMensagens', mensagem);
    }

    function _aoReceberConfirmacaoDeArmazenamentoNovaMensagem(mensagem) {
      $rootScope.$broadcast('mensagemEnviada', mensagem);
    }

    function _falhaAoEnviarMensagem(mensagem) {
      $rootScope.$broadcast('falhaAoEnviarMensagem', mensagem);
    }

    function _reconectarAoSignalR(conexao) {
      if (!conexao)
        return;
      setTimeout(function () {
        conectarHub();
      }, 10000);
    }

    function _configurarListeners() {
      for (var i = listeners.length - 1; i >= 0; i--) {
        _conexao.on(listeners[i].nome, listeners[i].metodo);
      }
    }

    //#endregion

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("app.cadastros.parametros")
    .controller("ParametrosController", ParametrosController);

  function ParametrosController(
    $q,
    $state,
    $scope,
    $mdToast,
    $interval,
    $mdDialog,
    $timeout,
    Api,
    RotasHtml,
    MdDialogService,
    ArquivosService,
    ParametrosService,
    LoginUsuarioService,
    SessionStorageService,
    RequisicaoGenericaService,
    ControleAcessoConfig,
    KeysSessionStorage,
    ParametrosFactory,
    ListarBoletos,
    obterDadosParametro,
    obterListasParametro,
    DatatableFactory,
    LogomarcaStream
  ) {
    var vm = this;

    vm.form = {};
    vm.tornarCampoObrigatorio = false;
    init();

    var processando = undefined;
    vm.logomarca = "";
    vm.emProgressoLogoMarca = false;
    vm.logomarcaStream = LogomarcaStream.data;
    vm.acaoCopiar = false;

    function init() {
      vm.parametro = ParametrosFactory.parametro;
      vm.parametro = obterDadosParametro.data;
      vm.listasParametro = obterListasParametro.data;
      vm.listaSegmento = vm.listasParametro[0].listaItemsGenericos;
      vm.listaTipo = vm.listasParametro[1].listaItemsGenericos;
      vm.listaTipoCidade = vm.listasParametro[2].listaItemsGenericos;
      vm.listaConfiguracaoVisualizacaoTelaLeitura =
        vm.listasParametro[3].listaItemsGenericos;
      vm.listaDataLeituraSerRealizada =
        vm.listasParametro[4].listaItemsGenericos;
      vm.listaConsumoAdicionalAConsistirLigacaoForaFaixa =
        vm.listasParametro[5].listaItemsGenericos;
      vm.listaTipoServico = vm.listasParametro[6].listaItemsGenericos;
      vm.listaComboFonteMensagens = vm.listasParametro[7].listaItemsGenericos;
      vm.listaGerarMensagemFaturamentoAutomaticamente =
        vm.listasParametro[8].listaItemsGenericos;
      vm.listaMensagemImpressaFaturaQuandoEnviaDebitoSeparado =
        vm.listasParametro[9].listaItemsGenericos;
      vm.listaLeyoutDebitosAnteriores = [];
      vm.listasParametro[10].listaItemsGenericos.forEach(function (item) {
        var itemNovo = {
          id: parseInt(item.id),
          descricao: item.descricao,
        };
        vm.listaLeyoutDebitosAnteriores.push(itemNovo);
      });
      vm.listaTipoProcesso = vm.listasParametro[11].listaItemsGenericos;
      vm.listaOcorrencias = vm.listasParametro[12].listaItemsGenericos;
      vm.listaBoletos = vm.listasParametro[13].listaItemsGenericos;
      vm.listaTipoAcaoConsumoMinimoCreditoRemanescente =
        vm.listasParametro[14].listaItemsGenericos;
      vm.tipoDetalheCalculo = SessionStorageService.recuperar(
        KeysSessionStorage.tipoDetalheCalculo
      );
      vm.listaImprimeConsumoCampoFaturadoMenorMinimo =
        vm.listasParametro[15].listaItemsGenericos;
      vm.listaOpcoesLeituraFracionada =
        vm.listasParametro[16].listaItemsGenericos;
      vm.quantidadeCasasDecimais = [1, 2, 3, 4];
      vm.tipoProcessoBKP = angular.copy(vm.parametro.tipoProcesso);
      vm.sistemaGestorBKP = angular.copy(vm.parametro.coletor.sistemaGestor);
      vm.utilizaRotinaCriticaLeiturasBKP = angular.copy(
        vm.parametro.impressao.utilizaRotinaCriticaLeituras
      );
      vm.utilizaCadastroRegionalBKP = angular.copy(
        vm.parametro.utilizaCadastroRegional
      );
      vm.utilizaCancelamentoDinamicoBKP = angular.copy(
        vm.parametro.utilizaCancelamentoDinamico
      );
      vm.utilizarGerenciamentoFaturasRetidasVinculadasBKP = angular.copy(
        vm.parametro.utilizarGerenciamentoFaturasRetidasVinculadas
      );
      vm.marcaEspecialBKP = angular.copy(vm.parametro.utilizarMarcaEspecial);
      vm.marcaEspecialNomeSolucaoBKP = angular.copy(
        vm.parametro.nomeSolucaoMarcaEspecial
      );
      vm.boletos = ListarBoletos.data;
      vm.listaTipoUnidadeMedida = vm.listasParametro[18].listaItemsGenericos;
      vm.tornarCampoObrigatorio = $state.params.dadosEmpresaFaltando;
      vm.codigosCobrancaAplicacaoIsencaoChips = _converterStringParaArrayCodigosCobrancaAplicacaoIsencao(
        vm.parametro.codigosCobrancaAplicacaoIsencao
      );

      vm.tiposConsumo = [
        {
          id: 1,
          descricao: "01 - Real",
        },
        {
          id: 2,
          descricao: "02 - Faturado",
        },
      ];

      vm.limiteMaximoDigitosLeitura = [
        {
          valor: 6,
          descricao: "06",
        },
        {
          valor: 7,
          descricao: "07",
        },
        {
          valor: 8,
          descricao: "08",
        },
        {
          valor: 9,
          descricao: "09",
        },
      ];

      vm.temposMinutosIntervaloEnvioOnline = [
        {
          valor: 0,
          descricao: "Sem intervalo",
        },
        {
          valor: 1,
          descricao: "1 minuto",
        },
        {
          valor: 2,
          descricao: "2 minutos",
        },
        {
          valor: 3,
          descricao: "3 minutos",
        },
        {
          valor: 4,
          descricao: "4 minutos",
        },
        {
          valor: 5,
          descricao: "5 minutos",
        },
        {
          valor: 10,
          descricao: "10 minutos",
        },
        { valor: 30, descricao: "30 minutos" },
      ];

      vm.opcoesRetencaoDados = [
        { codigo: 3, descricao: '3 meses' },
        { codigo: 6, descricao: '6 meses' },
        { codigo: 9, descricao: '9 meses' },
      ];

      vm.opcoesIntervaloExecucaoRetencao = [
        { codigo: 7, descricao: 'Semanal' },
        { codigo: 30, descricao: 'Mensal' },
        { codigo: 90, descricao: 'Trimestral' },
        { codigo: 180, descricao: 'Semestral' },
        { codigo: 365, descricao: 'Anual' },
      ];

      vm.temposMinutosTempoLimiteCancelamentoLeitura = [
        {
          valor: 0,
          descricao: "Sem intervalo",
        },
        {
          valor: 1,
          descricao: "1 minuto",
        },
        {
          valor: 2,
          descricao: "2 minutos",
        },
        {
          valor: 3,
          descricao: "3 minutos",
        },
        {
          valor: 4,
          descricao: "4 minutos",
        },
        {
          valor: 5,
          descricao: "5 minutos",
        },
        {
          valor: 10,
          descricao: "10 minutos",
        },
        { valor: 30, descricao: "30 minutos" },
      ];

      vm.utilizaLimiteMaximoTentativasLeitura =
        vm.parametro.coletor.limiteMaximoTentativasLeitura > 0;

      vm.modoSuporte = [
        {
          valor: true,
          descricao: "Sim",
        },
        {
          valor: false,
          descricao: "Não",
        },
      ];

      vm.rotinaChat = [
        {
          valor: true,
          descricao: "Sim",
        },
        {
          valor: false,
          descricao: "Não",
        },
      ];

      vm.tipoImportacao = [
        {
          valor: 1,
          descricao: "Padrão",
        },
        {
          valor: 2,
          descricao: "Casan",
        },
        {
          valor: 3,
          descricao: "Caema",
        },
        {
          valor: 4,
          descricao: "Bauru",
        },
      ];

      vm.listaSistemasGestor = [
        {
          codigo: 0,
          descricao: "Outros",
        },
        {
          codigo: 1,
          descricao: "ICommercial",
        },
        {
          codigo: 2,
          descricao: "Fiorilli",
        },
        {
          codigo: 3,
          descricao: "Thema",
        },
      ];

      vm.dtOptions =
        DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao([
          {
            targets: [2],
            orderable: false,
          },
        ]);

      vm.dtOptions.order = [];

      vm.selecionarTodosRegistros = vm.parametro.controleImportacao.some(
        function (registro) {
          return registro.bloquearImportacao;
        }
      );
    }

    vm.metodos = {
      predefinirCamposParaEdicao: predefinirCamposParaEdicao,
      editar: editar,
      pesquisar: pesquisar,
      reverter: reverter,
      inicioProgresso: inicioProgresso,
      fimProgresso: fimProgresso,
      uploadLogomarca: uploadLogomarca,
      preenchimentoAutomaticoConsumoAlterado:
        preenchimentoAutomaticoConsumoAlterado,
      limpaMensagemConsumoAlterado: limpaMensagemConsumoAlterado,
      preenchimentoAutomaticoSaldoM3: preenchimentoAutomaticoSaldoM3,
      limpaMensagemSaldoM3: limpaMensagemSaldoM3,
      preenchimentoAutomaticoSaldoLNR: preenchimentoAutomaticoSaldoLNR,
      limpaMensagemSaldoLNR: limpaMensagemSaldoLNR,
      preenchimentoAutomaticoComunicadoDebitoAnterior:
        preenchimentoAutomaticoComunicadoDebitoAnterior,
      limpaMensagemComunicadoDebitoAnterior:
        limpaMensagemComunicadoDebitoAnterior,
      limpaCamposUtilizaComunicadoPagamentoFaturas:
        limpaCamposUtilizaComunicadoPagamentoFaturas,
      limpaCamposUtilizaConfiguracaoTitulo:
        limpaCamposUtilizaConfiguracaoTitulo,
      limpaCamposNumeroDiasValidade: limpaCamposNumeroDiasValidade,
      limpaCamposPadronizacaoConsumo: limpaCamposPadronizacaoConsumo,
      limpaCamposCriaServico: limpaCamposCriaServico,
      limpaCamposCalculoProporcional: limpaCamposCalculoProporcional,
      cancelarUpload: cancelarUpload,
      validacaoArquivoLogomarca: validacaoArquivoLogomarca,
      zeraCampoComValorNulo: zeraCampoComValorNulo,
      tratarValidacaoes: _tratarValidacaoes,
      ngChangeNumeroDiasConsumoLimiteAlerta:
        ngChangeNumeroDiasConsumoLimiteAlerta,
      verificarValoresCasasDecimais: verificarValoresCasasDecimais,
      validarNumeroMaximoTentativas: validarNumeroMaximoTentativas,
      onChangeintervaloEnvioCoordenadasGeoprocessamento:
        onChangeintervaloEnvioCoordenadasGeoprocessamento,
      onChangeQuantidadeFaturaBobina: onChangeQuantidadeFaturaBobina,
      abrirDialogImagensPredefinidas: abrirDialogImagensPredefinidas,
      zoomImagem: zoomImagem,
      inputFotoAplicacao: inputFotoAplicacao,
      selecionarFotoLogoAplicacao: selecionarFotoLogoAplicacao,
      changeUtilizarFonteParametrizavel: changeUtilizarFonteParametrizavel,
      changeQtdCaracteresMensagem: changeQtdCaracteresMensagem,
      changeUtilizarControleImportacao: changeUtilizarControleImportacao,
      changeSelecionarTodosRegistros: changeSelecionarTodosRegistros,
      changeSelecionarRegistro: changeSelecionarRegistro,
      configuraMdSelectOcorrencia: configuraMdSelectOcorrencia,
      onChangeBloquearImportacaoNaoVisitadosRepasseRepassar:
        onChangeBloquearImportacaoNaoVisitadosRepasseRepassar,
      onChangeexibirRelatorioModoGlobal: onChangeexibirRelatorioModoGlobal,
      onChangeUtilizaRentencaoDados: onChangeUtilizaRentencaoDados,
      changeInfracaoConsumo: changeInfracaoConsumo,
      changeSituacaoExecucaoConsumo: changeSituacaoExecucaoConsumo,
      onChangeSistemaGestor: onChangeSistemaGestor,
      onChangeTipoProcesso: onChangeTipoProcesso,
      onChangeCobrarTbo: onChangeCobrarTbo,
      onChangeintervaloEnvioLeituras: onChangeintervaloEnvioLeituras,
      abrirSolucao: abrirSolucao,
      copiarUrlApiFinalizacaoCarga: copiarUrlApiFinalizacaoCarga,
      transformarChipCodigoCobrancaAplicacaoIsencao: transformarChipCodigoCobrancaAplicacaoIsencao,
      copiarUrlApiFinalizacaoCarga: copiarUrlApiFinalizacaoCarga
    };

    vm.metodosTab = {
      mostraTabImplantacao: mostraTabImplantacao,
    };

    $scope.$watch("vm.controleForm.editarAtivo", function (newValue, oldValue) {
      _verificarNecessidadeLogout(newValue);
    });

    $scope.$watch("vm.arquivosLogomarca[0]", function (newValue, oldValue) {
      if (newValue) {
        vm.metodos.validacaoArquivoLogomarca();
      }
    });

    $scope.$watchCollection("vm.codigosCobrancaAplicacaoIsencaoChips", function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      var valoresSanitizados = _sanitizarArrayCodigosCobrancaAplicacaoIsencao(newValue);

      if (!angular.equals(valoresSanitizados, newValue)) {
        vm.codigosCobrancaAplicacaoIsencaoChips = valoresSanitizados;
        return;
      }

      vm.parametro.codigosCobrancaAplicacaoIsencao =
        _converterArrayParaStringCodigosCobrancaAplicacaoIsencao(valoresSanitizados);
    });

    $scope.$watch(
      "vm.parametro.utilizaCadastroRegional",
      function (newValue, oldValue) {
        if (vm.controleForm && vm.controleForm.editarAtivo) {
          vm.parametro.utilizaImportacaoLeituraViaFtp = newValue;
        }
      }
    );

    $scope.$watch(
      "vm.parametro.utilizarServicoPoupaAgua",
      function (newValue, oldValue) {
        if (newValue) {
          _atualizarStatusFormularioPoupaAgua();
        }
      }
    );

    $scope.$watch(
      "vm.parametro.empresa.codigoImanager",
      function (newValue, oldValue) {
        var ehIlhaSolteira = "2471";
        if (newValue != ehIlhaSolteira) {
          vm.parametro.utilizarServicoPoupaAgua = false;
        }
      }
    );

    function mostraTabImplantacao() {
      return SessionStorageService.recuperar(
        ControleAcessoConfig.key_modo_implantacao
      );
    }

    function pesquisar() {
      return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(
        Api.parametros.listarPorPaginacao,
        vm.entidadeDeEnvio
      );
    }

    function predefinirCamposParaEdicao() {
      if (
        vm.parametro.controleImportacao.every(function (registro) {
          return registro.bloquearImportacao;
        })
      ) {
        vm.selecionarTodosRegistros = true;
      } else if (
        vm.parametro.controleImportacao.some(function (registro) {
          return registro.bloquearImportacao;
        })
      ) {
        vm.selecionarTodosRegistros = false;
      } else if (
        !vm.parametro.controleImportacao.every(function (registro) {
          return registro.bloquearImportacao;
        })
      ) {
        vm.selecionarTodosRegistros = false;
      }
    }

    function editar(parametro) {
      if (parametro.utilizarControleImportacao) {
        return _verificarExistenciaCampoSelecionado(parametro);
      } else {
        return _editarSemVerificacaoCampoSelecionado(parametro);
      }
    }

    function _editarSemVerificacaoCampoSelecionado(parametro) {
      var deferred = $q.defer();
      var ehBauru = parametro.empresa.codigoImanager == "0070";

      if (!ehBauru) {
        parametro.coletor.utilizaRotinaFotosObservacaoLeitura = "N";
      }

      if (
        parametro.coletor.stringParametrizacao
          .toUpperCase()
          .includes("NUMERO_CASAS_DECIMAIS_MEIO_CALCULO")
      ) {
        var valorCasaDecimais = parseInt(
          _retornaValorStringParametrizacao(
            parametro.coletor.stringParametrizacao,
            "NUMERO_CASAS_DECIMAIS_MEIO_CALCULO"
          )
        );

        if (
          valorCasaDecimais < 2 ||
          valorCasaDecimais > 8 ||
          isNaN(valorCasaDecimais)
        ) {
          return MdDialogService.alertPadrao(
            "Está configurado para utilizar a string de parametrização [NUMERO_CASAS_DECIMAIS_MEIO_CALCULO], porém o valor da mesma está fora do intervalo válido (2 a 8).",
            vm.event
          );
        }
      }

      if (parametro.calculo.tipoDetalheCalculo != 6) {
        parametro.calculo.considerarDependentesExcecaoSemConsumoSomatorioCalculoMestre = false;
      }

      RequisicaoGenericaService.editar(Api.parametros.api, parametro).then(
        function (success) {
          SessionStorageService.armazenar(
            KeysSessionStorage.parametrosEmpresa,
            success.data
          );

          _verificarMudancaParametroCritico(success.data);

          deferred.resolve(success);

          if (parametro.calculo.utilizaCalculoProporcionalNumeroDias == "S") {
            var mensagem = "";

            if (
              parametro.calculo.codigoOcorrenciaCalculoProporcional == "" ||
              parametro.calculo.codigoOcorrenciaCalculoProporcional == undefined
            ) {
              mensagem +=
                "- Foi parametrizado a utilização de cálculo proporcional, porém, não existe ocorrência de cálculo proporcional configurada. <br>";
            }

            mensagem +=
              "- Devido a parametrização de  cálculo proporcional, todos os leituristas foram atualizados para desabilitar a rotina de alteração da data de leitura.";

            if (mensagem.length > 0) {
              MdDialogService.alertPadrao("Atenção", null, mensagem);
            }
          }
        },
        function (error) {
          var mensagem = _tratarValidacaoes(error);
          if (mensagem != "") {
            MdDialogService.alertPadrao("Atenção", null, mensagem);
          } else {
            tratarErroAPI(error);
          }
          vm.controleForm.emProgresso = false;
        }
      );
      return deferred.promise;
    }

    function _verificarExistenciaCampoSelecionado(parametro) {
      if (
        !vm.parametro.controleImportacao.some(function (registro) {
          return registro.bloquearImportacao;
        })
      ) {
        MdDialogService.alertPadrao(
          "Atenção!",
          null,
          "Deve ser marcado pelo menos um registro."
        );
        return;
      } else {
        return _editarSemVerificacaoCampoSelecionado(parametro);
      }
    }

    function reverter() {
      vm.mensagemMinimo = "";
      vm.mensagemMaximo = "";
      vm.form.tamanhoFatura.$setValidity("valorMaiorZero", true);
      vm.form.tamanhoFatura.$setValidity("valorMenorBonina", true);
    }

    function preenchimentoAutomaticoConsumoAlterado() {
      if (
        !vm.parametro.comunicado.mensagemConsumoAlterado &&
        vm.parametro.comunicado.utilizaComunicadoConsumoAlterado == "S"
      ) {
        vm.parametro.comunicado.mensagemConsumoAlterado =
          "Prezado consumidor, Informamos que neste mês ocorreu uma alteração no seu consumo em relação aos meses anteriores. Por esse motivo sua fatura foi retida e será entregue após uma nova conferência por funcionários do SAAE. Solicitamos que verifique possíveis vazamentos e acompanhe seu consumo através da leitura do hidrômetro. Qualquer dúvida entre em contato com o SAAE, antes do vencimento da fatura, tendo sua leitura anotada.Lembre - se, desperdícios e vazamentos custam caro para todos.";
      }
    }

    function limpaMensagemConsumoAlterado() {
      if (
        vm.parametro.comunicado.utilizaComunicadoConsumoAlterado != "S" &&
        vm.parametro.comunicado.mensagemConsumoAlterado
      ) {
        vm.parametro.comunicado.mensagemConsumoAlterado = "";
      } else
        vm.parametro.comunicado.mensagemConsumoAlterado =
          "Prezado consumidor, Informamos que neste mês ocorreu uma alteração no seu consumo em relação aos meses anteriores. Por esse motivo sua fatura foi retida e será entregue após uma nova conferência por funcionários do SAAE. Solicitamos que verifique possíveis vazamentos e acompanhe seu consumo através da leitura do hidrômetro. Qualquer dúvida entre em contato com o SAAE, antes do vencimento da fatura, tendo sua leitura anotada.Lembre - se, desperdícios e vazamentos custam caro para todos.";
    }

    function preenchimentoAutomaticoSaldoM3() {
      if (
        !vm.parametro.impressaomensagemSaldoM3 &&
        vm.parametro.impressao.utilizaMensagemSaldoM3 == "S"
      ) {
        vm.parametro.impressao.mensagemSaldoM3 =
          "FOI SUBTRAIDO DESTA CONTA O VALOR DE ******* \nREFERENTE A \n$$$$$$ M3. SALDO PENDENTE \nPROXIMA CONTA: @@@@@@ M3.";
      }
    }

    function limpaMensagemSaldoM3() {
      if (
        vm.parametro.impressao.utilizaMensagemSaldoM3 != "S" &&
        vm.parametro.impressao.mensagemSaldoM3
      ) {
        vm.parametro.impressao.mensagemSaldoM3 = "";
      } else
        vm.parametro.impressao.mensagemSaldoM3 =
          "FOI SUBTRAIDO DESTA CONTA O VALOR DE ******* \nREFERENTE A \n$$$$$$ M3. SALDO PENDENTE \nPROXIMA CONTA: @@@@@@ M3.";
    }

    function preenchimentoAutomaticoSaldoLNR() {
      if (
        !vm.parametro.impressao.mensagemSaldoLNR &&
        vm.parametro.impressao.utilizaMensagemSaldoLNR == "S"
      ) {
        vm.parametro.impressao.mensagemSaldoLNR =
          "PREZADO CONSUMIDOR: FOI SUBTRAIDO DESTA\nFATURA $$$$$$ M3, \nPROVENIENTE DO ACUMULO DE \nLEITURAS NAO REALIZADAS.";
      }
    }

    function limpaMensagemSaldoLNR() {
      if (
        vm.parametro.impressao.utilizaMensagemSaldoLNR != "S" &&
        vm.parametro.impressao.mensagemSaldoLNR
      ) {
        vm.parametro.impressao.mensagemSaldoLNR = "";
      } else
        vm.parametro.impressao.mensagemSaldoLNR =
          "PREZADO CONSUMIDOR: FOI SUBTRAIDO DESTA\nFATURA $$$$$$ M3, \nPROVENIENTE DO ACUMULO DE \nLEITURAS NAO REALIZADAS.";
    }

    function preenchimentoAutomaticoComunicadoDebitoAnterior() {
      if (
        !vm.parametro.comunicado.mensagemDebitoAnterior &&
        vm.parametro.utilizaComunicadoDebitoAnterior == "S"
      ) {
        vm.parametro.comunicado.mensagemDebitoAnterior =
          "Em nosso cadastro consta pendente a(s) fatura(s) \nreferentes ao consumo de água e / ou esgoto dos\nmeses abaixo relacionados.Este atraso no\npagamento causa problemas no equilíbrio econômico\ne financeiro do SAAE, sobrecarregando\nos demais consumidores na manutenção dos\nserviços.\nDiante disso, com fundamento na Lei\nFederal 11.445, art. 40, Inc.V, § 2, de\n05 / 01 / 2007, informamos que o fornecimento de água\nde seu imóvel será interrompido no prazo de 30\ndias a contar do recebimento deste, caso o seu\ndébito ainda esteja pendente.A data de\nvencimento encontra - se na parte inferior deste\naviso.Você pode utilizar este documento para\nrealizar o pagamento das faturas em atraso.";
      }
    }

    function limpaCamposNumeroDiasValidade() {
      if (vm.parametro.comunicado.utilizaValidadeComunicadoDebito != "S") {
        vm.parametro.comunicado.numeroDiasValidadeComunicadoDebito = 0;
      }
    }

    function limpaCamposUtilizaComunicadoPagamentoFaturas() {
      if (vm.parametro.comunicado.utilizaMensagemDebitoPagamentoAtraso == "S") {
        vm.parametro.comunicado.mensagemDebitoPagamentoAtraso = "";
      }
    }

    function limpaCamposUtilizaConfiguracaoTitulo() {
      if (
        vm.parametro.comunicado.utilizaConfiguracaoTituloComunicadoDebitos !=
        "S"
      ) {
        vm.parametro.comunicado.tituloComunicadoDebitos = "";
      }
    }

    function copiarUrlApiFinalizacaoCarga() {
      vm.acaoCopiar = true;

      var texto = vm.parametro.impressao.urlApiFinalizacaoCarga;
      var textarea = document.createElement('textarea');
      textarea.value = texto;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      textarea.style.top = '-999999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      $timeout(function () {
        vm.acaoCopiar = false;
      }, 3000);
    }

    function limpaCamposCriaServico() {
      if (vm.parametro.calculo.criaServicoArredondamento != "S") {
        vm.parametro.calculo.codigoServicoArredondamentoAcrescimo = 0;
        vm.parametro.calculo.descricaoServicoArredondamentoAcrescimo = "";
        vm.parametro.calculo.codigoServicoArredondamentoDesconto = 0;
        vm.parametro.calculo.descricaoServicoArredondamentoDesconto = "";
        vm.parametro.calculo.referenciaArredondamentoValorTotalConta = 0;
        vm.parametro.calculo.digitoDesconsideradoArredondamento = 0;
        vm.parametro.calculo.tipoServicoArredondamento = 1;
      }
    }

    function limpaCamposPadronizacaoConsumo() {
      if (vm.parametro.calculo.utilizaPadronizacaoConsumoForaFaixa != "S") {
        vm.parametro.calculo.percentualConsumoForaFaixaAbaixoMedia = 0;
        vm.parametro.calculo.percentualConsumoForaFaixaAcimaMedia = 0;
      }
    }

    function limpaCamposCalculoProporcional() {
      if (vm.parametro.calculo.utilizaCalculoProporcionalNumeroDias != "S") {
        vm.parametro.calculo.numeroDiasLimiteCalculoNormal = 0;
        vm.parametro.calculo.numeroDiasConsumoCalculoProporcional = 0;
      }
    }

    function limpaMensagemComunicadoDebitoAnterior() {
      if (
        vm.parametro.comunicado.utilizaComunicadoDebitoAnterior != "S" &&
        vm.parametro.comunicado.mensagemDebitoAnterior
      ) {
        vm.parametro.comunicado.mensagemDebitoAnterior = "";
        vm.parametro.comunicado.utilizaValidadeComunicadoDebito = "N";
        vm.parametro.comunicado.utilizaMensagemDebitoPagamentoAtraso = "N";
        vm.parametro.comunicado.utilizaConfiguracaoTituloComunicadoDebitos =
          "N";
      } else
        vm.parametro.comunicado.mensagemDebitoAnterior =
          "Em nosso cadastro consta pendente a(s) fatura(s) \nreferentes ao consumo de água e / ou esgoto dos\nmeses abaixo relacionados.Este atraso no\npagamento causa problemas no equilíbrio econômico\ne financeiro do SAAE, sobrecarregando\nos demais consumidores na manutenção dos\nserviços.\nDiante disso, com fundamento na Lei\nFederal 11.445, art. 40, Inc.V, § 2, de\n05 / 01 / 2007, informamos que o fornecimento de água\nde seu imóvel será interrompido no prazo de 30\ndias a contar do recebimento deste, caso o seu\ndébito ainda esteja pendente.A data de\nvencimento encontra - se na parte inferior deste\naviso.Você pode utilizar este documento para\nrealizar o pagamento das faturas em atraso.";
    }

    function validacaoArquivoLogomarca() {
      var reg = /[\/.](?:jpg|png)$/i;
      var lstrFileName = vm.arquivosLogomarca[0].lfFileName.toUpperCase();
      if (!reg.test(lstrFileName)) {
        MdDialogService.alertPadrao(
          "Atenção!",
          null,
          "Arquivo inválido. São aceitas somente imagens com extensões .png e .jpg.. Selecione outra imagem",
          vm.event
        );
        vm.lfApi.removeAll();
        return;
      }
    }

    function cancelarUpload() {
      vm.lfApi.removeAll();
      vm.realizandoUpload = false;
    }

    function uploadLogomarca(event) {
      vm.emProgressoLogoMarca = true;
      var promessa = ParametrosService.uploadLogomarca(vm.arquivosLogomarca);

      promessa
        .then(
          function (success) {
            atualizaUrlLogomarca(success.data);
            vm.metodos.cancelarUpload();
          },
          function (error) {
            tratarErroAPI(error, event);
            vm.metodos.fimProgresso();
          }
        )
        .finally(function () {
          vm.emProgressoLogoMarca = false;
        });
    }

    function inicioProgresso() {
      vm.emProgresso = true;
      processando = $interval(function () {
        vm.progresso += 3;

        if (vm.progresso > 100) {
          vm.progresso = 0;
        }
      }, 100);
    }

    function fimProgresso() {
      vm.emProgresso = false;
      vm.progresso = 0;
      if (angular.isDefined(processando)) {
        $interval.cancel(processando);
        processando = undefined;
      }
    }

    function atualizaUrlLogomarca(logomarca) {
      if (logomarca) {
        vm.logomarcaStream = logomarca;
      }
    }

    $scope.$watch(
      "vm.parametro.comunicado.layoutComunicadoDebitoAnterior",
      function (newValue, oldValue) {
        if (newValue == 2)
          vm.parametro.comunicado.utilizaImpressaoCanhotoComunicadoDebito = "S";
      }
    );

    function tratarErroAPI(error, event) {
      if (error.data == null && error.status == -1) {
        MdDialogService.alertPadrao(
          "Não foi possível conectar-se à API. Por favor verifique a sua conexão.",
          event
        );
      } else {
        if (error.data.message)
          MdDialogService.alertPadrao(error.data.message, event);
        else MdDialogService.alertPadrao(error.data, event);
      }
    }

    function _tratarValidacaoes(error) {
      var mensagemErro = "";

      if (!error) return mensagemErro;

      if (error.data && error.data[""]) {
        error.data[""].map(function (err) {
          mensagemErro += err + "<br>";
        });
      } else if (error.data && error.data.errors && error.data.errors[""]) {
        error.data.errors[""].map(function (err) {
          mensagemErro += err + "<br>";
        });
      }

      return mensagemErro;
    }

    function ngChangeNumeroDiasConsumoLimiteAlerta() {
      if (
        vm.parametro.coletor.numeroDiasConsumoLimiteAlerta == undefined ||
        vm.parametro.coletor.numeroDiasConsumoLimiteAlerta <= 0
      ) {
        vm.parametro.coletor.numeroDiasConsumoLimiteAlerta = 1;
      }
    }

    function zeraCampoComValorNulo(entidade, keyCampo, propriedade, valor) {
      if (!valor) {
        valor = 0;
      }

      if (propriedade === undefined || propriedade === null) {
        if (entidade == "coletor") {
          vm.parametro.coletor[keyCampo] = valor;
        } else if (entidade == "empresa") {
          vm.parametro.empresa[keyCampo] = valor;
        } else if (entidade == "calculo") {
          vm.parametro.calculo[keyCampo] = valor;
        } else if (entidade == "comunicado") {
          vm.parametro.comunicado[keyCampo] = valor;
        } else if (entidade == "diretorio") {
          vm.parametro.diretorio[keyCampo] = valor;
        } else if (entidade == "impressao") {
          vm.parametro.impressao[keyCampo] = valor;
        } else if (entidade == "marcaEpecial") {
          vm.parametro.marcaEpecial[keyCampo] = valor;
        } else if (entidade == "proxy") {
          vm.parametro.proxy[keyCampo] = valor;
        } else if (entidade == "valor") {
          vm.parametro.valor[keyCampo] = valor;
        } else {
          vm.parametro[keyCampo] = valor;
        }
      }
    }

    function verificarValoresCasasDecimais(segmento) {
      switch (segmento) {
        case "00":
          vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisAgua = 4;
          vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisGas = 4;
          break;
        case "01":
          vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisGas = 4;
          break;
        case "02":
          vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisAgua = 4;
          break;
        default:
          break;
      }
    }

    function _verificarEdicaoUtilizaRotinaCriticaLeituras(parametro) {
      if (vm.utilizaRotinaCriticaLeiturasBKP !== parametro)
        vm.utilizaRotinaCriticaLeiturasEditado = true;
    }

    function _verificarEdicaoTipoProcesso(tipoProcesso) {
      if (tipoProcesso !== vm.tipoProcessoBKP) vm.tipoProcessoEditado = true;
    }

    function _verificarEdicaoSistemaGestor(sistemaGestor) {
      if (sistemaGestor !== vm.sistemaGestorBKP) vm.sistemaGestorEditado = true;
    }

    function _verificarEdicaoUtilizaCadastroRegional(parametro) {
      if (vm.utilizaCadastroRegionalBKP !== parametro)
        vm.utilizaCadastroRegionalEditado = true;
    }

    function _verificarEdicaoUtilizaCancelamentoDinamico(parametro) {
      if (vm.utilizaCancelamentoDinamicoBKP !== parametro)
        vm.utilizaCancelamentoDinamicoEditado = true;
    }

    function _verificaEdicaoGerenciamentoFaturasRetidas(parametro) {
      if (vm.utilizarGerenciamentoFaturasRetidasVinculadasBKP !== parametro)
        vm.utilizarGerenciamentoFaturasRetidasVinculadasEditado = true;
    }

    function _verificarEdicaoMarcaEspecial(parametros) {
      vm.marcaEpecialEditado =
        parametros.utilizarMarcaEspecial !== vm.marcaEspecialBKP ||
        (parametros.utilizarMarcaEspecial &&
          parametros.nomeSolucaoMarcaEspecial !==
          vm.marcaEspecialNomeSolucaoBKP);
    }

    function _verificarNecessidadeLogout(editarAtivo) {
      if (!editarAtivo && vm.sistemaGestorEditado) {
        vm.sistemaGestorEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança no sistema gestor, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }
      if (!editarAtivo && vm.tipoProcessoEditado) {
        vm.tipoProcessoEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança no tipo de processo, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }
      if (!editarAtivo && vm.utilizaRotinaCriticaLeiturasEditado) {
        vm.utilizaRotinaCriticaLeiturasEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança na utilização da rotina de crítica de leituras, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }
      if (!editarAtivo && vm.utilizaCadastroRegionalEditado) {
        vm.utilizaCadastroRegionalEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança na utilização de cadastro de regionais, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }

      if (!editarAtivo && vm.utilizaCancelamentoDinamicoEditado) {
        vm.utilizaCancelamentoDinamicoEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança na utilização de cancelamento dinâmico, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }

      if (
        !editarAtivo &&
        vm.utilizarGerenciamentoFaturasRetidasVinculadasEditado
      ) {
        vm.utilizarGerenciamentoFaturasRetidasVinculadasEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança na utilização do gerenciamento de faturas retidas vinculadas, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }

      if (!editarAtivo && vm.marcaEpecialEditado) {
        vm.marcaEpecialEditado = false;
        MdDialogService.alertPadraoComEvento(
          "Ao realizar mudança na utilização de marca especial, a aplicação é reiniciada!",
          _logout,
          null,
          null
        );
        return;
      }
    }

    function _verificarMudancaParametroCritico(parametros) {
      _verificarEdicaoSistemaGestor(parametros.coletor.sistemaGestor);
      _verificarEdicaoTipoProcesso(parametros.tipoProcesso);
      _verificarEdicaoUtilizaRotinaCriticaLeituras(
        parametros.impressao.utilizaRotinaCriticaLeituras
      );
      _verificarEdicaoUtilizaCadastroRegional(
        parametros.utilizaCadastroRegional
      );
      _verificarEdicaoUtilizaCancelamentoDinamico(
        parametros.utilizaCancelamentoDinamico
      );
      _verificaEdicaoGerenciamentoFaturasRetidas(
        parametros.utilizarGerenciamentoFaturasRetidasVinculadas
      );
      _verificarEdicaoMarcaEspecial(parametros);
    }

    function _logout() {
      LoginUsuarioService.logout();
      SessionStorageService.remover(KeysSessionStorage.parametrosEmpresa);
      $mdToast.show({
        template:
          '<md-toast id="logout-message" layout="column" layout-align="center start"><div class="md-toast-content">Logout realizado com sucesso !!</div></md-toast>',
        hideDelay: 7000,
        position: "top right",
        parent: "#content",
      });
      $state.go("app.login");
    }

    function _retornaValorStringParametrizacao(strings, stringARetornarValor) {
      var arrayStrings = strings.split("@");
      var resultado = "";

      arrayStrings.forEach(function (stringParametrizacao) {
        if (stringParametrizacao.includes(stringARetornarValor)) {
          var stringValor = stringParametrizacao.trim().split("=");
          resultado = stringValor[1];
        }
      });

      return resultado;
    }

    function validarNumeroMaximoTentativas() {
      if (!vm.utilizaLimiteMaximoTentativasLeitura) {
        vm.parametro.coletor.limiteMaximoTentativasLeitura = 0;
      }

      if (
        vm.utilizaLimiteMaximoTentativasLeitura &&
        vm.parametro.coletor.limiteMaximoTentativasLeitura == 0
      ) {
        vm.parametro.coletor.limiteMaximoTentativasLeitura = 1;
      }
    }

    function onChangeintervaloEnvioCoordenadasGeoprocessamento(
      input,
      form,
      controleForm
    ) {
      if (
        input.$modelValue < 60 &&
        (controleForm.editarAtivo || controleForm.inserirAtivo)
      ) {
        form.intervaloEnvioCoordenadasGeoprocessamento.$setValidity(
          "intervaloEnvioCoordenadasGeoprocessamento",
          false
        );
      } else {
        form.intervaloEnvioCoordenadasGeoprocessamento.$setValidity(
          "intervaloEnvioCoordenadasGeoprocessamento",
          true
        );
      }
    }

    function onChangeQuantidadeFaturaBobina(
      inputTamnhoBobina,
      inputTamanhoFatura,
      form,
      controleForm
    ) {
      if (controleForm.editarAtivo || controleForm.inserirAtivo) {
        if (
          inputTamnhoBobina.$$rawModelValue > 0 &&
          inputTamanhoFatura.$$rawModelValue > 0
        ) {
          form.tamanhoBobina.$setValidity("valorMaiorZero", true);
          form.tamanhoFatura.$setValidity("valorMaiorZero", true);
          if (
            inputTamanhoFatura.$$rawModelValue >
            inputTamnhoBobina.$$rawModelValue
          ) {
            form.tamanhoFatura.$setValidity("valorMenorBonina", false);
            vm.parametro.impressao.quantidadeFaturaBobina = undefined;
          } else {
            form.tamanhoFatura.$setValidity("valorMenorBonina", true);
            vm.parametro.impressao.quantidadeFaturaBobina = Math.floor(
              inputTamnhoBobina.$$rawModelValue /
              inputTamanhoFatura.$$rawModelValue
            );
          }
        }

        if (inputTamnhoBobina.$$rawModelValue == 0) {
          vm.parametro.impressao.quantidadeFaturaBobina = undefined;
          form.tamanhoBobina.$setValidity("valorMaiorZero", false);
        }

        if (inputTamanhoFatura.$$rawModelValue == 0) {
          vm.parametro.impressao.quantidadeFaturaBobina = undefined;
          form.tamanhoFatura.$setValidity("valorMaiorZero", false);
        }

        if (
          inputTamanhoFatura.$$rawModelValue > 0 &&
          !(inputTamnhoBobina.$$rawModelValue > 0)
        ) {
          vm.parametro.impressao.quantidadeFaturaBobina = undefined;
          form.tamanhoBobina.$setValidity("valorMaiorZero", false);
          form.tamanhoBobina.$setDirty();
          form.tamanhoBobina.$setTouched();
        } else if (
          inputTamnhoBobina.$$rawModelValue > 0 &&
          !(inputTamanhoFatura.$$rawModelValue > 0)
        ) {
          vm.parametro.impressao.quantidadeFaturaBobina = undefined;
          form.tamanhoFatura.$setValidity("valorMaiorZero", false);
          form.tamanhoFatura.$setDirty();
          form.tamanhoFatura.$setTouched();
        } else {
          if (
            inputTamnhoBobina.$$rawModelValue == null ||
            inputTamnhoBobina.$$rawModelValue == undefined
          ) {
            form.tamanhoBobina.$setValidity("valorMaiorZero", true);
          }

          if (
            inputTamanhoFatura.$$rawModelValue == null ||
            inputTamanhoFatura.$$rawModelValue == undefined
          ) {
            form.tamanhoFatura.$setValidity("valorMaiorZero", true);
          }
        }
      }
    }

    function onChangeexibirRelatorioModoGlobal() {
      vm.parametro.parametroJobRetencao.valorMensalContrato = null;
    }


    function onChangeUtilizaRentencaoDados() {
      vm.parametro.mesesRetencao = null;
      vm.parametro.diasIntervaloExecucao = null;
      $timeout(function () {
        if (vm.form && vm.form.utilizaRentencaoDados) {
          vm.form.diasIntervaloExecucao.$setTouched();
          vm.form.diasIntervaloExecucao.$setDirty();
          vm.form.mesesRetencao.$setTouched();
          vm.form.mesesRetencao.$setDirty();
        }
      }, 10);
      vm.form.$setDirty();
    }

    function abrirDialogImagensPredefinidas() {
      $mdDialog
        .show({
          controller: "DialogImagensPreDefinidasBackgroundController as vm",
          templateUrl: RotasHtml.parametros.dialogs.dialogImagensPredefinidas,
          multiple: true,
          targetEvent: event,
          clickOutsideToClose: false,
          escapeToClose: false,
          locals: {
            ZoomImagem: zoomImagem,
            ImagemSelecionada: vm.parametro.empresa.imagemFundoAplicacao,
          },
        })
        .then(function (success) {
          vm.parametro.empresa.imagemFundoAplicacao = success;
          vm.form.$setDirty();
        });
    }

    function zoomImagem(imagem) {
      $mdDialog.show({
        controller: "DialogDetalharFotoController as vm",
        templateUrl:
          RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura.dialogs
            .fotos.dialogs.detalharFotos,
        multiple: true,
        targetEvent: event,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Foto: imagem,
        },
      });
    }

    function changeUtilizarFonteParametrizavel(utilizaFonteParametrizavel) {
      if (utilizaFonteParametrizavel) {
        vm.parametro.impressao.quantidadeCaracteresMensagemTipo01 = null;
        vm.parametro.impressao.quantidadeCaracteresMensagemTipo02 = null;
      }
    }

    function changeQtdCaracteresMensagem(tipo, valor) {
      vm.mensagemMinimo = "O valor deve ser maior que 0";
      vm.mensagemMaximo = "O valor deve ser menor que 100";
      var qtdCaracteresMensagem = vm.form["qtdCaracteresMensagemTipo" + tipo];

      qtdCaracteresMensagem.$setValidity("valorMinimoCaracteres", valor >= 1);
      qtdCaracteresMensagem.$setValidity("valorMaximoCaracteres", valor <= 100);
    }

    function onChangeBloquearImportacaoNaoVisitadosRepasseRepassar(
      bloquearImportacaoNaoVisitadosRepasseRepassar
    ) {
      if (bloquearImportacaoNaoVisitadosRepasseRepassar == "N") {
        vm.parametro.utilizarSenhaImplantacaoFinalizarCargaClientesNaoVisitados = false;
      }
    }

    function inputFotoAplicacao() {
      document.getElementById("inputFotoAplicacao").click();
    }

    function selecionarFotoLogoAplicacao(event) {
      var arquivo = event.target.files[0];
      if (_validacaoArquivoLogoAplicacao(arquivo)) {
        ArquivosService.obterArquivo(arquivo).then(function (arquivoViewModel) {
          document.getElementById("inputFotoAplicacao").value = null;
          vm.parametro.empresa.logomarcaAplicacao =
            arquivoViewModel.base64StringArquivo;
          vm.form.$setDirty();
        });
      }
    }

    function changeSituacaoExecucaoConsumo(valor) {
      if (!valor) {
        return;
      }
      vm.parametro.calculo.codigoOcorrenciaInfracaoConsumo = null;
    }

    function changeInfracaoConsumo(valor) {
      if (!valor) {
        return;
      }
      vm.parametro.calculo.codigoOcorrenciaSituacaoExcecaoComConsumo = null;
    }

    function onChangeSistemaGestor(valor) {
      if (valor != 2) {
        vm.parametro.utilizarImportacaoGrupoLeituraFilaFiorilli = false;
        vm.parametro.utilizarReimportacaoMesmaReferencia = false;
        vm.codigosCobrancaAplicacaoIsencaoChips = [];
      }
      if (valor == 3) {
        vm.parametro.tipoProcesso = '01';
        vm.parametro.utilizaAtualizacaoOcorrencia = 'N';
      }
    }

    function onChangeTipoProcesso(valor) {
      if (valor == '02') {
        vm.parametro.impressao.utilizarVinculoPrevioNotaCliente = true;
      }
    }

    function onChangeCobrarTbo(valor) {
      if (!valor)
        vm.parametro.calculo.cobrarTBOApenasComConsumoLigacaoExcecao = false;
    }

    function onChangeintervaloEnvioLeituras(valor) {
      if (valor == 0) {
        vm.parametro.coletor.tempoLimiteCancelamentoLeitura = 0;
      }
    }

    function abrirSolucao(caminho) {
      if (
        !caminho.startsWith("http://") &&
        !caminho.startsWith("https://")
      ) {
        caminho = "https://" + caminho;
      }
      window.open(caminho, "_blank");
    }

    function changeUtilizarControleImportacao(valor) {
      if (!valor) {
        vm.parametro.controleImportacao.forEach(function (registro) {
          registro.bloquearImportacao = valor;
        });
        vm.selecionarTodosRegistros = valor;
      }
    }

    function changeSelecionarTodosRegistros(valor) {
      vm.parametro.controleImportacao.forEach(function (registro) {
        registro.bloquearImportacao = valor;
      });
    }

    function changeSelecionarRegistro() {
      if (
        vm.parametro.controleImportacao.every(function (item) {
          return item.bloquearImportacao;
        })
      ) {
        vm.selecionarTodosRegistros = true;
      } else {
        vm.selecionarTodosRegistros = false;
      }
    }

    function configuraMdSelectOcorrencia() {
      vm.filtroOcorrencia = "";
      angular
        .element("#filtro-ocorrencia-md-select")
        .on("keydown", function (ev) {
          ev.stopPropagation();
        });
    }

    function _validacaoArquivoLogoAplicacao(arquivo) {
      var reg = /[\/.](?:jpg|png)$/i;
      var fileName = arquivo.name.toUpperCase();
      var tamanhoMaximo = 5 * 1024 * 1024; // 5 MB em bytes

      if (!reg.test(fileName)) {
        MdDialogService.alertPadrao(
          "Atenção!",
          null,
          "Arquivo inválido. São aceitas somente imagens com extensões .png e .jpg.. Selecione outra imagem",
          vm.event
        );
        arquivo = {};
        vm.form.$setValidity("fotoLogomarcaAplicacao", false);
        return false;
      } else {
        if (arquivo.size > tamanhoMaximo) {
          MdDialogService.alertPadrao(
            "Atenção!",
            null,
            "Arquivo inválido. O tamanho máximo permitido é de 5 MB. Selecione outra imagem.",
            vm.event
          );
          arquivo = {};
          vm.form.$setValidity("fotoLogomarcaAplicacao", false);
          return false;
        }

        vm.form.$setValidity("fotoLogomarcaAplicacao", true);
        return true;
      }
    }

    function _atualizarStatusFormularioPoupaAgua() {
      setTimeout(function () {
        vm.form.utilizarServicoPoupaAgua.$setDirty();
      }, 1);
    }

    function transformarChipCodigoCobrancaAplicacaoIsencao(chip) {
      if (!chip) {
        return undefined;
      }

      var valorSomenteNumeros = chip.toString().replace(/\D/g, "");

      if (!valorSomenteNumeros) {
        return undefined;
      }

      return valorSomenteNumeros;
    }

    function _sanitizarArrayCodigosCobrancaAplicacaoIsencao(valores) {
      if (!valores || !valores.length) {
        return [];
      }

      return valores
        .map(function (valor) {
          return valor.toString().replace(/\D/g, "");
        })
        .filter(function (valor) {
          return valor !== "";
        });
    }

    function _converterStringParaArrayCodigosCobrancaAplicacaoIsencao(valor) {
      if (!valor) {
        return [];
      }

      return valor.split(";").filter(function (item) {
        return item !== "";
      });
    }

    function _converterArrayParaStringCodigosCobrancaAplicacaoIsencao(valores) {
      if (!valores || !valores.length) {
        return "";
      }

      return valores.join(";") + ";";
    }
  }
})();

(function(){
    'use strict';

    angular
        .module('app.cadastros.tiposervico')
        .controller('TipoServicoController', TipoServicoController)

    /** @ngInject */
    function TipoServicoController(TipoServicoFactory, RequisicaoGenericaService, Api, $q, MdDialogService){
        var vm = this;
        var rotasApi = Api.tipoServico;


        vm.metodos = {
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            pesquisar: pesquisar,
            construirDtOptions: construirDtOptions,
            preDefinirCamposInsercao: preDefinirCamposInsercao
        }

        init();

        function init(){
            vm.tipoServico = {};         
        }

        function salvar(tipoServico){
            //return RequisicaoGenericaService.salvar(rotasApi.salvar,tipoServico);
            var deferred = $q.defer();
            RequisicaoGenericaService.salvar(rotasApi.salvar,tipoServico).then(
                    function (success) {
                        deferred.resolve(success);
                    },
                    function (error) {
                        var mensagemErro = "";
                        console.log(error);
                        
                        if (error.data.errors['']) {
                            error.data.errors[''].map(function (err) {
                                mensagemErro += err + "<br>";
                            });
                            MdDialogService.alertPadrao("Atenção", null, mensagemErro);
                        }
                        else {
                            MdDialogService.alertPadrao("Atenção", null, error.data);
                        }
                        vm.controleForm.emProgresso = false;
                    }
                );            
            return deferred.promise;

        }

        function editar(tipoServico){
            return RequisicaoGenericaService.editar(rotasApi.editar, tipoServico);
        }

        function excluir(tipoServico){
            return RequisicaoGenericaService.excluir(rotasApi.excluir, tipoServico.codigo);
        }

        function pesquisar(){ 
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotasApi.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function construirDtOptions(){
            TipoServicoFactory.construirDtOptions("#cadastros-tiposervico-datatable-tiposervico", _selecionar, vm.entidadeDeEnvio);
        }
        function preDefinirCamposInsercao(){
            vm.tipoServico = {
                ativo: true,
                exigeFoto: false,
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.ocorrencia')
        .controller('OcorrenciaController', OcorrenciaController);

    function OcorrenciaController(
        $q,
        OcorrenciaFactory,
        OcorrenciaService,
        Api,
        RequisicaoGenericaService,
        SessionStorageService,
        KeysSessionStorage,
        MdDialogService
    ) {
        var vm = this;

        var rotaApi = Api.ocorrencia;
        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        vm.sistemaGestorEhThema = vm.parametros.coletor.sistemaGestor == 3;
        vm.codigoImanagerMacaubas = vm.parametros.empresa.codigoImanager == '1093';
        init();

        vm.listaTipoServico = [
            {
                id: 1,
                descricao: "01 - Acréscimo"
            },
            {
                id: 2,
                descricao: "02 - Desconto"
            },
        ];

        vm.situacoesLigacao = [
            {
                codigo: 0,
                descricao: "Ambas"
            },
            {
                codigo: 1,
                descricao: "Ligada/Ativa"
            },
            {
                codigo: 2,
                descricao: "Desligada/Cortada"
            },
        ];

        vm.opcoesTipoAcaoOcorrenciaAcaoOcorrenciaAnterior = [
            { chave: 1, valor: '01 - Calcula pela Média', tooltip: 'Campo 46 do A11' },
            { chave: 2, valor: '02 - Calcula Tarifa Mínima' },
            { chave: 3, valor: '03 - Calcula Consumo Fixo Determinado (m³)' },
            { chave: 4, valor: '04 - Calcula Normal', tooltip: 'Obrigatório digitar leitura' },
            { chave: 5, valor: '05 - Calcula Consumo Medido', tooltip: 'Obrigatório digitar leitura' },
            { chave: 6, valor: '06 - Calcula Valor Fixo Determinado (R$)' },
            { chave: 7, valor: '07 - Calcula pela Média com possibilidade de alteração', tooltip: 'Campo 46 do A11' },
            { chave: 8, valor: '08 - Calcula Tarifa Mínima com possibilidade de alteração' },
            { chave: 9, valor: '09 - Calcula pela Média alternativa', tooltip: 'Campo 109 do A11' },
            { chave: 10, valor: '10 - Calcula pela Média alternativa com possibilidade de alteração', tooltip: 'Campo 109 do A11' }
        ];

        vm.metodos = {
            pesquisar: _pesquisar,
            salvar: _salvar,
            editar: _editar,
            excluir: _excluir,
            construirDtOptions: _construirDtOptions,
            selecionar: _selecionar,
            tabSelecionada: OcorrenciaService.tabSelecionada,
            predefinirCamposParaInsercao: _predefinirCamposParaInsercao,
            changeQtdMinimaFotos: changeQtdMinimaFotos,
            changeQtdMaximaFotos: changeQtdMaximaFotos,
            changeExigeCapturarFoto: changeExigeCapturarFoto,
            onChangeTipoAcaoOcorrencia: onChangeTipoAcaoOcorrencia,
            onOpenTipoAcaoOcorrencia: onOpenTipoAcaoOcorrencia,
            onCloseTipoAcaoOcorrencia: onCloseTipoAcaoOcorrencia,
            onOpenAcaoOcorrenciaAnterior: onOpenAcaoOcorrenciaAnterior,
            onCloseAcaoOcorrenciaAnterior: onCloseAcaoOcorrenciaAnterior
        };

        vm.valorAntesDeAbrirTipoAcao = null;
        vm.valorAntesDeAbrirAcaoAnterior = null;

        function init() {
            vm.form = {};
            vm.rota = rotaApi.proximocodigo;
            vm.ocorrencia = OcorrenciaFactory.ocorrencia();
            vm.controladorTelaOcorrencia = OcorrenciaFactory.controladorTelaOcorrencia;
        }

        function _pesquisar() {
            var resultado = RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotaApi.listarPorPaginacao, vm.entidadeDeEnvio);
            resultado.then(function (success) {
                var dados = success.data.lstResultado[0];
                if (dados.quantidadeMinimaFotos == 0 || dados.quantidadeMaximaFotos == 0) {
                    dados.quantidadeMinimaFotos = "";
                    dados.quantidadeMaximaFotos = "";
                }
            })
            return resultado;
        }

        function _salvar(entidade) {
            var deferred = $q.defer();

            RequisicaoGenericaService.salvar(rotaApi.criar, entidade)
                .then(
                    function (success) {
                        deferred.resolve(success);
                    },
                    function (error) {
                        _tratarErro(error);
                    }
                );

            return deferred.promise;
        }

        function _editar(entidade) {
            var deferred = $q.defer();

            RequisicaoGenericaService.editar(rotaApi.criar, entidade)
                .then(
                    function (success) {
                        deferred.resolve(success);
                    },
                    function (error) {
                        _tratarErro(error);
                    }
                );

            return deferred.promise;
        }

        function _excluir(entidade) {
            var deferred = $q.defer();

            RequisicaoGenericaService.excluir(rotaApi.excluir, entidade.codigo)
                .then(
                    function (success) {
                        deferred.resolve(success);
                    },
                    function (error) {
                        MdDialogService.alertPadrao("Atenção!", null, error.data);;
                    }
                );

            return deferred.promise;
        }

        function _construirDtOptions() {
            OcorrenciaFactory.construirDtOptions('#cadastros-ocorrencias-datatable-ocorrencia', _selecionar, vm.entidadeDeEnvio);
        }

        function _selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function _predefinirCamposParaInsercao() {
            vm.ocorrencia = OcorrenciaFactory.predefinirCamposInsercao();

            if (vm.sistemaGestorEhThema) {
                vm.ocorrencia.tipoAcaoOcorrencia = 1;
                vm.ocorrencia.permiteDigitarLeitura = 'N';
                vm.ocorrencia.geraLeituraCalculada = 'N';
            }
        }

        function _tratarErro(error) {
            var mensagemErro = "";
            if (error.data.errors && error.data.errors[""]) {
                mensagemErro = error.data.errors[""][0];
            } else {
                mensagemErro = error.data;
            }
            MdDialogService.alertPadrao("Atenção!", null, mensagemErro);
            vm.controleForm.emProgresso = false;
        }

        function changeQtdMinimaFotos(valor) {
            if (valor <= 0) {
                vm.form.minimoFotosPorOcorrencia.$setValidity("validaQuantidadeMinimaFotos", false);
            } else {
                vm.form.minimoFotosPorOcorrencia.$setValidity("validaQuantidadeMinimaFotos", true);
            }

            if (vm.ocorrencia.quantidadeMaximaFotos < valor) {
                vm.form.maximoFotosPorOcorrencia.$setValidity("", false)
                vm.mensagemErro = true;
            } else {
                vm.mensagemErro = false;
                vm.form.maximoFotosPorOcorrencia.$setValidity("", true);
            }
        }

        function changeQtdMaximaFotos(valor) {
            if (valor <= 0) {
                vm.form.maximoFotosPorOcorrencia.$setValidity("validaQuantidadeMaximaFotos", false);
            } else {
                vm.form.maximoFotosPorOcorrencia.$setValidity("validaQuantidadeMaximaFotos", true);
            }

            if (valor < vm.ocorrencia.quantidadeMinimaFotos) {
                vm.mensagemErro = true;
                vm.form.maximoFotosPorOcorrencia.$setValidity("", false);
            } else {
                vm.mensagemErro = false;
                vm.form.maximoFotosPorOcorrencia.$setValidity("", true);
            }
        }

        function changeExigeCapturarFoto(valor) {
            if (valor = 'S') {
                vm.ocorrencia.quantidadeMinimaFotos = 1;
                vm.ocorrencia.quantidadeMaximaFotos = 48;
            };
        }

        function onChangeTipoAcaoOcorrencia(valor) {
            if (vm.sistemaGestorEhThema) {
                vm.ocorrencia.tipoAcaoOcorrencia = 1;
                vm.ocorrencia.consumoFixoDeterminado = null;
                vm.ocorrencia.codigoValorFixoDeterminado = null;
                return;
            }

            if (valor != 3) {
                vm.ocorrencia.consumoFixoDeterminado = null;
            }
            if (valor != 6) {
                vm.ocorrencia.codigoValorFixoDeterminado = null;
            }
        }

        function onOpenTipoAcaoOcorrencia() {
            vm.valorAntesDeAbrirTipoAcao = vm.ocorrencia.tipoAcaoOcorrencia;
        }

        function onCloseTipoAcaoOcorrencia() {
            if (vm.valorAntesDeAbrirTipoAcao !== null && vm.valorAntesDeAbrirTipoAcao === vm.ocorrencia.tipoAcaoOcorrencia) {
                vm.ocorrencia.tipoAcaoOcorrencia = null;
                vm.ocorrencia.consumoFixoDeterminado = null;
                vm.ocorrencia.codigoValorFixoDeterminado = null;
            }
            vm.valorAntesDeAbrirTipoAcao = null;
        }

        function onOpenAcaoOcorrenciaAnterior() {
            vm.valorAntesDeAbrirAcaoAnterior = vm.ocorrencia.acaoOcorrenciaAnterior;
        }

        function onCloseAcaoOcorrenciaAnterior() {
            if (vm.valorAntesDeAbrirAcaoAnterior !== null && vm.valorAntesDeAbrirAcaoAnterior === vm.ocorrencia.acaoOcorrenciaAnterior) {
                vm.ocorrencia.acaoOcorrenciaAnterior = null;
            }
            vm.valorAntesDeAbrirAcaoAnterior = null;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.cadastros.cronogramagrupo')
    .controller('CronogramaGruposController', CronogramaGruposController)

  /** @ngInject */
  function CronogramaGruposController(Api, FormatacaoStringService, RequisicaoGenericaService,
    RegionalService, CronogramaGrupoFactory, listarAgrupamentos,
    SessionStorageService, KeysSessionStorage) {
    var vm = this;

    var rotasApi = Api.cronogramaGrupos;

    vm.metodos = {
      preDefinirCamposInsercao: preDefinirCamposInsercao,
      salvar: salvar,
      pesquisar: pesquisar,
      editar: editar,
      excluir: excluir,
      construirDtOptions: construirDtOptions
    }


    init();

    function init() {
      vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
      vm.stringService = FormatacaoStringService;
      vm.cronograma = CronogramaGrupoFactory.construirEntidade();
      CronogramaGrupoFactory.setAgrupamentos(listarAgrupamentos.data);
      _pesquisarRegionais();
    }

    function salvar(cronograma) {
      return RequisicaoGenericaService.salvar(rotasApi.salvar, cronograma);
    }

    function editar(cronograma) {
      return RequisicaoGenericaService.editar(rotasApi.editar, cronograma);
    }

    function excluir(cronograma) {
      return RequisicaoGenericaService.excluir(rotasApi.excluir, cronograma);
    }

    function pesquisar() {
      return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotasApi.listarPorPaginacao, vm.entidadeDeEnvio);
    }

    function _selecionar(posicaoEntidade) {
      vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
    }

    function construirDtOptions() {
      CronogramaGrupoFactory.construirDtOptions("#cadastros-cronogramaleituras-datatable-cronogramaleituras", _selecionar, vm.entidadeDeEnvio);
    }

    function preDefinirCamposInsercao() {
      var data = new Date();
      vm.cronograma = {
        mes: data.getMonth() + 1,
        ano: data.getFullYear()
      }
    }

    function _pesquisarRegionais() {

      vm.cronograma.regional = undefined;
      vm.emProgressoBuscaRegional = true;

      RegionalService.listarTodos().then(
        function (success) {
          vm.emProgressoBuscaRegional = false;
          vm.regionais = success.data;
        },
        function (error) {
          vm.emProgressoBuscaRegional = false;
        }
      )
    }


  }


}());

(function () {
    'use strict';

    angular
        .module('app.cadastros.leiturista')
        .controller('LeituristaController', LeituristaController);

    function LeituristaController(
        $q,
        $scope,
        LeituristaFactory,
        LeituristaService,
        Api,
        RequisicaoGenericaService,
        DatatableFactory,
        ValidacaoService,
        ListarTodosArquivos,
        Listardicionariosleiturista,
        ListarTodosEquipamentos,
        ListarTodasImpressoras,
        ListarTodosFormulariosImpressao,
        ListarCamposRecadastramento,
        MdDialogService,
        MdToastService,
        Regional,
        SessionStorageService,
        KeysSessionStorage
    ) {
        var vm = this;

        var rotaApi = Api.leiturista;

        init();

        vm.metodos = {
            pesquisar: pesquisar,
            salvar: salvar,
            editar: editar,
            excluir: excluir,
            construirDtOptions: construirDtOptions,
            selecionar: selecionar,
            tabSelecionada: LeituristaService.tabSelecionada,
            predefinirCamposParaInsercao: predefinirCamposParaInsercao,
            predefinirCamposParaEdicao: predefinirCamposParaEdicao,
            ngChangeTipoRotina: ngChangeTipoRotina,
            zeraCampoComValorNulo: zeraCampoComValorNulo,
            ngChangeImpressora: ngChangeImpressora,
            selecionarFoto: selecionarFoto,
            limparFoto: limparFoto,
            novaPesquisa: novaPesquisa,
            reverter: reverter,
            onChangePortaBluetoothTelemetria: onChangePortaBluetoothTelemetria,
            preencherZerosAEsquerda: preencherZerosAEsquerda,
            verificaHora: verificaHora,
            definirCamposClonados: definirCamposClonados,
            changeUtilizarRecadastramento: changeUtilizarRecadastramento,
            changeUtilizarConfiguracaoRecadastramentoCampos: changeUtilizarConfiguracaoRecadastramentoCampos,
            replicarConfiguracoes: replicarConfiguracoes,
            changeSelecionarTodosCampos: changeSelecionarTodosCampos,
            changeSelecionarCampo: changeSelecionarCampo,
            exibirItensTabela: exibirItensTabela,
            onChangeTamanhoFormulario: onChangeTamanhoFormulario,
            onChangeUtilizaLeituraAPI: onChangeUtilizaLeituraAPI,
            onChangeFabricante: onChangeFabricante
        };

        function init() {
            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            vm.form = {};
            vm.rota = rotaApi.proximocodigo;
            vm.leiturista = LeituristaFactory.leiturista();
            vm.controladorTelaLeiturista = LeituristaFactory.controladorTelaLeiturista;
            vm.arquivos = ListarTodosArquivos.data;
            vm.equipamentos = ListarTodosEquipamentos.data;
            vm.impressoras = ListarTodasImpressoras.data;
            vm.formulariosImpressao = ListarTodosFormulariosImpressao.data;
            vm.rotinas = Listardicionariosleiturista.data[0];
            vm.layouts = Listardicionariosleiturista.data[1];
            vm.impressoesFotos = Listardicionariosleiturista.data[2];

            vm.arquivo = undefined;

            vm.regionais = Regional.data;

            vm.fabricanteEquipamentoTelemetria = [
                { id: 1, nome: 'Diehl Metering' },
                { id: 2, nome: 'Saga Medição' }
            ];

            vm.tiposConfirmacaoLeitura = [
                { id: 1, descricao: 'Leitura digitada' },
                { id: 2, descricao: 'Leitura digitada invertida' }
            ];

            vm.regexHora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            vm.diasSemana = [
                { dia: "Segunda", valor: "1" },
                { dia: "Terça", valor: "2" },
                { dia: "Quarta", valor: "3" },
                { dia: "Quinta", valor: "4" },
                { dia: "Sexta", valor: "5" },
                { dia: "Sábado", valor: "6" },
                { dia: "Domingo", valor: "0" }
            ];

            vm.tiposFotoGravacaoAutomatica = [
                { id: 1, descricao: 'Hidrômetro' },
                { id: 2, descricao: 'Fachada' },
                { id: 3, descricao: 'Prova de adulteração' },
                { id: 9, descricao: 'Outros' }
            ]

            vm.fabricantes = [
                { chave: 1, valor: 'Techem' },
                { chave: 2, valor: 'Evoit/Fluid' },
                { chave: 3, valor: 'Saga' },
                { chave: 4, valor: 'Ioutility' },
                { chave: 5, valor: 'Laager' }
            ]
        }

        vm.segmentos = [
            {
                codigo: "01",
                descricao: "01 - Água"
            },
            {
                codigo: "02",
                descricao: "02 - Gás"
            }
        ];

        vm.tipoColetas = [
            {
                codigo: 1,
                descricao: "01 - Leitura"
            },
            {
                codigo: 2,
                descricao: "02 - Consumo"
            }
        ]

        vm.dtOptions = DatatableFactory.construirDtOptionsResponsivoSemPaginacaoPadrao([
            {
                targets: [0],
                orderable: false
            },
            {
                targets: [1],
                responsivePriority: 1
            }
        ]);
        vm.dtOptions.order = [];
        vm.selecionarTodosCampos = 'N';

        $scope.$watch('vm.arquivo', function () {
            if (vm.arquivo) {
                if (_validarArquivo(vm.arquivo)) {
                    vm.leiturista.foto.nome = vm.arquivo.nome;
                    vm.leiturista.foto.tipo = vm.arquivo.tipo;
                    vm.leiturista.foto.conteudo = vm.arquivo.conteudo;
                }
            } else {
                _adicionarFotoPadrao();
            }
        });

        $scope.$watch('vm.leiturista.recadastramentoPermissaoAlteracao', function (newValue) {
            var icons = {
                'informacoesPessoais': 'icon-bookmark s24',
                'informacoesEndereco': 'icon-bookmark s24',
                'informacoesLigacao': 'icon-bookmark s24',
                'informacoesImovel': 'icon-bookmark s24'
            };
            if (newValue) {
                Object.keys(icons).forEach(function (tabKey, index) {
                    var tipoInformacao = index + 1;
                    var permiteRecadastrar = newValue.some(function (item) {
                        return item.tipoInformacao === tipoInformacao && item.permiteRecadastrar === 'S';
                    });

                    icons[tabKey] = permiteRecadastrar ? 'icon-bookmark-check s24' : 'icon-bookmark s24';
                });
            }
            vm.tabIcones = icons;
            exibirItensTabela(vm.tabSelecionadaTabela);
        }, true);



        function zeraCampoComValorNulo(keyCampo, propriedade) {
            if (!propriedade) {
                if (keyCampo == "modeloImpressao") {
                    vm.leiturista.configuracao.modeloImpressao = 0;
                } else if (keyCampo == "detalheModeloImpressao") {
                    vm.leiturista.configuracao.detalheModeloImpressao = 0;
                } else if (keyCampo == "tamanhoFormularioImpressao") {
                    vm.leiturista.configuracao.tamanhoFormularioImpressao = 0;
                } else if (keyCampo == "coordenadaXCodigoBarras") {
                    vm.leiturista.configuracao.coordenadaXCodigoBarras = 0;
                } else {
                    vm.leiturista[keyCampo] = 0;
                }
            }
        }

        function pesquisar() {
            _limparCampoFotoParaPesquisa();
            return RequisicaoGenericaService.listarPorPaginacaoJsonFormato(rotaApi.listarPorPaginacao, vm.entidadeDeEnvio);
        }

        function novaPesquisa() {
            vm.leiturista = LeituristaFactory.leiturista();
            _adicionarFotoPadrao();

            return;
        }

        function reverter() {
            if (vm.leiturista == undefined || vm.leiturista == {}) {
                vm.leiturista = LeituristaFactory.leiturista();
                _adicionarFotoPadrao();
            } else if (vm.controleForm.entidadeClonada) {
                vm.leiturista = vm.controleForm.entidadeClonada;
                vm.controleForm.entidadeClonada = undefined;
            }

            //remover erros de validação
            Object.keys(vm.form).forEach(function (key) {
                if (typeof vm.form[key] === 'object' && vm.form[key].hasOwnProperty('$error')) {
                    vm.form[key].$error = {};
                }
            });
            vm.form.$setPristine();
            vm.form.$setUntouched();
        }

        function salvar(entidade) {
            var deferred = $q.defer();
            if (_validar()) {
                RequisicaoGenericaService.salvar(rotaApi.criar, entidade).then(
                    function (success) {
                        deferred.resolve(success);
                        if (success.data.recadastramento.utilizaRecadastramento == 'S') {
                            _verificarParametrosVerdadeiros();
                        }
                    },
                    function (error) {
                        var mensagemErro = "";
                        if (error.data && error.data.errors && error.data.errors['']) {
                            error.data.errors[''].map(function (err) {
                                mensagemErro += err + "<br>";
                            });
                            MdDialogService.alertPadrao("Atenção", null, mensagemErro);
                        } else {
                            MdDialogService.alertPadrao("Atenção", null, error.data);
                        }
                        vm.controleForm.emProgresso = false;
                    }
                );
            }
            return deferred.promise;
        }

        function editar(entidade) {
            var deferred = $q.defer();
            if (_validar()) {
                RequisicaoGenericaService.editar(rotaApi.editar, entidade).then(
                    function (success) {
                        deferred.resolve(success);
                        if (success.data.recadastramento.utilizaRecadastramento == 'S') {
                            _verificarParametrosVerdadeiros();
                        }
                    },
                    function (error) {
                        var mensagemErro = "";
                        if (error.data && error.data.errors && error.data.errors['']) {
                            error.data.errors[''].map(function (err) {
                                mensagemErro += err + "<br>";
                            });
                            MdDialogService.alertPadrao("Atenção", null, mensagemErro);
                        } else {
                            MdDialogService.alertPadrao("Atenção", null, error.data);
                        }
                        vm.controleForm.emProgresso = false;
                    }
                );
            }
            return deferred.promise;
        }

        function excluir(entidade) {
            return RequisicaoGenericaService.excluir(rotaApi.excluir, entidade.codigo)
        }

        function construirDtOptions() {
            LeituristaFactory.construirDtOptions('#cadastros-leituristas-datatable-leiturista', selecionar, vm.entidadeDeEnvio);
        }

        function selecionar(posicaoEntidade) {
            vm.metodosExternosPgToolbar.metodoControladorExternoListarTodasEntidades(null, posicaoEntidade);
        }

        function predefinirCamposParaInsercao() {
            vm.leiturista = LeituristaFactory.predefinirCamposInsercao();
            vm.leiturista.foto.conteudo = 'assets/images/avatars/user.jpg';
            vm.leiturista = {
                configuracao: {
                    segmento: "01",
                    tipoColeta: 1,
                },
                recadastramentoPermissaoAlteracao: angular.copy(ListarCamposRecadastramento.data)
            };
            vm.tabSelecionadaTabela = 'informacoes-pessoais';
            vm.selecionarTodosCampos = 'S'
        }

        function predefinirCamposParaEdicao() {
            var novosCampos = ListarCamposRecadastramento.data.filter(function (campo) {
                return !vm.leiturista.recadastramentoPermissaoAlteracao.some(function (item) {
                    return item.codigo == campo.codigo;
                });
            });

            vm.leiturista.recadastramentoPermissaoAlteracao.push.apply(vm.leiturista.recadastramentoPermissaoAlteracao, novosCampos);
            vm.leiturista.recadastramentoPermissaoAlteracao.sort(function (a, b) {
                return a.codigo - b.codigo;
            });
            var permiteRecadastrar = _verificarPermissaoTodosCampos();
            if (permiteRecadastrar) {
                vm.selecionarTodosCampos = 'S';
                vm.form.$setDirty();
            }
        }

        function definirCamposClonados() {
            var entidade = angular.copy(vm.controleForm.entidadeClonada);

            entidade.codigo = undefined;
            entidade.nome = undefined;
            entidade.apelido = undefined;
            entidade.endereco = undefined;
            entidade.bairro = undefined;
            entidade.cep = undefined;
            entidade.cidade = undefined;
            entidade.telefoneCelular = undefined;
            entidade.telefoneResidencial = undefined;

            vm.leiturista = entidade;
        }

        function ngChangeTipoRotina(tipoRotina) {
            ValidacaoService.validarParametroString(tipoRotina);
            if (tipoRotina == "02") {
                vm.leiturista.desabilitarLayoutArquivo = true;
                vm.leiturista.configuracao.layoutArquivo = "2";
            } else {
                vm.leiturista.desabilitarLayoutArquivo = false;
            }
        }

        function ngChangeImpressora(impressoraCodigo) {
            if (impressoraCodigo && impressoraCodigo != null) {
                var impressora = vm.impressoras.filter(function (item) {
                    if (item.codigo == impressoraCodigo) {
                        return item;
                    }
                });

                if (impressora[0].metodoImpressaoZebra == 1) {
                    vm.leiturista.bloquearTamanhoFormulario = true;
                } else {
                    vm.leiturista.bloquearTamanhoFormulario = false;
                }
            } else {
                vm.leiturista.bloquearTamanhoFormulario = false;
            }
        }

        function selecionarFoto() {
            vm.form.$pristine = false;
            document.querySelector('#cadastro-leiturista-foto').click();
        }

        function limparFoto() {
            document.querySelector('#cadastro-leiturista-foto').value = null;
            _adicionarFotoPadrao();
            vm.form.$pristine = false;
        }

        function onChangePortaBluetoothTelemetria(input, form, controleForm) {
            if (input.$modelValue <= 0 && (controleForm.editarAtivo || controleForm.inserirAtivo)) {
                form.portaBluetoothTelemetria.$setValidity("portaBluetoothTelemetria", false);
            } else {
                form.portaBluetoothTelemetria.$setValidity("portaBluetoothTelemetria", true);
            }
        }

        function onChangeTamanhoFormulario(input, controleForm) {
            if ((input.$modelValue < 1500 || input.$modelValue == null || input.$modelValue == undefined)
                && (controleForm.editarAtivo || controleForm.inserirAtivo) && !vm.leiturista.bloquearTamanhoFormulario) {
                input.$setValidity("tamanhoFormulario", false);
            } else {
                input.$setValidity("tamanhoFormulario", true);
            }
        }

        function onChangeUtilizaLeituraAPI() {
            vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI = undefined;
            vm.leiturista.configuracao.rotaTokenTelemetriaAPI = undefined;
            vm.leiturista.configuracao.enderecoRotaTelemetriaAPI = undefined;
            vm.leiturista.configuracao.usernameTelemetriaAPI = undefined;
            vm.leiturista.configuracao.passwordTelemetriaAPI = undefined;
            vm.leiturista.configuracao.clientIdTelemetriaAPI = undefined;
            vm.leiturista.configuracao.clientSecretTelemetriaAPI = undefined;

        }

        function onChangeFabricante(fabricanteSelecionado) {
            if (fabricanteSelecionado == 2 || fabricanteSelecionado == 4) {
                vm.leiturista.configuracao.usernameTelemetriaAPI = undefined;
                vm.leiturista.configuracao.passwordTelemetriaAPI = undefined;
                vm.leiturista.configuracao.clientIdTelemetriaAPI = undefined;
                vm.leiturista.configuracao.clientSecretTelemetriaAPI = undefined;
            }
        }

        function preencherZerosAEsquerda(valor) {
            if (valor) {
                return valor.toString().padStart(2, '0');
            }
        }

        function verificaHora() {
            var inicio = new Date("2015-11-26T" + vm.leiturista.permissaoAcesso.horaInicial);
            var fim = new Date("2015-11-26T" + vm.leiturista.permissaoAcesso.horaFinal);

            if (fim < inicio) {
                vm.form.horaFim.$setValidity("hora", false);
            } else {
                vm.form.horaFim.$setValidity("hora", true);
            }
        }

        function changeUtilizarRecadastramento(valor) {
            if (valor == 'S') {
                vm.leiturista.recadastramento.permiteRecadastrarRuaBairroNovo = 'S';
            } else {
                vm.leiturista.recadastramento = {
                    permiteRecadastrarRuaBairroNovo: 'N',
                    utilizaPermissaoAlterarCampoRecadastramento: 'N'
                };
            }
        }

        function changeUtilizarConfiguracaoRecadastramentoCampos(valor) {
            var permiteRecadastrar = _verificarPermissaoTodosCampos();

            if (vm.controleForm.inserirAtivo) {
                if (valor == 'S' && permiteRecadastrar) {
                    vm.selecionarTodosCampos = valor;
                }
            }
        }

        function changeSelecionarCampo(valor) {
            var permiteRecadastrar = _verificarPermissaoTodosCampos();

            if (valor.permiteRecadastrar == 'S') {
                vm.selecionarTodosCampos = permiteRecadastrar ? 'S' : 'N';
            } else {
                vm.selecionarTodosCampos = 'N';
            }
        }

        function replicarConfiguracoes(modelo) {
            vm.controleForm.emProgresso = true;

            RequisicaoGenericaService.salvar(rotaApi.replicarRecadastramentoLeituristas, modelo).then(
                function (success) {
                    MdToastService.toastPadrao("Configurações de recadastramento replicadas para todos os leituristas com sucesso!");
                }, function (error) {
                    MdDialogService.alertPadrao("Atenção!", null, error.data);

                }).finally(function () {
                    vm.controleForm.emProgresso = false;
                });
        }

        function exibirItensTabela(tabSelecionada) {
            if (!vm.leiturista.recadastramentoPermissaoAlteracao) return;
            vm.tabSelecionadaTabela = tabSelecionada;
            vm.dadosExibicaoTabela = vm.leiturista.recadastramentoPermissaoAlteracao.filter(function (item) {
                switch (tabSelecionada) {
                    case 'informacoes-pessoais':
                        return item.tipoInformacao === 1;
                    case 'informacoes-endereco':
                        return item.tipoInformacao === 2;
                    case 'informacoes-ligacao':
                        return item.tipoInformacao === 3;
                    case 'informacoes-imovel':
                        return item.tipoInformacao === 4;
                }
            });

            var todosMarcados = vm.dadosExibicaoTabela.every(function (campo) {
                return campo.permiteRecadastrar === 'S';
            });
            vm.selecionarTodosCampos = todosMarcados ? 'S' : 'N';
        }

        function changeSelecionarTodosCampos(valor) {
            const mapeamento = {
                'informacoes-pessoais': 1,
                'informacoes-endereco': 2,
                'informacoes-ligacao': 3,
                'informacoes-imovel': 4
            };

            const tipoInformacao = mapeamento[vm.tabSelecionadaTabela];
            if (tipoInformacao) {
                vm.dadosExibicaoTabela.forEach(function (campo) {
                    if (campo.tipoInformacao === tipoInformacao) {
                        campo.permiteRecadastrar = valor;
                    }
                });
            }
        }

        function _validar() {
            var equipamento = vm.equipamentos.filter(function (item) {
                if (item.codigo == vm.leiturista.configuracao.eqpCodigo) {
                    return item;
                }
            });

            if (vm.leiturista.configuracao.tipoRotina == "02" &&
                equipamento[0].sistemaOperacional == 2 &&
                vm.leiturista.configuracao.codigoFormularioImpressao == null) {
                MdDialogService.alertPadrao("Atenção", null, "O formulário de impressão deve ser configurado.");
                vm.controleForm.emProgresso = false;
                return false;
            }

            if (vm.parametros.calculo.utilizaCalculoProporcionalNumeroDias == "S"
                && vm.leiturista.configuracao.alteraDataLeitura == "S") {
                MdDialogService.alertPadrao("Atenção", null, "Não é permitido utilizar a opção para alterar a data de leitura em conjunto com a rotina de cálculo proporcional.");
                vm.controleForm.emProgresso = false;
                return false;
            }
            return true;
        }

        function _adicionarFotoPadrao() {
            vm.arquivo = undefined;
            vm.leiturista.foto.conteudo = 'assets/images/avatars/user.jpg';
        }

        function _validarArquivo(arquivo) {
            var reg = /[\/.](?:jpg|png)$/i;
            if (!reg.test(arquivo.nome.toUpperCase())) {
                MdDialogService.alertPadrao("Atenção", vm.event, "Extensão para o tipo de arquivo inválida.");
                return false;
            }
            else if (arquivo.tamanho > 5242880) {
                MdDialogService.alertPadrao("Atenção", vm.event, "Tamanho máximo permitido para o tipo de arquivo é de 5MB.");
                return false;
            }

            return true;
        }

        function _limparCampoFotoParaPesquisa() {
            vm.entidadeDeEnvio.clsEntidade.foto = {};
        }

        function _verificarParametrosVerdadeiros() {
            if (vm.leiturista.recadastramento.utilizaRecadastramento == 'S') {
                var possuiOutrosParametrosVerdadeiros = false;

                Object.keys(vm.leiturista.recadastramento).forEach(function (item) {
                    if (item != 'utilizaRecadastramento' && vm.leiturista.recadastramento[item] == 'S') {
                        possuiOutrosParametrosVerdadeiros = true;
                    }
                });

                if (!possuiOutrosParametrosVerdadeiros) {
                    MdDialogService.alertPadrao(
                        "Atenção!",
                        null,
                        "Nenhum parâmetro foi marcado. A rotina de recadastramento, no coletor, será apenas para consulta."
                    );
                }
            }
        }

        function _verificarPermissaoTodosCampos() {
            var permite = vm.dadosExibicaoTabela.every(function (campo) {
                return campo.permiteRecadastrar == 'S';
            });
            return permite;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'sly'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService,
        RequisicaoGenericaService, MdToastService, ApiAtalhos, LoginUsuarioService, $rootScope, MdDialogService) {
        var vm = this;

        var codigoUsuarioLogado = LoginUsuarioService.usuarioArmazenado().codigo;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function () {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response) {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if (vm.shortcuts.length > 0) {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response) {
                        vm.results = response;
                    },
                    // Error
                    function () {
                        vm.results = [];
                    }
                ).finally(
                    function () {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref && flatNavigation[x].state !== 'app.inicio') {
                    results.push(flatNavigation[x]);
                }
            }

            function removerAcentos(str) {
                return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
            }

            for (var i = 0; i < results.length; i++) {
                results[i].hasShortcut = false;
                for (var y = 0; y < vm.shortcuts.length; y++) {
                    if (vm.shortcuts[y]._id === results[i]._id && vm.shortcuts[y]._path === results[i]._path) {
                        results[i].hasShortcut = true;
                        // Copiar os campos necessários do shortcut para o result
                        results[i].codigo = vm.shortcuts[y].codigo;
                        results[i].codigoUsuario = vm.shortcuts[y].codigoUsuario;
                        break;
                    }
                }
            }

            if (vm.query) {
                var queryNormalizada = removerAcentos(vm.query.toLowerCase());

                results = results.filter(function (item) {
                    var tituloNormalizado = removerAcentos(item.title.toLowerCase());
                    return tituloNormalizado.indexOf(queryNormalizada) > -1;
                });
            } else {
                if (vm.shortcuts.length > 0) {
                    results = vm.shortcuts;
                }
            }

            vm.selectedResultIndex = 0;

            $timeout(function () {
                deferred.resolve(results);
            }, 250);

            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.listarSemParams(ApiAtalhos.atalhos.listarTodos + codigoUsuarioLogado).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts(item, adicionarShortCuts) {
            vm.query = "";
            /**
             * Verifica Se é pra inserir ou excluir o atalho com base na váriavel adicionarShortCuts
             */
            if (adicionarShortCuts) {
                // Add as a shortcut
                vm.shortcuts = item;
                vm.results = item;
            }
            else {
                // Remove the shortcut
                for (var x = 0; x < vm.shortcuts.length; x++) {
                    if (vm.shortcuts[x]._id === item._id && vm.shortcuts[x]._path == item._path) {
                        // Remove the x-th item from the array
                        vm.shortcuts.splice(x, 1);

                        // Atualizar os results
                        if (vm.shortcuts.length === 0) {
                            vm.results = null;
                        } else {
                            vm.results = vm.shortcuts;
                        }

                        // Update the selected index
                        if (x >= vm.shortcuts.length) {
                            vm.selectedResultIndex = vm.shortcuts.length - 1;
                        }

                        break;
                    }
                }
            }
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            if (vm.shortcuts.length >= 6) {
                MdDialogService.alertPadrao(
                    'Atenção!',
                    null,
                    'O usuário já atingiu o limite de 6 menus favoritos.'
                );
                return;
            }

            var deferred = $q.defer();

            // Update the hasShortcut status                        
            item.hasShortcut = true;

            var modelo = {
                codigoUsuario: codigoUsuarioLogado,
                id: item._id,
                path: item._path,
                atalho: item.hasShortcut,
                icone: item.icon,
                estado: item.state,
                titulo: item.title,
                uisref: item.uisref,
                peso: item.weight
            };
            // Requisição para api para inserir o Atalho solicitado
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.salvar(ApiAtalhos.atalhos.criar, modelo).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao("Atalho cadastrado com sucesso!");
                        deferred.resolve(success.data);

                        // Save the shortcuts
                        vm.saveShortcuts(success.data, true);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        item.hasShortcut = false;
                        MdToastService.toastPadrao(error.data, true);
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            var deferred = $q.defer();

            // Update the hasShortcut status
            item.hasShortcut = false;

            // Requisição para Api para remover o Atalho
            $timeout(function () {
                $rootScope.loadingProgress = true;
                RequisicaoGenericaService.excluir(ApiAtalhos.atalhos.excluir, item.codigo + "/" + item.codigoUsuario).then(
                    function (success) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao(success.data);
                        deferred.resolve(success.data);

                        //Save the shortcuts
                        vm.saveShortcuts(item, false);
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        MdToastService.toastPadrao(error.data, true);
                        deferred.reject(error.data);
                    });
            });

            return deferred.promise;
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if (item.hasShortcut) {
                vm.removeShortcut(item);
            }
            else {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > (resultsEl.height() + resultsEl.scrollTop())) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict: 'E',
            scope: {},
            require: 'msShortcuts',
            controller: 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile: function (tElement) {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement) {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * Created by nova on 28/07/2016.
 */
(function()
 {
    'use strict';

    angular
        .module('app.diretivas',
                [

    ]);


})();

(function () {
    'use strict';
    angular
        .module('app.diretivas')
        .directive('caracteresPermitidos', caracteresPermitidosDirective);

    /** @ngInject */
    function caracteresPermitidosDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var regexDeCaracteresInvalidos = /[^a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ \-!@#$%^&*()_=+\[\]{};':"\\|,.<>\/?~`]/g;

                function removerCaracteresInvalidos(texto) {
                    if (!texto) {
                        return undefined;
                    }

                    var textoLimpo = texto.replace(regexDeCaracteresInvalidos, '');

                    if (textoLimpo !== texto) {
                        ngModelCtrl.$setViewValue(textoLimpo);
                        ngModelCtrl.$render();
                    }
                    return textoLimpo;
                }

                ngModelCtrl.$parsers.push(removerCaracteresInvalidos);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module ('app.diretivas')
        .directive('validacaoMes', function(){
            return {
                require: 'ngModel', 
                link: function(scope, elm, attrs, ctrl){
                    ctrl.$validators.mes_invalido = function(modelValue, viewValue){                        
                        if(viewValue != '' &&(viewValue <= 12 && viewValue > 0))
                            return true;
                        return false;
                    };
                }
            };
        });
} ());
(function () {

    'use strict';

    angular
        .module('app.service')
        .service('ValidacaoIEService', ValidacaoIEService);

    /** @ngInject */
    function ValidacaoIEService() {
        this.validarInscricaoEstadual = validarInscricaoEstadual;

        function eIndefinido(objeto) {
            return typeof objeto === typeof undefined;
        }

        function tamanhoNaoE(string, tamanho) {
            if (eIndefinido(tamanho)) {
                tamanho = 9;
            }

            return string.length !== tamanho;
        }

        function tamanhoE(string, tamanho) {
            return !tamanhoNaoE(string, tamanho);
        }

        function serie(de, ate) {
            var resultado = [];

            while (de <= ate) {
                resultado.push(de++);
            }

            return resultado;
        }

        function primeiros(string, quantidade) {
            if (eIndefinido(quantidade)) {
                quantidade = 8;
            }

            return string.substring(0, quantidade);
        }

        function substracaoPor11SeMaiorQue2CasoContrario0(valor) {
            return valor < 2 ? 0 : 11 - valor;
        }

        function mod(valor, multiplicadores, divisor) {
            if (eIndefinido(divisor)) {
                divisor = 11;
            }

            if (eIndefinido(multiplicadores)) {
                multiplicadores = serie(2, 9);
            }

            var i = 0;

            return valor.split('').reduceRight(function (anterior, atual) {
                if (i > multiplicadores.length - 1) {
                    i = 0;
                }

                return (multiplicadores[i++] * parseInt(atual, 10)) + anterior;
            }, 0) % divisor;
        }

        function calculoTrivial(valor, base, validarTamanho) {
            if (!validarTamanho && tamanhoNaoE(valor)) {
                return false;
            }

            if (eIndefinido(base)) {
                base = primeiros(valor);
            }

            var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

            return valor === base + digito;
        }

        function naoComecaCom(string, valor) {
            return string.substring(0, valor.length) !== valor;
        }

        function entre(valor, limiteInferior, limiteSuperior) {
            if (typeof valor === 'string') {
                valor = parseInt(valor, 10);
            }

            return valor >= limiteInferior && valor <= limiteSuperior;
        }

        var funcoes = {
            ba: function (valor) {
                if (tamanhoNaoE(valor, 8) && tamanhoNaoE(valor)) {
                    return false;
                }

                var base = primeiros(valor, valor.length - 2);
                var primeiroDigito, segundoDigito;

                var segundoMultiplicador = serie(2, 7);
                var primeiroMultiplicador = serie(2, 8);

                var primeiroResto, segundoResto;
                var digitoComparacao = valor.substring(0, 1);

                if (tamanhoE(valor, 9)) {
                    segundoMultiplicador.push(8);
                    primeiroMultiplicador.push(9);
                    digitoComparacao = valor.substring(1, 2);
                }

                if ('0123458'.split('').indexOf(digitoComparacao) !== -1) {
                    segundoResto = mod(base, segundoMultiplicador, 10);
                    segundoDigito = segundoResto === 0 ? 0 : 10 - segundoResto;

                    primeiroResto = mod(base + segundoDigito, primeiroMultiplicador, 10);
                    primeiroDigito = primeiroResto === 0 ? 0 : 10 - primeiroResto;
                } else {
                    segundoResto = mod(base, segundoMultiplicador);
                    segundoDigito = substracaoPor11SeMaiorQue2CasoContrario0(segundoResto);

                    primeiroResto = mod(base + segundoDigito, primeiroMultiplicador);
                    primeiroDigito = substracaoPor11SeMaiorQue2CasoContrario0(primeiroResto);
                }

                return valor === base + primeiroDigito + segundoDigito;
            },

            se: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            al: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '24')) {
                    return false;
                }

                //
                // Removi a validação do tipo da empresa abaixo
                // devido a ambiguidade entre a especificação do
                // Sintegra (http://www.sintegra.gov.br/Cad_Estados/cad_AL.html) e do
                // site do da Sefaz do Alagoas (http://www.sefaz.al.gov.br/sintegra/cad_AL.asp).
                // Veja o issue #4 - https://github.com/gammasoft/ie/issues/4
                //
                // if('03578'.split('').indexOf(valor.substring(2, 3)) === -1) {
                //     return false;
                // }

                var base = primeiros(valor);

                var resto = mod(base) * 10;
                resto = resto - (parseInt(resto / 11, 10) * 11);
                var digito = resto === 10 ? 0 : resto;

                return valor === base + digito;
            },

            pb: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            rn: function (valor) {
                if (tamanhoNaoE(valor) && tamanhoNaoE(valor, 10)) {
                    return false;
                }

                if (naoComecaCom(valor, '20')) {
                    return false;
                }

                var base = valor.substring(0, valor.length - 1);

                var multiplicadores = serie(2, 9);
                if (tamanhoE(valor, 10)) {
                    multiplicadores.push(10);
                }

                var resto = (mod(base, multiplicadores) * 10) % 11;
                var digito = resto === 10 ? 0 : resto;

                return valor === base + digito;
            },

            ap: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '03')) {
                    return false;
                }

                var base = primeiros(valor);

                var p, d;

                if (entre(base, 3000001, 3017000)) {
                    p = 5;
                    d = 0;
                } else if (entre(base, 3017001, 3019022)) {
                    p = 9;
                    d = 1;
                } else {
                    p = 0;
                    d = 0;
                }

                var resto = mod(p + base, [2, 3, 4, 5, 6, 7, 8, 9, 1]);

                var digito;
                if (resto === 1) {
                    digito = 0;
                } else if (resto === 0) {
                    digito = d;
                } else {
                    digito = 11 - resto;
                }

                return valor === base + digito;
            },

            rr: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '24')) {
                    return false;
                }

                var base = primeiros(valor);
                var digito = mod(base, [8, 7, 6, 5, 4, 3, 2, 1], 9);

                return valor === base + digito;
            },

            am: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ro: function (valor) {
                var base, digito, resultadoMod;

                if (tamanhoE(valor, 9)) {
                    base = valor.substring(3, 8);
                    digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

                    return valor === valor.substring(0, 3) + base + digito;
                } else if (tamanhoE(valor, 14)) {
                    base = primeiros(valor, 13);
                    resultadoMod = mod(base);
                    digito = resultadoMod <= 1 ? 1 : 11 - resultadoMod;

                    return valor === base + digito;
                } else {
                    return false;
                }
            },

            rj: function (valor) {
                if (tamanhoNaoE(valor, 8)) {
                    return false;
                }

                var base = primeiros(valor, 7);
                var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base, serie(2, 7)));

                return valor === base + digito;
            },

            sc: function (valor) {
                return calculoTrivial(valor);
            },

            pi: function (valor) {
                return calculoTrivial(valor);
            },

            es: function (valor) {
                return calculoTrivial(valor);
            },

            pr: function (valor) {
                if (tamanhoNaoE(valor, 10)) {
                    return false;
                }

                var base = primeiros(valor);

                var restoPrimeiro = mod(base, serie(2, 7));
                var primeiro = 11 - restoPrimeiro >= 10 ? 0 : 11 - restoPrimeiro;

                var restoSegundo = mod(base + primeiro, serie(2, 7));
                var segundo = 11 - restoSegundo >= 10 ? 0 : 11 - restoSegundo;

                return valor === base + primeiro + segundo;
            },

            pa: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '15')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ce: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '06')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            pe: function (valor) {
                var base = valor.substring(0, valor.length - 2);

                var restoPrimeiro = mod(base);
                var primeiro = 11 - restoPrimeiro >= 10 ? 0 : 11 - restoPrimeiro;

                var restoSegundo = mod(base + primeiro);
                var segundo = 11 - restoSegundo >= 10 ? 0 : 11 - restoSegundo;

                return valor === base + primeiro + segundo;
            },

            ma: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (naoComecaCom(valor, '12')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            ac: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                if (naoComecaCom(valor, '01')) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var primeiroDigito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));
                var segundoDigito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiroDigito));

                return valor === base + primeiroDigito + segundoDigito;
            },

            rs: function (valor) {
                if (tamanhoNaoE(valor, 10)) {
                    return false;
                }

                var base = primeiros(valor, 9);
                return calculoTrivial(valor, base, true);
            },

            mt: function (valor) {
                if (tamanhoNaoE(valor, 11) && tamanhoNaoE(valor)) {
                    return false;
                }

                var base = tamanhoE(valor, 11) ? valor.substring(0, 10) : primeiros(valor);
                return calculoTrivial(valor, base);
            },

            sp: function (valor) {
                valor = valor.toUpperCase();

                var segundaBase;

                if (valor.substr(0, 1) === 'P') {
                    if (tamanhoNaoE(valor, 13)) {
                        return false;
                    }

                    var base = valor.substring(1, 9);
                    segundaBase = valor.substring(10, 13);
                    var resto = mod(base, [10, 8, 7, 6, 5, 4, 3, 1]).toString();
                    var digito = resto.length > 1 ? resto[1] : resto[0];

                    return valor === 'P' + base + digito + segundaBase;
                } else {
                    if (tamanhoNaoE(valor, 12)) {
                        return false;
                    }

                    var primeiraBase = primeiros(valor);
                    segundaBase = valor.substring(9, 11);

                    var primeiroResto = mod(primeiraBase, [10, 8, 7, 6, 5, 4, 3, 1]).toString();
                    var primeiro = primeiroResto.length > 1 ? primeiroResto[1] : primeiroResto[0];

                    var segundoResto = mod(primeiraBase + primeiro + segundaBase, serie(2, 10)).toString();
                    var segundo = segundoResto.length > 1 ? segundoResto[1] : segundoResto[0];

                    return valor === primeiraBase + primeiro + segundaBase + segundo;
                }
            },

            mg: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var baseComZero = valor.substring(0, 3) + '0' + valor.substring(3, 11);

                var i = 0;
                var produtorioLiteral = baseComZero.split('').reduceRight(function (anterior, atual) {
                    if (i > [2, 1].length - 1) {
                        i = 0;
                    }

                    return ([2, 1][i++] * parseInt(atual, 10)).toString() + anterior.toString();
                }, '').split('').reduce(function (anterior, atual) {
                    return anterior + parseInt(atual);
                }, 0);

                var primeiro = ((parseInt(produtorioLiteral / 10) + 1) * 10) - produtorioLiteral;
                if (primeiro === 10) {
                    primeiro = 0;
                }

                var segundo = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiro, serie(2, 11)));

                return valor === base + primeiro + segundo;
            },

            to: function (valor) {
                if (tamanhoNaoE(valor) && tamanhoNaoE(valor, 11)) {
                    return false;
                }

                var base;

                if (tamanhoE(valor, 11)) {
                    if (['01', '02', '03', '99'].indexOf(valor.substring(2, 4)) === -1) {
                        return false;
                    }

                    base = valor.substring(0, 2) + valor.substring(4, 10);
                } else {
                    base = primeiros(valor);
                }

                var digito = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));

                return valor === valor.substring(0, valor.length - 1) + digito;
            },

            go: function (valor) {
                if (tamanhoNaoE(valor)) {
                    return false;
                }

                if (['10', '11', '15'].indexOf(valor.substring(0, 2)) === -1) {
                    return false;
                }

                var base = primeiros(valor);

                if (base === '11094402') {
                    return valor.substr(8) === '1' || valor.substr(8) === '0';
                }

                var resto = mod(base);
                var digito;

                if (resto === 0) {
                    digito = 0;
                } else if (resto === 1) {
                    if (entre(base, 10103105, 10119997)) {
                        digito = 1;
                    } else {
                        digito = 0;
                    }
                } else {
                    digito = 11 - resto;
                }

                return valor === base + digito;
            },

            ms: function (valor) {
                if (naoComecaCom(valor, '28')) {
                    return false;
                }

                return calculoTrivial(valor);
            },

            df: function (valor) {
                if (tamanhoNaoE(valor, 13)) {
                    return false;
                }

                var base = primeiros(valor, 11);

                var primeiro = substracaoPor11SeMaiorQue2CasoContrario0(mod(base));
                var segundo = substracaoPor11SeMaiorQue2CasoContrario0(mod(base + primeiro));

                return valor === base + primeiro + segundo;
            }
        };

        function lookup(ie) {
            var resultado = [];

            for (var estado in funcoes) {
                if (funcoes[estado](ie)) {
                    resultado.push(estado);
                }
            }

            if (tamanhoE(resultado, 0)) {
                return false;
            } else {
                return resultado;
            }
        }

        function validarInscricaoEstadual(ie, estado) {
            if (eIndefinido(estado) || estado === null) {
                estado = '';
            }

            estado = estado.toLowerCase();

            if (estado !== '' && !(estado in funcoes)) {
                throw new Error('estado não é válido');
            }

            if (eIndefinido(ie)) {
                throw new Error('ie deve ser fornecida');
            }

            if (Array.isArray(ie)) {
                return ie.map(function (ie) { return validar(ie, estado); });
            }

            if (typeof ie !== 'string') {
                throw new Error('ie deve ser string ou array de strings');
            }

            if (ie.match(/^ISENTO$/i)) {
                return true;
            }

            ie = ie.replace(/[\.|\-|\/|\s]/g, '');

            if (estado === '') {
                return lookup(ie);
            }

            if (/^\d+$/.test(ie) || estado === 'sp') {
                return funcoes[estado](ie);
            }

            return false;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('validacaoIe', validacaoIeDirective);

    function validacaoIeDirective(ValidacaoIEService) {
        return {
            restrict: 'A',
            require: '^ngModel',
            scope: {
                uf: '=?',
                naoHabilitarValidacao: '=?'
            },
            controller: function () {
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    $log.error("É necessário informar o ng-model para o funcionamento correto da diretiva");
                    return;
                }

                /**
                 * Método de controle executado para validar ou inválidar o modél, também criando um validador customizado à ser utilizado na view
                 * 'validacaoDocumento', e este método é disparado sempre ao final da execução de um $parses ou $formatters
                 */
                ngModelCtrl.$validators.validacaoIE = function (modelValue, viewValue) {
                    if (!viewValue || viewValue.length == 0)
                        return true;
                    else if (scope.naoHabilitarValidacao ){
                        return true;
                    }
                    else if (viewValue && ValidacaoIEService.validarInscricaoEstadual(viewValue, scope.uf)) {
                        return true;
                    }
                    else
                        return false;

                }
            }
        }
    };

})();

/**
 * Created by nova on 05/08/2016.
 */
(function () {
    'use strict';

    angular.module('app.diretivas')
        .controller('ToolbarDesktopMobileController', ToolbarDesktopMobileController)
        .directive('toolbarDesktopMobile', toolbarDesktopMobileDirective);


    function ToolbarDesktopMobileController($scope, $rootScope, $mdSidenav, MdDialogService, MdToastService, $interval, $timeout) {
        var vm = this;

        // Controladores
        this.$onInit = function () {

            vm.metodosExternos = {
                metodoAcaoExternoCriar: metodoToolbarSalvar
            };

            // Controle do Formulário utilizado pela diretiva no bindToController{controleForm: "=?"}
            vm.controleForm = {
                emProgresso: false,
                desabilitarButtonEditar: false,
                desabilitarButtonInserir: false,
                desabilitarButtonExcluir: false,
                desabilitarButtonListarTodos: false,
                desabilitarMetodoToolbarAtualizar: false,
                habilitarButtonSalvar: false,
                pesquisa: {
                    pesquisar: function () {
                        vm.toolbar.pesquisar();
                    },
                    novaPesquisa: function () {
                        vm.toolbar.novaPesquisa();
                    },
                    chamarPesquisar: function () {
                        vm.metodosToolbar.pesquisar();
                    }
                },
                reverter: function (ativarControladorPesquisaAtiva) {
                    vm.toolbar.reverter(ativarControladorPesquisaAtiva);
                },
                pesquisaAtiva: false,
                inserirAtivo: false,
                editarAtivo: false,
                listarTodasEntidades: false,
                chamarListagemTodasEntidades: function () {
                    listarTodasEntidades();
                },
                pesquisarDatatable: false,
                entidadesPesquisadas: null,
                atualizarIndice: {
                    atualizarIndiceParaUltimaPosicao: function () {
                        vm.indice = vm.entidades.length - 1;
                    }
                },
                listarTodas: function (id) {
                    vm.indice = id;

                    if (vm.indice === 0) {
                        vm.controlador.primeiraEntidade = true;
                        vm.controlador.ultimaEntidade = false;
                    } else if (vm.indice === vm.entidades.length - 1) {
                        vm.controlador.primeiraEntidade = false;
                        vm.controlador.ultimaEntidade = true;
                    } else {
                        vm.controlador.primeiraEntidade = false;
                        vm.controlador.ultimaEntidade = false;
                    }

                    vm.controleForm.listarTodasEntidades = false;
                    vm.toolbar.listarTodasEntidades();
                },
                preLoaderToolbar: {
                    inicioProgresso: function () {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                    },
                    fimProgresso: function () {
                        metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                    }
                },
                atualizar: {
                    atualizar: function (event) {
                        vm.metodosToolbar.atualizar(event);
                    }
                }
            };

            // Controlador para exibir o textoExibido da aplicação no determinado momento
            vm.controleTextoAExibir = {
                aguardando: "Aguardando",
                novaPesquisa: "Nova Pesquisa",
                pesquisando: "Exibindo",
                editando: "Editando",
                inserindo: "Inserindo",
                listarTodasEntidades: "Exibindo em modo Tabela"
            };

            // Controlador para habilitar e desabilitar os buttons com base no textoExibido que à aplicação está
            vm.controlador = {
                pesquisaAtiva: false,
                primeiraEntidade: false,
                ultimaEntidade: false,
                editarAtivo: false,
                novaEntidade: false,
                listarTodasEntidades: false,
                processaEntidade: false,
            };

            /**
             * Função que interage com o recurso link da diretiva,
             * para pegar o controle do formulário
             * @param formCtrl
             */
            $scope.getFormCtrl = function (formCtrl) {
                vm.formulario = formCtrl;
            };

            // Data
            vm.textoExibido = vm.controleTextoAExibir.aguardando;
            vm.buttonSelecionado = null;
            vm.tempoDelay = 350;
            vm.indice = 0;
            vm.progresso = 0;
            vm.progressoBuffer = 0;
            var promessa = null;
            var processando = undefined;
            var entidadeTemporaria = {};

            ///////////////////////////////////////////////////////////////////

            // Definição Dos Métodos
            var metodosInternosToolbar = {
                chamarPesquisa: chamarPesquisa,
                atualizarFormulario: atualizarFormulario,
                preLoaderToolbar: {
                    inicioProgresso: inicioProgresso,
                    fimProgresso: fimProgresso
                },
                preDefinirControleForm: preDefinirControleForm
            };
            vm.toolbar = {
                novaPesquisa: novaPesquisa,
                pesquisar: pesquisar,
                editar: editar,
                inserir: inserir,
                reverter: reverter,
                primeira: primeira,
                anterior: anterior,
                proxima: proxima,
                ultima: ultima,
                listarTodasEntidades: listarTodasEntidades,
                abrirSidenav: abrirSidenav
            };
            vm.metodosToolbar = {
                pesquisar: metodoToolbarPesquisar,
                atualizar: metodoToolbarAtualizar,
                salvar: metodoToolbarSalvar,
                excluir: metodoToolbarExcluir
            };
            ////////////////////////////////////////////////////////////////////////////


            // Métodos em Scopo

            $scope.$on('$destroy', function () {
                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
            });

            // Métodos Internos
            function chamarPesquisa(event, implementacaoSuccess) {
                promessa = vm.pesquisar();
                if (promessa) {
                    metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                    promessa.then(
                        function (success) {
                            if (success.data.length > 0) {
                                implementacaoSuccess(success);
                                console.log(vm.entidades);
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            } else {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();

                                if (!vm.desabilitarMensagemAoPesquisar)
                                    MdDialogService.alertPadrao("Não foi encontrado nenhum registro cadastrado", event);

                                vm.toolbar.novaPesquisa();
                            }
                        },
                        function (error) {
                            if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                if (error.data.indexOf("\n") != -1)
                                    MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                else
                                    MdDialogService.alertPadrao(error.data, event);
                            }
                            else {
                                MdDialogService.alertPadrao(error.data, event);
                            }

                            metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            vm.toolbar.novaPesquisa();
                        });
                }
            }

            function atualizarFormulario() {
                if (angular.isDefined(vm.formulario)) {
                    vm.formulario.$setUntouched();
                    vm.formulario.$setPristine();
                }
            }

            function inicioProgresso() {
                vm.controleForm.emProgresso = true;
                processando = $interval(function () {
                    vm.progresso += 3;

                    if (vm.progresso > 100)
                        vm.progresso = 0;

                }, 100);
            }

            function fimProgresso() {
                vm.controleForm.emProgresso = false;
                vm.progresso = 0;
                if (angular.isDefined(processando)) {
                    $interval.cancel(processando);
                    processando = undefined;
                }
            }

            /**
             * Método para redefinidir as propriedade de vm.controleForm
             * @param {string} chamada 
             */
            function preDefinirControleForm(chamada) {
                if (chamada == "novaPesquisa") {
                    vm.controleForm.pesquisaAtiva = false;
                    vm.controleForm.listarTodasEntidades = false;
                    vm.controleForm.entidadesPesquisadas = null;
                    vm.controleForm.desabilitarButtonInserir = false;
                    vm.controleForm.desabilitarButtonEditar = false;
                }
                if (chamada == "reverter") {

                }
                vm.controleForm.inserirAtivo = false;
                vm.controleForm.editarAtivo = false;
                vm.controleForm.habilitarButtonSalvar = false;
            }
            ////////////////////////////////////////////

            // Métodos Toolbar
            function novaPesquisa() {
                metodosInternosToolbar.atualizarFormulario();


                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controlador.pesquisaAtiva = false;
                vm.controlador.primeiraEntidade = false;
                vm.controlador.ultimaEntidade = false;
                vm.controlador.editarAtivo = false;
                vm.controlador.novaEntidade = false;
                vm.controlador.listarTodasEntidades = false;
                vm.controlador.processaEntidade = false;


                preDefinirControleForm("novaPesquisa");



                vm.indice = 0;
                vm.textoExibido = vm.controleTextoAExibir.novaPesquisa;
                vm.entidades = [];
                vm.entidade = {};
                entidadeTemporaria = {};

                if (angular.isDefined(vm.toolbarNovaPesquisa)) {
                    vm.toolbarNovaPesquisa();
                }

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }
            }

            function pesquisar() {
                metodosInternosToolbar.atualizarFormulario();

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controleForm.pesquisaAtiva = true;
                vm.controlador.pesquisaAtiva = true;

                vm.controlador.primeiraEntidade = true;

                if (vm.controlador.listarTodasEntidades) {
                    vm.textoExibido = vm.controleTextoAExibir.listarTodasEntidades;
                }
                else {
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;
                }
            }

            function editar(entidade) {
                metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarEditar)) {
                    vm.toolbarEditar();
                }

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                entidadeTemporaria = angular.copy(entidade);
                vm.textoExibido = vm.controleTextoAExibir.editando;
                vm.controleForm.editarAtivo = true;
                vm.controlador.editarAtivo = true;

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }
            }

            function inserir(entidade) {
                //      metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarInserir)) {
                    vm.toolbarInserir();
                }
                if (entidade) {
                    entidadeTemporaria = entidade;
                }

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                vm.textoExibido = vm.controleTextoAExibir.inserindo;
                vm.controleForm.inserirAtivo = true;
                vm.controlador.novaEntidade = true;

                if (vm.controlador.pesquisaAtiva) {
                    vm.entidade = {};
                }

                if (!$rootScope.tamanhoTelaDesktop) {
                    $mdSidenav('sidenav').close();
                }

            }

            function reverter(ativarControladorPesquisaAtiva) {
                metodosInternosToolbar.atualizarFormulario();

                if (angular.isDefined(vm.toolbarReverter)) {
                    vm.toolbarReverter();
                }

                // Seta os controladores de edição ou inserção para false e retorna a entidade para o textoExibido anterior
                preDefinirControleForm("reverter");

                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

                vm.controlador.editarAtivo = false;
                vm.controlador.novaEntidade = false;

                if (!vm.controlador.pesquisaAtiva && ativarControladorPesquisaAtiva) {
                    vm.toolbar.pesquisar();
                } else if (vm.controlador.pesquisaAtiva && !ativarControladorPesquisaAtiva) {
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;
                    vm.entidade = entidadeTemporaria;
                } else if (!vm.controlador.pesquisaAtiva && !ativarControladorPesquisaAtiva) {
                    vm.textoExibido = vm.controleTextoAExibir.novaPesquisa;
                    vm.entidade = entidadeTemporaria;
                }

                if (vm.indice === -1) {
                    vm.toolbar.novaPesquisa();
                } else if (vm.indice === 0) {
                    vm.controlador.primeiraEntidade = true;
                    vm.controlador.ultimaEntidade = false;
                } else if (vm.indice === vm.entidades.length - 1) {
                    vm.controlador.ultimaEntidade = true;
                    vm.controlador.primeiraEntidade = false;
                } else {
                    vm.controlador.ultimaEntidade = false;
                    vm.controlador.primeiraEntidade = false;
                }
            }

            function primeira() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    vm.indice = 0;
                    vm.entidade = vm.entidades[0];
                    vm.controlador.primeiraEntidade = true;
                    vm.controlador.ultimaEntidade = false;
                    vm.controlador.processaEntidade = false;
                }, 250);

                if (angular.isDefined(vm.primeira)) {
                    vm.primeira();
                }
            }

            function anterior() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    if (vm.indice > 0) {
                        vm.controlador.ultimaEntidade = false;
                        vm.entidade = vm.entidades[vm.indice - 1];
                        vm.indice--;
                        vm.controlador.processaEntidade = false;
                        if (vm.indice === 0) {
                            vm.controlador.primeiraEntidade = true;
                        }
                    }
                }, 250);

                if (angular.isDefined(vm.anterior)) {
                    vm.anterior();
                }
            }

            function proxima() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    if (vm.indice < vm.entidades.length - 1) {
                        vm.controlador.primeiraEntidade = false;
                        vm.entidade = vm.entidades[vm.indice + 1];
                        vm.indice++;
                        vm.controlador.processaEntidade = false;
                        if (vm.indice === vm.entidades.length - 1) {
                            vm.controlador.ultimaEntidade = true;
                        }
                    }
                }, 250);

                if (angular.isDefined(vm.proxima)) {
                    vm.proxima();
                }
            }

            function ultima() {
                vm.controlador.processaEntidade = true;
                $timeout(function () {
                    vm.indice = vm.entidades.length - 1;
                    vm.entidade = vm.entidades[vm.entidades.length - 1];
                    vm.controlador.primeiraEntidade = false;
                    vm.controlador.ultimaEntidade = true;
                    vm.controlador.processaEntidade = false;
                }, 250);

                if (angular.isDefined(vm.ultima)) {
                    vm.ultima();
                }
            }

            function listarTodasEntidades() {
                if (!vm.controlador.listarTodasEntidades) {
                    vm.controleForm.pesquisarDatatable = true;
                    vm.controlador.listarTodasEntidades = true;
                    vm.controleForm.listarTodasEntidades = true;
                    vm.textoExibido = vm.controleTextoAExibir.listarTodasEntidades;
                    vm.buttonSelecionado = "listarTodos";

                    if (!$rootScope.tamanhoTelaDesktop) {
                        $mdSidenav('sidenav').close();
                    }
                } else {
                    vm.controleForm.pesquisarDatatable = false;
                    vm.controleForm.listarTodasEntidades = false;
                    vm.controlador.listarTodasEntidades = false;
                    vm.buttonSelecionado = null;
                    vm.textoExibido = vm.controleTextoAExibir.pesquisando;

                    if (!$rootScope.tamanhoTelaDesktop) {
                        $mdSidenav('sidenav').close();
                    }
                }
            }

            function abrirSidenav() {
                $mdSidenav('sidenav').toggle();
            }
            /////////////////////////////////////

            // Métodos com Interação com o Controller exterior
            function metodoToolbarPesquisar(entidadeDePesquisa, event) {
                vm.controleForm.entidadesPesquisadas = entidadeDePesquisa;
                metodosInternosToolbar.chamarPesquisa(event, function (success) {
                    if (!success.data.length) {
                        vm.entidades = [success.data];
                        vm.entidade = success.data;
                    } else {
                        vm.entidades = success.data;
                        vm.entidade = vm.entidades[0];
                    }
                    if (angular.isDefined(vm.toolbarPesquisar)) {
                        vm.toolbarPesquisar();
                    }
                    vm.toolbar.pesquisar();
                });
            }

            function metodoToolbarAtualizar(event) {
                if (!vm.controleForm.desabilitarMetodoToolbarAtualizar) {
                    metodosInternosToolbar.chamarPesquisa(event, function (success) {
                        if (angular.isDefined(vm.toolbarAtualizar)) {
                            vm.toolbarAtualizar();
                        }
                        vm.entidades = success.data;
                        vm.entidade = success.data[vm.indice];
                        vm.indice < vm.entidades.length - 1 ? vm.controlador.ultimaEntidade = false : vm.controlador.ultimaEntidade = true;
                    });
                } else {
                    vm.atualizarEntidadeNoController();
                }
            }

            function metodoToolbarSalvar(event) {
                if (vm.controlador.novaEntidade) {
                    promessa = vm.salvar();
                    if (promessa) {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                        promessa.then(
                            function (success) {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                MdToastService.toastPadrao("Registro cadastrado com sucesso.");
                                console.log(success.data);

                                vm.entidades.push(success.data);
                                vm.entidade = success.data;
                                vm.indice = vm.entidades.length - 1;

                                vm.toolbar.reverter(true);
                            },
                            function (error) {
                                if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                    if (error.data.indexOf("\n") != -1)
                                        MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                    else
                                        MdDialogService.alertPadrao(error.data, event);
                                }
                                else {
                                    MdDialogService.alertPadrao(error.data, event);
                                }
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();

                            });
                    }
                }
                else {
                    promessa = vm.editar();
                    if (promessa) {
                        metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                        promessa.then(
                            function (success) {
                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                console.log(success.data);

                                vm.entidades[vm.indice] = success.data;
                                MdToastService.toastPadrao("Registro alterado com sucesso.");
                                entidadeTemporaria = success.data;
                                vm.toolbar.reverter();
                            },
                            function (error) {
                                if (error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                                    if (error.data.indexOf("\n") != -1)
                                        MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                    else
                                        MdDialogService.alertPadrao(error.data, event);
                                }
                                else {
                                    MdDialogService.alertPadrao(error.data, event);
                                }

                                metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                            });
                    }
                }
            }

            function metodoToolbarExcluir(entidade, event) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event,
                    function () {
                        promessa = vm.excluir();
                        if (promessa) {
                            metodosInternosToolbar.preLoaderToolbar.inicioProgresso();
                            promessa.then(
                                function (success) {
                                    metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                    MdToastService.toastPadrao(success.data);
                                    vm.entidades.splice(vm.entidades.indexOf(entidade), 1);
                                    vm.indice = vm.entidades.length - 1;
                                    entidadeTemporaria = vm.entidades[vm.indice];
                                    vm.toolbar.reverter();
                                },
                                function (error) {
                                    if (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined") {
                                        if (error.data.indexOf("\n") != -1)
                                            MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                                        else
                                            MdDialogService.alertPadrao(error.data, event);
                                    }
                                    else {
                                        MdDialogService.alertPadrao(error.data, event);
                                    }

                                    metodosInternosToolbar.preLoaderToolbar.fimProgresso();
                                });
                        }
                    });
            }
            //////////////////////////////////////////////////////////////////

            /* 
              Vericações realizadas quando a diretiva é inicializada    
            */

            if (angular.isUndefined(vm.ngUtilizaNavegacao)) {
                vm.ngUtilizaNavegacao = true;
            }

            if (angular.isUndefined(vm.entidades) || !vm.entidades) {
                vm.entidades = [];
            }

            if (angular.isUndefined(vm.entidade) || !vm.entidade) {
                vm.entidade = {};
            } else {
                vm.controleForm.entidadesPesquisadas = vm.entidade
            }

            vm.tipolayout = vm.ngUtilizaNavegacao ? "space-between center" : "";

            /*
              Condição que verifica se a entidade da diretiva já está preenchida no controller
              caso a condição, já realiza a consulta com base na entidade preenchida do controller
            */
            if (vm.iniciarChamandoPesquisa) {


                /**
                 * Se o parâmetro "habilitarPesquisar" que foi preenchido no controller que está utilizando o toolbar
                 * estiver preenchido será habilitado o estado de pesquisar da toolbar
                 */
                if (vm.entidade.habilitarPesquisar) {
                    vm.toolbar.pesquisar();
                }

                /**
                 * Se o parâmetro "chamarPesquisa" que foi preenchido no controller que está utilizando o toolbar
                 * estiver preenchido será feito uma chamada para api buscando as entidades no banco de dados
                 */

                if (vm.entidade.chamarPesquisa) {
                    vm.metodosToolbar.pesquisar(vm.entidade);
                }


                /**
                 * Se a entidade "chamarInsercao" estiver preenchida será colocado a toolbar em modo de inserção
                 */
                if (vm.entidade.chamarInsercao) {
                    vm.toolbar.inserir()
                }

                /**
                 * Se a entidade "listandoTodasEntidades" estiver preenchida será colocado a toolbar em modo exibição em Tabela
                 */
                if (vm.entidade.listandoTodasEntidades) {
                    vm.toolbar.listarTodasEntidades()
                }
            }
        } // onNit

    } // Controller

    function toolbarDesktopMobileDirective($rootScope) {
        return {
            templateUrl: $rootScope.tamanhoTelaDesktop ? 'app/compartilhado/diretivas/toolbar-mobile-desktop/desktop/toolbar-desktop.html' : 'app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/toolbar-mobile.html',
            scope: {},
            controller: 'ToolbarDesktopMobileController as vm',
            restrict: "AE",
            require: '^form',
            bindToController: {
                iniciarChamandoPesquisa: '=?',
                ngDisabled: '=?',
                ngDisabledBotaoNovaPesquisa: '=?',
                ngDisabledBotaoPesquisar: '=?',
                ngDisabledBotaoSalvar: '=?',
                ngDisabledBotaoReverter: '=?',
                ngDisabledBotaoExcluir: '=?',
                ngDisabledBotaoEditar: '=?',
                ngDisabledBotaoInserir: '=?',
                ngDisabledBotaoAtualizar: '=?',
                ngDisabledBotaoPrimeira: '=?',
                ngDisabledBotaoAnterior: '=?',
                ngDisabledBotaoProxima: '=?',
                ngDisabledBotaoUltima: '=?',
                ngDisabledBotaoListarTodasEntidades: '=?',
                ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela: '=?',
                ngUtilizaNavegacao: '=?',
                ngOcultaBotaoNovaPesquisa: '=?',
                ngOcultaBotaoPesquisar: '=?',
                ngOcultaBotaoSalvar: '=?',
                ngOcultaBotaoReverter: '=?',
                ngOcultaBotaoExcluir: '=?',
                ngOcultaBotaoEditar: '=?',
                ngOcultaBotaoInserir: '=?',
                ngOcultaBotaoAtualizar: '=?',
                toolbarNovaPesquisa: '&?',
                toolbarPesquisar: '&?',
                toolbarAtualizar: '&?',
                toolbarReverter: '&?',
                toolbarEditar: '&?',
                toolbarInserir: '&?',
                metodosExternos: '=?',
                entidades: '=?',
                entidade: '=?',
                controleForm: '=?',
                pesquisar: '&?',
                salvar: "&?",
                editar: "&?",
                excluir: "&?",
                atualizarEntidadeNoController: "&?",
                primeira: "&?",
                proxima: "&?",
                anterior: "&?",
                ultima: "&?",
                desabilitarMensagemAoPesquisar: "=?"
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('validacaoAno', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    ctrl.$validators.ano_invalido = function (modelValue, viewValue) {
                        if (viewValue != '' && (viewValue > 1900))
                            return true;
                        return false;
                    };
                }
            };
        });
}());
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('teste', testeDirective);

    function testeDirective() {
        return {
            restrict: 'A',            
            require: '^ngModel',            
            link: function (scope, element, attrs, ngModelCtrl) {                
                ngModelCtrl.$validators.testando = function (modelValue, viewValue) {
                    console.log(viewValue)
                    return false;
                }
            }
        }
    };

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('selectSimples', selectSimples);

    function selectSimples() {
        return {
            restrict: 'E',
            templateUrl: 'app/compartilhado/diretivas/select-simples/select-simples.html',
            scope: {
                titulo: '@',
                nomeControle: '@',
                lista: '=',
                chave: '@',
                valor: '@',
                utilizaPesquisa: '=?',
                utilizaOrdenacao: '=?',
                disabled: '=?ngDisabled',
                required: '=?ngRequired',
                modelo: '=ngModel'
            },
            link: function (scope, element, attrs) {
                scope.campoPesquisa = '';
                scope.valorAntesDaAbertura = null;

                scope.aoAbrir = function () {
                    scope.valorAntesDaAbertura = scope.modelo;
                };

                scope.aoFechar = function () {
                    if (scope.valorAntesDaAbertura !== null &&
                        scope.valorAntesDaAbertura !== undefined &&
                        scope.valorAntesDaAbertura === scope.modelo &&
                        scope.modelo !== null) {
                        scope.modelo = undefined;
                    }
                    scope.valorAntesDaAbertura = null;
                    scope.campoPesquisa = '';
                };

                scope.obterListaFiltrada = function () {
                    if (!scope.lista) return [];

                    var listaFiltrada = scope.lista;

                    if (scope.utilizaPesquisa && scope.campoPesquisa) {
                        var termoPesquisa = scope.campoPesquisa.toLowerCase();
                        listaFiltrada = scope.lista.filter(function (item) {
                            var valorItem = item[scope.valor] || '';
                            return valorItem.toString().toLowerCase().indexOf(termoPesquisa) !== -1;
                        });
                    }

                    if (scope.utilizaOrdenacao) {
                        listaFiltrada = listaFiltrada.slice().sort(function (a, b) {
                            var campoOrdenacao = scope.utilizaOrdenacao ? scope.valor : scope.chave;
                            var valorA = a[campoOrdenacao] || '';
                            var valorB = b[campoOrdenacao] || '';
                            return valorA.toString().localeCompare(valorB.toString());
                        });
                    } else {
                        listaFiltrada = listaFiltrada.slice().sort(function (a, b) {
                            var valorA = a[scope.chave] || '';
                            var valorB = b[scope.chave] || '';
                            if (typeof valorA === 'number' && typeof valorB === 'number') {
                                return valorA - valorB;
                            }
                            return valorA.toString().localeCompare(valorB.toString());
                        });
                    }

                    return listaFiltrada;
                };

                scope.estaSelecionado = function (item) {
                    if (!item) return false;
                    return scope.modelo === item[scope.chave];
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('scrollClass', function ($rootScope) {
            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    /*
                        O atributo scrollContainerTag deve ser a div/tag que está com o scroll
                        para identificar quando a pagina está ou não sendo "scrollada"
                    */
                    var scrollContainer = $(attr.scrollContainerTag);
                    var isScrolling = false;

                    if ($rootScope.utilizaBotaoScroll) {
                        updateState();

                        scrollContainer.on('scroll', updateState);

                        element.click(function () {
                            scrollContainer.animate({
                                scrollTop: 0
                            }, "slow")
                        });
                    }

                    function updateState() {
                        var newState = scrollContainer.scrollTop() !== 0;

                        if (newState !== isScrolling) {
                            element.toggleClass(attr.scrollClass, newState);
                        }

                        isScrolling = newState;
                    }
                }
            };
        });
}());
/**
 * Created by nova on 29/09/2016.
 */
(function (){
  'use strict';

  angular
    .module('app.diretivas')
    .controller('ProximoCodigoController', ProximoCodigoController)
    .directive('proximoCodigo', proximoCodigoDirective);

  function ProximoCodigoController(ProximoCodigoService, MdDialogService, $log) {
    var vm = this;


    if(angular.isDefined(vm.rota)) {
      vm.gerarProximoCodigo = function (event) {
        if(angular.isDefined(vm.preLoaderToolbar)) {
          vm.preLoaderToolbar.inicioProgresso();
        }
        if(angular.isDefined(vm.ativaPreLoader)){
          vm.ativaPreLoader = true;
        }
        var promessa = ProximoCodigoService.proximoCodigo(vm.rota);
        promessa.then(
          function(success){
            vm.entidadeCodigo = success.data;
            if(angular.isDefined(vm.preLoaderToolbar)) {
              vm.preLoaderToolbar.fimProgresso();
            }
            if(angular.isDefined(vm.ativaPreLoader)){
              vm.ativaPreLoader = false;
            }
          },
          function(error){
            MdDialogService.alertPadrao(error.data, event);
            if(angular.isDefined(vm.preLoaderToolbar)) {
              vm.preLoaderToolbar.fimProgresso();
            }
            if(angular.isDefined(vm.ativaPreLoader)){
              vm.ativaPreLoader = false;
            }
          });
      };
    }
    else{
      $log.error("Para o funcionamento desta diretiva é necessário passar a rota do proximo código");
    }

  }

  function proximoCodigoDirective(){
    return{
      templateUrl: 'app/compartilhado/diretivas/proximo-codigo/proximo-codigo.html',
      controller: 'ProximoCodigoController as vm',
      restrict: 'E',
      scope: {},
      bindToController:{
        rota: '=?',
        entidadeCodigo: '=?',
        preLoaderToolbar: '=?',
        ativaPreLoader: '=?'
      }
    };
  }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO       
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/proximo-codigo');
        // endregion
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('ProgressLinearController', ProgressLinearController)
        .directive('progressLinear', progressLinearDirective);

    function ProgressLinearController($scope, $interval) {
        var vm = this;
        var processando;

        vm.metodosInternos = {
            iniciarProgresso: _iniciarProgresso,
            _fimProgresso: _fimProgresso
        }

        if (!vm.mode)
            vm.mdMode = "buffer"
        else
            vm.mdMode = vm.mode;

        $scope.$watch('vm.ngDisabled', function (newValue, oldValue) {
            if (vm.ngDisabled) {
                _iniciarProgresso();
            }
            else {
                _fimProgresso();
            }
        });

        function _iniciarProgresso() {
            processando = $interval(function () {
                vm.progresso += 3;
                if (vm.progresso > 100)
                    vm.progresso = 0;
            }, 100);
        }

        function _fimProgresso() {
            vm.progresso = 0;
            $interval.cancel(processando);
        }
    }

    function progressLinearDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/progress-linear/progress-linear.html',
            controller: 'ProgressLinearController as vm',
            restrict: 'E',
            scope: {},
            bindToController: {
                ngDisabled: '=?',
                mode: '@?',
            }
        }
    };

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .service('PgToolbarService', PgToolbarService)

    function PgToolbarService($interval, MdDialogService, DataTableConfigPadrao) {

        //////////////////////////// Definição dos Métodos //////////////////////////////////////////
        this.iniciarPreLoaderToolbar = iniciarPreLoaderToolbar;
        this.finalizarPreLoaderToolbar = finalizarPreLoaderToolbar;
        this.atualizarEntidadeDeEnvio = atualizarEntidadeDeEnvio;
        this.atualizarEntidadeDeEnvioQuandoRegistroForExcluido = atualizarEntidadeDeEnvioQuandoRegistroForExcluido;
        this.atualizarBotoesDeNavegacao = atualizarBotoesDeNavegacao;
        this.definirPosicaoEntidadeDeEnvio = definirPosicaoEntidadeDeEnvio;
        this.exibirAlertaDeErro = exibirAlertaDeErro;
        this.armazenarEntidadeDeEnvio = armazenarEntidadeDeEnvio;
        //////////////////////////// FIM Definição dos Métodos //////////////////////////////////////////        

        //////////////////////////// Implementação dos Métodos ////////////////////////////////////////////        

        /**
         * Método para iniciar o pré-loader da toolbar
         * @param {object} controladorToolbar controladorToolbar
         * @param {object} controladorPreloader controladroPrealoder
         */
        function iniciarPreLoaderToolbar(controladorToolbar, controladorPreloader) {
            if (controladorToolbar && controladorPreloader) {
                controladorPreloader.progresso = 0;
                controladorToolbar.emProgresso = true;
                $interval(function () {
                    controladorPreloader.progresso += 3;
                    if (controladorPreloader.progresso > 100)
                        controladorPreloader.progresso = 0;

                }, 100);
            }
        }

        /**
         * Método para finalizar o pré-loader da toolbar
         * @param {object} controladorToolbar controladorToolbar
         * @param {object} controladorPreloader controladroPrealoder
         */
        function finalizarPreLoaderToolbar(controladorToolbar, controladorPreloader) {
            if (controladorToolbar && controladorPreloader) {
                controladorPreloader.progresso = 0;
                controladorToolbar.emProgresso = false;
            }
        }


        /**
         * Método para atualizar os campos da entidade de envio
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {object} novaEntidadeDeEnvio succes.data
         */
        function atualizarEntidadeDeEnvio(entidadeDeEnvio, novaEntidadeDeEnvio) {
            if (entidadeDeEnvio && novaEntidadeDeEnvio) {
                entidadeDeEnvio.intPosicao = novaEntidadeDeEnvio.intPosicao;
                entidadeDeEnvio.intTamanhoPagina = novaEntidadeDeEnvio.intTamanhoPagina;
                entidadeDeEnvio.intTotalResultado = novaEntidadeDeEnvio.intTotalResultado;
            }
        }

        /**
         * Método para atualizar a entidade de envio quando é excluído um registro         
         * @param {object} entidadeDeEnvio
         * Retorno boolean: 'true' se entidadeDeEnvio.intTotalResultado >= 1
         *                  'false' se entidadeDeEnvio.intTotalResultado < 1
         */
        function atualizarEntidadeDeEnvioQuandoRegistroForExcluido(entidadeDeEnvio) {
            entidadeDeEnvio.intTotalResultado--;
            if (entidadeDeEnvio.intTotalResultado >= 1) {
                if (entidadeDeEnvio.intPosicao > 1)
                    entidadeDeEnvio.intPosicao--;

                return true;
            }
            else
                return false;
        }

        /**
         * Método para autlizar o campo clsEntidade com uma nova entidade de pesquisa
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {object} novaEntidadeDePesquisa vm.entidade entidade do controller
         */
        function atualizarEntidadeDeEnvioComNovaEntidadeParaPesquisa(entidadeDeEnvio, novaEntidadeDePesquisa) {
            if (entidadeDeEnvio && novaEntidadeDePesquisa)
                entidadeDeEnvio.clsEntidade = novaEntidadeDePesquisa;
        }

        /**
         * Método para atualizar os botões de navegações verificando qual é a posição para habiltiar ou desabilitar os botões:
         * primeira anterior proxima e ultima
         * @param {object} entidadeDeEnvio 
         * @param {object} controladorToolbar 
         */
        function atualizarBotoesDeNavegacao(entidadeDeEnvio, controladorToolbar) {
            if (entidadeDeEnvio && controladorToolbar) {
                if (entidadeDeEnvio.intPosicao > 1)
                    controladorToolbar.primeiraEntidade = false;
                else if (entidadeDeEnvio.intPosicao <= 1)
                    controladorToolbar.primeiraEntidade = true;

                if (entidadeDeEnvio.intPosicao >= entidadeDeEnvio.intTotalResultado)
                    controladorToolbar.ultimaEntidade = true;
                else if (entidadeDeEnvio.intPosicao < entidadeDeEnvio.intTotalResultado)
                    controladorToolbar.ultimaEntidade = false;
            }
        }


        /**
         * Defini qual será o valor da posição da entidade de envio, 
         * com base na no botão de navegação pressionado
         * @param {object} entidadeDeEnvio Entidade de Envio
         * @param {string} direcao botão pressionado pelo usuário
         */
        function definirPosicaoEntidadeDeEnvio(entidadeDeEnvio, direcao) {
            if (entidadeDeEnvio && direcao) {
                if (direcao == "primeira")
                    entidadeDeEnvio.intPosicao = 1;
                else if (direcao == 'anterior')
                    entidadeDeEnvio.intPosicao--;
                else if (direcao == "proxima")
                    entidadeDeEnvio.intPosicao++;
                else if (direcao == "ultima")
                    entidadeDeEnvio.intPosicao = entidadeDeEnvio.intTotalResultado;
                else
                    alert("direção passada como parâmetro na navegação não existe");
            }
        }

        /**
         * Método que exibi o alerta de erro padrão verificando se existe quebra de linha no texto assim exibindo as linhas quebradas 
         * caso exista ou em forma de titulo caso não exista
         * @param {object} error error
         * @param {event} event event do botão
         */
        function exibirAlertaDeErro(error, event) {
            if (error && error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                if (error.data.indexOf("\n") != -1)
                    MdDialogService.alertPadrao("", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                else if (error.data.indexOf("<br>") != -1)
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                else
                    MdDialogService.alertPadrao("Atenção!", null, error.data, event);
            }
            else {
                MdDialogService.alertPadrao("Atenção!", null, error.data, event);
            }
        }

        /**
         * Método para armazenar em vm.entidadeDeEnvio.clsEntidade a "entidadeDePesquisa" ou não
         * verificando a condição do verificaodr "verificacaoNaoArmazenarEntidadeDePesquisa" :
         *  false = vm.entidadeDeEnvio.clsEntidade = entidadeDePesquisa
         *  true = entidadde de pesquisa não recebe nenhum valor
         * @param {object} entidadeDeEnvio vm.entidadeDeEnvio
         * @param {bool} verificador 
         */
        function armazenarEntidadeDeEnvio(entidadeDeEnvio, verificacaoNaoArmazenarEntidadeDePesquisa, entidadeDePesquisa) {
            if (!verificacaoNaoArmazenarEntidadeDePesquisa) {
                entidadeDeEnvio.clsEntidade = entidadeDePesquisa;
            }
        }
        //////////////////////////// Fim Implementação dos Métodos ////////////////////////////////////////////
    }


})();

(function () {
    'use strict'

    angular.module('app.factory', []);

})();

(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('PgToolbarFactory', PgToolbarFactory);

    function PgToolbarFactory(DataTableConfigPadrao, $rootScope, urlApi) {

        //////////////////////////// Definição dos Métodos //////////////////////////////////////////
        return {
            construirEntidadeDeEnvioPadrao: construirEntidadeDeEnvioPadrao,
            verificarUtilizacaoNavegacao: verificarUtilizacaoNavegacao,
            definirTipoLayout: definirTipoLayout,
            construirPathHtmlComponentes: construirPathHtmlComponentes,
            construirTextosAExibir: construirTextosAExibir,
            preDefinirControladoresDaToolbar: preDefinirControladoresDaToolbar,
            predefinirControladorPreLoader: predefinirControladorPreLoader
        }
        //////////////////////////// FIM Definição dos Métodos //////////////////////////////////////////        

        //////////////////////////// Implementação dos Métodos ////////////////////////////////////////////        

        /**
         * Método que constroí a entidade genérica padrão para se trabalhar com a toolbar de paginação
         */
        function construirEntidadeDeEnvioPadrao(entidadeDeEnvio) {
            return {
                intPosicao: 1,
                intTamanhoPagina: 1,
                intTotalResultado: 0,
                clsEntidade: entidadeDeEnvio ? entidadeDeEnvio : {}
            }
        }


        /**
         * Verifica se a toolbar irá utilizar navegação
         * Por default utilizaNavegacao será false assim retornará true
         * @param {bool} utilizaNavegacao 
         */
        function verificarUtilizacaoNavegacao(utilizaNavegacao) {
            if (!utilizaNavegacao)
                return true;
            else
                return false;
        }

        /**
         * Defini o tipo de layout que a toolbar irá ter
         * pode default seu layout será "space-between center"
         * @param {string} tipoLayout 
         */
        function definirTipoLayout(tipoLayout) {
            if (tipoLayout)
                return tipoLayout;
            else
                return "space-between center";
        }

        /**
         * Defini todos os paths dos componenetes
         */
        function construirPathHtmlComponentes() {
            return {
                botaoNovaPesquisa: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-nova-pesquisa.html',
                botaoPesquisar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-pesquisar.html',
                botaoSalvar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-salvar.html',
                botaoReverter: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-reverter.html',
                botaoExcluir: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-excluir.html',
                botaoEditar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-editar.html',
                botaoInserir: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-inserir.html',
                botaoAtualizar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-atualizar.html',
                botaoGenerico: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-generico.html',
                botaoClonar: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-clonar.html',
                listarTodasEntidades: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-listar-todas-entidades.html',
                navegacao: {
                    botaoPrimeira: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-primeira.html',
                    botaoAnterior: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-anterior.html',
                    botaoProxima: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-proxima.html',
                    botaoUltima: 'app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-ultima.html'
                },
                sidenav: {
                    botaoSidenav: 'app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-botao-sidenav.html',
                    sidenav: 'app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-mobile-sidenav.html',
                }
            }
        }

        /**
         * Defini todos os textos que serão exibidos
         */
        function construirTextosAExibir() {
            return {
                aguardando: "Aguardando",
                novaPesquisa: "Nova Pesquisa",
                pesquisando: "Exibindo",
                editando: "Editando",
                inserindo: "Inserindo",
                excluindo: "Excluindo",
                listarTodasEntidades: "Exibindo em modo Tabela"
            }
        }

        /**
         * Pré-defini os controladores padrão da toolbar
         */
        function preDefinirControladoresDaToolbar() {
            return {
                pesquisaAtiva: false,
                primeiraEntidade: false,
                ultimaEntidade: false,
                editarAtivo: false,
                inserirAtivo: false,
                listarTodasEntidades: false,
                emProgresso: false,
                entidadeTemporaria: {}
            }
        }

        /**
         * Pre-defini controladores padrão pre-loader
         */
        function predefinirControladorPreLoader() {
            return {
                progresso: 0
            }
        }
        //////////////////////////// Fim Implementação dos Métodos ////////////////////////////////////////////
    }

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('PgToolbarController', PgToolbarController)
        .directive('pgToolbar', pgToolbarDirective);

    function PgToolbarController($log, $scope, $rootScope, $mdSidenav, $window, PgToolbarService, PgToolbarFactory, MdDialogService, MdToastService) {
        var vm = this;

        $scope.obterControleFormulario = function (formCtrl) {
            vm.form = formCtrl;
        };


        /////////////////////////////////////////////////// DATA ///////////////////////////////////////////////////////
        vm.tela = $window;
        vm.larguraPadraoMobileTela = 600;

        // verifica se a entidade foi declarada no controller externo, caso não seja elas são definidas
        if (!vm.entidade)
            vm.entidade = {}
        if (!vm.entidades)
            vm.entidades = [];

        vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();

        vm.tempoDelay = 350;
        var primeiraConsulta = false;

        vm.tipolayout = PgToolbarFactory.definirTipoLayout(vm.ngTipoLayout);
        vm.htmlComponente = PgToolbarFactory.construirPathHtmlComponentes();
        vm.textoExibido = PgToolbarFactory.construirTextosAExibir().aguardando;
        vm.controladorToolbar = PgToolbarFactory.preDefinirControladoresDaToolbar();
        vm.controladorPreLoader = PgToolbarFactory.predefinirControladorPreLoader();

        $rootScope.$on('dispararAcaoPesquisar', function () {
            metodoAcaoPesquisar();
        });

        init();
        /////////////////////////////////////////////////// FIM DATA ///////////////////////////////////////////////////////

        /////////////////////////////////////////////////// DEFINIÇÃO MÉTODOS ///////////////////////////////////////////////////////
        vm.metodosExternos = {
            metodoControladorExternoListarTodasEntidades: metodoControladorListarTodasEntidades,
            metodoControladorExternoPesquisar: metodoAcaoPesquisar,
            metodoAcaoExternaEditarEntidade: metodosAcaoAEditar,
            metodosAcaoAtualizar: metodosAcaoAtualizar
        }
        vm.metodosControladores = {
            metodoControladorAtualizarFormulario: metodoControladorAtualizarFormulario,
            metodoControladorNovaPesquisa: metodoControladorNovaPesquisa,
            metodoControladorPesquisar: metodoControladorPesquisar,
            metodoControladorSalvar: metodoControladorSalvar,
            metodoControladorInserir: metodoControladorInserir,
            metodoControladorEditar: metodoControladorEditar,
            metodoControladorReverter: metodoControladorReverter,
            metodoControladorListarTodasEntidades: metodoControladorListarTodasEntidades,
            metodoControladorAbrirSidenav: metodoControladorAbrirSidenav,
            metodoControladorFecharSidenav: metodoControladorFecharSidenav,
            metodoControladorClonar: metodoControladorClonar
        };
        vm.metodosAcao = {
            metodoAcaoNavegacao: metodoAcaoNavegacao,
            metodoAcaoPesquisar: metodoAcaoPesquisar,
            metodosAcaoAtualizar: metodosAcaoAtualizar,
            metodosAcaoCriar: metodosAcaoCriar,
            metodosAcaoAEditar: metodosAcaoAEditar,
            metodosAcaoExcluir: metodosAcaoExcluir,
            metodosAcaoBotaoGenerico: metodosAcaoBotaoGenerico
        }
        /////////////////////////////////////////////////// FIM DEFINIÇÃO MÉTODOS ///////////////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO MÉTODOS INIT E WATCHS /////////////////////////////////////////////////

        /**
         * Método inciializador
         */
        function init() {
            if (vm.iniciarChamandoPesquisa) {
                metodoAcaoPesquisar(vm.entidade, null, false);
            }
            if (vm.iniciarHabilitandoModoPesquisa) {
                metodoControladorPesquisar();
            }
            if (vm.iniciarHabilitandoEdicao) {
                metodoControladorEditar(null);
            }

            vm.esconderBotaoGenerico = angular.isDefined(vm.esconderBotaoGenerico) ? vm.esconderBotaoGenerico : true;
        }

        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO MÉTODOS INIT E WATCHS /////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO  MÉTODOS CONTROLADORES /////////////////////////////////////////////////

        /**
         * Método para reconfigurar as definições do formulário
         */
        function metodoControladorAtualizarFormulario() {
            if (vm.form) {
                vm.form.$setUntouched();
                vm.form.$setPristine();
            }
        }

        /**
         * Método controlador chamado quando é pressionado o botão de Nova Pesquisa setando os valores inicias novamente
         */
        function metodoControladorNovaPesquisa() {
            vm.entidade = {};
            vm.entidades = [];
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

            vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();

            vm.controladorToolbar = PgToolbarFactory.preDefinirControladoresDaToolbar();
            vm.controladorPreLoader = PgToolbarFactory.predefinirControladorPreLoader()
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().novaPesquisa;

            metodoControladorAtualizarFormulario();

            metodoControladorFecharSidenav();

            if (vm.metodoExternoAcaoNovaPesquisa)
                vm.metodoExternoAcaoNovaPesquisa();
        }

        /**
         * Método controlador chamado quando é pressioando o botão de Pesquisar
         */
        function metodoControladorPesquisar() {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

            vm.controladorToolbar.pesquisaAtiva = true;

            if (vm.iniciarHabilitandoEdicao && vm.iniciarChamandoPesquisa)
                return;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
        }

        /**
         * Método controlador chamando quando é pressioando o botão salvar da toolbar
         * Verificando se é um inserção ou edição assim chamando a ação correta para inserir ou editar
         * o registro na API
         * @param {object} entidade entidade do controller
         */
        function metodoControladorSalvar(entidade) {
            if (vm.controladorToolbar.inserirAtivo)
                metodosAcaoCriar(entidade)
            else if (vm.controladorToolbar.editarAtivo)
                metodosAcaoAEditar(entidade)
        }

        /**
         * Método controlado chamado quando o botão Inserir é pressionado alterando a toolbar para o estado de Inserção
         * @param {object} entidade entidade do controller
         * @param {event} event event do botão
         */
        function metodoControladorInserir(entidade, event) {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeTemporaria = angular.copy(entidade);
            vm.entidade = {};
            vm.controladorToolbar.inserirAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().inserindo;

            if (vm.preDefinirCamposParaInsercao)
                vm.preDefinirCamposParaInsercao();
        }

        /**
         * Método controlador que chamado quando o botão editar é pressioando alterando 
         * o estado da toolbar para Editando
         * @param {object} entidade  entidade do controller
         */
        function metodoControladorEditar(entidade) {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeTemporaria = angular.copy(entidade);
            vm.controladorToolbar.editarAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().editando;

            if (vm.preDefinirCamposParaEdicao)
                vm.preDefinirCamposParaEdicao();
        }

        /**
         * Método controlado chamado quando o botão Reverter da toolbar é pressioando, 
         * assim retornando a toolbar para seu estado anterior
         */
        function metodoControladorReverter() {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
            metodoControladorAtualizarFormulario();

            if (!vm.controladorToolbar.pesquisaAtiva) {
                if (!primeiraConsulta)
                    vm.textoExibido = PgToolbarFactory.construirTextosAExibir().aguardando;
                else
                    vm.textoExibido = PgToolbarFactory.construirTextosAExibir().novaPesquisa;


                vm.entidade = angular.copy(vm.controladorToolbar.entidadeTemporaria);
            }
            else if (vm.controladorToolbar.pesquisaAtiva) {
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
                vm.entidade = angular.copy(vm.controladorToolbar.entidadeTemporaria);
            }

            vm.controladorToolbar.inserirAtivo = false;
            vm.controladorToolbar.editarAtivo = false;
            vm.controladorToolbar.entidadeTemporaria = {};

            if (vm.metodoExternoAcaoReverter)
                vm.metodoExternoAcaoReverter();
        }

        /**
         * Método controlado chamado quando o botão listar todas entidades é pressioando
         * alterando a forma de exibição da tabela para modo tabela ou alterando novamente para o modo 
         * de exibição tradional         
         * @param {event} event
         */
        function metodoControladorListarTodasEntidades(event, posicaoEntidadeSelecionada) {
            metodoControladorFecharSidenav();

            if (!vm.controladorToolbar.listarTodasEntidades) {
                vm.controladorToolbar.listarTodasEntidades = true;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().listarTodasEntidades;

                if (vm.construirDtOptions)
                    vm.construirDtOptions();
            }
            else {
                vm.controladorToolbar.listarTodasEntidades = false;
                vm.textoExibido = PgToolbarFactory.construirTextosAExibir().pesquisando;
                vm.campoPesquisar = "";

                if (posicaoEntidadeSelecionada) {
                    vm.entidadeDeEnvio.intPosicao = posicaoEntidadeSelecionada;
                    metodoAcaoPesquisar(null, null, true)
                }
            }
        }

        /**
         * Método para abrir o sidenav quando estiver em mobile
         */
        function metodoControladorAbrirSidenav() {
            if (vm.tela.screen.width < vm.larguraPadraoMobileTela)
                $mdSidenav('pg-toolbar-sidenav').toggle();
        }

        /**
         * Método que fecha o sidenav quando é chamado
         */
        function metodoControladorFecharSidenav() {
            if (vm.tela.screen.width < vm.larguraPadraoMobileTela)
                $mdSidenav('pg-toolbar-sidenav').close();
        }

        function metodoControladorClonar(entidade, event) {
            $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;
            metodoControladorAtualizarFormulario();
            metodoControladorFecharSidenav();

            vm.controladorToolbar.entidadeClonada = angular.copy(entidade);
            vm.entidade = {};
            vm.controladorToolbar.inserirAtivo = true;
            vm.textoExibido = PgToolbarFactory.construirTextosAExibir().inserindo;

            if (vm.definirCamposClonados)
                vm.definirCamposClonados();
        }
        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO  MÉTODOS CONTROLADORES /////////////////////////////////////////////

        /////////////////////////////////////////////////// IMPLEMENTAÇÃO  MÉTODOS AÇÃO /////////////////////////////////////////////////      

        /**
         * Método que navega entre as entidades sempre realizando uma pesquisa para API
         * @param {string} direcao 'primeira', 'anterior', 'proxima', 'ultima'
         */
        function metodoAcaoNavegacao(direcao) {
            if (angular.isDefined(vm.acaoPesquisar)) {
                var posicaoTemporaria = vm.entidadeDeEnvio.intPosicao;

                if (vm.metodoExternoAcaoNavegacao)
                    vm.metodoExternoAcaoNavegacao();

                PgToolbarService.definirPosicaoEntidadeDeEnvio(vm.entidadeDeEnvio, direcao);
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);

                var promessa = vm.acaoPesquisar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            vm.entidade = success.data.lstResultado[0];
                            vm.entidades = success.data.lstResultado;

                            PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                            PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        },
                        function (error) {
                            vm.entidadeDeEnvio.intPosicao = posicaoTemporaria;
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
        }

        /**
         * Método utilizado para realizar a pesquisa com base na entidade de pesquisa
         * @param {object} entidade entidade de pesquisa
         * @param {event} event event do botão
         * @param {boolean} naoArmazenarEntidadeDePesquisa booleano para verificar se é para armazenar o ou não a entidade de pesquisa 
         */
        function metodoAcaoPesquisar(entidade, event, naoArmazenarEntidadeDePesquisa) {
            if (angular.isDefined(vm.acaoPesquisar)) {

                PgToolbarService.armazenarEntidadeDeEnvio(vm.entidadeDeEnvio, naoArmazenarEntidadeDePesquisa, entidade);

                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoPesquisar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            if (success.data && success.data.lstResultado && success.data.lstResultado.length > 0) {
                                primeiraConsulta = true;

                                vm.entidade = success.data.lstResultado[0];
                                vm.entidades = success.data.lstResultado;

                                metodoControladorPesquisar();

                                PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                                PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                            }
                            else {
                                MdDialogService.alertPadrao("Não foi encontrado nenhum registro cadastrado", event);
                                metodoControladorReverter()
                            }
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão pesquisar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-pesquisar'")
            }
        }

        /**
         * Método utilizado para recarregar a consulta realizado na pesquisa 
         */
        function metodosAcaoAtualizar(event) {
            if (vm.controladorAtualizarEntidadeExternamente) {
                if (vm.metodoExternoAtualizarEntidadeExternamente) {
                    vm.metodoExternoAtualizarEntidadeExternamente();
                }
                else {
                    $log.warn("Para o funcionamento correto da atualizar a entidade externamente.\n" +
                        "É necessário definir passar uma função pelo parâmetro 'metodo-externo-atualizar-entidade-externamente'")
                }
            }
            else {
                if (angular.isDefined(vm.acaoPesquisar)) {
                    metodoControladorFecharSidenav();

                    PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                    var promessa = vm.acaoPesquisar();
                    if (promessa) {
                        promessa.then(
                            function (success) {
                                vm.entidade = success.data.lstResultado[0];
                                vm.entidades = success.data.lstResultado;

                                PgToolbarService.atualizarBotoesDeNavegacao(success.data, vm.controladorToolbar);
                                PgToolbarService.atualizarEntidadeDeEnvio(vm.entidadeDeEnvio, success.data);
                                PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                            },
                            function (error) {
                                PgToolbarService.exibirAlertaDeErro(error, event);
                                vm.entidadeDeEnvio = PgToolbarFactory.construirEntidadeDeEnvioPadrao();
                                PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                metodoControladorNovaPesquisa();
                            });
                    }
                    else
                        PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                }
            }
        }

        /**
         * Método utilizado para mandar um requisição para api para Criar um novo registro
         * @param {event} event event do botão
         */
        function metodosAcaoCriar(event) {
            if (angular.isDefined(vm.acaoCriar)) {
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoCriar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            MdToastService.toastPadrao("Registro cadastrado com sucesso.");

                            vm.entidade = success.data;
                            vm.entidadeDeEnvio.intPosicao = 1;
                            vm.entidadeDeEnvio.intTotalResultado = 1;
                            vm.entidadeDeEnvio.clsEntidade = success.data;


                            metodoControladorPesquisar();
                            vm.controladorToolbar.inserirAtivo = false;
                            PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão criar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-criar'")
            }
        }

        /**
         * Método utilizado para mandar um requisição para api para Editar um registro
         * @param {event} event event do botão
         */
        function metodosAcaoAEditar(event) {
            if (vm.acaoEditar) {
                PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                var promessa = vm.acaoEditar();
                if (promessa) {
                    promessa.then(
                        function (success) {
                            MdToastService.toastPadrao("Registro Editado com sucesso.");

                            vm.entidade = success.data;

                            metodoControladorPesquisar();
                            vm.controladorToolbar.editarAtivo = false;
                            PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        },
                        function (error) {
                            PgToolbarService.exibirAlertaDeErro(error, event);
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        });
                }
                else
                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
            }
            else {
                $log.warn("Para o funcionamento da ação do botão editar.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-editar'")
            }
        }

        /**
         * Método utilizado para mandar uma requisição para Api para excluir um registro
         * @param {evemt} event 
         */
        function metodosAcaoExcluir(event) {
            if (angular.isDefined(vm.acaoExcluir)) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event,
                    function () {
                        PgToolbarService.iniciarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                        var promessa = vm.acaoExcluir();
                        if (promessa) {
                            promessa.then(
                                function (success) {
                                    MdToastService.toastPadrao(success.data);

                                    if (PgToolbarService.atualizarEntidadeDeEnvioQuandoRegistroForExcluido(vm.entidadeDeEnvio))
                                        metodoAcaoNavegacao();
                                    else
                                        metodoControladorNovaPesquisa();

                                    vm.controladorToolbar.editarAtivo = false;
                                    PgToolbarService.atualizarBotoesDeNavegacao(vm.entidadeDeEnvio, vm.controladorToolbar);
                                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                },
                                function (error) {
                                    PgToolbarService.exibirAlertaDeErro(error, event);
                                    PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                                });
                        }
                        else
                            PgToolbarService.finalizarPreLoaderToolbar(vm.controladorToolbar, vm.controladorPreLoader);
                    });
            }
            else {
                $log.warn("Para o funcionamento da ação do botão excluir.\n" +
                    "É necessário passar uma função pelo parâmetro 'acao-excluir'")
            }
        }

        function metodosAcaoBotaoGenerico(event) {
            if (angular.isDefined(vm.acaoBotaoGenerico)) {
                vm.acaoBotaoGenerico();
            }
        }
        /////////////////////////////////////////////////// FIM IMPLEMENTAÇÃO  MÉTODOS AÇÃO /////////////////////////////////////////////////        

    } // CONTROLLER

    function pgToolbarDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/pg-toolbar/pg-toolbar.html',
            controller: 'PgToolbarController as vm',
            require: '^form',
            restrict: "AE",
            scope: {},
            bindToController: {
                ngTipoLayout: '@?',
                entidade: '=?',
                entidades: '=?',
                metodosExternos: '=?',
                metodoExternoAcaoNavegacao: '&?',
                metodoExternoAcaoNovaPesquisa: '&?',
                metodoExternoAcaoReverter: '&?',
                metodoExternoAtualizarEntidadeExternamente: '&?',
                metodoExternoControladorPesquisar: '&?',
                controladorAtualizarEntidadeExternamente: '=?',
                entidadeDeEnvio: '=?',
                controladorToolbar: '=?',
                controladorPreLoader: '=?',
                acaoPesquisar: '&?',
                acaoCriar: '&?',
                acaoEditar: '&?',
                acaoExcluir: '&?',
                acaoBotaoGenerico: '&?',
                construirDtOptions: '&?',
                campoPesquisar: '=?',
                iniciarChamandoPesquisa: '=?',
                iniciarHabilitandoModoPesquisa: '=?',
                iniciarHabilitandoEdicao: '=?',
                desabilitarBotaoNovaPesquisa: '=?',
                desabilitarBotaoPesquisar: '=?',
                desabilitarBotaoSalvar: '=?',
                desabilitarBotaoReverter: '=?',
                desabilitarBotaoExcluir: '=?',
                desabilitarBotaoEditar: '=?',
                desabilitarBotaoInserir: '=?',
                desabilitarBotaoAtualizar: '=?',
                desabilitarBotoesNavegacao: '=?',
                desabilitarBotaoPrimeira: '=?',
                desabilitarBotaoAnterior: '=?',
                desabilitarBotaoProxima: '=?',
                desabilitarBotaoUltima: '=?',
                desabilitarBotaoListarTodasEntidades: '=?',
                desabilitarBotaoGenerico: '=?',
                esconderBotaoNovaPesquisa: '=?',
                esconderBotaoPesquisar: '=?',
                esconderBotaoSalvar: '=?',
                esconderBotaoReverter: '=?',
                esconderBotaoExcluir: '=?',
                esconderBotaoEditar: '=?',
                esconderBotaoInserir: '=?',
                esconderBotaoAtualizar: '=?',
                esconderMensagemStatus: '=?',
                esconderBotaoPrimeira: '=?',
                esconderBotaoAnterior: '=?',
                escoderTextoInformativoQuantidade: '=?',
                esconderBotaoProxima: '=?',
                esconderBotaoUltima: '=?',
                esconderBotaoListarTodasEntidades: '=?',
                esconderBotaoModoTabela: '=?',
                esconderBotaoGenerico: '=?',
                preDefinirCamposParaEdicao: '&?',
                preDefinirCamposParaInsercao: '&?',
                tooltipBotaoGenerico: '@?',
                iconeBotaoGenerico: '@?',
                definirCamposClonados: '&?',
                utilizaBotaoClonar: '=?',
                desabilitarBotaoClonar: '=?',
            },
            link: function (scope, element, attr, formCtrl) {
                scope.obterControleFormulario(formCtrl);
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO       
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/pg-toolbar');
        // endregion
    }

})();

/**
 * Created by nova on 30/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.diretivas')
    .controller("PesquisarPorIdentificadorController", PesquisarPorIdentificadorController)
    .directive("pesquisarPorIdentificador", pesquisarPorIdentificadorDirective);

  function PesquisarPorIdentificadorController($linq){
    var vm = this;

    var resultado = {};

    vm.metodoControllerPesquisarPorCodigo = {
      implementarPesquisa : function(implementacao){
        implementacao(vm.codigo);        
      }
    };

    vm.pesquisar = {
      onKeydown: function (event) {
          if (event.key == "Enter") {
            event.target.blur();
          }
      },
      onBlur: function(codigo) {
        console.log(codigo);
        if (angular.isUndefined(vm.implementarNoController)) {
          if(angular.isDefined(vm.listaAPesquisar)) {
            resultado = $linq.Enumerable().From(vm.listaAPesquisar)
              .Where(function (item) {
                return item.identificador == codigo
              }).FirstOrDefault();
            if (resultado != undefined) {
              vm.entidade = resultado.identificador;
              vm.codigo = null;
            }
            else {
              vm.entidade = null;
              vm.codigo = "";
            }
          }
          else{
            console.log("Para realizar a pesquisa pela diretiva é necessário passar a lista à pesquisar e a entidade");
          }

        }
        else{
          vm.implementarNoController();
        }
      }
    };

  }

  function pesquisarPorIdentificadorDirective(){
    return{
      templateUrl: 'app/compartilhado/diretivas/pesquisar-por-identificador/pesquisar-por-identificador.html',
      controller: 'PesquisarPorIdentificadorController as vm',
      restrict: 'E',
      scope:{},
      bindToController: {
        listaAPesquisar: '=?',
        entidade: '=?',
        metodoControllerPesquisarPorCodigo: '=?',
        implementarNoController: '&?',
        ngDisabled: '=?'
      }
    }
  }



})();

/**
 * Created by nova on 30/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.diretivas')
    .directive("pesquisarPorCodigo", pesquisarPorCodigoDirective);

  function pesquisarPorCodigoDirective($linq){
    return{
      restrict: 'A',
      require: '^ngModel',
      scope:{
        listaAPesquisar: '=?',
        entidadePesquisada: '=?'
      },
      link: function (scope, element, attrs, ngModelCtrl) {
        scope.$watch('entidadePesquisada', function(newValue, oldValue){            
          var resultado = $linq.Enumerable().From(scope.listaAPesquisar)
          .Where(function (item) {
            return item.codigo == newValue;
          }).FirstOrDefault();
          if (!resultado && !scope.listaAPesquisar && scope.entidadePesquisada){
              ngModelCtrl.$setViewValue(scope.entidadePesquisada);
              ngModelCtrl.$render();
          }
          else if (resultado){
            ngModelCtrl.$setViewValue(resultado.codigo);
            ngModelCtrl.$render();
          }
          else{
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
          }
        });
        
         element.bind('keydown', function(event){
          if(event.key == 'Enter'){
            event.target.blur();
            event.stopPropagation();
          }
        })

        element.bind('blur', function(){
          var resultado = $linq.Enumerable().From(scope.listaAPesquisar)
          .Where(function (item) {
            return item.codigo == ngModelCtrl.$viewValue;
          }).FirstOrDefault();
          if(resultado){
            scope.entidadePesquisada = resultado.codigo;
          }
          else{
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
            scope.entidadePesquisada = null;
          }
        });

      }
    }
  }



})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('pesquisarCliente', pesquisarClienteDirective);

  function pesquisarClienteDirective($linq) {
    return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
        listaAPesquisar: '=?',
        entidadePesquisada: '=?',
        solucoes: '=?',
        pesquisaSolucaoCodigo: '=?',
        solucaoCodigo: '=?'
      },
      link: function (scope, element, attrs, ngModelCtrl) {
        var lista = scope.listaAPesquisar;
        var solucoesTemporarias = angular.copy(scope.solucoes);

        scope.$watch('entidadePesquisada', function (newValue, oldValue) {
          var resultado = $linq.Enumerable().From(lista)
            .Where(function (item) {
              return item.codigo == newValue;
            }).FirstOrDefault();
          if (resultado) {
            ngModelCtrl.$setViewValue(resultado.codigo);
            ngModelCtrl.$render();
            scope.solucoes = resultado.solucoes;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          } else {
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
            scope.solucoes = solucoesTemporarias;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          }
        });

        element.bind('keydown', function (event) {
          if (event.key == 'Enter') {
            event.target.blur();
            event.stopPropagation();
          }
        })

        element.bind('blur', function () {
          var resultado = $linq.Enumerable().From(lista)
            .Where(function (item) {
              return item.codigo == ngModelCtrl.$viewValue;
            }).FirstOrDefault();
          if (resultado) {
            scope.entidadePesquisada = resultado.codigo;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          } else {
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
            scope.entidadePesquisada = null;
            scope.solucaoCodigo = null;
            scope.pesquisaSolucaoCodigo = null
          }
        });

      }
    }
  }

})();

/**
 * Created by nova on 29/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('MultiSelectController', MultiSelectController)
        .directive('multiSelectDirective', multiSelectDirective);

    function MultiSelectController($scope, $element) {
        var vm = this;
        vm.todos = true;
        vm.metodos = {
            limparSelecao: limparSelecao,
            onChangeItem: onChangeItem
        }

        $scope.searchTerm;
        $scope.clearSearchTerm = function () {
            $scope.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function limparSelecao() {

            if (vm.todos === true) {
                $scope.model = [];
            }
        }

        function onChangeItem() {
            if ($scope.model.length > 0)
                vm.todos = false;

            if (($scope.model.length === $scope.data.length)
                || ($scope.model.length === 0)) {
                vm.todos = true;
                $scope.model = [];
            }
        }

    }

    function multiSelectDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/multi-select/multi-select.html',
            controller: 'MultiSelectController as vm',
            restrict: 'E',
            scope: {
                data: '=',
                model: '= ',
                descricaoExibicao: '@',
                textoPlaceholder: '@',
                flex: '@?',
                formName: '@?',
                obrigatorio: '@?',
                textoPesquisaPlaceholder: '@',
                disabled: '=',
                carregando: '='
            }

        };
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('maxValue', maxValue);

    function maxValue($parse) {
        return {
            restrict: 'EA', //attribute or element,
            require: 'ngModel',
            link: function (scope, e, attrs, ngModel) {
                e.bind('keyup', function (event) {
                    scope.maxValue = $parse(attrs.maxValue)(scope) || 10
                    if (ngModel.$modelValue > scope.maxValue) {
                        event.preventDefault();
                        ngModel.$setViewValue(scope.maxValue);
                        ngModel.$render();
                    }
                });
            },
        };
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('minValue', minValue);

    function minValue($parse) {
        return {
            restrict: 'EA', //attribute or element,
            require: 'ngModel',
            link: function (scope, e, attrs, ngModel) {
                e.bind('keyup', function (event) {
                    scope.minValue = $parse(attrs.minValue)(scope) || 0
                    if (ngModel.$modelValue < scope.minValue) {
                        event.preventDefault();
                        ngModel.$setViewValue(scope.minValue);
                        ngModel.$render();
                    }
                });
            },
        };
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function(){
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTelefone', mascaraTelefoneDirective);

    function mascaraTelefoneDirective() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    else
                        return string + this;
                };

                var lstrMascara8 = "####-####";
                var lstrMascara9 = "#####-####";
                var lstrMascara11 = "(##)####-####";
                var lstrMascara12 = "(##)#####-####";

                var EhDigitoValido = function(key) {
                    var re = /[\d-()]+/;
                    return re.exec(key) != null;
                }

                var RetirarMascara = function(strTexto) {
                    return strTexto.replace('(', '').replace(')', '').replace('-', '');
                }

                var Mascarar = function(texto) {
                    texto = RetirarMascara(texto);
                    if (texto.length < 5)
                        return texto;

                    var digitosMascara = [];

                    var mascara = texto.length <= 8 ? lstrMascara8 :
                    texto.length <= 9 ? lstrMascara9 :
                    texto.length <= 10 ? lstrMascara11 : lstrMascara12;

                    for (var i = 0; i < mascara.length; i++) {
                        var lchDigito = mascara[i];
                        if (lchDigito != '#') {
                            var digTemp = {};
                            digTemp.indice = i;
                            digTemp.digito = lchDigito;
                            digitosMascara.push(digTemp);
                        }
                    }

                    var textomascarado = texto;

                    for (var i = 0; i < digitosMascara.length; i++) {
                        var value = digitosMascara[i];
                        textomascarado = textomascarado.insert(value.indice, value.digito);
                    }
                    return textomascarado;
                }
                ngModelCtrl.$parsers.push(function(valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }
                    var _valor = valorView.replace(/[^\d]+/g, "");
                    var valor = Mascarar(_valor);
                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });

                element.bind('keydown', function(event) {                   
                    // bloqueia o espaço
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }

                    if (EhDigitoValido(event.key)) {
                        if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
                            ngModelCtrl.$viewValue.length == 14) {
                            event.preventDefault();
                        }
                    }
                });
            }
        }
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function(){
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTamanhoCampo', mascaraTamanhoCampoDirective);

    function mascaraTamanhoCampoDirective(){
        return{
            restrict: 'A',
            require: "^ngModel",
            link: function(scope, element, attrs , ngModelCtrl){
                var quantidadeMaximaCaracteres = attrs.mascaraTamanhoCampo;
                if(!quantidadeMaximaCaracteres){
                    alert("Para o funcionamento correto da diretiva mascara-tamanho-campo.\n" +
                          "É necessário informa a quantidade de caracteres máxima na diretiva \n" +
                          "Exemplo: mascara-tamanho-campo='50'");
                }

                var formatarDiretiva = function(valor){
                    if(valor !== undefined) {
                        if (quantidadeMaximaCaracteres) {
                            if (valor && (valor.length > quantidadeMaximaCaracteres)) {
                                valor = valor.substring(0, quantidadeMaximaCaracteres);
                            }
                        }
                    }

                    return valor;
                };

                ngModelCtrl.$parsers.push(function(valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }

                    var valor = formatarDiretiva(valorView);

                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });

                element.bind('keydown', function(event) {                    
                    if (event.key && event.key.length === 1) {
                        if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue.length == quantidadeMaximaCaracteres) {
                            event.preventDefault();
                        }
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraRelease', MascaraReleaseDirective);

    function MascaraReleaseDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue == null) {
                        return '';
                    }

                    var cleanInputValue = inputValue.replace(/[^0-9a-zA-ZçÇ]/gi, '').toUpperCase();

                    var padrao = /^[0-9]$/;

                    var mascaraInput = "";

                    if (cleanInputValue.length == 3) {
                        mascaraInput = cleanInputValue[0] + cleanInputValue[1] + "/" + cleanInputValue[2];
                    }

                    if (cleanInputValue.length == 2) {
                        mascaraInput = cleanInputValue[0] + "/" + cleanInputValue[1];
                    }

                    if (cleanInputValue.length > 3) {
                        mascaraInput = cleanInputValue[0] + cleanInputValue[1] + "/" + cleanInputValue[2];
                    }

                    if (cleanInputValue.length < 2) {
                        if (padrao.test(cleanInputValue)) {
                            mascaraInput = cleanInputValue;
                        }
                    }

                    if (mascaraInput != inputValue) {
                        modelCtrl.$setViewValue(mascaraInput);
                        modelCtrl.$render();
                    }

                    return mascaraInput;
                });
            }
        }
    }


})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraNumeros', mascaraNumerosDirective);

    function mascaraNumerosDirective() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                var tamanhoMaximo = attrs.mascaraNumeros;
                if (tamanhoMaximo == '')
                    tamanhoMaximo = 5;

                var aceitaNegativo = angular.isDefined(attrs.aceitaNegativo);

                var numeroCasasDecimais = attrs.numeroCasasDecimais;

                if (angular.isUndefined(numeroCasasDecimais))
                    numeroCasasDecimais = 0;
                else {
                    if (numeroCasasDecimais === 0)
                        numeroCasasDecimais = 2;
                }

                var EhDigitoValido = function (key) {
                    var re = /[\d-.]+/;
                    return re.exec(key) != null;
                };

                ngModelCtrl.$parsers.push(function (valorView) {
                    if (valorView === null) {
                        return valorView;
                    } else if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }

                    valorView = String(valorView);

                    var valor = valorView.replace(/[^\d-.]+/g, "");
                    //var valor = valorView;

                    if (aceitaNegativo) {
                        var vetNegativoCheck = valor.split('-');
                        if (!angular.isUndefined(vetNegativoCheck[1])) {
                            vetNegativoCheck[1] = vetNegativoCheck[1].slice(0, vetNegativoCheck[1].length);
                            valor = vetNegativoCheck[0] + '-' + vetNegativoCheck[1];
                            if (vetNegativoCheck[0].length > 0 || !aceitaNegativo) {
                                valor = vetNegativoCheck[0];
                            }
                        }
                    }

                    if (numeroCasasDecimais > 0) {
                        var vetDecimalCheck = valor.split('.');
                        if (!angular.isUndefined(vetDecimalCheck[1])) {
                            if (numeroCasasDecimais === 0) {
                                valor = vetDecimalCheck[0];
                            } else {
                                vetDecimalCheck[1] = vetDecimalCheck[1].slice(0, numeroCasasDecimais);
                                valor = vetDecimalCheck[0] + '.' + vetDecimalCheck[1];
                            }
                        }
                    }

                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return Number(valor);
                });

                element.bind('keydown', function (event) {
                    // bloqueia o espaço
                    if (event.key == ' ') {
                        event.preventDefault();
                    }

                    // bloqueia o negativo
                    if (!aceitaNegativo && event.key == '-') {
                        event.preventDefault();
                    }

                    // bloqueia o decimal
                    if (numeroCasasDecimais === 0 && event.key == '.') {
                        event.preventDefault();
                    }

                    if (EhDigitoValido(event.key)) {
                        if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
                            ngModelCtrl.$viewValue.length == tamanhoMaximo) {
                            event.preventDefault();
                        }
                    }
                });
            }
        }
    }

})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraNumeroLetra', MascaraNumeroLetraDirective);

    function MascaraNumeroLetraDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue == null) {
                        return '';
                    }
                
                    var cleanInputValue = inputValue.replace(/[^0-9a-zA-ZçÇ]/gi, '');           

                    if (cleanInputValue != inputValue) {
                        modelCtrl.$setViewValue(cleanInputValue);
                        modelCtrl.$render();
                    }

                    return cleanInputValue;
                });
            }
        }
    };


})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraNumeroGenerica', MascaraNumeroGenericaDirective);

  function MascaraNumeroGenericaDirective() {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {        
        var mascara = attrs.mascaraNumeroGenerica;
        if (!mascara) {
          alert("Para o funcionamento correto da diretiva mascara-numero-generica.\n" +
            "É necessário informar a máscara na diretiva \n" +
            "Exemplo: mascara-numero-generica='###-###'");
          return;
        }

        if (mascara === '')
          return;

        if (!ngModelCtrl) {
          return;
        }

        // Método de insert para string
        String.prototype.insert = function (index, string) {
          if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
          else
            return string + this;
        };

        //tamanho máximo da mascara
        var tamanhoMaximo = mascara.length;

        // vetor com os digitos especiais da mascara
        var digitosMascara = [];
        for (var i = 0; i < mascara.length; i++) {
          var lchDigito = mascara[i];
          if (lchDigito != '#') {
            var digTemp = {};
            digTemp.indice = i;
            digTemp.digito = lchDigito;
            digitosMascara.push(digTemp);
          }
        }

        var _regex = "[\\d";
        var _regexLimpeza = "[^\\d";
        for (var i = 0; i < digitosMascara.length; i++) {
          var digto = digitosMascara[i].digito;
          if (_regex.indexOf(digto) !== -1)
            continue;
          _regex += digto;
          _regexLimpeza += digto;
        }
        _regex += "]+";
        _regexLimpeza += "]+";
        // Regex para validar mascara
        var regexMascara = new RegExp(_regex);
        // Regex para limpar o conteudo da mascara
        var regexLimpeza = new RegExp(_regexLimpeza, "g");

        var EhDigitoValido = function (key) {
          return regexMascara.exec(key) != null;
        }

        var RetirarMascara = function (strTexto) {
          for (var i = 0; i < digitosMascara.length; i++) {
            strTexto = strTexto.replace(digitosMascara[i].digito, '');
          }
          return strTexto;
        }

        var ultimoValor = null;
        var Mascarar = function (texto) {
          // se nao tem mascara retorna
          if (digitosMascara.length == 0)
            return texto;

          // se o tamanho é menor que o primeiro indice retorna
          if (texto.length < digitosMascara[0].indice + 1)
            return texto;

          // se houve backspace retorna
          if (ultimoValor != null && texto.length < ultimoValor.length)
            return texto;

          // se o tamanho é maior que o máximo retorna a informação correta
          if (texto.length > tamanhoMaximo)
            return ultimoValor;

          texto = RetirarMascara(texto);
          var textoMascarado = texto;

          for (var i = 0; i < digitosMascara.length; i++) {
            var value = digitosMascara[i];
            textoMascarado = textoMascarado.insert(value.indice, value.digito);
            var proximo = i + 1;
            if (angular.isDefined(digitosMascara[proximo]))
              if (textoMascarado.length < digitosMascara[proximo].indice)
                return textoMascarado;
          }

          return textoMascarado;
        }
      
        ngModelCtrl.$parsers.push(function (valorView) {   
          if (angular.isUndefined(valorView)) {
            var valorView = '';
          }
          var _valor = valorView.replace(regexLimpeza, "");
          var valor = Mascarar(_valor);
          ultimoValor = valor;
          if (valorView !== valor) {
            ngModelCtrl.$setViewValue(valor);
            ngModelCtrl.$render();
          }

          if (angular.isDefined(attrs.converteMascaraParaNumero))
            return Number(valor);
          else
            return valor;
        });

        element.bind('keydown', function (event) {
          // bloqueia o espaço
          if (event.keyCode === 32) {
            event.preventDefault();
          }

          if (EhDigitoValido(event.key)) {
            if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
              ngModelCtrl.$viewValue.length == tamanhoMaximo) {
              var elm = element[0];

              // Se tiver algum texto selecionado, permite a substituição deste texto
              var valorSelecionado = elm.value.substr(elm.selectionStart, elm.selectionEnd);

              if (valorSelecionado == "") {
                event.preventDefault();
              }
            }
          }
        });

        element.bind('blur', function (e) {
          if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null) {
            ngModelCtrl.$setViewValue(Mascarar(ngModelCtrl.$viewValue));
            ngModelCtrl.$render();
          }
        });
      }
    }
  }

})();

/**
 * Created by nova on 12/09/2016.
 */
(function () {
    'use strict'

    angular
        .module('app.diretivas')
        .directive('mascaraFormatarNome', mascaraFormatarNomeDirective);

    function mascaraFormatarNomeDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {

                var formatarDiretiva = function (valor) {
                    if (valor !== undefined) {
                        valor = valor.replace(/[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ?\s]/g, "");

                        return valor;
                    }
                };

                ngModelCtrl.$parsers.push(function (valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }

                    var valor = formatarDiretiva(valorView);

                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }
                    return valor;
                });
            }
        }
    }


})();

/**
 * Created by nova on 25/10/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .service('MascaraDocumentoService', MascaraDocumentoService);

    function MascaraDocumentoService() {

        this.verificarCPF = verificarCPF;

        function verificarCPF(strCPF) {
            var Soma;
            var Resto;
            Soma = 0;
            if (strCPF == "00000000000") return false;

            for (var i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (var i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(10, 11))) return false;
            return true;
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraDocumento', mascaraDocumentoDirective);

  function mascaraDocumentoDirective($log, Regex, MascaraDocumentoService) {
    return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
        mascaraAUtilizar: '@?',
        desabilitarMascara: '=?',
        limitarTamanhoCampoQuandoDesabilitarMascaraAtivo: '@?',
        alterarMascaraDinamicamente: '=?'
      },
      controller: function () {},
      link: function (scope, element, attrs, ngModelCtrl) {
        if (!ngModelCtrl) {
          $log.error("É necessário informar o ng-model para o funcionamento correto da diretiva");
          return;
        }

        String.prototype.insert = function (index, string) {
          if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
          else
            return string + this;
        };

        //////////////////////////////////////// Variáveis Locais ///////////////////////////////////////////////////////////////
        var ultimoDigito = "";
        var mascaraCnpj = "##.###.###/####-##";
        var mascaraCpf = "###.###.###-##";
        var tamanhoMascara = null;
        var tipoMascara = null;
        var regex = null;
        var regexLimpeza = null;
        var regexValidacaoUtilizada = null;
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Chamadas Incializadoras ////////////////////////////////////////////////////////                          
        preDefinirRegex(preDefinirDigitosMascara(mascaraCnpj));
        preDefinirMascara();
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Métodos  ////////////////////////////////////////////////////////

        /**
         * Método para definir qual mascará será utiliza no campo
         * 'AMBOS' / 'CNPJ' / 'CPF'
         * E também definir qual RegeEpx de validação será utilizada no model
         */
        function preDefinirMascara() {
          if (!scope.mascaraAUtilizar || scope.mascaraAUtilizar.toUpperCase() == "AMBOS") {
            tipoMascara = "AMBOS"
            tamanhoMascara = mascaraCnpj.length;
            regexValidacaoUtilizada = new RegExp(Regex.cpfCnpj);
          } else if (scope.mascaraAUtilizar && scope.mascaraAUtilizar.toUpperCase() == "CNPJ") {
            tamanhoMascara = mascaraCnpj.length;
            tipoMascara = "CNPJ";
            regexValidacaoUtilizada = new RegExp(Regex.cnpj);
          } else if (scope.mascaraAUtilizar && scope.mascaraAUtilizar.toUpperCase() == "CPF") {
            tamanhoMascara = mascaraCpf.length;
            tipoMascara = "CPF";
            regexValidacaoUtilizada = new RegExp(Regex.cpf);
          }
        }

        /**
         * Método que verifica se a tecla digitada é valido
         * @param {string} key 
         */
        function ehDigitoValido(key) {
          return regex.exec(key) != null
        }

        /**
         * Método que verifica se a tecla digitada é um digito de navegação
         * @param {string} key 
         */
        function ehDigitoDeNavegacao(key) {
          if (key == 8 || key == 46 || key == 37 || key == 37 || key == 38 || key == 39 || key == 40)
            return true;
          else
            return false;
        }

        /**
         * Método que defini quais são os digitos da mascara, com base na mascara passada como parâmetro
         * Exemplo: CPF: '###.###.###-##' então seus digitos são: '..-'
         * @param {Array} mascaraAtiva 
         */
        function preDefinirDigitosMascara(mascaraAtiva) {
          var digitosMarscaraAtiva = []
          for (var i = 0; i < mascaraAtiva.length; i++) {
            if (mascaraAtiva[i] != '#') {
              digitosMarscaraAtiva.push({
                indice: i,
                digito: mascaraAtiva[i]
              });
            }
          }
          return digitosMarscaraAtiva;
        }

        /**
         * Método que defini as regex da diretiva, com base no array de digitos da mascará ativa passada como parâmetro
         * variáveis 'regex' e 'regexLimpeza'
         * @param {Array} arrayDigitosMascara 
         */
        function preDefinirRegex(arrayDigitosMascara) {
          var _regex = "[\\d";
          var _regexLimpeza = "[^\\d";
          for (var i = 0; i < arrayDigitosMascara.length; i++) {
            var digto = arrayDigitosMascara[i].digito;
            if (_regex.indexOf(digto) !== -1)
              continue;
            _regex += digto;
            _regexLimpeza += digto;
          }
          _regex += "]+";
          _regexLimpeza += "]+";

          regex = new RegExp(_regex);
          regexLimpeza = new RegExp(_regexLimpeza, "g");
        }

        /**
         * Método que retorna o texto do campo sem a mascará 
         * @param {Array} arrayDigistosMascara 
         * @param {string} textoARemover 
         */
        function retirarMascara(arrayDigistosMascara, textoARemover) {
          for (var i = 0; i < arrayDigistosMascara.length; i++) {
            textoARemover = textoARemover.replace(arrayDigistosMascara[i].digito, '');
          }
          return textoARemover;
        }

        /**
         * Método que recebe o texto do campo e o mascará
         * @param {string} texto 
         */
        function mascarar(texto) {
          var mascara = tipoMascara == "CNPJ" ? mascaraCnpj :
            tipoMascara == "CPF" ? mascaraCpf :
            tipoMascara == "AMBOS" && texto.length < 15 ? mascaraCpf :
            mascaraCnpj;


          var digitosMascara = preDefinirDigitosMascara(mascara);
          preDefinirRegex(digitosMascara);

          // se nao tem mascara retorna
          if (digitosMascara.length == 0)
            return texto;

          // se o tamanho é menor que o primeiro indice retorna
          if (texto.length < digitosMascara[0].indice + 1)
            return texto;

          // se houve backspace retorna
          if (ultimoDigito != null && texto.length < ultimoDigito.length)
            return texto;

          // se o tamanho é maior que o máximo retorna a informação correta
          if (texto.length > tamanhoMascara)
            return ultimoDigito;

          var textoMascarado = retirarMascara(digitosMascara, texto);


          for (var i = 0; i < digitosMascara.length; i++) {
            var value = digitosMascara[i];
            textoMascarado = textoMascarado.insert(value.indice, value.digito);
            var proximo = i + 1;
            if (angular.isDefined(digitosMascara[proximo]))
              if (textoMascarado.length < digitosMascara[proximo].indice)
                return textoMascarado;
          }

          return textoMascarado;
        }
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////// Métodos de Controle do Model  //////////////////////////////////////////////////

        /**
         * Método de controle do model executado sempre que o valor é alterado na View
         */
        ngModelCtrl.$parsers.push(function (valorView) {
          if (!scope.desabilitarMascara) {
            if (!valorView || angular.isUndefined(valorView)) {
              var valorView = '';
            }
            var _valor = valorView.replace(regexLimpeza, "");
            var valor = mascarar(_valor);
            ultimoDigito = valor;
            if (valorView !== valor) {
              ngModelCtrl.$setViewValue(valor);
              ngModelCtrl.$render();
            }
            return valor;
          } else {
            ultimoDigito = valorView;
            return valorView;
          }
        });

        /**
         * Método de controle do model executado sempre que o valor é alterado no model ou 'Controller'
         */
        ngModelCtrl.$formatters.push(function (modelValue) {
          if (!modelValue)
            ultimoDigito = "";

          return modelValue;
        });

        /**
         * Método de controle executado para validar ou inválidar o modél, também criando um validador customizado à ser utilizado na view
         * 'validacaoDocumento', e este método é disparado sempre ao final da execução de um $parses ou $formatters
         */
        ngModelCtrl.$validators.validacaoDocumento = function (modelValue, viewValue) {
          if (!viewValue || viewValue.length == 0)
            return true;
          else if (scope.desabilitarMascara)
            return true
          else if (viewValue && regexValidacaoUtilizada.test(viewValue)) {
            return true;
          } else
            return false;

        }

        /**
         * Método de controle executado para validar ou inválidar o CPF preenchido, assim criando um validador customizado
         * 'cpfValidacao'
         */
        ngModelCtrl.$validators.cpfValidacao = function (modelValue, viewValue) {
          if (!viewValue || viewValue.length == 0 || tipoMascara !== "CPF")
            return true;
          else if (viewValue && MascaraDocumentoService.verificarCPF(viewValue.replace(/\./g, '').replace(/\-/g, '')))
            return true;
          else
            return false;

        }

        /**
         * Método de controle executado sempre que o usuário pressionar alguma teclado no campo
         */
        element.bind('keydown', function (event) {
          // bloqueia o espaço
          if (event.keyCode === 32) {
            event.preventDefault();
          }

          if (scope.alterarMascaraDinamicamente || angular.isDefined(attrs.alterarMascaraDinamicamente)) {
            preDefinirMascara();
          }

          if (ultimoDigito.length >= scope.limitarTamanhoCampoQuandoDesabilitarMascaraAtivo && scope.desabilitarMascara &&
            !ehDigitoDeNavegacao(event.keyCode)) {
            event.preventDefault();
          }
        });
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      }
    }
  };

})();

/**
 * Created by nova on 29/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .directive('mascaraConversorStringParaData', mascaraConversorStringParaDataDirective);

  function mascaraConversorStringParaDataDirective($filter) {
    return {
      restrict: "A",
      require: "^ngModel",
      link: function (scope, element, attrs, ngModelCtrl) {

        ngModelCtrl.$parsers.push(function (modelValue) {
          if (modelValue) {
            var data = $filter('date')(modelValue, 'dd/MM/yyyy');
            var dataFormatada = data.split('/');
            return new Date(dataFormatada[2], dataFormatada[1] - 1, dataFormatada[0]);
          }
          else{
            return null;
          }
        });

        ngModelCtrl.$formatters.push(function (modelValue) {
          if (modelValue) {
            var data = $filter('date')(modelValue, 'dd/MM/yyyy');
            var dataFormatada = data.split('/');
            return new Date(dataFormatada[2], dataFormatada[1] - 1, dataFormatada[0]);
          } else {
            return null;
          }
        });
      }
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraCampoGenerica', mascaraCampoGenerica);

    function mascaraCampoGenerica() {
        return {
            restrict: 'A',
            require: '^ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var mascara = attrs.mascaraCampoGenerica;
                if (!mascara) {
                    alert("Para o funcionamento correto da diretiva mascara-campo-generica.\n" +
                        "É necessário informar a máscara na diretiva \n" +
                        "Exemplo: mascara-campo-generica='###-###'");
                    return;
                }

                if (mascara === '')
                    return;

                if (!ngModelCtrl) {
                    return;
                }

                // Método de insert para string
                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    else
                        return string + this;
                };

                //tamanho máximo da mascara
                var tamanhoMaximo = mascara.length;

                // vetor com os digitos especiais da mascara
                var digitosMascara = [];
                for (var i = 0; i < mascara.length; i++) {
                    var lchDigito = mascara[i];
                    if (lchDigito != '#') {
                        var digTemp = {};
                        digTemp.indice = i;
                        digTemp.digito = lchDigito;
                        digitosMascara.push(digTemp);
                    }
                }

                var _regex = "[\\d";
                var _regexLimpeza = "[^\\d";
                var ultimoDigitoValido = null;
                for (var i = 0; i < digitosMascara.length; i++) {
                    var digto = digitosMascara[i].digito;
                    if (_regex.indexOf(digto) !== -1)
                        continue;
                    _regex += digto;
                    _regexLimpeza += digto;
                }
                _regex += "]+";
                _regexLimpeza += "]+";
                // Regex para validar mascara
                var regexMascara = new RegExp(_regex);
                // Regex para limpar o conteudo da mascara
                var regexLimpeza = new RegExp(_regexLimpeza, "g");

                var EhDigitoValido = function(key){                    
                    if (key != 37 && key != 39 && key != 16 && key != 17 && key != 37 && key != 8 && key != 38 && key != 40 
                        && (ultimoDigitoValido == 37 && key == 65)){
                        return true;
                        ultimoDigitoValido = key;
                    }
                    else 
                        return false;
                }

                var RetirarMascara = function (strTexto) {
                    for (var i = 0; i < digitosMascara.length; i++) {
                        strTexto = strTexto.replace(digitosMascara[i].digito, '');
                    }
                    return strTexto;
                }

                var ultimoValor = null;
                var Mascarar = function (texto) {
                    // se nao tem mascara retorna
                    if (digitosMascara.length == 0)
                        return texto;

                    // se o tamanho é menor que o primeiro indice retorna
                    if (texto.length < digitosMascara[0].indice + 1)
                        return texto;

                    // se houve backspace retorna
                    if (ultimoValor != null && texto.length < ultimoValor.length)
                        return texto;

                    // se o tamanho é maior que o máximo retorna a informação correta
                    if (texto.length > tamanhoMaximo)
                        return ultimoValor;

                    texto = RetirarMascara(texto);
                    var textoMascarado = texto;

                    for (var i = 0; i < digitosMascara.length; i++) {
                        var value = digitosMascara[i];
                        textoMascarado = textoMascarado.insert(value.indice, value.digito);
                        var proximo = i + 1;
                        if (angular.isDefined(digitosMascara[proximo]))
                            if (textoMascarado.length < digitosMascara[proximo].indice)
                                return textoMascarado;
                    }

                    return textoMascarado;
                }

                ngModelCtrl.$parsers.push(function (valorView) {
                    if (angular.isUndefined(valorView)) {
                        var valorView = '';
                    }
                    var valor = Mascarar(valorView);
                    ultimoValor = valor;                    
                    if (valorView !== valor) {
                        ngModelCtrl.$setViewValue(valor);
                        ngModelCtrl.$render();
                    }

                    if (angular.isDefined(attrs.converteMascaraParaNumero))
                        return Number(valor);
                    else
                        return valor;
                });

                element.bind('keydown', function (event) {
                    // bloqueia o espaço
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }

                    if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null &&
                        ngModelCtrl.$viewValue.length == tamanhoMaximo && EhDigitoValido(event.keyCode)) {
                        var elm = element[0];

                        // Se tiver algum texto selecionado, permite a substituição deste texto
                        var valorSelecionado = elm.value.substr(elm.selectionStart, elm.selectionEnd);
                        console.log(valorSelecionado);
                        if (valorSelecionado == "") {
                            event.preventDefault();
                        }
                    }
                });

                element.bind('blur', function (e) {
                    if (angular.isDefined(ngModelCtrl.$viewValue) && ngModelCtrl.$viewValue != null) {
                        ngModelCtrl.$setViewValue(Mascarar(ngModelCtrl.$viewValue));
                        ngModelCtrl.$render();
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('app.diretivas')
        .directive ('mascaraBarraEspaco', MascaraBarraEspaco);

    /** @ngInject */
    function MascaraBarraEspaco() {

        return {
            require:'ngModel',
            restrict: 'A',
            link: function(scope, element, attrs, modelCtrl){
                modelCtrl.$parsers.push(function(inputValue){
                    if(inputValue == null)
                        return ''
                    const cleanInputValue = inputValue.replace(/\s/gi, '');

                    if (cleanInputValue != inputValue) {
                        modelCtrl.$setViewValue(cleanInputValue);
                        modelCtrl.$render();
                    }

                    return cleanInputValue;
                });
            }
        }
    }

} ());
/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('HeaderPadraoController', HeaderPadraoController)
        .directive('headerPadrao', headerPadraoDirective);

    function HeaderPadraoController() {
        var vm = this;

        vm.navegarParaEstadoAnterior = navegarParaEstadoAnterior;

        function navegarParaEstadoAnterior() {
            if (angular.isDefined(vm.voltarAoEstadoAnterior)) {
                vm.voltarAoEstadoAnterior();
            }
            else {
                alert("É necessário implementar o método para voltar ao estado anterior");
            }
        }

        if (angular.isUndefined(vm.ngUtilizaPesquisa)) {
            vm.ngUtilizaPesquisa = true;
        }
    }

    function headerPadraoDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/header-padrao/header-padrao.html',
            restrict: 'E',
            scope: {
                icone: '@?',
                translateNome: '@?',                
            },
            controller: 'HeaderPadraoController as vm',
            bindToController: {
                liberarPesquisaQuandoDatatableAtivo: '=?',
                pesquisar: '=?',
                ngUtilizaPesquisa: '=?',
                textoAuxiliar: '=?',
                textoAuxiliarHabilitado: '=?',
                habilitarIconeVoltarAoEstadoAnterior: '=?',
                voltarAoEstadoAnterior: '&?',
                mensagemTooltipIconeEstadoAnterior: '=?'
            }

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO       
        $translatePartialLoaderProvider.addPart('app/compartilhado/diretivas/header-padrao');
        // endregion
    }

})();

/**
 * Created by nova on 27/10/2016.
 */
(function () {
    'use strict';

    angular.module('app.diretivas')
        .controller('GroupButtonHorizontalController', GroupButtonHorizontalController)
        .directive('groupButtonHorizontal', groupButtonHorizontalDirective);

    function GroupButtonHorizontalController($scope, MdDialogService, MdToastService) {
        var vm = this;

        //<editor-fold desc="Data">
        vm.requisicaSolicitada = false;
        //</editor-fold>

        //<editor-fold desc"Definição dos Métodos">
        var metodosInterno = {
            redefineConfiguracoesIniciaisNoFormulario: redefineConfiguracoesIniciaisNoFormulario
        };
        vm.metodosGroupButtonHorizontal = {
            salvar: salvar,
            editar: editar,
            cancelar: cancelar
        };
        //</editor-fold>

        //<editor-fold desc"Implementação dos Métodos">
        /**
         * Função que interage com o recurso link da diretiva,
         * para pegar o controle do formulário
         * @param formCtrl
         */
        $scope.getFormCtrl = function (formCtrl) {
            vm.formulario = formCtrl;
        };

        //<editor-fold desc"Métodos Interno">
        function redefineConfiguracoesIniciaisNoFormulario() {
            vm.formulario.$setUntouched();
            vm.formulario.$setPristine();
        }
        //</editor-fold>

        //<editor-fold desc"Métodos GroupButtonHorizontal">
        function salvar(event) {
            vm.requisicaSolicitada = true;
            if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.inicioProgresso)
                vm.controleForm.preLoaderToolbar.inicioProgresso();
            vm.salvar().then(
                function (success) {
                    MdToastService.toastPadrao(vm.nomeEntidade + " cadastrado com sucesso!");
                    metodosInterno.redefineConfiguracoesIniciaisNoFormulario();

                    vm.entidade = {};
                    vm.entidades.push(success.data);
                    vm.requisicaSolicitada = false;
                    vm.verificaEditarAtivo = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao(error.data, event);
                    vm.requisicaSolicitada = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                });
        }
        function editar(event) {
            vm.requisicaSolicitada = true;
            if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.inicioProgresso)
                vm.controleForm.preLoaderToolbar.inicioProgresso();
            vm.editar().then(
                function (success) {
                    MdToastService.toastPadrao(vm.nomeEntidade + " editado com sucesso!");
                    metodosInterno.redefineConfiguracoesIniciaisNoFormulario();

                    angular.forEach(vm.entidades, function (item, index) {
                        if (item.codigo === success.data.codigo) {
                            vm.entidades[index] = success.data;
                        }
                    });                    
                    vm.entidade = {};
                    vm.requisicaSolicitada = false;
                    vm.verificaEditarAtivo = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                },
                function (error) {
                    MdDialogService.alertPadrao("Falha ao editar o Registro\n Detalhes: " + error.data, event);                    
                    vm.requisicaSolicitada = false;

                    if (vm.controleForm && vm.controleForm.preLoaderToolbar && vm.controleForm.preLoaderToolbar.fimProgresso)
                        vm.controleForm.preLoaderToolbar.fimProgresso();
                });
        }
        function cancelar() {
            vm.entidade = {};
            metodosInterno.redefineConfiguracoesIniciaisNoFormulario();
            vm.verificaEditarAtivo = false;
        }
        //</editor-fold>

        //</editor-fold>

    }

    function groupButtonHorizontalDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/group-button-horizontal/group-button-horizontal.html',
            controller: 'GroupButtonHorizontalController as vm',
            restrict: 'AE',
            require: '^form',
            scope: {},
            bindToController: {
                entidade: '=?',
                entidades: '=?',
                verificaEditarAtivo: '=?',
                salvar: '&?',
                editar: '&?',
                controleForm: '=?',
                nomeEntidade: '@?'
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
            }
        }
    }

})();

/**
 * Created by nova on 01/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('GroupButtonController', GroupButtonController)
        .directive('groupButton', groupButtonDirective);

    function GroupButtonController($scope, $rootScope, MdDialogService, MdToastService) {
        var vm = this;

        // Data
        vm.requisicaoSolicitada = false
        var entidadeTemporaria = null;
        var verificaSeExisteEntidade;
        var verificaCancelar = true;
        var promessa;
        var existeAtributoRegistroExistente = false;
        ////////////////////////////////////////

        // Métodos

        /**
         * Função que interage com o recurso link da diretiva,
         * para pegar o controle do formulário
         * @param formCtrl
         */
        $scope.getFormCtrl = function (formCtrl) {
            vm.formulario = formCtrl;
        };

        $scope.verfificarSeExisteAtributo = function(existe){
            existeAtributoRegistroExistente = existe;
        }

        var metodosInternos = {
            salvar: function () {
                vm.requisicaoSolicitada = true;
                if (angular.isDefined(vm.toolbarPreLoader)) {
                    vm.toolbarPreLoader.inicioProgresso();
                }
                promessa = vm.salvar();
                promessa.then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        vm.entidade = success.data;
                        verificaCancelar = false;
                        MdToastService.toastPadrao("Registro cadastrado com sucesso!");
                        vm.metodosControladores.cancelarEdicao();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        MdDialogService.alertPadrao(error.data);
                    });
            },
            editar: function () {
                vm.requisicaoSolicitada = true;
                if (angular.isDefined(vm.toolbarPreLoader)) {
                    vm.toolbarPreLoader.inicioProgresso();
                }
                promessa = vm.editar();
                promessa.then(
                    function (success) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        vm.entidade = success.data;
                        verificaCancelar = false;
                        MdToastService.toastPadrao("Registro editado com sucesso!");
                        vm.metodosControladores.cancelarEdicao();
                    },
                    function (error) {
                        vm.requisicaoSolicitada = false;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.fimProgresso();
                        }
                        MdDialogService.alertPadrao(error.data);
                    });
            }
        };

        vm.metodosControladores = {
            habilitaEditar: function (entidade) {
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = true;

                entidadeTemporaria = angular.copy(entidade);
                verificaCancelar = true;
                vm.controladorAtivo = true;

                if (existeAtributoRegistroExistente){
                    verificaSeExisteEntidade = vm.registroExistente;
                }
                else
                    verificaSeExisteEntidade = entidade;


            },
            cancelarEdicao: function () {
                vm.controladorAtivo = false;
                $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                vm.formulario.$setUntouched();
                vm.formulario.$setPristine();

                if (verificaCancelar) {
                    vm.entidade = entidadeTemporaria;
                }

            }
        };

        vm.metodosButtons = {
            salvar: function (event) {
                if (!verificaSeExisteEntidade) {
                    metodosInternos.salvar();
                }
                else {
                    metodosInternos.editar();
                }
            },
            excluir: function (event) {
                MdDialogService.confirmPadraoComEvento("Excluir",
                    'Deseja realmente excluir o registro ?', event, function () {
                        vm.requisicaoSolicitada = true;
                        if (angular.isDefined(vm.toolbarPreLoader)) {
                            vm.toolbarPreLoader.inicioProgresso();
                        }
                        promessa = vm.excluir();
                        promessa.then(
                            function (success) {
                                vm.requisicaoSolicitada = false;
                                if (angular.isDefined(vm.toolbarPreLoader)) {
                                    vm.toolbarPreLoader.fimProgresso();
                                }
                                verificaCancelar = false;
                                MdToastService.toastPadrao(success.data);
                                vm.entidade = null;
                                vm.metodosControladores.cancelarEdicao();
                            },
                            function (error) {
                                vm.requisicaoSolicitada = false;
                                if (angular.isDefined(vm.toolbarPreLoader)) {
                                    vm.toolbarPreLoader.fimProgresso();
                                }
                                MdDialogService.alertPadrao(error.data, event);
                            });
                    });
            }
        };

        ////////////////////////////////////////

    }

    function groupButtonDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/group-button/group-button.html',
            controller: 'GroupButtonController as vm',
            restrict: 'AE',
            require: '^form',
            scope: {},
            bindToController: {
                ngDisabled: '=?',
                ngDisabledExcluir: '=?',
                preLoader: '=?',
                entidade: '=?',
                registroExistente: '=?',
                controladorAtivo: '=?',
                salvar: '&?',
                editar: '&?',
                excluir: '&?',
                toolbarPreLoader: '=?'
            },
            link: function (scope, element, attr, formCtrl) {
                scope.getFormCtrl(formCtrl);
                scope.verfificarSeExisteAtributo(angular.isDefined(attr.registroExistente))
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('DataTableController', DataTableController)
        .directive('tabela', dataTable);

    function DataTableController($scope) {
        var vm = this;


        vm.acaoClick = function (dado) {
            dado.emProgresso = true;
            vm.acao()(dado);
        }

    }

    function dataTable() {
        return {
            templateUrl: 'app/compartilhado/diretivas/data-table/data-table.html',
            restrict: 'E',
            controller: 'DataTableController as vm',
            scope: {
                cabecalhos: "=",
                dados: "=",
                options: "=",
                tituloAcao: "@?",
                iconeAcao: "@?",
                desabilitar: "=?",
                propriedadesExibir: "=",
                corIcone: "@"
            }, bindToController: {
                acao: "&?"
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('ngFileModel', ngFileModel);

    function ngFileModel() {
        return {
            scope: {
                ngFileModel: "=",
                limpar:"&"
            },
            link: function (scope, element, attributes) {
                element.on("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.ngFileModel = {
                                nome: changeEvent.target.files[0].name,
                                tipo: changeEvent.target.files[0].type,
                                tamanho: changeEvent.target.files[0].size,
                                conteudo: loadEvent.target.result
                            };
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('FabButtonController', FabButtonController)
        .directive('fabButton', fabButtonDirective);

    function FabButtonController() {
        var vm = this;

        vm.metodos = {
            abrirDialog: abrirDialog
        }

        function abrirDialog(event, botaoSelecionado) {
            botaoSelecionado.executarAcaoClick();
        }
    }

    function fabButtonDirective() {
        return {
            templateUrl: 'app/compartilhado/diretivas/fab-button/fab-button.html',
            controller: 'FabButtonController as vm',
            restrict: 'E',
            scope: {},
            bindToController: {
                tituloMenu: "@?",
                buttons: '=',
                disabled: '='
            }
        }
    }

})();

(function () {
  "use strict";

  angular
    .module("app.diretivas")
    .controller(
      "CarregamentoCircularController",
      CarregamentoCircularController
    )
    .directive("carregamentoCircular", carregamentoCircular);

  function CarregamentoCircularController($scope) {
    var vm = this;
  }

  /** @ngInject */
  function carregamentoCircular() {
    return {
      templateUrl:
        "app/compartilhado/diretivas/carregamento-circular/carregamento-circular.html",
      controller: "CarregamentoCircularController as vm",
      restrict: "E",
      scope: {},
      bindToController: {
        emProgresso: "=?",
        mensagem: "@?",
        titulo: "@?",
        subTitulo: "@?",
      },
    };
  }
})();

/**
 * Created by nova on 09/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.diretivas')
    .controller('DefineFocusController', DefineFocusController)
    .directive('defineFocus', defineFocusDirective);

  function DefineFocusController($scope, $timeout) {
    var vm = this;
    var elemento;

    $scope.getElement = function (element) {
      elemento = element;
    }


    if (angular.isUndefined(vm.defineFocusNoCampoQuandoNovaPesquisa)) {
      vm.defineFocusNoCampoQuandoNovaPesquisa = false;
    }

    if (vm.defineFocusNoCampoQuandoNovaPesquisa) {
      if (angular.isDefined(vm.modelFocus)) {
        $scope.$watch('vm.modelFocus', function (newValue, oldValue) {
          if (Object.getOwnPropertyNames(newValue).length === 0) {
            $timeout(function () {
              elemento.focus();
            });
          }
        });
      } else {
        alert("O atributo: define-focus-no-campo-quando-nova-pesquisa está habilitado\nÉ necessário definir o model em: model-focus");
      }
    } 
    else {
      $timeout(function () {
        elemento.focus();
      });      
    }
  }

  function defineFocusDirective($timeout) {
    return {
      restrict: 'A',
      scope: {},
      controller: 'DefineFocusController as vm',
      bindToController: {
        defineFocus: '=?',
        modelFocus: '=?',
        defineFocusNoCampoQuandoNovaPesquisa: '=?'
      },
      link: function (scope, element, attrs) {
        scope.getElement(element);
      }
    }
  }

})();

(function(){
  'use strict'

  angular
    .module('app.filtros', []);

})();

(function () {
  'use strict';

  angular
    .module('app.filtros')
    .filter('filtrarPorDescricao', filtrarPorDescricao);

  function filtrarPorDescricao() {
    return function (itens, descricao) {
      if (itens.length == 0 || !descricao) {
        return itens;
      }
      var filtrados = [];

      angular.forEach(itens, function (key, value) {
        if (key.registroSituacao.descricao == descricao) {
          filtrados.push(key);
        }
      });

      console.log(filtrados);
      return filtrados;

    }
  }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ValidacaoService', ValidacaoService);

    /** @ngInject */
    function ValidacaoService(MensagemConstant) {

        //#region Data
        //#region Definição dos métodos

        this.validarParametroString = _validarParametroString;
        this.validarParametroObjeto = _validarParametroObjeto;
        this.validarParametroFuncao = _validarParametroFuncao;   
        this.validarParametroBoolean = _validarParametroBoolean;
        this.validarParametroNumber = _validarParametroNumber;
        this.validarParametroArray = _validarParametroArray;
        //#endregion


        //#endregionregion 

        //#region Implementação dos Métodos

        function _validarParametroString(paramString) {
            if (typeof paramString != 'string')
                throw new Error(MensagemConstant.parametroStringInvalido + ": " + paramString);
        }

        function _validarParametroObjeto(paramObjeto) {
            if (typeof paramObjeto != 'object')
                throw new Error(MensagemConstant.parametroObjectInvalido + ": " + paramObjeto);
        }

        function _validarParametroFuncao(paramFuncao) {
            if (typeof paramFuncao != 'function')
                throw new Error(MensagemConstant.parametroFuncaoInvalida + ": " + paramFuncao);
        }

        function _validarParametroBoolean(paramBoolean) {
            if (typeof paramBoolean != 'boolean')
                throw new Error(MensagemConstant.parametroBoleanoInvalida + ": " + paramBoolean);
        }
     
        function _validarParametroNumber(paramNumber) {
            if (typeof paramNumber != 'number')
                throw new Error(MensagemConstant.parametroNumeroInvalido + ": " + paramNumber);
        }

        function _validarParametroArray(paramArray){
            if(!Array.isArray(paramArray))
                throw new Error(MensagemConstant.parametroArrayInvalido + ": " + paramArray);
        }

        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('UsuarioService', UsuarioService);

    /** @ngInject */
    function UsuarioService(Api, RequisicaoGenericaService, MdToastService, PgToolbarService, MdDialogService, $q, RotasHtml) {
        // Métodos de Requests region

        // Método de request interno do Serviço
        var listarGenericamente = function (rota, colaborador, controleForm, controlePreloader) {            
            var deferred = $q.defer();
                        
            PgToolbarService.iniciarPreLoaderToolbar(controleForm, controlePreloader);
            RequisicaoGenericaService.listarSemParams(rota + colaborador.codigo).then(
                function (success) {
                    console.log(success.data);
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.resolve(success.data);
                },
                function (error) {
                    PgToolbarService.finalizarPreLoaderToolbar(controleForm, controlePreloader);
                    deferred.reject(error.data);
                });
            return deferred.promise;
        }
        // endregion

        this.verificaTabSelecionada = function (tab, usuario, controleForm, controlePreloader) {
            switch (tab) {
                case 'detalhesColaborador':
                    listarGenericamente(Api.usuario.detalhes_usuario.listarDetalhesUsuario, usuario, controleForm, controlePreloader).then
                        (function (success) { usuario.detalhes = success; });
                    break;
                default:
                    break;
            }
        };

        this.controlaButtonsToolbar = function (tab, controleForm) {
            if (tab !== 'colaborador') {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = true;
                    controleForm.desabilitarButtonInserir = true;
                    controleForm.desabilitarButtonExcluir = true;
                    controleForm.desabilitarButtonListarTodos = true;
                    controleForm.desabilitarMetodoToolbarAtualizar = true;
                }
            } else {
                if (angular.isDefined(controleForm)) {
                    controleForm.desabilitarButtonEditar = false;
                    controleForm.desabilitarButtonInserir = false;
                    controleForm.desabilitarButtonExcluir = false;
                    controleForm.desabilitarButtonListarTodos = false;
                    controleForm.desabilitarMetodoToolbarAtualizar = false;
                }
            }
        };

        this.listarHtmlRotas = function () {
            return RotasHtml.usuario;
        }
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.service')
    .service('TokenService', TokenService);

  /** @ngInject */
  function TokenService(ControleAcessoConfig) {
    this.setarToken = function(strToken) {
      sessionStorage.setItem(ControleAcessoConfig.key_token, strToken);
    }

    this.getToken = function() {
      return sessionStorage.getItem(ControleAcessoConfig.key_token);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('SessionStorageService', SessionStorageService);

    /** @ngInject */
    function SessionStorageService() {

        this.armazenar = function (chave, valor) {
            sessionStorage.setItem(chave, JSON.stringify(valor));
        }

        this.recuperar = function (chave) {
            return JSON.parse(sessionStorage.getItem(chave));
        }

        this.remover = function (chave) {
            sessionStorage.removeItem(chave);
        }
    } // SessionStorageService
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ServicosGenericoService', ServicosGenericoService);


    function ServicosGenericoService($q, $timeout, Api, RequisicaoGenericaService, MdDialogService, MdToastService) {

        this.pesquisarAutoCompleteCodigoOuNomeGenericoApi = pesquisarAutoCompleteCodigoOuNomeGenericoApi;
        this.pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString = pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString;
        this.pesquisarAutoCompleteCodigoOuNomeGenerico = pesquisarAutoCompleteCodigoOuNomeGenerico;
        this.pesquisarAutoCompleteCodigoOuDescricaoGenericoApi = pesquisarAutoCompleteCodigoOuDescricaoGenericoApi;
        this.pesquisarAutoCompleteCodigoOuDescricaoGenerico = pesquisarAutoCompleteCodigoOuDescricaoGenerico;
        this.pesquisarAutoCompleteDescricaoGenericoApi = pesquisarAutoCompleteDescricaoGenericoApi;
        this.pesquisarAutoCompleteDescricaoGenerico = pesquisarAutoCompleteDescricaoGenerico;
        this.retornaSomatorioDeHorasEMinutos = retornaSomatorioDeHorasEMinutos;
        this.excluirRegistroPorCodigoOuGenericamente = excluirRegistroPorCodigoOuGenericamente;
        this.excluirRegistroPorCodigoOuGenericamenteEmDialogs = excluirRegistroPorCodigoOuGenericamenteEmDialogs;
        this.retornaHoraFormataComTempo = retornaHoraFormataComTempo;
        this.definirDataAtual = definirDataAtual;
        this.definirTempoParaNull = definirTempoParaNull;
        this.retornarControladorDialog = retornarControladorDialog;
        this.exibirPreloaderRequisicaoIniciada = exibirPreloaderRequisicaoIniciada;
        this.ocultarPreloaderRequisicaoFinalizada = ocultarPreloaderRequisicaoFinalizada;
        this.exibirAlertaDeErro = exibirAlertaDeErro;
        this.tratarErroAPI = _tratarErroAPI;

        /**
         * Método para buscar api na rota passada como parametro por código ou nome
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query 
         */
        function pesquisarAutoCompleteCodigoOuNomeGenericoApi(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.nome = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método para buscar api com params em formato string na rota passada como parametro por código ou nome
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query 
         */
        function pesquisarAutoCompleteCodigoOuNomeGenericoApiParamsEmFormatoString(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.nome = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParamsFormatoString(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método que irá buscar buscar um objeto por código ou nome  em cima da lista passada como parametro no md-autocomplete
         * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
         * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
         */
        function pesquisarAutoCompleteCodigoOuNomeGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.codigo == query || item.nome.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Método para buscar api na rota passada como parametro por código ou descricao
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} query 
         */
        function pesquisarAutoCompleteCodigoOuDescricaoGenericoApi(rota, query) {
            var queryConsulta = {};
            if (parseInt(query))
                queryConsulta.codigo = query;
            else
                queryConsulta.descricao = query;

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método que irá buscar buscar um objeto por código ou descrição em cima da lista passada como parametro no md-autocomplete
         * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
         * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
         */
        function pesquisarAutoCompleteCodigoOuDescricaoGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.codigo == query || item.descricao.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Método para buscar api na rota passada como parametro por descricao
         * com base no texto digitado pelo usuário
         * @param {*rota para pesquisar na api} Rota
         * @param {*texto pesquisado no camo md-autocomplete-cliente} queryDePesquisa
         */
        function pesquisarAutoCompleteDescricaoGenericoApi(rota, queryDePesquisa) {
            var queryConsulta = {
                descricao: queryDePesquisa
            };

            var deferred = $q.defer();
            $timeout(function () {
                RequisicaoGenericaService.listarComParams(rota, queryConsulta).then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject(error.data);
                    });
            });
            return deferred.promise;
        }

        /**
         * Método que irá buscar buscar um objeto por descrição em cima da lista passada como parametro no md-autocomplete
         * @param {listaAPesquisar} listaAPesquisar Lista generica de pesquisa
         * @param {*texto pesquisado no campo md-autocomplete} queryDePesquisa query generica
         */
        function pesquisarAutoCompleteDescricaoGenerico(listaAPesquisar, queryDePesquisa) {
            var query = queryDePesquisa.toLowerCase();
            var resultado = query ? listaAPesquisar.filter(function (item, index) {
                return (item.descricao.toLowerCase().search(query) != -1);
            }) : listaAPesquisar;
            return resultado;
        }

        /**
         * Recebe um array de Tempo e realiza o retorna o somatario de horas e minutos do mesmo
         * @param {*arrayDeHorasEMinutos} arrayTotalHoras 
         */
        function retornaSomatorioDeHorasEMinutos(arrayTotalHoras) {
            var tempoTotal = 0;
            arrayTotalHoras.forEach(function (item, index) {
                item[0] = parseInt(item[0]) * 60;
                item[1] = parseInt(item[1]);
                tempoTotal += item[0] + item[1];
            });

            var horasTotais = Math.floor(tempoTotal / 60);
            var minutosTotais = tempoTotal % 60;

            var stringHoras = horasTotais.toString().length === 1 ? "0" + horasTotais : horasTotais;
            var stringMinutos = minutosTotais.toString().length === 1 ? "0" + minutosTotais : minutosTotais;

            return stringHoras + ":" + stringMinutos;
        };

        /**
         * Método que faz uma requisição para Api para excluir uma Entidade por código          
         * @param {*rota Api} rota 
         * @param {*Lista de Entidade} entidades 
         * @param {*Entidade a ser excluida} entidade 
         * @param {*vm.controleForm} controleForm 
         * @param {*event do button} event 
         * @param {*Titulo da Mensagem} tituloMensagem 
         * @param {*Delegate de função se necessário} functionSuccess 
         */
        function excluirRegistroPorCodigoOuGenericamente(rota, entidades, entidade, controleForm, event, tituloMensagem, functionSuccess, index,
            dataExclusao) {
            if (tituloMensagem) {
                var mensagem = tituloMensagem;
            } else {
                var mensagem = 'Deseja realmente excluir o Registro?';
            }

            if (dataExclusao) {
                var dataParaExclusao = dataExclusao;
            }
            else {
                var dataParaExclusao = entidade.codigo
            }
            MdDialogService.confirmPadraoComEvento("Excluir",
                mensagem, event,
                function () {
                    if (controleForm) {
                        if (controleForm.preLoaderToolbar)
                            controleForm.preLoaderToolbar.inicioProgresso();
                    }
                    RequisicaoGenericaService.excluir(rota, dataParaExclusao).then(
                        function (success) {

                            if (functionSuccess) {
                                functionSuccess(success);
                            } else {
                                MdToastService.toastPadrao(success.data);
                            }

                            if (controleForm) {
                                if (controleForm.preLoaderToolbar)
                                    controleForm.preLoaderToolbar.fimProgresso();
                            }

                            if (index || typeof index !== 'undefined') {
                                entidades.splice(index, 1);
                            }
                            else {
                                entidades.splice(entidades.indexOf(entidade), 1);
                            }
                        },
                        function (error) {
                            MdDialogService.alertPadrao(error.data, event);
                            if (controleForm) {
                                if (controleForm.preLoaderToolbar)
                                    controleForm.preLoaderToolbar.fimProgresso();
                            }
                        });
                });
        };

        /**
         * Método que faz uma requisição para Api para excluir uma Entidade por código em Dialogs
         * @param {*rota Api} rota 
         * @param {*Lista de Entidade} entidades 
         * @param {*Entidade a ser excluida} entidade 
         * @param {*vm.preloader} preloader.habilitar Váriavel para habilitar o preloader do dialog aberto
         * @param {*event do button} event 
         * @param {*Titulo da Mensagem} tituloMensagem 
         * @param {*Delegate de função se necessário} functionSuccess 
         */
        function excluirRegistroPorCodigoOuGenericamenteEmDialogs(rota, entidades, entidade, preloader, mdDialog, event, tituloMensagem,
            functionSuccess, index, mensagemExclusao, dataExclusao) {
            if (tituloMensagem) {
                var mensagem = tituloMensagem;
            } else {
                var mensagem = 'Deseja realmente excluir o Registro?';
            }

            if (dataExclusao) {
                var dataParaExclusao = dataExclusao;
            }
            else {
                var dataParaExclusao = entidade.codigo
            }

            MdDialogService.confirmPadraoComEvento("Excluir",
                mensagem, event,
                function () {

                    if (preloader) {
                        preloader.habilitar = true;
                        preloader.requisicaoSolicitada = true;
                        if (mensagemExclusao) {
                            preloader.mensagem = mensagemExclusao;
                            preloader.mensagemPreloader = mensagemExclusao;

                        }
                    }
                    RequisicaoGenericaService.excluir(rota, dataParaExclusao).then(
                        function (success) {
                            if (functionSuccess) {
                                functionSuccess(success);
                            } else {
                                MdToastService.toastPadrao(success.data);
                            }
                            if (preloader) {
                                preloader.habilitar = false;
                                preloader.mensagem = null;
                                preloader.requisicaoSolicitada = false;
                                preloader.mensagemPreloader = mensagemExclusao;
                                if (mensagemExclusao)
                                    preloader.mensagem = null;
                            }


                            if (index || typeof index !== 'undefined') {
                                entidades.splice(index, 1);
                            }
                            else {
                                entidades.splice(entidades.indexOf(entidade), 1);
                            }


                            if (mdDialog) {
                                mdDialog.hide();
                            }
                        },
                        function (error) {
                            if (preloader) {
                                preloader.habilitar = false;
                                preloader.requisicaoSolicitada = false;
                            }
                            MdDialogService.alertPadrao(error.data, event);
                        });
                });
        };

        /**
         * Método que recebe uma data sem tempo e retorna uma data formatada "dd/MM/yyyy - hh-MM-ss"
         * @param {*data que será passada como parametro} dataSemTempo 
         */
        function retornaHoraFormataComTempo(dataSemTempo) {
            var data = new Date();

            var dataFormatada = new Date(dataSemTempo);
            dataFormatada.setHours(data.getHours(), data.getMinutes(), data.getSeconds());

            return dataFormatada;
        }

        /**
         * Método que que retorna um data no formato 'dd/MM/yyyy' com horas, minutos, segundos e milisegundos zeradas
         */
        function definirDataAtual() {
            var data = new Date();
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
            data.setMilliseconds(0);

            return data
        }

        /**
         * Método que seta as horas, minutos, segundos e milisegundos para zero do tempo da Data
         * @param {data} data 
         */
        function definirTempoParaNull(data) {
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
            data.setMilliseconds(0);

            return data;
        }

        /**
         * Método para retornar o controleDialog padrão
         */
        function retornarControladorDialog() {
            return {
                requisicaoSolicitada: false,
                mensagemPreloader: ""
            };
        }

        /**
         * Método genérico que recebe o objeto 'preloader' e habilita a sua requisição e seta a mensagem passada para ser exibida
         * @param {object} preloader 
         * @param {string} mensagem 
         */
        function exibirPreloaderRequisicaoIniciada(preloader, mensagem) {
            preloader.requisicaoSolicitada = true;
            mensagem ? preloader.mensagemPreloader = mensagem : preloader.mensagemPreloader = "";
        }

        /**
         * Método genérico que recebe o objeto 'preloader' e desabilita a sua requisição e seta a mensagem do objeto para null
         * @param {object} preloader 
         */
        function ocultarPreloaderRequisicaoFinalizada(preloader) {
            preloader.requisicaoSolicitada = false;
            preloader.mensagemPreloader = "";
        }

        /**
         * Método que exibi o alerta de erro padrão verificando se existe quebra de linha no texto assim exibindo as linhas quebradas 
         * caso exista ou em forma de titulo caso não exista
         * @param {object} error error
         * @param {event} event event do botão
         */
        function exibirAlertaDeErro(error, event) {
            if (error && error.data && (typeof error.data.substrituirQuebraDeLinhasParaTagHtml !== "undefined")) {
                if (error.data.indexOf("\n") != -1)
                    MdDialogService.alertPadrao("Atenção!", event, error.data.substrituirQuebraDeLinhasParaTagHtml());
                else if (error.data.indexOf("<br>") != -1)
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
                else
                    MdDialogService.alertPadrao("Atenção!", event, error.data);
            }
            else if (error && error.data) {
                MdDialogService.alertPadrao("Atenção!", event, error.data);
            }
            else {
                MdDialogService.alertPadrao("Atenção!", event, error);
            }
        }

        function _tratarErroAPI(error) {
            console.log(error);
            if (error.data == null && error.status == -1) {
                MdDialogService.alertPadrao("Não foi possível conectar-se à API. Por favor verifique a sua conexão.");
            }
            else {
                if (error && error.data && error.data.message)
                    error.data = error.data.message;

                exibirAlertaDeErro(error);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ServicoInicializadorService', ServicoInicializadorService);

    /** @ngInject */
    function ServicoInicializadorService(Api, RequisicaoGenericaService, SessionStorageService,
        ServicosGenericoService, KeysSessionStorage, $rootScope,
        LoginUsuarioService) {

        $rootScope.tipoDetalheCalculo = {};

        this.inicializarParametros = _inicializarParametros;

        var armazenarParametrosEmpresa = _armazenarParametrosEmpresa;

        function _inicializarParametros(acaoSuccess) {
            _armazenarParametrosEmpresa(acaoSuccess);
        }

        function _armazenarParametrosEmpresa(acaoSuccess) {
            RequisicaoGenericaService.listarSemParams(Api.parametros.dadosParametro).then(
                function (success) {
                    SessionStorageService.armazenar(KeysSessionStorage.parametrosEmpresa, success.data);
                    $rootScope.parametros = success.data;
                    SessionStorageService.armazenar(KeysSessionStorage.tipoDetalheCalculo, success.data.calculo.tipoDetalheCalculo);
                    SessionStorageService.armazenar(KeysSessionStorage.tipoProcesso, success.data.tipoProcesso);
                    acaoSuccess();
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, null);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('FormatacaoStringService', FormatacaoStringService)
        .service('RequisicaoGenericaService', RequisicaoGenericaService);

    function RequisicaoGenericaService(urlApi, $http, TokenService) {

        this.listarSemParams = function (rota) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: { "Content-Type": "Application/Json" }
            });
        };

        this.listarSemParamsComCache = function (rota) {
            return $http.get(urlApi.url_base_api + rota, { cache: true });
        };

        this.listarComParams = function listarComParams(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "Application/Json"
                },
                params: data
            });
        };


        this.listarPor = function (rota, data) {

            var json = angular.toJson(data, false);

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: { "Content-Type": "Application/Json" },
                params: { clsEntidade: json }
            });
        };

        this.listarPorPaginacaoJsonFormato = function (rota, data) {


            var entidadeEnvio = angular.copy(data);
            entidadeEnvio.clsEntidade = angular.toJson(data.clsEntidade, false);

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json" },
                data: entidadeEnvio
            });
        };

        this.listarTodosComParametrosPelaUrl = function (rota, parametro) {

            return $http({
                url: urlApi.url_base_api + rota + parametro,
                method: "GET",
                headers: { "Content-Type": "Application/Json" }
            });
        };

        this.listarTodosComParametros = function (rota, parametros) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                params: parametros,
                headers: { "Content-Type": "Application/Json" }
            });
        };

        this.listarTodosComArrayDeParametrosPelaRota = function (rota, parametro) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "GET",
                headers: { "Content-Type": "Application/Json" },
                params: {
                    "modelo[]": parametro
                }
            });
        };

        this.salvar = function (rota, data) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.importar = function (rota, data) {

            return $http({
                url: urlApi.url_layout + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.validarArquivos = function (dados, rota) {
            var formData = new FormData();

            formData.append('files[]', dados.arquivo.lfFile);
            formData.append('parametros', JSON.stringify(dados.parametros));

            return $http.post(urlApi.url_arquivo_api + rota, formData, {
                timeout: 60000000,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        }

        this.uploadArquivos = function (arquivos, rota) {
            var formData = new FormData();
            var _token = TokenService.getToken();

            angular.forEach(arquivos, function (obj) {
                formData.append('files[]', obj.lfFile);
            });

            return $http.post(urlApi.url_base_api + rota, formData, {
                timeout: 60000000,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined, "Authorization": "Bearer " + _token }
            });
        }

        this.editar = function (rota, data) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "PUT",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.excluir = function (rota, data) {

            return $http({
                url: urlApi.url_base_api + rota + data,
                method: "DELETE",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.excluirSemUrl = function (rota, data) {
            return $http({
                url: urlApi.url_base_api + rota,
                method: "DELETE",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.deleteComParams = function deleteComParams(rota, data) {
            var token = TokenService.getToken();

            return $http({
                url: urlApi.url_base_api + rota,
                method: "DELETE",
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "Application/Json"
                },
                params: data
            });
        };

        this.downloadArquivo = function downloadArquivo(rota, strArquivo) {

            return $http({
                url: urlApi.url_base_api + rota,
                params: {
                    strArquivo: strArquivo
                },
                method: "GET",
                headers: {
                    "Content-disposition": "attachment;filename=" + strArquivo
                }
            });
        }


        this.downloadPDF = function (rota, data) {

            return $http({
                url: urlApi.url_base_api + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json" },
                responseType: 'arraybuffer',
                data: data
            });
        };
    }

    function FormatacaoStringService() {

        this.formatarComZeroEsquerda = function (string, quantidade) {

            if (string && string.length < quantidade) {
                while (string.length < quantidade) {
                    string = '0' + string;
                }

                return string;
            }
        }
    }
})();

/* eslint-disable no-undef */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('RelatorioService', RelatorioService);

    /** @ngInject */
    function RelatorioService($http, urlApi, $window) {

        var service = {
            gerarRelatorio: gerarRelatorio,
            visualizarRelatorio: visualizarRelatorio,
            arrayBufferToString: arrayBufferToString
        };

        function gerarRelatorio(rota, dados) {
            return $http({
                method: 'POST',
                url: urlApi.url_base_api + rota,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                },
                data: dados
            });
        }

        function visualizarRelatorio(rota, nomeArquivo) {
            $window.open(urlApi.url_relatorio + rota + nomeArquivo);
        }

        function arrayBufferToString(buffer) {
            var arr = new Uint8Array(buffer);
            var enc = new TextDecoder("utf-8");
            var str = enc.decode(arr);

            return str;
        }


        return service;
    }
})();
/**
 * Created by nova on 29/09/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.service')
    .service("ProximoCodigoService", ProximoCodigoService);

  function ProximoCodigoService(urlApi, $http, TokenService){

    this.proximoCodigo = function(rota){
      var token = TokenService.getToken();
      return $http({
        url: urlApi.url_base_api + rota,
        method: "GET",
        headers: {"Authorization": "Bearer " + token}
      });
    };

  }

})();

/* eslint-disable no-undef */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('PesquisaSatisfacao', PesquisaSatisfacao);

    /** @ngInject */
    function PesquisaSatisfacao(LocalStorageService) {

        var service = {
            abrirPesquisaSatisfacao: abrirPesquisaSatisfacao
        };

        function abrirPesquisaSatisfacao(urlIManager, codigoCliente, codigoProduto, codigoUsuario) {
            var pesquisaAberta = LocalStorageService.recuperar("pesquisaAberta");

            if (pesquisaAberta) {
                return;
            }

            LocalStorageService.remover("pesquisaAberta");
            LocalStorageService.armazenar("pesquisaAberta", true);

            if (window['carregarPerguntas']) {
                window['carregarPerguntas'](
                    urlIManager,
                    codigoCliente,
                    codigoProduto,
                    codigoUsuario
                );
            }
        }

        return service;
    }
})();
/**
 * Created by nova on 20/07/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.service')
    .service("NotificationService", NotificationService);

  function NotificationService(MdDialogService) {

    this.criarNotificacao = criarNotificacao;
    this.verificarPermissao = verificarPermissao;

    /**
     * Método para criar e exibir uma notificação
     * @param {*titulo da notificação} titulo
     * @param {*mensagem da notificação} body
     * @param {*indentificador unico da notificação} tag
     * @param {*função opcional quando a notificação é exibida} functionOnShow
     * @param {*função opcional quando é clicado em cima da notificação} functionOnClick
     * @param {*função opcional quando a notificação é fechada} functionOnClose
     * @param {*função opcional quando ocorre algum erro com a notificação} functionOnerror
     */
    function criarNotificacao(titulo, body, tag, functionOnShow, functionOnClick, functionOnClose, functionOnerror, estadoNavegacao) {
      if (!estadoNavegacao)
        throw new Error("É obrigatório informar o 'estadoNavegacao' ");

      /**
       * Método para criar a notificação
       */
      function notificacao() {
        var opcoes = {
          body: body ? body : "",
          tag: tag ? tag : null,
          icon: '/assets/images/logos/logo-small.png',
          iconUrl: '/assets/images/logos/logo-small.png',
        }

        var notificacao = new Notification(titulo, opcoes);

        if (functionOnShow)
          notificacao.onshow = functionOnShow;

        if (functionOnClick)
          notificacao.onclick = functionOnClick;
        else {
          notificacao.onclick = function () {
            notificacao.close();
          }
        }

        if (functionOnClose)
          notificacao.onclose = functionOnClose;

        if (functionOnerror)
          notificacao.onerror = functionOnerror;
        else {
          notificacao.onerror = function (event) {
            console.log("Ocorreu um erro para criar a notificação\nDetalhes: " + event);
          }
        }

        return notificacao;
      }

      /**
       * Verifica se o browser suporta a componente de notificação, caso não suporte
       * será criado um dialog para exibir a notificação
       */
      if (!("Notification" in window)) {
        MdDialogService.confirmPadraoComEvento(titulo, body, null, functionOnClick, functionOnClose);
      }

      /**
       * Verifica se é permitido criar a notificação no browser para o usuário
       */
      else if (Notification.permission === "granted") {
        return notificacao();
      }

      /**
       * Se não houve permissão para criar a notificação, é solicitado a permissão
       */
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          // Se o usuario aceitar é criado a notificação
          if (permission === "granted") {
            return notificacao();
          }
        });
      }
      else
        alert("As notificações do seu browser estão bloqueadas. Por favor habilite as nas configurações do seu browser")

    }

    /**
     * Método que retorna a permissão do usuário para Notificações
     */
    function verificarPermissao() {
      return Notification.permission;
    }

  } // NotificationService

})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("MdToastService", MdToastService);

    function MdToastService($mdToast) {

        this.toastPadrao = function (texto, erro) {
            var corToast;

            if (erro)
                corToast = 'error-toast';
            else
                corToast = 'success-toast'

            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top')
                    .theme(corToast)
                    .hideDelay(3000));
        }

        this.toastErro = function (texto) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top center')
                    .theme('error-toast')
                    .hideDelay(3000));
        }

        this.toastWarning = function (texto, tempo) {
            if (!tempo)
                tempo = 5000;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top')
                    .theme('warning-toast')
                    .hideDelay(tempo));
        }

        this.toastInfo = function (texto) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(texto)
                    .position('top')
                    .theme('info-toast')
                    .hideDelay(3000));
        }

    } // MdDialogService

})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("MdDialogService", MdDialogService);

    function MdDialogService($mdDialog) {

        this.alertPadrao = function (titulo, event, htmlContent) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title(titulo)
                .htmlContent(htmlContent)
                .ariaLabel(titulo)
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert);
        };

        this.alertPadraoComEvento = function (titulo, eventSim, event, htmlContent) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title(titulo)
                .htmlContent(htmlContent)
                .ariaLabel(titulo)
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert).then(
                function () {
                    eventSim();
                }
            );
        };

        this.confirmPadraoComEvento = function (titulo, htmlContent, event, eventSim, eventNao) {
            var confirm = $mdDialog.confirm()
                .title(titulo)
                .ariaLabel(titulo)
                .htmlContent(htmlContent)
                .clickOutsideToClose(false)
                .targetEvent(event)
                .multiple(true)
                .ok("Sim")
                .cancel("Não");

            $mdDialog.show(confirm).then(
                function () {
                    if (angular.isDefined(eventSim) && eventSim) {
                        eventSim();
                    }
                },
                function () {
                    if (angular.isDefined(eventNao) && eventNao) {
                        eventNao();
                    }
                }
            );

        }

        this.alertPadraoResolve = function (titulo, event) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title("Falha ao resolver as dependências")
                .textContent("A conexão foi recusada pelo servidor. A aplicação será redirecionada para o estado anterior ativo.")
                .ariaLabel("Falha ao resolver as dependências, a conexão foi recusada pelo servidor")
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert);
        };

        this.abrirDialogPadrao = function (event, NomeController, templateHtml, parametros, escToClose) {
            if (angular.isUndefined(escToClose))
                escToClose = true;

            $mdDialog.show({
                controller: NomeController,
                controllerAs: 'vm',
                templateUrl: templateHtml,
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: escToClose,
                multiple: true,
                locals: {
                    Parametros: parametros
                }
            });
        }

        this.alertLogin = function (titulo, event, htmlContent) {
            var alert = $mdDialog.alert({
                onComplete: function afterShowAnimation() {
                    var $dialog = angular.element(document.querySelector('md-dialog md-dialog-content .md-dialog-content-body'));
                    angular.element($dialog).addClass('dialogLogin-corpo');
                }
            })
                .parent(angular.element(document.querySelector('body')))
                .targetEvent(event)
                .clickOutsideToClose(true)
                .title(titulo)
                .htmlContent(htmlContent)
                .ariaLabel(titulo)
                .multiple(true)
                .ok("Ok");

            $mdDialog.show(alert);
        };

        this.abrirDialogProcessamento = function (config) {
            var template = [
                '<md-dialog aria-label="{{config.title}}">',
                '  <md-dialog-content layout="column" layout-align="center start" class="md-padding" style="min-width: 400px;">',
                '    <h3 style="font-weight: 500; width: 100%; text-align: center;">{{config.title}}</h3>',
                '    <div layout="column" layout-align="center center" style="width: 100%; margin-top: 10px; text-align: center;">',
                '      <md-progress-circular md-mode="indeterminate" md-diameter="40"></md-progress-circular>',
                '      <div layout="column" style="margin-top: 20px;">',
                '        <h3 style="margin: 0;">{{config.body}}</h3>',
                '        <h4 style="margin: 5px 0 0 0; font-weight: bold;">{{config.progress}}</h4>',
                '      </div>',
                '    </div>',
                '  </md-dialog-content>',
                '</md-dialog>'
            ].join('');

            $mdDialog.show({
                controller: function ($scope, config) {
                    $scope.config = config;
                },
                template: template,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                locals: {
                    config: config
                }
            });
        };

        this.abrirDialogResultados = function (config) {
            var template = [
                '<md-dialog aria-label="{{config.title}}" style="width: 600px; max-height: 52vh; display: flex; flex-direction: column;">',
                '  <md-dialog-content style="flex-grow: 1; display: flex; flex-direction: column;">',
                '    <div style="padding: 0 24px 0 24px; flex-shrink: 0;">',
                '      <h2 style="width: 100%; text-align: center; margin-top: 0; margin-bottom: 16px;"><strong>{{config.title}}</strong></h2>',
                '      <h3 style="margin-top: 0;">{{config.mensagem}}</h3>',
                '      <md-divider></md-divider>',
                '    </div>',
                '    <div style="flex-grow: 1; overflow-y: auto; padding: 0 24px;">',
                '      <md-list flex>',
                '        <md-list-item class="md-2-line" style="margin-top: -10px" ng-repeat="item in config.resultados">',
                '          <md-icon md-svg-src="{{item.iconSrc}}" style="color: {{item.iconColor}}; margin-right: 16px;"></md-icon>',
                '          <div class="md-list-item-text">',
                '            <h3><strong>{{item.titulo}}</strong></h3>',
                '            <p>{{item.mensagem}}</p>',
                '            <md-divider style="margin-bottom: 5px;"></md-divider>',
                '          </div>',
                '        </md-list-item>',
                '      </md-list>',
                '    </div>',
                '  </md-dialog-content>',
                '  <md-dialog-actions layout="row" layout-align="end center" style="flex-shrink: 0;">',
                '    <md-button ng-click="fechar()" class="md-primary">Ok</md-button>',
                '  </md-dialog-actions>',
                '</md-dialog>'
            ].join('');

            $mdDialog.show({
                controller: function ($scope, $mdDialog, config) {
                    $scope.config = config;
                    $scope.fechar = function () {
                        $mdDialog.hide();
                    }
                },
                template: template,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    config: config
                }
            });
        };

        this.fecharDialogProcessamento = function () {
            $mdDialog.hide();
        };

    } // MdDialogService

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LogsServico', LogsServico);

    /** @ngInject */
    function LogsServico(Api, RequisicaoGenericaService) {
        var rota = Api.relatorios.logs;

        this.enviarFormulario = function (entidade) {
            return RequisicaoGenericaService.downloadPDF(rota.enviaFormulario, entidade);
        }

        this.enviarDados = function (entidade) {
            return RequisicaoGenericaService.salvar(rota.filtrarDados, entidade);
        }

        this.constroiFiltrosUtilizados = function (entidade) {
            var filtro = "";

            if (entidade.dataInicio && entidade.dataFim)
                filtro += "Perí­odo: " + entidade.dataInicio.toLocaleString().substr(0, 10) + " a " + entidade.dataFim.toLocaleString().substr(0, 10);

            return filtro;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LoginService', LoginService);

    /** @ngInject */
    function LoginService($http,
        urlApi,
        Api,
        $rootScope,
        $state,
        MdDialogService,
        ControleAcessoConfig,
        LoginUsuarioService,
        TokenService,
        ServicoInicializadorService,
        ControleAcessoService,
        ChatHubService,
        RequisicaoGenericaService
    ) {
        var vm = this;

        this.gerarToken = function (usuario, senha) {
            var strData = {
                'login': btoa(usuario),
                'senha': btoa(senha)
            }
            return $http({
                url: urlApi.url_base_api + Api.controleAcesso.login,
                data: angular.toJson(strData),
                headers: {
                    'Content-Type': 'application/json'
                },
                method: "POST"
            });
        };

        function _geraTokenCadastro() {
            var dadosTokens = new FormData();
            dadosTokens.append("username", 'SW50ZWdyYWNhb1VTRVI=');
            dadosTokens.append("password", 'SW50ZWdyYWNhb1BBU1NXT1JE');

            return $http({
                url: urlApi.url_base_api + Api.token.criar,
                transformRequest: angular.identity,
                data: dadosTokens,
                headers: {
                    'Content-Type': undefined
                },
                method: "POST"
            })
        }

        function _proximoCodigo(_token) {
            return $http({
                url: urlApi.url_base_api + Api.usuario.retornaProximoCodigo,
                method: "GET",
                headers: { "Authorization": "Bearer " + _token }
            });
        };

        function _cadastraUsuario(usuario, senhaImplantacao) {
            _geraTokenCadastro().then(function (success) {
                var _token = success.data.access_token;
                TokenService.setarToken(_token);

                RequisicaoGenericaService.listarSemParams(Api.modoimplantacao.validarSenhaImplantacao + senhaImplantacao)
                    .then(
                        function (success) {
                            _proximoCodigo(_token).then(function (success) {
                                var proximoCodigoCadastro = success.data;

                                var dadosUsuario = {
                                    'codigo': proximoCodigoCadastro,
                                    'codigoPerfil': 1,
                                    'login': btoa(usuario),
                                    'nome': usuario,
                                    'senha': btoa(btoa(usuario))
                                }

                                $http({
                                    url: urlApi.url_base_api + Api.usuario.criar,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "Authorization": "Bearer " + _token
                                    },
                                    method: "POST",
                                    data: dadosUsuario
                                }).then(function (success) {
                                    vm.autenticarUsuario(atob(dadosUsuario.login), atob(success.config.data.senha), true, senhaImplantacao);
                                }, function (error) {
                                    if (error.status == 409) {
                                        MdDialogService.alertLogin("Atenção!", event, "Usuário ou senha inválido. Tente novamente.");
                                        $state.go('app.login')
                                    }
                                })
                            });
                        },
                        function (error) {
                            $state.go('app.login');
                        });
            })
        }

        vm.autenticarUsuario = function (usuario, senha, loginAutomatico, senhaImplantacao) {
            $rootScope.loadingProgress = true;
            var tokenApi = this.gerarToken(usuario, senha);
            tokenApi.then(
                function (success) {
                    TokenService.setarToken(success.data.token);
                    if (loginAutomatico) {
                        RequisicaoGenericaService.listarSemParams(Api.modoimplantacao.validarSenhaImplantacao + senhaImplantacao)
                            .then(
                                function (successSenhaImplantacao) {
                                    _efetuarLogin(success.data);
                                },
                                function (errorSenhaImplantacao) {
                                    LoginUsuarioService.logout();
                                    $state.go('app.login');
                                });
                    } else {
                        _efetuarLogin(success.data);
                    }

                },
                function (error) {
                    if (loginAutomatico) {
                        _cadastraUsuario(usuario, senhaImplantacao)
                    } else {
                        $rootScope.loadingProgress = false;
                        var erro = { data: error.data };
                        if (error.data && error.data.mensagemDeRetorno) {
                            erro.data = error.data.mensagemDeRetorno;
                        }
                        ShowError(erro.data, event);
                    }
                });
        }

        function ShowError(error, event) {
            var erro = { data: error };

            if (error != null) {
                if (error.length > 0 && error.includes("Login ou senha inválidos, tente novamente."))
                    erro.data = "Usuário ou senha inválido. Tente novamente.";
            }
            else if (error == null)
                erro.data =
                    "Não foi possível estabelecer conexão com o servidor.<br>Verifique sua conexão com a internet e tente novamente.";

            MdDialogService.alertLogin("Atenção!", event, erro.data);
            $rootScope.$broadcast('msSplashScreen::remove');
        }

        function _efetuarLogin(dados) {
            LoginUsuarioService.armazenarUsuario(dados);
            ServicoInicializadorService.inicializarParametros(function () {
                LoginUsuarioService.carregarAgrupamentos(dados.login);
                ControleAcessoService.carregarRotinasPermitidasUsuario(
                    dados.login, function () {
                        $rootScope.loadingProgress = false;
                        $state.go(ControleAcessoConfig.configuracao.estado_home, { vemDoLogin: true }).then(function () {
                            ChatHubService.conectarHub();
                            ChatHubService.notificarNovasMensagens();
                            if (dados.mensagemDeRetorno.length > 0) {
                                MdDialogService.alertLogin(
                                    "Atenção!", event, dados.mensagemDeRetorno);
                            }
                        });
                    });
            });
        }
    }
})();



(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LoginUsuarioService', LoginUsuarioService);

    /** @ngInject */
    function LoginUsuarioService(ApiAcesso, $http, ControleAcessoConfig, TokenService,
        urlApi, ChatHubService, RequisicaoGenericaService, KeysSessionStorage, Api, ServicosGenericoService, LocalStorageService) {
        var configuracao = ControleAcessoConfig.configuracao;

        this.listarTodos = function () {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.listartodos,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        };

        this.listarPorPerfil = function (intCodigoPerfil) {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.listarporperfil + intCodigoPerfil,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        };

        this.usuarioPorId = function (intCodigo) {
            var token = TokenService.getToken();
            return $http({
                url: urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.baseUrl + intCodigo,
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        };

        this.usuarioPorLoginSenha = function (strLogin, strSenha) {
            var lstrLogin = btoa(strLogin);
            var lstrSenha = btoa(strSenha);
            var token = TokenService.getToken();
            var url = urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.baseUrl;

            return $http({
                url: url,
                params: {
                    strLogin: lstrLogin,
                    strSenha: lstrSenha
                },
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + token
                },

            });
        };

        this.alterarSenha = function (_strLogin, _strSenhaAtual, _strSenhaNova) {
            var lstrLogin = btoa(_strLogin);
            var lstrSenhaAtual = btoa(_strSenhaAtual);
            var lstrSenhaNova = btoa(_strSenhaNova);
            var token = TokenService.getToken();
            var configuracao = ControleAcessoConfig.configuracao;

            var lstrUrl = urlApi.url_base_api + ApiAcesso.baseUrl + ApiAcesso.usuario.baseUrl +
                ApiAcesso.usuario.alterarsenha +
                "?strLogin=" + lstrLogin + "&strSenhaAtual=" + lstrSenhaAtual + "&strSenhaNova=" + lstrSenhaNova

            return $http({
                url: lstrUrl,
                method: "PUT",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });
        }

        this.armazenarUsuario = function (usuario) {
            if (usuario && usuario.login && !usuario.codigo) {
                RequisicaoGenericaService.listarSemParams(Api.usuario.selecionarPorLogin + '?login=' + usuario.login)
                    .then(function (success) {
                        usuario.codigo = success.data;
                        sessionStorage.setItem(ControleAcessoConfig.key_usuario, JSON.stringify(usuario));
                    })
                    .catch(function (error) {
                        sessionStorage.setItem(ControleAcessoConfig.key_usuario, JSON.stringify(usuario));
                        ServicosGenericoService.exibirAlertaDeErro(error, null);
                    });
            } else {
                sessionStorage.setItem(ControleAcessoConfig.key_usuario, JSON.stringify(usuario));
            }
        }

        this.usuarioArmazenado = function () {
            return JSON.parse(sessionStorage.getItem(ControleAcessoConfig.key_usuario));
        }

        this.logout = function () {
            sessionStorage.clear(ControleAcessoConfig.key_usuario);
            LocalStorageService.remover("pesquisaAberta");
            ChatHubService.desconectarHub();
        }

        this.carregarAgrupamentos = function (login) {
            var parametros = JSON.parse(sessionStorage.getItem(KeysSessionStorage.parametrosEmpresa));
            if (parametros.utilizaCadastroRegional) {
                _pesquisarPorLogin(login);
            } else {
                sessionStorage.setItem(KeysSessionStorage.usuarioAgrupamentos, JSON.stringify([]));
            }
        }

        this.agrupamentosArmazenado = function () {
            return sessionStorage.getItem(KeysSessionStorage.usuarioAgrupamentos);
        }

        function _pesquisarPorLogin(login) {
            RequisicaoGenericaService.listarSemParams(Api.usuario.selecionarPorLogin + '?login=' + login).then(
                function (success) {
                    RequisicaoGenericaService.listarSemParams(Api.usuario.listarAgrupamentos + '/' + success.data + '/Agrupamentos').then(
                        function (success) {
                            sessionStorage.setItem(KeysSessionStorage.usuarioAgrupamentos, JSON.stringify(success.data));
                        },
                        function (error) {
                            ServicosGenericoService.exibirAlertaDeErro(error, null);
                        }
                    );
                },
                function (error) {
                    ServicosGenericoService.exibirAlertaDeErro(error, null);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LocalStorageService', LocalStorageService);

    /** @ngInject */
    function LocalStorageService() {

        this.chavesLocalStorage = {
            tamanhoPaginaDatatable: "Tamanho_Pagina_Datatable",
            badgeMensagensNaoVisualizadas: "Badge_Mensagens_Nao_Visualizadas",
            menus: "Menus"
        }

        this.armazenar = function (chave, valor) {
            localStorage.setItem(chave, JSON.stringify(valor));
        }

        this.recuperar = function (chave) {
            return JSON.parse(localStorage.getItem(chave));
        }

        this.remover = function (chave) {
            localStorage.removeItem(chave);
        }
    } // SessionStorageService
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('LeituristaUtilsService', LeituristaUtilsService);

    /** @ngInject */
    function LeituristaUtilsService() {
        this.retornarLeituristaPorCodigo = _retornarLeituristaPorCodigo;

        function _retornarLeituristaPorCodigo(leituristas, codigoLeiturista) {
            return leituristas.filter(function (x) {
                return x.codigo === codigoLeiturista;
            })[0];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ImanagerRequisicaoGenericaService', ImanagerRequisicaoGenericaService);

    function ImanagerRequisicaoGenericaService(urlApi, $http) {

        this.get = function (rota) {

            return $http({
                url: urlApi.url_imanager + rota,
                method: "GET",
                headers: { "Content-Type": "Application/Json" }
            });
        };


        this.getComParametros = function (rota, parametros) {

            return $http({
                url: urlApi.url_imanager + rota,
                method: "GET",
                params: parametros,
                headers: { "Content-Type": "Application/Json" }
            });
        };

        this.post = function (rota, data) {

            return $http({
                url: urlApi.url_imanager + rota,
                method: "POST",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.put = function (rota, data) {

            return $http({
                url: urlApi.url_imanager + rota,
                method: "PUT",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };

        this.delete = function (rota, data) {

            return $http({
                url: urlApi.url_imanager + rota + data,
                method: "DELETE",
                headers: { "Content-Type": "Application/Json" },
                data: data
            });
        };
    }
})();

/* eslint-disable no-console */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('HubService', HubService);

    /** @ngInject */
    function HubService($q, MdToastService) {

        var _conexao = null;
        var _listeners = [];

        var service = {
            conectar: conectar,
            realizarRequisicao: realizarRequisicao
        };

        function _configurarListeners() {
            for (var i = _listeners.length - 1; i >= 0; i--) {
                _conexao.on(_listeners[i].nome, _listeners[i].metodo);
            }
        }

        // function realizarRequisicao(nomeMetodo, dados, reconectar) {
        //   if (dados != undefined) {
        //     _requisicaoComParametro(nomeMetodo, dados, reconectar);
        //   } else {
        //     _requisicaoSemParametro(nomeMetodo, reconectar);
        //   }
        // }

        // function _requisicaoComParametro(nomeMetodo, parametro, reconectar) {
        //   _conexao
        //     .invoke(nomeMetodo, parametro)
        //     .catch(function (err) {
        //       console.error(err.toString());
        //       if (reconectar && typeof reconectar === "function" && _hubDesconectado(err.toString()))
        //         reconectar();
        //       return;
        //     });
        // }

        // function _requisicaoSemParametro(nomeMetodo, reconectar) {
        //   _conexao
        //     .invoke(nomeMetodo)
        //     .catch(function (err) {
        //       console.error(err.toString());
        //       if (reconectar && typeof reconectar === "function" && _hubDesconectado(err.toString()))
        //         reconectar();
        //       return;
        //     });
        // }

        function realizarRequisicao(nomeMetodo, dados, callbackErro) {
            if (dados != undefined) {
                _requisicaoComParametro(nomeMetodo, dados, callbackErro);
            } else {
                _requisicaoSemParametro(nomeMetodo);
            }
        }

        function _requisicaoComParametro(nomeMetodo, parametro, callbackErro) {
            _conexao
                .invoke(nomeMetodo, parametro)
                .catch(function (err) {
                    if (callbackErro) {
                        callbackErro(err);
                    }
                    return console.error(err.toString());
                });
        }

        function _requisicaoSemParametro(nomeMetodo) {
            _conexao
                .invoke(nomeMetodo)
                .catch(function (err) {
                    return console.error(err.toString());
                });
        }

        function conectar(url, nomeHub, listeners) {
            var deferred = $q.defer();
            try {
                _listeners = angular.copy(listeners);
                _conexao = new signalR.HubConnectionBuilder()
                    .withUrl(url + nomeHub, {
                        transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling
                    })
                    .build();

                _conexao.serverTimeoutInMilliseconds = 120000;

                _conexao
                    .start()
                    .then(function () {
                        deferred.resolve(_conexao);
                        _configurarListeners();
                    })
                    .catch(function (error) {
                        MdToastService.toastErro("Não foi possível realizar conexão com o servidor.");
                        deferred.reject(error);
                    });
            } catch (err) {
                MdToastService.toastErro("Não foi possível realizar conexão com o servidor.");
                deferred.reject(err);
            }
            return deferred.promise;
        }

        function _hubDesconectado(err) {
            return err.includes("Cannot send data if the connection is not in the 'Connected' State.");
        }

        return service;
    }
})();

(function(){
    'use strict';

    angular
        .module('app.service')
        .service('FotosService', FotosService)

    /** @ngInject */
    function FotosService($mdDialog, RotasHtml){

        var service  = {
            abrirDialogDetalheFoto: abrirDialogDetalheFoto
        };

        function abrirDialogDetalheFoto(urlFoto){            
            var rota = RotasHtml.gerenciamento.leitura.visualizacao.tabs.dadosLeitura.dialogs.fotos;       
            $mdDialog.show({
                controller: 'DialogDetalharFotoController',
                controllerAs: 'vm',
                templateUrl: rota.dialogs.detalharFotos,
                transclude: true,
                multiple: true,
                locals: {
                    Foto: urlFoto
                }
            });  
        }

        return service
    }

}());
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('FaturamentoServico', FaturamentoServico);

    /** @ngInject */
    function FaturamentoServico(Api, RequisicaoGenericaService) {
        var rota = Api.relatorios.faturamento;


        this.enviarFormulario = function (entidade) {
            return RequisicaoGenericaService.downloadPDF(rota.enviaFormulario, entidade);
        }

        this.gerarRelatorioCAEMA = function (entidade) {
            return RequisicaoGenericaService.downloadPDF(Api.relatorios.faturamentoCaema.gerarRelatorio, entidade);
        }

        this.constroiFiltrosUtilizados = function (entidade) {
            if (entidade.localidadeItapemirim) {
                var localidade = `Localidade: ${entidade.localidadeItapemirim.codigo} - ${entidade.localidadeItapemirim.descricao}`
            }
            var filtro = "";

            switch (entidade.tipoFiltro) {
                case '1':
                    filtro = 'Referência: ' + entidade.mes + '/' + entidade.ano;
                    break;

                case '2':
                    filtro = 'Período: ' + entidade.mesInicial + '/' + entidade.anoInicial + ' a ' + entidade.mesFinal + '/' + entidade.anoFinal;
                    break;

                case '3':
                    filtro = 'Período: ' + entidade.dataInicial.toLocaleString().substr(0, 10) + ' a ' + entidade.dataFinal.toLocaleString().substr(0, 10);
                    break;
            }

            if (entidade.localidadeItapemirim) {
                filtro += (filtro !== '' ? ', ' : '') + localidade;
            }
            return filtro;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('EstatisticasServico', EstatisticasServico);

    /** @ngInject */
    function EstatisticasServico(Api, RequisicaoGenericaService) {
        var rota = Api.relatorios.estatisticas;

        this.enviarFormulario = function (entidade) {
            return RequisicaoGenericaService.downloadPDF(rota.enviaFormulario, entidade);
        }

        this.constroiFiltrosUtilizados = function (entidade) {
            var filtro = "";

            if (entidade.dataInicio && entidade.dataFim)
                filtro = "Período: " + entidade.dataInicio.toLocaleString().substr(0, 10) + " a " + entidade.dataFim.toLocaleString().substr(0, 10);


            return filtro;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.service')
        .service('ControleAcessoService', ControleAcessoService);

    /** @ngInject */
    function ControleAcessoService(Api, RequisicaoGenericaService, msNavigationService, $q, SessionStorageService, KeysSessionStorage) {
        var _controleAcesso = {};
        var _menus = [];


        var service = {
            carregarRotinasPermitidasUsuario: _carregarRotinasPermitidasUsuario,
            carregarControleAcessoPorPerfil: _carregarControleAcessoPorPerfil,
            recarregarControleAcesso: _recarregarControleAcesso
        }

        function _carregarRotinasPermitidasUsuario(login, acaoSucesso) {
            _selecionarPerfilUsuario(login).then(
                function (success) {
                    _carregarControleAcessoPorPerfil(success.data, acaoSucesso);
                }
            )
        }

        function _carregarControleAcessoPorPerfil(perfilCodigo, acaoSucesso) {
            RequisicaoGenericaService.listarSemParams(Api.menu.listarporperfil + perfilCodigo + "/" + false).then(
                function (success) {
                    var parametros = SessionStorageService.recuperar(
                        KeysSessionStorage.parametrosEmpresa
                    );

                    var sistemaGestorEhFiorilli = parametros.coletor.sistemaGestor == 2;
                    var tipoProcesso = parametros.tipoProcesso;

                    _controleAcesso = success.data;
                    _menus = _controleAcesso.menus;
                    if (sistemaGestorEhFiorilli && tipoProcesso == '01') {
                        var menuProcessamento = _menus.find(function (menu) { return menu.codigo === 2; });
                        if (menuProcessamento) {
                            var menuItemExportacao = menuProcessamento.itens.find(function (item) { return item.codigo === 20; });
                            if (menuItemExportacao) {
                                menuItemExportacao.titulo = "Exportação de carga";
                            }
                        }
                    }
                    _limpar();
                    sessionStorage.setItem("MenusAcessoUsuarioLogado", JSON.stringify(_menus));
                    _construirControleAcesso(_menus);

                    if (acaoSucesso != null && acaoSucesso != undefined) {
                        acaoSucesso();
                    }
                }
            );
        }

        function _selecionarPerfilUsuario(login) {
            var deferred = $q.defer();
            RequisicaoGenericaService.listarSemParams(Api.usuario.selecionarPerfilUsuario + '?login=' + login).then(
                function (success) {
                    deferred.resolve(success);
                    return success.data;
                },
                function (error) {
                    deferred.resolve(error);
                    return 0;
                }
            );

            return deferred.promise;
        }

        function _recarregarControleAcesso() {
            var deferred = $q.defer();
            var menus = JSON.parse(sessionStorage.getItem("MenusAcessoUsuarioLogado"));
            if (menus && menus.length > 0) {
                _limpar();
                _construirControleAcesso(menus);
            }
            deferred.resolve("Finalizado");
            return deferred.promise;
        }

        function _construirControleAcesso(menus) {
            for (var i = 0; i <= menus.length - 1; i++) {
                _criarMsNavigationServiceProvider(menus[i]);
                _construirMenuItens(menus[i].itens);
            }
        }

        function _construirMenuItens(menuItens) {
            for (var i = 0; i <= menuItens.length - 1; i++) {
                var existeRotinasSelecionadas = _verificarSubrotina(menuItens[i].itens)
                if (menuItens[i].estado != "" || existeRotinasSelecionadas) {
                    _criarMsNavigationServiceProvider(menuItens[i]);
                    _construirMenuItens(menuItens[i].itens);
                }
            }
        }

        function _criarMsNavigationServiceProvider(menuItem) {
            if (menuItem.selecionado) {
                msNavigationService.saveItem(menuItem.navegacao, {
                    title: menuItem.titulo,
                    state: menuItem.estado,
                    group: menuItem.grupo,
                    weight: menuItem.peso,
                    icon: menuItem.icone
                });
            }
        }

        function _limpar() {
            var marcaEspecial = SessionStorageService.recuperar("marcaEspecial");

            var titulo = ((marcaEspecial && marcaEspecial.utilizarMarcaEspecial)
                ? marcaEspecial.nomeSolucaoMarcaEspecial
                : 'Reader Web') + "®";

            msNavigationService.clearNavigation();

            // Navegação
            msNavigationService.saveItem('app', {
                title: titulo,
                group: true,
            });

            msNavigationService.saveItem('app.inicio', {
                title: 'Início',
                icon: 'icon-tile-four',
                state: 'app.inicio',
                weight: 1,
            });
        }

        function _verificarSubrotina(itens) {
            var rotinasSelecionadas = []
            if (itens && itens.length > 0) {
                itens.map(function (item) {
                    if (item.selecionado == true) {
                        rotinasSelecionadas.push(item);
                    }
                });

                return rotinasSelecionadas.length > 0;
            }

            return false;
        }

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.service')
        .service('Base64Service', Base64Service);

    /** @ngInject */
    function Base64Service() {
        var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9+/=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = Base64._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/rn/g, "n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = c1 = c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2 } else { c2 = e.charCodeAt(n + 1); c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3 } } return t } };

        this.converteDadosParaString64 = converteDadosParaString64;
        this.converterArquivosGrandesParaBase64 = converterArquivosGrandesParaBase64;
        this.convertToBase64String = convertToBase64String;

        function converteDadosParaString64(dadosRelatorio) {
            var jsonString = JSON.stringify(dadosRelatorio);
            return Base64.encode(jsonString);
        }

        function converterArquivosGrandesParaBase64(arrayBuffer) {
            var binario = '';
            // eslint-disable-next-line no-undef
            var bytes = new Uint8Array(arrayBuffer);
            var tamanho = bytes.byteLength;
            for (var i = 0; i < tamanho; i++) {
                binario += String.fromCharCode(bytes[i]);
            }
            var base64String = btoa(binario);
            return base64String;
        }

        function convertToBase64String(arrayBuffer) {
            // eslint-disable-next-line no-undef
            var args = new Uint8Array(arrayBuffer);
            var base64String = btoa(String.fromCharCode.apply(null, args));
            return base64String;
        }
    }
})();

/**
 * Created by nova on 20/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.service')
        .service("ArquivosService", ArquivosService);

    function ArquivosService($q, RequisicaoGenericaService, MdDialogService) {

        this.retornarIcone = retornarIcone;
        this.baixarArquivo = baixarArquivo;
        this.obterArquivo = obterArquivo;


        /**
         * Método que retorna o icone e o css com base na extensão
         * @param {extensao} extensao extensao do arquivo 
         */
        function retornarIcone(extensao) {
            /**
             * cores do css:
             * imagem: green, * video: aqua, * documento: blue, * audio: red, * compactado: yellowgreen, * outros: dimgray
             */
            if (extensao.search("png" || "jpg" || "jpeg" || "gif" || "bmp") != -1)
                return { icone: "icon-file-image", css: "imagem" }
            else if (extensao.search("avi" || "mp4" || "mpeg" || "amv" || "mkv" || "mov" || "rmvb") != -1)
                return { icone: "icon-file-video", css: "video" }
            else if (extensao.search("mp3" || "wav" || "ac3" || "wma" || "cc3" || "ogg") != -1)
                return { icone: "icon-file-music", css: "audio" }
            else if (extensao.search("rar" || "zip" || "7z") != -1)
                return { icone: "icon-file-presentation-box", css: "compactado" }
            else if (extensao.search("doc" || "docx") != -1)
                return { icone: "icon-file-word", css: "documento" }
            else if (extensao.search("xls" || "xlsx") != -1)
                return { icone: "icon-file-excel", css: "documento" }
            else if (extensao.search("pdf") != -1)
                return { icone: "icon-file-pdf", css: "documento" }
            else if (extensao.search("ppt" || "pps" || "ppsx") != -1)
                return { icone: "icon-file-powerpoint", css: "documento" }
            else if (extensao.search("txt") != -1)
                return { icone: "icon-file-document", css: "documento" }
            else if (extensao.search("xml" || "xaml") != -1)
                return { icone: "icon-file-xml", css: "documento" }
            else
                return { icone: "icon-file", css: "outros" }
        }

        /**
         * Método genérico que faz uma requisição para api buscando o arquivo a ser realizado o download
         * e posteriormente criando o blob para que o usuário possa selecionar aonde salvar o arquivo selecionado
         * em sua máquina
         * @param {rota} rota Rota da Api
         * @param {modelo} modelo  Arquivo selecionado
         */
        function baixarArquivo(rota, nomeArquivo) {
            var deferred = $q.defer();

            RequisicaoGenericaService.downloadArquivo(rota, nomeArquivo)
                .then(function (success) {
                    var data = success.data.replace(/\r?\n/g, "\r\n");
                    var headers = success.headers();

                    var contentType = headers['content-type'];

                    var elementoLink = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        elementoLink.setAttribute('href', url);
                        elementoLink.setAttribute("download", nomeArquivo);

                        var eventoClick = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        elementoLink.dispatchEvent(eventoClick);

                        deferred.resolve(success);
                    } catch (ex) {
                        MdDialogService.alertPadrao(ex, null, null);

                        deferred.reject(ex);
                    }
                }, function (error) {
                    MdDialogService.alertPadrao(error.data, null, null);

                    deferred.reject(error);
                });
            return deferred.promise;
        }

        /**
        * Método genérico que realizar a leitura de um arquivo através da classe FileReader e retorna sua leitura em um objeto da seguinte forma
        * {
        *      bytes: bytes,
        *      base64StringArquivo: base64StringArquivo,
        *      nomeArquivo: arquivo.nome,
        *      tipoArquivo: arquivo.type
        * }
        * @param {file} arquivo 
        */
        function obterArquivo(arquivo) {
            if (!arquivo)
                throw new Error("É necessário informar um arquivo");
            var reader = new FileReader();

            return $q(function (resolve, reject) {
                reader.onerror = function () {
                    reader.abort();
                    reject(new Error("Erro ao converter arquivo"));
                }
                reader.onload = function () {
                    //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
                    var bytesArquivo = Array.from(new Uint8Array(this.result));

                    //if you want the base64encoded file you would use the below line:
                    var base64StringArquivo = btoa(bytesArquivo.map(function (item) { return String.fromCharCode(item) }).join(""));

                    //Resolve the promise with your custom file structure
                    resolve({
                        bytesArquivo: bytesArquivo,
                        base64StringArquivo: base64StringArquivo,
                        nomeArquivo: arquivo.name,
                        tipoArquivo: arquivo.type
                    });
                }
                reader.readAsArrayBuffer(arquivo);
            });
        }

        /**
         * Realiza o download de um arquivo a partir de um array de bytes recebido do backend.
         * @param {Uint8Array|Array} bytesArquivo Array de bytes do arquivo
         * @param {string} nomeArquivo Nome do arquivo para salvar
         * @param {string} tipoArquivo Tipo MIME do arquivo (ex: 'application/pdf', 'image/png')
         */
        this.baixarArquivoBytes = function (bytesArquivo, nomeArquivo, tipoArquivo) {
            let blob;
            if (typeof bytesArquivo === 'string') {
                const decodedString = atob(bytesArquivo);
                blob = new Blob([decodedString], { type: tipoArquivo });
            } else {
                blob = new Blob([new Uint8Array(bytesArquivo)], { type: tipoArquivo });
            }
            const url = window.URL.createObjectURL(blob);

            const elementoLink = document.createElement('a');
            elementoLink.setAttribute('href', url);
            elementoLink.setAttribute('download', nomeArquivo);

            document.body.appendChild(elementoLink);
            elementoLink.click();
            document.body.removeChild(elementoLink);

            window.URL.revokeObjectURL(url);
        };

    } // ArquivosService

})();

/**
 * Created by nova on 18/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.filtro',
        [

        ]
        );

})();

(function () {
    'use strict';

    angular
        .module('app.filtro')
        .filter('filtrarEstoria', filtrarEstoria);

    /** @ngInject */
    function filtrarEstoria(input) {
        console.log("awe");
        return undefined;
    }


})();
(function () {
    'use strict';

    angular
        .module('app.loginautomatico', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.loginautomatico', {
            url: '/loginautomatico',
            module: 'publico',
            params: { dados: null },
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'LoginAutomaticoController as vm'

                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.loginautomatico')
        .controller('LoginAutomaticoController', LoginAutomaticoController);

    /** @ngInject */
    function LoginAutomaticoController(
        LoginService,
        $stateParams
    ) {
        var loginAutomatico = true;

        LoginService.autenticarUsuario($stateParams.dados.login.toUpperCase(), btoa($stateParams.dados.login.toUpperCase()), loginAutomatico, $stateParams.dados.chave);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/login',
            module: 'publico',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            resolve: {
                DadosMarcaEspecial: function (Api, RequisicaoGenericaService) {
                    return RequisicaoGenericaService.listarSemParams(Api.parametros.marcaEspecial);
                },
            }
        });

        // Tradução
        $translatePartialLoaderProvider.addPart('app/main/login');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $rootScope,
        LoginService,
        ControleAcessoConfig,
        Api,
        RequisicaoGenericaService,
        SessionStorageService,
        DadosMarcaEspecial
    ) {
        var vm = this;
        vm.versao = ControleAcessoConfig.configuracao.versao;
        vm.release = ControleAcessoConfig.configuracao.release;
        vm.configuracao = ControleAcessoConfig.configuracao;
        SessionStorageService.armazenar("marcaEspecial", DadosMarcaEspecial.data);
        vm.marcaEspecial = DadosMarcaEspecial.data;

        vm.metodos = {
            autenticarUsuario: function () {
                var usuario = vm.form.usuario;
                var senha = vm.form.senha;
                LoginService.autenticarUsuario(usuario, senha);
            }
        }

        init();

        function init() {
            RequisicaoGenericaService.listarSemParams(Api.parametros.imagensPersonalizacao)
                .then(function (success) {
                    vm.configuracao.logomarcaAplicacao = success.data.logomarcaAplicacao;
                    vm.configuracao.imagemFundoAplicacao = success.data.imagemFundoAplicacao || 'assets/images/backgrounds/planoFundoDesk-1.png';
                });

            if (vm.marcaEspecial.utilizarMarcaEspecial) {
                vm.configuracao.logomarcaAplicacao = vm.marcaEspecial.imagemLogomarca;
                $rootScope.title = "..:: " + vm.marcaEspecial.nomeSolucaoMarcaEspecial + " ::.."
                vm.configuracao.aplicacao = vm.marcaEspecial.nomeSolucaoMarcaEspecial;
            }
            else {
                $rootScope.title = "..:: Reader Web® ::..";
                vm.configuracao.aplicacao = "Reader Web®"
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.inicio')
        .controller('InicioController', InicioController);

    function InicioController(ControleAcessoConfig, SessionStorageService, urlApi, LoginUsuarioService, KeysSessionStorage, RequisicaoGenericaService, Api, PesquisaSatisfacao, $stateParams, $mdDialog, VerificacaoDatamobil) {
        var vm = this;

        vm.configuracao = ControleAcessoConfig.configuracao;
        vm.exibirNotificacao = false;
        vm.marcaEspecial = SessionStorageService.recuperar("marcaEspecial");
        vm.nomeSolucao = (vm.marcaEspecial && vm.marcaEspecial.utilizarMarcaEspecial)
            ? vm.marcaEspecial.nomeSolucaoMarcaEspecial
            : "Reader Web®";

        vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
        vm.usuario = LoginUsuarioService.usuarioArmazenado();

        init();

        function init() {
            if ($stateParams.vemDoLogin && VerificacaoDatamobil) {
                if (!VerificacaoDatamobil.contratual && !VerificacaoDatamobil.dataUltimoAcessoGratuito) {
                    abrirDialogDatamobil();
                }
            }

            if (urlApi.exibir_pesquisa_satisfacao && vm.usuario.login && vm.usuario.login != "MASTER") {
                RequisicaoGenericaService.listarSemParams(Api.usuario.selecionarPorLogin + '?login=' + vm.usuario.login)
                    .then(function (success) {
                        PesquisaSatisfacao.abrirPesquisaSatisfacao(urlApi.url_imanager, vm.parametros.empresa.codigoImanager, 2, success.data);
                    });
            }
        }

        function abrirDialogDatamobil() {
            $mdDialog.show({
                controller: 'DialogDatamobilController',
                controllerAs: 'vm',
                templateUrl: 'app/main/inicio/components/dialog/dialog-datamobil.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.carga')
        .controller('GerenciamentoCargaController', GerenciamentoCargaController);

    function GerenciamentoCargaController(GerenciamentoCargaService, $interval, $scope, MdToastService,
        $mdSidenav, SessionStorageService, KeysSessionStorage,
        Regional) {
        var vm = this;
        var funcaoTimer = undefined;
        var funcaoTimerReconectar = undefined;
        init();

        $(document).ready(function () {
            $('#gerencimanto-carga').on('click', function (event) {
                if (!vm.cargasDisponibilizada) {
                    $mdSidenav('filtro-gerenciamento-carga').open();
                }
            });
            $('.sidenav').on('click', function (event) {
                event.stopPropagation();
            });
        });

        // Methods
        function init() {
            _definirListeners();

            vm.parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            var regionais = Regional.data;
            if (regionais.length > 0) {
                GerenciamentoCargaService.setRegionalId(regionais[0].codigo);
            }
            GerenciamentoCargaService.setDataReferencia(new Date());

            // if ($stateParams.dataFiltro) {
            //   GerenciamentoCargaService.setDataReferencia($stateParams.dataFiltro)
            // } else {
            //   GerenciamentoCargaService.setDataReferencia(new Date());
            // }

            vm.conexaoVerificada = false;
            vm.conexaoEstabelecida = false;
            vm.emProgresso = GerenciamentoCargaService.getProgresso();
            GerenciamentoCargaService.form = vm;
            _inicializarIntervalo();
            _conectarHub();
        }

        vm.metodos = {
            abrirFiltros: abrirFiltros
        }

        $scope.$on('$destroy', function () {
            $interval.cancel(funcaoTimer);
            clearInterval(funcaoTimer);
            funcaoTimer = undefined;

            $interval.cancel(funcaoTimerReconectar);
            clearInterval(funcaoTimerReconectar);
            funcaoTimerReconectar = undefined;

            _inicializarIntervalo();
        });

        function _conectarHub() {
            GerenciamentoCargaService.conectarHub().then(function (success) {
                vm.conexaoVerificada = true;
                vm.conexaoEstabelecida = true;
                MdToastService.toastInfo("Atualizando informações...");

                GerenciamentoCargaService.atualizar(GerenciamentoCargaService.getDataReferencia());
                _monitorar();

            }, function (error) {
                vm.conexaoVerificada = true;
                vm.conexaoEstabelecida = false;
                _reconectar();
            });
        }

        function _reconectar() {
            if (angular.isUndefined(funcaoTimerReconectar)) {
                funcaoTimerReconectar = $interval(function () {
                    if (!vm.conexaoEstabelecida) {
                        _conectarHub();
                    }
                }, 10000);
            }
        }

        function _monitorar() {
            if (angular.isUndefined(funcaoTimer)) {
                funcaoTimer = $interval(function () {
                    if (vm.tempoRestante == 0 && vm.conexaoEstabelecida) {
                        GerenciamentoCargaService.atualizar(GerenciamentoCargaService.getDataReferencia());
                        _inicializarIntervalo();
                    } else {
                        if (!vm.emProgresso){
                            vm.tempoRestante = vm.tempoRestante - 1;
                            if (vm.tempoRestante == 5) {
                                MdToastService.toastInfo("Atualizando informações...");
                            }
                        }
                    }
                }, 1000);
            }
        }

        function _inicializarIntervalo() {
            vm.tempoRestante = GerenciamentoCargaService.getIntervaloAtualizacao().valor;
        }

        function abrirFiltros() {
            $mdSidenav("filtro-gerenciamento-carga").toggle();
        }

        function _finalizarProgresso() {
            GerenciamentoCargaService.setProgresso(false);
        }

        function _definirListeners() {
            GerenciamentoCargaService.listenerProgressoControlerPrincipal = function (callback) {
                vm.emProgresso = callback();
            }

            GerenciamentoCargaService.listenerIntervalo = function (callback) {
                vm.tempoRestante = callback().valor;
            }

            GerenciamentoCargaService.listenerResultados = function (callback) {
                vm.cargasDisponibilizada = callback();
                _finalizarProgresso();               
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.datamobil')
        .controller('DatamobilController', DatamobilController);

    function DatamobilController($timeout, DatamobilIaService, msNavigationService, $mdSidenav, $interval, SessionStorageService, KeysSessionStorage, $mdDialog, MdDialogService, ConfiguracaoCliente, $rootScope, $scope) {
        var vm = this;
        var animacaoDotsInterval = null;
        var contadorTrialInterval = null;
        vm.sidenavAberta = false;
        vm.emProgresso = false;
        vm.conversaIniciada = false;
        vm.mensagens = [];
        vm.historicoComandos = SessionStorageService.recuperar(KeysSessionStorage.historicoComandosDatamobil) || [];
        vm.historicoIndex = null;
        vm.configuracaoCliente = null;
        vm.tempoRestante = null;
        vm.exibirContador = false;
        vm.corContador = '';
        vm.carregandoTrial = false;

        vm.metodos = {
            abrirFecharSidenav: abrirFecharSidenav,
            enviarMensagem: enviarMensagem,
            pressionandoTecla: pressionandoTecla,
            enviarComandoFavorito: enviarComandoFavorito
        };

        $timeout(function () {
            if (!msNavigationService.getFolded()) {
                msNavigationService.toggleFolded();
            }
            $mdSidenav('filtro').open();
        }, 50);

        init();

        function init() {
            if (ConfiguracaoCliente) {
                vm.configuracaoCliente = ConfiguracaoCliente;
                DatamobilIaService.configuracaoCliente = ConfiguracaoCliente;
                var validacao = DatamobilIaService.validarAcessoModulo();
                if (validacao.motivo === 'trial-ativo') {
                    vm.exibirContador = true;
                    if (!$rootScope.datamobilTrialAtivo) {
                        $rootScope.datamobilTrialAtivo = true;
                        iniciarContadorTrial();
                    } else {
                        sincronizarComRootScope();
                    }
                } else if (validacao.motivo === 'trial-expirado') {
                    vm.exibirContador = true;
                    vm.tempoRestante = DatamobilIaService.calcularDiasRestantes();
                    vm.corContador = 'vermelho';
                }
            }
        }

        function sincronizarComRootScope() {
            vm.tempoRestante = $rootScope.datamobilTempoRestante;
            vm.corContador = $rootScope.datamobilCorContador;

            $scope.$watch(function () {
                return $rootScope.datamobilTempoRestante;
            }, function (novoValor) {
                if (novoValor) {
                    vm.tempoRestante = novoValor;
                }
            }, true);

            $scope.$watch(function () {
                return $rootScope.datamobilCorContador;
            }, function (novoValor) {
                vm.corContador = novoValor;
            });
        }

        function iniciarContadorTrial() {
            atualizarContador();
            if (contadorTrialInterval) {
                $interval.cancel(contadorTrialInterval);
            }
            contadorTrialInterval = $interval(function () {
                atualizarContador();
            }, 1000);
        }

        function atualizarContador() {
            vm.tempoRestante = DatamobilIaService.calcularDiasRestantes();
            if (vm.tempoRestante && vm.tempoRestante.expirado) {
                vm.corContador = 'vermelho';
                $rootScope.datamobilTrialAtivo = false;
                $rootScope.datamobilCorContador = 'vermelho';
                if (contadorTrialInterval) {
                    $interval.cancel(contadorTrialInterval);
                }
            } else if (vm.tempoRestante) {
                $rootScope.datamobilTrialAtivo = true;
                $rootScope.datamobilTempoRestante = vm.tempoRestante;
                if (vm.tempoRestante.dias < 1) {
                    vm.corContador = 'vermelho';
                    $rootScope.datamobilCorContador = 'vermelho';
                } else if (vm.tempoRestante.dias <= 5) {
                    vm.corContador = 'amarelo';
                    $rootScope.datamobilCorContador = 'amarelo';
                } else {
                    vm.corContador = '';
                    $rootScope.datamobilCorContador = '';
                }
            }
        }

        vm.$onDestroy = function () {
            if (contadorTrialInterval) {
                $interval.cancel(contadorTrialInterval);
            }
        };

        function abrirFecharSidenav(sidenavId) {
            var sidenav = $mdSidenav(sidenavId);
            sidenav.toggle().then(function () {
                var el = document.getElementById('datamobil-ia');
                if (sidenav.isOpen()) {
                    el.classList.add('sidenav-aberta');
                } else {
                    el.classList.remove('sidenav-aberta');
                }
            });
            vm.sidenavAberta = !vm.sidenavAberta;
        }

        function enviarComandoFavorito(comando) {
            enviarMensagem(comando);
            if (vm.sidenavAberta) {
                abrirFecharSidenav('filtro');
            }
        }

        function iniciarAnimacaoDots() {
            pararAnimacaoDots();
            $timeout(function () {
                var dots = document.querySelectorAll('.loader .dot');
                if (!dots || dots.length === 0) return;
                var index = 0;
                for (var i = 0; i < dots.length; i++) {
                    dots[i].style.opacity = '0.2';
                }
                animacaoDotsInterval = $interval(function () {
                    for (var j = 0; j < dots.length; j++) {
                        dots[j].style.opacity = (j === index) ? '1' : '0.2';
                    }
                    index = (index + 1) % dots.length;
                }, 350);
            }, 0);
        }

        function pararAnimacaoDots() {
            if (animacaoDotsInterval) {
                $interval.cancel(animacaoDotsInterval);
                animacaoDotsInterval = null;
            }
            $timeout(function () {
                var dots = document.querySelectorAll('.loader .dot');
                for (var i = 0; i < dots.length; i++) {
                    dots[i].style.opacity = '1';
                }
            }, 0);
        }

        function enviarMensagem(mensagem) {
            if (!mensagem || vm.emProgresso || vm.carregandoTrial) return;

            var validacao = DatamobilIaService.validarAcessoModulo();

            if (validacao.motivo === 'trial-expirado') {
                mostrarDialogTrialExpirado();
                return;
            }

            if (validacao.motivo === 'trial-nao-iniciado') {
                mostrarDialogConfirmarTrial(mensagem);
                return;
            }

            if (!validacao.permitido) {
                mostrarDialogSemAcesso();
                return;
            }

            executarEnvioMensagem(mensagem);
        }

        function executarEnvioMensagem(mensagem) {
            vm.emProgresso = true;
            vm.conversaIniciada = true;
            vm.mensagens.push({ comando: mensagem, tipo: 'enviada' });
            if (!vm.historicoComandos.length || vm.historicoComandos[vm.historicoComandos.length - 1] !== mensagem) {
                vm.historicoComandos.push(mensagem);
                SessionStorageService.armazenar(KeysSessionStorage.historicoComandosDatamobil, vm.historicoComandos);
            }
            vm.historicoIndex = null;
            vm.comando = '';
            rolarParaFinal();
            iniciarAnimacaoDots();
            _realizarConsultarSQL(mensagem);
        }

        function mostrarDialogTrialExpirado() {
            MdDialogService.alertPadrao(
                'Aviso!',
                null,
                'Seu período trial chegou ao limite.<br>Para utilizar o módulo DATAMOBIL IA entre em contato com o suporte.'
            );
        }

        function mostrarDialogConfirmarTrial(mensagem) {
            MdDialogService.confirmPadraoComEvento(
                'Atenção!',
                'Identificamos que o módulo não está ativo, deseja utilizar gratuitamente por 21 dias?',
                null,
                function () {
                    vm.carregandoTrial = true;
                    DatamobilIaService.iniciarTrial().then(function (config) {
                        vm.configuracaoCliente = config;
                        vm.exibirContador = true;
                        $rootScope.datamobilTrialAtivo = true;
                        iniciarContadorTrial();
                        executarEnvioMensagem(mensagem);
                    }).catch(function () {
                        MdDialogService.alertPadrao(
                            'Erro',
                            null,
                            'Não foi possível ativar o trial. Tente novamente.'
                        );
                    }).finally(function () {
                        vm.carregandoTrial = false;
                    });
                }
            );
        }

        function mostrarDialogSemAcesso() {
            MdDialogService.alertPadrao(
                'Aviso',
                null,
                'Para utilizar o módulo DATAMOBIL IA entre em contato com o suporte.'
            );
        }

        function mostrarDialogErroServidor() {
            MdDialogService.alertPadrao(
                'Atenção!',
                null,
                'Não foi possível concluir sua solicitação no momento.<br><br>Tente novamente em alguns instantes.'
            );
        }

        function rolarParaFinal() {
            $timeout(function () {
                var elemento = document.querySelector('.mensagens');
                if (elemento) {
                    try {
                        elemento.scrollTo({ top: elemento.scrollHeight, behavior: 'smooth' });
                    } catch (e) {
                        elemento.scrollTop = elemento.scrollHeight;
                    }
                }
            }, 0);
        }

        function pressionandoTecla(event) {
            var codigoTeclaPressionada = event.keyCode;
            if (codigoTeclaPressionada === 13) {
                pressionandoEnter(event);
            } else if (codigoTeclaPressionada === 38) {
                pressionandoSetaParaCima(event);
            } else if (codigoTeclaPressionada === 40) {
                pressionandoSetaParaBaixo(event);
            }
        }

        function pressionandoEnter(event) {
            enviarMensagem(vm.comando);
            event.preventDefault();
        }

        function pressionandoSetaParaCima(event) {
            if (!vm.historicoComandos.length) return;
            if (vm.historicoIndex === null) {
                vm.historicoIndex = vm.historicoComandos.length - 1;
            } else if (vm.historicoIndex > 0) {
                vm.historicoIndex--;
            }
            vm.comando = vm.historicoComandos[vm.historicoIndex];
            event.preventDefault();
        }

        function pressionandoSetaParaBaixo(event) {
            if (!vm.historicoComandos.length || vm.historicoIndex === null) return;
            if (vm.historicoIndex < vm.historicoComandos.length - 1) {
                vm.historicoIndex++;
                vm.comando = vm.historicoComandos[vm.historicoIndex];
            } else {
                vm.historicoIndex = null;
                vm.comando = '';
            }
            event.preventDefault();
        }

        function _realizarConsultarSQL(comando) {
            DatamobilIaService.consultarIA(comando).then(function (response) {
                var resposta = response.data;
                var novaMensagem = { tipo: 'recebida', comando: comando };

                if (resposta && resposta.error) {
                    novaMensagem.texto = resposta.error.split(' [line')[0];
                    vm.mensagens.push(novaMensagem);
                } else if (resposta && resposta.Erro) {
                    novaMensagem.texto = resposta.Erro.replace('❌', '').trim();
                    vm.mensagens.push(novaMensagem);
                } else if (resposta && resposta.data && resposta.query) {
                    novaMensagem.data = resposta.data;
                    novaMensagem.query = resposta.query;
                    novaMensagem.usageGPT = resposta.usage_GPT;
                    novaMensagem.usageGptDiagnostico = resposta.usage_GPT_Diagnostico;
                    vm.mensagens.push(novaMensagem);
                }
                DatamobilIaService.salvarHistoricoComandos(novaMensagem);
            }).catch(function () {
                mostrarDialogErroServidor();
            }).finally(function () {
                vm.emProgresso = false;
                pararAnimacaoDots();
                rolarParaFinal();
            });
        }
    }
})();


(function () {
  'use strict';

  angular
    .module('app.chat')
    .controller('ChatController', ChatController);

  /** @ngInject */
  function ChatController($mdSidenav, $rootScope, $timeout, $document, $mdMedia, Regex, ChatHubService, ChatsService, Leituristas, MdToastService, User) {

    var vm = this;

    // Data
    init();

    //#region metodos
    vm.listarConversa = listarConversa;
    vm.dataEnvioDiferenteAtual = dataEnvioDiferenteAtual;
    vm.listarConversaAoSairDatePicker = listarConversaAoSairDatePicker;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleLeftSidenavView = toggleLeftSidenavView;
    vm.enviarMensagem = enviarMensagem;
    vm.desabilitarEnvioMensagem = desabilitarEnvioMensagem;
    vm.verificarSeExisteLeituristasComConversa = verificarSeExisteLeituristasComConversa;
    //#endregion

    $rootScope.$on('conectadoAoChat', function () {
      vm.semConexao = false;
      vm.enviandoMensagem = false;
      ChatsService.listarLeituristas().then(function (success) {
        _inserirLeituristas(success.data);
      });
    });

    $rootScope.$on('desconectadoDoChat', function () {
      vm.semConexao = true;
      vm.enviandoMensagem = false;
    })

    $rootScope.$on('novasMensagens', function (event, mensagem) {
      _aoReceberMensagem(mensagem);
    })

    $rootScope.$on('mensagemEnviada', function (event, mensagem) {
      _aoReceberConfirmacaoDeArmazenamentoNovaMensagem(mensagem);
    })

    $rootScope.$on('falhaAoEnviarMensagem', function (event, mensagem) {
      _falhaAoEnviarMensagem(mensagem);
    })

    function init() {
      vm.dataMaxima = new Date();
      vm.user = User.data;
      vm.leftSidenavView = false;
      vm.chat = undefined;
      _inserirLeituristas(Leituristas.data);
      vm.chat = undefined;
      vm.dataConversa = new Date().toLocaleDateString();
      vm.carregandoConversa = false;
    }

    function listarConversa(leituristaId) {
      vm.enviandoMensagem = false;

      var leiturista = _retornarLeiturista(leituristaId);

      if (leiturista.dataUltimaMensagem)
        vm.dataConversa = _prepararDataConversa(leiturista.dataUltimaMensagem);
      else
        vm.dataConversa = new Date().toLocaleDateString();

      _listarMensagensApi(leiturista);

      definirFocoNoTextAreaResponder();
    }

    function desabilitarEnvioMensagem() {
      return vm.carregandoConversa ||
        vm.enviandoMensagem ||
        vm.semConexao;
    }

    function verificarSeExisteLeituristasComConversa() {
      return vm.leituristas.filter(function (lei) {
        return lei.ultimaMensagem;
      }).length > 0;
    }

    function dataEnvioDiferenteAtual() {
      if (!vm.dataConversa)
        return false;

      var dataConversa = _prepararDataConversa(vm.dataConversa);

      return dataConversa != new Date().toLocaleDateString();
    }

    function listarConversaAoSairDatePicker() {
      if (!new RegExp(Regex.data).test(vm.dataConversa))
        vm.dataConversa = vm.dataConversa.toLocaleDateString();

      if (vm.leituristaSelecionadoId && vm.dataConversa)
        return _listarMensagensApi(_retornarLeiturista(vm.leituristaSelecionadoId));
    }

    function enviarMensagem($event) {
      if ($event && $event.keyCode === 13 && $event.shiftKey) {
        vm.textareaGrow = true;
        return;
      }

      if ($event && $event.keyCode !== 13) {
        return;
      }

      if (desabilitarEnvioMensagem())
        return;

      if (vm.mensagem === '') {
        limparTextAreaMensagem();
        return;
      }

      var mensagem = {
        chtMsgMensagem: vm.mensagem,
        leiCodigo: vm.leituristaSelecionadoId
      };

      vm.enviandoMensagem = true;

      ChatHubService.enviarMensagem(mensagem);

    }

    function limparTextAreaMensagem() {
      vm.mensagem = '';
      vm.textareaGrow = false;
    }

    function rolarParaFimDaConversa(doTopo) {
      $timeout(function () {
        var chatContent = angular.element($document.find('#chat-content'));

        if (doTopo)
          chatContent[0].scrollTop = 0;

        chatContent.animate({
          scrollTop: chatContent[0].scrollHeight - chatContent[0].offsetTop
        }, 400);
      }, 0);

    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function toggleLeftSidenavView(id) {
      vm.leftSidenavView = id;
    }

    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.codigo === value;
      })[0];
    };

    function definirFocoNoTextAreaResponder() {
      setTimeout(function () {
        var textArea = angular.element('#textAreaMensagem');
        textArea.focus();
      }, 0)
    }

    //#region metodos privados

    function _falhaAoEnviarMensagem(mensagem) {
      vm.enviandoMensagem = false;
      MdToastService.toastErro("Ocorreu um erro ao enviar a mensagem: ");
      console.error(mensagem);
    }

    function _aoReceberConfirmacaoDeArmazenamentoNovaMensagem(mensagem) {
      vm.enviandoMensagem = false;
      _adicionarMensagemNaLista(mensagem);
      limparTextAreaMensagem();
      definirFocoNoTextAreaResponder();
    }

    function _retornarLeiturista(leituristaId) {
      return vm.leituristas.getById(leituristaId);
    }

    function _listarMensagensApi(leiturista) {
      vm.carregandoConversa = true;
      //   vm.dataConversa = angular.copy(vm.dataConversa);

      ChatsService.listarMensagensCentral(leiturista.codigo, vm.dataConversa)
        .then(
          function (response) {

            if (!response.data)
              response.data = [];

            vm.leituristaSelecionadoId = leiturista.codigo;

            leiturista.quantidadeMensagensNaoLidas = 0;

            vm.chat = response.data;

            limparTextAreaMensagem();


            if (!$mdMedia('gt-md')) {
              $mdSidenav('left-sidenav').close();
            }

            vm.toggleLeftSidenavView(false);

            vm.carregandoConversa = false;

            rolarParaFimDaConversa(true);

            definirFocoNoTextAreaResponder();

          },
          function (error) {
            vm.carregandoConversa = false;
            vm.chat = undefined;
            MdToastService.toastErro("Ocorreu um erro ao listar a conversa");
            console.error(error);
          });
    }

    function _aoReceberMensagem(mensagem) {
      if (!vm.leituristaSelecionadoId || (vm.leituristaSelecionadoId != mensagem.leiCodigo))
        vm.leituristas.getById(mensagem.leiCodigo).quantidadeMensagensNaoLidas += 1;
      _adicionarMensagemNaLista(mensagem);
    }

    function _inserirLeituristas(leituristas) {
      vm.leituristas = leituristas;
    }

    function _prepararDataConversa(data) {
      if (new RegExp(Regex.data_hora).test(data))
        return angular.copy(data.split(" ")[0]);

      if (new RegExp(Regex.data).test(data))
        return data;

      return data.toLocaleDateString();
    }

    function _adicionarMensagemNaLista(mensagem) {

      var leiturista = _retornarLeiturista(mensagem.leiCodigo);

      leiturista.ultimaMensagem = mensagem.chtMsgMensagem;

      leiturista.dataUltimaMensagem = angular.copy(mensagem.chtMsgDataHora);// new Date(mensagem.chtMsgDataHora);

      if (vm.leituristaSelecionadoId != mensagem.leiCodigo)
        return;

      vm.chat.push(mensagem);

      rolarParaFimDaConversa();
    }

    //#endregion metodos privados
  }
})();

(function webpackUniversalModuleDefinition(root,factory){if(typeof exports==="object"&&typeof module==="object")module.exports=factory();else if(typeof define==="function"&&define.amd)define([],factory);else if(typeof exports==="object")exports["signalR"]=factory();else root["signalR"]=factory()})(window,function(){return function(modules){var installedModules={};function __webpack_require__(moduleId){if(installedModules[moduleId]){return installedModules[moduleId].exports}var module=installedModules[moduleId]={i:moduleId,l:false,exports:{}};modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);module.l=true;return module.exports}__webpack_require__.m=modules;__webpack_require__.c=installedModules;__webpack_require__.d=function(exports,name,getter){if(!__webpack_require__.o(exports,name)){Object.defineProperty(exports,name,{enumerable:true,get:getter})}};__webpack_require__.r=function(exports){if(typeof Symbol!=="undefined"&&Symbol.toStringTag){Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"})}Object.defineProperty(exports,"__esModule",{value:true})};__webpack_require__.t=function(value,mode){if(mode&1)value=__webpack_require__(value);if(mode&8)return value;if(mode&4&&typeof value==="object"&&value&&value.__esModule)return value;var ns=Object.create(null);__webpack_require__.r(ns);Object.defineProperty(ns,"default",{enumerable:true,value:value});if(mode&2&&typeof value!="string")for(var key in value)__webpack_require__.d(ns,key,function(key){return value[key]}.bind(null,key));return ns};__webpack_require__.n=function(module){var getter=module&&module.__esModule?function getDefault(){return module["default"]}:function getModuleExports(){return module};__webpack_require__.d(getter,"a",getter);return getter};__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)};__webpack_require__.p="";return __webpack_require__(__webpack_require__.s=0)}([function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);var es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(1);var es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0___default=__webpack_require__.n(es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0__);var _index__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(3);__webpack_require__.d(__webpack_exports__,"VERSION",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["VERSION"]});__webpack_require__.d(__webpack_exports__,"AbortError",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["AbortError"]});__webpack_require__.d(__webpack_exports__,"HttpError",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HttpError"]});__webpack_require__.d(__webpack_exports__,"TimeoutError",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]});__webpack_require__.d(__webpack_exports__,"HttpClient",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]});__webpack_require__.d(__webpack_exports__,"HttpResponse",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]});__webpack_require__.d(__webpack_exports__,"DefaultHttpClient",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["DefaultHttpClient"]});__webpack_require__.d(__webpack_exports__,"HubConnection",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnection"]});__webpack_require__.d(__webpack_exports__,"HubConnectionState",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnectionState"]});__webpack_require__.d(__webpack_exports__,"HubConnectionBuilder",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnectionBuilder"]});__webpack_require__.d(__webpack_exports__,"MessageType",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["MessageType"]});__webpack_require__.d(__webpack_exports__,"LogLevel",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["LogLevel"]});__webpack_require__.d(__webpack_exports__,"HttpTransportType",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["HttpTransportType"]});__webpack_require__.d(__webpack_exports__,"TransferFormat",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"]});__webpack_require__.d(__webpack_exports__,"NullLogger",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["NullLogger"]});__webpack_require__.d(__webpack_exports__,"JsonHubProtocol",function(){return _index__WEBPACK_IMPORTED_MODULE_1__["JsonHubProtocol"]});if(!Uint8Array.prototype.indexOf){Object.defineProperty(Uint8Array.prototype,"indexOf",{value:Array.prototype.indexOf,writable:true})}if(!Uint8Array.prototype.slice){Object.defineProperty(Uint8Array.prototype,"slice",{value:Array.prototype.slice,writable:true})}if(!Uint8Array.prototype.forEach){Object.defineProperty(Uint8Array.prototype,"forEach",{value:Array.prototype.forEach,writable:true})}},function(module,exports,__webpack_require__){(function(global){var require;
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */
(function(global,factory){true?module.exports=factory():undefined})(this,function(){"use strict";function objectOrFunction(x){var type=typeof x;return x!==null&&(type==="object"||type==="function")}function isFunction(x){return typeof x==="function"}var _isArray=void 0;if(Array.isArray){_isArray=Array.isArray}else{_isArray=function(x){return Object.prototype.toString.call(x)==="[object Array]"}}var isArray=_isArray;var len=0;var vertxNext=void 0;var customSchedulerFn=void 0;var asap=function asap(callback,arg){queue[len]=callback;queue[len+1]=arg;len+=2;if(len===2){if(customSchedulerFn){customSchedulerFn(flush)}else{scheduleFlush()}}};function setScheduler(scheduleFn){customSchedulerFn=scheduleFn}function setAsap(asapFn){asap=asapFn}var browserWindow=typeof window!=="undefined"?window:undefined;var browserGlobal=browserWindow||{};var BrowserMutationObserver=browserGlobal.MutationObserver||browserGlobal.WebKitMutationObserver;var isNode=typeof self==="undefined"&&typeof process!=="undefined"&&{}.toString.call(process)==="[object process]";var isWorker=typeof Uint8ClampedArray!=="undefined"&&typeof importScripts!=="undefined"&&typeof MessageChannel!=="undefined";function useNextTick(){return function(){return process.nextTick(flush)}}function useVertxTimer(){if(typeof vertxNext!=="undefined"){return function(){vertxNext(flush)}}return useSetTimeout()}function useMutationObserver(){var iterations=0;var observer=new BrowserMutationObserver(flush);var node=document.createTextNode("");observer.observe(node,{characterData:true});return function(){node.data=iterations=++iterations%2}}function useMessageChannel(){var channel=new MessageChannel;channel.port1.onmessage=flush;return function(){return channel.port2.postMessage(0)}}function useSetTimeout(){var globalSetTimeout=setTimeout;return function(){return globalSetTimeout(flush,1)}}var queue=new Array(1e3);function flush(){for(var i=0;i<len;i+=2){var callback=queue[i];var arg=queue[i+1];callback(arg);queue[i]=undefined;queue[i+1]=undefined}len=0}function attemptVertx(){try{var r=require;var vertx=__webpack_require__(!function webpackMissingModule(){var e=new Error("Cannot find module 'vertx'");e.code="MODULE_NOT_FOUND";throw e}());vertxNext=vertx.runOnLoop||vertx.runOnContext;return useVertxTimer()}catch(e){return useSetTimeout()}}var scheduleFlush=void 0;if(isNode){scheduleFlush=useNextTick()}else if(BrowserMutationObserver){scheduleFlush=useMutationObserver()}else if(isWorker){scheduleFlush=useMessageChannel()}else if(browserWindow===undefined&&"function"==="function"){scheduleFlush=attemptVertx()}else{scheduleFlush=useSetTimeout()}function then(onFulfillment,onRejection){var parent=this;var child=new this.constructor(noop);if(child[PROMISE_ID]===undefined){makePromise(child)}var _state=parent._state;if(_state){var callback=arguments[_state-1];asap(function(){return invokeCallback(_state,child,callback,parent._result)})}else{subscribe(parent,child,onFulfillment,onRejection)}return child}function resolve$1(object){var Constructor=this;if(object&&typeof object==="object"&&object.constructor===Constructor){return object}var promise=new Constructor(noop);resolve(promise,object);return promise}var PROMISE_ID=Math.random().toString(36).substring(16);function noop(){}var PENDING=void 0;var FULFILLED=1;var REJECTED=2;var GET_THEN_ERROR=new ErrorObject;function selfFulfillment(){return new TypeError("You cannot resolve a promise with itself")}function cannotReturnOwn(){return new TypeError("A promises callback cannot return that same promise.")}function getThen(promise){try{return promise.then}catch(error){GET_THEN_ERROR.error=error;return GET_THEN_ERROR}}function tryThen(then$$1,value,fulfillmentHandler,rejectionHandler){try{then$$1.call(value,fulfillmentHandler,rejectionHandler)}catch(e){return e}}function handleForeignThenable(promise,thenable,then$$1){asap(function(promise){var sealed=false;var error=tryThen(then$$1,thenable,function(value){if(sealed){return}sealed=true;if(thenable!==value){resolve(promise,value)}else{fulfill(promise,value)}},function(reason){if(sealed){return}sealed=true;reject(promise,reason)},"Settle: "+(promise._label||" unknown promise"));if(!sealed&&error){sealed=true;reject(promise,error)}},promise)}function handleOwnThenable(promise,thenable){if(thenable._state===FULFILLED){fulfill(promise,thenable._result)}else if(thenable._state===REJECTED){reject(promise,thenable._result)}else{subscribe(thenable,undefined,function(value){return resolve(promise,value)},function(reason){return reject(promise,reason)})}}function handleMaybeThenable(promise,maybeThenable,then$$1){if(maybeThenable.constructor===promise.constructor&&then$$1===then&&maybeThenable.constructor.resolve===resolve$1){handleOwnThenable(promise,maybeThenable)}else{if(then$$1===GET_THEN_ERROR){reject(promise,GET_THEN_ERROR.error);GET_THEN_ERROR.error=null}else if(then$$1===undefined){fulfill(promise,maybeThenable)}else if(isFunction(then$$1)){handleForeignThenable(promise,maybeThenable,then$$1)}else{fulfill(promise,maybeThenable)}}}function resolve(promise,value){if(promise===value){reject(promise,selfFulfillment())}else if(objectOrFunction(value)){handleMaybeThenable(promise,value,getThen(value))}else{fulfill(promise,value)}}function publishRejection(promise){if(promise._onerror){promise._onerror(promise._result)}publish(promise)}function fulfill(promise,value){if(promise._state!==PENDING){return}promise._result=value;promise._state=FULFILLED;if(promise._subscribers.length!==0){asap(publish,promise)}}function reject(promise,reason){if(promise._state!==PENDING){return}promise._state=REJECTED;promise._result=reason;asap(publishRejection,promise)}function subscribe(parent,child,onFulfillment,onRejection){var _subscribers=parent._subscribers;var length=_subscribers.length;parent._onerror=null;_subscribers[length]=child;_subscribers[length+FULFILLED]=onFulfillment;_subscribers[length+REJECTED]=onRejection;if(length===0&&parent._state){asap(publish,parent)}}function publish(promise){var subscribers=promise._subscribers;var settled=promise._state;if(subscribers.length===0){return}var child=void 0,callback=void 0,detail=promise._result;for(var i=0;i<subscribers.length;i+=3){child=subscribers[i];callback=subscribers[i+settled];if(child){invokeCallback(settled,child,callback,detail)}else{callback(detail)}}promise._subscribers.length=0}function ErrorObject(){this.error=null}var TRY_CATCH_ERROR=new ErrorObject;function tryCatch(callback,detail){try{return callback(detail)}catch(e){TRY_CATCH_ERROR.error=e;return TRY_CATCH_ERROR}}function invokeCallback(settled,promise,callback,detail){var hasCallback=isFunction(callback),value=void 0,error=void 0,succeeded=void 0,failed=void 0;if(hasCallback){value=tryCatch(callback,detail);if(value===TRY_CATCH_ERROR){failed=true;error=value.error;value.error=null}else{succeeded=true}if(promise===value){reject(promise,cannotReturnOwn());return}}else{value=detail;succeeded=true}if(promise._state!==PENDING){}else if(hasCallback&&succeeded){resolve(promise,value)}else if(failed){reject(promise,error)}else if(settled===FULFILLED){fulfill(promise,value)}else if(settled===REJECTED){reject(promise,value)}}function initializePromise(promise,resolver){try{resolver(function resolvePromise(value){resolve(promise,value)},function rejectPromise(reason){reject(promise,reason)})}catch(e){reject(promise,e)}}var id=0;function nextId(){return id++}function makePromise(promise){promise[PROMISE_ID]=id++;promise._state=undefined;promise._result=undefined;promise._subscribers=[]}function validationError(){return new Error("Array Methods must be provided an Array")}function validationError(){return new Error("Array Methods must be provided an Array")}var Enumerator=function(){function Enumerator(Constructor,input){this._instanceConstructor=Constructor;this.promise=new Constructor(noop);if(!this.promise[PROMISE_ID]){makePromise(this.promise)}if(isArray(input)){this.length=input.length;this._remaining=input.length;this._result=new Array(this.length);if(this.length===0){fulfill(this.promise,this._result)}else{this.length=this.length||0;this._enumerate(input);if(this._remaining===0){fulfill(this.promise,this._result)}}}else{reject(this.promise,validationError())}}Enumerator.prototype._enumerate=function _enumerate(input){for(var i=0;this._state===PENDING&&i<input.length;i++){this._eachEntry(input[i],i)}};Enumerator.prototype._eachEntry=function _eachEntry(entry,i){var c=this._instanceConstructor;var resolve$$1=c.resolve;if(resolve$$1===resolve$1){var _then=getThen(entry);if(_then===then&&entry._state!==PENDING){this._settledAt(entry._state,i,entry._result)}else if(typeof _then!=="function"){this._remaining--;this._result[i]=entry}else if(c===Promise$2){var promise=new c(noop);handleMaybeThenable(promise,entry,_then);this._willSettleAt(promise,i)}else{this._willSettleAt(new c(function(resolve$$1){return resolve$$1(entry)}),i)}}else{this._willSettleAt(resolve$$1(entry),i)}};Enumerator.prototype._settledAt=function _settledAt(state,i,value){var promise=this.promise;if(promise._state===PENDING){this._remaining--;if(state===REJECTED){reject(promise,value)}else{this._result[i]=value}}if(this._remaining===0){fulfill(promise,this._result)}};Enumerator.prototype._willSettleAt=function _willSettleAt(promise,i){var enumerator=this;subscribe(promise,undefined,function(value){return enumerator._settledAt(FULFILLED,i,value)},function(reason){return enumerator._settledAt(REJECTED,i,reason)})};return Enumerator}();function all(entries){return new Enumerator(this,entries).promise}function race(entries){var Constructor=this;if(!isArray(entries)){return new Constructor(function(_,reject){return reject(new TypeError("You must pass an array to race."))})}else{return new Constructor(function(resolve,reject){var length=entries.length;for(var i=0;i<length;i++){Constructor.resolve(entries[i]).then(resolve,reject)}})}}function reject$1(reason){var Constructor=this;var promise=new Constructor(noop);reject(promise,reason);return promise}function needsResolver(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function needsNew(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}var Promise$2=function(){function Promise(resolver){this[PROMISE_ID]=nextId();this._result=this._state=undefined;this._subscribers=[];if(noop!==resolver){typeof resolver!=="function"&&needsResolver();this instanceof Promise?initializePromise(this,resolver):needsNew()}}Promise.prototype.catch=function _catch(onRejection){return this.then(null,onRejection)};Promise.prototype.finally=function _finally(callback){var promise=this;var constructor=promise.constructor;return promise.then(function(value){return constructor.resolve(callback()).then(function(){return value})},function(reason){return constructor.resolve(callback()).then(function(){throw reason})})};return Promise}();Promise$2.prototype.then=then;Promise$2.all=all;Promise$2.race=race;Promise$2.resolve=resolve$1;Promise$2.reject=reject$1;Promise$2._setScheduler=setScheduler;Promise$2._setAsap=setAsap;Promise$2._asap=asap;function polyfill(){var local=void 0;if(typeof global!=="undefined"){local=global}else if(typeof self!=="undefined"){local=self}else{try{local=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}}var P=local.Promise;if(P){var promiseToString=null;try{promiseToString=Object.prototype.toString.call(P.resolve())}catch(e){}if(promiseToString==="[object Promise]"&&!P.cast){return}}local.Promise=Promise$2}Promise$2.polyfill=polyfill;Promise$2.Promise=Promise$2;Promise$2.polyfill();return Promise$2})}).call(this,__webpack_require__(2))},function(module,exports){var g;g=function(){return this}();try{g=g||Function("return this")()||(1,eval)("this")}catch(e){if(typeof window==="object")g=window}module.exports=g},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"VERSION",function(){return VERSION});var _Errors__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(4);__webpack_require__.d(__webpack_exports__,"AbortError",function(){return _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"]});__webpack_require__.d(__webpack_exports__,"HttpError",function(){return _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"]});__webpack_require__.d(__webpack_exports__,"TimeoutError",function(){return _Errors__WEBPACK_IMPORTED_MODULE_0__["TimeoutError"]});var _HttpClient__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(5);__webpack_require__.d(__webpack_exports__,"HttpClient",function(){return _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]});__webpack_require__.d(__webpack_exports__,"HttpResponse",function(){return _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]});var _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(6);__webpack_require__.d(__webpack_exports__,"DefaultHttpClient",function(){return _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_2__["DefaultHttpClient"]});var _HubConnection__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(9);__webpack_require__.d(__webpack_exports__,"HubConnection",function(){return _HubConnection__WEBPACK_IMPORTED_MODULE_3__["HubConnection"]});__webpack_require__.d(__webpack_exports__,"HubConnectionState",function(){return _HubConnection__WEBPACK_IMPORTED_MODULE_3__["HubConnectionState"]});var _HubConnectionBuilder__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(15);__webpack_require__.d(__webpack_exports__,"HubConnectionBuilder",function(){return _HubConnectionBuilder__WEBPACK_IMPORTED_MODULE_4__["HubConnectionBuilder"]});var _IHubProtocol__WEBPACK_IMPORTED_MODULE_5__=__webpack_require__(14);__webpack_require__.d(__webpack_exports__,"MessageType",function(){return _IHubProtocol__WEBPACK_IMPORTED_MODULE_5__["MessageType"]});var _ILogger__WEBPACK_IMPORTED_MODULE_6__=__webpack_require__(8);__webpack_require__.d(__webpack_exports__,"LogLevel",function(){return _ILogger__WEBPACK_IMPORTED_MODULE_6__["LogLevel"]});var _ITransport__WEBPACK_IMPORTED_MODULE_7__=__webpack_require__(17);__webpack_require__.d(__webpack_exports__,"HttpTransportType",function(){return _ITransport__WEBPACK_IMPORTED_MODULE_7__["HttpTransportType"]});__webpack_require__.d(__webpack_exports__,"TransferFormat",function(){return _ITransport__WEBPACK_IMPORTED_MODULE_7__["TransferFormat"]});var _Loggers__WEBPACK_IMPORTED_MODULE_8__=__webpack_require__(13);__webpack_require__.d(__webpack_exports__,"NullLogger",function(){return _Loggers__WEBPACK_IMPORTED_MODULE_8__["NullLogger"]});var _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_9__=__webpack_require__(22);__webpack_require__.d(__webpack_exports__,"JsonHubProtocol",function(){return _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_9__["JsonHubProtocol"]});var VERSION="1.1.2"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HttpError",function(){return HttpError});__webpack_require__.d(__webpack_exports__,"TimeoutError",function(){return TimeoutError});__webpack_require__.d(__webpack_exports__,"AbortError",function(){return AbortError});var __extends=undefined&&undefined.__extends||function(){var extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b}||function(d,b){for(var p in b)if(b.hasOwnProperty(p))d[p]=b[p]};return function(d,b){extendStatics(d,b);function __(){this.constructor=d}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __)}}();var HttpError=function(_super){__extends(HttpError,_super);function HttpError(errorMessage,statusCode){var _newTarget=this.constructor;var _this=this;var trueProto=_newTarget.prototype;_this=_super.call(this,errorMessage)||this;_this.statusCode=statusCode;_this.__proto__=trueProto;return _this}return HttpError}(Error);var TimeoutError=function(_super){__extends(TimeoutError,_super);function TimeoutError(errorMessage){var _newTarget=this.constructor;if(errorMessage===void 0){errorMessage="A timeout occurred."}var _this=this;var trueProto=_newTarget.prototype;_this=_super.call(this,errorMessage)||this;_this.__proto__=trueProto;return _this}return TimeoutError}(Error);var AbortError=function(_super){__extends(AbortError,_super);function AbortError(errorMessage){var _newTarget=this.constructor;if(errorMessage===void 0){errorMessage="An abort occurred."}var _this=this;var trueProto=_newTarget.prototype;_this=_super.call(this,errorMessage)||this;_this.__proto__=trueProto;return _this}return AbortError}(Error)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HttpResponse",function(){return HttpResponse});__webpack_require__.d(__webpack_exports__,"HttpClient",function(){return HttpClient});var __assign=undefined&&undefined.__assign||Object.assign||function(t){for(var s,i=1,n=arguments.length;i<n;i++){s=arguments[i];for(var p in s)if(Object.prototype.hasOwnProperty.call(s,p))t[p]=s[p]}return t};var HttpResponse=function(){function HttpResponse(statusCode,statusText,content){this.statusCode=statusCode;this.statusText=statusText;this.content=content}return HttpResponse}();var HttpClient=function(){function HttpClient(){}HttpClient.prototype.get=function(url,options){return this.send(__assign({},options,{method:"GET",url:url}))};HttpClient.prototype.post=function(url,options){return this.send(__assign({},options,{method:"POST",url:url}))};HttpClient.prototype.delete=function(url,options){return this.send(__assign({},options,{method:"DELETE",url:url}))};HttpClient.prototype.getCookieString=function(url){return""};return HttpClient}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"DefaultHttpClient",function(){return DefaultHttpClient});var _Errors__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(4);var _HttpClient__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(5);var _XhrHttpClient__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(7);var __extends=undefined&&undefined.__extends||function(){var extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b}||function(d,b){for(var p in b)if(b.hasOwnProperty(p))d[p]=b[p]};return function(d,b){extendStatics(d,b);function __(){this.constructor=d}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __)}}();var nodeHttpClientModule;if(typeof XMLHttpRequest==="undefined"){var requireFunc=true?require:undefined;nodeHttpClientModule=requireFunc("./NodeHttpClient")}var DefaultHttpClient=function(_super){__extends(DefaultHttpClient,_super);function DefaultHttpClient(logger){var _this=_super.call(this)||this;if(typeof XMLHttpRequest!=="undefined"){_this.httpClient=new _XhrHttpClient__WEBPACK_IMPORTED_MODULE_2__["XhrHttpClient"](logger)}else if(typeof nodeHttpClientModule!=="undefined"){_this.httpClient=new nodeHttpClientModule.NodeHttpClient(logger)}else{throw new Error("No HttpClient could be created.")}return _this}DefaultHttpClient.prototype.send=function(request){if(request.abortSignal&&request.abortSignal.aborted){return Promise.reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"])}if(!request.method){return Promise.reject(new Error("No method defined."))}if(!request.url){return Promise.reject(new Error("No url defined."))}return this.httpClient.send(request)};DefaultHttpClient.prototype.getCookieString=function(url){return this.httpClient.getCookieString(url)};return DefaultHttpClient}(_HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"])},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"XhrHttpClient",function(){return XhrHttpClient});var _Errors__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(4);var _HttpClient__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(5);var _ILogger__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(8);var __extends=undefined&&undefined.__extends||function(){var extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b}||function(d,b){for(var p in b)if(b.hasOwnProperty(p))d[p]=b[p]};return function(d,b){extendStatics(d,b);function __(){this.constructor=d}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __)}}();var XhrHttpClient=function(_super){__extends(XhrHttpClient,_super);function XhrHttpClient(logger){var _this=_super.call(this)||this;_this.logger=logger;return _this}XhrHttpClient.prototype.send=function(request){var _this=this;if(request.abortSignal&&request.abortSignal.aborted){return Promise.reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"])}if(!request.method){return Promise.reject(new Error("No method defined."))}if(!request.url){return Promise.reject(new Error("No url defined."))}return new Promise(function(resolve,reject){var xhr=new XMLHttpRequest;xhr.open(request.method,request.url,true);xhr.withCredentials=true;xhr.setRequestHeader("X-Requested-With","XMLHttpRequest");xhr.setRequestHeader("Content-Type","text/plain;charset=UTF-8");var headers=request.headers;if(headers){Object.keys(headers).forEach(function(header){xhr.setRequestHeader(header,headers[header])})}if(request.responseType){xhr.responseType=request.responseType}if(request.abortSignal){request.abortSignal.onabort=function(){xhr.abort();reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"])}}if(request.timeout){xhr.timeout=request.timeout}xhr.onload=function(){if(request.abortSignal){request.abortSignal.onabort=null}if(xhr.status>=200&&xhr.status<300){resolve(new _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"](xhr.status,xhr.statusText,xhr.response||xhr.responseText))}else{reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"](xhr.statusText,xhr.status))}};xhr.onerror=function(){_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning,"Error from HTTP request. "+xhr.status+": "+xhr.statusText+".");reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"](xhr.statusText,xhr.status))};xhr.ontimeout=function(){_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning,"Timeout from HTTP request.");reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["TimeoutError"])};xhr.send(request.content||"")})};return XhrHttpClient}(_HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"])},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"LogLevel",function(){return LogLevel});var LogLevel;(function(LogLevel){LogLevel[LogLevel["Trace"]=0]="Trace";LogLevel[LogLevel["Debug"]=1]="Debug";LogLevel[LogLevel["Information"]=2]="Information";LogLevel[LogLevel["Warning"]=3]="Warning";LogLevel[LogLevel["Error"]=4]="Error";LogLevel[LogLevel["Critical"]=5]="Critical";LogLevel[LogLevel["None"]=6]="None"})(LogLevel||(LogLevel={}))},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HubConnectionState",function(){return HubConnectionState});__webpack_require__.d(__webpack_exports__,"HubConnection",function(){return HubConnection});var _HandshakeProtocol__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(10);var _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(14);var _ILogger__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(8);var _Utils__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(12);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var DEFAULT_TIMEOUT_IN_MS=30*1e3;var DEFAULT_PING_INTERVAL_IN_MS=15*1e3;var HubConnectionState;(function(HubConnectionState){HubConnectionState[HubConnectionState["Disconnected"]=0]="Disconnected";HubConnectionState[HubConnectionState["Connected"]=1]="Connected"})(HubConnectionState||(HubConnectionState={}));var HubConnection=function(){function HubConnection(connection,logger,protocol){var _this=this;_Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(connection,"connection");_Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(logger,"logger");_Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(protocol,"protocol");this.serverTimeoutInMilliseconds=DEFAULT_TIMEOUT_IN_MS;this.keepAliveIntervalInMilliseconds=DEFAULT_PING_INTERVAL_IN_MS;this.logger=logger;this.protocol=protocol;this.connection=connection;this.handshakeProtocol=new _HandshakeProtocol__WEBPACK_IMPORTED_MODULE_0__["HandshakeProtocol"];this.connection.onreceive=function(data){return _this.processIncomingData(data)};this.connection.onclose=function(error){return _this.connectionClosed(error)};this.callbacks={};this.methods={};this.closedCallbacks=[];this.id=0;this.receivedHandshakeResponse=false;this.connectionState=HubConnectionState.Disconnected;this.cachedPingMessage=this.protocol.writeMessage({type:_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Ping})}HubConnection.create=function(connection,logger,protocol){return new HubConnection(connection,logger,protocol)};Object.defineProperty(HubConnection.prototype,"state",{get:function(){return this.connectionState},enumerable:true,configurable:true});HubConnection.prototype.start=function(){return __awaiter(this,void 0,void 0,function(){var handshakeRequest,handshakePromise;var _this=this;return __generator(this,function(_a){switch(_a.label){case 0:handshakeRequest={protocol:this.protocol.name,version:this.protocol.version};this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug,"Starting HubConnection.");this.receivedHandshakeResponse=false;handshakePromise=new Promise(function(resolve,reject){_this.handshakeResolver=resolve;_this.handshakeRejecter=reject});return[4,this.connection.start(this.protocol.transferFormat)];case 1:_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug,"Sending handshake request.");return[4,this.sendMessage(this.handshakeProtocol.writeHandshakeRequest(handshakeRequest))];case 2:_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information,"Using HubProtocol '"+this.protocol.name+"'.");this.cleanupTimeout();this.resetTimeoutPeriod();this.resetKeepAliveInterval();return[4,handshakePromise];case 3:_a.sent();this.connectionState=HubConnectionState.Connected;return[2]}})})};HubConnection.prototype.stop=function(){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug,"Stopping HubConnection.");this.cleanupTimeout();this.cleanupPingTimer();return this.connection.stop()};HubConnection.prototype.stream=function(methodName){var _this=this;var args=[];for(var _i=1;_i<arguments.length;_i++){args[_i-1]=arguments[_i]}var invocationDescriptor=this.createStreamInvocation(methodName,args);var subject=new _Utils__WEBPACK_IMPORTED_MODULE_3__["Subject"](function(){var cancelInvocation=_this.createCancelInvocation(invocationDescriptor.invocationId);var cancelMessage=_this.protocol.writeMessage(cancelInvocation);delete _this.callbacks[invocationDescriptor.invocationId];return _this.sendMessage(cancelMessage)});this.callbacks[invocationDescriptor.invocationId]=function(invocationEvent,error){if(error){subject.error(error);return}else if(invocationEvent){if(invocationEvent.type===_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion){if(invocationEvent.error){subject.error(new Error(invocationEvent.error))}else{subject.complete()}}else{subject.next(invocationEvent.item)}}};var message=this.protocol.writeMessage(invocationDescriptor);this.sendMessage(message).catch(function(e){subject.error(e);delete _this.callbacks[invocationDescriptor.invocationId]});return subject};HubConnection.prototype.sendMessage=function(message){this.resetKeepAliveInterval();return this.connection.send(message)};HubConnection.prototype.send=function(methodName){var args=[];for(var _i=1;_i<arguments.length;_i++){args[_i-1]=arguments[_i]}var invocationDescriptor=this.createInvocation(methodName,args,true);var message=this.protocol.writeMessage(invocationDescriptor);return this.sendMessage(message)};HubConnection.prototype.invoke=function(methodName){var _this=this;var args=[];for(var _i=1;_i<arguments.length;_i++){args[_i-1]=arguments[_i]}var invocationDescriptor=this.createInvocation(methodName,args,false);var p=new Promise(function(resolve,reject){_this.callbacks[invocationDescriptor.invocationId]=function(invocationEvent,error){if(error){reject(error);return}else if(invocationEvent){if(invocationEvent.type===_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion){if(invocationEvent.error){reject(new Error(invocationEvent.error))}else{resolve(invocationEvent.result)}}else{reject(new Error("Unexpected message type: "+invocationEvent.type))}}};var message=_this.protocol.writeMessage(invocationDescriptor);_this.sendMessage(message).catch(function(e){reject(e);delete _this.callbacks[invocationDescriptor.invocationId]})});return p};HubConnection.prototype.on=function(methodName,newMethod){if(!methodName||!newMethod){return}methodName=methodName.toLowerCase();if(!this.methods[methodName]){this.methods[methodName]=[]}if(this.methods[methodName].indexOf(newMethod)!==-1){return}this.methods[methodName].push(newMethod)};HubConnection.prototype.off=function(methodName,method){if(!methodName){return}methodName=methodName.toLowerCase();var handlers=this.methods[methodName];if(!handlers){return}if(method){var removeIdx=handlers.indexOf(method);if(removeIdx!==-1){handlers.splice(removeIdx,1);if(handlers.length===0){delete this.methods[methodName]}}}else{delete this.methods[methodName]}};HubConnection.prototype.onclose=function(callback){if(callback){this.closedCallbacks.push(callback)}};HubConnection.prototype.processIncomingData=function(data){this.cleanupTimeout();if(!this.receivedHandshakeResponse){data=this.processHandshakeResponse(data);this.receivedHandshakeResponse=true}if(data){var messages=this.protocol.parseMessages(data,this.logger);for(var _i=0,messages_1=messages;_i<messages_1.length;_i++){var message=messages_1[_i];switch(message.type){case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation:this.invokeClientMethod(message);break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].StreamItem:case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion:var callback=this.callbacks[message.invocationId];if(callback!=null){if(message.type===_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion){delete this.callbacks[message.invocationId]}callback(message)}break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Ping:break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Close:this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information,"Close message received from server.");this.connection.stop(message.error?new Error("Server returned an error on close: "+message.error):undefined);break;default:this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning,"Invalid message type: "+message.type+".");break}}}this.resetTimeoutPeriod()};HubConnection.prototype.processHandshakeResponse=function(data){var _a;var responseMessage;var remainingData;try{_a=this.handshakeProtocol.parseHandshakeResponse(data),remainingData=_a[0],responseMessage=_a[1]}catch(e){var message="Error parsing handshake response: "+e;this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error,message);var error=new Error(message);this.connection.stop(error);this.handshakeRejecter(error);throw error}if(responseMessage.error){var message="Server returned handshake error: "+responseMessage.error;this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error,message);this.handshakeRejecter(message);this.connection.stop(new Error(message));throw new Error(message)}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug,"Server handshake complete.")}this.handshakeResolver();return remainingData};HubConnection.prototype.resetKeepAliveInterval=function(){var _this=this;this.cleanupPingTimer();this.pingServerHandle=setTimeout(function(){return __awaiter(_this,void 0,void 0,function(){var _a;return __generator(this,function(_b){switch(_b.label){case 0:if(!(this.connectionState===HubConnectionState.Connected))return[3,4];_b.label=1;case 1:_b.trys.push([1,3,,4]);return[4,this.sendMessage(this.cachedPingMessage)];case 2:_b.sent();return[3,4];case 3:_a=_b.sent();this.cleanupPingTimer();return[3,4];case 4:return[2]}})})},this.keepAliveIntervalInMilliseconds)};HubConnection.prototype.resetTimeoutPeriod=function(){var _this=this;if(!this.connection.features||!this.connection.features.inherentKeepAlive){this.timeoutHandle=setTimeout(function(){return _this.serverTimeout()},this.serverTimeoutInMilliseconds)}};HubConnection.prototype.serverTimeout=function(){this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."))};HubConnection.prototype.invokeClientMethod=function(invocationMessage){var _this=this;var methods=this.methods[invocationMessage.target.toLowerCase()];if(methods){methods.forEach(function(m){return m.apply(_this,invocationMessage.arguments)});if(invocationMessage.invocationId){var message="Server requested a response, which is not supported in this version of the client.";this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error,message);this.connection.stop(new Error(message))}}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning,"No client method with the name '"+invocationMessage.target+"' found.")}};HubConnection.prototype.connectionClosed=function(error){var _this=this;var callbacks=this.callbacks;this.callbacks={};this.connectionState=HubConnectionState.Disconnected;if(this.handshakeRejecter){this.handshakeRejecter(error)}Object.keys(callbacks).forEach(function(key){var callback=callbacks[key];callback(null,error?error:new Error("Invocation canceled due to connection being closed."))});this.cleanupTimeout();this.cleanupPingTimer();this.closedCallbacks.forEach(function(c){return c.apply(_this,[error])})};HubConnection.prototype.cleanupPingTimer=function(){if(this.pingServerHandle){clearTimeout(this.pingServerHandle)}};HubConnection.prototype.cleanupTimeout=function(){if(this.timeoutHandle){clearTimeout(this.timeoutHandle)}};HubConnection.prototype.createInvocation=function(methodName,args,nonblocking){if(nonblocking){return{arguments:args,target:methodName,type:_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation}}else{var id=this.id;this.id++;return{arguments:args,invocationId:id.toString(),target:methodName,type:_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation}}};HubConnection.prototype.createStreamInvocation=function(methodName,args){var id=this.id;this.id++;return{arguments:args,invocationId:id.toString(),target:methodName,type:_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].StreamInvocation}};HubConnection.prototype.createCancelInvocation=function(id){return{invocationId:id,type:_IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].CancelInvocation}};return HubConnection}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HandshakeProtocol",function(){return HandshakeProtocol});var _TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(11);var _Utils__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(12);var HandshakeProtocol=function(){function HandshakeProtocol(){}HandshakeProtocol.prototype.writeHandshakeRequest=function(handshakeRequest){return _TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].write(JSON.stringify(handshakeRequest))};HandshakeProtocol.prototype.parseHandshakeResponse=function(data){var responseMessage;var messageData;var remainingData;if(Object(_Utils__WEBPACK_IMPORTED_MODULE_1__["isArrayBuffer"])(data)||typeof Buffer!=="undefined"&&data instanceof Buffer){var binaryData=new Uint8Array(data);var separatorIndex=binaryData.indexOf(_TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].RecordSeparatorCode);if(separatorIndex===-1){throw new Error("Message is incomplete.")}var responseLength=separatorIndex+1;messageData=String.fromCharCode.apply(null,binaryData.slice(0,responseLength));remainingData=binaryData.byteLength>responseLength?binaryData.slice(responseLength).buffer:null}else{var textData=data;var separatorIndex=textData.indexOf(_TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].RecordSeparator);if(separatorIndex===-1){throw new Error("Message is incomplete.")}var responseLength=separatorIndex+1;messageData=textData.substring(0,responseLength);remainingData=textData.length>responseLength?textData.substring(responseLength):null}var messages=_TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].parse(messageData);var response=JSON.parse(messages[0]);if(response.type){throw new Error("Expected a handshake response from the server.")}responseMessage=response;return[remainingData,responseMessage]};return HandshakeProtocol}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"TextMessageFormat",function(){return TextMessageFormat});var TextMessageFormat=function(){function TextMessageFormat(){}TextMessageFormat.write=function(output){return""+output+TextMessageFormat.RecordSeparator};TextMessageFormat.parse=function(input){if(input[input.length-1]!==TextMessageFormat.RecordSeparator){throw new Error("Message is incomplete.")}var messages=input.split(TextMessageFormat.RecordSeparator);messages.pop();return messages};TextMessageFormat.RecordSeparatorCode=30;TextMessageFormat.RecordSeparator=String.fromCharCode(TextMessageFormat.RecordSeparatorCode);return TextMessageFormat}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"Arg",function(){return Arg});__webpack_require__.d(__webpack_exports__,"getDataDetail",function(){return getDataDetail});__webpack_require__.d(__webpack_exports__,"formatArrayBuffer",function(){return formatArrayBuffer});__webpack_require__.d(__webpack_exports__,"isArrayBuffer",function(){return isArrayBuffer});__webpack_require__.d(__webpack_exports__,"sendMessage",function(){return sendMessage});__webpack_require__.d(__webpack_exports__,"createLogger",function(){return createLogger});__webpack_require__.d(__webpack_exports__,"Subject",function(){return Subject});__webpack_require__.d(__webpack_exports__,"SubjectSubscription",function(){return SubjectSubscription});__webpack_require__.d(__webpack_exports__,"ConsoleLogger",function(){return ConsoleLogger});var _ILogger__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(8);var _Loggers__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(13);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var Arg=function(){function Arg(){}Arg.isRequired=function(val,name){if(val===null||val===undefined){throw new Error("The '"+name+"' argument is required.")}};Arg.isIn=function(val,values,name){if(!(val in values)){throw new Error("Unknown "+name+" value: "+val+".")}};return Arg}();function getDataDetail(data,includeContent){var detail="";if(isArrayBuffer(data)){detail="Binary data of length "+data.byteLength;if(includeContent){detail+=". Content: '"+formatArrayBuffer(data)+"'"}}else if(typeof data==="string"){detail="String data of length "+data.length;if(includeContent){detail+=". Content: '"+data+"'"}}return detail}function formatArrayBuffer(data){var view=new Uint8Array(data);var str="";view.forEach(function(num){var pad=num<16?"0":"";str+="0x"+pad+num.toString(16)+" "});return str.substr(0,str.length-1)}function isArrayBuffer(val){return val&&typeof ArrayBuffer!=="undefined"&&(val instanceof ArrayBuffer||val.constructor&&val.constructor.name==="ArrayBuffer")}function sendMessage(logger,transportName,httpClient,url,accessTokenFactory,content,logMessageContent){return __awaiter(this,void 0,void 0,function(){var _a,headers,token,responseType,response;return __generator(this,function(_b){switch(_b.label){case 0:if(!accessTokenFactory)return[3,2];return[4,accessTokenFactory()];case 1:token=_b.sent();if(token){headers=(_a={},_a["Authorization"]="Bearer "+token,_a)}_b.label=2;case 2:logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"("+transportName+" transport) sending data. "+getDataDetail(content,logMessageContent)+".");responseType=isArrayBuffer(content)?"arraybuffer":"text";return[4,httpClient.post(url,{content:content,headers:headers,responseType:responseType})];case 3:response=_b.sent();logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"("+transportName+" transport) request complete. Response status: "+response.statusCode+".");return[2]}})})}function createLogger(logger){if(logger===undefined){return new ConsoleLogger(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information)}if(logger===null){return _Loggers__WEBPACK_IMPORTED_MODULE_1__["NullLogger"].instance}if(logger.log){return logger}return new ConsoleLogger(logger)}var Subject=function(){function Subject(cancelCallback){this.observers=[];this.cancelCallback=cancelCallback}Subject.prototype.next=function(item){for(var _i=0,_a=this.observers;_i<_a.length;_i++){var observer=_a[_i];observer.next(item)}};Subject.prototype.error=function(err){for(var _i=0,_a=this.observers;_i<_a.length;_i++){var observer=_a[_i];if(observer.error){observer.error(err)}}};Subject.prototype.complete=function(){for(var _i=0,_a=this.observers;_i<_a.length;_i++){var observer=_a[_i];if(observer.complete){observer.complete()}}};Subject.prototype.subscribe=function(observer){this.observers.push(observer);return new SubjectSubscription(this,observer)};return Subject}();var SubjectSubscription=function(){function SubjectSubscription(subject,observer){this.subject=subject;this.observer=observer}SubjectSubscription.prototype.dispose=function(){var index=this.subject.observers.indexOf(this.observer);if(index>-1){this.subject.observers.splice(index,1)}if(this.subject.observers.length===0){this.subject.cancelCallback().catch(function(_){})}};return SubjectSubscription}();var ConsoleLogger=function(){function ConsoleLogger(minimumLogLevel){this.minimumLogLevel=minimumLogLevel}ConsoleLogger.prototype.log=function(logLevel,message){if(logLevel>=this.minimumLogLevel){switch(logLevel){case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Critical:case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Error:console.error("["+(new Date).toISOString()+"] "+_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel]+": "+message);break;case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Warning:console.warn("["+(new Date).toISOString()+"] "+_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel]+": "+message);break;case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information:console.info("["+(new Date).toISOString()+"] "+_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel]+": "+message);break;default:console.log("["+(new Date).toISOString()+"] "+_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel]+": "+message);break}}};return ConsoleLogger}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"NullLogger",function(){return NullLogger});var NullLogger=function(){function NullLogger(){}NullLogger.prototype.log=function(_logLevel,_message){};NullLogger.instance=new NullLogger;return NullLogger}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"MessageType",function(){return MessageType});var MessageType;(function(MessageType){MessageType[MessageType["Invocation"]=1]="Invocation";MessageType[MessageType["StreamItem"]=2]="StreamItem";MessageType[MessageType["Completion"]=3]="Completion";MessageType[MessageType["StreamInvocation"]=4]="StreamInvocation";MessageType[MessageType["CancelInvocation"]=5]="CancelInvocation";MessageType[MessageType["Ping"]=6]="Ping";MessageType[MessageType["Close"]=7]="Close"})(MessageType||(MessageType={}))},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HubConnectionBuilder",function(){return HubConnectionBuilder});var _HttpConnection__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(16);var _HubConnection__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(9);var _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(22);var _Loggers__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(13);var _Utils__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(12);var HubConnectionBuilder=function(){function HubConnectionBuilder(){}HubConnectionBuilder.prototype.configureLogging=function(logging){_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(logging,"logging");if(isLogger(logging)){this.logger=logging}else{this.logger=new _Utils__WEBPACK_IMPORTED_MODULE_4__["ConsoleLogger"](logging)}return this};HubConnectionBuilder.prototype.withUrl=function(url,transportTypeOrOptions){_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(url,"url");this.url=url;if(typeof transportTypeOrOptions==="object"){this.httpConnectionOptions=transportTypeOrOptions}else{this.httpConnectionOptions={transport:transportTypeOrOptions}}return this};HubConnectionBuilder.prototype.withHubProtocol=function(protocol){_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(protocol,"protocol");this.protocol=protocol;return this};HubConnectionBuilder.prototype.build=function(){var httpConnectionOptions=this.httpConnectionOptions||{};if(httpConnectionOptions.logger===undefined){httpConnectionOptions.logger=this.logger}if(!this.url){throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.")}var connection=new _HttpConnection__WEBPACK_IMPORTED_MODULE_0__["HttpConnection"](this.url,httpConnectionOptions);return _HubConnection__WEBPACK_IMPORTED_MODULE_1__["HubConnection"].create(connection,this.logger||_Loggers__WEBPACK_IMPORTED_MODULE_3__["NullLogger"].instance,this.protocol||new _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_2__["JsonHubProtocol"])};return HubConnectionBuilder}();function isLogger(logger){return logger.log!==undefined}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HttpConnection",function(){return HttpConnection});var _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(6);var _ILogger__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(8);var _ITransport__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(17);var _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(18);var _ServerSentEventsTransport__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(20);var _Utils__WEBPACK_IMPORTED_MODULE_5__=__webpack_require__(12);var _WebSocketTransport__WEBPACK_IMPORTED_MODULE_6__=__webpack_require__(21);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var MAX_REDIRECTS=100;var WebSocketModule=null;var EventSourceModule=null;if(typeof window==="undefined"&&"function"!=="undefined"){var requireFunc=true?require:undefined;WebSocketModule=requireFunc("ws");EventSourceModule=requireFunc("eventsource")}var HttpConnection=function(){function HttpConnection(url,options){if(options===void 0){options={}}this.features={};_Utils__WEBPACK_IMPORTED_MODULE_5__["Arg"].isRequired(url,"url");this.logger=Object(_Utils__WEBPACK_IMPORTED_MODULE_5__["createLogger"])(options.logger);this.baseUrl=this.resolveUrl(url);options=options||{};options.logMessageContent=options.logMessageContent||false;var isNode=typeof window==="undefined";if(!isNode&&typeof WebSocket!=="undefined"&&!options.WebSocket){options.WebSocket=WebSocket}else if(isNode&&!options.WebSocket){if(WebSocketModule){options.WebSocket=WebSocketModule}}if(!isNode&&typeof EventSource!=="undefined"&&!options.EventSource){options.EventSource=EventSource}else if(isNode&&!options.EventSource){if(typeof EventSourceModule!=="undefined"){options.EventSource=EventSourceModule}}this.httpClient=options.httpClient||new _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_0__["DefaultHttpClient"](this.logger);this.connectionState=2;this.options=options;this.onreceive=null;this.onclose=null}HttpConnection.prototype.start=function(transferFormat){transferFormat=transferFormat||_ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"].Binary;_Utils__WEBPACK_IMPORTED_MODULE_5__["Arg"].isIn(transferFormat,_ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"],"transferFormat");this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Starting connection with transfer format '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][transferFormat]+"'.");if(this.connectionState!==2){return Promise.reject(new Error("Cannot start a connection that is not in the 'Disconnected' state."))}this.connectionState=0;this.startPromise=this.startInternal(transferFormat);return this.startPromise};HttpConnection.prototype.send=function(data){if(this.connectionState!==1){throw new Error("Cannot send data if the connection is not in the 'Connected' State.")}return this.transport.send(data)};HttpConnection.prototype.stop=function(error){return __awaiter(this,void 0,void 0,function(){var e_1;return __generator(this,function(_a){switch(_a.label){case 0:this.connectionState=2;this.stopError=error;_a.label=1;case 1:_a.trys.push([1,3,,4]);return[4,this.startPromise];case 2:_a.sent();return[3,4];case 3:e_1=_a.sent();return[3,4];case 4:if(!this.transport)return[3,6];return[4,this.transport.stop()];case 5:_a.sent();this.transport=undefined;_a.label=6;case 6:return[2]}})})};HttpConnection.prototype.startInternal=function(transferFormat){return __awaiter(this,void 0,void 0,function(){var url,negotiateResponse,redirects,_loop_1,this_1,state_1,e_2;var _this=this;return __generator(this,function(_a){switch(_a.label){case 0:url=this.baseUrl;this.accessTokenFactory=this.options.accessTokenFactory;_a.label=1;case 1:_a.trys.push([1,12,,13]);if(!this.options.skipNegotiation)return[3,5];if(!(this.options.transport===_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets))return[3,3];this.transport=this.constructTransport(_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets);return[4,this.transport.connect(url,transferFormat)];case 2:_a.sent();return[3,4];case 3:throw Error("Negotiation can only be skipped when using the WebSocket transport directly.");case 4:return[3,11];case 5:negotiateResponse=null;redirects=0;_loop_1=function(){var accessToken_1;return __generator(this,function(_a){switch(_a.label){case 0:return[4,this_1.getNegotiationResponse(url)];case 1:negotiateResponse=_a.sent();if(this_1.connectionState===2){return[2,{value:void 0}]}if(negotiateResponse.error){throw Error(negotiateResponse.error)}if(negotiateResponse.ProtocolVersion){throw Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.")}if(negotiateResponse.url){url=negotiateResponse.url}if(negotiateResponse.accessToken){accessToken_1=negotiateResponse.accessToken;this_1.accessTokenFactory=function(){return accessToken_1}}redirects++;return[2]}})};this_1=this;_a.label=6;case 6:return[5,_loop_1()];case 7:state_1=_a.sent();if(typeof state_1==="object")return[2,state_1.value];_a.label=8;case 8:if(negotiateResponse.url&&redirects<MAX_REDIRECTS)return[3,6];_a.label=9;case 9:if(redirects===MAX_REDIRECTS&&negotiateResponse.url){throw Error("Negotiate redirection limit exceeded.")}return[4,this.createTransport(url,this.options.transport,negotiateResponse,transferFormat)];case 10:_a.sent();_a.label=11;case 11:if(this.transport instanceof _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__["LongPollingTransport"]){this.features.inherentKeepAlive=true}this.transport.onreceive=this.onreceive;this.transport.onclose=function(e){return _this.stopConnection(e)};this.changeState(0,1);return[3,13];case 12:e_2=_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error,"Failed to start the connection: "+e_2);this.connectionState=2;this.transport=undefined;throw e_2;case 13:return[2]}})})};HttpConnection.prototype.getNegotiationResponse=function(url){return __awaiter(this,void 0,void 0,function(){var _a,headers,token,negotiateUrl,response,e_3;return __generator(this,function(_b){switch(_b.label){case 0:if(!this.accessTokenFactory)return[3,2];return[4,this.accessTokenFactory()];case 1:token=_b.sent();if(token){headers=(_a={},_a["Authorization"]="Bearer "+token,_a)}_b.label=2;case 2:negotiateUrl=this.resolveNegotiateUrl(url);this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Sending negotiation request: "+negotiateUrl+".");_b.label=3;case 3:_b.trys.push([3,5,,6]);return[4,this.httpClient.post(negotiateUrl,{content:"",headers:headers})];case 4:response=_b.sent();if(response.statusCode!==200){throw Error("Unexpected status code returned from negotiate "+response.statusCode)}return[2,JSON.parse(response.content)];case 5:e_3=_b.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error,"Failed to complete negotiation with the server: "+e_3);throw e_3;case 6:return[2]}})})};HttpConnection.prototype.createConnectUrl=function(url,connectionId){if(!connectionId){return url}return url+(url.indexOf("?")===-1?"?":"&")+("id="+connectionId)};HttpConnection.prototype.createTransport=function(url,requestedTransport,negotiateResponse,requestedTransferFormat){return __awaiter(this,void 0,void 0,function(){var connectUrl,transports,_i,transports_1,endpoint,transport,ex_1;return __generator(this,function(_a){switch(_a.label){case 0:connectUrl=this.createConnectUrl(url,negotiateResponse.connectionId);if(!this.isITransport(requestedTransport))return[3,2];this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Connection was provided an instance of ITransport, using that directly.");this.transport=requestedTransport;return[4,this.transport.connect(connectUrl,requestedTransferFormat)];case 1:_a.sent();this.changeState(0,1);return[2];case 2:transports=negotiateResponse.availableTransports||[];_i=0,transports_1=transports;_a.label=3;case 3:if(!(_i<transports_1.length))return[3,9];endpoint=transports_1[_i];this.connectionState=0;transport=this.resolveTransport(endpoint,requestedTransport,requestedTransferFormat);if(!(typeof transport==="number"))return[3,8];this.transport=this.constructTransport(transport);if(!!negotiateResponse.connectionId)return[3,5];return[4,this.getNegotiationResponse(url)];case 4:negotiateResponse=_a.sent();connectUrl=this.createConnectUrl(url,negotiateResponse.connectionId);_a.label=5;case 5:_a.trys.push([5,7,,8]);return[4,this.transport.connect(connectUrl,requestedTransferFormat)];case 6:_a.sent();this.changeState(0,1);return[2];case 7:ex_1=_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error,"Failed to start the transport '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport]+"': "+ex_1);this.connectionState=2;negotiateResponse.connectionId=undefined;return[3,8];case 8:_i++;return[3,3];case 9:throw new Error("Unable to initialize any of the available transports.")}})})};HttpConnection.prototype.constructTransport=function(transport){switch(transport){case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets:if(!this.options.WebSocket){throw new Error("'WebSocket' is not supported in your environment.")}return new _WebSocketTransport__WEBPACK_IMPORTED_MODULE_6__["WebSocketTransport"](this.httpClient,this.accessTokenFactory,this.logger,this.options.logMessageContent||false,this.options.WebSocket);case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].ServerSentEvents:if(!this.options.EventSource){throw new Error("'EventSource' is not supported in your environment.")}return new _ServerSentEventsTransport__WEBPACK_IMPORTED_MODULE_4__["ServerSentEventsTransport"](this.httpClient,this.accessTokenFactory,this.logger,this.options.logMessageContent||false,this.options.EventSource);case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].LongPolling:return new _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__["LongPollingTransport"](this.httpClient,this.accessTokenFactory,this.logger,this.options.logMessageContent||false);default:throw new Error("Unknown transport: "+transport+".")}};HttpConnection.prototype.resolveTransport=function(endpoint,requestedTransport,requestedTransferFormat){var transport=_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][endpoint.transport];if(transport===null||transport===undefined){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Skipping transport '"+endpoint.transport+"' because it is not supported by this client.")}else{var transferFormats=endpoint.transferFormats.map(function(s){return _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][s]});if(transportMatches(requestedTransport,transport)){if(transferFormats.indexOf(requestedTransferFormat)>=0){if(transport===_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets&&!this.options.WebSocket||transport===_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].ServerSentEvents&&!this.options.EventSource){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Skipping transport '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport]+"' because it is not supported in your environment.'")}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Selecting transport '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport]+"'.");return transport}}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Skipping transport '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport]+"' because it does not support the requested transfer format '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][requestedTransferFormat]+"'.")}}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug,"Skipping transport '"+_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport]+"' because it was disabled by the client.")}}return null};HttpConnection.prototype.isITransport=function(transport){return transport&&typeof transport==="object"&&"connect"in transport};HttpConnection.prototype.changeState=function(from,to){if(this.connectionState===from){this.connectionState=to;return true}return false};HttpConnection.prototype.stopConnection=function(error){this.transport=undefined;error=this.stopError||error;if(error){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error,"Connection disconnected with error '"+error+"'.")}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information,"Connection disconnected.")}this.connectionState=2;if(this.onclose){this.onclose(error)}};HttpConnection.prototype.resolveUrl=function(url){if(url.lastIndexOf("https://",0)===0||url.lastIndexOf("http://",0)===0){return url}if(typeof window==="undefined"||!window||!window.document){throw new Error("Cannot resolve '"+url+"'.")}var aTag=window.document.createElement("a");aTag.href=url;this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information,"Normalizing '"+url+"' to '"+aTag.href+"'.");return aTag.href};HttpConnection.prototype.resolveNegotiateUrl=function(url){var index=url.indexOf("?");var negotiateUrl=url.substring(0,index===-1?url.length:index);if(negotiateUrl[negotiateUrl.length-1]!=="/"){negotiateUrl+="/"}negotiateUrl+="negotiate";negotiateUrl+=index===-1?"":url.substring(index);return negotiateUrl};return HttpConnection}();function transportMatches(requestedTransport,actualTransport){return!requestedTransport||(actualTransport&requestedTransport)!==0}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"HttpTransportType",function(){return HttpTransportType});__webpack_require__.d(__webpack_exports__,"TransferFormat",function(){return TransferFormat});var HttpTransportType;(function(HttpTransportType){HttpTransportType[HttpTransportType["None"]=0]="None";HttpTransportType[HttpTransportType["WebSockets"]=1]="WebSockets";HttpTransportType[HttpTransportType["ServerSentEvents"]=2]="ServerSentEvents";HttpTransportType[HttpTransportType["LongPolling"]=4]="LongPolling"})(HttpTransportType||(HttpTransportType={}));var TransferFormat;(function(TransferFormat){TransferFormat[TransferFormat["Text"]=1]="Text";TransferFormat[TransferFormat["Binary"]=2]="Binary"})(TransferFormat||(TransferFormat={}))},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"LongPollingTransport",function(){return LongPollingTransport});var _AbortController__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(19);var _Errors__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(4);var _ILogger__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(8);var _ITransport__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(17);var _Utils__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(12);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var LongPollingTransport=function(){function LongPollingTransport(httpClient,accessTokenFactory,logger,logMessageContent){this.httpClient=httpClient;this.accessTokenFactory=accessTokenFactory;this.logger=logger;this.pollAbort=new _AbortController__WEBPACK_IMPORTED_MODULE_0__["AbortController"];this.logMessageContent=logMessageContent;this.running=false;this.onreceive=null;this.onclose=null}Object.defineProperty(LongPollingTransport.prototype,"pollAborted",{get:function(){return this.pollAbort.aborted},enumerable:true,configurable:true});LongPollingTransport.prototype.connect=function(url,transferFormat){return __awaiter(this,void 0,void 0,function(){var pollOptions,token,pollUrl,response;return __generator(this,function(_a){switch(_a.label){case 0:_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(url,"url");_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(transferFormat,"transferFormat");_Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isIn(transferFormat,_ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"],"transferFormat");this.url=url;this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Connecting.");if(transferFormat===_ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"].Binary&&(typeof XMLHttpRequest!=="undefined"&&typeof(new XMLHttpRequest).responseType!=="string")){throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.")}pollOptions={abortSignal:this.pollAbort.signal,headers:{},timeout:1e5};if(transferFormat===_ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"].Binary){pollOptions.responseType="arraybuffer"}return[4,this.getAccessToken()];case 1:token=_a.sent();this.updateHeaderToken(pollOptions,token);pollUrl=url+"&_="+Date.now();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) polling: "+pollUrl+".");return[4,this.httpClient.get(pollUrl,pollOptions)];case 2:response=_a.sent();if(response.statusCode!==200){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error,"(LongPolling transport) Unexpected response code: "+response.statusCode+".");this.closeError=new _Errors__WEBPACK_IMPORTED_MODULE_1__["HttpError"](response.statusText||"",response.statusCode);this.running=false}else{this.running=true}this.receiving=this.poll(this.url,pollOptions);return[2]}})})};LongPollingTransport.prototype.getAccessToken=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(_a){switch(_a.label){case 0:if(!this.accessTokenFactory)return[3,2];return[4,this.accessTokenFactory()];case 1:return[2,_a.sent()];case 2:return[2,null]}})})};LongPollingTransport.prototype.updateHeaderToken=function(request,token){if(!request.headers){request.headers={}}if(token){request.headers["Authorization"]="Bearer "+token;return}if(request.headers["Authorization"]){delete request.headers["Authorization"]}};LongPollingTransport.prototype.poll=function(url,pollOptions){return __awaiter(this,void 0,void 0,function(){var token,pollUrl,response,e_1;return __generator(this,function(_a){switch(_a.label){case 0:_a.trys.push([0,,8,9]);_a.label=1;case 1:if(!this.running)return[3,7];return[4,this.getAccessToken()];case 2:token=_a.sent();this.updateHeaderToken(pollOptions,token);_a.label=3;case 3:_a.trys.push([3,5,,6]);pollUrl=url+"&_="+Date.now();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) polling: "+pollUrl+".");return[4,this.httpClient.get(pollUrl,pollOptions)];case 4:response=_a.sent();if(response.statusCode===204){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information,"(LongPolling transport) Poll terminated by server.");this.running=false}else if(response.statusCode!==200){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error,"(LongPolling transport) Unexpected response code: "+response.statusCode+".");this.closeError=new _Errors__WEBPACK_IMPORTED_MODULE_1__["HttpError"](response.statusText||"",response.statusCode);this.running=false}else{if(response.content){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) data received. "+Object(_Utils__WEBPACK_IMPORTED_MODULE_4__["getDataDetail"])(response.content,this.logMessageContent)+".");if(this.onreceive){this.onreceive(response.content)}}else{this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Poll timed out, reissuing.")}}return[3,6];case 5:e_1=_a.sent();if(!this.running){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Poll errored after shutdown: "+e_1.message)}else{if(e_1 instanceof _Errors__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Poll timed out, reissuing.")}else{this.closeError=e_1;this.running=false}}return[3,6];case 6:return[3,1];case 7:return[3,9];case 8:this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Polling complete.");if(!this.pollAborted){this.raiseOnClose()}return[7];case 9:return[2]}})})};LongPollingTransport.prototype.send=function(data){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(_a){if(!this.running){return[2,Promise.reject(new Error("Cannot send until the transport is connected"))]}return[2,Object(_Utils__WEBPACK_IMPORTED_MODULE_4__["sendMessage"])(this.logger,"LongPolling",this.httpClient,this.url,this.accessTokenFactory,data,this.logMessageContent)]})})};LongPollingTransport.prototype.stop=function(){return __awaiter(this,void 0,void 0,function(){var deleteOptions,token;return __generator(this,function(_a){switch(_a.label){case 0:this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Stopping polling.");this.running=false;this.pollAbort.abort();_a.label=1;case 1:_a.trys.push([1,,5,6]);return[4,this.receiving];case 2:_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) sending DELETE request to "+this.url+".");deleteOptions={headers:{}};return[4,this.getAccessToken()];case 3:token=_a.sent();this.updateHeaderToken(deleteOptions,token);return[4,this.httpClient.delete(this.url,deleteOptions)];case 4:_a.sent();this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) DELETE request sent.");return[3,6];case 5:this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,"(LongPolling transport) Stop finished.");this.raiseOnClose();return[7];case 6:return[2]}})})};LongPollingTransport.prototype.raiseOnClose=function(){if(this.onclose){var logMessage="(LongPolling transport) Firing onclose event.";if(this.closeError){logMessage+=" Error: "+this.closeError}this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace,logMessage);this.onclose(this.closeError)}};return LongPollingTransport}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"AbortController",function(){return AbortController});var AbortController=function(){function AbortController(){this.isAborted=false;this.onabort=null}AbortController.prototype.abort=function(){if(!this.isAborted){this.isAborted=true;if(this.onabort){this.onabort()}}};Object.defineProperty(AbortController.prototype,"signal",{get:function(){return this},enumerable:true,configurable:true});Object.defineProperty(AbortController.prototype,"aborted",{get:function(){return this.isAborted},enumerable:true,configurable:true});return AbortController}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"ServerSentEventsTransport",function(){return ServerSentEventsTransport});var _ILogger__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(8);var _ITransport__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(17);var _Utils__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(12);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var ServerSentEventsTransport=function(){function ServerSentEventsTransport(httpClient,accessTokenFactory,logger,logMessageContent,eventSourceConstructor){this.httpClient=httpClient;this.accessTokenFactory=accessTokenFactory;this.logger=logger;this.logMessageContent=logMessageContent;this.eventSourceConstructor=eventSourceConstructor;this.onreceive=null;this.onclose=null}ServerSentEventsTransport.prototype.connect=function(url,transferFormat){return __awaiter(this,void 0,void 0,function(){var token;var _this=this;return __generator(this,function(_a){switch(_a.label){case 0:_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(url,"url");_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(transferFormat,"transferFormat");_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isIn(transferFormat,_ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"],"transferFormat");this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(SSE transport) Connecting.");this.url=url;if(!this.accessTokenFactory)return[3,2];return[4,this.accessTokenFactory()];case 1:token=_a.sent();if(token){url+=(url.indexOf("?")<0?"?":"&")+("access_token="+encodeURIComponent(token))}_a.label=2;case 2:return[2,new Promise(function(resolve,reject){var opened=false;if(transferFormat!==_ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"].Text){reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));return}var eventSource;if(typeof window!=="undefined"){eventSource=new _this.eventSourceConstructor(url,{withCredentials:true})}else{var cookies=_this.httpClient.getCookieString(url);eventSource=new _this.eventSourceConstructor(url,{withCredentials:true,headers:{Cookie:cookies}})}try{eventSource.onmessage=function(e){if(_this.onreceive){try{_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(SSE transport) data received. "+Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(e.data,_this.logMessageContent)+".");_this.onreceive(e.data)}catch(error){_this.close(error);return}}};eventSource.onerror=function(e){var error=new Error(e.data||"Error occurred");if(opened){_this.close(error)}else{reject(error)}};eventSource.onopen=function(){_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information,"SSE connected to "+_this.url);_this.eventSource=eventSource;opened=true;resolve()}}catch(e){reject(e);return}})]}})})};ServerSentEventsTransport.prototype.send=function(data){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(_a){if(!this.eventSource){return[2,Promise.reject(new Error("Cannot send until the transport is connected"))]}return[2,Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["sendMessage"])(this.logger,"SSE",this.httpClient,this.url,this.accessTokenFactory,data,this.logMessageContent)]})})};ServerSentEventsTransport.prototype.stop=function(){this.close();return Promise.resolve()};ServerSentEventsTransport.prototype.close=function(e){if(this.eventSource){this.eventSource.close();this.eventSource=undefined;if(this.onclose){this.onclose(e)}}};return ServerSentEventsTransport}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"WebSocketTransport",function(){return WebSocketTransport});var _ILogger__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(8);var _ITransport__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(17);var _Utils__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(12);var __awaiter=undefined&&undefined.__awaiter||function(thisArg,_arguments,P,generator){return new(P||(P=Promise))(function(resolve,reject){function fulfilled(value){try{step(generator.next(value))}catch(e){reject(e)}}function rejected(value){try{step(generator["throw"](value))}catch(e){reject(e)}}function step(result){result.done?resolve(result.value):new P(function(resolve){resolve(result.value)}).then(fulfilled,rejected)}step((generator=generator.apply(thisArg,_arguments||[])).next())})};var __generator=undefined&&undefined.__generator||function(thisArg,body){var _={label:0,sent:function(){if(t[0]&1)throw t[1];return t[1]},trys:[],ops:[]},f,y,t,g;return g={next:verb(0),throw:verb(1),return:verb(2)},typeof Symbol==="function"&&(g[Symbol.iterator]=function(){return this}),g;function verb(n){return function(v){return step([n,v])}}function step(op){if(f)throw new TypeError("Generator is already executing.");while(_)try{if(f=1,y&&(t=op[0]&2?y["return"]:op[0]?y["throw"]||((t=y["return"])&&t.call(y),0):y.next)&&!(t=t.call(y,op[1])).done)return t;if(y=0,t)op=[op[0]&2,t.value];switch(op[0]){case 0:case 1:t=op;break;case 4:_.label++;return{value:op[1],done:false};case 5:_.label++;y=op[1];op=[0];continue;case 7:op=_.ops.pop();_.trys.pop();continue;default:if(!(t=_.trys,t=t.length>0&&t[t.length-1])&&(op[0]===6||op[0]===2)){_=0;continue}if(op[0]===3&&(!t||op[1]>t[0]&&op[1]<t[3])){_.label=op[1];break}if(op[0]===6&&_.label<t[1]){_.label=t[1];t=op;break}if(t&&_.label<t[2]){_.label=t[2];_.ops.push(op);break}if(t[2])_.ops.pop();_.trys.pop();continue}op=body.call(thisArg,_)}catch(e){op=[6,e];y=0}finally{f=t=0}if(op[0]&5)throw op[1];return{value:op[0]?op[1]:void 0,done:true}}};var WebSocketTransport=function(){function WebSocketTransport(httpClient,accessTokenFactory,logger,logMessageContent,webSocketConstructor){this.logger=logger;this.accessTokenFactory=accessTokenFactory;this.logMessageContent=logMessageContent;this.webSocketConstructor=webSocketConstructor;this.httpClient=httpClient;this.onreceive=null;this.onclose=null}WebSocketTransport.prototype.connect=function(url,transferFormat){return __awaiter(this,void 0,void 0,function(){var token;var _this=this;return __generator(this,function(_a){switch(_a.label){case 0:_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(url,"url");_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(transferFormat,"transferFormat");_Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isIn(transferFormat,_ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"],"transferFormat");this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(WebSockets transport) Connecting.");if(!this.accessTokenFactory)return[3,2];return[4,this.accessTokenFactory()];case 1:token=_a.sent();if(token){url+=(url.indexOf("?")<0?"?":"&")+("access_token="+encodeURIComponent(token))}_a.label=2;case 2:return[2,new Promise(function(resolve,reject){url=url.replace(/^http/,"ws");var webSocket;var cookies=_this.httpClient.getCookieString(url);if(typeof window==="undefined"&&cookies){webSocket=new _this.webSocketConstructor(url,undefined,{headers:{Cookie:""+cookies}})}if(!webSocket){webSocket=new _this.webSocketConstructor(url)}if(transferFormat===_ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"].Binary){webSocket.binaryType="arraybuffer"}webSocket.onopen=function(_event){_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information,"WebSocket connected to "+url+".");_this.webSocket=webSocket;resolve()};webSocket.onerror=function(event){var error=null;if(typeof ErrorEvent!=="undefined"&&event instanceof ErrorEvent){error=event.error}reject(error)};webSocket.onmessage=function(message){_this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(WebSockets transport) data received. "+Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(message.data,_this.logMessageContent)+".");if(_this.onreceive){_this.onreceive(message.data)}};webSocket.onclose=function(event){return _this.close(event)}})]}})})};WebSocketTransport.prototype.send=function(data){if(this.webSocket&&this.webSocket.readyState===this.webSocketConstructor.OPEN){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(WebSockets transport) sending data. "+Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(data,this.logMessageContent)+".");this.webSocket.send(data);return Promise.resolve()}return Promise.reject("WebSocket is not in the OPEN state")};WebSocketTransport.prototype.stop=function(){if(this.webSocket){this.webSocket.onclose=function(){};this.webSocket.onmessage=function(){};this.webSocket.onerror=function(){};this.webSocket.close();this.webSocket=undefined;this.close(undefined)}return Promise.resolve()};WebSocketTransport.prototype.close=function(event){this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace,"(WebSockets transport) socket closed.");if(this.onclose){if(event&&(event.wasClean===false||event.code!==1e3)){this.onclose(new Error("WebSocket closed with status code: "+event.code+" ("+event.reason+")."))}else{this.onclose()}}};return WebSocketTransport}()},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);__webpack_require__.d(__webpack_exports__,"JsonHubProtocol",function(){return JsonHubProtocol});var _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(14);var _ILogger__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(8);var _ITransport__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(17);var _Loggers__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(13);var _TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(11);var JSON_HUB_PROTOCOL_NAME="json";var JsonHubProtocol=function(){function JsonHubProtocol(){this.name=JSON_HUB_PROTOCOL_NAME;this.version=1;this.transferFormat=_ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"].Text}JsonHubProtocol.prototype.parseMessages=function(input,logger){if(typeof input!=="string"){throw new Error("Invalid input for JSON hub protocol. Expected a string.")}if(!input){return[]}if(logger===null){logger=_Loggers__WEBPACK_IMPORTED_MODULE_3__["NullLogger"].instance}var messages=_TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__["TextMessageFormat"].parse(input);var hubMessages=[];for(var _i=0,messages_1=messages;_i<messages_1.length;_i++){var message=messages_1[_i];var parsedMessage=JSON.parse(message);if(typeof parsedMessage.type!=="number"){throw new Error("Invalid payload.")}switch(parsedMessage.type){case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Invocation:this.isInvocationMessage(parsedMessage);break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].StreamItem:this.isStreamItemMessage(parsedMessage);break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Completion:this.isCompletionMessage(parsedMessage);break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Ping:break;case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Close:break;default:logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information,"Unknown message type '"+parsedMessage.type+"' ignored.");continue}hubMessages.push(parsedMessage)}return hubMessages};JsonHubProtocol.prototype.writeMessage=function(message){return _TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__["TextMessageFormat"].write(JSON.stringify(message))};JsonHubProtocol.prototype.isInvocationMessage=function(message){this.assertNotEmptyString(message.target,"Invalid payload for Invocation message.");if(message.invocationId!==undefined){this.assertNotEmptyString(message.invocationId,"Invalid payload for Invocation message.")}};JsonHubProtocol.prototype.isStreamItemMessage=function(message){this.assertNotEmptyString(message.invocationId,"Invalid payload for StreamItem message.");if(message.item===undefined){throw new Error("Invalid payload for StreamItem message.")}};JsonHubProtocol.prototype.isCompletionMessage=function(message){if(message.result&&message.error){throw new Error("Invalid payload for Completion message.")}if(!message.result&&message.error){this.assertNotEmptyString(message.error,"Invalid payload for Completion message.")}this.assertNotEmptyString(message.invocationId,"Invalid payload for Completion message.")};JsonHubProtocol.prototype.assertNotEmptyString=function(value,errorMessage){if(typeof value!=="string"||value===""){throw new Error(errorMessage)}};return JsonHubProtocol}()}])});
//# sourceMappingURL=signalr.min.js.map
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["signalR"] = factory();
	else
		root["signalR"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(es6_promise_dist_es6_promise_auto_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["VERSION"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbortError", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["AbortError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpError", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HttpError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultHttpClient", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["DefaultHttpClient"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnection", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnectionState", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnectionState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnectionBuilder", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HubConnectionBuilder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageType", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["MessageType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["LogLevel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpTransportType", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["HttpTransportType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransferFormat", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NullLogger", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["NullLogger"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonHubProtocol", function() { return _index__WEBPACK_IMPORTED_MODULE_1__["JsonHubProtocol"]; });

// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// This is where we add any polyfills we'll need for the browser. It is the entry module for browser-specific builds.

// Copy from Array.prototype into Uint8Array to polyfill on IE. It's OK because the implementations of indexOf and slice use properties
// that exist on Uint8Array with the same name, and JavaScript is magic.
// We make them 'writable' because the Buffer polyfill messes with it as well.
if (!Uint8Array.prototype.indexOf) {
    Object.defineProperty(Uint8Array.prototype, "indexOf", {
        value: Array.prototype.indexOf,
        writable: true,
    });
}
if (!Uint8Array.prototype.slice) {
    Object.defineProperty(Uint8Array.prototype, "slice", {
        value: Array.prototype.slice,
        writable: true,
    });
}
if (!Uint8Array.prototype.forEach) {
    Object.defineProperty(Uint8Array.prototype, "forEach", {
        value: Array.prototype.forEach,
        writable: true,
    });
}



/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module 'vertx'"); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$2) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$2 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$2.prototype.then = then;
Promise$2.all = all;
Promise$2.race = race;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

/*global self*/
function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill;
Promise$2.Promise = Promise$2;

Promise$2.polyfill();

return Promise$2;

})));



//# sourceMappingURL=es6-promise.auto.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony import */ var _Errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbortError", function() { return _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpError", function() { return _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return _Errors__WEBPACK_IMPORTED_MODULE_0__["TimeoutError"]; });

/* harmony import */ var _HttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function() { return _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]; });

/* harmony import */ var _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultHttpClient", function() { return _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_2__["DefaultHttpClient"]; });

/* harmony import */ var _HubConnection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnection", function() { return _HubConnection__WEBPACK_IMPORTED_MODULE_3__["HubConnection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnectionState", function() { return _HubConnection__WEBPACK_IMPORTED_MODULE_3__["HubConnectionState"]; });

/* harmony import */ var _HubConnectionBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HubConnectionBuilder", function() { return _HubConnectionBuilder__WEBPACK_IMPORTED_MODULE_4__["HubConnectionBuilder"]; });

/* harmony import */ var _IHubProtocol__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageType", function() { return _IHubProtocol__WEBPACK_IMPORTED_MODULE_5__["MessageType"]; });

/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return _ILogger__WEBPACK_IMPORTED_MODULE_6__["LogLevel"]; });

/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpTransportType", function() { return _ITransport__WEBPACK_IMPORTED_MODULE_7__["HttpTransportType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransferFormat", function() { return _ITransport__WEBPACK_IMPORTED_MODULE_7__["TransferFormat"]; });

/* harmony import */ var _Loggers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NullLogger", function() { return _Loggers__WEBPACK_IMPORTED_MODULE_8__["NullLogger"]; });

/* harmony import */ var _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonHubProtocol", function() { return _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_9__["JsonHubProtocol"]; });

// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
var VERSION = "1.1.2";












/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpError", function() { return HttpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return TimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbortError", function() { return AbortError; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/** Error thrown when an HTTP request fails. */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /** Constructs a new instance of {@link @aspnet/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */
    function HttpError(errorMessage, statusCode) {
        var _newTarget = this.constructor;
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        _this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return HttpError;
}(Error));

/** Error thrown when a timeout elapses. */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    /** Constructs a new instance of {@link @aspnet/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function TimeoutError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "A timeout occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return TimeoutError;
}(Error));

/** Error thrown when an action is aborted. */
var AbortError = /** @class */ (function (_super) {
    __extends(AbortError, _super);
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function AbortError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "An abort occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return AbortError;
}(Error));



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return HttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function() { return HttpClient; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/** Represents an HTTP response. */
var HttpResponse = /** @class */ (function () {
    function HttpResponse(statusCode, statusText, content) {
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
    return HttpResponse;
}());

/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.get = function (url, options) {
        return this.send(__assign({}, options, { method: "GET", url: url }));
    };
    HttpClient.prototype.post = function (url, options) {
        return this.send(__assign({}, options, { method: "POST", url: url }));
    };
    HttpClient.prototype.delete = function (url, options) {
        return this.send(__assign({}, options, { method: "DELETE", url: url }));
    };
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
    HttpClient.prototype.getCookieString = function (url) {
        return "";
    };
    return HttpClient;
}());



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultHttpClient", function() { return DefaultHttpClient; });
/* harmony import */ var _Errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _HttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _XhrHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var nodeHttpClientModule;
if (typeof XMLHttpRequest === "undefined") {
    // In order to ignore the dynamic require in webpack builds we need to do this magic
    // @ts-ignore: TS doesn't know about these names
    var requireFunc =  true ? require : undefined;
    nodeHttpClientModule = requireFunc("./NodeHttpClient");
}
/** Default implementation of {@link @aspnet/signalr.HttpClient}. */
var DefaultHttpClient = /** @class */ (function (_super) {
    __extends(DefaultHttpClient, _super);
    /** Creates a new instance of the {@link @aspnet/signalr.DefaultHttpClient}, using the provided {@link @aspnet/signalr.ILogger} to log messages. */
    function DefaultHttpClient(logger) {
        var _this = _super.call(this) || this;
        if (typeof XMLHttpRequest !== "undefined") {
            _this.httpClient = new _XhrHttpClient__WEBPACK_IMPORTED_MODULE_2__["XhrHttpClient"](logger);
        }
        else if (typeof nodeHttpClientModule !== "undefined") {
            _this.httpClient = new nodeHttpClientModule.NodeHttpClient(logger);
        }
        else {
            throw new Error("No HttpClient could be created.");
        }
        return _this;
    }
    /** @inheritDoc */
    DefaultHttpClient.prototype.send = function (request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return this.httpClient.send(request);
    };
    DefaultHttpClient.prototype.getCookieString = function (url) {
        return this.httpClient.getCookieString(url);
    };
    return DefaultHttpClient;
}(_HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]));



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrHttpClient", function() { return XhrHttpClient; });
/* harmony import */ var _Errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _HttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var XhrHttpClient = /** @class */ (function (_super) {
    __extends(XhrHttpClient, _super);
    function XhrHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        return _this;
    }
    /** @inheritDoc */
    XhrHttpClient.prototype.send = function (request) {
        var _this = this;
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            // Explicitly setting the Content-Type header for React Native on Android platform.
            xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            var headers = request.headers;
            if (headers) {
                Object.keys(headers)
                    .forEach(function (header) {
                    xhr.setRequestHeader(header, headers[header]);
                });
            }
            if (request.responseType) {
                xhr.responseType = request.responseType;
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = function () {
                    xhr.abort();
                    reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["AbortError"]());
                };
            }
            if (request.timeout) {
                xhr.timeout = request.timeout;
            }
            xhr.onload = function () {
                if (request.abortSignal) {
                    request.abortSignal.onabort = null;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new _HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"](xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                }
                else {
                    reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"](xhr.statusText, xhr.status));
                }
            };
            xhr.onerror = function () {
                _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning, "Error from HTTP request. " + xhr.status + ": " + xhr.statusText + ".");
                reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["HttpError"](xhr.statusText, xhr.status));
            };
            xhr.ontimeout = function () {
                _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning, "Timeout from HTTP request.");
                reject(new _Errors__WEBPACK_IMPORTED_MODULE_0__["TimeoutError"]());
            };
            xhr.send(request.content || "");
        });
    };
    return XhrHttpClient;
}(_HttpClient__WEBPACK_IMPORTED_MODULE_1__["HttpClient"]));



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */
var LogLevel;
(function (LogLevel) {
    /** Log level for very low severity diagnostic messages. */
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */
    LogLevel[LogLevel["None"] = 6] = "None";
})(LogLevel || (LogLevel = {}));


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HubConnectionState", function() { return HubConnectionState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HubConnection", function() { return HubConnection; });
/* harmony import */ var _HandshakeProtocol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
var DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
/** Describes the current state of the {@link HubConnection} to the server. */
var HubConnectionState;
(function (HubConnectionState) {
    /** The hub connection is disconnected. */
    HubConnectionState[HubConnectionState["Disconnected"] = 0] = "Disconnected";
    /** The hub connection is connected. */
    HubConnectionState[HubConnectionState["Connected"] = 1] = "Connected";
})(HubConnectionState || (HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */
var HubConnection = /** @class */ (function () {
    function HubConnection(connection, logger, protocol) {
        var _this = this;
        _Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(connection, "connection");
        _Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(logger, "logger");
        _Utils__WEBPACK_IMPORTED_MODULE_3__["Arg"].isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
        this.logger = logger;
        this.protocol = protocol;
        this.connection = connection;
        this.handshakeProtocol = new _HandshakeProtocol__WEBPACK_IMPORTED_MODULE_0__["HandshakeProtocol"]();
        this.connection.onreceive = function (data) { return _this.processIncomingData(data); };
        this.connection.onclose = function (error) { return _this.connectionClosed(error); };
        this.callbacks = {};
        this.methods = {};
        this.closedCallbacks = [];
        this.id = 0;
        this.receivedHandshakeResponse = false;
        this.connectionState = HubConnectionState.Disconnected;
        this.cachedPingMessage = this.protocol.writeMessage({ type: _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Ping });
    }
    /** @internal */
    // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    HubConnection.create = function (connection, logger, protocol) {
        return new HubConnection(connection, logger, protocol);
    };
    Object.defineProperty(HubConnection.prototype, "state", {
        /** Indicates the state of the {@link HubConnection} to the server. */
        get: function () {
            return this.connectionState;
        },
        enumerable: true,
        configurable: true
    });
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    HubConnection.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var handshakeRequest, handshakePromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handshakeRequest = {
                            protocol: this.protocol.name,
                            version: this.protocol.version,
                        };
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug, "Starting HubConnection.");
                        this.receivedHandshakeResponse = false;
                        handshakePromise = new Promise(function (resolve, reject) {
                            _this.handshakeResolver = resolve;
                            _this.handshakeRejecter = reject;
                        });
                        return [4 /*yield*/, this.connection.start(this.protocol.transferFormat)];
                    case 1:
                        _a.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug, "Sending handshake request.");
                        return [4 /*yield*/, this.sendMessage(this.handshakeProtocol.writeHandshakeRequest(handshakeRequest))];
                    case 2:
                        _a.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information, "Using HubProtocol '" + this.protocol.name + "'.");
                        // defensively cleanup timeout in case we receive a message from the server before we finish start
                        this.cleanupTimeout();
                        this.resetTimeoutPeriod();
                        this.resetKeepAliveInterval();
                        // Wait for the handshake to complete before marking connection as connected
                        return [4 /*yield*/, handshakePromise];
                    case 3:
                        // Wait for the handshake to complete before marking connection as connected
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */
    HubConnection.prototype.stop = function () {
        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug, "Stopping HubConnection.");
        this.cleanupTimeout();
        this.cleanupPingTimer();
        return this.connection.stop();
    };
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */
    HubConnection.prototype.stream = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var invocationDescriptor = this.createStreamInvocation(methodName, args);
        var subject = new _Utils__WEBPACK_IMPORTED_MODULE_3__["Subject"](function () {
            var cancelInvocation = _this.createCancelInvocation(invocationDescriptor.invocationId);
            var cancelMessage = _this.protocol.writeMessage(cancelInvocation);
            delete _this.callbacks[invocationDescriptor.invocationId];
            return _this.sendMessage(cancelMessage);
        });
        this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
            if (error) {
                subject.error(error);
                return;
            }
            else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion) {
                    if (invocationEvent.error) {
                        subject.error(new Error(invocationEvent.error));
                    }
                    else {
                        subject.complete();
                    }
                }
                else {
                    subject.next((invocationEvent.item));
                }
            }
        };
        var message = this.protocol.writeMessage(invocationDescriptor);
        this.sendMessage(message)
            .catch(function (e) {
            subject.error(e);
            delete _this.callbacks[invocationDescriptor.invocationId];
        });
        return subject;
    };
    HubConnection.prototype.sendMessage = function (message) {
        this.resetKeepAliveInterval();
        return this.connection.send(message);
    };
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */
    HubConnection.prototype.send = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var invocationDescriptor = this.createInvocation(methodName, args, true);
        var message = this.protocol.writeMessage(invocationDescriptor);
        return this.sendMessage(message);
    };
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */
    HubConnection.prototype.invoke = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var invocationDescriptor = this.createInvocation(methodName, args, false);
        var p = new Promise(function (resolve, reject) {
            // invocationId will always have a value for a non-blocking invocation
            _this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
                if (error) {
                    reject(error);
                    return;
                }
                else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion) {
                        if (invocationEvent.error) {
                            reject(new Error(invocationEvent.error));
                        }
                        else {
                            resolve(invocationEvent.result);
                        }
                    }
                    else {
                        reject(new Error("Unexpected message type: " + invocationEvent.type));
                    }
                }
            };
            var message = _this.protocol.writeMessage(invocationDescriptor);
            _this.sendMessage(message)
                .catch(function (e) {
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete _this.callbacks[invocationDescriptor.invocationId];
            });
        });
        return p;
    };
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
     *
     * @param {string} methodName The name of the hub method to define.
     * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
     */
    HubConnection.prototype.on = function (methodName, newMethod) {
        if (!methodName || !newMethod) {
            return;
        }
        methodName = methodName.toLowerCase();
        if (!this.methods[methodName]) {
            this.methods[methodName] = [];
        }
        // Preventing adding the same handler multiple times.
        if (this.methods[methodName].indexOf(newMethod) !== -1) {
            return;
        }
        this.methods[methodName].push(newMethod);
    };
    HubConnection.prototype.off = function (methodName, method) {
        if (!methodName) {
            return;
        }
        methodName = methodName.toLowerCase();
        var handlers = this.methods[methodName];
        if (!handlers) {
            return;
        }
        if (method) {
            var removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) {
                    delete this.methods[methodName];
                }
            }
        }
        else {
            delete this.methods[methodName];
        }
    };
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */
    HubConnection.prototype.onclose = function (callback) {
        if (callback) {
            this.closedCallbacks.push(callback);
        }
    };
    HubConnection.prototype.processIncomingData = function (data) {
        this.cleanupTimeout();
        if (!this.receivedHandshakeResponse) {
            data = this.processHandshakeResponse(data);
            this.receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            var messages = this.protocol.parseMessages(data, this.logger);
            for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                var message = messages_1[_i];
                switch (message.type) {
                    case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation:
                        this.invokeClientMethod(message);
                        break;
                    case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].StreamItem:
                    case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion:
                        var callback = this.callbacks[message.invocationId];
                        if (callback != null) {
                            if (message.type === _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Completion) {
                                delete this.callbacks[message.invocationId];
                            }
                            callback(message);
                        }
                        break;
                    case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Ping:
                        // Don't care about pings
                        break;
                    case _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Close:
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information, "Close message received from server.");
                        // We don't want to wait on the stop itself.
                        // tslint:disable-next-line:no-floating-promises
                        this.connection.stop(message.error ? new Error("Server returned an error on close: " + message.error) : undefined);
                        break;
                    default:
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning, "Invalid message type: " + message.type + ".");
                        break;
                }
            }
        }
        this.resetTimeoutPeriod();
    };
    HubConnection.prototype.processHandshakeResponse = function (data) {
        var _a;
        var responseMessage;
        var remainingData;
        try {
            _a = this.handshakeProtocol.parseHandshakeResponse(data), remainingData = _a[0], responseMessage = _a[1];
        }
        catch (e) {
            var message = "Error parsing handshake response: " + e;
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error, message);
            var error = new Error(message);
            // We don't want to wait on the stop itself.
            // tslint:disable-next-line:no-floating-promises
            this.connection.stop(error);
            this.handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            var message = "Server returned handshake error: " + responseMessage.error;
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error, message);
            this.handshakeRejecter(message);
            // We don't want to wait on the stop itself.
            // tslint:disable-next-line:no-floating-promises
            this.connection.stop(new Error(message));
            throw new Error(message);
        }
        else {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Debug, "Server handshake complete.");
        }
        this.handshakeResolver();
        return remainingData;
    };
    HubConnection.prototype.resetKeepAliveInterval = function () {
        var _this = this;
        this.cleanupPingTimer();
        this.pingServerHandle = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.connectionState === HubConnectionState.Connected)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendMessage(this.cachedPingMessage)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        // We don't care about the error. It should be seen elsewhere in the client.
                        // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                        this.cleanupPingTimer();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, this.keepAliveIntervalInMilliseconds);
    };
    HubConnection.prototype.resetTimeoutPeriod = function () {
        var _this = this;
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this.timeoutHandle = setTimeout(function () { return _this.serverTimeout(); }, this.serverTimeoutInMilliseconds);
        }
    };
    HubConnection.prototype.serverTimeout = function () {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise.
        // tslint:disable-next-line:no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    };
    HubConnection.prototype.invokeClientMethod = function (invocationMessage) {
        var _this = this;
        var methods = this.methods[invocationMessage.target.toLowerCase()];
        if (methods) {
            methods.forEach(function (m) { return m.apply(_this, invocationMessage.arguments); });
            if (invocationMessage.invocationId) {
                // This is not supported in v1. So we return an error to avoid blocking the server waiting for the response.
                var message = "Server requested a response, which is not supported in this version of the client.";
                this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error, message);
                // We don't need to wait on this Promise.
                // tslint:disable-next-line:no-floating-promises
                this.connection.stop(new Error(message));
            }
        }
        else {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Warning, "No client method with the name '" + invocationMessage.target + "' found.");
        }
    };
    HubConnection.prototype.connectionClosed = function (error) {
        var _this = this;
        var callbacks = this.callbacks;
        this.callbacks = {};
        this.connectionState = HubConnectionState.Disconnected;
        // if handshake is in progress start will be waiting for the handshake promise, so we complete it
        // if it has already completed this should just noop
        if (this.handshakeRejecter) {
            this.handshakeRejecter(error);
        }
        Object.keys(callbacks)
            .forEach(function (key) {
            var callback = callbacks[key];
            callback(null, error ? error : new Error("Invocation canceled due to connection being closed."));
        });
        this.cleanupTimeout();
        this.cleanupPingTimer();
        this.closedCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
    };
    HubConnection.prototype.cleanupPingTimer = function () {
        if (this.pingServerHandle) {
            clearTimeout(this.pingServerHandle);
        }
    };
    HubConnection.prototype.cleanupTimeout = function () {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }
    };
    HubConnection.prototype.createInvocation = function (methodName, args, nonblocking) {
        if (nonblocking) {
            return {
                arguments: args,
                target: methodName,
                type: _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation,
            };
        }
        else {
            var id = this.id;
            this.id++;
            return {
                arguments: args,
                invocationId: id.toString(),
                target: methodName,
                type: _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].Invocation,
            };
        }
    };
    HubConnection.prototype.createStreamInvocation = function (methodName, args) {
        var id = this.id;
        this.id++;
        return {
            arguments: args,
            invocationId: id.toString(),
            target: methodName,
            type: _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].StreamInvocation,
        };
    };
    HubConnection.prototype.createCancelInvocation = function (id) {
        return {
            invocationId: id,
            type: _IHubProtocol__WEBPACK_IMPORTED_MODULE_1__["MessageType"].CancelInvocation,
        };
    };
    return HubConnection;
}());



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HandshakeProtocol", function() { return HandshakeProtocol; });
/* harmony import */ var _TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/** @private */
var HandshakeProtocol = /** @class */ (function () {
    function HandshakeProtocol() {
    }
    // Handshake request is always JSON
    HandshakeProtocol.prototype.writeHandshakeRequest = function (handshakeRequest) {
        return _TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].write(JSON.stringify(handshakeRequest));
    };
    HandshakeProtocol.prototype.parseHandshakeResponse = function (data) {
        var responseMessage;
        var messageData;
        var remainingData;
        if (Object(_Utils__WEBPACK_IMPORTED_MODULE_1__["isArrayBuffer"])(data) || (typeof Buffer !== "undefined" && data instanceof Buffer)) {
            // Format is binary but still need to read JSON text from handshake response
            var binaryData = new Uint8Array(data);
            var separatorIndex = binaryData.indexOf(_TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].RecordSeparatorCode);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, binaryData.slice(0, responseLength));
            remainingData = (binaryData.byteLength > responseLength) ? binaryData.slice(responseLength).buffer : null;
        }
        else {
            var textData = data;
            var separatorIndex = textData.indexOf(_TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].RecordSeparator);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = (textData.length > responseLength) ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        var messages = _TextMessageFormat__WEBPACK_IMPORTED_MODULE_0__["TextMessageFormat"].parse(messageData);
        var response = JSON.parse(messages[0]);
        if (response.type) {
            throw new Error("Expected a handshake response from the server.");
        }
        responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [remainingData, responseMessage];
    };
    return HandshakeProtocol;
}());



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextMessageFormat", function() { return TextMessageFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Not exported from index
/** @private */
var TextMessageFormat = /** @class */ (function () {
    function TextMessageFormat() {
    }
    TextMessageFormat.write = function (output) {
        return "" + output + TextMessageFormat.RecordSeparator;
    };
    TextMessageFormat.parse = function (input) {
        if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
            throw new Error("Message is incomplete.");
        }
        var messages = input.split(TextMessageFormat.RecordSeparator);
        messages.pop();
        return messages;
    };
    TextMessageFormat.RecordSeparatorCode = 0x1e;
    TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
    return TextMessageFormat;
}());



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Arg", function() { return Arg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataDetail", function() { return getDataDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatArrayBuffer", function() { return formatArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return isArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendMessage", function() { return sendMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLogger", function() { return createLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subject", function() { return Subject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectSubscription", function() { return SubjectSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleLogger", function() { return ConsoleLogger; });
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _Loggers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/** @private */
var Arg = /** @class */ (function () {
    function Arg() {
    }
    Arg.isRequired = function (val, name) {
        if (val === null || val === undefined) {
            throw new Error("The '" + name + "' argument is required.");
        }
    };
    Arg.isIn = function (val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) {
            throw new Error("Unknown " + name + " value: " + val + ".");
        }
    };
    return Arg;
}());

/** @private */
function getDataDetail(data, includeContent) {
    var detail = "";
    if (isArrayBuffer(data)) {
        detail = "Binary data of length " + data.byteLength;
        if (includeContent) {
            detail += ". Content: '" + formatArrayBuffer(data) + "'";
        }
    }
    else if (typeof data === "string") {
        detail = "String data of length " + data.length;
        if (includeContent) {
            detail += ". Content: '" + data + "'";
        }
    }
    return detail;
}
/** @private */
function formatArrayBuffer(data) {
    var view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    var str = "";
    view.forEach(function (num) {
        var pad = num < 16 ? "0" : "";
        str += "0x" + pad + num.toString(16) + " ";
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== "undefined" &&
        (val instanceof ArrayBuffer ||
            // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
            (val.constructor && val.constructor.name === "ArrayBuffer"));
}
/** @private */
function sendMessage(logger, transportName, httpClient, url, accessTokenFactory, content, logMessageContent) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, token, responseType, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!accessTokenFactory) return [3 /*break*/, 2];
                    return [4 /*yield*/, accessTokenFactory()];
                case 1:
                    token = _b.sent();
                    if (token) {
                        headers = (_a = {},
                            _a["Authorization"] = "Bearer " + token,
                            _a);
                    }
                    _b.label = 2;
                case 2:
                    logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(" + transportName + " transport) sending data. " + getDataDetail(content, logMessageContent) + ".");
                    responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
                    return [4 /*yield*/, httpClient.post(url, {
                            content: content,
                            headers: headers,
                            responseType: responseType,
                        })];
                case 3:
                    response = _b.sent();
                    logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(" + transportName + " transport) request complete. Response status: " + response.statusCode + ".");
                    return [2 /*return*/];
            }
        });
    });
}
/** @private */
function createLogger(logger) {
    if (logger === undefined) {
        return new ConsoleLogger(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information);
    }
    if (logger === null) {
        return _Loggers__WEBPACK_IMPORTED_MODULE_1__["NullLogger"].instance;
    }
    if (logger.log) {
        return logger;
    }
    return new ConsoleLogger(logger);
}
/** @private */
var Subject = /** @class */ (function () {
    function Subject(cancelCallback) {
        this.observers = [];
        this.cancelCallback = cancelCallback;
    }
    Subject.prototype.next = function (item) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            observer.next(item);
        }
    };
    Subject.prototype.error = function (err) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.error) {
                observer.error(err);
            }
        }
    };
    Subject.prototype.complete = function () {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.complete) {
                observer.complete();
            }
        }
    };
    Subject.prototype.subscribe = function (observer) {
        this.observers.push(observer);
        return new SubjectSubscription(this, observer);
    };
    return Subject;
}());

/** @private */
var SubjectSubscription = /** @class */ (function () {
    function SubjectSubscription(subject, observer) {
        this.subject = subject;
        this.observer = observer;
    }
    SubjectSubscription.prototype.dispose = function () {
        var index = this.subject.observers.indexOf(this.observer);
        if (index > -1) {
            this.subject.observers.splice(index, 1);
        }
        if (this.subject.observers.length === 0) {
            this.subject.cancelCallback().catch(function (_) { });
        }
    };
    return SubjectSubscription;
}());

/** @private */
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger(minimumLogLevel) {
        this.minimumLogLevel = minimumLogLevel;
    }
    ConsoleLogger.prototype.log = function (logLevel, message) {
        if (logLevel >= this.minimumLogLevel) {
            switch (logLevel) {
                case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Critical:
                case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Error:
                    console.error("[" + new Date().toISOString() + "] " + _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel] + ": " + message);
                    break;
                case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Warning:
                    console.warn("[" + new Date().toISOString() + "] " + _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel] + ": " + message);
                    break;
                case _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information:
                    console.info("[" + new Date().toISOString() + "] " + _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel] + ": " + message);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    console.log("[" + new Date().toISOString() + "] " + _ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"][logLevel] + ": " + message);
                    break;
            }
        }
    };
    return ConsoleLogger;
}());



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NullLogger", function() { return NullLogger; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** A logger that does nothing when log messages are sent to it. */
var NullLogger = /** @class */ (function () {
    function NullLogger() {
    }
    /** @inheritDoc */
    // tslint:disable-next-line
    NullLogger.prototype.log = function (_logLevel, _message) {
    };
    /** The singleton instance of the {@link @aspnet/signalr.NullLogger}. */
    NullLogger.instance = new NullLogger();
    return NullLogger;
}());



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageType", function() { return MessageType; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** Defines the type of a Hub Message. */
var MessageType;
(function (MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @aspnet/signalr.InvocationMessage} interface. */
    MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @aspnet/signalr.StreamItemMessage} interface. */
    MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @aspnet/signalr.CompletionMessage} interface. */
    MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @aspnet/signalr.StreamInvocationMessage} interface. */
    MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @aspnet/signalr.CancelInvocationMessage} interface. */
    MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @aspnet/signalr.PingMessage} interface. */
    MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @aspnet/signalr.CloseMessage} interface. */
    MessageType[MessageType["Close"] = 7] = "Close";
})(MessageType || (MessageType = {}));


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HubConnectionBuilder", function() { return HubConnectionBuilder; });
/* harmony import */ var _HttpConnection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/* harmony import */ var _HubConnection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22);
/* harmony import */ var _Loggers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.





/** A builder for configuring {@link @aspnet/signalr.HubConnection} instances. */
var HubConnectionBuilder = /** @class */ (function () {
    function HubConnectionBuilder() {
    }
    HubConnectionBuilder.prototype.configureLogging = function (logging) {
        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(logging, "logging");
        if (isLogger(logging)) {
            this.logger = logging;
        }
        else {
            this.logger = new _Utils__WEBPACK_IMPORTED_MODULE_4__["ConsoleLogger"](logging);
        }
        return this;
    };
    HubConnectionBuilder.prototype.withUrl = function (url, transportTypeOrOptions) {
        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") {
            this.httpConnectionOptions = transportTypeOrOptions;
        }
        else {
            this.httpConnectionOptions = {
                transport: transportTypeOrOptions,
            };
        }
        return this;
    };
    /** Configures the {@link @aspnet/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @aspnet/signalr.IHubProtocol} implementation to use.
     */
    HubConnectionBuilder.prototype.withHubProtocol = function (protocol) {
        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    };
    /** Creates a {@link @aspnet/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @aspnet/signalr.HubConnection}.
     */
    HubConnectionBuilder.prototype.build = function () {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        var httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) {
            // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
            httpConnectionOptions.logger = this.logger;
        }
        // Now create the connection
        if (!this.url) {
            throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        }
        var connection = new _HttpConnection__WEBPACK_IMPORTED_MODULE_0__["HttpConnection"](this.url, httpConnectionOptions);
        return _HubConnection__WEBPACK_IMPORTED_MODULE_1__["HubConnection"].create(connection, this.logger || _Loggers__WEBPACK_IMPORTED_MODULE_3__["NullLogger"].instance, this.protocol || new _JsonHubProtocol__WEBPACK_IMPORTED_MODULE_2__["JsonHubProtocol"]());
    };
    return HubConnectionBuilder;
}());

function isLogger(logger) {
    return logger.log !== undefined;
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpConnection", function() { return HttpConnection; });
/* harmony import */ var _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17);
/* harmony import */ var _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18);
/* harmony import */ var _ServerSentEventsTransport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);
/* harmony import */ var _WebSocketTransport__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var MAX_REDIRECTS = 100;
var WebSocketModule = null;
var EventSourceModule = null;
if (typeof window === "undefined" && "function" !== "undefined") {
    // In order to ignore the dynamic require in webpack builds we need to do this magic
    // @ts-ignore: TS doesn't know about these names
    var requireFunc =  true ? require : undefined;
    WebSocketModule = requireFunc("ws");
    EventSourceModule = requireFunc("eventsource");
}
/** @private */
var HttpConnection = /** @class */ (function () {
    function HttpConnection(url, options) {
        if (options === void 0) { options = {}; }
        this.features = {};
        _Utils__WEBPACK_IMPORTED_MODULE_5__["Arg"].isRequired(url, "url");
        this.logger = Object(_Utils__WEBPACK_IMPORTED_MODULE_5__["createLogger"])(options.logger);
        this.baseUrl = this.resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent || false;
        var isNode = typeof window === "undefined";
        if (!isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
            options.WebSocket = WebSocket;
        }
        else if (isNode && !options.WebSocket) {
            if (WebSocketModule) {
                options.WebSocket = WebSocketModule;
            }
        }
        if (!isNode && typeof EventSource !== "undefined" && !options.EventSource) {
            options.EventSource = EventSource;
        }
        else if (isNode && !options.EventSource) {
            if (typeof EventSourceModule !== "undefined") {
                options.EventSource = EventSourceModule;
            }
        }
        this.httpClient = options.httpClient || new _DefaultHttpClient__WEBPACK_IMPORTED_MODULE_0__["DefaultHttpClient"](this.logger);
        this.connectionState = 2 /* Disconnected */;
        this.options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    HttpConnection.prototype.start = function (transferFormat) {
        transferFormat = transferFormat || _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"].Binary;
        _Utils__WEBPACK_IMPORTED_MODULE_5__["Arg"].isIn(transferFormat, _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"], "transferFormat");
        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Starting connection with transfer format '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][transferFormat] + "'.");
        if (this.connectionState !== 2 /* Disconnected */) {
            return Promise.reject(new Error("Cannot start a connection that is not in the 'Disconnected' state."));
        }
        this.connectionState = 0 /* Connecting */;
        this.startPromise = this.startInternal(transferFormat);
        return this.startPromise;
    };
    HttpConnection.prototype.send = function (data) {
        if (this.connectionState !== 1 /* Connected */) {
            throw new Error("Cannot send data if the connection is not in the 'Connected' State.");
        }
        // Transport will not be null if state is connected
        return this.transport.send(data);
    };
    HttpConnection.prototype.stop = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.connectionState = 2 /* Disconnected */;
                        // Set error as soon as possible otherwise there is a race between
                        // the transport closing and providing an error and the error from a close message
                        // We would prefer the close message error.
                        this.stopError = error;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.transport) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.transport.stop()];
                    case 5:
                        _a.sent();
                        this.transport = undefined;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.startInternal = function (transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var url, negotiateResponse, redirects, _loop_1, this_1, state_1, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.baseUrl;
                        this.accessTokenFactory = this.options.accessTokenFactory;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!this.options.skipNegotiation) return [3 /*break*/, 5];
                        if (!(this.options.transport === _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets)) return [3 /*break*/, 3];
                        // No need to add a connection ID in this case
                        this.transport = this.constructTransport(_ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets);
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        return [4 /*yield*/, this.transport.connect(url, transferFormat)];
                    case 2:
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3: throw Error("Negotiation can only be skipped when using the WebSocket transport directly.");
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        negotiateResponse = null;
                        redirects = 0;
                        _loop_1 = function () {
                            var accessToken_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.getNegotiationResponse(url)];
                                    case 1:
                                        negotiateResponse = _a.sent();
                                        // the user tries to stop the connection when it is being started
                                        if (this_1.connectionState === 2 /* Disconnected */) {
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        if (negotiateResponse.error) {
                                            throw Error(negotiateResponse.error);
                                        }
                                        if (negotiateResponse.ProtocolVersion) {
                                            throw Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                                        }
                                        if (negotiateResponse.url) {
                                            url = negotiateResponse.url;
                                        }
                                        if (negotiateResponse.accessToken) {
                                            accessToken_1 = negotiateResponse.accessToken;
                                            this_1.accessTokenFactory = function () { return accessToken_1; };
                                        }
                                        redirects++;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 6;
                    case 6: return [5 /*yield**/, _loop_1()];
                    case 7:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _a.label = 8;
                    case 8:
                        if (negotiateResponse.url && redirects < MAX_REDIRECTS) return [3 /*break*/, 6];
                        _a.label = 9;
                    case 9:
                        if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
                            throw Error("Negotiate redirection limit exceeded.");
                        }
                        return [4 /*yield*/, this.createTransport(url, this.options.transport, negotiateResponse, transferFormat)];
                    case 10:
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        if (this.transport instanceof _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__["LongPollingTransport"]) {
                            this.features.inherentKeepAlive = true;
                        }
                        this.transport.onreceive = this.onreceive;
                        this.transport.onclose = function (e) { return _this.stopConnection(e); };
                        // only change the state if we were connecting to not overwrite
                        // the state if the connection is already marked as Disconnected
                        this.changeState(0 /* Connecting */, 1 /* Connected */);
                        return [3 /*break*/, 13];
                    case 12:
                        e_2 = _a.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error, "Failed to start the connection: " + e_2);
                        this.connectionState = 2 /* Disconnected */;
                        this.transport = undefined;
                        throw e_2;
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.getNegotiationResponse = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, token, negotiateUrl, response, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _b.sent();
                        if (token) {
                            headers = (_a = {},
                                _a["Authorization"] = "Bearer " + token,
                                _a);
                        }
                        _b.label = 2;
                    case 2:
                        negotiateUrl = this.resolveNegotiateUrl(url);
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Sending negotiation request: " + negotiateUrl + ".");
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.httpClient.post(negotiateUrl, {
                                content: "",
                                headers: headers,
                            })];
                    case 4:
                        response = _b.sent();
                        if (response.statusCode !== 200) {
                            throw Error("Unexpected status code returned from negotiate " + response.statusCode);
                        }
                        return [2 /*return*/, JSON.parse(response.content)];
                    case 5:
                        e_3 = _b.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error, "Failed to complete negotiation with the server: " + e_3);
                        throw e_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.createConnectUrl = function (url, connectionId) {
        if (!connectionId) {
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + ("id=" + connectionId);
    };
    HttpConnection.prototype.createTransport = function (url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var connectUrl, transports, _i, transports_1, endpoint, transport, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connectUrl = this.createConnectUrl(url, negotiateResponse.connectionId);
                        if (!this.isITransport(requestedTransport)) return [3 /*break*/, 2];
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Connection was provided an instance of ITransport, using that directly.");
                        this.transport = requestedTransport;
                        return [4 /*yield*/, this.transport.connect(connectUrl, requestedTransferFormat)];
                    case 1:
                        _a.sent();
                        // only change the state if we were connecting to not overwrite
                        // the state if the connection is already marked as Disconnected
                        this.changeState(0 /* Connecting */, 1 /* Connected */);
                        return [2 /*return*/];
                    case 2:
                        transports = negotiateResponse.availableTransports || [];
                        _i = 0, transports_1 = transports;
                        _a.label = 3;
                    case 3:
                        if (!(_i < transports_1.length)) return [3 /*break*/, 9];
                        endpoint = transports_1[_i];
                        this.connectionState = 0 /* Connecting */;
                        transport = this.resolveTransport(endpoint, requestedTransport, requestedTransferFormat);
                        if (!(typeof transport === "number")) return [3 /*break*/, 8];
                        this.transport = this.constructTransport(transport);
                        if (!!negotiateResponse.connectionId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getNegotiationResponse(url)];
                    case 4:
                        negotiateResponse = _a.sent();
                        connectUrl = this.createConnectUrl(url, negotiateResponse.connectionId);
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.transport.connect(connectUrl, requestedTransferFormat)];
                    case 6:
                        _a.sent();
                        this.changeState(0 /* Connecting */, 1 /* Connected */);
                        return [2 /*return*/];
                    case 7:
                        ex_1 = _a.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error, "Failed to start the transport '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport] + "': " + ex_1);
                        this.connectionState = 2 /* Disconnected */;
                        negotiateResponse.connectionId = undefined;
                        return [3 /*break*/, 8];
                    case 8:
                        _i++;
                        return [3 /*break*/, 3];
                    case 9: throw new Error("Unable to initialize any of the available transports.");
                }
            });
        });
    };
    HttpConnection.prototype.constructTransport = function (transport) {
        switch (transport) {
            case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets:
                if (!this.options.WebSocket) {
                    throw new Error("'WebSocket' is not supported in your environment.");
                }
                return new _WebSocketTransport__WEBPACK_IMPORTED_MODULE_6__["WebSocketTransport"](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.WebSocket);
            case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].ServerSentEvents:
                if (!this.options.EventSource) {
                    throw new Error("'EventSource' is not supported in your environment.");
                }
                return new _ServerSentEventsTransport__WEBPACK_IMPORTED_MODULE_4__["ServerSentEventsTransport"](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.EventSource);
            case _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].LongPolling:
                return new _LongPollingTransport__WEBPACK_IMPORTED_MODULE_3__["LongPollingTransport"](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false);
            default:
                throw new Error("Unknown transport: " + transport + ".");
        }
    };
    HttpConnection.prototype.resolveTransport = function (endpoint, requestedTransport, requestedTransferFormat) {
        var transport = _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][endpoint.transport];
        if (transport === null || transport === undefined) {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
        }
        else {
            var transferFormats = endpoint.transferFormats.map(function (s) { return _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][s]; });
            if (transportMatches(requestedTransport, transport)) {
                if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                    if ((transport === _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].WebSockets && !this.options.WebSocket) ||
                        (transport === _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"].ServerSentEvents && !this.options.EventSource)) {
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Skipping transport '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport] + "' because it is not supported in your environment.'");
                    }
                    else {
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Selecting transport '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport] + "'.");
                        return transport;
                    }
                }
                else {
                    this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Skipping transport '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport] + "' because it does not support the requested transfer format '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"][requestedTransferFormat] + "'.");
                }
            }
            else {
                this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Debug, "Skipping transport '" + _ITransport__WEBPACK_IMPORTED_MODULE_2__["HttpTransportType"][transport] + "' because it was disabled by the client.");
            }
        }
        return null;
    };
    HttpConnection.prototype.isITransport = function (transport) {
        return transport && typeof (transport) === "object" && "connect" in transport;
    };
    HttpConnection.prototype.changeState = function (from, to) {
        if (this.connectionState === from) {
            this.connectionState = to;
            return true;
        }
        return false;
    };
    HttpConnection.prototype.stopConnection = function (error) {
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this.stopError || error;
        if (error) {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Error, "Connection disconnected with error '" + error + "'.");
        }
        else {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information, "Connection disconnected.");
        }
        this.connectionState = 2 /* Disconnected */;
        if (this.onclose) {
            this.onclose(error);
        }
    };
    HttpConnection.prototype.resolveUrl = function (url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
            return url;
        }
        if (typeof window === "undefined" || !window || !window.document) {
            throw new Error("Cannot resolve '" + url + "'.");
        }
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative  path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        var aTag = window.document.createElement("a");
        aTag.href = url;
        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information, "Normalizing '" + url + "' to '" + aTag.href + "'.");
        return aTag.href;
    };
    HttpConnection.prototype.resolveNegotiateUrl = function (url) {
        var index = url.indexOf("?");
        var negotiateUrl = url.substring(0, index === -1 ? url.length : index);
        if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
            negotiateUrl += "/";
        }
        negotiateUrl += "negotiate";
        negotiateUrl += index === -1 ? "" : url.substring(index);
        return negotiateUrl;
    };
    return HttpConnection;
}());

function transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || ((actualTransport & requestedTransport) !== 0);
}


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpTransportType", function() { return HttpTransportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransferFormat", function() { return TransferFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */
var HttpTransportType;
(function (HttpTransportType) {
    /** Specifies no transport preference. */
    HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */
    HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */
    HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */
    HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType || (HttpTransportType = {}));
/** Specifies the transfer format for a connection. */
var TransferFormat;
(function (TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})(TransferFormat || (TransferFormat = {}));


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LongPollingTransport", function() { return LongPollingTransport; });
/* harmony import */ var _AbortController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _Errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// Not exported from 'index', this type is internal.
/** @private */
var LongPollingTransport = /** @class */ (function () {
    function LongPollingTransport(httpClient, accessTokenFactory, logger, logMessageContent) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.pollAbort = new _AbortController__WEBPACK_IMPORTED_MODULE_0__["AbortController"]();
        this.logMessageContent = logMessageContent;
        this.running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    Object.defineProperty(LongPollingTransport.prototype, "pollAborted", {
        // This is an internal type, not exported from 'index' so this is really just internal.
        get: function () {
            return this.pollAbort.aborted;
        },
        enumerable: true,
        configurable: true
    });
    LongPollingTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var pollOptions, token, pollUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(url, "url");
                        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isRequired(transferFormat, "transferFormat");
                        _Utils__WEBPACK_IMPORTED_MODULE_4__["Arg"].isIn(transferFormat, _ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"], "transferFormat");
                        this.url = url;
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Connecting.");
                        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
                        if (transferFormat === _ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"].Binary &&
                            (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
                            throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
                        }
                        pollOptions = {
                            abortSignal: this.pollAbort.signal,
                            headers: {},
                            timeout: 100000,
                        };
                        if (transferFormat === _ITransport__WEBPACK_IMPORTED_MODULE_3__["TransferFormat"].Binary) {
                            pollOptions.responseType = "arraybuffer";
                        }
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 2:
                        response = _a.sent();
                        if (response.statusCode !== 200) {
                            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Mark running as false so that the poll immediately ends and runs the close logic
                            this.closeError = new _Errors__WEBPACK_IMPORTED_MODULE_1__["HttpError"](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            this.running = true;
                        }
                        this.receiving = this.poll(this.url, pollOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    LongPollingTransport.prototype.updateHeaderToken = function (request, token) {
        if (!request.headers) {
            request.headers = {};
        }
        if (token) {
            // tslint:disable-next-line:no-string-literal
            request.headers["Authorization"] = "Bearer " + token;
            return;
        }
        // tslint:disable-next-line:no-string-literal
        if (request.headers["Authorization"]) {
            // tslint:disable-next-line:no-string-literal
            delete request.headers["Authorization"];
        }
    };
    LongPollingTransport.prototype.poll = function (url, pollOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var token, pollUrl, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 8, 9]);
                        _a.label = 1;
                    case 1:
                        if (!this.running) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 4:
                        response = _a.sent();
                        if (response.statusCode === 204) {
                            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Information, "(LongPolling transport) Poll terminated by server.");
                            this.running = false;
                        }
                        else if (response.statusCode !== 200) {
                            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Unexpected status code
                            this.closeError = new _Errors__WEBPACK_IMPORTED_MODULE_1__["HttpError"](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            // Process the response
                            if (response.content) {
                                this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) data received. " + Object(_Utils__WEBPACK_IMPORTED_MODULE_4__["getDataDetail"])(response.content, this.logMessageContent) + ".");
                                if (this.onreceive) {
                                    this.onreceive(response.content);
                                }
                            }
                            else {
                                // This is another way timeout manifest.
                                this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        if (!this.running) {
                            // Log but disregard errors that occur after stopping
                            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Poll errored after shutdown: " + e_1.message);
                        }
                        else {
                            if (e_1 instanceof _Errors__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]) {
                                // Ignore timeouts and reissue the poll.
                                this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                            else {
                                // Close the connection with the error as the result.
                                this.closeError = e_1;
                                this.running = false;
                            }
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Polling complete.");
                        // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
                        // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
                        if (!this.pollAborted) {
                            this.raiseOnClose();
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.running) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(_Utils__WEBPACK_IMPORTED_MODULE_4__["sendMessage"])(this.logger, "LongPolling", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
            });
        });
    };
    LongPollingTransport.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deleteOptions, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Stopping polling.");
                        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
                        this.running = false;
                        this.pollAbort.abort();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.receiving];
                    case 2:
                        _a.sent();
                        // Send DELETE to clean up long polling on the server
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) sending DELETE request to " + this.url + ".");
                        deleteOptions = {
                            headers: {},
                        };
                        return [4 /*yield*/, this.getAccessToken()];
                    case 3:
                        token = _a.sent();
                        this.updateHeaderToken(deleteOptions, token);
                        return [4 /*yield*/, this.httpClient.delete(this.url, deleteOptions)];
                    case 4:
                        _a.sent();
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) DELETE request sent.");
                        return [3 /*break*/, 6];
                    case 5:
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, "(LongPolling transport) Stop finished.");
                        // Raise close event here instead of in polling
                        // It needs to happen after the DELETE request is sent
                        this.raiseOnClose();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.raiseOnClose = function () {
        if (this.onclose) {
            var logMessage = "(LongPolling transport) Firing onclose event.";
            if (this.closeError) {
                logMessage += " Error: " + this.closeError;
            }
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace, logMessage);
            this.onclose(this.closeError);
        }
    };
    return LongPollingTransport;
}());



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbortController", function() { return AbortController; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */
var AbortController = /** @class */ (function () {
    function AbortController() {
        this.isAborted = false;
        this.onabort = null;
    }
    AbortController.prototype.abort = function () {
        if (!this.isAborted) {
            this.isAborted = true;
            if (this.onabort) {
                this.onabort();
            }
        }
    };
    Object.defineProperty(AbortController.prototype, "signal", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbortController.prototype, "aborted", {
        get: function () {
            return this.isAborted;
        },
        enumerable: true,
        configurable: true
    });
    return AbortController;
}());



/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerSentEventsTransport", function() { return ServerSentEventsTransport; });
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var ServerSentEventsTransport = /** @class */ (function () {
    function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, logMessageContent, eventSourceConstructor) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.logMessageContent = logMessageContent;
        this.eventSourceConstructor = eventSourceConstructor;
        this.onreceive = null;
        this.onclose = null;
    }
    ServerSentEventsTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(url, "url");
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(transferFormat, "transferFormat");
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isIn(transferFormat, _ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"], "transferFormat");
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(SSE transport) Connecting.");
                        // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send
                        this.url = url;
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var opened = false;
                            if (transferFormat !== _ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"].Text) {
                                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                                return;
                            }
                            var eventSource;
                            if (typeof window !== "undefined") {
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: true });
                            }
                            else {
                                // Non-browser passes cookies via the dictionary
                                var cookies = _this.httpClient.getCookieString(url);
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: true, headers: { Cookie: cookies } });
                            }
                            try {
                                eventSource.onmessage = function (e) {
                                    if (_this.onreceive) {
                                        try {
                                            _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(SSE transport) data received. " + Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(e.data, _this.logMessageContent) + ".");
                                            _this.onreceive(e.data);
                                        }
                                        catch (error) {
                                            _this.close(error);
                                            return;
                                        }
                                    }
                                };
                                eventSource.onerror = function (e) {
                                    var error = new Error(e.data || "Error occurred");
                                    if (opened) {
                                        _this.close(error);
                                    }
                                    else {
                                        reject(error);
                                    }
                                };
                                eventSource.onopen = function () {
                                    _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information, "SSE connected to " + _this.url);
                                    _this.eventSource = eventSource;
                                    opened = true;
                                    resolve();
                                };
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        })];
                }
            });
        });
    };
    ServerSentEventsTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.eventSource) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["sendMessage"])(this.logger, "SSE", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
            });
        });
    };
    ServerSentEventsTransport.prototype.stop = function () {
        this.close();
        return Promise.resolve();
    };
    ServerSentEventsTransport.prototype.close = function (e) {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
            if (this.onclose) {
                this.onclose(e);
            }
        }
    };
    return ServerSentEventsTransport;
}());



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebSocketTransport", function() { return WebSocketTransport; });
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var WebSocketTransport = /** @class */ (function () {
    function WebSocketTransport(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor) {
        this.logger = logger;
        this.accessTokenFactory = accessTokenFactory;
        this.logMessageContent = logMessageContent;
        this.webSocketConstructor = webSocketConstructor;
        this.httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
    }
    WebSocketTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(url, "url");
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isRequired(transferFormat, "transferFormat");
                        _Utils__WEBPACK_IMPORTED_MODULE_2__["Arg"].isIn(transferFormat, _ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"], "transferFormat");
                        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(WebSockets transport) Connecting.");
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            url = url.replace(/^http/, "ws");
                            var webSocket;
                            var cookies = _this.httpClient.getCookieString(url);
                            if (typeof window === "undefined" && cookies) {
                                // Only pass cookies when in non-browser environments
                                webSocket = new _this.webSocketConstructor(url, undefined, {
                                    headers: {
                                        Cookie: "" + cookies,
                                    },
                                });
                            }
                            if (!webSocket) {
                                // Chrome is not happy with passing 'undefined' as protocol
                                webSocket = new _this.webSocketConstructor(url);
                            }
                            if (transferFormat === _ITransport__WEBPACK_IMPORTED_MODULE_1__["TransferFormat"].Binary) {
                                webSocket.binaryType = "arraybuffer";
                            }
                            // tslint:disable-next-line:variable-name
                            webSocket.onopen = function (_event) {
                                _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Information, "WebSocket connected to " + url + ".");
                                _this.webSocket = webSocket;
                                resolve();
                            };
                            webSocket.onerror = function (event) {
                                var error = null;
                                // ErrorEvent is a browser only type we need to check if the type exists before using it
                                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                    error = event.error;
                                }
                                reject(error);
                            };
                            webSocket.onmessage = function (message) {
                                _this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(WebSockets transport) data received. " + Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(message.data, _this.logMessageContent) + ".");
                                if (_this.onreceive) {
                                    _this.onreceive(message.data);
                                }
                            };
                            webSocket.onclose = function (event) { return _this.close(event); };
                        })];
                }
            });
        });
    };
    WebSocketTransport.prototype.send = function (data) {
        if (this.webSocket && this.webSocket.readyState === this.webSocketConstructor.OPEN) {
            this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(WebSockets transport) sending data. " + Object(_Utils__WEBPACK_IMPORTED_MODULE_2__["getDataDetail"])(data, this.logMessageContent) + ".");
            this.webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    };
    WebSocketTransport.prototype.stop = function () {
        if (this.webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this.webSocket.onclose = function () { };
            this.webSocket.onmessage = function () { };
            this.webSocket.onerror = function () { };
            this.webSocket.close();
            this.webSocket = undefined;
            // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
            // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
            this.close(undefined);
        }
        return Promise.resolve();
    };
    WebSocketTransport.prototype.close = function (event) {
        // webSocket will be null if the transport did not start successfully
        this.logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_0__["LogLevel"].Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (event && (event.wasClean === false || event.code !== 1000)) {
                this.onclose(new Error("WebSocket closed with status code: " + event.code + " (" + event.reason + ")."));
            }
            else {
                this.onclose();
            }
        }
    };
    return WebSocketTransport;
}());



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonHubProtocol", function() { return JsonHubProtocol; });
/* harmony import */ var _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14);
/* harmony import */ var _ILogger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _ITransport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17);
/* harmony import */ var _Loggers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
/* harmony import */ var _TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.





var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */
var JsonHubProtocol = /** @class */ (function () {
    function JsonHubProtocol() {
        /** @inheritDoc */
        this.name = JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */
        this.version = 1;
        /** @inheritDoc */
        this.transferFormat = _ITransport__WEBPACK_IMPORTED_MODULE_2__["TransferFormat"].Text;
    }
    /** Creates an array of {@link @aspnet/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */
    JsonHubProtocol.prototype.parseMessages = function (input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") {
            throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        }
        if (!input) {
            return [];
        }
        if (logger === null) {
            logger = _Loggers__WEBPACK_IMPORTED_MODULE_3__["NullLogger"].instance;
        }
        // Parse the messages
        var messages = _TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__["TextMessageFormat"].parse(input);
        var hubMessages = [];
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var message = messages_1[_i];
            var parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") {
                throw new Error("Invalid payload.");
            }
            switch (parsedMessage.type) {
                case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Invocation:
                    this.isInvocationMessage(parsedMessage);
                    break;
                case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].StreamItem:
                    this.isStreamItemMessage(parsedMessage);
                    break;
                case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Completion:
                    this.isCompletionMessage(parsedMessage);
                    break;
                case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Ping:
                    // Single value, no need to validate
                    break;
                case _IHubProtocol__WEBPACK_IMPORTED_MODULE_0__["MessageType"].Close:
                    // All optional values, no need to validate
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log(_ILogger__WEBPACK_IMPORTED_MODULE_1__["LogLevel"].Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    };
    /** Writes the specified {@link @aspnet/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */
    JsonHubProtocol.prototype.writeMessage = function (message) {
        return _TextMessageFormat__WEBPACK_IMPORTED_MODULE_4__["TextMessageFormat"].write(JSON.stringify(message));
    };
    JsonHubProtocol.prototype.isInvocationMessage = function (message) {
        this.assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) {
            this.assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
        }
    };
    JsonHubProtocol.prototype.isStreamItemMessage = function (message) {
        this.assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) {
            throw new Error("Invalid payload for StreamItem message.");
        }
    };
    JsonHubProtocol.prototype.isCompletionMessage = function (message) {
        if (message.result && message.error) {
            throw new Error("Invalid payload for Completion message.");
        }
        if (!message.result && message.error) {
            this.assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        }
        this.assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    };
    JsonHubProtocol.prototype.assertNotEmptyString = function (value, errorMessage) {
        if (typeof value !== "string" || value === "") {
            throw new Error(errorMessage);
        }
    };
    return JsonHubProtocol;
}());



/***/ })
/******/ ]);
});
//# sourceMappingURL=signalr.js.map
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function () {
    'use strict';

    angular.module('app.factory')
        .factory('RastreamentoLeituristasFactory', RastreamentoLeituristasFactory);

    function RastreamentoLeituristasFactory($rootScope, $state) {

        var _form = {
        };

        var _filtros = {
            leituras: [],
            leiturista: null,
            dataInicial: null,
            dataFinal: null
        }

        var _preLoader = false;

        return {
            filtros: _filtros,
            form: _form,
            preLoader: _preLoader,
            setValoresInciaisFiltro: setValoresInciaisFiltro,
            atualizarMapa: atualizarMapa,
            setHabilitarMapa: setHabilitarMapa,
            centralizarMapa: centralizarMapa
        }

        function setValoresInciaisFiltro() {
            _filtros.leituras = [],
            _filtros.leiturista = null,
            _filtros.dataInicial = null,
            _filtros.dataFinal = null,
            _filtros.nomeArquivo = null,
            _filtros.tarefa =null,
            _preLoader = false;
            setHabilitarMapa(false);
        }

        function atualizarMapa(dados) {
            $rootScope.$broadcast('atualizarMapaFactory', angular.copy(dados));
            setHabilitarMapa(true);
        }

        function setHabilitarMapa(valor) {
            $rootScope.$broadcast('habilitarMapa', valor);
        }

        function centralizarMapa(dados) {
            $rootScope.$broadcast('centralizarMapaRastreamento', dados);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('MenuFactory', MenuFactory)

    /** @ngInject */
    function MenuFactory(msNavigationService, SessionStorageService, KeysSessionStorage) {
        var vm = this;
        var _menusTipoProcesso1 = [
            {
                menuNavegacao: 'app.processamento.exportacaomobile',
                title: 'Disponibilizar carga',
                state: 'app.exportacao_mobile',
                weight: 1
            },
            {
                menuNavegacao: 'app.processamento.geracaoarquivo',
                title: 'Geração de arq. de retorno',
                state: 'app.geracao_arquivo',
                weight: 3
            },

        ];

        var _menusTipoProcesso2 = [
            {
                menuNavegacao: 'app.processamento.importacaoGrupoLeitura',
                title: 'Importação grupo de leitura',
                state: 'app.importacao_grupo_leitura',
                weight: 1
            },
            {
                menuNavegacao: 'app.processamento.distribuicao',
                title: 'Distribuição de leituras',
                state: 'app.distribuicao',
                weight: 2
            },

            {
                menuNavegacao: 'app.processamento.disponibilizar_tarefa',
                title: 'Disponibilização de tarefas',
                state: 'app.disponibilizar_tarefas',
                weight: 3
            },
            {
                menuNavegacao: 'app.processamento.exportacao',
                title: 'Exportação grupo de leituras',
                state: 'app.exportacao_grupo_leitura',
                weight: 3
            },
            {
                menuNavegacao: 'app.processamento.gerenciamentogrupo',
                title: 'Gerenciamento de grupo',
                state: 'app.gerenciamento_grupo',
                weight: 4
            },
        ];

        var _menusCompartilhados = [

        ]

        function _constroiMenuTipoProcesso(tipoProcesso) {
            var menus = _recuperarMenusTipoProcesso(tipoProcesso);
            menus = menus.concat(_menusCompartilhados);
            menus.forEach(function (menu) {
                msNavigationService.saveItem(menu.menuNavegacao, {
                    title: menu.title,
                    state: menu.state,
                    weight: menu.weight
                })
            });
        }
        function _removerMenusTipoProcesso(tipoProcesso) {
            var menus = _recuperarMenusTipoProcesso(tipoProcesso);
            menus.forEach(function (menu) {
                msNavigationService.deleteItem(menu.menuNavegacao);
            })
        }

        function _removerTodosMenusTipoProcesso() {
            var menus = _recuperarTodosMenus();
            menus.forEach(function (menu) {
                msNavigationService.deleteItem(menu.menuNavegacao);
            });
        }

        function _recuperarMenusTipoProcesso(tipoProcesso) {
            var menus = null;
            if (tipoProcesso === '01') {
                var parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
                var sistemaGestorEhFiorilli = parametros && parametros.coletor && parametros.coletor.sistemaGestor == 2;

                menus = angular.copy(_menusTipoProcesso1);

                if (sistemaGestorEhFiorilli) {
                    menus.push({
                        menuNavegacao: 'app.processamento.exportacao',
                        title: 'Exportação grupo de leituras',
                        state: 'app.exportacao_grupo_leitura',
                        weight: 2
                    });
                }
            }
            else {
                menus = _menusTipoProcesso2
            }
            return menus;
        }
        function _recuperarTodosMenus() {
            var menusProcesso1 = _recuperarMenusTipoProcesso('01');
            return menusProcesso1.concat(_menusTipoProcesso2);
        }

        return {
            construirMenuTipoProcesso: _constroiMenuTipoProcesso,
            removerTodosMenusTipoProcesso: _removerTodosMenusTipoProcesso,
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('InterceptorRequestFactory', InterceptorRequestFactory);

    function InterceptorRequestFactory($q, $injector, $rootScope, TokenService) {
        return {
            request: function (config) {
                if (!config.ignoreAuthInterceptor) {
                    config.headers.Authorization = "Bearer " + TokenService.getToken();
                }
                return config;
            },
            requestError: function (rejection) {
                return $q.reject(rejection);
            },
            response: function (response) {
                return response;
            },
            responseError: function (rejection) {
                if ((rejection.status === 401 || rejection.status === 403) && !rejection.config.ignoreAuthInterceptor) {
                    if (!$rootScope.interceptorRequestError.unauthorizedError) {
                        $rootScope.interceptorRequestError.unauthorizedError = true;
                        $injector.get('MdDialogService').alertPadraoComEvento(
                            "A autenticação com o servidor foi perdida, você foi redirecionado para a tela de login para se autenticar novamente.",
                            function () {
                                $injector.get('$state').go('app.login');
                                $rootScope.interceptorRequestError.unauthorizedError = false;
                            }
                        );
                    }
                } else if (rejection.status === 502 || rejection.status === 503) {
                    $injector.get('$state').go('app.em_manutencao');
                } else {
                    return $q.reject(rejection);
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.factory')
        .factory('DatatableFactory', DatatableFactory);

    function DatatableFactory(urlApi, $q, ValidacaoService, TokenService, LocalStorageService) {

        var _tabela;
        var _converterEntidadePesquisaParaJson = true;
        var _quantidadeItensPorPagina = LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);

        function construirButtonSelecionar(td, col, icone) {
            var iconeUtilizado = icone ? icone : "icon-pencil";
            return $q(function (resolve) {
                $(td).html(
                    '<i id=acao-selecionar' + col + ' class="' + iconeUtilizado + ' s16 icone-cor-padrao" ng-click="" ng-disabled=""> </i>'
                );
                resolve('ok');
            });
        }

        function construirDtOptionsComPaginacaoResponsivoPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                drawCallback: function (settings) {
                    var api = this.api();
                    if (api && (tamanhoPaginaDatatable() != api.page.info().length)) {
                        armazenarTamanhoPaginaDatatable(api.page.info().length);
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [10, 30, 50, 100],
                pageLength: _quantidadeItensPorPagina,
                responsive: true,
                columnDefs: definicaoColunas,
                language: {
                    infoEmpty: "Não existem dados para exibição",
                    emptyTable: "Não existem dados para exibição",
                    zeroRecords: "Não existem dados para exibição",
                    info: "_START_ a _END_ de _TOTAL_ registro(s)",
                    sInfoFiltered: "(filtrado de  _MAX_ registro(s))",
                    lengthMenu: "Exibir _MENU_ linhas",
                    search: "Pesquisar: ",
                    paginate: {
                        "first": "<<",
                        "last": ">>",
                        "next": ">",
                        "previous": "<"
                    },
                }

            }
        }

        function construirDtOptionsResponsivoSemPaginacaoPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                fixedHeader: {
                    bottom: true
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "hfcgxhfghfgh",
                    "sProcessing": "",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }

        function construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar(rotaApi, entidadePesquisa, idDatatable, definicaoColunas) {
            ValidacaoService.validarParametroString(rotaApi);
            ValidacaoService.validarParametroObjeto(entidadePesquisa);
            ValidacaoService.validarParametroString(idDatatable);
            ValidacaoService.validarParametroArray(definicaoColunas);

            var deferred = $q.defer();
            var token = TokenService.getToken();
            var entidadeDeEnvio = angular.copy(entidadePesquisa);

            $(function () {
                _tabela = $(idDatatable).dataTable({
                    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: urlApi.url_base_api + rotaApi,
                        type: "POST",
                        dataType: 'json',
                        headers: {
                            "Authorization": "Bearer " + token
                        },
                        data: function (data) {
                            if (entidadeDeEnvio) {
                                _converterEntidadePesquisaParaJson ?
                                    data.clsEntidade = angular.toJson(entidadeDeEnvio, false) :
                                    data.clsEntidade = entidadeDeEnvio
                            }
                            console.log(data);
                            return data;
                        },
                        dataSrc: function (json) {
                            console.log(json);
                            return json.data;
                        }
                    },
                    initComplete: function () {
                        var api = this.api(),
                            searchBox = angular.element('body').find('#pesquisar');

                        // Bind an external input as a table wide search box
                        if (searchBox.length > 0) {
                            searchBox.on('keyup', function (event) {
                                api.search(event.target.value).draw();
                            });
                        }
                    },
                    drawCallback: function (settings) {
                        var api = this.api();
                        if (api && api.page.info() && (tamanhoPaginaDatatable() != api.page.info().length))
                            armazenarTamanhoPaginaDatatable(api.page.info().length);
                    },
                    pagingType: 'numbers',
                    lengthMenu: [10, 30, 50, 100],
                    pageLength: _quantidadeItensPorPagina,
                    responsive: true,
                    columnDefs: definicaoColunas
                });
                deferred.resolve(_tabela);
            });
            return deferred.promise;
        }

        function destruirTabela() {
            if (_tabela && _tabela.api())
                _tabela.api().destroy();
        }

        function armazenarTamanhoPaginaDatatable(tamanhoPagina) {
            _quantidadeItensPorPagina = tamanhoPagina;
            LocalStorageService.armazenar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable, tamanhoPagina);
        }

        function tamanhoPaginaDatatable() {
            return LocalStorageService.recuperar(LocalStorageService.chavesLocalStorage.tamanhoPaginaDatatable);
        }

        function construirColunaDeSelecionarPadrao(selecionar, icone) {
            return {
                targets: 0,
                createdCell: function (td, cellData, rowData, col) {
                    var tabela = this.DataTable();
                    construirButtonSelecionar(td, col, icone).then(
                        function (success) {
                            $('#acao-selecionar' + col).on('click', function () {
                                var indexLinha = tabela.page.info().start + (tabela.cell(td).index().row + 1);
                                if (selecionar)
                                    selecionar(indexLinha, td, cellData, rowData, col);
                            });
                        });
                },
                defaultContent: "",
                orderable: false,
                filterable: false,
                responsivePriority: 1
            };
        }

        function _construirColunaAcaoPadrao(targetColuna) {
            return {
                targets: targetColuna,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            }
        }

        function _setConverterEntidadePesquisaParaJson(valor) {
            _converterEntidadePesquisaParaJson = valor;
        }

        function construirDtOptionPadrao(columnsDef, ordenar) {
            return {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                ordering: ordenar,
                lengthMenu: [10, 20, 50, 100],
                autoWidth: true,
                responsive: true,
                columnDefs: columnsDef,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sSearch": "",
                    "sSearchPlaceholder": "Pesquisar: ",
                    "sLengthMenu": 'Exibir <select>' +
                        '<option value="10">10</option>' +
                        '<option value="20">20</option>' +
                        '<option value="50">50</option>' +
                        '<option value="100">100</option>' +
                        '</select> registros',
                    oPaginate: {
                        "sPrevious": "Anterior",
                        "sNext": "Próximo",
                        "sLast": "Último",
                        "sShow": "Exibir"
                    }
                }
            }
        }

        function construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao(definicaoColunas) {
            return {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: true,
                paging: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                columnDefs: definicaoColunas,
                oLanguage: {
                    "sInfo": "",
                    "sEmptyTable": "Não foram encontrados dados!",
                    "sSearch": "Pesquisar: ",
                    "sSearchPlaceholder": "",
                    "sInfoEmpty": "",
                    "sInfoFiltered": "",
                    "sLoadingRecords": "Carregando dados...",
                    "sProcessing": "Carregando dados...",
                    "sZeroRecords": "Nenhum dado encontrado com base na pesquisa informada."
                }
            }
        }




        return {
            construirDtOptionsComPaginacaoResponsivoPadrao: construirDtOptionsComPaginacaoResponsivoPadrao,
            construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar: construirDtOptionsComPaginacaoProcessadoNoServidorParaToolbar,
            construirDtOptionsResponsivoSemPaginacaoPadrao: construirDtOptionsResponsivoSemPaginacaoPadrao,
            construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao: construirDtOptionsResponsivoSemPaginacaoPadraoComPesquisaHeaderPadrao,
            //construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY: construirDtOptionsComPaginacaoProcessadoNoServidorComSrollY,
            construirColunaDeSelecionarPadrao: construirColunaDeSelecionarPadrao,
            destruirTabela: destruirTabela,
            construirDtOptionPadrao: construirDtOptionPadrao,
            construirColunaAcaoPadrao: _construirColunaAcaoPadrao,
            setConverterEntidadePesquisaParaJson: _setConverterEntidadePesquisaParaJson
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    }
                    else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            }
            else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('altDate', altDate);

  /** @ngInject */
  function altDate() {
    return function (value) {
      var diff = Date.now() - new Date(value);

      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */
      if (diff < (60 * 60 * 1000)) {
        return moment(value).fromNow();
      }
      /*
       * If in the day
       * e.g. "11:23"
       */
      else if (diff < (60 * 60 * 24 * 1000)) {
        return moment(value).format('HH:mm');
      }
      /*
       * If in week
       * e.g "Tuesday"
       */
      else if (diff < (60 * 60 * 24 * 7 * 1000)) {
        return moment(value).format('dddd');
      }
      /*
       * If more than a week
       * e.g. 03/29/2016
       */
      else {
        return moment(value).calendar();
      }

    };
  }

})();

String.prototype.removerTagsHtml = function () {
    return this.replace(/<.*?>/g, '');
}

String.prototype.substrituirQuebraDeLinhasParaTagHtml = function(){
    return this.replace(/\n/g, "<br>");    
}
jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "enum-necessidade-cliente-pre": function (a) {
        var retorno;
        switch (a.removerTagsHtml().trim()) {
            case "Deve ter": retorno = 4; break;
            case "Deveria ter": retorno = 3; break;
            case "Poderia ter": retorno = 2; break;
            case "Não terá por enquanto": retorno = 1; break;
            default: retorno = 0;
        }
        return retorno;
    },

    "enum-necessidade-cliente-asc": function (a, b) {
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    },

    "enum-necessidade-cliente-desc": function (a, b) {
        return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    }
});
jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  "numero-ano-pre": function (a) {
    var ukDatea = a.split('/');
    console.log(ukDatea);
    return (ukDatea[1] + ukDatea[0]) * 1;
  },

  "numero-ano-asc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
  },

  "numero-ano-desc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
  }
});

/**
 * This sorting plug-in for DataTables will correctly sort data in date time or date
 * format typically used in Germany:
 * date and time:`dd.mm.YYYY HH:mm`
 * just date:`dd.mm.YYYY`.
 *
 * Please note that this plug-in is **deprecated*. The
 * [datetime](//datatables.net/blog/2014-12-18) plug-in provides enhanced
 * functionality and flexibility.
 *
 *  @name Date (dd.mm.YYYY) or date and time (dd.mm.YYYY HH:mm)
 *  @summary Sort date / time in the format `dd.mm.YYYY HH:mm` or `dd.mm.YYYY`.
 *  @author [Ronny Vedrilla](http://www.ambient-innovation.com)
 *  @deprecated
 *
 *  @example
 *    $('#example').dataTable( {
 *       columnDefs: [
 *         { type: 'de_datetime', targets: 0 },
 *         { type: 'de_date', targets: 1 }
 *       ]
 *    } );
 */

jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  "date-pt-br-pre": function (a) {
    var regex = /([0-9]{2}\/[0-9]{2}\/[0-9]{4})/gm;
    var data = regex.exec(a);
    if (data) {
      var ukDatea = data[0].split('/');
      return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
    }else{return null;}
  },

  "date-pt-br-asc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
  },

  "date-pt-br-desc": function (a, b) {
    console.log(a);
    console.log(b);
    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
  }
});

// jQuery.extend( jQuery.fn.dataTableExt.oSort, {
//	"de_datetime-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_datetime-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	},
//
//	"de_date-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_date-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	}
//} );

/**
 * Array prototype
 *
 * Get by id
 *
 * @param value
 * @returns {T}
 */
Array.prototype.getById = function (value) {
    return this.filter(function (x) {
        return x.id === value;
    })[0];
};
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('pdf', PdfDirective);

    function PdfDirective() {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                var url = scope.$eval(attrs.src);
                element.replaceWith('<object id="frameRel" type="application/pdf" class="container-relatorio" flex-gt-sm="100" frameborder= "0" style= "border:0" data="' + url + '"></object>');
            }
        };
    }

})();
/**
 * Created by nova on 09/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .directive('mascaraTeste', mascaraTeste);

    function mascaraTeste() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs, ngModelCtrl) {

                console.log("Entro aqui");
                element.bind('keydown', function (event) {
                    console.log(event.keyCode)
                    if (event.keyCode == 27) {
                        console.log("Entro aqui");
                        event.preventDefault();
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.diretivas')
        .controller('CampoDataController', CampoDataController)
        .directive('campoData', CampoDataDirective);

    function CampoDataController() {
        var vm = this;
    }

    function CampoDataDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                ngModelCtrl.$formatters.unshift(function (modelValue) {
                    if (angular.isUndefined(modelValue) ||
                        angular.equals(modelValue, {}) ||
                        angular.equals(modelValue, null))
                        return modelValue;

                    var data = Date.parse(modelValue);

                    return moment(data).format('DD/MM/YYYY');
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.compartilhado')
        .controller('DialogSenhaImplantacaoController', DialogSenhaImplantacaoController);

    function DialogSenhaImplantacaoController($mdDialog, Api, RequisicaoGenericaService, MdDialogService) {
        var vm = this;

        var rotaApi = Api.modoimplantacao;

        vm.metodos = {
            fecharDialog: fecharDialog,
            verificarSenhaImplantacao: verificarSenhaImplantacao
        }

        init();

        function init() {
        }

        function fecharDialog() {
            $mdDialog.cancel()
        }

        function verificarSenhaImplantacao(senha) {
            RequisicaoGenericaService.listarSemParams(rotaApi.validarSenhaImplantacao + senha).then(
                function (success) {
                    $mdDialog.hide(senha);
                },
                function (error) {
                    MdDialogService.alertPadrao("Senha de implantação não confere.", vm.event);
                });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($mdDialog, $rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast,
        msNavigationService, LoginUsuarioService, TokenService, ControleAcessoConfig, $scope, $interval, dateFilter, SessionStorageService,
        KeysSessionStorage, $window, urlApi, MdDialogService,
        RequisicaoGenericaService, Api, $injector) {
        var vm = this;
        var contadorTrialInterval = null;
        var DatamobilIaService = null;
        var RequisicaoDatamobilService = null;

        $rootScope.modoImplantacao = SessionStorageService.recuperar(ControleAcessoConfig.key_modo_implantacao);
        vm.datamobilTrialAtivo = false;
        vm.datamobilTempoRestante = null;
        vm.datamobilCorContador = '';
        vm.versao = ControleAcessoConfig.configuracao.versao;
        vm.release = ControleAcessoConfig.configuracao.release;
        vm.marcaEspecial = SessionStorageService.recuperar("marcaEspecial");

        vm.exibirChatSuporte = urlApi.exibir_icone_suporte

        vm.horaAtual = dateFilter(new Date(), 'dd/MM/yyyy HH:mm');

        var updateTime = $interval(function () {
            vm.horaAtual = dateFilter(new Date(), 'dd/MM/yyyy HH:mm');
        }, 1000);

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        vm.usuario = LoginUsuarioService.usuarioArmazenado();

        // Methods

        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.alterarSenha = alterarSenha;
        vm.abrirConsultaSolicitacoes = abrirConsultaSolicitacoes;
        vm.abrirDialogLicencas = abrirDialogLicencas;
        vm.abrirDialogConfiguracaoSmartphone = abrirDialogConfiguracaoSmartphone;
        vm.irParaDatamobil = irParaDatamobil;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            try {
                DatamobilIaService = $injector.get('DatamobilIaService');
                RequisicaoDatamobilService = $injector.get('RequisicaoDatamobilService');
                verificarTrialDatamobil();
            } catch (e) {
            }

            $scope.$watch(function () {
                return $rootScope.datamobilTrialAtivo;
            }, function (novoValor) {
                vm.datamobilTrialAtivo = novoValor;
            });

            $scope.$watch(function () {
                return $rootScope.datamobilTempoRestante;
            }, function (novoValor) {
                vm.datamobilTempoRestante = novoValor;
            }, true);

            $scope.$watch(function () {
                return $rootScope.datamobilCorContador;
            }, function (novoValor) {
                vm.datamobilCorContador = novoValor;
            });
        }

        function verificarTrialDatamobil() {
            if (!DatamobilIaService || !RequisicaoDatamobilService) return;

            RequisicaoDatamobilService.autenticar().then(function () {
                return DatamobilIaService.obterConfiguracaoCliente();
            }).then(function (config) {
                DatamobilIaService.configuracaoCliente = config;
                var validacao = DatamobilIaService.validarAcessoModulo();
                if (validacao.motivo === 'trial-ativo') {
                    $rootScope.datamobilTrialAtivo = true;
                    iniciarContadorTrial();
                }
            }).catch(function () {
            });
        }

        function iniciarContadorTrial() {
            atualizarContadorTrial();
            if (contadorTrialInterval) {
                $interval.cancel(contadorTrialInterval);
            }
            contadorTrialInterval = $interval(function () {
                atualizarContadorTrial();
            }, 1000);
        }

        function atualizarContadorTrial() {
            if (!DatamobilIaService) return;

            var tempoRestante = DatamobilIaService.calcularDiasRestantes();
            if (tempoRestante && tempoRestante.expirado) {
                $rootScope.datamobilTrialAtivo = false;
                if (contadorTrialInterval) {
                    $interval.cancel(contadorTrialInterval);
                }
            } else if (tempoRestante) {
                $rootScope.datamobilTempoRestante = tempoRestante;
                if (tempoRestante.dias < 1) {
                    $rootScope.datamobilCorContador = 'vermelho';
                } else if (tempoRestante.dias <= 5) {
                    $rootScope.datamobilCorContador = 'amarelo';
                } else {
                    $rootScope.datamobilCorContador = '';
                }
            }
        }

        $scope.$on('$destroy', function () {
            if (contadorTrialInterval) {
                $interval.cancel(contadorTrialInterval);
            }
        });


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout() {
            SessionStorageService.remover(KeysSessionStorage.historicoComandosDatamobil);
            LoginUsuarioService.logout();
            if (window['fecharDialogQuestionario']) window['fecharDialogQuestionario']();

            $mdToast.show({
                template: '<md-toast id="logout-message" layout="column" layout-align="center start"><div class="md-toast-content">Logout realizado com sucesso !!</div></md-toast>',
                hideDelay: 7000,
                position: 'top right',
                parent: '#content'
            });
            $state.go('app.login');
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

        function alterarSenha(event) {
            $mdDialog.show({
                controller: 'DialogAlteracaoSenhaToolbarController',
                controllerAs: 'vm',
                templateUrl: 'app/compartilhado/dialog-alteracao-senha/dialog-alteracao-senha.html',
                //parent: ---------------,
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    Usuario: vm.usuario
                }
            });
        }

        function abrirConsultaSolicitacoes() {
            var parametros = SessionStorageService.recuperar(KeysSessionStorage.parametrosEmpresa);
            var codigoCliente = parametros.empresa.codigoImanager;
            var cnpj = parametros.empresa.cnpj;
            if (!_validarDadosCliente(codigoCliente, cnpj)) {
                return;
            }
            cnpj = _formatarCNPJ(cnpj);

            var produto = 2;
            if (!urlApi.url_consulta_solicitacoes) {
                MdDialogService
                    .alertPadrao("Para consultar as solicitações, é necessário informar a URL de acesso no arquivo de configuração da aplicação.");
                return;
            }
            var urlConsulta = urlApi.url_consulta_solicitacoes + codigoCliente + "/" + cnpj + "/" + produto;
            $window.open(urlConsulta, "_blank");
        }

        function abrirDialogLicencas() {
            $mdDialog.show({
                controller: 'DialogDetalhamentoLicencasController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/dialog-detalhamento-licencas/views/dialog-detalhamento-licencas.html',
                targetEvent: event,
                clickOutsideToClose: false
            });
        }

        function abrirDialogConfiguracaoSmartphone() {
            RequisicaoGenericaService.listarSemParams(
                Api.leiturista.listarTodosAtivos)
                .then(function (success) {
                    $mdDialog.show({
                        controller: 'DialogConfiguracaoSmartphone',
                        controllerAs: 'vm',
                        templateUrl: 'app/toolbar/dialogs/dialog-configuracao-smartphone/views/dialog-configuracao-smartphone.html',
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            Leituristas: success.data
                        }
                    });
                });
        }

        function irParaDatamobil() {
            $state.go('app.datamobil');
        }

        function _validarDadosCliente(codigo, cnpj) {
            if ((!codigo || codigo == 0) && (!cnpj || cnpj == "")) {
                MdDialogService
                    .alertPadrao("Para consultar as solicitações, é necessário preencher o código do cliente e o CNPJ no cadastro de parâmetros.");
                return false;
            }
            else if (!codigo || codigo == 0) {
                MdDialogService
                    .alertPadrao("Para consultar as solicitações, é necessário preencher o código do cliente no cadastro de parâmetros.");
                return false;
            }
            else if (!cnpj || cnpj == "") {
                MdDialogService
                    .alertPadrao("Para consultar as solicitações, é necessário preencher o CNPJ no cadastro de parâmetros.");
                return false;
            }
            return true;
        }

        function _formatarCNPJ(cnpj) {
            if (cnpj && typeof cnpj == 'string') {
                cnpj = cnpj.replace(/\./g, "");
                cnpj = cnpj.replace("/", "");
                cnpj = cnpj.replace("-", "");
                return cnpj;
            }
        }


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
/**
 * Created by nova on 19/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.constants', [

    ]);

})();

(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('RotasHtml', {

            toolbar: {
                dialogLicencasTemporarias: 'app/toolbar/dialogs/dialog-detalhamento-licencas/dialog-licencas-temporarias/dialog-licencas-temporarias.html',
                dialogVisualizarLicencasTemporariasCadastradas: 'app/toolbar/dialogs/dialog-detalhamento-licencas/'
                    + 'dialog-visualizar-licencas-temporarias-cadastradas/dialog-visualizar-licencas-temporarias-cadastradas.html'
            },

            arquivo: {
                templateUrl: 'app/main/cadastros/relacionados/arquivo/views/cadastro-arquivo.html',
                form: 'app/main/cadastros/relacionados/arquivo/views/cadastro-arquivo-form.html',
                tabela: 'app/main/cadastros/relacionados/arquivo/views/cadastro-arquivos-tabela.html',
            },

            formularioImpressao: {
                templateUrl: 'app/main/cadastros/relacionados/formulario-impressao/views/formulario-impressao.html',
                form: 'app/main/cadastros/relacionados/formulario-impressao/views/formulario-impressao-form.html',
                tabela: 'app/main/cadastros/relacionados/formulario-impressao/views/formularios-impressao-tabela.html',
                tabs: {
                    tabGeral: 'app/main/cadastros/relacionados/formulario-impressao/views/tabs/tab-geral/tab-geral.html',
                    tabEspecifico: 'app/main/cadastros/relacionados/formulario-impressao/views/tabs/tab-especifico/tab-especifico.html'
                }
            },

            mododeimplantacao: {
                templateUrl: 'app/main/ferramentasadministrativas/mododeimplantacao/views/mododeimplantacao.html',
                form: 'app/main/ferramentasadministrativas/mododeimplantacao/views/mododeimplantacao-form.html'
            },

            backup_banco_dados: {
                templateUrl: 'app/main/ferramentasadministrativas/backupbancodados/views/backupbancodados.html',
                form: 'app/main/ferramentasadministrativas/backupbancodados/views/backupbancodados.form.html'
            },

            geracaoarquivo: {
                sidenav: 'app/main/processamento/geracaoarquivo/views/sidenav/geracaoarquivo-filtro-sidenav.html',
                templateUrl: 'app/main/processamento/geracaoarquivo/views/geracaoarquivo.html',
                form: 'app/main/processamento/geracaoarquivo/views/geracaoarquivo-form.html',
                dialog_lista_nomes: 'app/main/processamento/geracaoarquivo/views/dialogs/lista-nomes-arquivo/dialog-lista-nomes-arquivo.html',
                tabelaArquivo: 'app/main/processamento/geracaoarquivo/views/geracaoarquivo-lista.html'
            },

            exportacaogestor: {
                sidenav: 'app/main/processamento/exportacaogestor/views/sidenav/exportacaogestor-filtro-sidenav.html',
                templateUrl: 'app/main/processamento/exportacaogestor/views/exportacaogestor.html',
                form: 'app/main/processamento/exportacaogestor/views/exportacaogestor-form.html',
                dialog_lista_nomes: 'app/main/processamento/exportacaogestor/views/dialogs/lista-nomes-arquivo/dialog-lista-nomes-arquivo.html',
                tabelaArquivo: 'app/main/processamento/exportacaogestor/views/exportacaogestor-lista.html'
            },

            exportacaomobile: {
                templateUrl: 'app/main/processamento/exportacao-mobile/views/exportacao-mobile.html',
                form: 'app/main/processamento/exportacao-mobile/views/exportacao-mobile-form.html'
            },

            disponibilizarCargaFiorilli: {
                templateUrl: 'app/main/processamento/exportacao-mobile/FIORILLI/disponibilizar-carga-fiorilli.html'
            },

            disponibilizarCargaThema: {
                templateUrl: 'app/main/processamento/exportacao-mobile/THEMA/disponibilizar-carga-thema.html'
            },

            equipamento: {
                templateUrl: 'app/main/cadastros/relacionados/equipamento/views/equipamento.html',
                form: 'app/main/cadastros/relacionados/equipamento/views/equipamento-form.html',
                tabela: 'app/main/cadastros/relacionados/equipamento/views/equipamento-tabela.html'
            },
            parametros: {
                templateUrl: 'app/main/cadastros/parametros/views/parametros.html',
                form: 'app/main/cadastros/parametros/views/parametros-form.html',
                tabela: 'app/main/cadastros/parametros/views/parametros-tabela.html',
                tabs: {
                    tabEmpresa: 'app/main/cadastros/parametros/views/tabs/tab-empresa/tab-empresa.html',
                    tabPersonalizacao: 'app/main/cadastros/parametros/views/tabs/tab-personalizacao/tab-personalizacao.html',
                    tabColetor: 'app/main/cadastros/parametros/views/tabs/tab-coletor/tab-coletor.html',
                    tabColetorTabConfiguracao: 'app/main/cadastros/parametros/views/tabs/tab-coletor/tabs/tab-configuracao/tab-configuracao.html',
                    tabColetorTabLeitura: 'app/main/cadastros/parametros/views/tabs/tab-coletor/tabs/tab-leitura/tab-leitura.html',
                    tabOcorrencia: 'app/main/cadastros/parametros/views/tabs/tab-ocorrencia/tab-ocorrencia.html',
                    tabCalculo: 'app/main/cadastros/parametros/views/tabs/tab-calculo/tab-calculo.html',
                    tabCalculoTabConfiguracao: 'app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-configuracao/tab-configuracao.html',
                    tabCalculoTabFaixa: 'app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-faixa/tab-faixa.html',
                    tabCalculoTabArredondamento: 'app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-arredondamento/tab-arredondamento.html',
                    tabImpressao: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tab-impressao.html',
                    tabImpressaoTabMensagens: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-mensagens/tab-mensagens.html',
                    tabImpressaoTabOutros: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-outros/tab-outros.html',
                    tabImpressaoTabComunicados: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tab-comunicados.html',

                    tabImpressaoTabComunicadosTabConsumoAlterado: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-consumoalterado/tab-consumoalterado.html',
                    tabImpressaoTabComunicadosTabDebitosAnteriores: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-debitosanteriores/tab-debitosanteriores.html',
                    tabImpressaoTabComunicadosTabOcorrencia: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-ocorrencia/tab-ocorrencia.html',
                    tabImpressaoTabComunicadosTabQuitacaoAnualDebitos: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-quitacaoanualdebitos/tab-quitacaoanualdebitos.html',
                    tabImpressaoTabComunicadosTabAlternativo: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-alternativo/tab-alternativo.html',
                    tabImpressaoTabComunicadosTabServicos: 'app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-servicos/tab-servicos.html',

                    tabController: 'app/main/cadastros/parametros/views/tabs/tab-controller/tab-controller.html',
                    tabModoImplantacao: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tab-modoimplantacao.html',
                    tabModoImplantacaoTabConfiguracao: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-configuracao/tab-configuracao.html',
                    tabModoImplantacaoTabProcessamento: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-processamento/tab-processamento.html',
                    tabModoImplantacaoTabOutros: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-outros/tab-outros.html',
                    tabModoImplantacaoTabAuditoria: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-auditoria/tab-auditoria.html',
                    tabModoImplantacaoTabAuditoriaTabOutros: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-auditoria/tab-outros/tab-outros.html',
                    tabModoImplantacaoTabCritica: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-critica/tab-critica.html',
                    tabModoImplantacaoTabOutros: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-outros/tab-outros.html',
                    tabModoImplantacaoTabEspecifico: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-especifico/tab-especifico.html',
                    tabModoImplantacaoTabEspecificoTabJardinopolis: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-especifico/tab-jardinopolis/tab-jardinopolis.html',
                    tabModoImplantacaoTabDadosConfig: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-dados-config/tab-dados-config.html',
                    tabModoImplantacaoTabControleImportacao: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-controle-importacao/tab-controle-importacao.html',
                    tabModoImplantacaoTabIlhaSolteira: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-ilha-solteira.html',
                    tabModoImplantacaoTabIlhaSolteiraTabPoupaAgua: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-poupa-agua/tab-poupa-agua.html',
                    tabModoImplantacaoTabIlhaSolteiraTabLigacaoCota: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-ligacao-cota/tab-ligacao-cota.html',
                    tabModoImplantacaoTabIlhaSolteiraTabLancamentoOcorrencia: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-lancamento-ocorrencia/tab-lancamento-ocorrencia.html',
                    tabModoImplantacaoTabMarcaEspecial: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-marca-especial/tab-marca-especial.html',
                    tabModoImplantacaoTabDANFAg: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-danfag/tab-danfag.html',
                    tabModoImplantacaoTabRetencaoDados: 'app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-retencao-dados/tab-retencao-dados.html'
                },
                dialogs: {
                    dialogImagensPredefinidas: 'app/main/cadastros/parametros/views/tabs/tab-personalizacao/dialogs/dialog-imagens-predefinidas-background/views/dialog-imagens-predefinidas-background.html'
                }
            },

            impressora: {
                templateUrl: 'app/main/cadastros/relacionados/impressora/views/impressora.html',
                form: 'app/main/cadastros/relacionados/impressora/views/impressora-form.html',
                tabela: 'app/main/cadastros/relacionados/impressora/views/impressoras-tabela.html',
            },

            relatorio: {
                estatistica: {
                    templateUrl: 'app/main/relatorios/estatisticas/views/estatisticas.html',
                    form: 'app/main/relatorios/estatisticas/views/estatisticas-form.html',
                    caema: {
                        form: 'app/main/relatorios/estatisticas/views/CAEMA/estatisticas-form-caema.html'
                    }
                },
                logs: {
                    templateUrl: 'app/main/relatorios/logs/views/logs.html',
                    form: 'app/main/relatorios/logs/views/logs-form.html',
                    dialogs: {
                        selecionarArquivo: {
                            templateUrl: 'app/main/relatorios/logs/dialogs/views/selecionar-arquivo-log-dialog.html'
                        }
                    }
                },
                faturamento: {
                    dialogs: {
                        servicosPrestados: {
                            templateUrl: 'app/main/relatorios/faturamento/dialog/views/faturamento-servicos-prestados-dialog.html'
                        }
                    },
                    templateUrl: 'app/main/relatorios/faturamento/views/faturamento.html',
                    form: 'app/main/relatorios/faturamento/views/faturamento-form.html'
                },
                historicoConsumo: {
                    templateUrl: 'app/main/relatorios/historico-consumo/views/historico-consumo.html',
                    form: 'app/main/relatorios/historico-consumo/views/historico-consumo-form.html'
                },
                alertaCliente: {
                    templateUrl: 'app/main/relatorios/alerta-cliente/views/alerta-cliente.html',
                    form: 'app/main/relatorios/alerta-cliente/views/alerta-cliente-form.html'
                },
                vivaAgua: {
                    templateUrl: 'app/main/relatorios/viva-agua/views/viva-agua.html',
                    form: 'app/main/relatorios/viva-agua/views/viva-agua-form.html',
                    dialogs: {
                        localidades: 'app/main/relatorios/viva-agua/dialogs/views/viva-agua-localidades-dialog.html'
                    }
                },
                faturasRetidas: {
                    templateUrl: 'app/main/relatorios/faturas-retidas/views/faturas-retidas.html',
                    form: 'app/main/relatorios/faturas-retidas/views/faturas-retidas-form.html'
                },
                clientesNaoVisitados: {
                    templateUrl: 'app/main/relatorios/clientes-nao-visitados/views/clientes-nao-visitados.html',
                    form: 'app/main/relatorios/clientes-nao-visitados/views/clientes-nao-visitados-form.html'
                },
                personalizado: {
                    templateUrl: 'app/main/relatorios/personalizado/views/personalizado.html',
                    form: 'app/main/relatorios/personalizado/views/personalizado-form.html'
                },
            },

            leiturista: {
                templateUrl: 'app/main/cadastros/leiturista/views/leiturista.html',
                form: 'app/main/cadastros/leiturista/views/leiturista-form.html',
                tabela: 'app/main/cadastros/leiturista/views/leituristas-tabela.html',
                tabelaInformacoes: 'app/main/cadastros/leiturista/views/tabs/tab-recadastramento/tabela-informacoes/tabela-informacoes.html',
                tabs: {
                    pessoal: 'app/main/cadastros/leiturista/views/tabs/tab-pessoal/tab-pessoal.html',
                    configuracoes: 'app/main/cadastros/leiturista/views/tabs/tab-configuracoes/tab-configuracoes.html',
                    impressao: 'app/main/cadastros/leiturista/views/tabs/tab-impressao/tab-impressao.html',
                    telemetria: 'app/main/cadastros/leiturista/views/tabs/tab-telemetria/tab-telemetria.html',
                    recadastramento: 'app/main/cadastros/leiturista/views/tabs/tab-recadastramento/tab-recadastramento.html',
                }
            },

            ocorrencia: {
                templateUrl: 'app/main/cadastros/ocorrencia/views/ocorrencia.html',
                form: 'app/main/cadastros/ocorrencia/views/ocorrencia-form.html',
                tabela: 'app/main/cadastros/ocorrencia/views/ocorrencia-tabela.html',
                tabs: {
                    ocorrencia: 'app/main/cadastros/ocorrencia/views/tabs/tab-ocorrencia/tab-ocorrencia.html',
                    comunicado: 'app/main/cadastros/ocorrencia/views/tabs/tab-comunicado/tab-comunicado.html',
                    configuracoesAdicionais: 'app/main/cadastros/ocorrencia/views/tabs/tab-configuracoes-adicionais/tab-configuracoes-adicionais.html'
                }
            },

            tipoEntrega: {
                templateUrl: 'app/main/cadastros/entrega/tipo-entrega/views/tipo-entrega.html',
                form: 'app/main/cadastros/entrega/tipo-entrega/views/tipo-entrega-form.html',
                tabela: 'app/main/cadastros/entrega/tipo-entrega/views/tipo-entregas-tabela.html',
            },

            motivoNaoEntrega: {
                templateUrl: 'app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega.html',
                form: 'app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega-form.html',
                tabela: 'app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega-tabela.html',
            },
            gerenciamento: {
                critica: {
                    execucao: {
                        templateUrl: 'app/main/gerenciamento/critica/criticaleituras/views/critica-leituras.html',
                        form: 'app/main/gerenciamento/critica/criticaleituras/views/critica-leituras-form.html',
                        sidenav: {
                            filtro: 'app/main/gerenciamento/critica/criticaleituras/sidenav/filtro/views/filtro-critica-leituras.html',
                            execucao: 'app/main/gerenciamento/critica/criticaleituras/sidenav/execucao/views/execucao-critica-sidenav.html',
                            fotos: 'app/main/gerenciamento/critica/criticaleituras/sidenav/fotos/views/fotos-critica-sidenav.html',
                            legenda: 'app/main/gerenciamento/critica/criticaleituras/sidenav/legenda/legenda-critica-sidenav.html'
                        },
                        dialogs: {
                            visualizacaoLeitura: 'app/main/gerenciamento/critica/criticaleituras/dialogs/dialog-visualizacao-leitura/critica-leitura-dialog-visualizacao-leitura.html'
                        },
                        bottomSheet: {
                            fotosCritica: 'app/main/gerenciamento/critica/criticaleituras/bottom-sheet/bottom-sheet-fotos-critica/views/fotos-critica-bottom-sheet.html'
                        }
                    },
                    consulta: {
                        templateUrl: 'app/main/gerenciamento/critica/consultacritica/views/consulta-critica.html',
                        form: 'app/main/gerenciamento/critica/consultacritica/views/consulta-critica.form.html',
                        sidenav: {
                            filtro: 'app/main/gerenciamento/critica/consultacritica/sidenav/filtro/views/filtro-consulta-criticas.html'
                        },
                        dialogs: {
                            visualizacaoLeitura: 'app/main/gerenciamento/critica/criticaleituras/dialogs/dialog-visualizacao-leitura/critica-leitura-dialog-visualizacao-leitura.html',
                            historico: 'app/main/gerenciamento/critica/consultacritica/dialogs/historico-critica/views/historico-critica.html',
                            fotosVisita: 'app/main/gerenciamento/critica/consultacritica/dialogs/historico-critica/dialogs/dialog-fotos/views/dialog-fotos-historico-criticas.html'
                        }
                    },
                    acompanhamento: {
                        templateUrl: 'app/main/gerenciamento/critica/acompanhamento/views/acompanhamento-critica.html',
                        form: 'app/main/gerenciamento/critica/acompanhamento/views/acompanhamento-critica-form.html',
                        sidenav: {
                            filtro: 'app/main/gerenciamento/critica/acompanhamento/sidenav/filtro/views/filtro-acompanhamento-critica-sidenav.html'
                        }
                    }
                },
                leitura: {
                    visualizacao: {
                        templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/leitura-visualizacao.html',
                        form: 'app/main/gerenciamento/leitura/visualizacao/views/leitura-visualizacao-form.html',
                        tabs: {
                            dadosCadastrais: "app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosCadastrais/tab-dados-cadastrais.html",
                            dadosLeitura: {
                                templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/tab-dados-leitura.html',
                                dialogs: {
                                    fotos: {
                                        templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/fotos-dados-leitura.dialog.html',
                                        tabs: {
                                            tabHidrometro: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-hidrometro.html',
                                            tabFachada: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-fachada.html',
                                            tabProvaAdulteracao: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-prova-adulteracao.html',
                                            tabDemaisFotos: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-demais-fotos.html',
                                            tabRepasse: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-repasse.html',
                                        },
                                        dialogs: {
                                            detalharFotos: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/dialogs/detalhar-foto.dialog.html'
                                        }
                                    },
                                    logLeitura: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/logLeitura/log-leitura.dialog.html'
                                }
                            },
                            dadosFaturamento: {
                                templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/tab-dados-faturamento.html',
                                dialogs: {
                                    historico: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/historico/historico.dialog.html',
                                    historicoAbastecimento: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/historico-abastecimento/historico-abastecimento.dialog.html',
                                    servico: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/servico/dados-servico.html'
                                }
                            },
                            fotos: {
                                templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tab-fotos.html',
                                hidrometro: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tabs/tab-hidrometro.html',
                                provaAdulteracao: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tabs/prova-adulteracao.html'
                            },
                            dadosCritica: {
                                templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/critica/tab-critica.html',
                                dialogs: {
                                    motivoCritica: {
                                        templateUrl: 'app/main/gerenciamento/leitura/visualizacao/views/tabs/critica/dialogs/dialog-motivo-critica/views/dialog-motivo-critica.html'
                                    }
                                }
                            }
                        },
                        caema: {
                            form: 'app/main/gerenciamento/leitura/visualizacao/views/CAEMA/leitura-visualizacao-form-caema.html'
                        }
                    },
                    rastreamento: {
                        templateUrl: 'app/main/gerenciamento/leitura/rastreamento-leiturista/views/rastreamento-leiturista.html',
                        step: {
                            periodo: 'app/main/gerenciamento/leitura/rastreamento-leiturista/step/periodo/periodo-setp.html',
                            leituristas: 'app/main/gerenciamento/leitura/rastreamento-leiturista/step/leiturista/leiturista-step.html'
                        },
                        mapa: {
                            templateUrl: 'app/main/gerenciamento/leitura/rastreamento-leiturista/mapa/views/rastreamento-leiturista-mapa.html'
                        },
                        filtro: {
                            templateUrl: 'app/main/gerenciamento/leitura/rastreamento-leiturista/sidenavs/views/filtro-sidenav.html'
                        },
                        legenda: {
                            templateUrl: 'app/main/gerenciamento/leitura/rastreamento-leiturista/sidenavs/legenda/views/legenda-sidenav.html'
                        }
                    },
                    monitoramento: {
                        templateUrl: 'app/main/gerenciamento/leitura/monitoramento/views/monitoramento.html',
                        filtro: {
                            templateUrl: 'app/main/gerenciamento/leitura/monitoramento/sidenavs/filtro/views/filtro-sidenav.html',
                        },
                        dashboard: {
                            templateUrl: 'app/main/gerenciamento/leitura/monitoramento/sidenavs/dashboard/views/dashboard-sidenav.html',
                        },
                        mapa: {
                            templateUrl: 'app/main/gerenciamento/leitura/monitoramento/mapa/views/monitoramento-mapa.html'
                        },
                        legenda: {
                            templateUrl: 'app/main/gerenciamento/leitura/monitoramento/sidenavs/legenda/views/legenda-sidenav.html'
                        }
                    },
                    cancelamentoDinamico: {
                        templateUrl: 'app/main/gerenciamento/leitura/cancelamento-dinamico/views/cancelamento-dinamico.html',
                        form: 'app/main/gerenciamento/leitura/cancelamento-dinamico/views/cancelamento-dinamico-form.html',
                    },
                },
                produtividade: {
                    templateUrl: 'app/main/gerenciamento/produtividade/views/produtividade.html',
                    form: 'app/main/gerenciamento/produtividade/views/produtividade-form.html',
                    sidenav: {
                        filtro: {
                            templateUrl: 'app/main/gerenciamento/produtividade/sidenavs/filtro/views/filtro-produtividade.html'
                        }
                    },
                    dialogs: {
                        detalhesProdutividade: {
                            templateUrl: 'app/main/gerenciamento/produtividade/dialogs/dialog-detalhes/views/dialog-detalhes-produtividade.html'
                        },
                        detalhesOciosidade: {
                            templateUrl: 'app/main/gerenciamento/produtividade/dialogs/dialog-detalhes-ociosidade/views/dialog-detalhes-ociosidade.html'
                        },
                        detalhesCritica: {
                            templateUrl: 'app/main/gerenciamento/produtividade/dialogs/dialog-detalhes-critica/views/dialog-detalhes-critica.html'
                        }
                    }
                },
                dashboards: {
                    clientesocorrencia: {
                        templateUrl: 'app/main/gerenciamento/dashboards/cliente-ocorrencia/views/cliente-ocorrencia.html',
                        form: 'app/main/gerenciamento/dashboards/cliente-ocorrencia/views/cliente-ocorrencia-form.html',
                        dialogs: {
                            fotos: 'app/main/gerenciamento/dashboards/cliente-ocorrencia/dialogs/dialog-fotos/views/dialog-fotos-cliente-ocorrencia.html'
                        },
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/cliente-ocorrencia/sidenavs/filtro/views/filtro-cliente-ocorrencia.html',
                            filtroCasan: 'app/main/gerenciamento/dashboards/cliente-ocorrencia/sidenavs/filtro/views/CASAN/filtro-cliente-ocorrencia-casan.html'
                        }
                    },
                    comunicadosdebitoimpressos: {
                        templateUrl: 'app/main/gerenciamento/dashboards/comunicados-debito-impressos/views/comunicados-debito-impressos.html',
                        form: 'app/main/gerenciamento/dashboards/comunicados-debito-impressos/views/comunicados-debito-impressos-form.html',
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/comunicados-debito-impressos/sidenavs/filtro/views/filtro-comunicados-debito-impressos.html'
                        }
                    },
                    controlecargafluxo: {
                        templateUrl: 'app/main/gerenciamento/dashboards/controle-fluxo/views/controle-fluxo.html',
                        form: 'app/main/gerenciamento/dashboards/controle-fluxo/views/controle-fluxo-form.html',
                        sidenav: {
                            filtro: 'app/main/gerenciamento/dashboards/controle-fluxo/views/sidenav/controle-fluxo-filtro.html'
                        }
                    },
                    resumoretencoes: {
                        templateUrl: 'app/main/gerenciamento/dashboards/resumo-retencoes/views/resumo-retencoes.html',
                        faturasSimplificado: {
                            form: 'app/main/gerenciamento/dashboards/resumo-retencoes/views/faturas-simplificado/resumo-retencoes-faturas-simplificado-form.html'
                        },
                        faturasDetalhado: {
                            form: 'app/main/gerenciamento/dashboards/resumo-retencoes/views/faturas-detalhado/resumo-retencoes-faturas-detalhado-form.html'
                        },
                        comunicadosDetalhado: {
                            form: 'app/main/gerenciamento/dashboards/resumo-retencoes/views/comunicados-detalhado/resumo-retencoes-comunicados-detalhado-form.html'
                        },
                        comunicadosSimplificado: {
                            form: 'app/main/gerenciamento/dashboards/resumo-retencoes/views/comunicados-simplificado/resumo-retencoes-comunicados-simplificado-form.html'
                        },
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/resumo-retencoes/sidenav/filtro/views/filtro-resumo-retencoes.html'
                        }
                    },

                    quitacaoanual: {
                        templateUrl: 'app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual.html',
                        quitacaoAnualSimplificado: {
                            form: 'app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual-simplificado/quitacao-anual-simplificado-form.html'
                        },
                        quitacaoAnualDetalhado: {
                            form: 'app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual-detalhado/quitacao-anual-detalhado-form.html'
                        },
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/quitacao-anual/sidenav/filtro/views/filtro-quitacao-anual.html'
                        }
                    },

                    resumodistribuicaogrupos: {
                        templateUrl: 'app/main/gerenciamento/dashboards/distribuicao-grupos/views/resumo-distribuicao-grupos.html',
                        resumoDistribuicaoGrupos: {
                            form: 'app/main/gerenciamento/dashboards/distribuicao-grupos/views/resumo-distribuicao-grupos/resumo-distribuicao-grupos-form.html'
                        },
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/distribuicao-grupos/sidenav/filtro/views/filtro-resumo-dirtibuicao-grupos.html'
                        }
                    },

                    quantitativoleituras: {
                        templateUrl: 'app/main/gerenciamento/dashboards/quantitativo-leituras/views/quantitativo-leituras.html',
                        form: 'app/main/gerenciamento/dashboards/quantitativo-leituras/views/quantitativo-leituras-form.html',
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/quantitativo-leituras/sidenavs/filtro/views/filtro-quantitativo-leituras.html'
                        }
                    },
                    ocorrenciasleiturista: {
                        templateUrl: 'app/main/gerenciamento/dashboards/ocorrencias-leiturista/views/ocorrencias-leiturista.html',
                        form: 'app/main/gerenciamento/dashboards/ocorrencias-leiturista/views/ocorrencias-leiturista-form.html',
                        dialogs: {
                            detalhamento: 'app/main/gerenciamento/dashboards/ocorrencias-leiturista/dialogs/dialog-detalhamento/views/dialog-detalhamento-ocorrencias-leiturista.html'
                        },
                        sidenavs: {
                            filtro: 'app/main/gerenciamento/dashboards/ocorrencias-leiturista/sidenavs/filtro/views/filtro-ocorrencias-leiturista.html'
                        }
                    },
                }
            },

            gerenciamentoCarga: {
                totalizador: {
                    templateUrl: 'app/main/gerenciamentocarga/totalizador/views/gerenciamento-carga-totalizador.html'
                },
                leiturista: {
                    templateUrl: 'app/main/gerenciamentocarga/leiturista/views/gerenciamento-carga-leiturista.html',
                    dialogs: {
                        disponibilizarCarga: 'app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-disponibilizar-carga.html',
                        gerarArquivoRetorno: 'app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-baixar-arquivo-retorno.html',
                        disponibilizarTarefa: 'app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-disponibilizar-tarefas.html'
                    }
                },
                filtro: {
                    templateUrl: 'app/main/gerenciamentocarga/sidenavs/filtro/views/gerenciamento-carga-filtro.html'
                },
                caema: {
                    sidenav: {
                        filtro: {
                            templateUrl: 'app/main/gerenciamentocarga/sidenavs/filtro/views/CAEMA/gerenciamento-carga-caema-filtro.html'
                        }
                    }
                }
            },

            tipoServico: {
                templateUrl: 'app/main/cadastros/tiposervico/views/tiposervico.html',
                form: 'app/main/cadastros/tiposervico/views/tiposervico-form.html',
                tabela: 'app/main/cadastros/tiposervico/views/tiposervico-tabela.html'
            },

            importacaoGrupoLeitura: {
                templateUrl: 'app/main/processamento/importacao-grupo-leitura/views/importacao-grupo-leitura.html',
                form: 'app/main/processamento/importacao-grupo-leitura/views/importacao-grupo-leitura-form.html',
                caema: {
                    form: 'app/main/processamento/importacao-grupo-leitura/views/CAEMA/importacao-grupo-leitura-caema-form.html'
                }
            },

            distribuicao: {
                templateUrl: 'app/main/processamento/distribuicao/views/distribuicao.html',
                form: 'app/main/processamento/distribuicao/views/distribuicao-form.html',
                sidenav: {
                    filtroDistribuicao: 'app/main/processamento/distribuicao/sidenav/filtro/views/distribuicao-filtro.html'
                },
                dialogs: {
                    mensagemTipoDistribuicao: 'app/main/processamento/distribuicao/dialogs/dialog-mensagem-tipo-distribuicao/views/dialog-mensagem-tipo-distribuicao.html',
                    selecionarSetores: 'app/main/processamento/distribuicao/dialogs/dialog-selecionar-setor/views/dialog-selecionar-setor.html',
                    unificarTarefas: 'app/main/processamento/distribuicao/dialogs/dialog-unificar-tarefas/views/dialog-unificar-tarefas.html',
                    selecionarQuadras: 'app/main/processamento/distribuicao/dialogs/dialog-selecionar-quadra/views/dialog-selecionar-quadra.html',
                    calculoDistribuicaoAutomatica: 'app/main/processamento/distribuicao/dialogs/dialog-calculo-distribuicao-automatica/views/dialog-calculo-distribuicao-automatica.html',
                },
                caema: {
                    form: 'app/main/processamento/distribuicao/views/CAEMA/distribuicao-form-caema.html',
                    sidenav: {
                        filtroDistribuicao: 'app/main/processamento/distribuicao/sidenav/CAEMA/filtro/distribuicao-filtro-caema.html'
                    }
                }
            },

            cronogramaGrupos: {
                templateUrl: 'app/main/cadastros/cronogramagrupos/views/cronograma-grupo.html',
                form: 'app/main/cadastros/cronogramagrupos/views/cronograma-grupo-form.html',
                tabela: 'app/main/cadastros/cronogramagrupos/views/cronograma-grupo-tabela.html',
                caema: {
                    form: 'app/main/cadastros/cronogramagrupos/views/CAEMA/cronograma-grupo-form-caema.html'
                }
            },

            gerenciamentoGrupo: {
                templateUrl: 'app/main/processamento/gerenciamentogrupo/views/gerenciamento-grupo.html',
                form: 'app/main/processamento/gerenciamentogrupo/views/gerenciamento-grupo-form.html',
                sidenav: {
                    filtro: 'app/main/processamento/gerenciamentogrupo/sidenav/filtro/views/gerenciamento-grupo-filtro.html',
                    legenda: 'app/main/processamento/gerenciamentogrupo/sidenav/legenda-cores/views/gerenciamento-grupo-legenda-cores.html',

                },
                dialogs: {
                    caema: {
                        tarefas: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/views/CAEMA/dialog-tarefas-caema.html'
                    },
                    tarefas: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/views/dialog-tarefas.html',
                    distribuicao: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-distribuicao/gerenciamento-grupo-dialog-distribuicao.html',
                    disponibilizarTarefas: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-disponibilizar-tarefa/dialog-tarefas-disponibilizar-tarefas.html',
                    importacaoGrupoLeitura: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-importacao/gerenciamento-grupo-dialog-importacao.html',
                    exportacaoGrupoLeitura: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-exportacao/gerenciamento-grupo-dialog-exportacao.html',
                    datasGrupo: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-datas-grupo/views/dialog-datas-grupo.html',
                    dialogLegenda: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-datas-grupo/dialog-legenda/dialog-legenda.html',
                    rotas: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-rotas/views/dialog-rotas.html',
                    trocarLeiturista: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-troca-leiturista/dialog-trocar-leituristas.html',
                    detalhesUnificao: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-detalhes-unificacao/views/dialog-detalhes-unificacao.html'
                },
                caema: {
                    form: 'app/main/processamento/gerenciamentogrupo/views/CAEMA/gerenciamento-grupo-caema-form.html',
                    sidenav: {
                        filtro: 'app/main/processamento/gerenciamentogrupo/sidenav/filtro/views/CAEMA/gerenciamento-grupo-filtro-caema.html'
                    },
                    dialogs: {
                        selecionarSetores: 'app/main/processamento/gerenciamentogrupo/dialogs/dialog-selecionar-setor/views/dialog-selecionar-setores.html'
                    }
                }
            },

            disponibilizarTarefas: {
                templateUrl: 'app/main/processamento/disponibilizar-tarefas/views/disponibilizar-tarefas.html',
                form: 'app/main/processamento/disponibilizar-tarefas/views/disponibilizar-tarefas-form.html',
                caema: {
                    form: 'app/main/processamento/disponibilizar-tarefas/views/CAEMA/disponibilizar-tarefas-form-caema.html'
                },
                multiplosGrupos: {
                    form: 'app/main/processamento/disponibilizar-tarefas/views/multiplos-grupos/disponibilizar-tarefas-form-multiplos-grupos.html'
                }
            },

            exportacaoGrupoLeitura: {
                templateUrl: 'app/main/processamento/exportacao-grupo-leitura/views/exportacao-grupo-leitura.html',
                form: 'app/main/processamento/exportacao-grupo-leitura/views/exportacao-grupo-leitura-form.html',
                caema: {
                    form: 'app/main/processamento/exportacao-grupo-leitura/views/CAEMA/exportacao-grupo-leitura-caema-form.html'
                },
                bauru: {
                    form: 'app/main/processamento/exportacao-grupo-leitura/views/BAURU/exportacao-grupo-leitura-bauru-form.html'
                },
                fiorilli: {
                    form: 'app/main/processamento/exportacao-grupo-leitura/views/FIORILLI/exportacao-grupo-leitura-fiorilli-form.html'
                }
            },

            especieDocumento: {
                templateUrl: 'app/main/cadastros/relacionados/especie-documento/views/especie-documento.html',
                form: 'app/main/cadastros/relacionados/especie-documento/views/especie-documento-form.html',
                tabela: 'app/main/cadastros/relacionados/especie-documento/views/especie-documento-tabela.html'
            },

            boletoBancario: {
                templateUrl: 'app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario.html',
                form: 'app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario-form.html',
                tabela: 'app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario-tabela.html'
            },

            municipio: {
                templateUrl: 'app/main/cadastros/localizacao/municipios/views/municipio.html',
                form: 'app/main/cadastros/localizacao/municipios/views/municipio-form.html',
                tabela: 'app/main/cadastros/localizacao/municipios/views/municipio-tabela.html'
            },

            regional: {
                templateUrl: 'app/main/cadastros/localizacao/regionais/views/regional.html',
                form: 'app/main/cadastros/localizacao/regionais/views/regional-form.html',
                tabela: 'app/main/cadastros/localizacao/regionais/views/regional-tabela.html'
            },

            agrupamento: {
                templateUrl: 'app/main/cadastros/localizacao/agrupamentos/views/agrupamento.html',
                form: 'app/main/cadastros/localizacao/agrupamentos/views/agrupamento-form.html',
                tabela: 'app/main/cadastros/localizacao/agrupamentos/views/agrupamento-table.html'
            },

            controleCarga: {
                trocarSequencial: {
                    templateUrl: 'app/main/controlecarga/trocarsequencial/views/trocar-sequencial.html',
                    form: 'app/main/controlecarga/trocarsequencial/views/trocar-sequencial-form.html',
                    sidenav: {
                        filtro: 'app/main/controlecarga/trocarsequencial/sidenav/filtro/views/filtro-trocar-sequencial.html'
                    },
                    dialogs: {
                        alterarNumeroSequencial: 'app/main/controlecarga/trocarsequencial/dialogs/alterarsequencial/views/dialog-alterar-sequencial-tarefa.html'
                    }
                },
                trocarLeiturista: {
                    templateUrl: 'app/main/controlecarga/trocarleiturista/views/trocar-leiturista.html',
                    form: 'app/main/controlecarga/trocarleiturista/views/trocar-leiturista-form.html',
                    sidenav: {
                        filtro: 'app/main/controlecarga/trocarleiturista/sidenav/filtro/views/filtro-trocar-leiturista.html'
                    }
                },
                cancelarcarga: {
                    templateUrl: 'app/main/controlecarga/cancelarcarga/views/cancelar-carga.html',
                    form: 'app/main/controlecarga/cancelarcarga/views/cancelar-carga-form.html',
                    sidenav: {
                        filtro: 'app/main/controlecarga/cancelarcarga/sidenav/filtro/views/filtro-cancelar-carga.html'
                    }
                },
                faturasretidas: {
                    templateUrl: 'app/main/controlecarga/faturas-retidas/views/faturas-retidas.html',
                    form: 'app/main/controlecarga/faturas-retidas/views/faturas-retidas-form.html',
                    sidenav: {
                        filtro: 'app/main/controlecarga/faturas-retidas/components/sidenav/sidenav-faturas-retidas.html'
                    }
                }
            },

            pagamentoPix: {
                templateUrl: 'app/main/cadastros/relacionados/pagamento-pix/views/pagamento-pix.html',
                form: 'app/main/cadastros/relacionados/pagamento-pix/views/pagamento-pix-form.html',
                tabela: 'app/main/cadastros/relacionados/pagamento-pix/views/pagamento-pix-tabela.html',
                tabs: {
                    configuracoes: 'app/main/cadastros/relacionados/pagamento-pix/views/tabs/tab-configuracoes/tab-configuracoes.html',
                    integracao: 'app/main/cadastros/relacionados/pagamento-pix/views/tabs/tab-integracao/tab-integracao.html'
                }
            },

            exclusaoArquivo: {
                templateUrl: 'app/main/processamento/exclusao-arquivo/views/exclusao-arquivo-form.html',
                form: 'app/main/processamento/exclusao-arquivo/views/exclusao-arquivo-form.html'
            },

            downloadfotos: {
                templateUrl: 'app/main/processamento/download-fotos/views/download-fotos.html',
                form: 'app/main/processamento/download-fotos/views/download-fotos-form.html',
            },

            alertaCliente: {
                templateUrl: 'app/main/processamento/alerta-cliente/views/alerta-cliente.html',
                form: 'app/main/processamento/alerta-cliente/views/alerta-cliente-form.html',
                dialogs: {
                    dialogCadastrarAlerta: 'app/main/processamento/alerta-cliente/views/dialogs/dialog-cadastrar-alerta/views/dialog-cadastrar-alerta.html',
                }
            },

            disponibilizarCargaRetidas: {
                templateUrl: 'app/main/processamento/disponibilizar-carga-retidas/views/disponibilizar-carga-retidas.html',
                form: 'app/main/processamento/disponibilizar-carga-retidas/views/disponibilizar-carga-retidas-form.html',
                dialogs: {
                    dialogSelecionarLeiturista: 'app/main/processamento/disponibilizar-carga-retidas/views/dialog-selecionar-leiturista/views/dialog-selecionar-leiturista.html',
                    dialogDetalhesDependentes: 'app/main/processamento/disponibilizar-carga-retidas/views/dialog-detalhes-dependentes/views/dialog-detalhes-dependentes.html'
                }
            },

            cancelamentoFaturasRetidas: {
                form: 'app/main/processamento/cancelamento-faturas-retidas/views/cancelamento-faturas-retidas-form.html',
                templateUrl: 'app/main/processamento/cancelamento-faturas-retidas/views/cancelamento-faturas-retidas.html'
            }
        });
})();

(function () {
  'use strict';

  angular
    .module('app.constants')
    .constant('Regex', {
      telefone: /\([1-9]{2}\)\s?[0-9]{4,5}\-[0-9]{4}$/,
      cpf: /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/,
      cnpj: /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/,
      cpfCnpj: /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/,
      data_hora: /^(\d{2}\/){2}\d{4} \d{2}(:\d{2}){2}$/,
      data: /^(\d{2}\/){2}\d{4}/
    });
})();


(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('MensagemConstant', {
            parametroStringInvalido: 'O parâmetro deve ser uma string',
            parametroObjectInvalido: 'O parâmetro deve ser um objeto',
            parametroFuncaoInvalida: 'O parâmetro dever ser uma função',
            parametroBoleanoInvalida: 'O parâmetro dever ser um boleano',
            parametroNumeroInvalido: 'O parâmetro dever ser um numero',
            parametroArrayInvalido: 'O parâmetro dever ser um array'
        });
})();

/**
 * Created by nova on 18/07/2016.
 */
/*
  http://192.168.0.108:8051/
  http://localhost:59186/
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('KeysSessionStorage', {
            compatibilidade: 1,

            parametrosEmpresa: "parametrosEmpresa",
            historicoComandosDatamobil: "historicoComandosDatamobil",
            tipoDetalheCalculo: "tipoDetalheCalculo",
            tipoProcesso: "tipoProcesso",
            usuarioAgrupamentos: "usuarioAgrupamentos"

        });

})();

/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('DataTableConfigPadrao', {
            dtOptions: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [5, 10, 15, 20],
                pageLength: 5,
                responsive: true,
                language: {
                    infoEmpty: "Não existem dados para exibição",
                    emptyTable: "Não existem dados para exibição",
                    zeroRecords: "Não existem dados para exibição",
                    info: "_START_ a _END_",
                    sInfoFiltered: "(filtrado de  _MAX_ registro(s))",
                    lengthMenu: "Exibir _MENU_ linhas",
                    search: "Pesquisar: ",
                    paginate: {
                        "first": "<<",
                        "last": ">>",
                        "next": ">",
                        "previous": "<"
                    },
                }
            },
            dtOptionsPadraoComPaginacaoEReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [10, 15, 20, 25],
                pageLength: 10,
                responsive: true,
            },
            dtOptionsPadraoComPaginacaoPaginTypeNumbersEReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [100],
                pageLength: 100,
                responsive: true,
            },
            dtOptionsPadraoComPaginacaoNaoReponsivo: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [10, 15, 20, 25],
                pageLength: 10,
                responsive: false,
            },
            dtOptionsResponsivoSemPaginacao: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                paging: false,
                responsive: true
            },
            dtOptionsResponsivoSemPaginacaoComInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false,
                responsive: true,
            },
            dtOptionsNaoResponsivoSemPaginacaoComInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                responsive: false,
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                paging: false
            },
            dtOptionsResponsivoPaginacaoTipoNumberComInitComplete: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'numbers',
                lengthMenu: [10, 30, 50, 100],
                pageLength: 10,
                responsive: true,

            },
            dtOptionsResponsivoComPaginacaoComScrollYEInitComplete: {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');
                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                scrollY: 'auto',
                pagingType: 'numbers',
                lengthMenu: [100],
                pageLength: 100,
                responsive: true,
                order: []
            },
            dtOptionsResponsivoSemPaginacaoComScrollYEInitComplete: {
                dom: 'rt<"bottom"<"left"<"info"i>>>',
                initComplete: function () {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#pesquisar');

                    // Bind an external input as a table wide search box
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                orderMulti: true,
                scrollY: 'auto',
                responsive: true,
                paging: false
            },
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#pesquisar');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            columnDefsPadrao: {
                targets: 0,
                ordering: false,
                filterable: false,
                sortable: false,
                responsivePriority: 1
            }

        });

})();

(function () {
  "use strict";

  angular.module("app.constants").constant("ControleAcessoConfig", {
    configuracao: {
      path_logo_small: "/assets/images/logos/logo-small.png",
      path_logo: "/assets/images/logos/reader.png",
      path_logo_inovamobil: "/assets/images/logos/inovamobil.png",
      aplicacao: "Reader Web®",
      descricao_aplicacao: "Sistema de gerenciamento de leitura",
      estado_home: "app.inicio",
      versao: "11.00",
      release: "1/C",
    },
    key_token: "ICM_TKN",
    key_usuario: "ICM_USER",
    key_modo_implantacao: "false",
  });
})();

/**
 * Created by nova on 18/07/2016.
 */
/*
  http://192.168.0.108:8051/
  http://localhost:59186/
 */
(function () {
  "use strict";

  angular.module("app.constants").constant("Api", {
    compatibilidade: 1,

    estatisticas: {
      retornarArquivos: "api/estatistica/retornaArquivos",
      gerarRelatorio: "api/relatorios/gerarRelatorioEstatisticas",
    },

    parametros: {
      api: "api/parametros",
      editar: "api/parametros",
      dadosParametro: "api/parametros/dadosparametro",
      listarPorPaginacao: "api/parametros/listarcompaginacao",
      listasParametro: "api/parametros/listasparametro",
      uploadLogomarca: "api/parametros/uploadlogomarca",
      tipoProcesso: "api/parametros/tipoprocesso",
      imagensPersonalizacao: "api/parametros/imagensPersonalizacao",
      logomarcaStream: "api/parametros/logomarcaStream",
      marcaEspecial: "api/parametros/marcaEspecial",
    },

    usuario: {
      listartodos: "api/controleacesso/usuario/listartodos",
      retornarUsuarioPorId: "api/controleacesso/usuario/",
      retornarUsuarioPorUsuarioSenha: "api/controleacesso/usuario/",
      retornaProximoCodigo: "api/controleacesso/usuario/ProximoCodigo",
      confirmarSenha: "api/controleacesso/usuario/ConfirmarSenha/",
      confirmarSenhaPorCodigo:
        "api/controleacesso/usuario/ConfirmarSenhaPorCodigo/",
      criar: "api/controleacesso/usuario/",
      excluir: "api/controleacesso/usuario/",
      atualizar: "api/controleacesso/usuario",
      alterarsenha: "api/controleacesso/usuario/alterarsenha",
      listarPorPaginacao: "api/controleacesso/usuario/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/controleacesso/usuario/listarcompaginacaodatatable",
      selecionarPerfilUsuario: "api/uc_usuario/selecionarPerfilUsuario/",
      vincularAgrupamentos: "api/uc_usuario/vincularAgrupamentos",
      listarAgrupamentos: "api/uc_usuario",
      selecionarPorLogin: "api/uc_usuario/selecionarPorLogin/",
    },
    token: {
      criar: "api/seguranca/token",
    },
    controleAcesso: {
      login: "api/controleacesso/login",
    },
    perfil: {
      listartodos: "api/controleacesso/perfil/listartodos",
      retornarUsuarioPorId: "api/controleacesso/perfil/",
      retornarUsuarioPorUsuarioSenha: "api/controleacesso/perfil/",
      retornaProximoCodigo: "api/controleacesso/perfil/ProximoCodigo",
      criar: "api/controleacesso/perfil/",
      excluir: "api/controleacesso/perfil/",
      atualizar: "api/controleacesso/perfil",
      alterarsenha: "api/controleacesso/perfil/alterarsenha",
      listarpor: "api/controleacesso/perfil/listarpor",
      listarPorPaginacao: "api/controleacesso/perfil/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/controleacesso/perfil/listarcompaginacaodatatable",
      listarUsuariosPerfil: "api/uc_perfil/listarPerfis",
    },

    modoimplantacao: {
      api: "api/modoimplantacao",
      validarSenhaImplantacao: "api/modoimplantacao/validacodigohdn/",
    },

    backupbancodados: {
      realizarBackupBancoDados: "api/backupbancodados/realizarBackupBancoDados",
      listarTodos: "api/backupbancodados/listarTodos",
    },

    arquivo: {
      proximocodigo: "api/arquivo/proximocodigo",
      listartodos: "api/arquivo/listartodos",
      listarPorPaginacao: "api/arquivo/listarcompaginacao",
      listarPorPaginacaoDatatable: "api/arquivo/listarcompaginacaodatatable",
      criar: "api/arquivo/",
      editar: "api/arquivo/",
      excluir: "api/arquivo/",
      validar: "api/arquivo/validar",
    },

    enum: {
      listarTodosTiposDeEmpresa: "api/enum/listartodostipodeempresa",
      listarEnumsEquipamento: "api/enum/listarEnumsEquipamento",
      listardicionariosimpressora: "api/enum/listardicionariosimpressora",
      listardicionariosleiturista: "api/enum/listardicionariosleiturista",
      listarOpcoesLeituraFracionada: "api/enum/listaropcoesleiturafracionada",
      listarEnumsProtocolo: "api/enum/listaropcoesprotocolos",
    },

    formularioImpressao: {
      proximocodigo: "api/formularioimpressao/proximocodigo",
      listartodos: "api/formularioimpressao/listartodos",
      listarPorPaginacao: "api/formularioimpressao/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/formularioimpressao/listarcompaginacaodatatable",
      criar: "api/formularioimpressao/",
      editar: "api/formularioimpressao/",
      excluir: "api/formularioimpressao/",
    },

    equipamento: {
      proximocodigo: "api/equipamento/proximocodigo",
      listartodos: "api/equipamento/listartodos",
      listarPorPaginacao: "api/equipamento/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/equipamento/listarcompaginacaodatatable",
      criar: "api/equipamento/",
      editar: "api/equipamento/",
      excluir: "api/equipamento/",
    },

    tipoEntrega: {
      proximocodigo: "api/entrega/proximocodigo",
      listartodos: "api/entrega/listartodos",
      listarPorPaginacao: "api/entrega/listarcompaginacao",
      listarPorPaginacaoDatatable: "api/entrega/listarcompaginacaodatatable",
      criar: "api/entrega/",
      editar: "api/entrega/",
      excluir: "api/entrega/",
    },

    motivoNaoEntrega: {
      proximocodigo: "api/motivonaoentrega/proximocodigo",
      listartodos: "api/motivonaoentrega/listartodos",
      listarPorPaginacao: "api/motivonaoentrega/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/motivonaoentrega/listarcompaginacaodatatable",
      criar: "api/motivonaoentrega/",
      editar: "api/motivonaoentrega/",
      excluir: "api/motivonaoentrega/",
    },

    leiturista: {
      api: "api/leiturista",
      proximocodigo: "api/leiturista/proximocodigo",
      retornarArquivoPadrao: "api/leiturista/retornarArquivoPadrao",
      listarTodos: "api/leiturista/listartodos",
      listarDadosLookup: "api/leiturista/listartodoslookup",
      listarTodosAtivos: "api/leiturista/listartodosativos",
      listarPorPaginacao: "api/leiturista/listarcompaginacao",
      listarPorPaginacaoDatatable: "api/leiturista/listarcompaginacaodatatable",
      listarTodosCodigoNome: "api/leiturista/listarTodosCodigoNome",
      criar: "api/leiturista/",
      editar: "api/leiturista/",
      excluir: "api/leiturista/",
      verificarArquivoImportado: "api/leiturista/verificarArquivoImportado/",
      listarParaChat: "api/leiturista/ListarParaChat",
      listarLeituristasPorRegional:
        "api/leiturista/listarLeituristasPorRegional",
      listarCamposRecadastramento:
        "api/leiturista/listarRecadastramentoPermissaoAlteracao",
      replicarRecadastramentoLeituristas:
        "api/leiturista/replicarRecadastramentoLeituristas",
    },

    ocorrencia: {
      api: "api/ocorrencia",
      proximocodigo: "api/ocorrencia/proximocodigo",
      listarTodos: "api/ocorrencia/listartodos",
      listarTodosMenosNormal: "api/ocorrencia/listartodosmenosnormal",
      listarTodosAtivos: "api/ocorrencia/listartodosativos",
      listarPorPaginacao: "api/ocorrencia/listarcompaginacao",
      listarPorPaginacaoDatatable: "api/ocorrencia/listarcompaginacaodatatable",
      criar: "api/ocorrencia/",
      editar: "api/ocorrencia/",
      excluir: "api/ocorrencia/",
    },

    exportacao: {
      api: "api/ExportacaoColetor",
      existeStringParametrizacao:
        "api/ExportacaoColetor/existeStringParametrizacao/",
      uploadArquivo: "api/ExportacaoColetor/uploadarquivo",
      realizarExportacao: "api/ExportacaoColetor/realizarexportacao",
      criar: "api/ExportacaoColetor/",
      fiorilli: "api/ExportacaoColetor/fiorilli",
      listarLeituristasFiorilli: "api/ExportacaoCarga/listarLeituristasFiorilli",
      exportacaoCargaFiorilli: "api/ExportacaoCarga/Fiorilli",
      exportacaoCargaThema: "api/exportacaocoletor/thema",
    },


    impressora: {
      proximocodigo: "api/impressora/proximocodigo",
      listartodos: "api/impressora/listartodos",
      listarPorPaginacao: "api/impressora/listarcompaginacao",
      listarPorPaginacaoDatatable: "api/impressora/listarcompaginacaodatatable",
      criar: "api/impressora/",
      editar: "api/impressora/",
      excluir: "api/impressora/",
    },

    geracaoArquivoRetorno: {
      retornaListaNomesArquivoExportacao:
        "api/geracaoarquivoretorno/listanomesarquivoexportacao/",
      gerarArquivoRetorno: "api/geracaoarquivoretorno/gerarArquivoRetorno",
      abrirArquivo: "api/geracaoarquivoretorno/abrirArquivo/?nomeArquivo=",
    },

    exportacaoGestor: {
      retornaListaNomesArquivoExportacaoGestor:
        "api/exportacaogestor/listanomesarquivoexportacaogestor/",
      realizarEnvio: "api/exportacaogestor/realizarenvio/",
    },

    relatorios: {
      abrirRelatorio: "api/relatorios/abrir/",
      abrirRelatorioBytes: "api/relatorios/abrirPorBytes/",
      logs: {
        enviaFormulario: "api/logs/relatorios/",
        filtrarDados: "api/logs/filtrarDados",
      },
      estatisticas: {
        enviaFormulario: "api/estatisticas/relatorios/",
      },
      consumoCreditoDebito: {
        enviaFormulario: "api/consumocreditodebito/relatorios",
        gerarRelatorio: "api/readerWeb/ConsumoCreditoDebito",
        visualizarRelatorio: "pdfs/",
      },
      faturamento: {
        enviaFormulario: "api/faturamento/relatorios/",
        listarLocalidades: "api/faturamento/listarLocalidades",
      },
      historicoConsumo: {
        gerarRelatorio: "api/historicoconsumo/gerarRelatorio",
      },
      faturamentoCaema: {
        gerarRelatorio: "api/faturamentocaema/gerarRelatorio",
      },
      comunicadosDebitosImpressos: {
        gerarRelatorioComunicadosDebitoImpressos:
          "api/comunicadosdebitoimpressos/gerarRelatorio",
      },
      clientesPorOcorrencia: {
        gerarRelatorioClientesPorOcorrencia:
          "api/clientesporocorrencia/gerarRelatorio",
      },
      alertaCliente: {
        gerarRelatorio: "api/alertacliente/gerarRelatorio",
      },
      vivaAgua: {
        gerarRelatorio: "api/relatorio-viva-agua/gerarRelatorio",
        retornarClientesLocalidadesPorPlanilha:
          "api/relatorio-viva-agua/retornarClientesLocalidadesPorPlanilha",
        gerarRelatorioPlanilha:
          "api/relatorio-viva-agua/gerarRelatorioPlanilha",
        consultarClientes: "api/relatorio-viva-agua/consultar-clientes",
      },
      faturasRetidas: {
        gerarRelatorio: "api/faturasRetidaPorValor/gerarRelatorio",
      },
      clientesNaoVisitados: {
        gerarRelatorio: "api/clientesnaovisitados/gerarRelatorio",
      },
      personalizado: {
        consultar: "api/relatoriopersonalizado/gerarRelatorio",
      },
    },
    leitura: {
      visualizacao: {
        listarPorPaginacao: "api/visualizacao-leitura/listarcompaginacao",
        listarDadosLeitura: "api/visualizacao-leitura/listarDadosLeitura",
        listarDadosFaturamento:
          "api/visualizacao-leitura/listarDadosFaturamento",
        listarDadosHistorico: "api/visualizacao-leitura/listarDadosHistorico",
        listarDadosServico: "api/visualizacao-leitura/listarDadosServico",
        listarCaminhoFotosLeitura:
          "api/visualizacao-leitura/listarFotosLeitura",
        listarLogLeitura: "api/visualizacao-leitura/logLeitura",
        listarDadosHistoricoAbastecimento:
          "api/controleLancamentoConsumo/Listar",
        emitirSegundaVia: "api/segunda-via-fatura/gerarRelatorio",
        emitirSegundaViaOcorrencia: "api/relatorios/segunda-via-comunicado/ocorrencia"
      },
      rastreamento: {
        filtrar: "api/leitura/rastreamento",
      },
      cancelamentoDinamico: {
        gerarSenhaCancelamento:
          "api/cancelamentoDinamico/gerarSenhaCancelamento",
      },
    },
    tipoServico: {
      salvar: "api/tiposervico",
      editar: "api/tiposervico",
      excluir: "api/tiposervico/",
      listarPorPaginacao: "api/tiposervico/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/tiposervico/listarcompaginacaodatatable",
    },

    importacao: {
      verificarArquivoGrupoImportado:
        "api/importacaoGrupoLeitura/verificarArquivoGrupoImportado/",
      criar: "api/importacaoGrupoLeitura",
      removerGrupoLeitura: "api/importacaoGrupoLeitura/",
      importarBauru: "api/importacaoGrupoLeitura/importarBauru",
      importacaoFiorilli: "api/importacaogrupoleitura/importarfiorilli",
    },

    distribuicao: {
      verificarLeituraExisteGrupo:
        "api/distribuicao/verificarLeiturasExistentesGrupo",
      consistirLeiturasDistribuidas:
        "api/distribuicao/consistirLeiturasDistribuidas",
      carregarDadosDistribuicaoPorRota:
        "api/distribuicao/carregarDadosDistribuicaoPorRota",
      validarExecucaoDistribuicao:
        "api/distribuicao/validarExecucaoDistribuicao",
      dividirTarefa: "api/distribuicao/dividirTarefa",
      retornarGruposLeitura: "api/distribuicao/pesquisarGruposLeitura/",
      retornarTarefas: "api/distribuicao/pesquisarTarefas/",
      retornarTipoDistribuicao: "api/distribuicao/retornartipodistribuicao",
    },

    menu: {
      listarporperfil: "api/menus/listarporperfil/",
      atualizar: "api/menus",
    },
    gerenciamentoGrupo: {
      realizarFiltroGrupos:
        "api/gerenciamentogruposleitura/realizarFiltrosGrupos",
      realizarFiltroTarefas:
        "api/gerenciamentogruposleitura/realizarFiltrosGrupoTarefas",
    },
    disponibilizacaoTarefa: {
      pesquisarTarefas: "api/disponibilizacaotarefa/pesquisarTarefas/",
      disponibilizarTarefa: "api/disponibilizacaotarefa/disponibilizartarefa",
      disponibilizarMultiplasTarefas:
        "api/disponibilizacaotarefa/disponibilizarmultiplastarefas",
      retornarGruposLeitura:
        "api/disponibilizacaotarefa/pesquisarGruposLeitura/",
    },

    exportacaoGrupoLeitura: {
      gerarExportacaoGrupo: "api/exportacaoGrupoLeitura/gerarExportacaoGrupo",
      validarExportacaoGrupo:
        "api/exportacaoGrupoLeitura/validarExportacaoGrupo",
      verificarRetencoesPendentes:
        "api/exportacaoGrupoLeitura/verificarRetencoesPendentes",
      buscarSequencialControleEnvio:
        "api/exportacaoGrupoLeitura/buscarSequencialControleEnvio",
      retornarRotasDisponiveisExportacao:
        "api/exportacaoGrupoLeitura/retornarRotasDisponiveisExportacao",
      gravarGrupoLeituraControleDowloadArquivo:
        "api/exportacaoGrupoLeitura/gravarGrupoLeituraControleDowloadArquivo",
      listarLeituristas: "api/exportacaoGrupoLeitura/listarLeituristas",
    },

    cronogramaGrupos: {
      salvar: "api/cronogramaGrupo",
      editar: "api/cronogramaGrupo",
      excluir: "api/cronogramaGrupo/",
      listarPorPaginacao: "api/cronogramaGrupo/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/cronogramaGrupo/listarcompaginacaodatatable",
    },

    chat: {
      ListarMensagensCentral: "api/chat/ListarMensagensCentral",
      VerificarNovasMensagens: "api/chat/VerificarNovasMensagens",
    },

    municipio: {
      criar: "api/municipio/",
      atualizar: "api/municipio/",
      remover: "api/municipio/",
      listarPorPaginacao: "api/municipio/listarPorPaginacao/",
      listarPorPaginacaoDatatable: "api/municipio/listarPorPaginacaoDatatable",
      proximoCodigo: "api/municipio/proximoCodigo",
      retornarMunicipios: "api/municipio/listarMunicipios",
      listarMunicipios: "api/municipio/listarMunicipios",
    },

    regional: {
      criar: "api/regional/",
      atualizar: "api/regional/",
      remover: "api/regional/",
      listarPorPaginacao: "api/regional/listarPorPaginacao/",
      listarPorPaginacaoDatatable: "api/regional/listarPorPaginacaoDatatable",
      proximoCodigo: "api/regional/proximoCodigo",
      retornarRegionais: "api/regional/listarRegionais",
      listarGruposPorRegional: "api/regional/listarGruposRegional",
      listarGruposRegionalCancelamento:
        "api/regional/listarGruposRegionalCancelamento",
      listarMunicipiosPorRegional: "api/regional/listarMunicipiosRegionalGrupo",
      listarMunicipiosPorMultiplosGrupos:
        "api/regional/listarMunicipiosRegionalMultiplosGrupos",
      listarTarefasPorRegionalMunicipio:
        "api/regional/listarTarefasPorRegionalMunicipio",
      listarTarefasMultiplosGrupos:
        "api/regional/listarTarefasPorMultiplosGrupos",
      listar: "api/regional/listarTodos",
      listarTodos: "api/regional/listarImportacao",
    },

    agrupamento: {
      criar: "api/agrupamento/",
      atualizar: "api/agrupamento/",
      remover: "api/agrupamento/",
      listarPorPaginacao: "api/agrupamento/listarPorPaginacao/",
      listarPorPaginacaoDatatable:
        "api/agrupamento/listarPorPaginacaoDatatable",
      proximoCodigo: "api/agrupamento/proximoCodigo",
      retornarAgrupamentos: "api/agrupamento/listarAgrupamentos",
      listarGruposPorAgrupamento: "api/agrupamento/listarGruposAgrupamento",
      listar: "api/agrupamento/listarTodos",
      listarTodos: "api/agrupamento/listarImportacao",
    },

    criticaLeituras: {
      filtrarLeituras: "api/criticaLeituras/filtrarLeituras",
      atualizarDadosLeitura: "api/criticaLeituras/atualizarDadosLeitura",
      filtrarGruposComLeituraRetidas:
        "api/criticaLeituras/filtrarGruposComLeituraRetida/",
      filtrarCriticas: "api/criticaLeituras/filtrarCriticas",
      buscarHistoricoCritica: "api/criticaLeituras/listarHistoricoCritica",
      buscarHistoricoLeiturasFotos:
        "api/criticaleituras/buscarhistoricoleiturafotos",
      atualizarDadosCritica: "api/criticaLeituras/atualizarDadosCritica",
      liberarCriticasDistribuicao:
        "api/criticaLeituras/liberarCriticasDistribuicao",
      verificarHistoricoEmAberto:
        "api/criticaLeituras/verificarHistoricoEmAberto",
      buscarDadosAcompanhamentoCriticas:
        "api/criticaLeituras/buscarDadosAcompanhamentoCritica",
      buscarDadosOcorrenciaCritica: "api/criticaLeituras/buscarDadosOcorrencia",
      retornaUltimoHistoricoCritica:
        "api/criticaLeituras/retornaUltimoHistoricoCritica",
      buscarListaFotosVisita: "api/criticaLeituras/buscarListaFotosVisita",
    },

    integracao: {
      downloadFotosPorNomeArquivo:
        "api/integracao/fotos/downloadFotosPorNomeArquivo",
      validarExportacaoGrupo:
        "api/exportacaoGrupoLeitura/validarExportacaoGrupo",
    },

    especieDocumento: {
      criar: "api/especiesDocumentos/",
      atualizar: "api/especiesDocumentos/",
      remover: "api/especiesDocumentos/",
      listarPorPaginacao: "api/especiesDocumentos/listarPorPaginacao/",
      listarPorPaginacaoDatatable:
        "api/especiesDocumentos/listarPorPaginacaoDatatable",
      proximoCodigo: "api/especiesDocumentos/proximoCodigo",
      listar: "api/especiesDocumentos/listarTodos",
    },

    boletoBancario: {
      criar: "api/boletos/",
      atualizar: "api/boletos/",
      remover: "api/boletos/",
      listarPorPaginacao: "api/boletos/listarPorPaginacao/",
      listarPorPaginacaoDatatable: "api/boletos/listarPorPaginacaoDatatable",
      proximoCodigo: "api/boletos/proximoCodigo",
      listar: "api/boletos/listarTodos",
    },

    gerenciamentoCarga: {
      buscarDadosIniciais: "api/gerenciamentocarga",
    },

    controleFluxo: {
      filtrarDadosControleCargaFluxo:
        "api/controlecargafluxo/filtrarDadosControleCargaFluxo",
    },

    trocaSequencial: {
      listarTarefas: "api/trocaSequencial/listarTarefas/",
      alterarSequencialTarefas: "api/trocaSequencial/alterarSequencialTarefas",
      listarTarefasMultiplosGrupos:
        "api/trocaSequencial/ListarTarefasMultiplosGrupos/",
      alterarSequencialTarefasMultiplosGrupos:
        "api/trocaSequencial/alterarSequencialTarefasMultiplosGrupos",
    },

    trocarLeiturista: {
      buscarTarefas: "api/trocaLeiturista/buscarTarefas",
      filtrarDadosTarefaTroca: "api/trocaLeiturista/filtrarDadosTarefaTroca",
      salvarTrocaLeiturista: "api/trocaLeiturista/salvarTrocaLeiturista",
      validarTrocaLeiturista: "api/trocaLeiturista/validarTrocaLeiturista",
      filtrarDadosTrocaMultiplosGrupos:
        "api/trocaleiturista/filtrarTarefasMultiplosGrupos",
      salvarTrocaLeituristaMultiplosGrupos:
        "api/trocaleiturista/salvarTrocaLeituristaMultiplosGrupos",
    },

    cancelarTarefa: {
      cancelar: "api/cancelamentotarefa/cancelarTarefa",
      validar: "api/cancelamentotarefa/validarTarefa",
    },

    produtividade: {
      retornaGruposPorDataInicioDataFim:
        "api/produtividade/retornaGruposPorDataInicioDataFim",
      retornaLeituristaPorGleiCodigo:
        "api/produtividade/retornaLeituristaPorGleiCodigo",
      filtrarDadosProdutividade: "api/produtividade/filtrarDadosProdutividade",
      buscarDadosDetalheProdutividade:
        "api/produtividade/buscarDadosDetalheProdutividade",
      buscarDadosDetalheCritica: "api/produtividade/buscarDadosDetalheCritica",
    },

    cancelarCarga: {
      filtrarDadosCancelamento:
        "api/cancelamentocarga/filtrarDadosCancelamento",
      cancelar: "api/cancelamentocarga/cancelarCarga",
    },

    faturasRetidas: {
      listarFaturasRetidas:
        "api/ControleCargasFaturasRetidas/Listar",
      listarLigacoesRetidas:
        "api/ControleCargasFaturasRetidas/ListarLigacoesRetidas",
    },

    clienteOcorrencia: {
      filtrarClientesOcorrencia:
        "api/clienteocorrencia/filtrarClientesOcorrencia",
      retornarFotosClientesOcorrencia:
        "api/clienteocorrencia/retornaFotosCliente",
      retornarTodosGrupos: "api/clienteocorrencia/retornarTodosGrupos",
    },

    comunicadosDebitosImpressos: {
      filtrarComunicadosDebitoImpressos:
        "api/comunicadosdebitoimpressos/filtrarComunicadosDebitoImpressos",
    },

    resumoretencoes: {
      filtrarFaturasSimplificado:
        "api/resumoretencoes/filtrarFaturasSimplificado",
      filtrarFaturasDetalhado: "api/resumoretencoes/filtrarFaturasDetalhado",
      filtrarComunicadosDetalhado:
        "api/resumoretencoes/filtrarComunicadosDetalhado",
      filtrarComunicadosSimplificado:
        "api/resumoretencoes/filtrarComunicadosSimplificado",
    },
    quantitativoleituras: {
      filtrarQuantitativoLeituras:
        "api/quantitativoleituras/filtrarQuantitativoLeituras",
    },
    ocorrenciasleiturista: {
      filtrarOcorrenciasLeiturista:
        "api/ocorrenciasleiturista/filtrarOcorrenciaPorLeiturista",
      filtrarOcorrenciaPorLeituristaAgrupadoPorDia:
        "api/ocorrenciasleiturista/filtrarOcorrenciaPorLeituristaAgrupadoPorDia",
    },
    quitacaoanual: {
      filtrarQuitacaoAnualSimplificado:
        "api/resumoquitacaoanual/filtrarQuitacaoAnualSimplificado",
      filtrarQuitacaoAnualDetalhado:
        "api/resumoquitacaoanual/filtrarQuitacaoAnualDetalhado",
    },
    resumodistribuicaogrupos: {
      filtrarDadosDistribuicao:
        "api/resumodistribuicaogruposleitura/filtrarDadosDistribuicao",
    },
    pagamentoPix: {
      criar: "api/pagamentopix/",
      editar: "api/pagamentopix/",
      excluir: "api/pagamentopix/",
      proximocodigo: "api/pagamentopix/proximocodigo",
      listartodos: "api/pagamentopix/listartodos",
      listarPorPaginacao: "api/pagamentopix/listarcompaginacao",
      listarPorPaginacaoDatatable:
        "api/pagamentopix/listarcompaginacaodatatable",
    },

    exclusaoArquivo: {
      filtrarArquivos: "api/exclusaoarquivo/filtrarArquivos",
      validarArquivo: "api/exclusaoarquivo/existeLeitura",
      deletarArquivo: "api/exclusaoarquivo/deletarArquivo",
    },

    downloadFotos: {
      retornarArquivosMesAnoReferencia:
        "api/downloadfotosarquivo/retornarArquivosMesAnoReferencia",
      retornarListagemFotosCliente:
        "api/downloadfotosarquivo/retornarListagemFotosCliente",
      gerarZipDownload: "api/downloadfotosarquivo/gerarZipDownload",
    },

    alertaCliente: {
      listarTodos: "api/alertacliente/ListarTodos",
      salvar: "api/alertacliente",
      editar: "api/alertacliente",
      excluir: "api/alertacliente",
    },

    disponibilizarCargaRetidas: {
      listarFaturasRetidas: "api/LigacaoFaturasRetidas",
      disponibilizarCarga: "api/LigacaoFaturasRetidas",
      disponibilizarUnificadoArquivo:
        "api/LigacaoFaturasRetidas/disponibilizarUnificadoArquivo",
    },

    cancelamentoFaturasRetidas: {
      listarLigacoesRetidasCancelamento:
        "api/LigacaoFaturasRetidas/listarLigacoesRetidasCancelamento",
      cancelarLigacoesRetidas:
        "api/LigacaoFaturasRetidas/cancelarLigacoesRetidas",
    },
  });
})();


(function () {
  'use strict';

  angular
    .module('app.constants')
    .constant('ApiAcesso', {
      baseUrl : 'api/controleacesso/',
      estado_login : 'app.login',
      usuario: {
        baseUrl: 'usuario/',
        listartodos: 'usuario/listartodos',
        alterarsenha: 'alterarsenha',
        listarporperfil: 'usuario/listarporperfil/',
      }
    })
})();

/**
 * Created by nova on 18/07/2016.
 */
/*
  http://192.168.0.108:8051/
  http://localhost:59186/
 */
(function () {
    'use strict';

    angular
        .module('app.constants')
        .constant('ApiAtalhos', {     
            atalhos: {
                listarTodos: 'api/atalhos/ListarTodos/',
                criar: 'api/atalhos',
                atualizar: 'api/atalhos',
                excluir: 'api/atalhos/'
            }
        })

})();


(function () {
  'use strict';

  angular
    .module('app.constants')
    .constant('ApiAcesso', {
      baseUrl : 'api/controleAcesso/',
      estado_login : 'app.login',
      usuario: {
        baseUrl: 'usuario/',
        listartodos: 'usuario/listartodos',
        alterarsenha: 'alterarsenha',
        listarporperfil: 'usuario/listarporperfil/'
      }
    })
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'angular-chartist',
            'chart.js',
            'datatables',
            'gridshore.c3js.chart',
            'nvd3',
            'timer',
            'ui.sortable',
            'ng-sortable',            
            'moment-picker',
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'ngMask',
            

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',            

            // Servico
            'app.service',

            // Filtro
            'app.filtro',

            // Factory
            'app.factory',

            // Compartilhado
            'app.compartilhado',

            // Configs
            'app.configs',

            // Constants
            'app.constants',    

            // Main
            'app'            

        ]);
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(
        $scope,
        $rootScope,
        $location,
        $state
    ) {
        var dadosUrl = $location.search();
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (dadosUrl.login) {
                $state.go('app.loginautomatico',
                    { dados: dadosUrl })
                $rootScope.$broadcast('msSplashScreen::show');
            }
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');

            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
/**
 * Created by nova on 19/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs', [
            'datatables.scroller',
            'lfNgMdFileInput',
            'angular-linq',
            'ui.utils.masks',
            'firebase',
            'ja.qr'
        ]);

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs')
        .config(config);

    function config($translatePartialLoaderProvider) {

        // TRADUÇÃO
        $translatePartialLoaderProvider.addPart('app/config');
        $translatePartialLoaderProvider.addPart('app/compartilhado/mensagens-validacao');
        $translatePartialLoaderProvider.addPart('app/main/inicio');
        $translatePartialLoaderProvider.addPart('app/main/gerenciamento/leitura');
        $translatePartialLoaderProvider.addPart('app/main/processamento');
        $translatePartialLoaderProvider.addPart('app/main/gerenciamentocarga');

        // endregion

        //#region Relatorio
        $translatePartialLoaderProvider.addPart('app/main/relatorios');

        //controle de acesso
        $translatePartialLoaderProvider.addPart('app/main/controleacessomenu/controleacesso');
    }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.configs')
    .config(config);

  function config($mdThemingProvider){
    $mdThemingProvider.theme("success-toast");
    $mdThemingProvider.theme("error-toast");
    $mdThemingProvider.theme("warning-toast");
    $mdThemingProvider.theme("info-toast");
  }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.configs')
    .config(config);

  function config($httpProvider){
    $httpProvider.interceptors.push("InterceptorRequestFactory");
  }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function(){
  'use strict';

  angular
    .module('app.configs')
    .config(config);

  function config($mdDateLocaleProvider){
    $mdDateLocaleProvider.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    $mdDateLocaleProvider.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul',
      'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    $mdDateLocaleProvider.days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo'];

    $mdDateLocaleProvider.shortDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    $mdDateLocaleProvider.msgCalendar = "Calendário";

    $mdDateLocaleProvider.msgOpenCalendar = "Abrir Calendário";

    $mdDateLocaleProvider.formatDate = function(date) {
      if(!date){
        return '';
      }
      return moment(date).format('DD/MM/YYYY');
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

  }

})();

/**
 * Created by nova on 11/08/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.configs')
        .config(config);

    function config($compileProvider) {
        $compileProvider.preAssignBindingsEnabled(true);
    }

})();

/**
 * This sorting plug-in for DataTables will correctly sort data in date time or date
 * format typically used in Germany:
 * date and time:`dd.mm.YYYY HH:mm`
 * just date:`dd.mm.YYYY`.
 *
 * Please note that this plug-in is **deprecated*. The
 * [datetime](//datatables.net/blog/2014-12-18) plug-in provides enhanced
 * functionality and flexibility.
 *
 *  @name Date (dd.mm.YYYY) or date and time (dd.mm.YYYY HH:mm)
 *  @summary Sort date / time in the format `dd.mm.YYYY HH:mm` or `dd.mm.YYYY`.
 *  @author [Ronny Vedrilla](http://www.ambient-innovation.com)
 *  @deprecated
 *
 *  @example
 *    $('#example').dataTable( {
 *       columnDefs: [
 *         { type: 'de_datetime', targets: 0 },
 *         { type: 'de_date', targets: 1 }
 *       ]
 *    } );
 */

jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "date-pt-br-pre": function (a) {
        var regex = /([0-9]{2}\/[0-9]{2}\/[0-9]{4})/gm;
        var data = regex.exec(a);
        if (data) {
            var ukDatea = data[0].split('/');
            return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
        } else { return null; }
    },

    "date-pt-br-asc": function (a, b) {
        console.log(a);
        console.log(b);
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    },

    "date-pt-br-desc": function (a, b) {
        console.log(a);
        console.log(b);
        return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    }
});

// jQuery.extend( jQuery.fn.dataTableExt.oSort, {
//	"de_datetime-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_datetime-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split(' ');
//			var deTimea = deDatea[1].split(':');
//			var deDatea2 = deDatea[0].split('.');
//                        if(typeof deTimea[2] != 'undefined') {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1] + deTimea[2]) * 1;
//                        } else {
//                            x = (deDatea2[2] + deDatea2[1] + deDatea2[0] + deTimea[0] + deTimea[1]) * 1;
//                        }
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split(' ');
//			var deTimeb = deDateb[1].split(':');
//			deDateb = deDateb[0].split('.');
//                        if(typeof deTimeb[2] != 'undefined') {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1] + deTimeb[2]) * 1;
//                        } else {
//                            y = (deDateb[2] + deDateb[1] + deDateb[0] + deTimeb[0] + deTimeb[1]) * 1;
//                        }
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	},
//
//	"de_date-asc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity; // = l'an 1000 ...
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? -1 : ((x > y) ? 1 : 0));
//		return z;
//	},
//
//	"de_date-desc": function ( a, b ) {
//		var x, y;
//		if (jQuery.trim(a) !== '') {
//			var deDatea = jQuery.trim(a).split('.');
//			x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
//		} else {
//			x = Infinity;
//		}
//
//		if (jQuery.trim(b) !== '') {
//			var deDateb = jQuery.trim(b).split('.');
//			y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
//		} else {
//			y = Infinity;
//		}
//		var z = ((x < y) ? 1 : ((x > y) ? -1 : 0));
//		return z;
//	}
//} );

(function () {
    'use strict';

    angular
        .module('fuse')
        .provider('urlApi', geturlApi);

    /** @ngInject */
    function geturlApi(){
        var url;
        return {
            setUrl: function (value) {
                url = value;
            },
            $get: function () {
                return url;
            }
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .run(recarregarPagina);

  /** @ngInject */
  function recarregarPagina($window, LoginUsuarioService, ControleAcessoService, ChatHubService) {
    $window.onload = function () {
      if (!LoginUsuarioService.usuarioArmazenado()) {
        LoginUsuarioService.logout();
        ChatHubService.desconectarHub();
      }
      else {
        setTimeout(function () {
          ChatHubService.conectarHub();
          ChatHubService.notificarNovasMensagens();
        }, 1000)
        ControleAcessoService.recarregarControleAcesso();
      }
    }
  }
})();

/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
    .then(function(registration) {
      // updatefound is fired if service-worker.js changes.
      registration.onupdatefound = function() {
        // updatefound is also fired the very first time the SW is installed,
        // and there's no need to prompt for a reload at that point.
        // So check here to see if the page is already controlled,
        // i.e. whether there's an existing service worker.
        if (navigator.serviceWorker.controller) {
          // The updatefound event implies that registration.installing is set:
          // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function() {
            switch (installingWorker.state) {
              case 'installed':
                // At this point, the old content will have been purged and the
                // fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in the page's interface.
                break;

              case 'redundant':
                throw new Error('The installing ' +
                                'service worker became redundant.');

              default:
                // Ignore
            }
          };
        }
      };
    }).catch(function(e) {
      console.error('Error during service worker registration:', e);
    });
  }

  // Your custom JavaScript goes here
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock(SessionStorageService, KeysSessionStorage, MdDialogService, LoginUsuarioService, $rootScope,
        $timeout, $state, $mdMedia, editableThemes, msNavigationService, MenuFactory, urlApi) {

        $rootScope.title = "..:: Reader Web® ::..";
        $rootScope.tamanhoTelaDesktop = $mdMedia('min-width: 960px');
        $rootScope.interceptorRequestError = {
            unauthorizedError: false,
            notFoundError: false,
            disconnected: false
        };

        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;

        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {

            var handleBlockedRoute = function () {
                var postAlertAction = function () {
                    if (!fromState || !fromState.name) {
                        $state.go('app.login');
                    }
                };

                MdDialogService.alertPadraoComEvento(
                    'Atenção!',
                    postAlertAction,
                    null,
                    'O módulo Datamobil IA não está habilitado. Entre em contato com o suporte para obter mais informações.'
                );
            };

            if (toState.name === 'app.datamobil' && (!urlApi.url_datamobil || urlApi.url_datamobil.includes('${API_URL_DATAMOBIL_IA}'))) {
                e.preventDefault();
                handleBlockedRoute();
                return;
            }

            var usuario = LoginUsuarioService.usuarioArmazenado();

            //botão flutuando para voltar ao topo ta página
            $rootScope.utilizaBotaoScroll = false;
            $rootScope.loadingProgress = true;

            /**
             * Se a váriavel global estiver habilitada 'desabilitarMudancaDeEstadoDaAplicacao' o evento será cancelado e perguntado
             * se o usuário realmente deseja navegar para outro estado
             */
            if ($rootScope.desabilitarMudancaDeEstadoDaAplicacao) {
                e.preventDefault();
                $rootScope.loadingProgress = false;
                MdDialogService.confirmPadraoComEvento("Você realmente deseja sair da tela ?", "Pois todos os dados informados serão perdidos",
                    null,
                    function () {
                        $rootScope.desabilitarMudancaDeEstadoDaAplicacao = false;
                        irParaEstadoSelecionado(toState.name, true)
                    }, null);
            } else if (toState.module === 'privado' && usuario === null) {
                $rootScope.loadingProgress = false;
                e.preventDefault();
                $state.go('app.login');
            } else if (toState.module === 'privado_gerencia' && usuario &&
                (usuario.clsPerfil.descricao.toLocaleLowerCase() !== 'gerência' || usuario.codigoPerfil !== 2)) {
                $rootScope.loadingProgress = false;
                e.preventDefault();
                MdDialogService.alertPadrao("Acesso restrito.", null, null);
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.previousState = fromState.name;
            var parametros = JSON.parse(sessionStorage.getItem('parametros'));
            if (parametros) {
                sessionStorage.removeItem('parametros');
                $rootScope.state.params = parametros;
            }
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            // As funções stateChangeNotFound e stateChangeError não foram definidas no código,
            // então foram comentadas para evitar erros.
            // stateChangeNotFound();
            // stateChangeError();
        });

        // Método padrão para voltar um estado anterior
        $rootScope.voltarEstado = function () {
            $state.go($rootScope.previousState);
        }

        /**
         * Método que recebe o estado, e navega para o estado solicitado
         * @param {nomeEstado} estado
         * @param {boolean} habilitarLoadingProgress
         */
        function irParaEstadoSelecionado(estado, habilitarLoadingProgress) {
            if (habilitarLoadingProgress)
                $rootScope.loadingProgress = true;
            $state.go(estado);
        }
    }
})();
(function() {
  "use strict";

  angular.module("fuse").config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise("/login");

    var layouts = {
      verticalNavigationFullwidthToolbar2: {
        main: "app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html",
        toolbar:
          "app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html",
        navigation:
          "app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html"
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider.state("app", {
      abstract: true,
      module: "publico",
      views: {
        "main@": {
          templateUrl: layouts.verticalNavigationFullwidthToolbar2.main,
          controller: "MainController as vm"
        },
        "toolbar@app": {
          templateUrl: layouts.verticalNavigationFullwidthToolbar2.toolbar,
          controller: "ToolbarController as vm"
        },
        "navigation@app": {
          templateUrl: layouts.verticalNavigationFullwidthToolbar2.navigation,
          controller: "NavigationController as vm"
        }
      }
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, LoginUsuarioService, ControleAcessoService, SessionStorageService, $rootScope, urlApi) {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.nomeSolucao = "Reader Web";
        vm.exibiChatBlip = urlApi.exibir_icone_suporte;

        vm.marcaEspecial = SessionStorageService.recuperar("marcaEspecial");
        if (vm.marcaEspecial && vm.marcaEspecial.utilizarMarcaEspecial) {
            $rootScope.title = "..:: " + vm.marcaEspecial.nomeSolucaoMarcaEspecial + " ::..";
            vm.nomeSolucao = vm.marcaEspecial.nomeSolucaoMarcaEspecial;
        }

        if (LoginUsuarioService.usuarioArmazenado()) {
            ControleAcessoService.recarregarControleAcesso();
        }

        if (vm.exibiChatBlip === '0') {
            angular.element('#blip-chat-container').remove();
            new BlipChat()
                .withAppKey('Y2hhdGJvdGlub3ZhbW9iaWw6ZTA1MWI5ZDItNjUyZi00NzBhLTk1YTMtMWJmOTc1MTdhMzVj')
                .withButton({ "color": "#039BE5", "icon": "" })
                .withCustomCommonUrl('https://inovamobil.chat.blip.ai/')
                .withAccount({
                    email: 'analandia@vx.com.br',
                    extras: {
                        Tipo: 'Aplicativo'
                    }
                })
                .build();
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide, urlApiProvider) {
    $.ajax({
      url: 'app/data/config.json',
      async: false,
      dataType: 'json',
      success: function (data) {
        urlApiProvider.setUrl(data);
      }
    });
    // Put your common app configurations here

    // uiGmapgoogle-maps configuration
    uiGmapGoogleMapApiProvider.configure({
      //    key: 'your api key',
      v: '3.exp',
      libraries: 'weather,geometry,visualization'
    });

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('pt-br');
    $translateProvider.useSanitizeValueStrategy('sanitize');

    // Text Angular options
    $provide.decorator('taOptions', [
      '$delegate', function (taOptions) {
        taOptions.toolbar = [
          ['h1', 'h2', 'h3', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent', 'insertImage'
          ],
        ];

        taOptions.classes = {
          focussed: 'focussed',
          toolbar: 'ta-toolbar',
          toolbarGroup: 'ta-group',
          toolbarButton: 'md-button',
          toolbarButtonActive: 'active',
          disabled: '',
          textEditor: 'form-control',
          htmlEditor: 'form-control'
        };

        return taOptions;
      }
    ]);

    $provide.decorator('$state', ['$delegate', '$window',
      function ($delegate, $window) {
        var extended = {
          goNewTab: function (stateName, parametros) {
            sessionStorage.setItem('parametros', JSON.stringify(parametros));
            var url = this.href(stateName);
            $window.open(url, '_blank');
            sessionStorage.removeItem('parametros');
          }
        };
        angular.extend($delegate, extended);
        return $delegate;
      }
    ]);

    // Text Angular tools
    $provide.decorator('taTools', [
      '$delegate', function (taTools) {
        taTools.quote.iconclass = 'icon-format-quote';
        taTools.bold.iconclass = 'icon-format-bold';
        taTools.italics.iconclass = 'icon-format-italic';
        taTools.underline.iconclass = 'icon-format-underline';
        taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
        taTools.ul.iconclass = 'icon-format-list-bulleted';
        taTools.ol.iconclass = 'icon-format-list-numbers';
        taTools.redo.iconclass = 'icon-redo';
        taTools.undo.iconclass = 'icon-undo';
        taTools.clear.iconclass = 'icon-close-circle-outline';
        taTools.justifyLeft.iconclass = 'icon-format-align-left';
        taTools.justifyCenter.iconclass = 'icon-format-align-center';
        taTools.justifyRight.iconclass = 'icon-format-align-right';
        taTools.justifyFull.iconclass = 'icon-format-align-justify';
        taTools.indent.iconclass = 'icon-format-indent-increase';
        taTools.outdent.iconclass = 'icon-format-indent-decrease';
        taTools.html.iconclass = 'icon-code-tags';
        taTools.insertImage.iconclass = 'icon-file-image-box';
        taTools.insertLink.iconclass = 'icon-link';
        taTools.insertVideo.iconclass = 'icon-filmstrip';

        return taTools;
      }
    ]);

    $provide.decorator('mdDatepickerDirective', function ($delegate) {
      var directive = $delegate[0];

      var template = directive.template;
      var link = directive.link;

      // extending the link function
      directive.compile = function () {
        return function (scope, element, attrs, ctrl) {

          link.apply(this, arguments);
          if (attrs.ngMask) {
            var inputNgModelControl = scope.ctrl.ngInputElement.controller('ngModel')

            // for the first initialization
            inputNgModelControl.$formatters.push(function (value) {
              var viewValue = scope.ctrl.ngInputElement.controller('mdDatepicker').ngModelCtrl.$viewValue;
              if (!viewValue) {
                return undefined;
              }
              return scope.ctrl.$mdDateLocale.formatDate(viewValue);
            })
          }
        };
      };
      // replacing template when needed
      directive.template = function (tElement, tAttrs) {
        var originalTemplate = template.apply(this, arguments);
        // adding mask and ng-model to mdDatepicker's input
        if (tAttrs.ngMask) {
          var element = angular.element(originalTemplate);
          element.find('input').attr('mask', tAttrs.ngMask);
          element.find('input').attr('mask-validate', false);
          element.find('input').attr('ng-model', "ctrl.dateInput");

          // new tempalte with mask and ng-model attributes
          var newTemplate = ''
          for (var i = 0; i < element.length; i++) {
            newTemplate += element[i].outerHTML
          }
          return newTemplate;
        }
        return originalTemplate;
      };
      return $delegate;
    });

  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.gerenciamento.dashboards', [
            'app.gerenciamento.dashboards.clientesocorrencia',
            'app.gerenciamento.dashboards.comunicadosdebitoimpressos',
            'app.gerenciamento.dashboards.resumoretencoes',
            'app.gerenciamento.dashboards.quantitativoleituras',
            'app.gerenciamento.dashboards.ocorrenciasleiturista',
            'app.gerenciamento.dashboards.quitacaoanual',
            'app.gerenciamento.dashboards.distribuicaogrupos',
            'app.gerenciamento.dashboards.controlecargafluxo',
        ]).config(config);

    /** @ngInject */
    function config() {
    }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento.leitura', [
            'app.gerenciamento.leitura.visualizacao',
            'app.gerenciamento.leitura.rastreamento',
            'app.gerenciamento.leitura.monitoramento',
            'app.gerenciamento.leitura.cancelamentodinamico',
        ]).config(config);

    /** @ngInject */
    function config() {

    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.cadastros.usuario', [
            'app.cadastros.usuario.usuario',
            'app.cadastros.usuario.perfil'/*,
        'app.cadastros.usuario.setor'*/
        ])
        .config(Config);

    function Config() {
    }

})();

(function () {
    'use strict';

    angular
        .module('app.cadastros.relacionados', [
            'app.cadastros.relacionados.impressora',
            'app.cadastros.relacionados.cadastroArquivo',
            'app.cadastros.relacionados.formularioImpressao',
            'app.cadastros.relacionados.equipamento',
            'app.cadastros.relacionados.especiaDocumento',
            'app.cadastros.relacionados.boletoBancario',
            'app.cadastros.relacionados.pagamentoPix'
        ]).config(config);

    /** @ngInject */
    function config() {
    }
})();

(function(){
    'use strict';

    angular
        .module('app.cadastros.localizacao', [
            'app.cadastros.localizacao.municipio',
            'app.cadastros.localizacao.regional',
            'app.cadastros.localizacao.agrupamento'
        ]);

}());
(function () {
    'use strict';

    angular
        .module('app.cadastros.entrega', [
            'app.cadastros.entrega.tipoEntrega',
            'app.cadastros.entrega.motivoNaoEntrega'
        ]).config(config);

    /** @ngInject */
    function config() {
    }
})();

(function () {
    'use strict';

    angular
        .module('app.processamento', [
            'app.processamento.geracaoarquivo',
            'app.processamento.exportacaomobile',
            'app.processamento.importacao',
            'app.processamento.distribuicao',
            'app.processamento.gerenciamentogrupo',
            'app.processamento.disponibilizartarefas',
            'app.processamento.exportacaogrupoleitura',
            'app.processamento.exportacaogestor',
            'app.processamento.exclusaoarquivo',
            'app.processamento.downloadfotos',
            'app.processamento.alertacliente',
            'app.processamento.disponibilizarcargaretidas',
            'app.processamento.cancelamentofaturasretidas'
        ]).config(config);


    /** @ngInject */
    function config() {
    }

})();

(function () {
    'use strict';

    angular
        .module('app.relatorios', [
            'app.relatorios.visualizar',
            'app.relatorios.logs',
            'app.relatorios.estatisticas',
            'app.relatorios.faturamento',
            'app.relatorios.historicoconsumo',
            'app.relatorios.alertacliente',
            'app.relatorios.vivaagua',
            'app.relatorios.faturasretidas',
            'app.relatorios.clientesNaoVisitados',
            'app.relatorios.personalizado'
        ])
        .config(config);

    /** @ngInject */
    function config() {

    }

})();

(function () {
  'use strict';

  angular.module('app.controleacessomenu', [
                 'app.controleacessomenu.controlemenu'
  ]).config(config);

  /** @ngInject */
  function config() {

  }
})();

(function () {
    'use strict';

    angular
        .module('app.gerenciamento', [
            'app.gerenciamento.leitura',
            'app.gerenciamento.carga',
            'app.gerenciamento.critica',
            'app.gerenciamento.produtividade',
            'app.gerenciamento.dashboards'
        ]).config(config);

    /** @ngInject */
    function config() {
    }
})();

(function () {
    'use strict';

    angular
        .module('app.ferramentasadministrativas', [
            'app.ferramentasadministrativas.mododeimplantacao',
            'app.ferramentasadministrativas.backupbancodados'
        ]).config(config);

    /** @ngInject */
    function config() {
    }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.erros', [
      'app.erros.manutencao'
    ])
    .config(Config);

  function Config() {
  }

})();

(function () {
    'use strict';

    angular
        .module('app.controlecarga', [
            'app.controlecarga.trocarsequencial',
            'app.controlecarga.trocarleiturista',
            'app.controlecarga.cancelarcarga',
            'app.controlecarga.faturasretidas'
        ]);

}()); 
(function () {
  'use strict';

  angular
    .module('app.cadastros', [
      'app.cadastros.parametros',
      'app.cadastros.leiturista',
      'app.cadastros.ocorrencia',
      'app.cadastros.relacionados',
      'app.cadastros.usuario',
      'app.cadastros.entrega',
      'app.cadastros.tiposervico',
      'app.cadastros.cronogramagrupo',
      'app.cadastros.localizacao'
    ]).config(config);

  /** @ngInject */
  function config() {
  }
})();

/**
 * Created by nova on 27/09/2016.
 */
(function () {
    'use strict';

    angular
        .module('app', [
            'app.inicio',
            'app.login',
            'app.loginautomatico',
            'app.cadastros',
            'app.processamento',
            'app.relatorios',
            'app.ferramentasadministrativas',
            'app.gerenciamento',
            'app.controleacessomenu',
            'app.chat',
            'app.controlecarga',
            'app.erros',
            'app.datamobil'
        ])
        .config(Config);

    function Config(msNavigationServiceProvider) {

        // Navegação
        msNavigationServiceProvider.saveItem('app', {
            title: 'Reader Web',
            group: true,
        });

        msNavigationServiceProvider.saveItem('app.inicio', {
            title: 'Início',
            icon: 'icon-tile-four',
            state: 'app.inicio',
            weight: 1,
        });
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div><md-button \nclass=\"md-fab md-fab-bottom-right scroll-fab\" scroll-class=\"scrolling\" \nscroll-container-tag=\"{{ scrollButtonContainerLocal }}\" aria-label=\"Voltar para o topo\" ng-if=\"utilizaBotaoScroll\">\n<md-tooltip md-direction=\"top\">Voltar para o topo</md-tooltip><md-icon md-font-icon=\"icon-chevron-up\"></md-icon>\n</md-button>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/compartilhado/dialog-alteracao-senha/dialog-alteracao-senha.html","<md-dialog id=\"dialog-alteracao-senha\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form \nname=\"alteracaoSenhaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"RESOURCES.TITULO_ALTERACAO_SENHA\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\"><label translate=\"RESOURCES.SENHA_ATUAL\"></label><input type=\"password\" ng-model=\"vm.senhaAtual\" \nmascara-tamanho-campo=\"10\" mascara-barra-espaco ng-required=\"true\" ng-disabled=\"vm.emProgresso\" md-maxlength=\"10\">\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\">\n<label translate=\"RESOURCES.SENHA_NOVA\"></label><input type=\"password\" ng-model=\"vm.senhaNova\" \nmascara-tamanho-campo=\"10\" ng-required=\"true\" mascara-barra-espaco ng-disabled=\"vm.emProgresso\" md-maxlength=\"10\">\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\">\n<label translate=\"RESOURCES.CONFIRM_SENHA\"></label><input type=\"password\" ng-model=\"vm.confirmacaoSenhaNova\" \nname=\"confirmacaoSenhaNova\" ng-disabled=\"vm.emProgresso\" mascara-barra-espaco mascara-tamanho-campo=\"10\" \nng-required=\"true\" md-maxlength=\"10\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"erroSenha\" ng-if=\"(vm.senhaNova != vm.confirmacaoSenhaNova)\">As senhas devem ser iguais.</div><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"vm.emProgresso\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-if=\"!vm.emProgresso\" ng-click=\"vm.metodosDialog.confirmar();\" \nng-disabled=\"alteracaoSenhaForm.$invalid || (vm.senhaNova != vm.confirmacaoSenhaNova)\" flex><span>Salvar</span>\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div class=\"start-point\" \nng-show=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div class=\"big-circle md-whiteframe-4dp\">\n<md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span class=\"app-title\" \ntranslate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" translate=\"CHAT.START_MESSAGE\">\nSelect contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-show=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" flex layout-align=\"start center\">\n<div class=\"avatar-wrapper\" hide show-gt-sm><img \nng-src=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).diretorioFoto}}\" class=\"avatar\" \nalt=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).apelido}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"vm.leituristas.getById(vm.leituristaSelecionadoId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.leituristas.getById(vm.leituristaSelecionadoId).apelido}}</div></div><div class=\"chat-contact\" layout=\"row\" flex \nlayout-align=\"end center\"><md-datepicker flex-offset-gt-sm=\"5\" ng-change=\"vm.listarConversaAoSairDatePicker()\" \nname=\"dataConversa\" md-max-date=\"vm.dataMaxima\" ng-model=\"vm.dataConversa\" id=\"data-conversa\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data ng-disabled=\"vm.carregandoConversa\"></md-datepicker></div></div></md-toolbar>\n<md-progress-linear class=\"md-accent\" ng-show=\"vm.carregandoConversa\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-content id=\"chat-content\" flex=\"100\" ms-scroll><div class=\"chat-messages\" ng-show=\"vm.chat\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" \nng-class=\"{\'user\': dialog.chtMsgRemetente.toUpperCase() ===\'CENTRAL\', \'contact\': dialog.chtMsgRemetente.toUpperCase() !==\'CENTRAL\'}\">\n<img ng-if=\"dialog.chtMsgRemetente.toUpperCase() !==\'CENTRAL\'\" \nng-src=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).diretorioFoto}}\" class=\"avatar\" \nalt=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).apelido}}\"> <img \nng-if=\"dialog.chtMsgRemetente.toUpperCase() ===\'CENTRAL\'\" class=\"avatar\" ng-src=\"{{vm.user.avatar}}\"><div \nclass=\"bubble\" id=\"vm.chats.indexOf(dialog)\"><div class=\"message\">{{dialog.chtMsgMensagem}}</div><div \nclass=\"time secondary-text\">{{dialog.chtMsgDataHora | date: \"dd/MM/yyyy HH:mm:ss\" }}</div></div></div></div>\n</md-content><div class=\"chat-footer flex-noshrink\" layout=\"row\" ng-hide=\"vm.dataEnvioDiferenteAtual()\" \nlayout-align=\"center center\"><form ng-submit=\"vm.enviarMensagem()\" flex class=\"reply-form\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex md-no-float><textarea ng-keyup=\"vm.enviarMensagem($event)\" \nmd-no-autogrow maxlength=\"150\" ng-disabled=\"vm.desabilitarEnvioMensagem() \" id=\"textAreaMensagem\" \nng-model=\"vm.mensagem\" ng-class=\"{\'grow\': vm.textareaGrow}\" placeholder=\"Type and hit enter to send message\" translate \ntranslate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\r\n                            </textarea></md-input-container>\n<md-button class=\"md-fab\" type=\"submit\" ng-disabled=\"vm.desabilitarEnvioMensagem() || !vm.mensagem\" \naria-label=\"Send message\" translate layout=\"column\" layout-align=\"center center\" \ntranslate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" ng-hide=\"vm.enviandoMensagem\">\n</md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.enviandoMensagem\" \nclass=\"md-accent\"></md-progress-circular></md-button></form></div></div><md-sidenav \nclass=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" md-component-id=\"right-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/chat/sidenavs/right/right-sidenav.html\'\"></md-sidenav></div></div></div>");
$templateCache.put("app/main/datamobil-ia/datamobil-ia.html","<div id=\"datamobil-ia\" class=\"page-layout simple tabbed\" layout=\"column\"><md-button \nclass=\"md-fab md-raised md-mini botao-menu\" aria-label=\"menu\" ng-click=\"vm.metodos.abrirFecharSidenav(\'filtro\')\">\n<md-icon style=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-menu s24\"></md-icon></md-button><div \nclass=\"contador-trial\" ng-if=\"vm.exibirContador && vm.tempoRestante && !vm.tempoRestante.expirado\"><div \nclass=\"contador-trial-conteudo\" ng-class=\"vm.corContador\"><md-icon md-svg-src=\"assets/custom/auto-awesome.svg\">\n</md-icon><span class=\"contador-trial-texto\">Você tem mais</span> <span class=\"contador-trial-tempo\"><span \nng-if=\"vm.tempoRestante.dias > 0\">{{vm.tempoRestante.dias}}d </span><span>\n{{vm.tempoRestante.horas}}:{{vm.tempoRestante.minutos}}:{{vm.tempoRestante.segundos}}</span> </span><span \nclass=\"contador-trial-texto\">de acesso gratuito</span></div></div><div class=\"contador-trial\" \nng-if=\"vm.exibirContador && vm.tempoRestante && vm.tempoRestante.expirado\"><div \nclass=\"contador-trial-conteudo vermelho\"><md-icon md-svg-src=\"assets/custom/auto-awesome.svg\"></md-icon><span \nclass=\"contador-trial-texto\">Seu período trial chegou ao limite.</span></div></div><md-sidenav \nclass=\"sidenav lista-favoritos-sugestoes md-sidenav-right\" md-component-id=\"filtro\" md-whiteframe=\"4\" ms-scroll \nms-sidenav-helper md-disable-backdrop md-disable-close-events id=\"lista-favoritos-sugestoes\"><md-toolbar \nclass=\"toolbar-filtro\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"titulo\"><p class=\"m-0\" flex=\"100\" \nstyle=\"color: rgba(0, 0, 0, 0.87);\r\n              font-size: 2rem;\r\n              font-weight: 600\">Datamobil <span \nclass=\"texto-gradiente-ia\">IA</span></p></div><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirFecharSidenav(\'filtro\')\" aria-label=\"Fechar sidenav\"><md-icon \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"content-filtro\" flex><div class=\"container-sugestoes\" ng-hide=\"true\"><a class=\"btn-notion\" \nhref=\"https://buttery-onion-c2e.notion.site/Generate-Mock-5f6151aacaf64b2fa04d3f749c7967cd?pvs=74\" target=\"_blank\" \nrel=\"noopener noreferrer\"><span>Abrir sugestões</span><md-icon style=\"color: rgba(0, 0, 0, 0.54); margin-right: 8px\" \nmd-font-icon=\"icon-open-in-new s20\"></md-icon></a></div><lista-favoritos \non-comando-selecionado=\"vm.metodos.enviarComandoFavorito(comando)\" carregando=\"vm.carregandoTrial\"></lista-favoritos>\n</md-content></md-sidenav><div class=\"conteudo-principal\" \nng-class=\"{\'sidenav-aberta\': !vm.sidenavAberta, \'conversas-iniciadas\': vm.conversaIniciada}\"><div class=\"titulo\"><h1 \nstyle=\"font-size: 3.5rem;\r\n          font-weight: 500;\r\n          height: 40px;\r\n          color: rgba(0, 0, 0, 0.87);\r\n          line-height: 1.4 !important;\r\n          letter-spacing: -0.1px !important\">\nDatamobil <span class=\"texto-gradiente-ia\">IA</span></h1></div><div class=\"subtitulo\" ng-if=\"!vm.conversaIniciada\">\nConsultas inteligentes em segundos, sem complicação.</div><div class=\"mensagens\" ng-if=\"vm.conversaIniciada\"><div \nclass=\"mensagem-item\" ng-repeat=\"msg in vm.mensagens\" \nng-class=\"{\'enviada\': msg.tipo === \'enviada\', \'recebida\': msg.tipo === \'recebida\'}\"><mensagem-envio \nng-if=\"msg.tipo === \'enviada\'\" mensagem=\"msg\"></mensagem-envio><mensagem-recebida \nng-style=\"msg.data && {\'width\': \'100%\'}\" ng-if=\"msg.tipo === \'recebida\'\" mensagem=\"msg\"></mensagem-recebida></div><div \nng-show=\"vm.emProgresso\" class=\"loader\"><md-icon style=\"color: rgba(0, 0, 0, 0.87)\" \nmd-svg-src=\"assets/custom/auto-awesome.svg\"></md-icon><span style=\"margin-left: 30px; margin-right: 4px\">IA está</span>\n<div class=\"words\"><div class=\"word-list\"><span class=\"word texto-gradiente\">pensando...</span> <span \nclass=\"word texto-gradiente\">buscando...</span> <span class=\"word texto-gradiente\">processando...</span> <span \nclass=\"word texto-gradiente\">executando...</span> <span class=\"word texto-gradiente final\">gerando <span class=\"dots\">\n<i class=\"dot\">.</i><i class=\"dot\">.</i><i class=\"dot\">.</i></span></span></div></div></div></div><div \nclass=\"input-container\" layout=\"row\" layout-align=\"center center\"><md-input-container md-no-float class=\"md-block\">\n<textarea ng-model=\"vm.comando\" placeholder=\"Insira um comando...\" ng-keydown=\"vm.metodos.pressionandoTecla($event)\" \nrows=\"1\" caracteres-permitidos ng-disabled=\"vm.carregandoTrial\"></textarea></md-input-container><md-button \nclass=\"md-fab md-raised md-mini md-accent\" ng-click=\"vm.metodos.enviarMensagem(vm.comando)\" \nng-disabled=\"vm.carregandoTrial\"><md-icon ng-if=\"!vm.carregandoTrial\" md-font-icon=\"icon-arrow-right s24\"></md-icon>\n<md-progress-circular ng-if=\"vm.carregandoTrial\" md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\" \nstyle=\"margin-left: 4px; margin-top: 2px\"></md-progress-circular></md-button></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" layout=\"column\" layout-align=\"center center\" \nng-style=\"{\'background-image\': \'url(\' + vm.configuracao.imagemFundoAplicacao + \')\'}\"><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo-login\" layout=\"row\"><img \nng-src=\"{{ vm.configuracao.path_logo }}\"> <span class=\"pl-10\">{{ vm.configuracao.aplicacao }}</span></div><div \nclass=\"title\" translate=\"LOGIN.TEXTO_LOGIN\">Login</div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><md-icon class=\"icones\" md-font-icon=\"icon-account s18\"></md-icon><input class=\"input\" \ntype=\"text\" name=\"usuario\" placeholder=\"Usuário\" translate=\"UTF\" maxlength=\"20\" \nonkeydown=\"var a = this; setTimeout(function(){a.value = a.value.toUpperCase();}, 1)\" required \nng-model=\"vm.form.usuario\"><div ng-messages=\"loginForm.usuario.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.MSG_USUARIO\">Usuário deve ser informado</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><md-icon class=\"icones\" \nmd-font-icon=\"icon-lock-unlocked s18\"></md-icon><input class=\"input\" type=\"password\" name=\"senha\" placeholder=\"Senha\" \nmascara-tamanho-campo=\"10\" required md-maxlength=\"10\" ng-model=\"vm.form.senha\"></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\" hide-gt-sm></div>\n<div layout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"ENTRAR\" translate=\"LOGIN.ENTRAR\" translate-attr-aria-label=\"LOGIN.ENTRAR\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.metodos.autenticarUsuario($event)\" \nng-show=\"!$root.loadingProgress\">ENTRAR</md-button><div layout=\"row\" layout-align=\"center\" \nclass=\"carregamento-circular\"><md-progress-circular id=\"login-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"15\"></md-progress-circular></div></div><div><div \nclass=\"versaorelease\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\">Versão: <span \nstyle=\"padding-left: 5px;\r\n                                         padding-right: 15px\">{{ vm.versao }}</span>\n Release: <span style=\"padding-left: 5px\">{{ vm.release }}</span></div></div></div><div class=\"logo-rodape\" \nlayout-align=\"center center\"><img ng-src=\"data:image/png;base64,{{ vm.configuracao.logomarcaAplicacao }}\" \nng-if=\"vm.configuracao.logomarcaAplicacao != null && vm.configuracao.logomarcaAplicacao.length > 0\"> <img \nng-src=\"{{ vm.configuracao.path_logo_inovamobil }}\" \nng-if=\"vm.configuracao.logomarcaAplicacao == null || !vm.configuracao.logomarcaAplicacao.length\"></div></form></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts track by $index\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><div \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" \naria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button><md-menu \nmd-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" \naria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">Clique para adicionar/remover atalhos\n</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></div><input type=\"text\" placeholder=\"Pesquisar\" flex ng-model=\"MsShortcuts.query\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" \nng-if=\"MsShortcuts.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">\nNenhum resultado encontrado!</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" \nng-click=\"MsShortcuts.handleResultClick(result)\" ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" \nng-mousedown=\"MsShortcuts.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" md-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"icon icon-container\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}\n</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\">\n</md-icon></div></div></div></div></md-menu-content></md-menu></div><md-button \nclass=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/compartilhado/dialog-senha-implantacao/views/dialog-senha-implantacao.html","<md-dialog aria-label=\"Serviços prestados\" id=\"dialog-senha-controle-rotina\"><form ng-cloak><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RESOURCES.LIBERACAO_ROTINA\"></h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\" flex><md-input-container \nclass=\"md-block\" layout-align=\"center center\" flex-gt-sm=\"60\" flex><label translate=\"RESOURCES.SENHA\">Senha</label>\n<input type=\"password\" mascara-tamanho-campo=\"6\" mascara-numero-letra id=\"txtSenha\" ng-model=\"vm.txtSenha\" \nmd-autofocus=\"\" ng-keyup=\"$event.keyCode == 13 && vm.metodos.verificarSenhaImplantacao(vm.txtSenha)\" required>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\" flex><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.txtSenha\" ng-click=\"vm.metodos.verificarSenhaImplantacao(vm.txtSenha)\"><span \ntranslate=\"RESOURCES.LIBERAR\">Liberar</span></md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/compartilhado/diretivas/carregamento-circular/carregamento-circular.html","<div id=\"carregamento-circular\" layout=\"column\" layout-align=\"center center\" class=\"pre-loader-full-width\" \nng-if=\"vm.emProgresso\" flex><md-content class=\"elementClass\"><div flex class=\"textoDiv\"><span ng-if=\"vm.titulo\">\n{{vm.titulo}}</span> <span ng-if=\"!vm.titulo\">Aguarde...</span> <span ng-if=\"vm.subTitulo\"><br>{{vm.subTitulo}}</span>\n</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" flex><div flex><md-progress-circular \nmd-mode=\"indeterminate\" ng-class=\"{\'md-circular-aguarde\':(!vm.mensagem || vm.mensagem === \' \')}\" class=\"md-accent\" \nmd-diameter=\"60\"></md-progress-circular></div><div ng-if=\"vm.mensagem && vm.mensagem !== \' \'\" class=\"divAguarde\" \nflex=\"75\"><span style=\"white-space: pre-wrap\">{{vm.mensagem}}</span></div></div></md-content></div>");
$templateCache.put("app/compartilhado/diretivas/data-table/data-table.html","<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"options\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"cabecalho in cabecalhos track by $index\"><div class=\"table-header\"><span class=\"column-title text-center\">\n{{cabecalho}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"dado in dados track by $index\"><td \nclass=\"text-center\" ng-repeat=\"propriedade in propriedadesExibir track by $index\"><span>{{dado[propriedade]}}</span>\n</td><td class=\"text-center\" ng-if=\"tituloAcao\"><div layout=\"column\" flex layout-align=\"center center\"><md-button \nng-hide=\"dado.emProgresso\" class=\"md-icon-button\" ng-disabled=\"desabilitar\" ng-click=\"vm.acaoClick(dado)\"><md-tooltip \nmd-autohide id=\"btn-acao-tabela-{{$index}}\" md-delay=\"200\"><span>{{tituloAcao}}</span></md-tooltip><md-icon \nng-style=\"{\'color\':\'{{corIcone}}\'}\" md-font-icon=\"{{iconeAcao}}\"></md-icon></md-button><md-progress-circular \nng-show=\"dado.emProgresso\" class=\"md-accent\" md-diameter=\"16\" md-mode=\"indeterminate\"></md-progress-circular></div>\n</td></tr></tbody></table></ms-widget-front></ms-widget>");
$templateCache.put("app/compartilhado/diretivas/fab-button/fab-button.html","<div id=\"fab-button\" layout-gt-sm=\"column\" layout-align=\"end end\" flex><md-fab-speed-dial layout-align=\"end center\" \nng-hide=\"demo.hidden\" md-direction=\"left\" md-open=\"demo.isOpen\" class=\"md-scale alinhar\" ng-class=\"demo.selectedMode\">\n<md-fab-trigger><md-button aria-label=\"menu\" ng-disabled=\"vm.disabled\" class=\"md-fab\"><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{vm.tituloMenu}}</md-tooltip><md-icon md-font-icon=\"icon-playlist-plus s30\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><div ng-repeat=\"item in vm.buttons\"><md-button aria-label=\"{{item.name}}\" \nng-hide=\"item.hide\" class=\"md-fab md-mini\" ng-disabled=\"{{item.disabled}}\" \nng-click=\"vm.metodos.abrirDialog($event, item)\"><md-tooltip md-direction=\"{{item.direction}}\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">{{item.name}}</md-tooltip><md-icon md-font-icon=\"{{item.icon}}\">\n</md-icon></md-button></div></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/compartilhado/diretivas/group-button/group-button.html","<div id=\"group-button\" layout-gt-xs=\"row\" layout-align=\"end center\"><md-input-container><md-button \nclass=\"md-fab md-accent md-icon-button sample-show-hide\" \nng-click=\"vm.metodosControladores.habilitaEditar(vm.entidade)\" ng-disabled=\"vm.ngDisabled\" \nng-hide=\"vm.controladorAtivo\" aria-label=\"add contact\" translate translate-attr-aria-label=\"GROUP_BUTTON.EDICAO\">\n<md-icon md-font-icon=\"icon-pencil s30\"></md-icon></md-button></md-input-container><md-input-container><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosButtons.salvar($event)\" \nng-disabled=\"vm.formulario.$pristine || vm.formulario.$invalid || vm.requisicaoSolicitada\" \nng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate translate-attr-aria-label=\"GROUP_BUTTON.SALVAR\">\n<md-icon md-font-icon=\"icon-content-save s30\"></md-icon></md-button></md-input-container><md-input-container><md-button\n class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosControladores.cancelarEdicao()\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"GROUP_BUTTON.CANCELAR_EDICAO\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n</md-input-container><md-input-container ng-hide=\"vm.ngDisabledExcluir\"><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.metodosButtons.excluir($event)\" \nng-disabled=\"vm.requisicaoSolicitada\" ng-show=\"vm.controladorAtivo\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"GROUP_BUTTON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete s30\"></md-icon></md-button>\n</md-input-container></div>");
$templateCache.put("app/compartilhado/diretivas/group-button-horizontal/group-button-horizontal.html","<div id=\"group-button-horizontal\" class=\"espacamento-bottom\"><div layout=\"row\" ng-show=\"!vm.verificaEditarAtivo\">\n<md-button ng-click=\"vm.metodosGroupButtonHorizontal.salvar($event)\" class=\"send-button md-accent md-raised\" \naria-label=\"Salvar\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.SALVAR\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine || vm.requisicaSolicitada\"></md-button></div><div \nlayout=\"column\" ng-show=\"vm.verificaEditarAtivo\"><md-button ng-click=\"vm.metodosGroupButtonHorizontal.editar($event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Salvar Edição\" translate=\"GROUP_BUTTON_HORIZONTAL.SALVAR_EDICAO\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.SALVAR_EDICAO\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine || vm.requisicaSolicitada\"></md-button><md-button \nng-click=\"vm.metodosGroupButtonHorizontal.cancelar()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.requisicaSolicitada\" aria-label=\"Cancelar Edição\" translate=\"GROUP_BUTTON_HORIZONTAL.CANCELAR\" \ntranslate-attr-aria-label=\"GROUP_BUTTON_HORIZONTAL.CANCELAR\"></md-button></div></div>");
$templateCache.put("app/compartilhado/diretivas/header-padrao/header-padrao.html","<div id=\"cabecalho-padrao\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><i ng-if=\"vm.habilitarIconeVoltarAoEstadoAnterior\" \nclass=\"icon-arrow-left-bold s30\" ng-click=\"vm.navegarParaEstadoAnterior()\"><md-tooltip><span \nng-if=\"!vm.mensagemTooltipIconeEstadoAnterior\">Voltar para tela anterior </span><span \nng-if=\"vm.mensagemTooltipIconeEstadoAnterior\">{{vm.mensagemTooltipIconeEstadoAnterior}}</span></md-tooltip></i><md-icon\n md-font-icon=\"{{icone}}\"></md-icon><span translate=\"{{translateNome}}\"></span> <span \nng-show=\"vm.textoAuxiliarHabilitado\" ng-style=\"{\'margin-left\': \'10px\'}\">{{vm.textoAuxiliar}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start start\" flex ng-if=\"vm.ngUtilizaPesquisa\"><label><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon></label><input id=\"pesquisar\" \nclass=\"search-input\" type=\"text\" placeholder=\"Pesquisar\" ng-disabled=\"!vm.liberarPesquisaQuandoDatatableAtivo\" \nng-model=\"vm.pesquisar\" ng-model-options=\"{debounce: 400}\" translate \ntranslate-attr-placeholder=\"CABECALHO_PADRAO.PESQUISAR\" flex></div></div></div>");
$templateCache.put("app/compartilhado/diretivas/multi-select/multi-select.html","<div layout=\"row\" flex><md-input-container flex><label>{{textoPlaceholder}}</label><md-select ng-model=\"model\" \nng-change=\"vm.metodos.onChangeItem()\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-disabled=\"disabled\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \ntype=\"search\" placeholder=\"{{textoPesquisaPlaceholder}}\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"item\"><md-option ng-value=\"item\" ng-repeat=\"item in data |\r\n              filter:searchTerm\">\n{{item[descricaoExibicao]}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"carregando\" class=\"md-accent\" style=\"margin-top: 1px\"></md-progress-linear></md-input-container>\n<md-input-container><md-checkbox style=\"margin-right: 10px\" ng-model=\"vm.todos\" ng-change=\"vm.metodos.limparSelecao()\" \naria-label=\"Checkbox Disabled Indeterminate\" ng-disabled=\"!model || model.length == 0\" class=\"md-primary\">Todos\n</md-checkbox></md-input-container></div>");
$templateCache.put("app/compartilhado/diretivas/pesquisar-por-identificador/pesquisar-por-identificador.html","<label translate=\"PESQUISAR_POR_CODIGO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.codigo\" \nclass=\"pesquisar-por-codigo-borda-bottom-input\" placeholder=\"\" aria-label=\"Código\" ng-disabled=\"vm.ngDisabled\" \nng-model-options=\"{ debounce: 100 }\" translate translate-attr-aria-label=\"PESQUISAR_POR_CODIGO.CODIGO\" \nng-keydown=\"vm.pesquisar.onKeydown($event, vm.codigo)\" ng-blur=\"vm.pesquisar.onBlur(vm.codigo)\">");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/pg-toolbar.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"{{vm.tela.screen.width >= vm.larguraPadraoMobileTela ? vm.tipolayout : \'\'}}\"><div class=\"h1\" \nng-if=\"vm.tela.screen.width < vm.larguraPadraoMobileTela\" layout=\"row\" layout-align=\"start center\"><ng-include \nsrc=\"vm.htmlComponente.sidenav.botaoSidenav\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoNovaPesquisa\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoNovaPesquisa\"></ng-include></div><div class=\"h1\" \nlayout=\"row\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n             || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.pesquisaAtiva && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n             && !vm.esconderBotaoPesquisar\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoPesquisar\"></ng-include></div><div class=\"h1\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoSalvar\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoSalvar\"></ng-include></div><div \nclass=\"h1\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoReverter\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoReverter\"></ng-include></div><div \nclass=\"h1\" ng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoExcluir\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoExcluir\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoEditar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoEditar\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoInserir\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoInserir\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoGenerico\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoGenerico\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && vm.utilizaBotaoClonar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoClonar\"></ng-include></div><div class=\"h1\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoAtualizar\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoAtualizar\"></ng-include></div><div \nclass=\"toolbar-separator\" ng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\">\n</div><div class=\"texto-primario\" layout=\"row\" layout-align=\"start center\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\"><span>{{vm.textoExibido}}\n</span></div><div class=\"toolbar-separator\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderMensagemStatus\"></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoPrimeira\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoPrimeira\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoAnterior\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoAnterior\"></ng-include></div><div class=\"texto-secundario\" \nng-show=\"vm.entidadeDeEnvio.intTotalResultado && vm.entidadeDeEnvio.intTotalResultado > 0\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)) \r\n                    && !vm.escoderTextoInformativoQuantidade\">\n<span>{{ vm.entidadeDeEnvio.intPosicao }} de {{(vm.entidadeDeEnvio.intTotalResultado)}}</span></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela)\r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoProxima\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoProxima\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"((vm.tela.screen.width >= vm.larguraPadraoMobileTela) \r\n                    || (vm.tela.screen.width < vm.larguraPadraoMobileTela && !vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo))\r\n                    && !vm.esconderBotaoUltima\">\n<ng-include src=\"vm.htmlComponente.navegacao.botaoUltima\"></ng-include></div><div class=\"h1\" \nng-hide=\"vm.esconderBotaoModoTabela\" \nng-if=\"(vm.tela.screen.width >= vm.larguraPadraoMobileTela) && !vm.esconderBotaoListarTodasEntidades\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.listarTodasEntidades\"></ng-include></div></div>\n</md-toolbar><div id=\"pg-toolbar-sidenav\" ng-if=\"vm.tela.screen.width <= vm.larguraPadraoMobileTela\"><md-sidenav \nclass=\"md-sidenav-left md-whiteframe-4dp\" ms-scroll md-component-id=\"pg-toolbar-sidenav\" \nng-include=\"vm.htmlComponente.sidenav.sidenav\" ms-sidenav-helper></md-sidenav></div><md-progress-linear \nclass=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.controladorPreLoader.progresso}}\" \nmd-buffer-value=\"{{vm.controladorPreLoader.progresso}}\" ng-disabled=\"!vm.controladorToolbar.emProgresso\">");
$templateCache.put("app/compartilhado/diretivas/progress-linear/progress-linear.html","<md-progress-linear class=\"md-accent\" md-mode=\"{{vm.mdMode}}\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.ngDisabled\">{{vm.emProgresso}}");
$templateCache.put("app/compartilhado/diretivas/proximo-codigo/proximo-codigo.html","<md-input-container class=\"md-block proximo-codigo\"><md-button class=\"md-icon-button\" id=\"button-proximo-codigo\" \nng-click=\"vm.gerarProximoCodigo($event)\" aria-label=\"Proximo Código\" translate \ntranslate-attr-aria-label=\"MENSAGEM_PADRAO.PROXIMO_CODIGO\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline s30\"></md-icon></md-button><md-tooltip><span \ntranslate=\"MENSAGEM_PROXIMO_CODIGO.PROXIMO_CODIGO\">Próximo Código</span></md-tooltip></md-input-container>");
$templateCache.put("app/compartilhado/diretivas/select-simples/select-simples.html","<md-input-container class=\"md-block\" style=\"width: 100%\" id=\"select-simples-diretiva\"><label>{{ titulo }}</label>\n<md-select ng-model=\"modelo\" name=\"{{ nomeControle }}\" md-on-open=\"aoAbrir()\" md-on-close=\"aoFechar()\" \nng-disabled=\"disabled\" ng-required=\"required\" class=\"select-simples-component\"><md-select-header \nng-if=\"utilizaPesquisa\"><input ng-model=\"campoPesquisa\" type=\"search\" id=\"select-simples-searchbox\" \nplaceholder=\"Pesquisar..\" class=\"md-text\"></md-select-header><md-option ng-value=\"item[chave]\" \nng-repeat=\"item in obterListaFiltrada() track by item[chave]\"><span>{{ item[valor] }}</span> <span \nng-if=\"estaSelecionado(item)\" style=\"position: absolute; right: 16px; color: #039be5; font-size: 18px\">✓</span>\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/erros/error-404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR_404.STATUS\">404</div><div class=\"message\" \ntranslate=\"ERROR_404.MENSAGEM\"></div><a class=\"back-link md-accent-color\" ui-sref=\"app.inicio\" \ntranslate=\"ERROR_404.VOLTAR\"></a></div></div>");
$templateCache.put("app/main/erros/manutencao/manutencao.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"start center\"><div id=\"maintenance-form\" class=\"\"><img class=\"logo-image\" \nsrc=\"assets/images/logos/inovamobil.png\"><div class=\"title\">\nEstamos realizando algumas atualizações e melhorias em nossa aplicação.</div><div class=\"subtitle\">\nO acesso será normalizado em breve!<br>Agradecemos sua compreensão.</div></div></div></div>");
$templateCache.put("app/main/inicio/views/inicio.html","<div id=\"inicio\" class=\"flex-scrollable center\" layout=\"column\" ms-scroll><div class=\"logotipo_texto\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.exibirNotificacao\"><div class=\"logo-inicio\"><img \nng-src=\"{{ vm.configuracao.path_logo }}\"><div>{{ vm.nomeSolucao }}</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-margin layout-padding><div class=\"caixa-notificacao\" layout-align=\"center center\" \nlayout-margin layout-padding fles=\"80\" ng-if=\"vm.exibirNotificacao\">Atenção<br><div layout-align=\"center center\" \nng-repeat=\"notificacao in vm.notificacoes\"><span ng-bind-html=\"notificacao.textoNotificacao\"><br></div></div></div>\n</div>");
$templateCache.put("app/main/gerenciamentocarga/views/gerenciamento-carga.html","<div id=\"gerencimanto-carga\" class=\"page-layout carded fullwidth\" layout=\"column\"><header-padrao \ntranslate-nome=\"GERENCIAMENTO_CARGA.TITULO\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao>\n<md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" \nmd-component-id=\"filtro-gerenciamento-carga\" md-whiteframe=\"4\" ui-view=\"gerenciamento-carga-filtro\" ms-scroll \nmd-is-open=\"true\" ms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" md-component-id=\"filtro-gerenciamento-carga\" md-whiteframe=\"4\" \nui-view=\"gerenciamento-carga-filtro-caema\" ms-scroll md-is-open=\"true\" ms-sidenav-helper></md-sidenav><md-content \nclass=\"no-background\" ng-show=\"vm.cargasDisponibilizada\"><div layout-gt-xs=\"row\"><div flex><div \nui-view=\"gerenciamento-carga-totalizador\"></div></div></div><div layout=\"column\"><div \nui-view=\"gerenciamento-carga-leiturista\" flex></div></div><div class=\"button-float\" \nng-show=\"vm.conexaoEstabelecida && vm.cargasDisponibilizada\" layout=\"column\"><div class=\"button-toogle\" \nng-click=\"vm.metodos.abrirFiltros()\"><md-tooltip md-autohide md-direction=\"left\"><span>Filtrar</span></md-tooltip>\n<md-icon md-font-icon=\"icon-filter\" class=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></div></div></md-content></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div hide-xs \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" src=\"assets/images/logos/inovamobil.png\" \nng-if=\"!vm.marcaEspecial.utilizarMarcaEspecial\"> <img class=\"logo-image\" \nng-src=\"data:image/png;base64,{{ vm.marcaEspecial.imagemLogomarca }}\" ng-if=\"vm.marcaEspecial.utilizarMarcaEspecial\">\n</div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div \nhide layout-align=\"center center\" show-gt-sm ng-show=\"modoImplantacao\" id=\"modoimplantacao\" layout=\"row\"><span \nclass=\"modoimplantacao-badge text-boxed red-bg white-fg\">MODO DE IMPLANTAÇÃO</span></div><div \nclass=\"toolbar-separator\" ng-if=\"vm.datamobilTrialAtivo\"></div><div hide show-gt-sm ng-if=\"vm.datamobilTrialAtivo\" \nid=\"contador-trial-toolbar\" layout=\"row\" layout-align=\"center center\"><div class=\"contador-trial-icon\" \nng-class=\"vm.datamobilCorContador\" ng-click=\"vm.irParaDatamobil()\"><md-tooltip md-direction=\"bottom\">Você tem mais \n<span ng-if=\"vm.datamobilTempoRestante.dias > 0\">{{vm.datamobilTempoRestante.dias}}d </span>\n{{vm.datamobilTempoRestante.horas}}:{{vm.datamobilTempoRestante.minutos}}:{{vm.datamobilTempoRestante.segundos}} de acesso gratuito\n</md-tooltip><md-icon md-svg-src=\"assets/custom/auto-awesome.svg\"></md-icon></div></div><div class=\"toolbar-separator\">\n</div><div hide show-gt-sm id=\"datahora\" layout=\"row\"><span>Data/Hora:</span><div>{{vm.horaAtual}}</div></div><div \nclass=\"toolbar-separator\"></div><div layout=\"column\" layout-align=\"center center\"><div hide show-gt-sm \nid=\"versaorelease\" layout=\"row\"><div>Versão: <span>{{vm.versao}}</span> Release: <span>{{vm.release}}</span></div>\n</div></div><div class=\"toolbar-separator\"></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide-sm>{{vm.usuario.login}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-security\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.alterarSenha($event)\">Alterar Senha</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"vm.abrirDialogLicencas()\"><md-tooltip md-direction=\"bottom\">\nRelação de licenças</md-tooltip><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon></md-button><div \nclass=\"toolbar-separator\"></div><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.abrirDialogConfiguracaoSmartphone()\"><md-tooltip md-direction=\"bottom\">Configuração do smartphone\n</md-tooltip><md-icon md-font-icon=\"icon-qrcode\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.abrirConsultaSolicitacoes()\"><md-tooltip md-direction=\"bottom\">\nConsulta de solicitações</md-tooltip><md-icon class=\"icon\" style=\"color: #279FDA\" \nmd-svg-icon=\"/assets/icons/search-in-folder.svg\"></md-icon></md-button><div class=\"toolbar-separator\"></div>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><div ng-if=\"vm.exibirChatSuporte === \'0\'\" class=\"toolbar-separator\"></div><div \nng-if=\"vm.exibirChatSuporte === \'0\'\" id=\"chat-blip\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-atualizar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-atualizar-1\" \nng-click=\"vm.metodosAcao.metodosAcaoAtualizar($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoAtualizar\" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-atualizar-2\" ng-click=\"vm.metodosAcao.metodosAcaoAtualizar($event)\" aria-label=\"Atualizar\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoAtualizar\">\n<span class=\"h3\" translate=\"PG_TOOLBAR.ATUALIZAR\">Atualizar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-atualizar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.ATUALIZAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-clonar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-clonar-1\" \nng-click=\"vm.metodosControladores.metodoControladorClonar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n               || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n               || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoClonar\" \naria-label=\"Clonar\"><md-icon md-font-icon=\"icon-content-copy s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-clonar-2\" ng-click=\"vm.metodosControladores.metodoControladorClonar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n               || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n               || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoClonar\" \naria-label=\"Clonar\"><span class=\"h3\" translate=\"PG_TOOLBAR.CLONAR\">Clonar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-clonar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.CLONAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-editar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-editar-1\" \nng-click=\"vm.metodosControladores.metodoControladorEditar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoEditar\" \naria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-editar-2\" ng-click=\"vm.metodosControladores.metodoControladorEditar(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo \r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoEditar\" \naria-label=\"Editar\"><span class=\"h3\" translate=\"PG_TOOLBAR.EDITAR\">Editar</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-editar\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.EDITAR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-excluir.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-excluir\" \nng-click=\"vm.metodosAcao.metodosAcaoExcluir($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.inserirAtivo || vm.controladorToolbar.listarTodasEntidades\r\n                            || vm.desabilitarBotaoExcluir\" \naria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-excluir\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.EXCLUIR\"></span></md-tooltip>\n<md-button hide-gt-xs id=\"pg-toolbar-botao-inserir\" ng-click=\"vm.metodosAcao.metodosAcaoExcluir($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva || vm.controladorToolbar.inserirAtivo\r\n                || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoExcluir\" \naria-label=\"Excluir\"><span class=\"h3\" translate=\"PG_TOOLBAR.EXCLUIR\">Excluir</span></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-generico.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-generico\" \nng-click=\"vm.metodosAcao.metodosAcaoBotaoGenerico($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.inserirAtivo || vm.controladorToolbar.listarTodasEntidades\r\n                            || vm.desabilitarBotaoGenerico\">\n<md-icon md-font-icon=\"{{ vm.iconeBotaoGenerico }}\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-generico\" md-delay=\"vm.tempoDelay\"><span>{{ vm.tooltipBotaoGenerico }}</span></md-tooltip>\n<md-button hide-gt-xs id=\"pg-toolbar-botao-generico\" ng-click=\"vm.metodosAcao.metodosAcaoBotaoGenerico($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva || vm.controladorToolbar.inserirAtivo\r\n                || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoGenerico\">\n<span class=\"h3\">{{ vm.tooltipBotaoGenerico }}</span></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-inserir.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-inserir-1\" \nng-click=\"vm.metodosControladores.metodoControladorInserir(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso \r\n                            || vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoInserir\" \naria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-inserir-2\" ng-click=\"vm.metodosControladores.metodoControladorInserir(vm.entidade)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.editarAtivo \r\n                            || vm.controladorToolbar.inserirAtivo || vm.controladorToolbar.listarTodasEntidades\r\n                            || vm.desabilitarBotaoInserir\" \naria-label=\"Inserir\"><span class=\"h3\" translate=\"PG_TOOLBAR.INSERIR\">Inserir</span></md-button><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-inserir\" md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.INSERIR\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-listar-todas-entidades.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-listartodasentidades-1\" \nng-click=\"vm.metodosControladores.metodoControladorListarTodasEntidades($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.desabilitarBotaoListarTodasEntidades\" \naria-label=\"Listar Todos\" ng-class=\"{\'selecionado\': vm.controladorToolbar.listarTodasEntidades}\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-listartodasentidades-2\" \nng-click=\"vm.metodosControladores.metodoControladorListarTodasEntidades($event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                             || vm.desabilitarBotaoListarTodasEntidades\" \naria-label=\"Listar Todos\"><span style=\"font-size: 1.2rem !important\" translate=\"PG_TOOLBAR.ALTERAR_EXIBICAO\"></span>\n</md-button><md-tooltip hide-xs id=\"pg-toolbar-tooltip-listartodasentidades-1\" \nng-if=\"!vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"PG_TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_TABELA\"></span></md-tooltip><md-tooltip hide-xs \nid=\"pg-toolbar-tooltip-listartodasentidades-2\" ng-if=\"vm.controlador.listarTodasEntidades\" md-autohide \nmd-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_EDICAO\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-nova-pesquisa.html","<div layout-xs=\"row\"><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-nova-pesquisa-1\" \nng-click=\"vm.metodosControladores.metodoControladorNovaPesquisa()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoNovaPesquisa\" \naria-label=\"Pesquisar\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon></md-button><md-button hide-gt-xs \nid=\"pg-toolbar-botao-nova-pesquisa-2\" ng-click=\"vm.metodosControladores.metodoControladorNovaPesquisa()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                                || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo) \r\n                                || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoNovaPesquisa\" \naria-label=\"Pesquisa\"><span translate=\"PG_TOOLBAR.NOVA_PESQUISA\" class=\"h3\">Nova Pesquisa</span></md-button><md-tooltip\n hide-xs id=\"pg-toolbar-tooltip-nova-pesquisa\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"PG_TOOLBAR.NOVA_PESQUISA\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-pesquisar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-pesquisar\" type=\"submit\" \nng-click=\"vm.metodosAcao.metodoAcaoPesquisar(vm.entidade, $event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.pesquisaAtiva \r\n                           || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                           || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoPesquisar\" \naria-label=\"Buscar Pesquisa\"><md-icon md-font-icon=\"icon-magnify s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-pesquisar\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.BUSCAR_PESQUISA\"></span>\n</md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-reverter.html","<md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-reverter\" \nng-click=\"vm.metodosControladores.metodoControladorReverter()\" \nng-disabled=\"vm.controladorToolbar.emProgresso || \r\n                        (!vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)\r\n                         || vm.controladorToolbar.listarTodasEntidades || vm.desabilitarBotaoReverter\" \naria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-reverter\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.REVERTER\">Reverter</span>\n</md-tooltip>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-botao-salvar.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-salvar\" type=\"submit\" \nng-click=\"vm.metodosControladores.metodoControladorSalvar(vm.entidade, $event)\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.listarTodasEntidades\r\n                            || (!vm.controladorToolbar.editarAtivo && !vm.controladorToolbar.inserirAtivo)\r\n                            || vm.form.$invalid || vm.form.$pristine || vm.desabilitarBotaoSalvar\" \naria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save s30\"></md-icon></md-button><md-tooltip md-autohide \nid=\"pg-toolbar-tooltip-salvar\" md-delay=\"vm.tempoDelay\"><span translate=\"PG_TOOLBAR.SALVAR\"></span></md-tooltip></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-anterior.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-anterior\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'anterior\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.primeiraEntidade \r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades \r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoAnterior)\" \naria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-primeira.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-primeira\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'primeira\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || !vm.controladorToolbar.pesquisaAtiva \r\n                            || vm.controladorToolbar.primeiraEntidade\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoPrimeira)\" \naria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-proxima.html","<div><md-button class=\"md-icon-button\" ng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'proxima\')\" \nid=\"pg-toolbar-botao-proxima\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.ultimaEntidade \r\n                            || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoProxima)\" \naria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/pg-toolbar-navegacao-botao-ultima.html","<div><md-button class=\"md-icon-button\" id=\"pg-toolbar-botao-ultima\" \nng-click=\"vm.metodosAcao.metodoAcaoNavegacao(\'ultima\')\" \nng-disabled=\"vm.controladorToolbar.emProgresso || vm.controladorToolbar.ultimaEntidade \r\n                            || !vm.controladorToolbar.pesquisaAtiva\r\n                            || (vm.controladorToolbar.editarAtivo || vm.controladorToolbar.inserirAtivo)\r\n                            || vm.controladorToolbar.listarTodasEntidades\r\n                            || (vm.desabilitarBotoesNavegacao || vm.desabilitarBotaoUltima)\" \naria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/desktop/toolbar-desktop.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"{{vm.tipolayout}}\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao && !vm.ngOcultaBotaoNovaPesquisa\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoNovaPesquisa || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.novaEntidade\r\n                                    || vm.controlador.editarAtivo || !vm.controlador.pesquisaAtiva || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisar\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\" ng-if=\"!vm.controlador.pesquisaAtiva\"><span \ntranslate=\"TOOLBAR.PESQUISAR\">Pesquisar</span></md-tooltip><md-tooltip md-autohide md-delay=\"vm.tempoDelay\" \nng-if=\"vm.controlador.pesquisaAtiva\"><span translate=\"TOOLBAR.NOVA_PESQUISA\">Nova Pesquisa</span></md-tooltip></div>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoPesquisar\"><md-button \nclass=\"md-icon-button\" type=\"submit\" \nng-disabled=\"vm.ngDisabledBotaoPesquisar || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.pesquisaAtiva\r\n                                    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.pesquisar(vm.entidade, $event)\" aria-label=\"Buscar Pesquisa\"><md-icon \nmd-font-icon=\"icon-magnify s30\"></md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.BUSCAR_PESQUISA\">Buscar Pesquisa</span></md-tooltip></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoSalvar\"><md-button class=\"md-icon-button\" type=\"submit\" \nng-disabled=\"vm.ngDisabledBotaoSalvar || vm.controleForm.emProgresso || vm.ngDisabled\r\n                                    || (!vm.controlador.editarAtivo && !vm.controlador.novaEntidade)\r\n                                    || (vm.controlador.listarTodasEntidades || vm.formulario.$invalid || vm.formulario.$pristine)\r\n                                    && (!vm.controleForm.habilitarButtonSalvar && !vm.controleForm.emProgresso)\" \nng-click=\"vm.metodosToolbar.salvar(vm.entidade, $event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save s30\"></md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.SALVAR\">Salvar</span></md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoReverter\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoReverter || vm.controleForm.emProgresso\r\n                                    || vm.ngDisabled || (!vm.controlador.editarAtivo && !vm.controlador.novaEntidade)\r\n                                    || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.reverter()\" aria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n<md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.REVERTER\">Reverter</span></md-tooltip></div>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoExcluir\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoExcluir || vm.controleForm.emProgresso || vm.ngDisabled\r\n                                    || !vm.controlador.pesquisaAtiva  || vm.controlador.novaEntidade\r\n                                    || vm.controlador.listarTodasEntidades || vm.controleForm.desabilitarButtonExcluir\" \nng-click=\"vm.metodosToolbar.excluir(vm.entidade, $event)\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\">\n</md-icon></md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.EXCLUIR\">Excluir</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoEditar\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoEditar || vm.controleForm.emProgresso || vm.ngDisabled || vm.entidade === null\r\n                                    || !vm.controlador.pesquisaAtiva || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\r\n                                    || vm.controlador.editarAtivo || vm.controleForm.desabilitarButtonEditar\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.EDITAR\">Editar</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoInserir\"><md-button\n class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoInserir || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.editarAtivo\r\n                                    || vm.controlador.listarTodasEntidades || vm.controlador.novaEntidade\r\n                                    || vm.controleForm.desabilitarButtonInserir\" \nng-click=\"vm.toolbar.inserir(vm.entidade)\" aria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n</md-button><md-tooltip md-autohide md-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.INSERIR\">Inserir</span>\n</md-tooltip></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoAtualizar\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodosToolbar.atualizar($event)\" \nng-disabled=\"vm.ngDisabledBotaoAtualizar || !vm.controlador.pesquisaAtiva || vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.editarAtivo || vm.controlador.novaEntidade\r\n                       || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade \" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button><md-tooltip md-autohide \nmd-delay=\"vm.tempoDelay\"><span translate=\"TOOLBAR.ATUALIZAR\"></span></md-tooltip></div><div class=\"toolbar-separator\" \nng-if=\"vm.ngUtilizaNavegacao\"></div><div class=\"texto-primario\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao\"><span>{{vm.textoExibido}}</span></div><div class=\"toolbar-separator\" \nng-if=\"vm.ngUtilizaNavegacao\"></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.ngUtilizaNavegacao\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoPrimeira || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.primeiraEntidade\r\n                       || vm.controleForm.emProgresso || vm.entidades.length === 1\r\n                       || vm.controlador.novaEntidade || vm.controlador.editarAtivo\r\n                       || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.primeira()\" aria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoAnterior || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.primeiraEntidade\r\n                       || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                       || vm.controleForm.emProgresso || vm.controlador.processaEntidade \" \nng-click=\"vm.toolbar.anterior()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon>\n</md-button></div><div class=\"texto-secundario\" layout=\"row\" layout-align=\"start center\" \nng-show=\"(vm.entidades !== null && !vm.controlador.novaEntidade && vm.entidades.length > 0)\r\n                      && !vm.controlador.listarTodasEntidades\" \nng-if=\"vm.ngUtilizaNavegacao\"><span>{{(vm.indice + 1)}} de {{(vm.entidades.length)}}</span></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoProxima || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.ultimaEntidade\r\n                       || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controleForm.emProgresso || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.proxima(vm.proxima)\" aria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\">\n</md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\">\n<md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabledBotaoUltima || vm.ngDisabled || vm.entidades.length === 0 || vm.controlador.ultimaEntidade\r\n                       || vm.entidades.length === 1|| vm.controlador.novaEntidade\r\n                       || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                       || vm.controleForm.emProgresso || vm.controlador.processaEntidade \" \nng-click=\"vm.toolbar.ultima()\" aria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.ngUtilizaNavegacao\"><md-button \nclass=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === \'listarTodos\' && !vm.ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela}\" \nng-disabled=\"vm.ngDisabledBotaoListarTodasEntidades || vm.controleForm.emProgresso || vm.ngDisabled\r\n                       || vm.entidades.length === 0 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controleForm.desabilitarButtonListarTodos\r\n                       || (vm.ngDisabledBotaoListarTodasEntidadesEmModoExibicaoTabela && vm.controlador.listarTodasEntidades)\" \nng-click=\"vm.toolbar.listarTodasEntidades()\" aria-label=\"Listar Todos\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-tooltip \nng-if=\"!vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_TABELA\">Alterar exibição para tabela</span></md-tooltip><md-tooltip \nng-if=\"vm.controlador.listarTodasEntidades\" md-autohide md-delay=\"vm.tempoDelay\"><span \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO_PARA_MODO_EDICAO\">Alterar exibição para edição</span></md-tooltip></div></div>\n</md-toolbar><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.controleForm.emProgresso\">");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/toolbar-mobile.html","<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controleForm.listarTodasEntidades || vm.controlador.novaEntidade || vm.controlador.editarAtivo\" \nng-click=\"vm.toolbar.abrirSidenav()\" aria-label=\"Abrir Sidenav\"><md-icon md-font-icon=\"icon-menu s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.pesquisaAtiva || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.pesquisar(vm.entidade, $event)\" aria-label=\"Buscar Pesquisa\"><md-icon \nmd-font-icon=\"icon-magnify s30\"></md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoSalvar\"><md-button class=\"md-icon-button\" type=\"submit\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo && !vm.controlador.novaEntidade ||                                   vm.controlador.listarTodasEntidades\" \nng-disabled=\"vm.formulario.$invalid || vm.formulario.$pristine\" \nng-click=\"vm.metodosToolbar.salvar(vm.entidade, $event)\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save s30\"></md-icon></md-button></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoReverter\"><md-button class=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo && !vm.controlador.novaEntidade\r\n                                    || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.reverter()\" aria-label=\"Reverter\"><md-icon md-font-icon=\"icon-replay s30\"></md-icon></md-button>\n</div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoExcluir\"><md-button \nclass=\"md-icon-button\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || !vm.controlador.editarAtivo\r\n                           || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.metodosToolbar.excluir(vm.entidade, $event)\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-delete s30\">\n</md-icon></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.controleForm.emProgresso || vm.metodosToolbar.atualizar($event)\" \nng-hide=\"vm.controleForm.emProgresso || vm.ngDisabled || vm.controlador.novaEntidade\r\n                                    || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\r\n                                    || !vm.controlador.pesquisaAtiva\" \naria-label=\"Atualizar\"><md-icon md-font-icon=\"icon-refresh s30\"></md-icon></md-button></div><div layout=\"row\" \nng-show=\"!vm.controlador.editarAtivo && !vm.controlador.novaEntidade\r\n                                       &&  !vm.controlador.listarTodasEntidades\" \nng-if=\"vm.ngUtilizaNavegacao\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.primeiraEntidade|| vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.primeira()\" aria-label=\"Primeiro\"><md-icon md-font-icon=\"icon-chevron-double-left s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.primeiraEntidade|| vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo|| vm.controlador.listarTodasEntidades\r\n                     || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.anterior()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left s30\"></md-icon>\n</md-button></div><div class=\"texto-secundario\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.entidades !== null && !vm.controlador.novaEntidade && vm.entidades.length > 0\r\n                              && !vm.controlador.listarTodasEntidades\">\n{{(vm.indice + 1)}} de {{(vm.entidades.length)}}</div><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.ultimaEntidade || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo|| vm.controlador.listarTodasEntidades\r\n                     || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.proxima()\" aria-label=\"Proximo\"><md-icon md-font-icon=\"icon-chevron-right s30\"></md-icon>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.ngDisabled || vm.entidades === null || vm.controlador.ultimaEntidade || vm.entidades.length === 1 || vm.controlador.novaEntidade || vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades || vm.controlador.processaEntidade\" \nng-click=\"vm.toolbar.ultima()\" aria-label=\"Ultimo\"><md-icon md-font-icon=\"icon-chevron-double-right s30\"></md-icon>\n</md-button></div></div></div><div class=\"h1\" layout=\"row\" layout-align=\"end center\" ng-if=\"vm.ngUtilizaNavegacao\">\n<md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\" \nng-hide=\"vm.ngDisabled || !vm.controleForm.listarTodasEntidades\" ng-click=\"vm.toolbar.listarTodasEntidades()\" \naria-label=\"Listar Todos\"><md-icon md-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button></div></div>\n</md-toolbar><div id=\"sidenav\"><md-sidenav class=\"md-sidenav-left md-whiteframe-4dp\" ms-scroll \nmd-component-id=\"sidenav\" \nng-include=\"\'app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/sidenav/sidenav.html\'\" ms-sidenav-helper>\n</md-sidenav></div><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.controleForm.emProgresso\">");
$templateCache.put("app/main/cadastros/cronogramagrupos/views/cronograma-grupo-form.html","<div id=\"cronograma-grupos-form\"><form name=\"cronogramaGruposForm\" novalidate><pg-toolbar entidades=\"vm.cronogramas\" \nentidade=\"vm.cronograma\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-pre-loader=\"controladorPreLoader\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.cronograma)\" acao-editar=\"vm.metodos.editar(vm.cronograma)\" \nacao-excluir=\"vm.metodos.excluir(vm.cronograma.codigo)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposInsercao()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" \nng-if=\"!(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\"><div flex-gt-sm=\"20\" flex=\"100\" layout=\"row\">\n<md-input-container flex=\"100\"><label translate=\"RESOURCES.CODIGO\">Código</label><input type=\"text\" name=\"codigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.cronograma.codigo\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"100\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaRegional\">\n</md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.REGIONAL\">\n</label><md-select ng-model=\"vm.cronograma.regional\" flex md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nname=\"regional\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma regional encontrada.</span>\n<div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div><fieldset layout=\"column\" flex=\"100\"><legend class=\"grp-legend\">\nInformações do grupo</legend><div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\"><md-input-container flex-gt-sm \nflex=\"100\"><label translate=\"RESOURCES.MES\"></label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" \nvalidacao-mes \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.cronograma.mes\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"cronogramaGruposForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-sm flex=\"100\">\n<label translate=\"RESOURCES.ANO\"></label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.cronograma.ano\"><div ng-messages=\"cronogramaGruposForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm \nflex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><input type=\"text\" name=\"grupo\" \nmascara-numero-generica=\"####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" minlength=\"4\" ng-model=\"vm.cronograma.grupo\">\n<div ng-messages=\"cronogramaGruposForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MINIMO_4_DIGITOS\">Grupo deve conter 4 dígitos</div></div></md-input-container>\n</div></fieldset><fieldset layout=\"column\" flex=\"100\"><legend class=\"grp-legend\">Datas estimadas</legend><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"100\"><md-input-container flex-gt-sm=\"25\" flex=\"100\"><label \ntranslate=\"RESOURCES.DATA_INICIO\"></label><md-datepicker name=\"dataInicio\" ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-conversor-string-para-data md-max-date=\"vm.cronograma.dataFim\" ng-model=\"vm.cronograma.dataInicio\">\n</md-datepicker><div ng-messages=\"cronogramaGruposForm.dataInicio.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"25\" \nflex=\"100\"><label translate=\"RESOURCES.DATA_FIM\"></label><md-datepicker ng-mask=\"3?9/1?9/9999\" name=\"dataFim\" \nmascara-conversor-string-para-data \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" md-min-date=\"vm.cronograma.dataInicio\" \nng-model=\"vm.cronograma.dataFim\"></md-datepicker><div ng-messages=\"cronogramaGruposForm.dataFim.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></md-content>\n</form></div>");
$templateCache.put("app/main/cadastros/cronogramagrupos/views/cronograma-grupo-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-cronogramaleituras-datatable-cronogramaleituras\" width=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>\nMês</th><th>Ano</th><th>Grupo</th><th>Agrupamento</th><th>Data inicial</th><th>Data final</th></tr></thead></table>\n</div></div>");
$templateCache.put("app/main/cadastros/cronogramagrupos/views/cronograma-grupo.html","<div id=\"cronograma-grupos\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.CRONOGRAMA_GRUPOS\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao>\n<div class=\"content\"><div ui-view=\"cronogramagrupos-form\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div>\n<div ui-view=\"cronogramagrupos-form-caema\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div></div><div \nui-view=\"cronogramagrupos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/leiturista/views/leiturista-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.leituristas\" \nentidade=\"vm.leiturista\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-pre-loader=\"controladorPreLoader\" \ncontrolador-toolbar=\"vm.controleForm\" metodo-externo-acao-nova-pesquisa=\"vm.metodos.novaPesquisa()\" \nmetodo-externo-acao-reverter=\"vm.metodos.reverter()\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.leiturista)\" acao-editar=\"vm.metodos.editar(vm.leiturista)\" \nacao-excluir=\"vm.metodos.excluir(vm.leiturista)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\" \npre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao()\" \npre-definir-campos-para-edicao=\"vm.metodos.predefinirCamposParaEdicao()\" utiliza-botao-clonar=\"true\" \ndefinir-campos-clonados=\"vm.metodos.definirCamposClonados()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Pessoal\" id=\"cadastros-leiturista-mdtabs-pessoal\" \nmd-active=\"vm.tabSelecionada === \'pessoal\'\" md-on-select=\"vm.metodos.tabSelecionada(\'pessoal\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_PESSOAL\"></label></md-tab-label><md-tab-body><md-content ui-view=\"tab-pessoal\"></md-content>\n</md-tab-body></md-tab><md-tab label=\"Configuracoes\" id=\"cadastros-leiturista-mdtabs-configuracoes\" \nmd-active=\"vm.tabSelecionada === \'configuracoes\'\" md-on-select=\"vm.metodos.tabSelecionada(\'configuracoes\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_CONFIGURACOES\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-configuracoes\"></md-content></md-tab-body></md-tab><md-tab label=\"Impressao\" \nmd-active=\"vm.tabSelecionada === \'impressao\'\" id=\"cadastros-leiturista-mdtabs-impressao\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'impressao\')\"><md-tab-label><label translate=\"RESOURCES.TAB_IMPRESSAO\"></label>\n</md-tab-label><md-tab-body><md-content ui-view=\"tab-impressao\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Telemetria\" md-active=\"vm.tabSelecionada === \'telemetria\'\" id=\"cadastros-leiturista-mdtabs-telemetria\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'telemetria\')\"><md-tab-label><label translate=\"RESOURCES.TAB_TELEMETRIA\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-telemetria\"></md-content></md-tab-body></md-tab><md-tab \nid=\"cadastros-leiturista-mdtabs-recadastramento\" label=\"Recadastramento\" \nmd-active=\"vm.tabSelecionada === \'recadastramento\'\" md-on-select=\"vm.metodos.tabSelecionada(\'recadastramento\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_RECADASTRAMENTO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-recadastramento\"></md-content></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/cadastros/leiturista/views/leiturista.html","<div id=\"leiturista\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.LEITURISTA\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"leiturista-form\"></div></div><div ui-view=\"leituristas-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/leiturista/views/leituristas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-leituristas-datatable-leiturista\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Nome</th><th>Apelido</th><th>Inativo</th></tr></thead></table>\n</div></div>");
$templateCache.put("app/main/cadastros/parametros/views/parametros-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.parametro\" \nentidades=\"vm.parametros\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \npre-definir-campos-para-edicao=\"vm.metodos.predefinirCamposParaEdicao()\" acao-editar=\"vm.metodos.editar(vm.parametro)\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" metodo-externo-acao-reverter=\"vm.metodos.reverter()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \niniciar-habilitando-modo-pesquisa=\"true\" esconder-botao-pesquisar=\"true\" esconder-botao-inserir=\"true\" \nesconder-mensagem-status=\"true\" esconder-botao-primeira=\"true\" esconder-botao-ultima=\"true\" \nesconder-botao-excluir=\"true\" esconder-botao-proxima=\"true\" esconder-botao-anterior=\"true\" \nescoder-texto-informativo-quantidade=\"true\" esconder-botao-listar-todas-entidades=\"true\" \nesconder-botao-nova-pesquisa=\"true\" esconder-botao-atualizar=\"true\" campo-pesquisar=\"vm.pesquisar\" ng-tipo-layout=\" \">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tabs class=\"equipe-tabs\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Empresa\" md-active=\"vm.tabSelecionada === \'empresa\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'empresa\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_EMPRESA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-empresa\"></md-content></md-tab-body></md-tab><md-tab label=\"Personalização\" \nmd-active=\"vm.tabSelecionada === \'personalizacao\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'personalizacao\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_PERSONALIZACAO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-personalizacao\"></md-content></md-tab-body></md-tab><md-tab label=\"Coletor\" \nmd-active=\"vm.tabSelecionada === \'coletor\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'coletor\')\"><md-tab-label><label\n translate=\"RESOURCES.TAB_COLETOR\"></label></md-tab-label><md-tab-body><md-content ui-view=\"tab-coletor\"></md-content>\n</md-tab-body></md-tab><md-tab label=\"Ocorrencia\" md-active=\"vm.tabSelecionada === \'ocorrencia\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'ocorrencia\')\"><md-tab-label><label translate=\"RESOURCES.TAB_OCORRENCIA\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-ocorrencia\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Cálculo\" md-active=\"vm.tabSelecionada === \'calculo\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'calculo\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_CALCULO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-calculo\"></md-content></md-tab-body></md-tab><md-tab label=\"Impressão\" \nmd-active=\"vm.tabSelecionada === \'impressao\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'impressao\')\"><md-tab-label>\n<label translate=\"RESOURCES.TAB_IMPRESSAO\"></label></md-tab-label><md-tab-body><md-content ui-view=\"tab-impressao\">\n</md-content></md-tab-body></md-tab><md-tab label=\"Controller\" md-active=\"vm.tabSelecionada === \'controller\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'controller\')\"><md-tab-label><label translate=\"RESOURCES.TAB_CONTROLLER\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-controller\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Modo de implantação\" ng-if=\"vm.metodosTab.mostraTabImplantacao()\" \nmd-active=\"vm.tabSelecionada === \'modoimplantacao\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'modoimplantacao\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_MODO_IMPLANTACAO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao\"></md-content></md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/cadastros/parametros/views/parametros.html","<div id=\"parametros\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.PARAMETROS\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"parametros-form\"></div></div></div>");
$templateCache.put("app/main/cadastros/ocorrencia/views/ocorrencia-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.ocorrencias\" \nentidade=\"vm.ocorrencia\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.ocorrencia)\" \nacao-editar=\"vm.metodos.editar(vm.ocorrencia)\" acao-excluir=\"vm.metodos.excluir(vm.ocorrencia)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><md-tabs md-dynamic-height md-border-bottom><md-tab \nid=\"cadastros-ocorrencia-mdtabs-ocorrencia\" label=\"Pessoal\" md-active=\"vm.tabSelecionada === \'ocorrencia\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'ocorrencia\')\"><md-tab-label><label translate=\"RESOURCES.TAB_OCORRENCIA\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-ocorrencia\"></md-content></md-tab-body></md-tab><md-tab \nid=\"cadastros-ocorrencia-mdtabs-comunicado\" label=\"Configuracoes\" md-active=\"vm.tabSelecionada === \'comunicado\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'comunicado\')\"><md-tab-label><label translate=\"RESOURCES.TAB_COMUNICADO\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-comunicado\"></md-content></md-tab-body></md-tab><md-tab \nid=\"cadastros-ocorrencia-mdtabs-configuracoes-adicionais\" label=\"Configurações adicionais\" \nmd-active=\"vm.tabSelecionada === \'configuracoesAdicionais\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'configuracoesAdicionais\')\"><md-tab-label><label>Configurações adicionais\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-configuracoes-adicionais\"></md-content></md-tab-body>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/cadastros/ocorrencia/views/ocorrencia-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-ocorrencias-datatable-ocorrencia\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Descrição</th><th>Valor</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/ocorrencia/views/ocorrencia.html","<div id=\"ocorrencia\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.OCORRENCIA\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"ocorrencia-form\"></div></div><div ui-view=\"ocorrencias-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/tiposervico/views/tiposervico-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidades=\"vm.tiposServico\" entidade=\"vm.tipoServico\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-pre-loader=\"controladorPreLoader\" desabilitar-botao-excluir=\"true\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tipoServico)\" \nacao-editar=\"vm.metodos.editar(vm.tipoServico)\" acao-excluir=\"vm.metodos.excluir(vm.tipoServico)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposInsercao()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding \nflex ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout-gt-xs=\"row\" \nlayout=\"column\" flex><div flex-gt-xs=\"15\" flex layout=\"row\" \nng-if=\"!(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\"><md-input-container flex><label \ntranslate=\"RESOURCES.CODIGO\"></label><input type=\"text\" ng-model=\"vm.tipoServico.codigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex><label translate=\"RESOURCES.DESCRICAO\">\n</label><input type=\"text\" name=\"descricaoTipoServico\" ng-model=\"vm.tipoServico.descricao\" md-maxlength=\"50\" \nmascara-tamanho-campo=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricaoTipoServico.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex layout-padding><md-switch ng-model=\"vm.tipoServico.ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.ATIVO\"></span></md-switch><md-switch ng-model=\"vm.tipoServico.exigeFoto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.EXIGE_FOTO\"></span></md-switch></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/tiposervico/views/tiposervico-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-tiposervico-datatable-tiposervico\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Descrição</th><th>Ativo</th><th>Exige foto</th></tr></thead>\n</table></div></div>");
$templateCache.put("app/main/cadastros/tiposervico/views/tiposervico.html","<div id=\"tipo-servico\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.TIPO_SERVICOS\" icone=\"icon-library-books\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"tiposervico-form\"></div></div><div ui-view=\"tiposervico-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/controleacessomenu/controleacesso/views/controle-acesso-form.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"35\">\n<ms-widget-front class=\"white-bg\" flex><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">Colaboradores</span>\n <span class=\"ml-16 text-boxed blue-bg white-fg\">Perfil: {{vm.perfilDescricao}}</span></div><div class=\"pv-16\" \nstyle=\"margin-right: 10px\"><md-select class=\"simplified\" ng-model=\"vm.filtro.perfilCodigo\" \nng-change=\"vm.metodos.filtrarColaboradoresPorPerfil(vm.filtro.perfilCodigo)\" aria-label=\"Perfil\"><md-option \nng-repeat=\"perfil in vm.perfil\">{{perfil.descricao}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"colaborador in vm.colaboradores\"><div><div class=\"h3\">\n{{colaborador.nome}}</div><div><span class=\"secondary-text\">{{colaborador.login}}</span></div></div></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"30\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"h3\">Rotinas</span> <span class=\"ml-16 text-boxed blue-bg white-fg\" \nng-hide=\"vm.menuTitulo.length == 0\">{{vm.menuTitulo}}</span></div><div class=\"pv-16\" style=\"margin-right: 10px\">\n<md-select class=\"simplified\" ng-model=\"vm.filtro.menuCodigo\" \nng-change=\"vm.metodos.filtrarMenusItensPorMenu(vm.filtro.menuCodigo)\" aria-label=\"Menu\"><md-option \nng-repeat=\"rotina in vm.menus\">{{rotina.titulo}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"menuItem in vm.menusItens\"><div><i \nng-click=\"vm.metodosMenu.controleAcessoMenu(menuItem)\" class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-delete red-fg\':menuItem.selecionado === true, \'icon-plus green-fg\':menuItem.selecionado === false}\">\n</i></div><div ng-click=\"vm.metodos.filtrarMenusSubItensPorMenuItem(menuItem)\" class=\"h3\" flex>{{menuItem.titulo}}\n</div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"35\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">Subrotinas</span> <span class=\"ml-16 text-boxed blue-bg white-fg\" \nng-hide=\"vm.menuItemTitulo.length == 0\">{{vm.menuItemTitulo}}</span></div><div class=\"pv-16\" \nstyle=\"margin-right: 10px\"><md-select class=\"simplified\" ng-model=\"vm.filtro.menuSubMenuItemCodigo\" \nng-change=\"vm.metodosMenuItem.selecionarTodos(vm.filtro.menuSubMenuItemCodigo)\" aria-label=\"Menu\"><md-option>\nAdicionar todos</md-option><md-option>Remover todos</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"menuSubItem in vm.menusSubItens\"><div><i \nng-click=\"vm.metodosMenuItem.controleAcessoMenuIten(menuSubItem.selecionado, menuSubItem)\" \nclass=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-delete red-fg\':menuSubItem.selecionado === true, \'icon-plus green-fg\':menuSubItem.selecionado === false}\">\n</i></div><div class=\"h3\" flex>{{menuSubItem.titulo}}</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/controleacessomenu/controleacesso/views/controle-acesso.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><header-padrao \ntranslate-nome=\"CONTROLE_ACESSO_MENU.TITULO\" icone=\"icon-menu\" liberar-pesquisa-quando-datatable-ativo=\"false\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\" layout=\"column\"><div ui-view=\"controleacesso-form\"></div>\n</div>");
$templateCache.put("app/main/datamobil-ia/components/lista-favoritos/lista-favoritos.html","<div id=\"lista-favoritos\"><div class=\"titulo-lista-favoritos\"><p>Seus favoritos</p></div><div class=\"lista-container\">\n<div class=\"item-favorito\" ng-repeat=\"favorito in vm.datamobilIaService.favoritos track by favorito.id\"><md-button \nclass=\"comando-favorito\" ng-click=\"vm.onComandoSelecionado({comando: favorito.comando}); $event.currentTarget.blur()\" \nng-disabled=\"vm.carregando\">{{favorito.titulo ? favorito.titulo : favorito.comando}}<md-tooltip md-direction=\"bottom\">\n{{favorito.titulo ? favorito.titulo : favorito.comando}}</md-tooltip></md-button><md-menu \nmd-position-mode=\"target-right target\" style=\"margin-right: -2px\"><md-button class=\"md-icon-button btn-acao\" \naria-label=\"Opções\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.metodos.adicionarEditarFavoritos(favorito, $event)\">\n<md-icon md-font-icon=\"icon-pencil\" md-menu-align-target></md-icon>Editar</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.metodos.removerFavorito(favorito, $event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\nRemover</md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-if=\"!vm.datamobilIaService.favoritos.length\" class=\"sem-favoritos\"><p>Você ainda não tem favoritos.</p></div></div>\n</div>");
$templateCache.put("app/main/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/datamobil-ia/components/mensagem-envio/mensagem-envio.html","<div id=\"container-mensagem-envio\"><div class=\"mensagem-envio\"><p class=\"mensagem-digitada m-0\">{{vm.mensagem.comando}}\n</p></div><div class=\"botoes-acoes\"><md-button class=\"md-fab md-raised md-mini acao-copiar\" aria-label=\"Copiar\" \nng-click=\"vm.metodos.copiarMensagem(vm.mensagem, $event)\"><md-icon ng-if=\"!vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/copy.svg\"></md-icon><md-icon ng-if=\"vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-check-circle s16\"></md-icon><md-tooltip \nmd-autohidemd-delay=\"200\"><span>Copiar</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini acao-favoritar\" aria-label=\"Favoritar\" \nng-click=\"vm.metodos.atualizarFavorito(vm.mensagem)\" ng-disabled=\"vm.atualizandoFavorito\"><md-progress-circular \nstyle=\"margin-left: 4.5px\" ng-if=\"vm.atualizandoFavorito\" class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular><md-icon ng-if=\"!vm.atualizandoFavorito && !vm.metodos.isFavorito(vm.mensagem)\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-star-outline s20\"></md-icon><md-icon \nng-if=\"!vm.atualizandoFavorito && vm.metodos.isFavorito(vm.mensagem)\" style=\"color: rgba(0, 0, 0, 0.54)\" \nmd-font-icon=\"icon-star s20\"></md-icon><md-tooltip md-autohidemd-delay=\"200\"><span \nng-if=\"!vm.metodos.isFavorito(vm.mensagem)\">Favoritar</span> <span ng-if=\"vm.metodos.isFavorito(vm.mensagem)\">\nRemover favorito</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/ferramentasadministrativas/backupbancodados/views/backupbancodados.form.html","<div id=\"backup-banco-dados\" class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{ vm.mensagem }}\"></carregamento-circular><form \nname=\"vm.form\" novalidate><div class=\"pt-20 pb-10\" layout=\"row\" layout-align=\"center center\" flex><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.emProgresso\" ng-click=\"vm.metodos.gerarBackupBancoDados()\"><span>\nGerar backup do banco de dados</span></md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.emProgresso\" \nng-click=\"vm.metodos.atualizarDados()\"><span>Atualizar dados</span></md-button></div><table \nclass=\"dataTable row-border hover\" style=\"width: 100%\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Data/hora ínicio da geração\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nData/hora finalização da geração</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Tempo total (minutos)</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Usuário</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Motivo da falha</span></div></th></tr></thead><tbody><tr \nng-repeat=\"backup in vm.backups track by $index\"><td class=\"text-center\"><span>\n{{ backup.dataHoraInicioGeracao | date: \'dd/MM/yyyy HH:mm:ss\' }}</span></td><td class=\"text-center\"><span>\n{{ backup.dataHoraFinalizacaoGeracao | date: \'dd/MM/yyyy HH:mm:ss\' }}</span></td><td class=\"text-center\"><span \nng-if=\"backup.tempoGastoMinutos > 0\">{{ backup.tempoGastoMinutos }}</span> <span ng-if=\"backup.tempoGastoMinutos == 0\">\nMenos de um minuto</span></td><td class=\"text-center\"><span>{{ backup.usuario }}</span></td><td class=\"text-center\">\n<span class=\"text-boxed m-0 white-fg\" \nng-class=\"{ \'md-green-bg\': backup.status == 1, \'deep-orange-bg\': backup.status == 2 }\">\n{{ backup.status == 1 ? \'Gerado\' : \'Falha\' }}</span></td><td class=\"motivo-falha text-center\"><span>\n{{ backup.motivoFalha }}</span></td></tr></tbody></table></form></div>");
$templateCache.put("app/main/ferramentasadministrativas/backupbancodados/views/backupbancodados.html","<md-content id=\"backupbancodados\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Backup do banco de dados\" icone=\"icon-cloud\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"backupbancodados-form@app.backup_banco_dados\"></div></div></div></md-content>");
$templateCache.put("app/main/datamobil-ia/components/mensagens-recebidas/mensagens-recebidas.html","<div id=\"container-mensagem-recebida\"><div class=\"mensagem-recebida\"><p class=\"conteudo-mensagem m-0\" \nng-if=\"vm.mensagem.texto\">{{vm.mensagem.texto}}</p><div class=\"tabela-container\" ng-if=\"vm.mensagem.data\"><div \nclass=\"tabela-container\" ng-if=\"vm.mensagem.data\" style=\"min-width: 100%\"><tabela-resposta data=\"vm.mensagem.data\">\n</tabela-resposta></div></div></div><div class=\"botoes-acoes\"><md-button class=\"md-fab md-raised md-mini acao-aprovar\" \naria-label=\"Aprovar\" ng-click=\"vm.metodos.avaliar(\'positiva\')\" ng-disabled=\"vm.avaliando.carregando\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-2\" md-diameter=\"20px\" \nng-if=\"vm.avaliando.carregando && vm.avaliando.acao === \'positiva\'\"></md-progress-circular><md-icon \nng-if=\"!vm.avaliando.carregando || vm.avaliando.acao !== \'positiva\'\" style=\"color: rgba(0, 0, 0, 0.54)\" \nmd-svg-src=\"{{vm.respostaAvaliada === \'positiva\' ? \'assets/custom/thumbs-up-filled.svg\' : \'assets/custom/thumbs-up.svg\'}}\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Resposta satisfatória</span></md-tooltip></md-button><md-button \nng-click=\"vm.metodos.avaliar(\'negativa\')\" class=\"md-fab md-raised md-mini acao-reprovar\" aria-label=\"Reprovar\" \nng-disabled=\"vm.avaliando.carregando\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-2\" \nmd-diameter=\"20px\" style=\"margin-left: 4px\" ng-if=\"vm.avaliando.carregando && vm.avaliando.acao === \'negativa\'\">\n</md-progress-circular><md-icon ng-if=\"!vm.avaliando.carregando || vm.avaliando.acao !== \'negativa\'\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" \nmd-svg-src=\"{{vm.respostaAvaliada === \'negativa\' ? \'assets/custom/thumbs-down-filled.svg\' : \'assets/custom/thumbs-down.svg\'}}\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Resposta insatisfatória</span></md-tooltip></md-button><md-button\n ng-if=\"vm.mensagem.data\" ng-click=\"vm.metodos.download()\" class=\"md-fab md-raised md-mini acao-download\" \naria-label=\"Download\" ng-disabled=\"vm.baixandoRelatorio\"><md-progress-circular style=\"margin-left: 4px\" \nmd-mode=\"indeterminate\" class=\"md-hue-2\" md-diameter=\"20px\" ng-if=\"vm.baixandoRelatorio\"></md-progress-circular>\n<md-icon ng-if=\"!vm.baixandoRelatorio\" style=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/download.svg\">\n</md-icon><md-tooltip md-autohidemd-delay=\"200\"><span>Download</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/ferramentasadministrativas/mododeimplantacao/views/mododeimplantacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"modoImplantacao-Form\" novalidate><md-content \nlayout-padding><div layout-gt-sm=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nng-show=\"!vm.senha\" flex-gt-sm=\"20\"><label translate=\"RESOURCES.SENHA\">Senha</label><input type=\"password\" \nmascara-tamanho-campo=\"6\" mascara-numero-letra id=\"ferramentasadministrativas-mododeimplantacao-txtSenha\" \nng-keyup=\"$event.keyCode == 13 && vm.metodos.ativarModoImplantacao(true)\" ng-model=\"vm.txtSenha\" required>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-show=\"!vm.senha\" id=\"ferramentasadministrativas-mododeimplantacao-btnAtivar\" \nng-disabled=\"vm.emProgresso || !vm.txtSenha\" ng-click=\"vm.metodos.ativarModoImplantacao(true)\"><span \ntranslate=\"RESOURCES.ATIVAR_MODO_IMPLANTACAO\">Ativar modo de implantação</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-show=\"vm.senha\" id=\"ferramentasadministrativas-mododeimplantacao-btnDesativar\" \nng-click=\"vm.metodos.ativarModoImplantacao(false)\"><span translate=\"RESOURCES.DESATIVAR_MODO_IMPLANTACAO\">\nDesativar modo de implantação</span></md-button></div><progress-linear ng-disabled=\"vm.emProgresso\"></progress-linear>\n</md-content></form></div>");
$templateCache.put("app/main/ferramentasadministrativas/mododeimplantacao/views/mododeimplantacao.html","<div id=\"mododeimplantacao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.MODODEIMPLANTACAO\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"mododeimplantacao-form\"></div></div>");
$templateCache.put("app/main/gerenciamento/produtividade/views/produtividade-form.html","<div layout=\"column\" id=\"produtividade-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-produtividade\" md-whiteframe=\"4\" \nui-view=\"produtividade-filtro@app.gerenciamento_produtividade\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"no-results text-center\" ng-if=\"(!vm.dadosLeituristas || !vm.dadosLeituristas.length)\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.abrirFiltroProdutividade()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span></md-button></div>\n</div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"{{vm.mensagemCarregamento}}\"></carregamento-circular></md-content><md-content class=\"p-8\" \nstyle=\"overflow-y: scroll\" ng-if=\"vm.dadosLeituristas.length && !vm.emProgresso\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><div ng-repeat=\"leiturista in vm.dadosLeituristas track by $index\" layout=\"column\" \nclass=\"pb-8\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table class=\"dataTable hover row-border\">\n<thead><tr show-gt-sm hide class=\"border-top\"><th colspan=\"4\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leiturista: {{leiturista.dados[0].leiturista}}</span></div></th><th\n colspan=\"4\" class=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Horário</span></div></th><th colspan=\"3\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leituras</span></div></th><th colspan=\"1\" \nclass=\"borda-direita th-group-header\"></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Grupo(s)</span></div></th><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nQtde. tarefas</span></div></th><th ng-hide=\"true\"></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Data</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Dia</span></div>\n</th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Inicial\n</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Final</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Total</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title text-center\">Ociosidade</span><md-icon md-font-icon=\"icon-information-outline\" \nstyle=\"margin: 0!important\" class=\"s14\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span>\nÉ considerado tempo ocioso quando existe um espaço de tempo maior que quinze minutos entre as leituras.</span>\n</md-tooltip></md-icon></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Recebidas</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Realizadas</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Críticas</span>\n</div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nAções</span></div></th></tr></thead><tbody><tr ng-repeat=\"dados in leiturista.dados track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{dados.grupos}}</span></td><td \nclass=\"text-center border-left border-right\"><div layout=\"row\" layout-align=\"center center\"><span>\n{{dados.quantidadeTarefas}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirDialogDetalhesProdutividade(dados)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\">\n<span translate=\"RESOURCES.ABRIR_DETALHES\">Detalhes</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"cor-icone-padrao s16\"></md-icon></md-button><md-progress-circular class=\"md-accent\" mode=\"indeterminate\" \nng-if=\"dados.emProgressoDetalhesProdutividade\" md-diameter=\"20\"></md-progress-circular></div></td><td ng-hide=\"true\" \nclass=\"text-center border-right\"><span>{{dados.dateTimeData}}</span></td><td class=\"text-center border-right\"><span>\n{{dados.data}}</span></td><td class=\"text-center border-right\"><span>{{dados.diaSemana}}</span></td><td \nclass=\"text-center border-right\"><span>{{dados.horaInicial}}</span></td><td class=\"text-center border-right\"><span>\n{{dados.horaFinal}}</span></td><td class=\"text-center border-right\"><span>{{dados.horaTotal}}</span></td><td \nclass=\"text-center border-right\" ng-class=\"{\'red-bg white-fg\': dados.ociosidadeCritica}\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"70\" layout=\"row\" layout-align=\"end center\"><span>{{dados.horaOciosidade}}\n</span></div><div flex=\"30\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-if=\"dados.horaOciosidade != \'00:00:00\'\" ng-click=\"vm.metodos.abrirDialogDetalhesOciosidade(dados)\"><md-tooltip \nmd-autohide id=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.ABRIR_DETALHES_OCIOSIDADE\">Detalhes</span>\n</md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" ng-class=\"{\'icone-branco\': dados.ociosidadeCritica}\" \nclass=\"cor-icone-padrao s16 margin-0\"></md-icon></md-button></div></div></td><td class=\"text-center border-right\">\n<span>{{dados.leiturasRecebidas | number}}</span></td><td class=\"text-center border-right\"><span>\n{{dados.leiturasRealizadas | number}}</span></td><td class=\"text-center border-right\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\"><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><span>\n{{dados.quantidadeCriticas | number}}</span></div><div flex=\"70\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-if=\"dados.quantidadeCriticas > 0\" ng-click=\"vm.metodos.abrirDialogDetalhesCritica(dados)\">\n<md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.ABRIR_DETALHES_CRITICA\">Detalhes\n</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" class=\"cor-icone-padrao s16\"></md-icon></md-button>\n<md-progress-circular class=\"md-accent\" mode=\"indeterminate\" ng-if=\"dados.emProgresso\" md-diameter=\"20\">\n</md-progress-circular></div></div></td><td class=\"text-center border-right\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-if=\"false\" \nng-click=\"vm.metodos.abrirDialogDistribuicao(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.ABRIR_RASTREAMENTO\">Rastreamento</span></md-tooltip><md-icon md-font-icon=\"icon-map\" \nclass=\"cor-icone-padrao\"></md-icon></md-button></div></td></tr></tbody></table></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><ms-widget class=\"h-40\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\" \nng-repeat=\"total in leiturista.total\"><ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"secondary-text font-weight-500\"><span style=\"font-size: 11px\">{{total.title}}</span></div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-14\"><span ng-if=\"!total.usePipeNumber\" style=\"font-size: 14px\">\n{{total.data}}</span> <span ng-if=\"total.usePipeNumber\" style=\"font-size: 14px\">{{total.data | number}}</span></div>\n</div></ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div><div layout=\"column\" flex=\"100\">\n<ms-widget style=\"padding:0px!important\"><ms-widget-front class=\"white-bg\" layout=\"column\"><div \nclass=\"ph-16 border-bottom secondary-text\" style=\"background-color:lightgray\"><h3 class=\"text-bold\">Somatório geral\n</h3></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align-gt-sm=\"center center\"><div layout-gt-sm=\"row\" \nlayout=\"column\" flex-gt-sm=\"50\" flex=\"100\"><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leit. recebidas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.dadosSomatorioGeral.leiturasRecebidas | number}}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leit. realizadas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.dadosSomatorioGeral.leiturasRealizadas | number}}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Críticas</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{vm.dadosSomatorioGeral.criticas | number}}</div></div></ms-widget-front></ms-widget></div></div></ms-widget-front>\n</ms-widget></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/produtividade/views/produtividade.html","<div id=\"produtividade\" class=\"page-layout simple tabbed\" style=\"height: 75vh\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.PRODUTIVIDADE\" icone=\"icon-chart-bar\" ng-if=\"!vm.dadosLeituristas.length\" \npesquisar=\"vm.pesquisar\" ng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"fab-button\" \nng-if=\"vm.dadosLeituristas.length\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\" disabled=\"vm.emProgresso\"></div>\n<div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.dadosLeituristas.length\"><div flex=\"75\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" \nshow-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Agrupamento</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtroUtilizado.descricaoAgrupamento}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data inicial</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtroUtilizado.dataInicio | date: \'dd/MM/yyyy\'}}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data final</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtroUtilizado.dataFim | date: \'dd/MM/yyyy\'}}</div></div></ms-widget-front></ms-widget>\n</div></div><div class=\"content\" ms-scroll><div ui-view=\"produtividade-form\"></div></div></div>");
$templateCache.put("app/main/inicio/components/dialog/dialog-datamobil.html","<md-dialog aria-label=\"Datamobil\" class=\"dialog-datamobil\"><md-dialog-content><div class=\"dialog-datamobil-container\">\n<img src=\"assets/images/datamobil/datamobil.png\" alt=\"Datamobil\" class=\"dialog-datamobil-imagem\"><div \nclass=\"dialog-datamobil-botao-fechar\" ng-click=\"vm.fechar()\"></div><div class=\"dialog-datamobil-botao-principal\" \nng-click=\"vm.irParaDatamobil()\"></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamentocarga/leiturista/views/gerenciamento-carga-leiturista.html","<div flex layout-gt-sm=\"row\" style=\"height: 100% !important\" id=\"gerenciamento-carga-leiturista\"><div flex \nlayout=\"column\"><ms-widget flex class=\"widget-group\" ng-if=\"vm.habilitarLeituristas\"><ms-widget-front class=\"white-bg\" \nlayout-fill><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3 p-16\">\nLeituristas</div><div layout=\"row\" layout-align=\"center center\" layout-wrap><md-button \nng-click=\"vm.metodos.abrirChat($event)\" class=\"md-fab md-accent md-mini\" aria-label=\"Chat\" style=\"margin: 2px\"><md-icon\n md-svg-src=\"assets/angular-material-assets/img/icons/chat-24px.svg\"><md-tooltip>Chat</md-tooltip></md-icon>\n</md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.metodos.habilitarPesquisa()\" \naria-label=\"Pesquisar\" style=\"margin: 2px\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/search-24px.svg\"><md-tooltip>Pesquisar</md-tooltip></md-icon>\n</md-button></div></div><md-input-container ng-if=\"vm.habilitarPesquisa\" class=\"md-icon-float md-block\"><label>\nPesquisar</label><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \nng-click=\"vm.metodos.desabilitarPesquisa()\" class=\"name red-300-fg\"><md-tooltip>Fechar pesquisa</md-tooltip></md-icon>\n<input ng-model=\"vm.filtroLeiturista\" type=\"text\" maxlength=\"50\" style=\"max-width: 85%\"></md-input-container>\n<md-content ng-style=\"{\'height\' : \'40vh\'}\"><md-list-item \nng-repeat=\"leiturista in vm.leituristasFiltrados | filter: {apelido: vm.filtroLeiturista}\" \nng-click=\"vm.metodos.atualizarLeituristaDashboard(leiturista, $event)\" \nng-class=\"{\'leiturista-selecionado\': leiturista === vm.leituristaSelecionado}\" \nng-if=\"vm.leituristasFiltrados.length > 0\" class=\"noright\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" style=\"position: relative\"><img class=\"md-avatar\" ng-src=\"{{leiturista.foto}}\" \nalt=\"{{leiturista.apelido}}\"><div ng-show=\"leiturista.situacao.status > 0\" class=\"status\"><md-icon \nng-if=\"leiturista.situacao.status == 1\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s16\" ng-style=\"{\'color\' : \'green\'}\"><md-tooltip>Ativo</md-tooltip></md-icon><md-icon \nng-if=\"leiturista.situacao.status == 2\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s16\" ng-style=\"{\'color\' : \'orange\'}\"><md-tooltip>Ausente</md-tooltip></md-icon><md-icon \nng-if=\"leiturista.situacao.status == 3\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s16\" ng-style=\"{\'color\' : \'gray\'}\"><md-tooltip>Inativo</md-tooltip></md-icon><md-icon \nng-if=\"leiturista.situacao.status == 4\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" \nclass=\"s16\" ng-style=\"{\'color\' : \'red\'}\"><md-tooltip>Aguardando o envio de coordenadas</md-tooltip></md-icon></div>\n</div><div class=\"ph-16 pv-20\" layout=\"row\" layout-align=\"space-between center\" flex=\"70\"><div layout=\"column\" flex>\n<div layout=\"row\" flex><div hide-xs layout-gt-sm=\"row\" layout-align=\"start start\" flex=\"80\"><span class=\"font-size-16\">\n{{leiturista.apelido}}</span></div><div hide-gt-sm hide-sm layout=\"row\" layout-align=\"start start\" flex-offset=\"5\" \nflex=\"80\"><span class=\"font-size-16\">{{leiturista.apelido.substring(0, 5)}}...</span></div><div layout=\"row\" \nlayout-align=\"end end\" flex><span hide-xs hide-sm class=\"h3 secondary-text font-weight-500\">\n{{leiturista.situacao.realizado}}%</span> <span hide-gt-sm class=\"secondary-text font-size-12 font-weight-500\">\n{{leiturista.situacao.realizado}}%</span></div></div><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{leiturista.situacao.realizado}}\"></md-progress-linear></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex><md-menu flex><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\" ng-disabled=\"leiturista != vm.leituristaSelecionado\"><md-icon md-font-icon=\"icon-cellphone-android\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.tipoProcesso == \'02\'\"><md-button \nng-click=\"vm.metodos.abrirDisponibilizacaoTarefa(leiturista.codigo)\" aria-label=\"Flip widget\">Disponibilizar tarefa\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.tipoProcesso == \'01\'\"><md-button \nng-click=\"vm.metodos.abrirDisponibilizarCarga($event, leiturista.codigo)\" aria-label=\"Flip widget\">Disponibilizar carga\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.tipoProcesso == \'01\'\"><md-button \nng-click=\"vm.metodos.abrirGerarArquivoRetorno($event, leiturista.codigo)\" aria-label=\"Refresh widget\">Gerar arquivo\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu flex><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\" ng-disabled=\"leiturista != vm.leituristaSelecionado\"><md-icon \nmd-font-icon=\"icon-map\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.metodos.abrirRastreamento(leiturista)\" aria-label=\"Rastreamento\">Rastreamento</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.metodos.abrirMonitoramento(leiturista)\" aria-label=\"Monitoramento\">Monitoramento\n</md-button></md-menu-item></md-menu-content></md-menu><md-icon flex md-font-icon=\"icon-download\" \nng-hide=\"vm.arquivoProgress[leiturista.codigo]\" \nng-if=\"leiturista.situacao.realizado >= 100 && vm.tipoProcesso02 == false\" \nng-disabled=\"leiturista != vm.leituristaSelecionado\" ng-click=\"vm.metodos.gerarArquivoRetorno(leiturista, $event)\" \naria-label=\"Baixar\" class=\"md-secondary md-hue-3\" ng-style=\"{\'color\' : \'#66BB6A\'}\"><md-tooltip>\nDownload arquivo de retorno</md-tooltip></md-icon><md-progress-circular flex flex-offset=\"15\" \nng-disabled=\"leiturista != vm.leituristaSelecionado\" id=\"icon-download-progress\" class=\"md-accent md-hue-3\" \nng-show=\"vm.arquivoProgress[leiturista.codigo]\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<md-icon flex md-svg-src=\"../../../../../assets/icons/gerenciamento-carga/unificada.svg\" \nng-hide=\"vm.arquivoProgress[leiturista.codigo]\" \nng-if=\"leiturista.tarefaUnificada && vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-disabled=\"leiturista != vm.leituristaSelecionado\" aria-label=\"Unificada\" ng-click=\"\" class=\"md-secondary md-hue-3\" \nng-style=\"{\'color\' : \'#ff9800\'}\"><md-tooltip>Tarefa unificada</md-tooltip></md-icon><md-icon flex \nmd-svg-src=\"../../../../../assets/icons/gerenciamento-carga/comum.svg\" ng-hide=\"vm.arquivoProgress[leiturista.codigo]\" \nng-if=\"!leiturista.tarefaUnificada && vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-disabled=\"leiturista != vm.leituristaSelecionado\" aria-label=\"Comum\" ng-click=\"\" class=\"md-secondary md-hue-3\" \nng-style=\"{\'color\' : \'#66BB6A\'}\"><md-tooltip>Tarefa comum</md-tooltip></md-icon></div></md-list-item></md-content>\n</ms-widget-front></ms-widget></div><div flex layout=\"column\"><ms-widget flex class=\"widget-group\" \nng-if=\"vm.habilitarLeituristas\"><ms-widget-front class=\"white-bg\" layout-fill><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3 p-16\">{{vm.dashboard.titulo}}</div><md-button \nclass=\"md-fab md-accent md-mini\" ng-if=\"!vm.detalhes\" ng-click=\"vm.metodos.habilitarDetalhes(true)\" \naria-label=\"Detalhes\" style=\"margin: 2px\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/more_vert-24px.svg\"><md-tooltip>Detalhes</md-tooltip></md-icon>\n</md-button><md-button class=\"md-fab md-accent md-mini\" ng-if=\"vm.detalhes\" \nng-click=\"vm.metodos.habilitarLeituristaDashboard(vm.leituristasDashboard)\" aria-label=\"Dashboard\" style=\"margin: 2px\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/donut_large-24px.svg\"><md-tooltip>Estatísticas\n</md-tooltip></md-icon></md-button></div><div layout-gt-sm=\"row\" flex ng-show=\"vm.detalhes\"><div flex layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"p-8\"><div \nclass=\"h3 secondary-text\" style=\"text-align: center\">{{vm.tituloCarga}}</div><div class=\"pt-8 md-display-1\" \nstyle=\"text-align: center\" \nng-class=\"{\'tipo-processo-distribuido\' : vm.tipoProcesso02, \'tipo-processo\' : vm.tipoProcesso02 == false}\"><span \nclass=\"secondary-text\"></span><span>{{vm.dashboard.detalhe.nomeArquivo}}</span></div></div></div><div \nclass=\"border-top\" layout=\"row\" layout-align=\"center center\" flex=\"100\"><div class=\"p-8\"><div \nclass=\"h3 secondary-text\" style=\"text-align: center\">Recebido no coletor</div><div class=\"pt-8 md-display-1\" \nstyle=\"text-align: center\" \nng-class=\"{\'tipo-processo-distribuido\' : vm.tipoProcesso02, \'tipo-processo\' : vm.tipoProcesso02 == false}\"><span \nclass=\"secondary-text\"></span><span>{{vm.dashboard.detalhe.disponilizada}}</span></div></div></div></div></div><div \nlayout-gt-sm=\"row\" flex ng-if=\"!vm.detalhes\"><div layout=\"column\" flex ng-if=\"vm.emProgresso\"><md-content \nlayout-align=\"center center\" flex=\"50\" class=\"loading-content\" layout=\"column\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"64\"></md-progress-circular></md-content></div><div \nlayout=\"column\" layout-align=\"center center\" flex=\"50\" ng-if=\"!vm.emProgresso\"><nvd3 layout-align=\"center center\" \nconfig=\"vm.dashboard.mainChart.config\" options=\"vm.dashboard.mainChart.options\" data=\"vm.dashboard.mainChart.data\">\n</nvd3></div><div flex class=\"border-left\" layout=\"column\" layout-align=\"center center\" flex=\"50\"><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div layout=\"column\" flex layout-align=\"center center\"><span \nclass=\"font-size-32\" style=\"font-weight: 600\">{{vm.dashboard.footerLeft.total}}</span> <span class=\"font-size-18\">\n{{vm.dashboard.footerLeft.titulo}}</span></div></div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/gerenciamentocarga/totalizador/views/gerenciamento-carga-totalizador.html","<div id=\"widgets\" flex><div class=\"widget-group\" layout=\"row\" flex=\"95\" layout-wrap ng-if=\"vm.habilitarTotalizadores\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-md=\"33\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"p-16 green-400-bg white-fg\" style=\"justify-content: center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"pb-24\" layout=\"row\" layout-align=\"start start\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-engine\"></md-icon><div class=\"h3\">Leit. normal</div></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.totalizador.leituras}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.totalizador.clientes}}</div></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.totalizador.leiturasPercentual}}\"></md-progress-linear></ms-widget-front></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-md=\"33\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"p-16 orange-400-bg white-fg\" style=\"justify-content: center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"pb-24\" layout=\"row\" layout-align=\"start start\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-engine\"></md-icon><div class=\"h3\">Leit. com ocorrência</div></div><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.totalizador.leiturasComOcorrencia}}</div>\n<div class=\"h2 secondary-text pl-8\">/ {{vm.totalizador.clientes}}</div></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.totalizador.leiturasComOcorrenciaPercentual}}\"></md-progress-linear>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-md=\"33\" flex-gt-md=\"33\">\n<ms-widget-front class=\"p-16 red-400-bg white-fg\" style=\"justify-content: center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"pb-24\" layout=\"row\" layout-align=\"start start\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-engine\"></md-icon><div class=\"h3\">Somente ocorrência</div></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.totalizador.somenteOcorrencia}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.totalizador.clientes}}</div></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.totalizador.somenteOcorrenciaPercentual}}\"></md-progress-linear></ms-widget-front>\n</ms-widget></div></div>");
$templateCache.put("app/main/controlecarga/trocarleiturista/views/trocar-leiturista-form.html","<div layout=\"column\" id=\"troca-leiturista-form\"><carregamento-circular em-progresso=\"vm.emProgressoBuscaTarefa\" \ntitulo=\"Aguarde...\" mensagem=\"Buscando dado da tarefa...\"></carregamento-circular><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-left\" md-component-id=\"filtro-troca-leiturista\" md-whiteframe=\"4\" \nui-view=\"filtro-trocarleiturista-sidenav@app.controlecarga_trocarleiturista\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"no-results text-center\" \nng-if=\"!vm.dados && !vm.emProgresso && !vm.emProgressoBuscaTarefa && !vm.trocandoLeituristaViaDialog\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUMA_TAREFA\">Nenhuma tarefa filtrada.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroTrocarLeiturista()\"><span translate=\"RESOURCES.FILTRAR\">\nFiltrar</span></md-button></div></div><md-content flex=\"100\" class=\"p-8\" ng-if=\"vm.dados\"><table datatable=\"ng\" \ndt-options=\"vm.dtOptions\" class=\"dataTable hover row-border mt-15 border-right border-bottom\"><thead><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\">Referência</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Tarefa</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nData de disponibilização</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Quantidade de ligações</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Tipo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leiturista atual</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Novo leiturista</span></div></th></thead><tbody><tr><td \nclass=\"text-center border-left border-right\"><span ng-repeat=\"tarefa in vm.dados.tarefa\">{{tarefa.referencia}}<br>\n</span></td><td class=\"text-center border-right\"><span ng-repeat=\"tarefa in vm.dados.tarefa\">{{tarefa.tarefa}}<br>\n</span></td><td class=\"text-center border-right\"><span>\n{{ vm.dados.tarefa[0].dataDisponibilizacao | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></td><td \nclass=\"text-center border-right\"><span ng-if=\"vm.dados.tarefa.length == 1\">{{vm.dados.tarefa[0].quantidadeLeituras}} \n</span><span ng-if=\"vm.dados.tarefa.length > 1\">{{ vm.metodos.retornaTotalLeituras(vm.dados.tarefa) }}</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><span \nclass=\"ml-5 text-boxed orange-bg white-fg ng-binding\" ng-if=\"vm.dados.tarefa[0].tarefaUnificada\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Unificada </span><span class=\"ml-5 text-boxed green-bg white-fg ng-binding\" \nng-if=\"!vm.dados.tarefa[0].tarefaUnificada\" style=\"margin: 5px 5px; font-size: 0.85em\">Comum</span></td><td \nclass=\"text-center border-right\" style=\"padding-right: 8px\"><span>{{vm.dados.tarefa[0].nomeLeiturista}}</span></td><td \nclass=\"border-right\" ng-form=\"vm.form\"><md-input-container class=\"md-block\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-model=\"vm.leituristaDestino\" \nmd-on-open=\"vm.metodos.configuraMdSelectLeiturista()\" ng-required=\"vm.dados.leituristas.length > 0\" name=\"leiturista\" \nng-disabled=\"vm.dados.leituristas.length == 0\"><md-select-header ng-if=\"vm.dados.leituristas.length > 0\"><input \nng-model=\"vm.filtrarLeiturista\" type=\"search\" id=\"select-leiturista\" placeholder=\"Pesquisar leiturista..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.dados.leituristas | filter: vm.filtrarLeiturista\">\n{{leiturista.codigo}} - {{leiturista.apelido}}</md-option></md-select><span ng-if=\"vm.dados.leituristas.length == 0\" \nclass=\"nenhum-grupo\">Nenhuma leiturista encontrado.</span><div ng-messages=\"vm.form.leiturista.$error\"><div \nng-message=\"required\">Favor informar leiturista</div></div></md-input-container></td></tr></tbody></table><div \nlayout=\"row\" layout-align=\"end center\" flex><md-progress-circular ng-if=\"vm.emProgresso\" md-diameter=\"30\" \nclass=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><md-button \nng-disabled=\"vm.emProgresso || !vm.leituristaDestino\" class=\"md-raised md-accent\" \nng-click=\"vm.metodos.salvarTrocaLeiturista()\"><span>Salvar</span></md-button></div></md-content></div>");
$templateCache.put("app/main/controlecarga/trocarleiturista/views/trocar-leiturista.html","<div id=\"trocar-leiturista\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.TROCAR_TAREFAS_LEITURISTAS\" icone=\"icon-clipboard-text\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div class=\"fab-button\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\" \ndisabled=\"vm.emProgresso\"></div><div ui-view=\"trocarleiturista-form@app.controlecarga_trocarleiturista\"></div></div>");
$templateCache.put("app/main/controlecarga/cancelarcarga/views/cancelar-carga-form.html","<div id=\"cancelar-carga-form\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"filtro-cancelarcarga\" md-whiteframe=\"4\" \nui-view=\"filtro-cancelarcarga-sidenav@app.controlecarga_cancelamentocarga\" ms-scroll ms-sidenav-helper \nmd-is-open=\"true\"></md-sidenav><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagem }}\"></carregamento-circular><md-content layout-padding \nng-if=\"vm.dados.arquivos.length > 0 && !vm.emProgresso\" layout=\"column\"><div layout-gt-sm=\"row\" \nlayout-align=\"center center\" flex=\"100\"><div layout-align=\"center center\" layout-gt-xs=\"row\" flex=\"30\" flex-gt-xs=\"30\">\n<div layout=\"row\" flex=\"100\" class=\"div-card\"><ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">\nMês/Ano Referência</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{ vm.dados.filtros.mes }}/{{ vm.dados.filtros.ano }}</div></div></ms-widget-front></ms-widget></div></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div><table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead \nclass=\"header-table\"><tr><th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Nome do arquivo</span></div></th><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nData da disponibilização da carga</span></div></th><th ng-if=\"vm.tipoProcesso == \'01\'\" \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Leiturista</span>\n</div></th><th ng-if=\"vm.tipoProcesso == \'02\'\" class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Grupo</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Status</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Ação</span></div>\n</th></tr></thead><tbody><tr \nng-repeat=\"arquivo in vm.dados.arquivos | orderBy: vm.nomePropriedade:vm.reverso | filter: vm.pesquisar track by $index\">\n<td class=\"text-center border-left border-right\"><span>{{ arquivo.nomeArquivoExportacao }}</span></td><td \nclass=\"text-center border-right\"><span>{{ arquivo.dataExportacao | date:\'dd/MM/yyyy HH:mm:ss\' }}</span></td><td \nng-if=\"vm.tipoProcesso == \'01\'\" class=\"text-center border-right\"><span>{{ arquivo.leiturista }}</span></td><td \nng-if=\"vm.tipoProcesso == \'02\'\" class=\"text-center border-right\"><span>{{ arquivo.grupo }}</span></td><td \nclass=\"border-right text-center coluna-status\"><span class=\"text-boxed m-0 white-fg\" \nng-class=\"{\'light-blue-bg\': arquivo.statusCarga == 1, \r\n                                                         \'deep-orange-bg\': arquivo.statusCarga == 2,\r\n                                                         \'light-green-bg\': arquivo.statusCarga == 3}\">\n<md-tooltip md-autohide><span>\n{{ arquivo.statusCarga == 1 ? \'Nenhuma leitura executada\' : \'Existem leituras executadas\' }}</span></md-tooltip>\n{{ arquivo.statusDescricao }}</span></td><td class=\"text-center border-right\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.cancelarCarga(arquivo)\"><md-tooltip md-autohide><span translate=\"\">Cancelar carga</span>\n</md-tooltip><md-icon class=\"cor-icone-padrao\" md-font-icon=\"icon-close-circle\"></md-icon></md-button></td></tr>\n</tbody></table></div></ms-widget-front></ms-widget></div></md-content></div>");
$templateCache.put("app/main/controlecarga/cancelarcarga/views/cancelar-carga.html","<md-content id=\"cancelar-carga\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.CANCELAR_CARGA\" icone=\"icon-close-circle-outline\" pesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.dados.arquivos.length && !vm.emProgresso\" ng-utiliza-pesquisa=\"true\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nclass=\"button-float\" role=\"button\"><div class=\"button-toogle\" ng-click=\"vm.metodos.abrirFiltroCancelamento()\">\n<md-tooltip md-autohide id=\"pg-tooltip-filtrar\" md-direction=\"left\"><span>Filtrar</span></md-tooltip><md-icon \nmd-font-icon=\"icon-filter\" class=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></div></div><div ui-view=\"cancelar-carga-form@app.controlecarga_cancelamentocarga\">\n</div></div></div></md-content>");
$templateCache.put("app/main/processamento/disponibilizar-carga-retidas/views/disponibilizar-carga-retidas-form.html","<div id=\"processamento-disponibilizar-carga-retidas-form\" layout=\"column\"><progress-linear \nng-disabled=\"vm.emProgresso\"></progress-linear><carregamento-circular ng-if=\"vm.emProgressoDisponibilizacao\" \nem-progresso=\"vm.emProgressoDisponibilizacao\" mensagem=\"Disponibilizando faturas...\" titulo=\"Aguarde...\">\n</carregamento-circular><md-content layout-padding layout=\"column\"><div flex=\"100\" layout=\"column\" \nstyle=\"position: relative\"><div layout=\"row\" layout-align=\"start start\" class=\"contador-flutuante\" \nng-if=\"vm.metodos.quantidadeFaturasSelecionadas() > 0\"><h2 class=\"font-bold\">\n{{ vm.metodos.quantidadeFaturasSelecionadas() }} <span ng-if=\"vm.metodos.quantidadeFaturasSelecionadas() == 1\">\nligação selecionada</span> <span ng-if=\"vm.metodos.quantidadeFaturasSelecionadas() > 1\">ligações selecionadas</span>\n</h2></div><div layout=\"row\" layout-align=\"end start\" ng-if=\"!vm.ehDialog\" class=\"botao-flutuante\"><md-button \nclass=\"md-fab md-mini p-0\" aria-label=\"Disponibilizar faturas\" ng-click=\"vm.metodos.disponibilizarRetidas()\" \nng-disabled=\"vm.emProgresso || vm.emProgressoDisponibilizacao || vm.metodos.quantidadeFaturasSelecionadas() == 0\">\n<md-tooltip>Disponibilizar ligações selecionadas</md-tooltip><md-icon md-font-icon=\"icon-upload s32\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini p-0\" aria-label=\"Atualizar dados\" ng-click=\"vm.metodos.atualizarDados()\" \nng-disabled=\"vm.emProgresso || vm.emProgressoDisponibilizacao\"><md-tooltip>Atualizar</md-tooltip><md-icon \nmd-font-icon=\"icon-refresh s32\"></md-icon></md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th><md-checkbox class=\"margin-0\" \nng-disabled=\"vm.emProgresso || vm.emProgressoDisponibilizacao || !vm.faturasRetidas.length\" \nng-model=\"vm.todosMarcados\" ng-click=\"vm.metodos.marcarTodas()\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Código da ligação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Cliente principal</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label>Setor</label><md-select ng-model=\"vm.setorSelecionado\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configuraMdSelectSetor()\"><md-select-header ng-if=\"vm.setoresUnicos.length > 0\"><input \nng-model=\"vm.filtrarSetores\" type=\"search\" id=\"select-setor\" placeholder=\"Pesquisar setores..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"setor\" ng-repeat=\"setor in vm.setoresUnicos | filter: vm.filtrarSetores\">\n{{ setor }}</md-option></md-select></md-input-container></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-input-container class=\"md-block\" layout=\"column\" flex><label>Rota</label><md-select \nng-model=\"vm.rotaSelecionada\" multiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectRota()\"><md-select-header \nng-if=\"vm.rotasUnicas.length > 0\"><input ng-model=\"vm.filtrarRotas\" type=\"search\" id=\"select-rota\" \nplaceholder=\"Pesquisar rotas..\" class=\"md-text\"></md-select-header><md-option ng-value=\"rota\" \nng-repeat=\"rota in vm.rotasUnicas | filter: vm.filtrarRotas\">{{ rota }}</md-option></md-select></md-input-container>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Endereço</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nQuantidade de dependentes</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Próximo vencimento</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Dependentes</span></div></th></tr></thead><tbody><tr \nng-repeat=\"fatura in vm.faturasRetidas track by $index\"><td><md-checkbox ng-model=\"fatura.selecionada\" \nng-disabled=\"vm.emProgresso || vm.emProgressoDisponibilizacao\"></md-checkbox></td><td class=\"text-center\"><span>\n{{ fatura.codigo }}</span></td><td class=\"text-center\"><span>{{ fatura.nome }}</span></td><td class=\"text-center\">\n<span>{{ fatura.setor }}</span></td><td class=\"text-center\"><span>{{ fatura.rota }}</span></td><td class=\"text-center\">\n<span>{{ fatura.endereco }}</span></td><td class=\"text-center\"><span>{{ fatura.quantidadeDependentes }}</span></td><td \nclass=\"text-center\"><span ng-show=\"false\">{{ fatura.vencimento }}</span> <span \nng-class=\"{vencida: vm.metodos.faturaVencida(fatura)}\">{{ fatura.vencimento | date: \"dd/MM/yyyy HH:mm:ss\" }}</span>\n</td><td class=\"text-center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirDialogDetalhesDependentes(fatura.dependentes)\"><md-tooltip md-autohide><span>\nDetalhes dependentes</span></md-tooltip><md-icon md-font-icon=\"icon-account-multiple\" class=\"cor-icone-padrao\">\n</md-icon></md-button></td></tr></tbody></table></div></md-content></div>");
$templateCache.put("app/main/processamento/disponibilizar-carga-retidas/views/disponibilizar-carga-retidas.html","<md-content id=\"processamento-disponibilizar-carga-retidas\" class=\"page-layout simple tabbed\" layout=\"column\">\n<header-padrao translate-nome=\"Disponibilizar carga de faturas retidas vinculadas\" icone=\"icon-cellphone-android\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex \nms-scroll><div ui-view=\"disponibilizarcargaretidas-form\"></div></div></div></md-content>");
$templateCache.put("app/main/processamento/alerta-cliente/views/alerta-cliente-form.html","<div id=\"processamento-alerta-cliente-form\" layout=\"column\"><progress-linear ng-disabled=\"vm.emProgresso\">\n</progress-linear><md-content layout-padding layout=\"column\"><div flex=\"100\" layout=\"column\"><div flex layout=\"row\" \nclass=\"pr-30\" style=\"flex-direction: row-reverse; position: relative\"><div class=\"botao-flutuante\"><md-button \nclass=\"md-fab md-mini p-0\" aria-label=\"Cadastrar novo alerta\" ng-if=\"!vm.metodos.existeAlertaMarcado()\" \nng-click=\"vm.metodos.abrirDialogCadastroAlerta()\" ng-disabled=\"vm.emProgresso\"><md-tooltip>Cadastrar novo alerta\n</md-tooltip><md-icon md-font-icon=\"icon-plus s32\"></md-icon></md-button><md-button class=\"md-fab md-mini p-0\" \naria-label=\"Cadastrar novo alerta\" ng-if=\"!vm.metodos.existeAlertaMarcado()\" ng-click=\"vm.metodos.atualizarAlertas()\" \nng-disabled=\"vm.emProgresso\"><md-tooltip>Atualizar</md-tooltip><md-icon md-font-icon=\"icon-refresh s32\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini p-0\" aria-label=\"Excluir alertas marcado\" \nng-if=\"vm.metodos.existeAlertaMarcado()\" ng-click=\"vm.metodos.excluirAlertas()\" ng-disabled=\"vm.emProgresso\">\n<md-tooltip>Excluir alertas marcados</md-tooltip><md-icon md-font-icon=\"icon-delete s32\"></md-icon></md-button></div>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"width: 100%\" \nng-disabled=\"vm.emProgresso\"><thead><tr><th class=\"text-center\"><md-checkbox class=\"margin-0\" \nng-click=\"vm.metodos.marcarTodas()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Código da ligação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Alerta</span></div></th><th class=\"secondary-text\">Ação\n</th></tr></thead><tbody><tr ng-repeat=\"alerta in vm.alertas track by $index\"><td class=\"text-center\"><md-checkbox \nng-model=\"alerta.marcado\"></md-checkbox></td><td class=\"text-center\"><span>{{alerta.codigoLigacao}}</span></td><td \nclass=\"text-center\"><span>{{alerta.mensagem}}</span></td><td class=\"text-center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirDialogCadastroAlerta(alerta)\" ng-disabled=\"vm.emProgresso\"><md-tooltip md-autohide><span>\nEditar</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"cor-icone-padrao\"></md-icon></md-button></td></tr>\n</tbody></table></div></md-content></div>");
$templateCache.put("app/main/processamento/alerta-cliente/views/alerta-cliente.html","<md-content id=\"processamento-alerta-cliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Alerta de clientes\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div ui-view=\"alertacliente-form\"></div>\n</div></div></md-content>");
$templateCache.put("app/main/processamento/cancelamento-faturas-retidas/views/cancelamento-faturas-retidas-form.html","<div id=\"processamento-cancelamento-faturas-retidas-form\" layout=\"column\"><progress-linear \nng-disabled=\"vm.emProgresso\"></progress-linear><carregamento-circular ng-if=\"vm.emProgressoCancelamento\" \nem-progresso=\"vm.emProgressoCancelamento\" mensagem=\"Realizando o cancelamento...\" titulo=\"Aguarde...\">\n</carregamento-circular><md-content layout-padding layout=\"column\"><div flex=\"100\" layout=\"column\" \nstyle=\"position: relative\"><div layout=\"row\" layout-align=\"start start\" class=\"contador-flutuante\" \nng-if=\"vm.metodos.quantidadeFaturasSelecionadas() > 0\"><h2 class=\"font-bold\">\n{{ vm.metodos.quantidadeFaturasSelecionadas() }} <span ng-if=\"vm.metodos.quantidadeFaturasSelecionadas() == 1\">\nligação selecionada</span> <span ng-if=\"vm.metodos.quantidadeFaturasSelecionadas() > 1\">ligações selecionadas</span>\n</h2></div><div layout=\"row\" layout-align=\"end start\" class=\"botao-flutuante\"><md-button class=\"md-fab md-mini p-0\" \naria-label=\"Cancelar ligações selecionadas\" ng-click=\"vm.metodos.cancelar()\" \nng-disabled=\"vm.emProgresso || vm.emProgressoCancelamento || vm.metodos.quantidadeFaturasSelecionadas() == 0\">\n<md-tooltip>Cancelar ligações selecionadas</md-tooltip><md-icon md-font-icon=\"icon-close s32\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini p-0\" aria-label=\"Atualizar dados\" ng-click=\"vm.metodos.atualizarDados()\" \nng-disabled=\"vm.emProgresso || vm.emProgressoCancelamento\"><md-tooltip>Atualizar</md-tooltip><md-icon \nmd-font-icon=\"icon-refresh s32\"></md-icon></md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th><md-checkbox class=\"margin-0\" \nng-disabled=\"vm.emProgresso || vm.emProgressoCancelamento || !vm.faturasRetidas.length\" ng-model=\"vm.todosMarcados\" \nng-click=\"vm.metodos.marcarTodas()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leiturista</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Data da disponibilização</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Código da ligação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Cliente principal</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label>Setor</label><md-select ng-model=\"vm.setorSelecionado\" multiple=\"multiple\" \nmd-on-open=\"vm.metodos.configuraMdSelectSetor()\"><md-select-header ng-if=\"vm.setoresUnicos.length > 0\"><input \nng-model=\"vm.filtrarSetores\" type=\"search\" id=\"select-setor\" placeholder=\"Pesquisar setores..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"setor\" ng-repeat=\"setor in vm.setoresUnicos | filter: vm.filtrarSetores\">\n{{ setor }}</md-option></md-select></md-input-container></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-input-container class=\"md-block\" layout=\"column\" flex><label>Rota</label><md-select \nng-model=\"vm.rotaSelecionada\" multiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectRota()\"><md-select-header \nng-if=\"vm.rotasUnicas.length > 0\"><input ng-model=\"vm.filtrarRotas\" type=\"search\" id=\"select-rota\" \nplaceholder=\"Pesquisar rotas..\" class=\"md-text\"></md-select-header><md-option ng-value=\"rota\" \nng-repeat=\"rota in vm.rotasUnicas | filter: vm.filtrarRotas\">{{ rota }}</md-option></md-select></md-input-container>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Endereço</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nQuantidade de dependentes</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Dependentes</span></div></th></tr></thead><tbody><tr \nng-repeat=\"fatura in vm.faturasRetidas track by $index\"><td><md-checkbox ng-model=\"fatura.selecionada\" \nng-disabled=\"vm.emProgresso || vm.emProgressoCancelamento\"></md-checkbox></td><td class=\"text-center\"><span>\n{{ fatura.nomeLeiturista }}</span></td><td class=\"text-center\"><span>\n{{ fatura.dataDisponibilizacao | date: \"dd/MM/yyyy HH:mm:ss\" }}</span></td><td class=\"text-center\"><span>\n{{ fatura.codigo }}</span></td><td class=\"text-center\"><span>{{ fatura.nome }}</span></td><td class=\"text-center\">\n<span>{{ fatura.setor }}</span></td><td class=\"text-center\"><span>{{ fatura.rota }}</span></td><td class=\"text-center\">\n<span>{{ fatura.endereco }}</span></td><td class=\"text-center\"><span>{{ fatura.quantidadeDependentes }}</span></td><td \nclass=\"text-center\"><md-button class=\"md-icon-button\" ng-disabled=\"vm.emProgresso || vm.emProgressoCancelamento\" \nng-click=\"vm.metodos.abrirDialogDetalhesDependentes(fatura.dependentes)\"><md-tooltip md-autohide><span>\nDetalhes dependentes</span></md-tooltip><md-icon md-font-icon=\"icon-account-multiple\" class=\"cor-icone-padrao\">\n</md-icon></md-button></td></tr></tbody></table></div></md-content></div>");
$templateCache.put("app/main/processamento/cancelamento-faturas-retidas/views/cancelamento-faturas-retidas.html","<md-content id=\"processamento-cancelamento-faturas-retidas\" class=\"page-layout simple tabbed\" layout=\"column\">\n<header-padrao translate-nome=\"Cancelar faturas retidas disponibilizadas\" icone=\"icon-cellphone-android\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex \nms-scroll><div ui-view=\"cancelamentofaturasretidas-form\"></div></div></div></md-content>");
$templateCache.put("app/main/controlecarga/trocarsequencial/views/trocar-sequencial-form.html","<div layout=\"column\" id=\"troca-sequencial-form\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"filtro-trocarsequencial\" md-whiteframe=\"4\" \nui-view=\"filtro-trocarsequencial-sidenav@app.controlecaraga_trocarsequencial\" ms-scroll ms-sidenav-helper \nmd-is-open=\"true\"></md-sidenav><md-content layout-padding ng-if=\"vm.dados.tarefas.length\"><div layout=\"row\" flex=\"100\">\n<md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{vm.dados.leiturista.nomeLeiturista}}</span> <span class=\"md-subhead\">{{vm.dados.leiturista.agrupamento}}</span>\n</md-card-title-text><md-card-title-media class=\"ml-5\"><img class=\"w-64 h-64 avatar ml-10\" \nsrc=\"{{vm.dados.leiturista.caminhoFoto}}\" alt=\"Foto leiturista\"></md-card-title-media></md-card-title></md-card></div>\n<table datatable=\"ng\" class=\"dataTable hover row-border\" dt-options=\"vm.dtOptions\"><thead><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Referências</span></div></th><th \nclass=\"secondary-text\" ng-show=\"vm.parametro.tipoProcesso == \'02\'\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Tarefas</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Data de disponibilização</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Quantidade de ligações</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Situação</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Tipo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Sequencial padrão</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Sequencial</span></div></th></thead><tbody><tr \nng-repeat=\"tarefa in vm.dados.tarefas track by $index\"><td class=\"text-center border-left border-right\"><span \nng-if=\"!vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\">{{tarefa.referencia}} </span><span \nng-if=\"vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-repeat=\"detalheReferencia in tarefa.referencias track by $index\">{{ detalheReferencia }}<br></span></td><td \nclass=\"text-center border-right\" ng-show=\"vm.parametro.tipoProcesso == \'02\'\"><span \nng-if=\"!vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\">{{tarefa.tarefa}} </span><span \nng-if=\"vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-repeat=\"detalheTarefa in tarefa.tarefas track by $index\">{{ detalheTarefa }}<br></span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.dataDisponibilizacao | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.quantidadeLeituras}}</span></td><td class=\"text-center border-right\">\n<span class=\"ml-5 text-boxed red-bg white-fg ng-binding\" ng-if=\"tarefa.emCampo\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Em campo</span> <span class=\"ml-5 text-boxed blue-bg white-fg ng-binding\" \nng-if=\"!tarefa.emCampo\" style=\"margin: 5px 5px; font-size: 0.85em\">A receber</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><span \nclass=\"ml-5 text-boxed orange-bg white-fg ng-binding\" ng-if=\"tarefa.unificada\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Unificada</span> <span class=\"ml-5 text-boxed green-bg white-fg ng-binding\" \nng-if=\"!tarefa.unificada\" style=\"margin: 5px 5px; font-size: 0.85em\">Comum</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.sequencialOriginal}}</span></td><td class=\"text-center border-right\">\n<span ng-show=\"false\">{{tarefa.sequencial}}</span><md-input-container class=\"margin-0\" flex=\"25\"><input \nng-disabled=\"vm.emProgresso || tarefa.emCampo\" style=\"text-align: center\" aria-label=\"sequencial\" type=\"text\" \nng-model=\"tarefa.sequencial\" mascara-numero-generica=\"###\"></md-input-container></td></tr></tbody></table><div \nlayout=\"row\" layout-align=\"end center\" flex><md-progress-circular ng-if=\"vm.emProgresso\" md-diameter=\"30\" \nclass=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><md-button ng-disabled=\"vm.emProgresso\" \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.salvarTrocaSequencial()\"><span>Salvar</span></md-button></div>\n</md-content></div>");
$templateCache.put("app/main/controlecarga/trocarsequencial/views/trocar-sequencial.html","<div id=\"troca-sequencial\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.TROCAR_CARGA\" ng-if=\"vm.parametro.tipoProcesso == \'01\'\" icone=\"icon-clipboard-text\" \nng-utiliza-pesquisa=\"false\"></header-padrao><header-padrao translate-nome=\"RESOURCES.TROCAR_SEQUENCIAL\" \nng-if=\"vm.parametro.tipoProcesso == \'02\'\" icone=\"icon-clipboard-text\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div class=\"button-float\" ng-show=\"vm.dados.tarefas\"><div class=\"button-toogle\" \nng-click=\"vm.metodos.abrirFiltroTrocarSequencial()\"><md-tooltip md-autohide id=\"pg-tooltip-filtrar\" \nmd-direction=\"left\"><span>Filtrar</span></md-tooltip><md-icon md-font-icon=\"icon-filter\" \nclass=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" aria-label=\"icon-cog\"></md-icon></div>\n</div><div ui-view=\"trocarsequencial-form@app.controlecarga_trocarsequencial\"></div></div>");
$templateCache.put("app/main/controlecarga/faturas-retidas/views/faturas-retidas-form.html","<div id=\"faturas-retidas-form\" layout=\"column\"><md-sidenav style=\"min-width: 400px\" \nclass=\"sidenav filtro-sidenav md-sidenav-right\" md-component-id=\"sidenav-faturas-retidas\" md-whiteframe=\"5\" \nui-view=\"sidenav-faturas-retidas@app.controlecarga_faturasretidas\" ms-scroll ms-sidenav-helper md-is-open=\"true\">\n</md-sidenav><md-content layout=\"column\" class=\"conteudo-geral\"><md-card id=\"card-filtro-utilizado\" \nng-if=\"vm.filtroUtilizado != null\" class=\"container-filtro-utilizado\"><md-card-header><md-card-header-text><span>\nFiltro utilizado</span></md-card-header-text></md-card-header><md-card-content><div layout=\"row\" layout-wrap \nlayout-align=\"start stretch\" class=\"filtro-info\"><div class=\"filtro-item\"><div class=\"container-data-carga\"><span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 1\" class=\"filtro-label\">Referência:</span> <span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 2\" class=\"filtro-label\">Período:</span> <span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 1\" class=\"filtro-valor\">\n{{vm.filtroUtilizado.mesReferencia}}/{{vm.filtroUtilizado.anoReferencia}} </span><span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 2\" class=\"filtro-label\">De</span> <span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 2\" class=\"filtro-valor\">\n{{vm.filtroUtilizado.mesReferenciaInicial}}/{{vm.filtroUtilizado.anoReferenciaInicial}}</span> <span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 2\" class=\"filtro-label\">Até</span> <span \nng-if=\"vm.filtroUtilizado.tipoFiltro === 2\" class=\"filtro-valor\">\n{{vm.filtroUtilizado.mesReferenciaFinal}}/{{vm.filtroUtilizado.anoReferenciaFinal}}</span></div></div><div \nclass=\"container-parametro\"><span class=\"filtro-label\">Parâmetro:</span> <span class=\"filtro-valor\" \nng-if=\"vm.filtroUtilizado.tipoParametro === 1\">Todos</span> <span class=\"filtro-valor\" \nng-if=\"vm.filtroUtilizado.tipoParametro === 2\">\nCliente: {{vm.filtroUtilizado.clienteSelecionado.codigo}} - {{vm.filtroUtilizado.clienteSelecionado.nome}}</span></div>\n</div></md-card-content></md-card><div class=\"container-tabela-principal\" \nng-if=\"vm.listaFaturasRetidas && vm.listaFaturasRetidas.length > 0\" style=\"padding: 10px\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border-radius: 5px; overflow: hidden\"><thead \nstyle=\"position: sticky; top: 0; z-index: 10; background-color: white\"><tr><th \nclass=\"secondary-text border-left border-right\" style=\"max-width: 130px; padding-right: 15px;\r\n  padding-left: 15px\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Código da ligação</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title\" style=\"text-align: left\">\nCliente principal</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title\" style=\"text-align: left\">Endereço principal</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><md-input-container class=\"md-block\" layout=\"column\" \nflex style=\"margin: 0px; max-width: 160px\"><label>Setor</label><md-select ng-model=\"vm.setorSelecionado\" \nmultiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectSetor()\"><md-select-header \nng-if=\"vm.setoresUnicos.length > 0\"><input ng-model=\"vm.filtrarSetores\" type=\"search\" id=\"select-setor\" \nplaceholder=\"Pesquisar setores..\" class=\"md-text\"></md-select-header><md-option ng-value=\"setor\" \nng-repeat=\"setor in vm.setoresUnicos | filter: vm.filtrarSetores\">{{ setor }}</md-option></md-select>\n</md-input-container></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><md-input-container \nclass=\"md-block\" layout=\"column\" flex style=\"margin: 0px; max-width: 160px\"><label>Rota</label><md-select \nng-model=\"vm.rotaSelecionada\" multiple=\"multiple\" md-on-open=\"vm.metodos.configuraMdSelectRota()\"><md-select-header \nng-if=\"vm.rotasUnicas.length > 0\"><input ng-model=\"vm.filtrarRotas\" type=\"search\" id=\"select-rota\" \nplaceholder=\"Pesquisar rotas..\" class=\"md-text\"></md-select-header><md-option ng-value=\"rota\" \nng-repeat=\"rota in vm.rotasUnicas | filter: vm.filtrarRotas\">{{ rota }}</md-option></md-select></md-input-container>\n</div></th><th class=\"secondary-text coluna-quantidade\" \nstyle=\"max-width: 105px; padding-right: 20px;\r\n  padding-left: 20px\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Qtd. dependentes</span></div></th></tr></thead><tbody><tr \nng-repeat=\"fatura in vm.listaFaturasRetidas track by $index\"><td \nclass=\"details-control text-center border-right border-left\" \nng-class=\"{\'has-dependentes\': fatura.dependentes && fatura.dependentes.length > 0}\"><div \nstyle=\"display: flex; align-items: center; justify-content: center; gap: 8px\"><span \nng-if=\"fatura.dependentes && fatura.dependentes.length > 0\" class=\"expand-icon clickable\" \nstyle=\"font-size: 14px; color: rgba(0,0,0,0.54); cursor: pointer; user-select: none; font-weight: bold; \r\n                                           width: 22px; height: 22px; border: 2px solid rgba(0,0,0,0.54); border-radius: 50%; \r\n                                           display: inline-flex; align-items: center; justify-content: center; \r\n                                           background-color: white\" \ntitle=\"Clique para ver dependentes\">+</span> <span ng-if=\"!fatura.dependentes || fatura.dependentes.length == 0\" \nclass=\"no-expand-icon disabled\" \nstyle=\"font-size: 14px; color: #9e9e9e; cursor: not-allowed; user-select: none; font-weight: bold;\r\n                                           width: 22px; height: 22px; border: 2px solid #9e9e9e; border-radius: 50%; \r\n                                           display: inline-flex; align-items: center; justify-content: center; \r\n                                           background-color: white\" \ntitle=\"Sem dependentes\">-</span> <span>{{ fatura.codigoLigacaoPrincipal }}</span></div></td><td \nstyle=\"text-align: left\" class=\"border-right\"><span>{{ fatura.nomeClientePrincipal }}</span></td><td \nstyle=\"text-align: left\" class=\"border-right\"><span>{{ fatura.enderecoPrincipal }}</span></td><td \nclass=\"text-center border-right\"><span>{{ fatura.setorPrincipal }}</span></td><td class=\"text-center border-right\">\n<span>{{ fatura.rotaPrincipal }}</span></td><td class=\"text-center coluna-quantidade\"><span>\n{{ fatura.quantidadeDependentes }}</span></td></tr></tbody></table></div><div class=\"no-results text-center\" \nng-if=\"vm.filtroUtilizado != null && vm.listaFaturasRetidas && vm.listaFaturasRetidas.length == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s90\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\">Não existem dados para o filtro informado</div></div></div></md-content></div>");
$templateCache.put("app/main/controlecarga/faturas-retidas/views/faturas-retidas.html","<md-content id=\"faturas-retidas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.CONTROLE_CARGA_FATURAS_RETIDAS\" pesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.listaFaturasRetidas && vm.listaFaturasRetidas.length > 0 && !vm.emProgresso\" \nng-utiliza-pesquisa=\"true\"></header-padrao><md-button ng-disabled=\"vm.emProgresso\" hide-xs hide-sm \nclass=\"md-fab botao-flutuante\" ng-click=\"vm.metodos.abrirFiltro()\" aria-label=\"Abrir filtro\"><md-icon \nmd-font-icon=\"icon-filter-outline\"></md-icon></md-button><div \nui-view=\"controle-carga-faturas-retidas-form@app.controlecarga_faturasretidas\"></div></md-content>");
$templateCache.put("app/main/processamento/exclusao-arquivo/views/exclusao-arquivo-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"{{vm.progressoSplash.tituloSplash}}\" \nmensagem=\"{{vm.progressoSplash.mensagemSplash}}\"></carregamento-circular><div id=\"exclusao-arquivo-form\" \nclass=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate method=\"post\" enctype=\"multipart/form-data\">\n<md-content layout-padding><div layout-gt-sm=\"row\" layout-align=\"center start\"><md-input-container flex-gt-xs=\"5\" \nflex=\"100\"><label translate=\"RESOURCES.MES\">Mes</label><input type=\"text\" name=\"mes\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.filtros.mes\"><div ng-messages=\"vm.form.mes.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"10\" \nflex=\"100\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-model=\"vm.filtros.ano\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex><label translate=\"RESOURCES.LOCALIDADE\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\">\n</label><label translate=\"RESOURCES.AGRUPAMENTO\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></label>\n<md-select name=\"regional\" id=\"processamento-exportacaomobile-slcregional\" ng-model=\"vm.filtros.regionalCodigo\" \nng-change=\"vm.metodos.pesquisarMunicipios(vm.filtros.regionalCodigo)\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" id=\"processamento-exportacaomobile-slcregional-options-{{$index}}\" \nng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container id=\"md-select-municipio\" class=\"md-block\" layout=\"column\" \nflex-gt-xs=\"25\" flex=\"100\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"><label translate=\"RESOURCES.SETOR\">\nSetor</label><md-select ng-model=\"vm.filtros.municipio\" md-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" \nname=\"municipio\" ng-disabled=\"vm.municipios.length == 0 || vm.municipios == undefined\"><md-select-header \nng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" \nplaceholder=\"Pesquisar setor..\" class=\"md-text\"></md-select-header><md-option ng-value=\"undefined\"></md-option>\n<md-option ng-value=\"municipio.codigo\" ng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">\n{{municipio.descricao}}</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">\nNenhum setor encontrado.</span></md-input-container><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid ||vm.emProgresso\" ng-click=\"vm.metodos.filtrarArquivos()\"><span>Filtrar</span></md-button>\n</div><div layout-gt-sm=\"row\" layout-align=\"center center\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"simple-table-container\" \nms-responsive-table><div layout=\"row\" layout-align=\"space-between center\"><div class=\"table-title\" layout=\"row\" \nlayout-align=\"start center\">Arquivos</div></div><div layout=\"row\" flex=\"100\" class=\"pl-24\" layout-align=\"start center\">\n<md-button class=\"md-fab md-mini\" ng-disabled=\"!vm.arquivos.length\" ng-click=\"vm.metodos.selecionarTodosArquivos()\">\n<md-tooltip>Selecionar todos</md-tooltip><md-icon md-font-icon=\"icon-checkbox-marked-outline\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" style=\"margin-left: 10px!important\" \nng-disabled=\"!vm.metodos.existemArquivosMarcados()\" ng-click=\"vm.metodos.excluirArquivosSelecionados()\"><md-tooltip>\nExcluir selecionados</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><table class=\"simple\">\n<thead><tr><th style=\"width: 30%\">Selecionar</th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Nome</span></div></th></tr></thead><tbody><tr ng-repeat=\"arquivo in vm.arquivos\" \nclass=\"p-0 margin-0\"><td style=\"width: 30%; padding-left: 3rem\"><md-checkbox aria-label=\"chkbox-arquivo\" \nng-model=\"arquivo.selecionado\"></md-checkbox></td><td><span class=\"text-center\">{{arquivo.nome}}</span></td></tr>\n</tbody></table></div></ms-widget-front></ms-widget></div></div></md-content></form></div>");
$templateCache.put("app/main/processamento/exclusao-arquivo/views/exclusao-arquivo.html","<div id=\"exclusao-arquivo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"PROCESSAMENTO.EXCLUSAO_ARQUIVO.TITULO\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"exclusao_arquivo-form\"></div></div></div>");
$templateCache.put("app/main/processamento/disponibilizar-tarefas/views/disponibilizar-tarefas-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.disponibilizarTarefasForm\" novalidate method=\"post\">\n<md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.REGIONAL\">Agrupamento</label><md-select \nng-model=\"vm.entidade.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\" !(vm.grupoTarefa) && vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span>\n<div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\" id=\"container-mes\"><label for=\"\" translate=\"RESOURCES.MES\">Mes</label>\n<input type=\"text\" name=\"mes\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"vm.disponibilizarTarefasForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"15\" \nflex=\"100\" id=\"container-ano\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-model=\"vm.entidade.ano\" \nng-required=\"true\"><div ng-messages=\"vm.disponibilizarTarefasForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"15\" \nflex=\"100\" id=\"container-grupo\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.entidade.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-required=\"!(vm.grupoTarefa) && (vm.grupos.length > 0 && (vm.entidade.ano && vm.entidade.mes))\" name=\"grupo\" \nng-change=\"vm.metodos.realizarEventoChangeGrupo(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.disponibilizarTarefasForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex layout-align=\"center start\"><md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" \nflex=\"100\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.MUNICIPIO\">Município</label>\n<md-select ng-model=\"vm.entidade.municipio\" md-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" \nng-change=\"vm.metodos.pesquisarTarefasPorRegionalMunicipio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo,vm.entidade.municipio)\" \nng-required=\" !(vm.grupoTarefa) && vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0 || vm.municipios == undefined\"><md-select-header \nng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" \nplaceholder=\"Pesquisar municipio..\" class=\"md-text\"></md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}} - {{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nlayout=\"column\" flex-gt-xs=\"30\" flex=\"100\" ng-if=\"vm.ehEnorsulSertaozinho\"><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required name=\"leiturista\" \nid=\"processamento-disponibilizartarefas-txtDescricaoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-model=\"vm.entidade.leiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option \nng-repeat=\"leiturista in vm.leituristas | filter:{busca: vm.termoProcurado}\" value=\"{{leiturista.codigo}}\">\n{{leiturista.codigo}} - {{leiturista.apelido}}</md-option></md-select><div \nng-messages=\"vm.disponibilizarTarefasForm.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"20\" \nflex=\"100\" id=\"container-tarefa\"><label for=\"\" translate=\"RESOURCES.TAREFA\">Tarefa</label><md-select flex \nname=\"tarefa\" ng-required=\" !(vm.grupoTarefa) && (vm.tarefas.length > 0 && vm.entidade.grupo)\" \nmd-on-open=\"vm.metodos.configuraMdSelectTarefa()\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined && vm.entidade.grupo == undefined) || vm.tarefas.length == 0 || vm.tarefas == undefined\" \nng-model=\"vm.entidade.tarefa\"><md-select-header ng-if=\"vm.tarefas.length > 0\"><input ng-model=\"vm.filtrarTarefas\" \nmascara-numero-generica=\"###\" type=\"search\" id=\"select-tarefa\" placeholder=\"Pesquisar tarefa..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"tarefa\" ng-repeat=\"tarefa in vm.tarefas | filter: vm.filtrarTarefas\">{{tarefa}}\n</md-option></md-select><span ng-if=\"vm.tarefas.length == 0 && vm.entidade.grupo\" class=\"nenhum-grupo\">\nNenhuma tarefa encontrada.</span><div ng-messages=\"vm.disponibilizarTarefasForm.tarefa.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"!vm.ehEnorsulSertaozinho\"><div flex-gt-sm=\"40\" layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-xs=\"85\"><label class=\"md-subheader\" translate=\"RESOURCES.LEITURISTA\">\nLeiturista</label><md-select required name=\"leiturista\" \nid=\"processamento-disponibilizartarefas-txtDescricaoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-model=\"vm.entidade.leiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:{busca: vm.termoProcurado}\" value=\"{{leiturista.codigo}}\">\n{{leiturista.codigo}} - {{leiturista.apelido}}</md-option></md-select><div \nng-messages=\"vm.disponibilizarTarefasForm.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><md-divider></md-divider>\n<div layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"!vm.entidade.mes || !vm.entidade.ano || !vm.entidade.grupo  || !vm.entidade.tarefa || !vm.entidade.leiturista || vm.emProgresso\" \nng-click=\"vm.metodos.disponibilizarTarefa(vm.entidade)\"><span translate=\"RESOURCES.DISPONIBILIZAR\">Disponibilizar\n</span></md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/disponibilizar-tarefas/views/disponibilizar-tarefas.html","<div id=\"disponibilizartarefas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.DISPONIBILIZAR_TAREFAS\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div \nui-view=\"disponibilizartarefas-form-multiplos-grupos@app.disponibilizar_tarefas\" \nng-if=\"vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\"></div><div ui-view=\"disponibilizartarefas-form\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88 && !vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\">\n</div><div ui-view=\"disponibilizartarefas-form-caema@app.disponibilizar_tarefas\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div></div></div>");
$templateCache.put("app/main/processamento/distribuicao/views/distribuicao-form.html","<div id=\"distribuicao\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-distribuicao\" md-whiteframe=\"4\" ui-view=\"distribuicao-filtro\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" ms-scroll ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-left\" md-component-id=\"filtro-distribuicao\" md-whiteframe=\"4\" \nui-view=\"distribuicao-filtro-caema\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"no-results text-center\" \nng-if=\"(!vm.tarefas && !vm.distribuicao && !vm.distribuindoPorDialog) && !(vm.emProgresso)\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"PROCESSAMENTO.DISTRIBUICAO.SEM_GRUPO\">Nenhum grupo de leituras selecionado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroDistribuicao()\"><span>Filtrar</span></md-button></div>\n</div><md-content flex ng-if=\"vm.emProgresso || vm.emProgressoDistribuicao\" layout=\"column\"><carregamento-circular \nem-progresso=\"vm.emProgresso || vm.emProgressoDistribuicao\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular></md-content><md-subheader \nng-if=\"(vm.tarefas || vm.distribuicao) && !(vm.emProgresso || vm.emProgressoDistribuicao)\"><div \nng-if=\"((vm.tarefas && vm.distribuicao) && !vm.emProgresso)\" style=\"position: absolute;right: 1em\" \nng-style=\"{\'top\': vm.distribuindoPorDialog ? \'8em\' : \'8.1em\'}\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\"></div>\n<fieldset flex=\"100\" class=\"header-distribuicao\"><legend class=\"grp-legend\" \nng-click=\"vm.exibirReferencia = !vm.exibirReferencia\"><span translate=\"RESOURCES.REFERENCIA_DISTRIBUICAO\"></span>\n<md-icon class=\"md-accent\" ng-if=\"vm.exibirReferencia\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nclass=\"md-accent\" ng-if=\"!vm.exibirReferencia\" md-font-icon=\"icon-chevron-right\"></md-icon></legend><div flex=\"100\" \nlayout=\"column\" layout-gt-sm=\"row\" ng-hide=\"!vm.exibirReferencia\"><div flex-gt-sm=\"60\" layout-gt-xs=\"row\" \nlayout=\"column\"><md-input-container class=\"margin-0\" flex-gt-xs=\"5\"><label translate=\"RESOURCES.MES\"></label><input \ntype=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.mes }}\"></md-input-container><md-input-container \nclass=\"margin-0\" flex-gt-xs=\"10\"><label translate=\"RESOURCES.ANO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.ano }}\"></md-input-container><md-input-container class=\"margin-0\" flex-gt-xs=\"10\"><label \ntranslate=\"RESOURCES.GRUPO\"></label><input type=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.grupoLeitura }}\">\n</md-input-container><md-input-container class=\"margin-0\" flex-gt-xs=\"30\"><label \ntranslate=\"RESOURCES.ARQUIVO_IMPORTACAO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.arquivoImportacao }}\"></md-input-container><md-input-container class=\"margin-0\" \nflex-gt-xs=\"25\" ng-if=\"vm.distribuicao.regionalDescricao\"><label translate=\"RESOURCES.REGIONAL\"></label><input \ntype=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.regionalDescricao}}\"></md-input-container>\n<md-input-container class=\"margin-0\" flex-gt-xs=\"20\" ng-if=\"vm.distribuicao.municipioDescricao\"><label \ntranslate=\"RESOURCES.MUNICIPIO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.municipioDescricao}}\"></md-input-container></div><div flex-gt-sm=\"40\" layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"margin-0\" flex-gt-xs=\"35\"><label translate=\"RESOURCES.DATA_IMPORTACAO\">\n</label><input type=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.dataImportacao }}\"></md-input-container>\n<md-input-container class=\"margin-0\" flex-gt-xs=\"30\"><label translate=\"RESOURCES.LIGACOES\"></label><input type=\"text\" \nng-disabled=\"true\" value=\"{{ ::vm.distribuicao.quantidadeCliente }}\"></md-input-container><md-input-container \nclass=\"margin-0\" flex flex-gt-xs=\"35\"><label translate=\"RESOURCES.TIPO_DISTRIBUICAO\"></label><input type=\"text\" \nng-disabled=\"true\" value=\"{{ ::vm.distribuicao.tipoDistribuicao }}\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"mr-25 font-size-18 italic md-accent-fg\"><label>Quantidade a distribuir: \n<strong>{{ vm.quantidadeDistribuir }}</strong></label></div><div class=\"font-size-18 italic md-accent-fg\"><label>\nQuantidade de tarefas: <strong>{{ vm.numeroTarefas }}</strong></label></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-click=\"vm.metodos.habilitarRemocaoTarefas(true)\"><md-tooltip>Remover tarefas selecionadas</md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon></md-button></div><div><md-button class=\"md-fab md-mini\" \naria-label=\"Remover\" ng-click=\"vm.metodos.habilitarUnificacaoTarefas(true)\"><md-tooltip>Unificar tarefas selecionadas\n</md-tooltip><md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button></div><div><md-button \nclass=\"md-fab md-mini\" aria-label=\"Remover\" ng-click=\"vm.metodos.habilitarIncrementoDecremento(true)\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88  && vm.parametros.calculo.tipoDetalheCalculo != 89 && (vm.distribuicao.enumTipoDistribuicao == 5 || vm.distribuicao.enumTipoDistribuicao == 7)\">\n<md-tooltip>Incrementar/Decrementar tarefa selecionada</md-tooltip><md-icon md-font-icon=\"icon-swap-vertical\">\n</md-icon></md-button></div></div></fieldset><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Selecionar\" \nng-show=\"(vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar) && !vm.incrementandoDecrementandoTarefas.habilitar\" \nng-click=\"vm.metodos.marcarTodasTarefas()\"><md-tooltip>Selecionar todas as tarefas</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/distribuicao/check_box-white.svg\"></md-icon></md-button><div \nng-show=\"vm.removendoTarefas.habilitar\"><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" ng-click=\"vm.metodos.removerTarefasMarcadas()\"><md-tooltip>\nRemover tarefas selecionadas</md-tooltip><md-icon md-font-icon=\"icon-window-close\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Desfazer \" ng-disabled=\"!vm.removendoTarefas.removeuTarefa\" \nng-click=\"vm.metodos.desfazerRemocaoTarefas()\"><md-tooltip>Desfazer</md-tooltip><md-icon md-font-icon=\"icon-undo\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-green-600-bg\" aria-label=\"Efetivar\" \nng-hide=\"!vm.removendoTarefas.removeuTarefa\" ng-click=\"vm.metodos.efetivarRemocaoTarefas(false)\"><md-tooltip>Efetivar\n</md-tooltip><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-red-600-bg\" aria-label=\"Remover\" ng-click=\"vm.metodos.cancelarRemocaoTarefas(false)\">\n<md-tooltip>Cancelar</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nng-show=\"vm.unificandoTarefas.habilitar\"><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" ng-click=\"vm.metodos.abrirDialogUnificarTarefas()\"><md-tooltip>\nUnificar tarefas selecionadas</md-tooltip><md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Desfazer \" ng-disabled=\"!vm.unificandoTarefas.unificouTarefa\" \nng-click=\"vm.metodos.desfazerUnificarTarefas()\"><md-tooltip>Desfazer</md-tooltip><md-icon md-font-icon=\"icon-undo\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-green-600-bg\" aria-label=\"Efetivar\" \nng-hide=\"!vm.unificandoTarefas.unificouTarefa\" ng-click=\"vm.metodos.efetivarUnificarTarefas(false)\"><md-tooltip>\nEfetivar</md-tooltip><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-red-600-bg\" aria-label=\"Remover\" ng-click=\"vm.metodos.cancelarUnificarTarefas(false)\">\n<md-tooltip>Cancelar</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nng-show=\"vm.incrementandoDecrementandoTarefas.habilitar\"><md-input-container style=\"margin-top: 15px\"><label>Quantidade\n</label><input aria-label=\"tarefa\" type=\"text\" style=\"text-align: center; margin-top: 15px; width: 100px\" \nmascara-numero-generica=\"######\" ng-model=\"vm.quantidade\"></md-input-container><md-button \nclass=\"md-fab md-mini md-red-600-bg\" aria-label=\"Remover\" ng-click=\"vm.metodos.cancelarIncrementoDecremento(false)\">\n<md-tooltip>Finalizar incremento/decremento</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button>\n</div></div></md-subheader><md-content layout-padding \nng-if=\"(vm.tarefas || vm.distribuicao) && !(vm.emProgresso || vm.emProgressoDistribuicao)\" layout=\"column\"><div \nflex=\"100\" layout=\"column\" class=\"div-tabela-tarefas\"><table class=\"dataTable row-border hover\" ng-if=\"vm.tarefas\" \ndatatable=\"ng\" dt-options=\"vm.options\" style=\"width: 100%\"><thead><tr><th class=\"secondary-text\" \nng-show=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar || vm.incrementandoDecrementandoTarefas.habilitar\">\n<div class=\"table-header\"><span class=\"column-title text-center\" translate=\"RESOURCES.SELECIONAR\">Selecionar</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"RESOURCES.TAREFA\">Tarefa</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao === 7\"><div class=\"table-header\"><span class=\"column-title text-center\">\nBloco</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Qtde\n</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 2 || vm.distribuicao.enumTipoDistribuicao == 3 || vm.distribuicao.enumTipoDistribuicao == 4\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Setor</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 3 || vm.distribuicao.enumTipoDistribuicao == 4\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Quadra</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 4\"><div class=\"table-header\"><span class=\"column-title text-center\">Lote\n</span></div></th><th class=\"secondary-text\" ng-if=\"vm.distribuicao.enumTipoDistribuicao == 1\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Rota</span></div></th><th class=\"secondary-text\" \nng-if=\"(vm.distribuicao.enumTipoDistribuicao == 1 || vm.filtro.tipodistribuicao == 1 || vm.distribuicao.enumTipoDistribuicao == 5) && !vm.ehCalculoEspecifico && vm.codigoCliente != \'1093\'\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Roteirização inicial</span></div></th><th \nclass=\"secondary-text\" \nng-if=\"(vm.distribuicao.enumTipoDistribuicao == 1 || vm.filtro.tipodistribuicao == 1) && vm.codigoCliente == \'1093\'\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Sequência inicial</span></div></th><th \nclass=\"secondary-text\" \nng-if=\"(vm.distribuicao.enumTipoDistribuicao == 1 || vm.filtro.tipodistribuicao == 1) && vm.codigoCliente == \'1093\'\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Sequência final</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Endereço inicial</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Endereço final</span>\n</div></th><th class=\"secondary-text\" ng-if=\"vm.distribuicao.enumTipoDistribuicao == 6\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Bairro</span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr \nng-repeat=\"tarefa in vm.tarefas track by $index\" ng-class=\"{\'tarefa-marcada\': tarefa.marcado}\"><td class=\"text-center\" \nng-show=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar || vm.incrementandoDecrementandoTarefas.habilitar\">\n<md-checkbox ng-model=\"tarefa.marcado\" \nng-disabled=\"vm.metodos.existeTarefaMarcada() && !tarefa.marcado && vm.incrementandoDecrementandoTarefas.habilitar\" \nng-class=\"{\'cursor-pointer\':(vm.metodos.existeTarefaMarcada() && !tarefa.marcado && vm.incrementandoDecrementandoTarefas.habilitar)}\">\n</md-checkbox><md-tooltip md-direction=\"bottom\" \nng-if=\"vm.metodos.existeTarefaMarcada() && !tarefa.marcado && vm.incrementandoDecrementandoTarefas.habilitar\">\nPara marcar essa tarefa, deve ser desmarcado a tarefa atual</md-tooltip><md-button class=\"md-icon-button\" \nid=\"botao-decremento\" aria-label=\"Incrementar\" \nng-if=\"vm.incrementandoDecrementandoTarefas.habilitar && tarefa.marcado && !$first\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" \nng-click=\"vm.metodos.incrementarDecrementarTarefas(\'Decrementar\')\"><md-tooltip>Decrementar</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nid=\"botao-incremento\" aria-label=\"Incrementar\" \nng-if=\"vm.incrementandoDecrementandoTarefas.habilitar && tarefa.marcado && !$last\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" \nng-click=\"vm.metodos.incrementarDecrementarTarefas(\'Incrementar\')\"><md-tooltip>Incrementar</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"cor-icone-padrao\"></md-icon></md-button></td><td class=\"text-center\">\n<md-input-container flex=\"40\" class=\"margin-0\"><input aria-label=\"tarefa\" type=\"text\" style=\"text-align: center\" \nmascara-numero-generica=\"###\" ng-model=\"tarefa.tarefa\"></md-input-container></td><td class=\"text-center\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao === 7\"><span>{{tarefa.bloco}}</span></td><td class=\"text-center\"><span>\n{{tarefa.quantidade}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.setor && vm.distribuicao.enumTipoDistribuicao != 1 \"><span>{{tarefa.setor}}</span></td><td \nclass=\"text-center\" ng-if=\"tarefa.quadra\"><span>{{tarefa.quadra}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.lote\"><span>{{tarefa.lote}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.rota || vm.distribuicao.enumTipoDistribuicao == 1\"><span>{{tarefa.rota}}</span></td><td \nclass=\"text-center\" \nng-if=\"(tarefa.rota || vm.distribuicao.enumTipoDistribuicao == 1 || vm.distribuicao.enumTipoDistribuicao == 5) && !vm.ehCalculoEspecifico && vm.codigoCliente != \'1093\'\">\n<span>{{tarefa.roteirizacaoInicial}}</span></td><td class=\"text-center\" \nng-if=\"(tarefa.rota || vm.distribuicao.enumTipoDistribuicao == 1) && vm.codigoCliente == \'1093\'\"><span>\n{{tarefa.sequencialInicial}}</span></td><td class=\"text-center\" \nng-if=\"(tarefa.rota || vm.distribuicao.enumTipoDistribuicao == 1) && vm.codigoCliente == \'1093\'\"><span>\n{{tarefa.sequencialFinal}}</span></td><td class=\"text-center\"><span>{{tarefa.enderecoInicial}}</span></td><td \nclass=\"text-center\"><span>{{tarefa.enderecoFinal}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.bairro && vm.distribuicao.enumTipoDistribuicao == 6\"><span>{{tarefa.bairro}}</span></td><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-hide=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\" \nng-click=\"vm.metodos.dividirTarefa(tarefa,$index)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.DIVIDIR_TAREFA\">Dividir tarefa</span></md-tooltip><md-icon md-font-icon=\"icon-table-edit\" \nclass=\"cor-icone-padrao\"></md-icon></md-button></div></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"end start\" style=\"padding-bottom: 0px\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.emProgresso\" \nng-hide=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar || vm.incrementandoDecrementandoTarefas.habilitar\" \nng-click=\"vm.metodos.distribuirGrupo()\"><span translate=\"RESOURCES.DISTRIBUIR\">Distribuir</span></md-button></div>\n</md-content></div>");
$templateCache.put("app/main/processamento/distribuicao/views/distribuicao.html","<md-content id=\"distribuicao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.DISTRIBUICAO\" icone=\"icon-cellphone-android\" pesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"(vm.tarefas.length > 0 && vm.distribuicao) && !vm.emProgresso\" \nng-utiliza-pesquisa=\"true\"></header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex \nms-scroll><div ui-view=\"distribuicao-form\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div><div \nui-view=\"distribuicao-form-caema\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/processamento/exportacao-grupo-leitura/views/exportacao-grupo-leitura-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\">\n</carregamento-circular><div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"exportacaoGrupoForm\" novalidate \nmethod=\"post\"><md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select \nng-model=\"vm.entidade.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\"!(vm.grupo) && vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar agrupamento...\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span>\n<div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\" translate=\"RESOURCES.MES\">Mes</label><input type=\"text\" \nname=\"mes\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"exportacaoGrupoForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"10\" \nflex=\"100\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model=\"vm.entidade.ano\" ng-required=\"true\"><div ng-messages=\"exportacaoGrupoForm.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-xs=\"15\" flex=\"100\" ng-if=\"!vm.sistemaGestorEhFiorilli\"><label translate=\"RESOURCES.GRUPO\">\nGrupo</label><md-select name=\"grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-model=\"vm.entidade.grupo\" \nng-required=\"true\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"exportacaoGrupoForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nstyle=\"display: flex; flex-direction: column; max-width: 30%; width: 30%\"><multi-select-directive \nng-if=\"vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1\" form-name=\"leituristas\" data=\"vm.leituristas\" \nmodel=\"vm.entidade.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leituristas\" \nstyle=\"width: 100%; margin-bottom: -20px\" \ndisabled=\"vm.emProgresso || vm.leituristas.length == 0 || vm.buscandoLeituristas\" carregando=\"vm.buscandoLeituristas\">\n</multi-select-directive><span style=\"color: rgb(213,0,0); margin-left: 15px\" \nng-if=\"vm.leituristas.length == 0 && !vm.buscandoLeituristas\">Nenhum leiturista encontrado para referência informada.\n</span></div><md-input-container flex-gt-xs=\"15\" flex=\"100\" \nng-if=\"vm.sistemaGestorEhFiorilli && vm.modoImplantacaoAtivo\"><label>Tipo de exportação</label><md-select \nname=\"tipoExportacao\" ng-model=\"vm.entidade.tipoExportacao\" \nng-required=\"vm.sistemaGestorEhFiorilli && vm.modoImplantacaoAtivo\" \nng-change=\"vm.metodos.onChangeTipoExportacao(vm.entidade.tipoExportacao)\"><md-option ng-value=\"tipo.chave\" \nng-repeat=\"tipo in vm.tiposExportacao\">{{tipo.valor}}</md-option></md-select><div \nng-messages=\"exportacaoGrupoForm.tipoExportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 89 && !vm.sistemaGestorEhFiorilli\" flex-gt-xs=\"15\" flex=\"100\">\n<md-checkbox ng-model=\"vm.entidade.gerarArquivoZip\" ng-disabled=\"vm.emProgresso\"><span>Compactar arquivo</span>\n</md-checkbox></md-input-container></div><div layout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"vm.parametros.utilizarExportacaoParcialGrupoLeitura || vm.parametros.calculo.tipoDetalheCalculo == 89\"><fieldset\n flex=\"75\" layout-align=\"center center\" layout=\"column\"><legend class=\"grp-legend\">Registros para exportação</legend>\n<md-radio-group layout-align=\"center center\" flex=\"100\" layout=\"row\" \nng-change=\"vm.metodos.buscarSequencialControleEnvio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-model=\"vm.entidade.tipoExportacao\"><md-radio-button ng-value=\"1\">Não enviados</md-radio-button><md-radio-button \nng-value=\"2\">Reenviar</md-radio-button></md-radio-group><md-select ng-if=\"vm.entidade.tipoExportacao == 2\" \nng-required=\"true\" ng-model=\"vm.entidade.numeroSequencialGeracaoArquivo\"><md-option ng-value=\"numSeq\" \nng-repeat=\"numSeq in vm.sequenciais\">{{numSeq}}</md-option></md-select></fieldset></div><md-divider \nng-if=\"!vm.emProgresso\"></md-divider><div layout=\"row\" layout-align=\"center center\" layout-padding><md-button \nclass=\"md-raised md-accent\" id=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"exportacaoGrupoForm.$invalid || vm.emProgresso || (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 1 && (!vm.leituristas || vm.leituristas.length === 0)) || (vm.sistemaGestorEhFiorilli && vm.tipoProcesso == 2 && vm.entidade.grupo == undefined)\" \nng-click=\"vm.metodos.gerarArquivoExportacaoGrupo(vm.entidade)\"><span>{{vm.labelBotaoGerar}}</span></md-button></div>\n</md-content></form></div>");
$templateCache.put("app/main/processamento/exportacao-grupo-leitura/views/exportacao-grupo-leitura.html","<div id=\"exportacaogrupoleitura\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"{{vm.tituloHeader}}\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"exportacaogrupoleitura-form\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88 && vm.codigoCliente != \'0070\' && !vm.sistemaGestorEhFiorilli\">\n</div><div ui-view=\"exportacaogrupoleitura-caema-form@app.exportacao_grupo_leitura\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div><div \nui-view=\"exportacaogrupoleitura-bauru-form@app.exportacao_grupo_leitura\" ng-if=\"vm.codigoCliente == \'0070\'\"></div><div \nui-view=\"exportacaogrupoleitura-fiorilli-form@app.exportacao_grupo_leitura\" ng-if=\"vm.sistemaGestorEhFiorilli\"></div>\n</div></div>");
$templateCache.put("app/main/processamento/exportacao-mobile/FIORILLI/disponibilizar-carga-fiorilli.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.disponibilizarCargaForm\" novalidate method=\"post\">\n<md-content layout-padding><div layout-gt-sm=\"row\" layout-align=\"center center\" style=\"margin-bottom: -15px\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\">Mes</label><input type=\"text\" name=\"mes\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-required=\"true\" \nmascara-numero-generica=\"##\" ng-disabled=\"vm.emProgresso\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"vm.disponibilizarCargaForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"10\" \nflex=\"100\"><label for=\"\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-model=\"vm.entidade.ano\" \nng-required=\"true\" ng-disabled=\"vm.emProgresso\"><div ng-messages=\"vm.disponibilizarCargaForm.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"40\" layout=\"row\" style=\"margin-left: 100px\">\n<multi-select-directive form-name=\"leituristas\" data=\"vm.leituristas\" model=\"vm.filtro.leituristas\" obrigatorio=\"true\" \ndescricao-exibicao=\"nome\" texto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leituristas\" flex=\"90\" \ndisabled=\"vm.emProgresso\"></multi-select-directive></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.disponibilizarCargaForm.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.disponibilizarCarga()\">\nDisponibilizar</md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/exportacao-mobile/views/exportacao-mobile-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"exportacaomobileForm\" novalidate method=\"post\" \nenctype=\"multipart/form-data\"><md-content layout-padding><div layout-gt-sm=\"row\" layout-align=\"center center\"><div \nflex-gt-sm=\"40\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><input type=\"text\" \nng-model=\"vm.codigoLeiturista\" required id=\"processamento-exportacaomobile-txtCodigoLeiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" mascara-numero-generica=\"#####\" aria-label=\"RESOURCES.LEITURISTA\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"85\"><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required name=\"leiturista\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" id=\"processamento-exportacaomobile-txtDescricaoLeiturista\" \nmd-on-open=\"vm.metodos.configurarSelect()\" ng-model=\"vm.codigoLeiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">{{leiturista.apelido}}\n</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nng-if=\"vm.controleTela.pnlPocosCaldas\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.SETOR\">Setor</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.setor\" required \nid=\"processamento-exportacaomobile-txtSetor\" mascara-numero-generica=\"##\" aria-label=\"RESOURCES.SETOR\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.ROTA\">Rota</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.rotaPdc\" required \nid=\"processamento-exportacaomobile-txtRotaPdc\" ng-disabled=\"true\" mascara-numero-generica=\"###\" \naria-label=\"RESOURCES.ROTA\"></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nng-if=\"vm.controleTela.pnlDistribuicao\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.MES\">Mês</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.mesDistribuicao\" \nid=\"processamento-exportacaomobile-txtMesDistribuicao\" required mascara-numero-generica=\"##\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.ANO\">Ano</label>\n<input type=\"text\" ng-model=\"vm.parametrosExportacao.anoDistribuicao\" \nid=\"processamento-exportacaomobile-txtAnoDistribuicao\" required mascara-numero-generica=\"####\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.GRUPO\">\nGrupo de serviço</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.grupoDistribuicao\" \nid=\"processamento-exportacaomobile-txtGrupoDistribuicao\" required mascara-numero-generica=\"####\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.TAREFA\">Tarefa\n</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.tarefaDistribuicao\" \nid=\"processamento-exportacaomobile-txtTarefaDistribuicao\" required mascara-numero-generica=\"###\" ng-disabled=\"true\">\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.pnlOrigem\">\n<md-input-container><label translate=\"RESOURCES.DATA\">Data</label><md-datepicker flex-offset-gt-sm=\"5\" \nname=\"dataOrigem\" ng-model=\"vm.parametrosExportacao.dataOrigem\" ng-mask=\"3?9/1?9/9999\" \nid=\"processamento-exportacaomobile-txtDataOrigem\" mascara-conversor-string-para-data ng-disabled=\"true\" required>\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.ORIGEM\">Origem</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.origem\" \nid=\"processamento-exportacaomobile-txtOrigem\" required mascara-numero-generica=\"###\" ng-disabled=\"true\">\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.pnlArea\">\n<md-input-container><label translate=\"RESOURCES.DATA\">Data</label><md-datepicker flex-offset-gt-sm=\"5\" name=\"dataArea\" \nng-mask=\"3?9/1?9/9999\" ng-model=\"vm.parametrosExportacao.dataArea\" id=\"processamento-exportacaomobile-txtDataArea\" \nng-disabled=\"true\" mascara-conversor-string-para-data required></md-datepicker></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.AREA\">Área</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.area\" id=\"processamento-exportacaomobile-txtArea\" required ng-disabled=\"true\" \nmascara-numero-generica=\"##\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.ORIGEM\">Origem</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.origemArea\" \nid=\"processamento-exportacaomobile-txtOrigemArea\" required ng-disabled=\"true\" mascara-numero-generica=\"###\">\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.pnlGrade\" \nng-disabled=\"true\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.GRADE\">Grade\n</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.grade\" id=\"processamento-exportacaomobile-txtGrade\" \nrequired ng-disabled=\"true\" mascara-numero-generica=\"###\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.mesGrade\" id=\"processamento-exportacaomobile-txtMesGrade\" required \nng-disabled=\"true\" mascara-numero-generica=\"##\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.anoGrade\" id=\"processamento-exportacaomobile-txtAnoGrade\" required \nng-disabled=\"true\" mascara-numero-generica=\"####\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.controleTela.pnlRota\" ng-disabled=\"true\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.ROTA\">Rota</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.rota\" required id=\"processamento-exportacaomobile-txtRota\" ng-disabled=\"true\" \nmascara-numero-generica=\"###\" aria-label=\"RESOURCES.ROTA\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.controleTela.pnlLocalidade\" ng-disabled=\"true\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.localidade\" required id=\"processamento-exportacaomobile-txtLocalidade\" \nng-disabled=\"true\" mascara-numero-generica=\"##\" aria-label=\"RESOURCES.LOCALIDADE\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.ROTA_INICIAL\">Rota inicial</label>\n<input type=\"text\" ng-model=\"vm.parametrosExportacao.rotaInicial\" required \nid=\"processamento-exportacaomobile-txtRotaInicial\" ng-disabled=\"true\" mascara-numero-generica=\"###\" \naria-label=\"RESOURCES.ROTA_INICIAL\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.ROTA_FINAL\">Rota final</label><input type=\"text\" ng-model=\"vm.parametrosExportacao.rotaFinal\" \nrequired id=\"processamento-exportacaomobile-txtRotaFinal\" ng-disabled=\"true\" mascara-numero-generica=\"###\" \naria-label=\"RESOURCES.ROTA_FINAL\"></md-input-container></div><div layout-gt-sm=\"rom\" layout-align=\"center center\" \nng-if=\"vm.controleTela.localidadeRotaSequencia\" ng-disabled=\"true\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" \nid=\"processamento-exportacaomobile-lRSmes\" ng-model=\"vm.parametrosExportacao.mes\" ng-disabled=\"true\" \nmascara-numero-generica=\"##\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" id=\"processamento-exportacaomobile-lRSano\" \nng-model=\"vm.parametrosExportacao.ano\" ng-disabled=\"true\" mascara-numero-generica=\"####\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><input \ntype=\"text\" id=\"processamento-exportacaomobile-lRSLocalidade\" ng-model=\"vm.parametrosExportacao.localidade\" \nng-disabled=\"true\" mascara-numero-generica=\"##\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.ROTA\">Rota</label><input type=\"text\" \nid=\"processamento-exportacaomobile-lRSRota\" ng-model=\"vm.parametrosExportacao.rota\" ng-disabled=\"true\" \nmascara-numero-generica=\"###\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.SEQUENCIA\">Sequência</label><input type=\"text\" id=\"processamento-exportacaomobile-lRSSequencia\" \nng-model=\"vm.parametrosExportacao.sequencia\" ng-disabled=\"true\" mascara-numero-generica=\"###\"></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.chkProcedimentoRepasse\">\n<md-input-container class=\"md-block\" flex-gt-xs=\"40\"><md-checkbox \nng-model=\"vm.parametrosExportacao.procedimentoRepasse\" ng-true-value=\"\'S\'\" \nid=\"processamento-exportacaomobile-chkProcedimentoRepasse\" ng-false-value=\"\'N\'\" ng-disabled=\"vm.emProgresso\"><span \ntranslate=\"RESOURCES.PROCEDIMENTO_DE_REPASSE\">Procedimento de repasse</span></md-checkbox></md-input-container></div>\n<div layout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.chkImprimeAvisoCorte\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"40\"><md-checkbox ng-model=\"vm.parametrosExportacao.imprimeAvisoCorte\" ng-true-value=\"\'S\'\" \nid=\"processamento-exportacaomobile-chkImprimeAvisoCorte\" ng-false-value=\"\'N\'\" ng-disabled=\"vm.emProgresso\"><span \ntranslate=\"RESOURCES.IMPRIME_AVISO_CORTE\">Imprime aviso de corte</span></md-checkbox></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.controleTela.dtProximaLeitura\"><md-input-container flex=\"25\">\n<label class=\"md-subheader\" translate=\"RESOURCES.DATA_PROXIMA_LEITURA\">Data</label><md-datepicker \nflex-offset-gt-sm=\"5\" ng-model=\"vm.parametrosExportacao.dataProximaLeitura\" name=\"dataProximaLeitura\" \nid=\"processamento-exportacaomobile-txtDataProximaLeitura\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data required></md-datepicker><div \nng-messages=\"exportacaomobileForm.dataProximaLeitura.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-sm=\"rom\" \nlayout-align=\"center center\" ng-if=\"vm.controleTela.setorRotaMesAno\" ng-disabled=\"true\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.SETOR\">Setor</label><input \nid=\"processamento-exportacaomobile-setor\" type=\"text\" required mascara-numero-generica=\"##\" \nng-model=\"vm.parametrosExportacao.setor\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.ROTA\">Rota</label><input id=\"processamento-exportacaomobile-rota\" \ntype=\"text\" required mascara-numero-generica=\"###\" ng-model=\"vm.parametrosExportacao.rota\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.MES\">Mês</label>\n<input id=\"processamento-exportacaomobile-mes\" type=\"text\" required mascara-numero-generica=\"##\" \nng-model=\"vm.parametrosExportacao.mes\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.ANO\">Ano</label><input id=\"processamento-exportacaomobile-ano\" type=\"text\" \nrequired mascara-numero-generica=\"####\" ng-model=\"vm.parametrosExportacao.ano\" ng-disabled=\"true\"></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"center center\"><lf-ng-md-file-input flex=\"60\" name=\"arquivo\" \nlf-files=\"vm.arquivos\" lf-browse-label=\"Procurar\" lf-remove-label=\"Remover\" lf-placeholder=\"Selecionar arquivo\" \nlf-required progress ng-disabled=\"vm.emProgresso || !vm.codigoLeiturista\" lf-api=\"vm.lfApi\"></lf-ng-md-file-input>\n<md-input-container class=\"md-block mt-0 mb-0\" ng-if=\"vm.parametro.utilizarGerenciamentoFaturasRetidasVinculadas\">\n<md-checkbox class=\"mt-0 mb-0\" ng-model=\"vm.parametrosExportacao.disponibilizarRetidas\" ng-disabled=\"vm.emProgresso\">\n<span>Disponibilizar faturas retidas</span></md-checkbox></md-input-container></div><md-divider \nng-if=\"!vm.emProgresso\"></md-divider><progress-linear ng-disabled=\"vm.emProgresso\"></progress-linear><div layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-button class=\"md-raised md-accent\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"exportacaomobileForm.$invalid || vm.emProgresso || !vm.codigoLeiturista\" \nng-click=\"vm.metodos.realizarExportacao()\"><span>Disponibilizar carga</span></md-button></div></md-content></form>\n</div>");
$templateCache.put("app/main/processamento/exportacao-mobile/views/exportacao-mobile.html","<div id=\"exportacaomobile\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.EXPORTACAO_MOBILE\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"exportacaomobile-form\" \nng-if=\"!vm.sistemaGestorEhFiorilli && !vm.sistemaGestorEhThema\"></div><div ui-view=\"disponibilizarcargafiorilli\" \nng-if=\"vm.sistemaGestorEhFiorilli\"></div><div ui-view=\"disponibilizarcargathema\" ng-if=\"vm.sistemaGestorEhThema\"></div>\n</div></div>");
$templateCache.put("app/main/processamento/download-fotos/views/download-fotos-form.html","<div id=\"download-fotos-form\" class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><div \nclass=\"form-content\"><div class=\"secao-filtros\" layout-gt-sm=\"row\" layout-align=\"center center\" layout-padding><div \nflex=\"55\" layout=\"row\" layout-align=\"center start\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"LEITURA.VISUALIZACAO.MES\"></label><input type=\"text\" ui-number-mask=\"0\" ng-required=\"true\" \nid=\"cadastro-entrega-tipo-entrega-mes\" ng-blur=\"vm.metodos.setDefaultMes()\" name=\"mes\" min-value=\"1\" max-value=\"12\" \nng-required=\"true\" ng-model=\"vm.entidade.mes\" ng-change=\"vm.metodos.pesquisarArquivos()\" ng-disabled=\"vm.emProgresso\">\n</md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex-gt-sm=\"25\"><label \ntranslate=\"LEITURA.VISUALIZACAO.ANO\">ANO</label><input type=\"text\" name=\"ano\" ng-blur=\"vm.metodos.setDefaultAno()\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ui-number-mask=\"0\" ui-hide-group-sep ng-required=\"true\" \nng-model=\"vm.entidade.ano\" ng-change=\"vm.metodos.pesquisarArquivos()\" ng-disabled=\"vm.emProgresso\">\n</md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex><label>Arquivos</label><md-select \nng-model=\"vm.entidade.arquivo\" md-on-open=\"vm.metodos.configuraMdSelectArquivos()\" ng-required=\"true\" name=\"arquivo\" \nng-disabled=\"vm.arquivos.length == 0 || vm.emProgresso\"><md-select-header ng-if=\"vm.arquivos.length > 0\"><input \nid=\"select-arquivo\" type=\"search\" class=\"md-text\" placeholder=\"Pesquisar arquivo..\" ng-model=\"vm.filtrarArquivos\">\n</md-select-header><md-option ng-value=\"arquivo\" ng-repeat=\"arquivo in vm.arquivos | filter: vm.filtrarArquivos\">\n{{ arquivo }}</md-option></md-select><span ng-show=\"vm.arquivos.length == 0\" class=\"nenhum-grupo\">\nNenhum arquivo encontrado.</span><div ng-messages=\"vm.form.arquivos.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-button \nclass=\"md-raised md-accent btn-filtro\" ng-disabled=\"!vm.form.$valid ||vm.emProgresso\" style=\"margin-top: -20px\" \nng-click=\"vm.metodos.pesquisarFotosCliente()\"><span>Pesquisar</span></md-button><md-button \nclass=\"md-raised md-accent btn-download-fotos\" style=\"margin-top: -20px\" \nng-disabled=\"!vm.metodos.existeFotoSelecionada() || vm.emProgresso\" ng-click=\"vm.metodos.realizarDownload()\"><span>\nRealizar download das fotos selecionadas</span></md-button></div><md-divider></md-divider><div class=\"barra-progresso\" \nlayout=\"row\"><md-progress-linear class=\"md-accent\" md-mode=\"buffer\" value=\"{{vm.progresso}}\" \nmd-buffer-value=\"{{vm.progresso}}\" ng-disabled=\"!vm.emProgresso\" flex=\"100\"></div><div class=\"container-tabela\" \nng-if=\"vm.clienteFotos && vm.clienteFotos.length > 0\"><div class=\"table-scroll-wrapper\"><table \nclass=\"dataTable row-border hover tabela-download-fotos\" width=\"100%\"><thead><tr><th \nclass=\"secondary-text border-left th-selecionar\"><md-menu><div ng-click=\"$mdMenu.open($event)\" class=\"btn-selecionar\" \nng-class=\"{\'disabled\': !vm.clienteFotos || vm.clienteFotos.length === 0 || vm.emProgresso}\"><span \nstyle=\"font-weight: bold; font-size: 1.6rem\">Selecionar</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"s16\">\n</md-icon></div><md-menu-content width=\"5\"><md-menu-item><md-button ng-click=\"vm.metodos.selecionarTodosPagina()\">\n<span>{{ vm.metodos.todosDaPaginaSelecionados() ? \'Desmarcar todos da página\' : \'Selecionar todos da página\' }}</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.metodos.selecionarTodosTabela()\"><span>\n{{ vm.metodos.todosDaTabelaSelecionados() ? \'Desmarcar todos da tabela\' : \'Selecionar todos da tabela\' }}</span>\n</md-button></md-menu-item></md-menu-content></md-menu></th><th class=\"secondary-text\" \nng-click=\"vm.metodos.ordenarPor(\'codigoCliente\')\" style=\"cursor: pointer\"><div class=\"table-header\"><span \nclass=\"column-title\">Consumidor</span><md-icon ng-if=\"vm.ordenacao.campo === \'codigoCliente\'\" \nmd-font-icon=\"{{ vm.metodos.getClasseOrdenacao(\'codigoCliente\') }}\" class=\"s14\" style=\"margin-left: 4px\"></md-icon>\n</div></th><th class=\"secondary-text\" ng-click=\"vm.metodos.ordenarPor(\'fotos.length\')\" \nstyle=\"cursor: pointer; width: 200px\"><div class=\"table-header\" style=\"justify-content: center\"><span \nclass=\"column-title\">Quantidade de fotos</span><md-icon \nmd-font-icon=\"{{ vm.metodos.getClasseOrdenacao(\'fotos.length\') }}\" class=\"s14\" style=\"margin-left: 4px\" \nng-style=\"{\'visibility\': vm.ordenacao.campo === \'fotos.length\' ? \'visible\' : \'hidden\'}\"></md-icon></div></th><th \nclass=\"secondary-text border-right titulo-acoes\"><div class=\"table-header\" style=\"justify-content: center\"><span \nclass=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat-start=\"dadosCliente in (vm.clienteFotosFiltrados || []) | orderBy:vm.ordenacao.campo:vm.ordenacao.reversa | limitTo:vm.paginacao.itensPorPagina:((vm.paginacao.paginaAtual - 1) * vm.paginacao.itensPorPagina) track by dadosCliente.codigoCliente\">\n<td class=\"border-left text-center\"><md-checkbox ng-model=\"dadosCliente.selecionado\" \nng-checked=\"vm.metodos.todasFotosSelecionadas(dadosCliente)\" \nmd-indeterminate=\"vm.metodos.existeFotoClienteSelecionada(dadosCliente)\" aria-label=\"Selecionar fotos do consumidor\" \nng-click=\"vm.metodos.selecionarFotos(dadosCliente)\" ng-disabled=\"vm.emProgresso\" style=\"margin: 0\"></md-checkbox></td>\n<td>{{ dadosCliente.codigoCliente }}</td><td class=\"text-center\"><span style=\"margin-right: 30px\">\n{{ dadosCliente.fotos.length }} </span></td><td class=\"border-right acoes\"><i \nclass=\"{{ dadosCliente.exibirFotos ? \'icon-eye-off\' : \'icon-eye\' }} s18 icone-cor-padrao\" \nng-class=\"{\'disabled\': vm.emProgresso}\" ng-click=\"!vm.emProgresso && vm.metodos.expandirFotos(dadosCliente)\">\n<md-tooltip md-autohide><span>{{ dadosCliente.exibirFotos ? \'Ocultar fotos\' : \'Exibir fotos\' }}</span></md-tooltip></i>\n<md-icon md-svg-src=\"assets/custom/download.svg\" class=\"s18 ml-5\" style=\"color: rgba(3, 155, 229, 0.87) !important\" \nng-class=\"{\'disabled\': vm.emProgresso}\" \nng-click=\"!vm.emProgresso && vm.metodos.realizarDownloadUnitario(dadosCliente)\"><md-tooltip md-autohide><span>Download\n</span></md-tooltip></md-icon></td></tr><tr ng-repeat-end ng-show=\"dadosCliente.exibirFotos\"><td colspan=\"4\">\n<md-grid-list md-cols=\"4\" md-cols-sm=\"1\" md-row-height-gt-sm=\"1:1\" md-row-height=\"3:4\" md-gutter=\"4px\" \nmd-gutter-gt-sm=\"2px\"><md-grid-tile md-rowspan=\"1\" md-colspan=\"1\" \nng-repeat=\"foto in dadosCliente.fotos track by $index\" layout=\"row\" layout-align=\"center center\"><span flex=\"5\"></span>\n<md-checkbox ng-model=\"foto.selecionada\" aria-label=\"Marcar para download\" flex=\"5\" ng-disabled=\"vm.emProgresso\">\n</md-checkbox><span flex=\"5\"></span> <img ng-src=\"{{ vm.metodos.montarURLCDN(foto.cdnFoto) }}\" \nalt=\"{{ foto.cdnFoto }}\" flex=\"85\"></md-grid-tile></md-grid-list></td></tr></tbody></table></div><div \nclass=\"paginacao-footer\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\">\n<span ng-if=\"vm.metodos.totalFotosSelecionadas() > 0\" class=\"md-accent-color\">\n{{ vm.metodos.totalFotosSelecionadas() }} {{ vm.metodos.totalFotosSelecionadas() === 1 ? \'foto selecionada\' : \'fotos selecionadas\' }}\n</span></div><div layout=\"row\" layout-align=\"end center\"><span class=\"secondary-text\" \nstyle=\"margin-right: 8px; white-space: nowrap\">Itens por página:</span><md-select \nng-model=\"vm.paginacao.itensPorPagina\" ng-change=\"vm.metodos.mudarItensPorPagina()\" ng-disabled=\"vm.emProgresso\" \nstyle=\"min-width: 75px; margin-right: 16px\"><md-option ng-repeat=\"opcao in vm.paginacao.opcoes\" ng-value=\"opcao\">\n{{ opcao }}</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.mudarPagina(1)\" \nng-disabled=\"vm.paginacao.paginaAtual === 1 || vm.emProgresso\"><md-icon md-font-icon=\"icon-chevron-double-left\" \nclass=\"s20\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.mudarPagina(vm.paginacao.paginaAtual - 1)\" \nng-disabled=\"vm.paginacao.paginaAtual === 1 || vm.emProgresso\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s20\">\n</md-icon></md-button><span class=\"secondary-text\" style=\"margin: 0 8px; white-space: nowrap\">\n{{ (vm.paginacao.paginaAtual - 1) * vm.paginacao.itensPorPagina + 1 }} – {{ vm.paginacao.paginaAtual * vm.paginacao.itensPorPagina > vm.clienteFotosFiltrados.length ? vm.clienteFotosFiltrados.length : vm.paginacao.paginaAtual * vm.paginacao.itensPorPagina }} de {{ vm.clienteFotosFiltrados.length }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.mudarPagina(vm.paginacao.paginaAtual + 1)\" \nng-disabled=\"vm.paginacao.paginaAtual >= vm.metodos.totalPaginas() || vm.emProgresso\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s20\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.mudarPagina(vm.metodos.totalPaginas())\" \nng-disabled=\"vm.paginacao.paginaAtual >= vm.metodos.totalPaginas() || vm.emProgresso\"><md-icon \nmd-font-icon=\"icon-chevron-double-right\" class=\"s20\"></md-icon></md-button></div></div></div></div></form></div>");
$templateCache.put("app/main/processamento/download-fotos/views/download-fotos.html","<md-content id=\"downloadfotos\" class=\"page-layout simple tabbed\" layout=\"column\" style=\"height: 100%\"><header-padrao \ntranslate-nome=\"PROCESSAMENTO.DOWNLOAD_FOTOS\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"true\" \npesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.clienteFotos && vm.clienteFotos.length > 0  && !vm.emProgresso\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"downloadfotos-form@app.download_fotos\" style=\"height: 100%; display: flex; flex-direction: column\"></div>\n</div></div></md-content>");
$templateCache.put("app/main/processamento/exportacao-mobile/THEMA/disponibilizar-carga-thema.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.disponibilizarCargaForm\" novalidate method=\"post\">\n<md-content layout-padding><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"40\" layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><input type=\"text\" ng-model=\"vm.codigoLeiturista\" required \nid=\"processamento-exportacaomobile-txtCodigoLeiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" mascara-numero-generica=\"#####\" aria-label=\"RESOURCES.LEITURISTA\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"85\"><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required name=\"leiturista\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" id=\"processamento-exportacaomobile-txtDescricaoLeiturista\" \nmd-on-open=\"vm.metodos.configurarSelect()\" ng-model=\"vm.codigoLeiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">{{leiturista.apelido}}\n</md-option></md-select></md-input-container></div></div><div layout-gt-sm=\"row\" layout-align=\"center center\">\n<lf-ng-md-file-input flex=\"60\" name=\"arquivo\" lf-files=\"vm.arquivos\" lf-browse-label=\"Procurar\" \nlf-remove-label=\"Remover\" lf-placeholder=\"Selecionar arquivo\" lf-required progress \nng-disabled=\"vm.emProgresso || !vm.codigoLeiturista\" lf-api=\"vm.lfApi\"></lf-ng-md-file-input></div><md-divider \nng-if=\"!vm.emProgresso\"></md-divider><div layout=\"row\" layout-align=\"center center\" layout-padding><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.disponibilizarCargaForm.$invalid || vm.emProgresso\" \nng-click=\"vm.metodos.disponibilizarCarga()\">Disponibilizar</md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/geracaoarquivo/views/geracaoarquivo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"geracaoarquivoForm\" id=\"geracao-arquivo\" novalidate><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"center center\" flex><div flex-gt-sm=\"30\" flex layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"15\"><input type=\"text\" ng-model=\"vm.filtro.codigoLeiturista\" \nng-required=\"true\" id=\"geracao-arquivo-txtCodigoLeiturista\" \nng-disabled=\"vm.emProgresso || vm.leituristas.length == 0 || vm.codigoLeiturista\" mascara-numero-generica=\"#####\" \naria-label=\"RESOURCES.LEITURISTA\"></md-input-container><md-input-container class=\"md-block\" flex><label \nclass=\"md-subheader\" translate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-required=\"true\" \nname=\"leiturista\" id=\"geracao-arquivo-txtDescricaoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-model=\"vm.filtro.codigoLeiturista\" \nng-disabled=\"vm.emProgresso || vm.leituristas.length == 0 || vm.codigoLeiturista\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter: vm.termoProcurado | orderBy:\'apelido\' \">{{leiturista.apelido}}\n</md-option></md-select><div ng-messages=\"geracaoarquivoForm.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex><div flex-gt-sm=\"25\" flex layout=\"row\"><md-input-container \nid=\"data-disponibilizacao-carga\" class=\"md-block\" flex><label translate=\"PROCESSAMENTO.DATA_CARGA\"></label>\n<md-datepicker ng-model=\"vm.filtro.dataExportacao\" name=\"dataExportacao\" ng-disabled=\"vm.emProgresso\" \nng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data ng-required=\"true\"></md-datepicker><div \nng-messages=\"geracaoarquivoForm.dataExportacao.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"row\" flex \nlayout-align=\"center center\"><md-button flex flex-gt-sm=\"30\" class=\"md-raised md-accent\" \nng-disabled=\"(!vm.filtro.dataExportacao || !vm.filtro.codigoLeiturista || vm.emProgresso || vm.desabilitarBotaoFiltro) || geracaoarquivoForm.$invalid \" \nng-click=\"vm.metodos.pesquisarArquivosRetorno(vm.filtro);\"><div layout=\"row\" layout-align=\"center center\"><span>Filtrar\n</span><md-progress-circular ng-show=\"vm.emProgresso\" class=\"ml-10 md-accent\" md-diameter=\"16\" md-mode=\"indeterminate\">\n</md-progress-circular></div></md-button></div></div><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.options\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"cabecalho in vm.cabecalhos track by $index\">\n<div class=\"table-header\"><span class=\"column-title text-center\">{{ cabecalho }}</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"arquivo in vm.arquivos track by $index\"><td class=\"text-center\"><span>\n{{ arquivo.nomeArquivoExportacao }}</span></td><td class=\"text-center\"><span class=\"text-boxed m-0 white-fg\" \nng-class=\"{ \'md-green-bg\': !arquivo.emAndamento, \'deep-orange-bg\': arquivo.emAndamento }\">\n{{ arquivo.emAndamento ? \'Em andamento\' : \'Concluído\' }}</span></td><td class=\"text-center\"><div layout=\"column\" flex \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-disabled=\"vm.emProgresso || (!arquivo.cargaFinalizada && vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada)\" \nng-click=\"vm.metodos.gerarArquivoRetorno(arquivo)\" ng-hide=\"arquivo.emProgresso\"><md-tooltip \nid=\"btn-acao-tabela-{{ $index }}\" md-autohide md-delay=\"200\" \nng-if=\"!(!arquivo.cargaFinalizada && vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada)\"><span>Download do arquivo\n</span></md-tooltip><md-tooltip id=\"btn-acao-tabela-{{ $index }}\" md-autohide md-delay=\"200\" \nng-if=\"!arquivo.cargaFinalizada && vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada\"><span>\nDownload de arquivo de retorno indisponível, aguarde a finalização da carga</span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle\" \nng-class=\"{\'gerar-arquivo\': !(!arquivo.cargaFinalizada && vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada), \r\n                                                            \'nao-gerar-arquivo\': !arquivo.cargaFinalizada && vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada}\">\n</md-icon></md-button><md-progress-circular ng-show=\"arquivo.emProgresso\" class=\"md-accent\" md-diameter=\"16\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></td></tr></tbody></table></ms-widget-front></ms-widget></form>\n</div>");
$templateCache.put("app/main/processamento/geracaoarquivo/views/geracaoarquivo.html","<div id=\"geracaoarquivo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.GERACAO_ARQUIVO_RETORNO\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"geracaoarquivo-form\"></div></div>");
$templateCache.put("app/main/processamento/exportacaogestor/views/exportacaogestor-form.html","<div id=\"exportacao-gestor\"><div class=\"no-results text-center\" ng-if=\"!vm.arquivos.length\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"\">Nenhum dado.</div></div></div><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagem }}\"></carregamento-circular><form name=\"exportacaogestorForm\" id=\"exportacao-gestor\" \nnovalidate ng-if=\"vm.arquivos.length\"><tabela dados=\"vm.arquivos\" cabecalhos=\"vm.cabecalhos\" titulo-acao=\"Enviar\" \nicone-acao=\"icon-arrow-down-bold-circle\" propriedades-exibir=\"vm.propriedadesExibirTabela\" \ndesabilitar=\"vm.emProgresso\" cor-icone=\"#0091EA\" acao=\"vm.metodos.realizarEnvio\" options=\"vm.options\"></tabela></form>\n</div>");
$templateCache.put("app/main/processamento/exportacaogestor/views/exportacaogestor.html","<md-content id=\"exportacaogestor\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.EXPORTACAO_GESTOR\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"exportacaogestor-form\"></div></div></md-content>");
$templateCache.put("app/main/processamento/importacao-grupo-leitura/views/importacao-grupo-leitura-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"{{vm.tituloSplash}}\" sub-titulo=\"{{vm.subTituloSplash}}\">\n</carregamento-circular><div id=\"importacao-grupo\" class=\"md-background-bg md-whiteframe-1dp\"><form \nname=\"importacaoGrupoForm\" novalidate method=\"post\" enctype=\"multipart/form-data\"><md-content layout-padding><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><label translate=\"RESOURCES.AGRUPAMENTO\"></label><md-select name=\"regional\" \nid=\"processamento-exportacaomobile-slcregional\" ng-model=\"vm.parametrosExportacao.regionalCodigo\" required \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" id=\"processamento-exportacaomobile-slcregional-options-{{$index}}\" \nng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div ng-if=\"vm.parametros.utilizaImportacaoLeituraViaFtp\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.preLoader\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" \nclass=\"md-accent\"></md-progress-circular></div></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nng-if=\"!vm.parametros.utilizaImportacaoLeituraViaFtp && !vm.sistemaGestorEhFiorilli\"><lf-ng-md-file-input \nflex-gt-sm=\"50\" name=\"arquivo\" lf-files=\"vm.arquivos\" lf-browse-label=\"Procurar\" lf-remove-label=\"Remover\" \nlf-placeholder=\"Selecionar arquivo\" lf-required progress ng-disabled=\"vm.emProgresso\" lf-api=\"vm.lfApi\">\n</lf-ng-md-file-input></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nng-if=\"!vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.MES\">Mês</label><input type=\"text\" min-value=\"1\" max-value=\"12\" \nng-model=\"vm.parametrosExportacao.mesDistribuicao\" id=\"processamento-exportacaomobile-txtMesDistribuicao\" required \nmascara-numero-generica=\"##\" ng-disabled=\"!vm.sistemaGestorEhFiorilli\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" ui-number-mask=\"0\" \nui-hide-group-sep ng-model=\"vm.parametrosExportacao.anoDistribuicao\" \nid=\"processamento-exportacaomobile-txtAnoDistribuicao\" required maxlength=\"4\" \nng-disabled=\"!vm.sistemaGestorEhFiorilli\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" \nng-if=\"!vm.sistemaGestorEhFiorilli\"><label translate=\"RESOURCES.GRUPO\">Grupo de serviço</label><input type=\"text\" \nng-model=\"vm.parametrosExportacao.grupoDistribuicao\" id=\"processamento-exportacaomobile-txtGrupoDistribuicao\" required \nmascara-numero-generica=\"####\" ng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.parametros.utilizaImportacaoLeituraViaFtp && vm.parametrosExportacao.regionalCodigo\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"table-title\" layout=\"row\" layout-align=\"start center\">\n{{vm.arquivosFTP.titulo}}</div><div class=\"pv-16\" style=\"margin-right: 10px\"><md-select class=\"simplified\" \nng-model=\"vm.filtro.status\" ng-change=\"vm.metodos.filtrar(vm.filtro.status)\" aria-label=\"Menu\"><md-option \nng-repeat=\"status in vm.status\" value=\"{{status.valor}}\">{{status.valor}}</md-option></md-select></div></div><table \nclass=\"simple\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nSituação</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nNome</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nImportar</span></div></th></tr></thead><tbody><tr ng-repeat=\"arquivo in vm.arquivosFTP.arquivos\"><td><span \nclass=\"text-boxed m-0 light-blue-bg white-fg\" ng-if=\"arquivo.situacao == \'Importado\'\">{{arquivo.situacao}} </span><span\n class=\"text-boxed m-0 deep-orange-bg white-fg\" ng-if=\"arquivo.situacao ==\'Não importado\'\">{{arquivo.situacao}}</span>\n</td><td><span>{{arquivo.nome}}</span></td><td><md-button class=\"md-icon-button\" aria-label=\"Importar arquivo\" \nng-click=\"vm.metodos.importacaoViaFTP(arquivo.nome)\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button></td>\n</tr></tbody></table></div></ms-widget-front></ms-widget></div></div><md-divider ng-if=\"!vm.emProgresso\"></md-divider>\n<div layout=\"row\" layout-align=\"center center\" layout-padding ng-if=\"!vm.parametros.utilizaImportacaoLeituraViaFtp\">\n<md-button class=\"md-raised md-accent\" id=\"processamento-importacaoGrupo\" \nng-disabled=\"(importacaoGrupoForm.$invalid || vm.emProgresso) && !(vm.sistemaGestorEhFiorilli && vm.parametrosExportacao.mesDistribuicao && vm.parametrosExportacao.anoDistribuicao)\" \nng-click=\"vm.metodos.realizarImportacao()\"><span translate=\"RESOURCES.IMPORTAR\"></span></md-button></div></md-content>\n</form></div>");
$templateCache.put("app/main/processamento/importacao-grupo-leitura/views/importacao-grupo-leitura.html","<div id=\"importacao-grupo-leitura\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.IMPORTACAO_GRUPO_LEITURA\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content\"><div ui-view=\"importacao-grupo-leitura-caema-form\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div><div ui-view=\"importacao-grupo-leitura-form\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/views/gerenciamento-grupo-form.html","<div id=\"gerenciamentogrupo\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-gerenciamentogrupo\" md-whiteframe=\"4\" ui-view=\"gerenciamentogrupo-filtro\" ms-scroll \nms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"legenda-gerenciamentogrupo\" md-whiteframe=\"4\" ui-view=\"gerenciamentogrupo-legenda\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" ng-if=\"vm.grupos.length == 0\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\"></div><md-button ng-disabled=\"vm.emProgresso\" \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroGerenciamentoGrupo()\"><span>Filtrar</span></md-button>\n</div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular></md-content><md-content \nlayout-padding ng-if=\"vm.grupos.length > 0 && !vm.emProgresso\" layout=\"column\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between\" flex=\"100\"><div layout-align=\"start start\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"90\">\n<div layout=\"row\" flex=\"100\" flex-gt-xs=\"{{filtro.flexGtXs}}\" class=\"div-card\" ng-repeat=\"filtro in vm.filtros\">\n<ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">{{filtro.titulo}}</div><div \nclass=\"font-size-16\" style=\"text-align: center\">{{filtro.dado}}</div></div></ms-widget-front></ms-widget></div></div>\n<div flex=\"100\" flex-gt-xs=\"10\"><fab-button buttons=\"vm.itensMenu\" titulo-menu=\"Menu\"></div></div><div flex=\"100\" \nlayout=\"column\"><table class=\"dataTable row-border hover\" ng-if=\"vm.grupos\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr show-gt-sm hide><th colspan=\"2\" class=\"border-left border-right\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"></th><th colspan=\"3\" class=\"border-left border-right\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 89\"></th><th colspan=\"4\" class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Leituras</span></div></th><th \ncolspan=\"2\" class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Tarefas</span></div></th><th colspan=\"2\" class=\"border-right text-right\"><div \nclass=\"tabela-header-casan\"><i class=\"icon-alert-circle informativo-grupoleitura\" \nng-if=\"vm.grupos[0].existeProblemaExportacao\"><md-tooltip><span>Existem tarefas com problema na exportação</span>\n</md-tooltip></i><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.recuperarTodasTarefas()\" \nng-if=\"vm.existeGrupoDistribuido && vm.parametros.calculo.tipoDetalheCalculo == 89\"><md-tooltip md-autohide><span>\nExibir todas tarefas</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-app\" class=\"cor-icone-padrao\"></md-icon>\n</md-button></div></th></tr><tr><th class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"RESOURCES.GRUPO\">Grupo</span></div></th><th \nclass=\"secondary-text border-left border-right\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 89\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Município</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"RESOURCES.STATUS\">Status</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Total</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Efetuadas</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Não efetuadas</span></div></th>\n<th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Efetuadas(%)</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Pendentes de recebimento</span>\n</div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Pendentes de finalização</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Arquivo</span></div></th><th \nclass=\"border-right\"></th></tr></thead><tbody><tr ng-repeat=\"grupo in vm.grupos track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{grupo.grupo}}</span></td><td \nclass=\"text-center border-left border-right\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 89\"><span>\n{{grupo.municipioDescricao}}</span></td><td class=\"text-center border-right\"><span \nclass=\"text-boxed white-bg black-fg\" ng-if=\"grupo.situacao === \'NÃO DISTRIBUÍDO\'\">Não distribuido </span><span \nclass=\"text-boxed gray-bg black-fg\" ng-if=\"grupo.situacao === \'PARCIALMENTE DISTRIBUÍDO\'\">Parciamente distríbuido \n</span><span class=\"text-boxed yellow-700-bg black-fg\" ng-if=\"grupo.situacao === \'DISTRIBUÍDO\'\">Distríbuido </span>\n<span class=\"text-boxed orange-bg white-fg\" ng-if=\"grupo.situacao === \'EXPORTADO MOBILE\'\">Tarefas disponibilizadas \n</span><span class=\"text-boxed md-light-blue-600-bg white-fg\" ng-if=\"grupo.situacao === \'IMPORTADO MOBILE\'\">Importado \n</span><span class=\"text-boxed green-bg white-fg\" ng-if=\"grupo.situacao === \'GRUPO EXPORTADO\'\">Exportado</span></td><td\n class=\"text-center border-right\"><span>{{grupo.totalLeituras | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.leiturasEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.leiturasNaoEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{ grupo.porcentagemConclusaoLeituras }}%</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.recebimentoColetorTarefaPendenteQuantidade}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.finalizacaoCargaTarefaPendenteQuantidade}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.nomeArquivo}}</span></td><td class=\"text-center border-left\"><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirDialogDatas(grupo)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.DATAS_GRUPO\">Datas do grupo</span></md-tooltip><md-icon md-font-icon=\"icon-calendar\" \nclass=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.recuperarTarefas(grupo)\" ng-if=\"!(grupo.situacao === \'NÃO DISTRIBUÍDO\')\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.TAREFAS\">Tarefas</span></md-tooltip><md-icon \nmd-font-icon=\"icon-open-in-app\" class=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.selecionarMetodoAcao($event, grupo)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span\n translate=\"RESOURCES.ACAO\">Ação</span></md-tooltip><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" \nclass=\"cor-icone-padrao\"></md-icon></md-button></div></td></tr></tbody></table></div></md-content></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/views/gerenciamento-grupo.html","<div id=\"gerenciamentogrupo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.GERENCIAMENTO_GRUPO\" icone=\"icon-cellphone-android\" pesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.grupos.length > 0 && !vm.emProgresso\" ng-utiliza-pesquisa=\"true\">\n</header-padrao><div class=\"content\"><div ui-view=\"gerenciamentogrupo-form\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div><div \nui-view=\"gerenciamentogrupo-form-caema@app.gerenciamento_grupo\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\">\n</div></div></div>");
$templateCache.put("app/main/relatorios/alerta-cliente/views/alerta-cliente-form.html","<div layout-padding class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando relatório...\"></carregamento-circular><form name=\"relatorioClienteAlertaForm\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><md-input-container class=\"input-container\"><label \nstyle=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_INICIAL\">Período inicial</label><md-datepicker \nng-model=\"vm.entidade.dataInicio\" name=\"dataInicio\" ng-disabled=\"vm.emProgresso\" md-max-date=\"vm.entidade.dataFim\" \nrequired ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"relatorioClienteAlertaForm.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_FINAL\">Período final</label>\n<md-datepicker ng-model=\"vm.entidade.dataFim\" name=\"dataFim\" ng-disabled=\"vm.emProgresso\" \nmd-min-date=\"vm.entidade.dataInicio\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"relatorioClienteAlertaForm.dataFim.$error\"><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.tipoDetalheCalculo == 88\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"35\"><multi-select-directive name=\"regional\" id=\"faturamento-slcregional\" style=\"margin:0px;padding: 0px\" flex \nform-name=\"localidades\" data=\"vm.listaRegionais\" model=\"vm.entidade.regionais\" descricao-exibicao=\"descricao\" \ntexto-pesquisa-placeholder=\"Pesquisar...\" texto-placeholder=\"Localidades\"><span ng-if=\"vm.listaRegionais.length == 0\" \nclass=\"nenhum-encontrado\">Nenhuma localidade encontrada</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\" flex=\"35\"><md-input-container \nclass=\"md-block\" layout=\"row\" layout-align=\"center center\" flex><label translate=\"\">Código do cliente</label><input \nng-model=\"vm.entidade.codigoCliente\" type=\"text\" maxlength=\"15\" name=\"codigoCliente\"></md-input-container></div></div>\n<div layout=\"row\" flex layout-align=\"center center\"><md-input-container class=\"no-padding-and-margin\"><md-button \nclass=\"md-raised md-accent\" style=\"width: 100%\" ng-disabled=\"relatorioClienteAlertaForm.$invalid || vm.emProgresso\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span>Gerar Relatório</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/relatorios/alerta-cliente/views/alerta-cliente.html","<md-content id=\"alertacliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.ALERTA_CLIENTE.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_alertacliente\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/faturamento/views/faturamento-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Gerando relatório...\"></carregamento-circular><div \nid=\"faturamento\"><form name=\"vm.relatoriosFaturamentoForm\" novalidate><div layout=\"row\"><fieldset class=\"standard\" \nflex><legend class=\"grp-legend\" translate=\"RELATORIOS.FATURAMENTO.REFERENCIA\"></legend><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" flex layout-align=\"center center\"><div style=\"width: 100%\" flex flex-gt-sm=\"25\" \nlayout=\"row\"><md-radio-group style=\"width: 100%\" ng-model=\"vm.entidade.tipoFiltro\"><div layout-sm=\"row\" \nlayout=\"column\" layout-align=\"center center\"><div layout-sm=\"row\" layout-align=\"space-around center\" flex>\n<md-radio-button flex-offset-sm=\"5\" value=\"1\"><span translate=\"RELATORIOS.FATURAMENTO.MES_ANO_REFERENCIA\"></span>\n</md-radio-button><md-radio-button flex-offset-sm=\"5\" value=\"2\"><span \ntranslate=\"RELATORIOS.FATURAMENTO.PERIODO_LEITURA\"></span></md-radio-button></div></div></md-radio-group></div><div \nflex style=\"width: 100%\" layout-align=\"center center\" layout-align-gt-sm=\"start center\" layout=\"row\"><div flex \nlayout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\" ng-if=\"vm.entidade.tipoFiltro == 1\">\n<md-input-container flex=\"20\"><label translate=\"RELATORIOS.FATURAMENTO.MES\"></label><input \nmascara-numero-generica=\"##\" ng-required=\"vm.entidade.tipoFiltro == 1\" name=\"mes\" ng-model=\"vm.entidade.mes\" \nvalidacao-mes><div ng-messages=\"vm.relatoriosFaturamentoForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex=\"20\"><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" \nng-required=\"vm.entidade.tipoFiltro == 1\" name=\"ano\" ng-model=\"vm.entidade.ano\"><div \nng-messages=\"vm.relatoriosFaturamentoForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex layout-xs=\"column\" \nlayout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\" ng-if=\"vm.entidade.tipoFiltro == 2\"><div \nlayout=\"row\" layout-align=\"center center\" flex><span class=\"referencia-de-ate\" translate=\"RELATORIOS.FATURAMENTO.DE\">\n</span><md-input-container><label translate=\"RELATORIOS.FATURAMENTO.MES\"></label><input mascara-numero-generica=\"##\" \nng-required=\"vm.entidade.tipoFiltro == 2\" name=\"mesInicial\" ng-model=\"vm.entidade.mesInicial\" validacao-mes><div \nng-messages=\"vm.relatoriosFaturamentoForm.mesInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" \nng-required=\"vm.entidade.tipoFiltro == 2\" name=\"anoInicial\" ng-model=\"vm.entidade.anoInicial\"><div \nng-messages=\"vm.relatoriosFaturamentoForm.anoInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex \nlayout-align=\"center center\" layout=\"row\"><span flex-offset-gt-xs=\"5\" class=\"referencia-de-ate\" \ntranslate=\"RELATORIOS.FATURAMENTO.ATE\"></span><md-input-container><label translate=\"RELATORIOS.FATURAMENTO.MES\">\n</label><input mascara-numero-generica=\"##\" ng-required=\"vm.entidade.tipoFiltro == 2\" name=\"mesFinal\" \nng-model=\"vm.entidade.mesFinal\" validacao-mes><div ng-messages=\"vm.relatoriosFaturamentoForm.mesFinal.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" \nng-required=\"vm.entidade.tipoFiltro == 2\" name=\"anoFinal\" ng-model=\"vm.entidade.anoFinal\"><div \nng-messages=\"vm.relatoriosFaturamentoForm.anoFinal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div flex-gt-sm=\"70\" \nflex layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\" layout-align-gt-sm=\"start center\" \nng-if=\"vm.entidade.tipoFiltro == 3\"><div layout=\"row\" layout-align=\"end center\" flex><md-input-container \nclass=\"input-container faturamento-input-container-data\"><label style=\"margin-right: 15px\" \ntranslate=\"RELATORIOS.FATURAMENTO.DATA_INICIAL\"></label><md-datepicker ng-required=\"vm.entidade.tipoFiltro == 3\" \nng-model=\"vm.entidade.dataInicial\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" \nmd-max-date=\"vm.entidade.dataFinal\" mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"vm.relatoriosFaturamentoForm.dataInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" flex><md-input-container class=\"input-container faturamento-input-container-data\"><label \nstyle=\"margin-right: 15px\" translate=\"RELATORIOS.FATURAMENTO.DATA_FINAL\"></label><md-datepicker \nng-required=\"vm.entidade.tipoFiltro == 3\" ng-model=\"vm.entidade.dataFinal\" ng-mask=\"3?9/1?9/9999\" name=\"dataFinal\" \nng-disabled=\"vm.emProgresso\" md-min-date=\"vm.entidade.dataInicial\" mascara-conversor-string-para-data></md-datepicker>\n<div ng-messages=\"vm.relatoriosFaturamentoForm.dataFinal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div></div></fieldset>\n</div><div ng-if=\"vm.utilizaCadastroRegional\" layout=\"row\"><fieldset class=\"standart\" flex><legend class=\"grp-legend\" \ntranslate=\"RELATORIOS.FATURAMENTO.LOCALIDADE\"></legend><div flex layout=\"row\" layout-xs=\"column\" class=\"pt-10\"><div \nlayout=\"row\" flex=\"100\"><multi-select-directive name=\"regional\" id=\"faturamento-slcregional\" \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"localidades\" data=\"vm.listaRegionais\" model=\"vm.entidade.regionais\" \ndescricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Pesquisar...\" texto-placeholder=\"Localidade\"><span \nng-if=\"vm.listaRegionais.length == 0\" class=\"nenhum-encontrado\">Nenhuma localidade encontrada</span><div \nng-messages=\"vm.relatoriosFaturamentoForm.regional.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></div></div></fieldset></div><ng-container \nng-if=\"!vm.utilizaCadastroRegional\"><div layout-gt-sm=\"row\" layout=\"column\"><div ng-if=\"!vm.utilizaCadastroRegional\" \nlayout=\"row\" flex=\"50\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"RELATORIOS.FATURAMENTO.SERVICOS_PRESTADOS\"></legend><div layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex layout-padding><span translate=\"RELATORIOS.FATURAMENTO.NUMERO_SERVICOS_INCLUIDOS\">\n</span> {{vm.entidade.servicos.length || 0}}</div><div layout=\"row\" layout-align=\"start center\" flex=\"20\" flex-md=\"25\">\n<md-button class=\"md-fab no-padding no-margin\" ng-click=\"vm.metodos.abrirDialogServicos()\"><md-icon \nmd-font-icon=\"icon-plus\"><md-tooltip><span translate=\"RELATORIOS.FATURAMENTO.INSERIR_SERVICOS\"></span></md-tooltip>\n</md-icon></md-button></div></div></fieldset></div><div layout=\"row\" flex=\"50\"><fieldset class=\"standard\" flex><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.FATURAMENTO.OCORRENCIAS\"></legend><div layout=\"row\"><multi-select-directive \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"ocorrencias\" data=\"vm.ocorrencias\" model=\"vm.entidade.ocorrencias\" \ndescricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Pesquisar...\" texto-placeholder=\"Ocorrências\"></div>\n</fieldset></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"row\" flex-xs=\"100\" flex=\"50\"><fieldset \nclass=\"standard mt-10\" flex><div flex layout=\"row\" class=\"pt-10\" layout-align=\"center center\"><md-checkbox \nname=\"exibirOcorrenciaLeituraNormal\" ng-model=\"vm.entidade.exibirOcorrenciaLeituraNormal\" \naria-label=\"Exibir ocorrência normal\" ng-true-value=\"true\" ng-false-value=\"false\"><span \ntranslate=\"RELATORIOS.FATURAMENTO.EXIBIR_OCORRENCIA_NORMAL\"></span></md-checkbox></div></fieldset></div><div \nlayout=\"row\" flex-xs=\"100\" flex=\"50\"><fieldset class=\"standard mt-10\" flex><div flex layout=\"row\" class=\"pt-10\" \nlayout-align=\"center center\"><md-checkbox name=\"exibirLeiturasComSemHidrometro\" \nng-model=\"vm.entidade.exibirAgrupamentoLeiturasComSemHidrometro\" \naria-label=\"Exibir agrupamento de leituras com e sem hidrômetro\" ng-true-value=\"true\" ng-false-value=\"false\"><span \ntranslate=\"RELATORIOS.FATURAMENTO.EXIBIR_AGRUPAMENTO_LEITURA_COM_SEM_HIDROMETRO\"></span></md-checkbox></div></fieldset>\n</div></div><ng-container layout-gt-sm=\"row\" layout=\"column\" flex-xs=\"100\" flex=\"50\" \nng-if=\"vm.codigoImanager === \'3821\'\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"Localidade\">\n</legend><md-input-container class=\"md-block select-localidades\" flex=\"100\"><label>Localidade</label><md-select \nname=\"localidadeItapemirim \" id=\"relatorio-faturamento-localidades\" ng-model=\"vm.entidade.localidadeItapemirim\" \nng-disabled=\"vm.emProgresso\" ng-required=\"true\" md-on-open=\"vm.metodos.configuraMdSelectLocalidades()\">\n<md-select-header ng-if=\"vm.localidades.length > 0\"><input ng-model=\"vm.filtrarLocalidade\" type=\"search\" \nid=\"select-localidade\" placeholder=\"Pesquisar localidade..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"localidade\" ng-repeat=\"localidade in vm.localidades | filter: vm.filtrarLocalidade\">{{localidade.descricao}}\n</md-option></md-select><div ng-messages=\"vm.relatoriosFaturamentoForm.localidadeItapemirim.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset>\n</ng-container></ng-container><div layout=\"row\" flex layout-align=\"center center\"><md-input-container \nclass=\"input-gerar-relatorio\"><md-button ng-disabled=\"vm.relatoriosFaturamentoForm.$invalid\" \nclass=\"md-raised md-accent button-gerar-relatorio\" ng-click=\"vm.metodos.gerarRelatorio()\"><span \ntranslate=\"RELATORIOS.FATURAMENTO.GERAR\"></span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/relatorios/faturamento/views/faturamento.html","<md-content id=\"faturamentoPage\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.FATURAMENTO.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\"></header-padrao>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div ui-view=\"relatorios-form\">\n</div></div></div></md-content>");
$templateCache.put("app/main/relatorios/historico-consumo/views/historico-consumo-form.html","<div layout=\"column\" id=\"historicoconsumo-form\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando relatório...\"></carregamento-circular><md-content id=\"historico-form\" layout-padding layout=\"column\" \nflex layout-align=\"center center\"><form name=\"vm.historicoConsumoForm\" novalidate><div layout=\"row\" \nclass=\"container-filtros\"><fieldset class=\"standard\" flex=\"60\"><legend class=\"grp-legend\">Mês/Ano Referência</legend>\n<div layout=\"column\" layout-sm=\"column\" layout-xs=\"column\" flex layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"center center\" flex><span class=\"referencia-de-ate\">de</span><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.MES\"></label><input mascara-numero-generica=\"##\" ng-required=\"true\" \nname=\"mesInicial\" ng-model=\"vm.entidade.mesInicial\" validacao-mes><div \nng-messages=\"vm.historicoConsumoForm.mesInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" ng-required=\"true\" \nname=\"anoInicial\" ng-model=\"vm.entidade.anoInicial\"><div ng-messages=\"vm.historicoConsumoForm.anoInicial.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nflex layout-align=\"center center\" layout=\"row\"><span class=\"referencia-de-ate\">até</span><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.MES\"></label><input mascara-numero-generica=\"##\" ng-required=\"true\" name=\"mesFinal\" \nng-model=\"vm.entidade.mesFinal\" validacao-mes><div ng-messages=\"vm.historicoConsumoForm.mesFinal.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" ng-required=\"true\" \nname=\"anoFinal\" ng-model=\"vm.entidade.anoFinal\"><div ng-messages=\"vm.historicoConsumoForm.anoFinal.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>\n</fieldset><fieldset class=\"standard container-cliente\" layout=\"row\" layout-align=\"center center\" flex=\"40\"><legend \nclass=\"grp-legend\">Cliente</legend><div flex=\"60\" flex-offset=\"20\" layout=\"column\" layout-align=\"center center\" \nclass=\"input-cliente\"><md-input-container class=\"md-block\" layout=\"row\" layout-align=\"center center\" flex><label \ntranslate=\"\">Código do cliente</label><input ng-model=\"vm.entidade.codigoCliente\" type=\"text\" ng-required=\"true\" \nname=\"codigoCliente\"><div ng-messages=\"vm.historicoConsumoForm.codigoCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nlayout=\"row\" flex layout-align=\"center center\"><md-input-container class=\"input-gerar-relatorio\"><md-button \nng-disabled=\"vm.historicoConsumoForm.$invalid\" class=\"md-raised md-accent button-gerar-relatorio\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span>Gerar</span></md-button></md-input-container></div></form></md-content>\n</div>");
$templateCache.put("app/main/relatorios/historico-consumo/views/historico-consumo.html","<md-content id=\"historicoconsumo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.HISTORICO_CONSUMO.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_historicoconsumo\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/clientes-nao-visitados/views/clientes-nao-visitados-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Gerando relatório...\"></carregamento-circular><md-content \nid=\"clientesnaovisitados-form\" class=\"p-50\" layout=\"column\"><form name=\"form\" novalidate><div layout=\"row\"><div \nlayout=\"column\" flex=\"30\" style=\"margin-right: 5px\"><fieldset class=\"standard pr-30 pl-30\" flex><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.CLIENTES_NAO_VISITADOS.MES_ANO_REFERENCIA\"></legend><div layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">\nMês</label><input type=\"text\" name=\"mes\" validacao-mes mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.mes, vm.filtro.ano)\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.mes, vm.filtro.ano)\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div><div ng-if=\"vm.tipoProcesso == \'02\'\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><div id=\"select-grupos\" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" \nstyle=\"width: 230px; max-width: 230px;\r\n                            min-width: 230px\"><label>Grupos</label><md-select \nng-model=\"vm.filtro.grupo\" ng-change=\"vm.onChangeItemGrupos()\" md-on-close=\"vm.clearSearchTermGrupos()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-disabled=\"!vm.grupos || vm.grupos.length === 0\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermGrupos\" type=\"search\" \nplaceholder=\"Procurar grupos...\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-optgroup label=\"item\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.grupos | filter:vm.searchTermGrupos\">{{item.identificadorGrupo}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container><md-checkbox style=\"margin-right: 10px\" ng-model=\"vm.todosGrupos\" \nng-change=\"vm.limparSelecaoGrupos()\" aria-label=\"Checkbox Disabled Indeterminate\" \nng-disabled=\"!vm.filtro.grupo || vm.filtro.grupo.length == 0\" class=\"md-primary\">Todos</md-checkbox>\n</md-input-container></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" layout-align=\"center center\"><span \nclass=\"nenhum-grupo\" ng-if=\"vm.grupos && vm.grupos.length == 0\">Nenhum grupo encontrado.</span></div></div></fieldset>\n</div><div layout=\"column\" flex=\"70\"><fieldset class=\"standard\" layout=\"row\" layout-align=\"center center\" flex><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.LEITURISTAS\"></legend><div layout=\"row\" layout-align=\"center center\" flex>\n<multi-select-directive form-name=\"leiturista\" style=\"margin:0px;padding: 0px\" data=\"vm.leituristas\" \nmodel=\"vm.filtro.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leiturista\" flex=\"90\"></multi-select-directive>\n</div></fieldset></div></div><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><md-input-container \nclass=\"no-padding-and-margin\" flex=\"20\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.gerarRelatorio()\"><span>Gerar Relatório</span>\n</md-button></md-input-container></div></form></md-content>");
$templateCache.put("app/main/relatorios/clientes-nao-visitados/views/clientes-nao-visitados.html","<md-content id=\"clientesnaovisitados\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.CLIENTES_NAO_VISITADOS.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_clientesnaovisitados\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/faturas-retidas/views/faturas-retidas-form.html","<md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-show=\"vm.emProgresso\" ng-disabled=\"!vm.emProgresso\" \nflex=\"100\"></md-progress-linear><div layout=\"column\" id=\"faturasretidas-form\"><md-content layout-padding flex><form \nname=\"relatoriosFaturasRetidasForm\" novalidate><div layout=\"row\" class=\"container-filtros\"><fieldset class=\"standard\" \nflex><legend class=\"grp-legend\" translate=\"RELATORIOS.FATURAS_RETIDAS.REFERENCIA\"></legend><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"center center\" flex><div style=\"width: 100%\" flex-gt-sm=\"25\" \nlayout=\"row\" flex><md-radio-group style=\"width: 100%\" ng-model=\"vm.entidade.tipoFiltro\"><div layout-sm=\"row\" \nlayout=\"column\" layout-align=\"center center\"><div layout-sm=\"row\" layout-align=\"space-around center\" flex>\n<md-radio-button flex-offset-sm=\"5\" ng-repeat=\"tipoFiltro in vm.tiposFiltros\" ng-value=\"tipoFiltro.valor\"><span>\n{{tipoFiltro.descricao}}</span></md-radio-button></div></div></md-radio-group></div><div flex style=\"width: 100%\" \nlayout-align=\"center center\" layout-align-gt-sm=\"start center\" layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"center center\" layout-align-gt-sm=\"start center\" ng-if=\"vm.entidade.tipoFiltro == 1\"><md-input-container \nflex=\"20\"><label translate=\"RELATORIOS.FATURAS_RETIDAS.MES\"></label><input mascara-numero-generica=\"##\" \nng-required=\"vm.entidade.tipoFiltro == 1\" name=\"mes\" ng-model=\"vm.entidade.mes\" validacao-mes><div \nng-messages=\"relatoriosFaturasRetidasForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex=\"20\"><label \ntranslate=\"RELATORIOS.FATURAS_RETIDAS.ANO\"></label><input mascara-numero-generica=\"####\" \nng-required=\"vm.entidade.tipoFiltro == 1\" name=\"ano\" ng-model=\"vm.entidade.ano\"><div \nng-messages=\"relatoriosFaturasRetidasForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex layout-xs=\"column\" \nlayout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\" ng-if=\"vm.entidade.tipoFiltro == 2\">\n<md-input-container class=\"input-container\"><label style=\"margin-right: 15px\" \ntranslate=\"RELATORIOS.FATURAS_RETIDAS.PERIODO_INICIAL\">Data inicial</label><md-datepicker \nng-model=\"vm.entidade.dataInicial\" name=\"dataInicial\" ng-disabled=\"vm.emProgresso\" md-max-date=\"vm.entidade.dataFinal\" \nng-mask=\"3?9/1?9/9999\" required mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"relatoriosFaturasRetidasForm.dataInicial.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.FATURAS_RETIDAS.PERIODO_FINAL\">\nData final</label><md-datepicker ng-model=\"vm.entidade.dataFinal\" name=\"dataFinal\" ng-disabled=\"vm.emProgresso\" \nmd-min-date=\"vm.entidade.dataInicial\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"relatoriosFaturasRetidasForm.dataFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div></fieldset></div>\n<div layout=\"column\" layout-gt-sm=\"row\" flex><div layout=\"column\" flex><fieldset class=\"standard\"><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.LEITURISTA\"></legend><div layout=\"row\" flex layout-align=\"center center\">\n<multi-select-directive style=\"margin:0px;padding: 0px\" flex form-name=\"leiturista\" data=\"vm.leituristas\" \nmodel=\"vm.entidade.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leiturista\"></div></fieldset></div><div \nlayout-gt-sm=\"column\" layout=\"row\" flex><fieldset class=\"standard\" flex layout-align=\"center center\"><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.ORDENACAO\"></legend><div layout=\"row\" layout-gt-sm=\"column\" flex \nlayout-align=\"center center\"><md-radio-group ng-model=\"vm.entidade.ordenacao\" aria-activedescendant=\"radio_5\">\n<md-radio-button ng-value=\"1\" class=\"md-accent\" aria-checked=\"true\">Cronológica</md-radio-button><md-radio-button \nng-value=\"2\" class=\"md-accent\" aria-checked=\"false\">Cliente</md-radio-button></md-radio-group></div></fieldset></div>\n</div><div layout=\"row\" flex layout-align=\"center center\"><md-input-container class=\"no-padding-and-margin\"><md-button \nclass=\"md-raised md-accent\" style=\"width: 100%\" \nng-disabled=\"vm.relatoriosFaturasRetidasForm.$invalid || vm.emProgresso || !vm.entidade.ordenacao\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span translate=\"RELATORIOS.FATURAS_RETIDAS.GERAR_RELATORIO\"></span></md-button>\n</md-input-container></div></form></md-content></div>");
$templateCache.put("app/main/relatorios/faturas-retidas/views/faturas-retidas.html","<md-content id=\"faturasretidas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.FATURAS_RETIDAS.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_faturasretidas\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/estatisticas/views/estatisticas-form.html","<div layout-padding class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando relatório...\"></carregamento-circular><form name=\"relatoriosEstatisticasForm\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><fieldset \nclass=\"standard\" layout-align=\"center center\" flex flex-gt-sm=\"75\"><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"><div layout=\"row\" flex-gt-sm=\"50\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.REGIONAL\"></label><md-select name=\"regional\" id=\"estatisticas-slcregional\" \nng-change=\"vm.metodos.onChangeRegional()\" ng-model=\"vm.entidade.regional\" \nng-required=\"vm.parametros.utilizaCadastroRegional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-disabled=\"true\" ng-if=\"!vm.listaRegionais || vm.listaRegionais.length <= 0\">Não foram encontradas regionais\n</md-option><md-option ng-value=\"item.codigo\" ng-repeat=\"item in vm.listaRegionais\">{{item.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nflex-gt-sm=\"50\" layout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.listandoMunicipios\"></md-progress-circular><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.MUNICIPIO\"></label><md-select name=\"municipio\" id=\"estatisticas-slcmunicipio\" \nng-model=\"vm.entidade.municipio\" ng-disabled=\"!vm.entidade.regional || vm.listandoMunicipios\"><md-option \nng-value=\"item.codigo\" ng-disabled=\"true\" ng-if=\"vm.listaMunicipios.length <= 0\">Nenhum município encontrado\n</md-option><md-option ng-value=\"item.codigo\" ng-repeat=\"item in vm.listaMunicipios\">{{item.descricao}}</md-option>\n</md-select></md-input-container></div></div></fieldset></div><div layout-gt-sm=\"row\" layout-align=\"center center\">\n<fieldset class=\"standard\" layout-align=\"center center\" flex flex-gt-sm=\"75\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIOS.DATA_COLETA\"></legend><div layout-gt-sm=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_INICIAL\">Período inicial\n</label><md-datepicker ng-model=\"vm.entidade.dataInicio\" name=\"dataInicio\" ng-disabled=\"vm.emProgresso\" \nmd-max-date=\"vm.entidade.dataFim\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data></md-datepicker>\n<div ng-messages=\"relatoriosEstatisticasForm.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_FINAL\">Período final</label>\n<md-datepicker ng-model=\"vm.entidade.dataFim\" name=\"dataFim\" ng-disabled=\"vm.emProgresso\" \nmd-min-date=\"vm.entidade.dataInicio\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"relatoriosEstatisticasForm.dataFim.$error\"><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nclass=\"mb-10\" layout=\"row\" layout-align=\"center center\" flex><fieldset class=\"standard\" layout-align=\"center center\" \nflex flex-gt-sm=\"75\"><legend class=\"grp-legend\" translate=\"RELATORIOS.LEITURISTA\"></legend><div layout=\"row\" flex \nlayout-align=\"center center\"><multi-select-directive style=\"margin:0px;padding: 0px\" flex flex-gt-sm=\"50\" \nform-name=\"leiturista\" data=\"vm.leituristas\" model=\"vm.entidade.leiturista\" obrigatorio=\"true\" \ndescricao-exibicao=\"nome\" texto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leiturista\">\n</multi-select-directive></div></fieldset></div><div layout=\"row\" flex layout-align=\"center center\"><fieldset \nclass=\"standard\" layout=\"row\" flex-gt-sm=\"75\"><div flex><md-checkbox name=\"agrupamentoPorLeiturista\" \nng-model=\"vm.entidade.agrupamento\" aria-label=\"Agrupamento por leiturista\" ng-true-value=\"2\" ng-false-value=\"1\">\n</md-checkbox><span translate=\"RELATORIOS.AGRUPAR_LEITURISTA\">Agrupar por leiturista</span></div><div flex><md-checkbox\n name=\"utilizaDataRealColeta\" ng-model=\"vm.entidade.utilizaDataRealColeta\" aria-label=\"Utilizar data da coleta real\" \nng-true-value=\"true\" ng-false-value=\"false\"></md-checkbox><span>Utilizar data real da coleta</span><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"cor-icone-padrao\"><md-tooltip md-autohide md-direction=\"top\"><span \nclass=\"md-caption\">\nUtilizar parâmetro caso tenha sido realizadas leituras com cálculo proporcional no período informado.</span>\n</md-tooltip></md-icon></div></fieldset></div><div layout=\"row\" flex layout-align=\"center center\"><md-input-container \nclass=\"no-padding-and-margin\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" \nng-disabled=\"relatorioEstatisticasForm.$invalid || vm.emProgresso\r\n                               || (!vm.entidade.dataInicio || !vm.entidade.dataFim)\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span>Gerar</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/relatorios/estatisticas/views/estatisticas.html","<div id=\"estatisticasPage\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.ESTATISTICAS\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"relatorios-form\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div><div \nui-view=\"relatorios-form-caema\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div></div></div>");
$templateCache.put("app/main/relatorios/viva-agua/views/viva-agua-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"{{ vm.mensagemEmProgresso }}\"></carregamento-circular><div\n id=\"vivaagua-form\" class=\"container-principal\"><form name=\"vm.relatoriosVivaAguaForm\" novalidate><fieldset \nclass=\"standard container-filtros\"><md-checkbox name=\"gerarViaArquivo\" ng-model=\"vm.entidade.gerarViaArquivo\" \naria-label=\"Gerar espelho viva água via arquivo\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.metodos.realizarEventoChangeFiltroViaArquivo()\"></md-checkbox><span>Gerar espelho viva água via arquivo\n</span><div layout=\"row\" flex ng-if=\"vm.entidade.gerarViaArquivo\"><input type=\"file\" name=\"vivaaguaArquivo\" \nid=\"vivaagua-arquivo\" style=\"display:none\" onchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo()\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"\">Arquivo</label><input type=\"text\" \nname=\"vivaaguaArquivo\" id=\"vivaagua-arquivo-inputcontainer\" ng-model=\"vm.arquivo.name\" ng-required=\"true\" \nng-disabled=\"true\"></md-input-container><div layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-fab md-raised md-mini md-accent\" id=\"vivaagua-btn-carregar\" aria-label=\"Selecionar arquivo\" flex=\"35\" \nng-click=\"vm.metodos.abrirSelecaoArquivo()\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"300\"><span translate=\"\">Selecionar arquivo</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini md-accent\" id=\"vivaagua-btn-excluir\" ng-click=\"vm.metodos.removerArquivo($event)\" \naria-label=\"Excluir arquivo\" flex=\"35\" ng-disabled=\"vm.controleForm.emProgresso || !vm.arquivo\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span translate=\"\">\nExcluir arquivo</span></md-tooltip></md-button></div></div></fieldset><fieldset class=\"standard container-filtros\">\n<md-checkbox name=\"gerarManualmente\" ng-model=\"vm.entidade.gerarManualmente\" \naria-label=\"Gerar espelho viva água manualmente\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.metodos.realizarEventoChangeFiltroManualmente()\"></md-checkbox><span>Gerar espelho viva água manualmente\n</span><div layout=\"column\" flex ng-if=\"vm.entidade.gerarManualmente\"><fieldset class=\"standart agrupamento-filtros\" \nflex><legend class=\"grp-legend\">Filtros</legend><div flex layout=\"column\"><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"100\"><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><md-select \nng-model=\"vm.entidade.localidade\" \nmd-on-open=\"vm.metodos.configurarSelect(vm.filtrarLocalidades, \'#select-localidade\')\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\"vm.localidades.length > 0\" name=\"localidade\" ng-disabled=\"vm.localidades.length == 0\"><md-select-header \nng-if=\"vm.localidades.length > 0\"><input ng-model=\"vm.filtrarLocalidades\" type=\"search\" id=\"select-localidade\" \nplaceholder=\"Pesquisar localidade..\" class=\"md-text\"></md-select-header><md-option ng-value=\"localidade.codigo\" \nng-repeat=\"localidade in vm.localidades | filter: vm.filtrarLocalidades\">{{localidade.descricao}}</md-option>\n</md-select><span ng-if=\"vm.localidades.length == 0\" class=\"nenhum-grupo\">Nenhum localidade encontrado.</span><div \nng-messages=\"vm.relatoriosVivaAguaForm.localidade.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\"><div layout=\"row\" flex=\"30\"><div flex layout-align=\"center center\" \nlayout-align-gt-sm=\"start center\" layout=\"row\"><div flex layout=\"row\" layout-align=\"center center\" \nlayout-align-gt-sm=\"start center\"><md-input-container flex=\"30\"><label translate=\"RELATORIOS.FATURAMENTO.MES\"></label>\n<input mascara-numero-generica=\"##\" ng-required=\"true\" name=\"mes\" ng-model=\"vm.entidade.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano)\" validacao-mes><div \nng-messages=\"vm.relatoriosVivaAguaForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex=\"40\"><label \ntranslate=\"RELATORIOS.FATURAMENTO.ANO\"></label><input mascara-numero-generica=\"####\" ng-required=\"true\" name=\"ano\" \nng-model=\"vm.entidade.ano\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano)\"><div \nng-messages=\"vm.relatoriosVivaAguaForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div><div layout=\"row\" \nflex=\"30\"><div flex layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent progresso-inputs\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.entidade.grupo\" \nmd-on-open=\"vm.metodos.configurarSelect(vm.filtrarGrupos, \'#select-grupo\')\" ng-required=\"true\" name=\"grupo\" \nng-change=\"vm.metodos.realizarEventoChangeGrupo(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined || vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.relatoriosVivaAguaForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"row\" \nflex=\"40\"><div flex layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent progresso-inputs\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaSetor\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"100\"><label translate=\"RESOURCES.SETOR\">Setor</label><md-select ng-model=\"vm.entidade.setor\" \nmd-on-open=\"vm.metodos.configurarSelect(vm.filtrarSetor, \'#select-setor\')\" ng-required=\"true\" name=\"setor\" \nng-disabled=\"(vm.setor.length == 0 || vm.setor == undefined) && vm.entidade.grupo\" \nng-change=\"vm.metodos.realizarEventoChangeSetor(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.setor)\">\n<md-select-header ng-if=\"vm.setor.length > 0\"><input ng-model=\"vm.filtrarSetor\" type=\"search\" id=\"select-setor\" \nplaceholder=\"Pesquisar setor..\" class=\"md-text\"></md-select-header><md-option ng-value=\"setor.codigo\" \nng-repeat=\"setor in vm.setor | filter: vm.filtrarSetor\">{{ setor.descricao }}</md-option></md-select><span \nng-if=\"vm.setor.length == 0\" class=\"nenhum-grupo\">Nenhum setor encontrado.</span><div \nng-messages=\"vm.form.setor.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></div></div></div></fieldset><fieldset class=\"standart\" flex><legend \nclass=\"grp-legend\">Geração</legend><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" flex \nlayout-align=\"center center\"><div style=\"width: 100%\" flex flex-gt-sm=\"25\" layout=\"row\"><md-radio-group \nstyle=\"width: 100%\" ng-model=\"vm.entidade.tipoFiltro\" \nng-change=\"vm.metodos.realizarEventoChangeSetor(vm.entidade.localidade, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo, vm.entidade.setor)\">\n<div layout-sm=\"row\" layout=\"column\" layout-align=\"center center\"><div layout-sm=\"row\" \nlayout-align=\"space-around center\" flex><md-radio-button flex-offset-sm=\"5\" value=\"2\"><span>Somente faturas impressas\n</span></md-radio-button><md-radio-button flex-offset-sm=\"5\" value=\"1\"><span>Somente faturas retidas</span>\n</md-radio-button></div></div></md-radio-group></div><div layout=\"row\" layout-align=\"center center\" \nlayout-align-gt-sm=\"start center\" style=\"width: 100%\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaClientes\"></md-progress-circular><div layout=\"column\" \nlayout-align=\"center\" style=\"margin-left: 10px\" flex><multi-select-directive name=\"clientes\" id=\"vivaagua-clientes\" \nform-name=\"clientes\" data=\"vm.clientes\" model=\"vm.entidade.clientes\" descricao-exibicao=\"descricao\" \ntexto-pesquisa-placeholder=\"Pesquisar...\" texto-placeholder=\"Matrículas\" flex></multi-select-directive><span \nng-if=\"vm.clientes.length == 0\" class=\"nenhum-grupo\">Nenhum cliente encontrado.</span></div></div></div></fieldset>\n</div></fieldset><div layout=\"row\" flex layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent button-gerar-relatorio\" ng-if=\"vm.entidade.gerarManualmente\" \nng-disabled=\"vm.relatoriosVivaAguaForm.$invalid || (vm.entidade.gerarManualmente && (vm.clientes.length == 0 || vm.clientes == undefined))\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span translate=\"RELATORIOS.FATURAMENTO.GERAR\"></span></md-button><md-button \nclass=\"md-raised md-accent button-gerar-relatorio\" ng-if=\"vm.entidade.gerarViaArquivo\" \nng-disabled=\"vm.relatoriosVivaAguaForm.$invalid || !vm.arquivoBase64.length > 0\" \nng-click=\"vm.metodos.filtrarRelatorioPlanilha()\"><span>Filtrar</span></md-button></div></form></div>");
$templateCache.put("app/main/relatorios/viva-agua/views/viva-agua.html","<md-content id=\"vivaagua\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.VIVA_AGUA.TITULO\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\"></header-padrao>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_vivaagua\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/logs/views/logs-form.html","<md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" ng-show=\"vm.emProgresso\" ng-disabled=\"!vm.emProgresso\" \nflex=\"100\"></md-progress-linear><div class=\"md-background-bg md-whiteframe-1dp\" id=\"logs\"><form \nname=\"relatoriosLogsForm\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><fieldset class=\"standard\" flex \nlayout-align=\"center center\"><legend class=\"grp-legend\" translate=\"RELATORIOS.DATA_COLETA\"></legend><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><md-input-container class=\"input-container\"><label \nstyle=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_INICIAL\">Inicial</label><md-datepicker \nng-model=\"vm.entidade.dataInicio\" name=\"dataInicio\" ng-disabled=\"vm.emProgresso\" md-max-date=\"vm.entidade.dataFim\" \nng-mask=\"3?9/1?9/9999\" required mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"relatoriosLogsForm.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_FINAL\">Final</label>\n<md-datepicker ng-model=\"vm.entidade.dataFim\" name=\"dataFim\" ng-disabled=\"vm.emProgresso\" \nmd-min-date=\"vm.entidade.dataInicio\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"relatoriosLogsForm.dataFim.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><div layout=\"column\" flex><fieldset class=\"standard\"><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.LEITURISTA\"></legend><div layout=\"row\" flex layout-align=\"center center\">\n<multi-select-directive style=\"margin:0px;padding: 0px\" flex form-name=\"leiturista\" data=\"vm.leituristas\" \nmodel=\"vm.entidade.leiturista\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leiturista\"></div></fieldset></div><div \nlayout-gt-sm=\"column\" layout=\"row\" flex><fieldset class=\"standard\" flex layout-align=\"center center\"><legend \nclass=\"grp-legend\" translate=\"RELATORIOS.ORDENACAO\"></legend><div layout=\"row\" layout-gt-sm=\"column\" flex \nlayout-align=\"center center\"><md-radio-group ng-model=\"vm.entidade.ordenacao\" aria-activedescendant=\"radio_5\">\n<md-radio-button ng-value=\"1\" class=\"md-accent\" aria-checked=\"true\">Cronológica</md-radio-button><md-radio-button \nng-value=\"2\" class=\"md-accent\" aria-checked=\"false\">Cliente</md-radio-button></md-radio-group></div></fieldset></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex layout-align-gt-xs=\"center center\"><fieldset class=\"standard mt-10\" \nflex><div flex layout=\"row\" class=\"pt-10\" layout-align=\"center center\"><md-checkbox name=\"exibirGrafico\" \nng-model=\"vm.entidade.exibirGrafico\" aria-label=\"Exibir gráfico no relatorio\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\">\n<span translate=\"RELATORIOS.EXIBIRGRAFICO\">Exibir gráfico no relatório</span></md-checkbox></div></fieldset><fieldset \nclass=\"standard mt-10\" flex><div flex layout=\"row\" class=\"pt-10\" layout-align=\"center center\"><md-checkbox \nname=\"gerarRelatorioArquivoRemessa\" ng-model=\"vm.entidade.gerarRelatorioPorCarga\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" aria-label=\"Gerar relatorio arquivo remessa\"><span \ntranslate=\"RELATORIOS.LOGS.GERAR_RELATORIO_CARGA\">Gerar relatório por carga</span></md-checkbox></div></fieldset></div>\n<div layout=\"row\" flex layout-align=\"center center\"><md-input-container class=\"no-padding-and-margin\"><md-button \nclass=\"md-raised md-accent\" style=\"width: 100%\" \nng-disabled=\"relatoriosLogsForm.$invalid || vm.emProgresso || !vm.entidade.ordenacao\" \nng-click=\"vm.metodos.filtrarRelatorio()\"><span>Filtrar</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/relatorios/logs/views/logs.html","<div id=\"logsPage\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RELATORIOS.RELATORIO_LOGS\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"relatorios-form\"></div></div></div>");
$templateCache.put("app/main/relatorios/personalizado/views/personalizado-form.html","<div layout-padding id=\"personalizado-form\" class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular \nng-if=\"vm.emProgresso\" em-progresso=\"vm.emProgresso\" titulo=\"Gerando relatório...\"></carregamento-circular><form \nname=\"form\" novalidate><div layout=\"row\" style=\"justify-content: center\"><fieldset class=\"standard\" flex \nstyle=\"max-width: 98%; margin-top: 20px\"><legend class=\"grp-legend\" translate=\"Comando SQL\"></legend><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block pr-15\" style=\"margin: 18px 0px 0px 0px\" flex-gt-sm><label \ntranslate=\"Comando\"></label><textarea class=\"text-uppercase query\" max-rows=\"5\" ng-model=\"vm.query\" \nng-change=\"vm.metodos.verificarQuery()\" md-no-resize=\"true\" name=\"query\">\r\n          </textarea><div \nng-if=\"vm.queryInvalida\"><span style=\"font-size: small; color: red\">Não é permitido usar \' ; \'</span></div>\n</md-input-container><div class=\"pr-20\"><md-checkbox name=\"apenasPlanilha\" ng-model=\"vm.apenasPlanilha\" \naria-label=\"Mostrar dados leitura\"><span>Gerar apenas planilha</span></md-checkbox><md-input-container \nclass=\"no-padding-and-margin\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" \nng-disabled=\"form.$invalid || vm.emProgresso || vm.queryInvalida || vm.query == null || vm.query == \'\'\" \nng-click=\"vm.metodos.consultar()\"><span>Consultar</span></md-button></md-input-container></div></div></fieldset></div>\n</form><div layout=\"row\" ng-if=\"vm.dados != null && !vm.apenasPlanilha\" class=\"dados-exibicao\"><div layout=\"column\" \nclass=\"tabela\" ng-if=\"vm.dados != null\"><md-button ng-disabled=\"vm.form.$invalid || vm.dados == null\" \nclass=\"md-fab md-toolbar botao-flutuante\" ng-click=\"vm.metodos.gerarPlanilha(vm.dados.relatorioBase64)\" \naria-label=\"Exportar\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><label>Exportar planilha</label>\n</md-tooltip></md-button><table class=\"dataTable\" id=\"datatable-pendencia\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"coluna in vm.dados.colunas;\"><div class=\"table-header\"><span class=\"column-title text-center cabecalho\">\n{{ coluna }}</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.dados.registros\"><td class=\"text-center\" \nng-repeat=\"coluna in vm.dados.colunas\">{{ item[coluna] }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/relatorios/personalizado/views/personalizado.html","<md-content id=\"alertacliente\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Personalizado\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"relatorios-form@app.relatorios_personalizado\"></div></div></div></md-content>");
$templateCache.put("app/main/relatorios/visualizar/views/visualizar.html","<div id=\"relatorios\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><pdf src=\"vm.urlRelatorio\">\n</pdf></div><md-button aria-label=\"Voltar\" class=\"md-fab md-accent md-icon-button sample-show-hide botao-voltar\" \nonclick=\"window.history.go(-1)\"><md-icon md-font-icon=\"icon-undo s30\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/toolbar/dialogs/dialog-detalhamento-licencas/dialog-licencas-temporarias/dialog-licencas-temporarias.html","<md-dialog id=\"dialog-licenca-temporaria\" aria-label=\"Licença temporaria\" layout=\"column\" layout-align=\"space-between\" \nflex=\"100\"><form name=\"vm.licencaTemporariaForm\" novalidate><md-toolbar class=\"toolbar md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-accent\" layout=\"row\" layout-align=\"space-between center\"><h2>Cadastro de licença temporária\n</h2><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></div></md-toolbar><md-dialog-content class=\"pt-10 pb-15\" layout=\"column\" flex=\"100\"><div \nclass=\"campos-licenca-temporaria\" layout-gt-xs=\"column\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"TOOLBAR.INFORME_LICENCA\">Informe a licença que deseja cadastrar</label><input type=\"text\" name=\"licenca\" \nmascara-numero-generica=\"########\" mascara-tamanho-campo=\"8\" min=\"8\" ng-required=\"true\" \nng-model=\"vm.licencaTemporaria.licencaEquipamento\" \nng-change=\"vm.metodos.changeValidaCampoLicencaTemporaria(vm.licencaTemporaria.licencaEquipamento, vm.licencaTemporariaForm)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.licencaTemporariaForm.licenca.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaCaractereInicial\"><span>\nO número da licença deve iniciar com o código 1, que é o código destinado ao Reader</span></div><div \nng-message=\"validaQuantidadeCaracteresLicenca\"><span>O número da licença deve conter 8 caracteres</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TOOLBAR.INFORME_IMEI\">\nInforme o IMEI /Usuário do equipamento</label><input type=\"text\" name=\"imei\" mascara-tamanho-campo=\"25\" min=\"5\" \nng-required=\"true\" ng-model=\"vm.licencaTemporaria.imeiEquipamento\" \nng-change=\"vm.metodos.changeValidaCampoImei(vm.licencaTemporaria.imeiEquipamento, vm.licencaTemporariaForm)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                           !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.licencaTemporariaForm.imei.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaQuantidadeCaracteresImei\"><span>\nO número de IMEI deve conter no mínimo 5 caracteres</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.metodos.salvar()\" \nng-disabled=\"vm.licencaTemporariaForm.$invalid\" flex><span>Registrar</span></md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/toolbar/dialogs/dialog-detalhamento-licencas/views/dialog-detalhamento-licencas.html","<md-dialog id=\"dialog-detalhamento-licencas\" aria-label=\"Licenças\" layout=\"column\" layout-align=\"space-between\" \nflex=\"100\"><md-toolbar class=\"toolbar md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-accent\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Relação de licenças</h2><span flex></span><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"pesquisar\" layout=\"row\" layout-align=\"start center\" flex><label><md-icon \nclass=\"white-text icon search-icon\" md-font-icon=\"icon-magnify\" layout-align=\"center\"></md-icon></label><input \nid=\"pesquisar\" class=\"pesquisar-input\" type=\"text\" placeholder=\"Pesquisar\" translate ng-model=\"vm.pesquisar\" \nng-model-options=\"{debounce: 400}\" flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div></div></md-toolbar>\n<md-dialog-content class=\"pt-20 pb-0\" layout=\"column\" flex=\"100\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Buscando dados de licença\"></carregamento-circular><md-button \nclass=\"md-fab md-accent md-icon-button md-raised botao-dialog-licencas-temporarias\" aria-label=\"Licencas temporarias\" \nng-hide=\"vm.dados.temporariasDisponiveis <= 0\" ng-click=\"vm.metodos.abrirDialogLicencasTemporarias()\" \nng-if=\"vm.habilitaBotao\"><md-icon md-font-icon=\"icon-tablet-ipad s30\" md-direction=\"left\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Cadastrar licença temporária</md-tooltip></md-button><div class=\"container-tabela\" \nng-if=\"vm.dados\" layout=\"row\" flex=\"90\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\" style=\"width:100%\"><thead><th \nclass=\"secondary-text border-right border-left altura-cabecalho-tabela\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Licença</span></div></th><th \nclass=\"secondary-text border-right altura-cabecalho-tabela\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">IMEI/Usuário</span></div></th><th \nclass=\"secondary-text border-right altura-cabecalho-tabela\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leiturista</span></div></th><th \nclass=\"secondary-text border-right altura-cabecalho-tabela\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Data da última carga</span></div></th></thead><tbody><tr \nng-repeat=\"licenca in vm.dados.licencasPermanentes track by $index\"><td \nclass=\"text-center border-left border-right altura-linha\"><span>{{ licenca.numero }}</span></td><td \nclass=\"text-center border-right altura-linha\"><span>{{ licenca.usuario }}</span></td><td \nclass=\"text-center border-right altura-linha\"><span>{{ licenca.leiturista }}</span></td><td \nclass=\"text-center border-right altura-linha\"><span>{{ licenca.dataHoraUltimaCarga | date: \'dd/MM/yyyy HH:mm:ss\' }}\n</span></td></tr></tbody></table></div><div class=\"container-totalizadores\" ng-if=\"vm.dados\" layout=\"row\"><div \nclass=\"pr-10\" layout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 card-total-uso-disponivel white-fg\" layout=\"row\" flex=\"100\"><div class=\"totalizador\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-15\" style=\"text-align: center\">\nTotal de licenças em uso</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{ vm.dadosTotaisLicencas.quantidadeUtilizadas }}</div></div></ms-widget-front></ms-widget></div><div class=\"pr-10\" \nlayout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 card-total-uso-disponivel white-fg\" layout=\"row\" flex=\"100\"><div class=\"totalizador\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-15\" style=\"text-align: center\">\nTotal de licenças</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{ vm.dadosTotaisLicencas.quantidadeTotal }}</div></div></ms-widget-front></ms-widget></div><div class=\"pr-10\" \nlayout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"totalizador\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-15\" style=\"text-align: center\">\nTotal de licenças disponíveis</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{ vm.dadosTotaisLicencas.quantidadeDisponiveis }}</div></div></ms-widget-front></ms-widget></div><div class=\"pr-10\" \nlayout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"totalizador\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-15\" style=\"text-align: center\">\nTotal de licenças temporárias<md-button class=\"md-icon-button abrir-dialog-view-lic-temp\" \nng-click=\"vm.metodos.abrirDialogVisualizarLicencasTemporariasCadastradas()\" \nng-hide=\"vm.dados.licencasTemporarias <= 0\"><md-tooltip md-autohide><span class=\"font-size-13\">\nVisualizar licenças temporárias cadastradas</span></md-tooltip><md-icon class=\"s18\" md-font-icon=\"icon-open-in-new\">\n</md-icon></md-button></div><div class=\"font-size-16\" style=\"text-align: center\">{{ vm.dados.licencasTemporarias }}\n</div></div></ms-widget-front></ms-widget></div><div layout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"totalizador\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-15\" \nstyle=\"text-align: center\">Total de temporárias disponíveis para uso</div><div class=\"font-size-16\" \nstyle=\"text-align: center\">{{ vm.dados.temporariasDisponiveis }}</div></div></ms-widget-front></ms-widget></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/toolbar/dialogs/dialog-configuracao-smartphone/views/dialog-configuracao-smartphone.html","<md-dialog id=\"dialog-configuracao-smartphone\" class=\"dialogo-padrao\" aria-label=\"configuracaoSmartphone\" flex>\n<md-toolbar class=\"toolbar md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-accent\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"titulo\">Configuração do smartphone</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-0 pb-0\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\"><md-tabs class=\"config-abas\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Download\" md-active=\"vm.abaSelecionada === \'download\'\" md-on-select=\"vm.metodosAbas.abaselecionada(\'download\')\">\n<md-tab-label><label>Download versão</label></md-tab-label><md-tab-body><div class=\"corpo-tab\"><h3 \nclass=\"texto-qrcode mb-20\">Aponte a câmera para ler o QRCode</h3><qr text=\"vm.stringDownload\" size=\"150\" \nclass=\"qrcode\"></qr></div></md-tab-body></md-tab><md-tab label=\"Configuração\" \nmd-active=\"vm.abaSelecionada === \'configuracao\'\" md-on-select=\"vm.metodosAbas.abaselecionada(\'configuracao\')\">\n<md-tab-label><label>Configuração</label></md-tab-label><md-tab-body><h3 class=\"texto-qrcode mb-20\">\nAponte a câmera para ler o QRCode</h3><qr text=\"vm.string\" size=\"150\" class=\"qrcode\"></qr></md-tab-body></md-tab>\n</md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/toolbar/dialogs/dialog-detalhamento-licencas/dialog-visualizar-licencas-temporarias-cadastradas/dialog-visualizar-licencas-temporarias-cadastradas.html","<md-dialog id=\"dialog-visualizar-licenca-temporaria-cadastrada\" aria-label=\"Visualizar licença temporaria cadastrada\" \nlayout=\"column\" layout-align=\"space-between\" flex=\"100\"><md-toolbar class=\"toolbar md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-accent\" layout=\"row\" layout-align=\"space-between center\"><h2>\nLicenças temporárias cadastradas</h2><div layout=\"row\" layout-align=\"end center\"><div class=\"pesquisar\" layout=\"row\" \nlayout-align=\"start center\" flex><label><md-icon class=\"white-text icon search-icon\" md-font-icon=\"icon-magnify\" \nlayout-align=\"center\"></md-icon></label><input id=\"pesquisa\" class=\"pesquisar-input\" type=\"text\" \nplaceholder=\"Pesquisar\" translate ng-model=\"vm.pesquisar\" ng-model-options=\"{debounce: 400}\" flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content class=\"pt-20 pb-15\" layout=\"column\" flex=\"100\"><div \nng-if=\"vm.licencasTemporarias\" layout=\"row\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsLicencasTemporariasCadastradas\" dt-instance=\"vm.dtInstanceLicencasTemporariasCadastradas\">\n<thead><th class=\"secondary-text border-right border-left\"><div class=\"table-header\"><span \nclass=\"column-title text-center pb-5\">Licença</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center pb-5\">IMEI/Usuário</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center pb-5\">\nData de cadastro</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center pb-5\">Data de expiração</span></div></th></thead><tbody><tr \nng-repeat=\"licenca in vm.licencasTemporarias track by $index\" ng-class=\"{\'licencaTemporaria\' : licenca.estaVencido}\">\n<td class=\"text-center border-left border-right altura-linha\"><span>{{ licenca.numero }}</span></td><td \nclass=\"text-center border-right altura-linha\"><span>{{ licenca.usuario }}</span></td><td \nclass=\"text-center border-right altura-linha\"><span>{{ licenca.dataHoraCadastroLicencaTemporaria | date: \'dd/MM/yyyy\'}}\n</span></td><td class=\"text-center border-right altura-linha\"><span>\n{{ licenca.dataHoraVencimentoLicencaTemporaria | date: \'dd/MM/yyyy\' }}<md-tooltip md-autohide \nng-if=\"licenca.estaVencido\"><span class=\"font-size-13\">Esta licença está vencida</span></md-tooltip></span></td></tr>\n</tbody><tfoot><th colspan=\"4\" class=\"secondary-text border-right border-left\"><div class=\"blue-bg white-fg\">\nTotal de licenças temporárias cadastradas: {{ vm.licencasTemporarias.length }}</div></th></tfoot></table></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-botao-sidenav.html","<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodosControladores.metodoControladorAbrirSidenav()\" aria-label=\"Abrir Sidenav\"><md-icon \nmd-font-icon=\"icon-menu s30\"></md-icon></md-button></div>");
$templateCache.put("app/compartilhado/diretivas/pg-toolbar/componentes/sidenav/pg-toolbar-mobile-sidenav.html","<div class=\"h1\" layout=\"column\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><ng-include \nsrc=\"vm.htmlComponente.botaoNovaPesquisa\"></ng-include></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<ng-include src=\"vm.htmlComponente.botaoAtualizar\"></ng-include></div><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoInserir\"></ng-include></div><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoEditar\"></ng-include></div><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><ng-include src=\"vm.htmlComponente.botaoExcluir\"></ng-include>\n</div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><ng-include \nsrc=\"vm.htmlComponente.listarTodasEntidades\"></ng-include></div></div>");
$templateCache.put("app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidade=\"vm.motivoNaoEntrega\" entidades=\"vm.motivoNaoEntregas\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.motivoNaoEntrega)\" acao-editar=\"vm.metodos.editar(vm.motivoNaoEntrega)\" \nacao-excluir=\"vm.metodos.excluir(vm.motivoNaoEntrega)\" metodos-externos=\"vm.metodosExternosPgToolbar\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" campo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div \nclass=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label\n translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" id=\"cadastro-entrega-motivo-nao-entrega-numbercodigo\" \nname=\"codigo\" ng-model=\"vm.motivoNaoEntrega.codigo\" ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"4\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximocodigo\" \nentidade-codigo=\"vm.motivoNaoEntrega.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo>\n</div><md-input-container class=\"md-block\" flex flex-offset-gt-sm=\"5\"><label translate=\"RESOURCES.DESCRICAO\"></label>\n<input type=\"text\" name=\"descricao\" id=\"cadastro-entrega-motivo-nao-entrega-txtdescricao\" \nng-model=\"vm.motivoNaoEntrega.descricao\" mascara-tamanho-campo=\"40\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"40\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-entrega-motivo-nao-entrega-datatable-motivo-nao-entrega\" width=\"100%\"><thead><tr><th>Ação</th><th>Código\n</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/entrega/motivo-nao-entrega/views/motivo-nao-entrega.html","<div id=\"tipo-entrega\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.MOTIVO_NAO_ENTREGA\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"motivo-nao-entrega-form\"></div></div><div ui-view=\"motivo-nao-entrega-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/compartilhado/diretivas/toolbar-mobile-desktop/mobile/sidenav/sidenav.html","<div class=\"h1\" layout=\"column\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.editarAtivo ||vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisa\"><md-icon md-font-icon=\"icon-note-outline s30\"></md-icon>\n</md-button><md-button \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.editarAtivo ||vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.novaPesquisa()\" aria-label=\"Pesquisa\"><span translate=\"TOOLBAR.NOVA_PESQUISA\" class=\"h3\">\nNova Pesquisa</span></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.ngOcultaBotaoInserir\"><md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.inserir}\" \nng-disabled=\"vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.inserir(vm.cliente)\" aria-label=\"Inserir\"><md-icon md-font-icon=\"icon-plus s30\"></md-icon>\n</md-button><md-button ng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.inserir}\' \nng-disabled=\"vm.controlador.editarAtivo || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.inserir(vm.entidade)\" aria-label=\"Inserir\"><span class=\"h3\" translate=\"TOOLBAR.INSERIR\">Inserir\n</span></md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.ngOcultaBotaoEditar\">\n<md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.editar}\" \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil s30\"></md-icon>\n</md-button><md-button ng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.editar}\' \nng-disabled=\"vm.entidade === null || !vm.controlador.pesquisaAtiva\r\n    || vm.controlador.novaEntidade || vm.controlador.listarTodasEntidades\" \nng-click=\"vm.toolbar.editar(vm.entidade)\" aria-label=\"Editar\"><span class=\"h3\" translate=\"TOOLBAR.EDITAR\">Editar</span>\n</md-button></div><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-class=\"{\'selecionado\': vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\" \nng-disabled=\"vm.entidades === null || vm.controlador.novaEntidade\r\n                                || vm.controlador.editarAtivo\" \naria-label=\"Listar Todos\"><md-icon md-font-icon=\"icon-format-list-bulleted s30\"></md-icon></md-button><md-button \nclass=\"texto-secundario\" \nng-class=\'{\"selecionado\": vm.buttonSelecionado === vm.controleButtonSelecionado.listarTodasEntidades}\' \nng-disabled=\"vm.entidades === null || vm.controlador.novaEntidade || vm.controlador.editarAtivo\" \nng-click=\"vm.toolbar.listarTodasEntidades()\" aria-label=\"Listar Todos\"><span class=\"h4\" \ntranslate=\"TOOLBAR.ALTERAR_EXIBICAO\">Alterar Exibição</span></md-button></div></div>");
$templateCache.put("app/main/cadastros/cronogramagrupos/views/CAEMA/cronograma-grupo-form-caema.html","<div id=\"cronograma-grupos-form\"><form name=\"cronogramaGruposForm\" novalidate><pg-toolbar entidades=\"vm.cronogramas\" \nentidade=\"vm.cronograma\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-pre-loader=\"controladorPreLoader\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.cronograma)\" acao-editar=\"vm.metodos.editar(vm.cronograma)\" \nacao-excluir=\"vm.metodos.excluir(vm.cronograma.codigo)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \npre-definir-campos-para-insercao=\"vm.metodos.preDefinirCamposInsercao()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex=\"100\" \nng-if=\"!(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\"><div flex-gt-sm=\"20\" flex=\"100\" layout=\"row\">\n<md-input-container flex=\"100\"><label translate=\"RESOURCES.CODIGO\">Código</label><input type=\"text\" name=\"codigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva\" ng-model=\"vm.cronograma.codigo\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"100\"><div layout=\"row\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaRegional\"></md-progress-circular><md-input-container \nclass=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.LOCALIDADE\"></label><md-select \nng-model=\"vm.cronograma.regional\" flex md-on-open=\"vm.metodos.configuraMdSelectRegional()\" name=\"regional\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar localidade..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma localidade encontrada.\n</span><div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><fieldset \nlayout=\"column\" flex=\"100\"><legend class=\"grp-legend\">Informações do grupo</legend><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\"><md-input-container flex-gt-sm flex=\"100\"><label translate=\"RESOURCES.MES\"></label><input\n type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" validacao-mes \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.cronograma.mes\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\"><div \nng-messages=\"cronogramaGruposForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-sm flex=\"100\">\n<label translate=\"RESOURCES.ANO\"></label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.cronograma.ano\"><div ng-messages=\"cronogramaGruposForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm \nflex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><input type=\"text\" name=\"grupo\" \nmascara-numero-generica=\"####\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" minlength=\"4\" ng-model=\"vm.cronograma.grupo\">\n<div ng-messages=\"cronogramaGruposForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"minlength\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MINIMO_4_DIGITOS\">Grupo deve conter 4 dígitos</div></div></md-input-container>\n</div></fieldset><fieldset layout=\"column\" flex=\"100\"><legend class=\"grp-legend\">Datas</legend><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\"><md-input-container flex-gt-sm=\"25\" flex=\"100\"><label translate=\"RESOURCES.DATA_INICIO\">\n</label><md-datepicker name=\"dataInicio\" ng-mask=\"3?9/1?9/9999\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-conversor-string-para-data md-max-date=\"vm.cronograma.dataFim\" ng-model=\"vm.cronograma.dataInicio\">\n</md-datepicker><div ng-messages=\"cronogramaGruposForm.dataInicio.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-sm=\"25\" \nflex=\"100\"><label translate=\"RESOURCES.DATA_FIM\"></label><md-datepicker ng-mask=\"3?9/1?9/9999\" name=\"dataFim\" \nmascara-conversor-string-para-data \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" md-min-date=\"vm.cronograma.dataInicio\" \nng-model=\"vm.cronograma.dataFim\"></md-datepicker><div ng-messages=\"cronogramaGruposForm.dataFim.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></md-content>\n</form></div>");
$templateCache.put("app/main/cadastros/entrega/tipo-entrega/views/tipo-entrega-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.tipoEntrega\" \nentidades=\"vm.tipoEntregas\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.tipoEntrega)\" \nacao-editar=\"vm.metodos.editar(vm.tipoEntrega)\" acao-excluir=\"vm.metodos.excluir(vm.tipoEntrega)\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.tipoEntrega.codigo\" ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"4\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximocodigo\" \nentidade-codigo=\"vm.tipoEntrega.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex-gt-sm=\"40\" flex-offset-gt-sm=\"5\"><label translate=\"RESOURCES.DESCRICAO\">\n</label><input type=\"text\" name=\"descricao\" id=\"cadastro-entrega-tipo-entrega-txtdescricao\" \nng-model=\"vm.tipoEntrega.descricao\" mascara-tamanho-campo=\"40\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"40\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox \nname=\"permiteRecadastramento\" id=\"cadastro-entrega-tipo-entrega-chkPermiteRecadastramento\" \nng-model=\"vm.tipoEntrega.permiteRecadastramento\" aria-label=\"Permite recadastramento\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.PERMITIR_RECADASTRAMENTO\">Permitir recadastramento</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\"><md-checkbox name=\"preSelecionaColetor\" \nng-model=\"vm.tipoEntrega.preSelecionadoColetor\" aria-label=\"Pré selecionar tipo de entrega no coletor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nPré selecionar tipo de entrega no coletor</span></md-checkbox></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/cadastros/entrega/tipo-entrega/views/tipo-entrega.html","<div id=\"tipo-entrega\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.TIPO_ENTREGA\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"tipo-entrega-form\"></div></div><div ui-view=\"tipo-entregas-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/entrega/tipo-entrega/views/tipo-entregas-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-entrega-tipo-entrega-datatable-tipo-entrega\" width=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>\nDescrição</th><th>Permite Recadastramento</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/localizacao/regionais/views/regional-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate autocomplete=\"off\"><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.regionais\" \nentidade=\"vm.regional\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.regional)\" \nacao-editar=\"vm.metodos.editar(vm.regional)\" acao-excluir=\"vm.metodos.excluir(vm.regional)\" \npre-definir-campos-para-insercao=\"vm.metodos.inicializarCampos()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<div layout-gt-sm=\"row\"><div layout=\"row\" flex-gt-sm=\"20\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"REGIONAL.CODIGO\"></label><input type=\"text\" ng-model=\"vm.regional.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" \nentidade-codigo=\"vm.regional.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex><label translate=\"REGIONAL.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.regional.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox name=\"inativo\" \nid=\"cadastros-regional-chkinativo\" ng-model=\"vm.regional.ativo\" aria-label=\"Ativo\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.ATIVO\">Ativo</span></md-checkbox></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/localizacao/regionais/views/regional-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"regional-datatable\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descricao</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/localizacao/regionais/views/regional.html","<div id=\"colaborador\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"REGIONAL.TITULO\" ng-utiliza-pesquisa=\"false\" icone=\"icon-library-books\"></header-padrao><div \nclass=\"content\"><div ui-view=\"regional-form\"></div></div><div ui-view=\"regional-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/localizacao/agrupamentos/views/agrupamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate autocomplete=\"off\"><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.agrupamentos\" \nentidade=\"vm.agrupamento\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.agrupamento)\" \nacao-editar=\"vm.metodos.editar(vm.agrupamento)\" pre-definir-campos-para-insercao=\"vm.metodos.inicializarCampos()\" \ndesabilitar-botao-excluir=\"true\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout-gt-sm=\"row\"><div \nlayout=\"row\" flex-gt-sm=\"20\" flex><md-input-container class=\"md-block\" flex><label translate=\"AGRUPAMENTO.CODIGO\">\n</label><input type=\"text\" ng-model=\"vm.agrupamento.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rotaProximoCodigo\" \nentidade-codigo=\"vm.agrupamento.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex><label translate=\"AGRUPAMENTO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.agrupamento.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox name=\"inativo\" \nid=\"cadastros-regional-chkinativo\" ng-model=\"vm.agrupamento.ativo\" aria-label=\"Ativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.ATIVO\">Ativo</span></md-checkbox></md-input-container></div><fieldset aria-label=\"FTP\" \nlayout-margin=\"10px\" \nng-if=\"vm.parametros.utilizaImportacaoLeituraViaFtp || vm.parametros.empresa.codigoImanager == \'0070\'\"><legend \nclass=\"grp-legend\">Informações do FTP</legend><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-sm=\"60\"><label translate=\"AGRUPAMENTO.ENDERECO\"></label><input type=\"text\" \nng-model=\"vm.agrupamento.ftpEndereco\" name=\"ftpEndereco\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpEndereco.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"RESOURCES.PROTOCOLO\">\n</label><md-select name=\"protocolo\" id=\"slctProtocolo\" ng-model=\"vm.agrupamento.protocolo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" id=\"slctProtocolo-options-{{$index}}\" ng-repeat=\"(key, value) in vm.protocolos\">{{value}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-sm=\"20\"><label \ntranslate=\"AGRUPAMENTO.PORTA\">Porta FTP</label><input type=\"text\" ng-model=\"vm.agrupamento.ftpPorta\" name=\"ftpPorta\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpPorta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><div flex-gt-sm=\"70\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"AGRUPAMENTO.USUARIO\">Usuário</label><input \ntype=\"text\" ng-model=\"vm.agrupamento.ftpUsuario\" name=\"ftpUsuario\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nautocomplete=\"new-password\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpUsuario.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"AGRUPAMENTO.SENHA\">\nSenha</label><input type=\"password\" ng-model=\"vm.agrupamento.ftpSenha\" name=\"ftpSenha\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nautocomplete=\"new-password\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpSenha.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div flex-gt-sm=\"30\" flex=\"100\" class=\"radio-group-ftp\"><legend \nclass=\"grp-legend\">Modo FTP</legend><md-radio-group aria-label=\"Modo FTP\" layout-align=\"start center\" layout=\"row\" \nng-model=\"vm.agrupamento.ftpModoAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-radio-button ng-value=\"true\">Ativo</md-radio-button><md-radio-button ng-value=\"false\">Passivo</md-radio-button>\n</md-radio-group></div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label \ntranslate=\"AGRUPAMENTO.DIRETORIO_IMPORTACAO\">Diretório de importação</label><input type=\"text\" \nname=\"ftpDiretorioImportacao\" ng-model=\"vm.agrupamento.ftpDiretorioImportacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" mascara-tamanho-campo=\"100\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpDiretorioImportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\" flex-gt-sm=\"50\"><label translate=\"AGRUPAMENTO.DIRETORIO_EXPORTACAO\">Diretório exportação</label><input \ntype=\"text\" ng-model=\"vm.agrupamento.ftpDiretorioExportacao\" name=\"ftpDiretorioExportacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" mascara-tamanho-campo=\"100\" \nmd-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpDiretorioExportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-sm=\"50\"><label translate=\"AGRUPAMENTO.DIRETORIO_FOTOS\"></label>\n<input type=\"text\" name=\"ftpDiretorioFotos\" ng-model=\"vm.agrupamento.ftpDiretorioFotos\" \nng-required=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.parametros.calculo.tipoDetalheCalculo == 88\" \nmascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.ftpDiretorioFotos.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-offset=\"5\"><md-checkbox name=\"servidorWindows\" id=\"cadastros-regional-chkservidorWindows\" \nng-model=\"vm.agrupamento.ftpServidorWindows\" aria-label=\"Servidor Windows\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.SERVIDOR_WINDOWS\">Servidor Windows</span></md-checkbox></md-input-container></div></fieldset>\n</md-content></form></div>");
$templateCache.put("app/main/cadastros/localizacao/agrupamentos/views/agrupamento-table.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"agrupamento-datatable\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descricao</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/localizacao/agrupamentos/views/agrupamento.html","<div id=\"agrupamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"AGRUPAMENTO.AGRUPAMENTO\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" \nng-utiliza-pesquisa=\"false\" icone=\"icon-library-books\"></header-padrao><header-padrao \ntranslate-nome=\"AGRUPAMENTO.LOCALIDADE\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" \nng-utiliza-pesquisa=\"false\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"agrupamento-form\"></div></div><div ui-view=\"agrupamento-table\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/cadastros/localizacao/municipios/views/municipio-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.municipios\" \nentidade=\"vm.municipio\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.municipio)\" \npre-definir-campos-para-insercao=\"vm.metodos.inicializarCampos()\" acao-editar=\"vm.metodos.editar(vm.municipio)\" \nacao-excluir=\"vm.metodos.excluir(vm.municipio)\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout-gt-sm=\"row\"><div \nlayout=\"row\" flex-gt-sm=\"20\" flex><md-input-container class=\"md-block\" flex><label translate=\"MUNICIPIO.CODIGO\">\n</label><input type=\"text\" ng-model=\"vm.municipio.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" \nentidade-codigo=\"vm.municipio.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex><label translate=\"MUNICIPIO.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.municipio.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox name=\"inativo\" \nid=\"cadastros-municipio-chkinativo\" ng-model=\"vm.municipio.ativo\" aria-label=\"Ativo\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.ATIVO\">Ativo</span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"MUNICIPIO.LOCALIZACAO\"></label><input type=\"text\" \nng-model=\"vm.municipio.localizacao\" name=\"localizacao\" mascara-tamanho-campo=\"10\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"10\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.localizacao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.parametros.utilizaCadastroRegional\" \nflex-gt-sm=\"25\" flex><label ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" translate=\"RESOURCES.REGIONAL\">\n</label><label ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" translate=\"MUNICIPIO.LOCALIDADE\"></label>\n<md-select name=\"regional\" id=\"cadastros-municipio-slcregional\" ng-model=\"vm.municipio.agrupamento\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regiao.codigo\" ng-repeat=\"regiao in vm.regioes\">{{regiao.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/localizacao/municipios/views/municipio-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"municipio-datatable\" width=\"100%\"><thead><tr><th>\nAção</th><th>Código</th><th>Descricao</th><th>Localização</th><th>Regional</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/localizacao/municipios/views/municipio.html","<div id=\"colaborador\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"MUNICIPIO.TITULO\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" ng-utiliza-pesquisa=\"false\" \nicone=\"icon-library-books\"></header-padrao><header-padrao translate-nome=\"MUNICIPIO.SETOR\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" ng-utiliza-pesquisa=\"false\" icone=\"icon-library-books\">\n</header-padrao><div class=\"content\"><div ui-view=\"municipio-form\"></div></div><div ui-view=\"municipio-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate autocomplete=\"off\"><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.boletos\" \nentidade=\"vm.boleto\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.boleto)\" \nacao-editar=\"vm.metodos.editar(vm.boleto)\" acao-excluir=\"vm.metodos.excluir(vm.boleto)\" \npre-definir-campos-para-insercao=\"vm.metodos.inicializarCampos()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<div layout-gt-xs=\"row\" flex><div layout=\"row\" flex-gt-sm=\"20\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"BOLETO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.boleto.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo)\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" \nentidade-codigo=\"vm.boleto.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div></div>\n<div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"BOLETO.CEDENTE\">\n</label><input type=\"text\" ng-model=\"vm.boleto.cedente\" name=\"cedente\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cedente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"BOLETO.CNPJ_CEDENTE\">\n</label><input type=\"text\" ng-model=\"vm.boleto.cnpjCedente\" name=\"cnpjCedente\" mascara-tamanho-campo=\"18\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"18\" \nmascara-numero-generica=\"##.###.###/####-##\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cnpjCedente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label \ntranslate=\"BOLETO.AGENCIA_CODIGO\"></label><input type=\"text\" ng-model=\"vm.boleto.agenciaCodigoCedente\" \nname=\"agenciaCodigoCedente\" mascara-tamanho-campo=\"30\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"30\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.agenciaCodigoCedente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"BOLETO.ACEITE\"></label><input type=\"text\" \nng-model=\"vm.boleto.aceite\" name=\"aceite\" mascara-tamanho-campo=\"1\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"1\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.aceite.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label \ntranslate=\"BOLETO.LOCAL_PAGAMENTO\"></label><input type=\"text\" ng-model=\"vm.boleto.localPagamento\" \nname=\"localPagamento\" mascara-tamanho-campo=\"80\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"80\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.localPagamento.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block\"><label translate=\"BOLETO.ESPECIE\"></label><input type=\"text\" \nng-model=\"vm.boleto.especie\" name=\"especie\" mascara-tamanho-campo=\"2\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"2\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.especie.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"BOLETO.ESPECIE_DOCUMENTO\">\n</label><md-select name=\"eDocCodigo\" id=\"cadastros-boleto-slcespecie\" ng-model=\"vm.boleto.eDocCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"especie.codigo\" ng-repeat=\"especie in vm.especies\">{{especie.sigla}}</md-option></md-select><div \nng-messages=\"vm.form.eDocCodigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"BOLETO.CARTEIRA\"></label>\n<input type=\"text\" ng-model=\"vm.boleto.carteira\" name=\"carteira\" mascara-tamanho-campo=\"6\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"6\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.carteira.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Variação carteira</label><input \ntype=\"text\" ng-model=\"vm.boleto.variacaoCarteira\" name=\"variacaoCarteira\" mascara-tamanho-campo=\"6\" \nng-required=\"false\" md-maxlength=\"6\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.variacaoCarteira.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"BOLETO.INSTRUCOES\"></label>\n<textarea ng-model=\"vm.boleto.instrucoes\" id=\"cadastro-boleto-txtInstrucoes\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoConsumoAlterado($event)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" name=\"instrucoes\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n          </textarea><div ng-messages=\"vm.form.instrucoes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"boleto-datatable\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Cedente</th><th>CNPJ</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/relacionados/boleto-bancario/views/boleto-bancario.html","<div id=\"boleto\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"BOLETO.TITULO\" \nng-utiliza-pesquisa=\"false\" icone=\"icon-account\"></header-padrao><div class=\"content\"><div \nui-view=\"boleto-bancario-form\"></div></div><div ui-view=\"boleto-bancario-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/arquivo/views/cadastro-arquivo-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.arquivos\" \nentidade=\"vm.arquivo\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.arquivo)\" \nacao-editar=\"vm.metodos.editar(vm.arquivo)\" acao-excluir=\"vm.metodos.excluir(vm.arquivo)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\"></pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" \nid=\"cadastro-relacionados-arquivo-numbercodigo\" name=\"codigo\" ng-model=\"vm.arquivo.codigo\" ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"4\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.arquivo.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex \nflex-offset-gt-sm=\"5\"><label translate=\"RESOURCES.DESCRICAO\"></label><input type=\"text\" name=\"descricao\" \nid=\"cadastro-relacionados-arquivo-txtdescricao\" ng-model=\"vm.arquivo.descricao\" mascara-tamanho-campo=\"30\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"30\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.OBSERVACAO\"></label><input type=\"text\" name=\"observacao\" \nid=\"cadastro-relacionados-arquivo-txtobservacao\" ng-model=\"vm.arquivo.observacao\" mascara-tamanho-campo=\"50\" \nmd-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/arquivo/views/cadastro-arquivo.html","<div id=\"cadastro-arquivo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.ARQUIVO\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"cadastro-arquivo-form\"></div></div><div ui-view=\"cadastro-arquivos-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/arquivo/views/cadastro-arquivos-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-relacionados-arquivo-datatable-arquivos\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Descrição</th><th>Observação</th></tr></thead></table></div>\n</div>");
$templateCache.put("app/main/cadastros/relacionados/especie-documento/views/especie-documento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate autocomplete=\"off\"><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.especies\" \nentidade=\"vm.especie\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.especie)\" \nacao-editar=\"vm.metodos.editar(vm.especie)\" acao-excluir=\"vm.metodos.excluir(vm.especie)\" \npre-definir-campos-para-insercao=\"vm.metodos.inicializarCampos()\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<div layout-gt-sm=\"row\"><div layout=\"row\" flex-gt-sm=\"20\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"ESPECIE_DOCUMENTO.CODIGO\"></label><input type=\"text\" ng-model=\"vm.especie.codigo\" name=\"codigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo)\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota.proximoCodigo\" \nentidade-codigo=\"vm.especie.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div>\n<md-input-container class=\"md-block\" flex-gt-sm=\"60\"><label translate=\"ESPECIE_DOCUMENTO.DESCRICAO\"></label><input \ntype=\"text\" ng-model=\"vm.especie.descricao\" name=\"descricao\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"ESPECIE_DOCUMENTO.SIGLA\">\n</label><input type=\"text\" ng-model=\"vm.especie.sigla\" name=\"sigla\" mascara-tamanho-campo=\"6\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"6\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.sigla.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/especie-documento/views/especie-documento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"especie-datatable\" width=\"100%\"><thead><tr><th>Ação\n</th><th>Código</th><th>Descrição</th><th>Sigla</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/relacionados/especie-documento/views/especie-documento.html","<div id=\"especie\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"ESPECIE_DOCUMENTO.TITULO\" ng-utiliza-pesquisa=\"false\" icone=\"icon-account\"></header-padrao><div \nclass=\"content\"><div ui-view=\"especie-documento-form\"></div></div><div ui-view=\"especie-documento-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/impressora/views/impressora-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidades=\"vm.impressoras\" \nentidade=\"vm.impressora\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.impressora)\" \nacao-editar=\"vm.metodos.editar(vm.impressora)\" acao-excluir=\"vm.metodos.excluir(vm.impressora)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" \nid=\"cadastro-relacionados-impressora-numbercodigo\" name=\"codigo\" ng-model=\"vm.impressora.codigo\" ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"4\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.impressora.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.DESCRICAO\"></label><input type=\"text\" \nname=\"descricao\" id=\"cadastro-relacionados-impressora-txtdescricao\" ng-model=\"vm.impressora.descricao\" \nmascara-tamanho-campo=\"50\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><div layout=\"row\" flex-offset=\"5\" layout-align=\"center center\"><div \nclass=\"md-subheader\"><span style=\"color: #039be5\" translate=\"RESOURCES.MENSAGEM_PARTICULARIDADES_ZEBRA\"></span></div>\n</div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mt-30-xs\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.CONEXAO\">Conexão</label><md-select name=\"conexao\" \nid=\"cadastro-relacionados-impressora-slctConexao\" ng-model=\"vm.impressora.conexao\" \nng-change=\"vm.metodos.alterarConexao(vm.impressora.conexao)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"value\" id=\"cadastro-relacionados-impressora-slctConexao-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.conexoes\">{{key}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mt-20-xs\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.LAYOUT_FATURA_ZEBRA\">Layout fatura (Zebra)\n</label><md-select name=\"layoutFaturaZebra\" id=\"cadastro-relacionados-impressora-slctLayoutFaturaZebra\" \nng-model=\"vm.impressora.layoutFaturaZebra\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo && vm.regex.test(vm.impressora.descricao.toLowerCase())\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                    || vm.impressora.conexao == 02 || !vm.regex.test(vm.impressora.descricao.toLowerCase())\">\n<md-option ng-value=\"value\" id=\"cadastro-relacionados-impressora-slctLayoutFaturaZebra-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.layoutsFaturaZebra\">{{key}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block mt-30-xs\" flex-gt-sm=\"20\"><label translate=\"RESOURCES.METODO_IMPRESSAO_ZEBRA\">\nMétodo de impressão (Zebra)</label><md-select name=\"metodoImpressaoZebra\" \nid=\"cadastro-relacionados-impressora-slctMetodoImpressaoZebra\" ng-model=\"vm.impressora.metodoImpressaoZebra\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo && vm.regex.test(vm.impressora.descricao.toLowerCase())\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                    || vm.impressora.conexao == 02 || !vm.regex.test(vm.impressora.descricao.toLowerCase())\">\n<md-option ng-value=\"value\" id=\"cadastro-relacionados-impressora-slctMetodoImpressaoZebra-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.metodosImpressao\">{{key}}</md-option></md-select></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm><md-checkbox name=\"exibeMensagemPreparacaoImpressao\" \nid=\"cadastro-relacionados-impressora-chkexibEMensagemPreparacaoImpressao\" \nng-model=\"vm.impressora.exibeMensagemPreparaImpressao\" aria-label=\"Exibe mensagem de preparação de impressão\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                     || vm.impressora.conexao == 02\">\n<span translate=\"RESOURCES.EXIBIR_MENSAGEM_PREPARACAO_IMPRESSAO\">Exibir mensagem de preparação de impressão</span>\n</md-checkbox></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.OBSERVACAO\"></label><input type=\"text\" name=\"observacao\" \nid=\"cadastro-relacionados-impressora-txtobservacao\" ng-model=\"vm.impressora.observacao\" mascara-tamanho-campo=\"50\" \nmd-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/impressora/views/impressora.html","<div id=\"impressora\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.IMPRESSORA\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"impressora-form\"></div></div><div ui-view=\"impressoras-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/cadastros/relacionados/impressora/views/impressoras-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-relacionados-impressora-datatable-impressoras\" width=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>\nDescrição</th><th>Conexao</th><th>Layout Fatura Zebra</th><th>Metodo Impressao Zebra</th><th>Observação</th></tr>\n</thead></table></div></div>");
$templateCache.put("app/main/cadastros/relacionados/equipamento/views/equipamento-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.equipamento\" \nentidades=\"vm.equipamentos\" entidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.equipamento)\" \nacao-editar=\"vm.metodos.editar(vm.equipamento)\" acao-excluir=\"vm.metodos.excluir(vm.equipamento)\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao()\">\n</pg-toolbar><md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" \nng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" \nid=\"cadastro-relacionados-equipamento-numbercodigo\" name=\"codigo\" ng-model=\"vm.equipamento.codigo\" ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"4\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.equipamento.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" flex \nflex-offset-gt-sm=\"5\"><label translate=\"RESOURCES.DESCRICAO\"></label><input type=\"text\" name=\"descricao\" \nid=\"cadastro-relacionados-equipamento-txtdescricao\" ng-model=\"vm.equipamento.descricao\" mascara-tamanho-campo=\"30\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"30\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><fieldset class=\"standard\" flex-gt-sm=\"50\">\n<md-checkbox name=\"possuiTecladoFisico\" id=\"cadastro-relacionados-equipamento-chkUtilizaTecladoFisico\" \nng-model=\"vm.equipamento.possuiTecladoFisico\" aria-label=\"Utiliza teclado físico\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_TECLADO_FISICO\">Utilizar teclado físico</span></md-checkbox><div class=\"group-checkbox\" \nflex=\"100\" ng-if=\"vm.equipamento.possuiTecladoFisico == \'S\'\"><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.TIPO_UTILIZACAO_TECLADO_FISICO\"></label><md-select \nname=\"tipoUsoTecladoFisico\" id=\"cadastro-relacionados-equipamento-slctTipoUsoTecladoFisico\" \nng-model=\"vm.equipamento.tipoUsoTecladoFisico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" id=\"cadastro-relacionados-equipamento-slctTipoUsoTecladoFisico-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.tiposTeclado\">{{value}}</md-option></md-select><div \nng-messages=\"vm.form.tipoUsoTecladoFisico.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></fieldset><fieldset \nclass=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaTimerImpressaoFoto\" \nid=\"cadastro-relacionados-equipamento-chkUtilizaTimerImpressaoFoto\" \nng-model=\"vm.equipamento.utilizaTimerImpressaoFoto\" aria-label=\"Utiliza timer na impressão de foto\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_TIMER_IMPRESSAO_FOTO\">Utilizar timer na impresão de foto</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.equipamento.utilizaTimerImpressaoFoto == \'S\'\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.TIMER_IMPRESSAO_FOTO\">\n</label><input type=\"text\" ng-model=\"vm.equipamento.timerImpressaoFoto\" ui-number-mask=\"0\" ui-hide-group-sep \nname=\"timerImpressaoFoto\" id=\"cadastro-relacionados-equipamento-txtTimerImpressaoFoto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.equipamento.utilizaTimerImpressaoFoto == \'S\'\" \nmascara-tamanho-campo=\"6\"><div ng-messages=\"vm.form.timerImpressaoFoto.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></fieldset></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"35\"><label translate=\"RESOURCES.SISTEMA_OPERACIONAL\">\n</label><md-select name=\"sistemaOperacional\" id=\"cadastro-relacionados-equipamento-slctSistemaOperacional\" \nng-model=\"vm.equipamento.sistemaOperacional\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" id=\"cadastro-relacionados-equipamento-slctSistemaOperacional-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.sistemasOperacionais\">{{value}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"35\"><label translate=\"RESOURCES.TIPO_CAMERA\"></label><md-select \nname=\"tipoCamera\" id=\"cadastro-relacionados-equipamento-slctTipoCamera\" ng-model=\"vm.equipamento.tipoCamera\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"key\" id=\"cadastro-relacionados-equipamento-slctTipoCamera-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.tiposCamera\">{{value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"RESOURCES.TIMER\"></label><input type=\"text\" \nng-model=\"vm.equipamento.timer\" ui-number-mask=\"0\" ui-hide-group-sep name=\"timer\" \nid=\"cadastro-relacionados-equipamento-txtTimer\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"6\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs=\"20\"><md-checkbox name=\"utilizaPareamentoInterno\" \nid=\"cadastro-relacionados-equipamento-chkUtilizaPareamentoInterno\" ng-model=\"vm.equipamento.utilizaPareamentoInterno\" \naria-label=\"Utiliza pareamento interno\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_PAREAMENTO_INTERNO\">Utilizar pareamento interno</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs><md-checkbox name=\"possuiLeitorBarras\" \nid=\"cadastro-relacionados-equipamento-chkPossuiLeitorBarras\" ng-model=\"vm.equipamento.possuiLeitorBarras\" \naria-label=\"Leitor de código de barras\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.LEITOR_CODIGO_BARRAS\">Leitor de código barras</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs=\"5\"><md-checkbox name=\"possuiGps\" \nid=\"cadastro-relacionados-equipamento-chkPossuiGps\" ng-model=\"vm.equipamento.possuiGps\" aria-label=\"GPS\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.GPS\">GPS</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"25\"><md-checkbox name=\"utilizaPosicionamentoEspecial\" \nid=\"cadastro-relacionados-equipamento-chkUtilizaPosicionamentoEspecial\" \nng-model=\"vm.equipamento.utilizaPosicionamentoEspecial\" aria-label=\"Utilizar Posicionamento Especial\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_POSICIONAMENTO_ESPECIAL\">Utilizar posicionamento especial</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"25\"><md-checkbox \nname=\"utilizaModoTelefoneAutomatico\" id=\"cadastro-relacionados-equipamento-chkUtilizaModoTelefoneAutomatico\" \nng-model=\"vm.equipamento.utilizaModoTelefoneAutomatico\" aria-label=\"Utiliza modo telefone automático\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTLIZAR_MODO_TELEFONE_AUTOMATICO\">Utilizar modo telefone automático</span></md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.DIRETORIO_ARMAZENAMENTO_INTERNO\"></label><input type=\"text\" name=\"diretorioArmazenamentoInterno\" \nid=\"cadastro-relacionados-equipamento-txtDiretorioArmazenamentoInterno\" \nng-model=\"vm.equipamento.diretorioArmazenamentoInterno\" mascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-required=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.equipamento.sistemaOperacional == 2\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.diretorioArmazenamentoInterno.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.OBSERVACAO\"></label><input type=\"text\" \nname=\"observacao\" id=\"cadastro-relacionados-equipamento-txtobservacao\" ng-model=\"vm.equipamento.observacao\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/equipamento/views/equipamento-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-relacionados-equipamento-datatable-equipamento\" width=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>\nDescrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/relacionados/equipamento/views/equipamento.html","<div id=\"equipamento\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.EQUIPAMENTO\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"equipamento-form\"></div></div><div ui-view=\"equipamentos-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\">\n</div></div>");
$templateCache.put("app/main/cadastros/relacionados/pagamento-pix/views/pagamento-pix-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar entidade=\"vm.pagamentoPix\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" controlador-toolbar=\"vm.controleForm\" \ncontrolador-pre-loader=\"vm.controladorPreLoader\" acao-editar=\"vm.metodos.editar(vm.pagamentoPix)\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \ncampo-pesquisar=\"vm.pesquisar\" pre-definir-campos-para-insercao=\"vm.metodos.predefinirCamposParaInsercao()\" \niniciar-habilitando-modo-pesquisa=\"true\" metodo-externo-acao-reverter=\"vm.metodos.redefinir(vm.pagamentoPix)\" \nesconder-botao-pesquisar=\"true\" esconder-botao-excluir=\"true\" esconder-botao-inserir=\"true\" \nesconder-mensagem-status=\"true\" esconder-botao-primeira=\"true\" esconder-botao-ultima=\"true\" \nesconder-botao-proxima=\"true\" esconder-botao-anterior=\"true\" escoder-texto-informativo-quantidade=\"true\" \nesconder-botao-listar-todas-entidades=\"true\" esconder-botao-nova-pesquisa=\"true\" esconder-botao-atualizar=\"true\" \nesconder-botao-generico=\"false\" tooltip-botao-generico=\"Excluir\" icone-botao-generico=\"icon-delete s30\" \nacao-botao-generico=\"vm.metodos.excluir(vm.pagamentoPix)\" ng-tipo-layout=\" \"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs class=\"equipe-tabs\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Configurações\" md-active=\"vm.tabSelecionada === \'configuracoes\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'configuracoes\')\"><md-tab-label><label>Configurações</label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-configuracoes\"></md-content></md-tab-body></md-tab><md-tab label=\"Integração\" \nmd-active=\"vm.tabSelecionada === \'integracao\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'integracao\')\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 || (!vm.controleForm.pesquisaAtiva && vm.controleForm.editarAtivo && vm.controleForm.inserirAtivo)\">\n<md-tab-label><label>Integração</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-integracao\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/pagamento-pix/views/pagamento-pix.html","<div id=\"pagamento-pix\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.PAGAMENTO_PIX\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"pagamento-pix-form\"></div></div><div ui-view=\"pagamento-pix-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/formulario-impressao/views/formulario-impressao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \nentidade=\"vm.formularioImpressao\" entidades=\"vm.formulariosImpressao\" entidade-de-envio=\"vm.entidadeDeEnvio\" \ncontrolador-toolbar=\"vm.controleForm\" acao-pesquisar=\"vm.metodos.pesquisar()\" \nacao-criar=\"vm.metodos.salvar(vm.formularioImpressao)\" acao-editar=\"vm.metodos.editar(vm.formularioImpressao)\" \nacao-excluir=\"vm.metodos.excluir(vm.formularioImpressao)\" \npre-definir-campos-para-insercao=\"vm.metodos.redefinirValorCamposArquivos()\" \npre-definir-campos-para-edicao=\"vm.metodos.redefinirValorCamposArquivos()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \ncampo-pesquisar=\"vm.pesquisar\" utiliza-botao-clonar=\"true\" \ndefinir-campos-clonados=\"vm.metodos.definirCamposClonados()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><md-tabs \nid=\"cadastros-relacionados-formularioimpressao-mdtabs\" md-dynamic-height md-border-bottom><md-tab label=\"Geral\" \nid=\"cadastros-relacionados-formularioimpressao-mdtabs-geral\" md-active=\"vm.tabSelecionada === \'geral\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'geral\')\"><md-tab-label><label translate=\"RESOURCES.TAB_GERAL\"></label>\n</md-tab-label><md-tab-body><md-content ui-view=\"tab-geral\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Específico\" ng-if=\"vm.parametrosEmpresa.calculo.tipoDetalheCalculo == vm.tipoDetalheCalculo.santoAndre\" \nid=\"cadastros-relacionados-formularioimpressao-mdtabs-especifico\" md-active=\"vm.tabSelecionada === \'especifico\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'especifico\')\"><md-tab-label><label translate=\"RESOURCES.TAB_ESPECIFICO\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-especifico\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content></form></div>");
$templateCache.put("app/main/cadastros/relacionados/formulario-impressao/views/formulario-impressao.html","<div id=\"formulario-impressao\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.FORMULARIO_IMPRESSAO\" icone=\"icon-library-books\"></header-padrao><div class=\"content\"><div \nui-view=\"formulario-impressao-form\"></div></div><div ui-view=\"formularios-impressoes-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/relacionados/formulario-impressao/views/formularios-impressao-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"cadastros-relacionados-formularioimpressao-datatable-formularioimpressao\" width=\"100%\"><thead><tr><th>Ação</th><th>\nCódigo</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/usuario/perfil/views/perfil-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"perfilForm\" novalidate><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.perfis\" \nentidade=\"vm.perfil\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.perfil)\" \nacao-editar=\"vm.metodos.editar(vm.perfil)\" acao-excluir=\"vm.metodos.excluir(vm.perfil)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\"></pg-toolbar>\n<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"RESOURCES.CODIGO\"></label><input type=\"text\" ng-model=\"vm.perfil.codigo\" name=\"perfilCodigo\" \nmascara-numero-generica=\"#####\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"perfilForm.perfilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><proximo-codigo \nng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.perfil.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"5\" flex-gt-sm><label translate=\"RESOURCES.DESCRICAO\"></label><input type=\"text\" \nng-model=\"vm.perfil.descricao\" name=\"perfilDescricao\" mascara-tamanho-campo=\"20\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"20\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"perfilForm.perfilDescricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/cadastros/usuario/perfil/views/perfil.html","<div id=\"perfil\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao translate-nome=\"RESOURCES.PERFIL\" \nicone=\"icon-equal-box\" liberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" \npesquisar=\"vm.pesquisar\"></header-padrao><div class=\"content\"><div ui-view=\"perfil-form\"></div></div><div \nui-view=\"perfis-tabela\" ng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/usuario/perfil/views/perfis-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-usuario-perfil-datatable-perfil\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Descrição</th></tr></thead></table></div></div>");
$templateCache.put("app/main/cadastros/usuario/usuario/views/usuario-form.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.form\" novalidate><pg-toolbar \ncontrolador-toolbar=\"vm.controleForm\" entidade-de-envio=\"vm.entidadeDeEnvio\" entidades=\"vm.usuarios\" \nentidade=\"vm.usuario\" acao-pesquisar=\"vm.metodos.pesquisar()\" acao-criar=\"vm.metodos.salvar(vm.usuario)\" \nacao-editar=\"vm.metodos.editar(vm.usuario)\" acao-excluir=\"vm.metodos.excluir(vm.usuario)\" \nconstruir-dt-options=\"vm.metodos.construirDtOptions()\" metodos-externos=\"vm.metodosExternosPgToolbar\" \nmetodo-externo-acao-nova-pesquisa=\"vm.metodos.novaPesquisa()\"></pg-toolbar><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\"><div layout-gt-xs=\"row\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.CODIGO\"></label><input \ntype=\"text\" ng-model=\"vm.usuario.codigo\" name=\"codigo\" mascara-numero-generica=\"#####\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.codigo.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" entidade-codigo=\"vm.usuario.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo></div></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"RESOURCES.AGRUPAMENTO\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></label><label translate=\"RESOURCES.LOCALIDADE\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></label><md-select ng-model=\"vm.agrupamento\" \nname=\"usuariosAgrupamentos\" multiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.codigo\'}\" \nmd-on-open=\"vm.metodos.configuraMdSelectCategoria()\" \nng-required=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.parametros.utilizaCadastroRegional\" \nng-hide=\"!vm.parametros.utilizaCadastroRegional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-select-header><input id=\"usuario-agrupamento-md-select\" class=\"md-text\" ng-model=\"vm.filtrarAgrupamentos\" \ntype=\"search\" placeholder=\"\" translate ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" \ntranslate-attr-placeholder=\"RESOURCES.PESQUISAR_AGRUPAMENTO\"> <input id=\"usuario-agrupamento-md-select\" \nclass=\"md-text\" ng-model=\"vm.filtrarAgrupamentos\" type=\"search\" placeholder=\"\" translate \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" translate-attr-placeholder=\"RESOURCES.PESQUISAR_LOCALIDADE\">\n</md-select-header><md-option ng-value=\"agrupamento\" \nng-repeat=\"agrupamento in vm.agrupamentos | filter:vm.filtrarAgrupamentos track by agrupamento.codigo\">\n{{agrupamento.descricao}}</md-option></md-select><div ng-messages=\"vm.form.usuariosAgrupamentos.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.NOME\"></label>\n<input type=\"text\" ng-model=\"vm.usuario.nome\" name=\"nome\" mascara-tamanho-campo=\"50\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"50\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.nome.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"RESOURCES.PERFIL\">\n</label><md-select ng-model=\"vm.usuario.codigoPerfil\" name=\"perfilCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"perfil.codigo\" ng-repeat=\"perfil in vm.perfis track by perfil.codigo\">{{perfil.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.perfilCodigo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_MULTIPLO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"RESOURCES.LOGIN\"></label>\n<input type=\"text\" ng-model=\"vm.usuario.login\" name=\"login\" mascara-tamanho-campo=\"20\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"20\" \nng-change=\"vm.metodos.onChangeLogin(vm.usuario.login, vm.form, vm.controleForm)\" \nonkeydown=\"var a = this; setTimeout(function(){a.value = a.value.toUpperCase();}, 1)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.login.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n<div ng-message=\"usuarioExistente\"><span>Login já cadastrado para outro usuário.</span></div></div>\n</md-input-container><div class=\"md-block\" flex-gt-sm=\"15\" style=\"margin: 15px 0px 0px 25px\"><div layout=\"row\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.metodos.rotinaSenha($event);\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" flex><span>\n{{vm.usuario.possuiSenha ? \"Alterar\" : \"Incluir\"}} Senha</span></md-button></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"erroSenha\" ng-if=\"vm.controleForm.inserirAtivo && !vm.usuario.senha\">\nA senha deve ser informada.</div></div><md-input-container class=\"md-block\" flex><input type=\"hidden\" \nng-model=\"vm.usuario.senha\" ng-required=\"vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></md-content></form></div>");
$templateCache.put("app/main/cadastros/usuario/usuario/views/usuario.html","<div id=\"colaborador\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.COLABORADOR\" icone=\"icon-account\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.controleForm.listarTodasEntidades\" pesquisar=\"vm.pesquisar\">\n</header-padrao><div class=\"content\"><div ui-view=\"usuario-form\"></div></div><div ui-view=\"usuarios-tabela\" \nng-if=\"vm.controleForm.listarTodasEntidades\"></div></div>");
$templateCache.put("app/main/cadastros/usuario/usuario/views/usuarios-tabela.html","<div layout=\"column\" flex><div class=\"md-padding md-background-bg md-whiteframe-1dp fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"cadastros-usuario-usuario-datatable-usuario\" \nwidth=\"100%\"><thead><tr><th>Ação</th><th>Código</th><th>Nome</th><th>Perfil</th><th>Login</th></tr></thead></table>\n</div></div>");
$templateCache.put("app/main/gerenciamento/dashboards/distribuicao-grupos/views/resumo-distribuicao-grupos.html","<md-content id=\"quitacaoanual\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Resumo da distribuição dos grupos de leituras.\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"fab-button\" ng-if=\"vm.distribuicao.dados.tarefas.length\"><fab-button buttons=\"vm.menus\" \ntitulo-menu=\"Menu\" disabled=\"vm.emProgresso\"></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" \nflex ms-scroll><div \nui-view=\"dashboards-resumo-distribuicao-grupos-form@app.gerenciamento.dashboards_distribuicaogrupos\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/cliente-ocorrencia/views/cliente-ocorrencia-form.html","<div layout=\"column\" id=\"clienteocorrencia-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-component-id=\"filtro-clienteocorrencia\" md-whiteframe=\"4\" \nui-view=\"cliente-ocorrencia-filtro@app.gerenciamento.dashboards_clienteocorrencia\" ms-scroll ms-sidenav-helper \nmd-is-open=\"true\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo != 89\"></md-sidenav><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-component-id=\"filtro-clienteocorrencia\" md-whiteframe=\"4\" \nui-view=\"cliente-ocorrencia-filtro-casan@app.gerenciamento.dashboards_clienteocorrencia\" ms-scroll ms-sidenav-helper \nmd-is-open=\"true\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 89\"></md-sidenav><md-content flex \nng-if=\"vm.emProgresso || vm.emProgressoAlternativo\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular><carregamento-circular \nem-progresso=\"vm.emProgressoAlternativo\" titulo=\"Aguarde...\" mensagem=\"{{  vm.mensagem }}\"></carregamento-circular>\n</md-content><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.clientesOcorrencia.dados.length\"><div flex=\"80\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px !important; width: 100%\" layout=\"column\" \nflex=\"100\" ng-if=\"vm.parametro.utilizaCadastroRegional\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-weight-500 secondary-text\">Agrupamento</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ vm.clientesOcorrencia.filtros.dadosRegional.descricao }}</div>\n</div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px !important;\r\n          width: 100%;\r\n          flex: 2 2 100%;\r\n          min-width: 150px\" \nlayout=\"column\" flex=\"100\" \nng-if=\"vm.clientesOcorrencia.filtros.MesReferencia != undefined && vm.clientesOcorrencia.filtros.AnoReferencia != undefined\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.clientesOcorrencia.filtros.MesReferencia }}/{{ vm.clientesOcorrencia.filtros.AnoReferencia }}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px !important;\r\n          width: 100%;\r\n          flex: 2 2 100%;\r\n          min-width: 100px\" \nlayout=\"column\" flex=\"100\" \nng-if=\"vm.clientesOcorrencia.filtros.grupo != undefined && vm.parametro.utilizaCadastroRegional\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Grupo</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.clientesOcorrencia.filtros.grupo }}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px !important; width: 100%\" layout=\"column\" flex=\"100\" ng-if=\"vm.parametro.utilizaCadastroRegional\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Município</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-16\">{{ vm.clientesOcorrencia.filtros.dadosMunicipio.descricao }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px !important; width: 100%\" layout=\"column\" flex=\"100\" \nng-if=\"vm.clientesOcorrencia.filtros.dataInicial != undefined\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-weight-500 secondary-text\">Data inicial</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ vm.clientesOcorrencia.filtros.dataInicial | date: \'dd/MM/yyyy\' }}\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px !important; width: 100%\" \nlayout=\"column\" flex=\"100\" ng-if=\"vm.clientesOcorrencia.filtros.dataFinal != undefined\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data final</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.clientesOcorrencia.filtros.dataFinal | date: \'dd/MM/yyyy\' }}</div></div></ms-widget-front>\n</ms-widget></div></div><md-content ng-if=\"vm.clientesOcorrencia.dados.length && !vm.emProgresso\" class=\"p-8\" \nstyle=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" layout-align=\"space-between\"><div layout=\"column\" class=\"pb-8\" \nng-repeat=\"dado in vm.clientesOcorrencia.dados track by $index\"><ms-widget style=\"padding: 0 !important\">\n<ms-widget-front><div><table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr \nshow-gt-sm hide class=\"border-top\"><th ng-if=\"vm.parametro.tipoProcesso == \'01\'\" colspan=\"8\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nOcorrência: {{ dado.cabecalho.codigoOcorrencia }} - {{ dado.cabecalho.descricaoOcorrencia }}</span></div></th><th \nng-if=\"vm.parametro.tipoProcesso == \'02\' && !vm.parametro.utilizaCadastroRegional\" colspan=\"9\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nGrupo de leitura: {{ dado.cabecalho.grupo }}</span> <span \nclass=\"font-size-14 font-weight-900 text-center white-space-normal\">\nOcorrência: {{ dado.cabecalho.codigoOcorrencia }} - {{ dado.cabecalho.descricaoOcorrencia }}</span></div></th><th \nng-if=\"vm.parametro.utilizaCadastroRegional\" colspan=\"9\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nOcorrência: {{ dado.cabecalho.codigoOcorrencia }} - {{ dado.cabecalho.descricaoOcorrencia }}</span></div></th></tr><tr>\n<th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Nome</span></div></th><th class=\"secondary-text borda-esquerda borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Matrícula</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Hidrometro</span>\n</div></th><th ng-if=\"vm.parametro.tipoProcesso == \'02\' && !vm.parametro.utilizaCadastroRegional\" \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Rota</span></div>\n</th><th ng-if=\"vm.parametro.utilizaCadastroRegional\" class=\"secondary-text borda-direita\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Setor</span></div></th><th ng-if=\"vm.parametro.utilizaCadastroRegional\" \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Quadra</span>\n</div></th><th ng-if=\"vm.parametro.utilizaCadastroRegional\" class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Lote</span></div></th><th \nng-if=\"vm.parametro.utilizaCadastroRegional\" class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leiturista</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Endereço</span></div></th><th \nclass=\"secondary-text borda-direita\" ng-if=\"!vm.parametro.utilizaCadastroRegional\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leitura anterior</span></div></th><th class=\"secondary-text borda-direita\" \nng-if=\"!vm.parametro.utilizaCadastroRegional\"><div class=\"table-header\"><span class=\"column-title text-center\">\nLeitura atual</span></div></th><th class=\"secondary-text borda-direita\" ng-if=\"!vm.parametro.utilizaCadastroRegional\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Valor total</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Fotos</span>\n</div></th></tr></thead><tbody><tr sly-repeat=\"cliente in dado.dadosClientes\"><td \nclass=\"text-left border-left border-right\" style=\"padding-left: 5px !important\"><span>{{ cliente.clienteNome }}</span>\n</td><td class=\"text-center border-right\"><span>{{ cliente.matricula }}</span></td><td \nclass=\"text-center border-right\"><span>{{ cliente.hidrometro }}</span></td><td \nng-if=\"vm.parametro.tipoProcesso == \'02\' && !vm.parametro.utilizaCadastroRegional\" class=\"text-center border-right\">\n<span>{{ cliente.rota }}</span></td><td ng-if=\"vm.parametro.utilizaCadastroRegional\" class=\"text-center border-right\">\n<span>{{ cliente.setor }}</span></td><td ng-if=\"vm.parametro.utilizaCadastroRegional\" class=\"text-center border-right\">\n<span>{{ cliente.quadra }}</span></td><td ng-if=\"vm.parametro.utilizaCadastroRegional\" \nclass=\"text-center border-right\"><span>{{ cliente.lote }}</span></td><td ng-if=\"vm.parametro.utilizaCadastroRegional\" \nclass=\"text-center border-right\"><span>{{ cliente.leiturista }}</span></td><td class=\"text-left border-right\" \nstyle=\"padding-left: 5px !important\"><span>\n{{ cliente.rua }}, {{ cliente.numero }} {{ cliente.complemento }} - {{ cliente.bairro }}</span></td><td \nng-if=\"!vm.parametro.utilizaCadastroRegional\" class=\"text-center border-right\"><span>{{ cliente.leituraAnterior }}\n</span></td><td ng-if=\"!vm.parametro.utilizaCadastroRegional\" class=\"text-center border-right\"><span>\n{{ cliente.leituraAtual || \"-\" }}</span></td><td ng-if=\"!vm.parametro.utilizaCadastroRegional\" \nclass=\"text-center border-right\"><span>{{ cliente.valorTotal | currency:\'R$ \' }}</span></td><td \nclass=\"text-center border-right\"><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-disabled=\"!cliente.existeFotos\" ng-click=\"vm.metodos.abrirDialogFotos(cliente)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"Fotos\">Fotos</span></md-tooltip><md-icon \nmd-font-icon=\"icon-open-in-new\" ng-class=\"{ \'cor-icone-padrao\': cliente.existeFotos }\"></md-icon></md-button></div>\n</td></tr></tbody></table></div><div layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><ms-widget \nclass=\"h-40\" style=\"padding: 4px !important\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 blue-bg white-fg\" \nflex=\"100\"><div class=\"pt-2 pb-2\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-14\"><span style=\"font-size: 14px\">\nTotal da ocorrência: {{ dado.dadosClientes.length }}</span></div></div></ms-widget-front></ms-widget></div>\n</ms-widget-front></ms-widget></div><div layout=\"column\" flex=\"100\"><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align-gt-sm=\"center center\" flex-gt-sm=\"50\" flex=\"100\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px !important; width: 100%\" layout=\"column\" layout-align-gt-sm=\"center center\" flex-gt-sm=\"25\" \nflex=\"100\"><ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Total de clientes</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.clientesOcorrencia.totalizador | number }}</div></div></ms-widget-front></ms-widget></div>\n</div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/cliente-ocorrencia/views/cliente-ocorrencia.html","<md-content id=\"clienteocorrencia\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Clientes por ocorrência\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"fab-button\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\" \ndisabled=\"vm.emProgresso || vm.emProgressoRelatorio\"></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content\" flex ms-scroll><div \nui-view=\"dashboards-clientesocorrencia-form@app.gerenciamento.dashboards_clientesocorrencia\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/comunicados-debito-impressos/views/comunicados-debito-impressos-form.html","<div layout=\"column\" id=\"comunicadosimpressos-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-comunicadosimpressos\" md-whiteframe=\"4\" \nui-view=\"comunicados-debito-impressos-filtro@app.gerenciamento.dashboards_comunicadosdebitoimpressos\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" \nng-if=\"!vm.comunicadosImpressos.dados.length && !vm.emProgresso\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span></md-button></div></div>\n<md-content flex ng-if=\"vm.emProgresso || vm.emProgressoRelatorio\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular>\n<carregamento-circular em-progresso=\"vm.emProgressoRelatorio\" titulo=\"Aguarde...\" mensagem=\"Gerando Relatório...\">\n</carregamento-circular></md-content><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" \nshow-gt-sm hide ng-if=\"vm.comunicadosImpressos.dados.length\"><div flex=\"60\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Grupo</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.comunicadosImpressos.filtros.grupoLeitura }}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\" \nng-if=\"vm.comunicadosImpressos.filtros.MesReferencia != undefined && vm.comunicadosImpressos.filtros.AnoReferencia != undefined\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.comunicadosImpressos.filtros.MesReferencia }}/{{ vm.comunicadosImpressos.filtros.AnoReferencia }}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\" ng-if=\"vm.comunicadosImpressos.filtros.dataInicial != undefined\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data inicial</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.comunicadosImpressos.filtros.dataInicial | date: \'dd/MM/yyyy\' }}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\" ng-if=\"vm.comunicadosImpressos.filtros.dataFinal != undefined\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data final</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.comunicadosImpressos.filtros.dataFinal | date: \'dd/MM/yyyy\' }}</div></div></ms-widget-front>\n</ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\" ng-if=\"vm.comunicadosImpressos.dados.length && !vm.emProgresso\"><div layout=\"column\" \nclass=\"pb-8\" ng-repeat=\"dado in vm.comunicadosImpressos.dados track by $index\"><ms-widget style=\"padding:0!important\">\n<ms-widget-front><div><table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr \nshow-gt-sm hide class=\"border-top\"><th colspan=\"4\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nLeiturista: {{ dado.leiturista }}</span></div></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Número Aviso</span></div></th><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nCódigo Ligação</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Endereço</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Data</span></div></th></tr></thead><tbody><tr \nng-repeat=\"comunicado in dado.dadosComunicados track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{ comunicado.numeroAviso }}</span></td><td class=\"text-center border-right\"><span>{{ comunicado.codigoLigacao }}\n</span></td><td class=\"text-left border-right\" style=\"padding-left: 5px !important\"><span>\n{{ comunicado.rua }}, {{ comunicado.numero }} {{ comunicado.complemento }} - {{ comunicado.bairro }}</span></td><td \nclass=\"text-center border-right\"><span>{{ comunicado.data | date: \"dd/MM/yyyy\"}}</span></td></tr></tbody></table></div>\n<div layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><ms-widget class=\"h-40\" \nstyle=\"padding: 4px!important\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 blue-bg white-fg\" flex=\"100\"><div\n class=\"pt-2 pb-2\" layout=\"row\" layout-align=\"end center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-14\"><span style=\"font-size: 14px\">Total do leiturista: {{ dado.dadosComunicados.length }}</span></div>\n</div></ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div><div class=\"card md-whiteframe-4dp\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div flex=\"70\" flex-xs=\"100\" class=\"border-right\"><nvd3 \noptions=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div layout=\"column\" layout-align=\"center center\" \nflex=\"30\" flex-xs=\"100\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\"><span class=\"font-size-28\" \nstyle=\"font-weight: 600; text-align: center\">Total de comunicados</span> <span class=\"font-size-24\">\n{{ vm.comunicadosImpressos.totalizador | number }}</span></div></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/comunicados-debito-impressos/views/comunicados-debito-impressos.html","<md-content id=\"comunicadosimpressos\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Comunicados de débito impressos em campo\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"fab-button\" ng-if=\"vm.comunicadosImpressos.dados.length\"><fab-button buttons=\"vm.menus\" \ntitulo-menu=\"Menu\" disabled=\"vm.emProgresso || vm.emProgressoRelatorio\"></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"dashboards-comunicadosdebitoimpressos-form@app.gerenciamento.dashboards_comunicadosdebitoimpressos\"></div>\n</div></div></md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/quantitativo-leituras/views/quantitativo-leituras-form.html","<div layout=\"column\" id=\"quantitativoleituras-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-quantitativoleituras\" md-whiteframe=\"4\" \nui-view=\"quantitativo-leituras-filtro@app.gerenciamento.dashboards_quantitativoleituras\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"no-results text-center\" ng-if=\"!vm.quantitativo.dados.leituristas.length && !vm.emProgresso\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide ng-if=\"vm.quantitativo.dados.leituristas.length\">\n<div flex=\"40\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.quantitativo.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.quantitativo.filtros.mes }}/{{ vm.quantitativo.filtros.ano }}</div></div><div \nng-if=\"vm.quantitativo.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\"><div flex=\"100\" layout-align=\"center center\" class=\"font-weight-500 secondary-text\">Período de leituras\n</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.quantitativo.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.quantitativo.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.quantitativo.dados.leituristas.length\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\" flex=\"100\" ng-if=\"vm.quantitativo.dados.leituristas.length > 1\"><div \nclass=\"pv-8 h3 border-bottom\" flex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Análise geral dos leituristas</span></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"75\" flex-xs=\"100\" class=\"border-right\"><nvd3 \noptions=\"vm.multiBarChart.options\" data=\"vm.multiBarChart.data\"></nvd3></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"25\" flex-xs=\"100\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\"><span\n class=\"font-size-24\" style=\"font-weight: 600; text-align: center\">Total de leituras</span> <span class=\"font-size-20\">\n{{ vm.quantitativo.dados.total }}</span></div></div></div></div><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Detalhamento de leituras por grupo</span></div><div \nclass=\"agrupamento-detalhes border-bottom\" layout=\"row\" layout-xs=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"dado in vm.quantitativo.dados.leituristas track by $index\"><div \nlayout=\"column\" class=\"pb-8\" flex=\"40\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div>\n<table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr class=\"border-top\"><th \ncolspan=\"2\" class=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nLeiturista: {{ dado.codigo }} - {{ dado.nome }}</span></div></th></tr><tr><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nGrupo</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leituras</span></div></th></tr></thead><tbody><tr \nng-repeat=\"grupo in dado.gruposQuantitativo track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{ grupo.grupo }}</span></td><td class=\"text-center border-right\"><span>{{ grupo.quantidadeLeituras }}</span></td></tr>\n</tbody><tfoot><th colspan=\"2\" class=\"secondary-text border-right border-left\"><div class=\"text-left\"><span \nclass=\"text-left\">Total: {{ dado.total }}</span></div></th></tfoot></table></div></ms-widget-front></ms-widget></div>\n<div flex=\"60\" flex-xs=\"100\"><nvd3 options=\"dado.pieChart.options\" data=\"dado.pieChart.data\"></nvd3></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/quantitativo-leituras/views/quantitativo-leituras.html","<md-content id=\"quantitativoleituras\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Quantitativo de leituras\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"fab-button\" ng-if=\"vm.quantitativo.dados.leituristas.length && !vm.emProgresso\"><fab-button buttons=\"vm.menus\" \ntitulo-menu=\"Menu\" disabled=\"vm.emProgresso\"></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" \nflex ms-scroll><div ui-view=\"dashboards-quantitativoleituras-form@app.gerenciamento.dashboards_quantitativoleituras\">\n</div></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/controle-fluxo/views/controle-fluxo-form.html","<div layout=\"column\" id=\"controleFluxo-form\" flex=\"100\" ng-if=\"vm.controleCargaFluxo && !vm.emProgresso\"><div \nclass=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm><div flex=\"80\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data inicial</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.dadosFiltrados.dataInicial | date: \"dd/MM/yyyy\" }}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data final</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.dadosFiltrados.dataFinal | date: \"dd/MM/yyyy\" }}</div></div></ms-widget-front></ms-widget>\n</div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" layout-align=\"space-between\">\n<div layout=\"column\" class=\"pb-8\" ng-repeat=\"controleFluxo in vm.controleCargaFluxo track by $index\"><ms-widget \nstyle=\"padding:0!important\"><ms-widget-front><div><table class=\"dataTable hover row-border\" dt-options=\"vm.dtOptions\" \ndatatable=\"ng\"><thead><tr show-gt-sm hide class=\"border-top\"><th colspan=\"10\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header nome-leiturista\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nLeiturista: {{controleFluxo.nomeLeiturista}}</span></div></th></tr><tr show-gt-sm hide class=\"border-top\"><th \ncolspan=\"2\" ng-if=\"vm.parametro.tipoProcesso == \'01\'\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">Leitura</span></div>\n</th><th colspan=\"3\" ng-if=\"vm.parametro.tipoProcesso == \'02\'\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">Leitura</span></div>\n</th><th colspan=\"3\" ng-if=\"vm.parametro.tipoProcesso == \'01\'\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">Data e hora</span>\n</div></th><th colspan=\"4\" ng-if=\"vm.parametro.tipoProcesso == \'02\'\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">Data e hora</span>\n</div></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Arquivo</span></div></th><th class=\"secondary-text borda-esquerda borda-direita\" \nng-if=\"vm.parametro.tipoProcesso == \'02\'\"><div class=\"table-header\"><span class=\"column-title text-center\">\nNúmero da tarefa</span></div></th><th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Quantidade de leituras</span></div></th><th \nclass=\"secondary-text borda-direita\" ng-if=\"vm.parametro.tipoProcesso == \'02\'\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Distribuição</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Disponibilização</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nRecebimento no coletor</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Finalização da carga</span></div></th></tr></thead><tbody><tr \nng-repeat=\"dadosArquivos in controleFluxo.dadosControleCargaFluxo track by $index\" class=\"campo-tabela\"><td \nclass=\"text-left border-left border-right\" style=\"padding-left: 5px !important\"><span>\n{{dadosArquivos.nomeArquivoExportacao}}</span></td><td class=\"text-center border-right\" \nng-if=\"vm.parametro.tipoProcesso == \'02\'\"><span>{{dadosArquivos.numeroTarefa}}</span></td><td \nclass=\"text-center border-right\"><span>{{dadosArquivos.disponibilizacaoTarefaQuantidade}}</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.parametro.tipoProcesso == \'02\'\"><span>\n{{dadosArquivos.distribuicaoTarefaData | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></td><td class=\"text-center border-right\">\n<span>{{dadosArquivos.disponibilizacaoTarefaData | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></td><td \nclass=\"text-center border-right\"><span>{{dadosArquivos.recebidoColetorData | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></td>\n<td class=\"text-center border-right\"><span>{{dadosArquivos.finalizacaoCargaData | date: \"dd/MM/yyyy HH:mm:ss\"}}</span>\n</td></tr></tbody></table></div><div layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><ms-widget \nclass=\"h-30\" style=\"padding: 4px!important\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-2 blue-bg white-fg\" \nflex=\"100\"><div class=\"p-2\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-14\"><span style=\"font-size: 12px\">\nTotal de arquivos: {{controleFluxo.dadosControleCargaFluxo.length}}</span></div></div></ms-widget-front></ms-widget>\n</div></ms-widget-front></ms-widget></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/controle-fluxo/views/controle-fluxo.html","<md-content id=\"controleFluxo\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Controle de cargas\" icone=\"icon-poll\" campo-pesquisar=\"vm.pesquisar\" ng-ultiliza-pesquisa=\"true\" \nliberar-pesquisa-quando-datatable-ativo=\"true\" id=\"pesquisar\"></header-padrao><div class=\"button-float\" layout=\"row\" \nlayout-align=\"center\"><md-fab-speed-dial md-direction=\"left\" class=\"md-scale md-fab-speed-dial-fixo\" flex>\n<md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent md-icon-button sample-show-hide botao-menu\">\n<md-icon md-font-icon=\"icon-playlist-plus s30\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button \nclass=\"md-raised md-mini md-accent button-toogle icon-filter-outline md-fab\" aria-label=\"Fitrar\" \nng-click=\"vm.metodos.abrirFecharFiltro()\"><md-tooltip md-autohide>Filtrar</md-tooltip></md-button><md-button \nclass=\"md-raised md-mini md-accent button-toogle icon-refresh md-fab\" aria-label=\"Fitrar\" \nng-click=\"vm.metodos.atualizarDados()\"><md-tooltip md-autohide>Atualizar</md-tooltip></md-button></md-fab-actions>\n</md-fab-speed-dial></div><md-sidenav class=\"sidenav md-sidenav-right\" md-component-id=\"filtro-controleFluxo\" \nmd-whiteframe=\"4\" ui-view=\"dashboards-controlecargafluxo-filtro@app.gerenciamento.dashboards_controlecargafluxo\" \nms-scroll ms-sidenav-helper md-is-open=\"true\"></md-sidenav><md-content flex ng-if=\"vm.emProgresso\">\n<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\">\n</carregamento-circular></md-content><div class=\"content-card\" layout=\"column\" flex ng-show=\"vm.controleCargaFluxo\">\n<div class=\"content\" flex ms-scroll><div \nui-view=\"dashboards-controlecargafluxo-form@app.gerenciamento.dashboards_controlecargafluxo\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual.html","<md-content id=\"quitacaoanual\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Comunicados de quitação anual de débitos impressos em campo\" icone=\"icon-poll\" \nng-utiliza-pesquisa=\"false\"></header-padrao><div class=\"fab-button\" \nng-if=\"vm.quitacoes.dados.detalhesReferencias.length\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\" \ndisabled=\"vm.emProgresso\"></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div\n ng-if=\"vm.tipoSimplificadoOuDetalhado\" \nui-view=\"dashboards-quitacaoanual-simplificado-form@app.gerenciamento.dashboards_quitacaoanual\"></div><div \nng-if=\"!vm.tipoSimplificadoOuDetalhado\" \nui-view=\"dashboards-quitacaoanual-detalhado-form@app.gerenciamento.dashboards_quitacaoanual\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/ocorrencias-leiturista/views/ocorrencias-leiturista-form.html","<div layout=\"column\" id=\"ocorrenciasleiturista-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-ocorrenciasleiturista\" md-whiteframe=\"4\" \nui-view=\"ocorrencias-leiturista-filtro@app.gerenciamento.dashboards_ocorrenciasleiturista\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"no-results text-center\" \nng-if=\"!vm.ocorrenciasleiturista.dados.leituristas.length && !vm.emProgresso\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span></md-button></div></div>\n<md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" flex=\"15\" \nlayout-align=\"center center\" layout=\"row\" show-gt-sm hide ng-if=\"vm.ocorrenciasleiturista.dados.leituristas.length\">\n<div flex=\"30\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div \nng-if=\"vm.ocorrenciasleiturista.filtros.tipoFiltro === 1\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.ocorrenciasleiturista.filtros.mes }}/{{ vm.ocorrenciasleiturista.filtros.ano }}</div></div>\n<div ng-if=\"vm.ocorrenciasleiturista.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Período de leituras</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.ocorrenciasleiturista.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.ocorrenciasleiturista.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.ocorrenciasleiturista.dados.leituristas.length\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\" flex=\"100\" \nng-if=\"vm.ocorrenciasleiturista.dados.ocorrencias.length > 1\"><div class=\"pv-8 h3 border-bottom\" flex=\"100\" \nlayout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" style=\"font-weight: 600; text-align: center\">\nAnálise geral das ocorrências</span></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" flex=\"100\">\n<div flex=\"100\" flex-xs=\"100\"><nvd3 options=\"vm.multiBarChart.options\" data=\"vm.multiBarChart.data\" \nclass=\"border-bottom\"></nvd3></div></div><div layout=\"column\" layout-align=\"center center\" flex=\"25\" flex-xs=\"100\" \nstyle=\"padding: 25px\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\"><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Total de leituras com ocorrência</span> <span class=\"font-size-22\">\n{{ vm.ocorrenciasleiturista.dados.totalOcorrencias }}</span></div></div></div><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Detalhamento de ocorrências por leiturista</span></div><div \nclass=\"agrupamento-detalhes border-bottom\" layout=\"row\" layout-xs=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" flex=\"100\" \nng-repeat=\"dado in vm.ocorrenciasleiturista.dados.leituristas track by $index\"><div layout=\"column\" class=\"pb-8\" \nflex=\"40\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table \nclass=\"dataTable hover row-border\"><thead><tr class=\"border-top\"><th colspan=\"2\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nLeiturista: {{ dado.codigoLeiturista }} - {{ dado.nome }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.abrirDialogDetalhamento(dado)\" ng-disabled=\"vm.emProgressoDialog\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoDialog\"></md-progress-circular>\n<md-tooltip md-autohide><span>Ver detalhamento diário</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"cor-icone-padrao\"></md-icon></md-button></div></th></tr><tr><th \nclass=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nOcorrência</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leituras</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ocorrencia in dado.ocorrencias track by $index\"><td class=\"text-left border-left border-right\" \nstyle=\"padding-left: 5px !important\"><span>{{ ocorrencia.codigoOcorrencia }} - {{ ocorrencia.descricaoOcorrencia }}\n</span></td><td class=\"text-center border-right\"><span>{{ ocorrencia.total }}</span></td></tr></tbody><tfoot><th \ncolspan=\"2\" class=\"secondary-text border-right border-left\"><div class=\"text-left\"><span class=\"text-left\">\nTotal: {{ dado.total }}</span></div></th></tfoot></table></div></ms-widget-front></ms-widget></div><div flex=\"60\" \nflex-xs=\"100\"><nvd3 options=\"dado.pieChart.options\" data=\"dado.pieChart.data\"></nvd3></div></div></div></md-content>\n</div>");
$templateCache.put("app/main/gerenciamento/dashboards/ocorrencias-leiturista/views/ocorrencias-leiturista.html","<md-content id=\"ocorrenciasleiturista\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Ocorrências por leiturista\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"fab-button\" ng-if=\"vm.ocorrenciasleiturista.dados.leituristas.length\"><fab-button buttons=\"vm.menus\" \ntitulo-menu=\"Menu\" disabled=\"vm.emProgresso\"></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" \nflex ms-scroll><div ui-view=\"dashboards-ocorrenciasleiturista-form@app.gerenciamento.dashboards_ocorrenciasleiturista\">\n</div></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/critica/consultacritica/views/consulta-critica.form.html","<div id=\"consulta-critica-form\" layout=\"column\"><div class=\"botao-lateral-flutante\" role=\"button\"><div layout=\"column\">\n<div ng-if=\"vm.criticas.length > 0\" class=\"btn md-primary-bg\" ng-click=\"vm.metodos.atualizarCriticas()\"><md-tooltip \nmd-autohide id=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span translate=\"RESOURCES.ATUALIZAR_DADOS\">\nAtualizar dados</span></md-tooltip><md-icon md-font-icon=\"icon-refresh\" \nclass=\"white-text md-font material-icons md-default-theme s24\" role=\"img\" aria-label=\"icon-filter\"></md-icon></div><div\n class=\"btn md-primary-bg\" ng-click=\"vm.metodos.abrirFiltro()\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\" \nmd-direction=\"left\"><span translate=\"RESOURCES.FILTRAR_CRITICAS\">Filtrar críticas</span></md-tooltip><md-icon \nmd-font-icon=\"icon-filter\" class=\"white-text md-font material-icons md-default-theme s24\" role=\"img\" \naria-label=\"icon-filter\"></md-icon></div></div></div><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-consulta-critica\" md-whiteframe=\"4\" ui-view=\"filtro-sidenav-consulta-critica\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" ng-if=\"!vm.criticas || vm.criticas.length === 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"PROCESSAMENTO.DISTRIBUICAO.SEM_GRUPO\">Nenhum grupo de leituras selecionado.</div>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar\n</span></md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Atualizando leituras...\"></carregamento-circular>\n</md-content><md-content layout=\"column\" class=\"pr-40\" flex layout-padding \nng-if=\"vm.criticas.length > 0 && !vm.emProgresso\"><div flex=\"100\" layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"100\"><md-progress-spinner mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" \nng-if=\"vm.emProgressoCriticas\"></md-progress-spinner><md-button class=\"md-accent md-raised\" \nng-click=\"vm.metodos.liberarTodasCriticas()\">Liberar todos</md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.metodos.liberarCriticas(true)\">Liberar selecionados</md-button></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text border-left\"><div class=\"table-header text-center\"><md-checkbox class=\"margin-0\" \nng-model=\"vm.selecionarTodos\" ng-change=\"vm.metodos.marcarTodos()\"></md-checkbox></div></th><th \nclass=\"secondary-text border-right border-left\" ng-show=\"false\"><div class=\"table-header\"><span \nclass=\"column-title text-left\">Cd. Cliente</span></div></th><th class=\"secondary-text border-right border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Matrícula</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Localização</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-left\" style=\"white-space: normal\">Data</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Leitura</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-left\" style=\"white-space: normal\">Consumo (m3)</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Ocorrência</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-left\" style=\"white-space: normal\">%</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Leit. Cor.</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-left\" style=\"white-space: normal\">Cons. Cor.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Ocor. Cor.</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-left\" style=\"white-space: normal\">%</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-left\" \nstyle=\"white-space: normal\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"critica in vm.criticas track by $index\"><td class=\"border-left text-center\"><div><md-checkbox \nclass=\"margin-0\" ng-model=\"critica.marcado\"></md-checkbox></div></td><td class=\"text-left border-left border-right\" \nng-show=\"false\"><span>{{critica.codigoCliente}}</span></td><td class=\"text-left border-left border-right\"><span>\n{{critica.codigoClienteDigitoLigacao}}</span></td><td class=\"text-left border-right\"><span>{{critica.localizacao}}\n</span></td><td class=\"text-left border-right\"><span>{{critica.dataHoraColeta | date: \'dd/MM\'}}</span></td><td \nclass=\"text-left border-right\"><span>{{critica.leitura}}</span></td><td class=\"text-left border-right\"><span>\n{{critica.consumoFaturado}}</span></td><td class=\"text-left border-right\"><span>{{critica.ocorrencia}}</span></td><td \nclass=\"text-left border-right\"><span>{{critica.porcentagemConsumoFaturadoAcimaConsumoMedio}}</span></td><td \nclass=\"text-left border-right\"><span>{{critica.leituraCorrigida}}</span></td><td class=\"text-left border-right\"><span>\n{{critica.consumoCorrigido}}</span></td><td class=\"text-left border-right\"><span>{{critica.ocorrenciaCorrigida}}</span>\n</td><td class=\"text-left border-right\"><span>{{critica.porcentagemLeituraCorrigida}}</span></td><td \nclass=\"text-left border-right\"><span class=\"ml-5 text-boxed orange-bg white-fg ng-binding status-revisao\" \nng-if=\"critica.statusCritica == 2\" style=\"margin: 5px 0px; font-size: 0.85em\">Revisão</span> <span \nclass=\"ml-5 text-boxed purple-900-bg white-fg ng-binding status-revisao\" ng-if=\"critica.statusCritica == 4\" \nstyle=\"margin: 5px 0px; font-size: 0.85em\">Rev. impr.</span> <span \nclass=\"ml-5 text-boxed green-bg white-fg ng-binding status-revisao\" ng-if=\"critica.statusCritica == 3\" \nstyle=\"margin: 5px 0px; font-size: 0.85em\">Impressão</span></td></tr></tbody></table></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/critica/consultacritica/views/consulta-critica.html","<div id=\"consulta-criticas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.CONSULTA_CRITICA\" icone=\"icon-file-document\" pesquisar=\"vm.pesquisar\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.criticas.length > 0 && !vm.emProgresso\" \nng-utiliza-pesquisa=\"vm.criticas.length > 0 && !vm.emProgresso\"></header-padrao><div class=\"content\"><div \nui-view=\"consultacritica-form\"></div></div>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/views/critica-leituras-form.html","<div id=\"critica-leituras-form\" layout=\"column\"><div class=\"botao-lateral-flutante\" role=\"button\" \nng-if=\"vm.leiturasRetidas.length\"><div layout=\"column\"><div class=\"btn md-primary-bg margin-0\" \nng-click=\"vm.metodos.abrirFiltroCritica()\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\">\n<span translate=\"RESOURCES.FILTRAR_LEITURAS\">Filtrar leituras</span></md-tooltip><md-icon md-font-icon=\"icon-filter\" \nclass=\"white-text md-font material-icons md-default-theme s24\" role=\"img\" aria-label=\"icon-filter\"></md-icon></div><div\n class=\"btn md-primary-bg\" ng-click=\"vm.metodos.abrirLegendaCritica()\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span translate=\"RESOURCES.LEGENDA\">Legendas</span></md-tooltip>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"white-text md-font material-icons md-default-theme s24\" \nrole=\"img\" aria-label=\"icon-filter\"></md-icon></div><div class=\"btn md-primary-bg\" \nng-if=\"vm.critica.statusCritica > 1\" \nng-click=\"!vm.dialogHistoricoAberto && vm.metodos.abrirHistoricoCritica(vm.critica)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span translate=\"RESOURCES.HISTORICO_CRITICAS\">\nHistórico de críticas</span></md-tooltip><md-icon md-font-icon=\"icon-calendar-text\" \nclass=\"white-text md-font material-icons md-default-theme s24\" role=\"img\" aria-label=\"icon-filter\"></md-icon></div><div\n class=\"btn md-primary-bg\" ng-click=\"vm.metodos.abrirNovaAbaConsultaCriticas()\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span>Abrir consulta de críticas</span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-up-bold-hexagon-outline\" class=\"white-text md-font material-icons md-default-theme s24\" \nrole=\"img\" aria-label=\"icon-arrow-up-bold-hexagon-outline\"></md-icon></div></div></div><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-left\" md-component-id=\"filtro-critica-leituras\" md-whiteframe=\"4\" \nui-view=\"filtro-sidenav-critica-leituras\" ms-scroll ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"sidenav execucao-sidenav md-sidenav-right\" md-component-id=\"execucao-critica-leituras\" md-whiteframe=\"4\" \nui-view=\"execucao-critica-sidenav\" ms-scroll ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"sidenav execucao-sidenav md-sidenav-left\" md-component-id=\"fotos-critica-leituras\" md-whiteframe=\"4\" \nui-view=\"fotos-critica-sidenav\" ms-scroll ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"sidenav execucao-sidenav md-sidenav-left\" md-component-id=\"legenda-critica-leituras\" md-whiteframe=\"4\" \nui-view=\"legenda-critica-sidenav\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" \nng-if=\"!vm.leiturasRetidas || vm.leiturasRetidas.length === 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"PROCESSAMENTO.DISTRIBUICAO.SEM_GRUPO\">Nenhum grupo de leituras selecionado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroCritica()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar\n</span></md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular \nem-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"Atualizando leituras...\"></carregamento-circular>\n</md-content><md-content layout=\"column\" flex=\"100\" class=\"main-content\" \nng-if=\"vm.leiturasRetidas.length > 0 && !vm.emProgresso\"><div layout-gt-sm=\"row\" layout=\"column\" flex=\"100\"><div \nflex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text border-left\" ng-show=\"false\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Mat.</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Mat.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Local.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">\nData</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Leit.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Cons. (m3)</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Ocor.</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">%\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"leitura in vm.leiturasRetidas track by $index\" style=\"cursor: pointer\" \nng-class=\"{\'color-red\': vm.metodos.verificarPorcentagem(leitura) === \'red\',\r\n                         \'color-orange\': vm.metodos.verificarPorcentagem(leitura) === \'orange\',\r\n                         \'critica-selecionada\': leitura.selecionado}\" \nng-click=\"vm.metodos.abrirExecucaoCritica(leitura)\"><td class=\"text-center border-left border-right\" ng-show=\"false\" \nng-class=\"{\'cabecalho-vermelho\': leitura.clienteComUrgencia}\"><span>{{leitura.codigoCliente}}</span></td><td \nclass=\"text-center border-left border-right\" style=\"word-wrap: normal\" \nng-class=\"{\'cabecalho-vermelho\': leitura.clienteComUrgencia}\"><span>{{leitura.codigoClienteDigitoLigacao}}</span></td>\n<td class=\"text-center border-right\"><span>{{leitura.localizacao}}</span></td><td class=\"text-center border-right\">\n<span>{{leitura.dataHoraColeta | date: \'dd/MM\'}}</span></td><td class=\"text-center border-right\"><span>\n{{ leitura.somenteOcorrencia ? \'S.O.\': leitura.leitura}}</span></td><td class=\"text-center border-right\"><span>\n{{leitura.consumoFaturado}}</span></td><td class=\"text-center border-right\"><span>{{leitura.ocorrencia}}</span></td><td\n class=\"text-center border-right\"><span>{{leitura.porcentagemConsumoFaturadoAcimaConsumoMedio}}</span></td><td \nclass=\"text-center border-right\"><div class=\"text-boxed blue-bg white-fg ng-binding status-revisao-tabela\" \nng-if=\"leitura.statusCritica == 1\" style=\"padding: 2px 4px;font-size: 0.85em\">Pend</div><div \nclass=\"text-boxed orange-bg white-fg ng-binding status-revisao-tabela\" \nng-if=\"leitura.statusCritica == 2 && leitura.statusRetencao != 12\" style=\"padding: 2px 4px;font-size: 0.85em\"><span>\nRevi</span></div><div class=\"text-boxed green-bg white-fg ng-binding status-revisao-tabela\" \nng-if=\"leitura.statusCritica == 3\" style=\"padding: 2px 4px;font-size: 0.85em\">Impr</div><div \nclass=\"text-boxed lime-900-bg white-fg ng-binding status-revisao-tabela\" \nng-if=\"leitura.statusRetencao == 12 && leitura.statusCritica != 3\" style=\"padding: 2px 4px;font-size: 0.85em\">Ret</div>\n<span ng-show=\"false\">{{leitura.statusCritica}}</span><div \nclass=\"text-boxed purple-900-bg white-fg ng-binding status-revisao-tabela\" ng-if=\"leitura.statusCritica == 4\" \nstyle=\"padding: 2px 4px;font-size: 0.85em\">Rev. Impr</div><span ng-show=\"false\">{{leitura.statusCritica}}</span></td>\n</tr></tbody></table></div><div id=\"dados-leitura\" layout=\"column\" flex=\"100\" ng-if=\"vm.critica.leitura\"><fieldset \nflex=\"100\" layout=\"column\" ng-if=\"vm.critica.leitura\"><div layout=\"column\" layout-gt-sm=\"row\" flex-gt-sm=\"100\" \nflex=\"100\"><div layout=\"column\" class=\"pr-10\" flex-gt-sm=\"55\"><div layout=\"row\" class=\"text-left\"><span \nclass=\"ml-5 text-boxed blue-bg white-fg ng-binding\" ng-if=\"vm.critica.leitura.statusCritica == 1\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Pendente</span> <span \nclass=\"ml-5 text-boxed orange-bg white-fg ng-binding status-revisao\" \nng-if=\"vm.critica.leitura.statusCritica == 2 && leitura.statusRetencao != 12\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Revisão</span> <span \nclass=\"ml-5 text-boxed green-bg white-fg ng-binding status-revisao\" ng-if=\"vm.critica.leitura.statusCritica == 3\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Impressão</span> <span \nclass=\"ml-5 text-boxed purple-900-bg white-fg ng-binding status-revisao\" ng-if=\"vm.critica.leitura.statusCritica == 4\" \nstyle=\"margin: 5px 0px; font-size: 0.85em\">Rev. Impressão</span> <span \nclass=\"ml-5 text-boxed lime-900-bg white-fg ng-binding status-revisao\" \nng-if=\"vm.critica.leitura.statusRetencao == 12 && vm.critica.leitura.statusCritica != 3\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Retorno</span> <span \nclass=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" ng-if=\"vm.critica.leitura.somenteOcorrencia\" \nstyle=\"margin: 5px 5px 5px 0px; font-size: 0.85em\">Somente ocorrência</span> <span \nclass=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" ng-if=\"vm.critica.leitura.clienteComUrgencia\" \nstyle=\"margin: 5px 0px; font-size: 0.85em\">Urgente</span> <span \nclass=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" \nng-if=\"vm.critica.leitura.clienteCalculouPorProporcional\" style=\"margin: 5px 0px; font-size: 0.85em\">Projetada</span>\n</div><div><strong class=\"label-titulo-detalhe-leitura\">Matrícula:</strong>\n {{vm.critica.leitura.codigoClienteDigitoLigacao}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Cliente:\n</strong> {{vm.critica.leitura.nome}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Situação:</strong>\n {{vm.critica.leitura.descricaoSituacao}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Hidrômetro:</strong>\n {{vm.critica.leitura.hidrometro}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Economias:</strong>\n {{vm.critica.leitura.economias}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Endereço:</strong>\n {{vm.critica.leitura.endereco}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Média(m3):</strong>\n {{vm.critica.leitura.media}}</div><div><strong class=\"label-titulo-detalhe-leitura\">Data:</strong>\n {{vm.critica.leitura.dataHoraColeta | date: \'dd/MM/yyyy HH:mm:ss\'}}</div><div \nng-if=\"vm.critica.leitura.clienteCalculouPorProporcional\"><strong class=\"label-titulo-detalhe-leitura\">Data leitura:\n</strong> {{vm.critica.leitura.dataColetaGerada | date: \'dd/MM/yyyy\'}} <strong class=\"label-titulo-detalhe-leitura\">\nLeitura:</strong> {{vm.critica.leitura.leituraOriginalCalculoProporcional}}</div><div><strong \nclass=\"label-titulo-detalhe-leitura\">Observação:</strong> {{vm.critica.leitura.observacaoLeituraCritica}}</div><div \nflex=\"100\" class=\"mt-5\" layout=\"column\"><div flex=\"100\" class=\"p-4\"><table id=\"tabela-historico\" flex=\"100\" \nclass=\"dataTable row-border hover tabela-dados-leitura\"><thead><th \nclass=\"label-titulo-detalhe-leitura border-right border-left\">Mês/Ano</th><th \nclass=\"label-titulo-detalhe-leitura border-right\">Ocorrência</th><th class=\"label-titulo-detalhe-leitura border-right\">\nLeitura</th><th class=\"label-titulo-detalhe-leitura border-right\">Cons. (m3)</th></thead><tbody \nng-repeat=\"historico in vm.critica.leitura.historico\"><td class=\"text-center border-right border-left\">\n{{historico.mesAnoReferencia}}</td><td class=\"text-center border-right\">{{historico.ocorrencia}}</td><td \nclass=\"text-center border-right\">{{historico.leitura}}</td><td class=\"text-center border-right\">{{historico.consumo}}\n</td></tbody></table></div></div><div layout=\"column\" flex=\"100\" class=\"mt-5\"><table \nclass=\"dataTable row-border hover tabela-dados-leitura\"><thead><tr><th colspan=\"5\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\"><span \nclass=\"text-center label-titulo-detalhe-leitura\">Dados da primeira visita</span></div></th></tr><tr><th \nclass=\"label-titulo-detalhe-leitura border-left border-right\">Data</th><th \nclass=\"label-titulo-detalhe-leitura border-right\">Leitura</th><th class=\"label-titulo-detalhe-leitura border-right\">\nCons. (m3)</th><th class=\"label-titulo-detalhe-leitura border-right\">Oco.</th></tr></thead><tbody><td \nclass=\"text-center border-right border-left\"><span>{{ vm.historicoCritica[0].dataLeituraAntesCritica }}</span></td><td \nclass=\"text-center border-right\"><span>{{ vm.historicoCritica[0].leituraLidaAntesCritica }}</span></td><td \nclass=\"text-center border-right border-left\"><span>{{ vm.historicoCritica[0].consumoFaturadoAntesCritica }}</span></td>\n<td class=\"text-center border-right\"><span>{{ vm.historicoCritica[0].ocorrenciaAntesCritica }}</span></td></tbody>\n</table></div></div><div ng-form=\"formDadosCritica\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><md-input-container flex=\"50\" class=\"margin-left-right-bottom-0\"><label>Leitura\n</label><input type=\"text\" ng-disabled=\"vm.critica.leitura.criticaNoColetor || vm.critica.leitura.somenteOcorrencia \" \nng-change=\"vm.metodos.calcularConsumoPosCritica(vm.critica)\" mascara-numero-generica=\"########\" \nng-model-options=\"{debounce: 200}\" ng-model=\"vm.critica.leituraPosCritica\"><div \nng-if=\"vm.critica.leitura.somenteOcorrencia \" class=\"color-red\"><span>\nLeitura calc.: {{vm.critica.leitura.leituraFaturada}}</span></div></md-input-container><md-input-container flex=\"50\" \nclass=\"margin-left-right-bottom-0\"><label>Consumo</label><input type=\"text\" mascara-numero-generica=\"######\" \nng-disabled=\"vm.critica.leitura.criticaNoColetor \" ng-required=\"true\" name=\"consumoFaturado\" \nng-model=\"vm.critica.consumoFaturadoPosCritica\"><div ng-messages=\"formDadosCritica.consumoFaturado.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nflex=\"100\" layout=\"row\" layout-align=\"start center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoOcorrencia\"></md-progress-circular><md-input-container flex=\"100\" \nclass=\"margin-0\"><label>Ocorrência</label><md-select flex=\"100\" md-on-open=\"vm.metodos.configuraMdSelectOcorrencia()\" \nng-required=\"true\" ng-disabled=\"vm.critica.leitura.criticaNoColetor || vm.emProgressoOcorrencia \" \nng-change=\"vm.metodos.onChangeOcorrenciaCritica(vm.critica.codigoOcorrenciaPosCritica, vm.critica.leitura.nomeArquivoExportacao)\" \nname=\"selectOcorrenciaCritica\" ng-model=\"vm.critica.codigoOcorrenciaPosCritica\"><md-select-header><input \nng-model=\"vm.filtrarOcorrencia\" type=\"search\" id=\"select-ocorrencia\" placeholder=\"Pesquisar ocorrência..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"ocorrencia.codigo\" \nng-repeat=\"ocorrencia in vm.ocorrencias  | filter: vm.filtrarOcorrencia\">\n{{ocorrencia.codigo}} - {{ocorrencia.descricao}}</md-option></md-select><div \nng-messages=\"formDadosCritica.selectOcorrenciaCritica.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\"><md-input-container flex=\"100\" style=\"margin-left: 0!important\"><label>Status crítica\n</label><md-select ng-required=\"true\" name=\"selectStatusCritica\" ng-disabled=\"vm.critica.leitura.criticaNoColetor \" \nflex=\"100\" ng-model=\"vm.critica.statusCritica\"><md-option ng-value=\"2\">Revisão</md-option><md-option ng-value=\"4\">\nRevisão com impressão</md-option><md-option ng-value=\"3\">Impressão</md-option></md-select><div \nng-messages=\"formDadosCritica.selectStatusCritica.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around\"><div><md-checkbox ng-disabled=\"vm.critica.leitura.criticaNoColetor \" \nng-model=\"vm.critica.erroPorLeitura\"><strong class=\"label-titulo-detalhe-leitura\">Erro Leitura</strong></md-checkbox>\n</div><div><md-checkbox ng-model=\"vm.critica.erroPorOcorrencia\" ng-disabled=\"vm.critica.leitura.criticaNoColetor \">\n<strong class=\"label-titulo-detalhe-leitura\">Erro Ocorrência</strong></md-checkbox></div></div><div flex=\"100\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container flex=\"100\" class=\"margin-0\"><label for=\"\">Motivo</label>\n<textarea ng-required=\"vm.critica.erroPorLeitura || vm.critica.erroPorOcorrencia\" md-maxlength=\"100\" name=\"motivo\" \nng-disabled=\"vm.critica.leitura.criticaNoColetor \" ng-model=\"vm.critica.motivoCriticaNegada\" cols=\"10\" rows=\"2\">\n</textarea><div ng-messages=\"formDadosCritica.motivo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nng-if=\"!vm.emProgressoHist\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgressoCritica\"></md-progress-circular>\n<md-button flex=\"100\" \nng-disabled=\"vm.emProgressoCritica || !formDadosCritica.$valid || vm.critica.leitura.criticaNoColetor\" \nng-click=\"vm.metodos.validarExecucaoCritica(vm.critica)\" class=\"md-raised md-accent\">Salvar</md-button></div></div>\n</div></fieldset><div ng-if=\"vm.emProgressoHist\" flex=\"100\" style=\"height: 100%\" layout=\"row\"><div flex=\"100\" \nstyle=\"height: 10vh\" layout-align=\"center center\" layout=\"row\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div><div class=\"div-fotos\" layout=\"row\" \nng-if=\"vm.critica.leitura.fotos.length && !vm.emProgressoHist\" flex=\"25\" \nstyle=\"overflow-x: auto;margin: 4px;max-width:40vw\"><div \nng-click=\"!vm.dialogFotosAberto && vm.metodos.abrirDialogDetalheFoto(foto.url)\" \nstyle=\"min-width:150px;padding-right: 8px;cursor: pointer\" \nng-repeat=\"foto in vm.critica.leitura.fotos track by $index\" layout=\"column\" layout-align=\"center center\"><img \nwidth=\"150px\" height=\"100px\" src=\"{{vm.urlApi + foto.url}}\" alt=\"\"> <span>{{foto.data | date: \'dd/MM/yyyy\'}}</span>\n</div></div></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/views/critica-leituras.html","<div id=\"critica-leituras\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.EXECUCAO_CRITICAS\" icone=\"icon-file-document\" pesquisar=\"vm.pesquisar\" \nng-if=\"!vm.leiturasRetidas.length\" \nliberar-pesquisa-quando-datatable-ativo=\"vm.leiturasRetidas.length > 0 && !vm.emProgresso\" \nng-utiliza-pesquisa=\"vm.leiturasRetidas.length > 0 && !vm.emProgresso\"></header-padrao><div class=\"content\"><div \nui-view=\"criticaleituras-form\"></div></div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/views/resumo-retencoes.html","<md-content id=\"resumoretencoes\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"Resumo de retenções\" icone=\"icon-poll\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"fab-button\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><fab-button buttons=\"vm.menus\" \ntitulo-menu=\"Menu\" disabled=\"vm.emProgresso\"></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" \nflex ms-scroll><div ng-if=\"vm.tipoSimplificadoOuDetalhado && vm.tipoFaturaOuComunicado\" \nui-view=\"dashboards-resumoretencoes-faturassimplificado-form@app.gerenciamento.dashboards_resumoretencoes\"></div><div \nng-if=\"!vm.tipoSimplificadoOuDetalhado && vm.tipoFaturaOuComunicado\" \nui-view=\"dashboards-resumoretencoes-faturasdetalhado-form@app.gerenciamento.dashboards_resumoretencoes\"></div><div \nng-if=\"vm.tipoSimplificadoOuDetalhado && !vm.tipoFaturaOuComunicado\" \nui-view=\"dashboards-resumoretencoes-comunicadossimplificado-form@app.gerenciamento.dashboards_resumoretencoes\"></div>\n<div ng-if=\"!vm.tipoSimplificadoOuDetalhado && !vm.tipoFaturaOuComunicado\" \nui-view=\"dashboards-resumoretencoes-comunicadosdetalhado-form@app.gerenciamento.dashboards_resumoretencoes\"></div>\n</div></div></md-content>");
$templateCache.put("app/main/gerenciamento/critica/acompanhamento/views/acompanhamento-critica-form.html","<div id=\"acompanhamento-criticas-form\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-acompanhamento-criticas\" md-whiteframe=\"4\" ui-view=\"filtro-acompanhamento-sidenav\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" ng-if=\"!vm.informacoesCritica && !vm.emProgresso\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"PROCESSAMENTO.DISTRIBUICAO.SEM_GRUPO\">Nenhum grupo de leituras selecionado.</div>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroAcompanhamentoCritica()\"><span \ntranslate=\"RESOURCES.FILTRAR\">Filtrar</span></md-button></div></div><md-content flex ng-if=\"vm.emProgresso\">\n<carregamento-circular ng-if=\"vm.emProgresso\" em-progresso=\"vm.emProgresso\" mensagem=\"Carregando dados...\" \ntitulo=\"Aguarde...\"></carregamento-circular></md-content><md-content layout=\"column\" layout-padding flex=\"100\" \nng-if=\"vm.informacoesCritica && !vm.emProgresso\"><div layout-gt-sm=\"row\" layout-align=\"space-between\" flex=\"100\"><div \nlayout-align=\"start start\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"90\"><div layout=\"row\" flex=\"100\" \nsclass=\"div-card\"><ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">Agrupamento</div><div \nclass=\"font-size-16\" style=\"text-align: center\">\n{{ vm.filtros.regional }}-{{ vm.filtros.agrupamento.descricao.substring(6, vm.agrupamento.descricao.length).trim() }}\n</div></div></ms-widget-front></ms-widget></div><div layout=\"row\" flex=\"100\" sclass=\"div-card\"><ms-widget class=\"h-80\" \nstyle=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"font-weight-500 font-size-16\">Grupo</div><div class=\"font-size-16\" style=\"text-align: center\" \nng-if=\"vm.filtros.grupo === undefined\">Todos</div><div class=\"font-size-16\" style=\"text-align: center\" \nng-if=\"vm.filtros.grupo != undefined\">{{ vm.filtros.grupo }}</div></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" flex=\"100\" sclass=\"div-card\"><ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">\nMunicípio</div><div class=\"font-size-16\" style=\"text-align: center\" ng-if=\"vm.filtros.municipio === undefined\">Todos\n</div><div class=\"font-size-16\" style=\"text-align: center\" ng-if=\"vm.filtros.municipio != undefined\">\n{{ vm.filtros.municipio }}-{{ vm.filtros.municipioDetalhes.descricao}}</div></div></ms-widget-front></ms-widget></div>\n<div layout=\"row\" flex=\"100\" sclass=\"div-card\"><ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div \nclass=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">\nReferência</div><div class=\"font-size-16\" style=\"text-align: center\">{{ vm.filtros.mes }}/{{ vm.filtros.ano }}</div>\n</div></ms-widget-front></ms-widget></div></div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"width:100%\"><thead><th class=\"secondary-text border-right border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Referência</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\">Pendente</span>\n</div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\">%\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Lido (sem crítica)</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">%</span></div></th><th class=\"secondary-text border-right\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Em crítica</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\">%</span></div>\n</th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\">Criticado\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">%</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Total de leituras</span></div></th></thead><tbody><tr \nng-repeat=\"data in vm.informacoesCritica.dados track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{data.agrupamento}} - {{data.grupo}} - {{data.mesAnoReferencia}}</span></td><td class=\"text-center border-right\">\n<span>{{data.leiturasNaoLidas | number}}</span></td><td class=\"text-center border-right\"><span>\n{{data.porcentagemLeiturasNaoLidas}}</span></td><td class=\"text-center border-right\"><span>\n{{data.leiturasLidas | number}}</span></td><td class=\"text-center border-right\"><span>{{data.porcentagemLeiturasLidas}}\n</span></td><td class=\"text-center border-right\"><span>{{data.criticasARealizar | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{data.porcentagemCriticasNaoRealizadas}}</span></td><td \nclass=\"text-center border-right\"><span>{{data.criticasRealizadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{data.porcentagemCriticasRealizadas}}</span></td><td \nclass=\"text-center border-right\"><span>{{data.totalLeituras | number }}</span></td></tr></tbody><tfoot><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">Total</span></div>\n</th><th class=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.totalLeiturasNaoLidas | number}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.porcentagemTotalLeiturasNaoLidas }}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.totalLeiturasLidas | number}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.porcentagemTotalLeiturasLidas}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.totalCriticasNaoRealizadas | number}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.porcentagemTotalCriticasNaoRealizadas}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.totalCriticasRealizadas | number}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\"><span class=\"text-center\">\n{{vm.informacoesCritica.totalizador.porcentagemTotalCriticasRealizadas}}</span></div></th><th \nclass=\"secondary-text border-right border-left\"><div class=\"text-center\" style=\"padding-right: 18px\"><span>\n{{vm.informacoesCritica.totalizador.totalLeituras | number}}</span></div></th></tfoot></table></md-content></div>");
$templateCache.put("app/main/gerenciamento/critica/acompanhamento/views/acompanhamento-critica.html","<md-content id=\"acompanhamento-criticas\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"RESOURCES.ACOMPANHAMENTO_CRITICAS\" icone=\"icon-file-document\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\"><div class=\"fab-button\" ng-if=\"vm.informacoesCritica && !vm.emProgresso\">\n<fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\"></fab-button></div><div \nui-view=\"acompanhamento-critica-form@app.gerenciamento_critica_acompanhamento\"></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/views/rastreamento-leiturista.html","<div id=\"rastreamento-leiturista-html\" class=\"page-layout simple fullwidth doc-page rastreamento-leiturita-html\" \nlayout=\"column\" flex layout-fill><header-padrao translate-nome=\"LEITURA.RASTREAMENTO.TITULO\" icone=\"icon-map\" \nhabilitar-icone-voltar-ao-estado-anterior=\"vm.habilitarIconeVoltarATelaDeCliente\" \nvoltar-ao-estado-anterior=\"vm.metodos.implementarVoltarParaOEstado()\" \nmensagem-tooltip-icone-estado-anterior=\"vm.mensagemTooltipIconeEstadoAnteriorHeaderPadrao\" \nliberar-pesquisa-quando-datatable-ativo=\"false\" pesquisar=\"vm.pesquisar\" ng-utiliza-pesquisa=\"false\" \nng-hide=\"vm.habilitarMapa\"></header-padrao><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.preLoader\" \nflex><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"70\" class=\"md-accent\"></md-progress-circular></div><div\n class=\"button-float\" ng-show=\"vm.habilitarMapa\"><div layout=\"column\"><div class=\"button-toogle\" \nng-click=\"vm.metodos.centralizarMapa(vm.dados)\"><md-tooltip md-autohide id=\"pg-tooltip-centralizar-mapa\" \nmd-direction=\"left\"><span translate=\"RESOURCES.CENTRALIZAR_MAPA\">Centralizar mapa</span></md-tooltip><md-icon \nmd-font-icon=\"icon-crosshairs-gps\" class=\"white-text md-font material-icons icon-crosshairs-gps md-default-theme\" \nrole=\"img\" aria-label=\"icon-crosshairs-gps\"></md-icon></div><div class=\"button-toogle\" \nng-click=\"vm.metodos.abrirFiltros()\"><md-tooltip md-autohide id=\"pg-tooltip-filtrar\" md-direction=\"left\"><span \ntranslate=\"RESOURCES.FILTRAR\">Filtrar</span></md-tooltip><md-icon md-font-icon=\"icon-filter\" \nclass=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" aria-label=\"icon-cog\"></md-icon></div>\n<div class=\"button-toogle\" ng-click=\"vm.metodos.abrirLegendas()\"><md-tooltip md-autohide id=\"pg-tooltip-legenda\" \nmd-direction=\"left\"><span translate=\"RESOURCES.LEGENDA\">Legenda</span></md-tooltip><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></div><div class=\"button-toogle\" ng-show=\"vm.habilitarIconeVoltarATelaDeCliente\" \nng-click=\"vm.metodos.implementarVoltarParaOEstado()\"><md-icon md-font-icon=\"icon-keyboard-backspace\" \nclass=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" aria-label=\"icon-cog\"></md-icon></div>\n</div></div><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"filtro-rastreamento-leiturista\" md-whiteframe=\"4\" ui-view=\"gerenciamento-leiura-rastreamento--filtro\" \nms-scroll md-is-open=\"true\" ms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"legenda\" md-whiteframe=\"4\" ui-view=\"gerenciamento-leiura-rastreamento--legenda\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"imagem-background\" ng-show=\"!vm.preLoader\" layout=\"column\" \nng-if=\"!vm.habilitarMapa\" flex></div><div layout=\"column\" flex ng-show=\"vm.habilitarMapa\"><div \nstyle=\"height: 800px;width: auto\" ui-view=\"gerenciamento-leiura-rastreamento--mapa\"></div></div></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/leitura-visualizacao-form.html","<div class=\"md-background-bg md-whiteframe-1dp\" id=\"leitura-visualizacao\"><form name=\"vm.form\" novalidate><pg-toolbar \nclass=\"toolbar-fixa\" entidades=\"vm.ResultadodadosCadastrais\" entidade=\"vm.dadosCadastrais\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" esconder-botao-editar=\"true\" esconder-botao-excluir=\"true\" \nesconder-botao-inserir=\"true\" esconder-botao-salvar=\"!vm.editandoLeituraComRetencao\" \ndesabilitar-botao-salvar=\"!vm.editandoLeituraComRetencao\" esconder-botao-nova-pesquisa=\"true\" \nesconder-botao-pesquisar=\"true\" esconder-botao-reverter=\"!vm.editandoLeituraComRetencao\" \ndesabilitar-botao-reverter=\"!vm.editandoLeituraComRetencao\" esconder-botao-atualizar=\"true\" \nesconder-botao-modo-tabela=\"true\" esconder-botao-listar-todas-entidades=\"true\" esconder-mensagem-status=\"true\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-editar=\"vm.tabSelecionada === \'critica\' && vm.metodos.editar()\" \ncontrolador-pre-loader=\"controladorPreLoader\" controlador-toolbar=\"vm.controleForm\" \nmetodo-externo-acao-reverter=\"vm.editandoLeituraComRetencao && vm.metodos.fecharDialog()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" iniciar-habilitando-edicao=\"vm.editandoLeituraComRetencao\" \ncampo-pesquisar=\"vm.pesquisar\" ng-hide=\"!vm.dados\"></pg-toolbar><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-right\" md-component-id=\"filtro\" md-whiteframe=\"4\" ms-scroll md-is-open=\"true\" \nms-sidenav-helper><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><md-content class=\"content-filtro\" flex><fieldset class=\"standard\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><legend class=\"grp-legend\"><span \ntranslate=\"LEITURA.VISUALIZACAO.REGIONAL\"></span></legend><div layout=\"column\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.REGIONAL\"></label><md-select \nname=\"regional\" id=\"estatisticas-slcregional\" ng-change=\"vm.metodos.onChangeRegional()\" \nng-model=\"vm.filtroSelecionado.regional\" ng-required=\"true\"><md-option ng-value=\"item.codigo\" \nng-repeat=\"item in vm.listaRegionais\">{{item.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\" flex-gt-sm=\"100\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.listandoMunicipios\">\n</md-progress-circular><md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.MUNICIPIO\">\n</label><md-select name=\"municipio\" id=\"estatisticas-slcmunicipio\" ng-model=\"vm.filtroSelecionado.municipio\" \nng-disabled=\"!vm.filtroSelecionado.regional || vm.listandoMunicipios\"><md-option ng-value=\"item.codigo\" \nng-if=\"vm.listaMunicipios.length <= 0\">Nenhum município encontrado</md-option><md-option ng-value=\"item.codigo\" \nng-repeat=\"item in vm.listaMunicipios\">{{item.descricao}}</md-option></md-select></md-input-container></div></div>\n</fieldset><fieldset class=\"standard referencia-fieldset\"><legend class=\"grp-legend\">Referência</legend><div \nlayout=\"row\" layout-align=\"center center\" flex class=\"container-referencia\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"LEITURA.VISUALIZACAO.MES\"></label><input type=\"text\" ui-number-mask=\"0\" \nng-required=\"true\" id=\"cadastro-entrega-tipo-entrega-mes\" ng-blur=\"vm.metodos.setDefaultMes()\" name=\"mes\" \nmin-value=\"1\" max-value=\"12\" ng-required=\"true\" ng-model=\"vm.filtroSelecionado.mes\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"LEITURA.VISUALIZACAO.ANO\">ANO</label><input \ntype=\"text\" name=\"ano\" ng-blur=\"vm.metodos.setDefaultAno()\" id=\"cadastros-leiturista-tabimpressao-txtmodelo\" \nui-number-mask=\"0\" ui-hide-group-sep ng-required=\"true\" ng-model=\"vm.filtroSelecionado.ano\"></md-input-container></div>\n</fieldset><fieldset class=\"standard\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"><legend \nclass=\"grp-legend\">Leituras com foto</legend><div layout=\"row\" layout-align=\"center center\" flex><md-checkbox \nname=\"somenteLeiturasComFotos\" ng-model=\"vm.filtroSelecionado.somenteLeiturasComFotos\" \naria-label=\"Filtrar somente leituras com foto.\"><span>Filtrar somente leituras com foto</span></md-checkbox></div>\n</fieldset><fieldset class=\"standard fieldset-parametros\"><legend class=\"grp-legend\">Parâmetro</legend><div \nlayout-align=\"center center\" flex class=\"container-radio-button\"><md-radio-group class=\"md-primary\" \nlayout-gt-sm=\"column\" ng-model=\"vm.opcaoFiltro\" ng-change=\"vm.metodos.limparFiltrosRadio()\" required flex><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-radio-button ng-repeat=\"filtro in vm.filtros.slice(0, 2)\" ng-value=\"filtro\" \nlayout=\"center center\" style=\"margin: 5px\" flex>{{ filtro }}</md-radio-button></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-radio-button ng-repeat=\"filtro in vm.filtros.slice(2)\" ng-value=\"filtro\" layout=\"center center\" \nstyle=\"margin: 5px\" flex>{{ filtro }}</md-radio-button></div></md-radio-group></div><div layout=\"column\" flex><div \nlayout=\"row\" flex ng-hide=\"vm.opcaoFiltro != \'Leiturista\'\"><md-input-container class=\"md-block\" flex=\"15\"><input \ntype=\"text\" ng-model=\"vm.filtroSelecionado.codigoLeiturista\" ng-required=\"vm.opcaoFiltro == \'Leiturista\'\" \nid=\"cadastros-leituristae-txtCodigoLeiturista\" ng-disabled=\"vm.opcaoFiltro != \'Leiturista\'\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" mascara-numero-generica=\"#####\" aria-label=\"RESOURCES.LEITURISTA\">\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-required=\"vm.opcaoFiltro == \'Leiturista\'\" \nname=\"leiturista\" ng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" id=\"cadastros-leiturista-txtDescricaoLeiturista\" \nng-model=\"vm.filtroSelecionado.codigoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-disabled=\"vm.opcaoFiltro != \'Leiturista\'\"><md-select-header class=\"demo-select-header\"><input id=\"select\" \nname=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" placeholder=\"Pesquisar...\"></md-select-header>\n<md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">{{leiturista.apelido}}\n</md-option></md-select><div ng-messages=\"vm.form.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex ng-hide=\"vm.opcaoFiltro != \'Cliente\'\"><label translate=\"LEITURA.VISUALIZACAO.CLIENTE\">Cliente\n</label><input type=\"text\" ng-required=\"vm.opcaoFiltro  == \'Cliente\'\" name=\"filtroCliente\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ng-model=\"vm.filtroSelecionado.cliente\" \nng-disabled=\"vm.opcaoFiltro != \'Cliente\'\"><div ng-messages=\"vm.form.filtroCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex ng-hide=\"vm.opcaoFiltro != \'Hidrômetro\'\"><label translate=\"LEITURA.VISUALIZACAO.HIDROMETRO\">Hidrometro</label>\n<input type=\"text\" ng-required=\"vm.opcaoFiltro  == \'Hidrômetro\'\" name=\"filtroHidrometro\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ng-model=\"vm.filtroSelecionado.hidrometro\" \nng-disabled=\"vm.opcaoFiltro != \'Hidrômetro\'\"><div ng-messages=\"vm.form.filtroHidrometro.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div>\n</fieldset><div layout=\"column\" layout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.form.$invalid || vm.controleForm.emProgresso\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" ng-click=\"vm.metodos.pesquisarBotao()\" \nng-if=\"!vm.emProgresso\"><span>Pesquisar</span></md-button></div></md-content></md-sidenav><md-content layout-padding \nng-hide=\"vm.controleForm.listarTodasEntidades || !vm.dados\" ng-disabled=\"vm.controleForm.emProgresso\"><div \nclass=\"button-float\"><md-button class=\"md-primary button-toogle icon-filter-outline md-fab\" \nng-click=\"vm.metodos.abrirFiltro()\" ng-hide=\"vm.habilitaBotaoSidenav()\"></md-button></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex=\"100\"><div layout=\"row\" flex-xs=\"100\" layout-align=\"start center\"><span \nclass=\"ml-16 text-boxed blue-bg white-fg ng-binding\" ng-hide=\"!vm.dadosCadastrais.statusLeitura\" \nstyle=\"margin: 5px 0px; font-size: 0.75em\">{{vm.dadosCadastrais.statusLeitura}}</span></div><div layout=\"row\" \nflex-xs=\"100\" layout-align=\"start center\"><span \nclass=\"ml-16 text-boxed yellow-700-bg black-fg ng-binding status-critica\" ng-if=\"vm.leituraComCritica\" \nstyle=\"font-size: 0.75em\">Leitura com crítica</span></div><div layout=\"row\" flex-xs=\"100\" layout-align=\"start center\">\n<span class=\"ml-16 text-boxed md-teal-900-bg white-fg ng-binding status-critica\" \nng-if=\"vm.leituraComCriticaPendenteExecucao\" style=\"font-size: 0.75em\">Leitura com crítica pendente de execução</span>\n</div></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Dados cadastrais\" id=\"dados-cadastrais-tab\" \nmd-active=\"vm.tabSelecionada === \'dadosCadastrais\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosCadastrais\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_CADASTRAIS\"></label></md-tab-label><md-tab-body><md-content \nng-include=\"vm.rotasHtml.tabs.dadosCadastrais\"></md-content></md-tab-body></md-tab><md-tab label=\"Dados Leitura\" \nid=\"dados-leitura-tab\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || vm.controleForm.emProgresso \" \nmd-active=\"vm.tabSelecionada === \'dadosLeitura\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosLeitura\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_LEITURA\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosLeituraController as vm\"><md-content ng-include=\"vm.rotasHtml.tabs.dadosLeitura.templateUrl\">\n</md-content></div></md-tab-body></md-tab><md-tab label=\"Dados Faturamento\" id=\"dados-faturamento-tab\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || (vm.controleForm.emProgresso && !vm.controleForm.habilitarAbaFaturamento)\" \nmd-active=\"vm.tabSelecionada === \'dadosFaturamento\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosFaturamento\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_FATURAMENTO\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosFaturamentoController as vm\"><div ng-include=\"vm.rotasHtml.tabs.dadosFaturamento.templateUrl\">\n</div></div></md-tab-body></md-tab><md-tab label=\"Dados crítica\" id=\"dados-critica-tab\" \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || vm.controleForm.emProgresso || !vm.leituraComCritica\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_CRITICA\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosCriticaController as vm\"><div ng-include=\"vm.rotasHtml.tabs.dadosCritica.templateUrl\"></div></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/leitura-visualizacao.html","<div id=\"visualizacao-leitura\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"LEITURA.VISUALIZACAO.TITULO\" icone=\"icon-engine\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nclass=\"content\"><div ui-view=\"leitura-visualizacao-form@app.gerenciamento_leitura_visualizacao\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div><div \nui-view=\"leitura-visualizacao-form-caema@app.gerenciamento_leitura_visualizacao\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></div></div></div>");
$templateCache.put("app/main/gerenciamento/leitura/cancelamento-dinamico/views/cancelamento-dinamico-form.html","<div layout=\"column\" id=\"cancelamentodinamico-form\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando senha...\"></carregamento-circular><form name=\"vm.form\"><md-content layout-padding layout=\"column\" flex \nlayout-align=\"center center\"><fieldset class=\"standard\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\" flex><md-input-container class=\"md-block\" id=\"input-cliente\" flex=\"40\" flex-xs=\"70\">\n<label>Código ligação</label><input type=\"text\" ng-required=\"true\" name=\"cliente\" ng-model=\"vm.filtro.cliente\"><div \nng-messages=\"vm.form.cliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-list-item class=\"md-block\" flex=\"40\" flex-xs=\"100\"><md-input-container layout=\"column\" \nflex id=\"input-leiturista\"><label translate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select \nng-model=\"vm.filtro.leiturista\" md-on-open=\"vm.metodos.configuraMdSelectLeiturista()\" name=\"leiturista\" \nng-disabled=\"vm.leituristas.length == 0\" ng-required=\"true\"><md-select-header ng-if=\"vm.leituristas.length > 0\"><input \nng-model=\"vm.filtrarLeiturista\" type=\"search\" id=\"select-leiturista\" placeholder=\"Pesquisar leiturista..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter: vm.filtrarLeiturista\">{{leiturista.codigo}} - {{leiturista.apelido}}\n</md-option></md-select><span ng-if=\"vm.leituristas.length == 0\" class=\"nenhum-grupo\">Nenhuma leiturista encontrado.\n</span><div ng-messages=\"vm.form.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><div flex=\"20\" \nflex-xs=\"100\" layout-align-xs=\"center center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid || vm.emProgresso\" ng-click=\"vm.metodos.gerarSenha(vm.filtro)\"><span>Gerar</span>\n</md-button></div></div></fieldset></md-content></form><md-content layout-padding layout=\"column\" flex \nlayout-align=\"center center\" ng-if=\"vm.senha\"><div class=\"ms-card-content-wrapper white-bg\"><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div \nclass=\"h3 secondary-text font-size-30 line-height-72 font-weight-500\">Senha</div><div \nclass=\"light-blue-fg font-size-40 line-height-72\">{{ vm.senha }}</div></div><div class=\"p-16 grey-50-bg\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 secondary-text text-truncate\">Valido até:</span> <span class=\"h4 ml-8\">\n{{ vm.validade }}</span></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/leitura/cancelamento-dinamico/views/cancelamento-dinamico.html","<md-content id=\"cancelamentodinamico\" class=\"page-layout simple tabbed\" layout=\"column\"><header-padrao \ntranslate-nome=\"LEITURA.CANCELAMENTO_DINAMICO.TITULO\" icone=\"icon-close-circle-outline\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" flex ms-scroll><div \nui-view=\"leitura-cancelamentodinamico-form@app.gerenciamento.leitura_cancelamentodinamico\"></div></div></div>\n</md-content>");
$templateCache.put("app/main/gerenciamento/leitura/monitoramento/views/monitoramento.html","<div id=\"monitoramento\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\" flex layout-fill><div \nid=\"imagem-background\" layout=\"column\" flex><form name=\"vm.form\" novalidate><div class=\"botao-lateral-flutante\" \nrole=\"button\"><div layout=\"column\"><div class=\"btn md-primary-bg\" ng-if=\"vm.habilitarMapa\" \nng-click=\"vm.metodos.centralizarMapa()\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\">\n<span translate=\"RESOURCES.CENTRALIZAR_MAPA\">Centralizar mapa</span></md-tooltip><md-icon \nmd-font-icon=\"icon-crosshairs-gps\" class=\"white-text md-font material-icons icon-crosshairs-gps md-default-theme\" \nrole=\"img\" aria-label=\"icon-crosshairs-gps\"></md-icon></div><div class=\"btn md-primary-bg\" \nng-click=\"vm.metodos.abrirFiltros()\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span \ntranslate=\"RESOURCES.FILTRAR\">Filtrar</span></md-tooltip><md-icon md-font-icon=\"icon-filter\" \nclass=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" aria-label=\"icon-cog\"></md-icon></div>\n<div class=\"btn md-primary-bg\" ng-click=\"vm.metodos.abrirLegenda()\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\" md-direction=\"left\"><span translate=\"RESOURCES.LEGENDA\">Legenda</span></md-tooltip>\n<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"white-text md-font material-icons icon-information-outline md-default-theme\" role=\"img\" \naria-label=\"icon-information-outline\"></md-icon></div><div class=\"btn md-primary-bg\" \nng-show=\"vm.habilitarIconeVoltarATelaCarga\" ng-click=\"vm.metodos.implementarVoltarParaOEstado()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\" class=\"white-text md-font material-icons icon-cog md-default-theme\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></div></div></div><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"filtro\" ms-sidenav-helper ui-view=\"gerenciamento-leitura-monitoramento--filtro\"></md-sidenav>\n<md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll md-component-id=\"legenda\" ms-sidenav-helper \nui-view=\"gerenciamento-leitura-monitoramento--legenda\"></md-sidenav><md-sidenav \nclass=\"dashboard-sidenav md-sidenav-left\" md-component-id=\"dashboard\" \nui-view=\"gerenciamento-leitura-monitoramento--dashboard\" ms-scroll ms-sidenav-helper></md-sidenav><div layout=\"column\" \nflex ng-show=\"vm.habilitarMapa\"><div style=\"height: 800px;width: auto\" \nui-view=\"gerenciamento-leitura-monitoramento--mapa\"></div></div></form></div></div>");
$templateCache.put("app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-baixar-arquivo-retorno.html","<md-dialog id=\"gerenciamento-carga-dialog-baixar-arquivo-retorno\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodosGeral.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.GERACAO_ARQUIVO_RETORNO\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll ui-view=\"geracaoarquivo-form@app.gerenciamento_carga\"></div></md-dialog>");
$templateCache.put("app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-disponibilizar-carga.html","<md-dialog id=\"gerenciamento-carga-dialog-dipsonilizar-carga\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodosGeral.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.EXPORTACAO_MOBILE\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll ui-view=\"disponibilizar-carga@app.gerenciamento_carga\"></div></md-dialog>");
$templateCache.put("app/main/gerenciamentocarga/leiturista/views/dialogs/gerenciamento-carga-dialog-disponibilizar-tarefas.html","<md-dialog id=\"gerenciamento-carga-dialog-dipsonilizar-tarefa\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.DISPONIBILIZAR_TAREFAS\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll ui-view=\"disponibilizar-tarefas@app.gerenciamento_carga\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></div><div ms-scroll \nui-view=\"disponibilizar-tarefas-caema@app.gerenciamento_carga\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\">\n</div></md-dialog>");
$templateCache.put("app/main/gerenciamentocarga/sidenavs/filtro/views/gerenciamento-carga-filtro.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2></div>\n</md-toolbar><form name=\"vm.form\" novalidate flex><md-content class=\"content-filtro-gerenciamento-carga\" \nlayout-padding><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Configurações</span></legend>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.MONITORAMENTO.FILTROS.INTERVALO\">\nIntervalo (segundos)</label><md-select name=\"tipoSegmento\" id=\"cadastro-parametros-tabempresa-slctTipoSegmento\" \nng-model=\"vm.filtros.intervalo\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.emProgresso\"><md-option ng-value=\"intervalo\" ng-repeat=\"intervalo in vm.intervalos\">\n{{intervalo.descricao}}</md-option></md-select></md-input-container></fieldset><fieldset class=\"standard\" flex \nng-if=\"vm.parametros.utilizaCadastroRegional\"><legend class=\"grp-legend\"><span>Agrupamento</span></legend>\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.REGIONAL\"></label><md-select name=\"regional\" \nid=\"gerenciamento-carga-slcregional\" ng-model=\"vm.filtros.regionalId\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>\nData refêrencia</span></legend><div flex class=\"input-periodo\"><md-input-container class=\"md-block\"><label \ntranslate=\"GERENCIAMENTO_CARGA.FILTRO.DATA_REFERENCIA\"></label><md-datepicker ng-model=\"vm.filtros.data\" \nname=\"filtroData\" md-max-date=\"vm.dataAtual\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data \nng-required=\"true\" ng-disabled=\"vm.emProgresso\"></md-datepicker><div ng-messages=\"vm.form.filtroData.$error\"><div \nng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid\" ng-if=\"!vm.emProgresso\" ng-click=\"vm.metodos.atualizarDataReferencia(vm.filtros)\"><span>\nPesquisar</span></md-button><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.emProgresso\" class=\"md-accent\" \nmd-diameter=\"54\"></md-progress-circular></div></div><div class=\"disponibilizar-carga-tarefa text-center\"><span \nng-click=\"vm.metodos.disponibilizarCarga()\" ng-if=\"vm.parametros.tipoProcesso === \'01\'\">Disponibilizar carga </span>\n<span ng-click=\"vm.metodos.disponibilizarCarga()\" ng-if=\"vm.parametros.tipoProcesso === \'02\'\">Disponibilizar tarefa\n</span></div></md-content></form>");
$templateCache.put("app/main/controlecarga/faturas-retidas/components/sidenav/sidenav-faturas-retidas.html","<div id=\"sidenav-faturas-retidas\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex ng-submit=\"vm.metodos.filtrar(vm.filtro)\" \nng-disabled=\"vm.form.$invalid || vm.erroReferenciaInicial || vm.erroReferenciaFinal\"><md-radio-group \nstyle=\"margin-top: 10px\" layout=\"row\" flex ng-change=\"vm.metodos.onChangeTipoFiltro(vm.filtro)\" \nng-model=\"vm.filtro.tipoFiltro\" layout-align=\"center center\"><md-radio-button ng-value=\"1\">Mês/Ano referência\n</md-radio-button><md-radio-button ng-value=\"2\">Período</md-radio-button></md-radio-group><md-content class=\"content\" \nstyle=\"padding: 10px\" layout=\"column\"><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span \nng-if=\"vm.filtro.tipoFiltro == 1\">Referência </span><span ng-if=\"vm.filtro.tipoFiltro == 2\">Período</span></legend><div\n layout=\"row\" flex ng-if=\"vm.filtro.tipoFiltro === 1\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\" flex=\"20\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mesReferencia\" \nmascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesReferencia\" validacao-mes ng-required=\"vm.filtro.tipoFiltro === 1\" \nng-disable=\"vm.filtro.tipoFiltro != 1\"><div ng-messages=\"vm.form.mesReferencia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"25\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"anoReferencia\" \nmascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoReferencia\" ng-required=\"vm.filtro.tipoFiltro === 1\" \nng-disable=\"vm.filtro.tipoFiltro != 1\" validacao-ano><div ng-messages=\"vm.form.anoReferencia.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"column\" flex ng-if=\"vm.filtro.tipoFiltro === 2\"><div layout=\"row\" flex layout-align=\"center center\" \nstyle=\"margin-bottom: -25px\"><span style=\"margin-bottom: 25px\">De:</span><md-input-container class=\"md-block\" \nflex=\"20\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mesReferenciaInicial\" \nmascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesReferenciaInicial\" ng-required=\"vm.filtro.tipoFiltro === 2\" \nng-disable=\"vm.filtro.tipoFiltro != 2\" ng-change=\"vm.metodos.onChangeReferenciaPeriodo()\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mesReferenciaInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"25\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"anoReferenciaInicial\" \nmascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoReferenciaInicial\" ng-required=\"vm.filtro.tipoFiltro === 2\" \nng-disable=\"vm.filtro.tipoFiltro != 2\" ng-change=\"vm.metodos.onChangeReferenciaPeriodo()\" ng-required=\"true\" \nvalidacao-ano><div ng-messages=\"vm.form.anoReferenciaInicial.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"center center\" ng-if=\"vm.erroReferenciaInicial\" style=\"margin-top: -5px\"><span \nstyle=\"color: red; text-align: center; margin-bottom: 10px; font-size: 12px\">\nA referência inicial não pode ser maior que a referência final</span></div><div layout=\"row\" flex \nlayout-align=\"center center\"><span style=\"margin-bottom: 25px\">Até:</span><md-input-container class=\"md-block\" \nflex=\"20\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mesReferenciaFinal\" \nmascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesReferenciaFinal\" \nng-change=\"vm.metodos.onChangeReferenciaPeriodo(vm.filtro.mesReferenciaFinal, vm.filtro.anoReferenciaFinal)\" \nvalidacao-mes ng-required=\"true\"><div ng-messages=\"vm.form.mesReferenciaFinal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"25\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"anoReferenciaFinal\" \nmascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoReferenciaFinal\" validacao-ano \nng-change=\"vm.metodos.onChangeReferenciaPeriodo(vm.filtro.mesReferenciaFinal, vm.filtro.anoReferenciaFinal)\" \nng-required=\"true\"><div ng-messages=\"vm.form.anoReferenciaFinal.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"center center\" ng-if=\"vm.erroReferenciaFinal\" style=\"margin-top: -30px\"><span \nstyle=\"color: red; text-align: center; margin-bottom: 10px; font-size: 12px\">\nA referência final não pode ser menor que a referência inicial</span></div></div></fieldset><fieldset class=\"standard\" \nflex><legend class=\"grp-legend\"><span>Parâmetro</span></legend><md-radio-group layout=\"row\" flex \nng-change=\"vm.metodos.onChangeTipoParametro(vm.filtro)\" ng-model=\"vm.filtro.tipoParametro\" \nlayout-align=\"center center\" name=\"tipoParametro\"><md-radio-button ng-value=\"1\">Todos</md-radio-button><md-radio-button\n ng-value=\"2\">Cliente</md-radio-button></md-radio-group><div layout=\"row\" flex ng-if=\"vm.filtro.tipoParametro === 2\" \nlayout-align=\"center center\" style=\"margin-bottom: -20px; margin-top: 5px\"><md-autocomplete \nng-required=\"vm.filtro.tipoParametro === 2\" md-input-name=\"codigoCliente\" md-no-cache=\"true\" \nmd-selected-item=\"vm.filtro.clienteSelecionado\" \nmd-selected-item-change=\"vm.metodos.alterarItemSelecionadoAutoCompleteCliente(item)\" \nmd-search-text=\"vm.textoDePesquisaAutoCompleteCliente\" \nmd-items=\"item in vm.metodos.pesquisarAutoCompleteClienteVinculado(vm.textoDePesquisaAutoCompleteCliente)\" \nmd-item-text=\"item.codigo + \' - \' + item.nome\" ng-blur=\"vm.metodos.configuraAutoCompleteClienteOnBlur()\" md-autoselect \nmd-floating-label=\"Cliente\" flex><md-item-template><span md-highlight-text=\"vm.textoDePesquisaAutoCompleteCliente\">\n{{item.codigo}} - {{item.nome}}</span></md-item-template><md-not-found><label>\nCliente inexistente ou não possui faturas retidas.</label></md-not-found><div \nng-messages=\"vm.form.codigoCliente.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-autocomplete></div></fieldset></md-content><div \nstyle=\"display: flex; justify-content: center; align-items: center; padding: 10px\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \ntype=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.erroReferenciaInicial || vm.erroReferenciaFinal\" ng-if=\"!vm.emProgresso\"><span>\nFiltrar</span></md-button></div></form></div>");
$templateCache.put("app/main/processamento/disponibilizar-tarefas/views/multiplos-grupos/disponibilizar-tarefas-form-multiplos-grupos.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.disponibilizarTarefasForm\" novalidate method=\"post\">\n<md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.REGIONAL\">Agrupamento</label><md-select \nng-model=\"vm.entidade.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\" !(vm.grupoTarefa) && vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span>\n<div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\" translate=\"RESOURCES.MES\">Mes</label><input type=\"text\" \nname=\"mes\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"vm.disponibilizarTarefasForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"15\" \nflex=\"100\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-model=\"vm.entidade.ano\" \nng-required=\"true\"><div ng-messages=\"vm.disponibilizarTarefasForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"25\" \nflex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.entidade.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-required=\"!(vm.grupoTarefa) && (vm.grupos.length > 0 && (vm.entidade.ano && vm.entidade.mes))\" name=\"grupo\" \nng-change=\"vm.metodos.realizarEventoChangeGrupo(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\" \nmultiple=\"multiple\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" \nmascara-numero-generica=\"####\" type=\"search\" id=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}\n</md-option></md-select><span ng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.disponibilizarTarefasForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex layout-align=\"center start\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\" \nstyle=\"margin-top: 15px\"></md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" \nflex=\"100\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.MUNICIPIO\">Município</label>\n<md-select ng-model=\"vm.entidade.municipio\" md-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" \nng-change=\"vm.metodos.pesquisarTarefasMultiplosGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo,vm.entidade.municipio)\" \nng-required=\" !(vm.grupoTarefa) && vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0 || vm.municipios == undefined\"><md-select-header \nng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" \nplaceholder=\"Pesquisar municipio..\" class=\"md-text\"></md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}} - {{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><md-checkbox name=\"critica\" \nng-model=\"vm.entidade.critica\" aria-label=\"Ligações com crítica\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.metodos.pesquisarTarefasMultiplosGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo,vm.entidade.municipio)\">\n<span>Ligações com crítica</span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"><div flex-gt-sm=\"50\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaTarefas\" style=\"margin-top: 15px\"></md-progress-circular>\n<md-input-container flex-gt-xs=\"45\" flex=\"100\"><label for=\"\" translate=\"RESOURCES.TAREFA\">Tarefa</label><md-select \nflex name=\"tarefa\" ng-required=\" !(vm.grupoTarefa) && (vm.tarefas.length > 0 && vm.entidade.grupo)\" \nmd-on-open=\"vm.metodos.configuraMdSelectTarefa()\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined && vm.entidade.grupo == undefined) || vm.tarefas.length == 0 || vm.tarefas == undefined\" \nng-model=\"vm.entidade.tarefa\" multiple=\"multiple\"><md-select-header ng-if=\"vm.tarefas.length > 0\"><input \nng-model=\"vm.filtrarTarefas\" mascara-numero-generica=\"###\" type=\"search\" id=\"select-tarefa\" \nplaceholder=\"Pesquisar tarefa..\" class=\"md-text\"></md-select-header><md-option ng-value=\"tarefa\" \nng-repeat=\"tarefa in vm.tarefas | filter: vm.filtrarTarefas\">{{ tarefa.descricao }}</md-option></md-select><span \nng-if=\"vm.tarefas.length == 0 && vm.entidade.grupo\" class=\"nenhum-grupo\">Nenhuma tarefa encontrada.</span><div \nng-messages=\"vm.disponibilizarTarefasForm.tarefa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"45\"><label class=\"md-subheader\" translate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required \nname=\"leiturista\" id=\"processamento-disponibilizartarefas-txtDescricaoLeiturista\" \nmd-on-open=\"vm.metodos.configurarSelect()\" ng-model=\"vm.entidade.leiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">\n{{leiturista.codigo}} - {{leiturista.apelido}}</md-option></md-select><div \nng-messages=\"vm.disponibilizarTarefasForm.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><md-divider></md-divider>\n<div layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"!vm.entidade.mes || !vm.entidade.ano || !vm.entidade.grupo  || !vm.entidade.tarefa || !vm.entidade.leiturista || vm.emProgresso\" \nng-click=\"vm.metodos.disponibilizarMultiplasTarefas(vm.entidade)\"><span translate=\"RESOURCES.DISPONIBILIZAR\">\nDisponibilizar</span></md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/disponibilizar-tarefas/views/CAEMA/disponibilizar-tarefas-form-caema.html","<div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"vm.disponibilizarTarefasForm\" novalidate method=\"post\">\n<md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><md-select \nng-model=\"vm.entidade.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\" !(vm.grupoTarefa) && vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar localidade..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span>\n<div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\" translate=\"RESOURCES.MES\">Mes</label><input type=\"text\" \nname=\"mes\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"vm.disponibilizarTarefasForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"15\" \nflex=\"100\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" ng-model=\"vm.entidade.ano\" \nng-required=\"true\"><div ng-messages=\"vm.disponibilizarTarefasForm.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"25\" \nflex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.entidade.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-required=\"!(vm.grupoTarefa) && (vm.grupos.length > 0 && (vm.entidade.ano && vm.entidade.mes))\" name=\"grupo\" \nng-change=\"vm.metodos.realizarEventoChangeGrupo(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.disponibilizarTarefasForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex layout-align=\"center start\"><md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" \nflex=\"100\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.SETOR\">Setor</label><md-select \nng-model=\"vm.entidade.municipio\" md-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" \nng-change=\"vm.metodos.pesquisarTarefasPorRegionalMunicipio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo,vm.entidade.municipio)\" \nng-required=\" !(vm.grupoTarefa) && vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0 || vm.municipios == undefined\"><md-select-header \nng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" \nplaceholder=\"Pesquisar setor..\" class=\"md-text\"></md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.descricao}}</md-option></md-select>\n<span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum setor encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container flex-gt-xs=\"20\" flex=\"100\"><label for=\"\" \ntranslate=\"RESOURCES.TAREFA\">Tarefa</label><md-select flex name=\"tarefa\" \nng-required=\" !(vm.grupoTarefa) && (vm.tarefas.length > 0 && vm.entidade.grupo)\" \nmd-on-open=\"vm.metodos.configuraMdSelectTarefa()\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined && vm.entidade.grupo == undefined) || vm.tarefas.length == 0 || vm.tarefas == undefined\" \nng-model=\"vm.entidade.tarefa\"><md-select-header ng-if=\"vm.tarefas.length > 0\"><input ng-model=\"vm.filtrarTarefas\" \nmascara-numero-generica=\"###\" type=\"search\" id=\"select-tarefa\" placeholder=\"Pesquisar tarefa..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"tarefa\" ng-repeat=\"tarefa in vm.tarefas | filter: vm.filtrarTarefas\">{{tarefa}}\n</md-option></md-select><span ng-if=\"vm.tarefas.length == 0 && vm.entidade.grupo\" class=\"nenhum-grupo\">\nNenhuma tarefa encontrada.</span><div ng-messages=\"vm.disponibilizarTarefasForm.tarefa.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"40\" layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs=\"85\"><label class=\"md-subheader\" translate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required \nname=\"leiturista\" id=\"processamento-disponibilizartarefas-txtDescricaoLeiturista\" \nmd-on-open=\"vm.metodos.configurarSelect()\" ng-model=\"vm.entidade.leiturista\" \nng-disabled=\"(vm.desabilitarCampos) || (vm.emProgresso || vm.leituristas.length == 0)\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">\n{{leiturista.codigo}} - {{leiturista.apelido}}</md-option></md-select><div \nng-messages=\"vm.disponibilizarTarefasForm.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><md-divider></md-divider>\n<div layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"!vm.entidade.mes || !vm.entidade.ano || !vm.entidade.grupo  || !vm.entidade.tarefa || !vm.entidade.leiturista || vm.emProgresso\" \nng-click=\"vm.metodos.disponibilizarTarefa(vm.entidade)\"><span translate=\"RESOURCES.DISPONIBILIZAR\">Disponibilizar\n</span></md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/exportacao-grupo-leitura/views/BAURU/exportacao-grupo-leitura-bauru-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\">\n</carregamento-circular><div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"exportacaoGrupoForm\" novalidate \nmethod=\"post\"><md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\" \nclass=\"container-formulario\"><div><md-input-container class=\"md-block\"><label>Data</label><md-datepicker \nng-model=\"vm.entidade.dataExportacao\" name=\"dataExportacao\" ng-required=\"true\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data ng-disabled=\"vm.emProgresso\"></md-datepicker><div \nng-messages=\"exportacaoGrupoForm.dataExportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container>\n<md-checkbox ng-model=\"vm.entidade.gerarArquivoZip\" ng-disabled=\"vm.emProgresso\"><span>Compactar arquivo</span>\n</md-checkbox></md-input-container></div><div class=\"mensagem-fixa-bauru\"><strong layout-align=\"center center\">\nSerão exportados apenas os consumidores com leitura ou ocorrência lançada.</strong></div><md-divider \nng-if=\"!vm.emProgresso\"></md-divider><div layout=\"row\" layout-align=\"center center\" layout-padding><md-button \nclass=\"md-raised md-accent\" id=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"exportacaoGrupoForm.$invalid || vm.emProgresso\" \nng-click=\"vm.metodos.gerarArquivoExportacaoGrupo(vm.entidade)\"><span translate=\"RESOURCES.GERAR\">Gerar</span>\n</md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/distribuicao/views/CAEMA/distribuicao-form-caema.html","<div id=\"distribuicao\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-distribuicao\" md-whiteframe=\"4\" ui-view=\"distribuicao-filtro\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" ms-scroll ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-left\" md-component-id=\"filtro-distribuicao\" md-whiteframe=\"4\" \nui-view=\"distribuicao-filtro-caema\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"no-results text-center\" \nng-if=\"(!vm.tarefas && !vm.distribuicao && !vm.distribuindoPorDialog) && !(vm.emProgresso)\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"PROCESSAMENTO.DISTRIBUICAO.SEM_GRUPO\">Nenhum grupo de leituras selecionado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroDistribuicao()\"><span>Filtrar</span></md-button></div>\n</div><md-content flex ng-if=\"vm.emProgresso || vm.emProgressoDistribuicao\" layout=\"column\"><carregamento-circular \nem-progresso=\"vm.emProgresso || vm.emProgressoDistribuicao\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular></md-content><md-subheader \nng-if=\"(vm.tarefas || vm.distribuicao) && !(vm.emProgresso || vm.emProgressoDistribuicao)\"><div \nng-if=\"((vm.tarefas && vm.distribuicao) && !vm.emProgressoDistribuicao)\" style=\"position: absolute;right: 1em\" \nng-style=\"{\'top\': vm.distribuindoPorDialog ? \'8em\' : \'8.1em\'}\"><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\"></div>\n<fieldset flex=\"100\"><legend class=\"grp-legend\" ng-click=\"vm.exibirReferencia = !vm.exibirReferencia\"><span \ntranslate=\"RESOURCES.REFERENCIA_DISTRIBUICAO\"></span><md-icon class=\"md-accent\" ng-if=\"vm.exibirReferencia\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon class=\"md-accent\" ng-if=\"!vm.exibirReferencia\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></legend><div flex=\"100\" layout=\"column\" layout-gt-sm=\"row\" \nng-hide=\"!vm.exibirReferencia\"><div flex-gt-sm=\"60\" layout-gt-xs=\"row\" layout=\"column\"><md-input-container \nclass=\"margin-0\" flex=\"100\" flex-gt-xs=\"5\"><label translate=\"RESOURCES.MES\"></label><input type=\"text\" \nng-disabled=\"true\" value=\"{{ ::vm.distribuicao.mes }}\"></md-input-container><md-input-container class=\"margin-0\" \nflex-gt-xs=\"10\"><label translate=\"RESOURCES.ANO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.ano }}\"></md-input-container><md-input-container class=\"margin-0\" flex-gt-xs=\"10\"><label \ntranslate=\"RESOURCES.GRUPO\"></label><input type=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.grupoLeitura }}\">\n</md-input-container><md-input-container class=\"margin-0\" flex-gt-xs ng-if=\"vm.distribuicao.regionalDescricao\"><label \ntranslate=\"RESOURCES.LOCALIDADE\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.regionalDescricao}}\"></md-input-container><md-input-container class=\"margin-0\" \nflex-gt-xs=\"15\" ng-if=\"vm.distribuicao.municipioDescricao\"><label translate=\"RESOURCES.SETOR\"></label><input \ntype=\"text\" ng-disabled=\"true\" value=\"{{ ::vm.distribuicao.municipioDescricao}}\"></md-input-container></div><div \nflex-gt-sm=\"40\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"margin-0\" flex=\"100\"><label \ntranslate=\"RESOURCES.DATA_IMPORTACAO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.dataImportacao }}\"></md-input-container><md-input-container class=\"margin-0\" flex=\"100\">\n<label translate=\"RESOURCES.LIGACOES\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.quantidadeCliente }}\"></md-input-container><md-input-container class=\"margin-0\" flex \nflex-gt-xs=\"35\"><label translate=\"RESOURCES.TIPO_DISTRIBUICAO\"></label><input type=\"text\" ng-disabled=\"true\" \nvalue=\"{{ ::vm.distribuicao.tipoDistribuicao }}\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"mr-25 font-size-18 italic md-accent-fg\"><label>Quantidade a distribuir: \n<strong>{{ vm.quantidadeDistribuir }}</strong></label></div><div class=\"font-size-18 italic md-accent-fg\"><label>\nQuantidade de tarefas: <strong>{{ vm.numeroTarefas }}</strong></label></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-click=\"vm.metodos.habilitarRemocaoTarefas(true)\"><md-tooltip>Remover tarefas selecionadas</md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon></md-button></div><div><md-button class=\"md-fab md-mini\" \naria-label=\"Remover\" ng-click=\"vm.metodos.habilitarUnificacaoTarefas(true)\"><md-tooltip>Unificar tarefas selecionadas\n</md-tooltip><md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button></div></div></fieldset><div \nlayout=\"row\" flex=\"100\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Selecionar\" \nng-show=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\" ng-click=\"vm.metodos.marcarTodasTarefas()\">\n<md-tooltip>Selecionar todas as tarefas</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/distribuicao/check_box-white.svg\"></md-icon></md-button><div \nng-show=\"vm.removendoTarefas.habilitar\"><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" ng-click=\"vm.metodos.removerTarefasMarcadas()\"><md-tooltip>\nRemover tarefas selecionadas</md-tooltip><md-icon md-font-icon=\"icon-window-close\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Desfazer \" ng-disabled=\"!vm.removendoTarefas.removeuTarefa\" \nng-click=\"vm.metodos.desfazerRemocaoTarefas()\"><md-tooltip>Desfazer</md-tooltip><md-icon md-font-icon=\"icon-undo\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-green-600-bg\" aria-label=\"Efetivar\" \nng-hide=\"!vm.removendoTarefas.removeuTarefa\" ng-click=\"vm.metodos.efetivarRemocaoTarefas(false)\"><md-tooltip>Efetivar\n</md-tooltip><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-red-600-bg\" aria-label=\"Remover\" ng-click=\"vm.metodos.cancelarRemocaoTarefas(false)\">\n<md-tooltip>Cancelar</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div \nng-show=\"vm.unificandoTarefas.habilitar\"><md-button class=\"md-fab md-mini\" aria-label=\"Remover\" \nng-disabled=\"vm.metodos.verificarTarefasSelecionadas()\" ng-click=\"vm.metodos.abrirDialogUnificarTarefas()\"><md-tooltip>\nUnificar tarefas selecionadas</md-tooltip><md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"Desfazer \" ng-disabled=\"!vm.unificandoTarefas.unificouTarefa\" \nng-click=\"vm.metodos.desfazerUnificarTarefas()\"><md-tooltip>Desfazer</md-tooltip><md-icon md-font-icon=\"icon-undo\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-green-600-bg\" aria-label=\"Efetivar\" \nng-hide=\"!vm.unificandoTarefas.unificouTarefa\" ng-click=\"vm.metodos.efetivarUnificarTarefas(false)\"><md-tooltip>\nEfetivar</md-tooltip><md-icon md-font-icon=\"icon-check-all\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-red-600-bg\" aria-label=\"Remover\" ng-click=\"vm.metodos.cancelarUnificarTarefas(false)\">\n<md-tooltip>Cancelar</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div></div>\n</md-subheader><md-content layout-padding \nng-if=\"(vm.tarefas || vm.distribuicao) && !(vm.emProgresso || vm.emProgressoDistribuicao)\" layout=\"column\"><div \nflex=\"100\" layout=\"column\" class=\"div-tabela-tarefas\"><table class=\"dataTable row-border hover\" ng-if=\"vm.tarefas\" \ndatatable=\"ng\" dt-options=\"vm.options\"><thead><tr><th class=\"secondary-text\" \nng-show=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"RESOURCES.SELECIONAR\">Selecionar</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" translate=\"RESOURCES.TAREFA\">\nTarefa</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nQtde</span></div></th><th class=\"secondary-text\" ng-if=\"false\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Setor</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 1 || vm.distribuicao.enumTipoDistribuicao == 3\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Rota</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 3 || vm.distribuicao.enumTipoDistribuicao == 4\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Quadra</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.distribuicao.enumTipoDistribuicao == 4\"><div class=\"table-header\"><span class=\"column-title text-center\">Lote\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-justify\">\nEndereço inicial</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-justify\">Endereço final</span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody>\n<tr ng-repeat=\"tarefa in vm.tarefas track by $index\" ng-class=\"{\'tarefa-marcada\': tarefa.marcado}\"><td \nclass=\"text-center\" ng-show=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\"><md-checkbox \nng-model=\"tarefa.marcado\"></md-checkbox></td><td class=\"text-center\"><md-input-container flex=\"40\" class=\"margin-0\">\n<input aria-label=\"tarefa\" type=\"text\" style=\"text-align: center\" mascara-numero-generica=\"###\" \nng-model=\"tarefa.tarefa\"></md-input-container></td><td class=\"text-center\"><span>{{tarefa.quantidade}}</span></td><td \nclass=\"text-center\" ng-if=\"false\"><span>{{tarefa.setor}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.rota || vm.distribuicao.enumTipoDistribuicao == 1\"><span>{{tarefa.rota}}</span></td><td \nclass=\"text-center\" ng-if=\"tarefa.quadra\"><span>{{tarefa.quadra}}</span></td><td class=\"text-center\" \nng-if=\"tarefa.lote\"><span>{{tarefa.lote}}</span></td><td class=\"text-justify\"><span>{{tarefa.enderecoInicial}}</span>\n</td><td class=\"text-justify\"><span>{{tarefa.enderecoFinal}}</span></td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.dividirTarefa(tarefa,$index,true)\" \nng-hide=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.DIVIDIR_TAREFA\">Dividir tarefa</span></md-tooltip><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"cor-icone-padrao\"></md-icon></md-button></div></td></tr></tbody></table></div>\n<div layout=\"row\" layout-align=\"end start\" style=\"padding-bottom: 0px\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.emProgresso\" ng-hide=\"vm.removendoTarefas.habilitar || vm.unificandoTarefas.habilitar\" \nng-click=\"vm.metodos.distribuirGrupo()\"><span translate=\"RESOURCES.DISTRIBUIR\">Distribuir</span></md-button></div>\n</md-content></div>");
$templateCache.put("app/main/processamento/exportacao-grupo-leitura/views/CAEMA/exportacao-grupo-leitura-caema-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\">\n</carregamento-circular><div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"exportacaoGrupoForm\" novalidate \nmethod=\"post\"><md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center center\">\n<md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\" \nng-if=\"vm.parametros.utilizaCadastroRegional\"><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><md-select \nng-model=\"vm.entidade.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-required=\"!(vm.grupo) && vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\">\n<md-select-header ng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" \nid=\"select-regional\" placeholder=\"Pesquisar localidade..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}\n</md-option></md-select><span ng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma localidade encontrada.\n</span><div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex layout-align=\"center start\"><md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\" \ntranslate=\"RESOURCES.MES\">Mes</label><input type=\"text\" name=\"mes\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"exportacaoGrupoForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"15\" \nflex=\"100\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model=\"vm.entidade.ano\" ng-required=\"true\"><div ng-messages=\"exportacaoGrupoForm.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-xs=\"25\" flex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.entidade.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-required=\"!(vm.grupo) && vm.grupos.length > 0\" name=\"grupo\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"exportacaoGrupoForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center start\"><md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\"><label \ntranslate=\"RESOURCES.SETOR\">Setor</label><md-select ng-model=\"vm.entidade.setor\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" ng-change=\"vm.metodos.pesquisarRotasParaExportacao(vm.entidade)\" \nng-required=\" !(vm.grupo) && vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0 || vm.municipios == undefined\"><md-select-header \nng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" \nplaceholder=\"Pesquisar setor..\" class=\"md-text\"></md-select-header><md-option ng-value=\"municipio.descricao\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.descricao}}</md-option></md-select>\n<span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum setor encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex-gt-xs=\"30\" flex=\"100\"><label\n translate=\"RESOURCES.ROTA\">Rota</label><md-select ng-model=\"vm.entidade.rota\" \nmd-on-open=\"vm.metodos.configuraMdSelectRota()\" ng-required=\" !(vm.grupo) && vm.rotas.length > 0\" name=\"rota\" \nng-disabled=\"vm.rotas.length == 0 || vm.rotas == undefined\"><md-select-header ng-if=\"vm.rotas.length > 0\"><input \nng-model=\"vm.filtrarRota\" type=\"search\" id=\"select-municipio\" placeholder=\"Pesquisar rota..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"rota\" ng-repeat=\"rota in vm.rotas | filter: vm.filtrarRota\">{{rota}}\n</md-option></md-select><span ng-if=\"vm.rotas.length == 0\" class=\"nenhum-grupo\">Nenhuma rota encontrada.</span><div \nng-messages=\"vm.form.rota.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div><md-divider ng-if=\"!vm.emProgresso\"></md-divider><div layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-button class=\"md-raised md-accent\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"exportacaoGrupoForm.$invalid || vm.emProgresso\" \nng-click=\"vm.metodos.gerarArquivoExportacaoGrupo(vm.entidade)\"><span translate=\"RESOURCES.GERAR\">Gerar</span>\n</md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/exportacao-grupo-leitura/views/FIORILLI/exportacao-grupo-leitura-fiorilli-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\">\n</carregamento-circular><div class=\"md-background-bg md-whiteframe-1dp\"><form name=\"exportacaoGrupoForm\" novalidate \nmethod=\"post\"><md-content layout-padding><div layout-gt-xs=\"row\" layout=\"column\" flex layout-align=\"center start\">\n<md-input-container flex-gt-xs=\"10\" flex=\"100\"><label for=\"\" translate=\"RESOURCES.MES\">Mes</label><input type=\"text\" \nname=\"mes\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" ng-required=\"true\" \nmascara-numero-generica=\"##\" validacao-mes ng-model=\"vm.entidade.mes\"><div \nng-messages=\"exportacaoGrupoForm.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container flex-gt-xs=\"10\" \nflex=\"100\"><label for=\"\" translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" \nmascara-numero-generica=\"####\" ng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano)\" \nng-model=\"vm.entidade.ano\" ng-required=\"true\"><div ng-messages=\"exportacaoGrupoForm.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-xs=\"15\" flex=\"100\" ng-if=\"false\"><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select\n name=\"grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-model=\"vm.entidade.grupo\" ng-required=\"true\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-disabled=\"(vm.entidade.ano == undefined && vm.entidade.mes == undefined) || vm.grupos.length == 0\"><md-select-header\n ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" mascara-numero-generica=\"####\" type=\"search\" \nid=\"select-grupo\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"exportacaoGrupoForm.grupo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div layout=\"row\" style=\"width: 25%\">\n<md-input-container flex><label>Leituristas</label><md-select name=\"leituristas\" ng-model=\"vm.entidade.leituristas\" \nng-change=\"vm.metodos.onChangeLeituristas()\" md-on-close=\"vm.metodos.limparTermoPesquisado()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-disabled=\"false\" multiple=\"multiple\" \nng-required=\"vm.parametroUtilizaExportacaoPorLeiturista && vm.leituristas.length > 0 && !vm.todosLeituristas\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.filtrarLeituristas\" type=\"search\" \nplaceholder=\"Pesquisar leituristas..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"leiturista\"><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.filtrarLeituristas\">{{leiturista.apelidoExibicao}}</md-option>\n</md-optgroup></md-select><span ng-if=\"vm.leituristas.length === 0\" class=\"nenhum-leiturista\" \nstyle=\"color: rgb(213,0,0)\">Nenhum leiturista encontrado para a referência informada</span><div \nng-messages=\"exportacaoGrupoForm.leituristas.$error\"><div ng-message=\"required\" style=\"color: rgb(213,0,0)\" \nng-if=\"vm.parametroUtilizaExportacaoPorLeiturista && vm.leituristas.length > 0 && !vm.todosLeituristas\">\nCampo obrigatório</div></div></md-input-container><md-input-container><md-checkbox style=\"margin-right: 10px\" \nng-model=\"vm.todosLeituristas\" ng-change=\"vm.metodos.limparSelecao()\" aria-label=\"Checkbox Disabled Indeterminate\" \nng-disabled=\"!vm.leituristas.length\" class=\"md-primary\">Todos</md-checkbox></md-input-container></div>\n<md-input-container flex-gt-xs=\"15\" flex=\"100\" ng-if=\"vm.modoImplantacaoAtivo\"><label>Tipo de exportação</label>\n<md-select name=\"tipoExportacao\" ng-model=\"vm.entidade.tipoExportacao\" ng-required=\"vm.modoImplantacaoAtivo\" \nng-change=\"vm.metodos.onChangeTipoExportacao(vm.entidade.tipoExportacao)\"><md-option ng-value=\"tipo.chave\" \nng-repeat=\"tipo in vm.tiposExportacao\">{{tipo.valor}}</md-option></md-select><div \nng-messages=\"exportacaoGrupoForm.tipoExportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"column\" \nflex=\"100\" layout-align=\"center center\" \nng-if=\"vm.parametros.utilizarExportacaoParcialGrupoLeitura || vm.parametros.calculo.tipoDetalheCalculo == 89\"><fieldset\n flex=\"75\" layout-align=\"center center\" layout=\"column\"><legend class=\"grp-legend\">Registros para exportação</legend>\n<md-radio-group layout-align=\"center center\" flex=\"100\" layout=\"row\" \nng-change=\"vm.metodos.buscarSequencialControleEnvio(vm.entidade.regional, vm.entidade.mes, vm.entidade.ano, vm.entidade.grupo)\" \nng-model=\"vm.entidade.tipoExportacao\"><md-radio-button ng-value=\"1\">Não enviados</md-radio-button><md-radio-button \nng-value=\"2\">Reenviar</md-radio-button></md-radio-group><md-select ng-if=\"vm.entidade.tipoExportacao == 2\" \nng-required=\"true\" ng-model=\"vm.entidade.numeroSequencialGeracaoArquivo\"><md-option ng-value=\"numSeq\" \nng-repeat=\"numSeq in vm.sequenciais\">{{numSeq}}</md-option></md-select></fieldset></div><md-divider \nng-if=\"!vm.emProgresso\"></md-divider><div layout=\"row\" layout-align=\"center center\" layout-padding><md-button \nclass=\"md-raised md-accent\" id=\"processamento-exportacaomobile-btnDescricaoLeiturista\" \nng-disabled=\"!vm.entidade.mes \r\n                                 || !vm.entidade.ano \r\n                                 || (vm.parametroUtilizaExportacaoPorLeiturista && !vm.todosLeituristas && (!vm.entidade.leituristas || vm.entidade.leituristas.length === 0)) \r\n                                 || (vm.modoImplantacaoAtivo && !vm.entidade.tipoExportacao)\r\n                                 || vm.emProgresso\" \nng-click=\"vm.metodos.gerarArquivoExportacaoGrupo(vm.entidade)\"><span>{{vm.labelBotaoGerar}}</span></md-button></div>\n</md-content></form></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-distribuicao/gerenciamento-grupo-dialog-distribuicao.html","<md-dialog id=\"gerenciamento-grupo-dialog-distribuicao\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.DISTRIBUICAO\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\"></header-padrao><div\n ms-scroll class=\"scrollable\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" \nui-view=\"distribuicao-form@app.distribuicao\"></div><div ms-scroll class=\"scrollable\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" ui-view=\"distribuicao-form-caema@app.distribuicao\"></div>\n</md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-importacao/gerenciamento-grupo-dialog-importacao.html","<md-dialog id=\"gerenciamento-grupo-dialog-distribuicao\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.IMPORTACAO_GRUPO_LEITURA\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll flex=\"100\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" class=\"scrollable\" \nui-view=\"importacao-grupo-leitura-form@app.importacao_grupo_leitura\"></div><div ms-scroll flex=\"100\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" class=\"scrollable\" \nui-view=\"importacao-grupo-leitura-form-caema@app.importacao_grupo_leitura\"></div></md-dialog>");
$templateCache.put("app/main/processamento/importacao-grupo-leitura/views/CAEMA/importacao-grupo-leitura-caema-form.html","<carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"{{vm.tituloSplash}}\" mensagem=\"{{vm.mensagemSplash}}\">\n</carregamento-circular><div id=\"importacao-grupo-caema\" class=\"md-background-bg md-whiteframe-1dp\"><form \nname=\"importacaoGrupoForm\" novalidate method=\"post\" enctype=\"multipart/form-data\"><md-content layout-padding><div \nlayout-gt-sm=\"row\" layout-align=\"center center\" ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><label translate=\"RESOURCES.LOCALIDADE\"></label><md-select name=\"regional\" \nid=\"processamento-exportacaomobile-slcregional\" ng-model=\"vm.parametrosExportacao.localidadeCodigo\" ng-required=\"true\" \nng-change=\"vm.metodos.changeLocalidade(vm.parametrosExportacao.localidadeCodigo)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" id=\"processamento-exportacaomobile-slcregional-options-{{$index}}\" \nng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoSetores\"></md-progress-circular><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><label \ntranslate=\"RESOURCES.SETOR\"></label><md-select name=\"setor\" id=\"processamento-exportacaomobile-slcsetor\" \nng-change=\"vm.metodos.changeSetor()\" ng-model=\"vm.parametrosExportacao.setorCodigo\" ng-required=\"true\" \nng-disabled=\"!vm.municipios.length\"><md-option ng-value=\"setor.codigo\" \nid=\"processamento-exportacaomobile-slcregional-options-{{$index}}\" ng-repeat=\"setor in vm.municipios\">\n{{setor.descricao}}</md-option></md-select><div ng-messages=\"vm.form.setor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nng-if=\"vm.parametros.utilizaImportacaoLeituraViaFtp\" layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.preLoader\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\">\n</md-progress-circular></div></div><div layout-gt-sm=\"row\" layout-align=\"center center\" \nng-if=\"(vm.parametros.utilizaImportacaoLeituraViaFtp && vm.parametrosExportacao.localidadeCodigo) || vm.preLoader\"><div\n class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"table-title\" layout=\"row\" layout-align=\"start center\">\n{{vm.arquivosFTP.titulo}}</div><div class=\"pv-16\" style=\"margin-right: 10px\"><md-select class=\"simplified\" \nng-model=\"vm.filtro.status\" ng-change=\"vm.metodos.filtrar(vm.filtro.status)\" aria-label=\"Menu\"><md-option \nng-repeat=\"status in vm.status\" value=\"{{status.valor}}\">{{status.valor}}</md-option></md-select></div></div><div \nlayout=\"row\" flex=\"100\" class=\"pl-24\" layout-align=\"start center\" ng-if=\"vm.arquivosFTP.arquivos.length\"><md-button \nclass=\"md-fab md-mini\" ng-click=\"vm.metodos.selecionarTodosArquivos()\"><md-tooltip>Selecionar todos</md-tooltip>\n<md-icon md-font-icon=\"icon-checkbox-marked-outline\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \nstyle=\"margin-left: 10px!important\" ng-disabled=\"!vm.metodos.existemArquivosMarcados()\" \nng-click=\"vm.metodos.importarArquivosSelecionados()\"><md-tooltip>Importar selecionados</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\"></md-icon></md-button></div><table class=\"simple\"><thead><tr><th>Selecionar</th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Situação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Nome</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"arquivo in vm.arquivosFTP.arquivos\" class=\"p-0 margin-0\"><td \nstyle=\"padding-left: 24px!important\"><md-checkbox aria-label=\"chkbox-arquivo\" ng-model=\"arquivo.selecionado\">\n</md-checkbox></td><td><span class=\"text-boxed m-0 light-blue-bg white-fg\" ng-if=\"arquivo.situacao == \'Importado\'\">\n{{arquivo.situacao}} </span><span class=\"text-boxed m-0 deep-orange-bg white-fg\" \nng-if=\"arquivo.situacao ==\'Não importado\'\">{{arquivo.situacao}}</span></td><td><span>{{arquivo.nome}}</span></td></tr>\n</tbody></table></div></ms-widget-front></ms-widget></div></div><md-divider ng-if=\"!vm.emProgresso\"></md-divider><div \nlayout=\"row\" layout-align=\"center center\" layout-padding ng-if=\"!vm.parametros.utilizaImportacaoLeituraViaFtp\">\n<md-button class=\"md-raised md-accent\" id=\"processamento-importacaoGrupo\" \nng-disabled=\"importacaoGrupoForm.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.realizarImportacao()\"><span \ntranslate=\"RESOURCES.IMPORTAR\"></span></md-button></div></md-content></form></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-exportacao/gerenciamento-grupo-dialog-exportacao.html","<md-dialog id=\"gerenciamento-grupo-dialog-distribuicao\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.EXPORTACAO_GRUPO_LEITURA\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" class=\"scrollable\" \nui-view=\"exportacaogrupoleitura-form@app.exportacao_grupo_leitura\"></div><div ms-scroll \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" class=\"scrollable\" \nui-view=\"exportacaogrupoleitura-caema-form@app.exportacao_grupo_leitura\"></div></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/views/CAEMA/gerenciamento-grupo-caema-form.html","<div id=\"gerenciamentogrupo\" layout=\"column\"><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-left\" \nmd-component-id=\"filtro-gerenciamentogrupo\" md-whiteframe=\"4\" ui-view=\"gerenciamentogrupo-filtro-caema\" ms-scroll \nms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav filtro-sidenav md-sidenav-right\" \nmd-component-id=\"legenda-gerenciamentogrupo\" md-whiteframe=\"4\" ui-view=\"gerenciamentogrupo-legenda\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"no-results text-center\" ng-if=\"vm.grupos.length == 0\"><div class=\"message\">\n<md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\" \ntranslate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\"></div><md-button ng-disabled=\"vm.emProgresso\" \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltroGerenciamentoGrupo()\"><span>Filtrar</span></md-button>\n</div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular></md-content><md-content \nlayout-padding ng-if=\"vm.grupos.length > 0 && !vm.emProgresso\" layout=\"column\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between\" flex=\"100\"><div layout-align=\"start start\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"90\">\n<div layout=\"row\" flex=\"100\" flex-gt-xs=\"{{filtro.flexGtXs}}\" class=\"div-card\" ng-repeat=\"filtro in vm.filtros\">\n<ms-widget class=\"h-80\" style=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-16\">{{filtro.titulo}}</div><div \nclass=\"font-size-18\" style=\"text-align: center\">{{filtro.dado}}</div></div></ms-widget-front></ms-widget></div></div>\n<div flex=\"100\" layout-align=\"end center\" flex-gt-xs=\"10\"><fab-button buttons=\"vm.itensMenu\" titulo-menu=\"Menu\"></div>\n</div><div flex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\" ng-if=\"vm.grupos\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr show-gt-sm hide><th colspan=\"2\" class=\"border-left\"></th><th colspan=\"5\" \nclass=\"secondary-text border-left border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Leituras</span></div></th><th colspan=\"2\" class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Tarefas</span></div></th><th \nclass=\"border-right\"></th></tr><tr><th class=\"border-left secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"RESOURCES.GRUPO\">Grupo</span></div></th><th \nclass=\"border-left secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"RESOURCES.STATUS\">Status</span></div></th><th class=\"secondary-text border-left\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Total</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Efetuadas</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Não efetuadas</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Efetuadas(%)</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Pendentes de exportação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Pendentes de recebimento</span>\n</div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Pendentes de finalização</span></div></th><th class=\"secondary-text\" ng-show=\"false\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Arquivo</span></div></th><th \nclass=\"border-right\"></th></tr></thead><tbody><tr ng-repeat=\"grupo in vm.grupos track by $index\"><td \nclass=\"text-center border-left\"><span>{{grupo.grupo}}</span></td><td class=\"text-center border-left\"><span \nclass=\"text-boxed white-bg black-fg\" ng-if=\"grupo.situacao === \'NÃO DISTRIBUÍDO\'\">Não distribuido </span><span \nclass=\"text-boxed gray-bg black-fg\" ng-if=\"grupo.situacao === \'PARCIALMENTE DISTRIBUÍDO\'\">Parciamente distríbuido \n</span><span class=\"text-boxed yellow-700-bg black-fg\" ng-if=\"grupo.situacao === \'DISTRIBUÍDO\'\">Distríbuido </span>\n<span class=\"text-boxed orange-bg white-fg\" ng-if=\"grupo.situacao === \'EXPORTADO MOBILE\'\">Tarefas disponibilizadas \n</span><span class=\"text-boxed md-light-blue-600-bg white-fg\" ng-if=\"grupo.situacao === \'IMPORTADO MOBILE\'\">Importado \n</span><span class=\"text-boxed green-bg white-fg\" ng-if=\"grupo.situacao === \'GRUPO EXPORTADO\'\">Exportado</span></td><td\n class=\"text-center border-left border-right\"><span>{{grupo.totalLeituras | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.leiturasEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.leiturasNaoEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{ grupo.porcentagemConclusaoLeituras }}%</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.leiturasPendentesExportacao}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.recebimentoColetorTarefaPendenteQuantidade}}</span></td><td \nclass=\"text-center border-right\"><span>{{grupo.finalizacaoCargaTarefaPendenteQuantidade}}</span></td><td \nclass=\"text-center border-right\" ng-show=\"false\"><span>{{grupo.nomeArquivo}}</span></td><td \nclass=\"text-center border-left border-right\"><div layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.abrirDialogDatas(grupo)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.DATAS_GRUPO\">Datas do grupo</span></md-tooltip><md-icon \nmd-font-icon=\"icon-calendar\" class=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.recuperarTarefas(grupo)\" ng-if=\"!(grupo.situacao === \'NÃO DISTRIBUÍDO\')\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.TAREFAS\">Tarefas</span></md-tooltip><md-icon \nmd-font-icon=\"icon-open-in-app\" class=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.selecionarMetodoAcao($event, grupo)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span\n translate=\"RESOURCES.ACAO\">Ação</span></md-tooltip><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" \nclass=\"cor-icone-padrao\"></md-icon></md-button></div></td></tr></tbody></table></div></md-content></div>");
$templateCache.put("app/main/relatorios/faturamento/dialog/views/faturamento-servicos-prestados-dialog.html","<md-dialog aria-label=\"Serviços prestados\" id=\"servicos-prestados-dialog\"><form ng-cloak><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RELATORIOS.FATURAMENTO.SERVICOS_PRESTADOS\"></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div layout-gt-sm=\"row\" layout=\"column\" class=\"margin-top\"><div layout=\"row\" \nflex-gt-sm=\"50\" flex><md-input-container flex><label translate=\"RELATORIOS.FATURAMENTO.DESCRICAO\"></label><input \nmd-maxlength=\"20\" maxlength=\"20\" ng-model=\"vm.entidade.descricao\"></md-input-container></div><div layout=\"row\" \nflex-gt-sm=\"40\" flex><md-input-container flex><label translate=\"RELATORIOS.FATURAMENTO.QUANTIDADE\"></label><input \nmascara-numero-generica=\"######\" ng-model=\"vm.entidade.quantidade\"></md-input-container><md-input-container flex><label\n translate=\"RELATORIOS.FATURAMENTO.VALOR_UNITARIO\"></label><input type=\"text\" mascara-tamanho-campo=\"16\" ui-money-mask \nng-model=\"vm.entidade.valorUnitario\"></md-input-container></div><div layout=\"row\" layout-align=\"end center\" \nflex-gt-sm=\"10\" flex><div><md-button class=\"md-fab\" ng-click=\"vm.metodos.adicionarServico()\"><md-icon \nmd-font-icon=\"icon-plus\"><md-tooltip><span translate=\"RELATORIOS.FATURAMENTO.INSERIR_SERVICO\"></span></md-tooltip>\n</md-icon></md-button></div></div></div><div layout=\"column\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Qtde.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Valor unitário</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Total</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"servico in vm.servicos track by $index\"><td class=\"text-center\"><span>{{servico.codigo}}</span></td><td \nclass=\"text-center\"><p>{{servico.descricao}}</p></td><td class=\"text-center\"><span>{{servico.quantidade}}</span></td>\n<td class=\"text-center\"><span>{{servico.valorUnitario | currency: \'R$ \'}}</span></td><td class=\"text-center\"><span>\n{{servico.total | currency: \'R$ \'}}</span></td><td><i class=\"icon-trash icone-cor-padrao s24 mr-10\" \nng-click=\"vm.metodos.removerServico($index)\" index-servico=\"{{$index}}\" id=\"faturamento-deletar-{{$index}}\">\n<md-tooltip><span translate=\"RELATORIOS.FATURAMENTO.REMOVER_SERVICO\"></span></md-tooltip></i></td></tr></tbody></table>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\"><span \nstyle=\"margin-right: 2em; font-size: 1.4em\">Valor total {{ vm.valorTotal | currency: \'R$ \'}}</span></div><div \nlayout=\"column\" layout-align=\"end end\" ng-show=\"vm.preLoader\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/relatorios/estatisticas/views/CAEMA/estatisticas-form-caema.html","<div layout-padding class=\"md-background-bg md-whiteframe-1dp\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando relatório...\"></carregamento-circular><form name=\"relatoriosEstatisticasForm\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><fieldset class=\"standard\" layout-align=\"center center\" flex \nflex-gt-sm=\"75\"><div layout-gt-sm=\"row\" layout-align=\"center center\"><div layout=\"row\" flex-gt-sm=\"50\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.LOCALIDADE\"></label><md-select name=\"regional\" \nid=\"estatisticas-slcregional\" ng-change=\"vm.metodos.onChangeRegional()\" ng-model=\"vm.entidade.regional\" \nng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-disabled=\"true\" ng-if=\"!vm.listaRegionais || vm.listaRegionais.length <= 0\">Não foram encontradas localidades\n</md-option><md-option ng-value=\"item.codigo\" ng-repeat=\"item in vm.listaRegionais\">{{item.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nflex-gt-sm=\"50\" layout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.listandoMunicipios\"></md-progress-circular><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.SETOR\"></label><md-select name=\"municipio\" id=\"estatisticas-slcmunicipio\" \nng-model=\"vm.entidade.municipio\" ng-disabled=\"!vm.entidade.regional || vm.listandoMunicipios\"><md-option \nng-value=\"item.codigo\" ng-disabled=\"true\" ng-if=\"vm.listaMunicipios.length <= 0\">Nenhum Setor encontrado</md-option>\n<md-option ng-value=\"item.codigo\" ng-repeat=\"item in vm.listaMunicipios\">{{item.descricao}}</md-option></md-select>\n</md-input-container></div></div></fieldset></div><div layout-gt-sm=\"row\" layout-align=\"center center\"><fieldset \nclass=\"standard\" layout-align=\"center center\" flex flex-gt-sm=\"75\"><legend class=\"grp-legend\" \ntranslate=\"RELATORIOS.DATA_COLETA\"></legend><div layout-gt-sm=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_INICIAL\">Período inicial\n</label><md-datepicker ng-model=\"vm.entidade.dataInicio\" name=\"dataInicio\" ng-disabled=\"vm.emProgresso\" \nmd-max-date=\"vm.entidade.dataFim\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data></md-datepicker>\n<div ng-messages=\"relatoriosEstatisticasForm.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"input-container\"><label style=\"margin-right: 15px\" translate=\"RELATORIOS.PERIODO_FINAL\">Período final</label>\n<md-datepicker ng-model=\"vm.entidade.dataFim\" name=\"dataFim\" ng-disabled=\"vm.emProgresso\" \nmd-min-date=\"vm.entidade.dataInicio\" required ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"relatoriosEstatisticasForm.dataFim.$error\"><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nclass=\"mb-10\" layout=\"row\" layout-align=\"center center\" flex><fieldset class=\"standard\" layout-align=\"center center\" \nflex flex-gt-sm=\"75\"><legend class=\"grp-legend\" translate=\"RELATORIOS.LEITURISTA\"></legend><div layout=\"row\" flex \nlayout-align=\"center center\"><multi-select-directive style=\"margin:0px;padding: 0px\" flex flex-gt-sm=\"50\" \nform-name=\"leiturista\" data=\"vm.leituristas\" model=\"vm.entidade.leiturista\" obrigatorio=\"true\" \ndescricao-exibicao=\"nome\" texto-pesquisa-placeholder=\"Procurar leiturista\" texto-placeholder=\"Leiturista\"></div>\n</fieldset></div><div layout=\"row\" flex layout-align=\"center center\"><fieldset class=\"standard\" layout=\"row\" \nflex-gt-sm=\"75\"><div flex><md-checkbox name=\"agrupamentoPorLeiturista\" ng-model=\"vm.entidade.agrupamento\" \naria-label=\"Agrupamento por leiturista\" ng-true-value=\"2\" ng-false-value=\"1\"></md-checkbox><span \ntranslate=\"RELATORIOS.AGRUPAR_LEITURISTA\">Agrupar por leiturista</span></div><div flex><md-checkbox \nname=\"utilizaDataRealColeta\" ng-model=\"vm.entidade.utilizaDataRealColeta\" aria-label=\"Utilizar data da coleta real\" \nng-true-value=\"true\" ng-false-value=\"false\"></md-checkbox><span>Utilizar data real da coleta</span><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"cor-icone-padrao\"><md-tooltip md-autohide md-direction=\"top\"><span \nclass=\"md-caption\">\nUtilizar parâmetro caso tenha sido realizadas leituras com cálculo proporcional no período informado.</span>\n</md-tooltip></md-icon></div></fieldset></div><div layout=\"row\" flex layout-align=\"center center\"><md-input-container \nclass=\"no-padding-and-margin\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" \nng-disabled=\"relatorioEstatisticasForm.$invalid || vm.emProgresso\r\n                               || (!vm.entidade.dataInicio || !vm.entidade.dataFim)\" \nng-click=\"vm.metodos.gerarRelatorio()\"><span>Gerar</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/relatorios/logs/dialogs/views/selecionar-arquivo-log-dialog.html","<md-dialog flex><carregamento-circular em-progresso=\"vm.relatorioEmProgresso\" titulo=\"Gerando relatório...\" \nmensagem=\"{{ vm.infoArquivoSelecionado }}\"></carregamento-circular><form ng-cloak><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2 translate=\"RELATORIOS.LOGS.SELECIONAR_ARQUIVO\"></h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div ng-if=\"vm.logs && vm.logs.length > 0\" class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"white-bg\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.options\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Código</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Leiturista</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Arquivo</span></div></th><th \nng-hide=\"!vm.exibirDataColeta\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nData coleta</span></div></th><th class=\"secondary-text\"></th></tr></thead><tbody><tr \nng-repeat=\"log in vm.logs track by $index\"><td class=\"text-center\"><span>{{log.codigoLeiturista}}</span></td><td \nclass=\"text-center\"><span>{{log.leiturista}}</span></td><td class=\"text-center\"><span>{{log.arquivoExportacao}}</span>\n</td><td class=\"text-center\" ng-hide=\"!vm.exibirDataColeta\"><span>{{log.dataExecucao | date: \'dd/MM/yyyy\' }}</span>\n</td><td class=\"text-center\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.gerarRelatorio(log)\"><md-tooltip \nmd-autohide id=\"pg-tooltip-gerar-relatorio\"><span>Gerar Relatório</span></md-tooltip><md-icon \nmd-font-icon=\"icon-printer\" class=\"cor-icone-padrao\"></md-icon></md-button></td></tr></tbody></table></ms-widget-front>\n</ms-widget><md-divider></md-divider></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/relatorios/viva-agua/dialogs/views/viva-agua-localidades-dialog.html","<md-dialog id=\"vivaagua-localidade-dialog\" flex><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Gerando relatório...\" mensagem=\"{{ vm.infoLocalidadeSelecionada }}\"></carregamento-circular><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Selecionar localidade</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" ng-disabled=\"vm.emProgresso\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div ng-if=\"true\" class=\"widget-group\" layout=\"row\" layout-align=\"end start\" \nflex=\"100\" layout-wrap><md-button class=\"md-raised md-accent\" ng-click=\"vm.metodos.gerarRelatorioTodasLocalidades()\">\n<span>Gerar todas localidades</span><md-icon class=\"white\" md-font-icon=\"icon-printer\"></md-icon></md-button><ms-widget\n flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.options\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-left\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Referência</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title text-center\">Total de clientes</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Ações</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"localidade in vm.localidades track by $index\"><td class=\"text-center\"><span>\n{{localidade.codigoLocalidade}}</span></td><td class=\"text-left\"><span>{{localidade.descricaoLocalidade}}</span></td>\n<td class=\"text-center\"><span>{{localidade.mes}}/{{localidade.ano}}</span></td><td class=\"text-center\"><span>\n{{localidade.codigosClientes.length}}</span></td><td class=\"text-center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.gerarRelatorio(localidade)\" ng-disabled=\"vm.emProgresso\"><md-tooltip \nid=\"pg-tooltip-gerar-relatorio\" md-autohide><span>Gerar Relatório</span></md-tooltip><md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-printer\"></md-icon></md-button></td></tr></tbody></table></ms-widget-front></ms-widget><md-divider>\n</md-divider></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/relatorios/personalizado/dialogs/views/personalizado-planilha-dialog.html","<md-dialog id=\"personalizado-planilha-dialog\" flex><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\">\n<h2>Planilha</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" \nng-disabled=\"vm.emProgresso\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-10 pr-10 pl-20 pb-0\"><form \nname=\"vm.form\" novalidate><md-input-container class=\"md-block pt-0 pb-0 pr-10\"><label>Nome da planilha</label><input \ntype=\"text\" ng-model=\"vm.nomePlanilha\" ng-required=\"true\"></md-input-container></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.fecharDialog()\" class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid\"><span>Exportar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-configuracoes/tab-configuracoes.html","<div class=\"form-container\"><div layout-gt-xs=\"row\" flex layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex><label translate=\"RESOURCES.ARQUIVO\"></label><md-select name=\"arquivo\" \nid=\"cadastros-leiturista-tabconfiguracoes-slcarquivos\" ng-model=\"vm.leiturista.configuracao.arqCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"arquivo.codigo\" id=\"cadastro-leiturista-tabconfiguracoes-slctarquivo-options-{{$index}}\" \nng-repeat=\"arquivo in vm.arquivos\">{{arquivo.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.arquivo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.ROTINA\"></label>\n<md-select name=\"rotina\" id=\"cadastros-leiturista-tabconfiguracoes-slcrotina\" \nng-model=\"vm.leiturista.configuracao.tipoRotina\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.ngChangeTipoRotina(vm.leiturista.configuracao.tipoRotina)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"value\" id=\"cadastro-leiturista-tabconfiguracoes-slctrotina-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.rotinas\">{{key}}</md-option></md-select><div ng-messages=\"vm.form.rotina.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.LAYOUT\"></label><md-select name=\"layout\" \nid=\"cadastros-leiturista-tabconfiguracoes-slclayout\" ng-model=\"vm.leiturista.configuracao.layoutArquivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                       || vm.leiturista.desabilitarLayoutArquivo\">\n<md-option ng-value=\"value\" id=\"cadastro-leiturista-tabconfiguracoes-slclayout-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.layouts\">{{key}}</md-option></md-select><div ng-messages=\"vm.form.layout.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.EQUIPAMENTO\"></label><md-select \nname=\"equipamento\" id=\"cadastros-leiturista-tabconfiguracoes-slcequipamento\" \nng-model=\"vm.leiturista.configuracao.eqpCodigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"equipamento.codigo\" id=\"cadastro-leiturista-tabconfiguracoes-slctarquivo-options-{{$index}}\" \nng-repeat=\"equipamento in vm.equipamentos\">{{equipamento.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.equipamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.SEGMENTO\">\n</label><md-select id=\"cadastros-leiturista-tabconfiguracoes-slcsegmento\" name=\"segmento\" \nng-model=\"vm.leiturista.configuracao.segmento\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"segmento.codigo\" ng-repeat=\"segmento in vm.segmentos\">{{segmento.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.segmento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.TIPO_COLETA\">\n</label><md-select id=\"cadastros-leiturista-tabconfiguracoes-slcTipoColeta\" name=\"tipoColeta\" \nng-model=\"vm.leiturista.configuracao.tipoColeta\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoColeta.codigo\" ng-repeat=\"tipoColeta in vm.tipoColetas\">{{tipoColeta.descricao}}</md-option></md-select>\n<div ng-messages=\"vm.form.tipoColeta.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" flex \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox \nname=\"visualizarDadosLeitura\" id=\"cadastros-leiturista-tabconfiguracoes-chkvisualizardadosleitura\" \nng-model=\"vm.leiturista.configuracao.mostraDadosLeitura\" aria-label=\"Mostrar dados leitura\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.VISUALIZAR_DADOS_LEITURA\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"utilizaCartaoBackup\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkutilizacartaobackup\" \nng-model=\"vm.leiturista.configuracao.utilizaCartaoBackup\" aria-label=\"Utiliza cartão de backup\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CARTAO_BACKUP\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"permitirAlterarDataLeitura\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkpermitiralterardataleitura\" \nng-model=\"vm.leiturista.configuracao.alteraDataLeitura\" aria-label=\"Mostrar dados leitura\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || \r\n                         (vm.parametros.calculo.utilizaCalculoProporcionalNumeroDias == \'S\' && vm.controleForm.editarAtivo) || \r\n                         (vm.parametros.calculo.utilizaCalculoProporcionalNumeroDias == \'S\' && vm.controleForm.inserirAtivo)\">\n<span translate=\"RESOURCES.PERMITIR_ALTERAR_DATA_LEITURA\"></span></md-checkbox><md-tooltip md-autohide \nmd-direction=\"top\" \nng-if=\"(vm.parametros.calculo.utilizaCalculoProporcionalNumeroDias == \'S\' && vm.controleForm.editarAtivo) || \r\n                        (vm.parametros.calculo.utilizaCalculoProporcionalNumeroDias == \'S\' && vm.controleForm.inserirAtivo)\">\nParâmetro desabilitado devido a rotina de cálculo proporcional estar habilitada.</md-tooltip></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"exibeMensagemObservacaoCliente\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkexibemensagemobservacaocliente\" \nng-model=\"vm.leiturista.configuracao.ocultaOutrosDadosClienteTelaLeitura\" \naria-label=\"Ocultar outros dados do cliente na tela de leitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.OCULTAR_OUTROS_DADOS_CLIENTE_TELA_LEITURA\"></span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" flex layout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex>\n<md-checkbox name=\"utilizaGPS\" id=\"cadastros-leiturista-tabconfiguracoes-chkutilizagps\" \nng-model=\"vm.leiturista.configuracao.utilizaGPS\" aria-label=\"Utiliza GPS\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_GPS\"></span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex><md-checkbox name=\"avisaOcorrenciaAnterior\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkavisaocorrenciaanterior\" \nng-model=\"vm.leiturista.configuracao.avisaOcorrenciaAnterior\" aria-label=\"Avisa ocorrência anterior\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.AVISAR_OCORRENCIA_ANTERIOR\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"exibeMensagemObservacaoCliente\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkexibemensagemobservacaocliente\" \nng-model=\"vm.leiturista.configuracao.exibeObservacaoCliente\" aria-label=\"Exibe mensagem observação cliente\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.EXIBIR_MENSAGEM_OBSERVACAO_CLIENTE\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><md-checkbox name=\"ocultaHistoricoConsumo\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkOcultaHistoricoConsumo\" \nng-model=\"vm.leiturista.configuracao.ocultaHistoricoConsumo\" aria-label=\"Ocultar histórico consumo na tela de leitura\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.OCULTAR_HISTORICO_CONSUMO_TELA_LEITURA\"></span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" flex=\"100\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n<md-checkbox name=\"utilizaConfirmacaoLeituraForaFaixaSemVisualizacaoLeitura\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkutilizaconfirmacaoleituraforafaixasemvisualizacaoleitura\" \nng-model=\"vm.leiturista.configuracao.utilizaConfirmacaoLeituraForaFaixaSemVisualizacaoLeitura\" \naria-label=\"Utiliza confirmação da leitura na mensagem de alerta sem visualização da leitura digitada\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CONFIRMACAO_LEITURA_MENSAGEM_ALERTA_SEM_VISUALIZACAO_LEITURA_DIGITADA\"></span>\n</md-checkbox></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start start\" flex><fieldset \nclass=\"standard\" flex-gt-sm=\"50\" layout-alig flex><md-checkbox name=\"destacarMensagemAlerta\" \nid=\"cadastros-leiturista-tabconfiguracoes-chkdestacarmensagemalerta\" \nng-model=\"vm.leiturista.configuracao.destacaMensagemAlerta\" aria-label=\"Destacar mensagem de alerta\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.DESTACAR_MENSAGEM_ALERTA\"></span></md-checkbox><div class=\"group-checkbox\" flex=\"100\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex \nng-hide=\"vm.leiturista.configuracao.destacaMensagemAlerta == \'N\' || \r\n                                                 vm.leiturista.configuracao.destacaMensagemAlerta == undefined\">\n<label translate=\"RESOURCES.TIPO_CONFIRMACAO\"></label><md-select name=\"tipoConfirmacaoLeitura\" \nid=\"cadastros-leiturista-tabconfiguracoes-slcmensagemAlerta\" \nng-model=\"vm.leiturista.configuracao.tipoConfirmacaoLeitura\" \nng-required=\"vm.leiturista.configuracao.destacaMensagemAlerta == \'S\'\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                     || (!vm.leiturista.configuracao.destacaMensagemAlerta || vm.leiturista.configuracao.destacaMensagemAlerta == \'N\')\">\n<md-option ng-value=\"tipoConfirmacaoLeitura.id\" ng-repeat=\"tipoConfirmacaoLeitura in vm.tiposConfirmacaoLeitura\">\n{{vm.metodos.preencherZerosAEsquerda(tipoConfirmacaoLeitura.id)}} - {{tipoConfirmacaoLeitura.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.tipoConfirmacaoLeitura.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></fieldset><fieldset \nclass=\"standard\" flex-gt-sm=\"50\" flex><md-checkbox name=\"utilizaRotinaCapturaFotos\" \nid=\"cadastro-leiturista-tabconfiguracoes-chkutilizarotinacapturafotos\" \nng-model=\"vm.leiturista.configuracao.utilizaCapturaFotos\" aria-label=\"Ultiliza Captura de fotos\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_ROTINA_CAPTURA_FOTOS\"></span></md-checkbox><div class=\"group-checkbox\" flex=\"100\"><div \nlayout=\"column\" \nng-hide=\"vm.leiturista.configuracao.utilizaCapturaFotos == \'N\' ||\r\n                         vm.leiturista.configuracao.utilizaCapturaFotos == undefined\">\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.UTILIZAR_IMPRESSAO_FOTO\"></label><md-select \nname=\"impressaoFoto\" id=\"cadastros-leiturista-tabconfiguracoes-slcimpressaofoto\" \nng-model=\"vm.leiturista.configuracao.utilizaImpressaoFoto\" \nng-required=\"vm.leiturista.configuracao.utilizaCapturaFotos == \'S\' && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                               || (!vm.leiturista.configuracao.utilizaCapturaFotos || vm.leiturista.configuracao.utilizaCapturaFotos == \'N\')\">\n<md-option ng-value=\"value\" id=\"cadastro-leiturista-tabconfiguracoes-slctarquivo-options-{{$index}}\" \nng-repeat=\"(key, value) in vm.impressoesFotos\">{{key}}</md-option></md-select><div \nng-messages=\"vm.form.impressaoFoto.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><fieldset class=\"standard\" flex><md-checkbox name=\"gravarTipoFotoAutomaticamente\" \nid=\"cadastro-leiturista-tabconfiguracoes-chkgravarTipoFotoAutomaticamente\" \naria-label=\"Gravar tipo de foto automaticamente\" ng-model=\"vm.leiturista.configuracao.gravarTipoFotoAutomaticamente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nGravar tipo de foto automaticamente</span></md-checkbox><md-input-container class=\"md-block\" flex><label>\nTipo de foto para gravação automática</label><md-select name=\"tipoFotoGravacaoAutomatica\" \nid=\"cadastros-leiturista-tabconfiguracoes-slctipoFotoGravacaoAutomatica\" \nng-model=\"vm.leiturista.configuracao.tipoFotoGravacaoAutomatica\" \nng-disabled=\"(!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || !vm.leiturista.configuracao.gravarTipoFotoAutomaticamente\" \nng-required=\"vm.leiturista.configuracao.gravarTipoFotoAutomaticamente && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\">\n<md-option ng-repeat=\"tipo in vm.tiposFotoGravacaoAutomatica\" ng-value=\"tipo.id\">{{ tipo.descricao }}</md-option>\n</md-select><div ng-messages=\"vm.form.tipoFotoGravacaoAutomatica.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset></div></div></fieldset>\n</div><div class=\"pt-10\" layout-gt-xs=\"row\" layout-align=\"start start\" flex ng-if=\"false\"><fieldset class=\"standard\" \nflex><md-checkbox name=\"utilizaPermissaoAcesso\" id=\"cadastro-leiturista-tabconfiguracoes-chkutilizaPermissaoAcesso\" \nng-model=\"vm.leiturista.configuracao.utilizaPermissaoAcesso\" aria-label=\"Utiliza rotina de permissões de acesso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><label \ntranslate=\"RESOURCES.UTILIZA_PERMISSOES_ACESSO\"></label></md-checkbox><div class=\"group-checkbox\" \nng-if=\"vm.leiturista.configuracao.utilizaPermissaoAcesso\" flex=\"100\"><md-input-container flex-gt-sm=\"50\" \nclass=\"md-block\"><label>Dias da semana</label><md-select ng-model=\"vm.leiturista.permissaoAcesso.diasSemana\" \nmultiple=\"multiple\" name=\"dias\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option ng-value=\"semana.valor\" \nng-repeat=\"semana in vm.diasSemana\">{{semana.dia}}</md-option></md-select><div ng-messages=\"vm.form.dias.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"50\"><label>Hora inicial</label><input type=\"text\" mascara-numero-generica=\"##:##\" \nng-pattern=\"vm.regexHora\" ng-change=\"vm.metodos.verificaHora()\" ng-model=\"vm.leiturista.permissaoAcesso.horaInicial\" \nname=\"horaInicio\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.horaInicio.$error\"><div ng-message=\"pattern\" translate=\"MENSAGEM_VALIDACAO.HORA_INVALIDA\"></div>\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container flex-gt-sm=\"50\"><label>Hora final</label><input type=\"text\" mascara-numero-generica=\"##:##\" \nng-pattern=\"vm.regexHora\" ng-model=\"vm.leiturista.permissaoAcesso.horaFinal\" name=\"horaFim\" \nng-change=\"vm.metodos.verificaHora()\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div ng-messages=\"vm.form.horaFim.$error\">\n<div ng-message=\"hora\" translate=\"MENSAGEM_VALIDACAO.HORA_FINAL_MENOR\" \nng-if=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"></div><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.HORA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></div>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-recadastramento/tab-recadastramento.html","<div id=\"tab-recadastramento\" class=\"form-container\"><fieldset layout=\"column\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\"><md-checkbox \nid=\"cadastros-leiturista-tabrecadastramento-chkUtilizarRecadastramento\" name=\"utilizarRecadastramento\" \naria-label=\"Utilizar recadastramento\" ng-model=\"vm.leiturista.recadastramento.utilizaRecadastramento\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-change=\"vm.metodos.changeUtilizarRecadastramento(vm.leiturista.recadastramento.utilizaRecadastramento)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                         !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_RECADASTRAMENTO\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" \nng-if=\"vm.leiturista.recadastramento.utilizaRecadastramento == \'S\' &&\r\n                                (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) || \r\n                                (vm.controleForm.pesquisaAtiva && vm.leiturista.recadastramento.permiteRecadastrarRuaBairroNovo == \'S\')\">\n<md-checkbox id=\"cadastros-leiturista-tabrecadastramento-chkPermiteRecadastrarRuaBairroNovo\" \nname=\"utilizaLeituraTelemetria\" aria-label=\"Permitir recadastrar rua nova bairro novo\" \nng-model=\"vm.leiturista.recadastramento.permiteRecadastrarRuaBairroNovo\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                         !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.PERMITIR_RECADASTRAR_RUA_BAIRRO\"></span></md-checkbox></md-input-container></div><fieldset \nlayout=\"column\" flex=\"100\" \nng-if=\"vm.leiturista.recadastramento.utilizaRecadastramento == \'S\' &&\r\n                        (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) || \r\n                        (vm.controleForm.pesquisaAtiva && vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento == \'S\')\">\n<div layout=\"row\"><md-input-container class=\"md-block mb-0\"><md-checkbox \nid=\"cadastros-leiturista-tabrecadastramento-chkUtilizarRecadastramentoCampos\" \nname=\"utilizarRecadastramentoCamposSeremRecadastrados\" \naria-label=\"Utilizar configuraçao de campos a serem recadastrados\" \nng-model=\"vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-change=\"vm.metodos.changeUtilizarConfiguracaoRecadastramentoCampos(vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                 !vm.controleForm.editarAtivo && \r\n                                                 !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_CONFIGURACAO_CAMPOS\"></span></md-checkbox></md-input-container><div layout=\"row\" \nlayout-align=\"end end\" ng-if=\"vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento == \'S\'\" \nclass=\"container-btn-replicar\"><md-button class=\"md-fab md-raised md-accent mb-10\" aria-label=\"Excluir formulário\" \nng-if=\"vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento == \'S\' && \r\n                                      vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento && \r\n                                      vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-click=\"vm.metodos.replicarConfiguracoes(vm.leiturista)\" \nng-disabled=\"!vm.controleForm.pesquisaAtiva &&\r\n                                            vm.controleForm.editarAtivo && vm.controleForm.inserirAtivo\" \nflex-offset=\"20\"><md-icon layout-align=\"end end\" md-font-icon=\"icon-content-duplicate\"><md-tooltip>\nReplicar configurações para todos os leituristas</md-tooltip></md-icon></md-button></div></div><div \nclass=\"container-tabela\" layout=\"column\" \nng-if=\"vm.leiturista.recadastramento.utilizaPermissaoAlterarCampoRecadastramento == \'S\'\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Informações pessoais\" id=\"cadastros-leiturista-mdtabs-informacoes-pessoais\" \nmd-active=\"vm.tabSelecionadaTabela === \'informacoes-pessoais\'\" \nmd-on-select=\"vm.metodos.exibirItensTabela(\'informacoes-pessoais\')\"><md-tab-label><label>Informações pessoais</label>\n<md-icon md-font-icon=\"{{vm.tabIcones.informacoesPessoais}}\" style=\"color: #039BE5\"></md-icon></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-recadastramento.tabela-informacoes\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Informações de endereço\" id=\"cadastros-leiturista-mdtabs-informacoes-endereco\" \nmd-active=\"vm.tabSelecionadaTabela === \'informacoes-endereco\'\" \nmd-on-select=\"vm.metodos.exibirItensTabela(\'informacoes-endereco\')\"><md-tab-label><label>Informações de endereço\n</label><md-icon md-font-icon=\"{{vm.tabIcones.informacoesEndereco}}\" style=\"color: #039BE5\"></md-icon></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-recadastramento.tabela-informacoes\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Informações da ligação\" id=\"cadastros-leiturista-mdtabs-informacoes-ligacao\" \nmd-active=\"vm.tabSelecionadaTabela === \'informacoes-ligacao\'\" \nmd-on-select=\"vm.metodos.exibirItensTabela(\'informacoes-ligacao\')\"><md-tab-label><label>Informações da ligação</label>\n<md-icon md-font-icon=\"{{vm.tabIcones.informacoesLigacao}}\" style=\"color: #039BE5\"></md-icon></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-recadastramento.tabela-informacoes\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Informações do imóvel\" id=\"cadastros-leiturista-mdtabs-informacoes-imovel\" \nmd-active=\"vm.tabSelecionadaTabela === \'informacoes-imovel\'\" \nmd-on-select=\"vm.metodos.exibirItensTabela(\'informacoes-imovel\')\"><md-tab-label><label>Informações do imóvel</label>\n<md-icon md-font-icon=\"{{vm.tabIcones.informacoesImovel}}\" style=\"color: #039BE5\"></md-icon></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-recadastramento.tabela-informacoes\"></md-content></md-tab-body></md-tab>\n</md-tabs></div></fieldset></fieldset></div>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-impressao/tab-impressao.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.IMPRESSORA\"></label><md-select name=\"impressora\" \nid=\"cadastros-leiturista-tabimpressao-slcaimpressora\" ng-model=\"vm.leiturista.configuracao.impCodigo\" \nng-change=\"vm.metodos.ngChangeImpressora(vm.leiturista.configuracao.impCodigo)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"\"><em></em></md-option><md-option ng-value=\"impressora.codigo\" \nid=\"cadastro-leiturista-tabimpressao-slctaimpressora-options-{{$index}}\" ng-repeat=\"impressora in vm.impressoras\">\n{{impressora.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"10\"><label translate=\"RESOURCES.MODELO\"></label><input type=\"text\" name=\"modelo\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ui-number-mask=\"0\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'modeloImpressao\', vm.leiturista.configuracao.modeloImpressao)\" \nui-hide-group-sep ng-model=\"vm.leiturista.configuracao.modeloImpressao\" mascara-tamanho-campo=\"4\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label translate=\"RESOURCES.DETALHE\"></label>\n<input type=\"text\" name=\"detalhe\" id=\"cadastros-leiturista-tabimpressao-txtdetalhe\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'detalheModeloImpressao\', vm.leiturista.configuracao.detalheModeloImpressao)\" \nui-number-mask=\"0\" ui-hide-group-sep ng-model=\"vm.leiturista.configuracao.detalheModeloImpressao\" \nmascara-tamanho-campo=\"4\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.TAMANHO_FORMULARIO\"></label><input id=\"cadastros-leiturista-tabimpressao-txttamanhoformulario\" \ntype=\"text\" name=\"tamanhoFormulario\" ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"9\" \nng-model=\"vm.leiturista.configuracao.tamanhoFormularioImpressao\" \nng-required=\"vm.leiturista.configuracao.tipoRotina == \'02\'\" \nng-change=\"vm.metodos.onChangeTamanhoFormulario(vm.form.tamanhoFormulario, vm.controleForm)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || (vm.leiturista.bloquearTamanhoFormulario)\">\n<div ng-messages=\"vm.form.tamanhoFormulario.$error\"><div ng-message=\"tamanhoFormulario\"><span>\nDeve ser inserido um valor maior ou igual a 1500</span></div><div ng-message=\"required\"><span>\nDeve ser inserido um valor maior ou igual a 1500</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.COORDENADA_X_CODIGO_BARRAS\"></label><input type=\"text\" \nname=\"coordenadaXCodigoBarras\" id=\"cadastros-leiturista-tabimpressao-txtcoordenadaxcodigosbarras\" ui-number-mask=\"0\" \nui-negative-number \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'coordenadaXCodigoBarras\', vm.leiturista.configuracao.coordenadaXCodigoBarras)\" \nui-hide-group-sep ng-model=\"vm.leiturista.configuracao.coordenadaXCodigoBarras\" mascara-tamanho-campo=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.FORMULARIO_IMPRESSAO\"></label><md-select name=\"formularioImpressao\" \nid=\"cadastros-leiturista-tabimpressao-slcaformularioimpressao\" \nng-model=\"vm.leiturista.configuracao.codigoFormularioImpressao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"\"><em></em></md-option><md-option ng-value=\"formularioImpressao.codigo\" \nid=\"cadastro-leiturista-tabimpressao-slctaformularioimpressao-options-{{$index}}\" \nng-repeat=\"formularioImpressao in vm.formulariosImpressao\">{{formularioImpressao.descricao}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.PORTA_BLUETOOTH\">\n</label><input type=\"text\" name=\"portaBluetooth\" id=\"cadastros-leiturista-tabimpressao-txtportabluetooth\" \nng-model=\"vm.leiturista.configuracao.portaBluetoothSaida\" mascara-tamanho-campo=\"5\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\"><md-checkbox \nname=\"avisaContaRetidaNaoCalculadaComMesmoEnderecoEntrega\" \nid=\"cadastros-leiturista-tabimpressao-chkavisacontaretidanaocalculadacommesmoenderecoentrega\" \nng-model=\"vm.leiturista.configuracao.avisaContaRetidaMesmoEndereco\" \naria-label=\"Avisa conta retida não calculada com o mesmo endereço de entrega\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.AVISA_CONTA_RETIDA_NAO_CALCULADA_COM_MESMO_ENDERECO_ENTREGA\"></span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox \nname=\"imprimeContaRetidaComMesmoEnderecoEntrega\" \nid=\"cadastros-leiturista-tabimpressao-chkimprimecontaretidacommesmoendrecoentrega\" \nng-model=\"vm.leiturista.configuracao.imprimeContaRetidaMesmoEndereco\" \naria-label=\"Imprime conta retida com o mesmo endereço de entrega\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIME_CONTA_RETIDA_COM_O_MESMO_ENDERECO_DE_ENTREGA\"></span></md-checkbox></md-input-container>\n</div></div>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-telemetria/tab-telemetria.html","<div class=\"form-container\" layout=\"column\"><fieldset layout=\"column\" flex=\"100\"><md-input-container class=\"md-block\">\n<md-checkbox name=\"utilizaLeituraTelemetria\" id=\"cadastros-leiturista-tabtelemetria-chkutilizaleituraportelemetria\" \nng-model=\"vm.leiturista.configuracao.utilizaTelemetriaLeitura\" aria-label=\"Utilizar leitura por telemetria\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_LEITURA_TELEMETRIA\"></span></md-checkbox></md-input-container><div layout=\"row\" \nng-if=\"vm.leiturista.configuracao.utilizaTelemetriaLeitura == \'S\'\" flex><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label translate=\"RESOURCES.FABRICANTE\"></label><md-select name=\"fabricante\" \nid=\"cadastros-leiturista-tabtelemetria-slcafabricante\" \nng-model=\"vm.leiturista.configuracao.codigoFabricanteEquipamentosTelemetria\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"fabricante.id\" ng-repeat=\"fabricante in vm.fabricanteEquipamentoTelemetria\">{{fabricante.nome}}</md-option>\n</md-select><div ng-messages=\"vm.form.fabricante.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"40\"><label translate=\"RESOURCES.NUMERO_SERIE_EQUIPAMENTO\"></label><input type=\"text\" name=\"numeroSerie\" \nid=\"cadastros-leiturista-tabtelemetria-txtnumeroserieequipamento\" \nng-model=\"vm.leiturista.configuracao.numeroSerieBluetoothReceiverTelemetria\" mascara-tamanho-campo=\"30\" \nmd-maxlength=\"30\" ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.numeroSerie.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.SENHA\"></label><input type=\"text\" name=\"senhaTelemetria\" \nid=\"cadastros-leiturista-tabtelemetria-txtsenhatelemetria\" ng-model=\"vm.leiturista.configuracao.senhaTelemetria\" \nmascara-tamanho-campo=\"30\" md-maxlength=\"30\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.senhaTelemetria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"RESOURCES.PORTA_BLUETOOTH\"></label><input type=\"text\" \nname=\"portaBluetoothTelemetria\" id=\"cadastros-leiturista-tabtelemetria-txtportabluetoothtelemetria\" \nng-model=\"vm.leiturista.configuracao.portaBluetoothTelemetria\" \nng-change=\"vm.metodos.onChangePortaBluetoothTelemetria(vm.form.portaBluetoothTelemetria, vm.form, vm.controleForm)\" \nmascara-numeros=\"4\" ng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.portaBluetoothTelemetria.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"portaBluetoothTelemetria\"><span>\nCampo não pode ser 0</span></div></div></md-input-container></div></fieldset><fieldset class=\"mt-10\" layout=\"column\" \nflex=\"100\"><md-input-container class=\"md-block\"><md-checkbox name=\"utilizarTelemetriaLeituraAPI\" \nid=\"cadastros-leiturista-tabtelemetria-chkutilizaleiturapoapi\" \nng-model=\"vm.leiturista.configuracao.utilizarTelemetriaLeituraAPI\" aria-label=\"Utilizar leitura por API\" \nng-change=\"vm.metodos.onChangeUtilizaLeituraAPI(vm.leiturista.configuracao.utilizarTelemetriaLeituraAPI)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nUtilizar leitura por API</span></md-checkbox></md-input-container><div layout=\"row\" \nng-if=\"vm.leiturista.configuracao.utilizarTelemetriaLeituraAPI\" flex><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"20\"><label>Fabricante</label><md-select \nng-model=\"vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI \" flex \nname=\"codigoFabricanteEquipamentoTelemetriaAPI\" \nng-change=\"vm.metodos.onChangeFabricante(vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"fabricante.chave\" ng-repeat=\"fabricante in vm.fabricantes\">{{fabricante.valor}}</md-option></md-select><div \nng-messages=\"vm.form.codigoFabricanteEquipamentoTelemetriaAPI.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Rota/Token</label><input type=\"text\" name=\"rotaTokenTelemetriaAPI\" \nng-model=\"vm.leiturista.configuracao.rotaTokenTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Endereço/Rota para retorno das leituras</label><input type=\"text\" \nname=\"enderecoRotaTelemetriaAPI\" ng-model=\"vm.leiturista.configuracao.enderecoRotaTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container></div><div \nlayout=\"row\" \nng-if=\"vm.leiturista.configuracao.utilizarTelemetriaLeituraAPI \r\n            && (vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI == 1 \r\n            || vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI == 3\r\n            || vm.leiturista.configuracao.codigoFabricanteEquipamentoTelemetriaAPI == 5)\" \nflex><md-input-container class=\"md-block\" flex=\"20\"><label>Username</label><input type=\"text\" \nname=\"usernameTelemetriaAPI\" ng-model=\"vm.leiturista.configuracao.usernameTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"20\"><label>Password</label><input type=\"text\" name=\"passwordTelemetriaAPI\" \nng-model=\"vm.leiturista.configuracao.passwordTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Client_Id</label><input type=\"text\" name=\"clientIdTelemetriaAPI\" \nng-model=\"vm.leiturista.configuracao.clientIdTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Client_Secret</label><input type=\"text\" name=\"clientSecretTelemetriaAPI\" \nng-model=\"vm.leiturista.configuracao.clientSecretTelemetriaAPI\" \nng-disabled=\"!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"></md-input-container></div></fieldset>\n</div>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-pessoal/tab-pessoal.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><input type=\"file\" id=\"cadastro-leiturista-foto\" ng-show=\"false\" \nng-file-model=\"vm.arquivo\" accept=\"image/png, image/jpeg\"></div><div layout-gt-xs=\"row\" flex><div class=\"\" \nlayout=\"column\" flex=\"75\"><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"RESOURCES.CODIGO\"></label><input type=\"text\" name=\"codigo\" id=\"cadastros-leiturista-tabpessoal-txtCodigo\" \nui-number-mask=\"0\" ui-hide-group-sep ng-model=\"vm.leiturista.codigo\" mascara-tamanho-campo=\"4\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo)\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.leiturista.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo>\n<md-input-container class=\"md-block\" ng-if=\"vm.parametros.utilizaCadastroRegional\" flex-gt-sm=\"40\" flex><label \ntranslate=\"RESOURCES.REGIONAL\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\"></label><label \ntranslate=\"RESOURCES.LOCALIDADE\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\"></label><md-select \nname=\"regional\" id=\"cadastros-municipio-slcregional\" ng-model=\"vm.leiturista.agrupamentoId\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\"><md-checkbox name=\"inativo\" \nid=\"cadastros-leiturista-tabpessoal-chkinativo\" ng-model=\"vm.leiturista.inativo\" aria-label=\"Inativo\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.INATIVO\">Inativo</span></md-checkbox></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"RESOURCES.NOME\"></label><input type=\"text\" \nname=\"nome\" id=\"cadastro-leiturista-txtnome\" ng-model=\"vm.leiturista.nome\" mascara-tamanho-campo=\"40\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"40\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.nome.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"RESOURCES.APELIDO\">\n</label><input type=\"text\" name=\"apelido\" id=\"cadastro-leiturista-txtapelido\" ng-model=\"vm.leiturista.apelido\" \nmascara-tamanho-campo=\"20\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" md-maxlength=\"20\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.apelido.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.SENHA\"></label><input \ntype=\"text\" name=\"senha\" id=\"cadastro-leiturista-txtsenha\" ng-model=\"vm.leiturista.senha\" mascara-tamanho-campo=\"10\" \nmd-maxlength=\"10\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.senha.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></div><div class=\"\" layout-align=\"center end\" layout=\"row\" flex><div class=\"\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div \nlayout-gt-sm=\"column\" layout-xs=\"row\" flex layout-align=\"center center\"><div class=\"alterar-foto\" \nng-show=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-icon md-font-icon=\"icon-pencil\" class=\"s32\" \nng-click=\"vm.metodos.selecionarFoto()\"><md-tooltip>Alterar foto</md-tooltip></md-icon></div><div class=\"limpar-foto\" \nng-show=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-icon md-font-icon=\"icon-delete\" class=\"s32\" \nng-click=\"vm.metodos.limparFoto()\"><md-tooltip>Limpar foto</md-tooltip></md-icon></div></div><div><img \nclass=\"profile-image avatar huge\" src=\"{{vm.leiturista.foto.conteudo}}\"></div></div></div></div></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.ENDERECO\"></label>\n<input type=\"text\" name=\"endereco\" id=\"cadastro-leiturista-txtendereco\" ng-model=\"vm.leiturista.endereco\" \nmascara-tamanho-campo=\"40\" md-maxlength=\"40\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"RESOURCES.BAIRRO\"></label>\n<input type=\"text\" name=\"bairro\" id=\"cadastro-leiturista-txtbairro\" ng-model=\"vm.leiturista.bairro\" \nmascara-tamanho-campo=\"30\" md-maxlength=\"30\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.CEP\"></label><input \ntype=\"text\" name=\"cep\" id=\"cadastro-leiturista-txtcep\" ng-model=\"vm.leiturista.cep\" ui-br-cep-mask \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cep.$error\"><div ng-message=\"cep\" translate=\"MENSAGEM_VALIDACAO.CEP\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label \ntranslate=\"RESOURCES.CIDADE\"></label><input type=\"text\" name=\"cidade\" id=\"cadastro-leiturista-txtcidade\" \nng-model=\"vm.leiturista.cidade\" mascara-tamanho-campo=\"30\" md-maxlength=\"30\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label \ntranslate=\"RESOURCES.TELEFONE_CELULAR\"></label><input type=\"text\" name=\"telefoneCelular\" \nid=\"cadastro-leiturista-txttelefonecelular\" ng-model=\"vm.leiturista.telefoneCelular\" ui-br-phone-number \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.telefoneCelular.$error\"><div ng-message=\"brPhoneNumber\" \ntranslate=\"MENSAGEM_VALIDACAO.TELEFONE_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"RESOURCES.TELEFONE_RESIDENCIAL\"></label><input type=\"text\" name=\"telefoneResidencial\" \nid=\"cadastro-leiturista-txttelefoneresidencial\" ng-model=\"vm.leiturista.telefoneResidencial\" ui-br-phone-number \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.telefoneResidencial.$error\"><div ng-message=\"brPhoneNumber\" \ntranslate=\"MENSAGEM_VALIDACAO.TELEFONE_INVALIDO\"></div></div></md-input-container></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-calculo/tab-calculo.html","<md-content id=\"cadastro-parametros-tab-calculo\"><md-tabs class=\"tabcalculo-tabs\" md-dynamic-height md-border-bottom>\n<md-tab label=\"Configuração\" md-active=\"vm.tabSelecionada === \'configuracao\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'configuracao\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_COLETOR_TAB_CONFIGURACAO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-calculo-tab-configuracao\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Configuracação fora de faixa\" md-active=\"vm.tabSelecionada === \'faixa\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'faixa\')\"><md-tab-label><label translate=\"RESOURCES.TAB_CALCULO_TAB_FAIXA\">\n</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-calculo-tab-faixa\"></md-content></md-tab-body></md-tab>\n<md-tab label=\"Arredondamento\" md-active=\"vm.tabSelecionada === \'arredondamento\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'arredondamento\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_CALCULO_TAB_ARREDONDAMENTO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-calculo-tab-arredondamento\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tab-impressao.html","<md-content id=\"cadastro-parametros-tab-impressao\"><md-tabs class=\"tabcoletor-tabs\" md-dynamic-height md-border-bottom>\n<md-tab label=\"Mensagens\" md-active=\"vm.tabSelecionada === \'mensagens\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'mensagens\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_MENSAGENS\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-impressao-tab-mensagens\"></md-content></md-tab-body></md-tab><md-tab label=\"Comunicados\" \nmd-active=\"vm.tabSelecionada === \'comunicados\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'comunicados\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS\"></label></md-tab-label><md-tab-body>\n<md-content ui-view=\"tab-impressao-tab-comunicados\"></md-content></md-tab-body></md-tab><md-tab label=\"Outros\" \nmd-active=\"vm.tabSelecionada === \'outros\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'outros\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_OUTROS\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-impressao-tab-outros\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-empresa/tab-empresa.html","<md-content id=\"cadastro-parametros-tab-empresa\"><div class=\"form-container\"><div layout=\"row\"><div layout=\"column\" \nng-show=\"vm.controleForm.pesquisaAtiva && !vm.realizandoUpload\"><div flex-offset=\"10\"><span class=\"label\" \nstyle=\"color: #106cc8 !important; font-size: small !important\">Logomarca</span></div><div flex-offset=\"10\" \nclass=\"padd-bottom\" layout-align=\"start center\"><img ng-src=\"data:image/png;base64,{{vm.logomarcaStream}}\" \nclass=\"preencher-imagem\" alt=\"\" width=\"200px\" height=\"97px\"></div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.controleForm.pesquisaAtiva && !vm.realizandoUpload\"><md-button \nclass=\"edit-button md-icon-button\" name=\"botaoEditarLogomarca\" id=\"cadastro-parametros-tabempresa-botao-edtLogomarca\" \nng-click=\"vm.realizandoUpload = true;\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"250\"><span>Editar logomarca</span></md-tooltip></md-button></div></div><div layout-gt-sm=\"row\" \nlayout-padding ng-show=\"vm.controleForm.pesquisaAtiva && vm.realizandoUpload\"><lf-ng-md-file-input flex-gt-sm=\"60\" \nname=\"botaoProcurarImagem\" id=\"cadastro-parametros-tabempresa-botao-edtProcurarImagem\" name=\"arqLogomarca\" \nlf-files=\"vm.arquivosLogomarca\" accept=\"image/*\" lf-api=\"vm.lfApi\" lf-placeholder=\"Selecionar imagem\" \nlf-browse-label=\"Procurar\" progress lf-remove-label=\"Remover\" ng-click=\"vm.metodos.clickSelecao($event);\" preview>\n</lf-ng-md-file-input><div layout=\"row\" layout-align=\"center end\"><md-progress-circular class=\"md-accent mb-5\" \nng-if=\"vm.emProgressoLogoMarca\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" name=\"botaoEnviarImagem\" id=\"cadastro-parametros-tabempresa-botao-enviarImagem\" \nng-click=\"vm.metodos.uploadLogomarca($event);\" \nng-disabled=\"vm.arquivosLogomarca.length == 0 || vm.emProgressoLogoMarca\"><span>Enviar imagem para o servidor</span>\n</md-button><md-button class=\"md-raised md-accent\" name=\"botaoCancelarEnvio\" \nid=\"cadastro-parametros-tabempresa-botao-cancelarEnvio\" ng-disabled=\"vm.emProgressoLogoMarca\" \nng-click=\"vm.metodos.cancelarUpload();\"><span>Cancelar</span></md-button></div></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.NOME\">Nome</label><input type=\"text\" \nname=\"nomeEmpresa\" id=\"cadastro-parametros-tabempresa-txtNomeEmpresa\" ng-model=\"vm.parametro.empresa.nomeEmpresa\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"40\"><div ng-messages=\"vm.form.nomeEmpresa.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"40\"><label translate=\"RESOURCES.ENDERECO\">Endereço</label><input type=\"text\" name=\"endereco\" \nid=\"cadastro-parametros-tabempresa-txtEndereco\" ng-model=\"vm.parametro.empresa.endereco\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.tornarCampoObrigatorio\" mascara-tamanho-campo=\"40\"><div ng-messages=\"vm.form.endereco.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.BAIRRO\">Bairro</label><input \ntype=\"text\" name=\"bairro\" id=\"cadastro-parametros-tabempresa-txtBairro\" ng-model=\"vm.parametro.empresa.bairro\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.tornarCampoObrigatorio\" mascara-tamanho-campo=\"30\"><div ng-messages=\"vm.form.bairro.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label translate=\"RESOURCES.CIDADE\">Cidade\n</label><input type=\"text\" name=\"cidade\" id=\"cadastro-parametros-tabempresa-txtCidade\" \nng-model=\"vm.parametro.empresa.cidade\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.tornarCampoObrigatorio\" mascara-tamanho-campo=\"30\"><div ng-messages=\"vm.form.cidade.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"5\"><label>UF</label><input type=\"text\" name=\"uf\" \nng-model=\"vm.parametro.empresa.uf\" \nonkeydown=\"var a = this; setTimeout(function(){a.value = a.value.toUpperCase();}, 1)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.tornarCampoObrigatorio\" mascara-tamanho-campo=\"2\"><div ng-messages=\"vm.form.uf.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.CEP\">CEP</label><input type=\"text\" \nname=\"cep\" id=\"cadastro-parametros-tabempresa-txtCep\" ng-model=\"vm.parametro.empresa.cep\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.tornarCampoObrigatorio\" mascara-numero-generica=\"#####-###\"><div ng-messages=\"vm.form.cep.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.TELEFONE\">Telefone</label><input \ntype=\"text\" name=\"telefone\" id=\"cadastro-parametros-tabempresa-txtTelefone\" ng-model=\"vm.parametro.empresa.telefone\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nui-br-phone-number></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"RESOURCES.FAX\">Fax</label><input type=\"text\" name=\"fax\" id=\"cadastro-parametros-tabempresa-txtFax\" \nng-model=\"vm.parametro.empresa.fax\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-telefone></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.CNPJ\">CNPJ</label><input type=\"text\" name=\"cnpj\" id=\"cadastro-parametros-tabempresa-txtCnpj\" \nng-model=\"vm.parametro.empresa.cnpj\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"##.###.###/####-##\" ng-required=\"vm.tornarCampoObrigatorio\"><div \nng-messages=\"vm.form.cnpj.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.IE\">\nInscrição Estadual</label><input type=\"text\" name=\"ie\" id=\"cadastro-parametros-tabempresa-txtIe\" \nng-model=\"vm.parametro.empresa.ie\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"15\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"40\"><label translate=\"RESOURCES.EMAIL\">E-mail</label><input type=\"email\" name=\"email\" \nid=\"cadastro-parametros-tabempresa-txtEmail\" ng-model=\"vm.parametro.empresa.email\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"30\"><div ng-messages=\"vm.form.email.$error\"><div ng-message=\"email\" \ntranslate=\"MENSAGEM_VALIDACAO.EMAIL_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label translate=\"RESOURCES.SITE\">Site</label><input type=\"text\" name=\"site\" \nid=\"cadastro-parametros-tabempresa-txtSite\" ng-model=\"vm.parametro.empresa.site\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"30\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.TIPO\">Tipo</label><input type=\"text\" name=\"tipo\" id=\"cadastro-parametros-tabempresa-txtTipo\" \nng-model=\"vm.parametro.empresa.tipoEmpresa\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numeros=\"4\"></md-input-container></div><div layout=\"row\"><fieldset class=\"standard\" flex-gt-sm=\"100\" \nng-if=\"false\"><legend class=\"grp-legend\" translate=\"RESOURCES.BANCO_DADOS\"></legend><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label translate=\"RESOURCES.VERSAO_BANCO_DADOS\">Banco de dados\n</label><input type=\"text\" name=\"versaoBancoDados\" id=\"cadastro-parametros-tabempresa-txtVersao\" \nng-model=\"vm.parametro.versaoBancoDeDados\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"30\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.DATA_ULTIMO_BACKUP\">Último backup</label><md-datepicker flex-offset-gt-sm=\"5\" \nname=\"dataUltimoBackupBancoDados\" ng-model=\"vm.parametros.dataUltimoBackupBancoDados\" \nid=\"cadastro-parametros-tabempresa-dtUltimoBackup\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.DATA_ULTIMA_MANUTENCAO_BANCO_DADOS\">Última manutenção</label><md-datepicker flex-offset-gt-sm=\"5\" \nname=\"dataUltimaManutencaoBancoDados\" ng-model=\"vm.parametros.dataUltimaManutencaoBancoDados\" \nid=\"cadastro-parametros-tabempresa-dtUltimaManutencao\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-datepicker></md-input-container></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-coletor/tab-coletor.html","<md-content id=\"cadastro-parametros-tab-coletor\"><md-tabs class=\"tabcoletor-tabs\" md-dynamic-height md-border-bottom>\n<md-tab label=\"Configuração\" md-active=\"vm.tabSelecionada === \'configuracao\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'configuracao\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_COLETOR_TAB_CONFIGURACAO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-coletor-tab-configuracao\"></md-content></md-tab-body></md-tab><md-tab label=\"Parametrização\" \nmd-active=\"vm.tabSelecionada === \'leitura\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'leitura\')\"><md-tab-label><label\n translate=\"RESOURCES.TAB_COLETOR_TAB_LEITURA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-coletor-tab-leitura\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-ocorrencia/tab-ocorrencia.html","<md-content id=\"cadastro-parametros-tab-ocorrencia\"><div class=\"form-container\"><div layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.LEITURA_NORMAL\">\nLeitura normal</label><md-select name=\"codigoOcorrenciaLeituraNormal\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaLeituraNormal\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaLeituraNormal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.LEITURA_FORA_DA_FAIXA\">Leitura fora da faixa</label><md-select \nname=\"codigoOcorrenciaForaFaixa\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaForaFaixa\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaForaFaixa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.VIRADA_DE_MEDIDOR\">Virada de medidor\n</label><md-select name=\"codigoOcorrenciaVirada\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaVirada\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaVirada\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.LIGACAO_SEM_MEDIDOR\">Ligação sem medidor</label><md-select \nname=\"codigoOcorrenciaLigacaoSemMedidor\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaLigacaoSemMedidor\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaLigacaoSemMedidor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.HIDROMETRO_INVERTIDO\">\nHidrômetro invertido</label><md-select name=\"codigoOcorrenciaHidrometroInvertido\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaHidrometroInvertido\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaHidrometroInvertido\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.LEITURA_CONFIRMADA\">Leitura confirmada</label><md-select \nname=\"codigoOcorrenciaLeituraConfirmada\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaLeituraConfirmada\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaLeituraConfirmada\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.LEITURA_ATUAL_MENOR_QUE_ANTERIOR\">\nLeitura atual menor que anterior</label><md-select name=\"codigoOcorrenciaLeituraMenorAnterior\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaLeituraMenorAnterior\" \nng-model=\"vm.parametro.codigoOcorrenciaLeituraMenorAnterior\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.HIDROMETRO_NOVO\">Hidrômetro novo</label><md-select \nname=\"codigoOcorrenciaHidrometroNovo\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaHidrometroNovo\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaHidrometroNovo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.CALCULO_PROPORCIONAL\">\nCálculo proporcional</label><md-select name=\"codigoOcorrenciaCalculoProporcional\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaCalculoProporcional\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaCalculoProporcional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.SITUACAO_EXCECAO_CONSUMO\">Situação de exceção com consumo</label><md-select\n name=\"codigoOcorrenciaSituacaoExcecaoComConsumo\" \nng-change=\"vm.metodos.changeSituacaoExecucaoConsumo(vm.parametro.calculo.codigoOcorrenciaSituacaoExcecaoComConsumo)\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaSituacaoExcecaoComConsumo\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaSituacaoExcecaoComConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select><div class=\"mensagem-alerta-situacao-infracao\" \nng-if=\"vm.parametro.calculo.codigoOcorrenciaInfracaoConsumo\"><span>\nAs ocorrências de “Situação de exceção com consumo” e “Infração de consumo” não podem ser utilizadas simultaneamente.\n</span></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.HIDROMETRO_PARADO\">Hidrômetro parado</label><md-select \nname=\"codigoOcorrenciaHidrometroParado\" id=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaHidrometroParado\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaHidrometroParado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label translate=\"RESOURCES.INFRACAO_CONSUMO\">Infração de consumo</label><md-select \nname=\"codigoOcorrenciaInfracaoConsumo\" \nng-change=\"vm.metodos.changeInfracaoConsumo(vm.parametro.calculo.codigoOcorrenciaInfracaoConsumo)\" \nid=\"cadastro-parametros-tabocorrencia-slctCodigoOcorrenciaInfracaoConsumo\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaInfracaoConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"ocorrencia.id\" ng-repeat=\"ocorrencia in vm.listaOcorrencias\">\n{{ocorrencia.descricao}}</md-option></md-select><div class=\"mensagem-alerta-situacao-infracao\" \nng-if=\"vm.parametro.calculo.codigoOcorrenciaSituacaoExcecaoComConsumo\"><span>\nAs ocorrências de “Situação de exceção com consumo” e “Infração de consumo” não podem ser utilizadas simultaneamente.\n</span></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><md-checkbox name=\"utilizaCapturaFotoOcorrenciaAutomatica\" \nid=\"cadastro-parametros-tabocorrencia-chkUtilizaCapturaFotoOcorrenciaAutomatica\" \nng-model=\"vm.parametro.coletor.utilizaCapturaFotoOcorrenciaAutomatica\" aria-label=\"Ultiliza recursos de consumo médio\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoDetalheCalculo == vm.tipoDetalheCalculo.bauru\">\n<span translate=\"RESOURCES.CAPTURAR_FOTO_AUTOMATICA_APOS_GRAVACAO\">Capturar foto automática após gravação</span>\n</md-checkbox></md-input-container></div></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-controller/tab-controller.html","<md-content id=\"tab-controller\"><div class=\"form-container\"><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label translate=\"RESOURCES.TIMEOUT_GPS\">Timeout GPS (segundos)</label><input \nui-number-mask=\"0\" ui-hide-group-sep \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'coletor\',\'timeoutGPS\', vm.parametro.coletor.timeoutGPS)\" \nmascara-tamanho-campo=\"6\" name=\"timeoutGPS\" id=\"cadastro-parametros-tabcontroller-txtTimeoutGPS\" \nng-model=\"vm.parametro.coletor.timeoutGPS\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.INTERVALO_ENVIO_ONLINE\">Intervalo de envio de leituras</label><md-select \nname=\"intervaloEnvioOnline\" ng-model=\"vm.parametro.coletor.intervaloEnvioOnline\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeintervaloEnvioLeituras(vm.parametro.coletor.intervaloEnvioOnline)\"><md-option \nng-value=\"minutos.valor\" ng-repeat=\"minutos in vm.temposMinutosIntervaloEnvioOnline\">{{minutos.descricao}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label>\nTempo limite para cancelamento de leitura</label><md-select name=\"tempoLimiteCancelamentoLeitura\" \nng-model=\"vm.parametro.coletor.tempoLimiteCancelamentoLeitura\" \nng-disabled=\"vm.parametro.coletor.intervaloEnvioOnline == 0 || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"minutos.valor\" ng-repeat=\"minutos in vm.temposMinutosTempoLimiteCancelamentoLeitura\">\n{{minutos.descricao}}</md-option></md-select><md-icon class=\"cor-icone-padrao icone-informacao\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"bottom\">\nPara habilitar este campo, selecione um intervalo para envio de leituras diferente de \'Sem intervalo\'.</md-tooltip>\n</md-icon></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"45\" ng-if=\"false\"><label \ntranslate=\"RESOURCES.QTD_LEITURAS_PENDENTES_ENVIO_ONLINE_PERMITIDA\">\nQuantidade de leituras pendentes de envio online permitida</label><input ui-number-mask=\"0\" ui-hide-group-sep \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'quantidadeLeiturasPendentesEnvioOnlinePermitida\', vm.parametro.quantidadeLeiturasPendentesEnvioOnlinePermitida)\" \nmascara-tamanho-campo=\"5\" name=\"quantidadeLeiturasPendentesEnvioOnlinePermitida\" \nid=\"cadastro-parametros-tabcontroller-txtQuantidadeLeiturasPendentesEnvioOnlinePermitida\" \nng-model=\"vm.parametro.quantidadeLeiturasPendentesEnvioOnlinePermitida\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\"><fieldset class=\"standard\" flex flex-gt-sm=\"40\"><md-checkbox \nname=\"utilizaAlertaDiasConsumoLimite\" id=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaRotinaGeoprocessamento\" \nng-model=\"vm.parametro.coletor.utilizaRotinaGeoprocessamento\" aria-label=\"Utiliza rotina de Geoprocessamento\" \nng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_ROTINA_GEOPROCESSAMENTO\">Utilizar rotina de geoprocessamento</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.coletor.utilizaRotinaGeoprocessamento == true\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label \ntranslate=\"RESOURCES.INTERVALO_ENVIO_COORDENADAS_GEOPROCESSAMENTO\"></label><input ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"5\" ng-required=\"vm.parametro.coletor.utilizaRotinaGeoprocessamento == true\" \nname=\"intervaloEnvioCoordenadasGeoprocessamento\" \nid=\"cadastro-parametros-tabcoletor-tableitura-txtIntervaloEnvioCoordenadasGeoprocessamento\" ng-min=\"1\" \nng-model=\"vm.parametro.coletor.intervaloEnvioCoordenadasGeoprocessamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeintervaloEnvioCoordenadasGeoprocessamento(vm.form.intervaloEnvioCoordenadasGeoprocessamento, vm.form, vm.controleForm)\">\n<div ng-messages=\"vm.form.intervaloEnvioCoordenadasGeoprocessamento.$error\"><div ng-message=\"min\" \ntranslate=\"PARAMETROS.INTERVALO_ENVIO_COORDENADAS_GEOPROCESSAMENTO\"></div><div ng-message=\"max\" \ntranslate=\"PARAMETROS.INTERVALO_ENVIO_COORDENADAS_GEOPROCESSAMENTO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"intervaloEnvioCoordenadasGeoprocessamento\">\n<span>Intervalo não pode ser menor que 60 segundos</span></div></div></md-input-container></div></fieldset></div></div>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-personalizacao/tab-personalizacao.html","<md-content id=\"cadastro-parametros-tab-personalizacao\"><div class=\"form-container\" layout=\"column\"><fieldset \nlayout=\"column\" flex=\"100\"><legend class=\"grp-legend\">Imagens personalizadas</legend><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\"><fieldset layout=\"column\" flex><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"container-imagem\"><i class=\"icon-file-image-box s200 imagem-nao-definida\" \nng-if=\"vm.parametro.empresa.logomarcaAplicacao == \'\' \"></i> <img class=\"imagem-definida\" \nng-src=\"data:image/png;base64, {{vm.parametro.empresa.logomarcaAplicacao}}\" \nng-click=\"vm.metodos.zoomImagem(vm.parametro.empresa.logomarcaAplicacao)\" \nng-if=\"vm.parametro.empresa.logomarcaAplicacao != \'\'\"><md-tooltip md-autohide \nng-if=\"vm.parametro.empresa.logomarcaAplicacao != \'\'\">Clique para ampliar</md-tooltip></div><div layout=\"row\"><input \nid=\"inputFotoAplicacao\" hidden type=\"file\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarFotoLogoAplicacao(event)\" name=\"fotoLogomarcaAplicacao\" \naccept=\"image/jpeg, image/png\" multiple=\"multiple\" style=\"max-width: 100%;align-self: center\"><md-button \nclass=\"botao-arredondado\" ng-click=\"vm.metodos.inputFotoAplicacao()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                   !vm.controleForm.editarAtivo && \r\n                                                   !vm.controleForm.inserirAtivo\">\n<md-tooltip md-autohide><span>Selecione a foto</span></md-tooltip><md-icon md-font-icon=\"icon-camera cor-icone s32\" \nng-class=\" {\'desabilitado\': vm.controleForm.pesquisaAtiva && \r\n                                                                    !vm.controleForm.editarAtivo &&\r\n                                                                    !vm.controleForm.inserirAtivo}\">\n</md-icon></md-button></div><span class=\"cor-titulo\">Logomarca da aplicação</span></div></fieldset><fieldset \nlayout=\"column\" flex><div layout=\"column\" layout-align=\"center center\" style=\"height: 267px\"><div \nclass=\"container-imagem\"><i class=\"icon-file-image-box s200 imagem-nao-definida\" \nng-if=\"vm.parametro.empresa.imagemFundoAplicacao == \'\' \"></i> <img name=\"fotoFundoAplicacao\" class=\"imagem-definida\" \nng-if=\"vm.parametro.empresa.imagemFundoAplicacao != \'\' \" ng-src=\"{{vm.parametro.empresa.imagemFundoAplicacao}}\" \nng-click=\"vm.metodos.zoomImagem(vm.parametro.empresa.imagemFundoAplicacao)\" \nng-model=\"vm.parametro.empresa.imagemFundoAplicacao\"><md-tooltip md-autohide \nng-if=\"vm.parametro.empresa.imagemFundoAplicacao != \'\' \">Clique para ampliar</md-tooltip></div><div layout=\"row\">\n<md-button class=\"botao-arredondado\" ng-click=\"vm.metodos.abrirDialogImagensPredefinidas()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                   !vm.controleForm.editarAtivo && \r\n                                                   !vm.controleForm.inserirAtivo\">\n<md-tooltip md-autohide><span>Selecione a foto</span></md-tooltip><md-icon md-font-icon=\"icon-camera cor-icone s32\" \nng-class=\" {\'desabilitado\': vm.controleForm.pesquisaAtiva && \r\n                                                                    !vm.controleForm.editarAtivo &&\r\n                                                                    !vm.controleForm.inserirAtivo}\">\n</md-icon></md-button></div><span class=\"cor-titulo\">Imagem de fundo da aplicação</span></div></fieldset></div>\n</fieldset></div></md-content>");
$templateCache.put("app/main/cadastros/ocorrencia/views/tabs/tab-comunicado/tab-comunicado.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><md-checkbox \nname=\"imprimeComunicadoSeparado\" id=\"cadastros-ocorrencia-tabconfiguracoes-chkimprimeComunicadoSeparado\" \nng-model=\"vm.ocorrencia.imprimeComunicadoSeparado\" aria-label=\"Permite a impressão do comunicado de ocorrência\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.PERMITIR_IMPRESSAO_COMUNICADO\">Permite a impressão do comunicado de ocorrência</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"60\"><md-checkbox \nname=\"utilizaDescricaoOcorrenciaTituloComunicado\" \nid=\"cadastros-ocorrencia-tabconfiguracoes-chkutilizaDescricaoOcorrenciaTituloComunicado\" \nng-model=\"vm.ocorrencia.utilizaDescricaoOcorrenciaTituloComunicado\" \naria-label=\"Utiliza a descrição da ocorrência no título do comunicado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_DESCRICAO_DA_OCORRENCIA_NO_TITULO\">\nUtilizar a descrição da ocorrência no título do comunicado</span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\"><label \ntranslate=\"RESOURCES.MENSAGEM_ESPECIFICA_OCORRENCIA_COMUNICADO\"></label><textarea \nname=\"mensagemEspecificaOcorrenciaComunicado\" id=\"cadastro-ocorrencia-txtmensagemEspecificaOcorrenciaComunicado\" \nng-model=\"vm.ocorrencia.mensagemEspecificaOcorrenciaComunicado\" cols=\"66\" wrap=\"hard\" rows=\"5\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n            \r\n        </md-input-container>\r\n\r\n        \r\n        <div layout=\"row\" flex-offset=\"5\" flex-gt-sm=\"40\" \nlayout-align=\"center center\">\r\n            <div class=\"md-subheader\">\r\n                <span style=\"color: #039be5\" \ntranslate=\"RESOURCES.MENSAGEM_PARTICULARIDADES_MENSAGEM_COM_OCORRENCIA\"> </span>\r\n            </div>\r\n        </div>\n\r\n    </div>\r\n    \r\n</div>");
$templateCache.put("app/main/cadastros/ocorrencia/views/tabs/tab-configuracoes-adicionais/tab-configuracoes-adicionais.html","<div class=\"form-container tab-configuracoes-adicionais\"><div layout-gt-xs=\"row\" flex layout-align=\"start center\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"imprimeDescricaoConta\" \nid=\"cadastros-ocorrencia-chkimprimeDescricaoConta\" ng-model=\"vm.ocorrencia.imprimeDescricaoConta\" \naria-label=\"Imprime descrição na conta\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nImprime descrição na conta</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex><md-checkbox name=\"desconsideraLeitura\" id=\"cadastros-ocorrencia-chkdesconsideraLeitura\" \nng-model=\"vm.ocorrencia.desconsideraLeitura\" aria-label=\"Desconsidera leitura\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nDesconsidera leitura</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" \nflex><md-checkbox name=\"geraLeituraCalculada\" id=\"cadastros-ocorrencia-chkgeraLeituraCalculada\" \nng-model=\"vm.ocorrencia.geraLeituraCalculada\" aria-label=\"Gera leitura calculada\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.sistemaGestorEhThema || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<span>Gera leitura calculada</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex><md-checkbox name=\"geraRepasse\" id=\"cadastros-ocorrencia-chkgeraRepasse\" \nng-model=\"vm.ocorrencia.geraRepasse\" aria-label=\"Gera repasse\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nGera repasse</span></md-checkbox></md-input-container></div><div layout-gt-xs=\"row\" flex layout-align=\"start center\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox \nname=\"consideraOcorrenciaSomenteCalculoImpressaoConta\" \nid=\"cadastros-ocorrencia-chkconsideraOcorrenciaSomenteCalculoImpressaoConta\" \nng-model=\"vm.ocorrencia.consideraOcorrenciaSomenteCalculoImpressaoConta\" \naria-label=\"Considera ocorrência somente para cálculo e impressão\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nConsidera ocorrência somente para cálculo e impressão</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"calculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \nid=\"cadastros-ocorrencia-chkcalculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \nng-model=\"vm.ocorrencia.calculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \naria-label=\"Calcula fatura quando ocorrência bloquear impressão\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nCalcula fatura quando ocorrência bloquear impressão</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox name=\"geraLeituraCalculadaConsumoMinimoQuandoConsumoMenorMinimo\" \nid=\"cadastros-ocorrencia-chkgeraLeituraCalculadaConsumoMinimoQuandoConsumoMenorMinimo\" \nng-model=\"vm.ocorrencia.geraLeituraCalculadaConsumoMinimoQuandoConsumoMenorMinimo\" \naria-label=\"Gera leitura calculada com consumo mínimo quando consumo menor que mínimo\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nGera leitura calculada quando consumo menor que mínimo</span><md-tooltip md-direction=\"bottom\">\nGera leitura calculada com consumo mínimo quando consumo menor que mínimo</md-tooltip></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex><md-checkbox \nname=\"permiteCreditoConsumo\" id=\"cadastros-ocorrencia-chkpermiteCreditoConsumo\" \nng-model=\"vm.ocorrencia.permiteCreditoConsumo\" aria-label=\"Permite crédito de consumo\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nPermite crédito de consumo</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex><md-checkbox name=\"calculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \nid=\"cadastros-ocorrencia-chkcalculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \nng-model=\"vm.ocorrencia.calculaFaturaQuandoOcorrenciaBloqueiaImpressao\" \naria-label=\"Calcula fatura quando ocorrência bloquear impressão\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nCalcula fatura quando ocorrência bloquear impressão</span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" flex layout-align=\"start center\" style=\"margin-top: 10px\"><div flex-gt-sm=\"25\" flex \nstyle=\"margin-right: 5px\"><select-simples titulo=\"Tipo de ação para ocorrência\" nome-controle=\"tipoAcaoOcorrencia\" \nlista=\"vm.opcoesTipoAcaoOcorrenciaAcaoOcorrenciaAnterior\" chave=\"chave\" valor=\"valor\" utiliza-pesquisa=\"false\" \nutiliza-ordenacao=\"false\" ng-model=\"vm.ocorrencia.tipoAcaoOcorrencia\" \nng-change=\"vm.metodos.onChangeTipoAcaoOcorrencia(vm.ocorrencia.tipoAcaoOcorrencia)\" \nng-disabled=\"vm.sistemaGestorEhThema || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n</select-simples></div><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex \nng-if=\"vm.ocorrencia.tipoAcaoOcorrencia == 3\"><label>Consumo fixo determinado (m³)</label><input \nid=\"cadastros-ocorrencia-txtconsumoFixoDeterminado\" type=\"text\" name=\"consumoFixoDeterminado\" \nmascara-tamanho-campo=\"5\" mascara-numero-generica=\"#####\" ng-model=\"vm.ocorrencia.consumoFixoDeterminado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex \nng-if=\"vm.ocorrencia.tipoAcaoOcorrencia == 6\"><label>Código da tabela de valores fixos</label><input \nid=\"cadastros-ocorrencia-txtcodigoValorFixoDeterminado\" type=\"text\" name=\"codigoValorFixoDeterminado\" \nmascara-tamanho-campo=\"3\" mascara-numero-generica=\"###\" ng-model=\"vm.ocorrencia.codigoValorFixoDeterminado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><div flex-gt-sm=\"25\" flex style=\"margin-left: 5px\"><select-simples \ntitulo=\"Ação para ocorrência anterior\" nome-controle=\"acaoOcorrenciaAnterior\" \nlista=\"vm.opcoesTipoAcaoOcorrenciaAcaoOcorrenciaAnterior\" chave=\"chave\" valor=\"valor\" utiliza-pesquisa=\"false\" \nutiliza-ordenacao=\"false\" ng-model=\"vm.ocorrencia.acaoOcorrenciaAnterior\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</select-simples></div></div></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tab-modoimplantacao.html","<md-content id=\"tab-modoimplantacao\"><div class=\"form-container\"><md-tabs class=\"equipe-tabs\" md-dynamic-height \nmd-border-bottom><md-tab label=\"Configuração\" md-active=\"vm.tabSelecionada === \'configuracao\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'configuracao\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_CONFIGURACAO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-configuracao\"></md-content></md-tab-body></md-tab><md-tab label=\"Processamento\" \nmd-active=\"vm.tabSelecionada === \'processamento\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'processamento\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_PROCESSAMENTO\"></label></md-tab-label><md-tab-body>\n<md-content ui-view=\"tab-modoimplantacao-tab-processamento\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Processamento\" md-active=\"vm.tabSelecionada === \'auditoria\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'auditoria\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_AUDITORIA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-auditoria\"></md-content></md-tab-body></md-tab><md-tab label=\"critica\" \nng-if=\"vm.parametro.tipoProcesso === \'02\'\" md-active=\"vm.tabSelecionada === \'critica\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'critica\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_CRITICA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-critica\"></md-content></md-tab-body></md-tab><md-tab label=\"Outros\" \nmd-active=\"vm.tabSelecionada === \'outros\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'outros\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_OUTROS\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-outros\"></md-content></md-tab-body></md-tab><md-tab label=\"Outros\" \nng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 93\" md-active=\"vm.tabSelecionada === \'especifico\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'especifico\')\"><md-tab-label><label>Específico</label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-especifico\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Outros\" md-active=\"vm.tabSelecionada === \'dadosConfig\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'dadosConfig\')\"><md-tab-label><label>Dados Config</label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-dados-config\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Outros\" md-active=\"vm.tabSelecionada === \'controleImportacao\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'controleImportacao\')\"><md-tab-label><label \nng-if=\"vm.parametro.tipoProcesso == 01\">Controle Carga</label><label ng-if=\"vm.parametro.tipoProcesso != 01\">\nControle Importação</label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-controle-importacao\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Ilha solteira\" md-active=\"vm.tabSelecionada === \'ilhaSolteira\'\" \nng-if=\"vm.parametro.empresa.codigoImanager == 2471\" md-on-select=\"vm.metodosTab.tabSelecionada(\'ilhaSolteira\')\">\n<md-tab-label><label>Ilha Solteira</label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-ilhaSolteira\"></md-content></md-tab-body></md-tab><md-tab label=\"Marca especial\" \nmd-active=\"vm.tabSelecionada === \'marcaEspecial\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'marcaEspecial\')\">\n<md-tab-label><label>Marca especial</label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-marca-especial\"></md-content></md-tab-body></md-tab><md-tab label=\"DANFAg\" \nmd-active=\"vm.tabSelecionada === \'DANFAg\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'DANFAg\')\"><md-tab-label><label>\nDANFAg</label></md-tab-label><md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-danfag\"></md-content>\n</md-tab-body></md-tab><md-tab label=\"Retenção de dados\" md-active=\"vm.tabSelecionada === \'retencaoDados\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'retencaoDados\')\"><md-tab-label><label>Retenção de dados</label>\n</md-tab-label><md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-retencao-dados\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></md-content>");
$templateCache.put("app/main/cadastros/ocorrencia/views/tabs/tab-ocorrencia/tab-ocorrencia.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.CODIGO\"></label><input id=\"cadastros-ocorrencia-txtCodigo\" type=\"text\" name=\"codigoOcorrencia\" \nui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"4\" ng-model=\"vm.ocorrencia.codigo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo)\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><proximo-codigo rota=\"vm.rota\" entidade-codigo=\"vm.ocorrencia.codigo\" \npre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\" ng-show=\"vm.controleForm.inserirAtivo\"></proximo-codigo>\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.OBS_LEITURA\"></label><input \nid=\"cadastro-ocorrencia-txtobsleitura\" ype=\"text\" name=\"obsleitura\" mascara-tamanho-campo=\"4\" md-maxlength=\"4\" \nng-model=\"vm.ocorrencia.codigoObservacaoLeitura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.DESCRICAO\">\n</label><input id=\"cadastro-ocorrencia-txtdescricao\" type=\"text\" name=\"descricao\" mascara-tamanho-campo=\"100\" \nmd-maxlength=\"100\" ng-model=\"vm.ocorrencia.descricao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.nome.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container id=\"cadastro-ocorrencia-txtvalor\" class=\"md-block\" flex><label \ntranslate=\"RESOURCES.VALOR\"></label><input type=\"text\" name=\"valor\" mascara-tamanho-campo=\"18\" ui-money-mask=\"4\" \nng-model=\"vm.ocorrencia.valor\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"column\"><div layout-gt-xs=\"row\" flex=\"100\"><fieldset class=\"mt-16\" flex=\"100\" \nlayout-gt-xs=\"column\" style=\"display: flex\"><md-input-container class=\"md-block\" flex layout-align=\"start center\" \nstyle=\"display: flex\"><md-checkbox name=\"exigeCapturarFoto\" \nid=\"cadastros-ocorrencia-tabconfiguracoes-chkexigeCapturarFoto\" aria-label=\"Exige captura de fotos\" \nng-model=\"vm.ocorrencia.exigeCapturarFoto\" \nng-change=\"vm.metodos.changeExigeCapturarFoto(vm.ocorrencia.exigeCapturarFoto)\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.EXIGIR_CAPTURA_FOTOS\"></span></md-checkbox></md-input-container><div layout=\"row\" \nng-if=\"vm.ocorrencia.exigeCapturarFoto == \'S\' && (vm.controleForm.inserirAtivo || \r\n                                                                       vm.controleForm.editarAtivo || \r\n                                                                       vm.controleForm.pesquisaAtiva)\">\n<md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.MIN_FOTOS_OCORRENCIA\"></label><input \nid=\"cadastros-ocorrencia-txtMinFotosOcorrencia\" type=\"text\" name=\"minimoFotosPorOcorrencia\" mascara-tamanho-campo=\"2\" \nmascara-numero-generica=\"##\" ng-change=\"vm.metodos.changeQtdMinimaFotos(vm.ocorrencia.quantidadeMinimaFotos)\" \nng-model=\"vm.ocorrencia.quantidadeMinimaFotos\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || \r\n                                            vm.ocorrencia.exigeCapturarFoto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"vm.form.minimoFotosPorOcorrencia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"validaQuantidadeMinimaFotos\"><span \nng-if=\"(vm.ocorrencia.exigeCapturarFoto == \'S\' && vm.ocorrencia.quantidadeMinimaFotos <= 0)\">\nO valor informado deve ser maior que zero.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"RESOURCES.MAX_FOTOS_OCORRENCIA\"></label><input id=\"cadastros-ocorrencia-txtMaxFotosOcorrencia\" \ntype=\"text\" name=\"maximoFotosPorOcorrencia\" mascara-tamanho-campo=\"2\" mascara-numero-generica=\"##\" \nng-change=\"vm.metodos.changeQtdMaximaFotos(vm.ocorrencia.quantidadeMaximaFotos)\" \nng-model=\"vm.ocorrencia.quantidadeMaximaFotos\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo || \r\n                                            vm.ocorrencia.exigeCapturarFoto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                            !vm.controleForm.inserirAtivo\">\n<div ng-messages=\"\r\n                               vm.form.maximoFotosPorOcorrencia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div class=\"mensagem-erro mt-5\" ng-if=\"vm.mensagemErro\"><span>\nO valor informado não deve ser menor que o valor informado na quantidade mínima de fotos.</span></div><div \nng-message=\"validaQuantidadeMaximaFotos\"><span>O valor informado deve ser maior que zero.</span></div></div>\n</md-input-container></div></fieldset><fieldset class=\"standard\" layout-gt-xs=\"column\" layout-align=\"center center\" \nflex=\"100\"><legend class=\"grp-legend\">Geração de serviço no cálculo</legend><div layout-gt-xs=\"row\"><md-input-container\n class=\"md-block\" flex-gt-sm=\"15\"><label translate=\"RESOURCES.CODIGO\"></label><input \nid=\"cadastros-ocorrencia-codigoServico\" type=\"text\" name=\"codigoServico\" ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"4\" ng-model=\"vm.ocorrencia.codigoServico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label translate=\"RESOURCES.DESCRICAO\">\n</label><input id=\"cadastro-ocorrencia-descricaoServico\" type=\"text\" name=\"descricaoServico\" \nmascara-tamanho-campo=\"70\" md-maxlength=\"70\" ng-model=\"vm.ocorrencia.descricaoServico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                           !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"25\" flex-xs><label>Tipo</label><md-select \nid=\"cadastro-ocorrencia-tipoServico\" name=\"tipoServico\" ng-model=\"vm.ocorrencia.tipoServico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                               !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"tipoServico.id\" ng-repeat=\"tipoServico in vm.listaTipoServico\">{{ tipoServico.descricao }}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.VALOR\"></label><input id=\"cadastro-ocorrencia-valorServico\" type=\"text\" name=\"valorServico\" \nmascara-tamanho-campo=\"18\" ui-money-mask=\"4\" ng-model=\"vm.ocorrencia.valorServico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                           !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\" flex=\"25\"><md-checkbox id=\"cadastros-ocorrencia-tabconfiguracoes-chkpermiteImpressaoConta\" \nname=\"permiteImpressaoConta\" aria-label=\"Permite imprimir fatura\" ng-model=\"vm.ocorrencia.permiteImpressaoConta\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.PERMITIR_IMPRIMIR_FATURA\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex=\"25\"><md-checkbox id=\"cadastros-ocorrencia-tabconfiguracoes-chkpermiteDigitarLeitura\" \nname=\"permiteDigitarLeitura\" aria-label=\"Permite digitar leitura\" ng-model=\"vm.ocorrencia.permiteDigitarLeitura\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.sistemaGestorEhThema || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo)\">\n<span translate=\"RESOURCES.PERMITIR_DIGITAR_LEITURA\"></span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex=\"25\"><md-checkbox id=\"cadastros-ocorrencia-tabconfiguracoes-chklancamentoautomatico\" \nname=\"lancamentoautomatico\" aria-label=\"Utilizar lançamento automático\" ng-true-value=\"\'S\'\" \nng-model=\"vm.ocorrencia.lancamentoAutomatico\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.LANCAMENTO_AUTOMATICO_OCORRENCIA\">Utilizar lançamento automático</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><md-checkbox \nid=\"cadastros-ocorrencia-tabconfiguracoes-chkexibeNaRotinaImpressaoFaturasNaoImpressasPorOcorrencia\" \nname=\"exibeNaRotinaImpressaoFaturasNaoImpressasPorOcorrencia\" \naria-label=\"Exibe esta ocorrência na rotina de faturas não impressas por ocorrência\" ng-true-value=\"\'S\'\" \nng-model=\"vm.ocorrencia.exibeNaRotinaImpressaoFaturasNaoImpressasPorOcorrencia\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.EXIBIR_NA_ROTINA_IMPRESSAO_FATURAS_NAO_IMPRESSAS_POR_OCORRENCIA\">\nExibir na rotina de faturas não impressas por ocorrência</span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"25\"><md-checkbox \nname=\"bloqueiaLancamentoManual\" aria-label=\"Bloquear lançamento manual\" \nng-model=\"vm.ocorrencia.bloqueiaLancamentoManual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                 !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.BLOQUEIA_LANCAMENTO_OCORRENCIA\">Bloquear lançamento manual</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" style=\"margin-left: 0px !important\" flex=\"25\"><md-checkbox \nname=\"sugerirSolicitacaoServico\" aria-label=\"Sugerir solicitação de serviço\" \nng-model=\"vm.ocorrencia.sugerirSolicitacaoServico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                             !vm.controleForm.inserirAtivo\">\n<span>Sugerir solicitação de serviço</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nstyle=\"margin-left: 0px !important\" flex=\"25\"><label>Situação da ligação</label><md-select \nid=\"cadastro-ocorrencia-situacaoLigacao\" name=\"situacaoLigacao\" ng-model=\"vm.ocorrencia.situacaoLigacao\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                     !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"situacaoLigacao.codigo\" ng-repeat=\"situacaoLigacao in vm.situacoesLigacao\">\n{{ situacaoLigacao.descricao }}</md-option></md-select></md-input-container><div flex=\"25\"></div></div><div flex \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block mt-0\" flex-gt-sm=\"100\"><label \nng-if=\"!vm.codigoImanagerMacaubas\" \ntranslate=\"RESOURCES.MENSAGEM_ESPECIFICA_COLETOR_QUANDO_FATURA_NAO_IMPRESSA_PELA_OCORRENCIA\"></label><label \nng-if=\"vm.codigoImanagerMacaubas\">Mensagem específica a ser impressa na fatura</label><textarea \nid=\"cadastro-ocorrencia-txtmensagemEspecificaColetorQuandoFaturaNaoImpressaPelaOcorrencia\" \nname=\"mensagemEspecificaColetorQuandoFaturaNaoImpressaPelaOcorrencia\" mascara-tamanho-campo=\"100\" md-maxlength=\"100\" \nng-model=\"vm.ocorrencia.mensagemEspecificaColetorQuandoFaturaNaoImpressaPelaOcorrencia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                      \r\n                                     !vm.controleForm.inserirAtivo\">\n\r\n            </md-input-container>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/main/datamobil-ia/components/lista-favoritos/components/dialog-favoritos/dialog-favoritos.html","<md-dialog id=\"dialog-favoritos\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form name=\"favoritosForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.metodos.salvar()\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.titulo}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" \naria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear style=\"width: 100%\" class=\"md-accent\" md-mode=\"indeterminate\" ng-show=\"vm.favoritando\">\n</md-progress-linear><md-dialog-content ms-scroll><div class=\"input-titulo\"><md-input-container><label>Título</label>\n<input type=\"text\" name=\"titulo\" ng-model=\"vm.favorito.titulo\" mascara-tamanho-campo=\"60\" md-maxlength=\"60\" \ncaracteres-permitidos></md-input-container></div><div class=\"input-container\" layout=\"row\" \nlayout-align=\"center center\" ng-class=\"{\'has-content\': vm.favorito.comando}\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.copiarComando()\" aria-label=\"Copiar Comando\" \nstyle=\"position: absolute; top: 0; right: 0; z-index: 99\"><md-icon ng-if=\"!vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-svg-src=\"assets/custom/copy.svg\"></md-icon><md-icon ng-if=\"vm.acaoCopiar\" \nstyle=\"color: rgba(0, 0, 0, 0.54)\" md-font-icon=\"icon-check-circle s16\"></md-icon><md-tooltip \nmd-autohidemd-delay=\"200\"><span>Copiar</span></md-tooltip></md-button><label class=\"legend\">Comando</label>\n<md-input-container md-no-float class=\"md-block\"><textarea ng-model=\"vm.favorito.comando\" \nplaceholder=\"Insira um comando...\" rows=\"5\" ng-disabled=\"true\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions><md-button ng-if=\"vm.modoEdicao\" ng-click=\"vm.metodos.cancelar()\" \nclass=\"md-raised md-accent botao-cancelar\" ng-disabled=\"vm.favoritando\"><span>Cancelar</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"favoritosForm.$invalid || vm.favoritando\"><span \nng-if=\"!vm.modoEdicao\">Criar</span> <span ng-if=\"vm.modoEdicao\">Salvar</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.filtroLeiturista\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"leiturista in vm.leituristas  | filter: {apelido: vm.filtroLeiturista} | orderBy: \'apelido\' :false | filter:query as filteredContact\" \nng-click=\"vm.listarConversa(leiturista.codigo)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.leituristas[$index].apelido.charAt(0) !== vm.leituristas[$index-1].apelido.charAt(0)\">\n{{leiturista.apelido.charAt(0)}}</div><div class=\"avatar-wrapper\"><img ng-src=\"{{leiturista.diretorioFoto}}\" \nclass=\"md-avatar avatar\" alt=\"{{leiturista.apelido}}\"> <i class=\"icon icon- s16 status\" ng-class=\"leiturista.status\">\n</i></div><div class=\"md-list-item-text\"><h3>{{leiturista.apelido}}</h3><p class=\"mood\">{{leiturista.mood}}</p></div>\n</md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" class=\"no-results-message\" \ntranslate=\"CHAT.NO_RESULTS_CONTACTS\">No results..</div></md-content>");
$templateCache.put("app/main/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.leituristas.getById(vm.leituristaSelecionadoId).name}}\"><div class=\"contact-name\">\n{{vm.leituristas.getById(vm.leituristaSelecionadoId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" \nflex ms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.leituristas.getById(vm.leituristaSelecionadoId).mood\">\n{{vm.leituristas.getById(vm.leituristaSelecionadoId).mood}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.filtroLeiturista\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.filtroLeiturista && filteredChat.length > 0\" class=\"md-accent-fg subheader\" translate=\"CHAT.CHATS\">CHATS\n</div><md-list-item class=\"contact md-3-line\" \nng-repeat=\"leiturista in vm.leituristas | filter: vm.filtroLeiturista | orderBy: \'dataUltimaMensagem\':true | filter:query as filteredContact\" \nng-if=\"leiturista.ultimaMensagem.length > 0\" ng-click=\"vm.listarConversa(leiturista.codigo)\" \nng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img ng-src=\"{{leiturista.diretorioFoto}}\" \nclass=\"md-avatar avatar\" alt=\"{{leiturista.apelido}}\"> <i class=\"icon icon- s16 status\" ng-class=\"leiturista.status\">\n</i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{leiturista.apelido}}</h3><p class=\"last-message\">\n{{ leiturista.ultimaMensagem | limitTo: 15 }} {{leiturista.ultimaMensagem.length > 15 ? \'...\' : \'\'}}</p><p show-xs \nhide-gt-sm class=\"last-message-time\">{{leiturista.dataUltimaMensagem | date: \'dd/MM/yyyy\'}}</p></div><div \nlayout=\"column\" layout-align=\"center end\"><div hide show-gt-sm class=\"last-message-time\">\n{{leiturista.dataUltimaMensagem | date: \'dd/MM/yyyy HH:mm:ss\'}}</div><div \nng-if=\"leiturista.quantidadeMensagensNaoLidas > 0\" class=\"md-accent-bg unread-message-count\">\n{{leiturista.quantidadeMensagensNaoLidas}}</div></div><md-divider></md-divider></md-list-item></md-list><div \nng-if=\"filteredContact.length <= 0 || !vm.verificarSeExisteLeituristasComConversa()\" class=\"no-results-message\" \ntranslate=\"CHAT.NO_RESULTS\">Nenhuma conversa encontrada.</div></md-content><md-button class=\"md-fab contacts-button\" \nng-disabled=\"vm.carregandoConversa\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/datamobil-ia/components/mensagens-recebidas/components/tabela-resposta/tabela-resposta.html","<div class=\"tabela-resposta-container\"><div class=\"container-input-pesquisa-tabela\"><md-input-container><input \ntype=\"text\" class=\"search-input\" placeholder=\"Pesquisar...\" ng-model=\"vm.pesquisar\"></md-input-container></div><div \nclass=\"no-results text-center\" ng-if=\"vm.paginacao.totalItens === 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s40\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNenhum resultado encontrado!</div></div></div><table class=\"simple\" ng-if=\"vm.paginacao.totalItens > 0\"><thead><tr \nclass=\"border\"><th ng-repeat=\"header in vm.cabecalhos\" ng-click=\"vm.metodos.ordenarPor(header)\" \nstyle=\"cursor: pointer\">{{ header }}<md-icon ng-if=\"vm.ordenacao.coluna === header\" \nmd-font-icon=\"{{vm.ordenacao.direcao === \'asc\' ? \'icon-arrow-up\' : \'icon-arrow-down\'}}\" class=\"s12\" \nstyle=\"margin-top: -2px\"></md-icon></th></tr></thead><tbody><tr class=\"border\" ng-repeat=\"item in vm.dadosPaginados\">\n<td ng-repeat=\"header in vm.cabecalhos\">{{ item[header] }}</td></tr></tbody></table><div class=\"pagination-controls\" \nng-if=\"vm.paginacao.totalItens > 0\"><div class=\"items-per-page\"><label>Itens por página:</label><md-select \nng-model=\"vm.paginacao.itensPorPagina\" ng-change=\"vm.metodos.mudarItensPorPagina()\" aria-label=\"Itens por página\">\n<md-option ng-repeat=\"option in vm.paginacao.opcoesItensPorPagina\" ng-value=\"option\">{{option}}</md-option></md-select>\n</div><div class=\"pagination-info\"><span>\nExibindo {{vm.paginacao.itemInicial}} - {{vm.paginacao.itemFinal}} de {{vm.paginacao.totalItens}}</span></div><div \nclass=\"pagination-buttons\"><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.primeiraPagina()\" \naria-label=\"Primeira página\" ng-disabled=\"vm.paginacao.paginaAtual === 1\"><md-icon \nmd-font-icon=\"icon-chevron-double-left s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.paginaAnterior()\" aria-label=\"Página anterior\" ng-disabled=\"vm.paginacao.paginaAtual === 1\">\n<md-icon md-font-icon=\"icon-chevron-left s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.proximaPagina()\" aria-label=\"Próxima página\" \nng-disabled=\"vm.paginacao.paginaAtual === vm.paginacao.totalPaginas\"><md-icon md-font-icon=\"icon-chevron-right s24\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.ultimaPagina()\" \naria-label=\"Última página\" ng-disabled=\"vm.paginacao.paginaAtual === vm.paginacao.totalPaginas\"><md-icon \nmd-font-icon=\"icon-chevron-double-right s24\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/gerenciamento/dashboards/distribuicao-grupos/views/resumo-distribuicao-grupos/resumo-distribuicao-grupos-form.html","<div layout=\"column\" id=\"quitacaoanual-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-gruposleituras\" md-whiteframe=\"4\" \nui-view=\"distribuicaogrupos-filtro@app.gerenciamento_dashboards_distribuicaogrupos\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"no-results text-center\" ng-if=\"!vm.distribuicao.dados.tarefas.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide ng-if=\"vm.distribuicao.dados.tarefas.length\"><div \nflex=\"80\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.distribuicao.filtros.mes }}/{{ vm.distribuicao.filtros.ano }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Grupo</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.distribuicao.filtros.grupo }}</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" \nstyle=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" layout-align=\"space-between\" \nng-if=\"vm.distribuicao.dados.tarefas.length\"><div layout=\"column\" class=\"pb-8\"><ms-widget style=\"padding:0!important\">\n<ms-widget-front><div><table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr \nshow-gt-sm hide class=\"border-top\"><th colspan=\"7\" \nclass=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">Tarefas</span></div>\n</th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Leiturista</span></div></th><th class=\"secondary-text borda-esquerda borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Tarefa</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Qtde.</span>\n</div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nRota</span></div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Roteirização inicial</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Endereço inicial</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Endereço final\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"dado in vm.distribuicao.dados.tarefas track by $index\"><td \nclass=\"text-left border-left border-right\"><span>{{ dado.leiturista }}</span></td><td class=\"text-center border-right\">\n<span>{{ dado.tarefa }}</span></td><td class=\"text-center border-right\"><span>{{ dado.quantidade }}</span></td><td \nclass=\"text-center border-right\"><span>{{ dado.rota }}</span></td><td class=\"text-center border-right\"><span>\n{{ dado.roterizacaoInicial }}</span></td><td class=\"text-left border-right\"><span>{{ dado.enderecoInicial }}</span>\n</td><td class=\"text-left border-right\"><span>{{ dado.enderecoFinal }}</span></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\">\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Total de ligações</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.distribuicao.dados.totalLigacoes | number }}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Total distribuidas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.distribuicao.dados.totalLigacoesDistribuidas | number }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Total não distribuidas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.distribuicao.dados.totalLigacoesNaoDistribuidas | number }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Total de tarefas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.distribuicao.dados.totalTarefas | number }}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Data importação</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-20\">{{ vm.distribuicao.dados.dataImportacao | date: \"dd/MM/yyyy\" }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 font-size-14\">Arquivo</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-20\">\n{{ vm.distribuicao.dados.arquivoImportacao }}</div></div></ms-widget-front></ms-widget></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual-detalhado/quitacao-anual-detalhado-form.html","<div layout=\"column\" id=\"quitacaoanual-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-quitacaoanual\" md-whiteframe=\"4\" \nui-view=\"quitacaoanual-filtro@app.gerenciamento.dashboards_quitacaoanual\" ms-scroll ms-sidenav-helper></md-sidenav><div\n class=\"no-results text-center\" ng-if=\"!vm.quitacoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.quitacoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Quitação anual de débitos</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Detalhado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.quitacoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.quitacoes.filtros.mesReferencia }}/{{ vm.quitacoes.filtros.anoReferencia }}</div></div><div \nng-if=\"vm.quitacoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\"><div flex=\"100\" layout-align=\"center center\" class=\"font-weight-500 secondary-text\">Período de leituras\n</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.quitacoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.quitacoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.quitacoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\" \nng-repeat=\"referencia in vm.quitacoes.dados.detalhesReferencias track by $index\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Referência: {{ referencia.referencia }}</span></div><div \nclass=\"agrupamento-detalhes\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"grupo in referencia.grupos track by $index\"><div layout=\"column\" \nclass=\"pb-8\" flex=\"70\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table \nclass=\"dataTable hover row-border\"><thead><tr class=\"border-top\"><th colspan=\"3\" \nclass=\"border-left secondary-text black-fg th-group-header\"><div class=\"table-header\" id=\"agrupamento-header\"><span \nclass=\"font-size-14 font-weight-900 text-center white-space-normal\">Grupo: {{ grupo.grupo }}</span></div></th></tr><tr>\n<th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Código</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Endereço</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in grupo.clientes track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{ cliente.codigoLigacao }}</span></td><td class=\"text-left border-right\"><span>{{ cliente.endereco }}</span></td></tr>\n</tbody><tfoot><th colspan=\"3\" class=\"secondary-text border-right border-left\"><div class=\"text-left\"><span \nclass=\"text-left\" ng-if=\"referencia.grupos.length > 1\">Total: {{ grupo.total }}</span></div></th></tfoot></table></div>\n</ms-widget-front></ms-widget></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\">\n<div flex=\"30\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Total da referência {{ referencia.referencia }}</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ referencia.total }}</div></div></ms-widget-front></ms-widget>\n</div></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" style=\"margin-top: 50px\">\n<div flex=\"40\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-600 secondary-text font-size-20\">Total de comunicados</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-22\">{{ vm.quitacoes.dados.total }}</div></div></ms-widget-front>\n</ms-widget></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/controle-fluxo/views/sidenav/controle-fluxo-filtro.html","<div id=\"filtro-controleFluxo\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Período</span></legend>\n<div flex=\"100\" layout=\"column\" class=\"campos-data\"><md-input-container><label translate=\"RESOURCES.DATA_INICIO\">\nData Inicial</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtroSelecionado.dataInicial\" \nmd-max-date=\"vm.filtroSelecionado.dataFinal\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data final</label><md-datepicker ng-required=\"true\" \nng-model=\"vm.filtroSelecionado.dataFinal\" md-min-date=\"vm.filtroSelecionado.dataInicial\" ng-mask=\"3?9/1?9/9999\" \nname=\"dataFinal\" mascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\"><span>Leituristas</span></legend><div layout=\"column\" flex><div \nlayout=\"row\" flex layout-align=\"center center\"><multi-select-directive id=\"select-leituristas\" \nclass=\"filtros-multi-select\" style=\"margin:0px;padding: 0px\" flex form-name=\"leituristas\" data=\"vm.leituristas\" \nmodel=\"vm.filtroSelecionado.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"apelidoExibicao\" \ntexto-pesquisa-placeholder=\"Procurar leituristas...\" texto-placeholder=\"Leituristas\" disabled=\"false\"></div></div>\n</fieldset><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.form.$invalid\" ng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodos.filtrar(vm.filtroSelecionado)\"><span>Filtrar</span></md-button></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/gerenciamento/dashboards/quitacao-anual/views/quitacao-anual-simplificado/quitacao-anual-simplificado-form.html","<div layout=\"column\" id=\"quitacaoanual-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-quitacaoanual\" md-whiteframe=\"4\" \nui-view=\"quitacaoanual-filtro@app.gerenciamento.dashboards_quitacaoanual\" ms-scroll ms-sidenav-helper></md-sidenav><div\n class=\"no-results text-center\" ng-if=\"!vm.quitacoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.quitacoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Quitação anual de débitos</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Simplificado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.quitacoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referência</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.quitacoes.filtros.mesReferencia }}/{{ vm.quitacoes.filtros.anoReferencia }}</div></div><div \nng-if=\"vm.quitacoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\"><div flex=\"100\" layout-align=\"center center\" class=\"font-weight-500 secondary-text\">Período de leituras\n</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{ vm.quitacoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.quitacoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.quitacoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\" flex=\"100\" ng-if=\"vm.quitacoes.dados.detalhesReferencias.length > 1\">\n<div class=\"pv-8 h3 border-bottom\" flex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"font-size-24\" style=\"font-weight: 600; text-align: center\">Análise geral por referência</span></div><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"75\" flex-xs=\"100\" \nclass=\"border-right\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" data=\"vm.multiBarHorizontalChart.data\"></nvd3>\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"25\" flex-xs=\"100\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><span class=\"font-size-24\" style=\"font-weight: 600; text-align: center\">\nTotal de comunicados</span> <span class=\"font-size-20\">{{ vm.quitacoes.dados.total }}</span></div></div></div></div>\n<div class=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Detalhamento de grupo por referência</span></div><div \nclass=\"agrupamento-detalhes border-bottom\" layout=\"row\" layout-xs=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"dado in vm.quitacoes.dados.detalhesReferencias track by $index\">\n<div layout=\"column\" class=\"pb-8\" flex=\"40\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div>\n<table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr class=\"border-top\"><th \ncolspan=\"2\" class=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nReferência: {{ dado.referencia }}</span></div></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Grupo</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Total</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"grupo in dado.grupos track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{ grupo.grupo }}</span></td><td class=\"text-center border-right\">\n<span>{{ grupo.total }}</span></td></tr></tbody><tfoot><th colspan=\"2\" class=\"secondary-text border-right border-left\">\n<div class=\"text-left\"><span class=\"text-left\">Total: {{ dado.total }}</span></div></th></tfoot></table></div>\n</ms-widget-front></ms-widget></div><div flex=\"60\" flex-xs=\"100\"><nvd3 options=\"dado.pieChart.options\" \ndata=\"dado.pieChart.data\"></nvd3></div></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/dialogs/dialog-visualizacao-leitura/critica-leitura-dialog-visualizacao-leitura.html","<md-dialog id=\"critica-leituras-visualizacao\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-button \nclass=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icone s26\"></md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"LEITURA.VISUALIZACAO.TITULO\" icone=\"icon-engine\" ng-utiliza-pesquisa=\"false\"></header-padrao><div \nms-scroll class=\"scrollable\" ui-view=\"leitura-visualizacao-form@app.gerenciamento_leitura_visualizacao\"></div>\n</md-dialog>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/sidenav/legenda/legenda-critica-sidenav.html","<div id=\"legenda-critica-leituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h3><span>\nLegenda</span></h3></div></md-toolbar><md-content layout-padding layout=\"column\"><md-list><md-list-item \nng-repeat=\"item in vm.itens\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><md-icon class=\"icone-legenda\" \nmd-font-icon=\"{{item.icone}}\" ng-style=\"{\'color\' : item.cor}\"></md-icon><span class=\"legend-title ml-5 mr-5\" \nstyle=\"font-size: 14px\">{{item.situacao}}</span></div></md-list-item><md-divider></md-divider></md-list></md-content>\n</div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/views/comunicados-detalhado/resumo-retencoes-comunicados-detalhado-form.html","<div layout=\"column\" id=\"resumoretencoes-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-resumoretencoes\" md-whiteframe=\"4\" \nui-view=\"resumoretencoes-filtro@app.gerenciamento.dashboards_resumoretencoes\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"no-results text-center\" ng-if=\"!vm.retencoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Comunicados retidos</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Detalhado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referências</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.mesInicial }}/{{ vm.retencoes.filtros.anoInicial }} até {{ vm.retencoes.filtros.mesFinal }}/{{ vm.retencoes.filtros.anoFinal }}\n</div></div><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Período de leituras</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.retencoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\" \nng-repeat=\"referencia in vm.retencoes.dados.detalhesReferencias track by $index\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Referência: {{ referencia.referencia }}</span></div><div \nclass=\"agrupamento-detalhes\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"grupo in referencia.grupos track by $index\"><div layout=\"column\" \nclass=\"pb-8\" flex=\"70\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table \nclass=\"dataTable hover row-border\"><thead><tr class=\"border-top\"><th colspan=\"3\" \nclass=\"border-left secondary-text black-fg th-group-header\"><div class=\"table-header\" id=\"agrupamento-header\"><span \nclass=\"font-size-14 font-weight-900 text-center white-space-normal\">Grupo: {{ grupo.grupo }}</span></div></th></tr><tr>\n<th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Código</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Nome</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Comunicado</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"cliente in grupo.clientes track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{ cliente.codigoLigacao }}</span></td><td \nclass=\"text-left border-right\"><span>{{ cliente.nome }}</span></td><td class=\"text-left border-right\"><span>\n{{ cliente.tipoComunicado }}</span></td></tr></tbody><tfoot><th colspan=\"3\" \nclass=\"secondary-text border-right border-left\"><div class=\"text-left\"><span class=\"text-left\" \nng-if=\"referencia.grupos.length > 1\">Total: {{ grupo.totalGrupo }}</span></div></th></tfoot></table></div>\n</ms-widget-front></ms-widget></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\">\n<div flex=\"30\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Total da referência {{ referencia.referencia }}</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ referencia.totalReferencia }}</div></div></ms-widget-front>\n</ms-widget></div></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" \nstyle=\"margin-top: 50px\"><div flex=\"40\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm \nhide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-600 secondary-text font-size-20\">Total de retenções</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-22\">{{ vm.retencoes.dados.total }}</div></div></ms-widget-front>\n</ms-widget></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/views/comunicados-simplificado/resumo-retencoes-comunicados-simplificado-form.html","<div layout=\"column\" id=\"resumoretencoes-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-resumoretencoes\" md-whiteframe=\"4\" \nui-view=\"resumoretencoes-filtro@app.gerenciamento.dashboards_resumoretencoes\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"no-results text-center\" ng-if=\"!vm.retencoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Comunicados retidos</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Simplificado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referências</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.mesInicial }}/{{ vm.retencoes.filtros.anoInicial }} até {{ vm.retencoes.filtros.mesFinal }}/{{ vm.retencoes.filtros.anoFinal }}\n</div></div><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Período de leituras</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.retencoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\" flex=\"100\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length > 1\">\n<div class=\"pv-8 h3 border-bottom\" flex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"font-size-24\" style=\"font-weight: 600; text-align: center\">Análise geral por referência</span></div><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"75\" flex-xs=\"100\" \nclass=\"border-right\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" data=\"vm.multiBarHorizontalChart.data\"></nvd3>\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"25\" flex-xs=\"100\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><span class=\"font-size-24\" style=\"font-weight: 600; text-align: center\">\nTotal de retenções</span> <span class=\"font-size-20\">{{ vm.retencoes.dados.total }}</span></div></div></div></div><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Detalhamento de grupo por referência</span></div><div \nclass=\"agrupamento-detalhes border-bottom\" layout=\"row\" layout-xs=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"dado in vm.retencoes.dados.detalhesReferencias track by $index\">\n<div layout=\"column\" class=\"pb-8\" flex=\"40\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div>\n<table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr class=\"border-top\"><th \ncolspan=\"2\" class=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nReferência: {{ dado.referencia }}</span></div></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Grupo</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Total</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"grupo in dado.grupos track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{ grupo.grupo }}</span></td><td class=\"text-center border-right\">\n<span>{{ grupo.totalGrupo }}</span></td></tr></tbody><tfoot><th colspan=\"2\" \nclass=\"secondary-text border-right border-left\"><div class=\"text-left\"><span class=\"text-left\">\nTotal: {{ dado.totalReferencia }}</span></div></th></tfoot></table></div></ms-widget-front></ms-widget></div><div \nflex=\"60\" flex-xs=\"100\"><nvd3 options=\"dado.pieChart.options\" data=\"dado.pieChart.data\"></nvd3></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/views/faturas-detalhado/resumo-retencoes-faturas-detalhado-form.html","<div layout=\"column\" id=\"resumoretencoes-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-resumoretencoes\" md-whiteframe=\"4\" \nui-view=\"resumoretencoes-filtro@app.gerenciamento.dashboards_resumoretencoes\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"no-results text-center\" ng-if=\"!vm.retencoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Faturas retidas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Detalhado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referências</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.mesInicial }}/{{ vm.retencoes.filtros.anoInicial }} até {{ vm.retencoes.filtros.mesFinal }}/{{ vm.retencoes.filtros.anoFinal }}\n</div></div><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Período de leituras</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.retencoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\" \nng-repeat=\"referencia in vm.retencoes.dados.detalhesReferencias track by $index\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Referência: {{ referencia.referencia }}</span></div><div \nclass=\"agrupamento-detalhes\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"grupo in referencia.grupos track by $index\"><div layout=\"column\" \nclass=\"pb-8\" flex=\"70\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table \nclass=\"dataTable hover row-border\"><thead><tr class=\"border-top\"><th colspan=\"2\" \nclass=\"border-left secondary-text black-fg th-group-header\"><div class=\"table-header\" id=\"agrupamento-header\"><span \nclass=\"font-size-14 font-weight-900 text-center white-space-normal\">Grupo: {{ grupo.grupo }}</span></div></th></tr><tr>\n<th class=\"secondary-text borda-esquerda borda-direita\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Código</span></div></th><th class=\"secondary-text borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Nome</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cliente in grupo.clientes track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{ cliente.codigoLigacao }}</span></td><td class=\"text-left border-right\"><span>{{ cliente.nome }}</span></td></tr>\n</tbody><tfoot><th colspan=\"2\" class=\"secondary-text border-right border-left\"><div class=\"text-left\"><span \nclass=\"text-left\" ng-if=\"referencia.grupos.length > 1\">Total: {{ grupo.totalGrupo }}</span></div></th></tfoot></table>\n</div></ms-widget-front></ms-widget></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" \nlayout=\"row\"><div flex=\"30\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Total da referência {{ referencia.referencia }}</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ referencia.totalReferencia }}</div></div></ms-widget-front>\n</ms-widget></div></div></div><div class=\"white-bg\" flex=\"15\" layout-align=\"center center\" layout=\"row\" \nstyle=\"margin-top: 50px\"><div flex=\"40\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm \nhide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-600 secondary-text font-size-20\">Total de retenções</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-22\">{{ vm.retencoes.dados.total }}</div></div></ms-widget-front>\n</ms-widget></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/views/faturas-simplificado/resumo-retencoes-faturas-simplificado-form.html","<div layout=\"column\" id=\"resumoretencoes-form\" flex=\"100\"><md-sidenav class=\"sidenav md-sidenav-left\" \nmd-component-id=\"filtro-resumoretencoes\" md-whiteframe=\"4\" \nui-view=\"resumoretencoes-filtro@app.gerenciamento.dashboards_resumoretencoes\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"no-results text-center\" ng-if=\"!vm.retencoes.dados.detalhesReferencias.length && !vm.emProgresso\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"titulo-text\" translate=\"RESOURCES.NENHUM_FILTRO_REALIZADO\">Nenhum filtro realizado.</div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.abrirFiltro()\"><span translate=\"RESOURCES.FILTRAR\">Filtrar</span>\n</md-button></div></div><md-content flex ng-if=\"vm.emProgresso\"><carregamento-circular em-progresso=\"vm.emProgresso\" \ntitulo=\"Aguarde...\" mensagem=\"Atualizando os dados...\"></carregamento-circular></md-content><div class=\"white-bg\" \nflex=\"15\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide \nng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div flex=\"60\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Faturas retidas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">Simplificado</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 1\" \nclass=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Referências</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.mesInicial }}/{{ vm.retencoes.filtros.anoInicial }} até {{ vm.retencoes.filtros.mesFinal }}/{{ vm.retencoes.filtros.anoFinal }}\n</div></div><div ng-if=\"vm.retencoes.filtros.tipoFiltro === 2\" class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Período de leituras</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">\n{{ vm.retencoes.filtros.dataInicial | date: \'dd/MM/yyyy\' }} até {{ vm.retencoes.filtros.dataFinal | date: \'dd/MM/yyyy\'}}\n</div></div></ms-widget-front></ms-widget></div></div><md-content class=\"p-8\" style=\"overflow-y: scroll\" \nlayout=\"column\" flex=\"100\" layout-align=\"space-between\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\" flex=\"100\" ng-if=\"vm.retencoes.dados.detalhesReferencias.length > 1\">\n<div class=\"pv-8 h3 border-bottom\" flex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"font-size-24\" style=\"font-weight: 600; text-align: center\">Análise geral por referência</span></div><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"75\" flex-xs=\"100\" \nclass=\"border-right\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" data=\"vm.multiBarHorizontalChart.data\"></nvd3>\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"25\" flex-xs=\"100\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><span class=\"font-size-24\" style=\"font-weight: 600; text-align: center\">\nTotal de retenções</span> <span class=\"font-size-20\">{{ vm.retencoes.dados.total }}</span></div></div></div></div><div \nclass=\"card md-whiteframe-4dp agrupamento-tabelas\" layout=\"column\" flex=\"100\"><div class=\"pv-8 h3 border-bottom\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" flex><span class=\"font-size-24\" \nstyle=\"font-weight: 600; text-align: center\">Detalhamento de grupo por referência</span></div><div \nclass=\"agrupamento-detalhes border-bottom\" layout=\"row\" layout-xs=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" flex=\"100\" ng-repeat=\"dado in vm.retencoes.dados.detalhesReferencias track by $index\">\n<div layout=\"column\" class=\"pb-8\" flex=\"40\" flex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div>\n<table class=\"dataTable hover row-border\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr class=\"border-top\"><th \ncolspan=\"2\" class=\"border-left secondary-text border-right black-fg th-group-header\"><div class=\"table-header\" \nid=\"agrupamento-header\"><span class=\"font-size-14 font-weight-900 text-center white-space-normal\">\nReferência: {{ dado.referencia }}</span></div></th></tr><tr><th class=\"secondary-text borda-esquerda borda-direita\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Grupo</span></div></th><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Total</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"grupo in dado.grupos track by $index\"><td \nclass=\"text-center border-left border-right\"><span>{{ grupo.grupo }}</span></td><td class=\"text-center border-right\">\n<span>{{ grupo.totalGrupo }}</span></td></tr></tbody><tfoot><th colspan=\"2\" \nclass=\"secondary-text border-right border-left\"><div class=\"text-left\"><span class=\"text-left\">\nTotal: {{ dado.totalReferencia }}</span></div></th></tfoot></table></div></ms-widget-front></ms-widget></div><div \nflex=\"60\" flex-xs=\"100\"><nvd3 options=\"dado.pieChart.options\" data=\"dado.pieChart.data\"></nvd3></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/gerenciamento/produtividade/dialogs/dialog-detalhes-critica/views/dialog-detalhes-critica.html","<md-dialog layout=\"column\" id=\"dialog-detalhes-critica\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Detalhes de críticas</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex=\"100\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide><div \nflex=\"75\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Agrupamento</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.agrupamento}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leiturista</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.leiturista}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{vm.filtrosUtilizados.data | date: \'dd/MM/yyyy\'}}</div></div></ms-widget-front></ms-widget></div></div><div \nflex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Ocorrência</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Quantidade</span></div></th><th\n class=\"secondary-text border-left borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Ação</span></div></th></thead><tbody><tr ng-repeat=\"ocorrencia in vm.ocorrencias\"><td \nclass=\"text-center border-left\"><span>{{ocorrencia.ocorrencia}}</span></td><td class=\"text-center border-left\"><span>\n{{ocorrencia.quantidade}}</span></td><th class=\"text-center border-left border-right border-bottom\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.abrirTelaVisualizacaoLeituras(ocorrencia)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.ABRIR_VISUALIZACAO_LEITURAS\">Abrir visualização de leituras\n</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" class=\"cor-icone-padrao\"></md-icon></md-button></th></tr>\n</tbody></table></div><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><div flex=\"50\"></div><div flex=\"30\">\n<ms-widget class=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Total de críticas</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.totalCriticas | number}}</div></div></ms-widget-front></ms-widget></div><div flex=\"20\"></div>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/produtividade/dialogs/dialog-detalhes/views/dialog-detalhes-produtividade.html","<md-dialog layout=\"column\" id=\"dialog-detalhes-produtividade\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Detalhes de produtividade</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex=\"100\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide><div \nflex=\"75\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Agrupamento</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.agrupamento}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leiturista</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.leiturista}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{vm.filtrosUtilizados.data | date: \'dd/MM/yyyy\'}}</div></div></ms-widget-front></ms-widget></div></div><div \nflex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr show-gt-sm hide><th colspan=\"4\" class=\"border-left secondary-text th-group-header\"></th><th colspan=\"4\" \nclass=\"secondary-text border-left borda-direita th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leituras</span></div></th></tr><tr><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Tarefa</span></div></th><th class=\"secondary-text border-left\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Grupo</span></div></th><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Município</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Tipo tarefa</span></div></th>\n<th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Distribuídas</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Recebidas</span></div></th><th \nclass=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Realizadas</span></div></th><th class=\"secondary-text border-left\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Críticas</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"dados in vm.dadosDetalhes track by $index\"><td class=\"text-center border-left\"><span>\n{{dados.numeroTarefa}}</span></td><td class=\"text-center border-left\"><span>{{dados.grupo}}</span></td><td \nclass=\"text-center border-left\"><span>{{dados.municipio}}</span></td><td class=\"text-center border-left\"><span \nclass=\"ml-5 text-boxed green-bg white-fg ng-binding\" ng-if=\"!dados.tarefaCritica\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">1° visita</span> <span class=\"ml-5 text-boxed red-bg white-fg ng-binding\" \nng-if=\"dados.tarefaCritica\" style=\"margin: 5px 5px; font-size: 0.85em\">Crítica</span></td><td \nclass=\"text-center border-left\"><span>{{dados.leiturasDistribuidas | number}}</span></td><td \nclass=\"text-center border-left\"><span>{{dados.leiturasRecebidas | number}}</span></td><td \nclass=\"text-center border-left\"><span>{{dados.leiturasRealizadas | number}}</span></td><td \nclass=\"text-center border-left border-right\"><span>{{dados.criticas | number}}</span></td></tr></tbody></table></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/mapa/views/rastreamento-leiturista-mapa.html","<div id=\"mapa\" style=\"height: 100%;width: auto\"></div>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/sidenavs/views/filtro-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2></div>\n</md-toolbar><form name=\"vm.form\" novalidate><md-content class=\"content\" layout-padding><fieldset class=\"standard\" \nflex><legend class=\"grp-legend\"><span>Período</span></legend><div layout=\"row\" flex class=\"input-periodo\">\n<md-input-container class=\"md-block\"><label translate=\"LEITURA.RASTREAMENTO.DATA_INICIAL\"></label><md-datepicker \nng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" md-max-date=\"vm.filtro.dataFinal\" \nng-disabled=\"vm.desabilitarCamposFiltro\" mascara-conversor-string-para-data ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataInicial.$error\"><div ng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\">\n</div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block aumentar-tamanho-campo-data-ultima-validacao\"><label translate=\"LEITURA.RASTREAMENTO.DATA_FINAL\">\n</label><md-datepicker ng-model=\"vm.filtro.dataFinal\" name=\"dataFinal\" md-min-date=\"vm.filtro.dataInicial\" \nng-disabled=\"vm.desabilitarCamposFiltro\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data ng-required=\"true\">\n</md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\"><span>Leiturista</span></legend><md-autocomplete flex required \nmd-input-name=\"autocompleteField\" md-no-cache=\"true\" md-selected-item=\"vm.filtro.leiturista\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.apelido\" \nmd-min-length=\"0\" ng-disabled=\"vm.desabilitarCamposFiltro\" md-require-match md-floating-label=\"Pesquisar leiturista\">\n<md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.codigo}} - {{item.apelido}}\n</span></md-item-template><md-not-found>Nenhum leiturista \"{{vm.searchText}}\" foi encontrado.</md-not-found><div \nng-messages=\"vm.form.autocompleteField.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-autocomplete></fieldset><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-if=\"!vm.desabilitarCamposFiltro && !vm.emProgresso\" ng-disabled=\"!vm.form.$valid\" \nng-click=\"vm.metodos.atualizarMapa(vm.filtro);\"><span>filtrar</span></md-button><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.emProgresso\" class=\"md-accent\" md-diameter=\"54\"></md-progress-circular></div></div>\n</md-content></form>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/step/leiturista/leiturista-step.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><md-content class=\"md-padding\"><md-autocomplete \nmd-no-cache=\"true\" md-selected-item=\"vm.filtro.leiturista\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.apelido\" md-min-length=\"0\" \nplaceholder=\"Selecione um leiturista\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.apelido}}</span></md-item-template><md-not-found>\nNenhum leiturista \"{{vm.searchText}}\" foi encontrado.</md-not-found></md-autocomplete></md-content></div>");
$templateCache.put("app/main/gerenciamento/produtividade/dialogs/dialog-detalhes-ociosidade/views/dialog-detalhes-ociosidade.html","<md-dialog layout=\"column\" id=\"dialog-detalhes-produtividade\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Detalhes de ociosidade</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><div flex=\"75\" \nlayout-align-gt-sm=\"center center\" layout-gt-sm=\"row\" layout=\"column\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Agrupamento</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.agrupamento}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leiturista</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{vm.filtrosUtilizados.leiturista}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-8 md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Data</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">\n{{vm.filtrosUtilizados.data | date: \'dd/MM/yyyy\'}}</div></div></ms-widget-front></ms-widget></div></div><div \nflex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text border-left\">\n<div class=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Parada</span></div></th>\n<th class=\"secondary-text border-left\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Retorno</span></div></th><th class=\"secondary-text border-left borda-direita\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Total</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"dados in vm.detalhesOciosidade track by $index\"><td class=\"text-center border-left\">\n<span>{{dados.horaInicial}}</span></td><td class=\"text-center border-left\"><span>{{dados.horaFinal}}</span></td><td \nclass=\"text-center border-left border-right\"><span>{{dados.duracao}}</span></td></tr></tbody></table><div flex=\"100\" \nlayout-align=\"end center\" layout=\"row\"><ms-widget class=\"h-60\" style=\"padding: 4px!important;width: 32%\" \nlayout=\"column\" flex=\"32\"><ms-widget-front class=\"p-8 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Total</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-16\">\n{{vm.totalizador}}</div></div></ms-widget-front></ms-widget></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/CAEMA/leitura-visualizacao-form-caema.html","<div class=\"md-background-bg md-whiteframe-1dp\" id=\"leitura-visualizacao\"><form name=\"vm.form\" novalidate><pg-toolbar \nclass=\"toolbar-fixa\" entidades=\"vm.ResultadodadosCadastrais\" entidade=\"vm.dadosCadastrais\" \nentidade-de-envio=\"vm.entidadeDeEnvio\" esconder-botao-editar=\"true\" esconder-botao-excluir=\"true\" \nesconder-botao-inserir=\"true\" esconder-botao-salvar=\"!vm.editandoLeituraComRetencao\" \ndesabilitar-botao-salvar=\"!vm.editandoLeituraComRetencao\" esconder-botao-nova-pesquisa=\"true\" \nesconder-botao-pesquisar=\"true\" esconder-botao-reverter=\"!vm.editandoLeituraComRetencao\" \ndesabilitar-botao-reverter=\"!vm.editandoLeituraComRetencao\" esconder-botao-atualizar=\"true\" \nesconder-botao-modo-tabela=\"true\" esconder-botao-listar-todas-entidades=\"true\" esconder-mensagem-status=\"true\" \nacao-pesquisar=\"vm.metodos.pesquisar()\" acao-editar=\"vm.tabSelecionada === \'critica\' && vm.metodos.editar()\" \ncontrolador-pre-loader=\"controladorPreLoader\" controlador-toolbar=\"vm.controleForm\" \nmetodo-externo-acao-reverter=\"vm.editandoLeituraComRetencao && vm.metodos.fecharDialog()\" \nmetodos-externos=\"vm.metodosExternosPgToolbar\" construir-dt-options=\"vm.metodos.construirDtOptions()\" \niniciar-chamando-pesquisa=\"vm.iniciarChamandoPesquisa\" iniciar-habilitando-edicao=\"vm.editandoLeituraComRetencao\" \ncampo-pesquisar=\"vm.pesquisar\" ng-hide=\"!vm.dados\"></pg-toolbar><md-sidenav \nclass=\"sidenav filtro-sidenav md-sidenav-right\" md-component-id=\"filtro\" md-whiteframe=\"4\" ms-scroll md-is-open=\"true\" \nms-sidenav-helper><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><md-content class=\"content-filtro\" flex><fieldset class=\"standard\" \nng-if=\"!vm.editandoLeituraComRetencao && !vm.visualizandoLeituraComCritica\" flex><legend class=\"grp-legend\"><span \ntranslate=\"LEITURA.VISUALIZACAO.REGIONAL\"></span></legend><div layout-gt-sm=\"column\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.LOCALIDADE\"></label><md-select \nname=\"regional\" id=\"estatisticas-slcregional\" ng-change=\"vm.metodos.onChangeRegional()\" \nng-model=\"vm.filtroSelecionado.regional\" ng-required=\"true\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"item.codigo\" ng-repeat=\"item in vm.listaRegionais\">{{item.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\" flex><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.listandoMunicipios\"></md-progress-circular>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.SETOR\"></label><md-select \nname=\"municipio\" id=\"estatisticas-slcmunicipio\" ng-model=\"vm.filtroSelecionado.municipio\" \nng-disabled=\"!vm.filtroSelecionado.regional || vm.listandoMunicipios\"><md-option ng-value=\"item.codigo\" \nng-if=\"vm.listaMunicipios.length <= 0\">Nenhum município encontrado</md-option><md-option ng-value=\"item.codigo\" \nng-repeat=\"item in vm.listaMunicipios\">{{item.descricao}}</md-option></md-select></md-input-container></div></div>\n</fieldset><fieldset class=\"standard\"><legend class=\"grp-legend\">Referência</legend><div layout-gt-sm=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.MES\"></label><input type=\"text\" \nui-number-mask=\"0\" ng-required=\"true\" id=\"cadastro-entrega-tipo-entrega-mes\" ng-blur=\"vm.metodos.setDefaultMes()\" \nname=\"mes\" min-value=\"1\" max-value=\"12\" ng-required=\"true\" ng-model=\"vm.filtroSelecionado.mes\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.ANO\">ANO</label><input type=\"text\" \nname=\"ano\" ng-blur=\"vm.metodos.setDefaultAno()\" id=\"cadastros-leiturista-tabimpressao-txtmodelo\" ui-number-mask=\"0\" \nui-hide-group-sep ng-required=\"true\" ng-model=\"vm.filtroSelecionado.ano\"></md-input-container></div></fieldset>\n<fieldset class=\"standard\"><legend class=\"grp-legend\">Parâmetros</legend><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"><md-radio-group class=\"md-primary\" layout-gt-sm=\"row\" ng-model=\"vm.opcaoFiltro\" \nng-change=\"vm.metodos.limparFiltrosRadio()\" required layout-wrap><md-radio-button ng-repeat=\"filtro in vm.filtros\" \nng-value=\"filtro\" layout-gt-sm=\"row\" layout=\"center center\" style=\"margin: 10px\" flex flex-gt-sm=\"50\">{{ filtro }}\n</md-radio-button></md-radio-group></div></fieldset><div layout=\"column\" flex><div layout=\"row\" flex \nng-hide=\"vm.opcaoFiltro != \'Leiturista\'\"><md-input-container class=\"md-block\" flex=\"15\"><input type=\"text\" \nng-model=\"vm.filtroSelecionado.codigoLeiturista\" ng-required=\"vm.opcaoFiltro == \'Leiturista\'\" \nid=\"cadastros-leituristae-txtCodigoLeiturista\" ng-disabled=\"vm.opcaoFiltro != \'Leiturista\'\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" mascara-numero-generica=\"#####\" aria-label=\"RESOURCES.LEITURISTA\">\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-required=\"vm.opcaoFiltro == \'Leiturista\'\" \nname=\"leiturista\" ng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" id=\"cadastros-leiturista-txtDescricaoLeiturista\" \nng-model=\"vm.filtroSelecionado.codigoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-disabled=\"vm.opcaoFiltro != \'Leiturista\'\"><md-select-header class=\"demo-select-header\"><input id=\"select\" \nname=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" placeholder=\"Pesquisar...\"></md-select-header>\n<md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">{{leiturista.apelido}}\n</md-option></md-select><div ng-messages=\"vm.form.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block\" flex-gt-sm ng-hide=\"vm.opcaoFiltro != \'Cliente\'\"><label translate=\"LEITURA.VISUALIZACAO.CLIENTE\">\nCliente</label><input type=\"text\" ng-required=\"vm.opcaoFiltro  == \'Cliente\'\" name=\"filtroCliente\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ng-model=\"vm.filtroSelecionado.cliente\" \nng-disabled=\"vm.opcaoFiltro != \'Cliente\'\"><div ng-messages=\"vm.form.filtroCliente.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm ng-hide=\"vm.opcaoFiltro != \'Hidrômetro\'\"><label translate=\"LEITURA.VISUALIZACAO.HIDROMETRO\">Hidrometro\n</label><input type=\"text\" ng-required=\"vm.opcaoFiltro  == \'Hidrômetro\'\" name=\"filtroHidrometro\" \nid=\"cadastros-leiturista-tabimpressao-txtmodelo\" ng-model=\"vm.filtroSelecionado.hidrometro\" \nng-disabled=\"vm.opcaoFiltro != \'Hidrômetro\'\"><div ng-messages=\"vm.form.filtroHidrometro.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout=\"column\" layout-align=\"center center\" flex><md-button class=\"md-raised md-accent\" flex flex-gt-sm=\"15\" \nng-disabled=\"vm.form.$invalid || vm.controleForm.emProgresso\" \nid=\"processamento-exportacaomobile-btnDescricaoLeiturista\" ng-click=\"vm.metodos.pesquisarBotao()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><span>Pesquisar</span></md-button></div></md-content></md-sidenav><md-content \nlayout-padding ng-hide=\"vm.controleForm.listarTodasEntidades || !vm.dados\" ng-disabled=\"vm.controleForm.emProgresso\">\n<div class=\"button-float\"><md-button class=\"md-primary button-toogle icon-filter-outline md-fab\" \nng-click=\"vm.metodos.abrirFiltro()\" ng-hide=\"vm.habilitaBotaoSidenav()\"></md-button></div><div layout-gt-xs=\"row\" \nlayout=\"column\" flex=\"100\"><div layout=\"row\" flex-xs=\"100\" layout-align=\"start center\"><span \nclass=\"ml-16 text-boxed blue-bg white-fg ng-binding\" ng-hide=\"!vm.dadosCadastrais.statusLeitura\" \nstyle=\"margin: 5px 0px; font-size: 0.75em\">{{vm.dadosCadastrais.statusLeitura}}</span></div><div layout=\"row\" \nflex-xs=\"100\" layout-align=\"start center\"><span class=\"ml-16 text-boxed red-bg white-fg ng-binding status-critica\" \nng-if=\"vm.leitura.statusRetencao\" style=\"font-size: 0.75em\">{{vm.leitura.statusRetencao}}</span></div></div><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Dados cadastrais\" id=\"dados-cadastrais-tab\" \nmd-active=\"vm.tabSelecionada === \'dadosCadastrais\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosCadastrais\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_CADASTRAIS\"></label></md-tab-label><md-tab-body><md-content \nng-include=\"vm.rotasHtml.tabs.dadosCadastrais\"></md-content></md-tab-body></md-tab><md-tab label=\"Dados Leitura\" \nid=\"dados-leitura-tab\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || vm.controleForm.emProgresso \" \nmd-active=\"vm.tabSelecionada === \'dadosLeitura\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosLeitura\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_LEITURA\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosLeituraController as vm\"><md-content ng-include=\"vm.rotasHtml.tabs.dadosLeitura.templateUrl\">\n</md-content></div></md-tab-body></md-tab><md-tab label=\"Dados Faturamento\" id=\"dados-faturamento-tab\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || vm.controleForm.emProgresso\" \nmd-active=\"vm.tabSelecionada === \'dadosFaturamento\'\" md-on-select=\"vm.metodos.tabSelecionada(\'dadosFaturamento\')\">\n<md-tab-label><label translate=\"LEITURA.VISUALIZACAO.DADOS_FATURAMENTO\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosFaturamentoController as vm\"><div ng-include=\"vm.rotasHtml.tabs.dadosFaturamento.templateUrl\">\n</div></div></md-tab-body></md-tab><md-tab label=\"Dados crítica\" id=\"dados-critica-tab\" \nng-disabled=\"!vm.dadosCadastrais || !vm.dadosCadastrais.statusLeitura || vm.controleForm.emProgresso\" \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\" md-active=\"vm.tabSelecionada === \'critica\'\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'critica\')\"><md-tab-label><label \ntranslate=\"LEITURA.VISUALIZACAO.DADOS_CRITICA\"></label></md-tab-label><md-tab-body><div \nng-controller=\"DadosCriticaController as vm\"><div ng-include=\"vm.rotasHtml.tabs.dadosCritica.templateUrl\"></div></div>\n</md-tab-body></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/produtividade/sidenavs/filtro/views/filtro-produtividade.html","<div id=\"filtro-produtividade\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select ng-model=\"vm.filtro.agrupamento\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" ng-change=\"vm.metodos.onChangeAgrupamento(vm.filtro.agrupamento)\" \nng-required=\"vm.agrupamentos.length > 0\" name=\"agrupamento\" ng-disabled=\"vm.agrupamentos.length == 0\"><md-select-header\n ng-if=\"vm.agrupamentos.length > 0\"><input ng-model=\"vm.filtrarAgrupamentos\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"agrupamento.codigo\" \nng-repeat=\"agrupamento in vm.agrupamentos | filter: vm.filtrarAgrupamentos\">{{agrupamento.descricao}}</md-option>\n</md-select><span ng-if=\"vm.agrupamentos.length == 0\" class=\"nenhum-grupo\">Nenhum agrupamento encontrada.</span><div \nng-messages=\"vm.form.agrupamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-divider></md-divider><md-list-item><div layout=\"column\" flex=\"100\">\n<div flex=\"80\" layout=\"column\"><md-input-container><label translate=\"RESOURCES.DATA_INICIO\">Data início</label>\n<md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataInicio\" name=\"dataInicio\" ng-mask=\"3?9/1?9/9999\" \nng-change=\"vm.metodos.onChangeDataInicio(vm.form.dataInicio, vm.form)\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataInicio.$error\"><div \nng-message=\"dataMaxima\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFim\" \nng-mask=\"3?9/1?9/9999\" ng-change=\"vm.metodos.onChangeDataFim(vm.form.dataFim, vm.form)\" name=\"dataFim\" \nng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"vm.form.dataFim.$error\"><div ng-message=\"dataMinima\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\">\n</div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex=\"20\" class=\"p-8\" \nlayout-align=\"center center\" layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular></div></div></md-list-item><md-divider>\n</md-divider><md-list-item><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaLeituristas\">\n</md-progress-circular><multi-select-directive id=\"select-leituristas\" style=\"margin:0px;padding: 0px\" flex \nform-name=\"leiturista\" data=\"vm.leituristas\" model=\"vm.filtro.leituristas\" obrigatorio=\"true\" \ndescricao-exibicao=\"apelido\" texto-pesquisa-placeholder=\"Procurar leiturista...\" texto-placeholder=\"Leiturista\" \ndisabled=\"!vm.leituristas || !vm.leituristas.length\"></div></md-list-item><md-divider></md-divider><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.form.$valid || vm.emProgresso || vm.emProgressoBuscaGrupo\" \nng-click=\"vm.metodos.filtrarDadosProdutividade(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-list>\n</md-content></form></div>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/step/periodo/periodo-setp.html","<div layout=\"column\" class=\"page-layout carded fullwidth\"><div layout=\"row\" flex-gt-sm=\"100\"><md-input-container \nclass=\"md-block aumentar-tamanho-campo-data-ultima-validacao\"><label translate=\"LEITURA.RASTREAMENTO.DATA_INICIAL\">\n</label><md-datepicker ng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" ng-mask=\"3?9/1?9/9999\" \nmascara-conversor-string-para-data ng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\">\n<div ng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container \nclass=\"md-block aumentar-tamanho-campo-data-ultima-validacao\"><label translate=\"LEITURA.RASTREAMENTO.DATA_FINAL\">\n</label><md-datepicker ng-model=\"vm.filtro.dataFinal\" name=\"dataFinal\" ng-mask=\"3?9/1?9/9999\" \nmd-min-date=\"vm.filtro.dataInicial\" mascara-conversor-string-para-data ng-required=\"true\"></md-datepicker><div \nng-messages=\"vm.form.dataFinal.$error\"><div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div>\n<div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div>");
$templateCache.put("app/main/gerenciamento/leitura/monitoramento/mapa/views/monitoramento-mapa.html","<div id=\"mapa\" style=\"height: 100%;width: auto\"></div>");
$templateCache.put("app/main/processamento/disponibilizar-carga-retidas/views/dialog-detalhes-dependentes/views/dialog-detalhes-dependentes.html","<md-dialog id=\"dialog-selecionar-leiturista\" flex style=\"max-width: 1000px !important\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\"><h2>Detalhes dependentes</h2><span flex></span><div \nflex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-show=\"vm.exibeInformativo\"><md-icon \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nSe houver dependentes com mais de uma referência, será disponibilizada a mais antiga.</md-tooltip></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></div></md-toolbar><md-dialog-content layout-padding><div flex=\"100\" layout=\"column\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"width: 100%\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Código da ligação</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Cliente dependente\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Setor\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Rota\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nVencimento</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Mês/Ano referência</span></div></th></tr></thead><tbody><tr \nng-repeat=\"fatura in vm.faturasRetidasDependentes track by $index\"><td class=\"text-center\"><span>{{ fatura.codigo }}\n</span></td><td class=\"text-center\"><span>{{ fatura.nome }}</span></td><td class=\"text-center\"><span>{{ fatura.setor }}\n</span></td><td class=\"text-center\"><span>{{ fatura.rota }}</span></td><td class=\"text-center\"><span ng-show=\"false\">\n{{ fatura.vencimento }}</span> <span>{{ fatura.vencimento | date: \"dd/MM/yyyy HH:mm:ss\" }}</span></td><td \nclass=\"text-center\"><span>{{ fatura.mesAnoReferencia }}</span></td></tr></tbody></table></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/controlecarga/cancelarcarga/sidenav/filtro/views/filtro-cancelar-carga.html","<div id=\"filtro-cancelarcarga\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\"><span>Referência</span></legend><div layout=\"row\" flex \nclass=\"input-referencia\"><md-input-container class=\"md-block mb-0\" flex=\"15\"><label translate=\"RESOURCES.MES\">Mês\n</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.changeReferencia(vm.filtro.mes, vm.filtro.ano)\" validacao-mes ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" flex=\"25\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-change=\"vm.metodos.changeReferencia(vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></fieldset><fieldset class=\"standard\" flex ng-if=\"vm.tipoProcesso === \'01\'\"><legend \nclass=\"grp-legend\"><span>Leiturista</span></legend><md-input-container class=\"md-block\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-model=\"vm.filtro.leiturista\" \nmd-on-open=\"vm.metodos.configuraMdSelectLeiturista()\" name=\"leiturista\" ng-disabled=\"vm.leituristas.length == 0\">\n<md-select-header ng-if=\"vm.leituristas.length > 0\"><input ng-model=\"vm.filtrarLeiturista\" type=\"search\" \nid=\"select-leiturista\" placeholder=\"Pesquisar leiturista..\" class=\"md-text\"></md-select-header><md-option ng-value=\"0\">\nDesmarcar</md-option><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter: vm.filtrarLeiturista\">{{leiturista.codigo}} - {{leiturista.apelido}}\n</md-option></md-select><span ng-if=\"vm.leituristas.length == 0\" class=\"nenhum-grupo\">Nenhuma leiturista encontrado.\n</span><div ng-messages=\"vm.form.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset><fieldset \nclass=\"standard\" flex ng-if=\"vm.tipoProcesso === \'02\'\"><legend class=\"grp-legend\"><span>Grupo</span></legend>\n<md-input-container class=\"md-block\" layout=\"column\" flex><label>Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" name=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header \nng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" \nmascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"undefined\" md-option-empty>Desmarcar</md-option><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.grupo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></fieldset><fieldset class=\"standard\" flex ng-if=\"vm.tipoProcesso === \'01\'\"><legend \nclass=\"grp-legend\"><span>Status</span></legend><md-input-container class=\"md-block\" layout=\"column\" flex><label>Status\n</label><md-select ng-model=\"vm.filtro.status\" md-on-open=\"vm.metodos.configuraMdSelectStatus()\" name=\"status\" \nng-disabled=\"vm.status.length == 0\"><md-select-header ng-if=\"vm.status.length > 0\"><input ng-model=\"vm.filtrarStatus\" \ntype=\"search\" id=\"select-status\" placeholder=\"Procurar status...\" class=\"md-text\"></md-select-header><md-option \nng-value=\"status.codigo\" ng-repeat=\"status in vm.status | filter: vm.filtrarStatus\">{{ status.descricao }}</md-option>\n</md-select></md-input-container></fieldset><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\">\n</md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid || (vm.tipoProcesso === \'02\' && vm.grupos.length === 0)\" ng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodos.filtrarDadosCancelamento(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-content>\n</form></div>");
$templateCache.put("app/main/processamento/disponibilizar-carga-retidas/views/dialog-selecionar-leiturista/views/dialog-selecionar-leiturista.html","<md-dialog id=\"dialog-selecionar-leiturista\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2>Selecionar leiturista</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><form name=\"form\"><div \nflex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><input type=\"text\" \nng-model=\"vm.codigoLeiturista\" required ng-disabled=\"vm.emProgresso || vm.leituristas.length == 0\" \nng-change=\"vm.metodos.controlaTelaPorTipoArquivo()\" mascara-numero-generica=\"#####\" aria-label=\"RESOURCES.LEITURISTA\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"85\"><label class=\"md-subheader\" \ntranslate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select required name=\"leiturista\" \nid=\"processamento-exportacaomobile-txtDescricaoLeiturista\" md-on-open=\"vm.metodos.configurarSelect()\" \nng-model=\"vm.codigoLeiturista\" ng-disabled=\"vm.emProgresso || vm.leituristas.length == 0\"><md-select-header \nclass=\"demo-select-header\"><input id=\"select\" name=\"vm.termoProcurado\" ng-model=\"vm.termoProcurado\" type=\"search\" \nplaceholder=\"Pesquisar...\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter:vm.termoProcurado | orderBy:\'apelido\'\">{{leiturista.apelido}}\n</md-option></md-select></md-input-container></div></form></md-dialog-content><md-dialog-actions><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.disponibilizarFaturas()\" \nng-disabled=\"form.$invalid || vm.emProgresso\" style=\"display: flex; justify-content: center\"><span \nng-if=\"!vm.emProgresso\">Disponibilizar</span><md-progress-circular class=\"md-accent text-center\" md-diameter=\"26\" \nmd-mode=\"indeterminate\" ng-if=\"vm.emProgresso\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/controlecarga/trocarleiturista/sidenav/filtro/views/filtro-trocar-leiturista.html","<div id=\"filtro-trocar-sequencial\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select ng-model=\"vm.filtro.agrupamento\" \nmd-on-open=\"vm.metodos.configuraMdSelectAgrupamento()\" \nng-change=\"vm.metodos.changeAgrupamento(vm.filtro.agrupamento, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.agrupamentos.length > 0\" name=\"agrupamento\" ng-disabled=\"vm.agrupamentos.length == 0\"><md-select-header\n ng-if=\"vm.agrupamentos.length > 0\"><input ng-model=\"vm.filtrarAgrupamento\" type=\"search\" id=\"select-agrupamento\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"agrupamento.codigo\" \nng-repeat=\"agrupamento in vm.agrupamentos | filter: vm.filtrarAgrupamento\">{{agrupamento.descricao}}</md-option>\n</md-select><span ng-if=\"vm.agrupamentos.length == 0\" class=\"nenhum-grupo\">Nenhum agrupamento encontrada.</span><div \nng-messages=\"vm.form.agrupamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"column\" flex><div \nlayout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label>\n<input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.changeReferencia(vm.filtro.agrupamento, vm.filtro.mes, vm.filtro.ano)\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-change=\"vm.metodos.changeReferencia(vm.filtro.agrupamento, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><md-input-container class=\"md-block mt-0\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"true\" \nng-change=\"vm.metodos.changeGrupo(vm.filtro.agrupamento, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\" name=\"grupo\" \nng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" \ntype=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}\n</md-option></md-select><span ng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-list-item><md-divider></md-divider><md-list-item>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"20\" ng-if=\"vm.emProgressoTarefa\">\n</md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.TAREFA\">\nTarefa</label><md-select ng-model=\"vm.filtro.tarefa\" md-on-open=\"vm.metodos.configuraMdSelectTarefa()\" \nng-required=\"vm.tarefas.length > 0\" name=\"tarefa\" ng-disabled=\"vm.tarefas.length == 0\"><md-select-header \nng-if=\"vm.tarefas.length > 0\"><input ng-model=\"vm.filtrarTarefa\" type=\"search\" id=\"select-tarefa\" \nplaceholder=\"Pesquisar tarefa..\" class=\"md-text\"></md-select-header><md-option ng-value=\"tarefa\" \nng-repeat=\"tarefa in vm.tarefas | filter: vm.filtrarTarefa\">{{tarefa}}</md-option></md-select><span \nng-if=\"vm.tarefas.length == 0\" class=\"nenhum-grupo\">Nenhuma tarefa encontrada.</span><div \nng-messages=\"vm.form.tarefa.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></md-list-item><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\">\n<div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDadosTarefaTroca(vm.filtro)\"><span>Filtrar\n</span></md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamentocarga/sidenavs/filtro/views/CAEMA/gerenciamento-carga-caema-filtro.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2></div>\n</md-toolbar><form name=\"vm.form\" novalidate flex><md-content class=\"content-filtro-gerenciamento-carga\" \nlayout-padding><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Configurações</span></legend>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.MONITORAMENTO.FILTROS.INTERVALO\">\nIntervalo (segundos)</label><md-select name=\"tipoSegmento\" id=\"cadastro-parametros-tabempresa-slctTipoSegmento\" \nng-model=\"vm.filtros.intervalo\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option \nng-value=\"intervalo\" ng-repeat=\"intervalo in vm.intervalos\">{{intervalo.descricao}}</md-option></md-select>\n</md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Localidade</span>\n</legend><md-input-container class=\"md-block\" flex><label translate=\"RESOURCES.LOCALIDADE\"></label><md-select \nname=\"regional\" id=\"gerenciamento-carga-slcregional\" ng-model=\"vm.filtros.regionalId\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"regional.codigo\" ng-repeat=\"regional in vm.regionais\">{{regional.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>\nData refêrencia</span></legend><div flex class=\"input-periodo\"><md-input-container class=\"md-block\"><label \ntranslate=\"GERENCIAMENTO_CARGA.FILTRO.DATA_REFERENCIA\"></label><md-datepicker ng-model=\"vm.filtros.data\" \nname=\"filtroData\" md-max-date=\"vm.dataAtual\" ng-mask=\"3?9/1?9/9999\" mascara-conversor-string-para-data \nng-required=\"true\"></md-datepicker><div ng-messages=\"vm.form.filtroData.$error\"><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-if=\"!vm.emProgresso\" ng-disabled=\"!vm.form.$valid\" ng-click=\"vm.metodos.atualizarDataReferencia(vm.filtros)\"><span>\npesquisar</span></md-button><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.emProgresso\" class=\"md-accent\" \nmd-diameter=\"54\"></md-progress-circular></div></div><div class=\"disponibilizar-carga-tarefa text-center\"><span \nng-click=\"vm.metodos.disponibilizarCarga()\" ng-if=\"vm.parametros.tipoProcesso === \'01\'\">Disponibilizar carga </span>\n<span ng-click=\"vm.metodos.disponibilizarCarga()\" ng-if=\"vm.parametros.tipoProcesso === \'02\'\">Disponibilizar tarefa\n</span></div></md-content></form>");
$templateCache.put("app/main/controlecarga/trocarsequencial/sidenav/filtro/views/filtro-trocar-sequencial.html","<div id=\"filtro-trocar-sequencial\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><fieldset \nclass=\"standard\" flex ng-if=\"vm.parametros.utilizaCadastroRegional\"><legend class=\"grp-legend\"><span>Agrupamento</span>\n</legend><md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento\n</label><md-select ng-model=\"vm.filtro.agrupamento\" md-on-open=\"vm.metodos.configuraMdSelectAgrupamento()\" \nng-change=\"vm.metodos.changeAgrupamento()\" ng-required=\"vm.agrupamentos.length > 0\" name=\"agrupamento\" \nng-disabled=\"vm.agrupamentos.length == 0\"><md-select-header ng-if=\"vm.agrupamentos.length > 0\"><input \nng-model=\"vm.filtrarAgrupamento\" type=\"search\" id=\"select-agrupamento\" placeholder=\"Pesquisar agrupamento..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"agrupamento.codigo\" \nng-repeat=\"agrupamento in vm.agrupamentos | filter: vm.filtrarAgrupamento\">{{agrupamento.descricao}}</md-option>\n</md-select><span ng-if=\"vm.agrupamentos.length == 0\" class=\"nenhum-grupo\">Nenhum agrupamento encontrada.</span><div \nng-messages=\"vm.form.agrupamento.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Leiturista\n</span></legend><div layout=\"column\" layout-align=\"center\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.LEITURISTA\">Leiturista</label><md-select ng-model=\"vm.filtro.leiturista\" \nmd-on-open=\"vm.metodos.configuraMdSelectLeiturista()\" ng-required=\"vm.leituristas.length > 0\" name=\"leiturista\" \nng-disabled=\"vm.leituristas.length == 0\"><md-select-header ng-if=\"vm.leituristas.length > 0\"><input \nng-model=\"vm.filtrarLeiturista\" type=\"search\" id=\"select-leiturista\" placeholder=\"Pesquisar leiturista..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"leiturista.codigo\" \nng-repeat=\"leiturista in vm.leituristas | filter: vm.filtrarLeiturista\">{{leiturista.codigo}} - {{leiturista.apelido}}\n</md-option></md-select><span ng-if=\"vm.leituristas.length == 0\" class=\"nenhum-grupo\">Nenhuma leiturista encontrado.\n</span><div ng-messages=\"vm.form.leiturista.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.form.$valid\" ng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodos.buscarDadosTarefa(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-content></form>\n</div>");
$templateCache.put("app/main/controlecarga/trocarsequencial/dialogs/alterarsequencial/views/dialog-alterar-sequencial-tarefa.html","<md-dialog id=\"dialog-alterar-sequencial\"><md-toolbar class=\"toolbar md-accent\" flex><div \nclass=\"md-toolbar-tools md-accent\"><h2 translate=\"RESOURCES.ALTERAR_SEQUENCIAL\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><form name=\"form\"><md-input-container class=\"md-block\"><label>\nSequencial da tarefa</label><input mascara-numero-generica=\"###\" ng-required=\"true\" name=\"sequencial\" \nng-model=\"vm.sequencial\"><div ng-messages=\"form.sequencial.$error\"><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.retornarSequencialTarefa()\" class=\"md-raised md-accent\" \nng-disabled=\"form.$invalid\"><span translate=\"RESOURCES.UNIFICAR.CONFIRMAR\"></span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/controlecarga/faturas-retidas/components/tabela-dependentes/views/tabela-dependentes.html","<div class=\"child-table-container\" ng-if=\"vm.dependentes && vm.dependentes.length > 0\"><table \nclass=\"table table-striped child-table\"><thead><tr><th>Ligação</th><th>Dependente</th><th>Endereço</th><th>Setor</th>\n<th>Rota</th><th>Referência</th><th>Disponibilizada</th><th>Fatura impressa</th><th>Data disponibilização</th><th>\nArquivo</th><th>Leiturista</th></tr></thead><tbody><tr ng-repeat=\"dep in vm.dependentes track by $index\"><td>\n{{ dep.codigoLigacaoDependente }}</td><td>{{ dep.nomeClienteDependente }}</td><td>{{ dep.enderecoDependente }}</td><td>\n{{ dep.setorDependente }}</td><td>{{ dep.rotaDependente }}</td><td>{{ dep.mesAnoReferencia }}</td><td><span \nclass=\"status-badge\" ng-class=\"{\'status-sim\': dep.disponibilizada, \'status-nao\': !dep.disponibilizada}\">\n{{ dep.disponibilizada ? \'Sim\' : \'Não\' }}</span></td><td><span class=\"status-badge\" \nng-class=\"{\'status-sim\': dep.faturaImpressa, \'status-nao\': !dep.faturaImpressa}\">\n{{ dep.faturaImpressa ? \'Sim\' : \'Não\' }}</span></td><td>\n{{ dep.dataDisponibilizacao ? (dep.dataDisponibilizacao | date:\'dd/MM/yyyy\') : \'-\' }}</td><td>\n{{ dep.arquivoExportacao || \'-\' }}</td><td>{{ dep.leituristaResponsavel || \'-\' }}</td></tr></tbody></table></div><div \nclass=\"no-dependentes\" ng-if=\"!vm.dependentes || vm.dependentes.length === 0\"><i>Nenhum dependente encontrado</i></div>");
$templateCache.put("app/main/processamento/exclusao-arquivo/dialogs/dialog-confirmacao-exclusao/views/dialog-confirmacao-exclusao.html","<md-dialog id=\"dialog-confirmacao-exclusao\" md-theme=\"default\" class=\"md-default-theme md-transition-in\">\n<md-dialog-content class=\"md-dialog-content\"><h2 class=\"md-title\" ng-if=\"vm.arquivos.length > 1\">\nOs seguintes arquivos contém leituras realizadas:</h2><h2 class=\"md-title\" ng-if=\"vm.arquivos.length == 1\">\nO seguinte arquivo contém leituras realizadas:</h2><div class=\"md-dialog-content-body\"><p \nng-repeat=\"arquivo in vm.arquivos\">{{ arquivo.nomeArquivo }}</p><br><p><strong ng-if=\"vm.arquivos.length > 1\">\nDeseja continuar o processo de exclusão dos arquivos?</strong></p><p><strong ng-if=\"vm.arquivos.length == 1\">\nDeseja continuar o processo de exclusão do arquivo?</strong></p></div></md-dialog-content><md-dialog-actions><button \nclass=\"md-primary md-cancel-button md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.metodos.confirmarExclusao(false)\">Não</button> <button \nclass=\"md-primary md-confirm-button md-button md-ink-ripple md-default-theme\" type=\"button\" \nng-click=\"vm.metodos.confirmarExclusao(true)\" md-autofocus=\"true\">Sim</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-calculo-distribuicao-automatica/views/dialog-calculo-distribuicao-automatica.html","<md-dialog layout=\"column\" id=\"dialog-calculo-distribuicao-automatica\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Distribuição automática de leituras</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><div flex=\"20\" layout-align=\"center center\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"85\"><label>Total de leituras a serem distribuídas</label><input type=\"text\" \nng-model=\"vm.leiturasAhDistribuir\" ui-number-mask=\"0\" ui-hide-group-sep ng-disabled=\"true\"></md-input-container></div>\n<div flex=\"20\" layout-align=\"center center\" layout=\"row\"><md-input-container class=\"md-block input-btn\" flex=\"65\">\n<label>Total de tarefas</label><input type=\"text\" ng-model=\"vm.quantidadeTarefas\" ui-number-mask=\"0\" ui-hide-group-sep>\n</md-input-container><md-button class=\"md-fab md-mini btn-calcular\" aria-label=\"Calcular\" \nng-click=\"vm.metodos.calcular()\"><md-tooltip md-autohide><span>Calcular a média de leituras por tarefa</span>\n</md-tooltip><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/calculate-black-18dp.svg\"></md-icon>\n</md-button></div><div flex=\"20\" layout-align=\"center center\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"85\"><label>Média de leituras por tarefa</label><input type=\"text\" ng-model=\"vm.mediaLeituras\" ui-hide-group-sep \nng-disabled=\"true\"></md-input-container></div><div flex=\"20\" layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.continuarDistribuicao()\"><span>Continuar</span></md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-selecionar-quadra/views/dialog-selecionar-quadra.html","<md-dialog id=\"dialog-selecionar-quadra\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\">\n<h2 translate=\"RESOURCES.SELECIONAR_QUADRAS\"></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mt-0 pt-8\"><div layout=\"row\" \nflex><div layout-align=\"center center\"><md-checkbox ng-model=\"vm.selecionarTodos\" \nng-change=\"vm.metodos.marcarTodasQuadras(vm.selecionarTodos)\">Selecionar todas quadras</md-checkbox></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\" ng-class=\"{\'ml-25\': $index > 0}\" \nng-repeat=\"listaQuadras in vm.quadras track by $index\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"border-left border-right\"></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"RESOURCES.QUADRA\">Setor</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"RESOURCES.QUANTIDADE\">Quantidade</span></div></th></tr></thead><tr \nng-repeat=\"quadra in listaQuadras track by $index\"><td class=\"text-center border-left border-right\"><md-checkbox \nng-model=\"quadra.marcado\" class=\"margin-0\"></md-checkbox></td><td class=\"text-center border-right\">{{quadra.quadra}}\n</td><td class=\"text-center border-right\">{{quadra.quantidade}}</td></tr></table></div></div></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.selecionarQuadras()\" class=\"md-raised md-accent\"><span \ntranslate=\"RESOURCES.SELECIONAR\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-selecionar-setor/views/dialog-selecionar-setor.html","<md-dialog id=\"dialog-selecionar-setor\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2 translate=\"RESOURCES.SELECIONAR_SETORES\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><md-checkbox ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" \nng-model=\"vm.selecionarTodos\" ng-change=\"vm.metodos.marcarTodosSetores(vm.selecionarTodos)\">Selecionar todos setores\n</md-checkbox><div layout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\" ng-class=\"{\'ml-25\': $index > 0}\" \nng-repeat=\"listaSetores in vm.setores track by $index\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"border-left border-right\"></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"RESOURCES.SETOR\">Setor</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"RESOURCES.QUANTIDADE\">Quantidade</span></div></th></tr></thead><tr \nng-repeat=\"setor in listaSetores track by $index\"><td class=\"text-center border-left border-right\"><md-checkbox \nng-model=\"setor.marcado\" class=\"margin-0\"></md-checkbox></td><td class=\"text-center border-right\">{{setor.setor}}</td>\n<td class=\"text-center border-right\">{{setor.quantidade}}</td></tr></table></div></div></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.selecionarSetores()\" class=\"md-raised md-accent\"><span \ntranslate=\"RESOURCES.SELECIONAR\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-divisao-tarefas-sequencial/views/dialog-divisao-tarefas-sequencial.html","<md-dialog layout=\"column\" id=\"dialog-divisao-tarefas-sequencial\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>\nDivisão de tarefas - Rota: {{ vm.tarefa.rota }} - Sequenciais: {{ vm.tarefa.sequencialInicial }} - {{ vm.tarefa.sequencialFinal }}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><form name=\"vm.form\" novalidate layout=\"column\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"start start\" layout-padding><md-input-container flex=\"40\"><label>Sequencial Inicial</label><input \nui-number-mask=\"0\" ui-hide-group-sep ng-model=\"vm.sequencial.sequencialInicial\" name=\"sequencialInicial\" \nng-required=\"true\" ng-disabled=\"true\" ng-change=\"vm.metodos.changeSequencial()\"><div \nng-messages=\"vm.form.sequencialInicial.$error\"><div ng-message=\"required\">Campo obrigatório</div><div \nng-message=\"seqmin\">O valor informado deve ser superior ou igual a {{ vm.sequencialInicial }}</div><div \nng-message=\"seqmax\">O valor informado deve ser inferior a {{ vm.tarefa.sequencialFinal }}</div><div \nng-message=\"sequencialInicialError\">Sequencial inicial deve ser menor que o sequencial final</div></div>\n</md-input-container><md-input-container flex=\"40\"><label>Sequencial Final</label><input ui-number-mask=\"0\" \nui-hide-group-sep ng-model=\"vm.sequencial.sequencialFinal\" name=\"sequencialFinal\" ng-required=\"true\" \nng-change=\"vm.metodos.changeSequencial()\"><div ng-messages=\"vm.form.sequencialFinal.$error\"><div ng-message=\"required\">\nCampo obrigatório</div><div ng-message=\"seqmin\">O valor informado deve ser superior a {{ vm.sequencialInicial }}</div>\n<div ng-message=\"seqmax\">O valor informado deve ser inferior ou igual a {{ vm.tarefa.sequencialFinal }}</div><div \nng-message=\"sequencialFinalError\">Sequencial final deve ser maior que o sequencial inicial</div></div>\n</md-input-container><md-button class=\"md-fab md-mini\" aria-label=\"Adicionar\" \nng-click=\"vm.metodos.adicionarSequencial()\" ng-disabled=\"vm.form.$invalid\"><md-icon md-font-icon=\"icon-plus s30\">\n</md-icon></md-button></div><md-input-container flex=\"100\" class=\"mensagem-erro\"><div ng-messages=\"vm.mensagemErro\">\n<div>{{ vm.mensagemErro }}</div></div></md-input-container></form><div layout=\"column\" layout-padding><div \nclass=\"table-container\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"width-45\">Sequencial Inicial\n</th><th class=\"width-45\">Sequencial Final</th><th class=\"width-10\">Ações</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.sequenciais\"><td class=\"width-45 pl-2\">{{item.sequencialInicial}}</td><td class=\"width-45 pl-2\">\n{{item.sequencialFinal}}</td><td class=\"width-10 text-center\"><md-button class=\"md-icon-button\" aria-label=\"Excluir\" \nng-disabled=\"vm.emProgresso || $index != vm.sequenciais.length - 1\" ng-click=\"vm.metodos.excluirSequencial($index)\">\n<md-icon md-font-icon=\"icon-trash\" ng-class=\"{\'cor-icone-padrao\': $index == vm.sequenciais.length - 1}\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions class=\"pb-10\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.salvar()\" ng-disabled=\"vm.sequenciais.length == 0 || vm.emProgresso\">\n<span ng-if=\"!vm.emProgresso\">Salvar</span><md-progress-circular class=\"md-accent text-center\" md-diameter=\"26\" \nmd-mode=\"indeterminate\" ng-if=\"vm.emProgresso\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-unificar-tarefas/views/dialog-unificar-tarefas.html","<md-dialog id=\"dialog-selecionar-setor\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2>Unificação de tarefas</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><form name=\"form\">\n<md-input-container class=\"md-block\"><label>Número da tarefa</label><input ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"9\" ng-required=\"true\" name=\"numero\" pattern=\"^[1-9]\\d*$\" ng-model=\"vm.tarefa\"><div \nng-messages=\"form.numero.$error\"><div ng-message=\"pattern\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></form>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.metodos.retornarNumeroTarefa()\" \nclass=\"md-raised md-accent\" ng-disabled=\"form.$invalid\"><span translate=\"RESOURCES.UNIFICAR.CONFIRMAR\"></span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/dialogs/dialog-mensagem-tipo-distribuicao/views/dialog-mensagem-tipo-distribuicao.html","<md-dialog id=\"dialog-mensagem-tipo-distribuicao\"><md-dialog-content layout-padding><form novalidate \nname=\"formDialogMensagem\"><h2 class=\"text-bold\">Atenção</h2><span style=\"font-size: 0.9em\" ng-bind-html=\"vm.mensagem\">\n</span><md-input-container class=\"md-block select-tipo-distribuicao\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.TIPODISTRIBUICAO\">Tipo de distribuição</label><md-select ng-model=\"vm.tipoDistribuicao\" \nmd-on-open=\"vm.metodos.configuraMdSelectTipoDistribuicao()\" name=\"tipodistribuicao\" \nng-disabled=\"vm.tiposDistribuicao.length == 0\"><md-select-header ng-if=\"vm.tiposDistribuicao.length > 0\"><input \nng-model=\"vm.filtrarTipoDistribuicoes\" type=\"search\" id=\"select-tipodistribuicao\" \nplaceholder=\"Pesquisar tipo de distribuição..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"tipodistribuicao.codigo\" \nng-repeat=\"tipodistribuicao in vm.tiposDistribuicao | filter: vm.filtrarTipoDistribuicoes\">\n{{tipodistribuicao.descricao}}</md-option></md-select><span ng-if=\"vm.tiposDistribuicao.length == 0\" \nclass=\"nenhum-grupo\">Nenhum tipo de distribuição encontrado.</span><div \nng-messages=\"formDialogMensagem.tipodistribuicao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.cancelarDistribuicao()\">Cancelar</md-button><md-button \nng-click=\"vm.metodos.continuarDistribuicao()\">Continuar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/distribuicao/sidenav/filtro/views/distribuicao-filtro.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2></div>\n</md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaRegional\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.REGIONAL\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" \nname=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></md-list-item><md-divider></md-divider><md-list-item><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular>\n<md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.filtro.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"vm.grupos.length > 0\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\">\n<md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" \nmascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.grupo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.MUNICIPIO\">Município</label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" ng-required=\"vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0\"><md-select-header ng-if=\"vm.municipios.length > 0\"><input \nng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" placeholder=\"Pesquisar municipio..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}}-{{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><md-list-item><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaTipoDistribuicao\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.TIPODISTRIBUICAO\">Tipo de distribuição</label><md-select \nng-model=\"vm.filtro.tipodistribuicao\" md-on-open=\"vm.metodos.configuraMdSelectTipoDistribuicao()\" \nname=\"tipodistribuicao\" ng-disabled=\"vm.tipodistribuicoes.length == 0\"><md-select-header \nng-if=\"vm.tipodistribuicoes.length > 0\"><input ng-model=\"vm.filtrarTipoDistribuicoes\" type=\"search\" \nid=\"select-tipodistribuicao\" placeholder=\"Pesquisar tipo de distribuição..\" class=\"md-text\"></md-select-header>\n<md-option ng-value=\"tipodistribuicao.codigo\" \nng-repeat=\"tipodistribuicao in vm.tipodistribuicoes | filter: vm.filtrarTipoDistribuicoes\">\n{{tipodistribuicao.descricao}}</md-option></md-select><span ng-if=\"vm.tipodistribuicoes.length == 0\" \nclass=\"nenhum-grupo\">Nenhum tipo de distribuição encontrado.</span><div ng-messages=\"vm.form.tipodistribuicao.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n</md-list-item><md-divider></md-divider><md-list-item ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\">\n<md-switch name=\"ligacoescritica\" ng-model=\"vm.filtro.ligacaoCritica\">Ligações com crítica</md-switch></md-list-item>\n<md-list-item ng-if=\"vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"><md-switch name=\"repasse\" \nng-model=\"vm.filtro.repasse\">Repasse</md-switch></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid ||vm.emProgresso\" ng-click=\"vm.metodos.filtrarDadosDistribuicao(vm.filtro)\"><span>Filtrar\n</span></md-button></div></div></md-list></md-content></form>");
$templateCache.put("app/main/processamento/distribuicao/sidenav/CAEMA/filtro/distribuicao-filtro-caema.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2></div>\n</md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaRegional\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.LOCALIDADE\">Localidade</label><md-select \nng-model=\"vm.filtro.regional\" md-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar Localidade..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum localidade encontrado.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" \nname=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></md-list-item><md-divider></md-divider><md-list-item><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular>\n<md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.filtro.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"vm.grupos.length > 0\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\">\n<md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" \nmascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.grupo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.SETOR\">Setor</label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" ng-required=\"vm.municipios.length > 0\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0\"><md-select-header ng-if=\"vm.municipios.length > 0\"><input \nng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" placeholder=\"Pesquisar setor..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.descricao}}</md-option></md-select>\n<span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum setor encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-divider></md-divider><md-list-item><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaTipoDistribuicao\">\n</md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.TIPODISTRIBUICAO\">Tipo de distribuição</label><md-select ng-model=\"vm.filtro.tipodistribuicao\" \nmd-on-open=\"vm.metodos.configuraMdSelectTipoDistribuicao()\" name=\"tipodistribuicao\" \nng-disabled=\"vm.tipodistribuicoes.length == 0\"><md-select-header ng-if=\"vm.tipodistribuicoes.length > 0\"><input \nng-model=\"vm.filtrarTipoDistribuicoes\" type=\"search\" id=\"select-tipodistribuicao\" \nplaceholder=\"Pesquisar tipo de distribuição..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"tipodistribuicao.codigo\" \nng-repeat=\"tipodistribuicao in vm.tipodistribuicoes | filter: vm.filtrarTipoDistribuicoes\">\n{{tipodistribuicao.descricao}}</md-option></md-select><span ng-if=\"vm.tipodistribuicoes.length == 0\" \nclass=\"nenhum-grupo\">Nenhum tipo de distribuição encontrado.</span><div ng-messages=\"vm.form.tipodistribuicao.$error\">\n<div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n</md-list-item><md-divider></md-divider><md-list-item ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\">\n<md-switch name=\"ligacoescritica\" ng-model=\"vm.filtro.ligacaoCritica\">Ligações com crítica</md-switch></md-list-item>\n<md-divider></md-divider><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.form.$valid ||vm.emProgresso\" \nng-click=\"vm.metodos.filtrarDadosDistribuicao(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-list>\n</md-content></form>");
$templateCache.put("app/main/processamento/exportacao-mobile/dialogs/relatorio-dialog/views/relatorio-dialog.html","<md-dialog aria-label=\"Inconsistência\"><form ng-cloak><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Atenção</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><span>\nDurante a validação do arquivo, foram identificados consumidores com crédito/débito de consumo. </span><br><span>\nPara saber mais detalhes clique em <strong>visualizar</strong>.</span></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div layout=\"column\" layout-align=\"end end\" ng-show=\"vm.preLoader\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\" class=\"md-accent\"></md-progress-circular></div><md-button class=\"md-accent\" \nng-click=\"vm.metodos.gerarRelatorio()\" ng-show=\"!vm.preLoader\" md-autofocus>Visualizar</md-button><md-button \nng-click=\"vm.metodos.confirmar()\">Prosseguir</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/processamento/importacao-grupo-leitura/dialogs/estatistica-dialog/views/estatistica-dialog.html","<md-dialog id=\"dialog-estatisticas-importacao\" flex aria-label=\"Dialog\"><md-toolbar class=\"toolbar md-accent\" flex><div\n class=\"md-toolbar-tools\"><h2 translate=\"RESOURCES.ESTATISTICAS_IMPORTACAO\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" flex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"RESOURCES.REGISTRO_TABELA\">Registro / Tabela importada</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"RESOURCES.QUANTIDADE\">\nQuantidade de registros</span></div></th></tr></thead><tbody><tr ng-repeat=\"est in vm.dadosEstatisticas\"><td>\n{{est.tabela}}</td><td>{{est.quantidade}}</td></tr></tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/processamento/exportacao-mobile/dialogs/disponibilizar-retidas-dialog/views/disponibilizar-retidas-dialog.html","<md-dialog id=\"dialog-disponibilizar-retidas\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2>Disponibilizar faturas retidas</h2><span flex></span></div></md-toolbar>\n<md-dialog-content layout-padding><div class=\"content\" flex ms-scroll><div \nui-view=\"disponibilizarcargaretidas-form@app.exportacao_mobile\"></div></div></md-dialog-content><md-dialog-actions>\n<md-button class=\"md-raised md-accent md-warn\" style=\"display: flex; justify-content: center\" \nng-click=\"vm.metodos.cancelar()\"><span>Cancelar</span></md-button><md-button class=\"md-raised md-accent\" \nstyle=\"display: flex; justify-content: center\" ng-click=\"vm.metodos.atualizarDados()\"><span>Atualizar</span>\n</md-button><md-button class=\"md-raised md-accent\" style=\"display: flex; justify-content: center\" \nng-click=\"vm.metodos.disponibilizarRetidas()\"><span>Disponibilizar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-datas-grupo/views/dialog-datas-grupo.html","<md-dialog id=\"dialog-datas-grupo\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\"><h2 \ntranslate=\"RESOURCES.DATAS_GRUPO\"></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"botao-info-legenda\">\n<md-button class=\"md-icon-button md-mini\" ng-click=\"vm.metodos.abrirDialogLegenda()\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 89\" aria-label=\"Legenda\" translate \ntranslate-attr-aria-label=\"RESOURCES.LEGENDA\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip>\nLegenda</md-tooltip></md-button></div><table class=\"dataTable row-border hover\" ng-if=\"vm.grupo\"><thead><tr><th \ncolspan=\"6\" class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\" translate=\"RESOURCES.DATA\"></span></div></th></tr><tr><th \nclass=\"secondary-text border-left border-right\" ng-hide=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Início estimado</span></div>\n</th><th class=\"secondary-text border-right\" ng-hide=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Fim estimado</span></div></th>\n<th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Início real</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Fim real</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Importação</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Exportação</span></div></th>\n</tr></thead><tbody><tr><td class=\"text-center border-left border-right\" \nng-hide=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"><span>{{vm.grupo.dataInicioEstimada}}</span></td><td \nclass=\"text-center border-right\" ng-hide=\"vm.parametros.calculo.tipoDetalheCalculo != 89\"><span>\n{{vm.grupo.dataFinalEstimada}}</span></td><td class=\"text-center border-right\"><span>{{vm.grupo.dataInicioReal}}</span>\n</td><td class=\"text-center border-right\"><span>{{vm.grupo.dataFinalReal}}</span></td><td \nclass=\"text-center border-right\"><span>{{vm.grupo.dataImportacao }}</span></td><td class=\"text-center border-right\">\n<span>{{vm.grupo.dataExportacao | date}}</span></td></tr></tbody></table><div ng-if=\"vm.exibeProjecao\"><div \nclass=\"font-weight-500 font-size-16 title\">Projeção final:</div><div class=\"pt-10 pb-10\" layout=\"row\"><div \nlayout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" \nng-class=\"{\'projecao-menor-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaComFds) == \'verde\', \r\n                                            \'projecao-igual-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaComFds) == \'amarelo\', \r\n                                            \'projecao-maior-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaComFds) == \'vermelho\'\r\n                                            }\">\n<div class=\"font-weight-500 font-size-16\">Considerando fins de semana</div><div class=\"font-size-16\" \nstyle=\"text-align: center\">{{vm.dataPrevistaFormatadaComFds}}</div></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" flex=\"100\"><ms-widget class=\"h-90\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" \nng-class=\"{\'projecao-menor-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaSemFds) == \'verde\', \r\n                                            \'projecao-igual-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaSemFds) == \'amarelo\', \r\n                                            \'projecao-maior-data-final\': vm.metodos.definirCorCards(vm.dataPrevistaFormatadaSemFds) == \'vermelho\'\r\n                                            }\">\n<div class=\"font-weight-500 font-size-16\">Somente dias úteis</div><div class=\"font-size-16\" style=\"text-align: center\">\n{{vm.dataPrevistaFormatadaSemFds}}</div></div></ms-widget-front></ms-widget></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-datas-grupo/dialog-legenda/dialog-legenda.html","<md-dialog id=\"dialog-legenda\" aria-label=\"Legenda\" layout=\"column\" layout-align=\"space-between\" flex=\"100\"><md-toolbar\n class=\"toolbar md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-accent\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Legenda</span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><h2 class=\"titulo p-10\" layout-align=\"center center\">\nOs cards de projeção terão as cores a seguir:</h2><div layout-gt-sm=\"column\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex-offset=\"5\" ng-repeat=\"item in vm.legendaCores\"><div class=\"legenda\" \nng-style=\"{\'background-color\': item.cor}\"></div><span class=\"descricao\">{{item.descricao}}</span></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-selecionar-setor/views/dialog-selecionar-setores.html","<md-dialog id=\"dialog-selecionar-setor\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\">\n<h2 translate=\"RESOURCES.SELECIONAR_SETOR\"></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><form name=\"form\">\n<md-input-container class=\"md-block\"><label>Setores</label><md-select ng-model=\"vm.setorSelecionado\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" name=\"setor\" ng-required=\"true\" \nng-disabled=\"vm.setores.length == 0\"><md-select-header ng-if=\"vm.setores.length > 0\"><input \nng-model=\"vm.filtrarSetores\" type=\"search\" id=\"select-setor\" placeholder=\"Pesquisar setor..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"setor.codigo\" ng-repeat=\"setor in vm.setores | filter: vm.filtrarSetores\">\n{{setor.descricao}}</md-option></md-select><span ng-if=\"vm.setores.length == 0\" class=\"nenhum-grupo\">\nNenhum setor encontrado.</span><div ng-messages=\"form.setor.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.metodos.confirmar()\" class=\"md-raised md-accent\" \nng-disabled=\"form.$invalid\"><span translate=\"RESOURCES.UNIFICAR.CONFIRMAR\"></span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/sidenav/filtro/views/gerenciamento-grupo-filtro.html","<div id=\"gerenciamento-grupo-filtro\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.REGIONAL\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma regional encontrada.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-divider ng-if=\"vm.parametros.utilizaCadastroRegional\"></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader>\n<md-list-item><div layout=\"column\" flex><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\">\n<label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" \nng-model=\"vm.filtro.mes\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nvalidacao-mes ng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><md-input-container class=\"md-block mt-0\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span></md-input-container></div></div>\n</md-list-item><md-divider></md-divider><md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\">\n</md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.MUNICIPIO\"></label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" name=\"municipio\" ng-disabled=\"vm.municipios.length == 0\">\n<md-select-header ng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" \nid=\"select-municipio\" placeholder=\"Pesquisar município..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"undefined\" md-option-empty>Desmarcar</md-option><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}} - {{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"RESOURCES.SITUACAO\">Situação</span></md-subheader>\n<md-list-item><md-input-container><md-radio-group layout=\"row\" ng-required=\"true\" ng-model=\"vm.filtro.situacao\">\n<md-radio-button ng-value=\"1\">Aberto</md-radio-button><md-radio-button ng-value=\"2\">Todos</md-radio-button>\n</md-radio-group></md-input-container></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid\" ng-click=\"vm.metodos.filtrarGrupos(vm.filtro)\"><span>Filtrar</span></md-button></div>\n</div></md-list></md-content></form></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/views/dialog-tarefas.html","<md-dialog aria-label=\"Tarefas\" id=\"dialog-tarefas-gerenciamento-grupo\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\"><h2 \ntranslate=\"RESOURCES.DETALHAMENTO_GRUPO_LEITURA\"></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-0 pb-0\" layout=\"column\" \nflex=\"70\"><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular><div layout=\"column\"><div layout=\"row\"><md-button \nclass=\"md-fab btn-atualizar\" ng-click=\"vm.metodos.pesquisarTarefas()\"><md-icon class=\"s16\" md-font-icon=\"icon-refresh\">\n<md-tooltip md-direction=\"bottom\">Atualizar</md-tooltip></md-icon></md-button><div hide show-gt-xs \nlayout-align=\"start end\" layout-gt-xs=\"row\" flex=\"100\" id=\"div-filtro-cards\"><div layout=\"row\" flex=\"100\" \nflex-gt-xs=\"{{filtro.flexGtXs}}\" class=\"div-card\" ng-repeat=\"filtro in vm.filtro.informacoesCardFiltros\"><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div class=\"font-weight-500 font-size-12\">{{filtro.titulo}}</div><div \nclass=\"font-size-14\">{{filtro.dado}}</div></div></ms-widget-front></ms-widget></div></div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"width:100%\" dt-options=\"vm.dtOptions\"><thead><tr><th \ncolspan=\"2\" class=\"border-left border-right\"></th><th colspan=\"2\" class=\"secondary-text border-right\" \nng-show=\"vm.codigoCliente == 0070\"><div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">\nLocalização</span></div></th><th colspan=\"3\" class=\"secondary-text border-right\" ng-show=\"vm.codigoCliente != 0070\">\n<div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Localização</span></div></th><th \ncolspan=\"4\" class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leituras</span></div></th><th colspan=\"2\" class=\"border-right\">\n</th><th colspan=\"4\" class=\"secondary-text border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\">\n<div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Críticas</span></div></th><th \ncolspan=\"1\" class=\"border-right\" ng-if=\"vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"></th><th colspan=\"1\" \nclass=\"border-right\"></th></tr><tr><th class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.TAREFA\">Tarefa</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.STATUS\">Status</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.codigoCliente == 0070\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Bloco</span></div></th><th class=\"secondary-text border-right\" \nng-if=\"vm.parametros.utilizaCadastroRegional && !vm.tipoDetalheCalculoCaema\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.MUNICIPIO\">Munícipio</span></div></th><th \nclass=\"secondary-text border-right\" ng-hide=\"vm.codigoCliente == 0070\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.SETOR\">Setor</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"!vm.tipoDetalheCalculoCaema\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.QUADRA\">Quadra</span></div></th><th \nclass=\"secondary-text border-right\" ng-hide=\"vm.codigoCliente == 0070\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.LOTE\">Lote</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.tipoDetalheCalculoCaema\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.ROTA\">Rota</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Total</span></div></th><th class=\"secondary-text border-right\"><div\n class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Efet.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Não efetuadas</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"><div \nclass=\"table-header\"><span class=\"column-title text-center white-space-normal\">Rep. a realizar</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Efet.(%)</span></div></th><th class=\"secondary-text border-right\" \nng-if=\"false\"><div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Rep. a realizar\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leiturista</span></div></th><th \nclass=\"secondary-text border-right\" \nng-if=\"!(vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos || vm.parametros.coletor.utilizaRotinaRepasse == \'S\')\">\n<div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Data exportação</span></div></th>\n<th class=\"secondary-text border-right\" ng-if=\"vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><div \nclass=\"table-header\"><span class=\"column-title text-center white-space-normal\">Tipo tarefa</span></div></th><th \nclass=\"secondary-text border-right\" \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras || vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"><div \nclass=\"table-header\"><span class=\"column-title text-center white-space-normal\">Tipo visita</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><div \nclass=\"table-header\"><span class=\"column-title text-center white-space-normal\">Rev.</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Rev. Imp.</span></div></th><th \nclass=\"secondary-text border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><div \nclass=\"table-header\"><span class=\"column-title text-center white-space-normal\">Impr.</span></div></th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"tarefa in vm.tarefas track by $index\"><td class=\"text-center border-left border-right\">\n<span>{{tarefa.numeroDistribuicao == 0 ? \"\": tarefa.numeroDistribuicao}}</span></td><td \nclass=\"text-center border-right\"><span class=\"text-boxed white-bg black-fg\" \nng-if=\"tarefa.situacao === \'NÃO DISTRIBUÍDO\'\">Não distribuído </span><span class=\"text-boxed gray-bg black-fg\" \nng-if=\"tarefa.situacao === \'PARCIALMENTE DISTRIBUÍDO\'\">Parciamente distríbuido </span><span \nclass=\"text-boxed yellow-700-bg black-fg\" ng-if=\"tarefa.situacao === \'DISTRIBUÍDO\'\">Distríbuido </span><span \nclass=\"text-boxed orange-bg white-fg\" ng-if=\"tarefa.situacao === \'EXPORTADO MOBILE\'\">Disponibilizado </span><span \nclass=\"text-boxed md-light-blue-600-bg white-fg\" ng-if=\"tarefa.situacao === \'IMPORTADO MOBILE\'\">Importado </span><span \nclass=\"text-boxed green-bg white-fg\" \nng-if=\"tarefa.situacao === \'GRUPO EXPORTADO\' && tarefa.problemasExportacao.length == 0\">Exportado </span><span \nclass=\"text-boxed red-bg white-fg\" \nng-if=\"tarefa.situacao === \'GRUPO EXPORTADO\' && tarefa.problemasExportacao.length > 0\">Falha<md-tooltip><span>\n{{ tarefa.problemasExportacao }}</span></md-tooltip></span><br></td><td class=\"text-center border-right\" \nng-if=\"vm.parametros.utilizaCadastroRegional && !vm.tipoDetalheCalculoCaema\"><span>{{tarefa.municipio}}</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.codigoCliente == 0070\"><span>{{tarefa.bloco}}</span></td><td \nclass=\"text-center border-right\" ng-hide=\"vm.codigoCliente == 0070\"><span>{{tarefa.setor}}</span></td><td \nclass=\"text-center border-right\" ng-if=\"!vm.tipoDetalheCalculoCaema\"><span>{{tarefa.quadra}}</span></td><td \nclass=\"text-center border-right\" ng-hide=\"vm.codigoCliente == 0070\"><span>{{tarefa.lote}}</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.tipoDetalheCalculoCaema\"><span>{{tarefa.rota}}</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.totalVisitas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.visitasEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.visitasNaoEfetuadas | number}}</span></td><td \nclass=\"text-center border-right\" ng-if=\"vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"><span>\n{{tarefa.repassesRealizar | number}}</span></td><td class=\"text-center border-right\"><span>\n{{ tarefa.porcentagemConclusaoLeituras }}%</span></td><td class=\"text-center border-right\"><span>{{tarefa.leiturista}}\n</span></td><td class=\"text-center border-right\" \nng-if=\"!(vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos || vm.parametros.coletor.utilizaRotinaRepasse == \'S\')\">\n<span>{{tarefa.dataExportacao}}</span></td><td class=\"text-center border-right\" \nng-if=\"vm.parametros.utilizaDisponibilizacaoTarefasMultiplosGrupos\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\" ng-if=\"tarefa.tarefaUnificada\"><span>Abrir detalhes</span></md-tooltip><span \nclass=\"text-boxed orange-bg white-fg\" ng-if=\"tarefa.tarefaUnificada\" \nng-click=\"vm.metodos.abrirDialogDetalhesUnificacao(tarefa)\">Unificada </span><span \nclass=\"text-boxed green-bg white-fg\" ng-if=\"!tarefa.tarefaUnificada\">Comum</span></td><td \nclass=\"text-center border-right\" \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras || vm.parametros.coletor.utilizaRotinaRepasse == \'S\'\"><span\n class=\"text-boxed md-deep-purple-800-bg white-fg\" ng-if=\"tarefa.tipoVisita === 2 || tarefa.tipoVisita === 3\">\n{{tarefa.tipo}} </span><span class=\"text-boxed md-teal-800-bg white-fg\" ng-if=\"tarefa.tipoVisita === 1\">{{tarefa.tipo}}\n</span></td><td class=\"text-center border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><span>\n{{tarefa.criticasRevisao}}</span></td><td class=\"text-center border-right\" \nng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><span>{{tarefa.criticasRevisaoComImpressao}}</span></td>\n<td class=\"text-center border-right\" ng-if=\"vm.parametros.impressao.utilizaRotinaCriticaLeituras\"><span>\n{{tarefa.criticasImpressao}}</span></td><td class=\"text-center border-right\"><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-if=\"(tarefa.situacao === \'DISTRIBUÍDO\')\" \nng-click=\"vm.metodos.abrirDialogDisponibilizarTarefa(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\">\n<span translate=\"RESOURCES.DISPONIBILIZAR\">Disponibilizar</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nng-class=\"{\'cor-icone-padrao\': tarefa.situacao === \'DISTRIBUÍDO\'}\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"(tarefa.situacao === \'NÃO DISTRIBUÍDO\')\" \nng-click=\"vm.metodos.abrirDialogDistribuicao(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.DISTRIBUIR_TAREFAS\">Tarefas</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nng-class=\"{\'cor-icone-padrao\': tarefa.situacao === \'NÃO DISTRIBUÍDO\'}\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"!(tarefa.situacao === \'NÃO DISTRIBUÍDO\' || tarefa.situacao === \'DISTRIBUÍDO\')\" \nng-disabled=\"true\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-disabled=\"(tarefa.situacao !== \'EXPORTADO MOBILE\') || tarefa.visitasEfetuadas != 0 || tarefa.tarefasUnificadasComVisita\" \nng-click=\"vm.metodos.abrirDialogTrocaLeiturista(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.TROCAR_LEITURISTA\">Trocar Leiturista</span></md-tooltip><md-icon md-font-icon=\"icon-worker\" \nng-class=\"{ \'cor-icone-padrao\': (tarefa.situacao === \'EXPORTADO MOBILE\') && tarefa.visitasEfetuadas == 0 && !tarefa.tarefasUnificadasComVisita }\">\n</md-icon>></md-button><md-button class=\"md-icon-button\" \nng-disabled=\"(tarefa.situacao !== \'EXPORTADO MOBILE\') || tarefa.visitasEfetuadas != 0 || tarefa.tarefasUnificadasComVisita\" \nng-click=\"vm.metodos.cancelamentoTarefa(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.CANCELAMENTO_TAREFA\">Cancelar tarefa</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nng-class=\"{ \'cor-icone-padrao\': (tarefa.situacao === \'EXPORTADO MOBILE\') && tarefa.visitasEfetuadas == 0  && !tarefa.tarefasUnificadasComVisita }\">\n</md-icon></md-button></div></td></tr></tbody></table></div></md-dialog-content><md-dialog-content flex=\"20\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!vm.emProgressoBuscaTarefa\" class=\"estatisticas pt-0\"><div \nlayout-gt-sm=\"row\" flex-gt-sm=\"100\" flex=\"100\" layout=\"column\" layout-align=\"center center\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\" ng-repeat=\"total in vm.totalizador\">\n<ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\"><div class=\"pt-8 pb-4\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" class=\"font-weight-500\">\n{{total.title}}</div><div flex=\"100\" layout-align=\"center center\" class=\"font-size-20\">{{total.data | number}}</div>\n</div></ms-widget-front></ms-widget></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/sidenav/legenda-cores/views/gerenciamento-grupo-legenda-cores.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Legendas\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button><h2><span>Legenda</span>\n</h2></div></md-toolbar><md-content class=\"content\" layout-padding><md-list><md-list-item \nng-repeat=\"item in vm.itensLegenda\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><md-icon \nclass=\"icone-legenda\" md-font-icon=\"{{item.icone}}\" ng-style=\"{\'color\' : item.cor}\"></md-icon><span \nclass=\"legend-title\">{{item.situacao}}</span></div></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.fecharLegenda()\"><span>Fechar</span></md-button></div></div></md-list></md-content>");
$templateCache.put("app/main/cadastros/leiturista/views/tabs/tab-recadastramento/tabela-informacoes/tabela-informacoes.html","<div layout=\"column\" class=\"tabela-informacao\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"container-check mt-6\"><md-input-container class=\"md-block\"><md-checkbox \nid=\"cadastros-leiturista-tabrecadastramento-chkSelecionarTodosCampos\" name=\"selecionarTodosCampos\" \naria-label=\"Selecionar todos os campos\" ng-model=\"vm.selecionarTodosCampos\" \nng-change=\"vm.metodos.changeSelecionarTodosCampos(vm.selecionarTodosCampos)\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                    !vm.controleForm.editarAtivo && \r\n                                    !vm.controleForm.inserirAtivo\">\n<span ng-if=\"vm.selecionarTodosCampos == \'N\'\" translate=\"RESOURCES.MARCAR_TODOS_CAMPOS\"></span> <span \nng-if=\"vm.selecionarTodosCampos == \'S\'\" translate=\"RESOURCES.DESMARCAR_TODOS_CAMPOS\"></span></md-checkbox>\n</md-input-container></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"coluna-selecionar secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">\nSelecionar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-left\">\nCampo</span></div></th></tr></thead><tbody><tr ng-repeat=\"campo in vm.dadosExibicaoTabela\" \nng-click=\"vm.metodos.selecionarCampos(campo)\"><td class=\"text-center\"><md-checkbox aria-label=\"Selecionado\" \nng-model=\"campo.permiteRecadastrar\" ng-change=\"vm.metodos.changeSelecionarCampo(campo)\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                 !vm.controleForm.editarAtivo && \r\n                                                 !vm.controleForm.inserirAtivo\" \nstyle=\"margin-bottom: 5px\"></md-checkbox></td><td class=\"text-left\"><span>{{campo.descricao}}</span></td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/cadastros/relacionados/formulario-impressao/views/tabs/tab-especifico/tab-especifico.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" \nname=\"comunicadoUnicoDebito\" id=\"cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito\" \nstyle=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito\', \'comunicadoUnicoDebito\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_COMUNICADO_UNICO_DEBITO\">\nFormulário de comunicado de único débito</label><input type=\"text\" name=\"formularioComunicadoUnicoDebito\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtComunicadoUnicoDebito\" \nng-model=\"vm.formularioImpressao.comunicadoUnicoDebito\" ng-disabled=\"true\"></md-input-container><div flex-gt-sm=\"20\" \nlayout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-raised md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoUnicoDebitoSelecionar\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito\')\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Selecionar formulário\" flex=\"50\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"300\"><span translate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-raised md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoUnicoDebitoExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito\', \'comunicadoUnicoDebito\')\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoUnicoDebito || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Excluir formulário\" flex=\"50\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"300\"><span translate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip>\n</md-button></div></div><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoVariosDebitos\" \nid=\"cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoVariosDebitos\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoVariosDebitos\', \'comunicadoVariosDebitos\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_COMUNICADO_VARIOS_DEBITOS\">\nFormulário de comunicado de vários débitos</label><input type=\"text\" name=\"formularioComunicadoVariosDebitos\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtComunicadoVariosDebitos\" \nng-model=\"vm.formularioImpressao.comunicadoVariosDebitos\" ng-disabled=\"true\"></md-input-container><div flex-gt-sm=\"20\" \nlayout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-raised md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoVariosDebitosSelecionar\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoVariosDebitos\')\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Selecionar formulário\" flex=\"50\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"300\"><span translate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-raised md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoVariosDebitosExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoVariosDebitos\', \'comunicadoVariosDebitos\')\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoVariosDebitos || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Excluir formulário\" flex=\"50\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip \nmd-autohide md-delay=\"300\"><span translate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/cadastros/relacionados/formulario-impressao/views/tabs/tab-geral/tab-geral.html","<div class=\"form-container\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label \ntranslate=\"RESOURCES.CODIGO\">Código</label><input type=\"text\" name=\"codigo\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtCodigo\" ui-number-mask=\"0\" ui-hide-group-sep \nng-model=\"vm.formularioImpressao.codigo\" mascara-tamanho-campo=\"4\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.inserirAtivo)\"><div \nng-messages=\"vm.form.codigo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><proximo-codigo ng-show=\"vm.controleForm.inserirAtivo\" rota=\"vm.rota\" \nentidade-codigo=\"vm.formularioImpressao.codigo\" pre-loader-toolbar=\"vm.controleForm.preLoaderToolbar\"></proximo-codigo>\n<md-input-container class=\"md-block\" flex-offset-gt-sm=\"5\" flex-gt-sm=\"90\"><label translate=\"RESOURCES.DESCRICAO\">\nDescrição</label><input type=\"text\" name=\"descricao\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtDescricao\" ng-model=\"vm.formularioImpressao.descricao\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.emProgresso || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.descricao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"><div \nlayout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"fatura\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flFatura\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flFatura\', \'fatura\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_FATURA\">\nFormulário da fatura</label><input type=\"text\" name=\"formularioFatura\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioFatura\" ng-model=\"vm.formularioImpressao.fatura\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioFaturaSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flFatura\')\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" id=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioFaturaExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flFatura\', \'fatura\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.fatura || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div><div \nlayout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoAlternativo\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoAlternativo\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoAlternativo\', \'comunicadoAlternativo\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_COMUNICADO_ALTERNATIVO\">\nFormulário de comunicado alternativo</label><input type=\"text\" name=\"formularioComunicadoAlternativo\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtComunicadoAlternativo\" \nng-model=\"vm.formularioImpressao.comunicadoAlternativo\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoAlternativoSelecionar\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoAlternativo\')\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Selecionar formulário\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoAlternativoExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoAlternativo\', \'comunicadoAlternativo\')\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoAlternativo || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Excluir formulário\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div>\n</div></div><div layout-gt-xs=\"row\"><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"consumoAlterado\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flConsumoAlterado\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flConsumoAlterado\', \'comunicadoConsumoAlterado\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label \ntranslate=\"RESOURCES.FORMULARIO_COMUNICADO_CONSUMO_ALTERADO\">Formulário de comunicado de consumo alterado</label><input\n type=\"text\" name=\"formularioConsumoAlterado\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioConsumoAlterado\" \nng-model=\"vm.formularioImpressao.comunicadoConsumoAlterado\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioConsumoAlteradoSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flConsumoAlterado\')\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioConsumoAlteradoExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flConsumoAlterado\', \'comunicadoConsumoAlterado\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoConsumoAlterado || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div><div \nlayout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoDebitosAnteriores\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoDebitosAnteriores\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoDebitosAnteriores\', \'comunicadoDebitoAnterior\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label \ntranslate=\"RESOURCES.FORMULARIO_COMUNICADO_DEBITOS_ANTERIORES\">Formulário de comunicado de débitos anteriores</label>\n<input type=\"text\" name=\"formularioComunicadoDebitosAnteriores\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtComunicadoDebitosAnteriores\" \nng-model=\"vm.formularioImpressao.comunicadoDebitoAnterior\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoDebitosAnterioresSelecionar\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoDebitosAnteriores\')\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Selecionar formulário\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnComunicadoDebitosAnterioresExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoDebitosAnteriores\', \'comunicadoDebitoAnterior\')\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoDebitoAnterior || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Excluir formulário\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div>\n</div></div><div layout-gt-sm=\"row\"><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoOcorrencia\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoOcorrencia\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoOcorrencia\', \'comunicadoOcorrencia\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_COMUNICADO_OCORRENCIA\">\nFormulário de comunicado de ocorrência</label><input type=\"text\" name=\"formularioComunicadoOcorrencia\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioComunicadoOcorrencia\" \nng-model=\"vm.formularioImpressao.comunicadoOcorrencia\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioComunicadoOcorrenciaSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoOcorrencia\')\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioComunicadoOcorrenciaExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoOcorrencia\', \'comunicadoOcorrencia\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoOcorrencia || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div><div \nlayout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoQuitacaoAnual\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoQuitacaoAnual\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoQuitacaoAnual\', \'comunicadoQuitacaoAnual\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_COMUNICADO_QUITACAO_ANUAL\">\nFormulário de comunicado de quitação anual</label><input type=\"text\" name=\"formularioComunicadoQuitacaoAnual\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioComunicadoQuitacaoAnual\" \nng-model=\"vm.formularioImpressao.comunicadoQuitacaoAnual\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioComunicadoQuitacaoAnualSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoQuitacaoAnual\')\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioComunicadoQuitacaoAnualExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoQuitacaoAnual\', \'comunicadoQuitacaoAnual\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoQuitacaoAnual || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div></div><div \nlayout-gt-sm=\"row\"><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"extratoDebitos\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flExtratoDebitos\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flExtratoDebitos\', \'extratoDebito\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate=\"RESOURCES.FORMULARIO_EXTRATO_DEBITOS\">\nFormulário de extrado de débitos</label><input type=\"text\" name=\"formularioExtratoDebitos\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioExtratoDebitos\" \nng-model=\"vm.formularioImpressao.extratoDebito\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioExtratoDebitosSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flExtratoDebitos\')\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioExtratoDebitosExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flExtratoDebitos\', \'extratoDebito\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.extratoDebito || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div><div \nlayout=\"row\" flex-gt-xs=\"50\" ng-if=\"vm.tipoProcesso === \'01\'\"><input type=\"file\" name=\"relatorioClientesVisitados\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flRelatorioClientesVisitados\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flRelatorioClientesVisitados\', \'relatorioClientesVisitados\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label>Formulário do relatório de clientes visitados</label><input\n type=\"text\" name=\"formularioRelatorioClientesVisitados\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtFormularioRelatorioClientesVisitados\" \nng-model=\"vm.formularioImpressao.relatorioClientesVisitados\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioRelatorioClientesVisitadosSelecionar\" \naria-label=\"Selecionar formulário\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flRelatorioClientesVisitados\')\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btnFormularioRelatorioClientesVisitadosExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flRelatorioClientesVisitados\', \'relatorioClientesVisitados\')\" \naria-label=\"Excluir formulário\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.relatorioClientesVisitados || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div></div></div><div \nlayout-gt-sm=\"row\"><div layout=\"row\" flex-gt-xs=\"50\"><input type=\"file\" name=\"comunicadoServicosCobrancaAvulsa\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoServicosCobrancaAvulsa\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoServicosCobrancaAvulsa\', \'comunicadoServicosCobrancaAvulsa\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label \ntranslate=\"RESOURCES.FORMULARIO_COMUNICADO_SERVICOS_COBRANCA_AVULSA\">\nFormulário de comunicado de serviços de cobrança avulsa</label><input type=\"text\" \nname=\"formulariocomunicadoServicosCobrancaAvulsa\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-txtcomunicadoServicosCobrancaAvulsa\" \nng-model=\"vm.formularioImpressao.comunicadoServicosCobrancaAvulsa\" ng-disabled=\"true\"></md-input-container><div \nstyle=\"margin-bottom: 20px\" layout-align=\"center center\" layout=\"row\"><md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btncomunicadoServicosCobrancaAvulsaSelecionar\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoServicosCobrancaAvulsa\')\" \nng-disabled=\"vm.controleForm.emProgresso || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Selecionar formulário\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.SELECIONAR_FORMULARIO\">Selecionar formulário</span></md-tooltip></md-button>\n<md-button class=\"md-fab md-mini md-accent\" \nid=\"cadastros-relacionados-formularioimpressao-tabgeral-btncomunicadoServicosCobrancaAvulsaExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-formularioimpressao-tabgeral-flComunicadoServicosCobrancaAvulsa\', \'comunicadoServicosCobrancaAvulsa\')\" \nng-disabled=\"vm.controleForm.emProgresso || !vm.formularioImpressao.comunicadoServicosCobrancaAvulsa || (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\" \naria-label=\"Excluir formulário\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide \nmd-delay=\"300\"><span translate=\"RESOURCES.EXCLUIR_FORMULARIO\">Excluir formulário</span></md-tooltip></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/cadastros/relacionados/pagamento-pix/views/tabs/tab-integracao/tab-integracao.html","<md-content layout-padding ng-disabled=\"vm.controleForm.emProgresso\" id=\"tab-integracao\"><div class=\"form-container\">\n<div ng-if=\"vm.pagamentoPix.banco != 3\"><div flex=\"100\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex><label translate>Banco</label><md-select name=\"banco\" ng-model=\"vm.pagamentoPix.banco\" \nng-change=\"vm.metodos.onChangeBanco(vm.pagamentoPix.banco)\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                           (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                           (vm.controleForm.pesquisaAtiva &&\r\n                                           !vm.controleForm.editarAtivo &&\r\n                                           !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"banco.codigo\" ng-repeat=\"banco in vm.bancos\">{{ banco.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.banco.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>Convênio</label>\n<input type=\"text\" name=\"convenio\" mascara-numero-generica=\"##########\" ng-model=\"vm.pagamentoPix.numeroConvenio\" \nng-required=\"vm.pagamentoPix.banco != 0 &&\r\n                                        vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.banco == 0 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.convenio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div flex=\"100\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" flex><label translate>Endereço API</label><input type=\"text\" mascara-tamanho-campo=\"255\" \nmd-maxlength=\"255\" name=\"enderecoApi\" ng-model=\"vm.pagamentoPix.enderecoApi\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo ||\r\n                                        vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.enderecoApi.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex><label translate>Endereço da API de geração do token</label><input type=\"text\" \nmascara-tamanho-campo=\"255\" md-maxlength=\"255\" name=\"enderecoApiGeracaoToken\" \nng-model=\"vm.pagamentoPix.enderecoApiToken\" \nng-required=\"vm.pagamentoPix.banco != 0 &&\r\n                                        vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.enderecoApiGeracaoToken.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex=\"100\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>\nChave de acesso da integração</label><input type=\"text\" mascara-tamanho-campo=\"255\" md-maxlength=\"255\" \nname=\"chaveAcessoIntegracao\" ng-model=\"vm.pagamentoPix.chaveAcessoIntegracao\" \nng-required=\"vm.pagamentoPix.banco != 0 &&\r\n                                        vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.chaveAcessoIntegracao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div flex=\"50\" layout-gt-sm=\"row\">\n<input type=\"file\" name=\"certificado\" id=\"cadastros-relacionados-pagamentopix-flcertificado\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.metodos.selecionarArquivo(\r\n                            event,\'cadastros-relacionados-pagamentopix-flcertificado\', \'certificado\')\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"80\"><label translate>Certificado</label><input type=\"text\" \nname=\"certificado\" id=\"cadastros-relacionados-pagamentopix-txtCertificado\" ng-model=\"vm.pagamentoPix.certificado\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                            (vm.pagamentoPix.banco == 0 || vm.pagamentoPix.banco == 2) &&\r\n                                           (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"true\"><div ng-messages=\"vm.form.certificado.$error\"><div ng-show=\"vm.exibeMensagem\" \nclass=\"campo-obrigatorio\"><span>Campo obrigatório</span></div></div></md-input-container><div \nlayout-align=\"center center\" layout=\"row\"><md-button id=\"cadastros-relacionados-pagamentopix-btnCertificadoSelecionar\" \nclass=\"md-fab md-raised md-mini md-accent\" aria-label=\"Selecionar certificado\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-pagamentopix-flcertificado\')\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                               (vm.controleForm.pesquisaAtiva &&\r\n                                               !vm.controleForm.editarAtivo &&\r\n                                               !vm.controleForm.inserirAtivo)\" \nflex=\"35\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span \ntranslate>Selecionar certificado</span></md-tooltip></md-button><md-button class=\"md-fab md-raised md-mini md-accent\" \nid=\"cadastros-relacionados-pagamentopix-btnCertificadoExcluir\" \nng-click=\"vm.metodos.removerArquivoSelecionado($event, \'cadastros-relacionados-pagamentopix-flcertificado\', \'certificado\')\" \naria-label=\"Excluir certificado\" flex=\"35\" \nng-disabled=\"vm.controleForm.emProgresso ||\r\n                                               !vm.pagamentoPix.certificado ||\r\n                                              (!vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-autohide md-delay=\"300\"><span translate>\nExcluir certificado</span></md-tooltip></md-button></div></div></div><div flex=\"100\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>Usuário</label><input type=\"text\" \nmascara-tamanho-campo=\"500\" md-maxlength=\"500\" name=\"usuario\" ng-model=\"vm.pagamentoPix.usuarioCertificado\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.usuario.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>Senha\n</label><input type=\"password\" mascara-tamanho-campo=\"500\" md-maxlength=\"500\" name=\"senha\" \nng-model=\"vm.pagamentoPix.senhaCertificado\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.senha.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div><div flex=\"50\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex ng-if=\"vm.pagamentoPix.banco == 1\"><label translate>Dias adicionais para expiração do QR Code\n</label><input type=\"text\" mascara-tamanho-campo=\"5\" md-maxlength=\"5\" min=\"0\" name=\"diasAdicionaisExpiracaoPix\" \nmascara-numero-generica=\"##########\" ng-model=\"vm.pagamentoPix.diasAdicionaisExpiracaoPix\" \nng-required=\"vm.pagamentoPix.banco == 1 &&\r\n                                        vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<md-tooltip md-autohide md-delay=\"300\"><span>Número de dias para extensão de validade do QR Code Pix.</span>\n</md-tooltip><div ng-messages=\"vm.form.diasAdicionaisExpiracaoPix.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div \nng-if=\"vm.pagamentoPix.banco == 3\"><div flex=\"100\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex><label translate>Banco</label><md-select name=\"bancoInovapay\" ng-model=\"vm.pagamentoPix.banco\" \nng-change=\"vm.metodos.onChangeBanco(vm.pagamentoPix.banco)\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"banco.codigo\" ng-repeat=\"banco in vm.bancos\">{{ banco.descricao }}</md-option></md-select><div \nng-messages=\"vm.form.bancoInovapay.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>\nDias adicionais para expiração do QR Code</label><input type=\"text\" mascara-tamanho-campo=\"5\" md-maxlength=\"5\" min=\"0\" \nname=\"diasAdicionaisExpiracaoPixInovapay\" mascara-numero-generica=\"##########\" \nng-model=\"vm.pagamentoPix.diasAdicionaisExpiracaoPix\" \nng-required=\"vm.pagamentoPix.banco == 3 &&\r\n                                    vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                   (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                   (vm.controleForm.pesquisaAtiva &&\r\n                                   !vm.controleForm.editarAtivo &&\r\n                                   !vm.controleForm.inserirAtivo)\">\n<md-tooltip md-autohide md-delay=\"300\"><span>Número de dias para extensão de validade do QR Code Pix.</span>\n</md-tooltip><div ng-messages=\"vm.form.diasAdicionaisExpiracaoPixInovapay.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex=\"100\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>Endereço API</label>\n<input type=\"text\" mascara-tamanho-campo=\"255\" md-maxlength=\"255\" name=\"enderecoApiInovapay\" \nng-model=\"vm.pagamentoPix.enderecoApi\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo ||\r\n                                        vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.enderecoApiInovapay.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex><label translate>Endereço da API de geração do token</label><input type=\"text\" \nmascara-tamanho-campo=\"255\" md-maxlength=\"255\" name=\"enderecoApiGeracaoTokenInovapay\" \nng-model=\"vm.pagamentoPix.enderecoApiToken\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.enderecoApiGeracaoTokenInovapay.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div flex=\"100\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\" flex><label translate>Usuário</label><input \ntype=\"text\" mascara-tamanho-campo=\"500\" md-maxlength=\"500\" name=\"usuarioInovapay\" \nng-model=\"vm.pagamentoPix.usuarioCertificado\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.usuarioInovapay.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\" flex><label translate>Senha</label><input type=\"password\" mascara-tamanho-campo=\"500\" \nmd-maxlength=\"500\" name=\"senhaInovapay\" ng-model=\"vm.pagamentoPix.senhaCertificado\" \nng-required=\"vm.pagamentoPix.tipoConfiguracao == 2 &&\r\n                                       (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.pagamentoPix.tipoConfiguracao == 1 ||\r\n                                       (vm.controleForm.pesquisaAtiva &&\r\n                                       !vm.controleForm.editarAtivo &&\r\n                                       !vm.controleForm.inserirAtivo)\">\n<div ng-messages=\"vm.form.senhaInovapay.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div></md-content>");
$templateCache.put("app/main/cadastros/relacionados/pagamento-pix/views/tabs/tab-configuracoes/tab-configuracoes.html","<md-content layout-padding ng-disabled=\"vm.controleForm.emProgresso\"><div class=\"form-container\"><div flex=\"100\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label translate=\"RESOURCES.TIPO_QRCODE\">\n</label><md-select ng-model=\"vm.pagamentoPix.tipoConfiguracao\" name=\"tipoQrCode\" \nng-change=\"vm.metodos.validarCamposPixEstatico(vm.pagamentoPix)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoQrCode.codigo\" ng-repeat=\"tipoQrCode in vm.tiposQrCode\">{{tipoQrCode.descricao}}</md-option></md-select>\n<div ng-messages=\"vm.form.tipoQrCode.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"70\" flex><label translate=\"RESOURCES.CHAVE\"></label><input type=\"text\" mascara-tamanho-campo=\"77\" \nmd-maxlength=\"77\" name=\"chave\" ng-model=\"vm.pagamentoPix.chave\" ng-disabled=\"true\"><div \nng-messages=\"vm.form.chave.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div><div flex=\"100\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" flex><label translate=\"Empresa\"></label><input type=\"text\" mascara-tamanho-campo=\"25\" \nmd-maxlength=\"25\" name=\"empresa\" ng-model=\"vm.pagamentoPix.nomeEmpresa\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.empresa.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex><label \ntranslate=\"RESOURCES.CIDADE\"></label><input type=\"text\" mascara-tamanho-campo=\"15\" md-maxlength=\"15\" name=\"cidade\" \nng-model=\"vm.pagamentoPix.cidade\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.cidade.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></div></md-content>");
$templateCache.put("app/main/cadastros/usuario/usuario/views/dialogs/inclusaosenha/dialog-inclusao-senha.html","<md-dialog id=\"dialog-inclusao-senha\" class=\"dialogo-padrao dialog-senha\" aria-label=\"Dialog\"><form \nname=\"inclusaoSenhaForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nInclusão de senha</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\"><label \ntranslate=\"RESOURCES.SENHA\"></label><input type=\"password\" ng-model=\"vm.senhaNova\" mascara-tamanho-campo=\"10\" \nmascara-barra-espaco ng-required=\"true\" md-maxlength=\"10\"></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><label translate=\"RESOURCES.CONFIRMACAO\"></label>\n<input type=\"password\" ng-model=\"vm.confirmacaoSenhaNova\" name=\"confirmacaoSenhaNova\" mascara-tamanho-campo=\"10\" \nmascara-barra-espaco ng-required=\"true\" md-maxlength=\"10\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"erroSenha\" ng-if=\"(vm.senhaNova != vm.confirmacaoSenhaNova)\">\nAs senhas devem ser iguais.</div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodosDialog.confirmar($event);\" \nng-disabled=\"inclusaoSenhaForm.$invalid || (vm.senhaNova != vm.confirmacaoSenhaNova)\" flex><span>Confirmar</span>\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/gerenciamento/dashboards/distribuicao-grupos/sidenav/filtro/views/filtro-resumo-dirtibuicao-grupos.html","<div id=\"filtro-gruposleituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span>Referência\n</span></md-subheader><md-list-item><div layout=\"column\" flex><div layout=\"row\" flex><md-input-container \nclass=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mes\" \nmascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.mes, vm.filtro.ano)\" validacao-mes ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" flex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></div></md-list-item><md-list-item><div layout=\"row\" flex><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular>\n<md-input-container class=\"md-block mt-0\" layout=\"column\" flex=\"100\"><label translate=\"RESOURCES.GRUPO\">Grupo</label>\n<md-select ng-model=\"vm.filtro.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"true\" name=\"grupo\" \nng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" \ntype=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}\n</md-option></md-select><span ng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span>\n</md-input-container></div></md-list-item><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\">\n<div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" \nng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/cliente-ocorrencia/dialogs/dialog-fotos/views/dialog-fotos-cliente-ocorrencia.html","<md-dialog layout=\"column\" id=\"dialog-fotos\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Fotos</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex=\"100\" layout-align=\"center center\" layout=\"row\" show-gt-sm hide><div \nflex=\"50\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\" show-gt-sm hide><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important; width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-8 blue-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-weight-500 secondary-text\">Matrícula:</div><div flex=\"100\" \nlayout-align=\"center center\" class=\"font-size-18\">{{ vm.cliente.matricula }}</div></div></ms-widget-front></ms-widget>\n</div></div><div class=\"div-fotos\" layout=\"row\" flex=\"50\" style=\"overflow-x: auto;margin: 20px;max-width:80vw\"><div \nng-repeat=\"urlFoto in vm.cliente.urlFotos track by $index\" style=\"min-width:400px;padding-right: 8px\" layout=\"column\" \nlayout-align=\"center center\"><img width=\"400px\" height=\"250px\" src=\"{{ vm.urlApi + urlFoto.nomeFoto }}\" alt=\"Foto\">\n</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/dashboards/cliente-ocorrencia/sidenavs/filtro/views/filtro-cliente-ocorrencia.html","<div id=\"filtro-clienteocorrencia\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><div layout=\"row\" flex class=\"radio-group-button\"><md-radio-group class=\"md-primary\" \nlayout-gt-sm=\"row\" ng-model=\"vm.opcaoFiltro\" required layout-wrap><md-radio-button ng-repeat=\"filtro in vm.filtros\" \nng-value=\"filtro\" layout-gt-sm=\"row\" layout=\"center center\" style=\"margin: 20px\" flex>{{ filtro }}</md-radio-button>\n</md-radio-group></div><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span \nng-if=\"vm.opcaoFiltro == \'Referência\'\">Referência</span> <span ng-if=\"vm.opcaoFiltro == \'Período\'\">Período</span>\n</legend><div layout=\"row\" flex ng-if=\"vm.opcaoFiltro == \'Referência\'\"><md-input-container class=\"md-block mb-0\" \nflex=\"20\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" \nng-model=\"vm.filtro.mes\" validacao-mes ng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"30\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-required=\"true\" validacao-ano><div ng-messages=\"vm.form.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"ano_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nng-if=\"vm.opcaoFiltro == \'Período\'\"><div flex layout=\"row\" class=\"datas-periodo\"><md-input-container><label>Início\n</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataInicio\" name=\"dataInicio\" \nmd-max-date=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label>Fim\n</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\" name=\"dataFim\" \nmd-min-date=\"vm.filtro.dataInicio\" ng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data></md-datepicker><div\n ng-messages=\"vm.form.dataFim.$error\"><div ng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div>\n<div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></fieldset><fieldset \nclass=\"standard\" flex ng-if=\"vm.parametro.tipoProcesso == \'02\'\"><legend class=\"grp-legend\"><span>Grupos</span></legend>\n<div layout=\"column\" flex><div layout=\"row\" flex layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular>\n<multi-select-directive id=\"select-leituristas\" class=\"filtros-multi-select\" style=\"margin:0px;padding: 0px\" flex \nform-name=\"grupos\" data=\"vm.grupos\" model=\"vm.filtro.grupos\" obrigatorio=\"true\" descricao-exibicao=\"descricao\" \ntexto-pesquisa-placeholder=\"Procurar grupo...\" texto-placeholder=\"Grupos\" disabled=\"!vm.grupos || !vm.grupos.length\">\n</div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" layout-align=\"center center\"><span \nng-if=\"vm.grupos && vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span></div></div></fieldset>\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Ocorrências</span></legend><div layout=\"column\" flex>\n<div layout=\"row\" flex layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaOcorrencias\"></md-progress-circular><multi-select-directive \nid=\"select-leituristas\" class=\"filtros-multi-select\" style=\"margin:0px;padding: 0px\" flex form-name=\"ocorrencias\" \ndata=\"vm.ocorrencias\" model=\"vm.filtro.ocorrencias\" obrigatorio=\"true\" descricao-exibicao=\"descricao\" \ntexto-pesquisa-placeholder=\"Procurar ocorrências...\" texto-placeholder=\"Ocorrências\" disabled=\"false\"></div><div \nlayout=\"row\" class=\"p-0 m-0\" flex=\"100\" layout-align=\"center center\"><span ng-if=\"vm.grupos && vm.grupos.length == 0\" \nclass=\"nenhum-grupo\">Nenhuma ocorrência encontrada.</span></div></div></fieldset><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-if=\"!vm.emProgresso\" ng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\">\n<span>Filtrar</span></md-button></div></div></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/quantitativo-leituras/sidenavs/filtro/views/filtro-quantitativo-leituras.html","<div id=\"filtro-quantitativoleituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span><md-checkbox class=\"no-label md-default-theme\" \naria-label=\"Selecionar Referência\" ng-checked=\"vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês\n</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-required=\"true\" validacao-ano><div ng-messages=\"vm.form.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"ano_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container></div></div></md-list-item><md-divider>\n</md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"Período\">Período</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"!vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex=\"100\"><div flex=\"80\" layout=\"column\"><md-input-container><label translate=\"RESOURCES.DATA_INICIO\">Data início\n</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" \nmd-max-date=\"vm.filtro.dataFinal\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFinal\" \nng-mask=\"3?9/1?9/9999\" name=\"dataFinal\" md-min-date=\"vm.filtro.dataInicial\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-list-item>\n<md-divider></md-divider><md-list-item id=\"multiselect\"><div layout=\"column\" flex><div layout=\"row\" flex \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaGrupos\"></md-progress-circular><multi-select-directive id=\"select-grupos\" \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"grupos\" data=\"vm.grupos\" model=\"vm.filtro.grupos\" obrigatorio=\"true\" \ndescricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar grupos...\" texto-placeholder=\"Grupos\" \ndisabled=\"!vm.grupos\"></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" layout-align=\"center center\"><span \nng-if=\"vm.leituristas && vm.leituristas.length == 0\" class=\"nenhum-grupo\">Nenhum leiturista encontrado.</span></div>\n</div></md-list-item><md-divider></md-divider><md-list-item id=\"multiselect\"><div layout=\"column\" flex><div \nlayout=\"row\" flex layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaleituristas\"></md-progress-circular><multi-select-directive \nid=\"select-leituristas\" style=\"margin:0px;padding: 0px\" flex form-name=\"leituristas\" data=\"vm.leituristas\" \nmodel=\"vm.filtro.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leituristas...\" texto-placeholder=\"Leituristas\" \ndisabled=\"!vm.leituristas || !vm.leituristas\"></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" \nlayout-align=\"center center\"><span ng-if=\"vm.leituristas && vm.leituristas.length == 0\" class=\"nenhum-grupo\">\nNenhum leiturista encontrado.</span></div></div></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/comunicados-debito-impressos/sidenavs/filtro/views/filtro-comunicados-debito-impressos.html","<div id=\"filtro-comunicadosimpressos\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span><md-checkbox class=\"no-label md-default-theme\" \naria-label=\"Selecionar Referência\" ng-checked=\"vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês\n</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-required=\"true\" validacao-ano><div ng-messages=\"vm.form.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"ano_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container></div></div></md-list-item><md-divider>\n</md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"Período\">Período</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"!vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex=\"100\"><div flex=\"80\" layout=\"column\"><md-input-container><label translate=\"RESOURCES.DATA_INICIO\">Data início\n</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataInicio\" name=\"dataInicio\" \nmd-max-date=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data>\n</md-datepicker><div ng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"maxdate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFim\" \nng-mask=\"3?9/1?9/9999\" name=\"dataFim\" md-min-date=\"vm.filtro.dataInicio\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFim.$error\"><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-list-item>\n<md-divider></md-divider><md-list-item id=\"selectUnico\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular><md-input-container \nclass=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.filtro.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"vm.grupos.length > 0\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" name=\"grupo\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo.codigoGrupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{ grupo.descricao }}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.grupo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></md-list-item><md-divider></md-divider><md-list-item id=\"multiselect\"><div layout=\"column\" \nflex><div layout=\"row\" flex layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaleituristas\"></md-progress-circular>\n<multi-select-directive id=\"select-leituristas\" style=\"margin:0px;padding: 0px\" flex form-name=\"leituristas\" \ndata=\"vm.leituristas\" model=\"vm.filtro.leituristas\" obrigatorio=\"true\" descricao-exibicao=\"nome\" \ntexto-pesquisa-placeholder=\"Procurar leituristas...\" texto-placeholder=\"Leituristas\" \ndisabled=\"!vm.leituristas || !vm.leituristas\"></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" \nlayout-align=\"center center\"><span ng-if=\"vm.leituristas && vm.leituristas.length == 0\" class=\"nenhum-grupo\">\nNenhum leiturista encontrado.</span></div></div></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/quitacao-anual/sidenav/filtro/views/filtro-quitacao-anual.html","<div id=\"filtro-quitacaoanual\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span>Referência\n</span><md-checkbox class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" \nng-checked=\"vm.referenciaOuPeriodo\" ng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" \ntype=\"checkbox\" role=\"checkbox\" aria-checked=\"true\"></md-checkbox></md-subheader><md-list-item \nng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" flex><div layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">\nMês</label><input type=\"text\" name=\"mesReferencia\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesReferencia\" \nvalidacao-mes ng-required=\"true\"><div ng-messages=\"vm.form.mesReferencia.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"anoReferencia\" \nmascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoReferencia\" ng-required=\"true\" validacao-ano><div \nng-messages=\"vm.form.anoReferencia.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"ano_invalido\" translate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container>\n</div></div></div></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"Período\">\nPeríodo</span><md-checkbox class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" \nng-checked=\"!vm.referenciaOuPeriodo\" ng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" \ntype=\"checkbox\" role=\"checkbox\" aria-checked=\"false\"></md-checkbox></md-subheader><md-list-item \nng-if=\"!vm.referenciaOuPeriodo\"><div layout=\"column\" flex=\"100\"><div flex=\"80\" layout=\"column\"><md-input-container>\n<label translate=\"RESOURCES.DATA_INICIO\">Data início</label><md-datepicker ng-required=\"true\" \nng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" md-max-date=\"vm.filtro.dataFinal\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"vm.form.dataInicial.$error\"><div ng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\">\n</div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFinal\" \nng-mask=\"3?9/1?9/9999\" name=\"dataFinal\" md-min-date=\"vm.filtro.dataInicial\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-list-item>\n<md-divider></md-divider><md-list-item id=\"multiselect\"><div layout=\"column\" flex><div layout=\"row\" flex \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaGrupos\"></md-progress-circular><multi-select-directive id=\"select-grupos\" \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"grupos\" data=\"vm.grupos\" model=\"vm.filtro.gruposLeitura\" \nobrigatorio=\"true\" descricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar grupos...\" \ntexto-placeholder=\"Grupos\" disabled=\"!vm.grupos\"></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" \nlayout-align=\"center center\"><span ng-if=\"vm.grupos && vm.grupos.length == 0\" class=\"nenhum-grupo\">\nNenhum grupo encontrado.</span></div></div></md-list-item><md-divider></md-divider><div class=\"container-tipo\">\n<md-subheader class=\"md-no-sticky\"><span>Simplificado</span><md-checkbox class=\"no-label md-default-theme\" \naria-label=\"Selecionar Referência\" ng-checked=\"vm.tipoSimplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"true\"></md-checkbox></md-subheader><md-subheader class=\"md-no-sticky\"><span>Detalhado</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.tipoSimplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader></div><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/ocorrencias-leiturista/sidenavs/filtro/views/filtro-ocorrencias-leiturista.html","<div id=\"filtro-ocorrenciasleiturista\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span><md-checkbox class=\"no-label md-default-theme\" \naria-label=\"Selecionar Referência\" ng-checked=\"vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês\n</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-required=\"true\" validacao-ano><div ng-messages=\"vm.form.ano.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"ano_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container></div></div></md-list-item><md-divider>\n</md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"Período\">Período</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.referenciaOuPeriodo\" \nng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-list-item ng-if=\"!vm.referenciaOuPeriodo\"><div layout=\"column\" \nflex=\"100\"><div flex=\"80\" layout=\"column\"><md-input-container><label translate=\"RESOURCES.DATA_INICIO\">Data início\n</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataInicial\" name=\"dataInicial\" \nmd-max-date=\"vm.filtro.dataFinal\" ng-mask=\"3?9/1?9/9999\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataInicial.$error\"><div \nng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFinal\" \nng-mask=\"3?9/1?9/9999\" name=\"dataFinal\" md-min-date=\"vm.filtro.dataInicial\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFinal.$error\"><div \nng-message=\"mindate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-list-item>\n<md-divider></md-divider><md-list-item id=\"multiselect\"><div layout=\"column\" flex><div layout=\"row\" flex \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaleituristas\"></md-progress-circular><multi-select-directive id=\"select-leituristas\" \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"leituristas\" data=\"vm.leituristas\" model=\"vm.filtro.leituristas\" \nobrigatorio=\"true\" descricao-exibicao=\"nome\" texto-pesquisa-placeholder=\"Procurar leituristas...\" \ntexto-placeholder=\"Leituristas\" disabled=\"!vm.leituristas || !vm.leituristas\"></div><div layout=\"row\" class=\"p-0 m-0\" \nflex=\"100\" layout-align=\"center center\"><span ng-if=\"vm.leituristas && vm.leituristas.length == 0\" \nclass=\"nenhum-grupo\">Nenhum leiturista encontrado.</span></div></div></md-list-item><md-divider></md-divider>\n<md-list-item id=\"multiselect\"><div layout=\"column\" flex><div layout=\"row\" flex layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaOcorrencias\"></md-progress-circular><multi-select-directive id=\"select-leituristas\" \nstyle=\"margin:0px;padding: 0px\" flex form-name=\"ocorrencias\" data=\"vm.ocorrencias\" model=\"vm.filtro.ocorrencias\" \nobrigatorio=\"true\" descricao-exibicao=\"descricao\" texto-pesquisa-placeholder=\"Procurar ocorrências...\" \ntexto-placeholder=\"Ocorrências\" disabled=\"false\"></div><div layout=\"row\" class=\"p-0 m-0\" flex=\"100\" \nlayout-align=\"center center\"><span ng-if=\"vm.grupos && vm.grupos.length == 0\" class=\"nenhum-grupo\">\nNenhuma ocorrência encontrada.</span></div></div></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/dashboards/ocorrencias-leiturista/dialogs/dialog-detalhamento/views/dialog-detalhamento-ocorrencias-leiturista.html","<md-dialog layout=\"column\" id=\"dialog-detalhamento\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Detalhamento diário</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><div flex=\"50\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\"><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important\" layout=\"column\" layout-align=\"center center\" flex=\"50\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg card-titulo\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-weight-500 secondary-text\">Leiturista:</div><div flex=\"100\" layout-align=\"center center\" \nclass=\"font-size-18\">{{ vm.leiturista }}</div></div></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\" layout-align-xs=\"center center\" \nng-repeat=\"dado in vm.dados track by $index\"><div layout=\"column\" layout-align=\"center center\" class=\"pb-8\" flex=\"100\" \nflex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table class=\"dataTable hover row-border\">\n<thead><tr class=\"border-top\"><th colspan=\"2\" class=\"border-left secondary-text border-right black-fg th-group-header\">\n<div class=\"table-header\" id=\"agrupamento-header\"><span \nclass=\"font-size-14 font-weight-900 text-center white-space-normal\">\nData da leitura: {{ dado.dataLeitura | date: \"dd/MM/yyyy\"}}</span></div></th></tr><tr><th \nclass=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">Ocorrência</span>\n</div></th><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nLeituras</span></div></th></tr></thead><tbody><tr ng-repeat=\"ocorrencia in dado.ocorrencias track by $index\"><td \nclass=\"text-left border-right\" style=\"padding-left: 5px !important\"><span>\n{{ ocorrencia.codigoOcorrencia }} - {{ ocorrencia.descricaoOcorrencia }}</span></td><td \nclass=\"text-center border-right\"><span>{{ ocorrencia.total }}</span></td></tr></tbody><tfoot><th colspan=\"2\" \nclass=\"secondary-text border-right border-left\"><div class=\"text-left\"><span class=\"text-left\">Total: {{ dado.total }}\n</span></div></th></tfoot></table></div></ms-widget-front></ms-widget></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/critica/consultacritica/dialogs/historico-critica/views/historico-critica.html","<md-dialog layout=\"column\" id=\"historico-critica\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Histórico de crítica</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex=\"100\" layout=\"column\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr show-gt-sm hide><th colspan=\"3\" \nclass=\"secondary-text border-left border-right th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Crítica</span></div></th><th colspan=\"6\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Leitura</span></div></th><th colspan=\"2\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Consumo</span></div></th><th colspan=\"2\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Ocorrência</span></div></th><th colspan=\"2\" class=\"border-right th-group-header\"></th></tr>\n<tr><th class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Número</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Data</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Usuário</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Data</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Data pós crítica</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crítica</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Fat. inicial</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Fat. pós crítica</span></div>\n</th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crítica</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crítica</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"critica in vm.criticas track by $index\"><td class=\"text-center border-right border-left\"><span>\n{{critica.numeroCritica}}</span></td><td class=\"text-center border-right\"><span>{{critica.dataCritica}}</span></td><td \nclass=\"text-center border-right\"><span>{{critica.usuarioResponsavel}}</span></td><td class=\"text-center border-right\">\n<span>{{critica.dataLeituraAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.dataLeituraPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraLidaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraLidaPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraFaturadaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraFaturadaPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.consumoFaturadoAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.consumoFaturadoPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.ocorrenciaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.ocorrenciaPosCritica}}</span></td><td class=\"text-center border-right\"><div \nng-if=\"!critica.calculoProporcional\"><span class=\"ml-5 text-boxed blue-bg white-fg ng-binding\" \nng-if=\"critica.statusCritica === \'Pendente\'\" style=\"margin: 5px 5px; font-size: 0.85em\">Pendente</span> <span \nclass=\"ml-5 text-boxed orange-bg white-fg ng-binding status-revisao\" ng-if=\"critica.statusCritica === \'Revisão\' \" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Revisão</span> <span \nclass=\"ml-5 text-boxed purple-900-bg white-fg ng-binding status-revisao\" \nng-if=\"critica.statusCritica === \'Rev. impr.\' \" style=\"margin: 5px 5px; font-size: 0.85em\">Rev. impr.</span> <span \nclass=\"ml-5 text-boxed green-bg white-fg ng-binding status-revisao\" ng-if=\"critica.statusCritica === \'Impressão\'\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Impressão</span></div><span \nclass=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" ng-if=\"critica.calculoProporcional\" \nstyle=\"margin: 5px 0px; font-size: 0.85em\">Projetada</span></td></tr></tbody></table></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/sidenav/execucao/views/execucao-critica-sidenav.html","<div id=\"execucao-critica-leituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h3><span>\nCrítica</span></h3></div></md-toolbar><md-content layout-padding layout=\"column\"><div layout=\"column\"><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Matrícula: </strong>{{vm.clienteSelecionado.codigoCliente}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Cliente: </strong>{{vm.clienteSelecionado.nome}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Localização: </strong>{{vm.clienteSelecionado.localizacao}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Hidrômetro: </strong>{{vm.clienteSelecionado.hidrometro}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Economias: </strong>{{vm.clienteSelecionado.economias}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Endereço: </strong>{{vm.clienteSelecionado.endereco}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Média: </strong>{{vm.clienteSelecionado.media}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Data: </strong>{{vm.clienteSelecionado.dataHoraColeta | date: \'dd/MM/yyyy HH:mm:ss\'}}\n</div><div><strong style=\"color: rgb(4, 60, 88)\">Leitura: </strong>{{vm.clienteSelecionado.leitura}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Consumo: </strong>{{vm.clienteSelecionado.consumo}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Ocorrência: </strong>{{vm.clienteSelecionado.ocorrencia}}</div><div><strong \nstyle=\"color: rgb(4, 60, 88)\">Revisão:</strong><select><option value=\"0\">Não</option><option value=\"1\">Sim</option>\n</select></div><div><strong style=\"color: rgb(4, 60, 88)\">Imp.Rev:</strong><select><option value=\"0\">Não</option>\n<option value=\"1\">Sim</option></select></div><div><strong style=\"color: rgb(4, 60, 88)\">Erro Leit.: </strong><input \ntype=\"checkbox\"></div><div><strong style=\"color: rgb(4, 60, 88)\">Erro Oco.: </strong><input type=\"checkbox\"></div><div>\n<textarea style=\"resize: none\" cols=\"10\" rows=\"5\"></textarea></div><div><table><thead><th>Ocorrência</th><th>Leitura\n</th><th>Consumo</th></thead><tbody ng-repeat=\"historico in vm.clienteSelecionado.historico\"><td class=\"text-center\">\n{{historico.ocorrencia}}</td><td class=\"text-center\">{{historico.leitura}}</td><td class=\"text-center\">\n{{historico.consumo}}</td></tbody></table></div></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/dashboards/resumo-retencoes/sidenav/filtro/views/filtro-resumo-retencoes.html","<div id=\"filtro-resumoretencoes\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky subheader-check\" flex=\"100\"><span>Referências\n</span><md-checkbox class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" \nng-checked=\"vm.referenciaOuPeriodo\" ng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" \ntype=\"checkbox\" role=\"checkbox\" aria-checked=\"false\"></md-checkbox></md-subheader><md-list-item \nng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" flex><div layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"center center\" flex><span class=\"referencia-de-ate\">De</span><md-input-container class=\"md-block mb-0\" \nflex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mesInicial\" \nmascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesInicial\" validacao-mes ng-required=\"true\"><div \nng-messages=\"vm.form.mesInicial.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" flex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"anoInicial\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoInicial\" ng-required=\"true\" validacao-ano><div \nng-messages=\"vm.form.anoInicial.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"ano_invalido\" translate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container>\n</div></div></div></md-list-item><md-list-item ng-if=\"vm.referenciaOuPeriodo\"><div layout=\"column\" flex><div \nlayout=\"row\" flex><div layout=\"row\" layout-align=\"center center\" flex><span class=\"referencia-de-ate\">Até</span>\n<md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" \nname=\"mesFinal\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mesFinal\" validacao-mes ng-required=\"true\"><div \nng-messages=\"vm.form.mesFinal.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" flex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"anoFinal\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.anoFinal\" ng-required=\"true\" validacao-ano><div \nng-messages=\"vm.form.anoFinal.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div><div ng-message=\"ano_invalido\" translate=\"MENSAGEM_VALIDACAO.ANO_INVALIDO\"></div></div></md-input-container>\n</div></div></div></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"Período\">\nPeríodo</span><md-checkbox class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" \nng-checked=\"!vm.referenciaOuPeriodo\" ng-click=\"vm.metodos.marcarFiltroReferenciaOuPeriodo()\" tabindex=\"0\" \ntype=\"checkbox\" role=\"checkbox\" aria-checked=\"false\"></md-checkbox></md-subheader><md-list-item \nng-if=\"!vm.referenciaOuPeriodo\"><div layout=\"column\" flex=\"100\"><div flex=\"80\" layout=\"column\"><md-input-container>\n<label translate=\"RESOURCES.DATA_INICIO\">Data início</label><md-datepicker ng-required=\"true\" \nng-model=\"vm.filtro.dataInicio\" name=\"dataInicio\" md-max-date=\"vm.filtro.dataFim\" ng-mask=\"3?9/1?9/9999\" \nng-disabled=\"vm.emProgresso\" mascara-conversor-string-para-data></md-datepicker><div \nng-messages=\"vm.form.dataInicio.$error\"><div ng-message=\"maxdate\" translate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_INICIAL\">\n</div><div ng-message=\"valid\" translate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container><label \ntranslate=\"RESOURCES.DATA_FIM\">Data fim</label><md-datepicker ng-required=\"true\" ng-model=\"vm.filtro.dataFim\" \nng-mask=\"3?9/1?9/9999\" name=\"dataFim\" md-min-date=\"vm.filtro.dataInicio\" ng-disabled=\"vm.emProgresso\" \nmascara-conversor-string-para-data></md-datepicker><div ng-messages=\"vm.form.dataFim.$error\"><div ng-message=\"mindate\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_DATA_FINAL\"></div><div ng-message=\"valid\" \ntranslate=\"MENSAGEM_VALIDACAO.DATA_INVALIDA\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></md-list-item>\n<md-divider></md-divider><md-subheader class=\"md-no-sticky\"><span>Faturas retidas</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Faturas retidas\" ng-checked=\"vm.faturaOuComunicado\" tabindex=\"0\" \ntype=\"checkbox\" role=\"checkbox\" aria-checked=\"true\" ng-click=\"vm.metodos.marcarFiltroFaturaOuComunicado()\">\n</md-checkbox></md-subheader><div class=\"container-tipo\" ng-if=\"vm.faturaOuComunicado\"><md-subheader \nclass=\"md-no-sticky\"><span>Simplificado</span><md-checkbox class=\"no-label md-default-theme\" \naria-label=\"Selecionar Referência\" ng-checked=\"vm.simplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-subheader class=\"md-no-sticky\"><span>Detalhado</span><md-checkbox\n class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.simplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader></div><md-divider></md-divider><md-subheader class=\"md-no-sticky\">\n<span>Comunicados retidos</span><md-checkbox class=\"no-label md-default-theme\" aria-label=\"Faturas retidas\" \nng-checked=\"!vm.faturaOuComunicado\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" aria-checked=\"false\" \nng-click=\"vm.metodos.marcarFiltroFaturaOuComunicado()\"></md-checkbox></md-subheader><div class=\"container-tipo\" \nng-if=\"!vm.faturaOuComunicado\"><md-subheader class=\"md-no-sticky\"><span>Simplificado</span><md-checkbox \nclass=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"vm.simplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader><md-subheader class=\"md-no-sticky\"><span>Detalhado</span><md-checkbox\n class=\"no-label md-default-theme\" aria-label=\"Selecionar Referência\" ng-checked=\"!vm.simplificadoOuDetalhado\" \nng-click=\"vm.metodos.marcarFiltroSimplificadoOuDetalhado()\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" \naria-checked=\"false\"></md-checkbox></md-subheader></div><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span>\n</md-button></div></div></md-list></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/sidenav/fotos/views/fotos-critica-sidenav.html","<div id=\"execucao-critica-leituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h3><span>Fotos\n</span></h3></div></md-toolbar><md-content layout-padding layout=\"column\"><div style=\"min-width: 128px\" \nng-repeat=\"foto in vm.fotos\" layout=\"column\" layout-align=\"center center\"><img height=\"128px\" width=\"128px\" \nsrc=\"{{foto.src}}\" alt=\"teste\"><h5>{{foto.data}}</h5></div></md-content></div>");
$templateCache.put("app/main/gerenciamento/critica/criticaleituras/sidenav/filtro/views/filtro-critica-leituras.html","<div id=\"filtro-critica-leituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma regional encontrada.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-divider></md-divider></md-list-item><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"column\" flex><div \nlayout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label>\n<input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><md-input-container class=\"md-block mt-0\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"true\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-list-item><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.MUNICIPIO\"></label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" name=\"municipio\" ng-disabled=\"vm.municipios.length == 0\">\n<md-select-header ng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" \nid=\"select-municipio\" placeholder=\"Pesquisar município..\" class=\"md-text\"></md-select-header><md-option \nmd-option-empty ng-value=\"undefined\">Desmarcar</md-option><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}} - {{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0 && vm.filtro.grupo != undefined\" class=\"nenhum-grupo\">\nNenhum município encontrado.</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><md-list-item><md-input-container class=\"margin-0\"><md-checkbox ng-model=\"vm.filtro.pendentes\">Pendentes\n</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container class=\"margin-0\"><md-checkbox \nng-model=\"vm.filtro.criticados\">Criticados</md-checkbox></md-input-container></md-list-item><md-list-item>\n<md-input-container class=\"margin-0\"><md-checkbox ng-model=\"vm.filtro.retorno\"><span>Retorno</span></md-checkbox>\n</md-input-container></md-list-item><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\"><div \nlayout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\">\n</md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid || vm.emProgresso || vm.filtro.grupo == undefined\" \nng-click=\"vm.metodos.filtrarLeiturasComRetencao(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-list>\n</md-content></form></div>");
$templateCache.put("app/main/gerenciamento/critica/consultacritica/sidenav/filtro/views/filtro-consulta-criticas.html","<div id=\"filtro-critica-leituras\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, true)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar regionais..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma regional encontrada.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-divider></md-divider></md-list-item><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"column\" flex><div \nlayout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label>\n<input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, true)\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, true)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div><div layout=\"row\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular><md-input-container \nclass=\"md-block mt-0\" layout=\"column\" flex><label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select \nng-model=\"vm.filtro.grupo\" md-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"true\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo, true)\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-list-item><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.MUNICIPIO\"></label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" name=\"municipio\" ng-disabled=\"vm.municipios.length == 0\">\n<md-select-header ng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" \nid=\"select-municipio\" placeholder=\"Pesquisar município..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"municipio.codigo\" ng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">\n{{municipio.codigo}} - {{municipio.descricao}}</md-option></md-select><span \nng-if=\"vm.municipios.length == 0 && vm.filtro.grupo != undefined\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.form.$valid || vm.emProgresso || vm.filtro.grupo == undefined\" \nng-click=\"vm.metodos.filtrarCriticas(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-list></md-content>\n</form></div>");
$templateCache.put("app/main/gerenciamento/critica/acompanhamento/sidenav/filtro/views/filtro-acompanhamento-critica-sidenav.html","<div id=\"filtro-acompanhamneto-critica\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.AGRUPAMENTO\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar agrupamento..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma regional encontrada.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-divider></md-divider></md-list-item><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader><md-list-item><div layout=\"column\" flex><div \nlayout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\"><label translate=\"RESOURCES.MES\">Mês</label>\n<input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" validacao-mes \nng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><md-input-container class=\"md-block mt-0\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option md-option-empty ng-value=\"undefined\">\nDesmarcar</md-option><md-option ng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}\n</md-option></md-select><span ng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></div></div></md-list-item><md-list-item \nng-if=\"vm.parametros.utilizaCadastroRegional\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label translate=\"RESOURCES.MUNICIPIO\"></label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" name=\"municipio\" ng-disabled=\"vm.municipios.length == 0\">\n<md-select-header ng-if=\"vm.municipios.length > 0\"><input ng-model=\"vm.filtrarMunicipios\" type=\"search\" \nid=\"select-municipio\" placeholder=\"Pesquisar município..\" class=\"md-text\"></md-select-header><md-option \nmd-option-empty ng-value=\"undefined\">Desmarcar</md-option><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}} - {{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0 && vm.filtro.grupo != undefined\" class=\"nenhum-grupo\">\nNenhum município encontrado.</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.form.$valid || vm.emProgresso\" \nng-click=\"vm.metodos.filtrarCriticas(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-list></md-content>\n</form></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosCadastrais/tab-dados-cadastrais.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\"><div \nlayout-gt-sm=\"column\" flex><fieldset class=\"standard\" flex ng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 89\">\n<legend class=\"grp-legend\" translate=\"LEITURA.VISUALIZACAO.IMOVEL\"></legend><div layout-gt-sm=\"row\" flex>\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"15\"><label translate=\"LEITURA.VISUALIZACAO.MATRICULA_IMOVEL\">\n</label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.matriculaImovel\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex flex-gt-sm=\"40\"><label translate=\"LEITURA.VISUALIZACAO.NOME\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.nome\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"LEITURA.VISUALIZACAO.REFERENCIA\"></label>\n<input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.referencia\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"15\"><label translate=\"LEITURA.VISUALIZACAO.FATURA\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-fatura\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.fatura\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\"><label \ntranslate=\"LEITURA.VISUALIZACAO.SITUACAO\"></label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" \nname=\"codigo\" ng-model=\"vm.dadosCadastrais.situacao\" ng-disabled=\"true\"></md-input-container></div><div \nlayout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex flex-gt-sm=\"40\"><label \ntranslate=\"LEITURA.VISUALIZACAO.ENDERECO_IMOVEL\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.enderecoImovel\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.NUMERO_IMOVEL\"></label><input type=\"text\" ui-number-mask=\"0\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.numeroImovel\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"40\"><label \ntranslate=\"LEITURA.VISUALIZACAO.BAIRRO_IMOVEL\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.bairroImovel\" \nng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex \nflex-gt-sm=\"30\"><label translate=\"LEITURA.VISUALIZACAO.COMPLEMENTO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.complemento\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.ENDERECO_ENTREGA\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.entrega\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.QUADRA\"></label>\n<input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.quadra\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.LOTE\"></label><input type=\"text\" ui-number-mask=\"0\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.lote\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.SUB_LOTE\">\n</label><input type=\"text\" ui-number-mask=\"0\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.subLote\" ng-disabled=\"true\"></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 89\"><legend class=\"grp-legend\" \ntranslate=\"LEITURA.VISUALIZACAO.IMOVEL\"></legend><div layout-gt-sm=\"row\" flex><md-input-container \nng-if=\"vm.dadosCadastrais.sequencialExportacao && vm.dadosCadastrais.sequencialExportacao != 0\" class=\"md-block\" flex \nflex-gt-sm=\"15\"><label translate=\"LEITURA.VISUALIZACAO.SEQUENCIAL\"></label><input type=\"text\" \nname=\"sequencialExportacao\" ng-model=\"vm.dadosCadastrais.sequencialExportacao\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.MATRICULA_IMOVEL\"></label><input \ntype=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.matriculaImovel\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex flex-gt-sm=\"40\"><label translate=\"LEITURA.VISUALIZACAO.NOME\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.nome\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"10\"><label \ntranslate=\"LEITURA.VISUALIZACAO.REFERENCIA\"></label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" \nname=\"codigo\" ng-model=\"vm.dadosCadastrais.referencia\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\"><label translate=\"LEITURA.VISUALIZACAO.FATURA\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-fatura\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.fatura\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label \ntranslate=\"LEITURA.VISUALIZACAO.SITUACAO\"></label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" \nname=\"codigo\" ng-model=\"vm.dadosCadastrais.situacao\" ng-disabled=\"true\"></md-input-container></div><div \nlayout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex flex-gt-sm=\"40\"><label \ntranslate=\"LEITURA.VISUALIZACAO.ENDERECO_IMOVEL\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.enderecoImovel\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.NUMERO_IMOVEL\"></label><input type=\"text\" ui-number-mask=\"0\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.numeroImovel\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"40\"><label \ntranslate=\"LEITURA.VISUALIZACAO.BAIRRO_IMOVEL\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.bairroImovel\" \nng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex \nflex-gt-sm=\"30\"><label translate=\"LEITURA.VISUALIZACAO.COMPLEMENTO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.complemento\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"40\"><label>Municipío\n</label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.municipio\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\" flex><label translate=\"LEITURA.VISUALIZACAO.ENDERECO_ENTREGA\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.entrega\" ng-disabled=\"true\">\n</md-input-container></div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex><label>Setor</label>\n<input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.setor\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.QUADRA\"></label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" \nname=\"codigo\" ng-model=\"vm.dadosCadastrais.quadra\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.LOTE\"></label><input type=\"text\" ui-number-mask=\"0\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.lote\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.SUB_LOTE\">\n</label><input type=\"text\" ui-number-mask=\"0\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.subLote\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex><label>Unidade</label><input type=\"text\" id=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" \nng-model=\"vm.dadosCadastrais.unidade\" ng-disabled=\"true\"></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\" translate=\"LEITURA.VISUALIZACAO.HIDROMETRO\"></legend><div \nlayout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.NUMERO_HIDROMETRO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.numeroHidrometro\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.DATA_INSTALACAO_HIDROMETRO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.dataInstalacaoHidrometro\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.DATA_LIGACAO\"></label><input type=\"text\" \nid=\"cadastro-entrega-tipo-entrega-numbercodigo\" name=\"codigo\" ng-model=\"vm.dadosCadastrais.dataLigacaoHidrometro\" \nng-disabled=\"true\"></md-input-container></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"LEITURA.VISUALIZACAO.ECONOMIAS\"></legend><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" \nflex><label>Residencial</label><input type=\"text\" ng-model=\"vm.dadosCadastrais.economiaResidencial\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Comercial</label><input type=\"text\" \nng-model=\"vm.dadosCadastrais.economiaComercial\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Industrial</label><input type=\"text\" ng-model=\"vm.dadosCadastrais.economiaIndustrial\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label>Pública</label><input \ntype=\"text\" ng-model=\"vm.dadosCadastrais.economiaPublica\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Outros</label><input type=\"text\" ng-model=\"vm.dadosCadastrais.outros\" ng-disabled=\"true\">\n</md-input-container></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/tab-dados-faturamento.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\" id=\"dados-leitura\"><div \nlayout-gt-sm=\"column\" flex><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\"><label \ntranslate=\"LEITURA.VISUALIZACAO.DATA_VENCIMENTO\"></label><md-datepicker name=\"dataVencimento\" \nng-model=\"vm.dadosFaturamento.dataVencimento\" id=\"tab-dados-faturamento-data-vencimento\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" ng-disabled=\"true\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.CONSUMO_REAL\"></label><input \ntype=\"text\" ui-number-mask=\"0\" id=\"tab-dados-faturamento-consumo-real\" name=\"consumoReal\" \nng-model=\"vm.dadosFaturamento.consumoReal\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.CONSUMO_FATURADO\"></label><input type=\"text\" \nui-number-mask=\"0\" id=\"tab-dados-faturamento-consumo-faturado\" name=\"consumoAgua\" \nng-model=\"vm.dadosFaturamento.consumoFaturado\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"10\"><md-checkbox name=\"faturado\" id=\"tab-dados-leitura-faturado\" \nng-model=\"vm.dadosFaturamento.faturado\" aria-label=\"Faturado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"true\"><span translate=\"LEITURA.VISUALIZACAO.FATURADO\">Faturado</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"10\"><md-checkbox name=\"lido\" id=\"tab-dados-leitura-lido\" \nng-model=\"vm.dadosFaturamento.lido\" aria-label=\"Lido\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" ng-disabled=\"true\"><span\n translate=\"LEITURA.VISUALIZACAO.LIDO\">Lido</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><md-checkbox name=\"naoImprimeFatura\" id=\"tab-dados-leitura-nao-imprime-fatura\" \nng-model=\"vm.dadosFaturamento.naoImprimeFatura\" aria-label=\"naoImprimeFatura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"true\"><span translate=\"LEITURA.VISUALIZACAO.NAO_IMPRIME_FATURA\">Não imprime fatura</span></md-checkbox>\n</md-input-container><div layout-gt-sm=\"column\" flex><fab-button buttons=\"vm.itens\" titulo-menu=\"Menu\"></div></div>\n<fieldset class=\"standard\" flex><legend class=\"grp-legend\" translate=\"LEITURA.VISUALIZACAO.VALORES\"></legend><div \nlayout-gt-sm=\"row\" flex><div layout-gt-sm=\"column\" flex flex-gt-sm=\"70\"><div layout-gt-sm=\"row\" flex>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.VALOR_AGUA\"></label><input \ntype=\"text\" id=\"dialog-servico-valor-agua\" name=\"valorAgua\" ui-money-mask ng-model=\"vm.dadosFaturamento.valorAgua\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.VALOR_ESGOTO\"></label><input type=\"text\" id=\"dialog-servico-valor-esgoto\" \nname=\"valorEsgoto\" ui-money-mask ng-model=\"vm.dadosFaturamento.valorEsgoto\" ng-disabled=\"true\"></md-input-container>\n</div><div layout-gt-sm=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.VALOR_TBO_AGUA\"></label><input type=\"text\" id=\"dialog-servico-tbo-agua\" name=\"tboAgua\" \nui-money-mask ng-model=\"vm.dadosFaturamento.tboAgua\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.VALOR_TBO_ESGOTO\"></label><input type=\"text\" \nid=\"dialog-servico-tbo-esgoto\" name=\"tboAgua\" ui-money-mask ng-model=\"vm.dadosFaturamento.tboEsgoto\" \nng-disabled=\"true\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.VALOR_ICMS\"></label><input type=\"text\" id=\"dialog-servico-valor-icms\" name=\"valorIcms\" \nui-money-mask ng-model=\"vm.dadosFaturamento.icms\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.VALOR_FISAN\"></label><input type=\"text\" \nid=\"dialog-servico-valor-fisan\" name=\"valorIcms\" ui-money-mask ng-model=\"vm.dadosFaturamento.fisan\" ng-disabled=\"true\">\n</md-input-container></div></div><div layout=\"column\" flex><ms-widget flippable=\"true\" layout=\"column\" flex>\n<ms-widget-front class=\"white-bg\" flex><div layout=\"column\" class=\"card\" flex><div flex layout-align=\"center start\" \nclass=\"mb-20 p-5\" layout=\"column\"><div layout=\"row\" layout-align=\"start end\" class=\"mb-5 font-size-20 line-height-20\">\nFatura</div><div class=\"font-size-38 line-height-38 font-weight-500\">{{vm.dadosFaturamento.valorFatura | currency}}\n</div></div></div></ms-widget-front></ms-widget></div></div></fieldset><div layout-gt-sm=\"row\" flex></div><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\" translate=\"LEITURA.VISUALIZACAO.OBSERVACAO\"></legend>\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.OBSERVACAO\"></label><input \ntype=\"text\" name=\"observacao\" id=\"tab-dados-leitura-observacao\" ng-model=\"vm.dadosFaturamento.observacao\" \nmascara-tamanho-campo=\"80\" ng-disabled=\"true\"></md-input-container></fieldset></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/critica/tab-critica.html","<div id=\"visualizacao-leitura-tab-critica\" layout=\"column\" flex=\"100\"><div flex=\"100\" layout=\"column\" \nclass=\"form-container\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr \nshow-gt-sm hide><th colspan=\"2\" class=\"secondary-text border-left border-right th-group-header\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Crítica</span></div></th><th \ncolspan=\"6\" class=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Leitura</span></div></th><th colspan=\"2\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Consumo</span></div></th><th colspan=\"2\" \nclass=\"secondary-text border-right th-group-header\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Ocorrência</span></div></th><th colspan=\"3\" class=\"border-right th-group-header\"></th></tr>\n<tr><th ng-hide=\"true\" class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" style=\"white-space: normal\">Núm.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Data</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Usuário</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Data</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Data pós crít.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crít.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Fat. inicial</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Fat. pós crít.</span></div>\n</th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crít.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Inicial</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Pós crít.</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\">Leiturista</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Ações</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span class=\"column-title text-center\" \nstyle=\"white-space: normal\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"critica in vm.historicosCriticas\"><td \nng-hide=\"true\" class=\"text-center border-right border-left\"><span>{{critica.numeroCritica}}</span></td><td \nclass=\"text-center border-left border-right\" style=\"white-space: normal\"><span>{{critica.dataCritica}}</span></td><td \nclass=\"text-center border-right\"><span>{{critica.usuarioResponsavel}}</span></td><td class=\"text-center border-right\">\n<span>{{critica.dataLeituraAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.dataLeituraPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraLidaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraLidaPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraFaturadaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.leituraFaturadaPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.consumoFaturadoAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.consumoFaturadoPosCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.ocorrenciaAntesCritica}}</span></td><td class=\"text-center border-right\"><span>\n{{critica.ocorrenciaPosCritica}}</span></td><td class=\"text-center border-right\"><span>{{critica.leiturista}}</span>\n</td><td class=\"text-center border-right\" layout=\"row\" layout-align=\"start center\" flex><md-progress-circular \nclass=\"md-accent\" mode=\"indeterminate\" ng-if=\"critica.emProgresso\" md-diameter=\"20\"></md-progress-circular><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.abrirDialogFotos(critica)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span translate=\"RESOURCES.VISUALIZAR_FOTOS_VISITA\">Fotos</span></md-tooltip><md-icon \nmd-font-icon=\"icon-camera\" class=\"cor-icone-padrao\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"critica.motivo\" ng-click=\"vm.metodos.abrirDialogMotivoCritica(critica)\"><md-tooltip md-autohide \nid=\"pg-tooltip-gerar-relatorio\"><span>Visualizar motivo da crítica</span></md-tooltip><md-icon \nmd-font-icon=\"icon-document\" class=\"cor-icone-padrao\"></md-icon></md-button></td><td class=\"text-center border-right\" \nstyle=\"padding: 8px !important\"><div ng-if=\"!critica.calculoProporcional\"><span \nclass=\"ml-5 text-boxed blue-bg white-fg ng-binding\" ng-if=\"critica.statusCritica === \'Pendente\'\"><md-tooltip \nmd-autohide md-delay=\"250\"><span>Pendente</span></md-tooltip></span><span \nclass=\"ml-5 text-boxed orange-bg white-fg ng-binding status-revisao\" ng-if=\"critica.statusCritica === \'Revisão\' \">\n<md-tooltip md-autohide md-delay=\"250\"><span>Revisão</span></md-tooltip></span><span \nclass=\"ml-5 text-boxed purple-900-bg white-fg ng-binding status-revisao\" \nng-if=\"critica.statusCritica === \'Rev. impr.\' \"><md-tooltip md-autohide md-delay=\"250\"><span>Rev. impr.</span>\n</md-tooltip></span><span class=\"ml-5 text-boxed green-bg white-fg ng-binding status-revisao\" \nng-if=\"critica.statusCritica === \'Impressão\'\"><md-tooltip md-autohide md-delay=\"250\"><span>Impressão</span>\n</md-tooltip></span></div><span class=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" \nng-if=\"critica.calculoProporcional\"><md-tooltip md-autohide md-delay=\"250\"><span>Projetada</span></md-tooltip></span>\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/tab-dados-leitura.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\"><div \nlayout-gt-sm=\"column\" flex><div layout-gt-sm=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex-gt-sm=\"10\">\n<label translate=\"LEITURA.VISUALIZACAO.LEITURA_ANTERIOR\"></label><input type=\"text\" \nid=\"tab-dados-leitura-leitura-anterior\" name=\"leituraAnterior\" ng-model=\"vm.dadosLeitura.leituraAnterior\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \nstyle=\"right: auto\" translate=\"LEITURA.VISUALIZACAO.DATA_LEITURA_ANTERIOR\"></label><md-datepicker \nname=\"dataLeituraAnterior\" ng-model=\"vm.dadosLeitura.dataLeituraAnterior\" id=\"tab-dados-leitura-data-leitura-anterior\" \nmascara-conversor-string-para-data ng-mask=\"3?9/1?9/9999\" ng-disabled=\"true\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block leitura-hidrometro\" flex-gt-sm=\"15\"><label \ntranslate=\"LEITURA.VISUALIZACAO.LEITURA_HIDROMETRO\"></label><input type=\"text\" \nid=\"tab-dados-leitura-leitura-hidrometro\" name=\"leituraHidrometro\" ng-model=\"vm.dadosLeitura.leituraHidrometro\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"LEITURA.VISUALIZACAO.DATA_LEITURA\"></label><md-datepicker name=\"dataLeitura\" ng-mask=\"3?9/1?9/9999\" \nng-model=\"vm.dadosLeitura.dataLeitura\" id=\"tab-dados-leitura-data-leitura\" mascara-conversor-string-para-data \nng-disabled=\"true\"></md-datepicker></md-input-container><md-input-container class=\"md-block hora-leitura\" \nflex-gt-sm=\"30\"><label translate=\"LEITURA.VISUALIZACAO.HORA_LEITURA\"></label><input type=\"text\" ui-time-mask \nng-disabled=\"true\" id=\"tab-dados-leitura-hora-leitura\" name=\"horaLeitura\" ng-model=\"vm.dadosLeitura.horaLeitura\">\n</md-input-container><div layout=\"row\" layout-align=\"end center\" class=\"mb-10\" flex id=\"botao-menu-dados-leitura\"><div \nlayout-gt-sm=\"column\" flex><fab-button buttons=\"vm.menus\" titulo-menu=\"Menu\"></div></div></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.DIAS_CONSUMO\"></label><input \ntype=\"text\" ui-number-mask=\"0\" id=\"tab-dados-leitura-dias-consumo\" name=\"diasConsumo\" \nng-model=\"vm.dadosLeitura.diasConsumo\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"LEITURA.VISUALIZACAO.MEDIA\"></label><input type=\"text\" ui-number-mask=\"0\" \nid=\"tab-dados-leitura-media\" name=\"media\" ng-model=\"vm.dadosLeitura.media\" ng-disabled=\"true\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.LEITURISTA\"></label><input type=\"text\" id=\"tab-dados-leitura-leiturista\" \nname=\"leiturista\" ng-model=\"vm.dadosLeitura.leiturista\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.ENTREGA\"></label><input type=\"text\" \nid=\"tab-dados-leitura-entrega\" name=\"entrega\" ng-model=\"vm.dadosLeitura.entrega\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.MOTIVO_NAO_ENTREGA\"></label><input type=\"text\" \nid=\"tab-dados-leitura-motivo-nao-entrega\" name=\"motivoNaoEntrega\" ng-model=\"vm.dadosLeitura.motivoNaoEntrega\" \nng-disabled=\"true\"></md-input-container></div><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"LEITURA.VISUALIZACAO.OCORRENCIAS\"></legend><div layout-gt-sm=\"row\" flex><md-input-container \nclass=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.OCORRENCIA_1\"></label><input type=\"text\" \nid=\"tab-dados-leitura-ocorrencia\" name=\"ocorrencia\" ng-model=\"vm.dadosLeitura.ocorrencia01\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"LEITURA.VISUALIZACAO.OCORRENCIA_2\">\n</label><input type=\"text\" id=\"tab-dados-leitura-ocorrencia-2\" name=\"ocorrencia2\" \nng-model=\"vm.dadosLeitura.ocorrencia02\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"LEITURA.VISUALIZACAO.OCORRENCIA_3\"></label><input type=\"text\" \nid=\"tab-dados-leitura-ocorrencia-3\" name=\"ocorrencia3\" ng-model=\"vm.dadosLeitura.ocorrencia03\" ng-disabled=\"true\">\n</md-input-container></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\" \ntranslate=\"LEITURA.VISUALIZACAO.OBSERVACAO\"></legend><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.VISUALIZACAO.OBSERVACAO_ENTREGA\"></label><input type=\"text\" name=\"observacaoEntrega\" \nid=\"tab-dados-leitura-observacaoEntrega\" ng-model=\"vm.dadosLeitura.observacaoEntrega\" mascara-tamanho-campo=\"80\" \nng-disabled=\"true\"></md-input-container></fieldset></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/rastreamento-leiturista/sidenavs/legenda/views/legenda-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Legendas\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button><h2><span>Legendas</span>\n</h2></div></md-toolbar><md-content class=\"content\" layout-padding><md-list><md-list-item><div><i \nclass=\"icon-map-marker s24\" ng-style=\"{\'color\' : \'blue\'}\"></i> <span class=\"title\">Primeira leitura</span></div>\n</md-list-item><md-list-item><div><i class=\"icon-map-marker s24\" ng-style=\"{\'color\' : \'green\'}\"></i> <span \nclass=\"title\">Leitura normal</span></div></md-list-item><md-list-item><div><i class=\"icon-map-marker s24\" \nng-style=\"{\'color\' : \'orange\'}\"></i> <span class=\"title\">Leitura com ocorrência</span></div></md-list-item>\n<md-list-item><div><i class=\"icon-map-marker s24\" ng-style=\"{\'color\' : \'red\'}\"></i> <span class=\"title\">\nSomente ocorrência</span></div></md-list-item><md-list-item><div><i class=\"icon-map-marker s24\" \nng-style=\"{\'color\' : \'yellow\'}\"></i> <span class=\"title\">Última leitura</span></div></md-list-item><md-divider>\n</md-divider><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.metodos.fecharLegendas();\"><span>Fechar</span></md-button></div></div>\n</md-list></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tab-fotos.html","<md-content layout-padding ng-hide=\"vm.controleForm.listarTodasEntidades\" ng-disabled=\"vm.controleForm.emProgresso\">\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Hidrômetro\" md-active=\"vm.tabSelecionada === \'hidrometro\'\" \nid=\"cadastros-leiturista-mdtabs-hidrometro\" md-on-select=\"vm.metodos.tabSelecionada(\'hidrometro\')\"><md-tab-label><label\n translate=\"LEITURA.VISUALIZACAO.HIDROMETRO_FACHADA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-fotos-hidrometro\"></md-content></md-tab-body></md-tab><md-tab label=\"Prova de adulteração / outros\" \nmd-active=\"vm.tabSelecionada === \'provaAdulteracao\'\" id=\"cadastros-leiturista-mdtabs-prova-adulteracao\" \nmd-on-select=\"vm.metodos.tabSelecionada(\'provaAdulteracao\')\"><md-tab-label><label \ntranslate=\"LEITURA.VISUALIZACAO.PROVA_ADULTERACAO_OUTROS\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-fotos-prova-adulteracao\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/monitoramento/sidenavs/dashboard/views/dashboard-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Dashboard\"><md-icon md-font-icon=\"icon-chart-arc\"></md-icon></md-button><h2><span>{{vm.dashboard.title}}\n</span></h2><span flex></span><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Fechar\" \nlayout-align=\"left left\" ng-click=\"vm.metodos.fecharDashboard()\"><md-tooltip md-direction=\"left\">Fechar</md-tooltip>\n<md-icon md-font-icon=\"icon-close\" style=\"width: 24px; height: 24px\"></md-icon></md-button></div></md-toolbar>\n<md-content class=\"\" ms-scroll><md-list><div class=\"\" flex layout-wrap><ms-widget layout=\"column\" flex><ms-widget-front\n flex class=\"white-bg\"><div layout-align=\"center center\" class=\"ph-16 mt-8\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"vm.habilitarCampoPrimeiraLeitura\"><div class=\"h4\">\n{{vm.dashboard.primeiraLeitura}}</div></div><div layout-align=\"center center\" class=\"ph-16 mt-8\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"vm.habilitarCampoUltimaLeitura\"><div class=\"h4\">\n{{vm.dashboard.ultimaLeitura}}</div></div><div layout-align=\"center center\" class=\"ph-16 mt-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4\">{{vm.dashboard.retencoes}}</div></div><div class=\"p-2\"><nvd3 \nconfig=\"vm.dashboard.mainChart.config\" options=\"vm.dashboard.mainChart.options\" data=\"vm.dashboard.mainChart.data\">\n</nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-32\">{{vm.dashboard.footerLeft.count}}</span> <span class=\"h4\">{{vm.dashboard.footerLeft.title}}</span>\n</div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-32\">{{vm.dashboard.footerRight.count}}</span> <span class=\"h4\">{{vm.dashboard.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget></div></md-list></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/monitoramento/sidenavs/filtro/views/filtro-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>Filtros</span></h2><span \nflex></span><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Fechar\" layout-align=\"left left\" \nng-click=\"vm.metodos.abrirFiltros()\"><md-tooltip md-direction=\"left\">Fechar</md-tooltip><md-icon \nmd-font-icon=\"icon-close\" style=\"width: 24px; height: 24px\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"\"><md-subheader class=\"md-no-sticky\"><span translate=\"LEITURA.MONITORAMENTO.FILTROS.CONFIGURACAO\">Leituristas\n</span></md-subheader><md-list-item><md-input-container class=\"md-block\" flex><label \ntranslate=\"LEITURA.MONITORAMENTO.FILTROS.INTERVALO\">Intervalo (segundos)</label><md-select name=\"tipoSegmento\" \nid=\"cadastro-parametros-tabempresa-slctTipoSegmento\" ng-model=\"vm.filtro.intervalo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"intervalo\" \nng-repeat=\"intervalo in vm.intervalos\">{{intervalo.descricao}}</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-switch name=\"somenteRotaComLeituras\" ng-model=\"vm.filtro.somenteRotaComLeituras\">\nRotas com leituras</md-switch></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.preLoader\"><span class=\"font-weight-500\">Aguarde...</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></div>\n<md-subheader class=\"md-no-sticky\"><span translate=\"LEITURA.MONITORAMENTO.FILTROS.LEITURISTAS\">Leituristas</span>\n</md-subheader><md-list style=\"height: 45vh; overflow: scroll\"><md-list-item class=\"member\" \nng-repeat=\"leiturista in vm.leituristas | orderBy:\'codigo\'\" layout=\"row\" flex ng-disabled=\"vm.preLoader\" \nng-class=\"{\'disabled\': vm.preLoader}\" \nng-click=\"!vm.preLoader && vm.metodos.atualizarMapa(leiturista.codigo, vm.filtro.leituristas)\" \naria-label=\"Toggle Member\"><div layout=\"row\"><img class=\"md-avatar\" src=\"{{leiturista.foto}}\" \nalt=\"{{ leiturista.apelido }}\" ng-style><div ng-show=\"leiturista.estado > 0\" class=\"status\"><md-icon \nng-if=\"leiturista.estado == 1\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16\" \nng-style=\"{\'color\' : \'green\'}\"><md-tooltip>Enviando coordenadas</md-tooltip></md-icon><md-icon \nng-if=\"leiturista.estado == 2\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16\" \nng-style=\"{\'color\' : \'orange\'}\"><md-tooltip>Aguardando o envio de novas coordenadas</md-tooltip></md-icon><md-icon \nng-if=\"leiturista.estado == 3\" layout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16\" \nng-style=\"{\'color\' : \'gray\'}\"><md-tooltip>Desconectado</md-tooltip></md-icon><md-icon ng-if=\"leiturista.estado == 4\" \nlayout-align=\"center center\" md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16\" ng-style=\"{\'color\' : \'red\'}\">\n<md-tooltip>Aguardando o envio de coordenadas</md-tooltip></md-icon></div></div><span class=\"member-name\">\n{{ leiturista.codigo }} - {{ leiturista.apelido }}</span><div layout=\"column\" flex><md-button class=\"md-icon-button\" \nstyle=\"width: 100%\" flex \nng-if=\"vm.metodos.verificarSeLeituristaJaSelecionado(leiturista.codigo, vm.filtro.leituristas)\"><div layout=\"row\" \nlayout-align=\"start center\" flex></div></md-button></div><i class=\"icon-check s16\" \nng-if=\"vm.metodos.verificarSeLeituristaJaSelecionado(leiturista.codigo, vm.filtro.leituristas)\"></i></md-list-item>\n</md-list></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/monitoramento/sidenavs/legenda/views/legenda-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Legendas\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button><h2><span>Legendas</span>\n</h2></div></md-toolbar><md-content class=\"content\" layout-padding><md-list flex layout=\"column\" \nlayout-align=\"start start\"><md-list-item ng-repeat=\"legenda in vm.legendas\"><md-icon layout-align=\"center center\" \nmd-font-icon=\"icon-map-marker\" class=\"s24\" style=\"margin:0!important\" ng-style=\"{\'color\' : legenda.cor }\"></md-icon>\n<span class=\"title\">{{legenda.descricao}}</span></md-list-item></md-list><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.fecharLegenda()\"><span>Fechar</span></md-button></div></div></md-content>");
$templateCache.put("app/main/processamento/alerta-cliente/views/dialogs/dialog-cadastrar-alerta/views/dialog-cadastrar-alerta.html","<md-dialog id=\"dialog-selecionar-setor\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2>Cadastrar alerta</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><form name=\"form\">\n<md-input-container class=\"md-block\"><label>Código da ligação</label><input name=\"codigoLigacao\" \nmascara-numero-generica=\"###############\" ng-required=\"!vm.editando\" ng-model=\"vm.alerta.codigoLigacao\" \nng-disabled=\"vm.editando || vm.emProgresso\"><div ng-messages=\"form.ligacao.$error\"><div ng-message=\"pattern\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"100\" flex-xs><label>Alerta</label><input name=\"alerta\" type=\"text\" mascara-tamanho-campo=\"60\" \nmd-maxlength=\"60\" ng-required=\"true\" ng-model=\"vm.alerta.mensagem\" ng-disabled=\"vm.emProgresso\"><div \nng-messages=\"form.alerta.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-accent\" \nng-click=\"vm.metodos.salvar()\" ng-disabled=\"form.$invalid || vm.emProgresso\" \nstyle=\"display: flex; justify-content: center\"><span ng-if=\"!vm.emProgresso\">Salvar</span><md-progress-circular \nclass=\"md-accent text-center\" md-diameter=\"26\" md-mode=\"indeterminate\" ng-if=\"vm.emProgresso\"></md-progress-circular>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-disponibilizar-tarefa/dialog-tarefas-disponibilizar-tarefas.html","<md-dialog id=\"gerenciamento-grupo-dialog-disponibilizar-tarefa\" style=\"min-width: 85%;min-height: 95%\" \nclass=\"dialog-padrao\" aria-label=\"Dialog\"><md-button class=\"md-icon-button button-flutuante\" \nng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\" class=\"icone s26\">\n</md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.DISPONIBILIZAR_TAREFAS\" icone=\"icon-cellphone-android\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll id=\"disponibilizartarefas\" class=\"scrollable\" \nng-if=\"vm.parametros.calculo.tipoDetalheCalculo != 88\" ui-view=\"disponibilizartarefas-form@app.disponibilizar_tarefas\">\n</div><div ms-scroll class=\"scrollable\" ng-if=\"vm.parametros.calculo.tipoDetalheCalculo == 88\" \nui-view=\"disponibilizartarefas-form-caema@app.disponibilizar_tarefas\"></div></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-troca-leiturista/dialog-trocar-leituristas.html","<md-dialog id=\"gerenciamento-grupo-dialog-disponibilizar-tarefa\" style=\"min-width: 85%;min-height: 95%\" \nclass=\"dialog-padrao\" aria-label=\"Dialog\"><md-button class=\"md-icon-button button-flutuante\" \nng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\"><md-icon md-font-icon=\"icon-close\" class=\"icone s26\">\n</md-icon><md-tooltip>Fechar Dialog</md-tooltip></md-button><header-padrao \ntranslate-nome=\"RESOURCES.TROCAR_TAREFAS_LEITURISTAS\" icone=\"icon-clipboard-text\" ng-utiliza-pesquisa=\"false\">\n</header-padrao><div ms-scroll class=\"scrollable\" ui-view=\"trocarleiturista-form@app.controlecarga_trocarleiturista\">\n</div></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/sidenav/filtro/views/CAEMA/gerenciamento-grupo-filtro-caema.html","<div id=\"gerenciamento-grupo-filtro\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" flex><md-content class=\"content\" layout-padding><md-list>\n<md-list-item ng-if=\"vm.parametros.utilizaCadastroRegional\"><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.LOCALIDADE\">Localiadade</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"vm.regionais.length > 0\" name=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header \nng-if=\"vm.regionais.length > 0\"><input ng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" \nplaceholder=\"Pesquisar localidades..\" class=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhuma localidade encontrada.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></md-list-item><md-divider ng-if=\"vm.parametros.utilizaCadastroRegional\"></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"RESOURCES.REFERENCIA\">Referência</span></md-subheader>\n<md-list-item><div layout=\"column\" flex><div layout=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"30\">\n<label translate=\"RESOURCES.MES\">Mês</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" \nng-model=\"vm.filtro.mes\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nvalidacao-mes ng-required=\"true\"><div ng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"mes_invalido\" \ntranslate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex=\"50\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" name=\"ano\" mascara-numero-generica=\"####\" \nng-model=\"vm.filtro.ano\" ng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" \nng-required=\"true\"><div ng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaGrupo\">\n</md-progress-circular><md-input-container class=\"md-block mt-0\" layout=\"column\" flex><label \ntranslate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\" \nname=\"grupo\" ng-disabled=\"vm.grupos.length == 0\"><md-select-header ng-if=\"vm.grupos.length > 0\"><input \nng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" mascara-numero-generica=\"####\" \nplaceholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option ng-value=\"grupo\" \nng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span></md-input-container></div></div>\n</md-list-item><md-divider></md-divider><md-list-item ng-show=\"false\" ng-if=\"vm.parametros.utilizaCadastroRegional\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" ng-if=\"vm.emProgressoBuscaMunicipio\">\n</md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex><label translate=\"RESOURCES.SETOR\">\n</label><md-select ng-model=\"vm.filtro.municipio\" md-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" \nname=\"municipio\" ng-disabled=\"vm.municipios.length == 0\"><md-select-header ng-if=\"vm.municipios.length > 0\"><input \nng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" placeholder=\"Pesquisar setor..\" class=\"md-text\">\n</md-select-header><md-option ng-value=\"undefined\" md-option-empty>Desmarcar</md-option><md-option \nng-value=\"municipio.codigo\" ng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">\n{{municipio.descricao}}</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">\nNenhum setor encontrado.</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></md-list-item><md-divider>\n</md-divider><md-subheader class=\"md-no-sticky\"><span translate=\"RESOURCES.SITUACAO\">Situação</span></md-subheader>\n<md-list-item><md-input-container><md-radio-group layout=\"row\" ng-required=\"true\" ng-model=\"vm.filtro.situacao\">\n<md-radio-button ng-value=\"1\">Aberto</md-radio-button><md-radio-button ng-value=\"2\">Todos</md-radio-button>\n</md-radio-group></md-input-container></md-list-item><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.form.$valid\" ng-click=\"vm.metodos.filtrarGrupos(vm.filtro)\"><span>Filtrar</span></md-button></div>\n</div></md-list></md-content></form></div>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/views/CAEMA/dialog-tarefas-caema.html","<md-dialog aria-label=\"Tarefas\" id=\"dialog-tarefas-gerenciamento-grupo\" layout=\"column\" layout-align=\"space-between\">\n<md-dialog-content class=\"p-0\" layout=\"column\" flex><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools md-accent\"><h2 translate=\"RESOURCES.DETALHAMENTO_GRUPO_LEITURA\"></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><carregamento-circular em-progresso=\"vm.emProgresso\" titulo=\"Aguarde...\" \nmensagem=\"{{ vm.mensagemCarregamento }}\"></carregamento-circular><div layout=\"column\" class=\"pl-16 pr-16 pb-16\" \nstyle=\"max-height: 65vh!important\"><div layout=\"row\"><md-button class=\"md-fab btn-atualizar\" \nng-click=\"vm.metodos.pesquisarTarefas()\"><md-icon class=\"s16\" md-font-icon=\"icon-refresh\"><md-tooltip \nmd-direction=\"bottom\">Atualizar</md-tooltip></md-icon></md-button><div hide show-gt-xs layout-align=\"start end\" \nlayout-gt-xs=\"row\" flex=\"100\" id=\"div-filtro-cards\"><div layout=\"row\" flex=\"100\" flex-gt-xs=\"{{filtro.flexGtXs}}\" \nclass=\"div-card\" ng-repeat=\"filtro in vm.filtro.informacoesCardFiltros\"><ms-widget class=\"h-60\" \nstyle=\"padding: 4px!important;width: 100%\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-4 blue-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"font-weight-500 font-size-12\">{{filtro.titulo}}</div><div class=\"font-size-14\">{{filtro.dado}}</div></div>\n</ms-widget-front></ms-widget></div></div></div><div><table flex=\"100\" class=\"dataTable row-border hover\" \nng-if=\"vm.tarefas.length > 0\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr show-gt-sm hide><th colspan=\"2\" \nclass=\"border-left border-right\"></th><th colspan=\"3\" class=\"secondary-text border-right\"><div class=\"table-header\">\n<span class=\"column-title text-center white-space-normal\">Localização</span></div></th><th colspan=\"4\" \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leituras</span></div></th><th colspan=\"4\" class=\"border-right\">\n</th></tr><tr><th class=\"secondary-text border-left border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.TAREFA\">Tarefa</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.STATUS\">Status</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.SETOR\">Setor</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.ROTAS\">Rota</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\" translate=\"RESOURCES.QUADRAS\">Rota</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Total</span></div></th><th class=\"secondary-text border-right\"><div\n class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Efetuadas</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Não efetuadas</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Efetuadas(%)</span></div></th><th class=\"secondary-text\" \nng-if=\"false\"><div class=\"table-header\"><span class=\"column-title text-center white-space-normal\">Rep. a realizar\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Leiturista</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Data exportação</span></div></th><th \nclass=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-center white-space-normal\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat=\"tarefa in vm.tarefas track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{tarefa.numeroDistribuicao == 0 ? \"\": tarefa.numeroDistribuicao}}</span></td><td class=\"text-center border-right\">\n<span class=\"text-boxed white-bg black-fg\" ng-if=\"tarefa.situacao === \'NÃO DISTRIBUÍDO\'\">Não distríbuido </span><span \nclass=\"text-boxed gray-bg black-fg\" ng-if=\"tarefa.situacao === \'PARCIALMENTE DISTRIBUÍDO\'\">Parciamente distríbuido \n</span><span class=\"text-boxed yellow-700-bg black-fg\" ng-if=\"tarefa.situacao === \'DISTRIBUÍDO\'\">Distríbuido </span>\n<span class=\"text-boxed orange-bg white-fg\" ng-if=\"tarefa.situacao === \'EXPORTADO MOBILE\'\">Disponibilizado </span><span\n class=\"text-boxed md-light-blue-600-bg white-fg\" ng-if=\"tarefa.situacao === \'IMPORTADO MOBILE\'\">Importado </span><span\n class=\"text-boxed green-bg white-fg\" ng-if=\"tarefa.situacao === \'GRUPO EXPORTADO\'\">Exportado</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.setor}}</span></td><td class=\"text-center border-right\"><span>\n{{vm.metodos.quebrarRotas(tarefa.rota, tarefa)}}</span> <span ng-if=\"tarefa.quebrouRota && tarefa.rotaBKP\"><md-button \nng-click=\"vm.metodos.abrirDialogRotas(tarefa.rotaBKP)\" class=\"md-icon-button\"><md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-more\"><md-tooltip>Rotas</md-tooltip></md-icon></md-button></span></td><td \nclass=\"text-center border-right\"><span>{{vm.metodos.quebrarQuadras(tarefa.quadra, tarefa)}}</span> <span \nng-if=\"tarefa.quebrouQuadra && tarefa.quadraBKP\"><md-button \nng-click=\"vm.metodos.abrirDialogRotas(tarefa.quadraBKP, \'Quadra(s)\')\" class=\"md-icon-button\"><md-icon \nclass=\"cor-icone-padrao\" md-font-icon=\"icon-more\"><md-tooltip>Quadras</md-tooltip></md-icon></md-button></span></td><td\n class=\"text-center border-right\"><span>{{tarefa.totalVisitas}}</span></td><td class=\"text-center border-right\"><span>\n{{tarefa.visitasEfetuadas}}</span></td><td class=\"text-center border-right\"><span>{{tarefa.visitasNaoEfetuadas}}</span>\n</td><td class=\"text-center border-right\"><span>{{ tarefa.porcentagemConclusaoLeituras }}%</span></td><td \nclass=\"text-center border-right\"><span>{{tarefa.leiturista}}</span></td><td class=\"text-center border-right\"><span>\n{{tarefa.dataExportacao}}</span></td><td class=\"text-center border-left border-right\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-if=\"(tarefa.situacao === \'DISTRIBUÍDO\')\" \nng-click=\"vm.metodos.abrirDialogDisponibilizarTarefa(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\">\n<span translate=\"RESOURCES.DISPONIBILIZAR\">Disponibilizar</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nng-class=\"{\'cor-icone-padrao\': tarefa.situacao === \'DISTRIBUÍDO\'}\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"(tarefa.situacao === \'NÃO DISTRIBUÍDO\')\" \nng-click=\"vm.metodos.abrirDialogDistribuicao(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.DISTRIBUIR_TAREFAS\">Tarefas</span></md-tooltip><md-icon md-font-icon=\"icon-open-in-new\" \nng-class=\"{\'cor-icone-padrao\': tarefa.situacao === \'NÃO DISTRIBUÍDO\'}\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"!(tarefa.situacao === \'NÃO DISTRIBUÍDO\' || tarefa.situacao === \'DISTRIBUÍDO\')\" \nng-disabled=\"true\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-disabled=\"(tarefa.situacao !== \'EXPORTADO MOBILE\') || tarefa.visitasEfetuadas != 0\" \nng-click=\"vm.metodos.abrirDialogTrocaLeiturista(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.TROCAR_LEITURISTA\">Trocar Leiturista</span></md-tooltip><md-icon md-font-icon=\"icon-worker\" \nng-class=\"{ \'cor-icone-padrao\': (tarefa.situacao === \'EXPORTADO MOBILE\') && tarefa.visitasEfetuadas == 0 }\"></md-icon>>\n</md-button><md-button class=\"md-icon-button\" \nng-disabled=\"(tarefa.situacao !== \'EXPORTADO MOBILE\') || tarefa.visitasEfetuadas != 0\" \nng-click=\"vm.metodos.cancelamentoTarefa(tarefa)\"><md-tooltip md-autohide id=\"pg-tooltip-gerar-relatorio\"><span \ntranslate=\"RESOURCES.CANCELAMENTO_TAREFA\">Cancelar tarefa</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nng-class=\"{ \'cor-icone-padrao\': (tarefa.situacao === \'EXPORTADO MOBILE\') && tarefa.visitasEfetuadas == 0 }\"></md-icon>\n</md-button></div></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-content \nng-if=\"!vm.emProgressoBuscaTarefa\" class=\"estatisticas pt-0\"><div layout-gt-sm=\"row\" flex=\"100\" layout=\"column\" \nlayout-align=\"center center\"><ms-widget class=\"h-60\" style=\"padding: 4px!important;width: 100%\" layout=\"column\" \nflex=\"100\" ng-repeat=\"total in vm.totalizador\"><ms-widget-front class=\"p-4 blue-bg white-fg\" layout=\"row\" flex=\"100\">\n<div class=\"pt-8 pb-2\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nclass=\"font-weight-500 secondary-text\">{{total.title}}</div><div class=\"font-size-20\">{{total.data | number}}</div>\n</div></ms-widget-front></ms-widget></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-faixa/tab-faixa.html","<md-content id=\"cadastro-parametros-tab-calculo-tab-faixa\"><div class=\"form-container\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label \ntranslate=\"RESOURCES.CONSUMO_ADICIONAL_LEITURA\">Consumo adicional leitura</label><md-select \nname=\"consumoAdicionalAConsistirLeituraForaFaixa\" \nid=\"cadastro-parametros-tabcalculo-slctConsumoAdicionalAConsistirLeituraForaFaixa\" \nng-model=\"vm.parametro.calculo.consumoAdicionalAConsistirLeituraForaFaixa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" \nng-repeat=\"padraoNome in vm.listaConsumoAdicionalAConsistirLigacaoForaFaixa\">{{padraoNome.descricao}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.TIPO_CONSUMO_CONSISTENCIA_LEITURA_FORA_FAIXA\">\nConsumo a utilizar na consistência de leitura fora de faixa</label><md-select \nname=\"tipoConsumoConsistenciaLeituraForaFaixa\" \nid=\"cadastro-parametros-tabcalculo-slctTipoConsumoConsistenciaLeituraForaFaixa\" \nng-model=\"vm.parametro.calculo.tipoConsumoConsistenciaLeituraForaFaixa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoConsumo.id\" ng-repeat=\"tipoConsumo in vm.tiposConsumo\">{{tipoConsumo.descricao}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><md-checkbox \nname=\"consisteForaFaixaMesmoSemParametrosConsumo\" \nid=\"cadastro-parametros-tabcalculo-chkConsisteForaFaixaMesmoSemParametrosConsumo\" \nng-model=\"vm.parametro.calculo.consisteForaFaixaMesmoSemParametrosConsumo\" \naria-label=\"Realiza cobrança água/esgoto quando consumo zerado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.CONSISTIR_MESMO_SEM_PARAMETRO_CONSUMO\">Consistir mesmo sem parâmetro de consumo</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><fieldset class=\"standard\" \nflex-gt-sm=\"100\"><md-checkbox name=\"utilizaPadronizacaoConsumoForaFaixa\" \nid=\"cadastro-parametros-tabcalculo-chkutilizaPadronizacaoConsumoForaFaixa\" \nng-model=\"vm.parametro.calculo.utilizaPadronizacaoConsumoForaFaixa\" \nng-change=\"vm.metodos.limpaCamposPadronizacaoConsumo()\" aria-label=\"Ultiliza padronização de consumo\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_PADRONIZACAO_CONSUMO\">Utilizar padronização de consumo</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.calculo.utilizaPadronizacaoConsumoForaFaixa == \'S\'\"><div \nlayout=\"row\" layout-xs=\"row\"><div layout=\"column\" flex=\"15\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label\n translate=\"RESOURCES.ABAIXO_DA_MEDIA\"></label><input ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"3\" \nname=\"percentualConsumoForaFaixaAbaixoMedia\" \nid=\"cadastro-parametros-tabcalculo-txtPercentualConsumoForaFaixaAbaixoMedia\" \nng-model=\"vm.parametro.calculo.percentualConsumoForaFaixaAbaixoMedia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><label translate=\"RESOURCES.ACIMA_DA_MEDIA\">\n</label><input ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"3\" \nname=\"percentualConsumoForaFaixaAcimaMedia\" \nid=\"cadastro-parametros-tabcalculo-txtPercentualConsumoForaFaixaAcimaMedia\" \nng-model=\"vm.parametro.calculo.percentualConsumoForaFaixaAcimaMedia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"column\" flex=\"50\"><md-input-container class=\"md-block\" flex=\"100\"><label>\nOcorrência para leitura fora de faixa abaixo da média</label><md-select name=\"codigoOcorrenciaForaFaixaAbaixoMedia\" \nid=\"cadastro-parametros-tabcalculo-CodigoOcorrenciaForaFaixaAbaixoMedia\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaForaFaixaAbaixoMedia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\">\n<label>Ocorrência para leitura fora de faixa acima da média</label><md-select \nname=\"codigoOcorrenciaForaFaixaAcimaMedia\" id=\"cadastro-parametros-tabcalculo-CodigoOcorrenciaForaFaixaAcimaMedia\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaForaFaixaAcimaMedia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaOcorrencias\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div></div></div></fieldset></div></div>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-configuracao/tab-configuracao.html","<md-content id=\"cadastro-parametros-tab-calculo-tab-configuracao\"><div class=\"form-container\"><div layout-gt-xs=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"35\"><label translate=\"RESOURCES.TIPO_CALCULO\">\nTipo de cálculo</label><input id=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtTipoDetalheCalculo\" \nname=\"tipoDetalheCalculo\" type=\"text\" mascara-tamanho-campo=\"5\" ui-number-mask=\"0\" ui-hide-group-sep \nng-model=\"vm.parametro.calculo.tipoDetalheCalculo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                   !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"35\"><label translate=\"RESOURCES.UNIDADE_MEDIDA\">Unidade de medida de consumo</label><md-select \nid=\"cadastro-parametros-tabcoletor-tableitura-slctUnidadeMedida\" name=\"unidadeMedidaConsumo\" \nng-model=\"vm.parametro.calculo.unidadeMedidaConsumo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                       !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"unidade.id\" ng-repeat=\"unidade in vm.listaTipoUnidadeMedida\">{{unidade.descricao}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"35\"><md-checkbox \nid=\"cadastro-parametros-tabcalculo-chkIgualarConsumoALeituraAtualQuandoHidrometroNovo\" \nname=\"igualarConsumoALeituraAtualQuandoHidrometroNovo\" \naria-label=\"Iguala consumo a leitura atual quando hidrômetro novo\" \nng-model=\"vm.parametro.calculo.igualarConsumoALeituraAtualQuandoHidrometroNovo\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.IGUALAR_CONSUMO_LEITURA_ATUAL_QUANDO_HIDROMETRO_NOVO\">\nIgualar consumo a leitura atual quando hidrômetro novo</span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-xs=\"35\"><md-checkbox \nid=\"cadastro-parametros-tabcalculo-chkRealizaCobrancaAguaEsgotoConsumoZerado\" \nname=\"realizaCobrancaAguaEsgotoConsumoZerado\" aria-label=\"Realiza cobrança água/esgoto quando consumo zerado\" \nng-model=\"vm.parametro.calculo.realizaCobrancaAguaEsgotoConsumoZerado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.REALIZAR_COBRANCA_AGUA_ESGOTO_QUANDO_CONSUMO_ZERADO\">\nRealizar cobrança água/esgoto quando consumo zerado</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs=\"35\"><md-checkbox \nid=\"cadastro-parametros-tabcalculo-chkUtilizarValorFixoPrimeiraFaixaTabelaTarifaria\" \nname=\"utilizarValorFixoPrimeiraFaixaTabelaTarifaria\" aria-label=\"Utilizar valor fixo primeira faixa tabela tarifária\" \nng-model=\"vm.parametro.calculo.utilizarValorFixoPrimeiraFaixaTabelaTarifaria\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_VALOR_FIXO_PRIMEIRA_FAIXA_TABELA_TARIFARIA\">\nUtilizar valor fixo primeira faixa tabela tarifária</span></md-checkbox></md-input-container></div><div><fieldset \nclass=\"standard\" flex-gt-sm=\"100\" \nstyle=\"display: flex; align-items: start;\r\n            justify-content: start; flex-direction: row; margin-bottom: 10px\">\n<legend class=\"grp-legend\">Cobrança de TBO para ligações em exceção</legend><md-input-container \nclass=\"md-block chkCobrarTBOLigacaoExcecao\" flex-gt-xs=\"35\"><md-checkbox \nid=\"cadastro-parametros-tabcalculo-chkCobrarTBOLigacaoExcecao\" name=\"cobrarTBOLigacaoExcecao\" \naria-label=\"Cobrar TBO para ligação em exceção\" ng-model=\"vm.parametro.calculo.cobrarTBOLigacaoExcecao\" \nng-change=\"vm.metodos.onChangeCobrarTbo(vm.parametro.calculo.cobrarTBOLigacaoExcecao)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                                         !vm.controleForm.inserirAtivo\">\n<span>Cobrar TBO para ligação em exceção</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"30\"><md-checkbox id=\"cadastro-parametros-tabcalculo-chkCobrarTBOApenasComConsumoLigacaoExcecao\" \nname=\"cobrarTBOApenasComConsumoLigacaoExcecao\" aria-label=\"Apenas com consumo\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-model=\"vm.parametro.calculo.cobrarTBOApenasComConsumoLigacaoExcecao\" \nng-disabled=\"!vm.parametro.calculo.cobrarTBOLigacaoExcecao || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<span>Apenas com consumo</span></md-checkbox></md-input-container></fieldset></div><div layout=\"row\"><fieldset \nclass=\"standard\" flex-gt-sm=\"100\"><md-checkbox \nid=\"cadastro-parametros-tabcalculo-chkUtilizaCalculoProporcionalNumeroDias\" \nname=\"utilizaCalculoProporcionalNumeroDias\" aria-label=\"Ultiliza cálculo proporcional de dias de consumo\" \nng-model=\"vm.parametro.calculo.utilizaCalculoProporcionalNumeroDias\" \nng-change=\"vm.metodos.limpaCamposCalculoProporcional()\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_CALCULO_PROPORCIONAL\">Utilizar cálculo proporcional de dias de consumo</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.calculo.utilizaCalculoProporcionalNumeroDias == \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.NUMERO_DIAS_LIMITE_CALCULO_NORMAL\">\n</label><input id=\"cadastro-parametros-tabcalculo-txtNumeroDiasLimiteCalculoNormal\" \nname=\"numeroDiasLimiteCalculoNormal\" ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"5\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'numeroDiasLimiteCalculoNormal\', \r\n                                            vm.parametro.calculo.numeroDiasLimiteCalculoNormal)\" \nng-model=\"vm.parametro.calculo.numeroDiasLimiteCalculoNormal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                               !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><label \ntranslate=\"RESOURCES.NUMERO_DIAS_LIMITE_CALCULO_PROPORCIONAL\"></label><input \nid=\"cadastro-parametros-tabcalculo-txtNumeroDiasConsumoCalculoProporcional\" \nname=\"numeroDiasConsumoCalculoProporcional\" ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"5\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'numeroDiasConsumoCalculoProporcional\', \r\n                                            vm.parametro.calculo.numeroDiasConsumoCalculoProporcional)\" \nng-model=\"vm.parametro.calculo.numeroDiasConsumoCalculoProporcional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                               !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.DATA_LEITURA_ULTILIZADA\">Data da leitura a ser ultilizada</label><md-select \nid=\"cadastro-parametros-tabcalculo-slctTipoDataLeituraCalculoProporcional\" name=\"tipoDataLeituraCalculoProporcional\" \nng-model=\"vm.parametro.calculo.tipoDataLeituraCalculoProporcional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                                   !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"dataLeituraSerRealizada.id\" \nng-repeat=\"dataLeituraSerRealizada in vm.listaDataLeituraSerRealizada\">{{dataLeituraSerRealizada.descricao}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center top\"><div \nclass=\"md-subheader\"><span class=\"observacao\" translate=\"RESOURCES.OBSERVACAO_DATA_LEITURA_PROPORCIONAL\">\nA data da leitura selecionada será considerada para gravação e impressão na fatura quando calcular proporcional.</span>\n</div></div></div></fieldset></div><br><div layout=\"row\"><md-tab-body flex><fieldset class=\"standard\" flex=\"100\">\n<legend class=\"grp-legend\" translate=\"RESOURCES.STRING_DE_PARAMETRIZACAO\"></legend><md-input-container \nclass=\"md-block\" flex=\"100\"><textarea id=\"cadastro-parametros-tabcalculo-tabconsumoalterado-txtStringParametrizacao\" \nname=\"stringParametrizacao\" rows=\"2\" mascara-tamanho-campo=\"1000\" max-rows=\"3\" \nng-model=\"vm.parametro.coletor.stringParametrizacao\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoConsumoAlterado($event)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                              !vm.controleForm.inserirAtivo\">\n\r\n                        </textarea></md-input-container></fieldset></md-tab-body></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-calculo/tabs/tab-arredondamento/tab-arredondamento.html","<md-content id=\"cadastro-parametros-tab-calculo-tab-arredondamento\"><div class=\"form-container\"><div layout=\"row\">\n<fieldset class=\"standard\" flex-gt-sm=\"100\"><md-checkbox name=\"criaServicoArredondamento\" \nid=\"cadastro-parametros-tabcalculo-chkCriaServicoArredondamento\" \nng-model=\"vm.parametro.calculo.criaServicoArredondamento\" ng-change=\"vm.metodos.limpaCamposCriaServico()\" \naria-label=\"Cria serviço de arredondamento\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.CRIAR_SERVICO\">Criar serviço</span></md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.calculo.criaServicoArredondamento == \'S\'\"><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.SERVICO\">Serviço</label><md-select \nname=\"tipoServicoArredondamento\" id=\"cadastro-parametros-tabcalculo-slctTipoServicoArredondamento\" \nng-model=\"vm.parametro.calculo.tipoServicoArredondamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaTipoServico\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"5\"><label translate=\"RESOURCES.CODIGO\">Código</label><input ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"5\" name=\"codigoServicoArredondamentoAcrescimo\" \nid=\"cadastro-parametros-tabcalculo-txtCodigoServicoArredondamentoAcrescimo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'01\')==-1 && vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'03\')==-1\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'codigoServicoArredondamentoAcrescimo\', vm.parametro.calculo.codigoServicoArredondamentoAcrescimo)\" \nng-model=\"vm.parametro.calculo.codigoServicoArredondamentoAcrescimo\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"45\"><label translate=\"RESOURCES.ACRESCIMO\">Acrescimo</label><input \nname=\"descricaoServicoArredondamentoAcrescimo\" \nid=\"cadastro-parametros-tabcalculo-txtDescricaoServicoArredondamentoAcrescimo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'01\')==-1 && vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'03\')==-1\" \nmascara-tamanho-campo=\"50\" ng-model=\"vm.parametro.calculo.descricaoServicoArredondamentoAcrescimo\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"5\"><label \ntranslate=\"RESOURCES.CODIGO\">Código</label><input ui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"5\" \nname=\"codigoServicoArredondamentoDesconto\" id=\"cadastro-parametros-tabcalculo-txtCodigoServicoArredondamentoDesconto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'02\')==-1 && vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'03\')==-1\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'codigoServicoArredondamentoDesconto\', vm.parametro.calculo.codigoServicoArredondamentoDesconto)\" \nng-model=\"vm.parametro.calculo.codigoServicoArredondamentoDesconto\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"45\"><label translate=\"RESOURCES.DESCONTO\">Desconto</label><input \nname=\"descricaoServicoArredondamentoDesconto\" \nid=\"cadastro-parametros-tabcalculo-txtDescricaoServicoArredondamentoDesconto\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'02\')==-1 && vm.parametro.calculo.tipoServicoArredondamento.indexOf(\'03\')==-1\" \nmascara-tamanho-campo=\"50\" ng-model=\"vm.parametro.calculo.descricaoServicoArredondamentoDesconto\"></md-input-container>\n</div><div layout=\"row\"><fieldset class=\"standard\" flex-gt-sm=\"100\"><legend class=\"grp-legend\" \ntranslate=\"RESOURCES.ARREDONDAMENTO\"></legend><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.REFERENCIA\"></label><input ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"3\" name=\"referenciaArredondamentoValorTotalConta\" \nid=\"cadastro-parametros-tabcalculo-txtReferenciaArredondamentoValorTotalConta\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'referenciaArredondamentoValorTotalConta\', vm.parametro.calculo.referenciaArredondamentoValorTotalConta)\" \nng-model=\"vm.parametro.calculo.referenciaArredondamentoValorTotalConta\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label \ntranslate=\"RESOURCES.DIGITO_DESCONSIDERADO\"></label><input ui-number-mask=\"0\" ui-hide-group-sep \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'calculo\',\'digitoDesconsideradoArredondamento\', vm.parametro.calculo.digitoDesconsideradoArredondamento)\" \nmascara-tamanho-campo=\"3\" name=\"digitoDesconsideradoArredondamento\" \nid=\"cadastro-parametros-tabcalculo-txtDigitoDesconsideradoArredondamento\" \nng-model=\"vm.parametro.calculo.digitoDesconsideradoArredondamento\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-outros/tab-outros.html","<md-content id=\"tab-impressao-tab-comunicados-tab-quitacaoanualdebitos\"><div class=\"form-container\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><md-checkbox name=\"fixaProximaLeitura\" \nid=\"cadastro-parametros-taboutros-chkFixaProximaLeitura\" ng-model=\"vm.parametro.fixaProximaLeitura\" \naria-label=\"Fixa data da próxima leitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.FIXAR_DATA_PROXIMA_LEITURA\">Fixar data da próxima leitura</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><md-checkbox \nname=\"geraCodigoBarrasDebitoAutomatico\" id=\"cadastro-parametros-taboutros-chkGeraCodigoBarrasDebitoAutomatico\" \nng-model=\"vm.parametro.impressao.geraCodigoBarrasDebitoAutomatico\" \naria-label=\"Imprime código de barras débito automático\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.GERAR_CODIGO_BARRAS_DEBITO_AUTOMATICO\">Gerar código de barras débito automático</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"35\"><md-checkbox \nname=\"imprimeCodigoBarrasDebitoAutomatico\" id=\"cadastro-parametros-taboutros-chkImprimeCodigoBarrasDebitoAutomatico\" \nng-model=\"vm.parametro.impressao.imprimeCodigoBarrasDebitoAutomatico\" \naria-label=\"Imprime código de barras débito automático\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_CODIGO_BARRAS_DEBITO_AUTOMATICO\">Imprimir código de barras débito automático</span>\n</md-checkbox></md-input-container><pre></pre></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><md-checkbox name=\"imprimeConsumoResidual\" \nid=\"cadastro-parametros-taboutros-chkImprimeConsumoResidual\" ng-model=\"vm.parametro.impressao.imprimeConsumoResidual\" \naria-label=\"Imprime consumo residual\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_CONSUMO_RESIDUAL\">Imprimir consumo residual</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"vm.parametro.tipoProcesso === \'01\'\"><md-checkbox \nname=\"utilizaRelatorioClientesVisitados\" id=\"cadastro-parametros-taboutros-chkUtilizaRelatorioClientesVisitados\" \nng-model=\"vm.parametro.impressao.utilizaRelatorioClientesVisitados\" \naria-label=\"Utilizar sugestão de impressão do relatório de clientes visitados\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nUtilizar sugestão de impressão do relatório de clientes visitados</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"RESOURCES.BOLETO_BANCARIO\">Boleto bancário\n</label><md-select name=\"boletoBancario\" id=\"cadastro-parametros-tabimpressao-taboutros-slctboletoBancario\" \nng-model=\"vm.parametro.bolCodigo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"boleto.codigo\" ng-repeat=\"boleto in vm.boletos\">\n{{boleto.codigo}} - {{boleto.cedente}}</md-option></md-select></md-input-container></div><div layout=\"row\"><fieldset \nclass=\"standard\" flex flex-gt-sm=\"100\"><legend class=\"grp-legend\" translate=\"RESOURCES.VALORES\"></legend><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.LEITURA_COM_IMPRESSAO_SIMULTANEA\">Leitura com impressão simultânea</label><input \nui-number-mask=\"4\" maxlength=\"16\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorLeituraImpressaoSimultanea\', vm.parametro.valor.valorLeituraImpressaoSimultanea)\" \nname=\"valorLeituraImpressaoSimultanea\" id=\"cadastro-parametros-taboutros-txtValorLeituraImpressaoSimultanea\" \nng-model=\"vm.parametro.valor.valorLeituraImpressaoSimultanea\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"RESOURCES.SOMENTE_LEITURA\">\nSomente leitura</label><input ui-number-mask=\"4\" maxlength=\"16\" name=\"valorSomenteLeitura\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorSomenteLeitura\', vm.parametro.valor.valorSomenteLeitura)\" \nid=\"cadastro-parametros-taboutros-txtValorSomenteLeitura\" ng-model=\"vm.parametro.valor.valorSomenteLeitura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.COMUNICADO_CONSUMO_ALTERADO\">Comunicado de consumo alterado</label><input ui-number-mask=\"4\" \nmaxlength=\"16\" name=\"valorComunicadoConsumoAlterado\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorComunicadoConsumoAlterado\', vm.parametro.valor.valorComunicadoConsumoAlterado)\" \nid=\"cadastro-parametros-taboutros-txtValorComunicadoConsumoAlterado\" \nng-model=\"vm.parametro.valor.valorComunicadoConsumoAlterado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.COMUNICADO_DE_DEBITOS\">Comunicado de débitos</label><input ui-number-mask=\"4\" maxlength=\"16\" \nname=\"valorComunicadoDebito\" id=\"cadastro-parametros-taboutros-txtValorComunicadoDebito\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorComunicadoDebito\', vm.parametro.valor.valorComunicadoDebito)\" \nng-model=\"vm.parametro.valor.valorComunicadoDebito\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n<label translate=\"RESOURCES.COMUNICADO_OCORRENCIA\">Comunicado de ocorrência</label><input ui-number-mask=\"4\" \nmaxlength=\"16\" name=\"valorComunicadoPorOcorrencia\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorComunicadoPorOcorrencia\', vm.parametro.valor.valorComunicadoPorOcorrencia)\" \nid=\"cadastro-parametros-taboutros-txtValorComunicadoPorOcorrencia\" \nng-model=\"vm.parametro.valor.valorComunicadoPorOcorrencia\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.COMUNICADO_QUITACAO_ANUAL\">Comunicado de quitação anual</label><input ui-number-mask=\"4\" \nmaxlength=\"16\" name=\"valorComunicadoQuitacaoAnual\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorComunicadoQuitacaoAnual\', vm.parametro.valor.valorComunicadoQuitacaoAnual)\" \nid=\"cadastro-parametros-taboutros-txtValorComunicadoQuitacaoAnual\" \nng-model=\"vm.parametro.valor.valorComunicadoQuitacaoAnual\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.COMUNICADO_ALTERNATIVO\">Comunicado alternativo</label><input ui-number-mask=\"4\" maxlength=\"16\" \nname=\"valorComunicadoAlternativo\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorComunicadoAlternativo\', vm.parametro.valor.valorComunicadoAlternativo)\" \nid=\"cadastro-parametros-taboutros-txtValorComunicadoAlternativo\" \nng-model=\"vm.parametro.valor.valorComunicadoAlternativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label translate=\"RESOURCES.EXTRATO_DEBITOS\">\nExtrato de débitos</label><input ui-number-mask=\"4\" maxlength=\"16\" name=\"valorExtratoDebito\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorExtratoDebito\', vm.parametro.valor.valorExtratoDebito)\" \nid=\"cadastro-parametros-taboutros-txtValorExtratoDebito\" ng-model=\"vm.parametro.valor.valorExtratoDebito\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\">\n<label translate=\"RESOURCES.LEITURA_COM_HIDROMETRO\">Leitura com impressão e entrega de fatura</label><input \nui-number-mask=\"4\" maxlength=\"16\" name=\"valorLeituraComHidrometro\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorLeituraComHidrometro\', vm.parametro.valor.valorLeituraComHidrometro)\" \nid=\"cadastro-parametros-taboutros-txtvalorLeituraComHidrometro\" \nng-model=\"vm.parametro.valor.valorLeituraComHidrometro\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label \ntranslate=\"RESOURCES.LEITURA_SEM_HIDROMETRO\">Impressão e entrega de fatura</label><input ui-number-mask=\"4\" \nmaxlength=\"16\" name=\"valorLeituraSemHidrometro\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'valorLeituraSemHidrometro\', vm.parametro.valor.valorLeituraSemHidrometro)\" \nid=\"cadastro-parametros-taboutros-txtvalorLeituraLeituraSemHidrometro\" \nng-model=\"vm.parametro.valor.valorLeituraSemHidrometro\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"></md-input-container></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-mensagens/tab-mensagens.html","<md-content id=\"cadastro-parametros-tab-impressao-tab-mensagens\"><div class=\"form-container\"><div layout=\"column\" flex>\n<div layout=\"row\" flex=\"100\" class=\"mt-10 parametro-impressao\"><md-checkbox \nname=\"imprimirMensagemDebitoClientesDebitoAutomatico\" \nid=\"cadastro-parametros-tabImpressaoMensagem-chkImprimirMensagemDebitoClientesDebitoAutomatico\" \nng-model=\"vm.parametro.impressao.imprimirMensagemDebitoClientesDebitoAutomatico\" \naria-label=\"Imprimir mensagem de débitos para clientes com débito automático\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nImprimir mensagem de débitos para clientes com débito automático</span></md-checkbox></div><div layout-gt-sm=\"row\" \nflex><fieldset class=\"standard\" flex flex-gt-sm=\"50\"><div layout=\"row\" layout-xs=\"column\"><md-checkbox \nid=\"cadastro-parametros-tabimpressao-tabmensagens-chkUtilizaMensagemSaldoM3\" name=\"utilizaMensagemSaldoM3\" \naria-label=\"Cria serviço de arredondamento\" ng-change=\"vm.metodos.limpaMensagemSaldoM3()\" \nng-model=\"vm.parametro.impressao.utilizaMensagemSaldoM3\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                 !vm.controleForm.editarAtivo && \r\n                                                 !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_MENSAGEM_PARA_SALDO_M3\">Utilizar mensagem para saldo M3</span></md-checkbox></div>\n<div class=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.impressao.utilizaMensagemSaldoM3 == \'S\'\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label>\n<textarea id=\"cadastro-parametros-tabimpressao-tabmensagens-chkMensagemSaldoM3\" name=\"mensagemSaldoM3\" rows=\"2\" \nmascara-tamanho-campo=\"300\" max-rows=\"3\" ng-model=\"vm.parametro.impressao.mensagemSaldoM3\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoSaldoM3($event)\" \nng-required=\"vm.parametro.impressao.utilizaMensagemSaldoM3 == \'S\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                      !vm.controleForm.editarAtivo && \r\n                                                      !vm.controleForm.inserirAtivo\">\n\r\n                                </textarea></md-input-container></div></div></fieldset><br hide-gt-sm><fieldset \nclass=\"standard\" flex flex-gt-sm=\"50\"><md-checkbox \nid=\"cadastro-parametros-tabimpressao-tabmensagens-chkUtilizaMensagemSaldoLNR\" name=\"utilizaMensagemSaldoLNR\" \naria-label=\"Cria serviço de arredondamento\" ng-model=\"vm.parametro.impressao.utilizaMensagemSaldoLNR\" \nng-change=\"vm.metodos.limpaMensagemSaldoLNR($event)\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                             !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_MENSAGEM_PARA_SALDO_LNR\">Utilizar mensagem para saldo LNR</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.impressao.utilizaMensagemSaldoLNR == \'S\'\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label>\n<textarea id=\"cadastro-parametros-tabimpressao-tabmensagens-chkMensagemSaldoLNR\" name=\"mensagemSaldoLNR\" rows=\"2\" \nmascara-tamanho-campo=\"300\" max-rows=\"3\" ng-model=\"vm.parametro.impressao.mensagemSaldoLNR\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoSaldoLNR($event)\" \nng-required=\"vm.parametro.impressao.utilizaMensagemSaldoLNR == \'S\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                      !vm.controleForm.editarAtivo && \r\n                                                      !vm.controleForm.inserirAtivo\">\n\r\n                                  </textarea></md-input-container></div></div></fieldset></div><br><div layout=\"row\" \nflex=\"100\"><fieldset class=\"standard\" flex flex-gt-sm=\"100\"><md-checkbox \nid=\"cadastro-parametros-tabimpressao-tabmensagens-chkUtilizaMensagemFixa\" name=\"utilizaMensagemFixa\" \naria-label=\"Cria serviço de arredondamento\" ng-model=\"vm.parametro.impressao.utilizaMensagemFixa\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                             !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_MENSAGEM_FIXA_FATURA\">Utilizar mensagem fixa na fatura</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.impressao.utilizaMensagemFixa == \'S\'\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label>\n<textarea id=\"cadastro-parametros-tabimpressao-tabmensagens-chkMensagemFixa\" name=\"mensagemFixa\" rows=\"2\" \nmascara-tamanho-campo=\"9000\" max-rows=\"3\" ng-required=\"vm.parametro.impressao.utilizaMensagemFixa == \'S\'\" \nng-model=\"vm.parametro.impressao.mensagemFixa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                      !vm.controleForm.editarAtivo && \r\n                                                      !vm.controleForm.inserirAtivo\">\n\r\n                                                  </textarea></md-input-container></div></div></fieldset></div><br>\n<div layout=\"row\" flex><fieldset class=\"standard\" flex layout-gt-xs=\"column\"><md-input-container class=\"md-block\" flex>\n<md-checkbox id=\"cadastro-parametros-tabimpressao-tabmensagens-chkUtilizaFonteParametrizada\" \nname=\"utilizaFonteParametrizada\" aria-label=\"Cria serviço de arredondamento\" \nng-model=\"vm.parametro.impressao.utilizaFonteParametrizada\" \nng-change=\"vm.metodos.changeUtilizarFonteParametrizavel(vm.parametro.impressao.utilizaFonteParametrizada)\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                 !vm.controleForm.editarAtivo && \r\n                                                 !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_FONTE_PARAMETRIZAVEL\">Utilizar fonte parametrizável</span></md-checkbox>\n</md-input-container><div layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.parametro.impressao.utilizaFonteParametrizada == \'S\'\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.FONTE_MENSAGEM01\">Fonte da mensagem 01</label><md-select \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctFonteCampoMensagem01\" name=\"fonteCampoMensagem01\" \nng-model=\"vm.parametro.impressao.fonteCampoMensagem01\" \nng-required=\"vm.parametro.impressao.utilizaFonteParametrizada == \'S\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                   !vm.controleForm.editarAtivo && \r\n                                                   !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaComboFonteMensagens\">{{padraoNome.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.fonteCampoMensagem01.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"RESOURCES.FONTE_MENSAGEM02\">Fonte da mensagem 02</label><md-select \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctFonteCampoMensagem02\" name=\"fonteCampoMensagem02\" \nng-model=\"vm.parametro.impressao.fonteCampoMensagem02\" \nng-required=\"vm.parametro.impressao.utilizaFonteParametrizada == \'S\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                   !vm.controleForm.editarAtivo && \r\n                                                   !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaComboFonteMensagens\">{{padraoNome.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.fonteCampoMensagem02.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><br><div \nlayout=\"row\" flex><fieldset class=\"standard\" layout-gt-xs=\"column\" flex><md-input-container class=\"md-block\" \nlayout-align=\"start center\"><md-checkbox \nid=\"cadastro-parametros-tabimpressao-tabmensagens-chkUtilizaUtilizaRedefinicaoMensagem\" \nname=\"utilizaRedefinicaoMensagem\" aria-label=\"Utiliza redefinicão de mensagem\" \nng-model=\"vm.parametro.impressao.utilizaRedefinicaoMensagem\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                         !vm.controleForm.editarAtivo && \r\n                                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.ULTILIZA_REDEFINICAO_MENSAGEM\">Utilizar redefinição de mensagem</span></md-checkbox>\n</md-input-container><div flex=\"100\" ng-if=\"vm.parametro.impressao.utilizaRedefinicaoMensagem\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block mr-5\" flex><label \ntranslate=\"RESOURCES.QTD_CARACTERES_MSG_TIPO01\">Quantidade de caracteres para as mensagens do tipo 1</label><input \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctFonteCampoMensagem01\" name=\"qtdCaracteresMensagemTipo1\" \ntype=\"text\" mascara-tamanho-campo=\"3\" ui-number-mask=\"0\" ui-hide-group-sep \nng-change=\"vm.metodos.changeQtdCaracteresMensagem(1, vm.parametro.impressao.quantidadeCaracteresMensagemTipo01)\" \nng-model=\"vm.parametro.impressao.quantidadeCaracteresMensagemTipo01\" \nng-required=\"vm.parametro.impressao.utilizaRedefinicaoMensagem && \r\n                                                    vm.parametro.impressao.utilizaFonteParametrizada == \'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                       !vm.controleForm.editarAtivo && \r\n                                                       !vm.controleForm.inserirAtivo || \r\n                                                        vm.parametro.impressao.utilizaFonteParametrizada == \'S\'\">\n<md-icon class=\"cor-icone-padrao icone-informacao\" md-font-icon=\"icon-information-outline\"><md-tooltip \nmd-direction=\"top\">O campo refere-se à mensagem geral do tipo 01 e à mensagem específica do tipo 05.</md-tooltip>\n</md-icon><div ng-messages=\"vm.form.qtdCaracteresMensagemTipo1.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"valorMinimoCaracteres\"><span>\n{{ vm.mensagemMinimo }}</span></div><div ng-message=\"valorMaximoCaracteres\"><span>{{ vm.mensagemMaximo }}</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.QTD_CARACTERES_MSG_TIPO02\">Quantidade de caracteres para as mensagens do tipo 2</label><input \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctFonteCampoMensagem01\" name=\"qtdCaracteresMensagemTipo2\" \ntype=\"text\" mascara-tamanho-campo=\"3\" ui-number-mask=\"0\" ui-hide-group-sep \nng-change=\"vm.metodos.changeQtdCaracteresMensagem(2, vm.parametro.impressao.quantidadeCaracteresMensagemTipo02)\" \nng-model=\"vm.parametro.impressao.quantidadeCaracteresMensagemTipo02\" \nng-required=\"vm.parametro.impressao.utilizaRedefinicaoMensagem && \r\n                                                    vm.parametro.impressao.utilizaFonteParametrizada == \'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                       !vm.controleForm.editarAtivo && \r\n                                                       !vm.controleForm.inserirAtivo || \r\n                                                        vm.parametro.impressao.utilizaFonteParametrizada == \'S\'\">\n<md-icon class=\"cor-icone-padrao icone-informacao\" md-font-icon=\"icon-information-outline\"><md-tooltip \nmd-direction=\"top\">O campo refere-se à mensagem geral do tipo 02 e à mensagem específica do tipo 03.</md-tooltip>\n</md-icon><div ng-messages=\"vm.form.qtdCaracteresMensagemTipo2.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div ng-message=\"valorMinimoCaracteres\"><span>\n{{ vm.mensagemMinimo }}</span></div><div ng-message=\"valorMaximoCaracteres\"><span>{{ vm.mensagemMaximo }}</span></div>\n</div></md-input-container></div></div></fieldset></div><br><md-input-container class=\"md-block\" flex-gt-xs=\"100\" \nflex-xs><label translate=\"RESOURCES.MENSAGEM_ALTERNATIVA\">Mensagem alternativa</label><input \nid=\"cadastro-parametros-tabimpressao-tabmensagens-txtMensagemAlternativaFatura\" type=\"text\" mascara-tamanho-campo=\"80\" \nname=\"mensagemAlternativaFatura\" ng-model=\"vm.parametro.impressao.mensagemAlternativaFatura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                   !vm.controleForm.editarAtivo && \r\n                                   !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><label \ntranslate=\"RESOURCES.INFORMACAO_IMPRESSA_FATURA_DEBITO_SEPARADO\">\nInformação impressa na fatura quando envia débitos separados</label><md-select \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctTipoInformacaoImpressaComunicadoDebitosNaFatura\" \nname=\"tipoInformacaoImpressaComunicadoDebitosNaFatura\" \nng-model=\"vm.parametro.comunicado.tipoInformacaoImpressaComunicadoDebitosNaFatura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                       !vm.controleForm.editarAtivo && \r\n                                       !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" \nng-repeat=\"padraoNome in vm.listaMensagemImpressaFaturaQuandoEnviaDebitoSeparado\">{{padraoNome.descricao}}</md-option>\n</md-select></md-input-container><br><div layout=\"row\" flex=\"100\"><fieldset class=\"standard\" flex flex-gt-sm=\"100\">\n<md-checkbox id=\"cadastro-parametros-tabimpressao-tabmensagens-chkgeraMensagemFaturamentoReavisoAutomatica\" \nname=\"geraMensagemFaturamentoReavisoAutomatica\" aria-label=\"Cria serviço de arredondamento\" \nng-model=\"vm.parametro.impressao.geraMensagemFaturamentoReavisoAutomatica\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                             !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.GERAR_MENSAGEM_FATURAMENTO_AUTOMATICAMENTE\">\nGerar mensagem de faturamento/reaviso automaticamente</span></md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.impressao.geraMensagemFaturamentoReavisoAutomatica == \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"60\"><label \ntranslate=\"RESOURCES.SUBSTITUICAO_MENSAGENS_QUANDO_ENVIA_DEBITOS_SEPARADOS\">\nSubstituição de mensagens quando envia débitos separados</label><md-select \nid=\"cadastro-parametros-tabimpressao-tabmensagens-slctmensagemEnviarDebitoSeparado\" \nname=\"mensagemEnviarDebitoSeparado\" ng-model=\"vm.parametro.comunicado.mensagemEnviarDebitoSeparado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                       !vm.controleForm.editarAtivo && \r\n                                                       !vm.controleForm.inserirAtivo\">\n<md-option><em></em></md-option><md-option ng-value=\"padraoNome.id\" \nng-repeat=\"padraoNome in vm.listaGerarMensagemFaturamentoAutomaticamente\">{{padraoNome.descricao}}</md-option>\n</md-select></md-input-container></div></div></fieldset></div></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tab-comunicados.html","<md-content id=\"cadastro-parametros-tab-impressao-tab-comunicados\"><md-tabs class=\"tabcomunicados-tabs\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Consumo alterado\" \nmd-active=\"vm.tabSelecionada === \'consumoAlterado\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'consumoAlterado\')\">\n<md-tab-label><label translate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS_TAB_CONSUMOALTERADO\"></label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-impressao-tab-comunicados-tab-consumoalterado\"></md-content></md-tab-body>\n</md-tab><md-tab label=\"Débitos anteriores\" md-active=\"vm.tabSelecionada === \'debitosAnteriores\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'debitosAnteriores\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS_TAB_DEBITOSANTERIORES\"></label></md-tab-label><md-tab-body>\n<md-content ui-view=\"tab-impressao-tab-comunicados-tab-debitosanteriores\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Ocorrência\" md-active=\"vm.tabSelecionada === \'ocorrencia\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'ocorrencia\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS_TAB_OCORRENCIA\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-impressao-tab-comunicados-tab-ocorrencia\"></md-content></md-tab-body></md-tab><md-tab \nlabel=\"Quitação anual de débitos\" md-active=\"vm.tabSelecionada === \'quitacaoAnualDebitos\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'quitacaoAnualDebitos\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS_TAB_QUITACAOANUALDEBITOS\"></label></md-tab-label><md-tab-body>\n<md-content ui-view=\"tab-impressao-tab-comunicados-tab-quitacaoanualdebitos\"></md-content></md-tab-body></md-tab>\n<md-tab label=\"Alternativo\" md-active=\"vm.tabSelecionada === \'alternativo\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'alternativo\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_IMPRESSAO_TAB_COMUNICADOS_TAB_ALTERNATIVO\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-impressao-tab-comunicados-tab-alternativo\"></md-content></md-tab-body></md-tab><md-tab label=\"Serviços\" \nmd-active=\"vm.tabSelecionada === \'servicos\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'servicos\')\"><md-tab-label>\n<label translate=\"Serviços\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-impressao-tab-comunicados-tab-servicos\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-coletor/tabs/tab-configuracao/tab-configuracao.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\"><div layout=\"column\"><div\n layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"40\" flex-xs><label translate=\"RESOURCES.MENSAGEM\">\nMensagem</label><input type=\"text\" name=\"mensagemPrincipal\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtMensagem\" ng-model=\"vm.parametro.coletor.mensagemPrincipal\" \nmd-maxlength=\"20\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"20\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs><label \ntranslate=\"RESOURCES.SENHA_SAIDA\">Senha saída</label><input type=\"password\" name=\"senhaSaida\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtSenhaSaida\" ng-model=\"vm.parametro.coletor.senhaSaida\" \nmd-maxlength=\"10\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"10\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs><label \ntranslate=\"RESOURCES.SENHA_CONTROLE_ROTINAS\">Senha controle de rotinas</label><input type=\"password\" \nname=\"senhaControleRotinas\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtSenhaControleRotinas\" \nng-model=\"vm.parametro.coletor.senhaControleRotina\" md-maxlength=\"10\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"10\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs><label \ntranslate=\"RESOURCES.CONFIGURACAO\">Configuração</label><input type=\"text\" ui-number-mask=\"0\" ui-hide-group-sep \nname=\"tipoConfiguracao\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtTipoConfiguracao\" \nng-model=\"vm.parametro.coletor.tipoConfiguracao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"4\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs=\"40\" flex-xs><label translate=\"RESOURCES.TEMPO_INTERVALO_ALMOCO\"></label><input type=\"text\" \nname=\"intervaloMaximoEstatisticaLeitura\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-txtIntervaloMaximoEstatisticaLeitura\" \nng-model=\"vm.parametro.coletor.intervaloMaximoEstatisticaLeitura\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \npattern=\"^(([2]{1}[0-3]{1}){1}|([0-1]{1}[0-9]){1}){1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$\" \nmascara-numero-generica=\"##:##:##\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.intervaloMaximoEstatisticaLeitura.$error\"><div ng-message=\"pattern\" \ntranslate=\"RESOURCES.FORMATO_INVALIDO\"></div><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"20\" flex-xs><label translate=\"RESOURCES.SEGMENTO\">Segmento</label><md-select name=\"tipoSegmento\" \nid=\"cadastro-parametros-tabempresa-slctTipoSegmento\" ng-model=\"vm.parametro.empresa.tipoSegmento\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"segmento.id\" ng-repeat=\"segmento in vm.listaSegmento\">{{segmento.descricao}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs><label translate=\"RESOURCES.TELA\">\nTela</label><md-select name=\"tipoTela\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-slctTipoTela\" \nng-model=\"vm.parametro.coletor.tipoTela\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipo.id\" ng-repeat=\"tipo in vm.listaTipo\">{{tipo.descricao}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs><label translate=\"RESOURCES.CIDADE\">Cidade</label>\n<md-select name=\"tipoCidade\" id=\"cadastro-parametros-tabempresa-slctTipoCidade\" \nng-model=\"vm.parametro.empresa.tipoCidade\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoCidade.id\" ng-repeat=\"tipoCidade in vm.listaTipoCidade\">{{tipoCidade.descricao}}</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"40\" flex-xs><label \ntranslate=\"RESOURCES.CONFIGURACAO_LEITURA\">Configuração visualização tela leitura</label><md-select \nname=\"configuracaoVisualizacaoTelaLeitura\" \nid=\"cadastro-parametros-tabcoletor-tableitura-slctConfiguracaoVisualizacaoTelaLeitura\" \nng-model=\"vm.parametro.coletor.configuracaoVisualizacaoTelaLeitura\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaConfiguracaoVisualizacaoTelaLeitura\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"20\" flex-xs></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"20\" flex-xs></md-input-container></div><fieldset \nlayout=\"column\" flex=\"100\"><legend class=\"grp-legend\">Limite de fotos por leitura</legend><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"100\"><md-input-container flex-gt-sm flex=\"100\"><label \ntranslate=\"RESOURCES.LIMITE_MINIMO_FOTOS_POR_LEITURA\"></label><input type=\"text\" name=\"minimo\" ui-number-mask=\"0\" \nng-disabled=\"true\" ng-model=\"vm.parametro.coletor.minimoLimiteFotosPorLeitura\"></md-input-container><md-input-container\n flex-gt-sm flex=\"100\"><label translate=\"RESOURCES.LIMITE_MAXIMO_FOTOS_POR_LEITURA\"></label><input type=\"text\" \nname=\"maximo\" mascara-numero-generica=\"##\" ng-required=\"vm.controleForm.inserirAtivo || vm.controleForm.editarAtivo\" \npattern=\"^[1-4]?[1-8]$\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.parametro.coletor.limiteFotosPorLeitura\"><div ng-messages=\"vm.form.maximo.$error\"><div \nng-message=\"pattern\" translate=\"RESOURCES.FORMATO_INVALIDO\"></div></div></md-input-container></div></fieldset><br><div \nflex-gt-sm=\"100\" layout=\"row\"><fieldset class=\"standard\" flex-gt-sm=\"50\" flex-gt-offset=\"5\"><md-checkbox \nname=\"gerarLogFluxoRotinas\" ng-model=\"vm.parametro.coletor.gerarLogFluxoRotinas\" \naria-label=\"Gerar log de fluxo das rotinas\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nGerar log de fluxo das rotinas</span></md-checkbox></fieldset></div><br><div flex-gt-sm=\"100\" layout=\"row\"><fieldset \nclass=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaAlertaDiasConsumoLimite\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaAlertaDiasConsumoLimite\" \nng-model=\"vm.parametro.coletor.utilizaAlertaDiasConsumoLimite\" aria-label=\"Emitir alerta dias de consumo\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.EMITIR_ALERTA_DIAS_CONSUMO\"></span></md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.coletor.utilizaAlertaDiasConsumoLimite == \'S\'\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"100\"><label translate=\"RESOURCES.NUMERO_DIAS_CONSUMO_LIMITE\"></label><input ui-hide-group-sep \nmascara-tamanho-campo=\"5\" ng-required=\"vm.parametro.coletor.utilizaAlertaDiasConsumoLimite == \'S\'\" \nname=\"numeroDiasConsumoLimiteAlerta\" id=\"cadastro-parametros-tabcoletor-tableitura-txtNumeroDiasConsumoLimiteAlerta\" \nng-model=\"vm.parametro.coletor.numeroDiasConsumoLimiteAlerta\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.numeroDiasConsumoLimiteAlerta.$error\"><div ng-message=\"min\" \ntranslate=\"RESOURCES.NUMERO_DIAS_CONSUMO_LIMITE\"></div><div ng-message=\"max\" \ntranslate=\"PARAMETROS.NUMERO_DIAS_CONSUMO_LIMITE\"></div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\" flex-gt-sm=\"50\" flex-gt-offset=\"5\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 89\"><md-checkbox \nname=\"utilizaLimiteMaximoTentativasLeitura\" ng-model=\"vm.utilizaLimiteMaximoTentativasLeitura\" \naria-label=\"Utilizar limite máximo de tentativas de leitura\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.metodos.validarNumeroMaximoTentativas()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"\">Utilizar limite máximo de tentativas de leitura</span></md-checkbox><div class=\"group-checkbox\" \nflex=\"100\" ng-if=\"vm.utilizaLimiteMaximoTentativasLeitura\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label\n translate=\"\">Número máximo de tentativas de leitura</label><input ui-hide-group-sep type=\"text\" mascara-numeros=\"2\" \nmin-value=\"1\" ng-required=\"true\" name=\"limiteMaximoTentativasLeitura\" \nng-model=\"vm.parametro.coletor.limiteMaximoTentativasLeitura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-auditoria/tab-auditoria.html","<md-content id=\"cadastro-parametros-tab-modoImplantacao-tab-auditoria\"><md-tabs class=\"tabcomunicados-tabs\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Outros\" md-active=\"vm.tabSelecionada === \'outros\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'outros\')\"><md-tab-label><label \ntranslate=\"RESOURCES.TAB_MODO_IMPLANTACAO_TAB_AUDITORIA_TAB_OUTROS\"></label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-auditoria-tab-outros\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-coletor/tabs/tab-leitura/tab-leitura.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-leitura\"><div class=\"form-container\"><div layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"utilizaRecursoConsumoMedio\" id=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaRecursoConsumoMedio\" \nng-model=\"vm.parametro.coletor.utilizaRecursoConsumoMedio\" aria-label=\"Ultiliza recursos de consumo médio\" \nng-change=\"vm.parametro.coletor.mostraConsumoMedio = vm.parametro.coletor.utilizaRecursoConsumoMedio\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_RECURSOS_DE_CONSUMO_MEDIO\">Utilizar recursos de consumo médio</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox name=\"mostraConsumoMedio\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkMostraConsumoMedio\" \nng-model=\"vm.parametro.coletor.mostraConsumoMedio\" aria-label=\"Mostra consumo médio na tela de leitura\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.MOSTRAR_CONSUMO_MEDIO_NA_TELA_DE_LEITURA\">Mostrar consumo médio na tela de leitura</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"25\"><md-checkbox \nname=\"utilizaVariasOcorrencias\" id=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaVariasOcorrencias\" \nng-model=\"vm.parametro.coletor.utilizaVariasOcorrencias\" aria-label=\"Ultiliza várias ocorrências\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_VARIAS_OCORRENCIAS\">Utilizar várias ocorrências</span></md-checkbox></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"permiteCancelamentoLeitura\" id=\"cadastro-parametros-tabcoletor-tableitura-chkPermiteCancelamentoLeitura\" \nng-model=\"vm.parametro.coletor.permiteCancelamentoLeitura\" aria-label=\"Ultiliza cancelamento de leitura\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CANCELAMENTO_DE_LEITURA\">Utilizar cancelamento de leitura</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox \nname=\"utilizaSenhaCancelamentoLeitura\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaSenhaCancelamentoLeitura\" \nng-model=\"vm.parametro.coletor.utilizaSenhaCancelamentoLeitura\" \naria-label=\"Ultiliza senha para cancelamento de leitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_SENHA_PARA_CANCELAMENTO_DE_LEITURA\">Utilizar senha para cancelamento de leitura</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"utilizaMotivoNaoEntrega\" id=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaMotivoNaoEntrega\" \nng-model=\"vm.parametro.coletor.utilizaMotivoNaoEntrega\" aria-label=\"Ultiliza motivo de não entrega\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_MOTIVO_DE_NAO_ENTREGA\">Utilizar motivo de não entrega</span></md-checkbox>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex \nflex-gt-sm=\"30\"><md-checkbox name=\"utilizaTipoEntrega\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaTipoEntrega\" \nng-model=\"vm.parametro.coletor.utilizaTipoEntrega\" aria-label=\"Ultiliza tipo de entrega\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_TIPO_DE_ENTREGA\">Utilizar tipo de entrega</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox name=\"utilizaConsistenciaCategoria\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaConsistenciaCategoria\" \nng-model=\"vm.parametro.coletor.utilizaConsistenciaCategoria\" aria-label=\"Ultiliza consistência de categorias\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CONSISTENCIAS_DE_CATEGORIAS\">Utilizar consistência de categorias</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"utilizaRotinaEliminaLeitura\" id=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaRotinaEliminaLeitura\" \nng-model=\"vm.parametro.coletor.utilizaRotinaEliminaLeitura\" aria-label=\"Ultiliza rotina de eliminar leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_ROTINA_DE_ELIMINAR_LEITURAS\">Utilizar rotina de eliminar leituras</span></md-checkbox>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex \nflex-gt-sm=\"30\"><md-checkbox name=\"destacaSituacaoExcecaoClienteTelaLeitura\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkDestacaSituacaoExcecaoClienteTelaLeitura\" \nng-model=\"vm.parametro.coletor.destacaSituacaoExcecaoClienteTelaLeitura\" \naria-label=\"Destaca situação de exceção de cliente na tela de leitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.DESTACAR_SITUACAO_DE_EXCECAO_DE_CLIENTE_NA_TELA_DE_LEITURA\">\nDestacar situação de exceção de cliente na tela de leitura</span></md-checkbox></md-input-container><md-input-container\n class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox name=\"utilizaInformacaoFonteAlternativaTelaLeitura\" \nid=\"cadastro-parametros-tabcoletor-tableitura-chkUtilizaInformacaoFonteAlternativaTelaLeitura\" \nng-model=\"vm.parametro.coletor.utilizaInformacaoFonteAlternativaTelaLeitura\" \naria-label=\"Ultiliza informação de fonte alternativa\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_INFORMACAO_DE_FONTE_ALTERNATIVA\">Utilizar informação de fonte alternativa</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"18\"><md-checkbox \nname=\"permiteEnvioFotosSomenteViaWifi\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkPermiteEnviarFotoSomenteViaWifi\" \nng-model=\"vm.parametro.coletor.permiteEnvioFotosSomenteViaWifi\" aria-label=\"Permite envio de fotos somente via Wi-fi\" \nng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.PERMITIR_ENVIO_FOTOS_SOMENTE_VIA_WIFI\">Permitir envio de fotos somente via Wi-fi</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex flex-gt-sm=\"30\"><md-checkbox name=\"utilizaRotinaFotosObservacaoLeitura\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkUtilizaRotinaFotosObservacaoLeitura\" \nng-model=\"vm.parametro.coletor.utilizaRotinaFotosObservacaoLeitura\" \naria-label=\"Ultiliza rotina de foto para observação de leitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.calculo.tipoDetalheCalculo != vm.tipoDetalheCalculo.bauru\">\n<span translate=\"RESOURCES.UTILIZAR_ROTINA_DE_FOTO_PARA_OBSERVACAO_DE_LEITURA\">\nUtiliza rotina de foto para observação de leitura</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox name=\"utilizaMesAnoReferenciaNomeFoto\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkUtilizaMesAnoReferenciaNomeFoto\" \nng-model=\"vm.parametro.coletor.utilizaMesAnoReferenciaNomeFoto\" aria-label=\"Obriga GPS Ativo\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_MES_ANO_REFERENCIA_NOME_FOTO\">Utilizar mês/ano de referência no nome da foto</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"obrigaGPSAtivo\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkobrigaGpsAtivo\" \nng-model=\"vm.parametro.coletor.obrigaGPSAtivo\" aria-label=\"Obriga GPS Ativo\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.OBRIGAR_GPS_ATIVO\">Obriga GPS ativo</span></md-checkbox></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"utilizaTrocaLeiturista\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkUtilizaTrocaLeiturista\" \nng-model=\"vm.parametro.coletor.utilizaTrocaLeiturista\" aria-label=\"Ultiliza troca de leituristas\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_TROCA_DE_LEITURISTAS\">Utilizar troca de leituristas</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox \nname=\"utilizaRotinaRepasse\" id=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkUtilizaRotinaRepasse\" \nng-if=\"vm.parametro.calculo.tipoDetalheCalculo != 89 && vm.parametro.calculo.tipoDetalheCalculo != 88\" \nng-model=\"vm.parametro.coletor.utilizaRotinaRepasse\" aria-label=\"Ultiliza rotina de repasse\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_ROTINA_DE_REPASSE\">Utilizar rotina de repasse</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox name=\"enviaFotosEmTempoReal\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkEnviaFotosEmTempoReal\" \nng-model=\"vm.parametro.coletor.enviaFotosEmTempoReal\" aria-label=\"Envia fotos em tempo real\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.ENVIA_FOTOS_TEMPO_REAL\">Enviar fotos em tempo real</span></md-checkbox></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><md-checkbox \nname=\"bloquearFinalizacaoCargaFaturaRetida\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkbloquearFinalizacaoCargaFaturaRetida\" \nng-model=\"vm.parametro.coletor.bloquearFinalizacaoCargaFaturaRetida\" \naria-label=\"Bloquear finalização de carga com faturas retidas\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.BLOQUEAR_FINALIZACAO_CARGA_FATURAS_RETIDAS\">Bloquear finalização de carga com faturas retidas\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"35\"><md-checkbox \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkUtilizarControleTentativasLeitura\" \nname=\"UtilizarControleTentativasLeitura\" aria-label=\"Utilizar controle de tentativas de leitura\" \nng-model=\"vm.parametro.coletor.utilizarBloqueioTentativasLeitura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CONTROLE_TENTATIVAS_LEITURA\">Utilizar controle de tentativas de leituras</span><md-icon \nclass=\"cor-icone-padrao ml-8\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nAo tentar salvar a leitura e, por algum motivo, o processo não for concluído, não será permitido alterar a leitura/ocorrência informada\n</md-tooltip></md-icon></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\">\n<md-checkbox name=\"obrigarOcorrenciaSituacaoExcecao\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkobrigarOcorrenciaSituacaoExcecao\" \nng-model=\"vm.parametro.coletor.obrigarOcorrenciaSituacaoExcecao\" \naria-label=\"Obrigar ocorrência quando situação exceção\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.OBRIGAR_OCORRENCIA_SITUACAO_EXCECAO\">Obrigar ocorrência quando situação exceção</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex flex-gt-sm=\"30\"><md-checkbox name=\"enviarOnlineApenasFaturasCalculadas\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-ehkEnviarOnlineApenasFaturasCalculadas\" \nng-model=\"vm.parametro.coletor.enviarOnlineApenasFaturasCalculadas\" \naria-label=\"Enviar online apenas faturas calculadas\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nEnviar online apenas faturas calculadas</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" \nflex flex-gt-sm=\"30\"><md-checkbox name=\"abrirTecladoAutomaticamenteLeitura\" \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-ehkAbrirTecladoAutomaticamenteLeitura\" \nng-model=\"vm.parametro.coletor.abrirTecladoAutomaticamenteLeitura\" \naria-label=\"Enviar online apenas faturas calculadas\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nAbrir teclado automaticamente na leitura</span></md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><fieldset class=\"standard\" flex-gt-sm=\"50\" flex><legend class=\"grp-legend\" \ntranslate=\"RESOURCES.LEITURA_CONSUMO_FRACIONADO\">Leitura e consumo fracionado</legend><div layout=\"column\" ng-form \nname=\"leituraFracionadaForm\"><md-input-container><label translate=\"RESOURCES.SEGMENTO\">Segmento</label><md-select \nname=\"leituraFracionadaSegmento\" ng-model=\"vm.parametro.coletor.leituraConsumoFracionadoSegmento\" \nng-change=\"vm.metodos.verificarValoresCasasDecimais(vm.parametro.coletor.leituraConsumoFracionadoSegmento)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"opcaoLeitura.id\" ng-repeat=\"opcaoLeitura in vm.listaOpcoesLeituraFracionada\">{{ opcaoLeitura.descricao }}\n</md-option></md-select></md-input-container><fieldset><legend class=\"grp-legend\" \ntranslate=\"RESOURCES.NUMERO_CASAS_DECIMAIS\">Número de casas decimais</legend><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex><label translate=\"RESOURCES.AGUA\">Água</label><md-select \ntype=\"text\" name=\"leituraConsumoFracionadoAgua\" \nng-model=\"vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisAgua\" \nng-required=\"vm.parametro.coletor.leituraConsumoFracionadoSegmento === \'01\' \r\n                                                || vm.parametro.coletor.leituraConsumoFracionadoSegmento === \'03\' \" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) || \r\n                                            (vm.parametro.coletor.leituraConsumoFracionadoSegmento !== \'01\' && vm.parametro.coletor.leituraConsumoFracionadoSegmento !== \'03\')\">\n<md-option ng-value=\"quantidade\" ng-repeat=\"quantidade in vm.quantidadeCasasDecimais\">{{ quantidade }}</md-option>\n</md-select><div ng-messages=\"leituraFracionadaForm.leituraConsumoFracionadoAgua.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container flex><label \ntranslate=\"RESOURCES.GAS\">Gás</label><md-select type=\"text\" name=\"leituraConsumoFracionadoGas\" \nng-model=\"vm.parametro.coletor.leituraConsumoFracionadoCasasDecimaisGas\" \nng-required=\"vm.parametro.coletor.leituraConsumoFracionadoSegmento === \'02\' \r\n                                                || vm.parametro.coletor.leituraConsumoFracionadoSegmento === \'03\'\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\r\n                                            || (vm.parametro.coletor.leituraConsumoFracionadoSegmento !== \'02\' && vm.parametro.coletor.leituraConsumoFracionadoSegmento !== \'03\')\">\n<md-option ng-value=\"quantidade\" ng-repeat=\"quantidade in vm.quantidadeCasasDecimais\">{{ quantidade }}</md-option>\n</md-select><div ng-messages=\"leituraFracionadaForm.leituraConsumoFracionadoGas.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></fieldset>\n</div></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-configuracao/tab-configuracao.html","<md-content id=\"tab-modoimplantacao-tab-configuracao\"><div class=\"form-container\"><div layout-gt-sm=\"row\"><div \nlayout=\"column\" flex><md-input-container class=\"md-block\" flex flex-gt-sm=\"20\"><label>Sistema gestor</label><md-select \nname=\"sistemaGestor\" id=\"cadastro-parametros-tabcoletor-tableitura-slctSistemaGestor\" \nng-model=\"vm.parametro.coletor.sistemaGestor\" \nng-change=\"vm.metodos.onChangeSistemaGestor(vm.parametro.coletor.sistemaGestor)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"sistema.codigo\" ng-repeat=\"sistema in vm.listaSistemasGestor\">{{sistema.descricao}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex><md-input-container class=\"md-block\" flex flex-gt-sm=\"30\"><label \ntranslate=\"RESOURCES.TIPO_PROCESSO\">Tipo de processo</label><md-select name=\"tipoProcesso\" \nid=\"cadastro-parametros-tabcalculo-slcttipoProcesso\" ng-model=\"vm.parametro.tipoProcesso\" \nng-change=\"vm.metodos.onChangeTipoProcesso(vm.parametro.tipoProcesso)\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.parametro.coletor.sistemaGestor == 3 || vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-option ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaTipoProcesso\">{{padraoNome.descricao}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" flex flex-gt-sm=\"20\"><md-input-container class=\"md-block\" \nflex flex-gt-sm=\"10\"><label translate=\"RESOURCES.CODIGO_IMANAGER\">Cod. IManager</label><input type=\"text\" \nname=\"codigoImanager\" id=\"cadastro-parametros-tabempresa-txtCodigoIManager\" \nng-model=\"vm.parametro.empresa.codigoImanager\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"####\"></md-input-container></div><md-input-container class=\"md-block\" flex><label>\nLimite máximo de dígitos na leitura</label><md-select ng-model=\"vm.parametro.coletor.limiteMaximoDigitosLeitura\" \nid=\"cadastro-parametros-tabmodoimplantacao-limiteMaximoDigitosLeitura\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"limiteMaximoDigitoLeitura.valor\" ng-repeat=\"limiteMaximoDigitoLeitura in vm.limiteMaximoDigitosLeitura\">\n{{limiteMaximoDigitoLeitura.descricao}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" \nlayout=\"column\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.TIPO_ACAO_CONSUMO_CREDITO_REMANESCENTE\">Ação do crédito remanescente</label><md-select \nname=\"tipoAcaoConsumoMinimoCreditoRemanescente\" \nid=\"cadastro-parametros-tabmodoimplantacao-slcttipoAcaoConsumoMinimoCreditoRemanescente\" \nng-model=\"vm.parametro.calculo.tipoAcaoConsumoMinimoCreditoRemanescente\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaTipoAcaoConsumoMinimoCreditoRemanescente\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex flex>\n<label translate=\"RESOURCES.QUANDO_CONSUMO_MEDIDO_MENOR_MINIMO\">Quando consumo medido for menor que o mínimo</label>\n<md-select ng-model=\"vm.parametro.coletor.imprimeConsumoMedidoCampoFaturadoQuandoMenorMinimo\" \nid=\"cadastro-parametros-tabmodoimplantacao-slctImprimeConsumoMedidoCampoFaturadoQuandoMenorMinimo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaImprimeConsumoCampoFaturadoMenorMinimo\">\n{{padraoNome.descricao}}</md-option></md-select></md-input-container><div layout=\"column\" flex flex><md-input-container\n class=\"md-block\" flex><label translate=\"RESOURCES.RELEASE_MINIMA_MOBILE\">Release mínima Mobile</label><input \ntype=\"text\" name=\"releaseMinimaMobile\" id=\"cadastro-parametros-tabempresa-txtReleaseMinimaMobile\" \nng-model=\"vm.parametro.coletor.releaseMinimaMobile\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" mascara-release mascara-tamanho-campo=\"4\">\n<div ng-messages=\"vm.form.releaseMinimaMobile.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-xs=\"column\"><div layout=\"column\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"RESOURCES.LIMITE_MAXIMO_TENTATIVAS_LEITURA\">Limite máximo de tentativas de leitura</label><input \nui-number-mask=\"0\" ui-hide-group-sep \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'coletor\',\'limiteMaximoTentativasLeitura\', vm.parametro.coletor.limiteMaximoTentativasLeitura)\" \nmascara-tamanho-campo=\"1\" name=\"limiteMaximoTentativasLeitura\" \nid=\"cadastro-parametros-tabcontroller-txtLimiteMaximoTentativasLeitura\" \nng-model=\"vm.parametro.coletor.limiteMaximoTentativasLeitura\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div><md-input-container class=\"md-block\" flex flex-xs><label>\nNúmero de leituras para realizar backup</label><input type=\"text\" ui-number-mask=\"0\" ui-hide-group-sep \nname=\"numeroLeiturasRealizarBackup\" id=\"cadastro-parametros-numeroLeiturasRealizarBackup\" \nng-model=\"vm.parametro.coletor.numeroLeiturasRealizarBackup\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'coletor\',\'numeroLeiturasRealizarBackup\', vm.parametro.coletor.numeroLeiturasRealizarBackup, 1)\" \nmascara-tamanho-campo=\"2\"><div ng-messages=\"vm.form.numeroLeiturasRealizarBackup.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.parametro.coletor.sistemaGestor == 2\"><div layout=\"column\" layout-xs=\"column\" \nflex-gt-sm=\"100\"><div layout=\"row\" layout-xs=\"column\"><fieldset class=\"standard\" flex-gt-sm=\"40\"><legend \nclass=\"grp-legend\">Fiorilli</legend><md-checkbox name=\"imprimirContaDescontoTotal\" \nid=\"cadastro-parametros-tabmodoimplantacao-tabconfiguracao-chkImprimirContaDescontoTotal\" \nng-model=\"vm.parametro.impressao.imprimirContaDescontoTotal\" aria-label=\"Utilizar cadastro de regionais\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nImprimir fatura com valor total zero<md-icon class=\"cor-icone-padrao\" md-font-icon=\"icon-information-outline\" \nstyle=\"margin-bottom: 5px\"><md-tooltip md-autohide md-direction=\"right\"><span class=\"md-caption\">\nDefine valores do campo 07 do registro A01.</span></md-tooltip></md-icon></span></md-checkbox><md-checkbox \nname=\"utilizarReimportacaoMesmaReferencia\" \nid=\"cadastro-parametros-tabmodoimplantacao-chkUtilizarReimportacaoMesmaReferencia\" \nng-model=\"vm.parametro.utilizarReimportacaoMesmaReferencia\" \naria-label=\"Utilizar reimportação de carga utilizando a mesma referência\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-if=\"vm.parametro.tipoProcesso === \'02\'\"><span>Utilizar reimportação de carga com a mesma referência<md-icon \nclass=\"cor-icone-padrao\" md-font-icon=\"icon-information-outline\" style=\"margin-bottom: 5px\"><md-tooltip md-autohide \nmd-direction=\"right\"><span class=\"md-caption\">\nPermite realizar a importação de uma mesma referência, com isso o sistema irá importar apenas dados ainda não importados.\n</span></md-tooltip></md-icon></span></md-checkbox><md-checkbox name=\"utilizarImportacaoGrupoLeituraFilaFiorilli\" \nid=\"cadastro-parametros-tabmodoimplantacao-tabconfiguracao-chkUtilizarImportacaoGrupoLeituraFilaFiorilli\" \nng-model=\"vm.parametro.utilizarImportacaoGrupoLeituraFilaFiorilli\" \naria-label=\"Utilizar importação de grupo de leitura por fila\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nUtilizar importação de grupo de leitura por fila<md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-information-outline\" style=\"margin-bottom: 5px\"><md-tooltip md-autohide md-direction=\"right\"><span>\nEsta opção permite a importação de dados por meio de filas, o que reduz a carga de processamento na API Fiorilli.\n</span></md-tooltip><md-tooltip md-autohide md-direction=\"right\" style=\"margin-top: 23px\"><span>\nÉ recomendada quando a importação não pode ser realizada devido ao limite de memória da API, ajudando a evitar problemas de estouro de memória.\n</span></md-tooltip></md-icon></span></md-checkbox><md-checkbox name=\"utilizaExportacaoPorLeiturista\" \nng-if=\"vm.parametro.tipoProcesso === \'02\'\" \nid=\"cadastro-parametros-tabmodoimplantacao-chkUtilizaExportacaoPorLeiturista\" \nng-model=\"vm.parametro.utilizaExportacaoPorLeiturista\" aria-label=\"Utilizar importação de grupo de leitura por fila\" \nng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nUtiliza exportação por leiturista<md-icon class=\"cor-icone-padrao\" md-font-icon=\"icon-information-outline\" \nstyle=\"margin-bottom: 5px\"><md-tooltip md-autohide md-direction=\"right\"><span>\nQuando desmarcado, o sistema enviará o retorno à Fiorilli utilizando o nome do primeiro leiturista cadastrado e ativo.\n</span></md-tooltip><md-tooltip md-autohide md-direction=\"right\" style=\"margin-top: 23px\"><span>\nQuando marcado, o envio das leituras será feito conforme o leiturista responsável pela execução da leitura.</span>\n</md-tooltip></md-icon></span></md-checkbox><fieldset class=\"standard\" flex-gt-sm=\"100\"><div layout=\"column\" flex>\n<label class=\"md-caption\"><span style=\"font-size: 1.5rem\" \nng-class=\"{\'readonly\': vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo}\">\nCódigos de cobrança para aplicação de isenção</span><md-icon class=\"cor-icone-padrao\" \nmd-font-icon=\"icon-information-outline\" style=\"margin-bottom: 5px\"><md-tooltip md-autohide md-direction=\"right\"><span \nclass=\"md-caption\">\nInforme os códigos de cobrança, um por vez, pressionando Enter para confirmar cada item. São aceitos apenas valores numéricos.\n</span></md-tooltip></md-icon></label><md-chips class=\"chips-codigos-cobranca-aplicacao-isencao\" \nid=\"cadastro-parametros-tabmodoimplantacao-tabconfiguracao-chipsCodigosCobrancaAplicacaoIsencao\" \nname=\"codigosCobrancaAplicacaoIsencao\" ng-model=\"vm.codigosCobrancaAplicacaoIsencaoChips\" \nmd-transform-chip=\"vm.metodos.transformarChipCodigoCobrancaAplicacaoIsencao($chip)\" md-add-on-blur=\"true\" \nmd-separator-keys=\"[13]\" placeholder=\"Digite o código e pressione Enter\" \nreadonly=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n<md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></div></fieldset></fieldset></div></div></div>\n<div layout=\"row\" layout-xs=\"column\"><div layout=\"column\" layout-xs=\"column\" flex-gt-sm=\"100\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container flex class=\"md-block\" flex-gt-sm=\"35\"><md-checkbox \nname=\"utilizaGradeQuatroDigitos\" id=\"cadastro-parametros-taboutros-chkutilizaGradeQuatroDigitos\" \nng-model=\"vm.parametro.utilizaGradeQuatroDigitos\" aria-label=\"Utiliza grade com quatro dígitos\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZA_GRADE_QUATRO_DIGITOS\">Utiliza grade com quatro dígitos</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"65\" \nng-if=\"vm.parametro.tipoProcesso == \'02\' && vm.parametro.calculo.tipoDetalheCalculo != 88\"><md-checkbox \nname=\"utilizaDisponibilizacaoTarefasMultiplosGrupos\" \nid=\"cadastro-parametros-tabempresa-chkUtilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-model=\"vm.parametro.utilizaDisponibilizacaoTarefasMultiplosGrupos\" \naria-label=\"Utiliza Disponibilização de Tarefas de Múltiplos Grupos\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZA_DISPONIBILIZACAO_TAREFAS_MULTIPLOS_GRUPOS\">\nUtilizar disponibilização de tarefas de múltiplos grupos</span></md-checkbox></md-input-container><md-input-container \nflex class=\"md-block\" flex-gt-sm=\"65\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 88\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaRotinaGeracaoArquivoTempoReal\" name=\"utilizaRotinaGeracaoArquivoTempoReal\" \naria-label=\"utilizaRotinaGeracaoArquivoTempoReal\" ng-model=\"vm.parametro.utilizaRotinaGeracaoArquivoTempoReal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZA_ROTINA_GERACAO_ARQUIVO_TEMPO_REAL\">Utilizar rotina de geração de arquivo em tempo real\n</span></md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex \nclass=\"md-block\" flex-gt-sm=\"35\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 89\"><md-checkbox \nname=\"utilizaCancelamentoDinamico\" id=\"cadastro-parametros-taboutros-chkutilizaUtilizaCancelamentoDinamico\" \nng-model=\"vm.parametro.utilizaCancelamentoDinamico\" aria-label=\"Utiliza cancelamento dinâmico\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZA_CANCELAMENTO_DINAMICO\">Utilizar cancelamento dinâmico</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"65\" \nng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 89\"><md-checkbox name=\"utilizaExportacaoSomenteTarefasFinalizadas\" \nid=\"cadastro-parametros-tabempresa-chkUtilizaDisponibilizacaoTarefasMultiplosGrupos\" \nng-model=\"vm.parametro.utilizaExportacaoSomenteTarefasFinalizadas\" \naria-label=\"Utiliza exportação somente de tarefas finalizadas no coletor\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZA_EXPORTACAO_SOMENTE_TAREFAS_FINALIZADAS\">\nUtilizar exportação somente de tarefas finalizadas no coletor</span></md-checkbox></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><fieldset class=\"standard\" flex-gt-sm=\"40\"><md-checkbox name=\"utilizaCadastroRegional\" \nid=\"cadastro-parametros-tabmodoimplantacao-tabconfiguracao-chkUtilizaCadastroRegional\" \nng-model=\"vm.parametro.utilizaCadastroRegional\" aria-label=\"Utilizar cadastro de regionais\" ng-true-value=\"true\" \nng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CADASTRO_REGIONAL\"></span></md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.utilizaCadastroRegional\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><md-checkbox \nname=\"utilizaImportacaoLeituraViaFtp\" \nid=\"cadastro-parametros-tabmodoimplantacao-tabconfiguracao-chkUtilizaImportacaoLeituraViaFtp\" \nng-model=\"vm.parametro.utilizaImportacaoLeituraViaFtp\" aria-label=\"Utilizar importação de leitura via FTP\" \nng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_IMPORTACAO_VIA_FTP\"></span></md-checkbox></md-input-container></div></fieldset></div>\n</div></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-controle-importacao/tab-controle-importacao.html","<md-content id=\"tab-modoimplantacao-tab-controle-importacao\"><div class=\"form-container\"><fieldset layout=\"column\" \nflex=\"100\"><div layout=\"column\"><div class=\"ml-8\" flex=\"40\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nid=\"cadastro-parametros-tabmodoimplantacao-chkUtilizarControleImportacao\" class=\"mb-5\" \nname=\"utilizarControleImportacao\" aria-label=\"Utilizar controle de importação\" \nng-model=\"vm.parametro.utilizarControleImportacao\" \nng-change=\"vm.metodos.changeUtilizarControleImportacao(vm.parametro.utilizarControleImportacao)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                             !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span ng-if=\"vm.parametro.tipoProcesso == 01\" translate=\"RESOURCES.UTILIZAR_CONTROLE_DISPONIBILIZACAO_CARGA\"></span> \n<span ng-if=\"vm.parametro.tipoProcesso != 01\" translate=\"RESOURCES.UTILIZAR_CONTROLE_IMPORTACAO\"></span></md-checkbox>\n<md-icon class=\"cor-icone-padrao m-8\" md-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\" \nng-if=\"vm.parametro.tipoProcesso == 01\">\nDefine quais registros devem ter o envio obrigatório na disponibilização da carga</md-tooltip><md-tooltip \nmd-direction=\"top\" ng-if=\"vm.parametro.tipoProcesso != 01\">\nDefine quais registros devem ter o envio obrigatório para conclusão da importação</md-tooltip></md-icon></div><div \nclass=\"container-tabela\" layout=\"column\" ng-if=\"vm.parametro.utilizarControleImportacao\"><md-input-container \nclass=\"md-block\"><md-checkbox id=\"cadastro-parametros-tabmodoimplantacao-chkSelecionarTodosRegistros\" \nname=\"selecionarTodosRegistros\" aria-label=\"Selecionar todos os registros\" ng-if=\"vm.controleForm.editarAtivo\" \nng-model=\"vm.selecionarTodosRegistros\" \nng-change=\"vm.metodos.changeSelecionarTodosRegistros(vm.selecionarTodosRegistros)\"><span \nng-if=\"!vm.selecionarTodosRegistros\" translate=\"RESOURCES.MARCAR_TODOS_REGISTROS\"></span> <span \nng-if=\"vm.selecionarTodosRegistros\" translate=\"RESOURCES.DESMARCAR_TODOS_REGISTROS\"></span></md-checkbox>\n</md-input-container><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" style=\"width:100px\"><div class=\"table-header\"><span class=\"column-title text-center\">Registro\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-left\">Descrição\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Bloquear\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.parametro.controleImportacao\"><td class=\"text-center\">\n<span>{{item.registro}}</span></td><td class=\"text-left\"><span>{{item.descricao}}</span></td><td class=\"text-center\">\n<md-checkbox aria-label=\"Bloquear importacao\" ng-model=\"item.bloquearImportacao\" \nng-change=\"vm.metodos.changeSelecionarRegistro()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                                 !vm.controleForm.editarAtivo && \r\n                                                 !vm.controleForm.inserirAtivo\" \nstyle=\"margin: 0px\"></md-checkbox></td></tr></tbody></table></div></div></fieldset></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-critica/tab-critica.html","<md-content id=\"tab-parametros-critica\"><div layout=\"column\"><div layout-gt-sm=\"row\" flex><md-input-container flex \nflex-gt-sm=\"30\"><md-checkbox name=\"utilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa\" \nid=\"cadastro-parametros-taboutros-chkUtilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa\" \nng-model=\"vm.parametro.impressao.utilizaRotinaCriticaLeituras\" aria-label=\"Utilizar rotina de crítica de leituras\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_ROTINA_CRITICA\">Utilizar rotina de crítica de leituras</span></md-checkbox>\n</md-input-container></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-danfag/tab-danfag.html","<div class=\"form-container\" id=\"tab-NFAg\"><div layout-gt-xs=\"row\" flex layout-align=\"start center\"><md-input-container \nclass=\"md-block\" style=\"margin-right: 10px; margin-bottom: 30px\"><md-checkbox name=\"emiteNotaFiscal\" \nid=\"tabNFAg-chkEmiteNotaFiscal\" ng-model=\"vm.parametro.impressao.emiteNotaFiscal\" aria-label=\"Emite nota fiscal\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" ng-disabled=\"true\"><span>Emite nota fiscal</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex><label>Site Sefaz</label><input \ntype=\"text\" name=\"linkSefaz\" ng-model=\"vm.parametro.impressao.linkSefaz\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                               !vm.controleForm.inserirAtivo\" \nmd-maxlength=\"500\" mascara-tamanho-campo=\"500\"><md-icon class=\"icon-open-in-new icone-abrir-nova-aba\" \nng-if=\"vm.parametro.impressao.linkSefaz\" ng-click=\"vm.metodos.abrirSolucao(vm.parametro.impressao.linkSefaz)\">\n<md-tooltip md-autohide><span>Abrir {{vm.parametro.impressao.linkSefaz}} em nova aba</span></md-tooltip></md-icon>\n</md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 21px\"><md-checkbox \nname=\"utilizarVinculoPrevioNotaCliente\" id=\"tabNFAg-chkUtilizarVinculoPrevioNotaCliente\" \nng-model=\"vm.parametro.impressao.utilizarVinculoPrevioNotaCliente\" \naria-label=\"Utiliza vinculo prévio de nota fiscal ao cliente\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n              !vm.controleForm.inserirAtivo) || \r\n             vm.parametro.tipoProcesso == \'02\'\">\n<span>Utiliza vinculo prévio de nota fiscal ao cliente</span></md-checkbox></md-input-container></div><div \nlayout-gt-xs=\"row\" flex layout-align=\"start start\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex><label>\nUrl api - Finalização carga</label><input type=\"text\" name=\"urlApiFinalizacaoCarga\" \nng-model=\"vm.parametro.impressao.urlApiFinalizacaoCarga\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                         !vm.controleForm.editarAtivo && \r\n                         !vm.controleForm.inserirAtivo\" \nmd-maxlength=\"300\" mascara-tamanho-campo=\"300\" ng-required=\"vm.parametro.impressao.emiteNotaFiscal === \'S\'\"><md-icon \nng-click=\"vm.metodos.copiarUrlApiFinalizacaoCarga()\" \nng-if=\"!vm.acaoCopiar && vm.parametro.impressao.urlApiFinalizacaoCarga\" style=\"color: #039be5\" \nmd-svg-src=\"assets/custom/copy.svg\"><md-tooltip md-autohide><span>Copiar Url api - Finalização carga</span>\n</md-tooltip></md-icon><md-icon ng-if=\"vm.acaoCopiar\" style=\"color: #039be5\" md-font-icon=\"icon-check-circle s26\">\n<md-tooltip md-autohide><span>Url api - Finalização carga copiada com sucesso!</span></md-tooltip></md-icon><div \nng-messages=\"vm.form.urlApiFinalizacaoCarga.$error\"><div ng-message=\"required\">Campo obrigatório</div></div>\n</md-input-container></div><div layout=\"row\"><fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\">\nRetenções Federais</legend><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>PIS</label>\n<input id=\"cadastro-parametros-tabDanfag-txtCodigoPIS\" name=\"codigoPIS\" ng-model=\"vm.parametro.impressao.codigoPIS\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>COFINS</label><input id=\"cadastro-parametros-tabDanfag-txtCodigoCOFINS\" \nname=\"codigoCOFINS\" ng-model=\"vm.parametro.impressao.codigoCOFINS\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>IRPJ</label><input id=\"cadastro-parametros-tabDanfag-txtCodigoIRPJ\" \nname=\"codigoIRPJ\" ng-model=\"vm.parametro.impressao.codigoIRPJ\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>CSLL</label><input id=\"cadastro-parametros-tabDanfag-txtCodigoCSLL\" \nname=\"codigoCSLL\" ng-model=\"vm.parametro.impressao.codigoCSLL\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>TFS</label><input id=\"cadastro-parametros-tabDanfag-txtCodigoTFS\" \nname=\"codigoTFS\" ng-model=\"vm.parametro.impressao.codigoTFS\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>TFU</label><input id=\"cadastro-parametros-tabDanfag-txtCodigoTFU\" \nname=\"codigoTFU\" ng-model=\"vm.parametro.impressao.codigoTFU\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numero-generica=\"#####\" md-maxlength=\"5\" mascara-tamanho-campo=\"5\"></md-input-container></div></fieldset></div>\n</div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-dados-config/tab-dados-config.html","<md-content id=\"tab-modoimplantacao-tab-dados-config\"><div class=\"form-container\" layout=\"column\" flex=\"100\"><div \nlayout-gt-sm=\"row\" flex><fieldset class=\"standard\" flex-gt-lg=\"60\" flex=\"100\"><legend class=\"grp-legend\">Dados config\n</legend><div layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex><label>Mac do concentrador</label>\n<input id=\"cadastro-parametros-modoimplantacao-tab-dados-config-macConcentrador\" name=\"macConcentrador\" maxlength=\"12\" \nng-model=\"vm.parametro.coletor.macConcentrador\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.macConcentrador.$error\"></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Modo suporte</label><md-select id=\"cadastro-parametros-modoimplantacao-tab-dados-config-modoSuporte\" \nname=\"modoSuporte\" ng-model=\"vm.parametro.coletor.modoSuporte\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"modo.valor\" ng-repeat=\"modo in vm.modoSuporte\">{{modo.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.modoSuporte.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Rotina chat</label><md-select \nid=\"cadastro-parametros-modoimplantacao-tab-dados-config-rotinaChat\" name=\"rotinaChat\" \nng-model=\"vm.parametro.coletor.rotinaChat\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"rotina.valor\" ng-repeat=\"rotina in vm.rotinaChat\">{{rotina.descricao}}</md-option></md-select><div \nng-messages=\"vm.form.rotinaChat.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de importação</label><md-select \nid=\"cadastro-parametros-modoimplantacao-tab-dados-config-tipoImportacao\" name=\"tipoImportacao\" \nng-model=\"vm.parametro.coletor.tipoImportacao\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoImportacao.valor\" ng-repeat=\"tipoImportacao in vm.tipoImportacao\">{{tipoImportacao.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.tipoImportacao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Chave leiturista</label><input id=\"cadastro-parametros-modoimplantacao-tab-dados-config-chaveLeiturista\" \nname=\"chaveLeiturista\" maxlength=\"5\" ng-model=\"vm.parametro.coletor.chaveLeiturista\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.chaveLeiturista.$error\"></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Matrícula leiturista</label><input \nid=\"cadastro-parametros-modoimplantacao-tab-dados-config-matriculaLeiturista\" name=\"matriculaLeiturista\" maxlength=\"5\" \nng-model=\"vm.parametro.coletor.matriculaLeiturista\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.matriculaLeiturista.$error\"></div></md-input-container></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-especifico/tab-especifico.html","<md-content id=\"cadastro-parametros-tab-modoImplantacao-tab-especifico\"><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Jardinópolis\" ng-if=\"vm.parametro.calculo.tipoDetalheCalculo == 93\" \nmd-active=\"vm.tabSelecionada === \'jardinopolis\'\" md-on-select=\"vm.metodosTab.tabSelecionada(\'jardinopolis\')\">\n<md-tab-label><label>Jardinópolis</label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-especifico-tab-jardinopolis\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-ilha-solteira.html","<md-content id=\"cadastro-parametros-tab-modoImplantacao-tab-ilhasolteira\"><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Poupa água\" md-active=\"vm.tabSelecionada === \'poupa-agua\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'poupa-agua\')\"><md-tab-label><label>Poupa água</label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-ilhaSolteira-tab-poupaAgua\"></md-content></md-tab-body>\n</md-tab><md-tab label=\"Ligação cota\" md-active=\"vm.tabSelecionada === \'ligacao-cota\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'ligacao-cota\')\"><md-tab-label><label>Ligação cota</label></md-tab-label>\n<md-tab-body><md-content ui-view=\"tab-modoimplantacao-tab-ilhaSolteira-tab-ligacaoCota\"></md-content></md-tab-body>\n</md-tab><md-tab label=\"Lançamento de ocorrência\" md-active=\"vm.tabSelecionada === \'lancamento-ocorrencia\'\" \nmd-on-select=\"vm.metodosTab.tabSelecionada(\'lancamento-ocorrencia\')\"><md-tab-label><label>Lançamento de ocorrência\n</label></md-tab-label><md-tab-body><md-content \nui-view=\"tab-modoimplantacao-tab-ilhaSolteira-tab-lancamentoOcorrencia\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-outros/tab-outros.html","<md-content id=\"tab-modoimplantacao-tab-outros\"><div class=\"form-container\" layout=\"column\" flex=\"100\"><div \nlayout-gt-sm=\"row\" flex><fieldset class=\"standard\" flex=\"50\"><legend class=\"grp-legend\">Ligação mestre</legend><div \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex flex-gt-sm=\"50\"><label>\nConsumo dos dependentes a utilizar</label><md-select name=\"tipoProcesso\" id=\"cadastro-parametros-tabOutros\" \nng-model=\"vm.parametro.calculo.tipoConsumoSomatorioDependentesCalculoConsumoLigacaoMestre\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"tipoConsumo.id\" ng-repeat=\"tipoConsumo in vm.tiposConsumo\">{{tipoConsumo.descricao}}</md-option></md-select>\n<md-icon class=\"cor-icone-padrao\" md-font-icon=\"icon-information-outline\"><md-tooltip md-autohide md-direction=\"top\">\n<span class=\"md-caption\">\nEste é o consumo que será considerado no somatório do consumo dos dependentes para calcular o consumo da ligação mestre.\n</span></md-tooltip></md-icon></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-tabOutros-chkConsiderarDependentesExcecaoSemConsumoSomatorioCalculoMestre\" \nname=\"considerarDependentesExcecaoSemConsumoSomatorioCalculoMestre\" \naria-label=\"Considerar dependentes em situação de exceção sem cobrança de consumo no somatório\" \nng-model=\"vm.parametro.calculo.considerarDependentesExcecaoSemConsumoSomatorioCalculoMestre\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                         && !vm.controleForm.inserirAtivo) || vm.parametro.calculo.tipoDetalheCalculo != 6\">\n<span>Considerar dependentes em situação de exceção sem cobrança de consumo no somatório</span></md-checkbox>\n</md-input-container></div></fieldset><fieldset class=\"standard\" flex=\"50\"><legend class=\"grp-legend\">\nCobrança nos dependentes (rateio)</legend><div layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block check-cobrar-tarifa-minima\" flex><md-checkbox \nid=\"cadastro-parametros-tabOutros-chkRealizaCobrancaAguaEsgotoConsumoZerado\" \nname=\"realizaCobrancaAguaEsgotoConsumoZerado\" \naria-label=\"Cobrar tarifa mínima quando consumo da ligação mestre for zerado\" \nng-model=\"vm.parametro.calculo.realizaCobrancaAguaEsgotoConsumoZerado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo \r\n                                                 && !vm.controleForm.inserirAtivo\">\n<span>Cobrar tarifa mínima quando consumo da ligação mestre for zerado</span></md-checkbox></md-input-container></div>\n</fieldset></div><div layout-gt-sm=\"column\" flex><fieldset class=\"standard\" flex=\"100\"><legend class=\"grp-legend\">\nBobinas por rota <i class=\"icon-information-outline s20 icone-cor-padrao\"><md-tooltip class=\"tooltip-multiline-textos\">\nTamanho da bobina / Tamanho da fatura = Total de fatura por bobina</md-tooltip></i></legend><div layout=\"row\" \nflex=\"100\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label>Tamanho total da bobina (cm)</label><input \nid=\"cadastro-parametros-modoimplantacao-tabOutros-tamanhoBobina\" name=\"tamanhoBobina\" ui-number-mask maxlength=\"9\" \nng-model=\"vm.parametro.impressao.tamanhoBobina\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeQuantidadeFaturaBobina(vm.form.tamanhoBobina,vm.form.tamanhoFatura, vm.form, vm.controleForm)\">\n<div ng-messages=\"vm.form.tamanhoBobina.$error\"><div ng-message=\"valorMaiorZero\"><span>\nPara realizar o cálculo o valor deve ser maior que zero</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"100\"><label>Tamanho da fatura (cm)</label><input \nid=\"cadastro-parametros-modoimplantacao-tabOutros-tamanhoFatura\" name=\"tamanhoFatura\" ui-number-mask maxlength=\"6\" \nng-model=\"vm.parametro.impressao.tamanhoFatura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-change=\"vm.metodos.onChangeQuantidadeFaturaBobina(vm.form.tamanhoBobina,vm.form.tamanhoFatura, vm.form, vm.controleForm)\">\n<div ng-messages=\"vm.form.tamanhoFatura.$error\"><div ng-message=\"valorMaiorZero\"><span>\nPara realizar o cálculo o valor deve ser maior que zero</span></div><div ng-message=\"valorMenorBonina\"><span>\nPara realizar o cálculo o tamanho da fatura deve ser menor que o tamanho total da bobina</span></div></div>\n</md-input-container><md-input-container class=\"md-block mr-12\" flex-gt-sm=\"100\"><label>\nTotal de faturas por bobina (un)</label><input \nid=\"cadastro-parametros-modoimplantacao-tabOutros-quantidadeFaturaBobina\" name=\"quantidadeFaturaBobina\" \nng-model=\"vm.parametro.impressao.quantidadeFaturaBobina\" ng-disabled=\"true\"></md-input-container></div></fieldset><div \nflex-gt-sm=\"100\" layout=\"row\" class=\"mt-10\"><fieldset class=\"standard\" flex-gt-sm=\"100\"><md-input-container>\n<md-checkbox id=\"cadastro-parametros-modoimplantacao-tabOutros-chkExibirRelatorioModoGlobal\" \nname=\"exibirRelatorioModoGlobal\" aria-label=\"Exibir relatório no modo global\" \nng-model=\"vm.parametro.exibirRelatorioModoGlobal\" ng-change=\"vm.metodos.onChangeexibirRelatorioModoGlobal()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nExibir relatório no modo global</span></md-checkbox></md-input-container><div class=\"group-checkbox\" flex=\"50\" \nng-if=\"vm.parametro.exibirRelatorioModoGlobal\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label>\nValor mensal do contrato</label><input type=\"text\" name=\"valorMensalContrato\" ui-money-mask \nng-model=\"vm.parametro.valorMensalContrato\" ng-required=\"vm.parametro.exibirRelatorioModoGlobal\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.valorMensalContrato.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div></div></div>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-processamento/tab-processamento.html","<md-content id=\"tab-modoimplantacao-tab-processamento\"><div class=\"form-container\"><div layout-gt-sm=\"column\" flex><div\n layout=\"row\" layout-align=\"start center\" flex><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa\" \nname=\"utilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa\" aria-label=\"Utiliza exportação múltipla de arquivos\" \nng-model=\"vm.parametro.utilizaExportacaoLeiturasNaoEfetuadasQuandoMesmaTarefa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_EXPORTACAO_LEITURAS_NAO_EFETUADAS_SEM_REDISTRIBUICAO\">\nUtilizar exportação de leituras não efetuadas sem redistribuição</span></md-checkbox></md-input-container>\n<md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkBloqueiaNovaExportacaoImportacaoGrupoMesmoNomeArquivo\" \nname=\"bloqueiaNovaExportacaoImportacaoGrupoMesmoNomeArquivo\" \naria-label=\"Bloqueia nova exportação\\importação com mesmo nome de arquivo\" \nng-model=\"vm.parametro.bloqueiaNovaExportacaoImportacaoGrupoMesmoNomeArquivo\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.BLOQUEAR_EXPORTACAO_IMPORTACAO_COM_MESMO_NOME\">\nBloquear nova exportação\\importação com mesmo nome de arquivo</span></md-checkbox></md-input-container>\n<md-input-container flex class=\"md-block\"><md-checkbox name=\"utilizaRedistribuicaoLeiturasExportadaColetor\" \nid=\"cadastro-parametros-taboutros-chkUtilizaRedistribuicaoLeiturasExportadaColetor\" \naria-label=\"Utiliza redistribuição leituras exportadas para o coletor\" \nng-model=\"vm.parametro.utilizaRedistribuicaoLeiturasExportadaColetor\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_REDISTRIBUICAO_LEITURAS_EXPORTADAS_PARA_COLETOR\">\nUtilizar redistribuição leituras exportadas para o coletor</span></md-checkbox></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\" flex><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaAtualizacaoOcorrencia\" name=\"utilizaAtualizacaoOcorrencia\" \naria-label=\"Utiliza atualização de ocorrências\" ng-model=\"vm.parametro.utilizaAtualizacaoOcorrencia\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo) || vm.parametro.coletor.sistemaGestor == 3\">\n<span translate=\"RESOURCES.UTILIZAR_ATUALIZACAO_DE_OCORRENCIAS\">Utilizar atualização de ocorrências</span>\n</md-checkbox></md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaExportacaoMultiplosArquivos\" name=\"utilizaExportacaoMultiplosArquivos\" \naria-label=\"Utiliza exportação múltipla de arquivos\" ng-model=\"vm.parametro.utilizaExportacaoMultiplosArquivos\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" ng-disabled=\"true\"><span \ntranslate=\"RESOURCES.UTILIZAR_EXPORTACAO_MULTIPLA_ARQUIVOS\">Utilizar exportação múltipla de arquivos</span>\n</md-checkbox></md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkretornaConsumoRealQuandoNaoCalculaFatura\" \nname=\"retornaConsumoRealQuandoNaoCalculaFatura\" aria-label=\"Retorna consumo real quando não calcula fatura\" \nng-model=\"vm.parametro.calculo.retornaConsumoRealQuandoNaoCalculaFatura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.RETORNAR_CONSUMO_REAL_QUANDO_NAO_CALCULA_FATURA\">\nRetornar consumo real quando não calcula fatura</span></md-checkbox></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" flex><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaGrupoCalculo\" name=\"utilizaGrupoCalculo\" \naria-label=\"Utiliza grupo de cálculo\" ng-model=\"vm.parametro.utilizaGrupoCalculo\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_GRUPO_PARA_CALCULO\">Utilizar grupo de cálculo</span></md-checkbox>\n</md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaCreditoConsumo\" name=\"utilizaCreditoConsumo\" \naria-label=\"Utiliza crédito de consumo\" ng-model=\"vm.parametro.calculo.utilizaCreditoConsumo\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_CREDITO_CONSUMO\">Utilizar crédito de consumo</span></md-checkbox>\n</md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaEntidadeCalculoValorCategoria\" name=\"utilizaEntidadeCalculoValorCategoria\" \naria-label=\"Utiliza entidade cálculo valor por categoria\" \nng-model=\"vm.parametro.calculo.utilizaEntidadeCalculoValorCategoria\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_ENTIDADE_CALCULO_VALOR_POR_CATEGORIA\">Utilizar entidade cálculo valor por categoria\n</span></md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex><md-input-container \nclass=\"md-block\" flex><md-checkbox id=\"cadastro-parametros-taboutros-chkGeraCodigoBarrasSemImpressaoFatura\" \nname=\"geraCodigoBarrasSemImpressaoFatura\" aria-label=\"Gera código de barras sem impressão de fatura\" \nng-model=\"vm.parametro.impressao.geraCodigoBarrasSemImpressaoFatura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.GERAR_CODIGO_BARRAS_SEM_IMPRESSAO_FATURA\">Gerar código de barras sem impressão de fatura\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaLancamentoOcorrenciaRota\" name=\"utilizaLancamentoOcorrenciaRota\" \naria-label=\"Utiliza lançamento de ocorrência por rota\" ng-model=\"vm.parametro.coletor.utilizaLancamentoOcorrenciaRota\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_LANCAMENTO_OCORRENCIA_POR_ROTA\">Utilizar lançamento de ocorrência por rota</span>\n</md-checkbox></md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaConsistenciaLeituraNegativa\" name=\"utilizaConsistenciaLeituraNegativa\" \naria-label=\"Utiliza consistência de leitura negativa\" \nng-model=\"vm.parametro.calculo.utilizaConsistenciaLeituraNegativa\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_CONSISTENCIA_DE_LEITURA_NEGATIVA\">Utilizar consistência de leitura negativa</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex><md-input-container flex \nclass=\"md-block\"><md-checkbox id=\"cadastro-parametros-taboutros-chkExportarRepasseRealizar\" \nname=\"exportarRepasseRealizar\" aria-label=\"Exporta repasses a realizar\" \nng-model=\"vm.parametro.exportarRepasseRealizar\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.EXPORTAR_REPASSE_A_REALIZAR\">Exportar repasses a realizar</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-tabcoletor-tabconfiguracao-chkExibeInformacaoLeitura\" name=\"exibeInformacaoLeitura\" \naria-label=\"Exportar hidrômetro alterado\" ng-model=\"vm.parametro.coletor.exibeInformacaoLeitura\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.EXIBIR_INFORMACAO_DE_LEITURA_NA_PLANILHA\">Exibir informações de leitura na planilha</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaPesquisaRapidaTelaLeitura\" name=\"utilizaPesquisaRapidaTelaLeitura\" \naria-label=\"Utiliza consulta rápida na tela de leitura\" \nng-model=\"vm.parametro.coletor.utilizaPesquisaRapidaTelaLeitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_CONSULTA_RAPIDA_TELA_LEITURA\">Utilizar consulta rápida na tela de leitura</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex><md-input-container \nclass=\"md-block\" flex><md-checkbox id=\"cadastro-parametros-taboutros-chkUtilizaReenvioLeiturasFinalizacaoCarga\" \nname=\"utilizaReenvioLeiturasFinalizacaoCarga\" \naria-label=\"Utiliza reenvio de todas as leituras na finalização da carga\" \nng-model=\"vm.parametro.coletor.utilizaReenvioLeiturasFinalizacaoCarga\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZA_REENVIO_LEITURAS_FINALIZACAO_CARGA\">Reenviar todas as leituras ao finalizar carga\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkUtilizaExibicaoSituacaoLeitura\" \nname=\"utilizaExibicaoSituacaoConsumidorTelaLeitura\" \naria-label=\"Utilizar exibição de situação do consumidor na tela de leitura\" \nng-model=\"vm.parametro.coletor.utilizaExibicaoSituacaoLeitura\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZA_SITUACAO_CONSUMIDOR_TELA_LEITURA\">\nUtilizar exibição de situação do consumidor na tela de leitura</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-tabempresa-chkProcessaIdentificadorFimArquivo\" name=\"processaIdentificadorFimArquivo\" \naria-label=\"Utiliza identificador de fim de arquivo\" ng-model=\"vm.parametro.processaIdentificadorFimArquivo\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.UTILIZAR_PROCESSA_IDENTIFICADOR_FIM_ARQUIVO\">Utilizar identificador de fim de arquivo</span>\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex><md-input-container \nclass=\"md-block\" flex><md-checkbox id=\"cadastro-parametros-taboutros-chkConsistirCodigoBarrasDisponibilizacaoCarga\" \nname=\"consistirCodigoBarrasDisponibilizacaoCarga\" aria-label=\"Consistir código de barras na disponibilização de carga\" \nng-model=\"vm.parametro.consistirCodigoBarrasDisponibilizacaoCarga\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                          !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.CONSISTIR_CODIGO_BARRAS_DISPONIBILIZACAO_CARGA\">\nConsistir código de barras na disponibilização de carga</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox id=\"cadastro-parametros-taboutros-chkUtilizarExportacaoParcialGrupoLeitura\" \nname=\"utilizarExportacaoParcialGrupoLeitura\" aria-label=\"Utilizar exportação parcial do grupo de leitura\" \nng-model=\"vm.parametro.utilizarExportacaoParcialGrupoLeitura\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva\r\n                                               && !vm.controleForm.editarAtivo\r\n                                               && !vm.controleForm.inserirAtivo)\r\n                                               || vm.parametro.tipoProcesso != \'02\'\r\n                                               || (vm.parametro.calculo.tipoDetalheCalculo == 89\r\n                                               || vm.parametro.calculo.tipoDetalheCalculo == 88)\">\n<span translate=\"RESOURCES.UTILIZAR_EXPORTACAO_PARCIAL_GRUPO_LEITURA\">Utilizar exportação parcial do grupo de leitura\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkGerarArqRetornoSomenteCargaFinalizada\" \nname=\"gerarArqRetornoSomenteCargaFinalizada\" aria-label=\"Gerar arquivo de retorno somente com carga finalizada\" \nng-model=\"vm.parametro.gerarArquivoRetornoSomenteCargaFinalizada\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.GERAR_ARQUIVO_RETORNO_SOMENTE_CARGA_FINALIZADA\">\nGerar arquivo de retorno somente com carga finalizada</span></md-checkbox></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" flex><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-tabempresa-chkUtilizarGerenciamentoFaturasRetidasVinculadas\" \nname=\"utilizarGerenciamentoFaturasRetidasVinculadas\" aria-label=\"Utilizar gerenciamento de faturas retidas vinculadas\" \nng-model=\"vm.parametro.utilizarGerenciamentoFaturasRetidasVinculadas\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span>Utilizar gerenciamento de faturas retidas vinculadas</span></md-checkbox></md-input-container><md-input-container\n class=\"md-block\" flex class=\"check-exportar\"><md-checkbox \nid=\"cadastro-parametros-tabempresa-chkExportarAlertaCliente\" name=\"exportarAlertaCliente\" \naria-label=\"Exportar alerta cliente\" ng-model=\"vm.parametro.exportarAlertaCliente\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n                                 !vm.controleForm.inserirAtivo\">\n<span>Exportar alerta cliente</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex>\n<md-checkbox id=\"cadastro-parametros-taboutros-chkUtilizarRedistribuicaoConsumidoresNaoVisitados\" \nname=\"utilizarRedistribuicaoConsumidoresNaoVisitados\" aria-label=\"Utilizar redistribuição de clientes não visitados\" \nng-model=\"vm.parametro.utilizarRedistribuicaoConsumidoresNaoVisitados\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo) \r\n                                               || vm.parametro.tipoProcesso == \'01\'\r\n                                               || vm.parametro.calculo.tipoDetalheCalculo == 89\r\n                                               || vm.parametro.calculo.tipoDetalheCalculo == 88\">\n<span>Utilizar redistribuição de clientes não visitados</span></md-checkbox></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\" flex><md-input-container class=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-tabempresa-utilizarLeituraPreCadastrada\" name=\"utilizarLeituraPreCadastrada\" \naria-label=\"Utilizar rotina de leitura pré-cadastrada\" ng-model=\"vm.parametro.coletor.utilizarLeituraPreCadastrada\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && \r\n            !vm.controleForm.inserirAtivo\">\n<span>Utilizar rotina de leitura pré-cadastrada</span></md-checkbox></md-input-container><div flex \nstyle=\"margin-left: 15px !important\"></div><div flex style=\"margin-left: 15px !important\"></div></div><div \nlayout=\"row\" layout-align=\"start center\" flex><fieldset class=\"standard\" style=\"min-width:99%\"><legend \nclass=\"grp-legend\">Finalização de carga</legend><div layout=\"column\" layout-align=\"start start\" \nclass=\"container-fildset\"><div layout=\"row\" layout-align=\"start center\" style=\"width: 100%\"><md-input-container \nclass=\"md-block\" flex><md-checkbox id=\"cadastro-parametros-taboutros-chkBloquearFinalizacaoCargaFaturaNaoImpressa\" \nname=\"bloquearFinalizacaoCargaFaturaNaoImpressa\" aria-label=\"Bloquear finalização de carga com fatura não impressa\" \nng-model=\"vm.parametro.coletor.bloquearImportacaoFaturaNaoImpressa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.BLOQUEAR_FINALIZACAO_CARGA_FATURA_NAO_IMPRESSA\">\nBloquear finalização de carga com fatura não impressa</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox \nid=\"cadastro-parametros-taboutros-chkBloquearFinalizacaoCargaFaturaNaoImpressaMestreDependente\" \nname=\"bloquearFinalizacaoCargaFaturaNaoImpressaMestreDependente\" \naria-label=\"Bloquear finalização de carga com fatura não impressa para mestre e dependente\" \nng-model=\"vm.parametro.coletor.bloquearFinalizacaoCargaFaturaNaoImpressaMestreDependente\" ng-true-value=\"\'S\'\" \nng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                             !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.BLOQUEAR_FINALIZACAO_CARGA_FATURA_NAO_IMPRESSA_MESTRE_DEPENDENTE\">\nBloquear finalização de carga com fatura não impressa para mestre e dependente</span></md-checkbox>\n</md-input-container><div flex style=\"margin-left: -13px !important\"></div></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"width: 100%\"><md-input-container flex class=\"md-block\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkBloquearImportacaoNaoVisitadosRepasseRepassar\" \nname=\"bloquearImportacaoNaoVisitadosRepasseRepassar\" \naria-label=\"Bloqueia importação se existir consumidores não visitados ou repasse\" \nng-model=\"vm.parametro.bloquearImportacaoNaoVisitadosRepasseRepassar\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-change=\"vm.metodos.onChangeBloquearImportacaoNaoVisitadosRepasseRepassar(vm.parametro.bloquearImportacaoNaoVisitadosRepasseRepassar)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo &&\r\n                                                         !vm.controleForm.inserirAtivo\">\n<span translate=\"RESOURCES.BLOQUEAR_IMPORTACAO_SE_EXISTIR_CONSUMIDORES_NAO_VISITADOS_OU_REPASSE\">\nBloquear importação se existir consumidores não visitados ou repasse</span></md-checkbox></md-input-container>\n<md-input-container flex class=\"md-block\" ng-if=\"vm.parametro.bloquearImportacaoNaoVisitadosRepasseRepassar == \'S\'\">\n<md-checkbox id=\"cadastro-parametros-taboutros-utilizarSenhaImplantacaoFinalizarCargaClientesNaoVisitados\" \nname=\"utilizarSenhaImplantacaoFinalizarCargaClientesNaoVisitados\" \naria-label=\"Utilizar senha de implantação para finalizar carga com clientes não visitados\" \nng-model=\"vm.parametro.utilizarSenhaImplantacaoFinalizarCargaClientesNaoVisitados\" \nng-disabled=\"(vm.controleForm.pesquisaAtiva &&\r\n                                                                  !vm.controleForm.editarAtivo &&\r\n                                                                  !vm.controleForm.inserirAtivo)\">\n<span>Utilizar senha de implantação para finalizar carga com clientes não visitados</span></md-checkbox>\n</md-input-container><div flex style=\"margin-left: -13px !important\"></div></div></div></fieldset></div></div></div>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-marca-especial/tab-marca-especial.html","<md-content id=\"tab-modoimplantacao-tab-marca-especial\"><div class=\"form-container\"><fieldset layout=\"column\" \nflex=\"100\"><div layout=\"column\"><div class=\"ml-8\" flex=\"40\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nid=\"cadastro-parametros-tabmodoimplantacao-chkutilizarMarcaEspecial\" class=\"mb-5\" name=\"utilizarMarcaEspecial\" \naria-label=\"Utilizar marca especial\" ng-model=\"vm.parametro.utilizarMarcaEspecial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                             !vm.controleForm.editarAtivo && \r\n                                             !vm.controleForm.inserirAtivo\">\n<span>Utilizar marca especial</span></md-checkbox><md-icon class=\"cor-icone-padrao m-8\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"top\">\nA imagem da logo utilizada na marca especial, será a imagem cadastrada na aba de personalização.</md-tooltip></md-icon>\n</div><div class=\"container-tabela\" layout=\"column\" ng-if=\"vm.parametro.utilizarMarcaEspecial\" flex=\"25\" \nstyle=\"width: 35%\"><md-input-container class=\"md-block\" flex><label>Nome da solução a ser exibido</label><input \nid=\"cadastro-parametros-modoimplantacao-tab-marca-especial-nomeSolucaoMarcaEspecial\" name=\"nomeSolucaoMarcaEspecial\" \nmaxlength=\"30\" md-maxlength=\"30\" ng-model=\"vm.parametro.nomeSolucaoMarcaEspecial\" \nng-required=\"vm.parametro.utilizarMarcaEspecial && (vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo)\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.nomeSolucaoMarcaEspecial.$error\"></div></md-input-container></div></div></fieldset></div>\n</md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-retencao-dados/tab-retencao-dados.html","<md-content id=\"tab-modoimplantacao-tab-retencao-dados\"><div class=\"form-container\" layout=\"column\" flex=\"100\"><div \nflex-gt-sm=\"100\" layout=\"row\" class=\"mt-10\"><fieldset class=\"standard\" flex-gt-sm=\"100\" layout=\"row\">\n<md-input-container><md-checkbox id=\"cadastro-parametros-modoimplantacao-tabRetencaoDados-chkUtilizaRentencaoDados\" \nname=\"utilizaRentencaoDados\" aria-label=\"Utilizar retenção de exclusão de dados\" \nng-model=\"vm.parametro.parametroJobRetencao.utilizaRentencaoDados\" \nng-change=\"vm.metodos.onChangeUtilizaRentencaoDados()\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span>\nUtilizar retenção de exclusão de dados</span><md-icon class=\"cor-icone-padrao\" md-font-icon=\"icon-information-outline\" \nstyle=\"margin-bottom: 2px\"><md-tooltip md-autohide md-direction=\"right\"><span class=\"md-caption\">\nQuando ativo, o sistema realiza a limpeza do banco de dados, preservando apenas os meses configurados. A execução ocorre automaticamente conforme o intervalo definido.\n</span></md-tooltip></md-icon></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" \nng-show=\"vm.parametro.parametroJobRetencao.utilizaRentencaoDados\"><label>Manter dados dos últimos</label><md-select \nname=\"mesesRetencao\" ng-required=\"vm.parametro.parametroJobRetencao.utilizaRentencaoDados\" \nng-model=\"vm.parametro.parametroJobRetencao.mesesRetencao\" \nng-disabled=\"!vm.parametro.parametroJobRetencao.utilizaRentencaoDados || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"intervalo.codigo\" ng-repeat=\"intervalo in vm.opcoesRetencaoDados\">{{intervalo.descricao}}\n</md-option></md-select><div ng-messages=\"vm.form.mesesRetencao.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\" ng-show=\"vm.parametro.parametroJobRetencao.utilizaRentencaoDados\"><label>Intervalo de execução</label>\n<md-select name=\"diasIntervaloExecucao\" \nng-required=\"vm.parametro.parametroJobRetencao.utilizaRentencaoDados && vm.parametro.parametroJobRetencao.mesesRetencao != null\" \nng-model=\"vm.parametro.parametroJobRetencao.diasIntervaloExecucao\" \nng-disabled=\"!vm.parametro.parametroJobRetencao.utilizaRentencaoDados || (vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo)\">\n<md-option ng-value=\"intervalo.codigo\" ng-repeat=\"intervalo in vm.opcoesIntervaloExecucaoRetencao\">\n{{intervalo.descricao}}</md-option></md-select><div ng-messages=\"vm.form.diasIntervaloExecucao.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset>\n</div></div></md-content>");
$templateCache.put("app/main/gerenciamento/dashboards/cliente-ocorrencia/sidenavs/filtro/views/CASAN/filtro-cliente-ocorrencia-casan.html","<div id=\"filtro-clienteocorrencia\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" aria-label=\"Filtros\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><h2><span>\nFiltros</span></h2></div></md-toolbar><form name=\"vm.form\" novalidate flex><md-content id=\"conteudo-filtro\" \nclass=\"content\" layout-padding><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Agrupamento</span>\n</legend><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaRegional\"></md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.REGIONAL\">Agrupamento</label><md-select ng-model=\"vm.filtro.regional\" \nmd-on-open=\"vm.metodos.configuraMdSelectRegional()\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\" \nname=\"regional\" ng-disabled=\"vm.regionais.length == 0\"><md-select-header ng-if=\"vm.regionais.length > 0\"><input \nng-model=\"vm.filtrarRegionais\" type=\"search\" id=\"select-regional\" placeholder=\"Pesquisar agrupamento..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"regional.codigo\" \nng-repeat=\"regional in vm.regionais | filter: vm.filtrarRegionais\">{{regional.descricao}}</md-option></md-select><span \nng-if=\"vm.regionais.length == 0\" class=\"nenhum-grupo\">Nenhum regional encontrado.</span><div \nng-messages=\"vm.form.regional.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\">\n</div></div></md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Referência\n</span></legend><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"RESOURCES.MES\">\nMês</label><input type=\"text\" name=\"mes\" mascara-numero-generica=\"##\" ng-model=\"vm.filtro.mes\" validacao-mes \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.mes.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div><div\n ng-message=\"mes_invalido\" translate=\"MENSAGEM_VALIDACAO.MES_INVALIDO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"RESOURCES.ANO\">Ano</label><input type=\"text\" \nname=\"ano\" mascara-numero-generica=\"####\" ng-model=\"vm.filtro.ano\" \nng-model-options=\"{updateOn: \'default blur\',debounce: { \'default\': 500, \'blur\': 0 }}\" \nng-change=\"vm.metodos.pesquisarGrupos(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano)\" ng-required=\"true\"><div \nng-messages=\"vm.form.ano.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></div></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Grupo\n</span></legend><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaGrupo\"></md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label translate=\"RESOURCES.GRUPO\">Grupo</label><md-select ng-model=\"vm.filtro.grupo\" \nmd-on-open=\"vm.metodos.configuraMdSelectGrupo()\" ng-required=\"vm.grupos.length > 0\" name=\"grupo\" \nng-disabled=\"vm.grupos.length == 0\" \nng-change=\"vm.metodos.pesquisarMunicipiosPorRegional(vm.filtro.regional, vm.filtro.mes, vm.filtro.ano, vm.filtro.grupo)\">\n<md-select-header ng-if=\"vm.grupos.length > 0\"><input ng-model=\"vm.filtrarGrupos\" type=\"search\" id=\"select-grupo\" \nmascara-numero-generica=\"####\" placeholder=\"Pesquisar grupo..\" class=\"md-text\"></md-select-header><md-option \nng-value=\"grupo\" ng-repeat=\"grupo in vm.grupos | filter: vm.filtrarGrupos\">{{grupo}}</md-option></md-select><span \nng-if=\"vm.grupos.length == 0\" class=\"nenhum-grupo\">Nenhum grupo encontrado.</span><div \nng-messages=\"vm.form.grupo.$error\"><div ng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div>\n</div></md-input-container></fieldset><fieldset class=\"standard\" flex><legend class=\"grp-legend\"><span>Município</span>\n</legend><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"30\" \nng-if=\"vm.emProgressoBuscaMunicipio\"></md-progress-circular><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"100\"><label translate=\"RESOURCES.MUNICIPIO\">Município</label><md-select ng-model=\"vm.filtro.municipio\" \nmd-on-open=\"vm.metodos.configuraMdSelectMunicipio()\" ng-required=\"true\" name=\"municipio\" \nng-disabled=\"vm.municipios.length == 0\"><md-select-header ng-if=\"vm.municipios.length > 0\"><input \nng-model=\"vm.filtrarMunicipios\" type=\"search\" id=\"select-municipio\" placeholder=\"Pesquisar municipio..\" \nclass=\"md-text\"></md-select-header><md-option ng-value=\"municipio.codigo\" \nng-repeat=\"municipio in vm.municipios | filter: vm.filtrarMunicipios\">{{municipio.codigo}}-{{municipio.descricao}}\n</md-option></md-select><span ng-if=\"vm.municipios.length == 0\" class=\"nenhum-grupo\">Nenhum município encontrado.\n</span><div ng-messages=\"vm.form.municipio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></fieldset><fieldset \nclass=\"standard\" flex><legend class=\"grp-legend\"><span>Ocorrências</span></legend><div layout=\"column\" flex><div \nlayout=\"row\" flex layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30\" ng-if=\"vm.emProgressoBuscaOcorrencias\"></md-progress-circular><multi-select-directive \nid=\"select-leituristas\" class=\"filtros-multi-select\" style=\"margin:0px;padding: 0px\" flex form-name=\"ocorrencias\" \ndata=\"vm.ocorrencias\" model=\"vm.filtro.ocorrencias\" obrigatorio=\"true\" descricao-exibicao=\"descricao\" \ntexto-pesquisa-placeholder=\"Procurar ocorrências...\" texto-placeholder=\"Ocorrências\" disabled=\"false\"></div></div>\n</fieldset><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"40\" ng-if=\"vm.emProgresso\"></md-progress-circular><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.form.$invalid || vm.emProgresso\" ng-if=\"!vm.emProgresso\" \nng-click=\"vm.metodos.filtrarDados(vm.filtro)\"><span>Filtrar</span></md-button></div></div></md-content></form></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tabs/prova-adulteracao.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\"><div \nlayout-gt-sm=\"column\" flex><h1>PROVA ADULTERAÇÃO</h1></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/fotos/tabs/tab-hidrometro.html","<md-content id=\"cadastro-parametros-tab-coletor-tab-configuracao\"><div class=\"form-container\"><div \nlayout-gt-sm=\"column\" flex><ui-carousel slides=\"ctrl.slides\" slides-to-show=\"3\" slides-to-scroll=\"1\" initial-slide=\"1\" \nautoplay=\"true\" autoplay-speed=\"2000\" dots=\"true\"><carousel-item><h3>{{ item + 1 }}</h3></carousel-item></ui-carousel>\n</div></div></md-content>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-detalhes-unificacao/views/dialog-detalhes-unificacao.html","<md-dialog layout=\"column\" id=\"dialog-detalhamento\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Detalhamento de tarefas unificadas</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"overflow-y: scroll\" layout=\"column\" flex=\"100\" \nlayout-align=\"space-between\"><div flex=\"50\" layout-align=\"center center\" layout-gt-sm=\"row\" layout=\"column\"><ms-widget \nclass=\"h-60\" style=\"padding: 4px!important\" layout=\"column\" layout-align=\"center center\" flex=\"50\"><ms-widget-front \nclass=\"p-8 blue-bg white-fg card-titulo\" layout=\"row\" flex=\"100\"><div class=\"pt-2 pb-2\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div flex=\"100\" layout-align=\"center center\" class=\"font-size-18\">Leiturista\n</div><div flex=\"100\" layout-align=\"center center\" class=\"font-weight-500 secondary-text\">{{ vm.tarefa.leiturista }}\n</div></div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nlayout-align-xs=\"center center\"><div layout=\"column\" layout-align=\"center center\" class=\"pb-8\" flex=\"100\" \nflex-xs=\"100\"><ms-widget style=\"padding:0!important\"><ms-widget-front><div><table class=\"dataTable hover row-border\">\n<thead><tr><th class=\"secondary-text borda-direita\"><div class=\"table-header\"><span class=\"column-title text-center\">\nDescrição</span></div></th></tr></thead><tbody><tr \nng-repeat=\"detalhes in vm.tarefa.detalhesTarefasUnificadas track by $index\"><td class=\"text-center border-right\"><span>\n{{ detalhes.descricaoTarefa }}</span></td></tr></tbody></table></div></ms-widget-front></ms-widget></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/processamento/gerenciamentogrupo/dialogs/dialog-tarefas/dialogs/dialog-rotas/views/dialog-rotas.html","<md-dialog layout=\"column\"><md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools md-accent\"><h2>\n{{vm.titulo}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div>{{vm.rotas}}</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-auditoria/tab-outros/tab-outros.html","<md-content id=\"tab-modoimplantacao-tab-auditoria-tab-outros\"><div class=\"form-container\"><div layout-gt-sm=\"row\" flex>\n<md-input-container flex class=\"md-block\" flex-gt-sm=\"30\"><label translate=\"RESOURCES.VALOR_MAXIMO_FATURA\"></label>\n<input type=\"text\" name=\"valorMaximoFaturas\" ui-money-mask mascara-tamanho-campo=\"16\" \nng-model=\"vm.parametro.valor.valorMaximoImpressaoFatura\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container flex class=\"md-block\" flex-gt-sm=\"35\"><md-checkbox \nname=\"utilizaAuditoriaCreditoDebitoExportacao\" \nid=\"cadastro-parametros-tabmodoImplantacao-chkUtilizaAuditoriaCreditoDebitoExportacao\" \nng-model=\"vm.parametro.utilizaAuditoriaExportacaoCreditoDebito\" \naria-label=\"Utiliza auditoria de crédito/débito na exportação\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_AUDITORIA_EXPORTACAO_CREDITO_DEBITO\">Utilizar auditoria de crédito/débito na exportação\n</span></md-checkbox></md-input-container></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-especifico/tab-jardinopolis/tab-jardinopolis.html","<div id=\"cadastro-parametros-tab-modoImplantacao-tab-especifico-tabjardinopolis\" layout=\"column\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>Fator preço básico (R$)</label><input ui-number-mask=\"5\" \nmaxlength=\"11\" name=\"fatorPrecoBasico\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasico\', vm.parametro.valor.fatorPrecoBasico)\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasico\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasico\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>Expoente do consumo (R$)</label><input\n ui-number-mask=\"5\" maxlength=\"11\" name=\"expoenteConsumo\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'expoenteConsumo\', vm.parametro.valor.expoenteConsumo)\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtexpoenteConsumo\" \nng-model=\"vm.parametro.calculo.expoenteConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"cor-icone-padrao\"><md-tooltip md-autohide md-direction=\"top\"><span \nclass=\"md-caption\">\nTarifa de água = Fator preço básico x (Preço básico x Fator do preço básico por categoria) x Consumo ^ Expoente do consumo\n</span></md-tooltip></md-icon></md-input-container></div><div layout=\"column\"><fieldset class=\"standard\" flex \nflex-gt-sm=\"100\"><legend class=\"grp-legend\">Fator do preço básico da categoria</legend><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Residencial (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasicoCategoriaResidencial\', vm.parametro.calculo.fatorPrecoBasicoCategoriaResidencial)\" \nname=\"fatorPrecoBasicoCategoriaResidencial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasicoCategoriaResidencial\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasicoCategoriaResidencial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Comercial (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasicoCategoriaComercial\', vm.parametro.calculo.fatorPrecoBasicoCategoriaComercial)\" \nname=\"fatorPrecoBasicoCategoriaComercial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasicoCategoriaComercial\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasicoCategoriaComercial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Industrial (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasicoCategoriaIndustrial\', vm.parametro.calculo.fatorPrecoBasicoCategoriaIndustrial)\" \nname=\"fatorPrecoBasicoCategoriaIndustrial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasicoCategoriaIndustrial\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasicoCategoriaIndustrial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Orgãos Públicos (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasicoCategoriaPublica\', vm.parametro.calculo.fatorPrecoBasicoCategoriaPublica)\" \nname=\"fatorPrecoBasicoCategoriaPublica\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasicoCategoriaPublica\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasicoCategoriaPublica\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Outras (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorPrecoBasicoCategoriaOutras\', vm.parametro.calculo.fatorPrecoBasicoCategoriaOutras)\" \nname=\"fatorPrecoBasicoCategoriaOutras\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorPrecoBasicoCategoriaOutras\" \nng-model=\"vm.parametro.calculo.fatorPrecoBasicoCategoriaOutras\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset><fieldset class=\"standard\" flex flex-gt-sm=\"100\"><legend class=\"grp-legend\">\nFator do consumo mínimo da categoria</legend><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label>Residencial (R$)</label><input ui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorConsumoMinimoCategoriaResidencial\', vm.parametro.calculo.fatorConsumoMinimoCategoriaResidencial)\" \nname=\"fatorConsumoMinimoCategoriaResidencial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorConsumoMinimoCategoriaResidencial\" \nng-model=\"vm.parametro.calculo.fatorConsumoMinimoCategoriaResidencial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Comercial (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorConsumoMinimoCategoriaComercial\', vm.parametro.calculo.fatorConsumoMinimoCategoriaComercial)\" \nname=\"fatorConsumoMinimoCategoriaComercial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorConsumoMinimoCategoriaComercial\" \nng-model=\"vm.parametro.calculo.fatorConsumoMinimoCategoriaComercial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Industrial (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorConsumoMinimoCategoriaIndustrial\', vm.parametro.calculo.fatorConsumoMinimoCategoriaIndustrial)\" \nname=\"fatorConsumoMinimoCategoriaIndustrial\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorConsumoMinimoCategoriaIndustrial\" \nng-model=\"vm.parametro.calculo.fatorConsumoMinimoCategoriaIndustrial\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Orgãos Públicos (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorConsumoMinimoCategoriaPublica\', vm.parametro.calculo.fatorConsumoMinimoCategoriaPublica)\" \nname=\"fatorConsumoMinimoCategoriaPublica\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorConsumoMinimoCategoriaPublica\" \nng-model=\"vm.parametro.calculo.fatorConsumoMinimoCategoriaPublica\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Outras (R$)</label><input \nui-number-mask=\"5\" maxlength=\"11\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'valor\',\'fatorConsumoMinimoCategoriaOutras\', vm.parametro.calculo.fatorConsumoMinimoCategoriaOutras)\" \nname=\"fatorConsumoMinimoCategoriaOutras\" \nid=\"cadastro-parametros-tabespecifico-tabjardinopolis-txtfatorConsumoMinimoCategoriaOutras\" \nng-model=\"vm.parametro.calculo.fatorConsumoMinimoCategoriaOutras\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</md-input-container></div></fieldset></div></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-ligacao-cota/tab-ligacao-cota.html","<div id=\"cadastro-parametros-tab-ilhasolteira-tab-ligacaocota\" layout=\"column\" class=\"pt-10\"><md-content \nclass=\"content\" layout-padding><div layout=\"column\"><div layout=\"row\" class=\"mb-30\"><fieldset layout=\"column\" \nflex=\"50\"><legend class=\"grp-legend\">Serviço excedente água</legend><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Código</label><input \nid=\"cadastro-parametros-tabilhasolteira-codigoServicoExcedenteAguaLigacaoCota\" ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"5\" name=\"codigoServicoExcedenteAguaLigacaoCota  \" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.parametro.codigoServicoExcedenteAguaLigacaoCota\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.codigoServicoExcedenteAguaLigacaoCota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"75\"><label>Descrição</label><input \nid=\"cadastro-parametros-tabilhasolteira-descricaoServicoExcedenteAguaLigacaoCota\" \nname=\"descricaoServicoExcedenteAguaLigacaoCota\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"70\" md-maxlength=\"70\" ng-model=\"vm.parametro.descricaoServicoExcedenteAguaLigacaoCota\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricaoServicoExcedenteAguaLigacaoCota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset><fieldset \nlayout=\"column\" flex=\"50\"><legend class=\"grp-legend\">Serviço excedente esgoto</legend><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>Código</label><input \nid=\"cadastro-parametros-tabilhasolteira-codigoServicoExcedenteEsgotoLigacaoCota\" ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"5\" name=\"codigoServicoExcedenteEsgotoLigacaoCota\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.parametro.codigoServicoExcedenteEsgotoLigacaoCota\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.codigoServicoExcedenteEsgotoLigacaoCota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"75\"><label>Descrição</label><input \nid=\"cadastro-parametros-tabilhasolteira-descricaoServicoExcedenteEsgotoLigacaoCota\" \nname=\"descricaoServicoExcedenteEsgotoLigacaoCota\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"70\" md-maxlength=\"70\" ng-model=\"vm.parametro.descricaoServicoExcedenteEsgotoLigacaoCota\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.descricaoServicoExcedenteEsgotoLigacaoCota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></fieldset></div><div \nlayout-gt-xs=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"50\"><label>Ocorrências ligação cota</label>\n<md-select id=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaLigacaoCota\" name=\"codigoOcorrenciaLigacaoCota\" \nng-model=\"vm.parametro.codigoOcorrenciaLigacaoCota\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoOcorrenciaLigacaoCota.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label>Ocorrências ligação cota com cálculo proporcional</label><md-select \nid=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaLigacaoCotaCalculoProporcional\" \nname=\"codigoOcorrenciaLigacaoCotaCalculoProporcional\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaLigacaoCotaCalculoProporcional\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoOcorrenciaLigacaoCotaCalculoProporcional.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"50\"><label>\nOcorrências ligação cota com cálculo proporcional e crédito de consumo</label><md-select \nid=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaLigacaoCotaCalculoProporcionalComCreditoConsumo\" \nname=\"codigoOcorrenciaLigacaoCotaCalculoProporcionalComCreditoConsumo\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaLigacaoCotaCalculoProporcionalComCreditoConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoOcorrenciaLigacaoCotaCalculoProporcionalComCreditoConsumo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><div \nclass=\"md-block\" flex=\"50\" style=\"margin-left: 12px\"></div></div></div></md-content></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-lancamento-ocorrencia/tab-lancamento-ocorrencia.html","<div id=\"cadastro-parametros-tab-ilhasolteira-tab-lancamentoOcorrencia\" layout=\"column\" class=\"pt-20\"><md-content \nclass=\"content\" layout-padding><div layout=\"column\" flex><fieldset layout=\"column\" flex><div layout=\"column\" flex><div \nclass=\"ml-8\" flex=\"40\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nid=\"cadastro-parametros-tabilhasolteira-utilizarLancamentoAutomaticoOcorrenciaSemConsumo\" class=\"mb-5\" \nname=\"utilizarLancamentoAutomaticoOcorrenciaSemConsumo\" aria-label=\"Utilizar serviço poupa água\" \nng-model=\"vm.parametro.utilizarLancamentoAutomaticoOcorrenciaSemConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                  !vm.controleForm.editarAtivo && \r\n                                  !vm.controleForm.inserirAtivo\">\n<span>Utilizar lançamento automático de ocorrência sem consumo</span></md-checkbox></div><div flex layout=\"column\" \nng-if=\"vm.parametro.utilizarLancamentoAutomaticoOcorrenciaSemConsumo\" class=\"mt-10\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"50\"><label>Ocorrência hidrômetro parado</label><md-select \nid=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaHidrometroParado\" name=\"codigoOcorrenciaHidrometroParado\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaHidrometroParado\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoOcorrenciaHidrometroParado.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\"><label>Ocorrência imóvel vazio</label><md-select \nid=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaImovelVazio\" name=\"codigoOcorrenciaImovelVazio\" \nng-model=\"vm.parametro.codigoOcorrenciaImovelVazio\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.codigoOcorrenciaImovelVazio.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"50\"><label>Ocorrência cálculo proporcional com crédito de consumo</label>\n<md-select id=\"cadastro-parametros-taboilhasolteira-codigoOcorrenciaCalculoProporcionalComCreditoConsumo\" \nname=\"codigoOcorrenciaCalculoProporcionalComCreditoConsumo\" \nng-model=\"vm.parametro.calculo.codigoOcorrenciaCalculoProporcionalComCreditoConsumo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select><div ng-messages=\"vm.form.CodigoOcorrenciaCalculoProporcionalComCreditoConsumo.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Número de meses a considerar no histórico de consumo\n</label><input id=\"cadastro-parametros-taboilhasolteira-numeroMesesConsiderarHistoricoConsumo\" type=\"text\" \nname=\"numeroMesesConsiderarHistoricoConsumo\" ng-model=\"vm.parametro.numeroMesesConsiderarHistoricoConsumo\" \nng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-numeros=\"4\" ng-required=\"vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo\"><div \nng-messages=\"vm.form.numeroMesesConsiderarHistoricoConsumo.$error\"><div ng-message=\"required\" \ntranslate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container></div></div></div></fieldset></div>\n</md-content></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-modoimplantacao/tabs/tab-ilha-solteira/tab-poupa-agua/tab-poupa-agua.html","<div id=\"cadastro-parametros-tab-ilhasolteira-tab-poupaagua\" layout=\"column\" class=\"pt-20\"><md-content class=\"content\" \nlayout-padding><fieldset layout=\"column\" flex><div layout=\"column\" flex><div class=\"ml-8\" flex=\"40\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox id=\"cadastro-parametros-tabilhasolteira-utilizarServicoPoupaAgua\" \nclass=\"mb-5\" name=\"utilizarServicoPoupaAgua\" aria-label=\"Utilizar serviço poupa água\" \nng-model=\"vm.parametro.utilizarServicoPoupaAgua\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && \r\n                                !vm.controleForm.editarAtivo && \r\n                                !vm.controleForm.inserirAtivo\">\n<span>Utilizar serviço de poupa água</span></md-checkbox></div><div layout=\"column\" \nng-if=\"vm.parametro.utilizarServicoPoupaAgua\" class=\"mt-10\"><div layout=\"row\" class=\"mb-30\"><fieldset layout=\"column\" \nflex=\"50\"><legend class=\"grp-legend\">Serviço de desconto de água</legend><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Código</label><input \nid=\"cadastro-parametros-tabilhasolteira-codigoServicoDescontoAguaPoupaAgua\" ui-number-mask=\"0\" ui-hide-group-sep \nmascara-tamanho-campo=\"5\" name=\"codigoServicoDescontoAguaPoupaAgua  \" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.parametro.codigoServicoDescontoAguaPoupaAgua\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"75\"><label>Descrição</label><input \nid=\"cadastro-parametros-tabilhasolteira-descricaoServicoDescontoAguaPoupaAgua\" \nname=\"descricaoServicoDescontoAguaPoupaAgua\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"70\" md-maxlength=\"70\" ng-model=\"vm.parametro.descricaoServicoDescontoAguaPoupaAgua\">\n</md-input-container></div></fieldset><fieldset layout=\"column\" flex=\"50\"><legend class=\"grp-legend\">\nServiço de desconto de esgoto</legend><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>\nCódigo</label><input id=\"cadastro-parametros-tabilhasolteira-codigoServicoDescontoEsgotoPoupaAgua\" ui-number-mask=\"0\" \nui-hide-group-sep mascara-tamanho-campo=\"5\" name=\"codigoServicoDescontoEsgotoPoupaAgua\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nng-model=\"vm.parametro.codigoServicoDescontoEsgotoPoupaAgua\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"75\"><label>Descrição</label><input \nid=\"cadastro-parametros-tabilhasolteira-descricaoServicoDescontoEsgotoPoupaAgua\" \nname=\"descricaoServicoDescontoEsgotoPoupaAgua\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"70\" md-maxlength=\"70\" ng-model=\"vm.parametro.descricaoServicoDescontoEsgotoPoupaAgua\">\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" \nflex=\"100\"><label>Ocorrências para cálculo do serviço</label><md-select \nid=\"cadastro-parametros-taboilhasolteira-tabpoupaagua-ocorrenciasServicoPoupaAgua\" name=\"ocorrenciasServicoPoupaAgua\" \nng-model=\"vm.parametro.ocorrenciasServicoPoupaAgua\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmd-on-open=\"vm.metodos.configuraMdSelectOcorrencia()\" style=\"padding: 0 !important; margin: 0 !important\" \nmultiple=\"multiple\"><md-select-header><input id=\"filtro-ocorrencia-md-select\" type=\"search\" class=\"md-text\" \nplaceholder=\"Pesquisar\" ng-model=\"vm.filtroOcorrencia\"></md-select-header><md-option ng-value=\"ocorrencia.id\" \nng-repeat=\"ocorrencia in vm.listaOcorrencias | filter:vm.filtroOcorrencia\">{{ocorrencia.descricao}}</md-option>\n</md-select></md-input-container></div><md-input-container class=\"md-block mb-0 pb-0\" flex=\"100\"><label>\nMensagem para faturas sem desconto</label><textarea \nid=\"cadastro-parametros-tabilhasolteira-mensagemFaturaSemDescontoPoupaAgua\" \nng-model=\"vm.parametro.mensagemFaturaSemDescontoPoupaAgua \" name=\"mensagemFaturaSemDescontoPoupaAgua\" \nmascara-tamanho-campo=\"150\" md-maxlength=\"150\" rows=\"1\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</textarea></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>\nMensagem para faturas com economia de consumo</label><textarea \nid=\"cadastro-parametros-tabilhasolteira-mensagemFaturaEconomiaServicoPoupaAgua\" \nng-model=\"vm.parametro.mensagemFaturaEconomiaServicoPoupaAgua\" name=\"mensagemFaturaEconomiaServicoPoupaAgua\" \nmascara-tamanho-campo=\"300\" md-maxlength=\"300\" rows=\"1\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n</textarea></md-input-container></div></div></fieldset></md-content></div>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-personalizacao/dialogs/dialog-imagens-predefinidas-background/views/dialog-imagens-predefinidas-background.html","<md-dialog id=\"imagens-background\" layout=\"column\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Imagens predefinidas</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"2px\" md-gutter-gt-sm=\"4px\"><md-grid-tile \nng-repeat=\"imagem in vm.imagens track by $index\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" ng-click=\"\"><img \nng-src=\"{{imagem.src}}\" ng-click=\"vm.metodos.zoomImagem(imagem.src)\" width=\"300\" height=\"200\"><md-checkbox \nclass=\"check\" aria-label=\"Selecionado\" layout=\"row\" layout-align=\"start center\" ng-model=\"imagem.selecionado\" \nng-change=\"vm.metodos.selecionarImagem(imagem)\"></md-checkbox><md-tooltip md-autohide>Clique para ampliar</md-tooltip>\n</a></md-grid-tile></md-grid-list></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/critica/consultacritica/dialogs/historico-critica/dialogs/dialog-fotos/views/dialog-fotos-historico-criticas.html","<md-dialog layout=\"column\" id=\"fotos-visita-critica\" class=\"dialog-padrao\" aria-label=\"Dialog\"><md-toolbar \nclass=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><h2>Fotos da crítica</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Fechar\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" md-row-height-gt-sm=\"1:1\" \nmd-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile ng-repeat=\"foto in vm.fotos\" md-rowspan=\"1\" \nmd-colspan=\"1\"><a href=\"#\" ng-click=\"vm.metodos.abrirDialogDetalheFoto(foto)\"><img ng-src=\"{{foto}}\" width=\"300\" \nheight=\"200\"></a></md-grid-tile></md-grid-list></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/historico/historico.dialog.html","<md-dialog id=\"dialog-historico\" style=\"min-height: 85%; min-width: 95%\" class=\"dialogo-padrao\" aria-label=\"Dialog\">\n<form name=\"dialogHistorico\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nHistórico de consumo</span><div layout=\"row\" layout-align=\"end center\"><div class=\"pesquisar\" layout=\"row\" \nlayout-align=\"start center\" flex><label><md-icon class=\"white-text icon search-icon\" md-font-icon=\"icon-magnify\" \nlayout-align=\"center\"></md-icon></label><input id=\"pesquisar\" class=\"pesquisar-input\" type=\"text\" \nplaceholder=\"Pesquisar\" translate ng-model=\"vm.pesquisar\" ng-model-options=\"{debounce: 400}\" flex></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div></md-toolbar><div layout=\"column\" flex ng-hide=\"!vm.emProgresso\" layout-align=\"center center\" class=\"progress\">\n<md-progress-circular ng-disabled=\"!vm.emProgresso\" class=\"md-accent md-hue-1\" md-diameter=\"60\"></md-progress-circular>\n<span class=\"texto-progress\">Carregando histórico...</span></div><div><div class=\"card\" flex layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"blue-bg white-fg\" flex md-theme-watch layout-align=\"center center\" \nstyle=\"max-width: fit-content\"><md-card-title class=\"p-16\"><md-card-title-text><span class=\"font-size-16\">\n{{vm.nomeCliente}}</span></md-card-title-text></md-card-title></md-card></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span class=\"column-title text-center\">\nReferência</span></div></th><th class=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Consumo</span></div></th><th class=\"secondary-text altura-cabecalho-tabela\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Número dias</span></div></th><th \nclass=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span class=\"column-title text-center\">\nMédia de consumo diário</span></div></th><th class=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\">\n<span class=\"column-title text-center\">Leitura</span></div></th><th class=\"secondary-text altura-cabecalho-tabela\"><div\n class=\"table-header\"><span class=\"column-title text-center\">Ocorrência</span></div></th><th \nclass=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span class=\"column-title text-center\">\nConsumo faturado</span></div></th></tr></thead><tbody><tr ng-repeat=\"historico in vm.historicos track by $index\"><td \nclass=\"text-center altura-linha\"><span>{{historico.referencia}}</span></td><td class=\"text-center altura-linha\"><span>\n{{historico.consumo }}</span></td><td class=\"text-center altura-linha\"><span>{{historico.numeroDias}}</span></td><td \nclass=\"text-center altura-linha\"><span>{{historico.mediaConsumo.toFixed(3)}}</span></td><td \nclass=\"text-center altura-linha\"><span>{{historico.leitura}}</span></td><td class=\"text-center altura-linha\"><span>\n{{historico.ocorrencia}}</span></td><td class=\"text-center altura-linha\"><span>{{historico.consumoFaturado}}</span>\n</td></tr></tbody></table></div></form></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/historico-abastecimento/historico-abastecimento.dialog.html","<md-dialog id=\"dialog-historico\" style=\"min-height: 85%; min-width: 95%\" class=\"dialogo-padrao\" aria-label=\"Dialog\">\n<form name=\"dialogHistorico\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nHistórico de abastecimento</span><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" translate \ntranslate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div></md-toolbar><div layout=\"column\" flex ng-if=\"vm.emProgresso\" layout-align=\"center center\" class=\"progress\">\n<md-progress-circular ng-disabled=\"!vm.emProgresso\" class=\"md-accent md-hue-1\" md-diameter=\"60\"></md-progress-circular>\n<span class=\"texto-progress\">Carregando histórico...</span></div><div ng-if=\"!vm.emProgresso\"><div class=\"card\" flex \nlayout=\"row\" layout-align=\"center center\"><md-card class=\"blue-bg white-fg\" flex md-theme-watch \nlayout-align=\"center center\" style=\"max-width: fit-content\"><md-card-title class=\"card-total\"><md-card-title-text>\n<span>{{ vm.consumoTotal }}m³</span></md-card-title-text></md-card-title></md-card><md-button \nclass=\"md-fab md-raised md-mini md-accent\" \nng-click=\"vm.metodos.abrirSelecaoArquivo(\'cadastros-relacionados-formularioimpressao-tabespecifico-flComunicadoUnicoDebito\')\" \nng-disabled=\"vm.emProgresso\"><md-icon md-font-icon=\"icon-refresh\" class=\"s22\"></md-icon><md-tooltip md-autohide>\nAtualizar dados</md-tooltip></md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span\n class=\"column-title text-center\">Consumo</span></div></th><th class=\"secondary-text altura-cabecalho-tabela\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Responsável</span></div></th><th \nclass=\"secondary-text altura-cabecalho-tabela\"><div class=\"table-header\"><span class=\"column-title text-center\">Data\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"historico in vm.historicos track by $index\"><td \nclass=\"text-center altura-linha\"><span>{{ historico.consumoAbastecido }}</span></td><td \nclass=\"text-center altura-linha\"><span>{{ historico.leiturista.apelido || \'-\' }}</span></td><td \nclass=\"text-center altura-linha\"><span>{{ historico.dataHoraAbastecimento }}</span></td></tr></tbody></table></div>\n</form></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosFaturamento/dialogs/servico/dados-servico.html","<md-dialog id=\"dialog-servico\" class=\"dialogo-padrao\" aria-label=\"Dialog\"><form name=\"dialogServico\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent toolbar-servico\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nDetalhes dos serviços cobrados</span><div class=\"container-input-fechar\"><div class=\"input-pesquisa\" layout=\"row\" \nlayout-align=\"start start\"><label><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n</label><input id=\"pesquisarServicos\" type=\"search\" placeholder=\"Pesquisar\" ng-model=\"vm.pesquisarServicos\" \nng-disabled=\"!vm.possuiDados\" flex></div><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div layout=\"column\" flex \nng-hide=\"!vm.emProgresso\" layout-align=\"center center\" class=\"progress\"><md-progress-circular \nng-disabled=\"!vm.emProgresso\" class=\"md-accent md-hue-1\" md-diameter=\"60\"></md-progress-circular><span \nclass=\"texto-progress\">Carregando histórico...</span></div><md-dialog-content style=\"padding: 24px 24px 24px 24px\"><div\n layout=\"column\" class=\"dialog-content-servico\"><h2 class=\"text-center titulo\" ng-if=\"vm.possuiDados\">\n{{vm.nomeCliente}}</h2><div class=\"container-tabela-servicos\" ng-if=\"vm.possuiDados\"><table \nclass=\"dataTable row-border hover tabela-servico-custom\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text border-left border-right\"><div class=\"table-header\"><span class=\"column-title text-center\">Código\n</span></div></th><th class=\"secondary-text border-right\"><div class=\"table-header\"><span \nclass=\"column-title text-left\">Descrição</span></div></th><th class=\"secondary-text border-right\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Valor calculado</span></div></th></tr></thead><tbody><tr \nng-repeat=\"detalhe in vm.servico track by $index\"><td class=\"text-center border-left border-right\"><span>\n{{detalhe.codigo}}</span></td><td class=\"text-left border-right\"><span>{{detalhe.descricao}}</span></td><td \nclass=\"text-right border-right\"><span>{{detalhe.valorCalculado | currency:\'R$\'}}</span></td></tr></tbody></table></div>\n<div class=\"no-results text-center\" ng-if=\"!vm.emProgresso && !vm.possuiDados\"><div class=\"message\"><md-icon \nclass=\"message-icon s90\" md-font-icon=\"icon-information-outline\"></md-icon><div class=\"titulo-text\">\nNão existem serviços cobrados para este cliente</div></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/fotos-dados-leitura.dialog.html","<md-dialog id=\"dialog-fotos\" flex aria-label=\"Dialog Fotos\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Fotos</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodosDialog.fecharDialog()\" \naria-label=\"Fechar dialog\" translate translate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Hidrômetro/Fachada\" md-active=\"vm.tabSelecionada === \'hidrometro\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'hidrometro\')\" ng-if=\"vm.tipoDetalheCalculo == 89\" \nng-disabled=\"!vm.fotos.fotosHidrometro.length\"><md-tab-label><span translate=\"LEITURA.VISUALIZACAO.CASAN_FOTOS\"></span>\n</md-tab-label><md-tab-body><div ng-include=\"vm.rotasHtml.tabHidrometro\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Hidrômetro/Fachada\" md-active=\"vm.tabSelecionada === \'hidrometro\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'hidrometro\')\" ng-if=\"vm.tipoDetalheCalculo != 89\" \nng-disabled=\"!vm.fotos.fotosHidrometro.length\"><md-tab-label><span translate=\"LEITURA.VISUALIZACAO.HIDROMETRO\"></span>\n</md-tab-label><md-tab-body><div ng-include=\"vm.rotasHtml.tabHidrometro\"></div></md-tab-body></md-tab><md-tab \nlabel=\"Fachada\" ng-if=\"vm.tipoDetalheCalculo != 89\" md-active=\"vm.tabSelecionada === \'fachada\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'fachada\')\" ng-disabled=\"!vm.fotos.fotosFachada.length\"><md-tab-label>\n<span translate=\"LEITURA.VISUALIZACAO.FACHADA\"></span></md-tab-label><md-tab-body><div \nng-include=\"vm.rotasHtml.tabFachada\"></div></md-tab-body></md-tab><md-tab label=\"Prova de adulteração\" \nmd-active=\"vm.tabSelecionada === \'provaAdulteracao\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'provaAdulteracao\')\" ng-if=\"vm.tipoDetalheCalculo != 89\" \nng-disabled=\"!vm.fotos.fotosProvaAdulteracao.length\"><md-tab-label><span \ntranslate=\"LEITURA.VISUALIZACAO.PROVA_ADULTERACAO\"></span></md-tab-label><md-tab-body><div \nng-include=\"vm.rotasHtml.tabProvaAdulteracao\"></div></md-tab-body></md-tab><md-tab label=\"Demais fotos\" \nng-if=\"vm.tipoDetalheCalculo != 89\" md-active=\"vm.tabSelecionada === \'demaisFotos\'\" \nmd-on-select=\"vm.metodosDialog.tabSelecionada(\'demaisFotos\')\" ng-disabled=\"!vm.fotos.fotosOutros.length\"><md-tab-label>\n<span translate=\"LEITURA.VISUALIZACAO.DEMAIS_FOTOS\"></span></md-tab-label><md-tab-body><div \nng-include=\"vm.rotasHtml.tabDemaisFotos\"></div></md-tab-body></md-tab><md-tab label=\"Repasse\" \nmd-active=\"vm.tabSelecionada === \'repasse\'\" md-on-select=\"vm.metodosDialog.tabSelecionada(\'repasse\')\" \nng-if=\"vm.tipoDetalheCalculo != 89\" ng-disabled=\"!vm.fotos.fotosRepasse.length\"><md-tab-label><span \ntranslate=\"LEITURA.VISUALIZACAO.REPASSE\"></span></md-tab-label><md-tab-body><div ng-include=\"vm.rotasHtml.tabRepasse\">\n</div></md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/logLeitura/log-leitura.dialog.html","<md-dialog id=\"dialog-log-leitura\" class=\"dialogo-padrao\" aria-label=\"Dialog log leitura\"><form \nname=\"dialogLogLeitura\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nLog da leitura</span><md-button class=\"md-icon-button\" ng-click=\"vm.metodos.fecharDialog()\" aria-label=\"Fechar dialog\" \ntranslate translate-attr-aria-label=\"RESOURCES.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div class=\"div-cards-principal\" flex><div class=\"cards\" flex layout=\"row\"><md-card flex \nclass=\"blue-bg white-fg\" md-theme-watch style=\"margin-right: 50px\"><md-card-title><md-card-title-text><span \nclass=\"blue-bg white-fg font-weight-500 font-size-16\">Consumidor </span><span class=\"font-size-16\">\n{{ vm.dados.consumidor }}</span></md-card-title-text></md-card-title></md-card><md-card flex class=\"blue-bg white-fg\" \nmd-theme-watch style=\"margin-right: 50px\"><md-card-title><md-card-title-text><span \nclass=\"blue-bg white-fg font-weight-500 font-size-16\">Leiturista </span><span class=\"font-size-16\">\n{{ vm.dados.leiturista }}</span></md-card-title-text></md-card-title></md-card><md-card flex class=\"blue-bg white-fg\" \nmd-theme-watch><md-card-title><md-card-title-text><span class=\"blue-bg white-fg font-weight-500 font-size-16\">Arquivo \n</span><span class=\"font-size-16\">{{ vm.dados.arquivo }}</span></md-card-title-text></md-card-title></md-card></div>\n</div><div flex=\"100\" layout=\"column\" class=\"form-container\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"max-width: 100%\"><thead><tr><th class=\"secondary-text coluna-operacao\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Operação</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Data/Hora</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Leitura</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Ocorrência</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title text-center\">Valor fatura</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title text-center\">Cons. real</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Cons. faturado</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\">Tempo total</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"dadoLeitura in vm.dados.dadosLeitura\"><td \nclass=\"text-center coluna-operacao\"><span>{{ dadoLeitura.operacao }}</span></td><td class=\"text-center\"><span>\n{{ dadoLeitura.dataHora | date: \'dd/MM/yyyy HH:mm:ss\' }}</span></td><td class=\"text-center\"><span>\n{{ dadoLeitura.leitura }}</span></td><td class=\"text-center\"><span>{{ dadoLeitura.ocorrencia }}</span></td><td \nclass=\"text-center\"><span>{{ dadoLeitura.valorTotal | currency: \'R$ \'}}</span></td><td class=\"text-center\"><span>\n{{ dadoLeitura.consumoReal }}</span></td><td class=\"text-center\"><span>{{ dadoLeitura.consumoFaturado }}</span></td><td\n class=\"text-center\"><span>{{ dadoLeitura.tempoTotal }}</span></td></tr></tbody></table></div></form></md-dialog>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-alternativo/tab-alternativo.html","<md-content id=\"tab-impressao-tab-comunicados-tab-alternativo\"><div class=\"form-container\"><div layout=\"column\">\n<fieldset class=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaComunicadoAlternativo\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkUtilizaComunicadoAlternativo\" \nng-model=\"vm.parametro.comunicado.utilizaComunicadoAlternativo\" aria-label=\"Cria serviço de arredondamento\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_COMUNICADO_FORMULARIO_SEPARADO\">Utilizar comunicado em formulário separado</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.comunicado.utilizaComunicadoAlternativo == \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label><textarea \nng-model=\"vm.parametro.comunicado.mensagemComunicadoAlternativo\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-txtMensagemComunicadoAlternativo\" \nname=\"mensagemComunicadoAlternativo\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                  </textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><md-input-container class=\"md-block\"><span class=\"observacao\" \ntranslate=\"RESOURCES.OBSERVACAO_COMUNICADO_ALTERNATIVO\">\nPara quebrar a linha do comunicado, pressione a tecla ENTER. A largura do campo é correspondente à quantidade máxima de caracteres por linha do comunicado. O que passar do tamanho do campo irá sobrepor a impressão.\n<span></span></span></md-input-container></div></div><br><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label translate=\"RESOURCES.TITULO_COMUNICADO\">Título comunicado</label><input \ntype=\"text\" name=\"tituloComunicadoAlternativo\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-txtTituloComunicadoAlternativo\" \nng-model=\"vm.parametro.comunicado.tituloComunicadoAlternativo\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"28\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"45\"><md-checkbox \nname=\"imprimirSempreComunicadoAlternativo\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkImprimirSempreComunicadoAlternativo\" \nng-model=\"vm.parametro.comunicado.imprimirSempreComunicadoAlternativo\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n<md-checkbox name=\"imprimeComunicadoAlternativoEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkImprimeComunicadoAlternativoEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeComunicadoAlternativoEmCampoComContaRetida\" \naria-label=\"Imprime comunicado em campo com conta retida\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container></div></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-consumoalterado/tab-consumoalterado.html","<md-content id=\"tab-impressao-tab-comunicados-tab-consumoalterado\"><div class=\"form-container\"><div layout=\"column\">\n<fieldset class=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaComunicadoConsumoAlterado\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabconsumoalterado-chkUtilizaComunicadoConsumoAlterado\" \nng-change=\"vm.metodos.limpaMensagemConsumoAlterado($event)\" \nng-model=\"vm.parametro.comunicado.utilizaComunicadoConsumoAlterado\" aria-label=\"Cria serviço de arredondamento\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_COMUNICADO_FORMULARIO_SEPARADO\">Utilizar comunicado em formulário separado</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.comunicado.utilizaComunicadoConsumoAlterado == \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label><textarea \nng-model=\"vm.parametro.comunicado.mensagemConsumoAlterado\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabconsumoalterado-txtMensagemConsumoAlterado\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoConsumoAlterado($event)\" \nng-required=\"vm.parametro.comunicado.utilizaComunicadoConsumoAlterado == \'S\'\" name=\"mensagemConsumoAlterado\" rows=\"2\" \nmax-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                  </textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><md-input-container class=\"md-block\" flex=\"100\"><span \nclass=\"observacao\" translate=\"RESOURCES.OBSERVACAO_COMUNICADO_CONSUMO_ALTERADO\">\nPara quebrar a linha do comunicado, pressione a tecla ENTER. A largura do campo é correspondente à quantidade máxima de caracteres por linha do comunicado. O que passar do tamanho do campo irá sobrepor a impressão.\n<span></span></span></md-input-container></div></div><br><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"35\"><md-checkbox name=\"confirmaImpressaoConsumoAlterado\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabconsumoalterado-chkconfirmaImpressaoConsumoAlterado\" \nng-model=\"vm.parametro.comunicado.confirmaImpressaoConsumoAlterado\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.SOLICITAR_CONFIRMACAO_IMPRESSAO\">Solicitar confirmação de impressão</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"45\"><md-checkbox \nname=\"imprimirSempreComunicadoCA\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabconsumoalterado-chkImprimirSempreComunicadoCA\" \nng-model=\"vm.parametro.comunicado.imprimirSempreComunicadoCA\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n<md-checkbox name=\"imprimeComunicadoConsumoAlteradoEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabconsumoalterado-chkImprimeComunicadoConsumoAlteradoEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeComunicadoConsumoAlteradoEmCampoComContaRetida\" \naria-label=\"Imprime comunicado em campo com conta retida\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container></div></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-debitosanteriores/tab-debitosanteriores.html","<md-content id=\"tab-impressao-tab-comunicados-tab-debitosanteriores\"><div class=\"form-container\"><div layout=\"column\">\n<fieldset class=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaComunicadoDebitoAnterior\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkUtilizaComunicadoDebitoAnterior\" \nng-change=\"vm.metodos.limpaMensagemComunicadoDebitoAnterior($event)\" \nng-model=\"vm.parametro.comunicado.utilizaComunicadoDebitoAnterior\" aria-label=\"Cria serviço de arredondamento\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_COMUNICADO_FORMULARIO_SEPARADO\">Utilizar comunicado em formulário separado</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.comunicado.utilizaComunicadoDebitoAnterior == \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label><textarea \nng-model=\"vm.parametro.comunicado.mensagemDebitoAnterior\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-txtMensagemDebitoAnterior\" \nng-blur=\"vm.metodos.preenchimentoAutomaticoComunicadoDebitoAnterior($event)\" \nng-required=\"vm.parametro.comunicado.utilizaComunicadoDebitoAnterior == \'S\'\" name=\"mensagemDebitoAnterior\" rows=\"2\" \nmax-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                  </textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><span class=\"observacao\" \ntranslate=\"RESOURCES.OBSERVACAO_COMUNICADO_DEBITOS_ANTERIORES\">\nPara quebrar a linha do comunicado, pressione a tecla ENTER. O que passar do tamanho do campo irá sobrepor a impressão.\n</span></div></div><br><div layout=\"row\" layout-xs=\"column\" flex><md-input-container class=\"md-block\" flex-gt-sm=\"15\">\n<label translate=\"RESOURCES.LAYOUT\">Layout</label><md-select name=\"layoutComunicadoDebitoAnterior\" \nid=\"cadastro-parametros-tabcalculo-slctLayoutComunicadoDebitoAnterior\" \nng-required=\"(vm.controleForm.editarAtivo || vm.controleForm.inserirAtivo) && vm.parametro.comunicado.utilizaComunicadoDebitoAnterior\" \nng-model=\"vm.parametro.comunicado.layoutComunicadoDebitoAnterior\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><md-option\n ng-value=\"padraoNome.id\" ng-repeat=\"padraoNome in vm.listaLeyoutDebitosAnteriores track by $index\">\n{{padraoNome.descricao}}</md-option></md-select><div ng-messages=\"vm.form.layoutComunicadoDebitoAnterior.$error\"><div \nng-message=\"required\" translate=\"MENSAGEM_VALIDACAO.CAMPO_OBRIGATORIO\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><md-checkbox name=\"utilizaImpressaoCanhotoComunicadoDebito\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkUtilizaImpressaoCanhotoComunicadoDebito\" \nng-model=\"vm.parametro.comunicado.utilizaImpressaoCanhotoComunicadoDebito\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.comunicado.layoutComunicadoDebitoAnterior.indexOf(\'01\') == -1\">\n<span translate=\"RESOURCES.UTILIZAR_IMPRESSAO_CANHOTO\">Utilizar impressão de canhoto</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox name=\"imprimeNumeroComunicadoDA\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkImprimeNumeroComunicado\" \nng-model=\"vm.parametro.impressao.imprimeNumeroComunicadoDA\" aria-label=\"Imprime número do comunicado\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo || vm.parametro.comunicado.layoutComunicadoDebitoAnterior.indexOf(\'01\') == -1\">\n<span translate=\"RESOURCES.IMPRIMIR_NUMERO_COMUNICADO\">Imprimir número do comunicado</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox name=\"confirmaImpressaoDebitoAnterior\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkConfirmaImpressaoDebitoAnterior\" \nng-model=\"vm.parametro.comunicado.confirmaImpressaoDebitoAnterior\" aria-label=\"Solicita confirmação de impressão\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.SOLICITAR_CONFIRMACAO_IMPRESSAO\">Solicitar confirmação de impressão</span></md-checkbox>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><fieldset class=\"standard\" flex-gt-sm=\"50\"><md-checkbox\n name=\"utilizaConfiguracaoTituloComunicadoDebitos\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkUtilizaConfiguracaoTituloComunicadoDebitos\" \nng-change=\"vm.metodos.limpaCamposUtilizaConfiguracaoTitulo()\" \nng-model=\"vm.parametro.comunicado.utilizaConfiguracaoTituloComunicadoDebitos\" \naria-label=\"Utiliza configuração no título\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_CONFIGURACAO_TITULO\">Utilizar configuração no título</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.comunicado.utilizaConfiguracaoTituloComunicadoDebitos == \'S\'\">\n<div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label \ntranslate=\"RESOURCES.TITULO_COMUNICADO\">Título comunicado</label><input type=\"text\" name=\"tituloComunicadoDebitos\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-txtTituloComunicadoDebitos\" \nng-required=\"vm.parametro.comunicado.utilizaConfiguracaoTituloComunicadoDebitos == \'S\'\" \nng-model=\"vm.parametro.comunicado.tituloComunicadoDebitos\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"50\" md-maxlength=\"50\"></md-input-container></div></div></fieldset><br hide-gt-sm><fieldset \nclass=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaMensagemDebitoPagamentoAtraso\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkUtilizaMensagemDebitoPagamentoAtraso\" \nng-change=\"vm.metodos.limpaCamposUtilizaComunicadoPagamentoFaturas()\" \nng-model=\"vm.parametro.comunicado.utilizaMensagemDebitoPagamentoAtraso\" \naria-label=\"Utiliza comunicado para pagamento de faturas\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_COMUNICADO_PARA_PAGAMENTO_FATURA\">Utilizar comunicado para pagamento de faturas</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" \nng-if=\"vm.parametro.comunicado.utilizaMensagemDebitoPagamentoAtraso != \'S\'\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label translate=\"RESOURCES.MENSAGEM_COMUNICADOS_SEM_PAGAMENTO\">\nMensagem para comunicados sem pagamento</label><input type=\"text\" name=\"mensagemDebitoPagamentoAtraso\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-txtMensagemDebitoPagamentoAtraso\" \nng-model=\"vm.parametro.comunicado.mensagemDebitoPagamentoAtraso\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"60\" md-maxlength=\"60\"></md-input-container></div></div></fieldset></div><br><div layout=\"row\" \nlayout-xs=\"column\"><fieldset class=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaValidadeComunicadoDebito\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkUtilizaValidadeComunicadoDebito\" \nng-change=\"vm.metodos.limpaCamposNumeroDiasValidade()\" \nng-model=\"vm.parametro.comunicado.utilizaValidadeComunicadoDebito\" aria-label=\"Utiliza número de dias para validade\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_NUMERO_DIAS_VALIDADE\">Utilizar número de dias para validade</span></md-checkbox><div \nclass=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.comunicado.utilizaValidadeComunicadoDebito == \'S\'\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label \ntranslate=\"RESOURCES.NUMERO_DIAS_VALIDADE_COMUNICADO\">Nr. dias para validade do comunicado:</label><input type=\"text\" \nname=\"numeroDiasValidadeComunicadoDebito\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-txtNumeroDiasValidadeComunicadoDebito\" \nng-blur=\"vm.metodos.zeraCampoComValorNulo(\'numeroDiasValidadeComunicadoDebito\', vm.parametro.comunicado.numeroDiasValidadeComunicadoDebito)\" \nng-model=\"vm.parametro.comunicado.numeroDiasValidadeComunicadoDebito\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nui-number-mask=\"0\" ui-hide-group-sep mascara-tamanho-campo=\"5\"></md-input-container></div></div></fieldset></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><md-checkbox \nname=\"imprimirSempreComunicadoDA\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkImprimirSempreComunicadoDA\" \nng-model=\"vm.parametro.comunicado.imprimirSempreComunicadoDA\" aria-label=\"Imprime mesmo se a fatura não for impressa\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><md-checkbox \nname=\"imprimeComunicadoDebitoAnteriorEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabdebitosanteriores-chkImprimeComunicadoDebitoAnteriorEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeComunicadoDebitoAnteriorEmCampoComContaRetida\" \naria-label=\"Imprime comunicado em campo com conta retida\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_COM_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container></div></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-ocorrencia/tab-ocorrencia.html","<md-content id=\"tab-impressao-tab-comunicados-tab-ocorrencia\"><div class=\"form-container\"><div layout=\"column\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label><textarea \nng-model=\"vm.parametro.comunicado.mensagemComunicadoOcorrencia\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-txtMensagemComunicadoOcorrencia\" \nname=\"mensagemComunicadoOcorrencia\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                                          </textarea></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><md-input-container class=\"md-block\" flex=\"100\"><span \nclass=\"observacao\" translate=\"RESOURCES.OBSERVACAO_COMUNICADO_OCORRENCIA\">\nPara quebrar a linha do comunicado, pressione a tecla ENTER. A largura do campo é correspondente à quantidade máxima de caracteres por linha do comunicado. O que passar do tamanho do campo irá sobrepor a impressão.\n</span></md-input-container></div></div></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"33\"><md-checkbox name=\"imprimirSempreComunicadoOC\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-chkimprimirSempreComunicadoOC\" \nng-model=\"vm.parametro.comunicado.imprimirSempreComunicadoOC\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><md-checkbox \nname=\"utilizaImpressaoFotoComunicadoOcorrencia\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-chkUtilizaImpressaoFotoComunicadoOcorrencia\" \nng-model=\"vm.parametro.coletor.utilizaImpressaoFotoComunicadoOcorrencia\" \naria-label=\"Utiliza impressão de foto no comunicado\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_IMPRESSAO_FOTO_NO_COMUNICADO\">Utiliza impressão de foto no comunicado</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><md-checkbox \nname=\"imprimeComunicadoOcorrenciaEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-chkImprimeComunicadoOcorrenciaEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeComunicadoOcorrenciaEmCampoComContaRetida\" \naria-label=\"Imprime comunicado em campo com conta retida\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-quitacaoanualdebitos/tab-quitacaoanualdebitos.html","<md-content id=\"tab-impressao-tab-comunicados-tab-quitacaoanualdebitos\"><div class=\"form-container\"><div \nlayout=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\"></label><textarea\n ng-model=\"vm.parametro.comunicado.mensagemComunicadoQuitacaoAnualDebitos\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabquitacaoanualdebitos-txtMensagemComunicadoQuitacaoAnualDebitos\" \nname=\"mensagemComunicadoQuitacaoAnualDebitos\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                                          </textarea></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><md-input-container class=\"md-block\" flex=\"100\"><span \nclass=\"observacao\" translate=\"RESOURCES.OBSERVACAO_COMUNICADO_QUITACAO_ANUAL\">\n* Para quebrar a linha do comunicado, pressione a tecla ENTER. A largura do campo é correspondente à quantidade máxima de caracteres por linha do comunicado. O que passar do tamanho do campo irá sobrepor a impressão.\n</span></md-input-container></div></div></div><br><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.TITULO_COMUNICADO\"></label><textarea \nng-model=\"vm.parametro.comunicado.tituloComunicadoQuitacaoAnualDebitos\" name=\"tituloComunicadoQuitacaoAnualDebitos\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabquitacaoanualdebitos-txtTituloComunicadoQuitacaoAnualDebitos\" \nrows=\"2\" mascara-tamanho-campo=\"60\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                                                                              </textarea>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n<md-checkbox name=\"imprimirSempreComunicadoQA\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-chkImprimirSempreComunicadoQA\" \nng-model=\"vm.parametro.comunicado.imprimirSempreComunicadoQA\" aria-label=\"Ultiliza troca de leituristas\" \nng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><md-checkbox \nname=\"imprimeComunicadoQuitacaoAnualEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabocorrencia-chkImprimeComunicadoQuitacaoAnualEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeComunicadoQuitacaoAnualEmCampoComContaRetida\" \naria-label=\"Imprime comunicado em campo com conta retida\" ng-true-value=\"\'S\'\" ng-false-value=\"\'N\'\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container></div></div></md-content>");
$templateCache.put("app/main/cadastros/parametros/views/tabs/tab-impressao/tabs/tab-comunicados/tabs/tab-servicos/tab-servicos.html","<md-content id=\"tab-impressao-tab-comunicados-tab-servicos\"><div class=\"form-container\"><div layout=\"column\"><fieldset \nclass=\"standard\" flex-gt-sm=\"50\"><md-checkbox name=\"utilizaServicoCobrancaAvulsa\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkUtilizaServicoCobrancaAvulsa\" \nng-model=\"vm.parametro.comunicado.utilizaServicoCobrancaAvulsa\" aria-label=\"Utilizar serviço de cobrança avulsa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.UTILIZAR_COMUNICADO_FORMULARIO_SEPARADO\">Utilizar comunicado em formulário separado</span>\n</md-checkbox><div class=\"group-checkbox\" flex=\"100\" ng-if=\"vm.parametro.comunicado.utilizaServicoCobrancaAvulsa\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"RESOURCES.MENSAGEM\">\n</label><textarea ng-model=\"vm.parametro.comunicado.mensagemServicoCobrancaAvulsa\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-txtMensagemServicoCobrancaAvulsa\" \nname=\"mensagemServicoCobrancaAvulsa\" rows=\"2\" max-rows=\"3\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\">\n\r\n                                  </textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-subheader\"><md-input-container class=\"md-block\"><span class=\"observacao\" \ntranslate=\"RESOURCES.OBSERVACAO_COMUNICADO_ALTERNATIVO\">\nPara quebrar a linha do comunicado, pressione a tecla ENTER. A largura do campo é correspondente à quantidade máxima de caracteres por linha do comunicado. O que passar do tamanho do campo irá sobrepor a impressão.\n</span></md-input-container></div></div><br><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"45\"><label translate=\"RESOURCES.TITULO_COMUNICADO\">Título comunicado</label><input type=\"text\" \nname=\"tituloServicoCobrancaAvulsa\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-txtTituloServicoCobrancaAvulsa\" \nng-model=\"vm.parametro.comunicado.tituloServicoCobrancaAvulsa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\" \nmascara-tamanho-campo=\"28\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"45\"><md-checkbox \nname=\"imprimirSempreServicoCobrancaAvulsa\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkImprimirSempreServicoCobrancaAvulsa\" \nng-model=\"vm.parametro.comunicado.imprimirSempreServicoCobrancaAvulsa\" \naria-label=\"Imprimir sempre serviço cobrança avulsa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_SE_FATURA_NAO_IMPRESSA\">Imprimir comunicado mesmo se a fatura não for impressa\n</span></md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"45\">\n<md-checkbox name=\"imprimeServicoCobrancaAvulsaEmCampoComContaRetida\" \nid=\"cadastro-parametros-tabimpressao-tabcomunicados-tabalternativo-chkImprimeServicoCobrancaAvulsaEmCampoComContaRetida\" \nng-model=\"vm.parametro.comunicado.imprimeServicoCobrancaAvulsaEmCampoComContaRetida\" \naria-label=\"Imprime serviço cobrança avulsa em campo com conta retida\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_COMUNICADO_CAMPO_CONTA_RETIDA\">Imprimir comunicado em campo com conta retida</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><md-checkbox \nid=\"cadastro-parametros-taboutros-chkImprimeCodigoBarrasDebitoAutomaticoServicoCobrancaAvulsa\" \nname=\"imprimeCodigoBarrasDebitoAutomaticoServicoCobrancaAvulsa\" \naria-label=\"Imprime código de barras débito automático\" \nng-model=\"vm.parametro.comunicado.imprimeCodigoBarrasDebitoAutomaticoServicoCobrancaAvulsa\" \nng-disabled=\"vm.controleForm.pesquisaAtiva && !vm.controleForm.editarAtivo && !vm.controleForm.inserirAtivo\"><span \ntranslate=\"RESOURCES.IMPRIMIR_CODIGO_BARRAS_DEBITO_AUTOMATICO\">Imprimir código de barras débito automático</span>\n</md-checkbox></md-input-container></div></div></fieldset></div></div></md-content>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/dialogs/detalhar-foto.dialog.html","<md-dialog aria-label=\"Dialog fotos\" id=\"dialog-detalhar-fotos\"><md-dialog-content flex><div class=\"md-toolbar-tools\">\n<span flex></span><md-button class=\"md-icon-button button-flutuante\" ng-click=\"vm.metodos.fecharDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div><div id=\"div-imagem\" layout=\"column\" \nflex=\"100\"><img ng-if=\"vm.fotoBase64\" ng-src=\"{{vm.foto}}\" flex style=\"width: 100%\"> <img ng-if=\"!vm.fotoBase64\" \nng-src=\"data:image/jpeg;image/png;base64,{{vm.foto}}\" flex style=\"width: 100%\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/critica/dialogs/dialog-motivo-critica/views/dialog-motivo-critica.html","<md-dialog layout=\"column\" id=\"motivo-critica\" aria-label=\"Dialog\"><md-toolbar class=\"toolbar md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Motivo da crítica</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.metodos.fecharDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" flex=\"100\" \nlayout-align=\"center center\"><table class=\"dataTable hover row-hover\"><thead><th \nclass=\"secondary-text border-left border-right\" style=\"background-color: #dddddd;padding: 16px 8px\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" style=\"white-space: normal\">Erro(s)</span></div></th><th \nclass=\"secondary-text borda-direita\" style=\"background-color: #dddddd; padding: 16px 8px\"><div class=\"table-header\">\n<span class=\"column-title text-center\" style=\"white-space: normal\">Motivo</span></div></th></thead><tbody><tr><td \nclass=\"text-center border-left border-right\" style=\"padding: 16px 8px\"><span \nclass=\"ml-5 text-boxed red-bg white-fg ng-binding\" ng-if=\"vm.erros.leitura\" style=\"margin: 5px 5px; font-size: 0.85em\">\nLeitura</span> <span class=\"ml-5 text-boxed red-bg white-fg ng-binding status-revisao\" ng-if=\"vm.erros.ocorrencia\" \nstyle=\"margin: 5px 5px; font-size: 0.85em\">Ocorrência</span></td><td class=\"text-center border-right\" \nstyle=\"padding: 16px 8px\"><span>{{vm.motivo}}</span></td></tr></tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-demais-fotos.html","<div layout=\"column\" flex><div class=\"text-center p-32\" ng-if=\"!vm.fotos.fotosOutros.length\"><span \ntranslate=\"LEITURA.VISUALIZACAO.NAO_EXISTEM_FOTOS\"></span></div><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile \nng-repeat=\"foto in vm.fotos.fotosOutros\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" \nng-click=\"vm.metodosDialog.abrirDialogFotoDetalhada(foto.caminhoFoto)\"><img ng-src=\"{{foto.caminhoFoto}}\" width=\"300\" \nheight=\"200\"></a></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-fachada.html","<div layout=\"column\" flex><div class=\"text-center p-32\" ng-if=\"!vm.fotos.fotosFachada.length\"><span \ntranslate=\"LEITURA.VISUALIZACAO.NAO_EXISTEM_FOTOS\"></span></div><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile \nng-repeat=\"foto in vm.fotos.fotosFachada\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" \nng-click=\"vm.metodosDialog.abrirDialogFotoDetalhada(foto.caminhoFoto)\"><img ng-src=\"{{foto.caminhoFoto}}\" width=\"300\" \nheight=\"200\"></a></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-hidrometro.html","<div layout=\"column\" flex><div class=\"text-center p-32\" ng-if=\"!vm.fotos.fotosHidrometro.length\"><span \ntranslate=\"LEITURA.VISUALIZACAO.NAO_EXISTEM_FOTOS\"></span></div><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile \nng-repeat=\"foto in vm.fotos.fotosHidrometro\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" class=\"text-center\" \nstyle=\"text-decoration:none\" ng-click=\"vm.metodosDialog.abrirDialogFotoDetalhada(foto.caminhoFoto)\"><img \nng-src=\"{{foto.caminhoFoto}}\" width=\"300\" height=\"200\"> <span ng-if=\"foto.dataFoto.length\">{{ foto.dataFoto }}</span>\n</a></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-prova-adulteracao.html","<div layout=\"column\" flex><div class=\"text-center p-32\" ng-if=\"!vm.fotos.fotosProvaAdulteracao.length\"><span \ntranslate=\"LEITURA.VISUALIZACAO.NAO_EXISTEM_FOTOS\"></span></div><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile \nng-repeat=\"foto in vm.fotos.fotosProvaAdulteracao\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" \nng-click=\"vm.metodosDialog.abrirDialogFotoDetalhada(foto.caminhoFoto)\"><img ng-src=\"{{foto.caminhoFoto}}\" width=\"300\" \nheight=\"200\"></a></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/main/gerenciamento/leitura/visualizacao/views/tabs/dadosLeitura/dialogs/fotos/tabs/tab-repasse.html","<div layout=\"column\" flex><div class=\"text-center p-32\" ng-if=\"!vm.fotos.fotosRepasse.length\"><span \ntranslate=\"LEITURA.VISUALIZACAO.NAO_EXISTEM_FOTOS\"></span></div><md-grid-list md-cols=\"1\" md-cols-gt-sm=\"3\" \nmd-row-height-gt-sm=\"1:1\" md-row-height=\"4:3\" md-gutter=\"4px\" md-gutter-gt-sm=\"8px\"><md-grid-tile \nng-repeat=\"foto in vm.fotos.fotosRepasse\" md-rowspan=\"1\" md-colspan=\"1\"><a href=\"#\" \nng-click=\"vm.metodosDialog.abrirDialogFotoDetalhada(foto.caminhoFoto)\"><img ng-src=\"{{foto.caminhoFoto}}\" width=\"300\" \nheight=\"200\"></a></md-grid-tile></md-grid-list></div>");}]);